import * as lh from "vue";
import { computed as M, ref as z, shallowRef as sv, watch as tt, getCurrentScope as df, onScopeDispose as zl, shallowReadonly as xl, unref as y, defineComponent as W, toRefs as Nr, createBlock as G, openBlock as c, withCtx as N, renderSlot as I, withKeys as ui, onMounted as xt, createVNode as ne, mergeProps as oe, toHandlers as oE, normalizeProps as ve, guardReactiveProps as we, resolveDynamicComponent as Hr, nextTick as Ct, createCommentVNode as le, getCurrentInstance as po, toRef as _f, camelize as lv, watchSyncEffect as iE, withModifiers as xa, createTextVNode as Ne, withDirectives as ur, vShow as Ll, toDisplayString as ye, isRef as pf, normalizeStyle as Gr, toHandlerKey as sE, inject as Ui, provide as Zl, h as Vt, readonly as ql, watchEffect as pn, Teleport as Rd, useSlots as Yr, createElementBlock as _, Fragment as Qe, renderList as Ye, markRaw as cv, onUnmounted as zr, Comment as uv, cloneVNode as lE, reactive as Mr, mergeDefaults as dv, watchPostEffect as cE, effectScope as _v, customRef as uE, onBeforeUnmount as pv, onBeforeUpdate as dE, onUpdated as _E, useAttrs as h0, toValue as $r, createElementVNode as d, resolveComponent as ht, Transition as v0, createStaticVNode as mi, normalizeClass as Oe, createSlots as mn, TransitionGroup as mv, vModelCheckbox as gv, vModelText as fl, vModelSelect as pE, mergeModels as E0, useModel as Ni, KeepAlive as mE, onErrorCaptured as gE, vModelRadio as fE, useCssVars as hE, createApp as vE } from "vue";
import { useRouter as fv, useRoute as hv } from "vue-router";
const EE = ["top", "right", "bottom", "left"], lo = Math.min, pa = Math.max, t0 = Math.round, Bd = Math.floor, Mi = (t) => ({
  x: t,
  y: t
}), bE = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, SE = {
  start: "end",
  end: "start"
};
function B2(t, n, a) {
  return pa(t, lo(n, a));
}
function _i(t, n) {
  return typeof t == "function" ? t(n) : t;
}
function pi(t) {
  return t.split("-")[0];
}
function Wl(t) {
  return t.split("-")[1];
}
function mf(t) {
  return t === "x" ? "y" : "x";
}
function gf(t) {
  return t === "y" ? "height" : "width";
}
function Di(t) {
  return ["top", "bottom"].includes(pi(t)) ? "y" : "x";
}
function ff(t) {
  return mf(Di(t));
}
function wE(t, n, a) {
  a === void 0 && (a = !1);
  const i = Wl(t), s = ff(t), u = gf(s);
  let p = s === "x" ? i === (a ? "end" : "start") ? "right" : "left" : i === "start" ? "bottom" : "top";
  return n.reference[u] > n.floating[u] && (p = n0(p)), [p, n0(p)];
}
function yE(t) {
  const n = n0(t);
  return [F2(t), n, F2(n)];
}
function F2(t) {
  return t.replace(/start|end/g, (n) => SE[n]);
}
function TE(t, n, a) {
  const i = ["left", "right"], s = ["right", "left"], u = ["top", "bottom"], p = ["bottom", "top"];
  switch (t) {
    case "top":
    case "bottom":
      return a ? n ? s : i : n ? i : s;
    case "left":
    case "right":
      return n ? u : p;
    default:
      return [];
  }
}
function CE(t, n, a, i) {
  const s = Wl(t);
  let u = TE(pi(t), a === "start", i);
  return s && (u = u.map((p) => p + "-" + s), n && (u = u.concat(u.map(F2)))), u;
}
function n0(t) {
  return t.replace(/left|right|bottom|top/g, (n) => bE[n]);
}
function xE(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function vv(t) {
  return typeof t != "number" ? xE(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function r0(t) {
  const {
    x: n,
    y: a,
    width: i,
    height: s
  } = t;
  return {
    width: i,
    height: s,
    top: a,
    left: n,
    right: n + i,
    bottom: a + s,
    x: n,
    y: a
  };
}
function ch(t, n, a) {
  let {
    reference: i,
    floating: s
  } = t;
  const u = Di(n), p = ff(n), g = gf(p), E = pi(n), h = u === "y", f = i.x + i.width / 2 - s.width / 2, b = i.y + i.height / 2 - s.height / 2, w = i[g] / 2 - s[g] / 2;
  let x;
  switch (E) {
    case "top":
      x = {
        x: f,
        y: i.y - s.height
      };
      break;
    case "bottom":
      x = {
        x: f,
        y: i.y + i.height
      };
      break;
    case "right":
      x = {
        x: i.x + i.width,
        y: b
      };
      break;
    case "left":
      x = {
        x: i.x - s.width,
        y: b
      };
      break;
    default:
      x = {
        x: i.x,
        y: i.y
      };
  }
  switch (Wl(n)) {
    case "start":
      x[p] -= w * (a && h ? -1 : 1);
      break;
    case "end":
      x[p] += w * (a && h ? -1 : 1);
      break;
  }
  return x;
}
const AE = async (t, n, a) => {
  const {
    placement: i = "bottom",
    strategy: s = "absolute",
    middleware: u = [],
    platform: p
  } = a, g = u.filter(Boolean), E = await (p.isRTL == null ? void 0 : p.isRTL(n));
  let h = await p.getElementRects({
    reference: t,
    floating: n,
    strategy: s
  }), {
    x: f,
    y: b
  } = ch(h, i, E), w = i, x = {}, A = 0;
  for (let D = 0; D < g.length; D++) {
    const {
      name: L,
      fn: $
    } = g[D], {
      x: q,
      y: P,
      data: k,
      reset: U
    } = await $({
      x: f,
      y: b,
      initialPlacement: i,
      placement: w,
      strategy: s,
      middlewareData: x,
      rects: h,
      platform: p,
      elements: {
        reference: t,
        floating: n
      }
    });
    f = q ?? f, b = P ?? b, x = {
      ...x,
      [L]: {
        ...x[L],
        ...k
      }
    }, U && A <= 50 && (A++, typeof U == "object" && (U.placement && (w = U.placement), U.rects && (h = U.rects === !0 ? await p.getElementRects({
      reference: t,
      floating: n,
      strategy: s
    }) : U.rects), {
      x: f,
      y: b
    } = ch(h, w, E)), D = -1);
  }
  return {
    x: f,
    y: b,
    placement: w,
    strategy: s,
    middlewareData: x
  };
};
async function yd(t, n) {
  var a;
  n === void 0 && (n = {});
  const {
    x: i,
    y: s,
    platform: u,
    rects: p,
    elements: g,
    strategy: E
  } = t, {
    boundary: h = "clippingAncestors",
    rootBoundary: f = "viewport",
    elementContext: b = "floating",
    altBoundary: w = !1,
    padding: x = 0
  } = _i(n, t), A = vv(x), L = g[w ? b === "floating" ? "reference" : "floating" : b], $ = r0(await u.getClippingRect({
    element: (a = await (u.isElement == null ? void 0 : u.isElement(L))) == null || a ? L : L.contextElement || await (u.getDocumentElement == null ? void 0 : u.getDocumentElement(g.floating)),
    boundary: h,
    rootBoundary: f,
    strategy: E
  })), q = b === "floating" ? {
    x: i,
    y: s,
    width: p.floating.width,
    height: p.floating.height
  } : p.reference, P = await (u.getOffsetParent == null ? void 0 : u.getOffsetParent(g.floating)), k = await (u.isElement == null ? void 0 : u.isElement(P)) ? await (u.getScale == null ? void 0 : u.getScale(P)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, U = r0(u.convertOffsetParentRelativeRectToViewportRelativeRect ? await u.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: g,
    rect: q,
    offsetParent: P,
    strategy: E
  }) : q);
  return {
    top: ($.top - U.top + A.top) / k.y,
    bottom: (U.bottom - $.bottom + A.bottom) / k.y,
    left: ($.left - U.left + A.left) / k.x,
    right: (U.right - $.right + A.right) / k.x
  };
}
const RE = (t) => ({
  name: "arrow",
  options: t,
  async fn(n) {
    const {
      x: a,
      y: i,
      placement: s,
      rects: u,
      platform: p,
      elements: g,
      middlewareData: E
    } = n, {
      element: h,
      padding: f = 0
    } = _i(t, n) || {};
    if (h == null)
      return {};
    const b = vv(f), w = {
      x: a,
      y: i
    }, x = ff(s), A = gf(x), D = await p.getDimensions(h), L = x === "y", $ = L ? "top" : "left", q = L ? "bottom" : "right", P = L ? "clientHeight" : "clientWidth", k = u.reference[A] + u.reference[x] - w[x] - u.floating[A], U = w[x] - u.reference[x], Z = await (p.getOffsetParent == null ? void 0 : p.getOffsetParent(h));
    let ee = Z ? Z[P] : 0;
    (!ee || !await (p.isElement == null ? void 0 : p.isElement(Z))) && (ee = g.floating[P] || u.floating[A]);
    const X = k / 2 - U / 2, re = ee / 2 - D[A] / 2 - 1, Q = lo(b[$], re), ce = lo(b[q], re), me = Q, Se = ee - D[A] - ce, Le = ee / 2 - D[A] / 2 + X, qe = B2(me, Le, Se), _t = !E.arrow && Wl(s) != null && Le !== qe && u.reference[A] / 2 - (Le < me ? Q : ce) - D[A] / 2 < 0, ot = _t ? Le < me ? Le - me : Le - Se : 0;
    return {
      [x]: w[x] + ot,
      data: {
        [x]: qe,
        centerOffset: Le - qe - ot,
        ..._t && {
          alignmentOffset: ot
        }
      },
      reset: _t
    };
  }
}), OE = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(n) {
      var a, i;
      const {
        placement: s,
        middlewareData: u,
        rects: p,
        initialPlacement: g,
        platform: E,
        elements: h
      } = n, {
        mainAxis: f = !0,
        crossAxis: b = !0,
        fallbackPlacements: w,
        fallbackStrategy: x = "bestFit",
        fallbackAxisSideDirection: A = "none",
        flipAlignment: D = !0,
        ...L
      } = _i(t, n);
      if ((a = u.arrow) != null && a.alignmentOffset)
        return {};
      const $ = pi(s), q = Di(g), P = pi(g) === g, k = await (E.isRTL == null ? void 0 : E.isRTL(h.floating)), U = w || (P || !D ? [n0(g)] : yE(g)), Z = A !== "none";
      !w && Z && U.push(...CE(g, D, A, k));
      const ee = [g, ...U], X = await yd(n, L), re = [];
      let Q = ((i = u.flip) == null ? void 0 : i.overflows) || [];
      if (f && re.push(X[$]), b) {
        const Le = wE(s, p, k);
        re.push(X[Le[0]], X[Le[1]]);
      }
      if (Q = [...Q, {
        placement: s,
        overflows: re
      }], !re.every((Le) => Le <= 0)) {
        var ce, me;
        const Le = (((ce = u.flip) == null ? void 0 : ce.index) || 0) + 1, qe = ee[Le];
        if (qe)
          return {
            data: {
              index: Le,
              overflows: Q
            },
            reset: {
              placement: qe
            }
          };
        let _t = (me = Q.filter((ot) => ot.overflows[0] <= 0).sort((ot, st) => ot.overflows[1] - st.overflows[1])[0]) == null ? void 0 : me.placement;
        if (!_t)
          switch (x) {
            case "bestFit": {
              var Se;
              const ot = (Se = Q.filter((st) => {
                if (Z) {
                  const Me = Di(st.placement);
                  return Me === q || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  Me === "y";
                }
                return !0;
              }).map((st) => [st.placement, st.overflows.filter((Me) => Me > 0).reduce((Me, je) => Me + je, 0)]).sort((st, Me) => st[1] - Me[1])[0]) == null ? void 0 : Se[0];
              ot && (_t = ot);
              break;
            }
            case "initialPlacement":
              _t = g;
              break;
          }
        if (s !== _t)
          return {
            reset: {
              placement: _t
            }
          };
      }
      return {};
    }
  };
};
function uh(t, n) {
  return {
    top: t.top - n.height,
    right: t.right - n.width,
    bottom: t.bottom - n.height,
    left: t.left - n.width
  };
}
function dh(t) {
  return EE.some((n) => t[n] >= 0);
}
const IE = function(t) {
  return t === void 0 && (t = {}), {
    name: "hide",
    options: t,
    async fn(n) {
      const {
        rects: a
      } = n, {
        strategy: i = "referenceHidden",
        ...s
      } = _i(t, n);
      switch (i) {
        case "referenceHidden": {
          const u = await yd(n, {
            ...s,
            elementContext: "reference"
          }), p = uh(u, a.reference);
          return {
            data: {
              referenceHiddenOffsets: p,
              referenceHidden: dh(p)
            }
          };
        }
        case "escaped": {
          const u = await yd(n, {
            ...s,
            altBoundary: !0
          }), p = uh(u, a.floating);
          return {
            data: {
              escapedOffsets: p,
              escaped: dh(p)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function NE(t, n) {
  const {
    placement: a,
    platform: i,
    elements: s
  } = t, u = await (i.isRTL == null ? void 0 : i.isRTL(s.floating)), p = pi(a), g = Wl(a), E = Di(a) === "y", h = ["left", "top"].includes(p) ? -1 : 1, f = u && E ? -1 : 1, b = _i(n, t);
  let {
    mainAxis: w,
    crossAxis: x,
    alignmentAxis: A
  } = typeof b == "number" ? {
    mainAxis: b,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...b
  };
  return g && typeof A == "number" && (x = g === "end" ? A * -1 : A), E ? {
    x: x * f,
    y: w * h
  } : {
    x: w * h,
    y: x * f
  };
}
const ME = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(n) {
      var a, i;
      const {
        x: s,
        y: u,
        placement: p,
        middlewareData: g
      } = n, E = await NE(n, t);
      return p === ((a = g.offset) == null ? void 0 : a.placement) && (i = g.arrow) != null && i.alignmentOffset ? {} : {
        x: s + E.x,
        y: u + E.y,
        data: {
          ...E,
          placement: p
        }
      };
    }
  };
}, DE = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(n) {
      const {
        x: a,
        y: i,
        placement: s
      } = n, {
        mainAxis: u = !0,
        crossAxis: p = !1,
        limiter: g = {
          fn: (L) => {
            let {
              x: $,
              y: q
            } = L;
            return {
              x: $,
              y: q
            };
          }
        },
        ...E
      } = _i(t, n), h = {
        x: a,
        y: i
      }, f = await yd(n, E), b = Di(pi(s)), w = mf(b);
      let x = h[w], A = h[b];
      if (u) {
        const L = w === "y" ? "top" : "left", $ = w === "y" ? "bottom" : "right", q = x + f[L], P = x - f[$];
        x = B2(q, x, P);
      }
      if (p) {
        const L = b === "y" ? "top" : "left", $ = b === "y" ? "bottom" : "right", q = A + f[L], P = A - f[$];
        A = B2(q, A, P);
      }
      const D = g.fn({
        ...n,
        [w]: x,
        [b]: A
      });
      return {
        ...D,
        data: {
          x: D.x - a,
          y: D.y - i
        }
      };
    }
  };
}, kE = function(t) {
  return t === void 0 && (t = {}), {
    options: t,
    fn(n) {
      const {
        x: a,
        y: i,
        placement: s,
        rects: u,
        middlewareData: p
      } = n, {
        offset: g = 0,
        mainAxis: E = !0,
        crossAxis: h = !0
      } = _i(t, n), f = {
        x: a,
        y: i
      }, b = Di(s), w = mf(b);
      let x = f[w], A = f[b];
      const D = _i(g, n), L = typeof D == "number" ? {
        mainAxis: D,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...D
      };
      if (E) {
        const P = w === "y" ? "height" : "width", k = u.reference[w] - u.floating[P] + L.mainAxis, U = u.reference[w] + u.reference[P] - L.mainAxis;
        x < k ? x = k : x > U && (x = U);
      }
      if (h) {
        var $, q;
        const P = w === "y" ? "width" : "height", k = ["top", "left"].includes(pi(s)), U = u.reference[b] - u.floating[P] + (k && (($ = p.offset) == null ? void 0 : $[b]) || 0) + (k ? 0 : L.crossAxis), Z = u.reference[b] + u.reference[P] + (k ? 0 : ((q = p.offset) == null ? void 0 : q[b]) || 0) - (k ? L.crossAxis : 0);
        A < U ? A = U : A > Z && (A = Z);
      }
      return {
        [w]: x,
        [b]: A
      };
    }
  };
}, LE = function(t) {
  return t === void 0 && (t = {}), {
    name: "size",
    options: t,
    async fn(n) {
      const {
        placement: a,
        rects: i,
        platform: s,
        elements: u
      } = n, {
        apply: p = () => {
        },
        ...g
      } = _i(t, n), E = await yd(n, g), h = pi(a), f = Wl(a), b = Di(a) === "y", {
        width: w,
        height: x
      } = i.floating;
      let A, D;
      h === "top" || h === "bottom" ? (A = h, D = f === (await (s.isRTL == null ? void 0 : s.isRTL(u.floating)) ? "start" : "end") ? "left" : "right") : (D = h, A = f === "end" ? "top" : "bottom");
      const L = x - E.top - E.bottom, $ = w - E.left - E.right, q = lo(x - E[A], L), P = lo(w - E[D], $), k = !n.middlewareData.shift;
      let U = q, Z = P;
      if (b ? Z = f || k ? lo(P, $) : $ : U = f || k ? lo(q, L) : L, k && !f) {
        const X = pa(E.left, 0), re = pa(E.right, 0), Q = pa(E.top, 0), ce = pa(E.bottom, 0);
        b ? Z = w - 2 * (X !== 0 || re !== 0 ? X + re : pa(E.left, E.right)) : U = x - 2 * (Q !== 0 || ce !== 0 ? Q + ce : pa(E.top, E.bottom));
      }
      await p({
        ...n,
        availableWidth: Z,
        availableHeight: U
      });
      const ee = await s.getDimensions(u.floating);
      return w !== ee.width || x !== ee.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function hl(t) {
  return hf(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function ga(t) {
  var n;
  return (t == null || (n = t.ownerDocument) == null ? void 0 : n.defaultView) || window;
}
function gi(t) {
  var n;
  return (n = (hf(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : n.documentElement;
}
function hf(t) {
  return t instanceof Node || t instanceof ga(t).Node;
}
function co(t) {
  return t instanceof Element || t instanceof ga(t).Element;
}
function uo(t) {
  return t instanceof HTMLElement || t instanceof ga(t).HTMLElement;
}
function _h(t) {
  return typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof ga(t).ShadowRoot;
}
function Od(t) {
  const {
    overflow: n,
    overflowX: a,
    overflowY: i,
    display: s
  } = Ka(t);
  return /auto|scroll|overlay|hidden|clip/.test(n + i + a) && !["inline", "contents"].includes(s);
}
function PE(t) {
  return ["table", "td", "th"].includes(hl(t));
}
function b0(t) {
  return [":popover-open", ":modal"].some((n) => {
    try {
      return t.matches(n);
    } catch {
      return !1;
    }
  });
}
function vf(t) {
  const n = Ef(), a = Ka(t);
  return a.transform !== "none" || a.perspective !== "none" || (a.containerType ? a.containerType !== "normal" : !1) || !n && (a.backdropFilter ? a.backdropFilter !== "none" : !1) || !n && (a.filter ? a.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((i) => (a.willChange || "").includes(i)) || ["paint", "layout", "strict", "content"].some((i) => (a.contain || "").includes(i));
}
function BE(t) {
  let n = ki(t);
  for (; uo(n) && !Pl(n); ) {
    if (b0(n))
      return null;
    if (vf(n))
      return n;
    n = ki(n);
  }
  return null;
}
function Ef() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Pl(t) {
  return ["html", "body", "#document"].includes(hl(t));
}
function Ka(t) {
  return ga(t).getComputedStyle(t);
}
function S0(t) {
  return co(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.scrollX,
    scrollTop: t.scrollY
  };
}
function ki(t) {
  if (hl(t) === "html")
    return t;
  const n = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    _h(t) && t.host || // Fallback.
    gi(t)
  );
  return _h(n) ? n.host : n;
}
function Ev(t) {
  const n = ki(t);
  return Pl(n) ? t.ownerDocument ? t.ownerDocument.body : t.body : uo(n) && Od(n) ? n : Ev(n);
}
function Td(t, n, a) {
  var i;
  n === void 0 && (n = []), a === void 0 && (a = !0);
  const s = Ev(t), u = s === ((i = t.ownerDocument) == null ? void 0 : i.body), p = ga(s);
  return u ? n.concat(p, p.visualViewport || [], Od(s) ? s : [], p.frameElement && a ? Td(p.frameElement) : []) : n.concat(s, Td(s, [], a));
}
function bv(t) {
  const n = Ka(t);
  let a = parseFloat(n.width) || 0, i = parseFloat(n.height) || 0;
  const s = uo(t), u = s ? t.offsetWidth : a, p = s ? t.offsetHeight : i, g = t0(a) !== u || t0(i) !== p;
  return g && (a = u, i = p), {
    width: a,
    height: i,
    $: g
  };
}
function bf(t) {
  return co(t) ? t : t.contextElement;
}
function Dl(t) {
  const n = bf(t);
  if (!uo(n))
    return Mi(1);
  const a = n.getBoundingClientRect(), {
    width: i,
    height: s,
    $: u
  } = bv(n);
  let p = (u ? t0(a.width) : a.width) / i, g = (u ? t0(a.height) : a.height) / s;
  return (!p || !Number.isFinite(p)) && (p = 1), (!g || !Number.isFinite(g)) && (g = 1), {
    x: p,
    y: g
  };
}
const FE = /* @__PURE__ */ Mi(0);
function Sv(t) {
  const n = ga(t);
  return !Ef() || !n.visualViewport ? FE : {
    x: n.visualViewport.offsetLeft,
    y: n.visualViewport.offsetTop
  };
}
function UE(t, n, a) {
  return n === void 0 && (n = !1), !a || n && a !== ga(t) ? !1 : n;
}
function dl(t, n, a, i) {
  n === void 0 && (n = !1), a === void 0 && (a = !1);
  const s = t.getBoundingClientRect(), u = bf(t);
  let p = Mi(1);
  n && (i ? co(i) && (p = Dl(i)) : p = Dl(t));
  const g = UE(u, a, i) ? Sv(u) : Mi(0);
  let E = (s.left + g.x) / p.x, h = (s.top + g.y) / p.y, f = s.width / p.x, b = s.height / p.y;
  if (u) {
    const w = ga(u), x = i && co(i) ? ga(i) : i;
    let A = w, D = A.frameElement;
    for (; D && i && x !== A; ) {
      const L = Dl(D), $ = D.getBoundingClientRect(), q = Ka(D), P = $.left + (D.clientLeft + parseFloat(q.paddingLeft)) * L.x, k = $.top + (D.clientTop + parseFloat(q.paddingTop)) * L.y;
      E *= L.x, h *= L.y, f *= L.x, b *= L.y, E += P, h += k, A = ga(D), D = A.frameElement;
    }
  }
  return r0({
    width: f,
    height: b,
    x: E,
    y: h
  });
}
function $E(t) {
  let {
    elements: n,
    rect: a,
    offsetParent: i,
    strategy: s
  } = t;
  const u = s === "fixed", p = gi(i), g = n ? b0(n.floating) : !1;
  if (i === p || g && u)
    return a;
  let E = {
    scrollLeft: 0,
    scrollTop: 0
  }, h = Mi(1);
  const f = Mi(0), b = uo(i);
  if ((b || !b && !u) && ((hl(i) !== "body" || Od(p)) && (E = S0(i)), uo(i))) {
    const w = dl(i);
    h = Dl(i), f.x = w.x + i.clientLeft, f.y = w.y + i.clientTop;
  }
  return {
    width: a.width * h.x,
    height: a.height * h.y,
    x: a.x * h.x - E.scrollLeft * h.x + f.x,
    y: a.y * h.y - E.scrollTop * h.y + f.y
  };
}
function VE(t) {
  return Array.from(t.getClientRects());
}
function wv(t) {
  return dl(gi(t)).left + S0(t).scrollLeft;
}
function HE(t) {
  const n = gi(t), a = S0(t), i = t.ownerDocument.body, s = pa(n.scrollWidth, n.clientWidth, i.scrollWidth, i.clientWidth), u = pa(n.scrollHeight, n.clientHeight, i.scrollHeight, i.clientHeight);
  let p = -a.scrollLeft + wv(t);
  const g = -a.scrollTop;
  return Ka(i).direction === "rtl" && (p += pa(n.clientWidth, i.clientWidth) - s), {
    width: s,
    height: u,
    x: p,
    y: g
  };
}
function GE(t, n) {
  const a = ga(t), i = gi(t), s = a.visualViewport;
  let u = i.clientWidth, p = i.clientHeight, g = 0, E = 0;
  if (s) {
    u = s.width, p = s.height;
    const h = Ef();
    (!h || h && n === "fixed") && (g = s.offsetLeft, E = s.offsetTop);
  }
  return {
    width: u,
    height: p,
    x: g,
    y: E
  };
}
function YE(t, n) {
  const a = dl(t, !0, n === "fixed"), i = a.top + t.clientTop, s = a.left + t.clientLeft, u = uo(t) ? Dl(t) : Mi(1), p = t.clientWidth * u.x, g = t.clientHeight * u.y, E = s * u.x, h = i * u.y;
  return {
    width: p,
    height: g,
    x: E,
    y: h
  };
}
function ph(t, n, a) {
  let i;
  if (n === "viewport")
    i = GE(t, a);
  else if (n === "document")
    i = HE(gi(t));
  else if (co(n))
    i = YE(n, a);
  else {
    const s = Sv(t);
    i = {
      ...n,
      x: n.x - s.x,
      y: n.y - s.y
    };
  }
  return r0(i);
}
function yv(t, n) {
  const a = ki(t);
  return a === n || !co(a) || Pl(a) ? !1 : Ka(a).position === "fixed" || yv(a, n);
}
function zE(t, n) {
  const a = n.get(t);
  if (a)
    return a;
  let i = Td(t, [], !1).filter((g) => co(g) && hl(g) !== "body"), s = null;
  const u = Ka(t).position === "fixed";
  let p = u ? ki(t) : t;
  for (; co(p) && !Pl(p); ) {
    const g = Ka(p), E = vf(p);
    !E && g.position === "fixed" && (s = null), (u ? !E && !s : !E && g.position === "static" && !!s && ["absolute", "fixed"].includes(s.position) || Od(p) && !E && yv(t, p)) ? i = i.filter((f) => f !== p) : s = g, p = ki(p);
  }
  return n.set(t, i), i;
}
function ZE(t) {
  let {
    element: n,
    boundary: a,
    rootBoundary: i,
    strategy: s
  } = t;
  const p = [...a === "clippingAncestors" ? b0(n) ? [] : zE(n, this._c) : [].concat(a), i], g = p[0], E = p.reduce((h, f) => {
    const b = ph(n, f, s);
    return h.top = pa(b.top, h.top), h.right = lo(b.right, h.right), h.bottom = lo(b.bottom, h.bottom), h.left = pa(b.left, h.left), h;
  }, ph(n, g, s));
  return {
    width: E.right - E.left,
    height: E.bottom - E.top,
    x: E.left,
    y: E.top
  };
}
function qE(t) {
  const {
    width: n,
    height: a
  } = bv(t);
  return {
    width: n,
    height: a
  };
}
function WE(t, n, a) {
  const i = uo(n), s = gi(n), u = a === "fixed", p = dl(t, !0, u, n);
  let g = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const E = Mi(0);
  if (i || !i && !u)
    if ((hl(n) !== "body" || Od(s)) && (g = S0(n)), i) {
      const b = dl(n, !0, u, n);
      E.x = b.x + n.clientLeft, E.y = b.y + n.clientTop;
    } else s && (E.x = wv(s));
  const h = p.left + g.scrollLeft - E.x, f = p.top + g.scrollTop - E.y;
  return {
    x: h,
    y: f,
    width: p.width,
    height: p.height
  };
}
function m2(t) {
  return Ka(t).position === "static";
}
function mh(t, n) {
  return !uo(t) || Ka(t).position === "fixed" ? null : n ? n(t) : t.offsetParent;
}
function Tv(t, n) {
  const a = ga(t);
  if (b0(t))
    return a;
  if (!uo(t)) {
    let s = ki(t);
    for (; s && !Pl(s); ) {
      if (co(s) && !m2(s))
        return s;
      s = ki(s);
    }
    return a;
  }
  let i = mh(t, n);
  for (; i && PE(i) && m2(i); )
    i = mh(i, n);
  return i && Pl(i) && m2(i) && !vf(i) ? a : i || BE(t) || a;
}
const jE = async function(t) {
  const n = this.getOffsetParent || Tv, a = this.getDimensions, i = await a(t.floating);
  return {
    reference: WE(t.reference, await n(t.floating), t.strategy),
    floating: {
      x: 0,
      y: 0,
      width: i.width,
      height: i.height
    }
  };
};
function KE(t) {
  return Ka(t).direction === "rtl";
}
const QE = {
  convertOffsetParentRelativeRectToViewportRelativeRect: $E,
  getDocumentElement: gi,
  getClippingRect: ZE,
  getOffsetParent: Tv,
  getElementRects: jE,
  getClientRects: VE,
  getDimensions: qE,
  getScale: Dl,
  isElement: co,
  isRTL: KE
};
function XE(t, n) {
  let a = null, i;
  const s = gi(t);
  function u() {
    var g;
    clearTimeout(i), (g = a) == null || g.disconnect(), a = null;
  }
  function p(g, E) {
    g === void 0 && (g = !1), E === void 0 && (E = 1), u();
    const {
      left: h,
      top: f,
      width: b,
      height: w
    } = t.getBoundingClientRect();
    if (g || n(), !b || !w)
      return;
    const x = Bd(f), A = Bd(s.clientWidth - (h + b)), D = Bd(s.clientHeight - (f + w)), L = Bd(h), q = {
      rootMargin: -x + "px " + -A + "px " + -D + "px " + -L + "px",
      threshold: pa(0, lo(1, E)) || 1
    };
    let P = !0;
    function k(U) {
      const Z = U[0].intersectionRatio;
      if (Z !== E) {
        if (!P)
          return p();
        Z ? p(!1, Z) : i = setTimeout(() => {
          p(!1, 1e-7);
        }, 1e3);
      }
      P = !1;
    }
    try {
      a = new IntersectionObserver(k, {
        ...q,
        // Handle <iframe>s
        root: s.ownerDocument
      });
    } catch {
      a = new IntersectionObserver(k, q);
    }
    a.observe(t);
  }
  return p(!0), u;
}
function JE(t, n, a, i) {
  i === void 0 && (i = {});
  const {
    ancestorScroll: s = !0,
    ancestorResize: u = !0,
    elementResize: p = typeof ResizeObserver == "function",
    layoutShift: g = typeof IntersectionObserver == "function",
    animationFrame: E = !1
  } = i, h = bf(t), f = s || u ? [...h ? Td(h) : [], ...Td(n)] : [];
  f.forEach(($) => {
    s && $.addEventListener("scroll", a, {
      passive: !0
    }), u && $.addEventListener("resize", a);
  });
  const b = h && g ? XE(h, a) : null;
  let w = -1, x = null;
  p && (x = new ResizeObserver(($) => {
    let [q] = $;
    q && q.target === h && x && (x.unobserve(n), cancelAnimationFrame(w), w = requestAnimationFrame(() => {
      var P;
      (P = x) == null || P.observe(n);
    })), a();
  }), h && !E && x.observe(h), x.observe(n));
  let A, D = E ? dl(t) : null;
  E && L();
  function L() {
    const $ = dl(t);
    D && ($.x !== D.x || $.y !== D.y || $.width !== D.width || $.height !== D.height) && a(), D = $, A = requestAnimationFrame(L);
  }
  return a(), () => {
    var $;
    f.forEach((q) => {
      s && q.removeEventListener("scroll", a), u && q.removeEventListener("resize", a);
    }), b?.(), ($ = x) == null || $.disconnect(), x = null, E && cancelAnimationFrame(A);
  };
}
const eb = ME, tb = DE, gh = OE, nb = LE, rb = IE, ab = RE, ob = kE, ib = (t, n, a) => {
  const i = /* @__PURE__ */ new Map(), s = {
    platform: QE,
    ...a
  }, u = {
    ...s.platform,
    _c: i
  };
  return AE(t, n, {
    ...s,
    platform: u
  });
};
function sb(t) {
  return t != null && typeof t == "object" && "$el" in t;
}
function U2(t) {
  if (sb(t)) {
    const n = t.$el;
    return hf(n) && hl(n) === "#comment" ? null : n;
  }
  return t;
}
function Il(t) {
  return typeof t == "function" ? t() : y(t);
}
function lb(t) {
  return {
    name: "arrow",
    options: t,
    fn(n) {
      const a = U2(Il(t.element));
      return a == null ? {} : ab({
        element: a,
        padding: t.padding
      }).fn(n);
    }
  };
}
function Cv(t) {
  return typeof window > "u" ? 1 : (t.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function fh(t, n) {
  const a = Cv(t);
  return Math.round(n * a) / a;
}
function cb(t, n, a) {
  a === void 0 && (a = {});
  const i = a.whileElementsMounted, s = M(() => {
    var ee;
    return (ee = Il(a.open)) != null ? ee : !0;
  }), u = M(() => Il(a.middleware)), p = M(() => {
    var ee;
    return (ee = Il(a.placement)) != null ? ee : "bottom";
  }), g = M(() => {
    var ee;
    return (ee = Il(a.strategy)) != null ? ee : "absolute";
  }), E = M(() => {
    var ee;
    return (ee = Il(a.transform)) != null ? ee : !0;
  }), h = M(() => U2(t.value)), f = M(() => U2(n.value)), b = z(0), w = z(0), x = z(g.value), A = z(p.value), D = sv({}), L = z(!1), $ = M(() => {
    const ee = {
      position: x.value,
      left: "0",
      top: "0"
    };
    if (!f.value)
      return ee;
    const X = fh(f.value, b.value), re = fh(f.value, w.value);
    return E.value ? {
      ...ee,
      transform: "translate(" + X + "px, " + re + "px)",
      ...Cv(f.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: x.value,
      left: X + "px",
      top: re + "px"
    };
  });
  let q;
  function P() {
    h.value == null || f.value == null || ib(h.value, f.value, {
      middleware: u.value,
      placement: p.value,
      strategy: g.value
    }).then((ee) => {
      b.value = ee.x, w.value = ee.y, x.value = ee.strategy, A.value = ee.placement, D.value = ee.middlewareData, L.value = !0;
    });
  }
  function k() {
    typeof q == "function" && (q(), q = void 0);
  }
  function U() {
    if (k(), i === void 0) {
      P();
      return;
    }
    if (h.value != null && f.value != null) {
      q = i(h.value, f.value, P);
      return;
    }
  }
  function Z() {
    s.value || (L.value = !1);
  }
  return tt([u, p, g], P, {
    flush: "sync"
  }), tt([h, f], U, {
    flush: "sync"
  }), tt(s, Z, {
    flush: "sync"
  }), df() && zl(k), {
    x: xl(b),
    y: xl(w),
    strategy: xl(x),
    placement: xl(A),
    middlewareData: xl(D),
    isPositioned: xl(L),
    floatingStyles: $,
    update: P
  };
}
function kn(t, n) {
  const a = typeof t == "string" && !n ? `${t}Context` : n, i = Symbol(a);
  return [(s) => {
    const u = Ui(i, s);
    if (u || u === null)
      return u;
    throw new Error(
      `Injection \`${i.toString()}\` not found. Component must be used within ${Array.isArray(t) ? `one of the following components: ${t.join(
        ", "
      )}` : `\`${t}\``}`
    );
  }, (s) => (Zl(i, s), s)];
}
function Sf(t, n, a) {
  const i = a.originalEvent.target, s = new CustomEvent(t, {
    bubbles: !1,
    cancelable: !0,
    detail: a
  });
  n && i.addEventListener(t, n, { once: !0 }), i.dispatchEvent(s);
}
function ub(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var db = function t(n, a) {
  if (n === a) return !0;
  if (n && a && typeof n == "object" && typeof a == "object") {
    if (n.constructor !== a.constructor) return !1;
    var i, s, u;
    if (Array.isArray(n)) {
      if (i = n.length, i != a.length) return !1;
      for (s = i; s-- !== 0; )
        if (!t(n[s], a[s])) return !1;
      return !0;
    }
    if (n.constructor === RegExp) return n.source === a.source && n.flags === a.flags;
    if (n.valueOf !== Object.prototype.valueOf) return n.valueOf() === a.valueOf();
    if (n.toString !== Object.prototype.toString) return n.toString() === a.toString();
    if (u = Object.keys(n), i = u.length, i !== Object.keys(a).length) return !1;
    for (s = i; s-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(a, u[s])) return !1;
    for (s = i; s-- !== 0; ) {
      var p = u[s];
      if (!t(n[p], a[p])) return !1;
    }
    return !0;
  }
  return n !== n && a !== a;
};
const ll = /* @__PURE__ */ ub(db);
function g2(t) {
  return t == null;
}
function _b(t, n) {
  var a;
  const i = sv();
  return pn(() => {
    i.value = t();
  }, {
    ...n,
    flush: (a = void 0) != null ? a : "sync"
  }), ql(i);
}
function jl(t) {
  return df() ? (zl(t), !0) : !1;
}
function pb() {
  const t = /* @__PURE__ */ new Set(), n = (a) => {
    t.delete(a);
  };
  return {
    on: (a) => {
      t.add(a);
      const i = () => n(a);
      return jl(i), {
        off: i
      };
    },
    off: n,
    trigger: (...a) => Promise.all(Array.from(t).map((i) => i(...a)))
  };
}
function mb(t) {
  let n = !1, a;
  const i = _v(!0);
  return (...s) => (n || (a = i.run(() => t(...s)), n = !0), a);
}
function xv(t) {
  let n = 0, a, i;
  const s = () => {
    n -= 1, i && n <= 0 && (i.stop(), a = void 0, i = void 0);
  };
  return (...u) => (n += 1, a || (i = _v(!0), a = i.run(() => t(...u))), jl(s), a);
}
function di(t) {
  return typeof t == "function" ? t() : y(t);
}
const fi = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const gb = (t) => typeof t < "u", fb = (t) => t != null, hb = Object.prototype.toString, vb = (t) => hb.call(t) === "[object Object]", Eb = () => {
}, hh = /* @__PURE__ */ bb();
function bb() {
  var t, n;
  return fi && ((t = window?.navigator) == null ? void 0 : t.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((n = window?.navigator) == null ? void 0 : n.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window?.navigator.userAgent));
}
function Sb(t) {
  return po();
}
function Av(t, n = 1e4) {
  return uE((a, i) => {
    let s = di(t), u;
    const p = () => setTimeout(() => {
      s = di(t), i();
    }, di(n));
    return jl(() => {
      clearTimeout(u);
    }), {
      get() {
        return a(), s;
      },
      set(g) {
        s = g, i(), clearTimeout(u), u = p();
      }
    };
  });
}
function wb(t, n) {
  Sb() && pv(t, n);
}
function Rv(t, n, a = {}) {
  const {
    immediate: i = !0
  } = a, s = z(!1);
  let u = null;
  function p() {
    u && (clearTimeout(u), u = null);
  }
  function g() {
    s.value = !1, p();
  }
  function E(...h) {
    p(), s.value = !0, u = setTimeout(() => {
      s.value = !1, u = null, t(...h);
    }, di(n));
  }
  return i && (s.value = !0, fi && E()), jl(g), {
    isPending: ql(s),
    start: E,
    stop: g
  };
}
function hi(t) {
  var n;
  const a = di(t);
  return (n = a?.$el) != null ? n : a;
}
const w0 = fi ? window : void 0;
function Bl(...t) {
  let n, a, i, s;
  if (typeof t[0] == "string" || Array.isArray(t[0]) ? ([a, i, s] = t, n = w0) : [n, a, i, s] = t, !n)
    return Eb;
  Array.isArray(a) || (a = [a]), Array.isArray(i) || (i = [i]);
  const u = [], p = () => {
    u.forEach((f) => f()), u.length = 0;
  }, g = (f, b, w, x) => (f.addEventListener(b, w, x), () => f.removeEventListener(b, w, x)), E = tt(
    () => [hi(n), di(s)],
    ([f, b]) => {
      if (p(), !f)
        return;
      const w = vb(b) ? { ...b } : b;
      u.push(
        ...a.flatMap((x) => i.map((A) => g(f, x, A, w)))
      );
    },
    { immediate: !0, flush: "post" }
  ), h = () => {
    E(), p();
  };
  return jl(h), h;
}
function yb(t) {
  return typeof t == "function" ? t : typeof t == "string" ? (n) => n.key === t : Array.isArray(t) ? (n) => t.includes(n.key) : () => !0;
}
function Tb(...t) {
  let n, a, i = {};
  t.length === 3 ? (n = t[0], a = t[1], i = t[2]) : t.length === 2 ? typeof t[1] == "object" ? (n = !0, a = t[0], i = t[1]) : (n = t[0], a = t[1]) : (n = !0, a = t[0]);
  const {
    target: s = w0,
    eventName: u = "keydown",
    passive: p = !1,
    dedupe: g = !1
  } = i, E = yb(n);
  return Bl(s, u, (h) => {
    h.repeat && di(g) || E(h) && a(h);
  }, p);
}
function Ov() {
  const t = z(!1), n = po();
  return n && xt(() => {
    t.value = !0;
  }, n), t;
}
function Cb(t) {
  const n = Ov();
  return M(() => (n.value, !!t()));
}
function xb(t, n, a = {}) {
  const { window: i = w0, ...s } = a;
  let u;
  const p = Cb(() => i && "MutationObserver" in i), g = () => {
    u && (u.disconnect(), u = void 0);
  }, E = M(() => {
    const w = di(t), x = (Array.isArray(w) ? w : [w]).map(hi).filter(fb);
    return new Set(x);
  }), h = tt(
    () => E.value,
    (w) => {
      g(), p.value && w.size && (u = new MutationObserver(n), w.forEach((x) => u.observe(x, s)));
    },
    { immediate: !0, flush: "post" }
  ), f = () => u?.takeRecords(), b = () => {
    g(), h();
  };
  return jl(b), {
    isSupported: p,
    stop: b,
    takeRecords: f
  };
}
function Ab(t) {
  return JSON.parse(JSON.stringify(t));
}
function ma(t, n, a, i = {}) {
  var s, u, p;
  const {
    clone: g = !1,
    passive: E = !1,
    eventName: h,
    deep: f = !1,
    defaultValue: b,
    shouldEmit: w
  } = i, x = po(), A = a || x?.emit || ((s = x?.$emit) == null ? void 0 : s.bind(x)) || ((p = (u = x?.proxy) == null ? void 0 : u.$emit) == null ? void 0 : p.bind(x?.proxy));
  let D = h;
  n || (n = "modelValue"), D = D || `update:${n.toString()}`;
  const L = (P) => g ? typeof g == "function" ? g(P) : Ab(P) : P, $ = () => gb(t[n]) ? L(t[n]) : b, q = (P) => {
    w ? w(P) && A(D, P) : A(D, P);
  };
  if (E) {
    const P = $(), k = z(P);
    let U = !1;
    return tt(
      () => t[n],
      (Z) => {
        U || (U = !0, k.value = L(Z), Ct(() => U = !1));
      }
    ), tt(
      k,
      (Z) => {
        !U && (Z !== t[n] || f) && q(Z);
      },
      { deep: f }
    ), k;
  } else
    return M({
      get() {
        return $();
      },
      set(P) {
        q(P);
      }
    });
}
function wf(t) {
  return t ? t.flatMap((n) => n.type === Qe ? wf(n.children) : [n]) : [];
}
function Vr() {
  let t = document.activeElement;
  if (t == null)
    return null;
  for (; t != null && t.shadowRoot != null && t.shadowRoot.activeElement != null; )
    t = t.shadowRoot.activeElement;
  return t;
}
const Rb = ["INPUT", "TEXTAREA"];
function Iv(t, n, a, i = {}) {
  if (!n || i.enableIgnoredElement && Rb.includes(n.nodeName))
    return null;
  const {
    arrowKeyOptions: s = "both",
    attributeName: u = "[data-radix-vue-collection-item]",
    itemsArray: p = [],
    loop: g = !0,
    dir: E = "ltr",
    preventScroll: h = !0,
    focus: f = !1
  } = i, [b, w, x, A, D, L] = [
    t.key === "ArrowRight",
    t.key === "ArrowLeft",
    t.key === "ArrowUp",
    t.key === "ArrowDown",
    t.key === "Home",
    t.key === "End"
  ], $ = x || A, q = b || w;
  if (!D && !L && (!$ && !q || s === "vertical" && q || s === "horizontal" && $))
    return null;
  const P = a ? Array.from(a.querySelectorAll(u)) : p;
  if (!P.length)
    return null;
  h && t.preventDefault();
  let k = null;
  return q || $ ? k = Nv(P, n, {
    goForward: $ ? A : E === "ltr" ? b : w,
    loop: g
  }) : D ? k = P.at(0) || null : L && (k = P.at(-1) || null), f && k?.focus(), k;
}
function Nv(t, n, a, i = t.length) {
  if (--i === 0)
    return null;
  const s = t.indexOf(n), u = a.goForward ? s + 1 : s - 1;
  if (!a.loop && (u < 0 || u >= t.length))
    return null;
  const p = (u + t.length) % t.length, g = t[p];
  return g ? g.hasAttribute("disabled") && g.getAttribute("disabled") !== "false" ? Nv(
    t,
    g,
    a,
    i
  ) : g : null;
}
function f2(t) {
  if (t === null || typeof t != "object")
    return !1;
  const n = Object.getPrototypeOf(t);
  return n !== null && n !== Object.prototype && Object.getPrototypeOf(n) !== null || Symbol.iterator in t ? !1 : Symbol.toStringTag in t ? Object.prototype.toString.call(t) === "[object Module]" : !0;
}
function $2(t, n, a = ".", i) {
  if (!f2(n))
    return $2(t, {}, a);
  const s = Object.assign({}, n);
  for (const u in t) {
    if (u === "__proto__" || u === "constructor")
      continue;
    const p = t[u];
    p != null && (Array.isArray(p) && Array.isArray(s[u]) ? s[u] = [...p, ...s[u]] : f2(p) && f2(s[u]) ? s[u] = $2(
      p,
      s[u],
      (a ? `${a}.` : "") + u.toString()
    ) : s[u] = p);
  }
  return s;
}
function Ob(t) {
  return (...n) => (
    // eslint-disable-next-line unicorn/no-array-reduce
    n.reduce((a, i) => $2(a, i, ""), {})
  );
}
const Ib = Ob(), [yf] = kn("ConfigProvider");
let Nb = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict", Mb = (t = 21) => {
  let n = "", a = t;
  for (; a--; )
    n += Nb[Math.random() * 64 | 0];
  return n;
};
const Db = xv(() => {
  const t = z(/* @__PURE__ */ new Map()), n = z(), a = M(() => {
    for (const p of t.value.values())
      if (p)
        return !0;
    return !1;
  }), i = yf({
    scrollBody: z(!0)
  });
  let s = null;
  const u = () => {
    document.body.style.paddingRight = "", document.body.style.marginRight = "", document.body.style.pointerEvents = "", document.body.style.removeProperty("--scrollbar-width"), document.body.style.overflow = n.value ?? "", hh && s?.(), n.value = void 0;
  };
  return tt(a, (p, g) => {
    var E;
    if (!fi)
      return;
    if (!p) {
      g && u();
      return;
    }
    n.value === void 0 && (n.value = document.body.style.overflow);
    const h = window.innerWidth - document.documentElement.clientWidth, f = { padding: h, margin: 0 }, b = (E = i.scrollBody) != null && E.value ? typeof i.scrollBody.value == "object" ? Ib({
      padding: i.scrollBody.value.padding === !0 ? h : i.scrollBody.value.padding,
      margin: i.scrollBody.value.margin === !0 ? h : i.scrollBody.value.margin
    }, f) : f : { padding: 0, margin: 0 };
    h > 0 && (document.body.style.paddingRight = typeof b.padding == "number" ? `${b.padding}px` : String(b.padding), document.body.style.marginRight = typeof b.margin == "number" ? `${b.margin}px` : String(b.margin), document.body.style.setProperty("--scrollbar-width", `${h}px`), document.body.style.overflow = "hidden"), hh && (s = Bl(
      document,
      "touchmove",
      (w) => kb(w),
      { passive: !1 }
    )), Ct(() => {
      document.body.style.pointerEvents = "none", document.body.style.overflow = "hidden";
    });
  }, { immediate: !0, flush: "sync" }), t;
});
function Tf(t) {
  const n = Mb(6), a = Db();
  a.value.set(n, t ?? !1);
  const i = M({
    get: () => a.value.get(n) ?? !1,
    set: (s) => a.value.set(n, s)
  });
  return wb(() => {
    a.value.delete(n);
  }), i;
}
function Mv(t) {
  const n = window.getComputedStyle(t);
  if (n.overflowX === "scroll" || n.overflowY === "scroll" || n.overflowX === "auto" && t.clientWidth < t.scrollWidth || n.overflowY === "auto" && t.clientHeight < t.scrollHeight)
    return !0;
  {
    const a = t.parentNode;
    return !(a instanceof Element) || a.tagName === "BODY" ? !1 : Mv(a);
  }
}
function kb(t) {
  const n = t || window.event, a = n.target;
  return a instanceof Element && Mv(a) ? !1 : n.touches.length > 1 ? !0 : (n.preventDefault && n.cancelable && n.preventDefault(), !1);
}
const Lb = "data-radix-vue-collection-item";
function Pb(t, n = Lb) {
  const a = Symbol();
  return { createCollection: (i) => {
    const s = z([]);
    function u() {
      const p = hi(i);
      return p ? s.value = Array.from(
        p.querySelectorAll(`[${n}]:not([data-disabled])`)
      ) : s.value = [];
    }
    return dE(() => {
      s.value = [];
    }), xt(u), _E(u), tt(() => i?.value, u, { immediate: !0 }), Zl(a, s), s;
  }, injectCollection: () => Ui(a, z([])) };
}
function Kl(t) {
  const n = yf({
    dir: z("ltr")
  });
  return M(() => {
    var a;
    return t?.value || ((a = n.dir) == null ? void 0 : a.value) || "ltr";
  });
}
function Id(t) {
  const n = po(), a = n?.type.emits, i = {};
  return a != null && a.length || console.warn(
    `No emitted event found. Please check component: ${n?.type.__name}`
  ), a?.forEach((s) => {
    i[sE(lv(s))] = (...u) => t(s, ...u);
  }), i;
}
let h2 = 0;
function Bb() {
  pn((t) => {
    if (!fi)
      return;
    const n = document.querySelectorAll("[data-radix-focus-guard]");
    document.body.insertAdjacentElement(
      "afterbegin",
      n[0] ?? vh()
    ), document.body.insertAdjacentElement(
      "beforeend",
      n[1] ?? vh()
    ), h2++, t(() => {
      h2 === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((a) => a.remove()), h2--;
    });
  });
}
function vh() {
  const t = document.createElement("span");
  return t.setAttribute("data-radix-focus-guard", ""), t.tabIndex = 0, t.style.outline = "none", t.style.opacity = "0", t.style.position = "fixed", t.style.pointerEvents = "none", t;
}
function Fb(t) {
  return M(() => {
    var n;
    return di(t) ? !!((n = hi(t)) != null && n.closest("form")) : !0;
  });
}
function vl(t) {
  const n = po(), a = Object.keys(n?.type.props ?? {}).reduce((s, u) => {
    const p = (n?.type.props[u]).default;
    return p !== void 0 && (s[u] = p), s;
  }, {}), i = _f(t);
  return M(() => {
    const s = {}, u = n?.vnode.props ?? {};
    return Object.keys(u).forEach((p) => {
      s[lv(p)] = u[p];
    }), Object.keys({ ...a, ...s }).reduce((p, g) => (i.value[g] !== void 0 && (p[g] = i.value[g]), p), {});
  });
}
function Wn(t, n) {
  const a = vl(t), i = n ? Id(n) : {};
  return M(() => ({
    ...a.value,
    ...i
  }));
}
function Ze() {
  const t = po(), n = z(), a = M(() => {
    var p, g;
    return ["#text", "#comment"].includes((p = n.value) == null ? void 0 : p.$el.nodeName) ? (g = n.value) == null ? void 0 : g.$el.nextElementSibling : hi(n);
  }), i = Object.assign({}, t.exposed), s = {};
  for (const p in t.props)
    Object.defineProperty(s, p, {
      enumerable: !0,
      configurable: !0,
      get: () => t.props[p]
    });
  if (Object.keys(i).length > 0)
    for (const p in i)
      Object.defineProperty(s, p, {
        enumerable: !0,
        configurable: !0,
        get: () => i[p]
      });
  Object.defineProperty(s, "$el", {
    enumerable: !0,
    configurable: !0,
    get: () => t.vnode.el
  }), t.exposed = s;
  function u(p) {
    n.value = p, p && (Object.defineProperty(s, "$el", {
      enumerable: !0,
      configurable: !0,
      get: () => p instanceof Element ? p : p.$el
    }), t.exposed = s);
  }
  return { forwardRef: u, currentRef: n, currentElement: a };
}
function Ub(t, n) {
  const a = Av(!1, 300), i = z(null), s = pb();
  function u() {
    i.value = null, a.value = !1;
  }
  function p(g, E) {
    const h = g.currentTarget, f = { x: g.clientX, y: g.clientY }, b = $b(f, h.getBoundingClientRect()), w = Vb(f, b), x = Hb(E.getBoundingClientRect()), A = Yb([...w, ...x]);
    i.value = A, a.value = !0;
  }
  return pn((g) => {
    if (t.value && n.value) {
      const E = (f) => p(f, n.value), h = (f) => p(f, t.value);
      t.value.addEventListener("pointerleave", E), n.value.addEventListener("pointerleave", h), g(() => {
        var f, b;
        (f = t.value) == null || f.removeEventListener("pointerleave", E), (b = n.value) == null || b.removeEventListener("pointerleave", h);
      });
    }
  }), pn((g) => {
    var E;
    if (i.value) {
      const h = (f) => {
        var b, w;
        if (!i.value)
          return;
        const x = f.target, A = { x: f.clientX, y: f.clientY }, D = ((b = t.value) == null ? void 0 : b.contains(x)) || ((w = n.value) == null ? void 0 : w.contains(x)), L = !Gb(A, i.value), $ = !!x.closest("[data-grace-area-trigger]");
        D ? u() : (L || $) && (u(), s.trigger());
      };
      (E = t.value) == null || E.ownerDocument.addEventListener("pointermove", h), g(() => {
        var f;
        return (f = t.value) == null ? void 0 : f.ownerDocument.removeEventListener("pointermove", h);
      });
    }
  }), {
    isPointerInTransit: a,
    onPointerExit: s.on
  };
}
function $b(t, n) {
  const a = Math.abs(n.top - t.y), i = Math.abs(n.bottom - t.y), s = Math.abs(n.right - t.x), u = Math.abs(n.left - t.x);
  switch (Math.min(a, i, s, u)) {
    case u:
      return "left";
    case s:
      return "right";
    case a:
      return "top";
    case i:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function Vb(t, n, a = 5) {
  const i = [];
  switch (n) {
    case "top":
      i.push(
        { x: t.x - a, y: t.y + a },
        { x: t.x + a, y: t.y + a }
      );
      break;
    case "bottom":
      i.push(
        { x: t.x - a, y: t.y - a },
        { x: t.x + a, y: t.y - a }
      );
      break;
    case "left":
      i.push(
        { x: t.x + a, y: t.y - a },
        { x: t.x + a, y: t.y + a }
      );
      break;
    case "right":
      i.push(
        { x: t.x - a, y: t.y - a },
        { x: t.x - a, y: t.y + a }
      );
      break;
  }
  return i;
}
function Hb(t) {
  const { top: n, right: a, bottom: i, left: s } = t;
  return [
    { x: s, y: n },
    { x: a, y: n },
    { x: a, y: i },
    { x: s, y: i }
  ];
}
function Gb(t, n) {
  const { x: a, y: i } = t;
  let s = !1;
  for (let u = 0, p = n.length - 1; u < n.length; p = u++) {
    const g = n[u].x, E = n[u].y, h = n[p].x, f = n[p].y;
    E > i != f > i && a < (h - g) * (i - E) / (f - E) + g && (s = !s);
  }
  return s;
}
function Yb(t) {
  const n = t.slice();
  return n.sort((a, i) => a.x < i.x ? -1 : a.x > i.x ? 1 : a.y < i.y ? -1 : a.y > i.y ? 1 : 0), zb(n);
}
function zb(t) {
  if (t.length <= 1)
    return t.slice();
  const n = [];
  for (let i = 0; i < t.length; i++) {
    const s = t[i];
    for (; n.length >= 2; ) {
      const u = n[n.length - 1], p = n[n.length - 2];
      if ((u.x - p.x) * (s.y - p.y) >= (u.y - p.y) * (s.x - p.x))
        n.pop();
      else break;
    }
    n.push(s);
  }
  n.pop();
  const a = [];
  for (let i = t.length - 1; i >= 0; i--) {
    const s = t[i];
    for (; a.length >= 2; ) {
      const u = a[a.length - 1], p = a[a.length - 2];
      if ((u.x - p.x) * (s.y - p.y) >= (u.y - p.y) * (s.x - p.x))
        a.pop();
      else break;
    }
    a.push(s);
  }
  return a.pop(), n.length === 1 && a.length === 1 && n[0].x === a[0].x && n[0].y === a[0].y ? n : n.concat(a);
}
var Zb = function(t) {
  if (typeof document > "u")
    return null;
  var n = Array.isArray(t) ? t[0] : t;
  return n.ownerDocument.body;
}, Al = /* @__PURE__ */ new WeakMap(), Fd = /* @__PURE__ */ new WeakMap(), Ud = {}, v2 = 0, Dv = function(t) {
  return t && (t.host || Dv(t.parentNode));
}, qb = function(t, n) {
  return n.map(function(a) {
    if (t.contains(a))
      return a;
    var i = Dv(a);
    return i && t.contains(i) ? i : (console.error("aria-hidden", a, "in not contained inside", t, ". Doing nothing"), null);
  }).filter(function(a) {
    return !!a;
  });
}, Wb = function(t, n, a, i) {
  var s = qb(n, Array.isArray(t) ? t : [t]);
  Ud[a] || (Ud[a] = /* @__PURE__ */ new WeakMap());
  var u = Ud[a], p = [], g = /* @__PURE__ */ new Set(), E = new Set(s), h = function(b) {
    !b || g.has(b) || (g.add(b), h(b.parentNode));
  };
  s.forEach(h);
  var f = function(b) {
    !b || E.has(b) || Array.prototype.forEach.call(b.children, function(w) {
      if (g.has(w))
        f(w);
      else
        try {
          var x = w.getAttribute(i), A = x !== null && x !== "false", D = (Al.get(w) || 0) + 1, L = (u.get(w) || 0) + 1;
          Al.set(w, D), u.set(w, L), p.push(w), D === 1 && A && Fd.set(w, !0), L === 1 && w.setAttribute(a, "true"), A || w.setAttribute(i, "true");
        } catch ($) {
          console.error("aria-hidden: cannot operate on ", w, $);
        }
    });
  };
  return f(n), g.clear(), v2++, function() {
    p.forEach(function(b) {
      var w = Al.get(b) - 1, x = u.get(b) - 1;
      Al.set(b, w), u.set(b, x), w || (Fd.has(b) || b.removeAttribute(i), Fd.delete(b)), x || b.removeAttribute(a);
    }), v2--, v2 || (Al = /* @__PURE__ */ new WeakMap(), Al = /* @__PURE__ */ new WeakMap(), Fd = /* @__PURE__ */ new WeakMap(), Ud = {});
  };
}, jb = function(t, n, a) {
  a === void 0 && (a = "data-aria-hidden");
  var i = Array.from(Array.isArray(t) ? t : [t]), s = Zb(t);
  return s ? (i.push.apply(i, Array.from(s.querySelectorAll("[aria-live]"))), Wb(i, s, a, "aria-hidden")) : function() {
    return null;
  };
};
function Cf(t) {
  let n;
  tt(() => hi(t), (a) => {
    a ? n = jb(a) : n && n();
  }), zr(() => {
    n && n();
  });
}
let Kb = 0;
function fa(t, n = "radix") {
  const a = yf({ useId: void 0 });
  return lh.useId ? `${n}-${lh.useId()}` : a.useId ? `${n}-${a.useId()}` : `${n}-${++Kb}`;
}
function Qb(t) {
  const n = z(), a = M(() => {
    var s;
    return ((s = n.value) == null ? void 0 : s.width) ?? 0;
  }), i = M(() => {
    var s;
    return ((s = n.value) == null ? void 0 : s.height) ?? 0;
  });
  return xt(() => {
    const s = hi(t);
    if (s) {
      n.value = { width: s.offsetWidth, height: s.offsetHeight };
      const u = new ResizeObserver((p) => {
        if (!Array.isArray(p) || !p.length)
          return;
        const g = p[0];
        let E, h;
        if ("borderBoxSize" in g) {
          const f = g.borderBoxSize, b = Array.isArray(f) ? f[0] : f;
          E = b.inlineSize, h = b.blockSize;
        } else
          E = s.offsetWidth, h = s.offsetHeight;
        n.value = { width: E, height: h };
      });
      return u.observe(s, { box: "border-box" }), () => u.unobserve(s);
    } else
      n.value = void 0;
  }), {
    width: a,
    height: i
  };
}
function Xb(t, n) {
  const a = z(t);
  function i(s) {
    return n[a.value][s] ?? a.value;
  }
  return {
    state: a,
    dispatch: (s) => {
      a.value = i(s);
    }
  };
}
const Jb = "data-item-text";
function eS(t) {
  const n = Av("", 1e3);
  return {
    search: n,
    handleTypeaheadSearch: (a, i) => {
      if (!(t != null && t.value) && !i)
        return;
      n.value = n.value + a;
      const s = t?.value ?? i, u = Vr(), p = s.map((b) => {
        var w;
        return {
          ref: b,
          textValue: ((w = (b.querySelector(`[${Jb}]`) ?? b).textContent) == null ? void 0 : w.trim()) ?? ""
        };
      }), g = p.find((b) => b.ref === u), E = p.map((b) => b.textValue), h = nS(E, n.value, g?.textValue), f = p.find((b) => b.textValue === h);
      return f && f.ref.focus(), f?.ref;
    },
    resetTypeahead: () => {
      n.value = "";
    }
  };
}
function tS(t, n) {
  return t.map((a, i) => t[(n + i) % t.length]);
}
function nS(t, n, a) {
  const i = n.length > 1 && Array.from(n).every((g) => g === n[0]) ? n[0] : n, s = a ? t.indexOf(a) : -1;
  let u = tS(t, Math.max(s, 0));
  i.length === 1 && (u = u.filter((g) => g !== a));
  const p = u.find(
    (g) => g.toLowerCase().startsWith(i.toLowerCase())
  );
  return p !== a ? p : void 0;
}
const xf = W({
  name: "PrimitiveSlot",
  inheritAttrs: !1,
  setup(t, { attrs: n, slots: a }) {
    return () => {
      var i, s;
      if (!a.default)
        return null;
      const u = wf(a.default()), p = u.findIndex((f) => f.type !== uv);
      if (p === -1)
        return u;
      const g = u[p];
      (i = g.props) == null || delete i.ref;
      const E = g.props ? oe(n, g.props) : n;
      n.class && (s = g.props) != null && s.class && delete g.props.class;
      const h = lE(g, E);
      for (const f in E)
        f.startsWith("on") && (h.props || (h.props = {}), h.props[f] = E[f]);
      return u.length === 1 ? h : (u[p] = h, u);
    };
  }
}), Et = W({
  name: "Primitive",
  inheritAttrs: !1,
  props: {
    asChild: {
      type: Boolean,
      default: !1
    },
    as: {
      type: [String, Object],
      default: "div"
    }
  },
  setup(t, { attrs: n, slots: a }) {
    const i = t.asChild ? "template" : t.as;
    return typeof i == "string" && ["area", "img", "input"].includes(i) ? () => Vt(i, n) : i !== "template" ? () => Vt(t.as, n, { default: a.default }) : () => Vt(xf, n, { default: a.default });
  }
});
function kv() {
  const t = z(), n = M(() => {
    var a, i;
    return ["#text", "#comment"].includes((a = t.value) == null ? void 0 : a.$el.nodeName) ? (i = t.value) == null ? void 0 : i.$el.nextElementSibling : hi(t);
  });
  return {
    primitiveElement: t,
    currentElement: n
  };
}
const [Lv, rS] = kn("CollapsibleRoot"), aS = /* @__PURE__ */ W({
  __name: "CollapsibleRoot",
  props: {
    defaultOpen: { type: Boolean, default: !1 },
    open: { type: Boolean, default: void 0 },
    disabled: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["update:open"],
  setup(t, { expose: n, emit: a }) {
    const i = t, s = ma(i, "open", a, {
      defaultValue: i.defaultOpen,
      passive: i.open === void 0
    }), u = ma(i, "disabled");
    return rS({
      contentId: "",
      disabled: u,
      open: s,
      onOpenToggle: () => {
        s.value = !s.value;
      }
    }), n({ open: s }), Ze(), (p, g) => (c(), G(y(Et), {
      as: p.as,
      "as-child": i.asChild,
      "data-state": y(s) ? "open" : "closed",
      "data-disabled": y(u) ? "" : void 0
    }, {
      default: N(() => [
        I(p.$slots, "default", { open: y(s) })
      ]),
      _: 3
    }, 8, ["as", "as-child", "data-state", "data-disabled"]));
  }
}), oS = /* @__PURE__ */ W({
  __name: "CollapsibleTrigger",
  props: {
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(t) {
    const n = t;
    Ze();
    const a = Lv();
    return (i, s) => {
      var u, p;
      return c(), G(y(Et), {
        type: i.as === "button" ? "button" : void 0,
        as: i.as,
        "as-child": n.asChild,
        "aria-controls": y(a).contentId,
        "aria-expanded": y(a).open.value,
        "data-state": y(a).open.value ? "open" : "closed",
        "data-disabled": (u = y(a).disabled) != null && u.value ? "" : void 0,
        disabled: (p = y(a).disabled) == null ? void 0 : p.value,
        onClick: y(a).onOpenToggle
      }, {
        default: N(() => [
          I(i.$slots, "default")
        ]),
        _: 3
      }, 8, ["type", "as", "as-child", "aria-controls", "aria-expanded", "data-state", "data-disabled", "disabled", "onClick"]);
    };
  }
});
function iS(t, n) {
  var a;
  const i = z({}), s = z("none"), u = z(t), p = t.value ? "mounted" : "unmounted";
  let g;
  const E = ((a = n.value) == null ? void 0 : a.ownerDocument.defaultView) ?? w0, { state: h, dispatch: f } = Xb(p, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  }), b = (L) => {
    var $;
    if (fi) {
      const q = new CustomEvent(L, { bubbles: !1, cancelable: !1 });
      ($ = n.value) == null || $.dispatchEvent(q);
    }
  };
  tt(
    t,
    async (L, $) => {
      var q;
      const P = $ !== L;
      if (await Ct(), P) {
        const k = s.value, U = $d(n.value);
        L ? (f("MOUNT"), b("enter"), U === "none" && b("after-enter")) : U === "none" || ((q = i.value) == null ? void 0 : q.display) === "none" ? (f("UNMOUNT"), b("leave"), b("after-leave")) : $ && k !== U ? (f("ANIMATION_OUT"), b("leave")) : (f("UNMOUNT"), b("after-leave"));
      }
    },
    { immediate: !0 }
  );
  const w = (L) => {
    const $ = $d(n.value), q = $.includes(
      L.animationName
    ), P = h.value === "mounted" ? "enter" : "leave";
    if (L.target === n.value && q && (b(`after-${P}`), f("ANIMATION_END"), !u.value)) {
      const k = n.value.style.animationFillMode;
      n.value.style.animationFillMode = "forwards", g = E?.setTimeout(() => {
        var U;
        ((U = n.value) == null ? void 0 : U.style.animationFillMode) === "forwards" && (n.value.style.animationFillMode = k);
      });
    }
    L.target === n.value && $ === "none" && f("ANIMATION_END");
  }, x = (L) => {
    L.target === n.value && (s.value = $d(n.value));
  }, A = tt(
    n,
    (L, $) => {
      L ? (i.value = getComputedStyle(L), L.addEventListener("animationstart", x), L.addEventListener("animationcancel", w), L.addEventListener("animationend", w)) : (f("ANIMATION_END"), g !== void 0 && E?.clearTimeout(g), $?.removeEventListener("animationstart", x), $?.removeEventListener("animationcancel", w), $?.removeEventListener("animationend", w));
    },
    { immediate: !0 }
  ), D = tt(h, () => {
    const L = $d(n.value);
    s.value = h.value === "mounted" ? L : "none";
  });
  return zr(() => {
    A(), D();
  }), {
    isPresent: M(
      () => ["mounted", "unmountSuspended"].includes(h.value)
    )
  };
}
function $d(t) {
  return t && getComputedStyle(t).animationName || "none";
}
const El = W({
  name: "Presence",
  props: {
    present: {
      type: Boolean,
      required: !0
    },
    forceMount: {
      type: Boolean
    }
  },
  slots: {},
  setup(t, { slots: n, expose: a }) {
    var i;
    const { present: s, forceMount: u } = Nr(t), p = z(), { isPresent: g } = iS(s, p);
    a({ present: g });
    let E = n.default({ present: g });
    E = wf(E || []);
    const h = po();
    if (E && E?.length > 1) {
      const f = (i = h?.parent) != null && i.type.name ? `<${h.parent.type.name} />` : "component";
      throw new Error(
        [
          `Detected an invalid children for \`${f}\` for  \`Presence\` component.`,
          "",
          "Note: Presence works similarly to `v-if` directly, but it waits for animation/transition to finished before unmounting. So it expect only one direct child of valid VNode type.",
          "You can apply a few solutions:",
          [
            "Provide a single child element so that `presence` directive attach correctly.",
            "Ensure the first child is an actual element instead of a raw text node or comment node."
          ].map((b) => `  - ${b}`).join(`
`)
        ].join(`
`)
      );
    }
    return () => u.value || s.value || g.value ? Vt(n.default({ present: g })[0], {
      ref: (f) => {
        const b = hi(f);
        return typeof b?.hasAttribute > "u" || (b != null && b.hasAttribute("data-radix-popper-content-wrapper") ? p.value = b.firstElementChild : p.value = b), b;
      }
    }) : null;
  }
}), sS = /* @__PURE__ */ W({
  inheritAttrs: !1,
  __name: "CollapsibleContent",
  props: {
    forceMount: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  setup(t) {
    const n = t, a = Lv();
    a.contentId || (a.contentId = fa(void 0, "radix-vue-collapsible-content"));
    const i = z(), { forwardRef: s, currentElement: u } = Ze(), p = z(0), g = z(0), E = M(() => a.open.value), h = z(E.value), f = z();
    return tt(
      () => {
        var b;
        return [E.value, (b = i.value) == null ? void 0 : b.present];
      },
      async () => {
        await Ct();
        const b = u.value;
        if (!b)
          return;
        f.value = f.value || {
          transitionDuration: b.style.transitionDuration,
          animationName: b.style.animationName
        }, b.style.transitionDuration = "0s", b.style.animationName = "none";
        const w = b.getBoundingClientRect();
        g.value = w.height, p.value = w.width, h.value || (b.style.transitionDuration = f.value.transitionDuration, b.style.animationName = f.value.animationName);
      },
      {
        immediate: !0
      }
    ), xt(() => {
      requestAnimationFrame(() => {
        h.value = !1;
      });
    }), (b, w) => (c(), G(y(El), {
      ref_key: "presentRef",
      ref: i,
      present: b.forceMount || y(a).open.value,
      "force-mount": !0
    }, {
      default: N(() => {
        var x, A;
        return [
          ne(y(Et), oe(b.$attrs, {
            id: y(a).contentId,
            ref: y(s),
            "as-child": n.asChild,
            as: b.as,
            "data-state": y(a).open.value ? "open" : "closed",
            "data-disabled": (x = y(a).disabled) != null && x.value ? "" : void 0,
            hidden: !((A = i.value) != null && A.present),
            style: {
              "--radix-collapsible-content-height": `${g.value}px`,
              "--radix-collapsible-content-width": `${p.value}px`
            }
          }), {
            default: N(() => {
              var D;
              return [
                (D = i.value) != null && D.present ? I(b.$slots, "default", { key: 0 }) : le("", !0)
              ];
            }),
            _: 3
          }, 16, ["id", "as-child", "as", "data-state", "data-disabled", "hidden", "style"])
        ];
      }),
      _: 3
    }, 8, ["present"]));
  }
});
function Pv({ type: t, defaultValue: n, modelValue: a }) {
  const i = a || n;
  if (g2(t) && g2(a) && g2(n))
    throw new Error("Either the `type` or the `value` or `default-value` prop must be defined.");
  if (a !== void 0 && n !== void 0 && typeof a != typeof n)
    throw new Error(
      `Invalid prop \`value\` of value \`${a}\` supplied, should be the same type as the \`defaultValue\` prop, which is \`${n}\`. The \`value\` prop must be:
  ${t === "single" ? "- a string" : t === "multiple" ? "- an array of strings" : `- a string
- an array of strings`}
  - \`undefined\``
    );
  const s = a !== void 0 || n !== void 0;
  if (t && s) {
    const u = Array.isArray(a) || Array.isArray(n), p = a !== void 0 ? "modelValue" : "defaultValue", g = p === "modelValue" ? typeof a : typeof n;
    if (t === "single" && u)
      return console.error(`Invalid prop \`${p}\` of type ${g} supplied with type \`single\`. The \`modelValue\` prop must be a string or \`undefined\`.
    You can remove the \`type\` prop to let the component infer the type from the ${p} prop.`), "multiple";
    if (t === "multiple" && !u)
      return console.error(`Invalid prop \`${p}\` of type ${g} supplied with type \`multiple\`. The \`modelValue\` prop must be an array of strings or \`undefined\`.
    You can remove the \`type\` prop to let the component infer the type from the ${p} prop.`), "single";
  }
  return s ? Array.isArray(i) ? "multiple" : "single" : t;
}
function lS({ type: t, defaultValue: n, modelValue: a }) {
  return t || Pv({ type: t, defaultValue: n, modelValue: a });
}
function cS({ type: t, defaultValue: n }) {
  return n !== void 0 ? n : t === "single" ? void 0 : [];
}
function uS(t, n) {
  const a = z(lS(t)), i = ma(t, "modelValue", n, {
    defaultValue: cS(t),
    passive: t.modelValue === void 0,
    deep: !0
  });
  tt(
    () => [t.type, t.modelValue, t.defaultValue],
    () => {
      const p = Pv(t);
      a.value !== p && (a.value = p);
    },
    { immediate: !0 }
  );
  function s(p) {
    if (a.value === "single")
      i.value = p === i.value ? void 0 : p;
    else {
      const g = [...i.value || []];
      if (g.includes(p)) {
        const E = g.findIndex((h) => h === p);
        g.splice(E, 1);
      } else
        g.push(p);
      i.value = g;
    }
  }
  const u = M(() => a.value === "single");
  return {
    modelValue: i,
    type: a,
    changeModelValue: s,
    isSingle: u
  };
}
const [y0, dS] = kn("AccordionRoot"), _S = /* @__PURE__ */ W({
  __name: "AccordionRoot",
  props: {
    collapsible: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    dir: {},
    orientation: { default: "vertical" },
    asChild: { type: Boolean },
    as: {},
    type: {},
    modelValue: {},
    defaultValue: {}
  },
  emits: ["update:modelValue"],
  setup(t, { emit: n }) {
    const a = t, i = n, { dir: s, disabled: u } = Nr(a), p = Kl(s), { modelValue: g, changeModelValue: E, isSingle: h } = uS(a, i), { forwardRef: f, currentElement: b } = Ze();
    return dS({
      disabled: u,
      direction: p,
      orientation: a.orientation,
      parentElement: b,
      isSingle: h,
      collapsible: a.collapsible,
      modelValue: g,
      changeModelValue: E
    }), (w, x) => (c(), G(y(Et), {
      ref: y(f),
      "as-child": w.asChild,
      as: w.as
    }, {
      default: N(() => [
        I(w.$slots, "default", { modelValue: y(g) })
      ]),
      _: 3
    }, 8, ["as-child", "as"]));
  }
}), [Af, pS] = kn("AccordionItem"), mS = /* @__PURE__ */ W({
  __name: "AccordionItem",
  props: {
    disabled: { type: Boolean },
    value: {},
    asChild: { type: Boolean },
    as: {}
  },
  setup(t, { expose: n }) {
    const a = t, i = y0(), s = M(
      () => i.isSingle.value ? a.value === i.modelValue.value : Array.isArray(i.modelValue.value) && i.modelValue.value.includes(a.value)
    ), u = M(() => i.disabled.value || a.disabled), p = M(() => u.value ? "" : void 0), g = M(
      () => s.value ? "open" : "closed"
      /* Closed */
    );
    n({ open: s, dataDisabled: p });
    const { currentRef: E, currentElement: h } = Ze();
    pS({
      open: s,
      dataState: g,
      disabled: u,
      dataDisabled: p,
      triggerId: "",
      currentRef: E,
      currentElement: h,
      value: M(() => a.value)
    });
    function f(b) {
      var w;
      const x = b.target;
      if (Array.from(((w = i.parentElement.value) == null ? void 0 : w.querySelectorAll("[data-radix-vue-collection-item]")) ?? []).findIndex((A) => A === x) === -1)
        return null;
      Iv(
        b,
        h.value,
        i.parentElement.value,
        {
          arrowKeyOptions: i.orientation,
          dir: i.direction.value,
          focus: !0
        }
      );
    }
    return (b, w) => (c(), G(y(aS), {
      "data-orientation": y(i).orientation,
      "data-disabled": p.value,
      "data-state": g.value,
      disabled: u.value,
      open: s.value,
      as: a.as,
      "as-child": a.asChild,
      onKeydown: ui(f, ["up", "down", "left", "right", "home", "end"])
    }, {
      default: N(() => [
        I(b.$slots, "default", { open: s.value })
      ]),
      _: 3
    }, 8, ["data-orientation", "data-disabled", "data-state", "disabled", "open", "as", "as-child"]));
  }
}), gS = /* @__PURE__ */ W({
  __name: "AccordionContent",
  props: {
    forceMount: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  setup(t) {
    const n = t, a = y0(), i = Af();
    return Ze(), (s, u) => (c(), G(y(sS), {
      role: "region",
      hidden: !y(i).open.value,
      "as-child": n.asChild,
      "force-mount": n.forceMount,
      "aria-labelledby": y(i).triggerId,
      "data-state": y(i).dataState.value,
      "data-disabled": y(i).dataDisabled.value,
      "data-orientation": y(a).orientation,
      style: { "--radix-accordion-content-width": "var(--radix-collapsible-content-width)", "--radix-accordion-content-height": "var(--radix-collapsible-content-height)" }
    }, {
      default: N(() => [
        I(s.$slots, "default")
      ]),
      _: 3
    }, 8, ["hidden", "as-child", "force-mount", "aria-labelledby", "data-state", "data-disabled", "data-orientation"]));
  }
}), fS = /* @__PURE__ */ W({
  __name: "AccordionHeader",
  props: {
    asChild: { type: Boolean },
    as: { default: "h3" }
  },
  setup(t) {
    const n = t, a = y0(), i = Af();
    return Ze(), (s, u) => (c(), G(y(Et), {
      as: n.as,
      "as-child": n.asChild,
      "data-orientation": y(a).orientation,
      "data-state": y(i).dataState.value,
      "data-disabled": y(i).dataDisabled.value
    }, {
      default: N(() => [
        I(s.$slots, "default")
      ]),
      _: 3
    }, 8, ["as", "as-child", "data-orientation", "data-state", "data-disabled"]));
  }
}), hS = /* @__PURE__ */ W({
  __name: "AccordionTrigger",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(t) {
    const n = t, a = y0(), i = Af();
    i.triggerId || (i.triggerId = fa(void 0, "radix-vue-accordion-trigger"));
    function s() {
      const u = a.isSingle.value && i.open.value && !a.collapsible;
      i.disabled.value || u || a.changeModelValue(i.value.value);
    }
    return (u, p) => (c(), G(y(oS), {
      id: y(i).triggerId,
      ref: y(i).currentRef,
      "data-radix-vue-collection-item": "",
      as: n.as,
      "as-child": n.asChild,
      "aria-disabled": y(i).disabled.value || void 0,
      "aria-expanded": y(i).open.value || !1,
      "data-disabled": y(i).dataDisabled.value,
      "data-orientation": y(a).orientation,
      "data-state": y(i).dataState.value,
      disabled: y(i).disabled.value,
      onClick: s
    }, {
      default: N(() => [
        I(u.$slots, "default")
      ]),
      _: 3
    }, 8, ["id", "as", "as-child", "aria-disabled", "aria-expanded", "data-disabled", "data-orientation", "data-state", "disabled"]));
  }
}), [vi, vS] = kn("DialogRoot"), ES = /* @__PURE__ */ W({
  inheritAttrs: !1,
  __name: "DialogRoot",
  props: {
    open: { type: Boolean, default: void 0 },
    defaultOpen: { type: Boolean, default: !1 },
    modal: { type: Boolean, default: !0 }
  },
  emits: ["update:open"],
  setup(t, { emit: n }) {
    const a = t, i = ma(a, "open", n, {
      defaultValue: a.defaultOpen,
      passive: a.open === void 0
    }), s = z(), u = z(), { modal: p } = Nr(a);
    return vS({
      open: i,
      modal: p,
      openModal: () => {
        i.value = !0;
      },
      onOpenChange: (g) => {
        i.value = g;
      },
      onOpenToggle: () => {
        i.value = !i.value;
      },
      contentId: "",
      titleId: "",
      descriptionId: "",
      triggerElement: s,
      contentElement: u
    }), (g, E) => I(g.$slots, "default", { open: y(i) });
  }
}), Rf = /* @__PURE__ */ W({
  __name: "Teleport",
  props: {
    to: { default: "body" },
    disabled: { type: Boolean },
    forceMount: { type: Boolean }
  },
  setup(t) {
    const n = Ov();
    return (a, i) => y(n) || a.forceMount ? (c(), G(Rd, {
      key: 0,
      to: a.to,
      disabled: a.disabled
    }, [
      I(a.$slots, "default")
    ], 8, ["to", "disabled"])) : le("", !0);
  }
}), bS = /* @__PURE__ */ W({
  __name: "DialogPortal",
  props: {
    to: {},
    disabled: { type: Boolean },
    forceMount: { type: Boolean }
  },
  setup(t) {
    const n = t;
    return (a, i) => (c(), G(y(Rf), ve(we(n)), {
      default: N(() => [
        I(a.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), SS = "dismissableLayer.pointerDownOutside", wS = "dismissableLayer.focusOutside";
function Bv(t, n) {
  const a = n.closest(
    "[data-dismissable-layer]"
  ), i = t.dataset.dismissableLayer === "" ? t : t.querySelector(
    "[data-dismissable-layer]"
  ), s = Array.from(
    t.ownerDocument.querySelectorAll("[data-dismissable-layer]")
  );
  return !!(a && i === a || s.indexOf(i) < s.indexOf(a));
}
function yS(t, n) {
  var a;
  const i = ((a = n?.value) == null ? void 0 : a.ownerDocument) ?? globalThis?.document, s = z(!1), u = z(() => {
  });
  return pn((p) => {
    if (!fi)
      return;
    const g = async (h) => {
      const f = h.target;
      if (n != null && n.value) {
        if (Bv(n.value, f)) {
          s.value = !1;
          return;
        }
        if (h.target && !s.value) {
          let b = function() {
            Sf(
              SS,
              t,
              w
            );
          };
          const w = { originalEvent: h };
          h.pointerType === "touch" ? (i.removeEventListener("click", u.value), u.value = b, i.addEventListener("click", u.value, {
            once: !0
          })) : b();
        } else
          i.removeEventListener("click", u.value);
        s.value = !1;
      }
    }, E = window.setTimeout(() => {
      i.addEventListener("pointerdown", g);
    }, 0);
    p(() => {
      window.clearTimeout(E), i.removeEventListener("pointerdown", g), i.removeEventListener("click", u.value);
    });
  }), {
    onPointerDownCapture: () => s.value = !0
  };
}
function TS(t, n) {
  var a;
  const i = ((a = n?.value) == null ? void 0 : a.ownerDocument) ?? globalThis?.document, s = z(!1);
  return pn((u) => {
    if (!fi)
      return;
    const p = async (g) => {
      n != null && n.value && (await Ct(), !(!n.value || Bv(n.value, g.target)) && g.target && !s.value && Sf(
        wS,
        t,
        { originalEvent: g }
      ));
    };
    i.addEventListener("focusin", p), u(() => i.removeEventListener("focusin", p));
  }), {
    onFocusCapture: () => s.value = !0,
    onBlurCapture: () => s.value = !1
  };
}
const li = Mr({
  layersRoot: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), T0 = /* @__PURE__ */ W({
  __name: "DismissableLayer",
  props: {
    disableOutsidePointerEvents: { type: Boolean, default: !1 },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "dismiss"],
  setup(t, { emit: n }) {
    const a = t, i = n, { forwardRef: s, currentElement: u } = Ze(), p = M(
      () => {
        var A;
        return ((A = u.value) == null ? void 0 : A.ownerDocument) ?? globalThis.document;
      }
    ), g = M(() => li.layersRoot), E = M(() => u.value ? Array.from(g.value).indexOf(u.value) : -1), h = M(() => li.layersWithOutsidePointerEventsDisabled.size > 0), f = M(() => {
      const A = Array.from(g.value), [D] = [...li.layersWithOutsidePointerEventsDisabled].slice(-1), L = A.indexOf(D);
      return E.value >= L;
    }), b = yS(async (A) => {
      const D = [...li.branches].some(
        (L) => L?.contains(A.target)
      );
      !f.value || D || (i("pointerDownOutside", A), i("interactOutside", A), await Ct(), A.defaultPrevented || i("dismiss"));
    }, u), w = TS((A) => {
      [...li.branches].some(
        (D) => D?.contains(A.target)
      ) || (i("focusOutside", A), i("interactOutside", A), A.defaultPrevented || i("dismiss"));
    }, u);
    Tb("Escape", (A) => {
      E.value === g.value.size - 1 && (i("escapeKeyDown", A), A.defaultPrevented || i("dismiss"));
    });
    let x;
    return pn((A) => {
      u.value && (a.disableOutsidePointerEvents && (li.layersWithOutsidePointerEventsDisabled.size === 0 && (x = p.value.body.style.pointerEvents, p.value.body.style.pointerEvents = "none"), li.layersWithOutsidePointerEventsDisabled.add(u.value)), g.value.add(u.value), A(() => {
        a.disableOutsidePointerEvents && li.layersWithOutsidePointerEventsDisabled.size === 1 && (p.value.body.style.pointerEvents = x);
      }));
    }), pn((A) => {
      A(() => {
        u.value && (g.value.delete(u.value), li.layersWithOutsidePointerEventsDisabled.delete(u.value));
      });
    }), (A, D) => (c(), G(y(Et), {
      ref: y(s),
      "as-child": A.asChild,
      as: A.as,
      "data-dismissable-layer": "",
      style: Gr({
        pointerEvents: h.value ? f.value ? "auto" : "none" : void 0
      }),
      onFocusCapture: y(w).onFocusCapture,
      onBlurCapture: y(w).onBlurCapture,
      onPointerdownCapture: y(b).onPointerDownCapture
    }, {
      default: N(() => [
        I(A.$slots, "default")
      ]),
      _: 3
    }, 8, ["as-child", "as", "style", "onFocusCapture", "onBlurCapture", "onPointerdownCapture"]));
  }
}), E2 = "focusScope.autoFocusOnMount", b2 = "focusScope.autoFocusOnUnmount", Eh = { bubbles: !1, cancelable: !0 };
function CS(t, { select: n = !1 } = {}) {
  const a = Vr();
  for (const i of t)
    if (Ii(i, { select: n }), Vr() !== a)
      return !0;
}
function xS(t) {
  const n = Fv(t), a = bh(n, t), i = bh(n.reverse(), t);
  return [a, i];
}
function Fv(t) {
  const n = [], a = document.createTreeWalker(t, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (i) => {
      const s = i.tagName === "INPUT" && i.type === "hidden";
      return i.disabled || i.hidden || s ? NodeFilter.FILTER_SKIP : i.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; a.nextNode(); ) n.push(a.currentNode);
  return n;
}
function bh(t, n) {
  for (const a of t)
    if (!AS(a, { upTo: n }))
      return a;
}
function AS(t, { upTo: n }) {
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  for (; t; ) {
    if (n !== void 0 && t === n)
      return !1;
    if (getComputedStyle(t).display === "none")
      return !0;
    t = t.parentElement;
  }
  return !1;
}
function RS(t) {
  return t instanceof HTMLInputElement && "select" in t;
}
function Ii(t, { select: n = !1 } = {}) {
  if (t && t.focus) {
    const a = Vr();
    t.focus({ preventScroll: !0 }), t !== a && RS(t) && n && t.select();
  }
}
const OS = mb(() => z([]));
function IS() {
  const t = OS();
  return {
    add(n) {
      const a = t.value[0];
      n !== a && a?.pause(), t.value = Sh(t.value, n), t.value.unshift(n);
    },
    remove(n) {
      var a;
      t.value = Sh(t.value, n), (a = t.value[0]) == null || a.resume();
    }
  };
}
function Sh(t, n) {
  const a = [...t], i = a.indexOf(n);
  return i !== -1 && a.splice(i, 1), a;
}
function NS(t) {
  return t.filter((n) => n.tagName !== "A");
}
const Uv = /* @__PURE__ */ W({
  __name: "FocusScope",
  props: {
    loop: { type: Boolean, default: !1 },
    trapped: { type: Boolean, default: !1 },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["mountAutoFocus", "unmountAutoFocus"],
  setup(t, { emit: n }) {
    const a = t, i = n, { currentRef: s, currentElement: u } = Ze(), p = z(null), g = IS(), E = Mr({
      paused: !1,
      pause() {
        this.paused = !0;
      },
      resume() {
        this.paused = !1;
      }
    });
    pn((f) => {
      if (!fi)
        return;
      const b = u.value;
      if (!a.trapped)
        return;
      function w(L) {
        if (E.paused || !b)
          return;
        const $ = L.target;
        b.contains($) ? p.value = $ : Ii(p.value, { select: !0 });
      }
      function x(L) {
        if (E.paused || !b)
          return;
        const $ = L.relatedTarget;
        $ !== null && (b.contains($) || Ii(p.value, { select: !0 }));
      }
      function A(L) {
        b.contains(p.value) || Ii(b);
      }
      document.addEventListener("focusin", w), document.addEventListener("focusout", x);
      const D = new MutationObserver(A);
      b && D.observe(b, { childList: !0, subtree: !0 }), f(() => {
        document.removeEventListener("focusin", w), document.removeEventListener("focusout", x), D.disconnect();
      });
    }), pn(async (f) => {
      const b = u.value;
      if (await Ct(), !b)
        return;
      g.add(E);
      const w = Vr();
      if (!b.contains(w)) {
        const x = new CustomEvent(E2, Eh);
        b.addEventListener(E2, (A) => i("mountAutoFocus", A)), b.dispatchEvent(x), x.defaultPrevented || (CS(NS(Fv(b)), {
          select: !0
        }), Vr() === w && Ii(b));
      }
      f(() => {
        b.removeEventListener(E2, (D) => i("mountAutoFocus", D));
        const x = new CustomEvent(b2, Eh), A = (D) => {
          i("unmountAutoFocus", D);
        };
        b.addEventListener(b2, A), b.dispatchEvent(x), setTimeout(() => {
          x.defaultPrevented || Ii(w ?? document.body, { select: !0 }), b.removeEventListener(b2, A), g.remove(E);
        }, 0);
      });
    });
    function h(f) {
      if (!a.loop && !a.trapped || E.paused)
        return;
      const b = f.key === "Tab" && !f.altKey && !f.ctrlKey && !f.metaKey, w = Vr();
      if (b && w) {
        const x = f.currentTarget, [A, D] = xS(x);
        A && D ? !f.shiftKey && w === D ? (f.preventDefault(), a.loop && Ii(A, { select: !0 })) : f.shiftKey && w === A && (f.preventDefault(), a.loop && Ii(D, { select: !0 })) : w === x && f.preventDefault();
      }
    }
    return (f, b) => (c(), G(y(Et), {
      ref_key: "currentRef",
      ref: s,
      tabindex: "-1",
      "as-child": f.asChild,
      as: f.as,
      onKeydown: h
    }, {
      default: N(() => [
        I(f.$slots, "default")
      ]),
      _: 3
    }, 8, ["as-child", "as"]));
  }
}), MS = "menu.itemSelect", V2 = ["Enter", " "], DS = ["ArrowDown", "PageUp", "Home"], $v = ["ArrowUp", "PageDown", "End"], kS = [...DS, ...$v];
[...V2], [...V2];
function Vv(t) {
  return t ? "open" : "closed";
}
function LS(t) {
  const n = Vr();
  for (const a of t)
    if (a === n || (a.focus(), Vr() !== n))
      return;
}
function PS(t, n) {
  const { x: a, y: i } = t;
  let s = !1;
  for (let u = 0, p = n.length - 1; u < n.length; p = u++) {
    const g = n[u].x, E = n[u].y, h = n[p].x, f = n[p].y;
    E > i != f > i && a < (h - g) * (i - E) / (f - E) + g && (s = !s);
  }
  return s;
}
function BS(t, n) {
  if (!n)
    return !1;
  const a = { x: t.clientX, y: t.clientY };
  return PS(a, n);
}
function H2(t) {
  return t.pointerType === "mouse";
}
const FS = "DialogTitle", US = "DialogContent";
function $S({
  titleName: t = FS,
  contentName: n = US,
  componentLink: a = "dialog.html#title",
  titleId: i,
  descriptionId: s,
  contentElement: u
}) {
  const p = `Warning: \`${n}\` requires a \`${t}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://www.radix-vue.com/components/${a}`, g = `Warning: Missing \`Description\` or \`aria-describedby="undefined"\` for ${n}.`;
  xt(() => {
    var E;
    document.getElementById(i) || console.warn(p);
    const h = (E = u.value) == null ? void 0 : E.getAttribute("aria-describedby");
    s && h && (document.getElementById(s) || console.warn(g));
  });
}
const Hv = /* @__PURE__ */ W({
  __name: "DialogContentImpl",
  props: {
    forceMount: { type: Boolean },
    trapFocus: { type: Boolean },
    disableOutsidePointerEvents: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
  setup(t, { emit: n }) {
    const a = t, i = n, s = vi(), { forwardRef: u, currentElement: p } = Ze();
    return s.titleId || (s.titleId = fa(void 0, "radix-vue-dialog-title")), s.descriptionId || (s.descriptionId = fa(void 0, "radix-vue-dialog-description")), xt(() => {
      s.contentElement = p, Vr() !== document.body && (s.triggerElement.value = Vr());
    }), process.env.NODE_ENV !== "production" && $S({
      titleName: "DialogTitle",
      contentName: "DialogContent",
      componentLink: "dialog.html#title",
      titleId: s.titleId,
      descriptionId: s.descriptionId,
      contentElement: p
    }), (g, E) => (c(), G(y(Uv), {
      "as-child": "",
      loop: "",
      trapped: a.trapFocus,
      onMountAutoFocus: E[5] || (E[5] = (h) => i("openAutoFocus", h)),
      onUnmountAutoFocus: E[6] || (E[6] = (h) => i("closeAutoFocus", h))
    }, {
      default: N(() => [
        ne(y(T0), oe({
          id: y(s).contentId,
          ref: y(u),
          as: g.as,
          "as-child": g.asChild,
          "disable-outside-pointer-events": g.disableOutsidePointerEvents,
          role: "dialog",
          "aria-describedby": y(s).descriptionId,
          "aria-labelledby": y(s).titleId,
          "data-state": y(Vv)(y(s).open.value)
        }, g.$attrs, {
          onDismiss: E[0] || (E[0] = (h) => y(s).onOpenChange(!1)),
          onEscapeKeyDown: E[1] || (E[1] = (h) => i("escapeKeyDown", h)),
          onFocusOutside: E[2] || (E[2] = (h) => i("focusOutside", h)),
          onInteractOutside: E[3] || (E[3] = (h) => i("interactOutside", h)),
          onPointerDownOutside: E[4] || (E[4] = (h) => i("pointerDownOutside", h))
        }), {
          default: N(() => [
            I(g.$slots, "default")
          ]),
          _: 3
        }, 16, ["id", "as", "as-child", "disable-outside-pointer-events", "aria-describedby", "aria-labelledby", "data-state"])
      ]),
      _: 3
    }, 8, ["trapped"]));
  }
}), VS = /* @__PURE__ */ W({
  __name: "DialogContentModal",
  props: {
    forceMount: { type: Boolean },
    trapFocus: { type: Boolean },
    disableOutsidePointerEvents: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
  setup(t, { emit: n }) {
    const a = t, i = n, s = vi(), u = Id(i), { forwardRef: p, currentElement: g } = Ze();
    return Cf(g), (E, h) => (c(), G(Hv, oe({ ...a, ...y(u) }, {
      ref: y(p),
      "trap-focus": y(s).open.value,
      "disable-outside-pointer-events": !0,
      onCloseAutoFocus: h[0] || (h[0] = (f) => {
        var b;
        f.defaultPrevented || (f.preventDefault(), (b = y(s).triggerElement.value) == null || b.focus());
      }),
      onPointerDownOutside: h[1] || (h[1] = (f) => {
        const b = f.detail.originalEvent, w = b.button === 0 && b.ctrlKey === !0;
        (b.button === 2 || w) && f.preventDefault();
      }),
      onFocusOutside: h[2] || (h[2] = (f) => {
        f.preventDefault();
      })
    }), {
      default: N(() => [
        I(E.$slots, "default")
      ]),
      _: 3
    }, 16, ["trap-focus"]));
  }
}), HS = /* @__PURE__ */ W({
  __name: "DialogContentNonModal",
  props: {
    forceMount: { type: Boolean },
    trapFocus: { type: Boolean },
    disableOutsidePointerEvents: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
  setup(t, { emit: n }) {
    const a = t, i = Id(n);
    Ze();
    const s = vi(), u = z(!1), p = z(!1);
    return (g, E) => (c(), G(Hv, oe({ ...a, ...y(i) }, {
      "trap-focus": !1,
      "disable-outside-pointer-events": !1,
      onCloseAutoFocus: E[0] || (E[0] = (h) => {
        var f;
        h.defaultPrevented || (u.value || (f = y(s).triggerElement.value) == null || f.focus(), h.preventDefault()), u.value = !1, p.value = !1;
      }),
      onInteractOutside: E[1] || (E[1] = (h) => {
        var f;
        h.defaultPrevented || (u.value = !0, h.detail.originalEvent.type === "pointerdown" && (p.value = !0));
        const b = h.target;
        (f = y(s).triggerElement.value) != null && f.contains(b) && h.preventDefault(), h.detail.originalEvent.type === "focusin" && p.value && h.preventDefault();
      })
    }), {
      default: N(() => [
        I(g.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), GS = /* @__PURE__ */ W({
  __name: "DialogContent",
  props: {
    forceMount: { type: Boolean },
    trapFocus: { type: Boolean },
    disableOutsidePointerEvents: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
  setup(t, { emit: n }) {
    const a = t, i = n, s = vi(), u = Id(i), { forwardRef: p } = Ze();
    return (g, E) => (c(), G(y(El), {
      present: g.forceMount || y(s).open.value
    }, {
      default: N(() => [
        y(s).modal.value ? (c(), G(VS, oe({
          key: 0,
          ref: y(p)
        }, { ...a, ...y(u), ...g.$attrs }), {
          default: N(() => [
            I(g.$slots, "default")
          ]),
          _: 3
        }, 16)) : (c(), G(HS, oe({
          key: 1,
          ref: y(p)
        }, { ...a, ...y(u), ...g.$attrs }), {
          default: N(() => [
            I(g.$slots, "default")
          ]),
          _: 3
        }, 16))
      ]),
      _: 3
    }, 8, ["present"]));
  }
}), YS = /* @__PURE__ */ W({
  __name: "DialogOverlayImpl",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(t) {
    const n = vi();
    return Tf(!0), Ze(), (a, i) => (c(), G(y(Et), {
      as: a.as,
      "as-child": a.asChild,
      "data-state": y(n).open.value ? "open" : "closed",
      style: { "pointer-events": "auto" }
    }, {
      default: N(() => [
        I(a.$slots, "default")
      ]),
      _: 3
    }, 8, ["as", "as-child", "data-state"]));
  }
}), zS = /* @__PURE__ */ W({
  __name: "DialogOverlay",
  props: {
    forceMount: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  setup(t) {
    const n = vi(), { forwardRef: a } = Ze();
    return (i, s) => {
      var u;
      return (u = y(n)) != null && u.modal.value ? (c(), G(y(El), {
        key: 0,
        present: i.forceMount || y(n).open.value
      }, {
        default: N(() => [
          ne(YS, oe(i.$attrs, {
            ref: y(a),
            as: i.as,
            "as-child": i.asChild
          }), {
            default: N(() => [
              I(i.$slots, "default")
            ]),
            _: 3
          }, 16, ["as", "as-child"])
        ]),
        _: 3
      }, 8, ["present"])) : le("", !0);
    };
  }
}), ZS = /* @__PURE__ */ W({
  __name: "DialogClose",
  props: {
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(t) {
    const n = t;
    Ze();
    const a = vi();
    return (i, s) => (c(), G(y(Et), oe(n, {
      type: i.as === "button" ? "button" : void 0,
      onClick: s[0] || (s[0] = (u) => y(a).onOpenChange(!1))
    }), {
      default: N(() => [
        I(i.$slots, "default")
      ]),
      _: 3
    }, 16, ["type"]));
  }
}), qS = /* @__PURE__ */ W({
  __name: "DialogTitle",
  props: {
    asChild: { type: Boolean },
    as: { default: "h2" }
  },
  setup(t) {
    const n = t, a = vi();
    return Ze(), (i, s) => (c(), G(y(Et), oe(n, {
      id: y(a).titleId
    }), {
      default: N(() => [
        I(i.$slots, "default")
      ]),
      _: 3
    }, 16, ["id"]));
  }
}), WS = /* @__PURE__ */ W({
  __name: "DialogDescription",
  props: {
    asChild: { type: Boolean },
    as: { default: "p" }
  },
  setup(t) {
    const n = t;
    Ze();
    const a = vi();
    return (i, s) => (c(), G(y(Et), oe(n, {
      id: y(a).descriptionId
    }), {
      default: N(() => [
        I(i.$slots, "default")
      ]),
      _: 3
    }, 16, ["id"]));
  }
}), [Gv, jS] = kn("PopperRoot"), Of = /* @__PURE__ */ W({
  inheritAttrs: !1,
  __name: "PopperRoot",
  setup(t) {
    const n = z();
    return jS({
      anchor: n,
      onAnchorChange: (a) => n.value = a
    }), (a, i) => I(a.$slots, "default");
  }
}), Yv = /* @__PURE__ */ W({
  __name: "PopperAnchor",
  props: {
    element: {},
    asChild: { type: Boolean },
    as: {}
  },
  setup(t) {
    const n = t, { forwardRef: a, currentElement: i } = Ze(), s = Gv();
    return pn(() => {
      s.onAnchorChange(n.element ?? i.value);
    }), (u, p) => (c(), G(y(Et), {
      ref: y(a),
      as: u.as,
      "as-child": u.asChild
    }, {
      default: N(() => [
        I(u.$slots, "default")
      ]),
      _: 3
    }, 8, ["as", "as-child"]));
  }
});
function KS(t) {
  return t !== null;
}
function QS(t) {
  return {
    name: "transformOrigin",
    options: t,
    fn(n) {
      var a, i, s;
      const { placement: u, rects: p, middlewareData: g } = n, E = ((a = g.arrow) == null ? void 0 : a.centerOffset) !== 0, h = E ? 0 : t.arrowWidth, f = E ? 0 : t.arrowHeight, [b, w] = G2(u), x = { start: "0%", center: "50%", end: "100%" }[w], A = (((i = g.arrow) == null ? void 0 : i.x) ?? 0) + h / 2, D = (((s = g.arrow) == null ? void 0 : s.y) ?? 0) + f / 2;
      let L = "", $ = "";
      return b === "bottom" ? (L = E ? x : `${A}px`, $ = `${-f}px`) : b === "top" ? (L = E ? x : `${A}px`, $ = `${p.floating.height + f}px`) : b === "right" ? (L = `${-f}px`, $ = E ? x : `${D}px`) : b === "left" && (L = `${p.floating.width + f}px`, $ = E ? x : `${D}px`), { data: { x: L, y: $ } };
    }
  };
}
function G2(t) {
  const [n, a = "center"] = t.split("-");
  return [n, a];
}
const zv = {
  side: "bottom",
  sideOffset: 0,
  align: "center",
  alignOffset: 0,
  arrowPadding: 0,
  avoidCollisions: !0,
  collisionBoundary: () => [],
  collisionPadding: 0,
  sticky: "partial",
  hideWhenDetached: !1,
  updatePositionStrategy: "optimized",
  prioritizePosition: !1
}, [IQ, XS] = kn("PopperContent"), a0 = /* @__PURE__ */ W({
  inheritAttrs: !1,
  __name: "PopperContent",
  props: /* @__PURE__ */ dv({
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  }, {
    ...zv
  }),
  emits: ["placed"],
  setup(t, { emit: n }) {
    const a = t, i = n, s = Gv(), { forwardRef: u, currentElement: p } = Ze(), g = z(), E = z(), { width: h, height: f } = Qb(E), b = M(
      () => a.side + (a.align !== "center" ? `-${a.align}` : "")
    ), w = M(() => typeof a.collisionPadding == "number" ? a.collisionPadding : { top: 0, right: 0, bottom: 0, left: 0, ...a.collisionPadding }), x = M(() => Array.isArray(a.collisionBoundary) ? a.collisionBoundary : [a.collisionBoundary]), A = M(() => ({
      padding: w.value,
      boundary: x.value.filter(KS),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: x.value.length > 0
    })), D = _b(() => [
      eb({
        mainAxis: a.sideOffset + f.value,
        alignmentAxis: a.alignOffset
      }),
      a.prioritizePosition && a.avoidCollisions && gh({
        ...A.value
      }),
      a.avoidCollisions && tb({
        mainAxis: !0,
        crossAxis: !!a.prioritizePosition,
        limiter: a.sticky === "partial" ? ob() : void 0,
        ...A.value
      }),
      !a.prioritizePosition && a.avoidCollisions && gh({
        ...A.value
      }),
      nb({
        ...A.value,
        apply: ({ elements: Q, rects: ce, availableWidth: me, availableHeight: Se }) => {
          const { width: Le, height: qe } = ce.reference, _t = Q.floating.style;
          _t.setProperty(
            "--radix-popper-available-width",
            `${me}px`
          ), _t.setProperty(
            "--radix-popper-available-height",
            `${Se}px`
          ), _t.setProperty(
            "--radix-popper-anchor-width",
            `${Le}px`
          ), _t.setProperty(
            "--radix-popper-anchor-height",
            `${qe}px`
          );
        }
      }),
      E.value && lb({ element: E.value, padding: a.arrowPadding }),
      QS({
        arrowWidth: h.value,
        arrowHeight: f.value
      }),
      a.hideWhenDetached && rb({ strategy: "referenceHidden", ...A.value })
    ]), { floatingStyles: L, placement: $, isPositioned: q, middlewareData: P } = cb(
      s.anchor,
      g,
      {
        strategy: "fixed",
        placement: b,
        whileElementsMounted: (...Q) => JE(...Q, {
          animationFrame: a.updatePositionStrategy === "always"
        }),
        middleware: D
      }
    ), k = M(
      () => G2($.value)[0]
    ), U = M(
      () => G2($.value)[1]
    );
    cE(() => {
      q.value && i("placed");
    });
    const Z = M(
      () => {
        var Q;
        return ((Q = P.value.arrow) == null ? void 0 : Q.centerOffset) !== 0;
      }
    ), ee = z("");
    pn(() => {
      p.value && (ee.value = window.getComputedStyle(p.value).zIndex);
    });
    const X = M(() => {
      var Q;
      return ((Q = P.value.arrow) == null ? void 0 : Q.x) ?? 0;
    }), re = M(() => {
      var Q;
      return ((Q = P.value.arrow) == null ? void 0 : Q.y) ?? 0;
    });
    return XS({
      placedSide: k,
      onArrowChange: (Q) => E.value = Q,
      arrowX: X,
      arrowY: re,
      shouldHideArrow: Z
    }), (Q, ce) => {
      var me, Se, Le;
      return c(), _("div", {
        ref_key: "floatingRef",
        ref: g,
        "data-radix-popper-content-wrapper": "",
        style: Gr({
          ...y(L),
          transform: y(q) ? y(L).transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: ee.value,
          "--radix-popper-transform-origin": [
            (me = y(P).transformOrigin) == null ? void 0 : me.x,
            (Se = y(P).transformOrigin) == null ? void 0 : Se.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((Le = y(P).hide) == null ? void 0 : Le.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        })
      }, [
        ne(y(Et), oe({ ref: y(u) }, Q.$attrs, {
          "as-child": a.asChild,
          as: Q.as,
          "data-side": k.value,
          "data-align": U.value,
          style: {
            // if the PopperContent hasn't been placed yet (not all measurements done)
            // we prevent animations so that users's animation don't kick in too early referring wrong sides
            animation: y(q) ? void 0 : "none"
          }
        }), {
          default: N(() => [
            I(Q.$slots, "default")
          ]),
          _: 3
        }, 16, ["as-child", "as", "data-side", "data-align", "style"])
      ], 4);
    };
  }
}), Zv = /* @__PURE__ */ W({
  __name: "VisuallyHidden",
  props: {
    asChild: { type: Boolean },
    as: { default: "span" }
  },
  setup(t) {
    return Ze(), (n, a) => (c(), G(y(Et), {
      as: n.as,
      "as-child": n.asChild,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
        position: "absolute",
        border: 0,
        width: "1px",
        display: "inline-block",
        height: "1px",
        padding: 0,
        margin: "-1px",
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal"
      }
    }, {
      default: N(() => [
        I(n.$slots, "default")
      ]),
      _: 3
    }, 8, ["as", "as-child"]));
  }
}), JS = /* @__PURE__ */ W({
  __name: "VisuallyHiddenInput",
  props: {
    name: {},
    value: {},
    required: { type: Boolean },
    disabled: { type: Boolean }
  },
  setup(t) {
    const n = t, a = M(() => typeof n.value == "string" || typeof n.value == "number" || typeof n.value == "boolean" ? [{ name: n.name, value: n.value }] : typeof n.value == "object" && Array.isArray(n.value) ? n.value.flatMap((i, s) => typeof i == "object" ? Object.entries(i).map(([u, p]) => ({ name: `[${s}][${n.name}][${u}]`, value: p })) : { name: `[${n.name}][${s}]`, value: i }) : n.value !== null && typeof n.value == "object" && !Array.isArray(n.value) ? Object.entries(n.value).map(([i, s]) => ({ name: `[${n.name}][${i}]`, value: s })) : []);
    return (i, s) => (c(!0), _(Qe, null, Ye(a.value, (u) => (c(), G(Zv, {
      key: u.name,
      as: "input",
      type: "hidden",
      hidden: "",
      readonly: "",
      name: u.name,
      value: u.value,
      required: i.required,
      disabled: i.disabled
    }, null, 8, ["name", "value", "required", "disabled"]))), 128));
  }
}), ew = "data-radix-vue-collection-item", [If, tw] = kn("CollectionProvider");
function qv(t = ew) {
  const n = z(/* @__PURE__ */ new Map()), a = z(), i = tw({
    collectionRef: a,
    itemMap: n,
    attrName: t
  }), { getItems: s } = jv(i), u = M(() => Array.from(i.itemMap.value.values())), p = M(() => i.itemMap.value.size);
  return { getItems: s, reactiveItems: u, itemMapSize: p };
}
const Wv = W({
  name: "CollectionSlot",
  setup(t, { slots: n }) {
    const a = If(), { primitiveElement: i, currentElement: s } = kv();
    return tt(s, () => {
      a.collectionRef.value = s.value;
    }), () => Vt(xf, { ref: i }, n);
  }
}), Nf = W({
  name: "CollectionItem",
  inheritAttrs: !1,
  props: {
    value: {
      // It accepts any value
      validator: () => !0
    }
  },
  setup(t, { slots: n, attrs: a }) {
    const i = If(), { primitiveElement: s, currentElement: u } = kv();
    return pn((p) => {
      if (u.value) {
        const g = cv(u.value);
        i.itemMap.value.set(g, { ref: u.value, value: t.value }), p(() => i.itemMap.value.delete(g));
      }
    }), () => Vt(xf, { ...a, [i.attrName]: "", ref: s }, n);
  }
});
function jv(t) {
  const n = t ?? If();
  return { getItems: () => {
    const a = n.collectionRef.value;
    if (!a)
      return [];
    const i = Array.from(a.querySelectorAll(`[${n.attrName}]`));
    return Array.from(n.itemMap.value.values()).sort(
      (s, u) => i.indexOf(s.ref) - i.indexOf(u.ref)
    );
  } };
}
const [Ql, nw] = kn("ComboboxRoot"), rw = /* @__PURE__ */ W({
  __name: "ComboboxRoot",
  props: {
    modelValue: {},
    defaultValue: {},
    open: { type: Boolean, default: void 0 },
    defaultOpen: { type: Boolean },
    searchTerm: {},
    selectedValue: {},
    multiple: { type: Boolean },
    disabled: { type: Boolean },
    name: {},
    dir: {},
    filterFunction: {},
    displayValue: {},
    resetSearchTermOnBlur: { type: Boolean, default: !0 },
    resetSearchTermOnSelect: { type: Boolean, default: !0 },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["update:modelValue", "update:open", "update:searchTerm", "update:selectedValue"],
  setup(t, { emit: n }) {
    const a = t, i = n, { multiple: s, disabled: u, dir: p } = Nr(a), g = Kl(p), E = ma(a, "searchTerm", i, {
      // @ts-expect-error ignore the type error here
      defaultValue: "",
      passive: a.searchTerm === void 0
    }), h = ma(a, "modelValue", i, {
      // @ts-expect-error ignore the type error here
      defaultValue: a.defaultValue ?? s.value ? [] : void 0,
      passive: a.modelValue === void 0,
      deep: !0
    }), f = ma(a, "open", i, {
      defaultValue: a.defaultOpen,
      passive: a.open === void 0
    }), b = ma(a, "selectedValue", i, {
      defaultValue: void 0,
      passive: a.selectedValue === void 0
    });
    async function w(Me) {
      var je, Fe;
      f.value = Me, await Ct(), Me ? (h.value && (Array.isArray(h.value) && s.value ? b.value = (je = P().find((Pn) => {
        var Rt, Zr;
        return ((Zr = (Rt = Pn.ref) == null ? void 0 : Rt.dataset) == null ? void 0 : Zr.state) === "checked";
      })) == null ? void 0 : je.value : b.value = h.value), await Ct(), (Fe = D.value) == null || Fe.focus(), Se()) : (A.value = !1, a.resetSearchTermOnBlur && X("blur"));
    }
    function x(Me) {
      if (Array.isArray(h.value) && s.value) {
        const je = h.value.findIndex((Pn) => ll(Pn, Me)), Fe = [...h.value];
        je === -1 ? Fe.push(Me) : Fe.splice(je, 1), h.value = Fe;
      } else
        h.value = Me, w(!1);
    }
    const A = z(!1), D = z(), L = z(), { forwardRef: $, currentElement: q } = Ze(), { getItems: P, reactiveItems: k, itemMapSize: U } = qv("data-radix-vue-combobox-item"), Z = z([]);
    tt(() => U.value, () => {
      Z.value = P().map((Me) => Me.value);
    }, {
      immediate: !0,
      flush: "post"
    });
    const ee = M(() => {
      if (A.value) {
        if (a.filterFunction)
          return a.filterFunction(Z.value, E.value);
        const Me = Z.value.filter((je) => typeof je == "string");
        if (Me.length)
          return Me.filter((je) => {
            var Fe;
            return je.toLowerCase().includes((Fe = E.value) == null ? void 0 : Fe.toLowerCase());
          });
      }
      return Z.value;
    });
    function X(Me) {
      const je = Me === "blur" || Me === "select" && a.resetSearchTermOnSelect;
      !s.value && h.value && !Array.isArray(h.value) ? a.displayValue ? E.value = a.displayValue(h.value) : typeof h.value != "object" ? E.value = h.value.toString() : je && (E.value = "") : je && (E.value = "");
    }
    const re = M(() => ee.value.findIndex((Me) => ll(Me, b.value))), Q = M(() => {
      var Me;
      return (Me = k.value.find((je) => ll(je.value, b.value))) == null ? void 0 : Me.ref;
    }), ce = M(() => JSON.stringify(h.value));
    tt(ce, async () => {
      await Ct(), await Ct(), X("select");
    }, {
      // If searchTerm is provided with value during initialization, we don't reset it immediately
      immediate: !a.searchTerm
    }), tt(() => [ee.value.length, E.value.length], async ([Me, je], [Fe, Pn]) => {
      await Ct(), await Ct(), Me && (Pn > je || re.value === -1) && (b.value = ee.value[0]);
    });
    const me = Fb(q);
    function Se() {
      var Me;
      Q.value instanceof Element && ((Me = Q.value) == null || Me.scrollIntoView({ block: "nearest" }));
    }
    function Le() {
      Q.value instanceof Element && Q.value.focus && Q.value.focus();
    }
    const qe = z(!1);
    function _t() {
      qe.value = !0;
    }
    function ot() {
      requestAnimationFrame(() => {
        qe.value = !1;
      });
    }
    async function st(Me) {
      var je;
      ee.value.length && b.value && Q.value instanceof Element && (Me.preventDefault(), Me.stopPropagation(), qe.value || (je = Q.value) == null || je.click());
    }
    return nw({
      searchTerm: E,
      modelValue: h,
      // @ts-expect-error ignoring
      onValueChange: x,
      isUserInputted: A,
      multiple: s,
      disabled: u,
      open: f,
      onOpenChange: w,
      filteredOptions: ee,
      contentId: "",
      inputElement: D,
      selectedElement: Q,
      onInputElementChange: (Me) => D.value = Me,
      onInputNavigation: async (Me) => {
        const je = re.value;
        je === 0 && Me === "up" || je === ee.value.length - 1 && Me === "down" || (je === -1 && ee.value.length || Me === "home" ? b.value = ee.value[0] : Me === "end" ? b.value = ee.value[ee.value.length - 1] : b.value = ee.value[Me === "up" ? je - 1 : je + 1], await Ct(), Se(), Le(), Ct(() => {
          var Fe;
          return (Fe = D.value) == null ? void 0 : Fe.focus({ preventScroll: !0 });
        }));
      },
      onInputEnter: st,
      onCompositionEnd: ot,
      onCompositionStart: _t,
      selectedValue: b,
      onSelectedValueChange: (Me) => b.value = Me,
      parentElement: q,
      contentElement: L,
      onContentElementChange: (Me) => L.value = Me
    }), (Me, je) => (c(), G(y(Of), null, {
      default: N(() => [
        ne(y(Et), oe({
          ref: y($),
          style: {
            pointerEvents: y(f) ? "auto" : void 0
          },
          as: Me.as,
          "as-child": Me.asChild,
          dir: y(g)
        }, Me.$attrs), {
          default: N(() => [
            I(Me.$slots, "default", {
              open: y(f),
              modelValue: y(h)
            }),
            y(me) && a.name ? (c(), G(y(JS), {
              key: 0,
              name: a.name,
              value: y(h)
            }, null, 8, ["name", "value"])) : le("", !0)
          ]),
          _: 3
        }, 16, ["style", "as", "as-child", "dir"])
      ]),
      _: 3
    }));
  }
}), aw = /* @__PURE__ */ W({
  __name: "ComboboxInput",
  props: {
    type: { default: "text" },
    disabled: { type: Boolean },
    autoFocus: { type: Boolean },
    asChild: { type: Boolean },
    as: { default: "input" }
  },
  setup(t) {
    const n = t, a = Ql(), { forwardRef: i, currentElement: s } = Ze();
    xt(() => {
      const f = s.value.nodeName === "INPUT" ? s.value : s.value.querySelector("input");
      f && (a.onInputElementChange(f), setTimeout(() => {
        n.autoFocus && f?.focus();
      }, 1));
    });
    const u = M(() => n.disabled || a.disabled.value || !1), p = z();
    iE(() => {
      var f;
      return p.value = (f = a.selectedElement.value) == null ? void 0 : f.id;
    });
    function g(f) {
      a.open.value ? a.onInputNavigation(f.key === "ArrowUp" ? "up" : "down") : a.onOpenChange(!0);
    }
    function E(f) {
      a.open.value && a.onInputNavigation(f.key === "Home" ? "home" : "end");
    }
    function h(f) {
      var b;
      a.searchTerm.value = (b = f.target) == null ? void 0 : b.value, a.open.value || a.onOpenChange(!0), a.isUserInputted.value = !0;
    }
    return (f, b) => (c(), G(y(Et), {
      ref: y(i),
      as: f.as,
      "as-child": f.asChild,
      type: f.type,
      disabled: u.value,
      value: y(a).searchTerm.value,
      "aria-expanded": y(a).open.value,
      "aria-controls": y(a).contentId,
      "aria-disabled": u.value ?? void 0,
      "aria-activedescendant": p.value,
      "aria-autocomplete": "list",
      role: "combobox",
      autocomplete: "false",
      onInput: h,
      onKeydown: [
        ui(xa(g, ["prevent"]), ["down", "up"]),
        ui(y(a).onInputEnter, ["enter"]),
        ui(xa(E, ["prevent"]), ["home", "end"])
      ],
      onCompositionstart: y(a).onCompositionStart,
      onCompositionend: y(a).onCompositionEnd
    }, {
      default: N(() => [
        I(f.$slots, "default")
      ]),
      _: 3
    }, 8, ["as", "as-child", "type", "disabled", "value", "aria-expanded", "aria-controls", "aria-disabled", "aria-activedescendant", "onKeydown", "onCompositionstart", "onCompositionend"]));
  }
}), [Kv, ow] = kn("ComboboxGroup"), iw = /* @__PURE__ */ W({
  __name: "ComboboxGroup",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(t) {
    const n = t, { currentRef: a, currentElement: i } = Ze(), s = fa(void 0, "radix-vue-combobox-group"), u = Ql(), p = z(!1);
    function g() {
      if (!i.value)
        return;
      const E = i.value.querySelectorAll("[data-radix-vue-combobox-item]:not([data-hidden])");
      p.value = !!E.length;
    }
    return xb(i, () => {
      Ct(() => {
        g();
      });
    }, { childList: !0 }), tt(() => u.searchTerm.value, () => {
      Ct(() => {
        g();
      });
    }, { immediate: !0 }), ow({
      id: s
    }), (E, h) => ur((c(), G(y(Et), oe(n, {
      ref_key: "currentRef",
      ref: a,
      role: "group",
      "aria-labelledby": y(s)
    }), {
      default: N(() => [
        I(E.$slots, "default")
      ]),
      _: 3
    }, 16, ["aria-labelledby"])), [
      [Ll, p.value]
    ]);
  }
}), sw = /* @__PURE__ */ W({
  __name: "ComboboxLabel",
  props: {
    for: {},
    asChild: { type: Boolean },
    as: { default: "div" }
  },
  setup(t) {
    const n = t;
    Ze();
    const a = Kv({ id: "" });
    return (i, s) => (c(), G(y(Et), oe(n, {
      id: y(a).id
    }), {
      default: N(() => [
        I(i.$slots, "default")
      ]),
      _: 3
    }, 16, ["id"]));
  }
}), [NQ, lw] = kn("ComboboxContent"), cw = /* @__PURE__ */ W({
  __name: "ComboboxContentImpl",
  props: {
    position: { default: "inline" },
    bodyLock: { type: Boolean },
    dismissable: { type: Boolean, default: !0 },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {},
    disableOutsidePointerEvents: { type: Boolean }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside"],
  setup(t, { emit: n }) {
    const a = t, i = n, { position: s } = Nr(a), u = Ql();
    Tf(a.bodyLock);
    const { forwardRef: p, currentElement: g } = Ze();
    Cf(u.parentElement);
    const E = M(() => a.position === "popper" ? a : {}), h = vl(E.value);
    function f(w) {
      u.onSelectedValueChange("");
    }
    xt(() => {
      u.onContentElementChange(g.value);
    });
    const b = {
      // Ensure border-box for floating-ui calculations
      boxSizing: "border-box",
      "--radix-combobox-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-combobox-content-available-width": "var(--radix-popper-available-width)",
      "--radix-combobox-content-available-height": "var(--radix-popper-available-height)",
      "--radix-combobox-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-combobox-trigger-height": "var(--radix-popper-anchor-height)"
    };
    return lw({ position: s }), (w, x) => (c(), G(y(Wv), null, {
      default: N(() => [
        w.dismissable ? (c(), G(y(T0), {
          key: 0,
          "as-child": "",
          "disable-outside-pointer-events": w.disableOutsidePointerEvents,
          onDismiss: x[0] || (x[0] = (A) => y(u).onOpenChange(!1)),
          onFocusOutside: x[1] || (x[1] = (A) => {
            var D;
            (D = y(u).parentElement.value) != null && D.contains(A.target) && A.preventDefault(), i("focusOutside", A);
          }),
          onInteractOutside: x[2] || (x[2] = (A) => i("interactOutside", A)),
          onEscapeKeyDown: x[3] || (x[3] = (A) => i("escapeKeyDown", A)),
          onPointerDownOutside: x[4] || (x[4] = (A) => {
            var D;
            (D = y(u).parentElement.value) != null && D.contains(A.target) && A.preventDefault(), i("pointerDownOutside", A);
          })
        }, {
          default: N(() => [
            (c(), G(Hr(y(s) === "popper" ? y(a0) : y(Et)), oe({ ...w.$attrs, ...y(h) }, {
              id: y(u).contentId,
              ref: y(p),
              role: "listbox",
              "data-state": y(u).open.value ? "open" : "closed",
              style: {
                // flex layout so we can place the scroll buttons properly
                display: "flex",
                flexDirection: "column",
                // reset the outline by default as the content MAY get focused
                outline: "none",
                ...y(s) === "popper" ? b : {}
              },
              onPointerleave: f
            }), {
              default: N(() => [
                I(w.$slots, "default")
              ]),
              _: 3
            }, 16, ["id", "data-state", "style"]))
          ]),
          _: 3
        }, 8, ["disable-outside-pointer-events"])) : (c(), G(Hr(y(s) === "popper" ? y(a0) : y(Et)), oe({ key: 1 }, { ...w.$attrs, ...E.value }, {
          id: y(u).contentId,
          ref: y(p),
          role: "listbox",
          "data-state": y(u).open.value ? "open" : "closed",
          style: {
            // flex layout so we can place the scroll buttons properly
            display: "flex",
            flexDirection: "column",
            // reset the outline by default as the content MAY get focused
            outline: "none",
            ...y(s) === "popper" ? b : {}
          },
          onPointerleave: f
        }), {
          default: N(() => [
            I(w.$slots, "default")
          ]),
          _: 3
        }, 16, ["id", "data-state", "style"]))
      ]),
      _: 3
    }));
  }
}), uw = /* @__PURE__ */ W({
  __name: "ComboboxContent",
  props: {
    forceMount: { type: Boolean },
    position: {},
    bodyLock: { type: Boolean },
    dismissable: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {},
    disableOutsidePointerEvents: { type: Boolean }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside"],
  setup(t, { emit: n }) {
    const a = Wn(t, n), { forwardRef: i } = Ze(), s = Ql();
    return s.contentId || (s.contentId = fa(void 0, "radix-vue-combobox-content")), (u, p) => (c(), G(y(El), {
      present: u.forceMount || y(s).open.value
    }, {
      default: N(() => [
        ne(cw, oe({ ...y(a), ...u.$attrs }, { ref: y(i) }), {
          default: N(() => [
            I(u.$slots, "default")
          ]),
          _: 3
        }, 16)
      ]),
      _: 3
    }, 8, ["present"]));
  }
}), dw = /* @__PURE__ */ W({
  __name: "ComboboxEmpty",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(t) {
    const n = t;
    Ze();
    const a = Ql(), i = M(() => a.filteredOptions.value.length === 0);
    return (s, u) => i.value ? (c(), G(y(Et), ve(oe({ key: 0 }, n)), {
      default: N(() => [
        I(s.$slots, "default", {}, () => [
          Ne("No options")
        ])
      ]),
      _: 3
    }, 16)) : le("", !0);
  }
}), [MQ, _w] = kn("ComboboxItem"), pw = "combobox.select", mw = /* @__PURE__ */ W({
  __name: "ComboboxItem",
  props: {
    value: {},
    disabled: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["select"],
  setup(t, { emit: n }) {
    const a = t, i = n, { disabled: s } = Nr(a), u = Ql();
    Kv({ id: "", options: z([]) });
    const { forwardRef: p } = Ze(), g = M(
      () => {
        var D, L;
        return u.multiple.value && Array.isArray(u.modelValue.value) ? (D = u.modelValue.value) == null ? void 0 : D.some(($) => ll($, a.value)) : ll((L = u.modelValue) == null ? void 0 : L.value, a.value);
      }
    ), E = M(() => ll(u.selectedValue.value, a.value)), h = fa(void 0, "radix-vue-combobox-item"), f = fa(void 0, "radix-vue-combobox-option"), b = M(() => u.isUserInputted.value ? u.searchTerm.value === "" || !!u.filteredOptions.value.find((D) => ll(D, a.value)) : !0);
    async function w(D) {
      i("select", D), !(D != null && D.defaultPrevented) && !s.value && D && u.onValueChange(a.value);
    }
    function x(D) {
      if (!D)
        return;
      const L = { originalEvent: D, value: a.value };
      Sf(pw, w, L);
    }
    async function A(D) {
      await Ct(), !D.defaultPrevented && u.onSelectedValueChange(a.value);
    }
    if (a.value === "")
      throw new Error(
        "A <ComboboxItem /> must have a value prop that is not an empty string. This is because the Combobox value can be set to an empty string to clear the selection and show the placeholder."
      );
    return _w({
      isSelected: g
    }), (D, L) => (c(), G(y(Nf), { value: D.value }, {
      default: N(() => [
        ur(ne(y(Et), {
          id: y(f),
          ref: y(p),
          role: "option",
          tabindex: "-1",
          "aria-labelledby": y(h),
          "data-highlighted": E.value ? "" : void 0,
          "aria-selected": g.value,
          "data-state": g.value ? "checked" : "unchecked",
          "aria-disabled": y(s) || void 0,
          "data-disabled": y(s) ? "" : void 0,
          as: D.as,
          "as-child": D.asChild,
          "data-hidden": b.value ? void 0 : !0,
          onClick: x,
          onPointermove: A
        }, {
          default: N(() => [
            I(D.$slots, "default", {}, () => [
              Ne(ye(D.value), 1)
            ])
          ]),
          _: 3
        }, 8, ["id", "aria-labelledby", "data-highlighted", "aria-selected", "data-state", "aria-disabled", "data-disabled", "as", "as-child", "data-hidden"]), [
          [Ll, b.value]
        ])
      ]),
      _: 3
    }, 8, ["value"]));
  }
}), gw = /* @__PURE__ */ W({
  __name: "ComboboxSeparator",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(t) {
    const n = t;
    return Ze(), (a, i) => (c(), G(y(Et), oe(n, { "aria-hidden": "true" }), {
      default: N(() => [
        I(a.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), fw = /* @__PURE__ */ W({
  __name: "MenuAnchor",
  props: {
    element: {},
    asChild: { type: Boolean },
    as: {}
  },
  setup(t) {
    const n = t;
    return (a, i) => (c(), G(y(Yv), ve(we(n)), {
      default: N(() => [
        I(a.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
});
function hw() {
  const t = z(!1);
  return xt(() => {
    Bl("keydown", () => {
      t.value = !0;
    }, { capture: !0, passive: !0 }), Bl(["pointerdown", "pointermove"], () => {
      t.value = !1;
    }, { capture: !0, passive: !0 });
  }), t;
}
const vw = xv(hw), [C0, Ew] = kn(["MenuRoot", "MenuSub"], "MenuContext"), [Mf, bw] = kn("MenuRoot"), Sw = /* @__PURE__ */ W({
  __name: "MenuRoot",
  props: {
    open: { type: Boolean, default: !1 },
    dir: {},
    modal: { type: Boolean, default: !0 }
  },
  emits: ["update:open"],
  setup(t, { emit: n }) {
    const a = t, i = n, { modal: s, dir: u } = Nr(a), p = Kl(u), g = ma(a, "open", i), E = z(), h = vw();
    return Ew({
      open: g,
      onOpenChange: (f) => {
        g.value = f;
      },
      content: E,
      onContentChange: (f) => {
        E.value = f;
      }
    }), bw({
      onClose: () => {
        g.value = !1;
      },
      isUsingKeyboardRef: h,
      dir: p,
      modal: s
    }), (f, b) => (c(), G(y(Of), null, {
      default: N(() => [
        I(f.$slots, "default")
      ]),
      _: 3
    }));
  }
}), ww = "rovingFocusGroup.onEntryFocus", yw = { bubbles: !1, cancelable: !0 }, Tw = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function Cw(t, n) {
  return n !== "rtl" ? t : t === "ArrowLeft" ? "ArrowRight" : t === "ArrowRight" ? "ArrowLeft" : t;
}
function xw(t, n, a) {
  const i = Cw(t.key, a);
  if (!(n === "vertical" && ["ArrowLeft", "ArrowRight"].includes(i)) && !(n === "horizontal" && ["ArrowUp", "ArrowDown"].includes(i)))
    return Tw[i];
}
function Qv(t, n = !1) {
  const a = Vr();
  for (const i of t)
    if (i === a || (i.focus({ preventScroll: n }), Vr() !== a))
      return;
}
function Aw(t, n) {
  return t.map((a, i) => t[(n + i) % t.length]);
}
const [Rw, Ow] = kn("RovingFocusGroup"), Xv = /* @__PURE__ */ W({
  __name: "RovingFocusGroup",
  props: {
    orientation: { default: void 0 },
    dir: {},
    loop: { type: Boolean, default: !1 },
    currentTabStopId: {},
    defaultCurrentTabStopId: {},
    preventScrollOnEntryFocus: { type: Boolean, default: !1 },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["entryFocus", "update:currentTabStopId"],
  setup(t, { expose: n, emit: a }) {
    const i = t, s = a, { loop: u, orientation: p, dir: g } = Nr(i), E = Kl(g), h = ma(i, "currentTabStopId", s, {
      defaultValue: i.defaultCurrentTabStopId,
      passive: i.currentTabStopId === void 0
    }), f = z(!1), b = z(!1), w = z(0), { getItems: x } = qv();
    function A(L) {
      const $ = !b.value;
      if (L.currentTarget && L.target === L.currentTarget && $ && !f.value) {
        const q = new CustomEvent(ww, yw);
        if (L.currentTarget.dispatchEvent(q), s("entryFocus", q), !q.defaultPrevented) {
          const P = x().map((ee) => ee.ref).filter((ee) => ee.dataset.disabled !== ""), k = P.find((ee) => ee.getAttribute("data-active") === "true"), U = P.find(
            (ee) => ee.id === h.value
          ), Z = [k, U, ...P].filter(
            Boolean
          );
          Qv(Z, i.preventScrollOnEntryFocus);
        }
      }
      b.value = !1;
    }
    function D() {
      setTimeout(() => {
        b.value = !1;
      }, 1);
    }
    return n({
      getItems: x
    }), Ow({
      loop: u,
      dir: E,
      orientation: p,
      currentTabStopId: h,
      onItemFocus: (L) => {
        h.value = L;
      },
      onItemShiftTab: () => {
        f.value = !0;
      },
      onFocusableItemAdd: () => {
        w.value++;
      },
      onFocusableItemRemove: () => {
        w.value--;
      }
    }), (L, $) => (c(), G(y(Wv), null, {
      default: N(() => [
        ne(y(Et), {
          tabindex: f.value || w.value === 0 ? -1 : 0,
          "data-orientation": y(p),
          as: L.as,
          "as-child": L.asChild,
          dir: y(E),
          style: { outline: "none" },
          onMousedown: $[0] || ($[0] = (q) => b.value = !0),
          onMouseup: D,
          onFocus: A,
          onBlur: $[1] || ($[1] = (q) => f.value = !1)
        }, {
          default: N(() => [
            I(L.$slots, "default")
          ]),
          _: 3
        }, 8, ["tabindex", "data-orientation", "as", "as-child", "dir"])
      ]),
      _: 3
    }));
  }
}), Iw = /* @__PURE__ */ W({
  __name: "RovingFocusItem",
  props: {
    tabStopId: {},
    focusable: { type: Boolean, default: !0 },
    active: { type: Boolean, default: !0 },
    allowShiftKey: { type: Boolean },
    asChild: { type: Boolean },
    as: { default: "span" }
  },
  setup(t) {
    const n = t, a = Rw(), i = M(() => n.tabStopId || fa()), s = M(
      () => a.currentTabStopId.value === i.value
    ), { getItems: u } = jv();
    xt(() => {
      n.focusable && a.onFocusableItemAdd();
    }), zr(() => {
      n.focusable && a.onFocusableItemRemove();
    });
    function p(g) {
      if (g.key === "Tab" && g.shiftKey) {
        a.onItemShiftTab();
        return;
      }
      if (g.target !== g.currentTarget)
        return;
      const E = xw(
        g,
        a.orientation.value,
        a.dir.value
      );
      if (E !== void 0) {
        if (g.metaKey || g.ctrlKey || g.altKey || !n.allowShiftKey && g.shiftKey)
          return;
        g.preventDefault();
        let h = [...u().map((f) => f.ref).filter((f) => f.dataset.disabled !== "")];
        if (E === "last")
          h.reverse();
        else if (E === "prev" || E === "next") {
          E === "prev" && h.reverse();
          const f = h.indexOf(
            g.currentTarget
          );
          h = a.loop.value ? Aw(h, f + 1) : h.slice(f + 1);
        }
        Ct(() => Qv(h));
      }
    }
    return (g, E) => (c(), G(y(Nf), null, {
      default: N(() => [
        ne(y(Et), {
          tabindex: s.value ? 0 : -1,
          "data-orientation": y(a).orientation.value,
          "data-active": g.active,
          "data-disabled": g.focusable ? void 0 : "",
          as: g.as,
          "as-child": g.asChild,
          onMousedown: E[0] || (E[0] = (h) => {
            g.focusable ? y(a).onItemFocus(i.value) : h.preventDefault();
          }),
          onFocus: E[1] || (E[1] = (h) => y(a).onItemFocus(i.value)),
          onKeydown: p
        }, {
          default: N(() => [
            I(g.$slots, "default")
          ]),
          _: 3
        }, 8, ["tabindex", "data-orientation", "data-active", "data-disabled", "as", "as-child"])
      ]),
      _: 3
    }));
  }
}), [Jv, Nw] = kn("MenuContent"), e7 = /* @__PURE__ */ W({
  __name: "MenuContentImpl",
  props: /* @__PURE__ */ dv({
    loop: { type: Boolean },
    disableOutsidePointerEvents: { type: Boolean },
    disableOutsideScroll: { type: Boolean },
    trapFocus: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  }, {
    ...zv
  }),
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "entryFocus", "openAutoFocus", "closeAutoFocus", "dismiss"],
  setup(t, { emit: n }) {
    const a = t, i = n, s = C0(), u = Mf(), { trapFocus: p, disableOutsidePointerEvents: g, loop: E } = Nr(a);
    Bb(), Tf(g.value);
    const h = z(""), f = z(0), b = z(0), w = z(null), x = z("right"), A = z(0), D = z(null), { createCollection: L } = Pb(), { forwardRef: $, currentElement: q } = Ze(), P = L(q);
    tt(q, (Q) => {
      s.onContentChange(Q);
    });
    const { handleTypeaheadSearch: k } = eS(P);
    zr(() => {
      window.clearTimeout(f.value);
    });
    function U(Q) {
      var ce, me;
      return x.value === ((ce = w.value) == null ? void 0 : ce.side) && BS(Q, (me = w.value) == null ? void 0 : me.area);
    }
    async function Z(Q) {
      var ce;
      i("openAutoFocus", Q), !Q.defaultPrevented && (Q.preventDefault(), (ce = q.value) == null || ce.focus({
        preventScroll: !0
      }));
    }
    function ee(Q) {
      if (Q.defaultPrevented)
        return;
      const ce = Q.target.closest("[data-radix-menu-content]") === Q.currentTarget, me = Q.ctrlKey || Q.altKey || Q.metaKey, Se = Q.key.length === 1, Le = Iv(
        Q,
        Vr(),
        q.value,
        {
          loop: E.value,
          arrowKeyOptions: "vertical",
          dir: u?.dir.value,
          focus: !0,
          attributeName: "[data-radix-vue-collection-item]:not([data-disabled])"
        }
      );
      if (Le)
        return Le?.focus();
      if (Q.code === "Space" || (ce && (Q.key === "Tab" && Q.preventDefault(), !me && Se && k(Q.key)), Q.target !== q.value) || !kS.includes(Q.key))
        return;
      Q.preventDefault();
      const qe = P.value;
      $v.includes(Q.key) && qe.reverse(), LS(qe);
    }
    function X(Q) {
      var ce, me;
      (me = (ce = Q?.currentTarget) == null ? void 0 : ce.contains) != null && me.call(ce, Q.target) || (window.clearTimeout(f.value), h.value = "");
    }
    function re(Q) {
      var ce;
      if (!H2(Q))
        return;
      const me = Q.target, Se = A.value !== Q.clientX;
      if ((ce = Q?.currentTarget) != null && ce.contains(me) && Se) {
        const Le = Q.clientX > A.value ? "right" : "left";
        x.value = Le, A.value = Q.clientX;
      }
    }
    return Nw({
      onItemEnter: (Q) => !!U(Q),
      onItemLeave: (Q) => {
        var ce;
        U(Q) || ((ce = q.value) == null || ce.focus(), D.value = null);
      },
      onTriggerLeave: (Q) => !!U(Q),
      searchRef: h,
      pointerGraceTimerRef: b,
      onPointerGraceIntentChange: (Q) => {
        w.value = Q;
      }
    }), (Q, ce) => (c(), G(y(Uv), {
      "as-child": "",
      trapped: y(p),
      onMountAutoFocus: Z,
      onUnmountAutoFocus: ce[7] || (ce[7] = (me) => i("closeAutoFocus", me))
    }, {
      default: N(() => [
        ne(y(T0), {
          "as-child": "",
          "disable-outside-pointer-events": y(g),
          onEscapeKeyDown: ce[2] || (ce[2] = (me) => i("escapeKeyDown", me)),
          onPointerDownOutside: ce[3] || (ce[3] = (me) => i("pointerDownOutside", me)),
          onFocusOutside: ce[4] || (ce[4] = (me) => i("focusOutside", me)),
          onInteractOutside: ce[5] || (ce[5] = (me) => i("interactOutside", me)),
          onDismiss: ce[6] || (ce[6] = (me) => i("dismiss"))
        }, {
          default: N(() => [
            ne(y(Xv), {
              "current-tab-stop-id": D.value,
              "onUpdate:currentTabStopId": ce[0] || (ce[0] = (me) => D.value = me),
              "as-child": "",
              orientation: "vertical",
              dir: y(u).dir.value,
              loop: y(E),
              onEntryFocus: ce[1] || (ce[1] = (me) => {
                i("entryFocus", me), y(u).isUsingKeyboardRef.value || me.preventDefault();
              })
            }, {
              default: N(() => [
                ne(y(a0), {
                  ref: y($),
                  role: "menu",
                  as: Q.as,
                  "as-child": Q.asChild,
                  "aria-orientation": "vertical",
                  "data-radix-menu-content": "",
                  "data-state": y(Vv)(y(s).open.value),
                  dir: y(u).dir.value,
                  side: Q.side,
                  "side-offset": Q.sideOffset,
                  align: Q.align,
                  "align-offset": Q.alignOffset,
                  "avoid-collisions": Q.avoidCollisions,
                  "collision-boundary": Q.collisionBoundary,
                  "collision-padding": Q.collisionPadding,
                  "arrow-padding": Q.arrowPadding,
                  "prioritize-position": Q.prioritizePosition,
                  sticky: Q.sticky,
                  "hide-when-detached": Q.hideWhenDetached,
                  onKeydown: ee,
                  onBlur: X,
                  onPointermove: re
                }, {
                  default: N(() => [
                    I(Q.$slots, "default")
                  ]),
                  _: 3
                }, 8, ["as", "as-child", "data-state", "dir", "side", "side-offset", "align", "align-offset", "avoid-collisions", "collision-boundary", "collision-padding", "arrow-padding", "prioritize-position", "sticky", "hide-when-detached"])
              ]),
              _: 3
            }, 8, ["current-tab-stop-id", "dir", "loop"])
          ]),
          _: 3
        }, 8, ["disable-outside-pointer-events"])
      ]),
      _: 3
    }, 8, ["trapped"]));
  }
}), Mw = /* @__PURE__ */ W({
  inheritAttrs: !1,
  __name: "MenuItemImpl",
  props: {
    disabled: { type: Boolean },
    textValue: {},
    asChild: { type: Boolean },
    as: {}
  },
  setup(t) {
    const n = t, a = Jv(), { forwardRef: i } = Ze(), s = z(!1);
    async function u(g) {
      if (!g.defaultPrevented && H2(g)) {
        if (n.disabled)
          a.onItemLeave(g);
        else if (!a.onItemEnter(g)) {
          const E = g.currentTarget;
          E?.focus({ preventScroll: !0 });
        }
      }
    }
    async function p(g) {
      await Ct(), !g.defaultPrevented && H2(g) && a.onItemLeave(g);
    }
    return (g, E) => (c(), G(y(Nf), {
      value: { textValue: g.textValue }
    }, {
      default: N(() => [
        ne(y(Et), oe({
          ref: y(i),
          role: "menuitem",
          tabindex: "-1"
        }, g.$attrs, {
          as: g.as,
          "as-child": g.asChild,
          "data-radix-vue-collection-item": "",
          "aria-disabled": g.disabled || void 0,
          "data-disabled": g.disabled ? "" : void 0,
          "data-highlighted": s.value ? "" : void 0,
          onPointermove: u,
          onPointerleave: p,
          onFocus: E[0] || (E[0] = async (h) => {
            await Ct(), !(h.defaultPrevented || g.disabled) && (s.value = !0);
          }),
          onBlur: E[1] || (E[1] = async (h) => {
            await Ct(), !h.defaultPrevented && (s.value = !1);
          })
        }), {
          default: N(() => [
            I(g.$slots, "default")
          ]),
          _: 3
        }, 16, ["as", "as-child", "aria-disabled", "data-disabled", "data-highlighted"])
      ]),
      _: 3
    }, 8, ["value"]));
  }
}), Dw = /* @__PURE__ */ W({
  __name: "MenuItem",
  props: {
    disabled: { type: Boolean },
    textValue: {},
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["select"],
  setup(t, { emit: n }) {
    const a = t, i = n, { forwardRef: s, currentElement: u } = Ze(), p = Mf(), g = Jv(), E = z(!1);
    async function h() {
      const f = u.value;
      if (!a.disabled && f) {
        const b = new CustomEvent(MS, {
          bubbles: !0,
          cancelable: !0
        });
        i("select", b), await Ct(), b.defaultPrevented ? E.value = !1 : p.onClose();
      }
    }
    return (f, b) => (c(), G(Mw, oe(a, {
      ref: y(s),
      onClick: h,
      onPointerdown: b[0] || (b[0] = () => {
        E.value = !0;
      }),
      onPointerup: b[1] || (b[1] = async (w) => {
        var x;
        await Ct(), !w.defaultPrevented && (E.value || (x = w.currentTarget) == null || x.click());
      }),
      onKeydown: b[2] || (b[2] = async (w) => {
        const x = y(g).searchRef.value !== "";
        f.disabled || x && w.key === " " || y(V2).includes(w.key) && (w.currentTarget.click(), w.preventDefault());
      })
    }), {
      default: N(() => [
        I(f.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), kw = /* @__PURE__ */ W({
  __name: "MenuRootContentModal",
  props: {
    loop: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "entryFocus", "openAutoFocus", "closeAutoFocus"],
  setup(t, { emit: n }) {
    const a = t, i = n, s = Wn(a, i), u = C0(), { forwardRef: p, currentElement: g } = Ze();
    return Cf(g), (E, h) => (c(), G(e7, oe(y(s), {
      ref: y(p),
      "trap-focus": y(u).open.value,
      "disable-outside-pointer-events": y(u).open.value,
      "disable-outside-scroll": !0,
      onDismiss: h[0] || (h[0] = (f) => y(u).onOpenChange(!1)),
      onFocusOutside: h[1] || (h[1] = xa((f) => i("focusOutside", f), ["prevent"]))
    }), {
      default: N(() => [
        I(E.$slots, "default")
      ]),
      _: 3
    }, 16, ["trap-focus", "disable-outside-pointer-events"]));
  }
}), Lw = /* @__PURE__ */ W({
  __name: "MenuRootContentNonModal",
  props: {
    loop: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "entryFocus", "openAutoFocus", "closeAutoFocus"],
  setup(t, { emit: n }) {
    const a = Wn(t, n), i = C0();
    return (s, u) => (c(), G(e7, oe(y(a), {
      "trap-focus": !1,
      "disable-outside-pointer-events": !1,
      "disable-outside-scroll": !1,
      onDismiss: u[0] || (u[0] = (p) => y(i).onOpenChange(!1))
    }), {
      default: N(() => [
        I(s.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Pw = /* @__PURE__ */ W({
  __name: "MenuContent",
  props: {
    forceMount: { type: Boolean },
    loop: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "entryFocus", "openAutoFocus", "closeAutoFocus"],
  setup(t, { emit: n }) {
    const a = Wn(t, n), i = C0(), s = Mf();
    return (u, p) => (c(), G(y(El), {
      present: u.forceMount || y(i).open.value
    }, {
      default: N(() => [
        y(s).modal.value ? (c(), G(kw, ve(oe({ key: 0 }, { ...u.$attrs, ...y(a) })), {
          default: N(() => [
            I(u.$slots, "default")
          ]),
          _: 3
        }, 16)) : (c(), G(Lw, ve(oe({ key: 1 }, { ...u.$attrs, ...y(a) })), {
          default: N(() => [
            I(u.$slots, "default")
          ]),
          _: 3
        }, 16))
      ]),
      _: 3
    }, 8, ["present"]));
  }
}), Bw = /* @__PURE__ */ W({
  __name: "MenuPortal",
  props: {
    to: {},
    disabled: { type: Boolean },
    forceMount: { type: Boolean }
  },
  setup(t) {
    const n = t;
    return (a, i) => (c(), G(y(Rf), ve(we(n)), {
      default: N(() => [
        I(a.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), [t7, Fw] = kn("DropdownMenuRoot"), Uw = /* @__PURE__ */ W({
  __name: "DropdownMenuRoot",
  props: {
    defaultOpen: { type: Boolean },
    open: { type: Boolean, default: void 0 },
    dir: {},
    modal: { type: Boolean, default: !0 }
  },
  emits: ["update:open"],
  setup(t, { emit: n }) {
    const a = t, i = n;
    Ze();
    const s = ma(a, "open", i, {
      defaultValue: a.defaultOpen,
      passive: a.open === void 0
    }), u = z(), { modal: p, dir: g } = Nr(a), E = Kl(g);
    return Fw({
      open: s,
      onOpenChange: (h) => {
        s.value = h;
      },
      onOpenToggle: () => {
        s.value = !s.value;
      },
      triggerId: "",
      triggerElement: u,
      contentId: "",
      modal: p,
      dir: E
    }), (h, f) => (c(), G(y(Sw), {
      open: y(s),
      "onUpdate:open": f[0] || (f[0] = (b) => pf(s) ? s.value = b : null),
      dir: y(E),
      modal: y(p)
    }, {
      default: N(() => [
        I(h.$slots, "default", { open: y(s) })
      ]),
      _: 3
    }, 8, ["open", "dir", "modal"]));
  }
}), $w = /* @__PURE__ */ W({
  __name: "DropdownMenuTrigger",
  props: {
    disabled: { type: Boolean },
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(t) {
    const n = t, a = t7(), { forwardRef: i, currentElement: s } = Ze();
    return xt(() => {
      a.triggerElement = s;
    }), a.triggerId || (a.triggerId = fa(void 0, "radix-vue-dropdown-menu-trigger")), (u, p) => (c(), G(y(fw), { "as-child": "" }, {
      default: N(() => [
        ne(y(Et), {
          id: y(a).triggerId,
          ref: y(i),
          type: u.as === "button" ? "button" : void 0,
          "as-child": n.asChild,
          as: u.as,
          "aria-haspopup": "menu",
          "aria-expanded": y(a).open.value,
          "aria-controls": y(a).open.value ? y(a).contentId : void 0,
          "data-disabled": u.disabled ? "" : void 0,
          disabled: u.disabled,
          "data-state": y(a).open.value ? "open" : "closed",
          onClick: p[0] || (p[0] = async (g) => {
            var E;
            !u.disabled && g.button === 0 && g.ctrlKey === !1 && ((E = y(a)) == null || E.onOpenToggle(), await Ct(), y(a).open.value && g.preventDefault());
          }),
          onKeydown: p[1] || (p[1] = ui(
            (g) => {
              u.disabled || (["Enter", " "].includes(g.key) && y(a).onOpenToggle(), g.key === "ArrowDown" && y(a).onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(g.key) && g.preventDefault());
            },
            ["enter", "space", "arrow-down"]
          ))
        }, {
          default: N(() => [
            I(u.$slots, "default")
          ]),
          _: 3
        }, 8, ["id", "type", "as-child", "as", "aria-expanded", "aria-controls", "data-disabled", "disabled", "data-state"])
      ]),
      _: 3
    }));
  }
}), Vw = /* @__PURE__ */ W({
  __name: "DropdownMenuPortal",
  props: {
    to: {},
    disabled: { type: Boolean },
    forceMount: { type: Boolean }
  },
  setup(t) {
    const n = t;
    return (a, i) => (c(), G(y(Bw), ve(we(n)), {
      default: N(() => [
        I(a.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Hw = /* @__PURE__ */ W({
  __name: "DropdownMenuContent",
  props: {
    forceMount: { type: Boolean },
    loop: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "closeAutoFocus"],
  setup(t, { emit: n }) {
    const a = Wn(t, n);
    Ze();
    const i = t7(), s = z(!1);
    function u(p) {
      p.defaultPrevented || (s.value || setTimeout(() => {
        var g;
        (g = i.triggerElement.value) == null || g.focus();
      }, 0), s.value = !1, p.preventDefault());
    }
    return i.contentId || (i.contentId = fa(void 0, "radix-vue-dropdown-menu-content")), (p, g) => {
      var E;
      return c(), G(y(Pw), oe(y(a), {
        id: y(i).contentId,
        "aria-labelledby": (E = y(i)) == null ? void 0 : E.triggerId,
        style: {
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        },
        onCloseAutoFocus: u,
        onInteractOutside: g[0] || (g[0] = (h) => {
          var f;
          if (h.defaultPrevented) return;
          const b = h.detail.originalEvent, w = b.button === 0 && b.ctrlKey === !0, x = b.button === 2 || w;
          (!y(i).modal.value || x) && (s.value = !0), (f = y(i).triggerElement.value) != null && f.contains(h.target) && h.preventDefault();
        })
      }), {
        default: N(() => [
          I(p.$slots, "default")
        ]),
        _: 3
      }, 16, ["id", "aria-labelledby"]);
    };
  }
}), Gw = /* @__PURE__ */ W({
  __name: "DropdownMenuItem",
  props: {
    disabled: { type: Boolean },
    textValue: {},
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["select"],
  setup(t, { emit: n }) {
    const a = t, i = Id(n);
    return Ze(), (s, u) => (c(), G(y(Dw), ve(we({ ...a, ...y(i) })), {
      default: N(() => [
        I(s.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
});
function Yw() {
  if (typeof matchMedia == "function")
    return matchMedia("(pointer:coarse)").matches ? "coarse" : "fine";
}
Yw();
const [Df, zw] = kn("TabsRoot"), Zw = /* @__PURE__ */ W({
  __name: "TabsRoot",
  props: {
    defaultValue: {},
    orientation: { default: "horizontal" },
    dir: {},
    activationMode: { default: "automatic" },
    modelValue: {},
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["update:modelValue"],
  setup(t, { emit: n }) {
    const a = t, i = n, { orientation: s, dir: u } = Nr(a), p = Kl(u);
    Ze();
    const g = ma(a, "modelValue", i, {
      defaultValue: a.defaultValue,
      passive: a.modelValue === void 0
    }), E = z();
    return zw({
      modelValue: g,
      changeModelValue: (h) => {
        g.value = h;
      },
      orientation: s,
      dir: p,
      activationMode: a.activationMode,
      baseId: fa(void 0, "radix-vue-tabs"),
      tabsList: E
    }), (h, f) => (c(), G(y(Et), {
      dir: y(p),
      "data-orientation": y(s),
      "as-child": h.asChild,
      as: h.as
    }, {
      default: N(() => [
        I(h.$slots, "default", { modelValue: y(g) })
      ]),
      _: 3
    }, 8, ["dir", "data-orientation", "as-child", "as"]));
  }
}), qw = /* @__PURE__ */ W({
  __name: "TabsList",
  props: {
    loop: { type: Boolean, default: !0 },
    asChild: { type: Boolean },
    as: {}
  },
  setup(t) {
    const n = t, { loop: a } = Nr(n), { forwardRef: i, currentElement: s } = Ze(), u = Df();
    return u.tabsList = s, (p, g) => (c(), G(y(Xv), {
      "as-child": "",
      orientation: y(u).orientation.value,
      dir: y(u).dir.value,
      loop: y(a)
    }, {
      default: N(() => [
        ne(y(Et), {
          ref: y(i),
          role: "tablist",
          "as-child": p.asChild,
          as: p.as,
          "aria-orientation": y(u).orientation.value
        }, {
          default: N(() => [
            I(p.$slots, "default")
          ]),
          _: 3
        }, 8, ["as-child", "as", "aria-orientation"])
      ]),
      _: 3
    }, 8, ["orientation", "dir", "loop"]));
  }
});
function n7(t, n) {
  return `${t}-trigger-${n}`;
}
function r7(t, n) {
  return `${t}-content-${n}`;
}
const Ww = /* @__PURE__ */ W({
  __name: "TabsContent",
  props: {
    value: {},
    forceMount: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  setup(t) {
    const n = t, { forwardRef: a } = Ze(), i = Df(), s = M(() => n7(i.baseId, n.value)), u = M(() => r7(i.baseId, n.value)), p = M(() => n.value === i.modelValue.value), g = z(p.value);
    return xt(() => {
      requestAnimationFrame(() => {
        g.value = !1;
      });
    }), (E, h) => (c(), G(y(El), {
      present: p.value,
      "force-mount": ""
    }, {
      default: N(({ present: f }) => [
        ne(y(Et), {
          id: u.value,
          ref: y(a),
          "as-child": E.asChild,
          as: E.as,
          role: "tabpanel",
          "data-state": p.value ? "active" : "inactive",
          "data-orientation": y(i).orientation.value,
          "aria-labelledby": s.value,
          hidden: !f.value,
          tabindex: "0",
          style: Gr({
            animationDuration: g.value ? "0s" : void 0
          })
        }, {
          default: N(() => [
            E.forceMount || p.value ? I(E.$slots, "default", { key: 0 }) : le("", !0)
          ]),
          _: 2
        }, 1032, ["id", "as-child", "as", "data-state", "data-orientation", "aria-labelledby", "hidden", "style"])
      ]),
      _: 3
    }, 8, ["present"]));
  }
}), jw = /* @__PURE__ */ W({
  __name: "TabsTrigger",
  props: {
    value: {},
    disabled: { type: Boolean, default: !1 },
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(t) {
    const n = t, { forwardRef: a } = Ze(), i = Df(), s = M(() => n7(i.baseId, n.value)), u = M(() => r7(i.baseId, n.value)), p = M(() => n.value === i.modelValue.value);
    return (g, E) => (c(), G(y(Iw), {
      "as-child": "",
      focusable: !g.disabled,
      active: p.value
    }, {
      default: N(() => [
        ne(y(Et), {
          id: s.value,
          ref: y(a),
          role: "tab",
          type: g.as === "button" ? "button" : void 0,
          as: g.as,
          "as-child": g.asChild,
          "aria-selected": p.value ? "true" : "false",
          "aria-controls": u.value,
          "data-state": p.value ? "active" : "inactive",
          disabled: g.disabled,
          "data-disabled": g.disabled ? "" : void 0,
          "data-orientation": y(i).orientation.value,
          onMousedown: E[0] || (E[0] = xa((h) => {
            !g.disabled && h.ctrlKey === !1 ? y(i).changeModelValue(g.value) : h.preventDefault();
          }, ["left"])),
          onKeydown: E[1] || (E[1] = ui((h) => y(i).changeModelValue(g.value), ["enter", "space"])),
          onFocus: E[2] || (E[2] = () => {
            const h = y(i).activationMode !== "manual";
            !p.value && !g.disabled && h && y(i).changeModelValue(g.value);
          })
        }, {
          default: N(() => [
            I(g.$slots, "default")
          ]),
          _: 3
        }, 8, ["id", "type", "as", "as-child", "aria-selected", "aria-controls", "data-state", "disabled", "data-disabled", "data-orientation"])
      ]),
      _: 3
    }, 8, ["focusable", "active"]));
  }
}), a7 = "tooltip.open", [kf, Kw] = kn("TooltipProvider"), Qw = /* @__PURE__ */ W({
  inheritAttrs: !1,
  __name: "TooltipProvider",
  props: {
    delayDuration: { default: 700 },
    skipDelayDuration: { default: 300 },
    disableHoverableContent: { type: Boolean, default: !1 },
    disableClosingTrigger: { type: Boolean },
    disabled: { type: Boolean },
    ignoreNonKeyboardFocus: { type: Boolean, default: !1 }
  },
  setup(t) {
    const n = t, { delayDuration: a, skipDelayDuration: i, disableHoverableContent: s, disableClosingTrigger: u, ignoreNonKeyboardFocus: p, disabled: g } = Nr(n);
    Ze();
    const E = z(!0), h = z(!1), { start: f, stop: b } = Rv(() => {
      E.value = !0;
    }, i, { immediate: !1 });
    return Kw({
      isOpenDelayed: E,
      delayDuration: a,
      onOpen() {
        b(), E.value = !1;
      },
      onClose() {
        f();
      },
      isPointerInTransitRef: h,
      disableHoverableContent: s,
      disableClosingTrigger: u,
      disabled: g,
      ignoreNonKeyboardFocus: p
    }), (w, x) => I(w.$slots, "default");
  }
}), [x0, Xw] = kn("TooltipRoot"), Jw = /* @__PURE__ */ W({
  __name: "TooltipRoot",
  props: {
    defaultOpen: { type: Boolean, default: !1 },
    open: { type: Boolean, default: void 0 },
    delayDuration: { default: void 0 },
    disableHoverableContent: { type: Boolean, default: void 0 },
    disableClosingTrigger: { type: Boolean, default: void 0 },
    disabled: { type: Boolean, default: void 0 },
    ignoreNonKeyboardFocus: { type: Boolean, default: void 0 }
  },
  emits: ["update:open"],
  setup(t, { emit: n }) {
    const a = t, i = n;
    Ze();
    const s = kf(), u = M(() => a.disableHoverableContent ?? s.disableHoverableContent.value), p = M(() => a.disableClosingTrigger ?? s.disableClosingTrigger.value), g = M(() => a.disabled ?? s.disabled.value), E = M(() => a.delayDuration ?? s.delayDuration.value), h = M(() => a.ignoreNonKeyboardFocus ?? s.ignoreNonKeyboardFocus.value), f = ma(a, "open", i, {
      defaultValue: a.defaultOpen,
      passive: a.open === void 0
    });
    tt(f, (P) => {
      s.onClose && (P ? (s.onOpen(), document.dispatchEvent(new CustomEvent(a7))) : s.onClose());
    });
    const b = z(!1), w = z(), x = M(() => f.value ? b.value ? "delayed-open" : "instant-open" : "closed"), { start: A, stop: D } = Rv(() => {
      b.value = !0, f.value = !0;
    }, E, { immediate: !1 });
    function L() {
      D(), b.value = !1, f.value = !0;
    }
    function $() {
      D(), f.value = !1;
    }
    function q() {
      A();
    }
    return Xw({
      contentId: "",
      open: f,
      stateAttribute: x,
      trigger: w,
      onTriggerChange(P) {
        w.value = P;
      },
      onTriggerEnter() {
        s.isOpenDelayed.value ? q() : L();
      },
      onTriggerLeave() {
        u.value ? $() : D();
      },
      onOpen: L,
      onClose: $,
      disableHoverableContent: u,
      disableClosingTrigger: p,
      disabled: g,
      ignoreNonKeyboardFocus: h
    }), (P, k) => (c(), G(y(Of), null, {
      default: N(() => [
        I(P.$slots, "default", { open: y(f) })
      ]),
      _: 3
    }));
  }
}), ey = /* @__PURE__ */ W({
  __name: "TooltipTrigger",
  props: {
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(t) {
    const n = t, a = x0(), i = kf();
    a.contentId || (a.contentId = fa(void 0, "radix-vue-tooltip-content"));
    const { forwardRef: s, currentElement: u } = Ze(), p = z(!1), g = z(!1), E = M(() => a.disabled.value ? {} : {
      click: D,
      focus: x,
      pointermove: b,
      pointerleave: w,
      pointerdown: f,
      blur: A
    });
    xt(() => {
      a.onTriggerChange(u.value);
    });
    function h() {
      setTimeout(() => {
        p.value = !1;
      }, 1);
    }
    function f() {
      p.value = !0, document.addEventListener("pointerup", h, { once: !0 });
    }
    function b(L) {
      L.pointerType !== "touch" && !g.value && !i.isPointerInTransitRef.value && (a.onTriggerEnter(), g.value = !0);
    }
    function w() {
      a.onTriggerLeave(), g.value = !1;
    }
    function x(L) {
      var $, q;
      p.value || a.ignoreNonKeyboardFocus.value && !((q = ($ = L.target).matches) != null && q.call($, ":focus-visible")) || a.onOpen();
    }
    function A() {
      a.onClose();
    }
    function D() {
      a.disableClosingTrigger.value || a.onClose();
    }
    return (L, $) => (c(), G(y(Yv), { "as-child": "" }, {
      default: N(() => [
        ne(y(Et), oe({
          ref: y(s),
          "aria-describedby": y(a).open.value ? y(a).contentId : void 0,
          "data-state": y(a).stateAttribute.value,
          as: L.as,
          "as-child": n.asChild,
          "data-grace-area-trigger": ""
        }, oE(E.value)), {
          default: N(() => [
            I(L.$slots, "default")
          ]),
          _: 3
        }, 16, ["aria-describedby", "data-state", "as", "as-child"])
      ]),
      _: 3
    }));
  }
}), o7 = /* @__PURE__ */ W({
  __name: "TooltipContentImpl",
  props: {
    ariaLabel: {},
    asChild: { type: Boolean },
    as: {},
    side: { default: "top" },
    sideOffset: { default: 0 },
    align: { default: "center" },
    alignOffset: {},
    avoidCollisions: { type: Boolean, default: !0 },
    collisionBoundary: { default: () => [] },
    collisionPadding: { default: 0 },
    arrowPadding: { default: 0 },
    sticky: { default: "partial" },
    hideWhenDetached: { type: Boolean, default: !1 }
  },
  emits: ["escapeKeyDown", "pointerDownOutside"],
  setup(t, { emit: n }) {
    const a = t, i = n, s = x0(), { forwardRef: u } = Ze(), p = Yr(), g = M(() => {
      var f;
      return (f = p.default) == null ? void 0 : f.call(p);
    }), E = M(() => {
      var f;
      if (a.ariaLabel)
        return a.ariaLabel;
      let b = "";
      function w(x) {
        typeof x.children == "string" && x.type !== uv ? b += x.children : Array.isArray(x.children) && x.children.forEach((A) => w(A));
      }
      return (f = g.value) == null || f.forEach((x) => w(x)), b;
    }), h = M(() => {
      const { ariaLabel: f, ...b } = a;
      return b;
    });
    return xt(() => {
      Bl(window, "scroll", (f) => {
        const b = f.target;
        b != null && b.contains(s.trigger.value) && s.onClose();
      }), Bl(window, a7, s.onClose);
    }), (f, b) => (c(), G(y(T0), {
      "as-child": "",
      "disable-outside-pointer-events": !1,
      onEscapeKeyDown: b[0] || (b[0] = (w) => i("escapeKeyDown", w)),
      onPointerDownOutside: b[1] || (b[1] = (w) => {
        var x;
        y(s).disableClosingTrigger.value && (x = y(s).trigger.value) != null && x.contains(w.target) && w.preventDefault(), i("pointerDownOutside", w);
      }),
      onFocusOutside: b[2] || (b[2] = xa(() => {
      }, ["prevent"])),
      onDismiss: b[3] || (b[3] = (w) => y(s).onClose())
    }, {
      default: N(() => [
        ne(y(a0), oe({
          ref: y(u),
          "data-state": y(s).stateAttribute.value
        }, { ...f.$attrs, ...h.value }, { style: {
          "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
          "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
          "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
        } }), {
          default: N(() => [
            I(f.$slots, "default"),
            ne(y(Zv), {
              id: y(s).contentId,
              role: "tooltip"
            }, {
              default: N(() => [
                Ne(ye(E.value), 1)
              ]),
              _: 1
            }, 8, ["id"])
          ]),
          _: 3
        }, 16, ["data-state"])
      ]),
      _: 3
    }));
  }
}), ty = /* @__PURE__ */ W({
  __name: "TooltipContentHoverable",
  props: {
    ariaLabel: {},
    asChild: { type: Boolean },
    as: {},
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean }
  },
  setup(t) {
    const n = vl(t), { forwardRef: a, currentElement: i } = Ze(), { trigger: s, onClose: u } = x0(), p = kf(), { isPointerInTransit: g, onPointerExit: E } = Ub(s, i);
    return p.isPointerInTransitRef = g, E(() => {
      u();
    }), (h, f) => (c(), G(o7, oe({ ref: y(a) }, y(n)), {
      default: N(() => [
        I(h.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), ny = /* @__PURE__ */ W({
  __name: "TooltipContent",
  props: {
    forceMount: { type: Boolean },
    ariaLabel: {},
    asChild: { type: Boolean },
    as: {},
    side: { default: "top" },
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean }
  },
  emits: ["escapeKeyDown", "pointerDownOutside"],
  setup(t, { emit: n }) {
    const a = t, i = n, s = x0(), u = Wn(a, i), { forwardRef: p } = Ze();
    return (g, E) => (c(), G(y(El), {
      present: g.forceMount || y(s).open.value
    }, {
      default: N(() => [
        (c(), G(Hr(y(s).disableHoverableContent.value ? o7 : ty), oe({ ref: y(p) }, y(u)), {
          default: N(() => [
            I(g.$slots, "default")
          ]),
          _: 3
        }, 16))
      ]),
      _: 3
    }, 8, ["present"]));
  }
}), ry = /* @__PURE__ */ W({
  __name: "TooltipPortal",
  props: {
    to: {},
    disabled: { type: Boolean },
    forceMount: { type: Boolean }
  },
  setup(t) {
    const n = t;
    return (a, i) => (c(), G(y(Rf), ve(we(n)), {
      default: N(() => [
        I(a.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), ay = /^on[^a-z]/;
function oy(t) {
  return ay.test(t);
}
function DQ(t) {
  return t ? Array.isArray(t) ? t : [t] : [];
}
function Xa() {
  const t = z({}), n = z([]), a = z({}), i = h0();
  return pn(() => {
    const { class: s, style: u, ...p } = i;
    t.value = s, n.value = u, a.value = p;
  }), {
    classes: t,
    styles: n,
    attrs: a
  };
}
function iy() {
  const { attrs: t, styles: n, classes: a } = Xa(), i = z({}), s = z({});
  return pn(() => {
    for (const u in t.value)
      oy(u) ? s.value[u] = t.value[u] : i.value[u] = t.value[u];
  }), { attrs: i, listeners: s, styles: n, classes: a };
}
class sy extends Error {
  constructor() {
    super("Cascade panel not found. Are you sure the component calling useCascadePanel() exists within a <p-cascade-panel> component context?");
  }
}
class i7 extends Error {
  constructor() {
    super("Cascade panels not found. Are you sure the component calling useCascadePanels() exists within a <p-cascade> component context?");
  }
}
class ly extends Error {
  constructor() {
    super("No panels were provided and no cascade panel context was found. Are you sure the component calling useCascadePanels() exists within a <p-cascade> component context?");
  }
}
const s7 = function(t, n, a) {
  const i = t.top - a.top - n.height, s = t.left - a.left + t.width / 2 - n.width / 2;
  return {
    top: i,
    left: s
  };
}, l7 = function(t, n, a) {
  const i = t.top - a.top - n.height / 2 + t.height / 2, s = t.left - a.left + t.width;
  return {
    top: i,
    left: s
  };
}, Lf = function(t, n, a) {
  const i = t.top - a.top - n.height / 2 + t.height / 2, s = t.right - n.width;
  return {
    top: i,
    left: s
  };
}, c7 = function(t, n, a) {
  const i = t.top - a.top + t.height, s = t.left - a.left + t.width / 2 - n.width / 2;
  return {
    top: i,
    left: s
  };
}, u7 = function(t, n, a) {
  const i = t.top - a.top - n.height / 2 + t.height / 2, s = t.left - a.left - n.width;
  return {
    top: i,
    left: s
  };
}, Pf = function(t, n, a) {
  const i = t.top - a.top - n.height / 2 + t.height / 2, { left: s } = t;
  return {
    top: i,
    left: s
  };
}, Li = function(t, n, a) {
  const i = t.top - a.top - n.height, s = t.right - a.left - n.width;
  return {
    top: i,
    left: s
  };
}, Pi = function(t, n, a) {
  const i = t.top - a.top + t.height, s = t.right - a.left - n.width;
  return {
    top: i,
    left: s
  };
}, Bi = function(t, n, a) {
  const i = t.top - a.top - n.height, s = t.right - a.left - t.width;
  return {
    top: i,
    left: s
  };
}, Fi = function(t, n, a) {
  const i = t.top - a.top + t.height, s = t.right - a.left - t.width;
  return {
    top: i,
    left: s
  };
}, cy = function(t, n, a) {
  const i = t.bottom - a.top - n.height, s = t.left - a.left - n.width;
  return {
    top: i,
    left: s
  };
}, uy = function(t, n, a) {
  const i = t.bottom - a.top - n.height, s = t.left - a.left + t.width;
  return {
    top: i,
    left: s
  };
}, dy = function(t, n, a) {
  const i = t.top - a.top, s = t.left - a.left - n.width;
  return {
    top: i,
    left: s
  };
}, _y = function(t, n, a) {
  const i = t.top - a.top, s = t.left - a.left + t.width;
  return {
    top: i,
    left: s
  };
}, kQ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  bottom: c7,
  bottomLeft: Fi,
  bottomRight: Pi,
  left: u7,
  leftBottom: cy,
  leftInside: Pf,
  leftTop: dy,
  right: l7,
  rightBottom: uy,
  rightInside: Lf,
  rightTop: _y,
  top: s7,
  topLeft: Bi,
  topRight: Li
}, Symbol.toStringTag, { value: "Module" }));
function LQ(t) {
  return t.every((n) => typeof n == "string");
}
function PQ(t, n, a) {
  return t.reduce((i, s) => (i[n(s)] = a(s), i), {});
}
function BQ(t, n, a) {
  return t.reduce((i, s) => (i.set(n(s), a(s)), i), /* @__PURE__ */ new Map());
}
function cl(t) {
  return Y2(t) ? t : [t];
}
function Y2(t) {
  return Array.isArray(t);
}
function FQ(t) {
  return t.sort((n, a) => n.localeCompare(a));
}
function py(t, n) {
  const a = t.indexOf(n);
  return a > -1 ? t = [...t.slice(0, a), ...t.slice(a + 1)] : t = [...t, n], t;
}
const my = 365.2425, d7 = 6048e5, gy = 864e5, Bf = 6e4, Ff = 36e5, fy = 1e3, _l = 3600, Cd = 60, Qa = _l * 24, o0 = Qa * 7, hy = Qa * my, z2 = hy / 12, wh = Symbol.for("constructDateFrom");
function Bt(t, n) {
  return typeof t == "function" ? t(n) : t && typeof t == "object" && wh in t ? t[wh](n) : t instanceof Date ? new t.constructor(n) : new Date(n);
}
function nt(t, n) {
  return Bt(n || t, t);
}
function i0(t, n, a) {
  const i = nt(t, a?.in);
  return isNaN(n) ? Bt(a?.in || t, NaN) : (n && i.setDate(i.getDate() + n), i);
}
function Vd(t, n, a) {
  const i = nt(t, a?.in);
  if (isNaN(n)) return Bt(a?.in || t, NaN);
  if (!n)
    return i;
  const s = i.getDate(), u = Bt(a?.in || t, i.getTime());
  u.setMonth(i.getMonth() + n + 1, 0);
  const p = u.getDate();
  return s >= p ? u : (i.setFullYear(
    u.getFullYear(),
    u.getMonth(),
    s
  ), i);
}
function vy(t, n, a) {
  return Bt(t, +nt(t) + n);
}
let Ey = {};
function bl() {
  return Ey;
}
function _o(t, n) {
  const a = bl(), i = n?.weekStartsOn ?? n?.locale?.options?.weekStartsOn ?? a.weekStartsOn ?? a.locale?.options?.weekStartsOn ?? 0, s = nt(t, n?.in), u = s.getDay(), p = (u < i ? 7 : 0) + u - i;
  return s.setDate(s.getDate() - p), s.setHours(0, 0, 0, 0), s;
}
function Fl(t, n) {
  return _o(t, { ...n, weekStartsOn: 1 });
}
function _7(t, n) {
  const a = nt(t, n?.in), i = a.getFullYear(), s = Bt(a, 0);
  s.setFullYear(i + 1, 0, 4), s.setHours(0, 0, 0, 0);
  const u = Fl(s), p = Bt(a, 0);
  p.setFullYear(i, 0, 4), p.setHours(0, 0, 0, 0);
  const g = Fl(p);
  return a.getTime() >= u.getTime() ? i + 1 : a.getTime() >= g.getTime() ? i : i - 1;
}
function s0(t) {
  const n = nt(t), a = new Date(
    Date.UTC(
      n.getFullYear(),
      n.getMonth(),
      n.getDate(),
      n.getHours(),
      n.getMinutes(),
      n.getSeconds(),
      n.getMilliseconds()
    )
  );
  return a.setUTCFullYear(n.getFullYear()), +t - +a;
}
function Xl(t, ...n) {
  const a = Bt.bind(
    null,
    n.find((i) => typeof i == "object")
  );
  return n.map(a);
}
function pl(t, n) {
  const a = nt(t, n?.in);
  return a.setHours(0, 0, 0, 0), a;
}
function by(t, n, a) {
  const [i, s] = Xl(
    a?.in,
    t,
    n
  ), u = pl(i), p = pl(s), g = +u - s0(u), E = +p - s0(p);
  return Math.round((g - E) / gy);
}
function Sy(t, n) {
  const a = _7(t, n), i = Bt(t, 0);
  return i.setFullYear(a, 0, 4), i.setHours(0, 0, 0, 0), Fl(i);
}
function Ul(t, n, a) {
  return vy(t, n * 1e3);
}
function wy(t) {
  return Bt(t, Date.now());
}
function $l(t, n, a) {
  const [i, s] = Xl(
    a?.in,
    t,
    n
  );
  return +pl(i) == +pl(s);
}
function Vl(t) {
  return t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function p7(t) {
  return !(!Vl(t) && typeof t != "number" || isNaN(+nt(t)));
}
function yy(t) {
  return (n) => {
    const i = (t ? Math[t] : Math.trunc)(n);
    return i === 0 ? 0 : i;
  };
}
function Ty(t, n) {
  return +nt(t) - +nt(n);
}
function Uf(t, n) {
  const a = nt(t, n?.in);
  return a.setHours(23, 59, 59, 999), a;
}
function $f(t, n) {
  const a = nt(t, n?.in), i = a.getMonth();
  return a.setFullYear(a.getFullYear(), i + 1, 0), a.setHours(23, 59, 59, 999), a;
}
function Vf(t, n, a) {
  const i = Ty(t, n) / 1e3;
  return yy(a?.roundingMethod)(i);
}
function m7(t, n) {
  const [a, i] = Xl(t, n.start, n.end);
  return { start: a, end: i };
}
function yh(t, n) {
  const { start: a, end: i } = m7(n?.in, t);
  let s = +a > +i;
  const u = s ? +a : +i, p = s ? i : a;
  p.setHours(0, 0, 0, 0);
  let g = 1;
  const E = [];
  for (; +p <= u; )
    E.push(Bt(a, p)), p.setDate(p.getDate() + g), p.setHours(0, 0, 0, 0);
  return s ? E.reverse() : E;
}
function Cy(t, n) {
  const { start: a, end: i } = m7(n?.in, t);
  let s = +a > +i;
  const u = s ? +a : +i, p = s ? i : a;
  p.setHours(0, 0, 0, 0), p.setDate(1);
  let g = 1;
  const E = [];
  for (; +p <= u; )
    E.push(Bt(a, p)), p.setMonth(p.getMonth() + g);
  return s ? E.reverse() : E;
}
function Hf(t, n) {
  const a = nt(t, n?.in);
  return a.setDate(1), a.setHours(0, 0, 0, 0), a;
}
function xy(t, n) {
  const a = nt(t, n?.in), i = a.getFullYear();
  return a.setFullYear(i + 1, 0, 0), a.setHours(23, 59, 59, 999), a;
}
function g7(t, n) {
  const a = nt(t, n?.in);
  return a.setFullYear(a.getFullYear(), 0, 1), a.setHours(0, 0, 0, 0), a;
}
function Th(t, n) {
  const a = bl(), i = a.weekStartsOn ?? a.locale?.options?.weekStartsOn ?? 0, s = nt(t, n?.in), u = s.getDay(), p = (u < i ? -7 : 0) + 6 - (u - i);
  return s.setDate(s.getDate() + p), s.setHours(23, 59, 59, 999), s;
}
function Ay(t, n) {
  const a = nt(t, n?.in);
  return a.setSeconds(59, 999), a;
}
function Ry(t) {
  return Uf(Date.now(), t);
}
const Oy = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, Iy = (t, n, a) => {
  let i;
  const s = Oy[t];
  return typeof s == "string" ? i = s : n === 1 ? i = s.one : i = s.other.replace("{{count}}", n.toString()), a?.addSuffix ? a.comparison && a.comparison > 0 ? "in " + i : i + " ago" : i;
};
function S2(t) {
  return (n = {}) => {
    const a = n.width ? String(n.width) : t.defaultWidth;
    return t.formats[a] || t.formats[t.defaultWidth];
  };
}
const Ny = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, My = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Dy = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, ky = {
  date: S2({
    formats: Ny,
    defaultWidth: "full"
  }),
  time: S2({
    formats: My,
    defaultWidth: "full"
  }),
  dateTime: S2({
    formats: Dy,
    defaultWidth: "full"
  })
}, Ly = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Py = (t, n, a, i) => Ly[t];
function dd(t) {
  return (n, a) => {
    const i = a?.context ? String(a.context) : "standalone";
    let s;
    if (i === "formatting" && t.formattingValues) {
      const p = t.defaultFormattingWidth || t.defaultWidth, g = a?.width ? String(a.width) : p;
      s = t.formattingValues[g] || t.formattingValues[p];
    } else {
      const p = t.defaultWidth, g = a?.width ? String(a.width) : t.defaultWidth;
      s = t.values[g] || t.values[p];
    }
    const u = t.argumentCallback ? t.argumentCallback(n) : n;
    return s[u];
  };
}
const By = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Fy = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Uy = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, $y = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, Vy = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Hy = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Gy = (t, n) => {
  const a = Number(t), i = a % 100;
  if (i > 20 || i < 10)
    switch (i % 10) {
      case 1:
        return a + "st";
      case 2:
        return a + "nd";
      case 3:
        return a + "rd";
    }
  return a + "th";
}, Yy = {
  ordinalNumber: Gy,
  era: dd({
    values: By,
    defaultWidth: "wide"
  }),
  quarter: dd({
    values: Fy,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: dd({
    values: Uy,
    defaultWidth: "wide"
  }),
  day: dd({
    values: $y,
    defaultWidth: "wide"
  }),
  dayPeriod: dd({
    values: Vy,
    defaultWidth: "wide",
    formattingValues: Hy,
    defaultFormattingWidth: "wide"
  })
};
function _d(t) {
  return (n, a = {}) => {
    const i = a.width, s = i && t.matchPatterns[i] || t.matchPatterns[t.defaultMatchWidth], u = n.match(s);
    if (!u)
      return null;
    const p = u[0], g = i && t.parsePatterns[i] || t.parsePatterns[t.defaultParseWidth], E = Array.isArray(g) ? Zy(g, (b) => b.test(p)) : (
      // [TODO] -- I challenge you to fix the type
      zy(g, (b) => b.test(p))
    );
    let h;
    h = t.valueCallback ? t.valueCallback(E) : E, h = a.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      a.valueCallback(h)
    ) : h;
    const f = n.slice(p.length);
    return { value: h, rest: f };
  };
}
function zy(t, n) {
  for (const a in t)
    if (Object.prototype.hasOwnProperty.call(t, a) && n(t[a]))
      return a;
}
function Zy(t, n) {
  for (let a = 0; a < t.length; a++)
    if (n(t[a]))
      return a;
}
function qy(t) {
  return (n, a = {}) => {
    const i = n.match(t.matchPattern);
    if (!i) return null;
    const s = i[0], u = n.match(t.parsePattern);
    if (!u) return null;
    let p = t.valueCallback ? t.valueCallback(u[0]) : u[0];
    p = a.valueCallback ? a.valueCallback(p) : p;
    const g = n.slice(s.length);
    return { value: p, rest: g };
  };
}
const Wy = /^(\d+)(th|st|nd|rd)?/i, jy = /\d+/i, Ky = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Qy = {
  any: [/^b/i, /^(a|c)/i]
}, Xy = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Jy = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, eT = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, tT = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, nT = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, rT = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, aT = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, oT = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, iT = {
  ordinalNumber: qy({
    matchPattern: Wy,
    parsePattern: jy,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: _d({
    matchPatterns: Ky,
    defaultMatchWidth: "wide",
    parsePatterns: Qy,
    defaultParseWidth: "any"
  }),
  quarter: _d({
    matchPatterns: Xy,
    defaultMatchWidth: "wide",
    parsePatterns: Jy,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: _d({
    matchPatterns: eT,
    defaultMatchWidth: "wide",
    parsePatterns: tT,
    defaultParseWidth: "any"
  }),
  day: _d({
    matchPatterns: nT,
    defaultMatchWidth: "wide",
    parsePatterns: rT,
    defaultParseWidth: "any"
  }),
  dayPeriod: _d({
    matchPatterns: aT,
    defaultMatchWidth: "any",
    parsePatterns: oT,
    defaultParseWidth: "any"
  })
}, f7 = {
  code: "en-US",
  formatDistance: Iy,
  formatLong: ky,
  formatRelative: Py,
  localize: Yy,
  match: iT,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function sT(t, n) {
  const a = nt(t, n?.in);
  return by(a, g7(a)) + 1;
}
function h7(t, n) {
  const a = nt(t, n?.in), i = +Fl(a) - +Sy(a);
  return Math.round(i / d7) + 1;
}
function Gf(t, n) {
  const a = nt(t, n?.in), i = a.getFullYear(), s = bl(), u = n?.firstWeekContainsDate ?? n?.locale?.options?.firstWeekContainsDate ?? s.firstWeekContainsDate ?? s.locale?.options?.firstWeekContainsDate ?? 1, p = Bt(n?.in || t, 0);
  p.setFullYear(i + 1, 0, u), p.setHours(0, 0, 0, 0);
  const g = _o(p, n), E = Bt(n?.in || t, 0);
  E.setFullYear(i, 0, u), E.setHours(0, 0, 0, 0);
  const h = _o(E, n);
  return +a >= +g ? i + 1 : +a >= +h ? i : i - 1;
}
function lT(t, n) {
  const a = bl(), i = n?.firstWeekContainsDate ?? n?.locale?.options?.firstWeekContainsDate ?? a.firstWeekContainsDate ?? a.locale?.options?.firstWeekContainsDate ?? 1, s = Gf(t, n), u = Bt(n?.in || t, 0);
  return u.setFullYear(s, 0, i), u.setHours(0, 0, 0, 0), _o(u, n);
}
function v7(t, n) {
  const a = nt(t, n?.in), i = +_o(a, n) - +lT(a, n);
  return Math.round(i / d7) + 1;
}
function Pt(t, n) {
  const a = t < 0 ? "-" : "", i = Math.abs(t).toString().padStart(n, "0");
  return a + i;
}
const Oi = {
  // Year
  y(t, n) {
    const a = t.getFullYear(), i = a > 0 ? a : 1 - a;
    return Pt(n === "yy" ? i % 100 : i, n.length);
  },
  // Month
  M(t, n) {
    const a = t.getMonth();
    return n === "M" ? String(a + 1) : Pt(a + 1, 2);
  },
  // Day of the month
  d(t, n) {
    return Pt(t.getDate(), n.length);
  },
  // AM or PM
  a(t, n) {
    const a = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return a.toUpperCase();
      case "aaa":
        return a;
      case "aaaaa":
        return a[0];
      case "aaaa":
      default:
        return a === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(t, n) {
    return Pt(t.getHours() % 12 || 12, n.length);
  },
  // Hour [0-23]
  H(t, n) {
    return Pt(t.getHours(), n.length);
  },
  // Minute
  m(t, n) {
    return Pt(t.getMinutes(), n.length);
  },
  // Second
  s(t, n) {
    return Pt(t.getSeconds(), n.length);
  },
  // Fraction of second
  S(t, n) {
    const a = n.length, i = t.getMilliseconds(), s = Math.trunc(
      i * Math.pow(10, a - 3)
    );
    return Pt(s, n.length);
  }
}, Rl = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Ch = {
  // Era
  G: function(t, n, a) {
    const i = t.getFullYear() > 0 ? 1 : 0;
    switch (n) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return a.era(i, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return a.era(i, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return a.era(i, { width: "wide" });
    }
  },
  // Year
  y: function(t, n, a) {
    if (n === "yo") {
      const i = t.getFullYear(), s = i > 0 ? i : 1 - i;
      return a.ordinalNumber(s, { unit: "year" });
    }
    return Oi.y(t, n);
  },
  // Local week-numbering year
  Y: function(t, n, a, i) {
    const s = Gf(t, i), u = s > 0 ? s : 1 - s;
    if (n === "YY") {
      const p = u % 100;
      return Pt(p, 2);
    }
    return n === "Yo" ? a.ordinalNumber(u, { unit: "year" }) : Pt(u, n.length);
  },
  // ISO week-numbering year
  R: function(t, n) {
    const a = _7(t);
    return Pt(a, n.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, n) {
    const a = t.getFullYear();
    return Pt(a, n.length);
  },
  // Quarter
  Q: function(t, n, a) {
    const i = Math.ceil((t.getMonth() + 1) / 3);
    switch (n) {
      // 1, 2, 3, 4
      case "Q":
        return String(i);
      // 01, 02, 03, 04
      case "QQ":
        return Pt(i, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return a.ordinalNumber(i, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return a.quarter(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return a.quarter(i, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return a.quarter(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, n, a) {
    const i = Math.ceil((t.getMonth() + 1) / 3);
    switch (n) {
      // 1, 2, 3, 4
      case "q":
        return String(i);
      // 01, 02, 03, 04
      case "qq":
        return Pt(i, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return a.ordinalNumber(i, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return a.quarter(i, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return a.quarter(i, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return a.quarter(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, n, a) {
    const i = t.getMonth();
    switch (n) {
      case "M":
      case "MM":
        return Oi.M(t, n);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return a.ordinalNumber(i + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return a.month(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return a.month(i, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return a.month(i, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(t, n, a) {
    const i = t.getMonth();
    switch (n) {
      // 1, 2, ..., 12
      case "L":
        return String(i + 1);
      // 01, 02, ..., 12
      case "LL":
        return Pt(i + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return a.ordinalNumber(i + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return a.month(i, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return a.month(i, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return a.month(i, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(t, n, a, i) {
    const s = v7(t, i);
    return n === "wo" ? a.ordinalNumber(s, { unit: "week" }) : Pt(s, n.length);
  },
  // ISO week of year
  I: function(t, n, a) {
    const i = h7(t);
    return n === "Io" ? a.ordinalNumber(i, { unit: "week" }) : Pt(i, n.length);
  },
  // Day of the month
  d: function(t, n, a) {
    return n === "do" ? a.ordinalNumber(t.getDate(), { unit: "date" }) : Oi.d(t, n);
  },
  // Day of year
  D: function(t, n, a) {
    const i = sT(t);
    return n === "Do" ? a.ordinalNumber(i, { unit: "dayOfYear" }) : Pt(i, n.length);
  },
  // Day of week
  E: function(t, n, a) {
    const i = t.getDay();
    switch (n) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return a.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return a.day(i, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return a.day(i, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return a.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, n, a, i) {
    const s = t.getDay(), u = (s - i.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(u);
      // Padded numerical value
      case "ee":
        return Pt(u, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return a.ordinalNumber(u, { unit: "day" });
      case "eee":
        return a.day(s, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return a.day(s, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return a.day(s, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return a.day(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, n, a, i) {
    const s = t.getDay(), u = (s - i.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      // Numerical value (same as in `e`)
      case "c":
        return String(u);
      // Padded numerical value
      case "cc":
        return Pt(u, n.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return a.ordinalNumber(u, { unit: "day" });
      case "ccc":
        return a.day(s, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return a.day(s, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return a.day(s, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return a.day(s, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, n, a) {
    const i = t.getDay(), s = i === 0 ? 7 : i;
    switch (n) {
      // 2
      case "i":
        return String(s);
      // 02
      case "ii":
        return Pt(s, n.length);
      // 2nd
      case "io":
        return a.ordinalNumber(s, { unit: "day" });
      // Tue
      case "iii":
        return a.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return a.day(i, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return a.day(i, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return a.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, n, a) {
    const s = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return a.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return a.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return a.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return a.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, n, a) {
    const i = t.getHours();
    let s;
    switch (i === 12 ? s = Rl.noon : i === 0 ? s = Rl.midnight : s = i / 12 >= 1 ? "pm" : "am", n) {
      case "b":
      case "bb":
        return a.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return a.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return a.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return a.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, n, a) {
    const i = t.getHours();
    let s;
    switch (i >= 17 ? s = Rl.evening : i >= 12 ? s = Rl.afternoon : i >= 4 ? s = Rl.morning : s = Rl.night, n) {
      case "B":
      case "BB":
      case "BBB":
        return a.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return a.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return a.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, n, a) {
    if (n === "ho") {
      let i = t.getHours() % 12;
      return i === 0 && (i = 12), a.ordinalNumber(i, { unit: "hour" });
    }
    return Oi.h(t, n);
  },
  // Hour [0-23]
  H: function(t, n, a) {
    return n === "Ho" ? a.ordinalNumber(t.getHours(), { unit: "hour" }) : Oi.H(t, n);
  },
  // Hour [0-11]
  K: function(t, n, a) {
    const i = t.getHours() % 12;
    return n === "Ko" ? a.ordinalNumber(i, { unit: "hour" }) : Pt(i, n.length);
  },
  // Hour [1-24]
  k: function(t, n, a) {
    let i = t.getHours();
    return i === 0 && (i = 24), n === "ko" ? a.ordinalNumber(i, { unit: "hour" }) : Pt(i, n.length);
  },
  // Minute
  m: function(t, n, a) {
    return n === "mo" ? a.ordinalNumber(t.getMinutes(), { unit: "minute" }) : Oi.m(t, n);
  },
  // Second
  s: function(t, n, a) {
    return n === "so" ? a.ordinalNumber(t.getSeconds(), { unit: "second" }) : Oi.s(t, n);
  },
  // Fraction of second
  S: function(t, n) {
    return Oi.S(t, n);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, n, a) {
    const i = t.getTimezoneOffset();
    if (i === 0)
      return "Z";
    switch (n) {
      // Hours and optional minutes
      case "X":
        return Ah(i);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return sl(i);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return sl(i, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, n, a) {
    const i = t.getTimezoneOffset();
    switch (n) {
      // Hours and optional minutes
      case "x":
        return Ah(i);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return sl(i);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return sl(i, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, n, a) {
    const i = t.getTimezoneOffset();
    switch (n) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + xh(i, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + sl(i, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, n, a) {
    const i = t.getTimezoneOffset();
    switch (n) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + xh(i, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + sl(i, ":");
    }
  },
  // Seconds timestamp
  t: function(t, n, a) {
    const i = Math.trunc(+t / 1e3);
    return Pt(i, n.length);
  },
  // Milliseconds timestamp
  T: function(t, n, a) {
    return Pt(+t, n.length);
  }
};
function xh(t, n = "") {
  const a = t > 0 ? "-" : "+", i = Math.abs(t), s = Math.trunc(i / 60), u = i % 60;
  return u === 0 ? a + String(s) : a + String(s) + n + Pt(u, 2);
}
function Ah(t, n) {
  return t % 60 === 0 ? (t > 0 ? "-" : "+") + Pt(Math.abs(t) / 60, 2) : sl(t, n);
}
function sl(t, n = "") {
  const a = t > 0 ? "-" : "+", i = Math.abs(t), s = Pt(Math.trunc(i / 60), 2), u = Pt(i % 60, 2);
  return a + s + n + u;
}
const Rh = (t, n) => {
  switch (t) {
    case "P":
      return n.date({ width: "short" });
    case "PP":
      return n.date({ width: "medium" });
    case "PPP":
      return n.date({ width: "long" });
    case "PPPP":
    default:
      return n.date({ width: "full" });
  }
}, E7 = (t, n) => {
  switch (t) {
    case "p":
      return n.time({ width: "short" });
    case "pp":
      return n.time({ width: "medium" });
    case "ppp":
      return n.time({ width: "long" });
    case "pppp":
    default:
      return n.time({ width: "full" });
  }
}, cT = (t, n) => {
  const a = t.match(/(P+)(p+)?/) || [], i = a[1], s = a[2];
  if (!s)
    return Rh(t, n);
  let u;
  switch (i) {
    case "P":
      u = n.dateTime({ width: "short" });
      break;
    case "PP":
      u = n.dateTime({ width: "medium" });
      break;
    case "PPP":
      u = n.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      u = n.dateTime({ width: "full" });
      break;
  }
  return u.replace("{{date}}", Rh(i, n)).replace("{{time}}", E7(s, n));
}, Z2 = {
  p: E7,
  P: cT
}, uT = /^D+$/, dT = /^Y+$/, _T = ["D", "DD", "YY", "YYYY"];
function b7(t) {
  return uT.test(t);
}
function S7(t) {
  return dT.test(t);
}
function q2(t, n, a) {
  const i = pT(t, n, a);
  if (console.warn(i), _T.includes(t)) throw new RangeError(i);
}
function pT(t, n, a) {
  const i = t[0] === "Y" ? "years" : "days of the month";
  return `Use \`${t.toLowerCase()}\` instead of \`${t}\` (in \`${n}\`) for formatting ${i} to the input \`${a}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const mT = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, gT = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, fT = /^'([^]*?)'?$/, hT = /''/g, vT = /[a-zA-Z]/;
function Mn(t, n, a) {
  const i = bl(), s = i.locale ?? f7, u = i.firstWeekContainsDate ?? i.locale?.options?.firstWeekContainsDate ?? 1, p = i.weekStartsOn ?? i.locale?.options?.weekStartsOn ?? 0, g = nt(t, a?.in);
  if (!p7(g))
    throw new RangeError("Invalid time value");
  let E = n.match(gT).map((f) => {
    const b = f[0];
    if (b === "p" || b === "P") {
      const w = Z2[b];
      return w(f, s.formatLong);
    }
    return f;
  }).join("").match(mT).map((f) => {
    if (f === "''")
      return { isToken: !1, value: "'" };
    const b = f[0];
    if (b === "'")
      return { isToken: !1, value: ET(f) };
    if (Ch[b])
      return { isToken: !0, value: f };
    if (b.match(vT))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + b + "`"
      );
    return { isToken: !1, value: f };
  });
  s.localize.preprocessor && (E = s.localize.preprocessor(g, E));
  const h = {
    firstWeekContainsDate: u,
    weekStartsOn: p,
    locale: s
  };
  return E.map((f) => {
    if (!f.isToken) return f.value;
    const b = f.value;
    (S7(b) || b7(b)) && q2(b, n, String(t));
    const w = Ch[b[0]];
    return w(g, b, s.localize, h);
  }).join("");
}
function ET(t) {
  const n = t.match(fT);
  return n ? n[1].replace(hT, "'") : t;
}
function bT(t, n) {
  const a = nt(t, n?.in), i = a.getFullYear(), s = a.getMonth(), u = Bt(a, 0);
  return u.setFullYear(i, s + 1, 0), u.setHours(0, 0, 0, 0), u.getDate();
}
function ST() {
  return Object.assign({}, bl());
}
function wT(t, n) {
  const a = nt(t, n?.in).getDay();
  return a === 0 ? 7 : a;
}
function Jl(t, n) {
  return +nt(t) > +nt(n);
}
function ec(t, n) {
  return +nt(t) < +nt(n);
}
function yT(t, n) {
  const a = TT(n) ? new n(0) : Bt(n, 0);
  return a.setFullYear(t.getFullYear(), t.getMonth(), t.getDate()), a.setHours(
    t.getHours(),
    t.getMinutes(),
    t.getSeconds(),
    t.getMilliseconds()
  ), a;
}
function TT(t) {
  return typeof t == "function" && t.prototype?.constructor === t;
}
const CT = 10;
class w7 {
  subPriority = 0;
  validate(n, a) {
    return !0;
  }
}
class xT extends w7 {
  constructor(n, a, i, s, u) {
    super(), this.value = n, this.validateValue = a, this.setValue = i, this.priority = s, u && (this.subPriority = u);
  }
  validate(n, a) {
    return this.validateValue(n, this.value, a);
  }
  set(n, a, i) {
    return this.setValue(n, a, this.value, i);
  }
}
class AT extends w7 {
  priority = CT;
  subPriority = -1;
  constructor(n, a) {
    super(), this.context = n || ((i) => Bt(a, i));
  }
  set(n, a) {
    return a.timestampIsSet ? n : Bt(n, yT(n, this.context));
  }
}
class At {
  run(n, a, i, s) {
    const u = this.parse(n, a, i, s);
    return u ? {
      setter: new xT(
        u.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: u.rest
    } : null;
  }
  validate(n, a, i) {
    return !0;
  }
}
class RT extends At {
  priority = 140;
  parse(n, a, i) {
    switch (a) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return i.era(n, { width: "abbreviated" }) || i.era(n, { width: "narrow" });
      // A, B
      case "GGGGG":
        return i.era(n, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return i.era(n, { width: "wide" }) || i.era(n, { width: "abbreviated" }) || i.era(n, { width: "narrow" });
    }
  }
  set(n, a, i) {
    return a.era = i, n.setFullYear(i, 0, 1), n.setHours(0, 0, 0, 0), n;
  }
  incompatibleTokens = ["R", "u", "t", "T"];
}
const yn = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, io = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function Tn(t, n) {
  return t && {
    value: n(t.value),
    rest: t.rest
  };
}
function _n(t, n) {
  const a = n.match(t);
  return a ? {
    value: parseInt(a[0], 10),
    rest: n.slice(a[0].length)
  } : null;
}
function so(t, n) {
  const a = n.match(t);
  if (!a)
    return null;
  if (a[0] === "Z")
    return {
      value: 0,
      rest: n.slice(1)
    };
  const i = a[1] === "+" ? 1 : -1, s = a[2] ? parseInt(a[2], 10) : 0, u = a[3] ? parseInt(a[3], 10) : 0, p = a[5] ? parseInt(a[5], 10) : 0;
  return {
    value: i * (s * Ff + u * Bf + p * fy),
    rest: n.slice(a[0].length)
  };
}
function y7(t) {
  return _n(yn.anyDigitsSigned, t);
}
function En(t, n) {
  switch (t) {
    case 1:
      return _n(yn.singleDigit, n);
    case 2:
      return _n(yn.twoDigits, n);
    case 3:
      return _n(yn.threeDigits, n);
    case 4:
      return _n(yn.fourDigits, n);
    default:
      return _n(new RegExp("^\\d{1," + t + "}"), n);
  }
}
function l0(t, n) {
  switch (t) {
    case 1:
      return _n(yn.singleDigitSigned, n);
    case 2:
      return _n(yn.twoDigitsSigned, n);
    case 3:
      return _n(yn.threeDigitsSigned, n);
    case 4:
      return _n(yn.fourDigitsSigned, n);
    default:
      return _n(new RegExp("^-?\\d{1," + t + "}"), n);
  }
}
function Yf(t) {
  switch (t) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function T7(t, n) {
  const a = n > 0, i = a ? n : 1 - n;
  let s;
  if (i <= 50)
    s = t || 100;
  else {
    const u = i + 50, p = Math.trunc(u / 100) * 100, g = t >= u % 100;
    s = t + p - (g ? 100 : 0);
  }
  return a ? s : 1 - s;
}
function C7(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
class OT extends At {
  priority = 130;
  incompatibleTokens = ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"];
  parse(n, a, i) {
    const s = (u) => ({
      year: u,
      isTwoDigitYear: a === "yy"
    });
    switch (a) {
      case "y":
        return Tn(En(4, n), s);
      case "yo":
        return Tn(
          i.ordinalNumber(n, {
            unit: "year"
          }),
          s
        );
      default:
        return Tn(En(a.length, n), s);
    }
  }
  validate(n, a) {
    return a.isTwoDigitYear || a.year > 0;
  }
  set(n, a, i) {
    const s = n.getFullYear();
    if (i.isTwoDigitYear) {
      const p = T7(
        i.year,
        s
      );
      return n.setFullYear(p, 0, 1), n.setHours(0, 0, 0, 0), n;
    }
    const u = !("era" in a) || a.era === 1 ? i.year : 1 - i.year;
    return n.setFullYear(u, 0, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class IT extends At {
  priority = 130;
  parse(n, a, i) {
    const s = (u) => ({
      year: u,
      isTwoDigitYear: a === "YY"
    });
    switch (a) {
      case "Y":
        return Tn(En(4, n), s);
      case "Yo":
        return Tn(
          i.ordinalNumber(n, {
            unit: "year"
          }),
          s
        );
      default:
        return Tn(En(a.length, n), s);
    }
  }
  validate(n, a) {
    return a.isTwoDigitYear || a.year > 0;
  }
  set(n, a, i, s) {
    const u = Gf(n, s);
    if (i.isTwoDigitYear) {
      const g = T7(
        i.year,
        u
      );
      return n.setFullYear(
        g,
        0,
        s.firstWeekContainsDate
      ), n.setHours(0, 0, 0, 0), _o(n, s);
    }
    const p = !("era" in a) || a.era === 1 ? i.year : 1 - i.year;
    return n.setFullYear(p, 0, s.firstWeekContainsDate), n.setHours(0, 0, 0, 0), _o(n, s);
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "Q",
    "q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "i",
    "t",
    "T"
  ];
}
class NT extends At {
  priority = 130;
  parse(n, a) {
    return l0(a === "R" ? 4 : a.length, n);
  }
  set(n, a, i) {
    const s = Bt(n, 0);
    return s.setFullYear(i, 0, 4), s.setHours(0, 0, 0, 0), Fl(s);
  }
  incompatibleTokens = [
    "G",
    "y",
    "Y",
    "u",
    "Q",
    "q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "e",
    "c",
    "t",
    "T"
  ];
}
class MT extends At {
  priority = 130;
  parse(n, a) {
    return l0(a === "u" ? 4 : a.length, n);
  }
  set(n, a, i) {
    return n.setFullYear(i, 0, 1), n.setHours(0, 0, 0, 0), n;
  }
  incompatibleTokens = ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"];
}
class DT extends At {
  priority = 120;
  parse(n, a, i) {
    switch (a) {
      // 1, 2, 3, 4
      case "Q":
      case "QQ":
        return En(a.length, n);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return i.ordinalNumber(n, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return i.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return i.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return i.quarter(n, {
          width: "wide",
          context: "formatting"
        }) || i.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(n, a) {
    return a >= 1 && a <= 4;
  }
  set(n, a, i) {
    return n.setMonth((i - 1) * 3, 1), n.setHours(0, 0, 0, 0), n;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}
class kT extends At {
  priority = 120;
  parse(n, a, i) {
    switch (a) {
      // 1, 2, 3, 4
      case "q":
      case "qq":
        return En(a.length, n);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return i.ordinalNumber(n, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return i.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        }) || i.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return i.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return i.quarter(n, {
          width: "wide",
          context: "standalone"
        }) || i.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        }) || i.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(n, a) {
    return a >= 1 && a <= 4;
  }
  set(n, a, i) {
    return n.setMonth((i - 1) * 3, 1), n.setHours(0, 0, 0, 0), n;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "Q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}
class LT extends At {
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "L",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
  priority = 110;
  parse(n, a, i) {
    const s = (u) => u - 1;
    switch (a) {
      // 1, 2, ..., 12
      case "M":
        return Tn(
          _n(yn.month, n),
          s
        );
      // 01, 02, ..., 12
      case "MM":
        return Tn(En(2, n), s);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return Tn(
          i.ordinalNumber(n, {
            unit: "month"
          }),
          s
        );
      // Jan, Feb, ..., Dec
      case "MMM":
        return i.month(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.month(n, { width: "narrow", context: "formatting" });
      // J, F, ..., D
      case "MMMMM":
        return i.month(n, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return i.month(n, { width: "wide", context: "formatting" }) || i.month(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.month(n, { width: "narrow", context: "formatting" });
    }
  }
  validate(n, a) {
    return a >= 0 && a <= 11;
  }
  set(n, a, i) {
    return n.setMonth(i, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class PT extends At {
  priority = 110;
  parse(n, a, i) {
    const s = (u) => u - 1;
    switch (a) {
      // 1, 2, ..., 12
      case "L":
        return Tn(
          _n(yn.month, n),
          s
        );
      // 01, 02, ..., 12
      case "LL":
        return Tn(En(2, n), s);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return Tn(
          i.ordinalNumber(n, {
            unit: "month"
          }),
          s
        );
      // Jan, Feb, ..., Dec
      case "LLL":
        return i.month(n, {
          width: "abbreviated",
          context: "standalone"
        }) || i.month(n, { width: "narrow", context: "standalone" });
      // J, F, ..., D
      case "LLLLL":
        return i.month(n, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return i.month(n, { width: "wide", context: "standalone" }) || i.month(n, {
          width: "abbreviated",
          context: "standalone"
        }) || i.month(n, { width: "narrow", context: "standalone" });
    }
  }
  validate(n, a) {
    return a >= 0 && a <= 11;
  }
  set(n, a, i) {
    return n.setMonth(i, 1), n.setHours(0, 0, 0, 0), n;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "M",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}
function BT(t, n, a) {
  const i = nt(t, a?.in), s = v7(i, a) - n;
  return i.setDate(i.getDate() - s * 7), nt(i, a?.in);
}
class FT extends At {
  priority = 100;
  parse(n, a, i) {
    switch (a) {
      case "w":
        return _n(yn.week, n);
      case "wo":
        return i.ordinalNumber(n, { unit: "week" });
      default:
        return En(a.length, n);
    }
  }
  validate(n, a) {
    return a >= 1 && a <= 53;
  }
  set(n, a, i, s) {
    return _o(BT(n, i, s), s);
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "i",
    "t",
    "T"
  ];
}
function UT(t, n, a) {
  const i = nt(t, a?.in), s = h7(i, a) - n;
  return i.setDate(i.getDate() - s * 7), i;
}
class $T extends At {
  priority = 100;
  parse(n, a, i) {
    switch (a) {
      case "I":
        return _n(yn.week, n);
      case "Io":
        return i.ordinalNumber(n, { unit: "week" });
      default:
        return En(a.length, n);
    }
  }
  validate(n, a) {
    return a >= 1 && a <= 53;
  }
  set(n, a, i) {
    return Fl(UT(n, i));
  }
  incompatibleTokens = [
    "y",
    "Y",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "e",
    "c",
    "t",
    "T"
  ];
}
const VT = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], HT = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class GT extends At {
  priority = 90;
  subPriority = 1;
  parse(n, a, i) {
    switch (a) {
      case "d":
        return _n(yn.date, n);
      case "do":
        return i.ordinalNumber(n, { unit: "date" });
      default:
        return En(a.length, n);
    }
  }
  validate(n, a) {
    const i = n.getFullYear(), s = C7(i), u = n.getMonth();
    return s ? a >= 1 && a <= HT[u] : a >= 1 && a <= VT[u];
  }
  set(n, a, i) {
    return n.setDate(i), n.setHours(0, 0, 0, 0), n;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}
class YT extends At {
  priority = 90;
  subpriority = 1;
  parse(n, a, i) {
    switch (a) {
      case "D":
      case "DD":
        return _n(yn.dayOfYear, n);
      case "Do":
        return i.ordinalNumber(n, { unit: "date" });
      default:
        return En(a.length, n);
    }
  }
  validate(n, a) {
    const i = n.getFullYear();
    return C7(i) ? a >= 1 && a <= 366 : a >= 1 && a <= 365;
  }
  set(n, a, i) {
    return n.setMonth(0, i), n.setHours(0, 0, 0, 0), n;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "E",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}
function zf(t, n, a) {
  const i = bl(), s = a?.weekStartsOn ?? a?.locale?.options?.weekStartsOn ?? i.weekStartsOn ?? i.locale?.options?.weekStartsOn ?? 0, u = nt(t, a?.in), p = u.getDay(), E = (n % 7 + 7) % 7, h = 7 - s, f = n < 0 || n > 6 ? n - (p + h) % 7 : (E + h) % 7 - (p + h) % 7;
  return i0(u, f, a);
}
class zT extends At {
  priority = 90;
  parse(n, a, i) {
    switch (a) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return i.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.day(n, { width: "short", context: "formatting" }) || i.day(n, { width: "narrow", context: "formatting" });
      // T
      case "EEEEE":
        return i.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return i.day(n, { width: "short", context: "formatting" }) || i.day(n, { width: "narrow", context: "formatting" });
      // Tuesday
      case "EEEE":
      default:
        return i.day(n, { width: "wide", context: "formatting" }) || i.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.day(n, { width: "short", context: "formatting" }) || i.day(n, { width: "narrow", context: "formatting" });
    }
  }
  validate(n, a) {
    return a >= 0 && a <= 6;
  }
  set(n, a, i, s) {
    return n = zf(n, i, s), n.setHours(0, 0, 0, 0), n;
  }
  incompatibleTokens = ["D", "i", "e", "c", "t", "T"];
}
class ZT extends At {
  priority = 90;
  parse(n, a, i, s) {
    const u = (p) => {
      const g = Math.floor((p - 1) / 7) * 7;
      return (p + s.weekStartsOn + 6) % 7 + g;
    };
    switch (a) {
      // 3
      case "e":
      case "ee":
        return Tn(En(a.length, n), u);
      // 3rd
      case "eo":
        return Tn(
          i.ordinalNumber(n, {
            unit: "day"
          }),
          u
        );
      // Tue
      case "eee":
        return i.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.day(n, { width: "short", context: "formatting" }) || i.day(n, { width: "narrow", context: "formatting" });
      // T
      case "eeeee":
        return i.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return i.day(n, { width: "short", context: "formatting" }) || i.day(n, { width: "narrow", context: "formatting" });
      // Tuesday
      case "eeee":
      default:
        return i.day(n, { width: "wide", context: "formatting" }) || i.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.day(n, { width: "short", context: "formatting" }) || i.day(n, { width: "narrow", context: "formatting" });
    }
  }
  validate(n, a) {
    return a >= 0 && a <= 6;
  }
  set(n, a, i, s) {
    return n = zf(n, i, s), n.setHours(0, 0, 0, 0), n;
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "E",
    "i",
    "c",
    "t",
    "T"
  ];
}
class qT extends At {
  priority = 90;
  parse(n, a, i, s) {
    const u = (p) => {
      const g = Math.floor((p - 1) / 7) * 7;
      return (p + s.weekStartsOn + 6) % 7 + g;
    };
    switch (a) {
      // 3
      case "c":
      case "cc":
        return Tn(En(a.length, n), u);
      // 3rd
      case "co":
        return Tn(
          i.ordinalNumber(n, {
            unit: "day"
          }),
          u
        );
      // Tue
      case "ccc":
        return i.day(n, {
          width: "abbreviated",
          context: "standalone"
        }) || i.day(n, { width: "short", context: "standalone" }) || i.day(n, { width: "narrow", context: "standalone" });
      // T
      case "ccccc":
        return i.day(n, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return i.day(n, { width: "short", context: "standalone" }) || i.day(n, { width: "narrow", context: "standalone" });
      // Tuesday
      case "cccc":
      default:
        return i.day(n, { width: "wide", context: "standalone" }) || i.day(n, {
          width: "abbreviated",
          context: "standalone"
        }) || i.day(n, { width: "short", context: "standalone" }) || i.day(n, { width: "narrow", context: "standalone" });
    }
  }
  validate(n, a) {
    return a >= 0 && a <= 6;
  }
  set(n, a, i, s) {
    return n = zf(n, i, s), n.setHours(0, 0, 0, 0), n;
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "E",
    "i",
    "e",
    "t",
    "T"
  ];
}
function WT(t, n, a) {
  const i = nt(t, a?.in), s = wT(i, a), u = n - s;
  return i0(i, u, a);
}
class jT extends At {
  priority = 90;
  parse(n, a, i) {
    const s = (u) => u === 0 ? 7 : u;
    switch (a) {
      // 2
      case "i":
      case "ii":
        return En(a.length, n);
      // 2nd
      case "io":
        return i.ordinalNumber(n, { unit: "day" });
      // Tue
      case "iii":
        return Tn(
          i.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(n, {
            width: "short",
            context: "formatting"
          }) || i.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          s
        );
      // T
      case "iiiii":
        return Tn(
          i.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          s
        );
      // Tu
      case "iiiiii":
        return Tn(
          i.day(n, {
            width: "short",
            context: "formatting"
          }) || i.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          s
        );
      // Tuesday
      case "iiii":
      default:
        return Tn(
          i.day(n, {
            width: "wide",
            context: "formatting"
          }) || i.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(n, {
            width: "short",
            context: "formatting"
          }) || i.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          s
        );
    }
  }
  validate(n, a) {
    return a >= 1 && a <= 7;
  }
  set(n, a, i) {
    return n = WT(n, i), n.setHours(0, 0, 0, 0), n;
  }
  incompatibleTokens = [
    "y",
    "Y",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "E",
    "e",
    "c",
    "t",
    "T"
  ];
}
class KT extends At {
  priority = 80;
  parse(n, a, i) {
    switch (a) {
      case "a":
      case "aa":
      case "aaa":
        return i.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return i.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return i.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        }) || i.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(n, a, i) {
    return n.setHours(Yf(i), 0, 0, 0), n;
  }
  incompatibleTokens = ["b", "B", "H", "k", "t", "T"];
}
class QT extends At {
  priority = 80;
  parse(n, a, i) {
    switch (a) {
      case "b":
      case "bb":
      case "bbb":
        return i.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return i.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return i.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        }) || i.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(n, a, i) {
    return n.setHours(Yf(i), 0, 0, 0), n;
  }
  incompatibleTokens = ["a", "B", "H", "k", "t", "T"];
}
class XT extends At {
  priority = 80;
  parse(n, a, i) {
    switch (a) {
      case "B":
      case "BB":
      case "BBB":
        return i.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return i.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return i.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        }) || i.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(n, a, i) {
    return n.setHours(Yf(i), 0, 0, 0), n;
  }
  incompatibleTokens = ["a", "b", "t", "T"];
}
class JT extends At {
  priority = 70;
  parse(n, a, i) {
    switch (a) {
      case "h":
        return _n(yn.hour12h, n);
      case "ho":
        return i.ordinalNumber(n, { unit: "hour" });
      default:
        return En(a.length, n);
    }
  }
  validate(n, a) {
    return a >= 1 && a <= 12;
  }
  set(n, a, i) {
    const s = n.getHours() >= 12;
    return s && i < 12 ? n.setHours(i + 12, 0, 0, 0) : !s && i === 12 ? n.setHours(0, 0, 0, 0) : n.setHours(i, 0, 0, 0), n;
  }
  incompatibleTokens = ["H", "K", "k", "t", "T"];
}
class eC extends At {
  priority = 70;
  parse(n, a, i) {
    switch (a) {
      case "H":
        return _n(yn.hour23h, n);
      case "Ho":
        return i.ordinalNumber(n, { unit: "hour" });
      default:
        return En(a.length, n);
    }
  }
  validate(n, a) {
    return a >= 0 && a <= 23;
  }
  set(n, a, i) {
    return n.setHours(i, 0, 0, 0), n;
  }
  incompatibleTokens = ["a", "b", "h", "K", "k", "t", "T"];
}
class tC extends At {
  priority = 70;
  parse(n, a, i) {
    switch (a) {
      case "K":
        return _n(yn.hour11h, n);
      case "Ko":
        return i.ordinalNumber(n, { unit: "hour" });
      default:
        return En(a.length, n);
    }
  }
  validate(n, a) {
    return a >= 0 && a <= 11;
  }
  set(n, a, i) {
    return n.getHours() >= 12 && i < 12 ? n.setHours(i + 12, 0, 0, 0) : n.setHours(i, 0, 0, 0), n;
  }
  incompatibleTokens = ["h", "H", "k", "t", "T"];
}
class nC extends At {
  priority = 70;
  parse(n, a, i) {
    switch (a) {
      case "k":
        return _n(yn.hour24h, n);
      case "ko":
        return i.ordinalNumber(n, { unit: "hour" });
      default:
        return En(a.length, n);
    }
  }
  validate(n, a) {
    return a >= 1 && a <= 24;
  }
  set(n, a, i) {
    const s = i <= 24 ? i % 24 : i;
    return n.setHours(s, 0, 0, 0), n;
  }
  incompatibleTokens = ["a", "b", "h", "H", "K", "t", "T"];
}
class rC extends At {
  priority = 60;
  parse(n, a, i) {
    switch (a) {
      case "m":
        return _n(yn.minute, n);
      case "mo":
        return i.ordinalNumber(n, { unit: "minute" });
      default:
        return En(a.length, n);
    }
  }
  validate(n, a) {
    return a >= 0 && a <= 59;
  }
  set(n, a, i) {
    return n.setMinutes(i, 0, 0), n;
  }
  incompatibleTokens = ["t", "T"];
}
class aC extends At {
  priority = 50;
  parse(n, a, i) {
    switch (a) {
      case "s":
        return _n(yn.second, n);
      case "so":
        return i.ordinalNumber(n, { unit: "second" });
      default:
        return En(a.length, n);
    }
  }
  validate(n, a) {
    return a >= 0 && a <= 59;
  }
  set(n, a, i) {
    return n.setSeconds(i, 0), n;
  }
  incompatibleTokens = ["t", "T"];
}
class oC extends At {
  priority = 30;
  parse(n, a) {
    const i = (s) => Math.trunc(s * Math.pow(10, -a.length + 3));
    return Tn(En(a.length, n), i);
  }
  set(n, a, i) {
    return n.setMilliseconds(i), n;
  }
  incompatibleTokens = ["t", "T"];
}
class iC extends At {
  priority = 10;
  parse(n, a) {
    switch (a) {
      case "X":
        return so(
          io.basicOptionalMinutes,
          n
        );
      case "XX":
        return so(io.basic, n);
      case "XXXX":
        return so(
          io.basicOptionalSeconds,
          n
        );
      case "XXXXX":
        return so(
          io.extendedOptionalSeconds,
          n
        );
      case "XXX":
      default:
        return so(io.extended, n);
    }
  }
  set(n, a, i) {
    return a.timestampIsSet ? n : Bt(
      n,
      n.getTime() - s0(n) - i
    );
  }
  incompatibleTokens = ["t", "T", "x"];
}
class sC extends At {
  priority = 10;
  parse(n, a) {
    switch (a) {
      case "x":
        return so(
          io.basicOptionalMinutes,
          n
        );
      case "xx":
        return so(io.basic, n);
      case "xxxx":
        return so(
          io.basicOptionalSeconds,
          n
        );
      case "xxxxx":
        return so(
          io.extendedOptionalSeconds,
          n
        );
      case "xxx":
      default:
        return so(io.extended, n);
    }
  }
  set(n, a, i) {
    return a.timestampIsSet ? n : Bt(
      n,
      n.getTime() - s0(n) - i
    );
  }
  incompatibleTokens = ["t", "T", "X"];
}
class lC extends At {
  priority = 40;
  parse(n) {
    return y7(n);
  }
  set(n, a, i) {
    return [Bt(n, i * 1e3), { timestampIsSet: !0 }];
  }
  incompatibleTokens = "*";
}
class cC extends At {
  priority = 20;
  parse(n) {
    return y7(n);
  }
  set(n, a, i) {
    return [Bt(n, i), { timestampIsSet: !0 }];
  }
  incompatibleTokens = "*";
}
const uC = {
  G: new RT(),
  y: new OT(),
  Y: new IT(),
  R: new NT(),
  u: new MT(),
  Q: new DT(),
  q: new kT(),
  M: new LT(),
  L: new PT(),
  w: new FT(),
  I: new $T(),
  d: new GT(),
  D: new YT(),
  E: new zT(),
  e: new ZT(),
  c: new qT(),
  i: new jT(),
  a: new KT(),
  b: new QT(),
  B: new XT(),
  h: new JT(),
  H: new eC(),
  K: new tC(),
  k: new nC(),
  m: new rC(),
  s: new aC(),
  S: new oC(),
  X: new iC(),
  x: new sC(),
  t: new lC(),
  T: new cC()
}, dC = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, _C = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, pC = /^'([^]*?)'?$/, mC = /''/g, gC = /\S/, fC = /[a-zA-Z]/;
function hC(t, n, a, i) {
  const s = () => Bt(a, NaN), u = ST(), p = u.locale ?? f7, g = u.firstWeekContainsDate ?? u.locale?.options?.firstWeekContainsDate ?? 1, E = u.weekStartsOn ?? u.locale?.options?.weekStartsOn ?? 0, h = {
    firstWeekContainsDate: g,
    weekStartsOn: E,
    locale: p
  }, f = [new AT(i?.in, a)], b = n.match(_C).map((L) => {
    const $ = L[0];
    if ($ in Z2) {
      const q = Z2[$];
      return q(L, p.formatLong);
    }
    return L;
  }).join("").match(dC), w = [];
  for (let L of b) {
    S7(L) && q2(L, n, t), b7(L) && q2(L, n, t);
    const $ = L[0], q = uC[$];
    if (q) {
      const { incompatibleTokens: P } = q;
      if (Array.isArray(P)) {
        const U = w.find(
          (Z) => P.includes(Z.token) || Z.token === $
        );
        if (U)
          throw new RangeError(
            `The format string mustn't contain \`${U.fullToken}\` and \`${L}\` at the same time`
          );
      } else if (q.incompatibleTokens === "*" && w.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${L}\` and any other token at the same time`
        );
      w.push({ token: $, fullToken: L });
      const k = q.run(
        t,
        L,
        p.match,
        h
      );
      if (!k)
        return s();
      f.push(k.setter), t = k.rest;
    } else {
      if ($.match(fC))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + $ + "`"
        );
      if (L === "''" ? L = "'" : $ === "'" && (L = vC(L)), t.indexOf(L) === 0)
        t = t.slice(L.length);
      else
        return s();
    }
  }
  if (t.length > 0 && gC.test(t))
    return s();
  const x = f.map((L) => L.priority).sort((L, $) => $ - L).filter((L, $, q) => q.indexOf(L) === $).map(
    (L) => f.filter(($) => $.priority === L).sort(($, q) => q.subPriority - $.subPriority)
  ).map((L) => L[0]);
  let A = nt(a, i?.in);
  if (isNaN(+A)) return s();
  const D = {};
  for (const L of x) {
    if (!L.validate(A, h))
      return s();
    const $ = L.set(A, D, h);
    Array.isArray($) ? (A = $[0], Object.assign(D, $[1])) : A = $;
  }
  return A;
}
function vC(t) {
  return t.match(pC)[1].replace(mC, "'");
}
function Oh(t, n) {
  const a = nt(t, n?.in);
  return a.setMinutes(0, 0, 0), a;
}
function EC(t, n, a) {
  const [i, s] = Xl(
    a?.in,
    t,
    n
  );
  return +Oh(i) == +Oh(s);
}
function c0(t, n) {
  const a = nt(t, n?.in);
  return a.setSeconds(0, 0), a;
}
function bC(t, n) {
  return +c0(t) == +c0(n);
}
function x7(t, n, a) {
  const [i, s] = Xl(
    a?.in,
    t,
    n
  );
  return i.getFullYear() === s.getFullYear() && i.getMonth() === s.getMonth();
}
function Ih(t, n) {
  const a = nt(t, n?.in);
  return a.setMilliseconds(0), a;
}
function SC(t, n) {
  return +Ih(t) == +Ih(n);
}
function Nl(t, n, a) {
  const [i, s] = Xl(
    a?.in,
    t,
    n
  );
  return i.getFullYear() === s.getFullYear();
}
function wC(t, n) {
  return $l(
    Bt(t, t),
    wy(t)
  );
}
function yC(t, n) {
  const a = () => Bt(n?.in, NaN), s = AC(t);
  let u;
  if (s.date) {
    const h = RC(s.date, 2);
    u = OC(h.restDateString, h.year);
  }
  if (!u || isNaN(+u)) return a();
  const p = +u;
  let g = 0, E;
  if (s.time && (g = IC(s.time), isNaN(g)))
    return a();
  if (s.timezone) {
    if (E = NC(s.timezone), isNaN(E)) return a();
  } else {
    const h = new Date(p + g), f = nt(0, n?.in);
    return f.setFullYear(
      h.getUTCFullYear(),
      h.getUTCMonth(),
      h.getUTCDate()
    ), f.setHours(
      h.getUTCHours(),
      h.getUTCMinutes(),
      h.getUTCSeconds(),
      h.getUTCMilliseconds()
    ), f;
  }
  return nt(p + g + E, n?.in);
}
const Hd = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, TC = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, CC = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, xC = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function AC(t) {
  const n = {}, a = t.split(Hd.dateTimeDelimiter);
  let i;
  if (a.length > 2)
    return n;
  if (/:/.test(a[0]) ? i = a[0] : (n.date = a[0], i = a[1], Hd.timeZoneDelimiter.test(n.date) && (n.date = t.split(Hd.timeZoneDelimiter)[0], i = t.substr(
    n.date.length,
    t.length
  ))), i) {
    const s = Hd.timezone.exec(i);
    s ? (n.time = i.replace(s[1], ""), n.timezone = s[1]) : n.time = i;
  }
  return n;
}
function RC(t, n) {
  const a = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" + (4 + n) + "})|(\\d{2}|[+-]\\d{" + (2 + n) + "})$)"
  ), i = t.match(a);
  if (!i) return { year: NaN, restDateString: "" };
  const s = i[1] ? parseInt(i[1]) : null, u = i[2] ? parseInt(i[2]) : null;
  return {
    year: u === null ? s : u * 100,
    restDateString: t.slice((i[1] || i[2]).length)
  };
}
function OC(t, n) {
  if (n === null) return /* @__PURE__ */ new Date(NaN);
  const a = t.match(TC);
  if (!a) return /* @__PURE__ */ new Date(NaN);
  const i = !!a[4], s = pd(a[1]), u = pd(a[2]) - 1, p = pd(a[3]), g = pd(a[4]), E = pd(a[5]) - 1;
  if (i)
    return PC(n, g, E) ? MC(n, g, E) : /* @__PURE__ */ new Date(NaN);
  {
    const h = /* @__PURE__ */ new Date(0);
    return !kC(n, u, p) || !LC(n, s) ? /* @__PURE__ */ new Date(NaN) : (h.setUTCFullYear(n, u, Math.max(s, p)), h);
  }
}
function pd(t) {
  return t ? parseInt(t) : 1;
}
function IC(t) {
  const n = t.match(CC);
  if (!n) return NaN;
  const a = w2(n[1]), i = w2(n[2]), s = w2(n[3]);
  return BC(a, i, s) ? a * Ff + i * Bf + s * 1e3 : NaN;
}
function w2(t) {
  return t && parseFloat(t.replace(",", ".")) || 0;
}
function NC(t) {
  if (t === "Z") return 0;
  const n = t.match(xC);
  if (!n) return 0;
  const a = n[1] === "+" ? -1 : 1, i = parseInt(n[2]), s = n[3] && parseInt(n[3]) || 0;
  return FC(i, s) ? a * (i * Ff + s * Bf) : NaN;
}
function MC(t, n, a) {
  const i = /* @__PURE__ */ new Date(0);
  i.setUTCFullYear(t, 0, 4);
  const s = i.getUTCDay() || 7, u = (n - 1) * 7 + a + 1 - s;
  return i.setUTCDate(i.getUTCDate() + u), i;
}
const DC = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function A7(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
function kC(t, n, a) {
  return n >= 0 && n <= 11 && a >= 1 && a <= (DC[n] || (A7(t) ? 29 : 28));
}
function LC(t, n) {
  return n >= 1 && n <= (A7(t) ? 366 : 365);
}
function PC(t, n, a) {
  return n >= 1 && n <= 53 && a >= 0 && a <= 6;
}
function BC(t, n, a) {
  return t === 24 ? n === 0 && a === 0 : a >= 0 && a < 60 && n >= 0 && n < 60 && t >= 0 && t < 25;
}
function FC(t, n) {
  return n >= 0 && n <= 59;
}
function Nh(t, n, a) {
  const i = nt(t, a?.in), s = i.getFullYear(), u = i.getDate(), p = Bt(t, 0);
  p.setFullYear(s, n, 15), p.setHours(0, 0, 0, 0);
  const g = bT(p);
  return i.setMonth(n, Math.min(u, g)), i;
}
function Mh(t, n, a) {
  const i = nt(t, a?.in);
  return isNaN(+i) ? Bt(t, NaN) : (i.setFullYear(n), i);
}
function R7(t) {
  return pl(Date.now(), t);
}
function UC(t, n, a) {
  return Ul(t, -n);
}
function $C() {
  const t = /* @__PURE__ */ new Date();
  return t.setMilliseconds(0), t;
}
function VC({ startDate: t, endDate: n }) {
  const a = Vf(n, t);
  return { startDate: t, endDate: n, timeSpanInSeconds: a };
}
function HC({ seconds: t }) {
  const n = $C(), a = Ul(n, t), [i, s] = [n, a].sort((p, g) => p.getTime() - g.getTime()), u = Math.abs(t);
  return { startDate: i, endDate: s, timeSpanInSeconds: u };
}
function GC({ date: t, quantity: n, unit: a }) {
  const i = YC(a), s = Math.abs(n * i), u = UC(t, s), p = Ul(t, s), g = Vf(p, u);
  return { startDate: u, endDate: p, timeSpanInSeconds: g };
}
function YC(t) {
  switch (t) {
    case "second":
      return 1;
    case "minute":
      return Cd;
    case "hour":
      return _l;
    case "day":
      return Qa;
    default:
      const n = t;
      throw new Error(`Failed get multiplier for unit because unit is not supported: ${n}`);
  }
}
function zC({ period: t }) {
  if (t === "Today") {
    const a = R7(), i = Ry(), s = Vf(i, a);
    return {
      startDate: a,
      endDate: i,
      timeSpanInSeconds: s
    };
  }
  const n = t;
  throw new Error(`No handler for period: ${n}`);
}
function Dh(t) {
  if (!t)
    return null;
  switch (t.type) {
    case "range":
      return VC(t);
    case "span":
      return HC(t);
    case "around":
      return GC(t);
    case "period":
      return zC(t);
    default:
      const n = t;
      throw new Error(`No handler for DateRangeSelectValue.type: ${n}`);
  }
}
function A0(t, n) {
  return t && n.min && ec(t, n.min) ? n.min : t && n.max && Jl(t, n.max) ? n.max : t;
}
function O7(t, n, a) {
  switch (a) {
    case "second":
      return SC(t, n);
    case "minute":
      return bC(t, n);
    case "hour":
      return EC(t, n);
    case "day":
      return $l(t, n);
    case "month":
      return x7(t, n);
    case "year":
      return Nl(t, n);
    default:
      throw new Error(`isMatchingPrecision missing case for ${a}`);
  }
}
function I7(t, n, a = "minute") {
  return (!n.min || qC(t, n.min, a)) && (!n.max || ZC(t, n.max, a));
}
function R0(t, n) {
  return ec(t, n);
}
function ZC(t, n, a = "minute") {
  return ec(t, n) || O7(t, n, a);
}
function Zf(t, n) {
  return Jl(t, n);
}
function qC(t, n, a = "minute") {
  return Jl(t, n) || O7(t, n, a);
}
function y2(t) {
  return t instanceof HTMLElement;
}
function u0(t) {
  const n = eval;
  try {
    return n(t), !0;
  } catch {
    return !1;
  }
}
function ml() {
  return u0("crypto") ? crypto.randomUUID ? crypto.randomUUID() : WC() : jC();
}
function WC() {
  return (+[1e7] + -1e3 + -4e3 + -8e3 + -1e11).toString().replace(
    /[018]/g,
    (t) => (+t ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +t / 4).toString(16)
  );
}
function jC() {
  const t = kh(), n = kh();
  return `${t.slice(0, 8)}-${t.slice(8, 12)}-4${t.slice(13)}-a${n.slice(1, 4)}-${n.slice(4)}`;
}
function kh() {
  return `00000000000000000${(Math.random() * 18446744073709552e3).toString(16)}`.slice(-16);
}
function Nd(t) {
  return t !== void 0;
}
function W2(t) {
  return t != null;
}
function N7(t, n) {
  return n.key === t;
}
function M7(t) {
  const n = z(t ?? !1);
  return { value: n, toggle: () => {
    n.value = !n.value;
  }, setTrue: () => {
    n.value = !0;
  }, setFalse: () => {
    n.value = !1;
  } };
}
function KC(t) {
  let n = null;
  const a = (g, E) => {
    const h = z(g), f = u();
    h.value && f.observe(h.value, E);
  }, i = () => {
    u().disconnect();
  }, s = (g, E) => {
    const h = z(g);
    if (!h.value)
      return;
    const f = new MutationObserver(t);
    f.observe(h.value, E), setTimeout(() => f.disconnect(), 100);
  };
  function u() {
    return n || p(), n;
  }
  function p() {
    n = new MutationObserver(t);
  }
  return xt(() => {
    p();
  }), zr(() => {
    i();
  }), {
    observe: a,
    disconnect: i,
    check: s
  };
}
function D7(t) {
  let n = null;
  const a = (E) => {
    const h = z(E), f = p();
    h.value && f.observe(h.value);
  }, i = (E) => {
    const h = z(E), f = p();
    h.value && f.unobserve(h.value);
  }, s = () => {
    p().disconnect();
  }, u = (E) => {
    const h = z(E);
    if (!h.value)
      return;
    const f = new ResizeObserver(t);
    f.observe(h.value), setTimeout(() => f.disconnect(), 100);
  };
  function p() {
    return n || g(), n;
  }
  function g() {
    n = new ResizeObserver(t);
  }
  return xt(() => {
    g();
  }), zr(() => {
    s();
  }), {
    observe: a,
    disconnect: s,
    unobserve: i,
    check: u
  };
}
function j2(t) {
  const n = eval;
  try {
    return n(t), !0;
  } catch {
    return !1;
  }
}
function K2(t) {
  if (!(!j2("window") || !t))
    return window.getComputedStyle(t);
}
function k7(t) {
  const n = z(t), a = K2(n.value), i = z(a);
  function s([E]) {
    QC(E.target) && u(E.target);
  }
  function u(E) {
    const h = K2(E);
    h && (i.value = h);
  }
  const p = KC(s), g = D7(s);
  return tt(n, (E) => {
    E && (u(E), p.disconnect(), p.observe(n, { attributes: !0, childList: !0 }), g.disconnect(), g.observe(n));
  }, { immediate: !0 }), i;
}
function QC(t) {
  return !!t.attributes;
}
function tc(t) {
  const n = z(t), a = {
    height: z(0),
    width: z(0),
    x: z(0),
    y: z(0),
    left: z(0),
    top: z(0),
    right: z(0),
    bottom: z(0)
  };
  function i(u) {
    const p = u.getBoundingClientRect();
    a.height.value = p.height, a.width.value = p.width, a.x.value = p.x, a.y.value = p.y, a.left.value = p.left, a.top.value = p.top, a.right.value = p.right, a.bottom.value = p.bottom;
  }
  const s = D7(([u]) => i(u.target));
  return tt(n, (u) => {
    u && (i(u), s.disconnect(), s.observe(n));
  }, { immediate: !0 }), a;
}
function XC(t, n) {
  const a = z(t), i = z(n), { width: s } = tc(i), u = k7(i);
  return M(() => {
    const p = T2(u.value?.paddingLeft), g = T2(u.value?.paddingRight), E = T2(u.value?.columnGap), h = s.value - p - g;
    return JC(a.value, E) > h;
  });
}
function T2(t) {
  return t ? parseInt(t) : 0;
}
function JC(t, n) {
  return t.map(K2).reduce((a, i) => (i && (a += parseInt(i.width), a += parseInt(i.marginLeft) + parseInt(i.marginRight), i.boxSizing === "border-box" && (a += parseInt(i.borderLeftWidth) + parseInt(i.borderRightWidth))), a + n), 0);
}
function L7(t) {
  return df() ? (zl(t), !0) : !1;
}
const e4 = {
  immediate: !0
};
function t4(t, n, a, i = {}) {
  const { immediate: s, ...u } = { ...e4, ...i }, p = z(!s);
  function g() {
    $r(t)?.addEventListener(n, a, u);
  }
  function E() {
    $r(t)?.removeEventListener(n, a, u);
  }
  return L7(E), tt(() => $r(t), () => {
    p.value || (E(), g());
  }, { immediate: !0 }), {
    add: () => {
      g();
    },
    remove: () => {
      p.value = !0, E();
    }
  };
}
function ul(t, n, a) {
  return t4(document, t, n, a);
}
const n4 = /* @__PURE__ */ new Map();
function r4(t) {
  for (const { element: n, callback: a } of n4.values())
    $r(n).contains(t.target) || a();
}
ul("click", r4, { capture: !0 });
var Ca = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, C2, Lh;
function a4() {
  if (Lh) return C2;
  Lh = 1;
  var t = "Expected a function", n = NaN, a = "[object Symbol]", i = /^\s+|\s+$/g, s = /^[-+]0x[0-9a-f]+$/i, u = /^0b[01]+$/i, p = /^0o[0-7]+$/i, g = parseInt, E = typeof Ca == "object" && Ca && Ca.Object === Object && Ca, h = typeof self == "object" && self && self.Object === Object && self, f = E || h || Function("return this")(), b = Object.prototype, w = b.toString, x = Math.max, A = Math.min, D = function() {
    return f.Date.now();
  };
  function L(U, Z, ee) {
    var X, re, Q, ce, me, Se, Le = 0, qe = !1, _t = !1, ot = !0;
    if (typeof U != "function")
      throw new TypeError(t);
    Z = k(Z) || 0, $(ee) && (qe = !!ee.leading, _t = "maxWait" in ee, Q = _t ? x(k(ee.maxWait) || 0, Z) : Q, ot = "trailing" in ee ? !!ee.trailing : ot);
    function st(Ot) {
      var mt = X, an = re;
      return X = re = void 0, Le = Ot, ce = U.apply(an, mt), ce;
    }
    function Me(Ot) {
      return Le = Ot, me = setTimeout(Pn, Z), qe ? st(Ot) : ce;
    }
    function je(Ot) {
      var mt = Ot - Se, an = Ot - Le, ha = Z - mt;
      return _t ? A(ha, Q - an) : ha;
    }
    function Fe(Ot) {
      var mt = Ot - Se, an = Ot - Le;
      return Se === void 0 || mt >= Z || mt < 0 || _t && an >= Q;
    }
    function Pn() {
      var Ot = D();
      if (Fe(Ot))
        return Rt(Ot);
      me = setTimeout(Pn, je(Ot));
    }
    function Rt(Ot) {
      return me = void 0, ot && X ? st(Ot) : (X = re = void 0, ce);
    }
    function Zr() {
      me !== void 0 && clearTimeout(me), Le = 0, X = Se = re = me = void 0;
    }
    function De() {
      return me === void 0 ? ce : Rt(D());
    }
    function gn() {
      var Ot = D(), mt = Fe(Ot);
      if (X = arguments, re = this, Se = Ot, mt) {
        if (me === void 0)
          return Me(Se);
        if (_t)
          return me = setTimeout(Pn, Z), st(Se);
      }
      return me === void 0 && (me = setTimeout(Pn, Z)), ce;
    }
    return gn.cancel = Zr, gn.flush = De, gn;
  }
  function $(U) {
    var Z = typeof U;
    return !!U && (Z == "object" || Z == "function");
  }
  function q(U) {
    return !!U && typeof U == "object";
  }
  function P(U) {
    return typeof U == "symbol" || q(U) && w.call(U) == a;
  }
  function k(U) {
    if (typeof U == "number")
      return U;
    if (P(U))
      return n;
    if ($(U)) {
      var Z = typeof U.valueOf == "function" ? U.valueOf() : U;
      U = $(Z) ? Z + "" : Z;
    }
    if (typeof U != "string")
      return U === 0 ? U : +U;
    U = U.replace(i, "");
    var ee = u.test(U);
    return ee || p.test(U) ? g(U.slice(2), ee ? 2 : 8) : s.test(U) ? n : +U;
  }
  return C2 = L, C2;
}
a4();
function Md(t, n = {}) {
  const a = z(n), i = /* @__PURE__ */ new Set();
  let s = null;
  function u(w) {
    const x = $r(w), A = f();
    x && (A.observe(x), i.add(x));
  }
  function p(w) {
    const x = $r(w), A = f();
    x && (A.unobserve(x), i.delete(x));
  }
  function g() {
    f().disconnect(), i.clear();
  }
  function E({ root: w, rootMargin: x, threshold: A }) {
    return {
      root: y(w),
      rootMargin: x,
      threshold: A
    };
  }
  function h(w) {
    const x = $r(w);
    if (!x)
      return;
    const A = new IntersectionObserver(t, E(a.value));
    A.observe(x), setTimeout(() => A.disconnect(), 100);
  }
  function f() {
    return s || b(), s;
  }
  function b() {
    s && s.disconnect(), s = new IntersectionObserver(t, E(a.value)), i.forEach((w) => s.observe(w));
  }
  return xt(() => {
    b();
  }), zr(() => {
    g();
  }), tt(a, () => {
    b();
  }), {
    observe: u,
    disconnect: g,
    unobserve: p,
    check: h
  };
}
function o4(t) {
  return Array.isArray(t) ? t : [t];
}
function i4() {
  const t = Mr(/* @__PURE__ */ new Set()), n = /* @__PURE__ */ new Set();
  function a(s) {
    t.add(s.key), n.forEach((u) => u(s));
  }
  function i(s) {
    t.delete(s.key);
  }
  return document.addEventListener("keydown", a), document.addEventListener("keyup", i), (...[s, u]) => {
    const p = M(() => o4(y(s))), g = M(() => p.value.some((b) => t.has(b))), E = (b) => {
      p.value.includes(b.key) && u?.(b);
    }, h = () => {
      n.add(E);
    }, f = () => {
      n.delete(E);
    };
    return h(), L7(f), {
      down: g,
      connect: h,
      disconnect: f
    };
  };
}
const O0 = i4();
function s4(t) {
  let n = window.matchMedia(y(t));
  const a = z(n.matches);
  let i;
  function s(u) {
    a.value = u.matches;
  }
  return n.addEventListener("change", s), pf(t) && (i = tt(t, () => {
    n.removeEventListener("change", s), n = window.matchMedia(y(t)), n.addEventListener("change", s);
  })), po() && zr(() => {
    n.removeEventListener("change", s), i && i();
  }), a;
}
const d0 = Mr({ x: 0, y: 0 }), _0 = Mr({ x: 0, y: 0 }), qf = () => {
  Object.assign(_0, d0);
}, l4 = (t) => {
  d0.x = t.clientX, d0.y = t.clientY, _0.x === 0 && _0.y === 0 && qf();
}, Q2 = z(0), { add: c4, remove: u4 } = ul("mousemove", l4, { passive: !0 }), { add: d4, remove: _4 } = ul("click", qf, { capture: !0 }), { add: p4, remove: m4 } = ul("contextmenu", qf, { capture: !0 });
function g4() {
  Q2.value > 0 || (u4(), _4(), m4());
}
function f4() {
  c4(), d4(), p4();
}
function h4() {
  return Q2.value += 1, f4(), zl(() => {
    Q2.value -= 1, g4();
  }), {
    position: d0,
    positionAtLastClick: _0
  };
}
const Ph = {
  rootMargin: "-1px 0px 0px 0px",
  boundingElement: document.body
};
function v4(t, n) {
  const a = _f(t), i = z(!1), s = M(() => {
    const { rootMargin: E, boundingElement: h } = $r(n ?? {}), f = E ?? Ph.rootMargin, b = h ?? Ph.boundingElement;
    return {
      threshold: [1],
      rootMargin: f,
      root: b
    };
  });
  function u(E) {
    E.forEach((h) => {
      i.value = h.intersectionRatio < 1;
    });
  }
  const { observe: p, unobserve: g } = Md(u, s);
  return tt(a, (E, h) => {
    g(h), p(E);
  }, { immediate: !0 }), {
    stuck: i
  };
}
class x2 extends Error {
  constructor() {
    super("Invalid route query property");
  }
}
function E4() {
  const t = Mr([]);
  let n, a, i;
  const s = async () => {
    const u = Gd(n.query, t);
    await a.push({ query: u }), t.splice(0);
  };
  return tt(t, () => {
    t.length && (clearInterval(i), i = setTimeout(s));
  }), () => {
    a = fv(), n = hv();
    const u = () => {
      a.push({ query: {} });
    }, p = (f, b) => {
      h[f] = b;
    }, g = (f) => h[f], E = (f) => {
      delete h[f];
    }, h = new Proxy({}, {
      get(f, b) {
        if (typeof b == "symbol")
          throw new x2();
        return Gd(n.query, t)[b];
      },
      set(f, b, w) {
        if (typeof b == "symbol")
          throw new x2();
        const x = b4(b, w);
        return t.push(x), !0;
      },
      deleteProperty(f, b) {
        if (typeof b == "symbol")
          throw new x2();
        const w = S4(b);
        return t.push(w), !0;
      },
      ownKeys() {
        const f = Gd(n.query, t);
        return Object.keys(f);
      },
      has(f, b) {
        const w = Gd(n.query, t);
        return b in w;
      }
    });
    return {
      clear: u,
      set: p,
      get: g,
      remove: E,
      query: h
    };
  };
}
function Gd(t, n) {
  let a = { ...t };
  for (const i of n)
    a = i(a);
  return a;
}
function b4(t, n) {
  return (a) => ({ ...a, [t]: n });
}
function S4(t) {
  return (n) => {
    const a = { ...n };
    return delete a[t], a;
  };
}
E4();
var Kd = { exports: {} };
Kd.exports;
var Bh;
function w4() {
  return Bh || (Bh = 1, function(t, n) {
    var a = 200, i = "__lodash_hash_undefined__", s = 1, u = 2, p = 9007199254740991, g = "[object Arguments]", E = "[object Array]", h = "[object AsyncFunction]", f = "[object Boolean]", b = "[object Date]", w = "[object Error]", x = "[object Function]", A = "[object GeneratorFunction]", D = "[object Map]", L = "[object Number]", $ = "[object Null]", q = "[object Object]", P = "[object Promise]", k = "[object Proxy]", U = "[object RegExp]", Z = "[object Set]", ee = "[object String]", X = "[object Symbol]", re = "[object Undefined]", Q = "[object WeakMap]", ce = "[object ArrayBuffer]", me = "[object DataView]", Se = "[object Float32Array]", Le = "[object Float64Array]", qe = "[object Int8Array]", _t = "[object Int16Array]", ot = "[object Int32Array]", st = "[object Uint8Array]", Me = "[object Uint8ClampedArray]", je = "[object Uint16Array]", Fe = "[object Uint32Array]", Pn = /[\\^$.*+?()[\]{}|]/g, Rt = /^\[object .+?Constructor\]$/, Zr = /^(?:0|[1-9]\d*)$/, De = {};
    De[Se] = De[Le] = De[qe] = De[_t] = De[ot] = De[st] = De[Me] = De[je] = De[Fe] = !0, De[g] = De[E] = De[ce] = De[f] = De[me] = De[b] = De[w] = De[x] = De[D] = De[L] = De[q] = De[U] = De[Z] = De[ee] = De[Q] = !1;
    var gn = typeof Ca == "object" && Ca && Ca.Object === Object && Ca, Ot = typeof self == "object" && self && self.Object === Object && self, mt = gn || Ot || Function("return this")(), an = n && !n.nodeType && n, ha = an && !0 && t && !t.nodeType && t, pr = ha && ha.exports === an, Cn = pr && gn.process, qr = function() {
      try {
        return Cn && Cn.binding && Cn.binding("util");
      } catch {
      }
    }(), pt = qr && qr.isTypedArray;
    function Xn(F, J) {
      for (var se = -1, Re = F == null ? 0 : F.length, It = 0, Xe = []; ++se < Re; ) {
        var $t = F[se];
        J($t, se, F) && (Xe[It++] = $t);
      }
      return Xe;
    }
    function go(F, J) {
      for (var se = -1, Re = J.length, It = F.length; ++se < Re; )
        F[It + se] = J[se];
      return F;
    }
    function Ft(F, J) {
      for (var se = -1, Re = F == null ? 0 : F.length; ++se < Re; )
        if (J(F[se], se, F))
          return !0;
      return !1;
    }
    function va(F, J) {
      for (var se = -1, Re = Array(F); ++se < F; )
        Re[se] = J(se);
      return Re;
    }
    function Ja(F) {
      return function(J) {
        return F(J);
      };
    }
    function dr(F, J) {
      return F.has(J);
    }
    function Ut(F, J) {
      return F?.[J];
    }
    function mr(F) {
      var J = -1, se = Array(F.size);
      return F.forEach(function(Re, It) {
        se[++J] = [It, Re];
      }), se;
    }
    function gr(F, J) {
      return function(se) {
        return F(J(se));
      };
    }
    function Ra(F) {
      var J = -1, se = Array(F.size);
      return F.forEach(function(Re) {
        se[++J] = Re;
      }), se;
    }
    var xn = Array.prototype, Ea = Function.prototype, Bn = Object.prototype, An = mt["__core-js_shared__"], Wr = Ea.toString, fn = Bn.hasOwnProperty, jr = function() {
      var F = /[^.]+$/.exec(An && An.keys && An.keys.IE_PROTO || "");
      return F ? "Symbol(src)_1." + F : "";
    }(), fr = Bn.toString, Dr = RegExp(
      "^" + Wr.call(fn).replace(Pn, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    ), Rn = pr ? mt.Buffer : void 0, Fn = mt.Symbol, kr = mt.Uint8Array, Lr = Bn.propertyIsEnumerable, $i = xn.splice, _r = Fn ? Fn.toStringTag : void 0, Oa = Object.getOwnPropertySymbols, fo = Rn ? Rn.isBuffer : void 0, Kr = gr(Object.keys, Object), ho = Nn(mt, "DataView"), Ia = Nn(mt, "Map"), qt = Nn(mt, "Promise"), Pr = Nn(mt, "Set"), Na = Nn(mt, "WeakMap"), ba = Nn(Object, "create"), vo = Da(ho), bi = Da(Ia), Sa = Da(qt), Vi = Da(Pr), On = Da(Na), Qr = Fn ? Fn.prototype : void 0, eo = Qr ? Qr.valueOf : void 0;
    function Br(F) {
      var J = -1, se = F == null ? 0 : F.length;
      for (this.clear(); ++J < se; ) {
        var Re = F[J];
        this.set(Re[0], Re[1]);
      }
    }
    function Eo() {
      this.__data__ = ba ? ba(null) : {}, this.size = 0;
    }
    function Si(F) {
      var J = this.has(F) && delete this.__data__[F];
      return this.size -= J ? 1 : 0, J;
    }
    function hr(F) {
      var J = this.__data__;
      if (ba) {
        var se = J[F];
        return se === i ? void 0 : se;
      }
      return fn.call(J, F) ? J[F] : void 0;
    }
    function wi(F) {
      var J = this.__data__;
      return ba ? J[F] !== void 0 : fn.call(J, F);
    }
    function yi(F, J) {
      var se = this.__data__;
      return this.size += this.has(F) ? 0 : 1, se[F] = ba && J === void 0 ? i : J, this;
    }
    Br.prototype.clear = Eo, Br.prototype.delete = Si, Br.prototype.get = hr, Br.prototype.has = wi, Br.prototype.set = yi;
    function jn(F) {
      var J = -1, se = F == null ? 0 : F.length;
      for (this.clear(); ++J < se; ) {
        var Re = F[J];
        this.set(Re[0], Re[1]);
      }
    }
    function Ti() {
      this.__data__ = [], this.size = 0;
    }
    function Hi(F) {
      var J = this.__data__, se = to(J, F);
      if (se < 0)
        return !1;
      var Re = J.length - 1;
      return se == Re ? J.pop() : $i.call(J, se, 1), --this.size, !0;
    }
    function Pe(F) {
      var J = this.__data__, se = to(J, F);
      return se < 0 ? void 0 : J[se][1];
    }
    function K(F) {
      return to(this.__data__, F) > -1;
    }
    function pe(F, J) {
      var se = this.__data__, Re = to(se, F);
      return Re < 0 ? (++this.size, se.push([F, J])) : se[Re][1] = J, this;
    }
    jn.prototype.clear = Ti, jn.prototype.delete = Hi, jn.prototype.get = Pe, jn.prototype.has = K, jn.prototype.set = pe;
    function xe(F) {
      var J = -1, se = F == null ? 0 : F.length;
      for (this.clear(); ++J < se; ) {
        var Re = F[J];
        this.set(Re[0], Re[1]);
      }
    }
    function ut() {
      this.size = 0, this.__data__ = {
        hash: new Br(),
        map: new (Ia || jn)(),
        string: new Br()
      };
    }
    function hn(F) {
      var J = ya(this, F).delete(F);
      return this.size -= J ? 1 : 0, J;
    }
    function bt(F) {
      return ya(this, F).get(F);
    }
    function In(F) {
      return ya(this, F).has(F);
    }
    function vr(F, J) {
      var se = ya(this, F), Re = se.size;
      return se.set(F, J), this.size += se.size == Re ? 0 : 1, this;
    }
    xe.prototype.clear = ut, xe.prototype.delete = hn, xe.prototype.get = bt, xe.prototype.has = In, xe.prototype.set = vr;
    function Fr(F) {
      var J = -1, se = F == null ? 0 : F.length;
      for (this.__data__ = new xe(); ++J < se; )
        this.add(F[J]);
    }
    function Ma(F) {
      return this.__data__.set(F, i), this;
    }
    function on(F) {
      return this.__data__.has(F);
    }
    Fr.prototype.add = Fr.prototype.push = Ma, Fr.prototype.has = on;
    function Jn(F) {
      var J = this.__data__ = new jn(F);
      this.size = J.size;
    }
    function Ci() {
      this.__data__ = new jn(), this.size = 0;
    }
    function rc(F) {
      var J = this.__data__, se = J.delete(F);
      return this.size = J.size, se;
    }
    function ac(F) {
      return this.__data__.get(F);
    }
    function oc(F) {
      return this.__data__.has(F);
    }
    function Gi(F, J) {
      var se = this.__data__;
      if (se instanceof jn) {
        var Re = se.__data__;
        if (!Ia || Re.length < a - 1)
          return Re.push([F, J]), this.size = ++se.size, this;
        se = this.__data__ = new xe(Re);
      }
      return se.set(F, J), this.size = se.size, this;
    }
    Jn.prototype.clear = Ci, Jn.prototype.delete = rc, Jn.prototype.get = ac, Jn.prototype.has = oc, Jn.prototype.set = Gi;
    function Yi(F, J) {
      var se = Ai(F), Re = !se && ts(F), It = !se && !Re && ns(F), Xe = !se && !Re && !It && Cl(F), $t = se || Re || It || Xe, vn = $t ? va(F.length, String) : [], Ge = vn.length;
      for (var St in F)
        fn.call(F, St) && !($t && // Safari 9 has enumerable `arguments.length` in strict mode.
        (St == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
        It && (St == "offset" || St == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
        Xe && (St == "buffer" || St == "byteLength" || St == "byteOffset") || // Skip index properties.
        Qi(St, Ge))) && vn.push(St);
      return vn;
    }
    function to(F, J) {
      for (var se = F.length; se--; )
        if (wl(F[se][0], J))
          return se;
      return -1;
    }
    function bo(F, J, se) {
      var Re = J(F);
      return Ai(F) ? Re : go(Re, se(F));
    }
    function So(F) {
      return F == null ? F === void 0 ? re : $ : _r && _r in Object(F) ? ji(F) : lc(F);
    }
    function xi(F) {
      return wo(F) && So(F) == g;
    }
    function wa(F, J, se, Re, It) {
      return F === J ? !0 : F == null || J == null || !wo(F) && !wo(J) ? F !== F && J !== J : zi(F, J, se, Re, wa, It);
    }
    function zi(F, J, se, Re, It, Xe) {
      var $t = Ai(F), vn = Ai(J), Ge = $t ? E : Ta(F), St = vn ? E : Ta(J);
      Ge = Ge == g ? q : Ge, St = St == g ? q : St;
      var Nt = Ge == q, er = St == q, sn = Ge == St;
      if (sn && ns(F)) {
        if (!ns(J))
          return !1;
        $t = !0, Nt = !1;
      }
      if (sn && !Nt)
        return Xe || (Xe = new Jn()), $t || Cl(F) ? no(F, J, se, Re, It, Xe) : sc(F, J, Ge, se, Re, It, Xe);
      if (!(se & s)) {
        var it = Nt && fn.call(F, "__wrapped__"), Kn = er && fn.call(J, "__wrapped__");
        if (it || Kn) {
          var Ur = it ? F.value() : F, Er = Kn ? J.value() : J;
          return Xe || (Xe = new Jn()), It(Ur, Er, se, Re, Xe);
        }
      }
      return sn ? (Xe || (Xe = new Jn()), Wi(F, J, se, Re, It, Xe)) : !1;
    }
    function ic(F) {
      if (!Tl(F) || Ji(F))
        return !1;
      var J = ao(F) ? Dr : Rt;
      return J.test(Da(F));
    }
    function Zi(F) {
      return wo(F) && yl(F.length) && !!De[So(F)];
    }
    function qi(F) {
      if (!es(F))
        return Kr(F);
      var J = [];
      for (var se in Object(F))
        fn.call(F, se) && se != "constructor" && J.push(se);
      return J;
    }
    function no(F, J, se, Re, It, Xe) {
      var $t = se & s, vn = F.length, Ge = J.length;
      if (vn != Ge && !($t && Ge > vn))
        return !1;
      var St = Xe.get(F);
      if (St && Xe.get(J))
        return St == J;
      var Nt = -1, er = !0, sn = se & u ? new Fr() : void 0;
      for (Xe.set(F, J), Xe.set(J, F); ++Nt < vn; ) {
        var it = F[Nt], Kn = J[Nt];
        if (Re)
          var Ur = $t ? Re(Kn, it, Nt, J, F, Xe) : Re(it, Kn, Nt, F, J, Xe);
        if (Ur !== void 0) {
          if (Ur)
            continue;
          er = !1;
          break;
        }
        if (sn) {
          if (!Ft(J, function(Er, Xr) {
            if (!dr(sn, Xr) && (it === Er || It(it, Er, se, Re, Xe)))
              return sn.push(Xr);
          })) {
            er = !1;
            break;
          }
        } else if (!(it === Kn || It(it, Kn, se, Re, Xe))) {
          er = !1;
          break;
        }
      }
      return Xe.delete(F), Xe.delete(J), er;
    }
    function sc(F, J, se, Re, It, Xe, $t) {
      switch (se) {
        case me:
          if (F.byteLength != J.byteLength || F.byteOffset != J.byteOffset)
            return !1;
          F = F.buffer, J = J.buffer;
        case ce:
          return !(F.byteLength != J.byteLength || !Xe(new kr(F), new kr(J)));
        case f:
        case b:
        case L:
          return wl(+F, +J);
        case w:
          return F.name == J.name && F.message == J.message;
        case U:
        case ee:
          return F == J + "";
        case D:
          var vn = mr;
        case Z:
          var Ge = Re & s;
          if (vn || (vn = Ra), F.size != J.size && !Ge)
            return !1;
          var St = $t.get(F);
          if (St)
            return St == J;
          Re |= u, $t.set(F, J);
          var Nt = no(vn(F), vn(J), Re, It, Xe, $t);
          return $t.delete(F), Nt;
        case X:
          if (eo)
            return eo.call(F) == eo.call(J);
      }
      return !1;
    }
    function Wi(F, J, se, Re, It, Xe) {
      var $t = se & s, vn = ro(F), Ge = vn.length, St = ro(J), Nt = St.length;
      if (Ge != Nt && !$t)
        return !1;
      for (var er = Ge; er--; ) {
        var sn = vn[er];
        if (!($t ? sn in J : fn.call(J, sn)))
          return !1;
      }
      var it = Xe.get(F);
      if (it && Xe.get(J))
        return it == J;
      var Kn = !0;
      Xe.set(F, J), Xe.set(J, F);
      for (var Ur = $t; ++er < Ge; ) {
        sn = vn[er];
        var Er = F[sn], Xr = J[sn];
        if (Re)
          var Ri = $t ? Re(Xr, Er, sn, J, F, Xe) : Re(Er, Xr, sn, F, J, Xe);
        if (!(Ri === void 0 ? Er === Xr || It(Er, Xr, se, Re, Xe) : Ri)) {
          Kn = !1;
          break;
        }
        Ur || (Ur = sn == "constructor");
      }
      if (Kn && !Ur) {
        var oo = F.constructor, vt = J.constructor;
        oo != vt && "constructor" in F && "constructor" in J && !(typeof oo == "function" && oo instanceof oo && typeof vt == "function" && vt instanceof vt) && (Kn = !1);
      }
      return Xe.delete(F), Xe.delete(J), Kn;
    }
    function ro(F) {
      return bo(F, dc, Ki);
    }
    function ya(F, J) {
      var se = F.__data__;
      return Xi(J) ? se[typeof J == "string" ? "string" : "hash"] : se.map;
    }
    function Nn(F, J) {
      var se = Ut(F, J);
      return ic(se) ? se : void 0;
    }
    function ji(F) {
      var J = fn.call(F, _r), se = F[_r];
      try {
        F[_r] = void 0;
        var Re = !0;
      } catch {
      }
      var It = fr.call(F);
      return Re && (J ? F[_r] = se : delete F[_r]), It;
    }
    var Ki = Oa ? function(F) {
      return F == null ? [] : (F = Object(F), Xn(Oa(F), function(J) {
        return Lr.call(F, J);
      }));
    } : He, Ta = So;
    (ho && Ta(new ho(new ArrayBuffer(1))) != me || Ia && Ta(new Ia()) != D || qt && Ta(qt.resolve()) != P || Pr && Ta(new Pr()) != Z || Na && Ta(new Na()) != Q) && (Ta = function(F) {
      var J = So(F), se = J == q ? F.constructor : void 0, Re = se ? Da(se) : "";
      if (Re)
        switch (Re) {
          case vo:
            return me;
          case bi:
            return D;
          case Sa:
            return P;
          case Vi:
            return Z;
          case On:
            return Q;
        }
      return J;
    });
    function Qi(F, J) {
      return J = J ?? p, !!J && (typeof F == "number" || Zr.test(F)) && F > -1 && F % 1 == 0 && F < J;
    }
    function Xi(F) {
      var J = typeof F;
      return J == "string" || J == "number" || J == "symbol" || J == "boolean" ? F !== "__proto__" : F === null;
    }
    function Ji(F) {
      return !!jr && jr in F;
    }
    function es(F) {
      var J = F && F.constructor, se = typeof J == "function" && J.prototype || Bn;
      return F === se;
    }
    function lc(F) {
      return fr.call(F);
    }
    function Da(F) {
      if (F != null) {
        try {
          return Wr.call(F);
        } catch {
        }
        try {
          return F + "";
        } catch {
        }
      }
      return "";
    }
    function wl(F, J) {
      return F === J || F !== F && J !== J;
    }
    var ts = xi(/* @__PURE__ */ function() {
      return arguments;
    }()) ? xi : function(F) {
      return wo(F) && fn.call(F, "callee") && !Lr.call(F, "callee");
    }, Ai = Array.isArray;
    function cc(F) {
      return F != null && yl(F.length) && !ao(F);
    }
    var ns = fo || $e;
    function uc(F, J) {
      return wa(F, J);
    }
    function ao(F) {
      if (!Tl(F))
        return !1;
      var J = So(F);
      return J == x || J == A || J == h || J == k;
    }
    function yl(F) {
      return typeof F == "number" && F > -1 && F % 1 == 0 && F <= p;
    }
    function Tl(F) {
      var J = typeof F;
      return F != null && (J == "object" || J == "function");
    }
    function wo(F) {
      return F != null && typeof F == "object";
    }
    var Cl = pt ? Ja(pt) : Zi;
    function dc(F) {
      return cc(F) ? Yi(F) : qi(F);
    }
    function He() {
      return [];
    }
    function $e() {
      return !1;
    }
    t.exports = uc;
  }(Kd, Kd.exports)), Kd.exports;
}
w4();
class y4 {
  type;
  get length() {
    const n = this.storage();
    return n ? n.length : 0;
  }
  constructor(n) {
    this.type = n;
  }
  get(n, a = null) {
    const i = this.storage();
    if (!i)
      return null;
    const s = i.getItem(n);
    if (s === null)
      return a;
    try {
      return JSON.parse(s);
    } catch {
      return console.error(`Unable to parse current value for key ${n}, returning default instead`), a;
    }
  }
  set(n, a) {
    const i = JSON.stringify(a), s = this.storage();
    if (s)
      return s.setItem(n, i);
  }
  remove(n) {
    const a = this.storage();
    if (a)
      return a.removeItem(n);
  }
  clear() {
    const n = this.storage();
    if (n)
      return n.clear();
  }
  key(n) {
    const a = this.storage();
    return a ? a.key(n) : null;
  }
  storage() {
    return this.type === "local" && j2("localStorage") ? localStorage : this.type === "session" && j2("sessionStorage") ? sessionStorage : null;
  }
}
function T4(t, n, a = null) {
  const i = new y4(t), s = i.get(n, a), u = z(s);
  let p = !1;
  const g = () => {
    p = !0, i.remove(n), u.value = null;
  }, E = (h) => {
    u.value = h;
  };
  return tt(u, (h) => {
    if (p) {
      console.warn(`Storage for key ${n} as been removed and cannot be updated`);
      return;
    }
    i.set(n, h);
  }), {
    value: u,
    initialValue: s,
    remove: g,
    set: E
  };
}
function C4(t, n = null) {
  return T4("local", t, n);
}
var Qd = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
var x4 = Qd.exports, Fh;
function A4() {
  return Fh || (Fh = 1, function(t, n) {
    (function() {
      var a, i = "4.17.21", s = 200, u = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", p = "Expected a function", g = "Invalid `variable` option passed into `_.template`", E = "__lodash_hash_undefined__", h = 500, f = "__lodash_placeholder__", b = 1, w = 2, x = 4, A = 1, D = 2, L = 1, $ = 2, q = 4, P = 8, k = 16, U = 32, Z = 64, ee = 128, X = 256, re = 512, Q = 30, ce = "...", me = 800, Se = 16, Le = 1, qe = 2, _t = 3, ot = 1 / 0, st = 9007199254740991, Me = 17976931348623157e292, je = NaN, Fe = 4294967295, Pn = Fe - 1, Rt = Fe >>> 1, Zr = [
        ["ary", ee],
        ["bind", L],
        ["bindKey", $],
        ["curry", P],
        ["curryRight", k],
        ["flip", re],
        ["partial", U],
        ["partialRight", Z],
        ["rearg", X]
      ], De = "[object Arguments]", gn = "[object Array]", Ot = "[object AsyncFunction]", mt = "[object Boolean]", an = "[object Date]", ha = "[object DOMException]", pr = "[object Error]", Cn = "[object Function]", qr = "[object GeneratorFunction]", pt = "[object Map]", Xn = "[object Number]", go = "[object Null]", Ft = "[object Object]", va = "[object Promise]", Ja = "[object Proxy]", dr = "[object RegExp]", Ut = "[object Set]", mr = "[object String]", gr = "[object Symbol]", Ra = "[object Undefined]", xn = "[object WeakMap]", Ea = "[object WeakSet]", Bn = "[object ArrayBuffer]", An = "[object DataView]", Wr = "[object Float32Array]", fn = "[object Float64Array]", jr = "[object Int8Array]", fr = "[object Int16Array]", Dr = "[object Int32Array]", Rn = "[object Uint8Array]", Fn = "[object Uint8ClampedArray]", kr = "[object Uint16Array]", Lr = "[object Uint32Array]", $i = /\b__p \+= '';/g, _r = /\b(__p \+=) '' \+/g, Oa = /(__e\(.*?\)|\b__t\)) \+\n'';/g, fo = /&(?:amp|lt|gt|quot|#39);/g, Kr = /[&<>"']/g, ho = RegExp(fo.source), Ia = RegExp(Kr.source), qt = /<%-([\s\S]+?)%>/g, Pr = /<%([\s\S]+?)%>/g, Na = /<%=([\s\S]+?)%>/g, ba = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, vo = /^\w*$/, bi = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Sa = /[\\^$.*+?()[\]{}|]/g, Vi = RegExp(Sa.source), On = /^\s+/, Qr = /\s/, eo = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Br = /\{\n\/\* \[wrapped with (.+)\] \*/, Eo = /,? & /, Si = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, hr = /[()=,{}\[\]\/\s]/, wi = /\\(\\)?/g, yi = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, jn = /\w*$/, Ti = /^[-+]0x[0-9a-f]+$/i, Hi = /^0b[01]+$/i, Pe = /^\[object .+?Constructor\]$/, K = /^0o[0-7]+$/i, pe = /^(?:0|[1-9]\d*)$/, xe = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, ut = /($^)/, hn = /['\n\r\u2028\u2029\\]/g, bt = "\\ud800-\\udfff", In = "\\u0300-\\u036f", vr = "\\ufe20-\\ufe2f", Fr = "\\u20d0-\\u20ff", Ma = In + vr + Fr, on = "\\u2700-\\u27bf", Jn = "a-z\\xdf-\\xf6\\xf8-\\xff", Ci = "\\xac\\xb1\\xd7\\xf7", rc = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", ac = "\\u2000-\\u206f", oc = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Gi = "A-Z\\xc0-\\xd6\\xd8-\\xde", Yi = "\\ufe0e\\ufe0f", to = Ci + rc + ac + oc, bo = "['’]", So = "[" + bt + "]", xi = "[" + to + "]", wa = "[" + Ma + "]", zi = "\\d+", ic = "[" + on + "]", Zi = "[" + Jn + "]", qi = "[^" + bt + to + zi + on + Jn + Gi + "]", no = "\\ud83c[\\udffb-\\udfff]", sc = "(?:" + wa + "|" + no + ")", Wi = "[^" + bt + "]", ro = "(?:\\ud83c[\\udde6-\\uddff]){2}", ya = "[\\ud800-\\udbff][\\udc00-\\udfff]", Nn = "[" + Gi + "]", ji = "\\u200d", Ki = "(?:" + Zi + "|" + qi + ")", Ta = "(?:" + Nn + "|" + qi + ")", Qi = "(?:" + bo + "(?:d|ll|m|re|s|t|ve))?", Xi = "(?:" + bo + "(?:D|LL|M|RE|S|T|VE))?", Ji = sc + "?", es = "[" + Yi + "]?", lc = "(?:" + ji + "(?:" + [Wi, ro, ya].join("|") + ")" + es + Ji + ")*", Da = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", wl = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", ts = es + Ji + lc, Ai = "(?:" + [ic, ro, ya].join("|") + ")" + ts, cc = "(?:" + [Wi + wa + "?", wa, ro, ya, So].join("|") + ")", ns = RegExp(bo, "g"), uc = RegExp(wa, "g"), ao = RegExp(no + "(?=" + no + ")|" + cc + ts, "g"), yl = RegExp([
        Nn + "?" + Zi + "+" + Qi + "(?=" + [xi, Nn, "$"].join("|") + ")",
        Ta + "+" + Xi + "(?=" + [xi, Nn + Ki, "$"].join("|") + ")",
        Nn + "?" + Ki + "+" + Qi,
        Nn + "+" + Xi,
        wl,
        Da,
        zi,
        Ai
      ].join("|"), "g"), Tl = RegExp("[" + ji + bt + Ma + Yi + "]"), wo = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, Cl = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ], dc = -1, He = {};
      He[Wr] = He[fn] = He[jr] = He[fr] = He[Dr] = He[Rn] = He[Fn] = He[kr] = He[Lr] = !0, He[De] = He[gn] = He[Bn] = He[mt] = He[An] = He[an] = He[pr] = He[Cn] = He[pt] = He[Xn] = He[Ft] = He[dr] = He[Ut] = He[mr] = He[xn] = !1;
      var $e = {};
      $e[De] = $e[gn] = $e[Bn] = $e[An] = $e[mt] = $e[an] = $e[Wr] = $e[fn] = $e[jr] = $e[fr] = $e[Dr] = $e[pt] = $e[Xn] = $e[Ft] = $e[dr] = $e[Ut] = $e[mr] = $e[gr] = $e[Rn] = $e[Fn] = $e[kr] = $e[Lr] = !0, $e[pr] = $e[Cn] = $e[xn] = !1;
      var F = {
        // Latin-1 Supplement block.
        À: "A",
        Á: "A",
        Â: "A",
        Ã: "A",
        Ä: "A",
        Å: "A",
        à: "a",
        á: "a",
        â: "a",
        ã: "a",
        ä: "a",
        å: "a",
        Ç: "C",
        ç: "c",
        Ð: "D",
        ð: "d",
        È: "E",
        É: "E",
        Ê: "E",
        Ë: "E",
        è: "e",
        é: "e",
        ê: "e",
        ë: "e",
        Ì: "I",
        Í: "I",
        Î: "I",
        Ï: "I",
        ì: "i",
        í: "i",
        î: "i",
        ï: "i",
        Ñ: "N",
        ñ: "n",
        Ò: "O",
        Ó: "O",
        Ô: "O",
        Õ: "O",
        Ö: "O",
        Ø: "O",
        ò: "o",
        ó: "o",
        ô: "o",
        õ: "o",
        ö: "o",
        ø: "o",
        Ù: "U",
        Ú: "U",
        Û: "U",
        Ü: "U",
        ù: "u",
        ú: "u",
        û: "u",
        ü: "u",
        Ý: "Y",
        ý: "y",
        ÿ: "y",
        Æ: "Ae",
        æ: "ae",
        Þ: "Th",
        þ: "th",
        ß: "ss",
        // Latin Extended-A block.
        Ā: "A",
        Ă: "A",
        Ą: "A",
        ā: "a",
        ă: "a",
        ą: "a",
        Ć: "C",
        Ĉ: "C",
        Ċ: "C",
        Č: "C",
        ć: "c",
        ĉ: "c",
        ċ: "c",
        č: "c",
        Ď: "D",
        Đ: "D",
        ď: "d",
        đ: "d",
        Ē: "E",
        Ĕ: "E",
        Ė: "E",
        Ę: "E",
        Ě: "E",
        ē: "e",
        ĕ: "e",
        ė: "e",
        ę: "e",
        ě: "e",
        Ĝ: "G",
        Ğ: "G",
        Ġ: "G",
        Ģ: "G",
        ĝ: "g",
        ğ: "g",
        ġ: "g",
        ģ: "g",
        Ĥ: "H",
        Ħ: "H",
        ĥ: "h",
        ħ: "h",
        Ĩ: "I",
        Ī: "I",
        Ĭ: "I",
        Į: "I",
        İ: "I",
        ĩ: "i",
        ī: "i",
        ĭ: "i",
        į: "i",
        ı: "i",
        Ĵ: "J",
        ĵ: "j",
        Ķ: "K",
        ķ: "k",
        ĸ: "k",
        Ĺ: "L",
        Ļ: "L",
        Ľ: "L",
        Ŀ: "L",
        Ł: "L",
        ĺ: "l",
        ļ: "l",
        ľ: "l",
        ŀ: "l",
        ł: "l",
        Ń: "N",
        Ņ: "N",
        Ň: "N",
        Ŋ: "N",
        ń: "n",
        ņ: "n",
        ň: "n",
        ŋ: "n",
        Ō: "O",
        Ŏ: "O",
        Ő: "O",
        ō: "o",
        ŏ: "o",
        ő: "o",
        Ŕ: "R",
        Ŗ: "R",
        Ř: "R",
        ŕ: "r",
        ŗ: "r",
        ř: "r",
        Ś: "S",
        Ŝ: "S",
        Ş: "S",
        Š: "S",
        ś: "s",
        ŝ: "s",
        ş: "s",
        š: "s",
        Ţ: "T",
        Ť: "T",
        Ŧ: "T",
        ţ: "t",
        ť: "t",
        ŧ: "t",
        Ũ: "U",
        Ū: "U",
        Ŭ: "U",
        Ů: "U",
        Ű: "U",
        Ų: "U",
        ũ: "u",
        ū: "u",
        ŭ: "u",
        ů: "u",
        ű: "u",
        ų: "u",
        Ŵ: "W",
        ŵ: "w",
        Ŷ: "Y",
        ŷ: "y",
        Ÿ: "Y",
        Ź: "Z",
        Ż: "Z",
        Ž: "Z",
        ź: "z",
        ż: "z",
        ž: "z",
        Ĳ: "IJ",
        ĳ: "ij",
        Œ: "Oe",
        œ: "oe",
        ŉ: "'n",
        ſ: "s"
      }, J = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }, se = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      }, Re = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      }, It = parseFloat, Xe = parseInt, $t = typeof Ca == "object" && Ca && Ca.Object === Object && Ca, vn = typeof self == "object" && self && self.Object === Object && self, Ge = $t || vn || Function("return this")(), St = n && !n.nodeType && n, Nt = St && !0 && t && !t.nodeType && t, er = Nt && Nt.exports === St, sn = er && $t.process, it = function() {
        try {
          var R = Nt && Nt.require && Nt.require("util").types;
          return R || sn && sn.binding && sn.binding("util");
        } catch {
        }
      }(), Kn = it && it.isArrayBuffer, Ur = it && it.isDate, Er = it && it.isMap, Xr = it && it.isRegExp, Ri = it && it.isSet, oo = it && it.isTypedArray;
      function vt(R, V, B) {
        switch (B.length) {
          case 0:
            return R.call(V);
          case 1:
            return R.call(V, B[0]);
          case 2:
            return R.call(V, B[0], B[1]);
          case 3:
            return R.call(V, B[0], B[1], B[2]);
        }
        return R.apply(V, B);
      }
      function B0(R, V, B, ae) {
        for (var ge = -1, ke = R == null ? 0 : R.length; ++ge < ke; ) {
          var rt = R[ge];
          V(ae, rt, B(rt), R);
        }
        return ae;
      }
      function jt(R, V) {
        for (var B = -1, ae = R == null ? 0 : R.length; ++B < ae && V(R[B], B, R) !== !1; )
          ;
        return R;
      }
      function F0(R, V) {
        for (var B = R == null ? 0 : R.length; B-- && V(R[B], B, R) !== !1; )
          ;
        return R;
      }
      function _c(R, V) {
        for (var B = -1, ae = R == null ? 0 : R.length; ++B < ae; )
          if (!V(R[B], B, R))
            return !1;
        return !0;
      }
      function tr(R, V) {
        for (var B = -1, ae = R == null ? 0 : R.length, ge = 0, ke = []; ++B < ae; ) {
          var rt = R[B];
          V(rt, B, R) && (ke[ge++] = rt);
        }
        return ke;
      }
      function yo(R, V) {
        var B = R == null ? 0 : R.length;
        return !!B && Jr(R, V, 0) > -1;
      }
      function rs(R, V, B) {
        for (var ae = -1, ge = R == null ? 0 : R.length; ++ae < ge; )
          if (B(V, R[ae]))
            return !0;
        return !1;
      }
      function ze(R, V) {
        for (var B = -1, ae = R == null ? 0 : R.length, ge = Array(ae); ++B < ae; )
          ge[B] = V(R[B], B, R);
        return ge;
      }
      function nr(R, V) {
        for (var B = -1, ae = V.length, ge = R.length; ++B < ae; )
          R[ge + B] = V[B];
        return R;
      }
      function as(R, V, B, ae) {
        var ge = -1, ke = R == null ? 0 : R.length;
        for (ae && ke && (B = R[++ge]); ++ge < ke; )
          B = V(B, R[ge], ge, R);
        return B;
      }
      function U0(R, V, B, ae) {
        var ge = R == null ? 0 : R.length;
        for (ae && ge && (B = R[--ge]); ge--; )
          B = V(B, R[ge], ge, R);
        return B;
      }
      function os(R, V) {
        for (var B = -1, ae = R == null ? 0 : R.length; ++B < ae; )
          if (V(R[B], B, R))
            return !0;
        return !1;
      }
      var $0 = is("length");
      function V0(R) {
        return R.split("");
      }
      function H0(R) {
        return R.match(Si) || [];
      }
      function pc(R, V, B) {
        var ae;
        return B(R, function(ge, ke, rt) {
          if (V(ge, ke, rt))
            return ae = ke, !1;
        }), ae;
      }
      function To(R, V, B, ae) {
        for (var ge = R.length, ke = B + (ae ? 1 : -1); ae ? ke-- : ++ke < ge; )
          if (V(R[ke], ke, R))
            return ke;
        return -1;
      }
      function Jr(R, V, B) {
        return V === V ? e1(R, V, B) : To(R, mc, B);
      }
      function G0(R, V, B, ae) {
        for (var ge = B - 1, ke = R.length; ++ge < ke; )
          if (ae(R[ge], V))
            return ge;
        return -1;
      }
      function mc(R) {
        return R !== R;
      }
      function gc(R, V) {
        var B = R == null ? 0 : R.length;
        return B ? ls(R, V) / B : je;
      }
      function is(R) {
        return function(V) {
          return V == null ? a : V[R];
        };
      }
      function ss(R) {
        return function(V) {
          return R == null ? a : R[V];
        };
      }
      function fc(R, V, B, ae, ge) {
        return ge(R, function(ke, rt, Ve) {
          B = ae ? (ae = !1, ke) : V(B, ke, rt, Ve);
        }), B;
      }
      function Y0(R, V) {
        var B = R.length;
        for (R.sort(V); B--; )
          R[B] = R[B].value;
        return R;
      }
      function ls(R, V) {
        for (var B, ae = -1, ge = R.length; ++ae < ge; ) {
          var ke = V(R[ae]);
          ke !== a && (B = B === a ? ke : B + ke);
        }
        return B;
      }
      function cs(R, V) {
        for (var B = -1, ae = Array(R); ++B < R; )
          ae[B] = V(B);
        return ae;
      }
      function z0(R, V) {
        return ze(V, function(B) {
          return [B, R[B]];
        });
      }
      function hc(R) {
        return R && R.slice(0, Sc(R) + 1).replace(On, "");
      }
      function Ht(R) {
        return function(V) {
          return R(V);
        };
      }
      function us(R, V) {
        return ze(V, function(B) {
          return R[B];
        });
      }
      function ka(R, V) {
        return R.has(V);
      }
      function vc(R, V) {
        for (var B = -1, ae = R.length; ++B < ae && Jr(V, R[B], 0) > -1; )
          ;
        return B;
      }
      function Ec(R, V) {
        for (var B = R.length; B-- && Jr(V, R[B], 0) > -1; )
          ;
        return B;
      }
      function Z0(R, V) {
        for (var B = R.length, ae = 0; B--; )
          R[B] === V && ++ae;
        return ae;
      }
      var q0 = ss(F), W0 = ss(J);
      function j0(R) {
        return "\\" + Re[R];
      }
      function K0(R, V) {
        return R == null ? a : R[V];
      }
      function ea(R) {
        return Tl.test(R);
      }
      function Q0(R) {
        return wo.test(R);
      }
      function X0(R) {
        for (var V, B = []; !(V = R.next()).done; )
          B.push(V.value);
        return B;
      }
      function ds(R) {
        var V = -1, B = Array(R.size);
        return R.forEach(function(ae, ge) {
          B[++V] = [ge, ae];
        }), B;
      }
      function bc(R, V) {
        return function(B) {
          return R(V(B));
        };
      }
      function rr(R, V) {
        for (var B = -1, ae = R.length, ge = 0, ke = []; ++B < ae; ) {
          var rt = R[B];
          (rt === V || rt === f) && (R[B] = f, ke[ge++] = B);
        }
        return ke;
      }
      function Co(R) {
        var V = -1, B = Array(R.size);
        return R.forEach(function(ae) {
          B[++V] = ae;
        }), B;
      }
      function J0(R) {
        var V = -1, B = Array(R.size);
        return R.forEach(function(ae) {
          B[++V] = [ae, ae];
        }), B;
      }
      function e1(R, V, B) {
        for (var ae = B - 1, ge = R.length; ++ae < ge; )
          if (R[ae] === V)
            return ae;
        return -1;
      }
      function t1(R, V, B) {
        for (var ae = B + 1; ae--; )
          if (R[ae] === V)
            return ae;
        return ae;
      }
      function ta(R) {
        return ea(R) ? r1(R) : $0(R);
      }
      function ln(R) {
        return ea(R) ? a1(R) : V0(R);
      }
      function Sc(R) {
        for (var V = R.length; V-- && Qr.test(R.charAt(V)); )
          ;
        return V;
      }
      var n1 = ss(se);
      function r1(R) {
        for (var V = ao.lastIndex = 0; ao.test(R); )
          ++V;
        return V;
      }
      function a1(R) {
        return R.match(ao) || [];
      }
      function o1(R) {
        return R.match(yl) || [];
      }
      var i1 = function R(V) {
        V = V == null ? Ge : na.defaults(Ge.Object(), V, na.pick(Ge, Cl));
        var B = V.Array, ae = V.Date, ge = V.Error, ke = V.Function, rt = V.Math, Ve = V.Object, _s = V.RegExp, s1 = V.String, Kt = V.TypeError, xo = B.prototype, l1 = ke.prototype, ra = Ve.prototype, Ao = V["__core-js_shared__"], Ro = l1.toString, Ue = ra.hasOwnProperty, c1 = 0, wc = function() {
          var e = /[^.]+$/.exec(Ao && Ao.keys && Ao.keys.IE_PROTO || "");
          return e ? "Symbol(src)_1." + e : "";
        }(), Oo = ra.toString, u1 = Ro.call(Ve), d1 = Ge._, _1 = _s(
          "^" + Ro.call(Ue).replace(Sa, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
        ), Io = er ? V.Buffer : a, ar = V.Symbol, No = V.Uint8Array, yc = Io ? Io.allocUnsafe : a, Mo = bc(Ve.getPrototypeOf, Ve), Tc = Ve.create, Cc = ra.propertyIsEnumerable, Do = xo.splice, xc = ar ? ar.isConcatSpreadable : a, La = ar ? ar.iterator : a, br = ar ? ar.toStringTag : a, ko = function() {
          try {
            var e = Cr(Ve, "defineProperty");
            return e({}, "", {}), e;
          } catch {
          }
        }(), p1 = V.clearTimeout !== Ge.clearTimeout && V.clearTimeout, m1 = ae && ae.now !== Ge.Date.now && ae.now, g1 = V.setTimeout !== Ge.setTimeout && V.setTimeout, Lo = rt.ceil, Po = rt.floor, ps = Ve.getOwnPropertySymbols, f1 = Io ? Io.isBuffer : a, Ac = V.isFinite, h1 = xo.join, v1 = bc(Ve.keys, Ve), at = rt.max, gt = rt.min, E1 = ae.now, b1 = V.parseInt, Rc = rt.random, S1 = xo.reverse, ms = Cr(V, "DataView"), Pa = Cr(V, "Map"), gs = Cr(V, "Promise"), aa = Cr(V, "Set"), Ba = Cr(V, "WeakMap"), Fa = Cr(Ve, "create"), Bo = Ba && new Ba(), oa = {}, w1 = xr(ms), y1 = xr(Pa), T1 = xr(gs), C1 = xr(aa), x1 = xr(Ba), Fo = ar ? ar.prototype : a, Ua = Fo ? Fo.valueOf : a, Oc = Fo ? Fo.toString : a;
        function v(e) {
          if (Ke(e) && !fe(e) && !(e instanceof Ce)) {
            if (e instanceof Qt)
              return e;
            if (Ue.call(e, "__wrapped__"))
              return Iu(e);
          }
          return new Qt(e);
        }
        var ia = /* @__PURE__ */ function() {
          function e() {
          }
          return function(r) {
            if (!We(r))
              return {};
            if (Tc)
              return Tc(r);
            e.prototype = r;
            var o = new e();
            return e.prototype = a, o;
          };
        }();
        function Uo() {
        }
        function Qt(e, r) {
          this.__wrapped__ = e, this.__actions__ = [], this.__chain__ = !!r, this.__index__ = 0, this.__values__ = a;
        }
        v.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          escape: qt,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          evaluate: Pr,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          interpolate: Na,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          variable: "",
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          imports: {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            _: v
          }
        }, v.prototype = Uo.prototype, v.prototype.constructor = v, Qt.prototype = ia(Uo.prototype), Qt.prototype.constructor = Qt;
        function Ce(e) {
          this.__wrapped__ = e, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = Fe, this.__views__ = [];
        }
        function A1() {
          var e = new Ce(this.__wrapped__);
          return e.__actions__ = Mt(this.__actions__), e.__dir__ = this.__dir__, e.__filtered__ = this.__filtered__, e.__iteratees__ = Mt(this.__iteratees__), e.__takeCount__ = this.__takeCount__, e.__views__ = Mt(this.__views__), e;
        }
        function R1() {
          if (this.__filtered__) {
            var e = new Ce(this);
            e.__dir__ = -1, e.__filtered__ = !0;
          } else
            e = this.clone(), e.__dir__ *= -1;
          return e;
        }
        function O1() {
          var e = this.__wrapped__.value(), r = this.__dir__, o = fe(e), l = r < 0, m = o ? e.length : 0, S = V_(0, m, this.__views__), T = S.start, C = S.end, O = C - T, H = l ? C : T - 1, Y = this.__iteratees__, j = Y.length, te = 0, ie = gt(O, this.__takeCount__);
          if (!o || !l && m == O && ie == O)
            return Jc(e, this.__actions__);
          var de = [];
          e:
            for (; O-- && te < ie; ) {
              H += r;
              for (var Ee = -1, _e = e[H]; ++Ee < j; ) {
                var Te = Y[Ee], Ae = Te.iteratee, zt = Te.type, Tt = Ae(_e);
                if (zt == qe)
                  _e = Tt;
                else if (!Tt) {
                  if (zt == Le)
                    continue e;
                  break e;
                }
              }
              de[te++] = _e;
            }
          return de;
        }
        Ce.prototype = ia(Uo.prototype), Ce.prototype.constructor = Ce;
        function Sr(e) {
          var r = -1, o = e == null ? 0 : e.length;
          for (this.clear(); ++r < o; ) {
            var l = e[r];
            this.set(l[0], l[1]);
          }
        }
        function I1() {
          this.__data__ = Fa ? Fa(null) : {}, this.size = 0;
        }
        function N1(e) {
          var r = this.has(e) && delete this.__data__[e];
          return this.size -= r ? 1 : 0, r;
        }
        function M1(e) {
          var r = this.__data__;
          if (Fa) {
            var o = r[e];
            return o === E ? a : o;
          }
          return Ue.call(r, e) ? r[e] : a;
        }
        function D1(e) {
          var r = this.__data__;
          return Fa ? r[e] !== a : Ue.call(r, e);
        }
        function k1(e, r) {
          var o = this.__data__;
          return this.size += this.has(e) ? 0 : 1, o[e] = Fa && r === a ? E : r, this;
        }
        Sr.prototype.clear = I1, Sr.prototype.delete = N1, Sr.prototype.get = M1, Sr.prototype.has = D1, Sr.prototype.set = k1;
        function Un(e) {
          var r = -1, o = e == null ? 0 : e.length;
          for (this.clear(); ++r < o; ) {
            var l = e[r];
            this.set(l[0], l[1]);
          }
        }
        function L1() {
          this.__data__ = [], this.size = 0;
        }
        function P1(e) {
          var r = this.__data__, o = $o(r, e);
          if (o < 0)
            return !1;
          var l = r.length - 1;
          return o == l ? r.pop() : Do.call(r, o, 1), --this.size, !0;
        }
        function B1(e) {
          var r = this.__data__, o = $o(r, e);
          return o < 0 ? a : r[o][1];
        }
        function F1(e) {
          return $o(this.__data__, e) > -1;
        }
        function U1(e, r) {
          var o = this.__data__, l = $o(o, e);
          return l < 0 ? (++this.size, o.push([e, r])) : o[l][1] = r, this;
        }
        Un.prototype.clear = L1, Un.prototype.delete = P1, Un.prototype.get = B1, Un.prototype.has = F1, Un.prototype.set = U1;
        function $n(e) {
          var r = -1, o = e == null ? 0 : e.length;
          for (this.clear(); ++r < o; ) {
            var l = e[r];
            this.set(l[0], l[1]);
          }
        }
        function $1() {
          this.size = 0, this.__data__ = {
            hash: new Sr(),
            map: new (Pa || Un)(),
            string: new Sr()
          };
        }
        function V1(e) {
          var r = Xo(this, e).delete(e);
          return this.size -= r ? 1 : 0, r;
        }
        function H1(e) {
          return Xo(this, e).get(e);
        }
        function G1(e) {
          return Xo(this, e).has(e);
        }
        function Y1(e, r) {
          var o = Xo(this, e), l = o.size;
          return o.set(e, r), this.size += o.size == l ? 0 : 1, this;
        }
        $n.prototype.clear = $1, $n.prototype.delete = V1, $n.prototype.get = H1, $n.prototype.has = G1, $n.prototype.set = Y1;
        function wr(e) {
          var r = -1, o = e == null ? 0 : e.length;
          for (this.__data__ = new $n(); ++r < o; )
            this.add(e[r]);
        }
        function z1(e) {
          return this.__data__.set(e, E), this;
        }
        function Z1(e) {
          return this.__data__.has(e);
        }
        wr.prototype.add = wr.prototype.push = z1, wr.prototype.has = Z1;
        function cn(e) {
          var r = this.__data__ = new Un(e);
          this.size = r.size;
        }
        function q1() {
          this.__data__ = new Un(), this.size = 0;
        }
        function W1(e) {
          var r = this.__data__, o = r.delete(e);
          return this.size = r.size, o;
        }
        function j1(e) {
          return this.__data__.get(e);
        }
        function K1(e) {
          return this.__data__.has(e);
        }
        function Q1(e, r) {
          var o = this.__data__;
          if (o instanceof Un) {
            var l = o.__data__;
            if (!Pa || l.length < s - 1)
              return l.push([e, r]), this.size = ++o.size, this;
            o = this.__data__ = new $n(l);
          }
          return o.set(e, r), this.size = o.size, this;
        }
        cn.prototype.clear = q1, cn.prototype.delete = W1, cn.prototype.get = j1, cn.prototype.has = K1, cn.prototype.set = Q1;
        function Ic(e, r) {
          var o = fe(e), l = !o && Ar(e), m = !o && !l && cr(e), S = !o && !l && !m && ua(e), T = o || l || m || S, C = T ? cs(e.length, s1) : [], O = C.length;
          for (var H in e)
            (r || Ue.call(e, H)) && !(T && // Safari 9 has enumerable `arguments.length` in strict mode.
            (H == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            m && (H == "offset" || H == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            S && (H == "buffer" || H == "byteLength" || H == "byteOffset") || // Skip index properties.
            Yn(H, O))) && C.push(H);
          return C;
        }
        function Nc(e) {
          var r = e.length;
          return r ? e[xs(0, r - 1)] : a;
        }
        function X1(e, r) {
          return Jo(Mt(e), yr(r, 0, e.length));
        }
        function J1(e) {
          return Jo(Mt(e));
        }
        function fs(e, r, o) {
          (o !== a && !un(e[r], o) || o === a && !(r in e)) && Vn(e, r, o);
        }
        function $a(e, r, o) {
          var l = e[r];
          (!(Ue.call(e, r) && un(l, o)) || o === a && !(r in e)) && Vn(e, r, o);
        }
        function $o(e, r) {
          for (var o = e.length; o--; )
            if (un(e[o][0], r))
              return o;
          return -1;
        }
        function e_(e, r, o, l) {
          return or(e, function(m, S, T) {
            r(l, m, o(m), T);
          }), l;
        }
        function Mc(e, r) {
          return e && Sn(r, lt(r), e);
        }
        function t_(e, r) {
          return e && Sn(r, kt(r), e);
        }
        function Vn(e, r, o) {
          r == "__proto__" && ko ? ko(e, r, {
            configurable: !0,
            enumerable: !0,
            value: o,
            writable: !0
          }) : e[r] = o;
        }
        function hs(e, r) {
          for (var o = -1, l = r.length, m = B(l), S = e == null; ++o < l; )
            m[o] = S ? a : Qs(e, r[o]);
          return m;
        }
        function yr(e, r, o) {
          return e === e && (o !== a && (e = e <= o ? e : o), r !== a && (e = e >= r ? e : r)), e;
        }
        function Xt(e, r, o, l, m, S) {
          var T, C = r & b, O = r & w, H = r & x;
          if (o && (T = m ? o(e, l, m, S) : o(e)), T !== a)
            return T;
          if (!We(e))
            return e;
          var Y = fe(e);
          if (Y) {
            if (T = G_(e), !C)
              return Mt(e, T);
          } else {
            var j = ft(e), te = j == Cn || j == qr;
            if (cr(e))
              return nu(e, C);
            if (j == Ft || j == De || te && !m) {
              if (T = O || te ? {} : Su(e), !C)
                return O ? M_(e, t_(T, e)) : N_(e, Mc(T, e));
            } else {
              if (!$e[j])
                return m ? e : {};
              T = Y_(e, j, C);
            }
          }
          S || (S = new cn());
          var ie = S.get(e);
          if (ie)
            return ie;
          S.set(e, T), Ku(e) ? e.forEach(function(_e) {
            T.add(Xt(_e, r, o, _e, e, S));
          }) : Wu(e) && e.forEach(function(_e, Te) {
            T.set(Te, Xt(_e, r, o, Te, e, S));
          });
          var de = H ? O ? Bs : Ps : O ? kt : lt, Ee = Y ? a : de(e);
          return jt(Ee || e, function(_e, Te) {
            Ee && (Te = _e, _e = e[Te]), $a(T, Te, Xt(_e, r, o, Te, e, S));
          }), T;
        }
        function n_(e) {
          var r = lt(e);
          return function(o) {
            return Dc(o, e, r);
          };
        }
        function Dc(e, r, o) {
          var l = o.length;
          if (e == null)
            return !l;
          for (e = Ve(e); l--; ) {
            var m = o[l], S = r[m], T = e[m];
            if (T === a && !(m in e) || !S(T))
              return !1;
          }
          return !0;
        }
        function kc(e, r, o) {
          if (typeof e != "function")
            throw new Kt(p);
          return qa(function() {
            e.apply(a, o);
          }, r);
        }
        function Va(e, r, o, l) {
          var m = -1, S = yo, T = !0, C = e.length, O = [], H = r.length;
          if (!C)
            return O;
          o && (r = ze(r, Ht(o))), l ? (S = rs, T = !1) : r.length >= s && (S = ka, T = !1, r = new wr(r));
          e:
            for (; ++m < C; ) {
              var Y = e[m], j = o == null ? Y : o(Y);
              if (Y = l || Y !== 0 ? Y : 0, T && j === j) {
                for (var te = H; te--; )
                  if (r[te] === j)
                    continue e;
                O.push(Y);
              } else S(r, j, l) || O.push(Y);
            }
          return O;
        }
        var or = su(bn), Lc = su(Es, !0);
        function r_(e, r) {
          var o = !0;
          return or(e, function(l, m, S) {
            return o = !!r(l, m, S), o;
          }), o;
        }
        function Vo(e, r, o) {
          for (var l = -1, m = e.length; ++l < m; ) {
            var S = e[l], T = r(S);
            if (T != null && (C === a ? T === T && !Yt(T) : o(T, C)))
              var C = T, O = S;
          }
          return O;
        }
        function a_(e, r, o, l) {
          var m = e.length;
          for (o = he(o), o < 0 && (o = -o > m ? 0 : m + o), l = l === a || l > m ? m : he(l), l < 0 && (l += m), l = o > l ? 0 : Xu(l); o < l; )
            e[o++] = r;
          return e;
        }
        function Pc(e, r) {
          var o = [];
          return or(e, function(l, m, S) {
            r(l, m, S) && o.push(l);
          }), o;
        }
        function dt(e, r, o, l, m) {
          var S = -1, T = e.length;
          for (o || (o = Z_), m || (m = []); ++S < T; ) {
            var C = e[S];
            r > 0 && o(C) ? r > 1 ? dt(C, r - 1, o, l, m) : nr(m, C) : l || (m[m.length] = C);
          }
          return m;
        }
        var vs = lu(), Bc = lu(!0);
        function bn(e, r) {
          return e && vs(e, r, lt);
        }
        function Es(e, r) {
          return e && Bc(e, r, lt);
        }
        function Ho(e, r) {
          return tr(r, function(o) {
            return zn(e[o]);
          });
        }
        function Tr(e, r) {
          r = sr(r, e);
          for (var o = 0, l = r.length; e != null && o < l; )
            e = e[wn(r[o++])];
          return o && o == l ? e : a;
        }
        function Fc(e, r, o) {
          var l = r(e);
          return fe(e) ? l : nr(l, o(e));
        }
        function wt(e) {
          return e == null ? e === a ? Ra : go : br && br in Ve(e) ? $_(e) : J_(e);
        }
        function bs(e, r) {
          return e > r;
        }
        function o_(e, r) {
          return e != null && Ue.call(e, r);
        }
        function i_(e, r) {
          return e != null && r in Ve(e);
        }
        function s_(e, r, o) {
          return e >= gt(r, o) && e < at(r, o);
        }
        function Ss(e, r, o) {
          for (var l = o ? rs : yo, m = e[0].length, S = e.length, T = S, C = B(S), O = 1 / 0, H = []; T--; ) {
            var Y = e[T];
            T && r && (Y = ze(Y, Ht(r))), O = gt(Y.length, O), C[T] = !o && (r || m >= 120 && Y.length >= 120) ? new wr(T && Y) : a;
          }
          Y = e[0];
          var j = -1, te = C[0];
          e:
            for (; ++j < m && H.length < O; ) {
              var ie = Y[j], de = r ? r(ie) : ie;
              if (ie = o || ie !== 0 ? ie : 0, !(te ? ka(te, de) : l(H, de, o))) {
                for (T = S; --T; ) {
                  var Ee = C[T];
                  if (!(Ee ? ka(Ee, de) : l(e[T], de, o)))
                    continue e;
                }
                te && te.push(de), H.push(ie);
              }
            }
          return H;
        }
        function l_(e, r, o, l) {
          return bn(e, function(m, S, T) {
            r(l, o(m), S, T);
          }), l;
        }
        function Ha(e, r, o) {
          r = sr(r, e), e = Cu(e, r);
          var l = e == null ? e : e[wn(en(r))];
          return l == null ? a : vt(l, e, o);
        }
        function Uc(e) {
          return Ke(e) && wt(e) == De;
        }
        function c_(e) {
          return Ke(e) && wt(e) == Bn;
        }
        function u_(e) {
          return Ke(e) && wt(e) == an;
        }
        function Ga(e, r, o, l, m) {
          return e === r ? !0 : e == null || r == null || !Ke(e) && !Ke(r) ? e !== e && r !== r : d_(e, r, o, l, Ga, m);
        }
        function d_(e, r, o, l, m, S) {
          var T = fe(e), C = fe(r), O = T ? gn : ft(e), H = C ? gn : ft(r);
          O = O == De ? Ft : O, H = H == De ? Ft : H;
          var Y = O == Ft, j = H == Ft, te = O == H;
          if (te && cr(e)) {
            if (!cr(r))
              return !1;
            T = !0, Y = !1;
          }
          if (te && !Y)
            return S || (S = new cn()), T || ua(e) ? vu(e, r, o, l, m, S) : F_(e, r, O, o, l, m, S);
          if (!(o & A)) {
            var ie = Y && Ue.call(e, "__wrapped__"), de = j && Ue.call(r, "__wrapped__");
            if (ie || de) {
              var Ee = ie ? e.value() : e, _e = de ? r.value() : r;
              return S || (S = new cn()), m(Ee, _e, o, l, S);
            }
          }
          return te ? (S || (S = new cn()), U_(e, r, o, l, m, S)) : !1;
        }
        function __(e) {
          return Ke(e) && ft(e) == pt;
        }
        function ws(e, r, o, l) {
          var m = o.length, S = m, T = !l;
          if (e == null)
            return !S;
          for (e = Ve(e); m--; ) {
            var C = o[m];
            if (T && C[2] ? C[1] !== e[C[0]] : !(C[0] in e))
              return !1;
          }
          for (; ++m < S; ) {
            C = o[m];
            var O = C[0], H = e[O], Y = C[1];
            if (T && C[2]) {
              if (H === a && !(O in e))
                return !1;
            } else {
              var j = new cn();
              if (l)
                var te = l(H, Y, O, e, r, j);
              if (!(te === a ? Ga(Y, H, A | D, l, j) : te))
                return !1;
            }
          }
          return !0;
        }
        function $c(e) {
          if (!We(e) || W_(e))
            return !1;
          var r = zn(e) ? _1 : Pe;
          return r.test(xr(e));
        }
        function p_(e) {
          return Ke(e) && wt(e) == dr;
        }
        function m_(e) {
          return Ke(e) && ft(e) == Ut;
        }
        function g_(e) {
          return Ke(e) && oi(e.length) && !!He[wt(e)];
        }
        function Vc(e) {
          return typeof e == "function" ? e : e == null ? Lt : typeof e == "object" ? fe(e) ? Yc(e[0], e[1]) : Gc(e) : cd(e);
        }
        function ys(e) {
          if (!Za(e))
            return v1(e);
          var r = [];
          for (var o in Ve(e))
            Ue.call(e, o) && o != "constructor" && r.push(o);
          return r;
        }
        function f_(e) {
          if (!We(e))
            return X_(e);
          var r = Za(e), o = [];
          for (var l in e)
            l == "constructor" && (r || !Ue.call(e, l)) || o.push(l);
          return o;
        }
        function Ts(e, r) {
          return e < r;
        }
        function Hc(e, r) {
          var o = -1, l = Dt(e) ? B(e.length) : [];
          return or(e, function(m, S, T) {
            l[++o] = r(m, S, T);
          }), l;
        }
        function Gc(e) {
          var r = Us(e);
          return r.length == 1 && r[0][2] ? yu(r[0][0], r[0][1]) : function(o) {
            return o === e || ws(o, e, r);
          };
        }
        function Yc(e, r) {
          return Vs(e) && wu(r) ? yu(wn(e), r) : function(o) {
            var l = Qs(o, e);
            return l === a && l === r ? Xs(o, e) : Ga(r, l, A | D);
          };
        }
        function Go(e, r, o, l, m) {
          e !== r && vs(r, function(S, T) {
            if (m || (m = new cn()), We(S))
              h_(e, r, T, o, Go, l, m);
            else {
              var C = l ? l(Gs(e, T), S, T + "", e, r, m) : a;
              C === a && (C = S), fs(e, T, C);
            }
          }, kt);
        }
        function h_(e, r, o, l, m, S, T) {
          var C = Gs(e, o), O = Gs(r, o), H = T.get(O);
          if (H) {
            fs(e, o, H);
            return;
          }
          var Y = S ? S(C, O, o + "", e, r, T) : a, j = Y === a;
          if (j) {
            var te = fe(O), ie = !te && cr(O), de = !te && !ie && ua(O);
            Y = O, te || ie || de ? fe(C) ? Y = C : Je(C) ? Y = Mt(C) : ie ? (j = !1, Y = nu(O, !0)) : de ? (j = !1, Y = ru(O, !0)) : Y = [] : Wa(O) || Ar(O) ? (Y = C, Ar(C) ? Y = Ju(C) : (!We(C) || zn(C)) && (Y = Su(O))) : j = !1;
          }
          j && (T.set(O, Y), m(Y, O, l, S, T), T.delete(O)), fs(e, o, Y);
        }
        function zc(e, r) {
          var o = e.length;
          if (o)
            return r += r < 0 ? o : 0, Yn(r, o) ? e[r] : a;
        }
        function Zc(e, r, o) {
          r.length ? r = ze(r, function(S) {
            return fe(S) ? function(T) {
              return Tr(T, S.length === 1 ? S[0] : S);
            } : S;
          }) : r = [Lt];
          var l = -1;
          r = ze(r, Ht(ue()));
          var m = Hc(e, function(S, T, C) {
            var O = ze(r, function(H) {
              return H(S);
            });
            return { criteria: O, index: ++l, value: S };
          });
          return Y0(m, function(S, T) {
            return I_(S, T, o);
          });
        }
        function v_(e, r) {
          return qc(e, r, function(o, l) {
            return Xs(e, l);
          });
        }
        function qc(e, r, o) {
          for (var l = -1, m = r.length, S = {}; ++l < m; ) {
            var T = r[l], C = Tr(e, T);
            o(C, T) && Ya(S, sr(T, e), C);
          }
          return S;
        }
        function E_(e) {
          return function(r) {
            return Tr(r, e);
          };
        }
        function Cs(e, r, o, l) {
          var m = l ? G0 : Jr, S = -1, T = r.length, C = e;
          for (e === r && (r = Mt(r)), o && (C = ze(e, Ht(o))); ++S < T; )
            for (var O = 0, H = r[S], Y = o ? o(H) : H; (O = m(C, Y, O, l)) > -1; )
              C !== e && Do.call(C, O, 1), Do.call(e, O, 1);
          return e;
        }
        function Wc(e, r) {
          for (var o = e ? r.length : 0, l = o - 1; o--; ) {
            var m = r[o];
            if (o == l || m !== S) {
              var S = m;
              Yn(m) ? Do.call(e, m, 1) : Os(e, m);
            }
          }
          return e;
        }
        function xs(e, r) {
          return e + Po(Rc() * (r - e + 1));
        }
        function b_(e, r, o, l) {
          for (var m = -1, S = at(Lo((r - e) / (o || 1)), 0), T = B(S); S--; )
            T[l ? S : ++m] = e, e += o;
          return T;
        }
        function As(e, r) {
          var o = "";
          if (!e || r < 1 || r > st)
            return o;
          do
            r % 2 && (o += e), r = Po(r / 2), r && (e += e);
          while (r);
          return o;
        }
        function be(e, r) {
          return Ys(Tu(e, r, Lt), e + "");
        }
        function S_(e) {
          return Nc(da(e));
        }
        function w_(e, r) {
          var o = da(e);
          return Jo(o, yr(r, 0, o.length));
        }
        function Ya(e, r, o, l) {
          if (!We(e))
            return e;
          r = sr(r, e);
          for (var m = -1, S = r.length, T = S - 1, C = e; C != null && ++m < S; ) {
            var O = wn(r[m]), H = o;
            if (O === "__proto__" || O === "constructor" || O === "prototype")
              return e;
            if (m != T) {
              var Y = C[O];
              H = l ? l(Y, O, C) : a, H === a && (H = We(Y) ? Y : Yn(r[m + 1]) ? [] : {});
            }
            $a(C, O, H), C = C[O];
          }
          return e;
        }
        var jc = Bo ? function(e, r) {
          return Bo.set(e, r), e;
        } : Lt, y_ = ko ? function(e, r) {
          return ko(e, "toString", {
            configurable: !0,
            enumerable: !1,
            value: el(r),
            writable: !0
          });
        } : Lt;
        function T_(e) {
          return Jo(da(e));
        }
        function Jt(e, r, o) {
          var l = -1, m = e.length;
          r < 0 && (r = -r > m ? 0 : m + r), o = o > m ? m : o, o < 0 && (o += m), m = r > o ? 0 : o - r >>> 0, r >>>= 0;
          for (var S = B(m); ++l < m; )
            S[l] = e[l + r];
          return S;
        }
        function C_(e, r) {
          var o;
          return or(e, function(l, m, S) {
            return o = r(l, m, S), !o;
          }), !!o;
        }
        function Yo(e, r, o) {
          var l = 0, m = e == null ? l : e.length;
          if (typeof r == "number" && r === r && m <= Rt) {
            for (; l < m; ) {
              var S = l + m >>> 1, T = e[S];
              T !== null && !Yt(T) && (o ? T <= r : T < r) ? l = S + 1 : m = S;
            }
            return m;
          }
          return Rs(e, r, Lt, o);
        }
        function Rs(e, r, o, l) {
          var m = 0, S = e == null ? 0 : e.length;
          if (S === 0)
            return 0;
          r = o(r);
          for (var T = r !== r, C = r === null, O = Yt(r), H = r === a; m < S; ) {
            var Y = Po((m + S) / 2), j = o(e[Y]), te = j !== a, ie = j === null, de = j === j, Ee = Yt(j);
            if (T)
              var _e = l || de;
            else H ? _e = de && (l || te) : C ? _e = de && te && (l || !ie) : O ? _e = de && te && !ie && (l || !Ee) : ie || Ee ? _e = !1 : _e = l ? j <= r : j < r;
            _e ? m = Y + 1 : S = Y;
          }
          return gt(S, Pn);
        }
        function Kc(e, r) {
          for (var o = -1, l = e.length, m = 0, S = []; ++o < l; ) {
            var T = e[o], C = r ? r(T) : T;
            if (!o || !un(C, O)) {
              var O = C;
              S[m++] = T === 0 ? 0 : T;
            }
          }
          return S;
        }
        function Qc(e) {
          return typeof e == "number" ? e : Yt(e) ? je : +e;
        }
        function Gt(e) {
          if (typeof e == "string")
            return e;
          if (fe(e))
            return ze(e, Gt) + "";
          if (Yt(e))
            return Oc ? Oc.call(e) : "";
          var r = e + "";
          return r == "0" && 1 / e == -ot ? "-0" : r;
        }
        function ir(e, r, o) {
          var l = -1, m = yo, S = e.length, T = !0, C = [], O = C;
          if (o)
            T = !1, m = rs;
          else if (S >= s) {
            var H = r ? null : P_(e);
            if (H)
              return Co(H);
            T = !1, m = ka, O = new wr();
          } else
            O = r ? [] : C;
          e:
            for (; ++l < S; ) {
              var Y = e[l], j = r ? r(Y) : Y;
              if (Y = o || Y !== 0 ? Y : 0, T && j === j) {
                for (var te = O.length; te--; )
                  if (O[te] === j)
                    continue e;
                r && O.push(j), C.push(Y);
              } else m(O, j, o) || (O !== C && O.push(j), C.push(Y));
            }
          return C;
        }
        function Os(e, r) {
          return r = sr(r, e), e = Cu(e, r), e == null || delete e[wn(en(r))];
        }
        function Xc(e, r, o, l) {
          return Ya(e, r, o(Tr(e, r)), l);
        }
        function zo(e, r, o, l) {
          for (var m = e.length, S = l ? m : -1; (l ? S-- : ++S < m) && r(e[S], S, e); )
            ;
          return o ? Jt(e, l ? 0 : S, l ? S + 1 : m) : Jt(e, l ? S + 1 : 0, l ? m : S);
        }
        function Jc(e, r) {
          var o = e;
          return o instanceof Ce && (o = o.value()), as(r, function(l, m) {
            return m.func.apply(m.thisArg, nr([l], m.args));
          }, o);
        }
        function Is(e, r, o) {
          var l = e.length;
          if (l < 2)
            return l ? ir(e[0]) : [];
          for (var m = -1, S = B(l); ++m < l; )
            for (var T = e[m], C = -1; ++C < l; )
              C != m && (S[m] = Va(S[m] || T, e[C], r, o));
          return ir(dt(S, 1), r, o);
        }
        function eu(e, r, o) {
          for (var l = -1, m = e.length, S = r.length, T = {}; ++l < m; ) {
            var C = l < S ? r[l] : a;
            o(T, e[l], C);
          }
          return T;
        }
        function Ns(e) {
          return Je(e) ? e : [];
        }
        function Ms(e) {
          return typeof e == "function" ? e : Lt;
        }
        function sr(e, r) {
          return fe(e) ? e : Vs(e, r) ? [e] : Ou(Be(e));
        }
        var x_ = be;
        function lr(e, r, o) {
          var l = e.length;
          return o = o === a ? l : o, !r && o >= l ? e : Jt(e, r, o);
        }
        var tu = p1 || function(e) {
          return Ge.clearTimeout(e);
        };
        function nu(e, r) {
          if (r)
            return e.slice();
          var o = e.length, l = yc ? yc(o) : new e.constructor(o);
          return e.copy(l), l;
        }
        function Ds(e) {
          var r = new e.constructor(e.byteLength);
          return new No(r).set(new No(e)), r;
        }
        function A_(e, r) {
          var o = r ? Ds(e.buffer) : e.buffer;
          return new e.constructor(o, e.byteOffset, e.byteLength);
        }
        function R_(e) {
          var r = new e.constructor(e.source, jn.exec(e));
          return r.lastIndex = e.lastIndex, r;
        }
        function O_(e) {
          return Ua ? Ve(Ua.call(e)) : {};
        }
        function ru(e, r) {
          var o = r ? Ds(e.buffer) : e.buffer;
          return new e.constructor(o, e.byteOffset, e.length);
        }
        function au(e, r) {
          if (e !== r) {
            var o = e !== a, l = e === null, m = e === e, S = Yt(e), T = r !== a, C = r === null, O = r === r, H = Yt(r);
            if (!C && !H && !S && e > r || S && T && O && !C && !H || l && T && O || !o && O || !m)
              return 1;
            if (!l && !S && !H && e < r || H && o && m && !l && !S || C && o && m || !T && m || !O)
              return -1;
          }
          return 0;
        }
        function I_(e, r, o) {
          for (var l = -1, m = e.criteria, S = r.criteria, T = m.length, C = o.length; ++l < T; ) {
            var O = au(m[l], S[l]);
            if (O) {
              if (l >= C)
                return O;
              var H = o[l];
              return O * (H == "desc" ? -1 : 1);
            }
          }
          return e.index - r.index;
        }
        function ou(e, r, o, l) {
          for (var m = -1, S = e.length, T = o.length, C = -1, O = r.length, H = at(S - T, 0), Y = B(O + H), j = !l; ++C < O; )
            Y[C] = r[C];
          for (; ++m < T; )
            (j || m < S) && (Y[o[m]] = e[m]);
          for (; H--; )
            Y[C++] = e[m++];
          return Y;
        }
        function iu(e, r, o, l) {
          for (var m = -1, S = e.length, T = -1, C = o.length, O = -1, H = r.length, Y = at(S - C, 0), j = B(Y + H), te = !l; ++m < Y; )
            j[m] = e[m];
          for (var ie = m; ++O < H; )
            j[ie + O] = r[O];
          for (; ++T < C; )
            (te || m < S) && (j[ie + o[T]] = e[m++]);
          return j;
        }
        function Mt(e, r) {
          var o = -1, l = e.length;
          for (r || (r = B(l)); ++o < l; )
            r[o] = e[o];
          return r;
        }
        function Sn(e, r, o, l) {
          var m = !o;
          o || (o = {});
          for (var S = -1, T = r.length; ++S < T; ) {
            var C = r[S], O = l ? l(o[C], e[C], C, o, e) : a;
            O === a && (O = e[C]), m ? Vn(o, C, O) : $a(o, C, O);
          }
          return o;
        }
        function N_(e, r) {
          return Sn(e, $s(e), r);
        }
        function M_(e, r) {
          return Sn(e, Eu(e), r);
        }
        function Zo(e, r) {
          return function(o, l) {
            var m = fe(o) ? B0 : e_, S = r ? r() : {};
            return m(o, e, ue(l, 2), S);
          };
        }
        function sa(e) {
          return be(function(r, o) {
            var l = -1, m = o.length, S = m > 1 ? o[m - 1] : a, T = m > 2 ? o[2] : a;
            for (S = e.length > 3 && typeof S == "function" ? (m--, S) : a, T && yt(o[0], o[1], T) && (S = m < 3 ? a : S, m = 1), r = Ve(r); ++l < m; ) {
              var C = o[l];
              C && e(r, C, l, S);
            }
            return r;
          });
        }
        function su(e, r) {
          return function(o, l) {
            if (o == null)
              return o;
            if (!Dt(o))
              return e(o, l);
            for (var m = o.length, S = r ? m : -1, T = Ve(o); (r ? S-- : ++S < m) && l(T[S], S, T) !== !1; )
              ;
            return o;
          };
        }
        function lu(e) {
          return function(r, o, l) {
            for (var m = -1, S = Ve(r), T = l(r), C = T.length; C--; ) {
              var O = T[e ? C : ++m];
              if (o(S[O], O, S) === !1)
                break;
            }
            return r;
          };
        }
        function D_(e, r, o) {
          var l = r & L, m = za(e);
          function S() {
            var T = this && this !== Ge && this instanceof S ? m : e;
            return T.apply(l ? o : this, arguments);
          }
          return S;
        }
        function cu(e) {
          return function(r) {
            r = Be(r);
            var o = ea(r) ? ln(r) : a, l = o ? o[0] : r.charAt(0), m = o ? lr(o, 1).join("") : r.slice(1);
            return l[e]() + m;
          };
        }
        function la(e) {
          return function(r) {
            return as(sd(id(r).replace(ns, "")), e, "");
          };
        }
        function za(e) {
          return function() {
            var r = arguments;
            switch (r.length) {
              case 0:
                return new e();
              case 1:
                return new e(r[0]);
              case 2:
                return new e(r[0], r[1]);
              case 3:
                return new e(r[0], r[1], r[2]);
              case 4:
                return new e(r[0], r[1], r[2], r[3]);
              case 5:
                return new e(r[0], r[1], r[2], r[3], r[4]);
              case 6:
                return new e(r[0], r[1], r[2], r[3], r[4], r[5]);
              case 7:
                return new e(r[0], r[1], r[2], r[3], r[4], r[5], r[6]);
            }
            var o = ia(e.prototype), l = e.apply(o, r);
            return We(l) ? l : o;
          };
        }
        function k_(e, r, o) {
          var l = za(e);
          function m() {
            for (var S = arguments.length, T = B(S), C = S, O = ca(m); C--; )
              T[C] = arguments[C];
            var H = S < 3 && T[0] !== O && T[S - 1] !== O ? [] : rr(T, O);
            if (S -= H.length, S < o)
              return mu(
                e,
                r,
                qo,
                m.placeholder,
                a,
                T,
                H,
                a,
                a,
                o - S
              );
            var Y = this && this !== Ge && this instanceof m ? l : e;
            return vt(Y, this, T);
          }
          return m;
        }
        function uu(e) {
          return function(r, o, l) {
            var m = Ve(r);
            if (!Dt(r)) {
              var S = ue(o, 3);
              r = lt(r), o = function(C) {
                return S(m[C], C, m);
              };
            }
            var T = e(r, o, l);
            return T > -1 ? m[S ? r[T] : T] : a;
          };
        }
        function du(e) {
          return Gn(function(r) {
            var o = r.length, l = o, m = Qt.prototype.thru;
            for (e && r.reverse(); l--; ) {
              var S = r[l];
              if (typeof S != "function")
                throw new Kt(p);
              if (m && !T && Qo(S) == "wrapper")
                var T = new Qt([], !0);
            }
            for (l = T ? l : o; ++l < o; ) {
              S = r[l];
              var C = Qo(S), O = C == "wrapper" ? Fs(S) : a;
              O && Hs(O[0]) && O[1] == (ee | P | U | X) && !O[4].length && O[9] == 1 ? T = T[Qo(O[0])].apply(T, O[3]) : T = S.length == 1 && Hs(S) ? T[C]() : T.thru(S);
            }
            return function() {
              var H = arguments, Y = H[0];
              if (T && H.length == 1 && fe(Y))
                return T.plant(Y).value();
              for (var j = 0, te = o ? r[j].apply(this, H) : Y; ++j < o; )
                te = r[j].call(this, te);
              return te;
            };
          });
        }
        function qo(e, r, o, l, m, S, T, C, O, H) {
          var Y = r & ee, j = r & L, te = r & $, ie = r & (P | k), de = r & re, Ee = te ? a : za(e);
          function _e() {
            for (var Te = arguments.length, Ae = B(Te), zt = Te; zt--; )
              Ae[zt] = arguments[zt];
            if (ie)
              var Tt = ca(_e), Zt = Z0(Ae, Tt);
            if (l && (Ae = ou(Ae, l, m, ie)), S && (Ae = iu(Ae, S, T, ie)), Te -= Zt, ie && Te < H) {
              var et = rr(Ae, Tt);
              return mu(
                e,
                r,
                qo,
                _e.placeholder,
                o,
                Ae,
                et,
                C,
                O,
                H - Te
              );
            }
            var dn = j ? o : this, qn = te ? dn[e] : e;
            return Te = Ae.length, C ? Ae = ep(Ae, C) : de && Te > 1 && Ae.reverse(), Y && O < Te && (Ae.length = O), this && this !== Ge && this instanceof _e && (qn = Ee || za(qn)), qn.apply(dn, Ae);
          }
          return _e;
        }
        function _u(e, r) {
          return function(o, l) {
            return l_(o, e, r(l), {});
          };
        }
        function Wo(e, r) {
          return function(o, l) {
            var m;
            if (o === a && l === a)
              return r;
            if (o !== a && (m = o), l !== a) {
              if (m === a)
                return l;
              typeof o == "string" || typeof l == "string" ? (o = Gt(o), l = Gt(l)) : (o = Qc(o), l = Qc(l)), m = e(o, l);
            }
            return m;
          };
        }
        function ks(e) {
          return Gn(function(r) {
            return r = ze(r, Ht(ue())), be(function(o) {
              var l = this;
              return e(r, function(m) {
                return vt(m, l, o);
              });
            });
          });
        }
        function jo(e, r) {
          r = r === a ? " " : Gt(r);
          var o = r.length;
          if (o < 2)
            return o ? As(r, e) : r;
          var l = As(r, Lo(e / ta(r)));
          return ea(r) ? lr(ln(l), 0, e).join("") : l.slice(0, e);
        }
        function L_(e, r, o, l) {
          var m = r & L, S = za(e);
          function T() {
            for (var C = -1, O = arguments.length, H = -1, Y = l.length, j = B(Y + O), te = this && this !== Ge && this instanceof T ? S : e; ++H < Y; )
              j[H] = l[H];
            for (; O--; )
              j[H++] = arguments[++C];
            return vt(te, m ? o : this, j);
          }
          return T;
        }
        function pu(e) {
          return function(r, o, l) {
            return l && typeof l != "number" && yt(r, o, l) && (o = l = a), r = Zn(r), o === a ? (o = r, r = 0) : o = Zn(o), l = l === a ? r < o ? 1 : -1 : Zn(l), b_(r, o, l, e);
          };
        }
        function Ko(e) {
          return function(r, o) {
            return typeof r == "string" && typeof o == "string" || (r = tn(r), o = tn(o)), e(r, o);
          };
        }
        function mu(e, r, o, l, m, S, T, C, O, H) {
          var Y = r & P, j = Y ? T : a, te = Y ? a : T, ie = Y ? S : a, de = Y ? a : S;
          r |= Y ? U : Z, r &= ~(Y ? Z : U), r & q || (r &= -4);
          var Ee = [
            e,
            r,
            m,
            ie,
            j,
            de,
            te,
            C,
            O,
            H
          ], _e = o.apply(a, Ee);
          return Hs(e) && xu(_e, Ee), _e.placeholder = l, Au(_e, e, r);
        }
        function Ls(e) {
          var r = rt[e];
          return function(o, l) {
            if (o = tn(o), l = l == null ? 0 : gt(he(l), 292), l && Ac(o)) {
              var m = (Be(o) + "e").split("e"), S = r(m[0] + "e" + (+m[1] + l));
              return m = (Be(S) + "e").split("e"), +(m[0] + "e" + (+m[1] - l));
            }
            return r(o);
          };
        }
        var P_ = aa && 1 / Co(new aa([, -0]))[1] == ot ? function(e) {
          return new aa(e);
        } : rl;
        function gu(e) {
          return function(r) {
            var o = ft(r);
            return o == pt ? ds(r) : o == Ut ? J0(r) : z0(r, e(r));
          };
        }
        function Hn(e, r, o, l, m, S, T, C) {
          var O = r & $;
          if (!O && typeof e != "function")
            throw new Kt(p);
          var H = l ? l.length : 0;
          if (H || (r &= -97, l = m = a), T = T === a ? T : at(he(T), 0), C = C === a ? C : he(C), H -= m ? m.length : 0, r & Z) {
            var Y = l, j = m;
            l = m = a;
          }
          var te = O ? a : Fs(e), ie = [
            e,
            r,
            o,
            l,
            m,
            Y,
            j,
            S,
            T,
            C
          ];
          if (te && Q_(ie, te), e = ie[0], r = ie[1], o = ie[2], l = ie[3], m = ie[4], C = ie[9] = ie[9] === a ? O ? 0 : e.length : at(ie[9] - H, 0), !C && r & (P | k) && (r &= -25), !r || r == L)
            var de = D_(e, r, o);
          else r == P || r == k ? de = k_(e, r, C) : (r == U || r == (L | U)) && !m.length ? de = L_(e, r, o, l) : de = qo.apply(a, ie);
          var Ee = te ? jc : xu;
          return Au(Ee(de, ie), e, r);
        }
        function fu(e, r, o, l) {
          return e === a || un(e, ra[o]) && !Ue.call(l, o) ? r : e;
        }
        function hu(e, r, o, l, m, S) {
          return We(e) && We(r) && (S.set(r, e), Go(e, r, a, hu, S), S.delete(r)), e;
        }
        function B_(e) {
          return Wa(e) ? a : e;
        }
        function vu(e, r, o, l, m, S) {
          var T = o & A, C = e.length, O = r.length;
          if (C != O && !(T && O > C))
            return !1;
          var H = S.get(e), Y = S.get(r);
          if (H && Y)
            return H == r && Y == e;
          var j = -1, te = !0, ie = o & D ? new wr() : a;
          for (S.set(e, r), S.set(r, e); ++j < C; ) {
            var de = e[j], Ee = r[j];
            if (l)
              var _e = T ? l(Ee, de, j, r, e, S) : l(de, Ee, j, e, r, S);
            if (_e !== a) {
              if (_e)
                continue;
              te = !1;
              break;
            }
            if (ie) {
              if (!os(r, function(Te, Ae) {
                if (!ka(ie, Ae) && (de === Te || m(de, Te, o, l, S)))
                  return ie.push(Ae);
              })) {
                te = !1;
                break;
              }
            } else if (!(de === Ee || m(de, Ee, o, l, S))) {
              te = !1;
              break;
            }
          }
          return S.delete(e), S.delete(r), te;
        }
        function F_(e, r, o, l, m, S, T) {
          switch (o) {
            case An:
              if (e.byteLength != r.byteLength || e.byteOffset != r.byteOffset)
                return !1;
              e = e.buffer, r = r.buffer;
            case Bn:
              return !(e.byteLength != r.byteLength || !S(new No(e), new No(r)));
            case mt:
            case an:
            case Xn:
              return un(+e, +r);
            case pr:
              return e.name == r.name && e.message == r.message;
            case dr:
            case mr:
              return e == r + "";
            case pt:
              var C = ds;
            case Ut:
              var O = l & A;
              if (C || (C = Co), e.size != r.size && !O)
                return !1;
              var H = T.get(e);
              if (H)
                return H == r;
              l |= D, T.set(e, r);
              var Y = vu(C(e), C(r), l, m, S, T);
              return T.delete(e), Y;
            case gr:
              if (Ua)
                return Ua.call(e) == Ua.call(r);
          }
          return !1;
        }
        function U_(e, r, o, l, m, S) {
          var T = o & A, C = Ps(e), O = C.length, H = Ps(r), Y = H.length;
          if (O != Y && !T)
            return !1;
          for (var j = O; j--; ) {
            var te = C[j];
            if (!(T ? te in r : Ue.call(r, te)))
              return !1;
          }
          var ie = S.get(e), de = S.get(r);
          if (ie && de)
            return ie == r && de == e;
          var Ee = !0;
          S.set(e, r), S.set(r, e);
          for (var _e = T; ++j < O; ) {
            te = C[j];
            var Te = e[te], Ae = r[te];
            if (l)
              var zt = T ? l(Ae, Te, te, r, e, S) : l(Te, Ae, te, e, r, S);
            if (!(zt === a ? Te === Ae || m(Te, Ae, o, l, S) : zt)) {
              Ee = !1;
              break;
            }
            _e || (_e = te == "constructor");
          }
          if (Ee && !_e) {
            var Tt = e.constructor, Zt = r.constructor;
            Tt != Zt && "constructor" in e && "constructor" in r && !(typeof Tt == "function" && Tt instanceof Tt && typeof Zt == "function" && Zt instanceof Zt) && (Ee = !1);
          }
          return S.delete(e), S.delete(r), Ee;
        }
        function Gn(e) {
          return Ys(Tu(e, a, Du), e + "");
        }
        function Ps(e) {
          return Fc(e, lt, $s);
        }
        function Bs(e) {
          return Fc(e, kt, Eu);
        }
        var Fs = Bo ? function(e) {
          return Bo.get(e);
        } : rl;
        function Qo(e) {
          for (var r = e.name + "", o = oa[r], l = Ue.call(oa, r) ? o.length : 0; l--; ) {
            var m = o[l], S = m.func;
            if (S == null || S == e)
              return m.name;
          }
          return r;
        }
        function ca(e) {
          var r = Ue.call(v, "placeholder") ? v : e;
          return r.placeholder;
        }
        function ue() {
          var e = v.iteratee || tl;
          return e = e === tl ? Vc : e, arguments.length ? e(arguments[0], arguments[1]) : e;
        }
        function Xo(e, r) {
          var o = e.__data__;
          return q_(r) ? o[typeof r == "string" ? "string" : "hash"] : o.map;
        }
        function Us(e) {
          for (var r = lt(e), o = r.length; o--; ) {
            var l = r[o], m = e[l];
            r[o] = [l, m, wu(m)];
          }
          return r;
        }
        function Cr(e, r) {
          var o = K0(e, r);
          return $c(o) ? o : a;
        }
        function $_(e) {
          var r = Ue.call(e, br), o = e[br];
          try {
            e[br] = a;
            var l = !0;
          } catch {
          }
          var m = Oo.call(e);
          return l && (r ? e[br] = o : delete e[br]), m;
        }
        var $s = ps ? function(e) {
          return e == null ? [] : (e = Ve(e), tr(ps(e), function(r) {
            return Cc.call(e, r);
          }));
        } : al, Eu = ps ? function(e) {
          for (var r = []; e; )
            nr(r, $s(e)), e = Mo(e);
          return r;
        } : al, ft = wt;
        (ms && ft(new ms(new ArrayBuffer(1))) != An || Pa && ft(new Pa()) != pt || gs && ft(gs.resolve()) != va || aa && ft(new aa()) != Ut || Ba && ft(new Ba()) != xn) && (ft = function(e) {
          var r = wt(e), o = r == Ft ? e.constructor : a, l = o ? xr(o) : "";
          if (l)
            switch (l) {
              case w1:
                return An;
              case y1:
                return pt;
              case T1:
                return va;
              case C1:
                return Ut;
              case x1:
                return xn;
            }
          return r;
        });
        function V_(e, r, o) {
          for (var l = -1, m = o.length; ++l < m; ) {
            var S = o[l], T = S.size;
            switch (S.type) {
              case "drop":
                e += T;
                break;
              case "dropRight":
                r -= T;
                break;
              case "take":
                r = gt(r, e + T);
                break;
              case "takeRight":
                e = at(e, r - T);
                break;
            }
          }
          return { start: e, end: r };
        }
        function H_(e) {
          var r = e.match(Br);
          return r ? r[1].split(Eo) : [];
        }
        function bu(e, r, o) {
          r = sr(r, e);
          for (var l = -1, m = r.length, S = !1; ++l < m; ) {
            var T = wn(r[l]);
            if (!(S = e != null && o(e, T)))
              break;
            e = e[T];
          }
          return S || ++l != m ? S : (m = e == null ? 0 : e.length, !!m && oi(m) && Yn(T, m) && (fe(e) || Ar(e)));
        }
        function G_(e) {
          var r = e.length, o = new e.constructor(r);
          return r && typeof e[0] == "string" && Ue.call(e, "index") && (o.index = e.index, o.input = e.input), o;
        }
        function Su(e) {
          return typeof e.constructor == "function" && !Za(e) ? ia(Mo(e)) : {};
        }
        function Y_(e, r, o) {
          var l = e.constructor;
          switch (r) {
            case Bn:
              return Ds(e);
            case mt:
            case an:
              return new l(+e);
            case An:
              return A_(e, o);
            case Wr:
            case fn:
            case jr:
            case fr:
            case Dr:
            case Rn:
            case Fn:
            case kr:
            case Lr:
              return ru(e, o);
            case pt:
              return new l();
            case Xn:
            case mr:
              return new l(e);
            case dr:
              return R_(e);
            case Ut:
              return new l();
            case gr:
              return O_(e);
          }
        }
        function z_(e, r) {
          var o = r.length;
          if (!o)
            return e;
          var l = o - 1;
          return r[l] = (o > 1 ? "& " : "") + r[l], r = r.join(o > 2 ? ", " : " "), e.replace(eo, `{
/* [wrapped with ` + r + `] */
`);
        }
        function Z_(e) {
          return fe(e) || Ar(e) || !!(xc && e && e[xc]);
        }
        function Yn(e, r) {
          var o = typeof e;
          return r = r ?? st, !!r && (o == "number" || o != "symbol" && pe.test(e)) && e > -1 && e % 1 == 0 && e < r;
        }
        function yt(e, r, o) {
          if (!We(o))
            return !1;
          var l = typeof r;
          return (l == "number" ? Dt(o) && Yn(r, o.length) : l == "string" && r in o) ? un(o[r], e) : !1;
        }
        function Vs(e, r) {
          if (fe(e))
            return !1;
          var o = typeof e;
          return o == "number" || o == "symbol" || o == "boolean" || e == null || Yt(e) ? !0 : vo.test(e) || !ba.test(e) || r != null && e in Ve(r);
        }
        function q_(e) {
          var r = typeof e;
          return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? e !== "__proto__" : e === null;
        }
        function Hs(e) {
          var r = Qo(e), o = v[r];
          if (typeof o != "function" || !(r in Ce.prototype))
            return !1;
          if (e === o)
            return !0;
          var l = Fs(o);
          return !!l && e === l[0];
        }
        function W_(e) {
          return !!wc && wc in e;
        }
        var j_ = Ao ? zn : ol;
        function Za(e) {
          var r = e && e.constructor, o = typeof r == "function" && r.prototype || ra;
          return e === o;
        }
        function wu(e) {
          return e === e && !We(e);
        }
        function yu(e, r) {
          return function(o) {
            return o == null ? !1 : o[e] === r && (r !== a || e in Ve(o));
          };
        }
        function K_(e) {
          var r = ri(e, function(l) {
            return o.size === h && o.clear(), l;
          }), o = r.cache;
          return r;
        }
        function Q_(e, r) {
          var o = e[1], l = r[1], m = o | l, S = m < (L | $ | ee), T = l == ee && o == P || l == ee && o == X && e[7].length <= r[8] || l == (ee | X) && r[7].length <= r[8] && o == P;
          if (!(S || T))
            return e;
          l & L && (e[2] = r[2], m |= o & L ? 0 : q);
          var C = r[3];
          if (C) {
            var O = e[3];
            e[3] = O ? ou(O, C, r[4]) : C, e[4] = O ? rr(e[3], f) : r[4];
          }
          return C = r[5], C && (O = e[5], e[5] = O ? iu(O, C, r[6]) : C, e[6] = O ? rr(e[5], f) : r[6]), C = r[7], C && (e[7] = C), l & ee && (e[8] = e[8] == null ? r[8] : gt(e[8], r[8])), e[9] == null && (e[9] = r[9]), e[0] = r[0], e[1] = m, e;
        }
        function X_(e) {
          var r = [];
          if (e != null)
            for (var o in Ve(e))
              r.push(o);
          return r;
        }
        function J_(e) {
          return Oo.call(e);
        }
        function Tu(e, r, o) {
          return r = at(r === a ? e.length - 1 : r, 0), function() {
            for (var l = arguments, m = -1, S = at(l.length - r, 0), T = B(S); ++m < S; )
              T[m] = l[r + m];
            m = -1;
            for (var C = B(r + 1); ++m < r; )
              C[m] = l[m];
            return C[r] = o(T), vt(e, this, C);
          };
        }
        function Cu(e, r) {
          return r.length < 2 ? e : Tr(e, Jt(r, 0, -1));
        }
        function ep(e, r) {
          for (var o = e.length, l = gt(r.length, o), m = Mt(e); l--; ) {
            var S = r[l];
            e[l] = Yn(S, o) ? m[S] : a;
          }
          return e;
        }
        function Gs(e, r) {
          if (!(r === "constructor" && typeof e[r] == "function") && r != "__proto__")
            return e[r];
        }
        var xu = Ru(jc), qa = g1 || function(e, r) {
          return Ge.setTimeout(e, r);
        }, Ys = Ru(y_);
        function Au(e, r, o) {
          var l = r + "";
          return Ys(e, z_(l, tp(H_(l), o)));
        }
        function Ru(e) {
          var r = 0, o = 0;
          return function() {
            var l = E1(), m = Se - (l - o);
            if (o = l, m > 0) {
              if (++r >= me)
                return arguments[0];
            } else
              r = 0;
            return e.apply(a, arguments);
          };
        }
        function Jo(e, r) {
          var o = -1, l = e.length, m = l - 1;
          for (r = r === a ? l : r; ++o < r; ) {
            var S = xs(o, m), T = e[S];
            e[S] = e[o], e[o] = T;
          }
          return e.length = r, e;
        }
        var Ou = K_(function(e) {
          var r = [];
          return e.charCodeAt(0) === 46 && r.push(""), e.replace(bi, function(o, l, m, S) {
            r.push(m ? S.replace(wi, "$1") : l || o);
          }), r;
        });
        function wn(e) {
          if (typeof e == "string" || Yt(e))
            return e;
          var r = e + "";
          return r == "0" && 1 / e == -ot ? "-0" : r;
        }
        function xr(e) {
          if (e != null) {
            try {
              return Ro.call(e);
            } catch {
            }
            try {
              return e + "";
            } catch {
            }
          }
          return "";
        }
        function tp(e, r) {
          return jt(Zr, function(o) {
            var l = "_." + o[0];
            r & o[1] && !yo(e, l) && e.push(l);
          }), e.sort();
        }
        function Iu(e) {
          if (e instanceof Ce)
            return e.clone();
          var r = new Qt(e.__wrapped__, e.__chain__);
          return r.__actions__ = Mt(e.__actions__), r.__index__ = e.__index__, r.__values__ = e.__values__, r;
        }
        function np(e, r, o) {
          (o ? yt(e, r, o) : r === a) ? r = 1 : r = at(he(r), 0);
          var l = e == null ? 0 : e.length;
          if (!l || r < 1)
            return [];
          for (var m = 0, S = 0, T = B(Lo(l / r)); m < l; )
            T[S++] = Jt(e, m, m += r);
          return T;
        }
        function rp(e) {
          for (var r = -1, o = e == null ? 0 : e.length, l = 0, m = []; ++r < o; ) {
            var S = e[r];
            S && (m[l++] = S);
          }
          return m;
        }
        function ap() {
          var e = arguments.length;
          if (!e)
            return [];
          for (var r = B(e - 1), o = arguments[0], l = e; l--; )
            r[l - 1] = arguments[l];
          return nr(fe(o) ? Mt(o) : [o], dt(r, 1));
        }
        var op = be(function(e, r) {
          return Je(e) ? Va(e, dt(r, 1, Je, !0)) : [];
        }), ip = be(function(e, r) {
          var o = en(r);
          return Je(o) && (o = a), Je(e) ? Va(e, dt(r, 1, Je, !0), ue(o, 2)) : [];
        }), sp = be(function(e, r) {
          var o = en(r);
          return Je(o) && (o = a), Je(e) ? Va(e, dt(r, 1, Je, !0), a, o) : [];
        });
        function lp(e, r, o) {
          var l = e == null ? 0 : e.length;
          return l ? (r = o || r === a ? 1 : he(r), Jt(e, r < 0 ? 0 : r, l)) : [];
        }
        function cp(e, r, o) {
          var l = e == null ? 0 : e.length;
          return l ? (r = o || r === a ? 1 : he(r), r = l - r, Jt(e, 0, r < 0 ? 0 : r)) : [];
        }
        function up(e, r) {
          return e && e.length ? zo(e, ue(r, 3), !0, !0) : [];
        }
        function dp(e, r) {
          return e && e.length ? zo(e, ue(r, 3), !0) : [];
        }
        function _p(e, r, o, l) {
          var m = e == null ? 0 : e.length;
          return m ? (o && typeof o != "number" && yt(e, r, o) && (o = 0, l = m), a_(e, r, o, l)) : [];
        }
        function Nu(e, r, o) {
          var l = e == null ? 0 : e.length;
          if (!l)
            return -1;
          var m = o == null ? 0 : he(o);
          return m < 0 && (m = at(l + m, 0)), To(e, ue(r, 3), m);
        }
        function Mu(e, r, o) {
          var l = e == null ? 0 : e.length;
          if (!l)
            return -1;
          var m = l - 1;
          return o !== a && (m = he(o), m = o < 0 ? at(l + m, 0) : gt(m, l - 1)), To(e, ue(r, 3), m, !0);
        }
        function Du(e) {
          var r = e == null ? 0 : e.length;
          return r ? dt(e, 1) : [];
        }
        function pp(e) {
          var r = e == null ? 0 : e.length;
          return r ? dt(e, ot) : [];
        }
        function mp(e, r) {
          var o = e == null ? 0 : e.length;
          return o ? (r = r === a ? 1 : he(r), dt(e, r)) : [];
        }
        function gp(e) {
          for (var r = -1, o = e == null ? 0 : e.length, l = {}; ++r < o; ) {
            var m = e[r];
            l[m[0]] = m[1];
          }
          return l;
        }
        function ku(e) {
          return e && e.length ? e[0] : a;
        }
        function fp(e, r, o) {
          var l = e == null ? 0 : e.length;
          if (!l)
            return -1;
          var m = o == null ? 0 : he(o);
          return m < 0 && (m = at(l + m, 0)), Jr(e, r, m);
        }
        function hp(e) {
          var r = e == null ? 0 : e.length;
          return r ? Jt(e, 0, -1) : [];
        }
        var vp = be(function(e) {
          var r = ze(e, Ns);
          return r.length && r[0] === e[0] ? Ss(r) : [];
        }), Ep = be(function(e) {
          var r = en(e), o = ze(e, Ns);
          return r === en(o) ? r = a : o.pop(), o.length && o[0] === e[0] ? Ss(o, ue(r, 2)) : [];
        }), bp = be(function(e) {
          var r = en(e), o = ze(e, Ns);
          return r = typeof r == "function" ? r : a, r && o.pop(), o.length && o[0] === e[0] ? Ss(o, a, r) : [];
        });
        function Sp(e, r) {
          return e == null ? "" : h1.call(e, r);
        }
        function en(e) {
          var r = e == null ? 0 : e.length;
          return r ? e[r - 1] : a;
        }
        function wp(e, r, o) {
          var l = e == null ? 0 : e.length;
          if (!l)
            return -1;
          var m = l;
          return o !== a && (m = he(o), m = m < 0 ? at(l + m, 0) : gt(m, l - 1)), r === r ? t1(e, r, m) : To(e, mc, m, !0);
        }
        function yp(e, r) {
          return e && e.length ? zc(e, he(r)) : a;
        }
        var Tp = be(Lu);
        function Lu(e, r) {
          return e && e.length && r && r.length ? Cs(e, r) : e;
        }
        function Cp(e, r, o) {
          return e && e.length && r && r.length ? Cs(e, r, ue(o, 2)) : e;
        }
        function xp(e, r, o) {
          return e && e.length && r && r.length ? Cs(e, r, a, o) : e;
        }
        var Ap = Gn(function(e, r) {
          var o = e == null ? 0 : e.length, l = hs(e, r);
          return Wc(e, ze(r, function(m) {
            return Yn(m, o) ? +m : m;
          }).sort(au)), l;
        });
        function Rp(e, r) {
          var o = [];
          if (!(e && e.length))
            return o;
          var l = -1, m = [], S = e.length;
          for (r = ue(r, 3); ++l < S; ) {
            var T = e[l];
            r(T, l, e) && (o.push(T), m.push(l));
          }
          return Wc(e, m), o;
        }
        function zs(e) {
          return e == null ? e : S1.call(e);
        }
        function Op(e, r, o) {
          var l = e == null ? 0 : e.length;
          return l ? (o && typeof o != "number" && yt(e, r, o) ? (r = 0, o = l) : (r = r == null ? 0 : he(r), o = o === a ? l : he(o)), Jt(e, r, o)) : [];
        }
        function Ip(e, r) {
          return Yo(e, r);
        }
        function Np(e, r, o) {
          return Rs(e, r, ue(o, 2));
        }
        function Mp(e, r) {
          var o = e == null ? 0 : e.length;
          if (o) {
            var l = Yo(e, r);
            if (l < o && un(e[l], r))
              return l;
          }
          return -1;
        }
        function Dp(e, r) {
          return Yo(e, r, !0);
        }
        function kp(e, r, o) {
          return Rs(e, r, ue(o, 2), !0);
        }
        function Lp(e, r) {
          var o = e == null ? 0 : e.length;
          if (o) {
            var l = Yo(e, r, !0) - 1;
            if (un(e[l], r))
              return l;
          }
          return -1;
        }
        function Pp(e) {
          return e && e.length ? Kc(e) : [];
        }
        function Bp(e, r) {
          return e && e.length ? Kc(e, ue(r, 2)) : [];
        }
        function Fp(e) {
          var r = e == null ? 0 : e.length;
          return r ? Jt(e, 1, r) : [];
        }
        function Up(e, r, o) {
          return e && e.length ? (r = o || r === a ? 1 : he(r), Jt(e, 0, r < 0 ? 0 : r)) : [];
        }
        function $p(e, r, o) {
          var l = e == null ? 0 : e.length;
          return l ? (r = o || r === a ? 1 : he(r), r = l - r, Jt(e, r < 0 ? 0 : r, l)) : [];
        }
        function Vp(e, r) {
          return e && e.length ? zo(e, ue(r, 3), !1, !0) : [];
        }
        function Hp(e, r) {
          return e && e.length ? zo(e, ue(r, 3)) : [];
        }
        var Gp = be(function(e) {
          return ir(dt(e, 1, Je, !0));
        }), Yp = be(function(e) {
          var r = en(e);
          return Je(r) && (r = a), ir(dt(e, 1, Je, !0), ue(r, 2));
        }), zp = be(function(e) {
          var r = en(e);
          return r = typeof r == "function" ? r : a, ir(dt(e, 1, Je, !0), a, r);
        });
        function Zp(e) {
          return e && e.length ? ir(e) : [];
        }
        function qp(e, r) {
          return e && e.length ? ir(e, ue(r, 2)) : [];
        }
        function Wp(e, r) {
          return r = typeof r == "function" ? r : a, e && e.length ? ir(e, a, r) : [];
        }
        function Zs(e) {
          if (!(e && e.length))
            return [];
          var r = 0;
          return e = tr(e, function(o) {
            if (Je(o))
              return r = at(o.length, r), !0;
          }), cs(r, function(o) {
            return ze(e, is(o));
          });
        }
        function Pu(e, r) {
          if (!(e && e.length))
            return [];
          var o = Zs(e);
          return r == null ? o : ze(o, function(l) {
            return vt(r, a, l);
          });
        }
        var jp = be(function(e, r) {
          return Je(e) ? Va(e, r) : [];
        }), Kp = be(function(e) {
          return Is(tr(e, Je));
        }), Qp = be(function(e) {
          var r = en(e);
          return Je(r) && (r = a), Is(tr(e, Je), ue(r, 2));
        }), Xp = be(function(e) {
          var r = en(e);
          return r = typeof r == "function" ? r : a, Is(tr(e, Je), a, r);
        }), Jp = be(Zs);
        function e5(e, r) {
          return eu(e || [], r || [], $a);
        }
        function t5(e, r) {
          return eu(e || [], r || [], Ya);
        }
        var n5 = be(function(e) {
          var r = e.length, o = r > 1 ? e[r - 1] : a;
          return o = typeof o == "function" ? (e.pop(), o) : a, Pu(e, o);
        });
        function Bu(e) {
          var r = v(e);
          return r.__chain__ = !0, r;
        }
        function r5(e, r) {
          return r(e), e;
        }
        function ei(e, r) {
          return r(e);
        }
        var a5 = Gn(function(e) {
          var r = e.length, o = r ? e[0] : 0, l = this.__wrapped__, m = function(S) {
            return hs(S, e);
          };
          return r > 1 || this.__actions__.length || !(l instanceof Ce) || !Yn(o) ? this.thru(m) : (l = l.slice(o, +o + (r ? 1 : 0)), l.__actions__.push({
            func: ei,
            args: [m],
            thisArg: a
          }), new Qt(l, this.__chain__).thru(function(S) {
            return r && !S.length && S.push(a), S;
          }));
        });
        function o5() {
          return Bu(this);
        }
        function i5() {
          return new Qt(this.value(), this.__chain__);
        }
        function s5() {
          this.__values__ === a && (this.__values__ = Qu(this.value()));
          var e = this.__index__ >= this.__values__.length, r = e ? a : this.__values__[this.__index__++];
          return { done: e, value: r };
        }
        function l5() {
          return this;
        }
        function c5(e) {
          for (var r, o = this; o instanceof Uo; ) {
            var l = Iu(o);
            l.__index__ = 0, l.__values__ = a, r ? m.__wrapped__ = l : r = l;
            var m = l;
            o = o.__wrapped__;
          }
          return m.__wrapped__ = e, r;
        }
        function u5() {
          var e = this.__wrapped__;
          if (e instanceof Ce) {
            var r = e;
            return this.__actions__.length && (r = new Ce(this)), r = r.reverse(), r.__actions__.push({
              func: ei,
              args: [zs],
              thisArg: a
            }), new Qt(r, this.__chain__);
          }
          return this.thru(zs);
        }
        function d5() {
          return Jc(this.__wrapped__, this.__actions__);
        }
        var _5 = Zo(function(e, r, o) {
          Ue.call(e, o) ? ++e[o] : Vn(e, o, 1);
        });
        function p5(e, r, o) {
          var l = fe(e) ? _c : r_;
          return o && yt(e, r, o) && (r = a), l(e, ue(r, 3));
        }
        function m5(e, r) {
          var o = fe(e) ? tr : Pc;
          return o(e, ue(r, 3));
        }
        var g5 = uu(Nu), f5 = uu(Mu);
        function h5(e, r) {
          return dt(ti(e, r), 1);
        }
        function v5(e, r) {
          return dt(ti(e, r), ot);
        }
        function E5(e, r, o) {
          return o = o === a ? 1 : he(o), dt(ti(e, r), o);
        }
        function Fu(e, r) {
          var o = fe(e) ? jt : or;
          return o(e, ue(r, 3));
        }
        function Uu(e, r) {
          var o = fe(e) ? F0 : Lc;
          return o(e, ue(r, 3));
        }
        var b5 = Zo(function(e, r, o) {
          Ue.call(e, o) ? e[o].push(r) : Vn(e, o, [r]);
        });
        function S5(e, r, o, l) {
          e = Dt(e) ? e : da(e), o = o && !l ? he(o) : 0;
          var m = e.length;
          return o < 0 && (o = at(m + o, 0)), ii(e) ? o <= m && e.indexOf(r, o) > -1 : !!m && Jr(e, r, o) > -1;
        }
        var w5 = be(function(e, r, o) {
          var l = -1, m = typeof r == "function", S = Dt(e) ? B(e.length) : [];
          return or(e, function(T) {
            S[++l] = m ? vt(r, T, o) : Ha(T, r, o);
          }), S;
        }), y5 = Zo(function(e, r, o) {
          Vn(e, o, r);
        });
        function ti(e, r) {
          var o = fe(e) ? ze : Hc;
          return o(e, ue(r, 3));
        }
        function T5(e, r, o, l) {
          return e == null ? [] : (fe(r) || (r = r == null ? [] : [r]), o = l ? a : o, fe(o) || (o = o == null ? [] : [o]), Zc(e, r, o));
        }
        var C5 = Zo(function(e, r, o) {
          e[o ? 0 : 1].push(r);
        }, function() {
          return [[], []];
        });
        function x5(e, r, o) {
          var l = fe(e) ? as : fc, m = arguments.length < 3;
          return l(e, ue(r, 4), o, m, or);
        }
        function A5(e, r, o) {
          var l = fe(e) ? U0 : fc, m = arguments.length < 3;
          return l(e, ue(r, 4), o, m, Lc);
        }
        function R5(e, r) {
          var o = fe(e) ? tr : Pc;
          return o(e, ai(ue(r, 3)));
        }
        function O5(e) {
          var r = fe(e) ? Nc : S_;
          return r(e);
        }
        function I5(e, r, o) {
          (o ? yt(e, r, o) : r === a) ? r = 1 : r = he(r);
          var l = fe(e) ? X1 : w_;
          return l(e, r);
        }
        function N5(e) {
          var r = fe(e) ? J1 : T_;
          return r(e);
        }
        function M5(e) {
          if (e == null)
            return 0;
          if (Dt(e))
            return ii(e) ? ta(e) : e.length;
          var r = ft(e);
          return r == pt || r == Ut ? e.size : ys(e).length;
        }
        function D5(e, r, o) {
          var l = fe(e) ? os : C_;
          return o && yt(e, r, o) && (r = a), l(e, ue(r, 3));
        }
        var k5 = be(function(e, r) {
          if (e == null)
            return [];
          var o = r.length;
          return o > 1 && yt(e, r[0], r[1]) ? r = [] : o > 2 && yt(r[0], r[1], r[2]) && (r = [r[0]]), Zc(e, dt(r, 1), []);
        }), ni = m1 || function() {
          return Ge.Date.now();
        };
        function L5(e, r) {
          if (typeof r != "function")
            throw new Kt(p);
          return e = he(e), function() {
            if (--e < 1)
              return r.apply(this, arguments);
          };
        }
        function $u(e, r, o) {
          return r = o ? a : r, r = e && r == null ? e.length : r, Hn(e, ee, a, a, a, a, r);
        }
        function Vu(e, r) {
          var o;
          if (typeof r != "function")
            throw new Kt(p);
          return e = he(e), function() {
            return --e > 0 && (o = r.apply(this, arguments)), e <= 1 && (r = a), o;
          };
        }
        var qs = be(function(e, r, o) {
          var l = L;
          if (o.length) {
            var m = rr(o, ca(qs));
            l |= U;
          }
          return Hn(e, l, r, o, m);
        }), Hu = be(function(e, r, o) {
          var l = L | $;
          if (o.length) {
            var m = rr(o, ca(Hu));
            l |= U;
          }
          return Hn(r, l, e, o, m);
        });
        function Gu(e, r, o) {
          r = o ? a : r;
          var l = Hn(e, P, a, a, a, a, a, r);
          return l.placeholder = Gu.placeholder, l;
        }
        function Yu(e, r, o) {
          r = o ? a : r;
          var l = Hn(e, k, a, a, a, a, a, r);
          return l.placeholder = Yu.placeholder, l;
        }
        function zu(e, r, o) {
          var l, m, S, T, C, O, H = 0, Y = !1, j = !1, te = !0;
          if (typeof e != "function")
            throw new Kt(p);
          r = tn(r) || 0, We(o) && (Y = !!o.leading, j = "maxWait" in o, S = j ? at(tn(o.maxWait) || 0, r) : S, te = "trailing" in o ? !!o.trailing : te);
          function ie(et) {
            var dn = l, qn = m;
            return l = m = a, H = et, T = e.apply(qn, dn), T;
          }
          function de(et) {
            return H = et, C = qa(Te, r), Y ? ie(et) : T;
          }
          function Ee(et) {
            var dn = et - O, qn = et - H, ud = r - dn;
            return j ? gt(ud, S - qn) : ud;
          }
          function _e(et) {
            var dn = et - O, qn = et - H;
            return O === a || dn >= r || dn < 0 || j && qn >= S;
          }
          function Te() {
            var et = ni();
            if (_e(et))
              return Ae(et);
            C = qa(Te, Ee(et));
          }
          function Ae(et) {
            return C = a, te && l ? ie(et) : (l = m = a, T);
          }
          function zt() {
            C !== a && tu(C), H = 0, l = O = m = C = a;
          }
          function Tt() {
            return C === a ? T : Ae(ni());
          }
          function Zt() {
            var et = ni(), dn = _e(et);
            if (l = arguments, m = this, O = et, dn) {
              if (C === a)
                return de(O);
              if (j)
                return tu(C), C = qa(Te, r), ie(O);
            }
            return C === a && (C = qa(Te, r)), T;
          }
          return Zt.cancel = zt, Zt.flush = Tt, Zt;
        }
        var P5 = be(function(e, r) {
          return kc(e, 1, r);
        }), B5 = be(function(e, r, o) {
          return kc(e, tn(r) || 0, o);
        });
        function F5(e) {
          return Hn(e, re);
        }
        function ri(e, r) {
          if (typeof e != "function" || r != null && typeof r != "function")
            throw new Kt(p);
          var o = function() {
            var l = arguments, m = r ? r.apply(this, l) : l[0], S = o.cache;
            if (S.has(m))
              return S.get(m);
            var T = e.apply(this, l);
            return o.cache = S.set(m, T) || S, T;
          };
          return o.cache = new (ri.Cache || $n)(), o;
        }
        ri.Cache = $n;
        function ai(e) {
          if (typeof e != "function")
            throw new Kt(p);
          return function() {
            var r = arguments;
            switch (r.length) {
              case 0:
                return !e.call(this);
              case 1:
                return !e.call(this, r[0]);
              case 2:
                return !e.call(this, r[0], r[1]);
              case 3:
                return !e.call(this, r[0], r[1], r[2]);
            }
            return !e.apply(this, r);
          };
        }
        function U5(e) {
          return Vu(2, e);
        }
        var $5 = x_(function(e, r) {
          r = r.length == 1 && fe(r[0]) ? ze(r[0], Ht(ue())) : ze(dt(r, 1), Ht(ue()));
          var o = r.length;
          return be(function(l) {
            for (var m = -1, S = gt(l.length, o); ++m < S; )
              l[m] = r[m].call(this, l[m]);
            return vt(e, this, l);
          });
        }), Ws = be(function(e, r) {
          var o = rr(r, ca(Ws));
          return Hn(e, U, a, r, o);
        }), Zu = be(function(e, r) {
          var o = rr(r, ca(Zu));
          return Hn(e, Z, a, r, o);
        }), V5 = Gn(function(e, r) {
          return Hn(e, X, a, a, a, r);
        });
        function H5(e, r) {
          if (typeof e != "function")
            throw new Kt(p);
          return r = r === a ? r : he(r), be(e, r);
        }
        function G5(e, r) {
          if (typeof e != "function")
            throw new Kt(p);
          return r = r == null ? 0 : at(he(r), 0), be(function(o) {
            var l = o[r], m = lr(o, 0, r);
            return l && nr(m, l), vt(e, this, m);
          });
        }
        function Y5(e, r, o) {
          var l = !0, m = !0;
          if (typeof e != "function")
            throw new Kt(p);
          return We(o) && (l = "leading" in o ? !!o.leading : l, m = "trailing" in o ? !!o.trailing : m), zu(e, r, {
            leading: l,
            maxWait: r,
            trailing: m
          });
        }
        function z5(e) {
          return $u(e, 1);
        }
        function Z5(e, r) {
          return Ws(Ms(r), e);
        }
        function q5() {
          if (!arguments.length)
            return [];
          var e = arguments[0];
          return fe(e) ? e : [e];
        }
        function W5(e) {
          return Xt(e, x);
        }
        function j5(e, r) {
          return r = typeof r == "function" ? r : a, Xt(e, x, r);
        }
        function K5(e) {
          return Xt(e, b | x);
        }
        function Q5(e, r) {
          return r = typeof r == "function" ? r : a, Xt(e, b | x, r);
        }
        function X5(e, r) {
          return r == null || Dc(e, r, lt(r));
        }
        function un(e, r) {
          return e === r || e !== e && r !== r;
        }
        var J5 = Ko(bs), em = Ko(function(e, r) {
          return e >= r;
        }), Ar = Uc(/* @__PURE__ */ function() {
          return arguments;
        }()) ? Uc : function(e) {
          return Ke(e) && Ue.call(e, "callee") && !Cc.call(e, "callee");
        }, fe = B.isArray, tm = Kn ? Ht(Kn) : c_;
        function Dt(e) {
          return e != null && oi(e.length) && !zn(e);
        }
        function Je(e) {
          return Ke(e) && Dt(e);
        }
        function nm(e) {
          return e === !0 || e === !1 || Ke(e) && wt(e) == mt;
        }
        var cr = f1 || ol, rm = Ur ? Ht(Ur) : u_;
        function am(e) {
          return Ke(e) && e.nodeType === 1 && !Wa(e);
        }
        function om(e) {
          if (e == null)
            return !0;
          if (Dt(e) && (fe(e) || typeof e == "string" || typeof e.splice == "function" || cr(e) || ua(e) || Ar(e)))
            return !e.length;
          var r = ft(e);
          if (r == pt || r == Ut)
            return !e.size;
          if (Za(e))
            return !ys(e).length;
          for (var o in e)
            if (Ue.call(e, o))
              return !1;
          return !0;
        }
        function im(e, r) {
          return Ga(e, r);
        }
        function sm(e, r, o) {
          o = typeof o == "function" ? o : a;
          var l = o ? o(e, r) : a;
          return l === a ? Ga(e, r, a, o) : !!l;
        }
        function js(e) {
          if (!Ke(e))
            return !1;
          var r = wt(e);
          return r == pr || r == ha || typeof e.message == "string" && typeof e.name == "string" && !Wa(e);
        }
        function lm(e) {
          return typeof e == "number" && Ac(e);
        }
        function zn(e) {
          if (!We(e))
            return !1;
          var r = wt(e);
          return r == Cn || r == qr || r == Ot || r == Ja;
        }
        function qu(e) {
          return typeof e == "number" && e == he(e);
        }
        function oi(e) {
          return typeof e == "number" && e > -1 && e % 1 == 0 && e <= st;
        }
        function We(e) {
          var r = typeof e;
          return e != null && (r == "object" || r == "function");
        }
        function Ke(e) {
          return e != null && typeof e == "object";
        }
        var Wu = Er ? Ht(Er) : __;
        function cm(e, r) {
          return e === r || ws(e, r, Us(r));
        }
        function um(e, r, o) {
          return o = typeof o == "function" ? o : a, ws(e, r, Us(r), o);
        }
        function dm(e) {
          return ju(e) && e != +e;
        }
        function _m(e) {
          if (j_(e))
            throw new ge(u);
          return $c(e);
        }
        function pm(e) {
          return e === null;
        }
        function mm(e) {
          return e == null;
        }
        function ju(e) {
          return typeof e == "number" || Ke(e) && wt(e) == Xn;
        }
        function Wa(e) {
          if (!Ke(e) || wt(e) != Ft)
            return !1;
          var r = Mo(e);
          if (r === null)
            return !0;
          var o = Ue.call(r, "constructor") && r.constructor;
          return typeof o == "function" && o instanceof o && Ro.call(o) == u1;
        }
        var Ks = Xr ? Ht(Xr) : p_;
        function gm(e) {
          return qu(e) && e >= -st && e <= st;
        }
        var Ku = Ri ? Ht(Ri) : m_;
        function ii(e) {
          return typeof e == "string" || !fe(e) && Ke(e) && wt(e) == mr;
        }
        function Yt(e) {
          return typeof e == "symbol" || Ke(e) && wt(e) == gr;
        }
        var ua = oo ? Ht(oo) : g_;
        function fm(e) {
          return e === a;
        }
        function hm(e) {
          return Ke(e) && ft(e) == xn;
        }
        function vm(e) {
          return Ke(e) && wt(e) == Ea;
        }
        var Em = Ko(Ts), bm = Ko(function(e, r) {
          return e <= r;
        });
        function Qu(e) {
          if (!e)
            return [];
          if (Dt(e))
            return ii(e) ? ln(e) : Mt(e);
          if (La && e[La])
            return X0(e[La]());
          var r = ft(e), o = r == pt ? ds : r == Ut ? Co : da;
          return o(e);
        }
        function Zn(e) {
          if (!e)
            return e === 0 ? e : 0;
          if (e = tn(e), e === ot || e === -ot) {
            var r = e < 0 ? -1 : 1;
            return r * Me;
          }
          return e === e ? e : 0;
        }
        function he(e) {
          var r = Zn(e), o = r % 1;
          return r === r ? o ? r - o : r : 0;
        }
        function Xu(e) {
          return e ? yr(he(e), 0, Fe) : 0;
        }
        function tn(e) {
          if (typeof e == "number")
            return e;
          if (Yt(e))
            return je;
          if (We(e)) {
            var r = typeof e.valueOf == "function" ? e.valueOf() : e;
            e = We(r) ? r + "" : r;
          }
          if (typeof e != "string")
            return e === 0 ? e : +e;
          e = hc(e);
          var o = Hi.test(e);
          return o || K.test(e) ? Xe(e.slice(2), o ? 2 : 8) : Ti.test(e) ? je : +e;
        }
        function Ju(e) {
          return Sn(e, kt(e));
        }
        function Sm(e) {
          return e ? yr(he(e), -st, st) : e === 0 ? e : 0;
        }
        function Be(e) {
          return e == null ? "" : Gt(e);
        }
        var wm = sa(function(e, r) {
          if (Za(r) || Dt(r)) {
            Sn(r, lt(r), e);
            return;
          }
          for (var o in r)
            Ue.call(r, o) && $a(e, o, r[o]);
        }), ed = sa(function(e, r) {
          Sn(r, kt(r), e);
        }), si = sa(function(e, r, o, l) {
          Sn(r, kt(r), e, l);
        }), ym = sa(function(e, r, o, l) {
          Sn(r, lt(r), e, l);
        }), Tm = Gn(hs);
        function Cm(e, r) {
          var o = ia(e);
          return r == null ? o : Mc(o, r);
        }
        var xm = be(function(e, r) {
          e = Ve(e);
          var o = -1, l = r.length, m = l > 2 ? r[2] : a;
          for (m && yt(r[0], r[1], m) && (l = 1); ++o < l; )
            for (var S = r[o], T = kt(S), C = -1, O = T.length; ++C < O; ) {
              var H = T[C], Y = e[H];
              (Y === a || un(Y, ra[H]) && !Ue.call(e, H)) && (e[H] = S[H]);
            }
          return e;
        }), Am = be(function(e) {
          return e.push(a, hu), vt(td, a, e);
        });
        function Rm(e, r) {
          return pc(e, ue(r, 3), bn);
        }
        function Om(e, r) {
          return pc(e, ue(r, 3), Es);
        }
        function Im(e, r) {
          return e == null ? e : vs(e, ue(r, 3), kt);
        }
        function Nm(e, r) {
          return e == null ? e : Bc(e, ue(r, 3), kt);
        }
        function Mm(e, r) {
          return e && bn(e, ue(r, 3));
        }
        function Dm(e, r) {
          return e && Es(e, ue(r, 3));
        }
        function km(e) {
          return e == null ? [] : Ho(e, lt(e));
        }
        function Lm(e) {
          return e == null ? [] : Ho(e, kt(e));
        }
        function Qs(e, r, o) {
          var l = e == null ? a : Tr(e, r);
          return l === a ? o : l;
        }
        function Pm(e, r) {
          return e != null && bu(e, r, o_);
        }
        function Xs(e, r) {
          return e != null && bu(e, r, i_);
        }
        var Bm = _u(function(e, r, o) {
          r != null && typeof r.toString != "function" && (r = Oo.call(r)), e[r] = o;
        }, el(Lt)), Fm = _u(function(e, r, o) {
          r != null && typeof r.toString != "function" && (r = Oo.call(r)), Ue.call(e, r) ? e[r].push(o) : e[r] = [o];
        }, ue), Um = be(Ha);
        function lt(e) {
          return Dt(e) ? Ic(e) : ys(e);
        }
        function kt(e) {
          return Dt(e) ? Ic(e, !0) : f_(e);
        }
        function $m(e, r) {
          var o = {};
          return r = ue(r, 3), bn(e, function(l, m, S) {
            Vn(o, r(l, m, S), l);
          }), o;
        }
        function Vm(e, r) {
          var o = {};
          return r = ue(r, 3), bn(e, function(l, m, S) {
            Vn(o, m, r(l, m, S));
          }), o;
        }
        var Hm = sa(function(e, r, o) {
          Go(e, r, o);
        }), td = sa(function(e, r, o, l) {
          Go(e, r, o, l);
        }), Gm = Gn(function(e, r) {
          var o = {};
          if (e == null)
            return o;
          var l = !1;
          r = ze(r, function(S) {
            return S = sr(S, e), l || (l = S.length > 1), S;
          }), Sn(e, Bs(e), o), l && (o = Xt(o, b | w | x, B_));
          for (var m = r.length; m--; )
            Os(o, r[m]);
          return o;
        });
        function Ym(e, r) {
          return nd(e, ai(ue(r)));
        }
        var zm = Gn(function(e, r) {
          return e == null ? {} : v_(e, r);
        });
        function nd(e, r) {
          if (e == null)
            return {};
          var o = ze(Bs(e), function(l) {
            return [l];
          });
          return r = ue(r), qc(e, o, function(l, m) {
            return r(l, m[0]);
          });
        }
        function Zm(e, r, o) {
          r = sr(r, e);
          var l = -1, m = r.length;
          for (m || (m = 1, e = a); ++l < m; ) {
            var S = e == null ? a : e[wn(r[l])];
            S === a && (l = m, S = o), e = zn(S) ? S.call(e) : S;
          }
          return e;
        }
        function qm(e, r, o) {
          return e == null ? e : Ya(e, r, o);
        }
        function Wm(e, r, o, l) {
          return l = typeof l == "function" ? l : a, e == null ? e : Ya(e, r, o, l);
        }
        var rd = gu(lt), ad = gu(kt);
        function jm(e, r, o) {
          var l = fe(e), m = l || cr(e) || ua(e);
          if (r = ue(r, 4), o == null) {
            var S = e && e.constructor;
            m ? o = l ? new S() : [] : We(e) ? o = zn(S) ? ia(Mo(e)) : {} : o = {};
          }
          return (m ? jt : bn)(e, function(T, C, O) {
            return r(o, T, C, O);
          }), o;
        }
        function Km(e, r) {
          return e == null ? !0 : Os(e, r);
        }
        function Qm(e, r, o) {
          return e == null ? e : Xc(e, r, Ms(o));
        }
        function Xm(e, r, o, l) {
          return l = typeof l == "function" ? l : a, e == null ? e : Xc(e, r, Ms(o), l);
        }
        function da(e) {
          return e == null ? [] : us(e, lt(e));
        }
        function Jm(e) {
          return e == null ? [] : us(e, kt(e));
        }
        function eg(e, r, o) {
          return o === a && (o = r, r = a), o !== a && (o = tn(o), o = o === o ? o : 0), r !== a && (r = tn(r), r = r === r ? r : 0), yr(tn(e), r, o);
        }
        function tg(e, r, o) {
          return r = Zn(r), o === a ? (o = r, r = 0) : o = Zn(o), e = tn(e), s_(e, r, o);
        }
        function ng(e, r, o) {
          if (o && typeof o != "boolean" && yt(e, r, o) && (r = o = a), o === a && (typeof r == "boolean" ? (o = r, r = a) : typeof e == "boolean" && (o = e, e = a)), e === a && r === a ? (e = 0, r = 1) : (e = Zn(e), r === a ? (r = e, e = 0) : r = Zn(r)), e > r) {
            var l = e;
            e = r, r = l;
          }
          if (o || e % 1 || r % 1) {
            var m = Rc();
            return gt(e + m * (r - e + It("1e-" + ((m + "").length - 1))), r);
          }
          return xs(e, r);
        }
        var rg = la(function(e, r, o) {
          return r = r.toLowerCase(), e + (o ? od(r) : r);
        });
        function od(e) {
          return Js(Be(e).toLowerCase());
        }
        function id(e) {
          return e = Be(e), e && e.replace(xe, q0).replace(uc, "");
        }
        function ag(e, r, o) {
          e = Be(e), r = Gt(r);
          var l = e.length;
          o = o === a ? l : yr(he(o), 0, l);
          var m = o;
          return o -= r.length, o >= 0 && e.slice(o, m) == r;
        }
        function og(e) {
          return e = Be(e), e && Ia.test(e) ? e.replace(Kr, W0) : e;
        }
        function ig(e) {
          return e = Be(e), e && Vi.test(e) ? e.replace(Sa, "\\$&") : e;
        }
        var sg = la(function(e, r, o) {
          return e + (o ? "-" : "") + r.toLowerCase();
        }), lg = la(function(e, r, o) {
          return e + (o ? " " : "") + r.toLowerCase();
        }), cg = cu("toLowerCase");
        function ug(e, r, o) {
          e = Be(e), r = he(r);
          var l = r ? ta(e) : 0;
          if (!r || l >= r)
            return e;
          var m = (r - l) / 2;
          return jo(Po(m), o) + e + jo(Lo(m), o);
        }
        function dg(e, r, o) {
          e = Be(e), r = he(r);
          var l = r ? ta(e) : 0;
          return r && l < r ? e + jo(r - l, o) : e;
        }
        function _g(e, r, o) {
          e = Be(e), r = he(r);
          var l = r ? ta(e) : 0;
          return r && l < r ? jo(r - l, o) + e : e;
        }
        function pg(e, r, o) {
          return o || r == null ? r = 0 : r && (r = +r), b1(Be(e).replace(On, ""), r || 0);
        }
        function mg(e, r, o) {
          return (o ? yt(e, r, o) : r === a) ? r = 1 : r = he(r), As(Be(e), r);
        }
        function gg() {
          var e = arguments, r = Be(e[0]);
          return e.length < 3 ? r : r.replace(e[1], e[2]);
        }
        var fg = la(function(e, r, o) {
          return e + (o ? "_" : "") + r.toLowerCase();
        });
        function hg(e, r, o) {
          return o && typeof o != "number" && yt(e, r, o) && (r = o = a), o = o === a ? Fe : o >>> 0, o ? (e = Be(e), e && (typeof r == "string" || r != null && !Ks(r)) && (r = Gt(r), !r && ea(e)) ? lr(ln(e), 0, o) : e.split(r, o)) : [];
        }
        var vg = la(function(e, r, o) {
          return e + (o ? " " : "") + Js(r);
        });
        function Eg(e, r, o) {
          return e = Be(e), o = o == null ? 0 : yr(he(o), 0, e.length), r = Gt(r), e.slice(o, o + r.length) == r;
        }
        function bg(e, r, o) {
          var l = v.templateSettings;
          o && yt(e, r, o) && (r = a), e = Be(e), r = si({}, r, l, fu);
          var m = si({}, r.imports, l.imports, fu), S = lt(m), T = us(m, S), C, O, H = 0, Y = r.interpolate || ut, j = "__p += '", te = _s(
            (r.escape || ut).source + "|" + Y.source + "|" + (Y === Na ? yi : ut).source + "|" + (r.evaluate || ut).source + "|$",
            "g"
          ), ie = "//# sourceURL=" + (Ue.call(r, "sourceURL") ? (r.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++dc + "]") + `
`;
          e.replace(te, function(_e, Te, Ae, zt, Tt, Zt) {
            return Ae || (Ae = zt), j += e.slice(H, Zt).replace(hn, j0), Te && (C = !0, j += `' +
__e(` + Te + `) +
'`), Tt && (O = !0, j += `';
` + Tt + `;
__p += '`), Ae && (j += `' +
((__t = (` + Ae + `)) == null ? '' : __t) +
'`), H = Zt + _e.length, _e;
          }), j += `';
`;
          var de = Ue.call(r, "variable") && r.variable;
          if (!de)
            j = `with (obj) {
` + j + `
}
`;
          else if (hr.test(de))
            throw new ge(g);
          j = (O ? j.replace($i, "") : j).replace(_r, "$1").replace(Oa, "$1;"), j = "function(" + (de || "obj") + `) {
` + (de ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (C ? ", __e = _.escape" : "") + (O ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + j + `return __p
}`;
          var Ee = ld(function() {
            return ke(S, ie + "return " + j).apply(a, T);
          });
          if (Ee.source = j, js(Ee))
            throw Ee;
          return Ee;
        }
        function Sg(e) {
          return Be(e).toLowerCase();
        }
        function wg(e) {
          return Be(e).toUpperCase();
        }
        function yg(e, r, o) {
          if (e = Be(e), e && (o || r === a))
            return hc(e);
          if (!e || !(r = Gt(r)))
            return e;
          var l = ln(e), m = ln(r), S = vc(l, m), T = Ec(l, m) + 1;
          return lr(l, S, T).join("");
        }
        function Tg(e, r, o) {
          if (e = Be(e), e && (o || r === a))
            return e.slice(0, Sc(e) + 1);
          if (!e || !(r = Gt(r)))
            return e;
          var l = ln(e), m = Ec(l, ln(r)) + 1;
          return lr(l, 0, m).join("");
        }
        function Cg(e, r, o) {
          if (e = Be(e), e && (o || r === a))
            return e.replace(On, "");
          if (!e || !(r = Gt(r)))
            return e;
          var l = ln(e), m = vc(l, ln(r));
          return lr(l, m).join("");
        }
        function xg(e, r) {
          var o = Q, l = ce;
          if (We(r)) {
            var m = "separator" in r ? r.separator : m;
            o = "length" in r ? he(r.length) : o, l = "omission" in r ? Gt(r.omission) : l;
          }
          e = Be(e);
          var S = e.length;
          if (ea(e)) {
            var T = ln(e);
            S = T.length;
          }
          if (o >= S)
            return e;
          var C = o - ta(l);
          if (C < 1)
            return l;
          var O = T ? lr(T, 0, C).join("") : e.slice(0, C);
          if (m === a)
            return O + l;
          if (T && (C += O.length - C), Ks(m)) {
            if (e.slice(C).search(m)) {
              var H, Y = O;
              for (m.global || (m = _s(m.source, Be(jn.exec(m)) + "g")), m.lastIndex = 0; H = m.exec(Y); )
                var j = H.index;
              O = O.slice(0, j === a ? C : j);
            }
          } else if (e.indexOf(Gt(m), C) != C) {
            var te = O.lastIndexOf(m);
            te > -1 && (O = O.slice(0, te));
          }
          return O + l;
        }
        function Ag(e) {
          return e = Be(e), e && ho.test(e) ? e.replace(fo, n1) : e;
        }
        var Rg = la(function(e, r, o) {
          return e + (o ? " " : "") + r.toUpperCase();
        }), Js = cu("toUpperCase");
        function sd(e, r, o) {
          return e = Be(e), r = o ? a : r, r === a ? Q0(e) ? o1(e) : H0(e) : e.match(r) || [];
        }
        var ld = be(function(e, r) {
          try {
            return vt(e, a, r);
          } catch (o) {
            return js(o) ? o : new ge(o);
          }
        }), Og = Gn(function(e, r) {
          return jt(r, function(o) {
            o = wn(o), Vn(e, o, qs(e[o], e));
          }), e;
        });
        function Ig(e) {
          var r = e == null ? 0 : e.length, o = ue();
          return e = r ? ze(e, function(l) {
            if (typeof l[1] != "function")
              throw new Kt(p);
            return [o(l[0]), l[1]];
          }) : [], be(function(l) {
            for (var m = -1; ++m < r; ) {
              var S = e[m];
              if (vt(S[0], this, l))
                return vt(S[1], this, l);
            }
          });
        }
        function Ng(e) {
          return n_(Xt(e, b));
        }
        function el(e) {
          return function() {
            return e;
          };
        }
        function Mg(e, r) {
          return e == null || e !== e ? r : e;
        }
        var Dg = du(), kg = du(!0);
        function Lt(e) {
          return e;
        }
        function tl(e) {
          return Vc(typeof e == "function" ? e : Xt(e, b));
        }
        function Lg(e) {
          return Gc(Xt(e, b));
        }
        function Pg(e, r) {
          return Yc(e, Xt(r, b));
        }
        var Bg = be(function(e, r) {
          return function(o) {
            return Ha(o, e, r);
          };
        }), Fg = be(function(e, r) {
          return function(o) {
            return Ha(e, o, r);
          };
        });
        function nl(e, r, o) {
          var l = lt(r), m = Ho(r, l);
          o == null && !(We(r) && (m.length || !l.length)) && (o = r, r = e, e = this, m = Ho(r, lt(r)));
          var S = !(We(o) && "chain" in o) || !!o.chain, T = zn(e);
          return jt(m, function(C) {
            var O = r[C];
            e[C] = O, T && (e.prototype[C] = function() {
              var H = this.__chain__;
              if (S || H) {
                var Y = e(this.__wrapped__), j = Y.__actions__ = Mt(this.__actions__);
                return j.push({ func: O, args: arguments, thisArg: e }), Y.__chain__ = H, Y;
              }
              return O.apply(e, nr([this.value()], arguments));
            });
          }), e;
        }
        function Ug() {
          return Ge._ === this && (Ge._ = d1), this;
        }
        function rl() {
        }
        function $g(e) {
          return e = he(e), be(function(r) {
            return zc(r, e);
          });
        }
        var Vg = ks(ze), Hg = ks(_c), Gg = ks(os);
        function cd(e) {
          return Vs(e) ? is(wn(e)) : E_(e);
        }
        function Yg(e) {
          return function(r) {
            return e == null ? a : Tr(e, r);
          };
        }
        var zg = pu(), Zg = pu(!0);
        function al() {
          return [];
        }
        function ol() {
          return !1;
        }
        function qg() {
          return {};
        }
        function Wg() {
          return "";
        }
        function jg() {
          return !0;
        }
        function Kg(e, r) {
          if (e = he(e), e < 1 || e > st)
            return [];
          var o = Fe, l = gt(e, Fe);
          r = ue(r), e -= Fe;
          for (var m = cs(l, r); ++o < e; )
            r(o);
          return m;
        }
        function Qg(e) {
          return fe(e) ? ze(e, wn) : Yt(e) ? [e] : Mt(Ou(Be(e)));
        }
        function Xg(e) {
          var r = ++c1;
          return Be(e) + r;
        }
        var Jg = Wo(function(e, r) {
          return e + r;
        }, 0), e2 = Ls("ceil"), t2 = Wo(function(e, r) {
          return e / r;
        }, 1), n2 = Ls("floor");
        function r2(e) {
          return e && e.length ? Vo(e, Lt, bs) : a;
        }
        function a2(e, r) {
          return e && e.length ? Vo(e, ue(r, 2), bs) : a;
        }
        function o2(e) {
          return gc(e, Lt);
        }
        function i2(e, r) {
          return gc(e, ue(r, 2));
        }
        function s2(e) {
          return e && e.length ? Vo(e, Lt, Ts) : a;
        }
        function l2(e, r) {
          return e && e.length ? Vo(e, ue(r, 2), Ts) : a;
        }
        var c2 = Wo(function(e, r) {
          return e * r;
        }, 1), u2 = Ls("round"), d2 = Wo(function(e, r) {
          return e - r;
        }, 0);
        function _2(e) {
          return e && e.length ? ls(e, Lt) : 0;
        }
        function p2(e, r) {
          return e && e.length ? ls(e, ue(r, 2)) : 0;
        }
        return v.after = L5, v.ary = $u, v.assign = wm, v.assignIn = ed, v.assignInWith = si, v.assignWith = ym, v.at = Tm, v.before = Vu, v.bind = qs, v.bindAll = Og, v.bindKey = Hu, v.castArray = q5, v.chain = Bu, v.chunk = np, v.compact = rp, v.concat = ap, v.cond = Ig, v.conforms = Ng, v.constant = el, v.countBy = _5, v.create = Cm, v.curry = Gu, v.curryRight = Yu, v.debounce = zu, v.defaults = xm, v.defaultsDeep = Am, v.defer = P5, v.delay = B5, v.difference = op, v.differenceBy = ip, v.differenceWith = sp, v.drop = lp, v.dropRight = cp, v.dropRightWhile = up, v.dropWhile = dp, v.fill = _p, v.filter = m5, v.flatMap = h5, v.flatMapDeep = v5, v.flatMapDepth = E5, v.flatten = Du, v.flattenDeep = pp, v.flattenDepth = mp, v.flip = F5, v.flow = Dg, v.flowRight = kg, v.fromPairs = gp, v.functions = km, v.functionsIn = Lm, v.groupBy = b5, v.initial = hp, v.intersection = vp, v.intersectionBy = Ep, v.intersectionWith = bp, v.invert = Bm, v.invertBy = Fm, v.invokeMap = w5, v.iteratee = tl, v.keyBy = y5, v.keys = lt, v.keysIn = kt, v.map = ti, v.mapKeys = $m, v.mapValues = Vm, v.matches = Lg, v.matchesProperty = Pg, v.memoize = ri, v.merge = Hm, v.mergeWith = td, v.method = Bg, v.methodOf = Fg, v.mixin = nl, v.negate = ai, v.nthArg = $g, v.omit = Gm, v.omitBy = Ym, v.once = U5, v.orderBy = T5, v.over = Vg, v.overArgs = $5, v.overEvery = Hg, v.overSome = Gg, v.partial = Ws, v.partialRight = Zu, v.partition = C5, v.pick = zm, v.pickBy = nd, v.property = cd, v.propertyOf = Yg, v.pull = Tp, v.pullAll = Lu, v.pullAllBy = Cp, v.pullAllWith = xp, v.pullAt = Ap, v.range = zg, v.rangeRight = Zg, v.rearg = V5, v.reject = R5, v.remove = Rp, v.rest = H5, v.reverse = zs, v.sampleSize = I5, v.set = qm, v.setWith = Wm, v.shuffle = N5, v.slice = Op, v.sortBy = k5, v.sortedUniq = Pp, v.sortedUniqBy = Bp, v.split = hg, v.spread = G5, v.tail = Fp, v.take = Up, v.takeRight = $p, v.takeRightWhile = Vp, v.takeWhile = Hp, v.tap = r5, v.throttle = Y5, v.thru = ei, v.toArray = Qu, v.toPairs = rd, v.toPairsIn = ad, v.toPath = Qg, v.toPlainObject = Ju, v.transform = jm, v.unary = z5, v.union = Gp, v.unionBy = Yp, v.unionWith = zp, v.uniq = Zp, v.uniqBy = qp, v.uniqWith = Wp, v.unset = Km, v.unzip = Zs, v.unzipWith = Pu, v.update = Qm, v.updateWith = Xm, v.values = da, v.valuesIn = Jm, v.without = jp, v.words = sd, v.wrap = Z5, v.xor = Kp, v.xorBy = Qp, v.xorWith = Xp, v.zip = Jp, v.zipObject = e5, v.zipObjectDeep = t5, v.zipWith = n5, v.entries = rd, v.entriesIn = ad, v.extend = ed, v.extendWith = si, nl(v, v), v.add = Jg, v.attempt = ld, v.camelCase = rg, v.capitalize = od, v.ceil = e2, v.clamp = eg, v.clone = W5, v.cloneDeep = K5, v.cloneDeepWith = Q5, v.cloneWith = j5, v.conformsTo = X5, v.deburr = id, v.defaultTo = Mg, v.divide = t2, v.endsWith = ag, v.eq = un, v.escape = og, v.escapeRegExp = ig, v.every = p5, v.find = g5, v.findIndex = Nu, v.findKey = Rm, v.findLast = f5, v.findLastIndex = Mu, v.findLastKey = Om, v.floor = n2, v.forEach = Fu, v.forEachRight = Uu, v.forIn = Im, v.forInRight = Nm, v.forOwn = Mm, v.forOwnRight = Dm, v.get = Qs, v.gt = J5, v.gte = em, v.has = Pm, v.hasIn = Xs, v.head = ku, v.identity = Lt, v.includes = S5, v.indexOf = fp, v.inRange = tg, v.invoke = Um, v.isArguments = Ar, v.isArray = fe, v.isArrayBuffer = tm, v.isArrayLike = Dt, v.isArrayLikeObject = Je, v.isBoolean = nm, v.isBuffer = cr, v.isDate = rm, v.isElement = am, v.isEmpty = om, v.isEqual = im, v.isEqualWith = sm, v.isError = js, v.isFinite = lm, v.isFunction = zn, v.isInteger = qu, v.isLength = oi, v.isMap = Wu, v.isMatch = cm, v.isMatchWith = um, v.isNaN = dm, v.isNative = _m, v.isNil = mm, v.isNull = pm, v.isNumber = ju, v.isObject = We, v.isObjectLike = Ke, v.isPlainObject = Wa, v.isRegExp = Ks, v.isSafeInteger = gm, v.isSet = Ku, v.isString = ii, v.isSymbol = Yt, v.isTypedArray = ua, v.isUndefined = fm, v.isWeakMap = hm, v.isWeakSet = vm, v.join = Sp, v.kebabCase = sg, v.last = en, v.lastIndexOf = wp, v.lowerCase = lg, v.lowerFirst = cg, v.lt = Em, v.lte = bm, v.max = r2, v.maxBy = a2, v.mean = o2, v.meanBy = i2, v.min = s2, v.minBy = l2, v.stubArray = al, v.stubFalse = ol, v.stubObject = qg, v.stubString = Wg, v.stubTrue = jg, v.multiply = c2, v.nth = yp, v.noConflict = Ug, v.noop = rl, v.now = ni, v.pad = ug, v.padEnd = dg, v.padStart = _g, v.parseInt = pg, v.random = ng, v.reduce = x5, v.reduceRight = A5, v.repeat = mg, v.replace = gg, v.result = Zm, v.round = u2, v.runInContext = R, v.sample = O5, v.size = M5, v.snakeCase = fg, v.some = D5, v.sortedIndex = Ip, v.sortedIndexBy = Np, v.sortedIndexOf = Mp, v.sortedLastIndex = Dp, v.sortedLastIndexBy = kp, v.sortedLastIndexOf = Lp, v.startCase = vg, v.startsWith = Eg, v.subtract = d2, v.sum = _2, v.sumBy = p2, v.template = bg, v.times = Kg, v.toFinite = Zn, v.toInteger = he, v.toLength = Xu, v.toLower = Sg, v.toNumber = tn, v.toSafeInteger = Sm, v.toString = Be, v.toUpper = wg, v.trim = yg, v.trimEnd = Tg, v.trimStart = Cg, v.truncate = xg, v.unescape = Ag, v.uniqueId = Xg, v.upperCase = Rg, v.upperFirst = Js, v.each = Fu, v.eachRight = Uu, v.first = ku, nl(v, function() {
          var e = {};
          return bn(v, function(r, o) {
            Ue.call(v.prototype, o) || (e[o] = r);
          }), e;
        }(), { chain: !1 }), v.VERSION = i, jt(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(e) {
          v[e].placeholder = v;
        }), jt(["drop", "take"], function(e, r) {
          Ce.prototype[e] = function(o) {
            o = o === a ? 1 : at(he(o), 0);
            var l = this.__filtered__ && !r ? new Ce(this) : this.clone();
            return l.__filtered__ ? l.__takeCount__ = gt(o, l.__takeCount__) : l.__views__.push({
              size: gt(o, Fe),
              type: e + (l.__dir__ < 0 ? "Right" : "")
            }), l;
          }, Ce.prototype[e + "Right"] = function(o) {
            return this.reverse()[e](o).reverse();
          };
        }), jt(["filter", "map", "takeWhile"], function(e, r) {
          var o = r + 1, l = o == Le || o == _t;
          Ce.prototype[e] = function(m) {
            var S = this.clone();
            return S.__iteratees__.push({
              iteratee: ue(m, 3),
              type: o
            }), S.__filtered__ = S.__filtered__ || l, S;
          };
        }), jt(["head", "last"], function(e, r) {
          var o = "take" + (r ? "Right" : "");
          Ce.prototype[e] = function() {
            return this[o](1).value()[0];
          };
        }), jt(["initial", "tail"], function(e, r) {
          var o = "drop" + (r ? "" : "Right");
          Ce.prototype[e] = function() {
            return this.__filtered__ ? new Ce(this) : this[o](1);
          };
        }), Ce.prototype.compact = function() {
          return this.filter(Lt);
        }, Ce.prototype.find = function(e) {
          return this.filter(e).head();
        }, Ce.prototype.findLast = function(e) {
          return this.reverse().find(e);
        }, Ce.prototype.invokeMap = be(function(e, r) {
          return typeof e == "function" ? new Ce(this) : this.map(function(o) {
            return Ha(o, e, r);
          });
        }), Ce.prototype.reject = function(e) {
          return this.filter(ai(ue(e)));
        }, Ce.prototype.slice = function(e, r) {
          e = he(e);
          var o = this;
          return o.__filtered__ && (e > 0 || r < 0) ? new Ce(o) : (e < 0 ? o = o.takeRight(-e) : e && (o = o.drop(e)), r !== a && (r = he(r), o = r < 0 ? o.dropRight(-r) : o.take(r - e)), o);
        }, Ce.prototype.takeRightWhile = function(e) {
          return this.reverse().takeWhile(e).reverse();
        }, Ce.prototype.toArray = function() {
          return this.take(Fe);
        }, bn(Ce.prototype, function(e, r) {
          var o = /^(?:filter|find|map|reject)|While$/.test(r), l = /^(?:head|last)$/.test(r), m = v[l ? "take" + (r == "last" ? "Right" : "") : r], S = l || /^find/.test(r);
          m && (v.prototype[r] = function() {
            var T = this.__wrapped__, C = l ? [1] : arguments, O = T instanceof Ce, H = C[0], Y = O || fe(T), j = function(Te) {
              var Ae = m.apply(v, nr([Te], C));
              return l && te ? Ae[0] : Ae;
            };
            Y && o && typeof H == "function" && H.length != 1 && (O = Y = !1);
            var te = this.__chain__, ie = !!this.__actions__.length, de = S && !te, Ee = O && !ie;
            if (!S && Y) {
              T = Ee ? T : new Ce(this);
              var _e = e.apply(T, C);
              return _e.__actions__.push({ func: ei, args: [j], thisArg: a }), new Qt(_e, te);
            }
            return de && Ee ? e.apply(this, C) : (_e = this.thru(j), de ? l ? _e.value()[0] : _e.value() : _e);
          });
        }), jt(["pop", "push", "shift", "sort", "splice", "unshift"], function(e) {
          var r = xo[e], o = /^(?:push|sort|unshift)$/.test(e) ? "tap" : "thru", l = /^(?:pop|shift)$/.test(e);
          v.prototype[e] = function() {
            var m = arguments;
            if (l && !this.__chain__) {
              var S = this.value();
              return r.apply(fe(S) ? S : [], m);
            }
            return this[o](function(T) {
              return r.apply(fe(T) ? T : [], m);
            });
          };
        }), bn(Ce.prototype, function(e, r) {
          var o = v[r];
          if (o) {
            var l = o.name + "";
            Ue.call(oa, l) || (oa[l] = []), oa[l].push({ name: r, func: o });
          }
        }), oa[qo(a, $).name] = [{
          name: "wrapper",
          func: a
        }], Ce.prototype.clone = A1, Ce.prototype.reverse = R1, Ce.prototype.value = O1, v.prototype.at = a5, v.prototype.chain = o5, v.prototype.commit = i5, v.prototype.next = s5, v.prototype.plant = c5, v.prototype.reverse = u5, v.prototype.toJSON = v.prototype.valueOf = v.prototype.value = d5, v.prototype.first = v.prototype.head, La && (v.prototype[La] = l5), v;
      }, na = i1();
      Nt ? ((Nt.exports = na)._ = na, St._ = na) : Ge._ = na;
    }).call(x4);
  }(Qd, Qd.exports)), Qd.exports;
}
A4();
function R4(t, n = {}) {
  const a = z(!1), i = z(n), s = z(t), u = M(() => i.value.disconnectWhenVisible ?? !1);
  function p(h) {
    h.forEach((f) => {
      a.value = f.isIntersecting, u.value && f.isIntersecting && E();
    });
  }
  const { observe: g, disconnect: E } = Md(p, i);
  return xt(() => {
    g(s);
  }), { elementRef: s, visible: a, disconnect: E };
}
function nc(t) {
  try {
    return s4(t);
  } catch {
    return !1;
  }
}
const O4 = nc("(min-width: 640px)"), I4 = nc("(min-width: 768px)"), N4 = nc("(min-width: 1024px)"), M4 = nc("(min-width: 1280px)"), D4 = nc("(min-width: 1536px)"), k4 = nc("(hover: hover)"), Dd = Mr({
  sm: O4,
  md: I4,
  lg: N4,
  xl: M4,
  xxl: D4,
  hover: k4
});
function A2(t) {
  return t % 2 == 0;
}
function R2(t) {
  return t % 2 == 1;
}
function P7(t) {
  return typeof t == "number";
}
const Yd = function(t, n) {
  return function(a, i, s) {
    const { x: u, y: p } = $r(t), g = new DOMRect(u, p, 0, 0);
    return n(g, i, s);
  };
};
function UQ(t) {
  return t.value === void 0;
}
function $Q(t) {
  return t.value !== void 0;
}
function L4(t) {
  return typeof t == "string" ? t : P4(t) ? t.name?.toString() : t.path;
}
function P4(t) {
  return !!t.name;
}
function Wf(t) {
  if (typeof t != "string" || typeof window > "u")
    return !1;
  try {
    return new URL(t).host !== window.location.host;
  } catch {
    return !1;
  }
}
function B4(t) {
  return typeof t != "string" ? !1 : t.startsWith("/");
}
function F4(t) {
  return typeof t != "string" ? !1 : !B4(t);
}
function VQ(t) {
  try {
    return new URL(t).pathname;
  } catch {
    return t;
  }
}
function _a(t, n) {
  if (n == 1)
    return t;
  const a = ["s", "sh", "ch", "x", "z"].some(
    (i) => t.endsWith(i)
  ) ? "es" : "s";
  return `${t}${a}`;
}
function Qn(t) {
  return t.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, "-").toLowerCase();
}
function Xd(t) {
  return t.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&amp;/g, "&");
}
function HQ(t) {
  return t.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
}
function X2(t) {
  return `${t}px`;
}
const U4 = [
  ".p-label--failed",
  ".p-checkbox--failed",
  ".p-radio--failed",
  ".p-base-input--failed"
];
function GQ() {
  const t = document.querySelector(U4.join(", "));
  t && t.scrollIntoView({
    behavior: "smooth",
    block: "nearest"
  });
}
function I0(t) {
  return t.key ?? Qn(t.title);
}
function Uh(t, n) {
  const { promise: a, resolve: i } = Promise.withResolvers(), s = new IntersectionObserver((u) => {
    const [p] = u;
    p.isIntersecting && (s.unobserve(t), s.disconnect(), setTimeout(() => {
      i();
    }, 100));
  });
  return s.observe(t), t.scrollIntoView(n), a;
}
const N0 = Symbol("UseCascadePanels");
function $4() {
  const t = Ui(N0);
  if (!t)
    throw new i7();
  return t;
}
function V4(t) {
  if (!t)
    try {
      return $4();
    } catch {
      throw new ly();
    }
  const n = _f(t), a = Mr({}), i = z(!1), s = M(() => n.value.filter(($) => a[$.id]));
  function u($) {
    n.value.filter((P) => P.level === $).map((P) => P.id).forEach(h);
  }
  function p($) {
    return a[$];
  }
  function g($) {
    return n.value.find((q) => q.id === $);
  }
  function E($) {
    const q = g($);
    if (!q) {
      console.warn(`Panel with id "${String($)}" not found.`);
      return;
    }
    u(q.level), a[$] = !0, i.value || w();
  }
  function h($) {
    const q = g($);
    if (!q) {
      console.warn(`Panel with id "${String($)}" not found.`);
      return;
    }
    a[$] = !1, Nd(q.level) && u(q.level + 1), s.value.length === 0 && b();
  }
  function f($) {
    a[$] ? h($) : E($);
  }
  function b() {
    i.value = !1;
  }
  function w() {
    s.value.length === 0 && D(), i.value = !0;
  }
  function x() {
    i.value ? b() : w();
  }
  function A() {
    u();
  }
  function D($ = 0) {
    const q = n.value.filter((k) => k.level === $);
    if (q.length === 0)
      return;
    const [P] = q;
    E(P.id);
  }
  const L = {
    panels: n,
    openPanels: s,
    isOpen: i,
    state: ql(a),
    getPanelIsOpenById: p,
    getPanelById: g,
    openPanelById: E,
    closePanelById: h,
    togglePanelById: f,
    closeAll: A,
    close: b,
    open: w,
    toggle: x
  };
  return Zl(N0, L), L;
}
const B7 = Symbol("UseCascadePanel");
function H4() {
  const t = Ui(N0);
  if (!t)
    throw new i7();
  return t;
}
function G4() {
  const t = Ui(B7);
  if (!t)
    throw new sy();
  return t;
}
function Y4(t) {
  if (!t)
    return G4();
  const n = $r(t), { closePanelById: a, openPanelById: i, togglePanelById: s, getPanelIsOpenById: u } = H4(), p = M(() => u(n));
  function g() {
    a(n);
  }
  function E() {
    i(n);
  }
  function h() {
    s(n);
  }
  const f = {
    isOpen: p,
    toggle: h,
    open: E,
    close: g
  };
  return n && Zl(B7, f), f;
}
function F7(t, n) {
  const a = n?.target ?? z(), i = n?.content ?? z(), s = n?.container ?? z(), u = z(t), p = Mr({}), g = new ResizeObserver(E);
  function E() {
    if (a.value && i.value && s.value) {
      const h = j4(a.value, i.value, s.value, u.value);
      Object.assign(p, h);
    }
  }
  return U7(() => {
    pn(E), H7(g, [a, i, s]);
  }), $7(() => g.disconnect()), {
    target: a,
    content: i,
    container: s,
    position: p
  };
}
function YQ(t, n) {
  const { target: a, content: i, container: s, position: u } = F7(t, n), p = Mr({});
  return pn(() => Object.assign(p, V7(u))), {
    target: a,
    content: i,
    container: s,
    styles: p
  };
}
function z4(t, n) {
  const a = n?.target ?? z(), i = n?.content ?? z(), s = n?.container ?? z(), u = z(t), p = Mr({}), g = new ResizeObserver(E);
  function E() {
    if (a.value && i.value && s.value && u.value.length > 0) {
      const f = [...u.value.map((w) => F7(w, { target: a, content: i, container: s }))].sort((w, x) => K4(i.value, s.value, w.position, x.position)), [b] = f;
      Object.assign(p, b.position);
    }
  }
  return U7(() => {
    pn(E), H7(g, [a, i, s]);
  }), $7(() => g.disconnect()), {
    target: a,
    content: i,
    container: s,
    position: p
  };
}
function Z4(t, n) {
  const { target: a, content: i, container: s, position: u } = z4(t, n), p = Mr({});
  return pn(() => Object.assign(p, V7(u))), {
    target: a,
    content: i,
    container: s,
    styles: p
  };
}
function $h(t, n, a) {
  const i = q4(t, n, a), s = Math.min(i.right, window.innerWidth) - Math.max(i.left, 0), u = Math.min(i.bottom, window.innerHeight) - Math.max(i.top, 0), p = s * u, g = i.width * i.height;
  return p / g;
}
function q4(t, n, a) {
  const { width: i, height: s } = t.getBoundingClientRect(), { left: u, top: p } = n.getBoundingClientRect();
  return new DOMRect(a.left + u, a.top + p, i, s);
}
function W4(t, n, a) {
  n && t.observe(n), a && t.unobserve(a);
}
function U7(t) {
  po() ? xt(t) : t();
}
function $7(t) {
  po() && zr(t);
}
function j4(t, n, a, i) {
  const s = t.getBoundingClientRect(), u = n.getBoundingClientRect(), p = a.getBoundingClientRect();
  return i(s, u, p);
}
function K4(t, n, a, i) {
  const s = $h(t, n, a), u = $h(t, n, i);
  return u === s ? 0 : u > s ? 1 : -1;
}
function V7(t) {
  return {
    top: t.top ? X2(t.top) : void 0,
    left: t.left ? X2(t.left) : void 0,
    position: "absolute"
  };
}
function H7(t, n) {
  n.forEach((a) => {
    tt(a, (i, s) => W4(t, i, s), { immediate: !0 });
  });
}
const Q4 = "color-scheme";
let J2 = !1, O2 = 0, bd = null, Sd = null;
const { value: X4, set: J4 } = C4(Q4, void 0), G7 = X4.value ?? "dark", Hl = z(G7), jf = (t) => {
  u0("document") && (document.documentElement.classList.remove(Hl.value), document.documentElement.classList.add(t)), J4(t), Hl.value = t;
}, e6 = () => {
  jf(Hl.value == "dark" ? "light" : "dark");
}, t6 = (t) => {
  Hl.value = t.matches ? "dark" : "light";
}, n6 = () => {
  J2 || (u0("document") && (document.documentElement.classList.contains(Hl.value) || jf(G7)), u0("window") && (Sd = window.matchMedia("(prefers-color-scheme: dark)"), bd = t6, Sd.addEventListener("change", bd)), J2 = !0);
}, r6 = () => {
  Sd && bd && (Sd.removeEventListener("change", bd), Sd = null, bd = null), J2 = !1;
};
function Y7() {
  return xt(() => {
    O2++, n6();
  }), zr(() => {
    O2--, O2 === 0 && r6();
  }), { value: Hl, toggleTheme: e6, setTheme: jf };
}
function a6(t) {
  const { value: n, toggle: a, setTrue: i, setFalse: s } = M7(t), u = M(() => n.value);
  return { value: n, isOpen: u, open: i, close: s, toggle: a };
}
function z7(t, n, a) {
  const i = () => {
    document.addEventListener(t, n, a);
  }, s = () => {
    document.removeEventListener(t, n, a);
  };
  return xt(i), zr(s), { add: i, remove: s };
}
const Z7 = '(function(){"use strict";function O(){return{async:!1,baseUrl:null,breaks:!1,extensions:null,gfm:!0,headerIds:!0,headerPrefix:"",highlight:null,hooks:null,langPrefix:"language-",mangle:!0,pedantic:!1,renderer:null,sanitize:!1,sanitizer:null,silent:!1,smartypants:!1,tokenizer:null,walkTokens:null,xhtml:!1}}let I=O();function K(o){I=o}const M=/[&<>"\']/,Y=new RegExp(M.source,"g"),U=/[<>"\']|&(?!(#\\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\\w+);)/,ee=new RegExp(U.source,"g"),te={"&":"&amp;","<":"&lt;",">":"&gt;",\'"\':"&quot;","\'":"&#39;"},P=o=>te[o];function b(o,n){if(n){if(M.test(o))return o.replace(Y,P)}else if(U.test(o))return o.replace(ee,P);return o}const ne=/&(#(?:\\d+)|(?:#x[0-9A-Fa-f]+)|(?:\\w+));?/ig;function Q(o){return o.replace(ne,(n,t)=>(t=t.toLowerCase(),t==="colon"?":":t.charAt(0)==="#"?t.charAt(1)==="x"?String.fromCharCode(parseInt(t.substring(2),16)):String.fromCharCode(+t.substring(1)):""))}const ie=/(^|[^\\[])\\^/g;function m(o,n){o=typeof o=="string"?o:o.source,n=n||"";const t={replace:(e,i)=>(i=i.source||i,i=i.replace(ie,"$1"),o=o.replace(e,i),t),getRegex:()=>new RegExp(o,n)};return t}const se=/[^\\w:]/g,re=/^$|^[a-z][a-z0-9+.-]*:|^[?#]/i;function j(o,n,t){if(o){let e;try{e=decodeURIComponent(Q(t)).replace(se,"").toLowerCase()}catch{return null}if(e.indexOf("javascript:")===0||e.indexOf("vbscript:")===0||e.indexOf("data:")===0)return null}n&&!re.test(t)&&(t=he(n,t));try{t=encodeURI(t).replace(/%25/g,"%")}catch{return null}return t}const L={},le=/^[^:]+:\\/*[^/]*$/,oe=/^([^:]+:)[\\s\\S]*$/,ae=/^([^:]+:\\/*[^/]*)[\\s\\S]*$/;function he(o,n){L[" "+o]||(le.test(o)?L[" "+o]=o+"/":L[" "+o]=q(o,"/",!0)),o=L[" "+o];const t=o.indexOf(":")===-1;return n.substring(0,2)==="//"?t?n:o.replace(oe,"$1")+n:n.charAt(0)==="/"?t?n:o.replace(ae,"$1")+n:o+n}const Z={exec:function(){}};function N(o,n){const t=o.replace(/\\|/g,(s,r,l)=>{let h=!1,d=r;for(;--d>=0&&l[d]==="\\\\";)h=!h;return h?"|":" |"}),e=t.split(/ \\|/);let i=0;if(e[0].trim()||e.shift(),e.length>0&&!e[e.length-1].trim()&&e.pop(),e.length>n)e.splice(n);else for(;e.length<n;)e.push("");for(;i<e.length;i++)e[i]=e[i].trim().replace(/\\\\\\|/g,"|");return e}function q(o,n,t){const e=o.length;if(e===0)return"";let i=0;for(;i<e;){const s=o.charAt(e-i-1);if(s===n&&!t)i++;else if(s!==n&&t)i++;else break}return o.slice(0,e-i)}function ce(o,n){if(o.indexOf(n[1])===-1)return-1;const t=o.length;let e=0,i=0;for(;i<t;i++)if(o[i]==="\\\\")i++;else if(o[i]===n[0])e++;else if(o[i]===n[1]&&(e--,e<0))return i;return-1}function ue(o){o&&o.sanitize&&!o.silent&&console.warn("marked(): sanitize and sanitizer parameters are deprecated since version 0.7.0, should not be used and will be removed in the future. Read more here: https://marked.js.org/#/USING_ADVANCED.md#options")}function H(o,n){if(n<1)return"";let t="";for(;n>1;)n&1&&(t+=o),n>>=1,o+=o;return t+o}function F(o,n,t,e){const i=n.href,s=n.title?b(n.title):null,r=o[1].replace(/\\\\([\\[\\]])/g,"$1");if(o[0].charAt(0)!=="!"){e.state.inLink=!0;const l={type:"link",raw:t,href:i,title:s,text:r,tokens:e.inlineTokens(r)};return e.state.inLink=!1,l}return{type:"image",raw:t,href:i,title:s,text:b(r)}}function pe(o,n){const t=o.match(/^(\\s+)(?:```)/);if(t===null)return n;const e=t[1];return n.split(`\n`).map(i=>{const s=i.match(/^\\s+/);if(s===null)return i;const[r]=s;return r.length>=e.length?i.slice(e.length):i}).join(`\n`)}class B{constructor(n){this.options=n||I}space(n){const t=this.rules.block.newline.exec(n);if(t&&t[0].length>0)return{type:"space",raw:t[0]}}code(n){const t=this.rules.block.code.exec(n);if(t){const e=t[0].replace(/^ {1,4}/gm,"");return{type:"code",raw:t[0],codeBlockStyle:"indented",text:this.options.pedantic?e:q(e,`\n`)}}}fences(n){const t=this.rules.block.fences.exec(n);if(t){const e=t[0],i=pe(e,t[3]||"");return{type:"code",raw:e,lang:t[2]?t[2].trim().replace(this.rules.inline._escapes,"$1"):t[2],text:i}}}heading(n){const t=this.rules.block.heading.exec(n);if(t){let e=t[2].trim();if(/#$/.test(e)){const i=q(e,"#");(this.options.pedantic||!i||/ $/.test(i))&&(e=i.trim())}return{type:"heading",raw:t[0],depth:t[1].length,text:e,tokens:this.lexer.inline(e)}}}hr(n){const t=this.rules.block.hr.exec(n);if(t)return{type:"hr",raw:t[0]}}blockquote(n){const t=this.rules.block.blockquote.exec(n);if(t){const e=t[0].replace(/^ *>[ \\t]?/gm,""),i=this.lexer.state.top;this.lexer.state.top=!0;const s=this.lexer.blockTokens(e);return this.lexer.state.top=i,{type:"blockquote",raw:t[0],tokens:s,text:e}}}list(n){let t=this.rules.block.list.exec(n);if(t){let e,i,s,r,l,h,d,f,g,k,c,z,_=t[1].trim();const A=_.length>1,x={type:"list",raw:"",ordered:A,start:A?+_.slice(0,-1):"",loose:!1,items:[]};_=A?`\\\\d{1,9}\\\\${_.slice(-1)}`:`\\\\${_}`,this.options.pedantic&&(_=A?_:"[*+-]");const w=new RegExp(`^( {0,3}${_})((?:[	 ][^\\\\n]*)?(?:\\\\n|$))`);for(;n&&(z=!1,!(!(t=w.exec(n))||this.rules.block.hr.test(n)));){if(e=t[0],n=n.substring(e.length),f=t[2].split(`\n`,1)[0].replace(/^\\t+/,S=>" ".repeat(3*S.length)),g=n.split(`\n`,1)[0],this.options.pedantic?(r=2,c=f.trimLeft()):(r=t[2].search(/[^ ]/),r=r>4?1:r,c=f.slice(r),r+=t[1].length),h=!1,!f&&/^ *$/.test(g)&&(e+=g+`\n`,n=n.substring(g.length+1),z=!0),!z){const S=new RegExp(`^ {0,${Math.min(3,r-1)}}(?:[*+-]|\\\\d{1,9}[.)])((?:[ 	][^\\\\n]*)?(?:\\\\n|$))`),y=new RegExp(`^ {0,${Math.min(3,r-1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\\\* *){3,})(?:\\\\n+|$)`),$=new RegExp(`^ {0,${Math.min(3,r-1)}}(?:\\`\\`\\`|~~~)`),C=new RegExp(`^ {0,${Math.min(3,r-1)}}#`);for(;n&&(k=n.split(`\n`,1)[0],g=k,this.options.pedantic&&(g=g.replace(/^ {1,4}(?=( {4})*[^ ])/g,"  ")),!($.test(g)||C.test(g)||S.test(g)||y.test(n)));){if(g.search(/[^ ]/)>=r||!g.trim())c+=`\n`+g.slice(r);else{if(h||f.search(/[^ ]/)>=4||$.test(f)||C.test(f)||y.test(f))break;c+=`\n`+g}!h&&!g.trim()&&(h=!0),e+=k+`\n`,n=n.substring(k.length+1),f=g.slice(r)}}x.loose||(d?x.loose=!0:/\\n *\\n *$/.test(e)&&(d=!0)),this.options.gfm&&(i=/^\\[[ xX]\\] /.exec(c),i&&(s=i[0]!=="[ ] ",c=c.replace(/^\\[[ xX]\\] +/,""))),x.items.push({type:"list_item",raw:e,task:!!i,checked:s,loose:!1,text:c}),x.raw+=e}x.items[x.items.length-1].raw=e.trimRight(),x.items[x.items.length-1].text=c.trimRight(),x.raw=x.raw.trimRight();const E=x.items.length;for(l=0;l<E;l++)if(this.lexer.state.top=!1,x.items[l].tokens=this.lexer.blockTokens(x.items[l].text,[]),!x.loose){const S=x.items[l].tokens.filter($=>$.type==="space"),y=S.length>0&&S.some($=>/\\n.*\\n/.test($.raw));x.loose=y}if(x.loose)for(l=0;l<E;l++)x.items[l].loose=!0;return x}}html(n){const t=this.rules.block.html.exec(n);if(t){const e={type:"html",raw:t[0],pre:!this.options.sanitizer&&(t[1]==="pre"||t[1]==="script"||t[1]==="style"),text:t[0]};if(this.options.sanitize){const i=this.options.sanitizer?this.options.sanitizer(t[0]):b(t[0]);e.type="paragraph",e.text=i,e.tokens=this.lexer.inline(i)}return e}}def(n){const t=this.rules.block.def.exec(n);if(t){const e=t[1].toLowerCase().replace(/\\s+/g," "),i=t[2]?t[2].replace(/^<(.*)>$/,"$1").replace(this.rules.inline._escapes,"$1"):"",s=t[3]?t[3].substring(1,t[3].length-1).replace(this.rules.inline._escapes,"$1"):t[3];return{type:"def",tag:e,raw:t[0],href:i,title:s}}}table(n){const t=this.rules.block.table.exec(n);if(t){const e={type:"table",header:N(t[1]).map(i=>({text:i})),align:t[2].replace(/^ *|\\| *$/g,"").split(/ *\\| */),rows:t[3]&&t[3].trim()?t[3].replace(/\\n[ \\t]*$/,"").split(`\n`):[]};if(e.header.length===e.align.length){e.raw=t[0];let i=e.align.length,s,r,l,h;for(s=0;s<i;s++)/^ *-+: *$/.test(e.align[s])?e.align[s]="right":/^ *:-+: *$/.test(e.align[s])?e.align[s]="center":/^ *:-+ *$/.test(e.align[s])?e.align[s]="left":e.align[s]=null;for(i=e.rows.length,s=0;s<i;s++)e.rows[s]=N(e.rows[s],e.header.length).map(d=>({text:d}));for(i=e.header.length,r=0;r<i;r++)e.header[r].tokens=this.lexer.inline(e.header[r].text);for(i=e.rows.length,r=0;r<i;r++)for(h=e.rows[r],l=0;l<h.length;l++)h[l].tokens=this.lexer.inline(h[l].text);return e}}}lheading(n){const t=this.rules.block.lheading.exec(n);if(t)return{type:"heading",raw:t[0],depth:t[2].charAt(0)==="="?1:2,text:t[1],tokens:this.lexer.inline(t[1])}}paragraph(n){const t=this.rules.block.paragraph.exec(n);if(t){const e=t[1].charAt(t[1].length-1)===`\n`?t[1].slice(0,-1):t[1];return{type:"paragraph",raw:t[0],text:e,tokens:this.lexer.inline(e)}}}text(n){const t=this.rules.block.text.exec(n);if(t)return{type:"text",raw:t[0],text:t[0],tokens:this.lexer.inline(t[0])}}escape(n){const t=this.rules.inline.escape.exec(n);if(t)return{type:"escape",raw:t[0],text:b(t[1])}}tag(n){const t=this.rules.inline.tag.exec(n);if(t)return!this.lexer.state.inLink&&/^<a /i.test(t[0])?this.lexer.state.inLink=!0:this.lexer.state.inLink&&/^<\\/a>/i.test(t[0])&&(this.lexer.state.inLink=!1),!this.lexer.state.inRawBlock&&/^<(pre|code|kbd|script)(\\s|>)/i.test(t[0])?this.lexer.state.inRawBlock=!0:this.lexer.state.inRawBlock&&/^<\\/(pre|code|kbd|script)(\\s|>)/i.test(t[0])&&(this.lexer.state.inRawBlock=!1),{type:this.options.sanitize?"text":"html",raw:t[0],inLink:this.lexer.state.inLink,inRawBlock:this.lexer.state.inRawBlock,text:this.options.sanitize?this.options.sanitizer?this.options.sanitizer(t[0]):b(t[0]):t[0]}}link(n){const t=this.rules.inline.link.exec(n);if(t){const e=t[2].trim();if(!this.options.pedantic&&/^</.test(e)){if(!/>$/.test(e))return;const r=q(e.slice(0,-1),"\\\\");if((e.length-r.length)%2===0)return}else{const r=ce(t[2],"()");if(r>-1){const h=(t[0].indexOf("!")===0?5:4)+t[1].length+r;t[2]=t[2].substring(0,r),t[0]=t[0].substring(0,h).trim(),t[3]=""}}let i=t[2],s="";if(this.options.pedantic){const r=/^([^\'"]*[^\\s])\\s+([\'"])(.*)\\2/.exec(i);r&&(i=r[1],s=r[3])}else s=t[3]?t[3].slice(1,-1):"";return i=i.trim(),/^</.test(i)&&(this.options.pedantic&&!/>$/.test(e)?i=i.slice(1):i=i.slice(1,-1)),F(t,{href:i&&i.replace(this.rules.inline._escapes,"$1"),title:s&&s.replace(this.rules.inline._escapes,"$1")},t[0],this.lexer)}}reflink(n,t){let e;if((e=this.rules.inline.reflink.exec(n))||(e=this.rules.inline.nolink.exec(n))){let i=(e[2]||e[1]).replace(/\\s+/g," ");if(i=t[i.toLowerCase()],!i){const s=e[0].charAt(0);return{type:"text",raw:s,text:s}}return F(e,i,e[0],this.lexer)}}emStrong(n,t,e=""){let i=this.rules.inline.emStrong.lDelim.exec(n);if(!i||i[3]&&e.match(/[\\p{L}\\p{N}]/u))return;const s=i[1]||i[2]||"";if(!s||s&&(e===""||this.rules.inline.punctuation.exec(e))){const r=i[0].length-1;let l,h,d=r,f=0;const g=i[0][0]==="*"?this.rules.inline.emStrong.rDelimAst:this.rules.inline.emStrong.rDelimUnd;for(g.lastIndex=0,t=t.slice(-1*n.length+r);(i=g.exec(t))!=null;){if(l=i[1]||i[2]||i[3]||i[4]||i[5]||i[6],!l)continue;if(h=l.length,i[3]||i[4]){d+=h;continue}else if((i[5]||i[6])&&r%3&&!((r+h)%3)){f+=h;continue}if(d-=h,d>0)continue;h=Math.min(h,h+d+f);const k=n.slice(0,r+i.index+(i[0].length-l.length)+h);if(Math.min(r,h)%2){const z=k.slice(1,-1);return{type:"em",raw:k,text:z,tokens:this.lexer.inlineTokens(z)}}const c=k.slice(2,-2);return{type:"strong",raw:k,text:c,tokens:this.lexer.inlineTokens(c)}}}}codespan(n){const t=this.rules.inline.code.exec(n);if(t){let e=t[2].replace(/\\n/g," ");const i=/[^ ]/.test(e),s=/^ /.test(e)&&/ $/.test(e);return i&&s&&(e=e.substring(1,e.length-1)),e=b(e,!0),{type:"codespan",raw:t[0],text:e}}}br(n){const t=this.rules.inline.br.exec(n);if(t)return{type:"br",raw:t[0]}}del(n){const t=this.rules.inline.del.exec(n);if(t)return{type:"del",raw:t[0],text:t[2],tokens:this.lexer.inlineTokens(t[2])}}autolink(n,t){const e=this.rules.inline.autolink.exec(n);if(e){let i,s;return e[2]==="@"?(i=b(this.options.mangle?t(e[1]):e[1]),s="mailto:"+i):(i=b(e[1]),s=i),{type:"link",raw:e[0],text:i,href:s,tokens:[{type:"text",raw:i,text:i}]}}}url(n,t){let e;if(e=this.rules.inline.url.exec(n)){let i,s;if(e[2]==="@")i=b(this.options.mangle?t(e[0]):e[0]),s="mailto:"+i;else{let r;do r=e[0],e[0]=this.rules.inline._backpedal.exec(e[0])[0];while(r!==e[0]);i=b(e[0]),e[1]==="www."?s="http://"+e[0]:s=e[0]}return{type:"link",raw:e[0],text:i,href:s,tokens:[{type:"text",raw:i,text:i}]}}}inlineText(n,t){const e=this.rules.inline.text.exec(n);if(e){let i;return this.lexer.state.inRawBlock?i=this.options.sanitize?this.options.sanitizer?this.options.sanitizer(e[0]):b(e[0]):e[0]:i=b(this.options.smartypants?t(e[0]):e[0]),{type:"text",raw:e[0],text:i}}}}const u={newline:/^(?: *(?:\\n|$))+/,code:/^( {4}[^\\n]+(?:\\n(?: *(?:\\n|$))*)?)+/,fences:/^ {0,3}(`{3,}(?=[^`\\n]*(?:\\n|$))|~{3,})([^\\n]*)(?:\\n|$)(?:|([\\s\\S]*?)(?:\\n|$))(?: {0,3}\\1[~`]* *(?=\\n|$)|$)/,hr:/^ {0,3}((?:-[\\t ]*){3,}|(?:_[ \\t]*){3,}|(?:\\*[ \\t]*){3,})(?:\\n+|$)/,heading:/^ {0,3}(#{1,6})(?=\\s|$)(.*)(?:\\n+|$)/,blockquote:/^( {0,3}> ?(paragraph|[^\\n]*)(?:\\n|$))+/,list:/^( {0,3}bull)([ \\t][^\\n]+?)?(?:\\n|$)/,html:"^ {0,3}(?:<(script|pre|style|textarea)[\\\\s>][\\\\s\\\\S]*?(?:</\\\\1>[^\\\\n]*\\\\n+|$)|comment[^\\\\n]*(\\\\n+|$)|<\\\\?[\\\\s\\\\S]*?(?:\\\\?>\\\\n*|$)|<![A-Z][\\\\s\\\\S]*?(?:>\\\\n*|$)|<!\\\\[CDATA\\\\[[\\\\s\\\\S]*?(?:\\\\]\\\\]>\\\\n*|$)|</?(tag)(?: +|\\\\n|/?>)[\\\\s\\\\S]*?(?:(?:\\\\n *)+\\\\n|$)|<(?!script|pre|style|textarea)([a-z][\\\\w-]*)(?:attribute)*? */?>(?=[ \\\\t]*(?:\\\\n|$))[\\\\s\\\\S]*?(?:(?:\\\\n *)+\\\\n|$)|</(?!script|pre|style|textarea)[a-z][\\\\w-]*\\\\s*>(?=[ \\\\t]*(?:\\\\n|$))[\\\\s\\\\S]*?(?:(?:\\\\n *)+\\\\n|$))",def:/^ {0,3}\\[(label)\\]: *(?:\\n *)?([^<\\s][^\\s]*|<.*?>)(?:(?: +(?:\\n *)?| *\\n *)(title))? *(?:\\n+|$)/,table:Z,lheading:/^((?:.|\\n(?!\\n))+?)\\n {0,3}(=+|-+) *(?:\\n+|$)/,_paragraph:/^([^\\n]+(?:\\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\\n)[^\\n]+)*)/,text:/^[^\\n]+/};u._label=/(?!\\s*\\])(?:\\\\.|[^\\[\\]\\\\])+/,u._title=/(?:"(?:\\\\"?|[^"\\\\])*"|\'[^\'\\n]*(?:\\n[^\'\\n]+)*\\n?\'|\\([^()]*\\))/,u.def=m(u.def).replace("label",u._label).replace("title",u._title).getRegex(),u.bullet=/(?:[*+-]|\\d{1,9}[.)])/,u.listItemStart=m(/^( *)(bull) */).replace("bull",u.bullet).getRegex(),u.list=m(u.list).replace(/bull/g,u.bullet).replace("hr","\\\\n+(?=\\\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\\\* *){3,})(?:\\\\n+|$))").replace("def","\\\\n+(?="+u.def.source+")").getRegex(),u._tag="address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul",u._comment=/<!--(?!-?>)[\\s\\S]*?(?:-->|$)/,u.html=m(u.html,"i").replace("comment",u._comment).replace("tag",u._tag).replace("attribute",/ +[a-zA-Z:_][\\w.:-]*(?: *= *"[^"\\n]*"| *= *\'[^\'\\n]*\'| *= *[^\\s"\'=<>`]+)?/).getRegex(),u.paragraph=m(u._paragraph).replace("hr",u.hr).replace("heading"," {0,3}#{1,6} ").replace("|lheading","").replace("|table","").replace("blockquote"," {0,3}>").replace("fences"," {0,3}(?:`{3,}(?=[^`\\\\n]*\\\\n)|~{3,})[^\\\\n]*\\\\n").replace("list"," {0,3}(?:[*+-]|1[.)]) ").replace("html","</?(?:tag)(?: +|\\\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag",u._tag).getRegex(),u.blockquote=m(u.blockquote).replace("paragraph",u.paragraph).getRegex(),u.normal={...u},u.gfm={...u.normal,table:"^ *([^\\\\n ].*\\\\|.*)\\\\n {0,3}(?:\\\\| *)?(:?-+:? *(?:\\\\| *:?-+:? *)*)(?:\\\\| *)?(?:\\\\n((?:(?! *\\\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\\\n|$))*)\\\\n*|$)"},u.gfm.table=m(u.gfm.table).replace("hr",u.hr).replace("heading"," {0,3}#{1,6} ").replace("blockquote"," {0,3}>").replace("code"," {4}[^\\\\n]").replace("fences"," {0,3}(?:`{3,}(?=[^`\\\\n]*\\\\n)|~{3,})[^\\\\n]*\\\\n").replace("list"," {0,3}(?:[*+-]|1[.)]) ").replace("html","</?(?:tag)(?: +|\\\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag",u._tag).getRegex(),u.gfm.paragraph=m(u._paragraph).replace("hr",u.hr).replace("heading"," {0,3}#{1,6} ").replace("|lheading","").replace("table",u.gfm.table).replace("blockquote"," {0,3}>").replace("fences"," {0,3}(?:`{3,}(?=[^`\\\\n]*\\\\n)|~{3,})[^\\\\n]*\\\\n").replace("list"," {0,3}(?:[*+-]|1[.)]) ").replace("html","</?(?:tag)(?: +|\\\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag",u._tag).getRegex(),u.pedantic={...u.normal,html:m(`^ *(?:comment *(?:\\\\n|\\\\s*$)|<(tag)[\\\\s\\\\S]+?</\\\\1> *(?:\\\\n{2,}|\\\\s*$)|<tag(?:"[^"]*"|\'[^\']*\'|\\\\s[^\'"/>\\\\s]*)*?/?> *(?:\\\\n{2,}|\\\\s*$))`).replace("comment",u._comment).replace(/tag/g,"(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\\\b)\\\\w+(?!:|[^\\\\w\\\\s@]*@)\\\\b").getRegex(),def:/^ *\\[([^\\]]+)\\]: *<?([^\\s>]+)>?(?: +(["(][^\\n]+[")]))? *(?:\\n+|$)/,heading:/^(#{1,6})(.*)(?:\\n+|$)/,fences:Z,lheading:/^(.+?)\\n {0,3}(=+|-+) *(?:\\n+|$)/,paragraph:m(u.normal._paragraph).replace("hr",u.hr).replace("heading",` *#{1,6} *[^\n]`).replace("lheading",u.lheading).replace("blockquote"," {0,3}>").replace("|fences","").replace("|list","").replace("|html","").getRegex()};const a={escape:/^\\\\([!"#$%&\'()*+,\\-./:;<=>?@\\[\\]\\\\^_`{|}~])/,autolink:/^<(scheme:[^\\s\\x00-\\x1f<>]*|email)>/,url:Z,tag:"^comment|^</[a-zA-Z][\\\\w:-]*\\\\s*>|^<[a-zA-Z][\\\\w-]*(?:attribute)*?\\\\s*/?>|^<\\\\?[\\\\s\\\\S]*?\\\\?>|^<![a-zA-Z]+\\\\s[\\\\s\\\\S]*?>|^<!\\\\[CDATA\\\\[[\\\\s\\\\S]*?\\\\]\\\\]>",link:/^!?\\[(label)\\]\\(\\s*(href)(?:\\s+(title))?\\s*\\)/,reflink:/^!?\\[(label)\\]\\[(ref)\\]/,nolink:/^!?\\[(ref)\\](?:\\[\\])?/,reflinkSearch:"reflink|nolink(?!\\\\()",emStrong:{lDelim:/^(?:\\*+(?:([punct_])|[^\\s*]))|^_+(?:([punct*])|([^\\s_]))/,rDelimAst:/^(?:[^_*\\\\]|\\\\.)*?\\_\\_(?:[^_*\\\\]|\\\\.)*?\\*(?:[^_*\\\\]|\\\\.)*?(?=\\_\\_)|(?:[^*\\\\]|\\\\.)+(?=[^*])|[punct_](\\*+)(?=[\\s]|$)|(?:[^punct*_\\s\\\\]|\\\\.)(\\*+)(?=[punct_\\s]|$)|[punct_\\s](\\*+)(?=[^punct*_\\s])|[\\s](\\*+)(?=[punct_])|[punct_](\\*+)(?=[punct_])|(?:[^punct*_\\s\\\\]|\\\\.)(\\*+)(?=[^punct*_\\s])/,rDelimUnd:/^(?:[^_*\\\\]|\\\\.)*?\\*\\*(?:[^_*\\\\]|\\\\.)*?\\_(?:[^_*\\\\]|\\\\.)*?(?=\\*\\*)|(?:[^_\\\\]|\\\\.)+(?=[^_])|[punct*](\\_+)(?=[\\s]|$)|(?:[^punct*_\\s\\\\]|\\\\.)(\\_+)(?=[punct*\\s]|$)|[punct*\\s](\\_+)(?=[^punct*_\\s])|[\\s](\\_+)(?=[punct*])|[punct*](\\_+)(?=[punct*])/},code:/^(`+)([^`]|[^`][\\s\\S]*?[^`])\\1(?!`)/,br:/^( {2,}|\\\\)\\n(?!\\s*$)/,del:Z,text:/^(`+|[^`])(?:(?= {2,}\\n)|[\\s\\S]*?(?:(?=[\\\\<!\\[`*_]|\\b_|$)|[^ ](?= {2,}\\n)))/,punctuation:/^([\\spunctuation])/};a._punctuation="!\\"#$%&\'()+\\\\-.,/:;<=>?@\\\\[\\\\]`^{|}~",a.punctuation=m(a.punctuation).replace(/punctuation/g,a._punctuation).getRegex(),a.blockSkip=/\\[[^\\]]*?\\]\\([^\\)]*?\\)|`[^`]*?`|<[^>]*?>/g,a.escapedEmSt=/(?:^|[^\\\\])(?:\\\\\\\\)*\\\\[*_]/g,a._comment=m(u._comment).replace("(?:-->|$)","-->").getRegex(),a.emStrong.lDelim=m(a.emStrong.lDelim).replace(/punct/g,a._punctuation).getRegex(),a.emStrong.rDelimAst=m(a.emStrong.rDelimAst,"g").replace(/punct/g,a._punctuation).getRegex(),a.emStrong.rDelimUnd=m(a.emStrong.rDelimUnd,"g").replace(/punct/g,a._punctuation).getRegex(),a._escapes=/\\\\([!"#$%&\'()*+,\\-./:;<=>?@\\[\\]\\\\^_`{|}~])/g,a._scheme=/[a-zA-Z][a-zA-Z0-9+.-]{1,31}/,a._email=/[a-zA-Z0-9.!#$%&\'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/,a.autolink=m(a.autolink).replace("scheme",a._scheme).replace("email",a._email).getRegex(),a._attribute=/\\s+[a-zA-Z:_][\\w.:-]*(?:\\s*=\\s*"[^"]*"|\\s*=\\s*\'[^\']*\'|\\s*=\\s*[^\\s"\'=<>`]+)?/,a.tag=m(a.tag).replace("comment",a._comment).replace("attribute",a._attribute).getRegex(),a._label=/(?:\\[(?:\\\\.|[^\\[\\]\\\\])*\\]|\\\\.|`[^`]*`|[^\\[\\]\\\\`])*?/,a._href=/<(?:\\\\.|[^\\n<>\\\\])+>|[^\\s\\x00-\\x1f]*/,a._title=/"(?:\\\\"?|[^"\\\\])*"|\'(?:\\\\\'?|[^\'\\\\])*\'|\\((?:\\\\\\)?|[^)\\\\])*\\)/,a.link=m(a.link).replace("label",a._label).replace("href",a._href).replace("title",a._title).getRegex(),a.reflink=m(a.reflink).replace("label",a._label).replace("ref",u._label).getRegex(),a.nolink=m(a.nolink).replace("ref",u._label).getRegex(),a.reflinkSearch=m(a.reflinkSearch,"g").replace("reflink",a.reflink).replace("nolink",a.nolink).getRegex(),a.normal={...a},a.pedantic={...a.normal,strong:{start:/^__|\\*\\*/,middle:/^__(?=\\S)([\\s\\S]*?\\S)__(?!_)|^\\*\\*(?=\\S)([\\s\\S]*?\\S)\\*\\*(?!\\*)/,endAst:/\\*\\*(?!\\*)/g,endUnd:/__(?!_)/g},em:{start:/^_|\\*/,middle:/^()\\*(?=\\S)([\\s\\S]*?\\S)\\*(?!\\*)|^_(?=\\S)([\\s\\S]*?\\S)_(?!_)/,endAst:/\\*(?!\\*)/g,endUnd:/_(?!_)/g},link:m(/^!?\\[(label)\\]\\((.*?)\\)/).replace("label",a._label).getRegex(),reflink:m(/^!?\\[(label)\\]\\s*\\[([^\\]]*)\\]/).replace("label",a._label).getRegex()},a.gfm={...a.normal,escape:m(a.escape).replace("])","~|])").getRegex(),_extended_email:/[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/,url:/^((?:ftp|https?):\\/\\/|www\\.)(?:[a-zA-Z0-9\\-]+\\.?)+[^\\s<]*|^email/,_backpedal:/(?:[^?!.,:;*_\'"~()&]+|\\([^)]*\\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_\'"~)]+(?!$))+/,del:/^(~~?)(?=[^\\s~])([\\s\\S]*?[^\\s~])\\1(?=[^~]|$)/,text:/^([`~]+|[^`~])(?:(?= {2,}\\n)|(?=[a-zA-Z0-9.!#$%&\'*+\\/=?_`{\\|}~-]+@)|[\\s\\S]*?(?:(?=[\\\\<!\\[`*~_]|\\b_|https?:\\/\\/|ftp:\\/\\/|www\\.|$)|[^ ](?= {2,}\\n)|[^a-zA-Z0-9.!#$%&\'*+\\/=?_`{\\|}~-](?=[a-zA-Z0-9.!#$%&\'*+\\/=?_`{\\|}~-]+@)))/},a.gfm.url=m(a.gfm.url,"i").replace("email",a.gfm._extended_email).getRegex(),a.breaks={...a.gfm,br:m(a.br).replace("{2,}","*").getRegex(),text:m(a.gfm.text).replace("\\\\b_","\\\\b_| {2,}\\\\n").replace(/\\{2,\\}/g,"*").getRegex()};function fe(o){return o.replace(/---/g,"—").replace(/--/g,"–").replace(/(^|[-\\u2014/(\\[{"\\s])\'/g,"$1‘").replace(/\'/g,"’").replace(/(^|[-\\u2014/(\\[{\\u2018\\s])"/g,"$1“").replace(/"/g,"”").replace(/\\.{3}/g,"…")}function X(o){let n="",t,e;const i=o.length;for(t=0;t<i;t++)e=o.charCodeAt(t),Math.random()>.5&&(e="x"+e.toString(16)),n+="&#"+e+";";return n}class R{constructor(n){this.tokens=[],this.tokens.links=Object.create(null),this.options=n||I,this.options.tokenizer=this.options.tokenizer||new B,this.tokenizer=this.options.tokenizer,this.tokenizer.options=this.options,this.tokenizer.lexer=this,this.inlineQueue=[],this.state={inLink:!1,inRawBlock:!1,top:!0};const t={block:u.normal,inline:a.normal};this.options.pedantic?(t.block=u.pedantic,t.inline=a.pedantic):this.options.gfm&&(t.block=u.gfm,this.options.breaks?t.inline=a.breaks:t.inline=a.gfm),this.tokenizer.rules=t}static get rules(){return{block:u,inline:a}}static lex(n,t){return new R(t).lex(n)}static lexInline(n,t){return new R(t).inlineTokens(n)}lex(n){n=n.replace(/\\r\\n|\\r/g,`\n`),this.blockTokens(n,this.tokens);let t;for(;t=this.inlineQueue.shift();)this.inlineTokens(t.src,t.tokens);return this.tokens}blockTokens(n,t=[]){this.options.pedantic?n=n.replace(/\\t/g,"    ").replace(/^ +$/gm,""):n=n.replace(/^( *)(\\t+)/gm,(l,h,d)=>h+"    ".repeat(d.length));let e,i,s,r;for(;n;)if(!(this.options.extensions&&this.options.extensions.block&&this.options.extensions.block.some(l=>(e=l.call({lexer:this},n,t))?(n=n.substring(e.raw.length),t.push(e),!0):!1))){if(e=this.tokenizer.space(n)){n=n.substring(e.raw.length),e.raw.length===1&&t.length>0?t[t.length-1].raw+=`\n`:t.push(e);continue}if(e=this.tokenizer.code(n)){n=n.substring(e.raw.length),i=t[t.length-1],i&&(i.type==="paragraph"||i.type==="text")?(i.raw+=`\n`+e.raw,i.text+=`\n`+e.text,this.inlineQueue[this.inlineQueue.length-1].src=i.text):t.push(e);continue}if(e=this.tokenizer.fences(n)){n=n.substring(e.raw.length),t.push(e);continue}if(e=this.tokenizer.heading(n)){n=n.substring(e.raw.length),t.push(e);continue}if(e=this.tokenizer.hr(n)){n=n.substring(e.raw.length),t.push(e);continue}if(e=this.tokenizer.blockquote(n)){n=n.substring(e.raw.length),t.push(e);continue}if(e=this.tokenizer.list(n)){n=n.substring(e.raw.length),t.push(e);continue}if(e=this.tokenizer.html(n)){n=n.substring(e.raw.length),t.push(e);continue}if(e=this.tokenizer.def(n)){n=n.substring(e.raw.length),i=t[t.length-1],i&&(i.type==="paragraph"||i.type==="text")?(i.raw+=`\n`+e.raw,i.text+=`\n`+e.raw,this.inlineQueue[this.inlineQueue.length-1].src=i.text):this.tokens.links[e.tag]||(this.tokens.links[e.tag]={href:e.href,title:e.title});continue}if(e=this.tokenizer.table(n)){n=n.substring(e.raw.length),t.push(e);continue}if(e=this.tokenizer.lheading(n)){n=n.substring(e.raw.length),t.push(e);continue}if(s=n,this.options.extensions&&this.options.extensions.startBlock){let l=1/0;const h=n.slice(1);let d;this.options.extensions.startBlock.forEach(function(f){d=f.call({lexer:this},h),typeof d=="number"&&d>=0&&(l=Math.min(l,d))}),l<1/0&&l>=0&&(s=n.substring(0,l+1))}if(this.state.top&&(e=this.tokenizer.paragraph(s))){i=t[t.length-1],r&&i.type==="paragraph"?(i.raw+=`\n`+e.raw,i.text+=`\n`+e.text,this.inlineQueue.pop(),this.inlineQueue[this.inlineQueue.length-1].src=i.text):t.push(e),r=s.length!==n.length,n=n.substring(e.raw.length);continue}if(e=this.tokenizer.text(n)){n=n.substring(e.raw.length),i=t[t.length-1],i&&i.type==="text"?(i.raw+=`\n`+e.raw,i.text+=`\n`+e.text,this.inlineQueue.pop(),this.inlineQueue[this.inlineQueue.length-1].src=i.text):t.push(e);continue}if(n){const l="Infinite loop on byte: "+n.charCodeAt(0);if(this.options.silent){console.error(l);break}else throw new Error(l)}}return this.state.top=!0,t}inline(n,t=[]){return this.inlineQueue.push({src:n,tokens:t}),t}inlineTokens(n,t=[]){let e,i,s,r=n,l,h,d;if(this.tokens.links){const f=Object.keys(this.tokens.links);if(f.length>0)for(;(l=this.tokenizer.rules.inline.reflinkSearch.exec(r))!=null;)f.includes(l[0].slice(l[0].lastIndexOf("[")+1,-1))&&(r=r.slice(0,l.index)+"["+H("a",l[0].length-2)+"]"+r.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex))}for(;(l=this.tokenizer.rules.inline.blockSkip.exec(r))!=null;)r=r.slice(0,l.index)+"["+H("a",l[0].length-2)+"]"+r.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);for(;(l=this.tokenizer.rules.inline.escapedEmSt.exec(r))!=null;)r=r.slice(0,l.index+l[0].length-2)+"++"+r.slice(this.tokenizer.rules.inline.escapedEmSt.lastIndex),this.tokenizer.rules.inline.escapedEmSt.lastIndex--;for(;n;)if(h||(d=""),h=!1,!(this.options.extensions&&this.options.extensions.inline&&this.options.extensions.inline.some(f=>(e=f.call({lexer:this},n,t))?(n=n.substring(e.raw.length),t.push(e),!0):!1))){if(e=this.tokenizer.escape(n)){n=n.substring(e.raw.length),t.push(e);continue}if(e=this.tokenizer.tag(n)){n=n.substring(e.raw.length),i=t[t.length-1],i&&e.type==="text"&&i.type==="text"?(i.raw+=e.raw,i.text+=e.text):t.push(e);continue}if(e=this.tokenizer.link(n)){n=n.substring(e.raw.length),t.push(e);continue}if(e=this.tokenizer.reflink(n,this.tokens.links)){n=n.substring(e.raw.length),i=t[t.length-1],i&&e.type==="text"&&i.type==="text"?(i.raw+=e.raw,i.text+=e.text):t.push(e);continue}if(e=this.tokenizer.emStrong(n,r,d)){n=n.substring(e.raw.length),t.push(e);continue}if(e=this.tokenizer.codespan(n)){n=n.substring(e.raw.length),t.push(e);continue}if(e=this.tokenizer.br(n)){n=n.substring(e.raw.length),t.push(e);continue}if(e=this.tokenizer.del(n)){n=n.substring(e.raw.length),t.push(e);continue}if(e=this.tokenizer.autolink(n,X)){n=n.substring(e.raw.length),t.push(e);continue}if(!this.state.inLink&&(e=this.tokenizer.url(n,X))){n=n.substring(e.raw.length),t.push(e);continue}if(s=n,this.options.extensions&&this.options.extensions.startInline){let f=1/0;const g=n.slice(1);let k;this.options.extensions.startInline.forEach(function(c){k=c.call({lexer:this},g),typeof k=="number"&&k>=0&&(f=Math.min(f,k))}),f<1/0&&f>=0&&(s=n.substring(0,f+1))}if(e=this.tokenizer.inlineText(s,fe)){n=n.substring(e.raw.length),e.raw.slice(-1)!=="_"&&(d=e.raw.slice(-1)),h=!0,i=t[t.length-1],i&&i.type==="text"?(i.raw+=e.raw,i.text+=e.text):t.push(e);continue}if(n){const f="Infinite loop on byte: "+n.charCodeAt(0);if(this.options.silent){console.error(f);break}else throw new Error(f)}}return t}}class D{constructor(n){this.options=n||I}code(n,t,e){const i=(t||"").match(/\\S*/)[0];if(this.options.highlight){const s=this.options.highlight(n,i);s!=null&&s!==n&&(e=!0,n=s)}return n=n.replace(/\\n$/,"")+`\n`,i?\'<pre><code class="\'+this.options.langPrefix+b(i)+\'">\'+(e?n:b(n,!0))+`</code></pre>\n`:"<pre><code>"+(e?n:b(n,!0))+`</code></pre>\n`}blockquote(n){return`<blockquote>\n${n}</blockquote>\n`}html(n){return n}heading(n,t,e,i){if(this.options.headerIds){const s=this.options.headerPrefix+i.slug(e);return`<h${t} id="${s}">${n}</h${t}>\n`}return`<h${t}>${n}</h${t}>\n`}hr(){return this.options.xhtml?`<hr/>\n`:`<hr>\n`}list(n,t,e){const i=t?"ol":"ul",s=t&&e!==1?\' start="\'+e+\'"\':"";return"<"+i+s+`>\n`+n+"</"+i+`>\n`}listitem(n){return`<li>${n}</li>\n`}checkbox(n){return"<input "+(n?\'checked="" \':"")+\'disabled="" type="checkbox"\'+(this.options.xhtml?" /":"")+"> "}paragraph(n){return`<p>${n}</p>\n`}table(n,t){return t&&(t=`<tbody>${t}</tbody>`),`<table>\n<thead>\n`+n+`</thead>\n`+t+`</table>\n`}tablerow(n){return`<tr>\n${n}</tr>\n`}tablecell(n,t){const e=t.header?"th":"td";return(t.align?`<${e} align="${t.align}">`:`<${e}>`)+n+`</${e}>\n`}strong(n){return`<strong>${n}</strong>`}em(n){return`<em>${n}</em>`}codespan(n){return`<code>${n}</code>`}br(){return this.options.xhtml?"<br/>":"<br>"}del(n){return`<del>${n}</del>`}link(n,t,e){if(n=j(this.options.sanitize,this.options.baseUrl,n),n===null)return e;let i=\'<a href="\'+n+\'"\';return t&&(i+=\' title="\'+t+\'"\'),i+=">"+e+"</a>",i}image(n,t,e){if(n=j(this.options.sanitize,this.options.baseUrl,n),n===null)return e;let i=`<img src="${n}" alt="${e}"`;return t&&(i+=` title="${t}"`),i+=this.options.xhtml?"/>":">",i}text(n){return n}}class W{strong(n){return n}em(n){return n}codespan(n){return n}del(n){return n}html(n){return n}text(n){return n}link(n,t,e){return""+e}image(n,t,e){return""+e}br(){return""}}class G{constructor(){this.seen={}}serialize(n){return n.toLowerCase().trim().replace(/<[!\\/a-z].*?>/ig,"").replace(/[\\u2000-\\u206F\\u2E00-\\u2E7F\\\\\'!"#$%&()*+,./:;<=>?@[\\]^`{|}~]/g,"").replace(/\\s/g,"-")}getNextSafeSlug(n,t){let e=n,i=0;if(this.seen.hasOwnProperty(e)){i=this.seen[n];do i++,e=n+"-"+i;while(this.seen.hasOwnProperty(e))}return t||(this.seen[n]=i,this.seen[e]=0),e}slug(n,t={}){const e=this.serialize(n);return this.getNextSafeSlug(e,t.dryrun)}}class T{constructor(n){this.options=n||I,this.options.renderer=this.options.renderer||new D,this.renderer=this.options.renderer,this.renderer.options=this.options,this.textRenderer=new W,this.slugger=new G}static parse(n,t){return new T(t).parse(n)}static parseInline(n,t){return new T(t).parseInline(n)}parse(n,t=!0){let e="",i,s,r,l,h,d,f,g,k,c,z,_,A,x,w,E,S,y,$;const C=n.length;for(i=0;i<C;i++){if(c=n[i],this.options.extensions&&this.options.extensions.renderers&&this.options.extensions.renderers[c.type]&&($=this.options.extensions.renderers[c.type].call({parser:this},c),$!==!1||!["space","hr","heading","code","table","blockquote","list","html","paragraph","text"].includes(c.type))){e+=$||"";continue}switch(c.type){case"space":continue;case"hr":{e+=this.renderer.hr();continue}case"heading":{e+=this.renderer.heading(this.parseInline(c.tokens),c.depth,Q(this.parseInline(c.tokens,this.textRenderer)),this.slugger);continue}case"code":{e+=this.renderer.code(c.text,c.lang,c.escaped);continue}case"table":{for(g="",f="",l=c.header.length,s=0;s<l;s++)f+=this.renderer.tablecell(this.parseInline(c.header[s].tokens),{header:!0,align:c.align[s]});for(g+=this.renderer.tablerow(f),k="",l=c.rows.length,s=0;s<l;s++){for(d=c.rows[s],f="",h=d.length,r=0;r<h;r++)f+=this.renderer.tablecell(this.parseInline(d[r].tokens),{header:!1,align:c.align[r]});k+=this.renderer.tablerow(f)}e+=this.renderer.table(g,k);continue}case"blockquote":{k=this.parse(c.tokens),e+=this.renderer.blockquote(k);continue}case"list":{for(z=c.ordered,_=c.start,A=c.loose,l=c.items.length,k="",s=0;s<l;s++)w=c.items[s],E=w.checked,S=w.task,x="",w.task&&(y=this.renderer.checkbox(E),A?w.tokens.length>0&&w.tokens[0].type==="paragraph"?(w.tokens[0].text=y+" "+w.tokens[0].text,w.tokens[0].tokens&&w.tokens[0].tokens.length>0&&w.tokens[0].tokens[0].type==="text"&&(w.tokens[0].tokens[0].text=y+" "+w.tokens[0].tokens[0].text)):w.tokens.unshift({type:"text",text:y}):x+=y),x+=this.parse(w.tokens,A),k+=this.renderer.listitem(x,S,E);e+=this.renderer.list(k,z,_);continue}case"html":{e+=this.renderer.html(c.text);continue}case"paragraph":{e+=this.renderer.paragraph(this.parseInline(c.tokens));continue}case"text":{for(k=c.tokens?this.parseInline(c.tokens):c.text;i+1<C&&n[i+1].type==="text";)c=n[++i],k+=`\n`+(c.tokens?this.parseInline(c.tokens):c.text);e+=t?this.renderer.paragraph(k):k;continue}default:{const J=\'Token with "\'+c.type+\'" type was not found.\';if(this.options.silent){console.error(J);return}else throw new Error(J)}}}return e}parseInline(n,t){t=t||this.renderer;let e="",i,s,r;const l=n.length;for(i=0;i<l;i++){if(s=n[i],this.options.extensions&&this.options.extensions.renderers&&this.options.extensions.renderers[s.type]&&(r=this.options.extensions.renderers[s.type].call({parser:this},s),r!==!1||!["escape","html","link","image","strong","em","codespan","br","del","text"].includes(s.type))){e+=r||"";continue}switch(s.type){case"escape":{e+=t.text(s.text);break}case"html":{e+=t.html(s.text);break}case"link":{e+=t.link(s.href,s.title,this.parseInline(s.tokens,t));break}case"image":{e+=t.image(s.href,s.title,s.text);break}case"strong":{e+=t.strong(this.parseInline(s.tokens,t));break}case"em":{e+=t.em(this.parseInline(s.tokens,t));break}case"codespan":{e+=t.codespan(s.text);break}case"br":{e+=t.br();break}case"del":{e+=t.del(this.parseInline(s.tokens,t));break}case"text":{e+=t.text(s.text);break}default:{const h=\'Token with "\'+s.type+\'" type was not found.\';if(this.options.silent){console.error(h);return}else throw new Error(h)}}}return e}}class v{constructor(n){this.options=n||I}static passThroughHooks=new Set(["preprocess","postprocess"]);preprocess(n){return n}postprocess(n){return n}}function ge(o,n,t){return e=>{if(e.message+=`\nPlease report this to https://github.com/markedjs/marked.`,o){const i="<p>An error occurred:</p><pre>"+b(e.message+"",!0)+"</pre>";if(n)return Promise.resolve(i);if(t){t(null,i);return}return i}if(n)return Promise.reject(e);if(t){t(e);return}throw e}}function V(o,n){return(t,e,i)=>{typeof e=="function"&&(i=e,e=null);const s={...e};e={...p.defaults,...s};const r=ge(e.silent,e.async,i);if(typeof t>"u"||t===null)return r(new Error("marked(): input parameter is undefined or null"));if(typeof t!="string")return r(new Error("marked(): input parameter is of type "+Object.prototype.toString.call(t)+", string expected"));if(ue(e),e.hooks&&(e.hooks.options=e),i){const l=e.highlight;let h;try{e.hooks&&(t=e.hooks.preprocess(t)),h=o(t,e)}catch(g){return r(g)}const d=function(g){let k;if(!g)try{e.walkTokens&&p.walkTokens(h,e.walkTokens),k=n(h,e),e.hooks&&(k=e.hooks.postprocess(k))}catch(c){g=c}return e.highlight=l,g?r(g):i(null,k)};if(!l||l.length<3||(delete e.highlight,!h.length))return d();let f=0;p.walkTokens(h,function(g){g.type==="code"&&(f++,setTimeout(()=>{l(g.text,g.lang,function(k,c){if(k)return d(k);c!=null&&c!==g.text&&(g.text=c,g.escaped=!0),f--,f===0&&d()})},0))}),f===0&&d();return}if(e.async)return Promise.resolve(e.hooks?e.hooks.preprocess(t):t).then(l=>o(l,e)).then(l=>e.walkTokens?Promise.all(p.walkTokens(l,e.walkTokens)).then(()=>l):l).then(l=>n(l,e)).then(l=>e.hooks?e.hooks.postprocess(l):l).catch(r);try{e.hooks&&(t=e.hooks.preprocess(t));const l=o(t,e);e.walkTokens&&p.walkTokens(l,e.walkTokens);let h=n(l,e);return e.hooks&&(h=e.hooks.postprocess(h)),h}catch(l){return r(l)}}}function p(o,n,t){return V(R.lex,T.parse)(o,n,t)}p.options=p.setOptions=function(o){return p.defaults={...p.defaults,...o},K(p.defaults),p},p.getDefaults=O,p.defaults=I,p.use=function(...o){const n=p.defaults.extensions||{renderers:{},childTokens:{}};o.forEach(t=>{const e={...t};if(e.async=p.defaults.async||e.async||!1,t.extensions&&(t.extensions.forEach(i=>{if(!i.name)throw new Error("extension name required");if(i.renderer){const s=n.renderers[i.name];s?n.renderers[i.name]=function(...r){let l=i.renderer.apply(this,r);return l===!1&&(l=s.apply(this,r)),l}:n.renderers[i.name]=i.renderer}if(i.tokenizer){if(!i.level||i.level!=="block"&&i.level!=="inline")throw new Error("extension level must be \'block\' or \'inline\'");n[i.level]?n[i.level].unshift(i.tokenizer):n[i.level]=[i.tokenizer],i.start&&(i.level==="block"?n.startBlock?n.startBlock.push(i.start):n.startBlock=[i.start]:i.level==="inline"&&(n.startInline?n.startInline.push(i.start):n.startInline=[i.start]))}i.childTokens&&(n.childTokens[i.name]=i.childTokens)}),e.extensions=n),t.renderer){const i=p.defaults.renderer||new D;for(const s in t.renderer){const r=i[s];i[s]=(...l)=>{let h=t.renderer[s].apply(i,l);return h===!1&&(h=r.apply(i,l)),h}}e.renderer=i}if(t.tokenizer){const i=p.defaults.tokenizer||new B;for(const s in t.tokenizer){const r=i[s];i[s]=(...l)=>{let h=t.tokenizer[s].apply(i,l);return h===!1&&(h=r.apply(i,l)),h}}e.tokenizer=i}if(t.hooks){const i=p.defaults.hooks||new v;for(const s in t.hooks){const r=i[s];v.passThroughHooks.has(s)?i[s]=l=>{if(p.defaults.async)return Promise.resolve(t.hooks[s].call(i,l)).then(d=>r.call(i,d));const h=t.hooks[s].call(i,l);return r.call(i,h)}:i[s]=(...l)=>{let h=t.hooks[s].apply(i,l);return h===!1&&(h=r.apply(i,l)),h}}e.hooks=i}if(t.walkTokens){const i=p.defaults.walkTokens;e.walkTokens=function(s){let r=[];return r.push(t.walkTokens.call(this,s)),i&&(r=r.concat(i.call(this,s))),r}}p.setOptions(e)})},p.walkTokens=function(o,n){let t=[];for(const e of o)switch(t=t.concat(n.call(p,e)),e.type){case"table":{for(const i of e.header)t=t.concat(p.walkTokens(i.tokens,n));for(const i of e.rows)for(const s of i)t=t.concat(p.walkTokens(s.tokens,n));break}case"list":{t=t.concat(p.walkTokens(e.items,n));break}default:p.defaults.extensions&&p.defaults.extensions.childTokens&&p.defaults.extensions.childTokens[e.type]?p.defaults.extensions.childTokens[e.type].forEach(function(i){t=t.concat(p.walkTokens(e[i],n))}):e.tokens&&(t=t.concat(p.walkTokens(e.tokens,n)))}return t},p.parseInline=V(R.lexInline,T.parseInline),p.Parser=T,p.parser=T.parse,p.Renderer=D,p.TextRenderer=W,p.Lexer=R,p.lexer=R.lex,p.Tokenizer=B,p.Slugger=G,p.Hooks=v,p.parse=p,p.options,p.setOptions,p.use,p.walkTokens,p.parseInline,T.parse,R.lex;const de={gfm:!0,breaks:!0},ke=o=>p.lexer(o,de),me=o=>{const{id:n,text:t}=o.data,e=ke(t),i={id:n,tokens:e};self.postMessage(i)};self.onmessage=me})();\n', Vh = typeof self < "u" && self.Blob && new Blob(["(self.URL || self.webkitURL).revokeObjectURL(self.location.href);", Z7], { type: "text/javascript;charset=utf-8" });
function o6(t) {
  let n;
  try {
    if (n = Vh && (self.URL || self.webkitURL).createObjectURL(Vh), !n) throw "";
    const a = new Worker(n, {
      name: t?.name
    });
    return a.addEventListener("error", () => {
      (self.URL || self.webkitURL).revokeObjectURL(n);
    }), a;
  } catch {
    return new Worker(
      "data:text/javascript;charset=utf-8," + encodeURIComponent(Z7),
      {
        name: t?.name
      }
    );
  }
}
const ef = /* @__PURE__ */ new Map(), q7 = new o6();
q7.onmessage = (t) => {
  const { id: n, tokens: a } = t.data, i = ef.get(n);
  i && i(a);
};
function i6(t) {
  const n = ml(), a = z([]), i = (s) => {
    a.value = s;
  };
  return ef.set(n, i), pn(() => q7.postMessage({ id: n, text: $r(t) })), zl(() => ef.delete(n)), { tokens: a };
}
function s6(t) {
  const { value: n, toggle: a, setTrue: i, setFalse: s } = M7(t), u = M(() => n.value);
  return { value: n, isOpen: u, open: i, close: s, toggle: a };
}
const Hh = z();
function l6() {
  return { margin: M(() => Hh.value ? Hh.value : Dd.lg ? "-1px 0px 0px 0px" : "-65px 0px 0px 0px") };
}
function c6() {
  const t = /* @__PURE__ */ new Map();
  return (a) => {
    const i = () => {
      const u = t.get(a);
      u && u();
    };
    return {
      open: (u) => {
        i(), t.set(a, u);
      },
      close: i
    };
  };
}
const u6 = c6();
function d6(t, n) {
  const a = z(t), i = z(n), s = () => {
    !a.value || !i.value || (i.value.scrollTop = a.value.scrollTop, i.value.scrollLeft = a.value.scrollLeft, a.value.style.width = `${i.value.scrollWidth}px`);
  }, u = () => {
    a.value && a.value.addEventListener("scroll", s);
  }, p = () => {
    a.value && a.value.removeEventListener("scroll", s);
  };
  return xt(u), zr(p), {
    disconnect: p,
    source: a,
    target: i
  };
}
function _6() {
  const { value: t } = Y7(), n = Mr({});
  a(), tt(t, () => a());
  function a() {
    requestAnimationFrame(() => {
      Object.assign(n, p6());
    });
  }
  function i() {
    return ql(n);
  }
  return i;
}
const zQ = _6();
function p6() {
  const t = getComputedStyle(document.documentElement);
  return {
    colorBackgroundCode: t.getPropertyValue("--p-color-bg-code"),
    colorBackgroundFloating: t.getPropertyValue("--p-color-bg-floating"),
    colorBackgroundFloatingSticky: t.getPropertyValue("--p-color-bg-floating-sticky"),
    colorBackgroundOne: t.getPropertyValue("--p-color-bg-1"),
    colorBackgroundOverlay: t.getPropertyValue("--p-color-bg-overlay"),
    colorBackgroundTwo: t.getPropertyValue("--p-color-bg-2"),
    colorBackgroundZero: t.getPropertyValue("--p-color-bg-0"),
    colorButtonDangerBg: t.getPropertyValue("--p-color-button-danger-bg"),
    colorButtonDangerBgActive: t.getPropertyValue("--p-color-button-danger-bg-active"),
    colorButtonDangerBgHover: t.getPropertyValue("--p-color-button-danger-bg-hover"),
    colorButtonDangerBorder: t.getPropertyValue("--p-color-button-danger-border"),
    colorButtonDangerBorderActive: t.getPropertyValue("--p-color-button-danger-border-active"),
    colorButtonDangerBorderHover: t.getPropertyValue("--p-color-button-danger-border-hover"),
    colorButtonDangerText: t.getPropertyValue("--p-color-button-danger-text"),
    colorButtonDangerTextActive: t.getPropertyValue("--p-color-button-danger-text-active"),
    colorButtonDangerTextHover: t.getPropertyValue("--p-color-button-danger-text-hover"),
    colorButtonDefaultBg: t.getPropertyValue("--p-color-button-default-bg"),
    colorButtonDefaultBgActive: t.getPropertyValue("--p-color-button-default-bg-active"),
    colorButtonDefaultBgHover: t.getPropertyValue("--p-color-button-default-bg-hover"),
    colorButtonDefaultBorder: t.getPropertyValue("--p-color-button-default-border"),
    colorButtonDefaultBorderActive: t.getPropertyValue("--p-color-button-default-border-active"),
    colorButtonDefaultBorderHover: t.getPropertyValue("--p-color-button-default-border-hover"),
    colorButtonDefaultText: t.getPropertyValue("--p-color-button-default-text"),
    colorButtonDefaultTextActive: t.getPropertyValue("--p-color-button-default-text-active"),
    colorButtonDefaultTextHover: t.getPropertyValue("--p-color-button-default-text-hover"),
    colorButtonFlatBg: t.getPropertyValue("--p-color-button-flat-bg"),
    colorButtonFlatBgActive: t.getPropertyValue("--p-color-button-flat-bg-active"),
    colorButtonFlatBgHover: t.getPropertyValue("--p-color-button-flat-bg-hover"),
    colorButtonFlatBorder: t.getPropertyValue("--p-color-button-flat-border"),
    colorButtonFlatBorderActive: t.getPropertyValue("--p-color-button-flat-border-active"),
    colorButtonFlatBorderHover: t.getPropertyValue("--p-color-button-flat-border-hover"),
    colorButtonFlatDangerBg: t.getPropertyValue("--p-color-button-flat-danger-bg"),
    colorButtonFlatDangerBgActive: t.getPropertyValue("--p-color-button-flat-danger-bg-active"),
    colorButtonFlatDangerBgHover: t.getPropertyValue("--p-color-button-flat-danger-bg-hover"),
    colorButtonFlatDangerBorder: t.getPropertyValue("--p-color-button-flat-danger-border"),
    colorButtonFlatDangerBorderActive: t.getPropertyValue("--p-color-button-flat-danger-border-active"),
    colorButtonFlatDangerBorderHover: t.getPropertyValue("--p-color-button-flat-danger-border-hover"),
    colorButtonFlatDangerText: t.getPropertyValue("--p-color-button-flat-danger-text"),
    colorButtonFlatDangerTextActive: t.getPropertyValue("--p-color-button-flat-danger-text-active"),
    colorButtonFlatDangerTextHover: t.getPropertyValue("--p-color-button-flat-danger-text-hover"),
    colorButtonFlatText: t.getPropertyValue("--p-color-button-flat-text"),
    colorButtonFlatTextActive: t.getPropertyValue("--p-color-button-flat-text-active"),
    colorButtonFlatTextHover: t.getPropertyValue("--p-color-button-flat-text-hover"),
    colorButtonPrimaryBg: t.getPropertyValue("--p-color-button-primary-bg"),
    colorButtonPrimaryBgActive: t.getPropertyValue("--p-color-button-primary-bg-active"),
    colorButtonPrimaryBgHover: t.getPropertyValue("--p-color-button-primary-bg-hover"),
    colorButtonPrimaryBorder: t.getPropertyValue("--p-color-button-primary-border"),
    colorButtonPrimaryBorderActive: t.getPropertyValue("--p-color-button-primary-border-active"),
    colorButtonPrimaryBorderHover: t.getPropertyValue("--p-color-button-primary-border-hover"),
    colorButtonPrimaryDangerBg: t.getPropertyValue("--p-color-button-primary-danger-bg"),
    colorButtonPrimaryDangerBgActive: t.getPropertyValue("--p-color-button-primary-danger-bg-active"),
    colorButtonPrimaryDangerBgHover: t.getPropertyValue("--p-color-button-primary-danger-bg-hover"),
    colorButtonPrimaryDangerBorder: t.getPropertyValue("--p-color-button-primary-danger-border"),
    colorButtonPrimaryDangerBorderActive: t.getPropertyValue("--p-color-button-primary-danger-border-active"),
    colorButtonPrimaryDangerBorderHover: t.getPropertyValue("--p-color-button-primary-danger-border-hover"),
    colorButtonPrimaryDangerText: t.getPropertyValue("--p-color-button-primary-danger-text"),
    colorButtonPrimaryDangerTextActive: t.getPropertyValue("--p-color-button-primary-danger-text-active"),
    colorButtonPrimaryDangerTextHover: t.getPropertyValue("--p-color-button-primary-danger-text-hover"),
    colorButtonPrimaryText: t.getPropertyValue("--p-color-button-primary-text"),
    colorButtonPrimaryTextActive: t.getPropertyValue("--p-color-button-primary-text-active"),
    colorButtonPrimaryTextHover: t.getPropertyValue("--p-color-button-primary-text-hover"),
    colorButtonSelectedBg: t.getPropertyValue("--p-color-button-selected-bg"),
    colorButtonSelectedBorder: t.getPropertyValue("--p-color-button-selected-border"),
    colorButtonSelectedText: t.getPropertyValue("--p-color-button-selected-text"),
    colorDivider: t.getPropertyValue("--p-color-divider"),
    colorFocusRing: t.getPropertyValue("--p-color-focus-ring"),
    colorFocusRingOffset: t.getPropertyValue("--p-color-focus-ring-offset"),
    colorInputBg: t.getPropertyValue("--p-color-input-bg"),
    colorInputBgFocus: t.getPropertyValue("--p-color-input-bg-focus"),
    colorInputBgInvalid: t.getPropertyValue("--p-color-input-bg-invalid"),
    colorInputBorder: t.getPropertyValue("--p-color-input-border"),
    colorInputBorderFocus: t.getPropertyValue("--p-color-input-border-focus"),
    colorInputBorderInvalid: t.getPropertyValue("--p-color-input-border-invalid"),
    colorInputCheckedBg: t.getPropertyValue("--p-color-input-checked-bg"),
    colorInputCheckedBorder: t.getPropertyValue("--p-color-input-checked-border"),
    colorInputCheckedText: t.getPropertyValue("--p-color-input-checked-text"),
    colorInputPlaceholder: t.getPropertyValue("--p-color-input-placeholder"),
    colorInputText: t.getPropertyValue("--p-color-input-text"),
    colorInputTextInvalidIcon: t.getPropertyValue("--p-color-input-text-invalid-icon"),
    colorLive: t.getPropertyValue("--p-color-live"),
    colorMessageErrorBg: t.getPropertyValue("--p-color-message-error-bg"),
    colorMessageErrorText: t.getPropertyValue("--p-color-message-error-text"),
    colorMessageInfoBg: t.getPropertyValue("--p-color-message-info-bg"),
    colorMessageInfoText: t.getPropertyValue("--p-color-message-info-text"),
    colorMessageSuccessBg: t.getPropertyValue("--p-color-message-success-bg"),
    colorMessageSuccessText: t.getPropertyValue("--p-color-message-success-text"),
    colorMessageWarningBg: t.getPropertyValue("--p-color-message-warning-bg"),
    colorMessageWarningText: t.getPropertyValue("--p-color-message-warning-text"),
    colorSelectableHover: t.getPropertyValue("--p-color-selectable-hover"),
    colorSelected: t.getPropertyValue("--p-color-selected"),
    colorSelectionHighlight: t.getPropertyValue("--p-color-selection-highlight"),
    colorSentimentNegative: t.getPropertyValue("--p-color-sentiment-negative"),
    colorSentimentNegativeHslValues: t.getPropertyValue("--p-destructive"),
    colorSentimentNegativeHue: t.getPropertyValue("--p-color-sentiment-negative-hue"),
    colorSentimentNegativeLightness: t.getPropertyValue("--p-color-sentiment-negative-lightness"),
    colorSentimentNegativeSaturation: t.getPropertyValue("--p-color-sentiment-negative-saturation"),
    colorSentimentNeutral: t.getPropertyValue("--p-color-sentiment-neutral"),
    colorSentimentNeutralHslValues: t.getPropertyValue("--p-neutral"),
    colorSentimentNeutralHue: t.getPropertyValue("--p-color-sentiment-neutral-hue"),
    colorSentimentNeutralLightness: t.getPropertyValue("--p-color-sentiment-neutral-lightness"),
    colorSentimentNeutralSaturation: t.getPropertyValue("--p-color-sentiment-neutral-saturation"),
    colorSentimentPositive: t.getPropertyValue("--p-color-sentiment-positive"),
    colorSentimentPositiveHslValues: t.getPropertyValue("--p-positive"),
    colorSentimentPositiveHue: t.getPropertyValue("--p-color-sentiment-positive-hue"),
    colorSentimentPositiveLightness: t.getPropertyValue("--p-color-sentiment-positive-lightness"),
    colorSentimentPositiveSaturation: t.getPropertyValue("--p-color-sentiment-positive-saturation"),
    colorSentimentWarning: t.getPropertyValue("--p-color-sentiment-warning"),
    colorSentimentWarningHslValues: t.getPropertyValue("--p-warning"),
    colorSentimentWarningHue: t.getPropertyValue("--p-color-sentiment-warning-hue"),
    colorSentimentWarningLightness: t.getPropertyValue("--p-color-sentiment-warning-lightness"),
    colorSentimentWarningSaturation: t.getPropertyValue("--p-color-sentiment-warning-saturation"),
    colorSyntaxAttribute: t.getPropertyValue("--p-color-syntax-attribute"),
    colorSyntaxComment: t.getPropertyValue("--p-color-syntax-comment"),
    colorSyntaxKeyword: t.getPropertyValue("--p-color-syntax-keyword"),
    colorSyntaxParameter: t.getPropertyValue("--p-color-syntax-parameter"),
    colorSyntaxSelector: t.getPropertyValue("--p-color-syntax-selector"),
    colorSyntaxSymbol: t.getPropertyValue("--p-color-syntax-symbol"),
    colorSyntaxTitle: t.getPropertyValue("--p-color-syntax-title"),
    colorTagBg: t.getPropertyValue("--p-color-tag-bg"),
    colorTagBorder: t.getPropertyValue("--p-color-tag-border"),
    colorTagText: t.getPropertyValue("--p-color-tag-text"),
    colorTextCode: t.getPropertyValue("--p-color-text-code"),
    colorTextDefault: t.getPropertyValue("--p-color-text-default"),
    colorTextInvalid: t.getPropertyValue("--p-color-text-invalid"),
    colorTextInverse: t.getPropertyValue("--p-color-text-inverse"),
    colorTextLink: t.getPropertyValue("--p-color-text-link"),
    colorTextSelected: t.getPropertyValue("--p-color-text-selected"),
    colorTextSubdued: t.getPropertyValue("--p-color-text-subdued"),
    colorToggleBg: t.getPropertyValue("--p-color-toggle-bg"),
    colorToggleBgChecked: t.getPropertyValue("--p-color-toggle-bg-checked"),
    colorToggleTrigger: t.getPropertyValue("--p-color-toggle-trigger")
  };
}
class m6 extends Error {
  constructor() {
    super("Wizard not found. Are you sure the component calling useWizard() exists within a <p-wizard>?");
  }
}
class Gh extends Error {
  constructor() {
    super("Wizard step not found. Are you sure that the parent <p-wizard> was given a step with the kebab case title given?");
  }
}
const W7 = Symbol("UseWizard");
function g6(t) {
  const n = z(!1), a = z(t), i = z(0), s = z(0), u = M(() => a.value[i.value]);
  function p() {
    const P = b(i.value) + 1;
    return E(P);
  }
  function g() {
    const P = b(i.value) - 1;
    return E(P);
  }
  function E(q) {
    const P = typeof q == "number" ? f(q) : w(q);
    return new Promise((k) => {
      n.value = !0, P < 0 && k([{ index: i.value, valid: !1 }]);
      const U = D(P);
      return k(Promise.all(U));
    }).then((k) => {
      const U = k.find(({ valid: Z }) => !Z);
      return h(U?.index ?? P), {
        success: !U,
        newIndex: i.value
      };
    }).finally(() => n.value = !1);
  }
  function h(q) {
    let P = q;
    q < 0 && (P = 0), q >= a.value.length && (P = a.value.length - 1), i.value = P, s.value = Math.max(s.value, P);
  }
  function f(q) {
    return q - 1;
  }
  function b(q) {
    return q + 1;
  }
  function w(q) {
    const P = typeof q == "object" ? q : x(q);
    return P ? a.value.indexOf(P) : -1;
  }
  function x(q) {
    return typeof q == "number" ? a.value[q] : a.value.find((P) => I0(P) === q);
  }
  function A(q, P) {
    const k = w(q);
    k !== -1 && a.value.splice(k, 1, P);
  }
  function D(q) {
    const P = q ?? i.value + 1;
    return a.value.slice(i.value, P).map(async ({ validate: k }, U) => ({
      valid: k ? await k() : !0,
      index: U + i.value
    }));
  }
  async function L(q) {
    const P = D(q);
    return (await Promise.all(P)).every(({ valid: U }) => U);
  }
  const $ = {
    steps: a,
    currentStepIndex: i,
    currentStep: u,
    furthestStepIndex: s,
    loading: n,
    next: p,
    previous: g,
    goto: E,
    getStepIndex: w,
    getStep: x,
    setStep: A,
    isValid: L
  };
  return Zl(W7, $), $;
}
function j7() {
  const t = Ui(W7);
  if (!t)
    throw new m6();
  return t;
}
const K7 = Symbol("UseWizardStep");
function f6(t) {
  if (!t) {
    const s = Ui(K7);
    if (!s)
      throw new Gh();
    return s;
  }
  const n = j7(), a = z(t), i = M(() => {
    const s = n.getStep(a.value);
    if (!s)
      throw new Gh();
    return s;
  });
  return {
    wizard: n,
    step: i,
    defineValidate: (s) => {
      n.setStep(a.value, {
        ...i.value,
        validate: s
      });
    }
  };
}
const h6 = /* @__PURE__ */ W({
  __name: "PAccordionContent",
  props: {
    forceMount: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  setup(t) {
    const n = t, { classes: a, styles: i, attrs: s } = Xa();
    return (u, p) => (c(), G(y(gS), oe(n, { class: "p-accordion-content" }), {
      default: N(() => [
        d("div", oe({
          class: ["pb-4 pt-0", y(a)],
          style: y(i)
        }, y(s)), [
          I(u.$slots, "default")
        ], 16)
      ]),
      _: 3
    }, 16));
  }
}), v6 = /* @__PURE__ */ W({
  __name: "PAccordionItem",
  props: {
    disabled: { type: Boolean },
    value: {},
    asChild: { type: Boolean },
    as: {}
  },
  setup(t) {
    const { classes: n, styles: a } = Xa(), i = t;
    return (s, u) => (c(), G(y(mS), oe(i, {
      class: ["border-b", y(n)],
      style: y(a)
    }), {
      default: N(() => [
        I(s.$slots, "default")
      ]),
      _: 3
    }, 16, ["class", "style"]));
  }
}), E6 = /* @__PURE__ */ W({
  __name: "PAccordionTrigger",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(t) {
    const { classes: n, styles: a } = Xa(), i = t;
    return (s, u) => {
      const p = ht("p-icon");
      return c(), G(y(fS), { class: "flex" }, {
        default: N(() => [
          ne(y(hS), oe(i, {
            class: ["p-accordion-trigger", y(n)],
            style: y(a)
          }), {
            default: N(() => [
              I(s.$slots, "default"),
              I(s.$slots, "icon", {}, () => [
                ne(p, {
                  icon: "ChevronDownIcon",
                  class: "p-accordion-trigger-icon"
                })
              ])
            ]),
            _: 3
          }, 16, ["style", "class"])
        ]),
        _: 3
      });
    };
  }
}), b6 = /* @__PURE__ */ W({
  __name: "PAccordion",
  props: {
    collapsible: { type: Boolean, default: !0 },
    disabled: { type: Boolean },
    dir: {},
    orientation: {},
    asChild: { type: Boolean },
    as: {},
    type: { default: "single" },
    modelValue: {},
    defaultValue: {},
    sections: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: n }) {
    const s = Wn(t, n);
    return (u, p) => (c(), G(y(_S), ve(we(y(s))), {
      default: N(() => [
        (c(!0), _(Qe, null, Ye(u.sections, (g) => (c(), G(v6, {
          key: g,
          value: g
        }, {
          default: N(() => [
            ne(E6, null, {
              default: N(() => [
                I(u.$slots, "heading", { section: g }, () => [
                  Ne(ye(g), 1)
                ])
              ]),
              _: 2
            }, 1024),
            ne(h6, null, {
              default: N(() => [
                I(u.$slots, "content", { section: g })
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1032, ["value"]))), 128))
      ]),
      _: 3
    }, 16));
  }
}), S6 = (t) => {
  t.component("PAccordion", b6);
}, w6 = /* @__PURE__ */ W({
  __name: "PAutoHeightTransition",
  setup(t) {
    function n(p) {
      if (!y2(p))
        return;
      const { width: g } = getComputedStyle(p);
      p.style.width = g, p.style.position = "absolute", p.style.visibility = "hidden", p.style.height = "auto";
      const { height: E } = getComputedStyle(p);
      p.style.width = "", p.style.position = "", p.style.visibility = "", p.style.height = "0", u(p), s(p, E);
    }
    function a(p) {
      y2(p) && (p.style.height = "auto");
    }
    function i(p) {
      if (!y2(p))
        return;
      const { height: g } = getComputedStyle(p);
      p.style.height = g, u(p), s(p, "0");
    }
    function s(p, g) {
      requestAnimationFrame(() => {
        p.style.height = g;
      });
    }
    function u(p) {
      return getComputedStyle(p).height;
    }
    return (p, g) => (c(), G(v0, {
      name: "expand",
      onEnter: n,
      onAfterEnter: a,
      onLeave: i
    }, {
      default: N(() => [
        I(p.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }));
  }
}), Wt = (t, n) => {
  const a = t.__vccOpts || t;
  for (const [i, s] of n)
    a[i] = s;
  return a;
}, Q7 = /* @__PURE__ */ Wt(w6, [["__scopeId", "data-v-17c00e78"]]), y6 = (t) => {
  t.component("PAutoHeightTransition", Q7);
};
function T6(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M4.26 10.147a60.438 60.438 0 0 0-.491 6.347A48.62 48.62 0 0 1 12 20.904a48.62 48.62 0 0 1 8.232-4.41 60.46 60.46 0 0 0-.491-6.347m-15.482 0a50.636 50.636 0 0 0-2.658-.813A59.906 59.906 0 0 1 12 3.493a59.903 59.903 0 0 1 10.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.717 50.717 0 0 1 12 13.489a50.702 50.702 0 0 1 7.74-3.342M6.75 15a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm0 0v-3.675A55.378 55.378 0 0 1 12 8.443m-7.007 11.55A5.981 5.981 0 0 0 6.75 15.75v-1.5"
    })
  ]);
}
function C6(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M10.5 6h9.75M10.5 6a1.5 1.5 0 1 1-3 0m3 0a1.5 1.5 0 1 0-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-9.75 0h9.75"
    })
  ]);
}
function x6(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6 13.5V3.75m0 9.75a1.5 1.5 0 0 1 0 3m0-3a1.5 1.5 0 0 0 0 3m0 3.75V16.5m12-3V3.75m0 9.75a1.5 1.5 0 0 1 0 3m0-3a1.5 1.5 0 0 0 0 3m0 3.75V16.5m-6-9V3.75m0 3.75a1.5 1.5 0 0 1 0 3m0-3a1.5 1.5 0 0 0 0 3m0 9.75V10.5"
    })
  ]);
}
function A6(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m20.25 7.5-.625 10.632a2.25 2.25 0 0 1-2.247 2.118H6.622a2.25 2.25 0 0 1-2.247-2.118L3.75 7.5m8.25 3v6.75m0 0-3-3m3 3 3-3M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125Z"
    })
  ]);
}
function R6(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m20.25 7.5-.625 10.632a2.25 2.25 0 0 1-2.247 2.118H6.622a2.25 2.25 0 0 1-2.247-2.118L3.75 7.5m6 4.125 2.25 2.25m0 0 2.25 2.25M12 13.875l2.25-2.25M12 13.875l-2.25 2.25M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125Z"
    })
  ]);
}
function O6(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m20.25 7.5-.625 10.632a2.25 2.25 0 0 1-2.247 2.118H6.622a2.25 2.25 0 0 1-2.247-2.118L3.75 7.5M10 11.25h4M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125Z"
    })
  ]);
}
function I6(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m9 12.75 3 3m0 0 3-3m-3 3v-7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    })
  ]);
}
function N6(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m19.5 4.5-15 15m0 0h11.25m-11.25 0V8.25"
    })
  ]);
}
function M6(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M7.5 7.5h-.75A2.25 2.25 0 0 0 4.5 9.75v7.5a2.25 2.25 0 0 0 2.25 2.25h7.5a2.25 2.25 0 0 0 2.25-2.25v-7.5a2.25 2.25 0 0 0-2.25-2.25h-.75m-6 3.75 3 3m0 0 3-3m-3 3V1.5m6 9h.75a2.25 2.25 0 0 1 2.25 2.25v7.5a2.25 2.25 0 0 1-2.25 2.25h-7.5a2.25 2.25 0 0 1-2.25-2.25v-.75"
    })
  ]);
}
function D6(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9 8.25H7.5a2.25 2.25 0 0 0-2.25 2.25v9a2.25 2.25 0 0 0 2.25 2.25h9a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25H15M9 12l3 3m0 0 3-3m-3 3V2.25"
    })
  ]);
}
function k6(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m4.5 4.5 15 15m0 0V8.25m0 11.25H8.25"
    })
  ]);
}
function L6(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3"
    })
  ]);
}
function P6(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M19.5 13.5 12 21m0 0-7.5-7.5M12 21V3"
    })
  ]);
}
function B6(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m11.25 9-3 3m0 0 3 3m-3-3h7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    })
  ]);
}
function F6(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15M12 9l-3 3m0 0 3 3m-3-3h12.75"
    })
  ]);
}
function U6(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15M12 9l-3 3m0 0 3 3m-3-3h12.75"
    })
  ]);
}
function $6(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M8.25 9V5.25A2.25 2.25 0 0 1 10.5 3h6a2.25 2.25 0 0 1 2.25 2.25v13.5A2.25 2.25 0 0 1 16.5 21h-6a2.25 2.25 0 0 1-2.25-2.25V15m-3 0-3-3m0 0 3-3m-3 3H15"
    })
  ]);
}
function V6(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18"
    })
  ]);
}
function H6(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M15.75 17.25 12 21m0 0-3.75-3.75M12 21V3"
    })
  ]);
}
function G6(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6.75 15.75 3 12m0 0 3.75-3.75M3 12h18"
    })
  ]);
}
function Y6(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M17.25 8.25 21 12m0 0-3.75 3.75M21 12H3"
    })
  ]);
}
function z6(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M8.25 6.75 12 3m0 0 3.75 3.75M12 3v18"
    })
  ]);
}
function Z6(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M19.5 12c0-1.232-.046-2.453-.138-3.662a4.006 4.006 0 0 0-3.7-3.7 48.678 48.678 0 0 0-7.324 0 4.006 4.006 0 0 0-3.7 3.7c-.017.22-.032.441-.046.662M19.5 12l3-3m-3 3-3-3m-12 3c0 1.232.046 2.453.138 3.662a4.006 4.006 0 0 0 3.7 3.7 48.656 48.656 0 0 0 7.324 0 4.006 4.006 0 0 0 3.7-3.7c.017-.22.032-.441.046-.662M4.5 12l3 3m-3-3-3 3"
    })
  ]);
}
function q6(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
    })
  ]);
}
function W6(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m12.75 15 3-3m0 0-3-3m3 3h-7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    })
  ]);
}
function j6(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M8.25 9V5.25A2.25 2.25 0 0 1 10.5 3h6a2.25 2.25 0 0 1 2.25 2.25v13.5A2.25 2.25 0 0 1 16.5 21h-6a2.25 2.25 0 0 1-2.25-2.25V15M12 9l3 3m0 0-3 3m3-3H2.25"
    })
  ]);
}
function K6(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9"
    })
  ]);
}
function Q6(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9"
    })
  ]);
}
function X6(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3"
    })
  ]);
}
function J6(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 4.5v15m0 0 6.75-6.75M12 19.5l-6.75-6.75"
    })
  ]);
}
function ex(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M19.5 12h-15m0 0 6.75 6.75M4.5 12l6.75-6.75"
    })
  ]);
}
function tx(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M4.5 12h15m0 0-6.75-6.75M19.5 12l-6.75 6.75"
    })
  ]);
}
function nx(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 19.5v-15m0 0-6.75 6.75M12 4.5l6.75 6.75"
    })
  ]);
}
function rx(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
    })
  ]);
}
function ax(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M2.25 6 9 12.75l4.286-4.286a11.948 11.948 0 0 1 4.306 6.43l.776 2.898m0 0 3.182-5.511m-3.182 5.51-5.511-3.181"
    })
  ]);
}
function ox(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M2.25 18 9 11.25l4.306 4.306a11.95 11.95 0 0 1 5.814-5.518l2.74-1.22m0 0-5.94-2.281m5.94 2.28-2.28 5.941"
    })
  ]);
}
function ix(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m7.49 12-3.75 3.75m0 0 3.75 3.75m-3.75-3.75h16.5V4.499"
    })
  ]);
}
function sx(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m16.49 12 3.75 3.75m0 0-3.75 3.75m3.75-3.75H3.74V4.499"
    })
  ]);
}
function lx(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m11.99 16.5-3.75 3.75m0 0L4.49 16.5m3.75 3.75V3.75h11.25"
    })
  ]);
}
function cx(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M11.99 7.5 8.24 3.75m0 0L4.49 7.5m3.75-3.75v16.499h11.25"
    })
  ]);
}
function ux(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m11.99 16.5 3.75 3.75m0 0 3.75-3.75m-3.75 3.75V3.75H4.49"
    })
  ]);
}
function dx(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m11.99 7.5 3.75-3.75m0 0 3.75 3.75m-3.75-3.75v16.499H4.49"
    })
  ]);
}
function _x(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M7.49 12 3.74 8.248m0 0 3.75-3.75m-3.75 3.75h16.5V19.5"
    })
  ]);
}
function px(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m16.49 12 3.75-3.751m0 0-3.75-3.75m3.75 3.75H3.74V19.5"
    })
  ]);
}
function mx(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m15 11.25-3-3m0 0-3 3m3-3v7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    })
  ]);
}
function gx(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m19.5 19.5-15-15m0 0v11.25m0-11.25h11.25"
    })
  ]);
}
function fx(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M7.5 7.5h-.75A2.25 2.25 0 0 0 4.5 9.75v7.5a2.25 2.25 0 0 0 2.25 2.25h7.5a2.25 2.25 0 0 0 2.25-2.25v-7.5a2.25 2.25 0 0 0-2.25-2.25h-.75m0-3-3-3m0 0-3 3m3-3v11.25m6-2.25h.75a2.25 2.25 0 0 1 2.25 2.25v7.5a2.25 2.25 0 0 1-2.25 2.25h-7.5a2.25 2.25 0 0 1-2.25-2.25v-.75"
    })
  ]);
}
function hx(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9 8.25H7.5a2.25 2.25 0 0 0-2.25 2.25v9a2.25 2.25 0 0 0 2.25 2.25h9a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25H15m0-3-3-3m0 0-3 3m3-3V15"
    })
  ]);
}
function vx(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m4.5 19.5 15-15m0 0H8.25m11.25 0v11.25"
    })
  ]);
}
function Ex(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5m-13.5-9L12 3m0 0 4.5 4.5M12 3v13.5"
    })
  ]);
}
function bx(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M4.5 10.5 12 3m0 0 7.5 7.5M12 3v18"
    })
  ]);
}
function Sx(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m15 15-6 6m0 0-6-6m6 6V9a6 6 0 0 1 12 0v3"
    })
  ]);
}
function wx(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9 15 3 9m0 0 6-6M3 9h12a6 6 0 0 1 0 12h-3"
    })
  ]);
}
function yx(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m15 15 6-6m0 0-6-6m6 6H9a6 6 0 0 0 0 12h3"
    })
  ]);
}
function Tx(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m9 9 6-6m0 0 6 6m-6-6v12a6 6 0 0 1-12 0v-3"
    })
  ]);
}
function Cx(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9 9V4.5M9 9H4.5M9 9 3.75 3.75M9 15v4.5M9 15H4.5M9 15l-5.25 5.25M15 9h4.5M15 9V4.5M15 9l5.25-5.25M15 15h4.5M15 15v4.5m0-4.5 5.25 5.25"
    })
  ]);
}
function xx(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M3.75 3.75v4.5m0-4.5h4.5m-4.5 0L9 9M3.75 20.25v-4.5m0 4.5h4.5m-4.5 0L9 15M20.25 3.75h-4.5m4.5 0v4.5m0-4.5L15 9m5.25 11.25h-4.5m4.5 0v-4.5m0 4.5L15 15"
    })
  ]);
}
function Ax(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M7.5 21 3 16.5m0 0L7.5 12M3 16.5h13.5m0-13.5L21 7.5m0 0L16.5 12M21 7.5H7.5"
    })
  ]);
}
function Rx(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M3 7.5 7.5 3m0 0L12 7.5M7.5 3v13.5m13.5 0L16.5 21m0 0L12 16.5m4.5 4.5V7.5"
    })
  ]);
}
function Ox(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M16.5 12a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm0 0c0 1.657 1.007 3 2.25 3S21 13.657 21 12a9 9 0 1 0-2.636 6.364M16.5 12V8.25"
    })
  ]);
}
function Ix(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 9.75 14.25 12m0 0 2.25 2.25M14.25 12l2.25-2.25M14.25 12 12 14.25m-2.58 4.92-6.374-6.375a1.125 1.125 0 0 1 0-1.59L9.42 4.83c.21-.211.497-.33.795-.33H19.5a2.25 2.25 0 0 1 2.25 2.25v10.5a2.25 2.25 0 0 1-2.25 2.25h-9.284c-.298 0-.585-.119-.795-.33Z"
    })
  ]);
}
function Nx(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M21 16.811c0 .864-.933 1.406-1.683.977l-7.108-4.061a1.125 1.125 0 0 1 0-1.954l7.108-4.061A1.125 1.125 0 0 1 21 8.689v8.122ZM11.25 16.811c0 .864-.933 1.406-1.683.977l-7.108-4.061a1.125 1.125 0 0 1 0-1.954l7.108-4.061a1.125 1.125 0 0 1 1.683.977v8.122Z"
    })
  ]);
}
function Mx(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M2.25 18.75a60.07 60.07 0 0 1 15.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 0 1 3 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 0 0-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 0 1-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 0 0 3 15h-.75M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm3 0h.008v.008H18V10.5Zm-12 0h.008v.008H6V10.5Z"
    })
  ]);
}
function Dx(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M3.75 9h16.5m-16.5 6.75h16.5"
    })
  ]);
}
function kx(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25H12"
    })
  ]);
}
function Lx(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M3.75 6.75h16.5M3.75 12h16.5M12 17.25h8.25"
    })
  ]);
}
function Px(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M3.75 6.75h16.5M3.75 12H12m-8.25 5.25h16.5"
    })
  ]);
}
function Bx(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
    })
  ]);
}
function Fx(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M3.75 5.25h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5"
    })
  ]);
}
function Ux(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M3 4.5h14.25M3 9h9.75M3 13.5h9.75m4.5-4.5v12m0 0-3.75-3.75M17.25 21 21 17.25"
    })
  ]);
}
function $x(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M3 4.5h14.25M3 9h9.75M3 13.5h5.25m5.25-.75L17.25 9m0 0L21 12.75M17.25 9v12"
    })
  ]);
}
function Vx(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M21 10.5h.375c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125H21M3.75 18h15A2.25 2.25 0 0 0 21 15.75v-6a2.25 2.25 0 0 0-2.25-2.25h-15A2.25 2.25 0 0 0 1.5 9.75v6A2.25 2.25 0 0 0 3.75 18Z"
    })
  ]);
}
function Hx(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M21 10.5h.375c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125H21M4.5 10.5H18V15H4.5v-4.5ZM3.75 18h15A2.25 2.25 0 0 0 21 15.75v-6a2.25 2.25 0 0 0-2.25-2.25h-15A2.25 2.25 0 0 0 1.5 9.75v6A2.25 2.25 0 0 0 3.75 18Z"
    })
  ]);
}
function Gx(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M21 10.5h.375c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125H21M4.5 10.5h6.75V15H4.5v-4.5ZM3.75 18h15A2.25 2.25 0 0 0 21 15.75v-6a2.25 2.25 0 0 0-2.25-2.25h-15A2.25 2.25 0 0 0 1.5 9.75v6A2.25 2.25 0 0 0 3.75 18Z"
    })
  ]);
}
function Yx(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9.75 3.104v5.714a2.25 2.25 0 0 1-.659 1.591L5 14.5M9.75 3.104c-.251.023-.501.05-.75.082m.75-.082a24.301 24.301 0 0 1 4.5 0m0 0v5.714c0 .597.237 1.17.659 1.591L19.8 15.3M14.25 3.104c.251.023.501.05.75.082M19.8 15.3l-1.57.393A9.065 9.065 0 0 1 12 15a9.065 9.065 0 0 0-6.23-.693L5 14.5m14.8.8 1.402 1.402c1.232 1.232.65 3.318-1.067 3.611A48.309 48.309 0 0 1 12 21c-2.773 0-5.491-.235-8.135-.687-1.718-.293-2.3-2.379-1.067-3.61L5 14.5"
    })
  ]);
}
function zx(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0M3.124 7.5A8.969 8.969 0 0 1 5.292 3m13.416 0a8.969 8.969 0 0 1 2.168 4.5"
    })
  ]);
}
function Zx(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9.143 17.082a24.248 24.248 0 0 0 3.844.148m-3.844-.148a23.856 23.856 0 0 1-5.455-1.31 8.964 8.964 0 0 0 2.3-5.542m3.155 6.852a3 3 0 0 0 5.667 1.97m1.965-2.277L21 21m-4.225-4.225a23.81 23.81 0 0 0 3.536-1.003A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6.53 6.53m10.245 10.245L6.53 6.53M3 3l3.53 3.53"
    })
  ]);
}
function qx(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0M10.5 8.25h3l-3 4.5h3"
    })
  ]);
}
function Wx(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0"
    })
  ]);
}
function jx(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linejoin": "round",
      d: "M6.75 3.744h-.753v8.25h7.125a4.125 4.125 0 0 0 0-8.25H6.75Zm0 0v.38m0 16.122h6.747a4.5 4.5 0 0 0 0-9.001h-7.5v9h.753Zm0 0v-.37m0-15.751h6a3.75 3.75 0 1 1 0 7.5h-6m0-7.5v7.5m0 0v8.25m0-8.25h6.375a4.125 4.125 0 0 1 0 8.25H6.75m.747-15.38h4.875a3.375 3.375 0 0 1 0 6.75H7.497v-6.75Zm0 7.5h5.25a3.75 3.75 0 0 1 0 7.5h-5.25v-7.5Z"
    })
  ]);
}
function Kx(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M11.412 15.655 9.75 21.75l3.745-4.012M9.257 13.5H3.75l2.659-2.849m2.048-2.194L14.25 2.25 12 10.5h8.25l-4.707 5.043M8.457 8.457 3 3m5.457 5.457 7.086 7.086m0 0L21 21"
    })
  ]);
}
function Qx(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m3.75 13.5 10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75Z"
    })
  ]);
}
function Xx(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 6.042A8.967 8.967 0 0 0 6 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 0 1 6 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 0 1 6-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0 0 18 18a8.967 8.967 0 0 0-6 2.292m0-14.25v14.25"
    })
  ]);
}
function Jx(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m3 3 1.664 1.664M21 21l-1.5-1.5m-5.485-1.242L12 17.25 4.5 21V8.742m.164-4.078a2.15 2.15 0 0 1 1.743-1.342 48.507 48.507 0 0 1 11.186 0c1.1.128 1.907 1.077 1.907 2.185V19.5M4.664 4.664 19.5 19.5"
    })
  ]);
}
function eA(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M16.5 3.75V16.5L12 14.25 7.5 16.5V3.75m9 0H18A2.25 2.25 0 0 1 20.25 6v12A2.25 2.25 0 0 1 18 20.25H6A2.25 2.25 0 0 1 3.75 18V6A2.25 2.25 0 0 1 6 3.75h1.5m9 0h-9"
    })
  ]);
}
function tA(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M17.593 3.322c1.1.128 1.907 1.077 1.907 2.185V21L12 17.25 4.5 21V5.507c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0 1 11.186 0Z"
    })
  ]);
}
function nA(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 0 0 .75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 0 0-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0 1 12 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 0 1-.673-.38m0 0A2.18 2.18 0 0 1 3 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 0 1 3.413-.387m7.5 0V5.25A2.25 2.25 0 0 0 13.5 3h-3a2.25 2.25 0 0 0-2.25 2.25v.894m7.5 0a48.667 48.667 0 0 0-7.5 0M12 12.75h.008v.008H12v-.008Z"
    })
  ]);
}
function rA(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 12.75c1.148 0 2.278.08 3.383.237 1.037.146 1.866.966 1.866 2.013 0 3.728-2.35 6.75-5.25 6.75S6.75 18.728 6.75 15c0-1.046.83-1.867 1.866-2.013A24.204 24.204 0 0 1 12 12.75Zm0 0c2.883 0 5.647.508 8.207 1.44a23.91 23.91 0 0 1-1.152 6.06M12 12.75c-2.883 0-5.647.508-8.208 1.44.125 2.104.52 4.136 1.153 6.06M12 12.75a2.25 2.25 0 0 0 2.248-2.354M12 12.75a2.25 2.25 0 0 1-2.248-2.354M12 8.25c.995 0 1.971-.08 2.922-.236.403-.066.74-.358.795-.762a3.778 3.778 0 0 0-.399-2.25M12 8.25c-.995 0-1.97-.08-2.922-.236-.402-.066-.74-.358-.795-.762a3.734 3.734 0 0 1 .4-2.253M12 8.25a2.25 2.25 0 0 0-2.248 2.146M12 8.25a2.25 2.25 0 0 1 2.248 2.146M8.683 5a6.032 6.032 0 0 1-1.155-1.002c.07-.63.27-1.222.574-1.747m.581 2.749A3.75 3.75 0 0 1 15.318 5m0 0c.427-.283.815-.62 1.155-.999a4.471 4.471 0 0 0-.575-1.752M4.921 6a24.048 24.048 0 0 0-.392 3.314c1.668.546 3.416.914 5.223 1.082M19.08 6c.205 1.08.337 2.187.392 3.314a23.882 23.882 0 0 1-5.223 1.082"
    })
  ]);
}
function aA(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 21v-8.25M15.75 21v-8.25M8.25 21v-8.25M3 9l9-6 9 6m-1.5 12V10.332A48.36 48.36 0 0 0 12 9.75c-2.551 0-5.056.2-7.5.582V21M3 21h18M12 6.75h.008v.008H12V6.75Z"
    })
  ]);
}
function oA(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21M3 3h12m-.75 4.5H21m-3.75 3.75h.008v.008h-.008v-.008Zm0 3h.008v.008h-.008v-.008Zm0 3h.008v.008h-.008v-.008Z"
    })
  ]);
}
function iA(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M3.75 21h16.5M4.5 3h15M5.25 3v18m13.5-18v18M9 6.75h1.5m-1.5 3h1.5m-1.5 3h1.5m3-6H15m-1.5 3H15m-1.5 3H15M9 21v-3.375c0-.621.504-1.125 1.125-1.125h3.75c.621 0 1.125.504 1.125 1.125V21"
    })
  ]);
}
function sA(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M13.5 21v-7.5a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75V21m-4.5 0H2.36m11.14 0H18m0 0h3.64m-1.39 0V9.349M3.75 21V9.349m0 0a3.001 3.001 0 0 0 3.75-.615A2.993 2.993 0 0 0 9.75 9.75c.896 0 1.7-.393 2.25-1.016a2.993 2.993 0 0 0 2.25 1.016c.896 0 1.7-.393 2.25-1.015a3.001 3.001 0 0 0 3.75.614m-16.5 0a3.004 3.004 0 0 1-.621-4.72l1.189-1.19A1.5 1.5 0 0 1 5.378 3h13.243a1.5 1.5 0 0 1 1.06.44l1.19 1.189a3 3 0 0 1-.621 4.72M6.75 18h3.75a.75.75 0 0 0 .75-.75V13.5a.75.75 0 0 0-.75-.75H6.75a.75.75 0 0 0-.75.75v3.75c0 .414.336.75.75.75Z"
    })
  ]);
}
function lA(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 8.25v-1.5m0 1.5c-1.355 0-2.697.056-4.024.166C6.845 8.51 6 9.473 6 10.608v2.513m6-4.871c1.355 0 2.697.056 4.024.166C17.155 8.51 18 9.473 18 10.608v2.513M15 8.25v-1.5m-6 1.5v-1.5m12 9.75-1.5.75a3.354 3.354 0 0 1-3 0 3.354 3.354 0 0 0-3 0 3.354 3.354 0 0 1-3 0 3.354 3.354 0 0 0-3 0 3.354 3.354 0 0 1-3 0L3 16.5m15-3.379a48.474 48.474 0 0 0-6-.371c-2.032 0-4.034.126-6 .371m12 0c.39.049.777.102 1.163.16 1.07.16 1.837 1.094 1.837 2.175v5.169c0 .621-.504 1.125-1.125 1.125H4.125A1.125 1.125 0 0 1 3 20.625v-5.17c0-1.08.768-2.014 1.837-2.174A47.78 47.78 0 0 1 6 13.12M12.265 3.11a.375.375 0 1 1-.53 0L12 2.845l.265.265Zm-3 0a.375.375 0 1 1-.53 0L9 2.845l.265.265Zm6 0a.375.375 0 1 1-.53 0L15 2.845l.265.265Z"
    })
  ]);
}
function cA(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M15.75 15.75V18m-7.5-6.75h.008v.008H8.25v-.008Zm0 2.25h.008v.008H8.25V13.5Zm0 2.25h.008v.008H8.25v-.008Zm0 2.25h.008v.008H8.25V18Zm2.498-6.75h.007v.008h-.007v-.008Zm0 2.25h.007v.008h-.007V13.5Zm0 2.25h.007v.008h-.007v-.008Zm0 2.25h.007v.008h-.007V18Zm2.504-6.75h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V13.5Zm0 2.25h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V18Zm2.498-6.75h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V13.5ZM8.25 6h7.5v2.25h-7.5V6ZM12 2.25c-1.892 0-3.758.11-5.593.322C5.307 2.7 4.5 3.65 4.5 4.757V19.5a2.25 2.25 0 0 0 2.25 2.25h10.5a2.25 2.25 0 0 0 2.25-2.25V4.757c0-1.108-.806-2.057-1.907-2.185A48.507 48.507 0 0 0 12 2.25Z"
    })
  ]);
}
function uA(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6.75 2.994v2.25m10.5-2.25v2.25m-14.252 13.5V7.491a2.25 2.25 0 0 1 2.25-2.25h13.5a2.25 2.25 0 0 1 2.25 2.25v11.251m-18 0a2.25 2.25 0 0 0 2.25 2.25h13.5a2.25 2.25 0 0 0 2.25-2.25m-18 0v-7.5a2.25 2.25 0 0 1 2.25-2.25h13.5a2.25 2.25 0 0 1 2.25 2.25v7.5m-6.75-6h2.25m-9 2.25h4.5m.002-2.25h.005v.006H12v-.006Zm-.001 4.5h.006v.006h-.006v-.005Zm-2.25.001h.005v.006H9.75v-.006Zm-2.25 0h.005v.005h-.006v-.005Zm6.75-2.247h.005v.005h-.005v-.005Zm0 2.247h.006v.006h-.006v-.006Zm2.25-2.248h.006V15H16.5v-.005Z"
    })
  ]);
}
function dA(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z"
    })
  ]);
}
function _A(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5"
    })
  ]);
}
function pA(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6.827 6.175A2.31 2.31 0 0 1 5.186 7.23c-.38.054-.757.112-1.134.175C2.999 7.58 2.25 8.507 2.25 9.574V18a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9.574c0-1.067-.75-1.994-1.802-2.169a47.865 47.865 0 0 0-1.134-.175 2.31 2.31 0 0 1-1.64-1.055l-.822-1.316a2.192 2.192 0 0 0-1.736-1.039 48.774 48.774 0 0 0-5.232 0 2.192 2.192 0 0 0-1.736 1.039l-.821 1.316Z"
    }),
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M16.5 12.75a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM18.75 10.5h.008v.008h-.008V10.5Z"
    })
  ]);
}
function mA(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M7.5 14.25v2.25m3-4.5v4.5m3-6.75v6.75m3-9v9M6 20.25h12A2.25 2.25 0 0 0 20.25 18V6A2.25 2.25 0 0 0 18 3.75H6A2.25 2.25 0 0 0 3.75 6v12A2.25 2.25 0 0 0 6 20.25Z"
    })
  ]);
}
function gA(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 0 1 3 19.875v-6.75ZM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V8.625ZM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V4.125Z"
    })
  ]);
}
function fA(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M10.5 6a7.5 7.5 0 1 0 7.5 7.5h-7.5V6Z"
    }),
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M13.5 10.5H21A7.5 7.5 0 0 0 13.5 3v7.5Z"
    })
  ]);
}
function hA(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 0 1 .865-.501 48.172 48.172 0 0 0 3.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z"
    })
  ]);
}
function vA(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M2.25 12.76c0 1.6 1.123 2.994 2.707 3.227 1.068.157 2.148.279 3.238.364.466.037.893.281 1.153.671L12 21l2.652-3.978c.26-.39.687-.634 1.153-.67 1.09-.086 2.17-.208 3.238-.365 1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z"
    })
  ]);
}
function EA(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M8.625 9.75a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 0 1 .778-.332 48.294 48.294 0 0 0 5.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z"
    })
  ]);
}
function bA(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M20.25 8.511c.884.284 1.5 1.128 1.5 2.097v4.286c0 1.136-.847 2.1-1.98 2.193-.34.027-.68.052-1.02.072v3.091l-3-3c-1.354 0-2.694-.055-4.02-.163a2.115 2.115 0 0 1-.825-.242m9.345-8.334a2.126 2.126 0 0 0-.476-.095 48.64 48.64 0 0 0-8.048 0c-1.131.094-1.976 1.057-1.976 2.192v4.286c0 .837.46 1.58 1.155 1.951m9.345-8.334V6.637c0-1.621-1.152-3.026-2.76-3.235A48.455 48.455 0 0 0 11.25 3c-2.115 0-4.198.137-6.24.402-1.608.209-2.76 1.614-2.76 3.235v6.226c0 1.621 1.152 3.026 2.76 3.235.577.075 1.157.14 1.74.194V21l4.155-4.155"
    })
  ]);
}
function SA(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M2.25 12.76c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.076-4.076a1.526 1.526 0 0 1 1.037-.443 48.282 48.282 0 0 0 5.68-.494c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z"
    })
  ]);
}
function wA(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M8.625 12a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375M21 12c0 4.556-4.03 8.25-9 8.25a9.764 9.764 0 0 1-2.555-.337A5.972 5.972 0 0 1 5.41 20.97a5.969 5.969 0 0 1-.474-.065 4.48 4.48 0 0 0 .978-2.025c.09-.457-.133-.901-.467-1.226C3.93 16.178 3 14.189 3 12c0-4.556 4.03-8.25 9-8.25s9 3.694 9 8.25Z"
    })
  ]);
}
function yA(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 20.25c4.97 0 9-3.694 9-8.25s-4.03-8.25-9-8.25S3 7.444 3 12c0 2.104.859 4.023 2.273 5.48.432.447.74 1.04.586 1.641a4.483 4.483 0 0 1-.923 1.785A5.969 5.969 0 0 0 6 21c1.282 0 2.47-.402 3.445-1.087.81.22 1.668.337 2.555.337Z"
    })
  ]);
}
function TA(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9 12.75 11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 0 1-1.043 3.296 3.745 3.745 0 0 1-3.296 1.043A3.745 3.745 0 0 1 12 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 0 1-3.296-1.043 3.745 3.745 0 0 1-1.043-3.296A3.745 3.745 0 0 1 3 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 0 1 1.043-3.296 3.746 3.746 0 0 1 3.296-1.043A3.746 3.746 0 0 1 12 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 0 1 3.296 1.043 3.746 3.746 0 0 1 1.043 3.296A3.745 3.745 0 0 1 21 12Z"
    })
  ]);
}
function CA(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    })
  ]);
}
function xA(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m4.5 12.75 6 6 9-13.5"
    })
  ]);
}
function AA(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m4.5 5.25 7.5 7.5 7.5-7.5m-15 6 7.5 7.5 7.5-7.5"
    })
  ]);
}
function RA(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m18.75 4.5-7.5 7.5 7.5 7.5m-6-15L5.25 12l7.5 7.5"
    })
  ]);
}
function OA(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m5.25 4.5 7.5 7.5-7.5 7.5m6-15 7.5 7.5-7.5 7.5"
    })
  ]);
}
function IA(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m4.5 18.75 7.5-7.5 7.5 7.5"
    }),
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m4.5 12.75 7.5-7.5 7.5 7.5"
    })
  ]);
}
function NA(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m19.5 8.25-7.5 7.5-7.5-7.5"
    })
  ]);
}
function MA(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M15.75 19.5 8.25 12l7.5-7.5"
    })
  ]);
}
function DA(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m8.25 4.5 7.5 7.5-7.5 7.5"
    })
  ]);
}
function kA(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M8.25 15 12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"
    })
  ]);
}
function LA(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m4.5 15.75 7.5-7.5 7.5 7.5"
    })
  ]);
}
function PA(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M20.25 6.375c0 2.278-3.694 4.125-8.25 4.125S3.75 8.653 3.75 6.375m16.5 0c0-2.278-3.694-4.125-8.25-4.125S3.75 4.097 3.75 6.375m16.5 0v11.25c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125V6.375m16.5 0v3.75m-16.5-3.75v3.75m16.5 0v3.75C20.25 16.153 16.556 18 12 18s-8.25-1.847-8.25-4.125v-3.75m16.5 0c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125"
    })
  ]);
}
function BA(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M11.35 3.836c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m8.9-4.414c.376.023.75.05 1.124.08 1.131.094 1.976 1.057 1.976 2.192V16.5A2.25 2.25 0 0 1 18 18.75h-2.25m-7.5-10.5H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V18.75m-7.5-10.5h6.375c.621 0 1.125.504 1.125 1.125v9.375m-8.25-3 1.5 1.5 3-3.75"
    })
  ]);
}
function FA(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25ZM6.75 12h.008v.008H6.75V12Zm0 3h.008v.008H6.75V15Zm0 3h.008v.008H6.75V18Z"
    })
  ]);
}
function UA(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M8.25 7.5V6.108c0-1.135.845-2.098 1.976-2.192.373-.03.748-.057 1.123-.08M15.75 18H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08M15.75 18.75v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5A3.375 3.375 0 0 0 6.375 7.5H5.25m11.9-3.664A2.251 2.251 0 0 0 15 2.25h-1.5a2.251 2.251 0 0 0-2.15 1.586m5.8 0c.065.21.1.433.1.664v.75h-6V4.5c0-.231.035-.454.1-.664M6.75 7.5H4.875c-.621 0-1.125.504-1.125 1.125v12c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V16.5a9 9 0 0 0-9-9Z"
    })
  ]);
}
function $A(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M15.666 3.888A2.25 2.25 0 0 0 13.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 0 1-.75.75H9a.75.75 0 0 1-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 0 1-2.25 2.25H6.75A2.25 2.25 0 0 1 4.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 0 1 1.927-.184"
    })
  ]);
}
function VA(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    })
  ]);
}
function HA(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 9.75v6.75m0 0-3-3m3 3 3-3m-8.25 6a4.5 4.5 0 0 1-1.41-8.775 5.25 5.25 0 0 1 10.233-2.33 3 3 0 0 1 3.758 3.848A3.752 3.752 0 0 1 18 19.5H6.75Z"
    })
  ]);
}
function GA(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 16.5V9.75m0 0 3 3m-3-3-3 3M6.75 19.5a4.5 4.5 0 0 1-1.41-8.775 5.25 5.25 0 0 1 10.233-2.33 3 3 0 0 1 3.758 3.848A3.752 3.752 0 0 1 18 19.5H6.75Z"
    })
  ]);
}
function YA(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M2.25 15a4.5 4.5 0 0 0 4.5 4.5H18a3.75 3.75 0 0 0 1.332-7.257 3 3 0 0 0-3.758-3.848 5.25 5.25 0 0 0-10.233 2.33A4.502 4.502 0 0 0 2.25 15Z"
    })
  ]);
}
function zA(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M14.25 9.75 16.5 12l-2.25 2.25m-4.5 0L7.5 12l2.25-2.25M6 20.25h12A2.25 2.25 0 0 0 20.25 18V6A2.25 2.25 0 0 0 18 3.75H6A2.25 2.25 0 0 0 3.75 6v12A2.25 2.25 0 0 0 6 20.25Z"
    })
  ]);
}
function ZA(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M17.25 6.75 22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3-4.5 16.5"
    })
  ]);
}
function qA(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.325.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 0 1 1.37.49l1.296 2.247a1.125 1.125 0 0 1-.26 1.431l-1.003.827c-.293.241-.438.613-.43.992a7.723 7.723 0 0 1 0 .255c-.008.378.137.75.43.991l1.004.827c.424.35.534.955.26 1.43l-1.298 2.247a1.125 1.125 0 0 1-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.47 6.47 0 0 1-.22.128c-.331.183-.581.495-.644.869l-.213 1.281c-.09.543-.56.94-1.11.94h-2.594c-.55 0-1.019-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 0 1-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 0 1-1.369-.49l-1.297-2.247a1.125 1.125 0 0 1 .26-1.431l1.004-.827c.292-.24.437-.613.43-.991a6.932 6.932 0 0 1 0-.255c.007-.38-.138-.751-.43-.992l-1.004-.827a1.125 1.125 0 0 1-.26-1.43l1.297-2.247a1.125 1.125 0 0 1 1.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.086.22-.128.332-.183.582-.495.644-.869l.214-1.28Z"
    }),
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
    })
  ]);
}
function WA(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M10.343 3.94c.09-.542.56-.94 1.11-.94h1.093c.55 0 1.02.398 1.11.94l.149.894c.07.424.384.764.78.93.398.164.855.142 1.205-.108l.737-.527a1.125 1.125 0 0 1 1.45.12l.773.774c.39.389.44 1.002.12 1.45l-.527.737c-.25.35-.272.806-.107 1.204.165.397.505.71.93.78l.893.15c.543.09.94.559.94 1.109v1.094c0 .55-.397 1.02-.94 1.11l-.894.149c-.424.07-.764.383-.929.78-.165.398-.143.854.107 1.204l.527.738c.32.447.269 1.06-.12 1.45l-.774.773a1.125 1.125 0 0 1-1.449.12l-.738-.527c-.35-.25-.806-.272-1.203-.107-.398.165-.71.505-.781.929l-.149.894c-.09.542-.56.94-1.11.94h-1.094c-.55 0-1.019-.398-1.11-.94l-.148-.894c-.071-.424-.384-.764-.781-.93-.398-.164-.854-.142-1.204.108l-.738.527c-.447.32-1.06.269-1.45-.12l-.773-.774a1.125 1.125 0 0 1-.12-1.45l.527-.737c.25-.35.272-.806.108-1.204-.165-.397-.506-.71-.93-.78l-.894-.15c-.542-.09-.94-.56-.94-1.109v-1.094c0-.55.398-1.02.94-1.11l.894-.149c.424-.07.765-.383.93-.78.165-.398.143-.854-.108-1.204l-.526-.738a1.125 1.125 0 0 1 .12-1.45l.773-.773a1.125 1.125 0 0 1 1.45-.12l.737.527c.35.25.807.272 1.204.107.397-.165.71-.505.78-.929l.15-.894Z"
    }),
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
    })
  ]);
}
function jA(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M4.5 12a7.5 7.5 0 0 0 15 0m-15 0a7.5 7.5 0 1 1 15 0m-15 0H3m16.5 0H21m-1.5 0H12m-8.457 3.077 1.41-.513m14.095-5.13 1.41-.513M5.106 17.785l1.15-.964m11.49-9.642 1.149-.964M7.501 19.795l.75-1.3m7.5-12.99.75-1.3m-6.063 16.658.26-1.477m2.605-14.772.26-1.477m0 17.726-.26-1.477M10.698 4.614l-.26-1.477M16.5 19.794l-.75-1.299M7.5 4.205 12 12m6.894 5.785-1.149-.964M6.256 7.178l-1.15-.964m15.352 8.864-1.41-.513M4.954 9.435l-1.41-.514M12.002 12l-3.75 6.495"
    })
  ]);
}
function KA(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m6.75 7.5 3 2.25-3 2.25m4.5 0h3m-9 8.25h13.5A2.25 2.25 0 0 0 21 18V6a2.25 2.25 0 0 0-2.25-2.25H5.25A2.25 2.25 0 0 0 3 6v12a2.25 2.25 0 0 0 2.25 2.25Z"
    })
  ]);
}
function QA(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9 17.25v1.007a3 3 0 0 1-.879 2.122L7.5 21h9l-.621-.621A3 3 0 0 1 15 18.257V17.25m6-12V15a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 15V5.25m18 0A2.25 2.25 0 0 0 18.75 3H5.25A2.25 2.25 0 0 0 3 5.25m18 0V12a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 12V5.25"
    })
  ]);
}
function XA(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M8.25 3v1.5M4.5 8.25H3m18 0h-1.5M4.5 12H3m18 0h-1.5m-15 3.75H3m18 0h-1.5M8.25 19.5V21M12 3v1.5m0 15V21m3.75-18v1.5m0 15V21m-9-1.5h10.5a2.25 2.25 0 0 0 2.25-2.25V6.75a2.25 2.25 0 0 0-2.25-2.25H6.75A2.25 2.25 0 0 0 4.5 6.75v10.5a2.25 2.25 0 0 0 2.25 2.25Zm.75-12h9v9h-9v-9Z"
    })
  ]);
}
function JA(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z"
    })
  ]);
}
function eR(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m21 7.5-2.25-1.313M21 7.5v2.25m0-2.25-2.25 1.313M3 7.5l2.25-1.313M3 7.5l2.25 1.313M3 7.5v2.25m9 3 2.25-1.313M12 12.75l-2.25-1.313M12 12.75V15m0 6.75 2.25-1.313M12 21.75V19.5m0 2.25-2.25-1.313m0-16.875L12 2.25l2.25 1.313M21 14.25v2.25l-2.25 1.313m-13.5 0L3 16.5v-2.25"
    })
  ]);
}
function tR(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m21 7.5-9-5.25L3 7.5m18 0-9 5.25m9-5.25v9l-9 5.25M3 7.5l9 5.25M3 7.5v9l9 5.25m0-9v9"
    })
  ]);
}
function nR(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m8.25 7.5.415-.207a.75.75 0 0 1 1.085.67V10.5m0 0h6m-6 0h-1.5m1.5 0v5.438c0 .354.161.697.473.865a3.751 3.751 0 0 0 5.452-2.553c.083-.409-.263-.75-.68-.75h-.745M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    })
  ]);
}
function rR(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    })
  ]);
}
function aR(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M14.25 7.756a4.5 4.5 0 1 0 0 8.488M7.5 10.5h5.25m-5.25 3h5.25M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    })
  ]);
}
function oR(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M14.121 7.629A3 3 0 0 0 9.017 9.43c-.023.212-.002.425.028.636l.506 3.541a4.5 4.5 0 0 1-.43 2.65L9 16.5l1.539-.513a2.25 2.25 0 0 1 1.422 0l.655.218a2.25 2.25 0 0 0 1.718-.122L15 15.75M8.25 12H12m9 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    })
  ]);
}
function iR(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M15 8.25H9m6 3H9m3 6-3-3h1.5a3 3 0 1 0 0-6M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    })
  ]);
}
function sR(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m9 7.5 3 4.5m0 0 3-4.5M12 12v5.25M15 12H9m6 3H9m12-3a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    })
  ]);
}
function lR(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M15.042 21.672 13.684 16.6m0 0-2.51 2.225.569-9.47 5.227 7.917-3.286-.672ZM12 2.25V4.5m5.834.166-1.591 1.591M20.25 10.5H18M7.757 14.743l-1.59 1.59M6 10.5H3.75m4.007-4.243-1.59-1.59"
    })
  ]);
}
function cR(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M15.042 21.672 13.684 16.6m0 0-2.51 2.225.569-9.47 5.227 7.917-3.286-.672Zm-7.518-.267A8.25 8.25 0 1 1 20.25 10.5M8.288 14.212A5.25 5.25 0 1 1 17.25 10.5"
    })
  ]);
}
function uR(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M10.5 1.5H8.25A2.25 2.25 0 0 0 6 3.75v16.5a2.25 2.25 0 0 0 2.25 2.25h7.5A2.25 2.25 0 0 0 18 20.25V3.75a2.25 2.25 0 0 0-2.25-2.25H13.5m-3 0V3h3V1.5m-3 0h3m-3 18.75h3"
    })
  ]);
}
function dR(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M10.5 19.5h3m-6.75 2.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-15a2.25 2.25 0 0 0-2.25-2.25H6.75A2.25 2.25 0 0 0 4.5 4.5v15a2.25 2.25 0 0 0 2.25 2.25Z"
    })
  ]);
}
function _R(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M4.499 11.998h15m-7.5-6.75h.008v.008h-.008v-.008Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0ZM12 18.751h.007v.007H12v-.007Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
    })
  ]);
}
function pR(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m.75 12 3 3m0 0 3-3m-3 3v-6m-1.5-9H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
    })
  ]);
}
function mR(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m6.75 12-3-3m0 0-3 3m3-3v6m-1.5-15H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
    })
  ]);
}
function gR(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25M9 16.5v.75m3-3v3M15 12v5.25m-4.5-15H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
    })
  ]);
}
function fR(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M10.125 2.25h-4.5c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125v-9M10.125 2.25h.375a9 9 0 0 1 9 9v.375M10.125 2.25A3.375 3.375 0 0 1 13.5 5.625v1.5c0 .621.504 1.125 1.125 1.125h1.5a3.375 3.375 0 0 1 3.375 3.375M9 15l2.25 2.25L15 12"
    })
  ]);
}
function hR(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 8.25.22-.22a.75.75 0 0 1 1.28.53v6.441c0 .472.214.934.64 1.137a3.75 3.75 0 0 0 4.994-1.77c.205-.428-.152-.868-.627-.868h-.507m-6-2.25h7.5M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
    })
  ]);
}
function vR(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m3.75 9v7.5m2.25-6.466a9.016 9.016 0 0 0-3.461-.203c-.536.072-.974.478-1.021 1.017a4.559 4.559 0 0 0-.018.402c0 .464.336.844.775.994l2.95 1.012c.44.15.775.53.775.994 0 .136-.006.27-.018.402-.047.539-.485.945-1.021 1.017a9.077 9.077 0 0 1-3.461-.203M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
    })
  ]);
}
function ER(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 11.625h4.5m-4.5 2.25h4.5m2.121 1.527c-1.171 1.464-3.07 1.464-4.242 0-1.172-1.465-1.172-3.84 0-5.304 1.171-1.464 3.07-1.464 4.242 0M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
    })
  ]);
}
function bR(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m6.621 9.879a3 3 0 0 0-5.02 2.897l.164.609a4.5 4.5 0 0 1-.108 2.676l-.157.439.44-.22a2.863 2.863 0 0 1 2.185-.155c.72.24 1.507.184 2.186-.155L15 18M8.25 15.75H12m-1.5-13.5H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
    })
  ]);
}
function SR(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 9h3.75m-4.5 2.625h4.5M12 18.75 9.75 16.5h.375a2.625 2.625 0 0 0 0-5.25H9.75m.75-9H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
    })
  ]);
}
function wR(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m1.5 9 2.25 3m0 0 2.25-3m-2.25 3v4.5M9.75 15h4.5m-4.5 2.25h4.5m-3.75-15H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
    })
  ]);
}
function yR(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75"
    })
  ]);
}
function TR(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m5.231 13.481L15 17.25m-4.5-15H5.625c-.621 0-1.125.504-1.125 1.125v16.5c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Zm3.75 11.625a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z"
    })
  ]);
}
function CR(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m6.75 12H9m1.5-12H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
    })
  ]);
}
function xR(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m3.75 9v6m3-3H9m1.5-12H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
    })
  ]);
}
function AR(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
    })
  ]);
}
function RR(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
    })
  ]);
}
function OR(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M8.625 12a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    })
  ]);
}
function IR(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM12.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM18.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"
    })
  ]);
}
function NR(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 6.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 12.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 18.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Z"
    })
  ]);
}
function MR(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M21.75 9v.906a2.25 2.25 0 0 1-1.183 1.981l-6.478 3.488M2.25 9v.906a2.25 2.25 0 0 0 1.183 1.981l6.478 3.488m8.839 2.51-4.66-2.51m0 0-1.023-.55a2.25 2.25 0 0 0-2.134 0l-1.022.55m0 0-4.661 2.51m16.5 1.615a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V8.844a2.25 2.25 0 0 1 1.183-1.981l7.5-4.039a2.25 2.25 0 0 1 2.134 0l7.5 4.039a2.25 2.25 0 0 1 1.183 1.98V19.5Z"
    })
  ]);
}
function DR(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75"
    })
  ]);
}
function kR(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M4.499 8.248h15m-15 7.501h15"
    })
  ]);
}
function LR(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z"
    })
  ]);
}
function PR(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
    })
  ]);
}
function BR(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m15 11.25 1.5 1.5.75-.75V8.758l2.276-.61a3 3 0 1 0-3.675-3.675l-.61 2.277H12l-.75.75 1.5 1.5M15 11.25l-8.47 8.47c-.34.34-.8.53-1.28.53s-.94.19-1.28.53l-.97.97-.75-.75.97-.97c.34-.34.53-.8.53-1.28s.19-.94.53-1.28L12.75 9M15 11.25 12.75 9"
    })
  ]);
}
function FR(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"
    })
  ]);
}
function UR(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
    }),
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
    })
  ]);
}
function $R(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M15.182 16.318A4.486 4.486 0 0 0 12.016 15a4.486 4.486 0 0 0-3.198 1.318M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0ZM9.75 9.75c0 .414-.168.75-.375.75S9 10.164 9 9.75 9.168 9 9.375 9s.375.336.375.75Zm-.375 0h.008v.015h-.008V9.75Zm5.625 0c0 .414-.168.75-.375.75s-.375-.336-.375-.75.168-.75.375-.75.375.336.375.75Zm-.375 0h.008v.015h-.008V9.75Z"
    })
  ]);
}
function VR(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M15.182 15.182a4.5 4.5 0 0 1-6.364 0M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0ZM9.75 9.75c0 .414-.168.75-.375.75S9 10.164 9 9.75 9.168 9 9.375 9s.375.336.375.75Zm-.375 0h.008v.015h-.008V9.75Zm5.625 0c0 .414-.168.75-.375.75s-.375-.336-.375-.75.168-.75.375-.75.375.336.375.75Zm-.375 0h.008v.015h-.008V9.75Z"
    })
  ]);
}
function HR(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 0 1-1.125-1.125M3.375 19.5h1.5C5.496 19.5 6 18.996 6 18.375m-3.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-1.5A1.125 1.125 0 0 1 18 18.375M20.625 4.5H3.375m17.25 0c.621 0 1.125.504 1.125 1.125M20.625 4.5h-1.5C18.504 4.5 18 5.004 18 5.625m3.75 0v1.5c0 .621-.504 1.125-1.125 1.125M3.375 4.5c-.621 0-1.125.504-1.125 1.125M3.375 4.5h1.5C5.496 4.5 6 5.004 6 5.625m-3.75 0v1.5c0 .621.504 1.125 1.125 1.125m0 0h1.5m-1.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m1.5-3.75C5.496 8.25 6 7.746 6 7.125v-1.5M4.875 8.25C5.496 8.25 6 8.754 6 9.375v1.5m0-5.25v5.25m0-5.25C6 5.004 6.504 4.5 7.125 4.5h9.75c.621 0 1.125.504 1.125 1.125m1.125 2.625h1.5m-1.5 0A1.125 1.125 0 0 1 18 7.125v-1.5m1.125 2.625c-.621 0-1.125.504-1.125 1.125v1.5m2.625-2.625c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125M18 5.625v5.25M7.125 12h9.75m-9.75 0A1.125 1.125 0 0 1 6 10.875M7.125 12C6.504 12 6 12.504 6 13.125m0-2.25C6 11.496 5.496 12 4.875 12M18 10.875c0 .621-.504 1.125-1.125 1.125M18 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m-12 5.25v-5.25m0 5.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125m-12 0v-1.5c0-.621-.504-1.125-1.125-1.125M18 18.375v-5.25m0 5.25v-1.5c0-.621.504-1.125 1.125-1.125M18 13.125v1.5c0 .621.504 1.125 1.125 1.125M18 13.125c0-.621.504-1.125 1.125-1.125M6 13.125v1.5c0 .621-.504 1.125-1.125 1.125M6 13.125C6 12.504 5.496 12 4.875 12m-1.5 0h1.5m-1.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M19.125 12h1.5m0 0c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h1.5m14.25 0h1.5"
    })
  ]);
}
function GR(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M7.864 4.243A7.5 7.5 0 0 1 19.5 10.5c0 2.92-.556 5.709-1.568 8.268M5.742 6.364A7.465 7.465 0 0 0 4.5 10.5a7.464 7.464 0 0 1-1.15 3.993m1.989 3.559A11.209 11.209 0 0 0 8.25 10.5a3.75 3.75 0 1 1 7.5 0c0 .527-.021 1.049-.064 1.565M12 10.5a14.94 14.94 0 0 1-3.6 9.75m6.633-4.596a18.666 18.666 0 0 1-2.485 5.33"
    })
  ]);
}
function YR(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M15.362 5.214A8.252 8.252 0 0 1 12 21 8.25 8.25 0 0 1 6.038 7.047 8.287 8.287 0 0 0 9 9.601a8.983 8.983 0 0 1 3.361-6.867 8.21 8.21 0 0 0 3 2.48Z"
    }),
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 18a3.75 3.75 0 0 0 .495-7.468 5.99 5.99 0 0 0-1.925 3.547 5.975 5.975 0 0 1-2.133-1.001A3.75 3.75 0 0 0 12 18Z"
    })
  ]);
}
function zR(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M3 3v1.5M3 21v-6m0 0 2.77-.693a9 9 0 0 1 6.208.682l.108.054a9 9 0 0 0 6.086.71l3.114-.732a48.524 48.524 0 0 1-.005-10.499l-3.11.732a9 9 0 0 1-6.085-.711l-.108-.054a9 9 0 0 0-6.208-.682L3 4.5M3 15V4.5"
    })
  ]);
}
function ZR(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m9 13.5 3 3m0 0 3-3m-3 3v-6m1.06-4.19-2.12-2.12a1.5 1.5 0 0 0-1.061-.44H4.5A2.25 2.25 0 0 0 2.25 6v12a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9a2.25 2.25 0 0 0-2.25-2.25h-5.379a1.5 1.5 0 0 1-1.06-.44Z"
    })
  ]);
}
function qR(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M15 13.5H9m4.06-7.19-2.12-2.12a1.5 1.5 0 0 0-1.061-.44H4.5A2.25 2.25 0 0 0 2.25 6v12a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9a2.25 2.25 0 0 0-2.25-2.25h-5.379a1.5 1.5 0 0 1-1.06-.44Z"
    })
  ]);
}
function WR(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M3.75 9.776c.112-.017.227-.026.344-.026h15.812c.117 0 .232.009.344.026m-16.5 0a2.25 2.25 0 0 0-1.883 2.542l.857 6a2.25 2.25 0 0 0 2.227 1.932H19.05a2.25 2.25 0 0 0 2.227-1.932l.857-6a2.25 2.25 0 0 0-1.883-2.542m-16.5 0V6A2.25 2.25 0 0 1 6 3.75h3.879a1.5 1.5 0 0 1 1.06.44l2.122 2.12a1.5 1.5 0 0 0 1.06.44H18A2.25 2.25 0 0 1 20.25 9v.776"
    })
  ]);
}
function jR(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 10.5v6m3-3H9m4.06-7.19-2.12-2.12a1.5 1.5 0 0 0-1.061-.44H4.5A2.25 2.25 0 0 0 2.25 6v12a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9a2.25 2.25 0 0 0-2.25-2.25h-5.379a1.5 1.5 0 0 1-1.06-.44Z"
    })
  ]);
}
function KR(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M2.25 12.75V12A2.25 2.25 0 0 1 4.5 9.75h15A2.25 2.25 0 0 1 21.75 12v.75m-8.69-6.44-2.12-2.12a1.5 1.5 0 0 0-1.061-.44H4.5A2.25 2.25 0 0 0 2.25 6v12a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9a2.25 2.25 0 0 0-2.25-2.25h-5.379a1.5 1.5 0 0 1-1.06-.44Z"
    })
  ]);
}
function QR(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M3 8.689c0-.864.933-1.406 1.683-.977l7.108 4.061a1.125 1.125 0 0 1 0 1.954l-7.108 4.061A1.125 1.125 0 0 1 3 16.811V8.69ZM12.75 8.689c0-.864.933-1.406 1.683-.977l7.108 4.061a1.125 1.125 0 0 1 0 1.954l-7.108 4.061a1.125 1.125 0 0 1-1.683-.977V8.69Z"
    })
  ]);
}
function XR(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 0 1-.659 1.591l-5.432 5.432a2.25 2.25 0 0 0-.659 1.591v2.927a2.25 2.25 0 0 1-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 0 0-.659-1.591L3.659 7.409A2.25 2.25 0 0 1 3 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0 1 12 3Z"
    })
  ]);
}
function JR(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12.75 8.25v7.5m6-7.5h-3V12m0 0v3.75m0-3.75H18M9.75 9.348c-1.03-1.464-2.698-1.464-3.728 0-1.03 1.465-1.03 3.84 0 5.304 1.03 1.464 2.699 1.464 3.728 0V12h-1.5M4.5 19.5h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z"
    })
  ]);
}
function eO(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 3.75v16.5M2.25 12h19.5M6.375 17.25a4.875 4.875 0 0 0 4.875-4.875V12m6.375 5.25a4.875 4.875 0 0 1-4.875-4.875V12m-9 8.25h16.5a1.5 1.5 0 0 0 1.5-1.5V5.25a1.5 1.5 0 0 0-1.5-1.5H3.75a1.5 1.5 0 0 0-1.5 1.5v13.5a1.5 1.5 0 0 0 1.5 1.5Zm12.621-9.44c-1.409 1.41-4.242 1.061-4.242 1.061s-.349-2.833 1.06-4.242a2.25 2.25 0 0 1 3.182 3.182ZM10.773 7.63c1.409 1.409 1.06 4.242 1.06 4.242S9 12.22 7.592 10.811a2.25 2.25 0 1 1 3.182-3.182Z"
    })
  ]);
}
function tO(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M21 11.25v8.25a1.5 1.5 0 0 1-1.5 1.5H5.25a1.5 1.5 0 0 1-1.5-1.5v-8.25M12 4.875A2.625 2.625 0 1 0 9.375 7.5H12m0-2.625V7.5m0-2.625A2.625 2.625 0 1 1 14.625 7.5H12m0 0V21m-8.625-9.75h18c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125h-18c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125Z"
    })
  ]);
}
function nO(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418"
    })
  ]);
}
function rO(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m6.115 5.19.319 1.913A6 6 0 0 0 8.11 10.36L9.75 12l-.387.775c-.217.433-.132.956.21 1.298l1.348 1.348c.21.21.329.497.329.795v1.089c0 .426.24.815.622 1.006l.153.076c.433.217.956.132 1.298-.21l.723-.723a8.7 8.7 0 0 0 2.288-4.042 1.087 1.087 0 0 0-.358-1.099l-1.33-1.108c-.251-.21-.582-.299-.905-.245l-1.17.195a1.125 1.125 0 0 1-.98-.314l-.295-.295a1.125 1.125 0 0 1 0-1.591l.13-.132a1.125 1.125 0 0 1 1.3-.21l.603.302a.809.809 0 0 0 1.086-1.086L14.25 7.5l1.256-.837a4.5 4.5 0 0 0 1.528-1.732l.146-.292M6.115 5.19A9 9 0 1 0 17.18 4.64M6.115 5.19A8.965 8.965 0 0 1 12 3c1.929 0 3.716.607 5.18 1.64"
    })
  ]);
}
function aO(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12.75 3.03v.568c0 .334.148.65.405.864l1.068.89c.442.369.535 1.01.216 1.49l-.51.766a2.25 2.25 0 0 1-1.161.886l-.143.048a1.107 1.107 0 0 0-.57 1.664c.369.555.169 1.307-.427 1.605L9 13.125l.423 1.059a.956.956 0 0 1-1.652.928l-.679-.906a1.125 1.125 0 0 0-1.906.172L4.5 15.75l-.612.153M12.75 3.031a9 9 0 0 0-8.862 12.872M12.75 3.031a9 9 0 0 1 6.69 14.036m0 0-.177-.529A2.25 2.25 0 0 0 17.128 15H16.5l-.324-.324a1.453 1.453 0 0 0-2.328.377l-.036.073a1.586 1.586 0 0 1-.982.816l-.99.282c-.55.157-.894.702-.8 1.267l.073.438c.08.474.49.821.97.821.846 0 1.598.542 1.865 1.345l.215.643m5.276-3.67a9.012 9.012 0 0 1-5.276 3.67m0 0a9 9 0 0 1-10.275-4.835M15.75 9c0 .896-.393 1.7-1.016 2.25"
    })
  ]);
}
function oO(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m20.893 13.393-1.135-1.135a2.252 2.252 0 0 1-.421-.585l-1.08-2.16a.414.414 0 0 0-.663-.107.827.827 0 0 1-.812.21l-1.273-.363a.89.89 0 0 0-.738 1.595l.587.39c.59.395.674 1.23.172 1.732l-.2.2c-.212.212-.33.498-.33.796v.41c0 .409-.11.809-.32 1.158l-1.315 2.191a2.11 2.11 0 0 1-1.81 1.025 1.055 1.055 0 0 1-1.055-1.055v-1.172c0-.92-.56-1.747-1.414-2.089l-.655-.261a2.25 2.25 0 0 1-1.383-2.46l.007-.042a2.25 2.25 0 0 1 .29-.787l.09-.15a2.25 2.25 0 0 1 2.37-1.048l1.178.236a1.125 1.125 0 0 0 1.302-.795l.208-.73a1.125 1.125 0 0 0-.578-1.315l-.665-.332-.091.091a2.25 2.25 0 0 1-1.591.659h-.18c-.249 0-.487.1-.662.274a.931.931 0 0 1-1.458-1.137l1.411-2.353a2.25 2.25 0 0 0 .286-.76m11.928 9.869A9 9 0 0 0 8.965 3.525m11.928 9.868A9 9 0 1 1 8.965 3.525"
    })
  ]);
}
function iO(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M2.243 4.493v7.5m0 0v7.502m0-7.501h10.5m0-7.5v7.5m0 0v7.501m4.501-8.627 2.25-1.5v10.126m0 0h-2.25m2.25 0h2.25"
    })
  ]);
}
function sO(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M21.75 19.5H16.5v-1.609a2.25 2.25 0 0 1 1.244-2.012l2.89-1.445c.651-.326 1.116-.955 1.116-1.683 0-.498-.04-.987-.118-1.463-.135-.825-.835-1.422-1.668-1.489a15.202 15.202 0 0 0-3.464.12M2.243 4.492v7.5m0 0v7.502m0-7.501h10.5m0-7.5v7.5m0 0v7.501"
    })
  ]);
}
function lO(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M20.905 14.626a4.52 4.52 0 0 1 .738 3.603c-.154.695-.794 1.143-1.504 1.208a15.194 15.194 0 0 1-3.639-.104m4.405-4.707a4.52 4.52 0 0 0 .738-3.603c-.154-.696-.794-1.144-1.504-1.209a15.19 15.19 0 0 0-3.639.104m4.405 4.708H18M2.243 4.493v7.5m0 0v7.502m0-7.501h10.5m0-7.5v7.5m0 0v7.501"
    })
  ]);
}
function cO(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M10.05 4.575a1.575 1.575 0 1 0-3.15 0v3m3.15-3v-1.5a1.575 1.575 0 0 1 3.15 0v1.5m-3.15 0 .075 5.925m3.075.75V4.575m0 0a1.575 1.575 0 0 1 3.15 0V15M6.9 7.575a1.575 1.575 0 1 0-3.15 0v8.175a6.75 6.75 0 0 0 6.75 6.75h2.018a5.25 5.25 0 0 0 3.712-1.538l1.732-1.732a5.25 5.25 0 0 0 1.538-3.712l.003-2.024a.668.668 0 0 1 .198-.471 1.575 1.575 0 1 0-2.228-2.228 3.818 3.818 0 0 0-1.12 2.687M6.9 7.575V12m6.27 4.318A4.49 4.49 0 0 1 16.35 15m.002 0h-.002"
    })
  ]);
}
function uO(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M7.498 15.25H4.372c-1.026 0-1.945-.694-2.054-1.715a12.137 12.137 0 0 1-.068-1.285c0-2.848.992-5.464 2.649-7.521C5.287 4.247 5.886 4 6.504 4h4.016a4.5 4.5 0 0 1 1.423.23l3.114 1.04a4.5 4.5 0 0 0 1.423.23h1.294M7.498 15.25c.618 0 .991.724.725 1.282A7.471 7.471 0 0 0 7.5 19.75 2.25 2.25 0 0 0 9.75 22a.75.75 0 0 0 .75-.75v-.633c0-.573.11-1.14.322-1.672.304-.76.93-1.33 1.653-1.715a9.04 9.04 0 0 0 2.86-2.4c.498-.634 1.226-1.08 2.032-1.08h.384m-10.253 1.5H9.7m8.075-9.75c.01.05.027.1.05.148.593 1.2.925 2.55.925 3.977 0 1.487-.36 2.89-.999 4.125m.023-8.25c-.076-.365.183-.75.575-.75h.908c.889 0 1.713.518 1.972 1.368.339 1.11.521 2.287.521 3.507 0 1.553-.295 3.036-.831 4.398-.306.774-1.086 1.227-1.918 1.227h-1.053c-.472 0-.745-.556-.5-.96a8.95 8.95 0 0 0 .303-.54"
    })
  ]);
}
function dO(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6.633 10.25c.806 0 1.533-.446 2.031-1.08a9.041 9.041 0 0 1 2.861-2.4c.723-.384 1.35-.956 1.653-1.715a4.498 4.498 0 0 0 .322-1.672V2.75a.75.75 0 0 1 .75-.75 2.25 2.25 0 0 1 2.25 2.25c0 1.152-.26 2.243-.723 3.218-.266.558.107 1.282.725 1.282m0 0h3.126c1.026 0 1.945.694 2.054 1.715.045.422.068.85.068 1.285a11.95 11.95 0 0 1-2.649 7.521c-.388.482-.987.729-1.605.729H13.48c-.483 0-.964-.078-1.423-.23l-3.114-1.04a4.501 4.501 0 0 0-1.423-.23H5.904m10.598-9.75H14.25M5.904 18.5c.083.205.173.405.27.602.197.4-.078.898-.523.898h-.908c-.889 0-1.713-.518-1.972-1.368a12 12 0 0 1-.521-3.507c0-1.553.295-3.036.831-4.398C3.387 9.953 4.167 9.5 5 9.5h1.053c.472 0 .745.556.5.96a8.958 8.958 0 0 0-1.302 4.665c0 1.194.232 2.333.654 3.375Z"
    })
  ]);
}
function _O(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M5.25 8.25h15m-16.5 7.5h15m-1.8-13.5-3.9 19.5m-2.1-19.5-3.9 19.5"
    })
  ]);
}
function pO(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z"
    })
  ]);
}
function mO(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M8.25 21v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21m0 0h4.5V3.545M12.75 21h7.5V10.75M2.25 21h1.5m18 0h-18M2.25 9l4.5-1.636M18.75 3l-1.5.545m0 6.205 3 1m1.5.5-1.5-.5M6.75 7.364V3h-3v18m3-13.636 10.5-3.819"
    })
  ]);
}
function gO(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
    })
  ]);
}
function fO(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M15 9h3.75M15 12h3.75M15 15h3.75M4.5 19.5h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Zm6-10.125a1.875 1.875 0 1 1-3.75 0 1.875 1.875 0 0 1 3.75 0Zm1.294 6.336a6.721 6.721 0 0 1-3.17.789 6.721 6.721 0 0 1-3.168-.789 3.376 3.376 0 0 1 6.338 0Z"
    })
  ]);
}
function hO(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9 3.75H6.912a2.25 2.25 0 0 0-2.15 1.588L2.35 13.177a2.25 2.25 0 0 0-.1.661V18a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18v-4.162c0-.224-.034-.447-.1-.661L19.24 5.338a2.25 2.25 0 0 0-2.15-1.588H15M2.25 13.5h3.86a2.25 2.25 0 0 1 2.012 1.244l.256.512a2.25 2.25 0 0 0 2.013 1.244h3.218a2.25 2.25 0 0 0 2.013-1.244l.256-.512a2.25 2.25 0 0 1 2.013-1.244h3.859M12 3v8.25m0 0-3-3m3 3 3-3"
    })
  ]);
}
function vO(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m7.875 14.25 1.214 1.942a2.25 2.25 0 0 0 1.908 1.058h2.006c.776 0 1.497-.4 1.908-1.058l1.214-1.942M2.41 9h4.636a2.25 2.25 0 0 1 1.872 1.002l.164.246a2.25 2.25 0 0 0 1.872 1.002h2.092a2.25 2.25 0 0 0 1.872-1.002l.164-.246A2.25 2.25 0 0 1 16.954 9h4.636M2.41 9a2.25 2.25 0 0 0-.16.832V12a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 12V9.832c0-.287-.055-.57-.16-.832M2.41 9a2.25 2.25 0 0 1 .382-.632l3.285-3.832a2.25 2.25 0 0 1 1.708-.786h8.43c.657 0 1.281.287 1.709.786l3.284 3.832c.163.19.291.404.382.632M4.5 20.25h15A2.25 2.25 0 0 0 21.75 18v-2.625c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125V18a2.25 2.25 0 0 0 2.25 2.25Z"
    })
  ]);
}
function EO(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M2.25 13.5h3.86a2.25 2.25 0 0 1 2.012 1.244l.256.512a2.25 2.25 0 0 0 2.013 1.244h3.218a2.25 2.25 0 0 0 2.013-1.244l.256-.512a2.25 2.25 0 0 1 2.013-1.244h3.859m-19.5.338V18a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18v-4.162c0-.224-.034-.447-.1-.661L19.24 5.338a2.25 2.25 0 0 0-2.15-1.588H6.911a2.25 2.25 0 0 0-2.15 1.588L2.35 13.177a2.25 2.25 0 0 0-.1.661Z"
    })
  ]);
}
function bO(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
    })
  ]);
}
function SO(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M5.248 20.246H9.05m0 0h3.696m-3.696 0 5.893-16.502m0 0h-3.697m3.697 0h3.803"
    })
  ]);
}
function wO(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M15.75 5.25a3 3 0 0 1 3 3m3 0a6 6 0 0 1-7.029 5.912c-.563-.097-1.159.026-1.563.43L10.5 17.25H8.25v2.25H6v2.25H2.25v-2.818c0-.597.237-1.17.659-1.591l6.499-6.499c.404-.404.527-1 .43-1.563A6 6 0 1 1 21.75 8.25Z"
    })
  ]);
}
function yO(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m10.5 21 5.25-11.25L21 21m-9-3h7.5M3 5.621a48.474 48.474 0 0 1 6-.371m0 0c1.12 0 2.233.038 3.334.114M9 5.25V3m3.334 2.364C11.176 10.658 7.69 15.08 3 17.502m9.334-12.138c.896.061 1.785.147 2.666.257m-4.589 8.495a18.023 18.023 0 0 1-3.827-5.802"
    })
  ]);
}
function TO(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M16.712 4.33a9.027 9.027 0 0 1 1.652 1.306c.51.51.944 1.064 1.306 1.652M16.712 4.33l-3.448 4.138m3.448-4.138a9.014 9.014 0 0 0-9.424 0M19.67 7.288l-4.138 3.448m4.138-3.448a9.014 9.014 0 0 1 0 9.424m-4.138-5.976a3.736 3.736 0 0 0-.88-1.388 3.737 3.737 0 0 0-1.388-.88m2.268 2.268a3.765 3.765 0 0 1 0 2.528m-2.268-4.796a3.765 3.765 0 0 0-2.528 0m4.796 4.796c-.181.506-.475.982-.88 1.388a3.736 3.736 0 0 1-1.388.88m2.268-2.268 4.138 3.448m0 0a9.027 9.027 0 0 1-1.306 1.652c-.51.51-1.064.944-1.652 1.306m0 0-3.448-4.138m3.448 4.138a9.014 9.014 0 0 1-9.424 0m5.976-4.138a3.765 3.765 0 0 1-2.528 0m0 0a3.736 3.736 0 0 1-1.388-.88 3.737 3.737 0 0 1-.88-1.388m2.268 2.268L7.288 19.67m0 0a9.024 9.024 0 0 1-1.652-1.306 9.027 9.027 0 0 1-1.306-1.652m0 0 4.138-3.448M4.33 16.712a9.014 9.014 0 0 1 0-9.424m4.138 5.976a3.765 3.765 0 0 1 0-2.528m0 0c.181-.506.475-.982.88-1.388a3.736 3.736 0 0 1 1.388-.88m-2.268 2.268L4.33 7.288m6.406 1.18L7.288 4.33m0 0a9.024 9.024 0 0 0-1.652 1.306A9.025 9.025 0 0 0 4.33 7.288"
    })
  ]);
}
function CO(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 18v-5.25m0 0a6.01 6.01 0 0 0 1.5-.189m-1.5.189a6.01 6.01 0 0 1-1.5-.189m3.75 7.478a12.06 12.06 0 0 1-4.5 0m3.75 2.383a14.406 14.406 0 0 1-3 0M14.25 18v-.192c0-.983.658-1.823 1.508-2.316a7.5 7.5 0 1 0-7.517 0c.85.493 1.509 1.333 1.509 2.316V18"
    })
  ]);
}
function xO(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M13.181 8.68a4.503 4.503 0 0 1 1.903 6.405m-9.768-2.782L3.56 14.06a4.5 4.5 0 0 0 6.364 6.365l3.129-3.129m5.614-5.615 1.757-1.757a4.5 4.5 0 0 0-6.364-6.365l-4.5 4.5c-.258.26-.479.541-.661.84m1.903 6.405a4.495 4.495 0 0 1-1.242-.88 4.483 4.483 0 0 1-1.062-1.683m6.587 2.345 5.907 5.907m-5.907-5.907L8.898 8.898M2.991 2.99 8.898 8.9"
    })
  ]);
}
function AO(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244"
    })
  ]);
}
function RO(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0ZM3.75 12h.007v.008H3.75V12Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm-.375 5.25h.007v.008H3.75v-.008Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
    })
  ]);
}
function OO(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z"
    })
  ]);
}
function IO(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M13.5 10.5V6.75a4.5 4.5 0 1 1 9 0v3.75M3.75 21.75h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H3.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z"
    })
  ]);
}
function NO(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m15.75 15.75-2.489-2.489m0 0a3.375 3.375 0 1 0-4.773-4.773 3.375 3.375 0 0 0 4.774 4.774ZM21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    })
  ]);
}
function MO(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607ZM13.5 10.5h-6"
    })
  ]);
}
function DO(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607ZM10.5 7.5v6m3-3h-6"
    })
  ]);
}
function kO(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
    })
  ]);
}
function LO(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
    }),
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z"
    })
  ]);
}
function PO(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9 6.75V15m6-6v8.25m.503 3.498 4.875-2.437c.381-.19.622-.58.622-1.006V4.82c0-.836-.88-1.38-1.628-1.006l-3.869 1.934c-.317.159-.69.159-1.006 0L9.503 3.252a1.125 1.125 0 0 0-1.006 0L3.622 5.689C3.24 5.88 3 6.27 3 6.695V19.18c0 .836.88 1.38 1.628 1.006l3.869-1.934c.317-.159.69-.159 1.006 0l4.994 2.497c.317.158.69.158 1.006 0Z"
    })
  ]);
}
function BO(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M10.34 15.84c-.688-.06-1.386-.09-2.09-.09H7.5a4.5 4.5 0 1 1 0-9h.75c.704 0 1.402-.03 2.09-.09m0 9.18c.253.962.584 1.892.985 2.783.247.55.06 1.21-.463 1.511l-.657.38c-.551.318-1.26.117-1.527-.461a20.845 20.845 0 0 1-1.44-4.282m3.102.069a18.03 18.03 0 0 1-.59-4.59c0-1.586.205-3.124.59-4.59m0 9.18a23.848 23.848 0 0 1 8.835 2.535M10.34 6.66a23.847 23.847 0 0 0 8.835-2.535m0 0A23.74 23.74 0 0 0 18.795 3m.38 1.125a23.91 23.91 0 0 1 1.014 5.395m-1.014 8.855c-.118.38-.245.754-.38 1.125m.38-1.125a23.91 23.91 0 0 0 1.014-5.395m0-3.46c.495.413.811 1.035.811 1.73 0 .695-.316 1.317-.811 1.73m0-3.46a24.347 24.347 0 0 1 0 3.46"
    })
  ]);
}
function FO(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 18.75a6 6 0 0 0 6-6v-1.5m-6 7.5a6 6 0 0 1-6-6v-1.5m6 7.5v3.75m-3.75 0h7.5M12 15.75a3 3 0 0 1-3-3V4.5a3 3 0 1 1 6 0v8.25a3 3 0 0 1-3 3Z"
    })
  ]);
}
function UO(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M15 12H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    })
  ]);
}
function $O(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M18 12H6"
    })
  ]);
}
function VO(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M5 12h14"
    })
  ]);
}
function HO(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M21.752 15.002A9.72 9.72 0 0 1 18 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 0 0 3 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 0 0 9.002-5.998Z"
    })
  ]);
}
function GO(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m9 9 10.5-3m0 6.553v3.75a2.25 2.25 0 0 1-1.632 2.163l-1.32.377a1.803 1.803 0 1 1-.99-3.467l2.31-.66a2.25 2.25 0 0 0 1.632-2.163Zm0 0V2.25L9 5.25v10.303m0 0v3.75a2.25 2.25 0 0 1-1.632 2.163l-1.32.377a1.803 1.803 0 0 1-.99-3.467l2.31-.66A2.25 2.25 0 0 0 9 15.553Z"
    })
  ]);
}
function YO(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 7.5h1.5m-1.5 3h1.5m-7.5 3h7.5m-7.5 3h7.5m3-9h3.375c.621 0 1.125.504 1.125 1.125V18a2.25 2.25 0 0 1-2.25 2.25M16.5 7.5V18a2.25 2.25 0 0 0 2.25 2.25M16.5 7.5V4.875c0-.621-.504-1.125-1.125-1.125H4.125C3.504 3.75 3 4.254 3 4.875V18a2.25 2.25 0 0 0 2.25 2.25h13.5M6 7.5h3v3H6v-3Z"
    })
  ]);
}
function zO(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M18.364 18.364A9 9 0 0 0 5.636 5.636m12.728 12.728A9 9 0 0 1 5.636 5.636m12.728 12.728L5.636 5.636"
    })
  ]);
}
function ZO(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M8.242 5.992h12m-12 6.003H20.24m-12 5.999h12M4.117 7.495v-3.75H2.99m1.125 3.75H2.99m1.125 0H5.24m-1.92 2.577a1.125 1.125 0 1 1 1.591 1.59l-1.83 1.83h2.16M2.99 15.745h1.125a1.125 1.125 0 0 1 0 2.25H3.74m0-.002h.375a1.125 1.125 0 0 1 0 2.25H2.99"
    })
  ]);
}
function qO(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9.53 16.122a3 3 0 0 0-5.78 1.128 2.25 2.25 0 0 1-2.4 2.245 4.5 4.5 0 0 0 8.4-2.245c0-.399-.078-.78-.22-1.128Zm0 0a15.998 15.998 0 0 0 3.388-1.62m-5.043-.025a15.994 15.994 0 0 1 1.622-3.395m3.42 3.42a15.995 15.995 0 0 0 4.764-4.648l3.876-5.814a1.151 1.151 0 0 0-1.597-1.597L14.146 6.32a15.996 15.996 0 0 0-4.649 4.763m3.42 3.42a6.776 6.776 0 0 0-3.42-3.42"
    })
  ]);
}
function WO(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5"
    })
  ]);
}
function jO(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m18.375 12.739-7.693 7.693a4.5 4.5 0 0 1-6.364-6.364l10.94-10.94A3 3 0 1 1 19.5 7.372L8.552 18.32m.009-.01-.01.01m5.699-9.941-7.81 7.81a1.5 1.5 0 0 0 2.112 2.13"
    })
  ]);
}
function KO(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M14.25 9v6m-4.5 0V9M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    })
  ]);
}
function QO(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M15.75 5.25v13.5m-7.5-13.5v13.5"
    })
  ]);
}
function XO(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"
    })
  ]);
}
function JO(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125"
    })
  ]);
}
function e8(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m8.99 14.993 6-6m6 3.001c0 1.268-.63 2.39-1.593 3.069a3.746 3.746 0 0 1-1.043 3.296 3.745 3.745 0 0 1-3.296 1.043 3.745 3.745 0 0 1-3.068 1.593c-1.268 0-2.39-.63-3.068-1.593a3.745 3.745 0 0 1-3.296-1.043 3.746 3.746 0 0 1-1.043-3.297 3.746 3.746 0 0 1-1.593-3.068c0-1.268.63-2.39 1.593-3.068a3.746 3.746 0 0 1 1.043-3.297 3.745 3.745 0 0 1 3.296-1.042 3.745 3.745 0 0 1 3.068-1.594c1.268 0 2.39.63 3.068 1.593a3.745 3.745 0 0 1 3.296 1.043 3.746 3.746 0 0 1 1.043 3.297 3.746 3.746 0 0 1 1.593 3.068ZM9.74 9.743h.008v.007H9.74v-.007Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm4.125 4.5h.008v.008h-.008v-.008Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
    })
  ]);
}
function t8(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M14.25 9.75v-4.5m0 4.5h4.5m-4.5 0 6-6m-3 18c-8.284 0-15-6.716-15-15V4.5A2.25 2.25 0 0 1 4.5 2.25h1.372c.516 0 .966.351 1.091.852l1.106 4.423c.11.44-.054.902-.417 1.173l-1.293.97a1.062 1.062 0 0 0-.38 1.21 12.035 12.035 0 0 0 7.143 7.143c.441.162.928-.004 1.21-.38l.97-1.293a1.125 1.125 0 0 1 1.173-.417l4.423 1.106c.5.125.852.575.852 1.091V19.5a2.25 2.25 0 0 1-2.25 2.25h-2.25Z"
    })
  ]);
}
function n8(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M20.25 3.75v4.5m0-4.5h-4.5m4.5 0-6 6m3 12c-8.284 0-15-6.716-15-15V4.5A2.25 2.25 0 0 1 4.5 2.25h1.372c.516 0 .966.351 1.091.852l1.106 4.423c.11.44-.054.902-.417 1.173l-1.293.97a1.062 1.062 0 0 0-.38 1.21 12.035 12.035 0 0 0 7.143 7.143c.441.162.928-.004 1.21-.38l.97-1.293a1.125 1.125 0 0 1 1.173-.417l4.423 1.106c.5.125.852.575.852 1.091V19.5a2.25 2.25 0 0 1-2.25 2.25h-2.25Z"
    })
  ]);
}
function r8(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M15.75 3.75 18 6m0 0 2.25 2.25M18 6l2.25-2.25M18 6l-2.25 2.25m1.5 13.5c-8.284 0-15-6.716-15-15V4.5A2.25 2.25 0 0 1 4.5 2.25h1.372c.516 0 .966.351 1.091.852l1.106 4.423c.11.44-.054.902-.417 1.173l-1.293.97a1.062 1.062 0 0 0-.38 1.21 12.035 12.035 0 0 0 7.143 7.143c.441.162.928-.004 1.21-.38l.97-1.293a1.125 1.125 0 0 1 1.173-.417l4.423 1.106c.5.125.852.575.852 1.091V19.5a2.25 2.25 0 0 1-2.25 2.25h-2.25Z"
    })
  ]);
}
function a8(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z"
    })
  ]);
}
function o8(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Zm10.5-11.25h.008v.008h-.008V8.25Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
    })
  ]);
}
function i8(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    }),
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M15.91 11.672a.375.375 0 0 1 0 .656l-5.603 3.113a.375.375 0 0 1-.557-.328V8.887c0-.286.307-.466.557-.327l5.603 3.112Z"
    })
  ]);
}
function s8(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M21 7.5V18M15 7.5V18M3 16.811V8.69c0-.864.933-1.406 1.683-.977l7.108 4.061a1.125 1.125 0 0 1 0 1.954l-7.108 4.061A1.125 1.125 0 0 1 3 16.811Z"
    })
  ]);
}
function l8(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.347a1.125 1.125 0 0 1 0 1.972l-11.54 6.347a1.125 1.125 0 0 1-1.667-.986V5.653Z"
    })
  ]);
}
function c8(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    })
  ]);
}
function u8(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 6v12m6-6H6"
    })
  ]);
}
function d8(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 4.5v15m7.5-7.5h-15"
    })
  ]);
}
function _8(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M5.636 5.636a9 9 0 1 0 12.728 0M12 3v9"
    })
  ]);
}
function p8(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M3.75 3v11.25A2.25 2.25 0 0 0 6 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0 1 18 16.5h-2.25m-7.5 0h7.5m-7.5 0-1 3m8.5-3 1 3m0 0 .5 1.5m-.5-1.5h-9.5m0 0-.5 1.5M9 11.25v1.5M12 9v3.75m3-6v6"
    })
  ]);
}
function m8(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M3.75 3v11.25A2.25 2.25 0 0 0 6 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0 1 18 16.5h-2.25m-7.5 0h7.5m-7.5 0-1 3m8.5-3 1 3m0 0 .5 1.5m-.5-1.5h-9.5m0 0-.5 1.5m.75-9 3-3 2.148 2.148A12.061 12.061 0 0 1 16.5 7.605"
    })
  ]);
}
function g8(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6.72 13.829c-.24.03-.48.062-.72.096m.72-.096a42.415 42.415 0 0 1 10.56 0m-10.56 0L6.34 18m10.94-4.171c.24.03.48.062.72.096m-.72-.096L17.66 18m0 0 .229 2.523a1.125 1.125 0 0 1-1.12 1.227H7.231c-.662 0-1.18-.568-1.12-1.227L6.34 18m11.318 0h1.091A2.25 2.25 0 0 0 21 15.75V9.456c0-1.081-.768-2.015-1.837-2.175a48.055 48.055 0 0 0-1.913-.247M6.34 18H5.25A2.25 2.25 0 0 1 3 15.75V9.456c0-1.081.768-2.015 1.837-2.175a48.041 48.041 0 0 1 1.913-.247m10.5 0a48.536 48.536 0 0 0-10.5 0m10.5 0V3.375c0-.621-.504-1.125-1.125-1.125h-8.25c-.621 0-1.125.504-1.125 1.125v3.659M18 10.5h.008v.008H18V10.5Zm-3 0h.008v.008H15V10.5Z"
    })
  ]);
}
function f8(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M14.25 6.087c0-.355.186-.676.401-.959.221-.29.349-.634.349-1.003 0-1.036-1.007-1.875-2.25-1.875s-2.25.84-2.25 1.875c0 .369.128.713.349 1.003.215.283.401.604.401.959v0a.64.64 0 0 1-.657.643 48.39 48.39 0 0 1-4.163-.3c.186 1.613.293 3.25.315 4.907a.656.656 0 0 1-.658.663v0c-.355 0-.676-.186-.959-.401a1.647 1.647 0 0 0-1.003-.349c-1.036 0-1.875 1.007-1.875 2.25s.84 2.25 1.875 2.25c.369 0 .713-.128 1.003-.349.283-.215.604-.401.959-.401v0c.31 0 .555.26.532.57a48.039 48.039 0 0 1-.642 5.056c1.518.19 3.058.309 4.616.354a.64.64 0 0 0 .657-.643v0c0-.355-.186-.676-.401-.959a1.647 1.647 0 0 1-.349-1.003c0-1.035 1.008-1.875 2.25-1.875 1.243 0 2.25.84 2.25 1.875 0 .369-.128.713-.349 1.003-.215.283-.4.604-.4.959v0c0 .333.277.599.61.58a48.1 48.1 0 0 0 5.427-.63 48.05 48.05 0 0 0 .582-4.717.532.532 0 0 0-.533-.57v0c-.355 0-.676.186-.959.401-.29.221-.634.349-1.003.349-1.035 0-1.875-1.007-1.875-2.25s.84-2.25 1.875-2.25c.37 0 .713.128 1.003.349.283.215.604.401.96.401v0a.656.656 0 0 0 .658-.663 48.422 48.422 0 0 0-.37-5.36c-1.886.342-3.81.574-5.766.689a.578.578 0 0 1-.61-.58v0Z"
    })
  ]);
}
function h8(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M3.75 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0 1 3.75 9.375v-4.5ZM3.75 14.625c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5a1.125 1.125 0 0 1-1.125-1.125v-4.5ZM13.5 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0 1 13.5 9.375v-4.5Z"
    }),
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6.75 6.75h.75v.75h-.75v-.75ZM6.75 16.5h.75v.75h-.75v-.75ZM16.5 6.75h.75v.75h-.75v-.75ZM13.5 13.5h.75v.75h-.75v-.75ZM13.5 19.5h.75v.75h-.75v-.75ZM19.5 13.5h.75v.75h-.75v-.75ZM19.5 19.5h.75v.75h-.75v-.75ZM16.5 16.5h.75v.75h-.75v-.75Z"
    })
  ]);
}
function v8(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 5.25h.008v.008H12v-.008Z"
    })
  ]);
}
function E8(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M3.75 12h16.5m-16.5 3.75h16.5M3.75 19.5h16.5M5.625 4.5h12.75a1.875 1.875 0 0 1 0 3.75H5.625a1.875 1.875 0 0 1 0-3.75Z"
    })
  ]);
}
function b8(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m3.75 7.5 16.5-4.125M12 6.75c-2.708 0-5.363.224-7.948.655C2.999 7.58 2.25 8.507 2.25 9.574v9.176A2.25 2.25 0 0 0 4.5 21h15a2.25 2.25 0 0 0 2.25-2.25V9.574c0-1.067-.75-1.994-1.802-2.169A48.329 48.329 0 0 0 12 6.75Zm-1.683 6.443-.005.005-.006-.005.006-.005.005.005Zm-.005 2.127-.005-.006.005-.005.005.005-.005.005Zm-2.116-.006-.005.006-.006-.006.005-.005.006.005Zm-.005-2.116-.006-.005.006-.005.005.005-.005.005ZM9.255 10.5v.008h-.008V10.5h.008Zm3.249 1.88-.007.004-.003-.007.006-.003.004.006Zm-1.38 5.126-.003-.006.006-.004.004.007-.006.003Zm.007-6.501-.003.006-.007-.003.004-.007.006.004Zm1.37 5.129-.007-.004.004-.006.006.003-.004.007Zm.504-1.877h-.008v-.007h.008v.007ZM9.255 18v.008h-.008V18h.008Zm-3.246-1.87-.007.004L6 16.127l.006-.003.004.006Zm1.366-5.119-.004-.006.006-.004.004.007-.006.003ZM7.38 17.5l-.003.006-.007-.003.004-.007.006.004Zm-1.376-5.116L6 12.38l.003-.007.007.004-.004.007Zm-.5 1.873h-.008v-.007h.008v.007ZM17.25 12.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Zm0 4.5a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Z"
    })
  ]);
}
function S8(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m9 14.25 6-6m4.5-3.493V21.75l-3.75-1.5-3.75 1.5-3.75-1.5-3.75 1.5V4.757c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0 1 11.186 0c1.1.128 1.907 1.077 1.907 2.185ZM9.75 9h.008v.008H9.75V9Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm4.125 4.5h.008v.008h-.008V13.5Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
    })
  ]);
}
function w8(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M8.25 9.75h4.875a2.625 2.625 0 0 1 0 5.25H12M8.25 9.75 10.5 7.5M8.25 9.75 10.5 12m9-7.243V21.75l-3.75-1.5-3.75 1.5-3.75-1.5-3.75 1.5V4.757c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0 1 11.186 0c1.1.128 1.907 1.077 1.907 2.185Z"
    })
  ]);
}
function y8(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M2.25 7.125C2.25 6.504 2.754 6 3.375 6h6c.621 0 1.125.504 1.125 1.125v3.75c0 .621-.504 1.125-1.125 1.125h-6a1.125 1.125 0 0 1-1.125-1.125v-3.75ZM14.25 8.625c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v8.25c0 .621-.504 1.125-1.125 1.125h-5.25a1.125 1.125 0 0 1-1.125-1.125v-8.25ZM3.75 16.125c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125h-5.25a1.125 1.125 0 0 1-1.125-1.125v-2.25Z"
    })
  ]);
}
function T8(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6 6.878V6a2.25 2.25 0 0 1 2.25-2.25h7.5A2.25 2.25 0 0 1 18 6v.878m-12 0c.235-.083.487-.128.75-.128h10.5c.263 0 .515.045.75.128m-12 0A2.25 2.25 0 0 0 4.5 9v.878m13.5-3A2.25 2.25 0 0 1 19.5 9v.878m0 0a2.246 2.246 0 0 0-.75-.128H5.25c-.263 0-.515.045-.75.128m15 0A2.25 2.25 0 0 1 21 12v6a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 18v-6c0-.98.626-1.813 1.5-2.122"
    })
  ]);
}
function C8(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M15.59 14.37a6 6 0 0 1-5.84 7.38v-4.8m5.84-2.58a14.98 14.98 0 0 0 6.16-12.12A14.98 14.98 0 0 0 9.631 8.41m5.96 5.96a14.926 14.926 0 0 1-5.841 2.58m-.119-8.54a6 6 0 0 0-7.381 5.84h4.8m2.581-5.84a14.927 14.927 0 0 0-2.58 5.84m2.699 2.7c-.103.021-.207.041-.311.06a15.09 15.09 0 0 1-2.448-2.448 14.9 14.9 0 0 1 .06-.312m-2.24 2.39a4.493 4.493 0 0 0-1.757 4.306 4.493 4.493 0 0 0 4.306-1.758M16.5 9a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
    })
  ]);
}
function x8(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12.75 19.5v-.75a7.5 7.5 0 0 0-7.5-7.5H4.5m0-6.75h.75c7.87 0 14.25 6.38 14.25 14.25v.75M6 18.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"
    })
  ]);
}
function A8(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 3v17.25m0 0c-1.472 0-2.882.265-4.185.75M12 20.25c1.472 0 2.882.265 4.185.75M18.75 4.97A48.416 48.416 0 0 0 12 4.5c-2.291 0-4.545.16-6.75.47m13.5 0c1.01.143 2.01.317 3 .52m-3-.52 2.62 10.726c.122.499-.106 1.028-.589 1.202a5.988 5.988 0 0 1-2.031.352 5.988 5.988 0 0 1-2.031-.352c-.483-.174-.711-.703-.59-1.202L18.75 4.971Zm-16.5.52c.99-.203 1.99-.377 3-.52m0 0 2.62 10.726c.122.499-.106 1.028-.589 1.202a5.989 5.989 0 0 1-2.031.352 5.989 5.989 0 0 1-2.031-.352c-.483-.174-.711-.703-.59-1.202L5.25 4.971Z"
    })
  ]);
}
function R8(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m7.848 8.25 1.536.887M7.848 8.25a3 3 0 1 1-5.196-3 3 3 0 0 1 5.196 3Zm1.536.887a2.165 2.165 0 0 1 1.083 1.839c.005.351.054.695.14 1.024M9.384 9.137l2.077 1.199M7.848 15.75l1.536-.887m-1.536.887a3 3 0 1 1-5.196 3 3 3 0 0 1 5.196-3Zm1.536-.887a2.165 2.165 0 0 0 1.083-1.838c.005-.352.054-.695.14-1.025m-1.223 2.863 2.077-1.199m0-3.328a4.323 4.323 0 0 1 2.068-1.379l5.325-1.628a4.5 4.5 0 0 1 2.48-.044l.803.215-7.794 4.5m-2.882-1.664A4.33 4.33 0 0 0 10.607 12m3.736 0 7.794 4.5-.802.215a4.5 4.5 0 0 1-2.48-.043l-5.326-1.629a4.324 4.324 0 0 1-2.068-1.379M14.343 12l-2.882 1.664"
    })
  ]);
}
function O8(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M5.25 14.25h13.5m-13.5 0a3 3 0 0 1-3-3m3 3a3 3 0 1 0 0 6h13.5a3 3 0 1 0 0-6m-16.5-3a3 3 0 0 1 3-3h13.5a3 3 0 0 1 3 3m-19.5 0a4.5 4.5 0 0 1 .9-2.7L5.737 5.1a3.375 3.375 0 0 1 2.7-1.35h7.126c1.062 0 2.062.5 2.7 1.35l2.587 3.45a4.5 4.5 0 0 1 .9 2.7m0 0a3 3 0 0 1-3 3m0 3h.008v.008h-.008v-.008Zm0-6h.008v.008h-.008v-.008Zm-3 6h.008v.008h-.008v-.008Zm0-6h.008v.008h-.008v-.008Z"
    })
  ]);
}
function I8(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M21.75 17.25v-.228a4.5 4.5 0 0 0-.12-1.03l-2.268-9.64a3.375 3.375 0 0 0-3.285-2.602H7.923a3.375 3.375 0 0 0-3.285 2.602l-2.268 9.64a4.5 4.5 0 0 0-.12 1.03v.228m19.5 0a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3m19.5 0a3 3 0 0 0-3-3H5.25a3 3 0 0 0-3 3m16.5 0h.008v.008h-.008v-.008Zm-3 0h.008v.008h-.008v-.008Z"
    })
  ]);
}
function N8(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M7.217 10.907a2.25 2.25 0 1 0 0 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186 9.566-5.314m-9.566 7.5 9.566 5.314m0 0a2.25 2.25 0 1 0 3.935 2.186 2.25 2.25 0 0 0-3.935-2.186Zm0-12.814a2.25 2.25 0 1 0 3.933-2.185 2.25 2.25 0 0 0-3.933 2.185Z"
    })
  ]);
}
function M8(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9 12.75 11.25 15 15 9.75m-3-7.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285Z"
    })
  ]);
}
function D8(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 9v3.75m0-10.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.75c0 5.592 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.57-.598-3.75h-.152c-3.196 0-6.1-1.25-8.25-3.286Zm0 13.036h.008v.008H12v-.008Z"
    })
  ]);
}
function k8(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M15.75 10.5V6a3.75 3.75 0 1 0-7.5 0v4.5m11.356-1.993 1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 0 1-1.12-1.243l1.264-12A1.125 1.125 0 0 1 5.513 7.5h12.974c.576 0 1.059.435 1.119 1.007ZM8.625 10.5a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm7.5 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
    })
  ]);
}
function L8(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 0 0-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 0 0-16.536-1.84M7.5 14.25 5.106 5.272M6 20.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm12.75 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"
    })
  ]);
}
function P8(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m3 3 8.735 8.735m0 0a.374.374 0 1 1 .53.53m-.53-.53.53.53m0 0L21 21M14.652 9.348a3.75 3.75 0 0 1 0 5.304m2.121-7.425a6.75 6.75 0 0 1 0 9.546m2.121-11.667c3.808 3.807 3.808 9.98 0 13.788m-9.546-4.242a3.733 3.733 0 0 1-1.06-2.122m-1.061 4.243a6.75 6.75 0 0 1-1.625-6.929m-.496 9.05c-3.068-3.067-3.664-7.67-1.79-11.334M12 12h.008v.008H12V12Z"
    })
  ]);
}
function B8(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9.348 14.652a3.75 3.75 0 0 1 0-5.304m5.304 0a3.75 3.75 0 0 1 0 5.304m-7.425 2.121a6.75 6.75 0 0 1 0-9.546m9.546 0a6.75 6.75 0 0 1 0 9.546M5.106 18.894c-3.808-3.807-3.808-9.98 0-13.788m13.788 0c3.808 3.807 3.808 9.98 0 13.788M12 12h.008v.008H12V12Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
    })
  ]);
}
function F8(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m9 20.247 6-16.5"
    })
  ]);
}
function U8(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"
    })
  ]);
}
function $8(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M19.114 5.636a9 9 0 0 1 0 12.728M16.463 8.288a5.25 5.25 0 0 1 0 7.424M6.75 8.25l4.72-4.72a.75.75 0 0 1 1.28.53v15.88a.75.75 0 0 1-1.28.53l-4.72-4.72H4.51c-.88 0-1.704-.507-1.938-1.354A9.009 9.009 0 0 1 2.25 12c0-.83.112-1.633.322-2.396C2.806 8.756 3.63 8.25 4.51 8.25H6.75Z"
    })
  ]);
}
function V8(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M17.25 9.75 19.5 12m0 0 2.25 2.25M19.5 12l2.25-2.25M19.5 12l-2.25 2.25m-10.5-6 4.72-4.72a.75.75 0 0 1 1.28.53v15.88a.75.75 0 0 1-1.28.53l-4.72-4.72H4.51c-.88 0-1.704-.507-1.938-1.354A9.009 9.009 0 0 1 2.25 12c0-.83.112-1.633.322-2.396C2.806 8.756 3.63 8.25 4.51 8.25H6.75Z"
    })
  ]);
}
function H8(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M16.5 8.25V6a2.25 2.25 0 0 0-2.25-2.25H6A2.25 2.25 0 0 0 3.75 6v8.25A2.25 2.25 0 0 0 6 16.5h2.25m8.25-8.25H18a2.25 2.25 0 0 1 2.25 2.25V18A2.25 2.25 0 0 1 18 20.25h-7.5A2.25 2.25 0 0 1 8.25 18v-1.5m8.25-8.25h-6a2.25 2.25 0 0 0-2.25 2.25v6"
    })
  ]);
}
function G8(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6.429 9.75 2.25 12l4.179 2.25m0-4.5 5.571 3 5.571-3m-11.142 0L2.25 7.5 12 2.25l9.75 5.25-4.179 2.25m0 0L21.75 12l-4.179 2.25m0 0 4.179 2.25L12 21.75 2.25 16.5l4.179-2.25m11.142 0-5.571 3-5.571-3"
    })
  ]);
}
function Y8(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M3.75 6A2.25 2.25 0 0 1 6 3.75h2.25A2.25 2.25 0 0 1 10.5 6v2.25a2.25 2.25 0 0 1-2.25 2.25H6a2.25 2.25 0 0 1-2.25-2.25V6ZM3.75 15.75A2.25 2.25 0 0 1 6 13.5h2.25a2.25 2.25 0 0 1 2.25 2.25V18a2.25 2.25 0 0 1-2.25 2.25H6A2.25 2.25 0 0 1 3.75 18v-2.25ZM13.5 6a2.25 2.25 0 0 1 2.25-2.25H18A2.25 2.25 0 0 1 20.25 6v2.25A2.25 2.25 0 0 1 18 10.5h-2.25a2.25 2.25 0 0 1-2.25-2.25V6ZM13.5 15.75a2.25 2.25 0 0 1 2.25-2.25H18a2.25 2.25 0 0 1 2.25 2.25V18A2.25 2.25 0 0 1 18 20.25h-2.25A2.25 2.25 0 0 1 13.5 18v-2.25Z"
    })
  ]);
}
function z8(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M13.5 16.875h3.375m0 0h3.375m-3.375 0V13.5m0 3.375v3.375M6 10.5h2.25a2.25 2.25 0 0 0 2.25-2.25V6a2.25 2.25 0 0 0-2.25-2.25H6A2.25 2.25 0 0 0 3.75 6v2.25A2.25 2.25 0 0 0 6 10.5Zm0 9.75h2.25A2.25 2.25 0 0 0 10.5 18v-2.25a2.25 2.25 0 0 0-2.25-2.25H6a2.25 2.25 0 0 0-2.25 2.25V18A2.25 2.25 0 0 0 6 20.25Zm9.75-9.75H18a2.25 2.25 0 0 0 2.25-2.25V6A2.25 2.25 0 0 0 18 3.75h-2.25A2.25 2.25 0 0 0 13.5 6v2.25a2.25 2.25 0 0 0 2.25 2.25Z"
    })
  ]);
}
function Z8(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z"
    })
  ]);
}
function q8(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    }),
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9 9.563C9 9.252 9.252 9 9.563 9h4.874c.311 0 .563.252.563.563v4.874c0 .311-.252.563-.563.563H9.564A.562.562 0 0 1 9 14.437V9.564Z"
    })
  ]);
}
function W8(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M5.25 7.5A2.25 2.25 0 0 1 7.5 5.25h9a2.25 2.25 0 0 1 2.25 2.25v9a2.25 2.25 0 0 1-2.25 2.25h-9a2.25 2.25 0 0 1-2.25-2.25v-9Z"
    })
  ]);
}
function j8(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 12a8.912 8.912 0 0 1-.318-.079c-1.585-.424-2.904-1.247-3.76-2.236-.873-1.009-1.265-2.19-.968-3.301.59-2.2 3.663-3.29 6.863-2.432A8.186 8.186 0 0 1 16.5 5.21M6.42 17.81c.857.99 2.176 1.812 3.761 2.237 3.2.858 6.274-.23 6.863-2.431.233-.868.044-1.779-.465-2.617M3.75 12h16.5"
    })
  ]);
}
function K8(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 3v2.25m6.364.386-1.591 1.591M21 12h-2.25m-.386 6.364-1.591-1.591M12 18.75V21m-4.773-4.227-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z"
    })
  ]);
}
function Q8(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M4.098 19.902a3.75 3.75 0 0 0 5.304 0l6.401-6.402M6.75 21A3.75 3.75 0 0 1 3 17.25V4.125C3 3.504 3.504 3 4.125 3h5.25c.621 0 1.125.504 1.125 1.125v4.072M6.75 21a3.75 3.75 0 0 0 3.75-3.75V8.197M6.75 21h13.125c.621 0 1.125-.504 1.125-1.125v-5.25c0-.621-.504-1.125-1.125-1.125h-4.072M10.5 8.197l2.88-2.88c.438-.439 1.15-.439 1.59 0l3.712 3.713c.44.44.44 1.152 0 1.59l-2.879 2.88M6.75 17.25h.008v.008H6.75v-.008Z"
    })
  ]);
}
function X8(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 0 1-1.125-1.125M3.375 19.5h7.5c.621 0 1.125-.504 1.125-1.125m-9.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-7.5A1.125 1.125 0 0 1 12 18.375m9.75-12.75c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125m19.5 0v1.5c0 .621-.504 1.125-1.125 1.125M2.25 5.625v1.5c0 .621.504 1.125 1.125 1.125m0 0h17.25m-17.25 0h7.5c.621 0 1.125.504 1.125 1.125M3.375 8.25c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m17.25-3.75h-7.5c-.621 0-1.125.504-1.125 1.125m8.625-1.125c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M12 10.875v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125M13.125 12h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125M20.625 12c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5M12 14.625v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 14.625c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m0 1.5v-1.5m0 0c0-.621.504-1.125 1.125-1.125m0 0h7.5"
    })
  ]);
}
function J8(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9.568 3H5.25A2.25 2.25 0 0 0 3 5.25v4.318c0 .597.237 1.17.659 1.591l9.581 9.581c.699.699 1.78.872 2.607.33a18.095 18.095 0 0 0 5.223-5.223c.542-.827.369-1.908-.33-2.607L11.16 3.66A2.25 2.25 0 0 0 9.568 3Z"
    }),
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6 6h.008v.008H6V6Z"
    })
  ]);
}
function eI(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M16.5 6v.75m0 3v.75m0 3v.75m0 3V18m-9-5.25h5.25M7.5 15h3M3.375 5.25c-.621 0-1.125.504-1.125 1.125v3.026a2.999 2.999 0 0 1 0 5.198v3.026c0 .621.504 1.125 1.125 1.125h17.25c.621 0 1.125-.504 1.125-1.125v-3.026a2.999 2.999 0 0 1 0-5.198V6.375c0-.621-.504-1.125-1.125-1.125H3.375Z"
    })
  ]);
}
function tI(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
    })
  ]);
}
function nI(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M16.5 18.75h-9m9 0a3 3 0 0 1 3 3h-15a3 3 0 0 1 3-3m9 0v-3.375c0-.621-.503-1.125-1.125-1.125h-.871M7.5 18.75v-3.375c0-.621.504-1.125 1.125-1.125h.872m5.007 0H9.497m5.007 0a7.454 7.454 0 0 1-.982-3.172M9.497 14.25a7.454 7.454 0 0 0 .981-3.172M5.25 4.236c-.982.143-1.954.317-2.916.52A6.003 6.003 0 0 0 7.73 9.728M5.25 4.236V4.5c0 2.108.966 3.99 2.48 5.228M5.25 4.236V2.721C7.456 2.41 9.71 2.25 12 2.25c2.291 0 4.545.16 6.75.47v1.516M7.73 9.728a6.726 6.726 0 0 0 2.748 1.35m8.272-6.842V4.5c0 2.108-.966 3.99-2.48 5.228m2.48-5.492a46.32 46.32 0 0 1 2.916.52 6.003 6.003 0 0 1-5.395 4.972m0 0a6.726 6.726 0 0 1-2.749 1.35m0 0a6.772 6.772 0 0 1-3.044 0"
    })
  ]);
}
function rI(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M8.25 18.75a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 0 1-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 0 0-3.213-9.193 2.056 2.056 0 0 0-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 0 0-10.026 0 1.106 1.106 0 0 0-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12"
    })
  ]);
}
function aI(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6 20.25h12m-7.5-3v3m3-3v3m-10.125-3h17.25c.621 0 1.125-.504 1.125-1.125V4.875c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125Z"
    })
  ]);
}
function oI(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M17.995 3.744v7.5a6 6 0 1 1-12 0v-7.5m-2.25 16.502h16.5"
    })
  ]);
}
function iI(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M17.982 18.725A7.488 7.488 0 0 0 12 15.75a7.488 7.488 0 0 0-5.982 2.975m11.963 0a9 9 0 1 0-11.963 0m11.963 0A8.966 8.966 0 0 1 12 21a8.966 8.966 0 0 1-5.982-2.275M15 9.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
    })
  ]);
}
function sI(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
    })
  ]);
}
function lI(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M22 10.5h-6m-2.25-4.125a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0ZM4 19.235v-.11a6.375 6.375 0 0 1 12.75 0v.109A12.318 12.318 0 0 1 10.374 21c-2.331 0-4.512-.645-6.374-1.766Z"
    })
  ]);
}
function cI(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M18 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0ZM3 19.235v-.11a6.375 6.375 0 0 1 12.75 0v.109A12.318 12.318 0 0 1 9.374 21c-2.331 0-4.512-.645-6.374-1.766Z"
    })
  ]);
}
function uI(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z"
    })
  ]);
}
function dI(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z"
    })
  ]);
}
function _I(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M4.745 3A23.933 23.933 0 0 0 3 12c0 3.183.62 6.22 1.745 9M19.5 3c.967 2.78 1.5 5.817 1.5 9s-.533 6.22-1.5 9M8.25 8.885l1.444-.89a.75.75 0 0 1 1.105.402l2.402 7.206a.75.75 0 0 0 1.104.401l1.445-.889m-8.25.75.213.09a1.687 1.687 0 0 0 2.062-.617l4.45-6.676a1.688 1.688 0 0 1 2.062-.618l.213.09"
    })
  ]);
}
function pI(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m15.75 10.5 4.72-4.72a.75.75 0 0 1 1.28.53v11.38a.75.75 0 0 1-1.28.53l-4.72-4.72M12 18.75H4.5a2.25 2.25 0 0 1-2.25-2.25V9m12.841 9.091L16.5 19.5m-1.409-1.409c.407-.407.659-.97.659-1.591v-9a2.25 2.25 0 0 0-2.25-2.25h-9c-.621 0-1.184.252-1.591.659m12.182 12.182L2.909 5.909M1.5 4.5l1.409 1.409"
    })
  ]);
}
function mI(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m15.75 10.5 4.72-4.72a.75.75 0 0 1 1.28.53v11.38a.75.75 0 0 1-1.28.53l-4.72-4.72M4.5 18.75h9a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25h-9A2.25 2.25 0 0 0 2.25 7.5v9a2.25 2.25 0 0 0 2.25 2.25Z"
    })
  ]);
}
function gI(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9 4.5v15m6-15v15m-10.875 0h15.75c.621 0 1.125-.504 1.125-1.125V5.625c0-.621-.504-1.125-1.125-1.125H4.125C3.504 4.5 3 5.004 3 5.625v12.75c0 .621.504 1.125 1.125 1.125Z"
    })
  ]);
}
function fI(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M7.5 3.75H6A2.25 2.25 0 0 0 3.75 6v1.5M16.5 3.75H18A2.25 2.25 0 0 1 20.25 6v1.5m0 9V18A2.25 2.25 0 0 1 18 20.25h-1.5m-9 0H6A2.25 2.25 0 0 1 3.75 18v-1.5M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
    })
  ]);
}
function hI(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M21 12a2.25 2.25 0 0 0-2.25-2.25H15a3 3 0 1 1-6 0H5.25A2.25 2.25 0 0 0 3 12m18 0v6a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 18v-6m18 0V9M3 12V9m18 0a2.25 2.25 0 0 0-2.25-2.25H5.25A2.25 2.25 0 0 0 3 9m18 0V6a2.25 2.25 0 0 0-2.25-2.25H5.25A2.25 2.25 0 0 0 3 6v3"
    })
  ]);
}
function vI(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M8.288 15.038a5.25 5.25 0 0 1 7.424 0M5.106 11.856c3.807-3.808 9.98-3.808 13.788 0M1.924 8.674c5.565-5.565 14.587-5.565 20.152 0M12.53 18.22l-.53.53-.53-.53a.75.75 0 0 1 1.06 0Z"
    })
  ]);
}
function EI(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M3 8.25V18a2.25 2.25 0 0 0 2.25 2.25h13.5A2.25 2.25 0 0 0 21 18V8.25m-18 0V6a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 6v2.25m-18 0h18M5.25 6h.008v.008H5.25V6ZM7.5 6h.008v.008H7.5V6Zm2.25 0h.008v.008H9.75V6Z"
    })
  ]);
}
function bI(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M11.42 15.17 17.25 21A2.652 2.652 0 0 0 21 17.25l-5.877-5.877M11.42 15.17l2.496-3.03c.317-.384.74-.626 1.208-.766M11.42 15.17l-4.655 5.653a2.548 2.548 0 1 1-3.586-3.586l6.837-5.63m5.108-.233c.55-.164 1.163-.188 1.743-.14a4.5 4.5 0 0 0 4.486-6.336l-3.276 3.277a3.004 3.004 0 0 1-2.25-2.25l3.276-3.276a4.5 4.5 0 0 0-6.336 4.486c.091 1.076-.071 2.264-.904 2.95l-.102.085m-1.745 1.437L5.909 7.5H4.5L2.25 3.75l1.5-1.5L7.5 4.5v1.409l4.26 4.26m-1.745 1.437 1.745-1.437m6.615 8.206L15.75 15.75M4.867 19.125h.008v.008h-.008v-.008Z"
    })
  ]);
}
function SI(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M21.75 6.75a4.5 4.5 0 0 1-4.884 4.484c-1.076-.091-2.264.071-2.95.904l-7.152 8.684a2.548 2.548 0 1 1-3.586-3.586l8.684-7.152c.833-.686.995-1.874.904-2.95a4.5 4.5 0 0 1 6.336-4.486l-3.276 3.276a3.004 3.004 0 0 0 2.25 2.25l3.276-3.276c.256.565.398 1.192.398 1.852Z"
    }),
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M4.867 19.125h.008v.008h-.008v-.008Z"
    })
  ]);
}
function wI(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    })
  ]);
}
function yI(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6 18 18 6M6 6l12 12"
    })
  ]);
}
const TI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AcademicCapIcon: T6,
  AdjustmentsHorizontalIcon: C6,
  AdjustmentsVerticalIcon: x6,
  ArchiveBoxArrowDownIcon: A6,
  ArchiveBoxIcon: O6,
  ArchiveBoxXMarkIcon: R6,
  ArrowDownCircleIcon: I6,
  ArrowDownIcon: P6,
  ArrowDownLeftIcon: N6,
  ArrowDownOnSquareIcon: D6,
  ArrowDownOnSquareStackIcon: M6,
  ArrowDownRightIcon: k6,
  ArrowDownTrayIcon: L6,
  ArrowLeftCircleIcon: B6,
  ArrowLeftEndOnRectangleIcon: F6,
  ArrowLeftIcon: V6,
  ArrowLeftOnRectangleIcon: U6,
  ArrowLeftStartOnRectangleIcon: $6,
  ArrowLongDownIcon: H6,
  ArrowLongLeftIcon: G6,
  ArrowLongRightIcon: Y6,
  ArrowLongUpIcon: z6,
  ArrowPathIcon: q6,
  ArrowPathRoundedSquareIcon: Z6,
  ArrowRightCircleIcon: W6,
  ArrowRightEndOnRectangleIcon: j6,
  ArrowRightIcon: X6,
  ArrowRightOnRectangleIcon: K6,
  ArrowRightStartOnRectangleIcon: Q6,
  ArrowSmallDownIcon: J6,
  ArrowSmallLeftIcon: ex,
  ArrowSmallRightIcon: tx,
  ArrowSmallUpIcon: nx,
  ArrowTopRightOnSquareIcon: rx,
  ArrowTrendingDownIcon: ax,
  ArrowTrendingUpIcon: ox,
  ArrowTurnDownLeftIcon: ix,
  ArrowTurnDownRightIcon: sx,
  ArrowTurnLeftDownIcon: lx,
  ArrowTurnLeftUpIcon: cx,
  ArrowTurnRightDownIcon: ux,
  ArrowTurnRightUpIcon: dx,
  ArrowTurnUpLeftIcon: _x,
  ArrowTurnUpRightIcon: px,
  ArrowUpCircleIcon: mx,
  ArrowUpIcon: bx,
  ArrowUpLeftIcon: gx,
  ArrowUpOnSquareIcon: hx,
  ArrowUpOnSquareStackIcon: fx,
  ArrowUpRightIcon: vx,
  ArrowUpTrayIcon: Ex,
  ArrowUturnDownIcon: Sx,
  ArrowUturnLeftIcon: wx,
  ArrowUturnRightIcon: yx,
  ArrowUturnUpIcon: Tx,
  ArrowsPointingInIcon: Cx,
  ArrowsPointingOutIcon: xx,
  ArrowsRightLeftIcon: Ax,
  ArrowsUpDownIcon: Rx,
  AtSymbolIcon: Ox,
  BackspaceIcon: Ix,
  BackwardIcon: Nx,
  BanknotesIcon: Mx,
  Bars2Icon: Dx,
  Bars3BottomLeftIcon: kx,
  Bars3BottomRightIcon: Lx,
  Bars3CenterLeftIcon: Px,
  Bars3Icon: Bx,
  Bars4Icon: Fx,
  BarsArrowDownIcon: Ux,
  BarsArrowUpIcon: $x,
  Battery0Icon: Vx,
  Battery100Icon: Hx,
  Battery50Icon: Gx,
  BeakerIcon: Yx,
  BellAlertIcon: zx,
  BellIcon: Wx,
  BellSlashIcon: Zx,
  BellSnoozeIcon: qx,
  BoldIcon: jx,
  BoltIcon: Qx,
  BoltSlashIcon: Kx,
  BookOpenIcon: Xx,
  BookmarkIcon: tA,
  BookmarkSlashIcon: Jx,
  BookmarkSquareIcon: eA,
  BriefcaseIcon: nA,
  BugAntIcon: rA,
  BuildingLibraryIcon: aA,
  BuildingOffice2Icon: oA,
  BuildingOfficeIcon: iA,
  BuildingStorefrontIcon: sA,
  CakeIcon: lA,
  CalculatorIcon: cA,
  CalendarDateRangeIcon: uA,
  CalendarDaysIcon: dA,
  CalendarIcon: _A,
  CameraIcon: pA,
  ChartBarIcon: gA,
  ChartBarSquareIcon: mA,
  ChartPieIcon: fA,
  ChatBubbleBottomCenterIcon: vA,
  ChatBubbleBottomCenterTextIcon: hA,
  ChatBubbleLeftEllipsisIcon: EA,
  ChatBubbleLeftIcon: SA,
  ChatBubbleLeftRightIcon: bA,
  ChatBubbleOvalLeftEllipsisIcon: wA,
  ChatBubbleOvalLeftIcon: yA,
  CheckBadgeIcon: TA,
  CheckCircleIcon: CA,
  CheckIcon: xA,
  ChevronDoubleDownIcon: AA,
  ChevronDoubleLeftIcon: RA,
  ChevronDoubleRightIcon: OA,
  ChevronDoubleUpIcon: IA,
  ChevronDownIcon: NA,
  ChevronLeftIcon: MA,
  ChevronRightIcon: DA,
  ChevronUpDownIcon: kA,
  ChevronUpIcon: LA,
  CircleStackIcon: PA,
  ClipboardDocumentCheckIcon: BA,
  ClipboardDocumentIcon: UA,
  ClipboardDocumentListIcon: FA,
  ClipboardIcon: $A,
  ClockIcon: VA,
  CloudArrowDownIcon: HA,
  CloudArrowUpIcon: GA,
  CloudIcon: YA,
  CodeBracketIcon: ZA,
  CodeBracketSquareIcon: zA,
  Cog6ToothIcon: qA,
  Cog8ToothIcon: WA,
  CogIcon: jA,
  CommandLineIcon: KA,
  ComputerDesktopIcon: QA,
  CpuChipIcon: XA,
  CreditCardIcon: JA,
  CubeIcon: tR,
  CubeTransparentIcon: eR,
  CurrencyBangladeshiIcon: nR,
  CurrencyDollarIcon: rR,
  CurrencyEuroIcon: aR,
  CurrencyPoundIcon: oR,
  CurrencyRupeeIcon: iR,
  CurrencyYenIcon: sR,
  CursorArrowRaysIcon: lR,
  CursorArrowRippleIcon: cR,
  DevicePhoneMobileIcon: uR,
  DeviceTabletIcon: dR,
  DivideIcon: _R,
  DocumentArrowDownIcon: pR,
  DocumentArrowUpIcon: mR,
  DocumentChartBarIcon: gR,
  DocumentCheckIcon: fR,
  DocumentCurrencyBangladeshiIcon: hR,
  DocumentCurrencyDollarIcon: vR,
  DocumentCurrencyEuroIcon: ER,
  DocumentCurrencyPoundIcon: bR,
  DocumentCurrencyRupeeIcon: SR,
  DocumentCurrencyYenIcon: wR,
  DocumentDuplicateIcon: yR,
  DocumentIcon: RR,
  DocumentMagnifyingGlassIcon: TR,
  DocumentMinusIcon: CR,
  DocumentPlusIcon: xR,
  DocumentTextIcon: AR,
  EllipsisHorizontalCircleIcon: OR,
  EllipsisHorizontalIcon: IR,
  EllipsisVerticalIcon: NR,
  EnvelopeIcon: DR,
  EnvelopeOpenIcon: MR,
  EqualsIcon: kR,
  ExclamationCircleIcon: LR,
  ExclamationTriangleIcon: PR,
  EyeDropperIcon: BR,
  EyeIcon: UR,
  EyeSlashIcon: FR,
  FaceFrownIcon: $R,
  FaceSmileIcon: VR,
  FilmIcon: HR,
  FingerPrintIcon: GR,
  FireIcon: YR,
  FlagIcon: zR,
  FolderArrowDownIcon: ZR,
  FolderIcon: KR,
  FolderMinusIcon: qR,
  FolderOpenIcon: WR,
  FolderPlusIcon: jR,
  ForwardIcon: QR,
  FunnelIcon: XR,
  GifIcon: JR,
  GiftIcon: tO,
  GiftTopIcon: eO,
  GlobeAltIcon: nO,
  GlobeAmericasIcon: rO,
  GlobeAsiaAustraliaIcon: aO,
  GlobeEuropeAfricaIcon: oO,
  H1Icon: iO,
  H2Icon: sO,
  H3Icon: lO,
  HandRaisedIcon: cO,
  HandThumbDownIcon: uO,
  HandThumbUpIcon: dO,
  HashtagIcon: _O,
  HeartIcon: pO,
  HomeIcon: gO,
  HomeModernIcon: mO,
  IdentificationIcon: fO,
  InboxArrowDownIcon: hO,
  InboxIcon: EO,
  InboxStackIcon: vO,
  InformationCircleIcon: bO,
  ItalicIcon: SO,
  KeyIcon: wO,
  LanguageIcon: yO,
  LifebuoyIcon: TO,
  LightBulbIcon: CO,
  LinkIcon: AO,
  LinkSlashIcon: xO,
  ListBulletIcon: RO,
  LockClosedIcon: OO,
  LockOpenIcon: IO,
  MagnifyingGlassCircleIcon: NO,
  MagnifyingGlassIcon: kO,
  MagnifyingGlassMinusIcon: MO,
  MagnifyingGlassPlusIcon: DO,
  MapIcon: PO,
  MapPinIcon: LO,
  MegaphoneIcon: BO,
  MicrophoneIcon: FO,
  MinusCircleIcon: UO,
  MinusIcon: VO,
  MinusSmallIcon: $O,
  MoonIcon: HO,
  MusicalNoteIcon: GO,
  NewspaperIcon: YO,
  NoSymbolIcon: zO,
  NumberedListIcon: ZO,
  PaintBrushIcon: qO,
  PaperAirplaneIcon: WO,
  PaperClipIcon: jO,
  PauseCircleIcon: KO,
  PauseIcon: QO,
  PencilIcon: JO,
  PencilSquareIcon: XO,
  PercentBadgeIcon: e8,
  PhoneArrowDownLeftIcon: t8,
  PhoneArrowUpRightIcon: n8,
  PhoneIcon: a8,
  PhoneXMarkIcon: r8,
  PhotoIcon: o8,
  PlayCircleIcon: i8,
  PlayIcon: l8,
  PlayPauseIcon: s8,
  PlusCircleIcon: c8,
  PlusIcon: d8,
  PlusSmallIcon: u8,
  PowerIcon: _8,
  PresentationChartBarIcon: p8,
  PresentationChartLineIcon: m8,
  PrinterIcon: g8,
  PuzzlePieceIcon: f8,
  QrCodeIcon: h8,
  QuestionMarkCircleIcon: v8,
  QueueListIcon: E8,
  RadioIcon: b8,
  ReceiptPercentIcon: S8,
  ReceiptRefundIcon: w8,
  RectangleGroupIcon: y8,
  RectangleStackIcon: T8,
  RocketLaunchIcon: C8,
  RssIcon: x8,
  ScaleIcon: A8,
  ScissorsIcon: R8,
  ServerIcon: I8,
  ServerStackIcon: O8,
  ShareIcon: N8,
  ShieldCheckIcon: M8,
  ShieldExclamationIcon: D8,
  ShoppingBagIcon: k8,
  ShoppingCartIcon: L8,
  SignalIcon: B8,
  SignalSlashIcon: P8,
  SlashIcon: F8,
  SparklesIcon: U8,
  SpeakerWaveIcon: $8,
  SpeakerXMarkIcon: V8,
  Square2StackIcon: H8,
  Square3Stack3DIcon: G8,
  Squares2X2Icon: Y8,
  SquaresPlusIcon: z8,
  StarIcon: Z8,
  StopCircleIcon: q8,
  StopIcon: W8,
  StrikethroughIcon: j8,
  SunIcon: K8,
  SwatchIcon: Q8,
  TableCellsIcon: X8,
  TagIcon: J8,
  TicketIcon: eI,
  TrashIcon: tI,
  TrophyIcon: nI,
  TruckIcon: rI,
  TvIcon: aI,
  UnderlineIcon: oI,
  UserCircleIcon: iI,
  UserGroupIcon: sI,
  UserIcon: uI,
  UserMinusIcon: lI,
  UserPlusIcon: cI,
  UsersIcon: dI,
  VariableIcon: _I,
  VideoCameraIcon: mI,
  VideoCameraSlashIcon: pI,
  ViewColumnsIcon: gI,
  ViewfinderCircleIcon: fI,
  WalletIcon: hI,
  WifiIcon: vI,
  WindowIcon: EI,
  WrenchIcon: SI,
  WrenchScrewdriverIcon: bI,
  XCircleIcon: wI,
  XMarkIcon: yI
}, Symbol.toStringTag, { value: "Module" }));
function CI(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M11.7 2.805a.75.75 0 0 1 .6 0A60.65 60.65 0 0 1 22.83 8.72a.75.75 0 0 1-.231 1.337 49.948 49.948 0 0 0-9.902 3.912l-.003.002c-.114.06-.227.119-.34.18a.75.75 0 0 1-.707 0A50.88 50.88 0 0 0 7.5 12.173v-.224c0-.131.067-.248.172-.311a54.615 54.615 0 0 1 4.653-2.52.75.75 0 0 0-.65-1.352 56.123 56.123 0 0 0-4.78 2.589 1.858 1.858 0 0 0-.859 1.228 49.803 49.803 0 0 0-4.634-1.527.75.75 0 0 1-.231-1.337A60.653 60.653 0 0 1 11.7 2.805Z" }),
    d("path", { d: "M13.06 15.473a48.45 48.45 0 0 1 7.666-3.282c.134 1.414.22 2.843.255 4.284a.75.75 0 0 1-.46.711 47.87 47.87 0 0 0-8.105 4.342.75.75 0 0 1-.832 0 47.87 47.87 0 0 0-8.104-4.342.75.75 0 0 1-.461-.71c.035-1.442.121-2.87.255-4.286.921.304 1.83.634 2.726.99v1.27a1.5 1.5 0 0 0-.14 2.508c-.09.38-.222.753-.397 1.11.452.213.901.434 1.346.66a6.727 6.727 0 0 0 .551-1.607 1.5 1.5 0 0 0 .14-2.67v-.645a48.549 48.549 0 0 1 3.44 1.667 2.25 2.25 0 0 0 2.12 0Z" }),
    d("path", { d: "M4.462 19.462c.42-.419.753-.89 1-1.395.453.214.902.435 1.347.662a6.742 6.742 0 0 1-1.286 1.794.75.75 0 0 1-1.06-1.06Z" })
  ]);
}
function xI(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M18.75 12.75h1.5a.75.75 0 0 0 0-1.5h-1.5a.75.75 0 0 0 0 1.5ZM12 6a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 12 6ZM12 18a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 12 18ZM3.75 6.75h1.5a.75.75 0 1 0 0-1.5h-1.5a.75.75 0 0 0 0 1.5ZM5.25 18.75h-1.5a.75.75 0 0 1 0-1.5h1.5a.75.75 0 0 1 0 1.5ZM3 12a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 3 12ZM9 3.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5ZM12.75 12a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0ZM9 15.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5Z" })
  ]);
}
function AI(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M6 12a.75.75 0 0 1-.75-.75v-7.5a.75.75 0 1 1 1.5 0v7.5A.75.75 0 0 1 6 12ZM18 12a.75.75 0 0 1-.75-.75v-7.5a.75.75 0 0 1 1.5 0v7.5A.75.75 0 0 1 18 12ZM6.75 20.25v-1.5a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 0 1.5 0ZM18.75 18.75v1.5a.75.75 0 0 1-1.5 0v-1.5a.75.75 0 0 1 1.5 0ZM12.75 5.25v-1.5a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 0 1.5 0ZM12 21a.75.75 0 0 1-.75-.75v-7.5a.75.75 0 0 1 1.5 0v7.5A.75.75 0 0 1 12 21ZM3.75 15a2.25 2.25 0 1 0 4.5 0 2.25 2.25 0 0 0-4.5 0ZM12 11.25a2.25 2.25 0 1 1 0-4.5 2.25 2.25 0 0 1 0 4.5ZM15.75 15a2.25 2.25 0 1 0 4.5 0 2.25 2.25 0 0 0-4.5 0Z" })
  ]);
}
function RI(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M3.375 3C2.339 3 1.5 3.84 1.5 4.875v.75c0 1.036.84 1.875 1.875 1.875h17.25c1.035 0 1.875-.84 1.875-1.875v-.75C22.5 3.839 21.66 3 20.625 3H3.375Z" }),
    d("path", {
      "fill-rule": "evenodd",
      d: "m3.087 9 .54 9.176A3 3 0 0 0 6.62 21h10.757a3 3 0 0 0 2.995-2.824L20.913 9H3.087ZM12 10.5a.75.75 0 0 1 .75.75v4.94l1.72-1.72a.75.75 0 1 1 1.06 1.06l-3 3a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 1 1 1.06-1.06l1.72 1.72v-4.94a.75.75 0 0 1 .75-.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function OI(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M3.375 3C2.339 3 1.5 3.84 1.5 4.875v.75c0 1.036.84 1.875 1.875 1.875h17.25c1.035 0 1.875-.84 1.875-1.875v-.75C22.5 3.839 21.66 3 20.625 3H3.375Z" }),
    d("path", {
      "fill-rule": "evenodd",
      d: "m3.087 9 .54 9.176A3 3 0 0 0 6.62 21h10.757a3 3 0 0 0 2.995-2.824L20.913 9H3.087Zm6.133 2.845a.75.75 0 0 1 1.06 0l1.72 1.72 1.72-1.72a.75.75 0 1 1 1.06 1.06l-1.72 1.72 1.72 1.72a.75.75 0 1 1-1.06 1.06L12 15.685l-1.72 1.72a.75.75 0 1 1-1.06-1.06l1.72-1.72-1.72-1.72a.75.75 0 0 1 0-1.06Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function II(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M3.375 3C2.339 3 1.5 3.84 1.5 4.875v.75c0 1.036.84 1.875 1.875 1.875h17.25c1.035 0 1.875-.84 1.875-1.875v-.75C22.5 3.839 21.66 3 20.625 3H3.375Z" }),
    d("path", {
      "fill-rule": "evenodd",
      d: "m3.087 9 .54 9.176A3 3 0 0 0 6.62 21h10.757a3 3 0 0 0 2.995-2.824L20.913 9H3.087Zm6.163 3.75A.75.75 0 0 1 10 12h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function NI(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-.53 14.03a.75.75 0 0 0 1.06 0l3-3a.75.75 0 1 0-1.06-1.06l-1.72 1.72V8.25a.75.75 0 0 0-1.5 0v5.69l-1.72-1.72a.75.75 0 0 0-1.06 1.06l3 3Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function MI(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M20.03 3.97a.75.75 0 0 1 0 1.06L6.31 18.75h9.44a.75.75 0 0 1 0 1.5H4.5a.75.75 0 0 1-.75-.75V8.25a.75.75 0 0 1 1.5 0v9.44L18.97 3.97a.75.75 0 0 1 1.06 0Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function DI(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M9.75 6.75h-3a3 3 0 0 0-3 3v7.5a3 3 0 0 0 3 3h7.5a3 3 0 0 0 3-3v-7.5a3 3 0 0 0-3-3h-3V1.5a.75.75 0 0 0-1.5 0v5.25Zm0 0h1.5v5.69l1.72-1.72a.75.75 0 1 1 1.06 1.06l-3 3a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 1 1 1.06-1.06l1.72 1.72V6.75Z",
      "clip-rule": "evenodd"
    }),
    d("path", { d: "M7.151 21.75a2.999 2.999 0 0 0 2.599 1.5h7.5a3 3 0 0 0 3-3v-7.5c0-1.11-.603-2.08-1.5-2.599v7.099a4.5 4.5 0 0 1-4.5 4.5H7.151Z" })
  ]);
}
function kI(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M12 1.5a.75.75 0 0 1 .75.75V7.5h-1.5V2.25A.75.75 0 0 1 12 1.5ZM11.25 7.5v5.69l-1.72-1.72a.75.75 0 0 0-1.06 1.06l3 3a.75.75 0 0 0 1.06 0l3-3a.75.75 0 1 0-1.06-1.06l-1.72 1.72V7.5h3.75a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3h-9a3 3 0 0 1-3-3v-9a3 3 0 0 1 3-3h3.75Z" })
  ]);
}
function LI(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M3.97 3.97a.75.75 0 0 1 1.06 0l13.72 13.72V8.25a.75.75 0 0 1 1.5 0V19.5a.75.75 0 0 1-.75.75H8.25a.75.75 0 0 1 0-1.5h9.44L3.97 5.03a.75.75 0 0 1 0-1.06Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function PI(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M12 2.25a.75.75 0 0 1 .75.75v11.69l3.22-3.22a.75.75 0 1 1 1.06 1.06l-4.5 4.5a.75.75 0 0 1-1.06 0l-4.5-4.5a.75.75 0 1 1 1.06-1.06l3.22 3.22V3a.75.75 0 0 1 .75-.75Zm-9 13.5a.75.75 0 0 1 .75.75v2.25a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5V16.5a.75.75 0 0 1 1.5 0v2.25a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3V16.5a.75.75 0 0 1 .75-.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function BI(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M12 2.25a.75.75 0 0 1 .75.75v16.19l6.22-6.22a.75.75 0 1 1 1.06 1.06l-7.5 7.5a.75.75 0 0 1-1.06 0l-7.5-7.5a.75.75 0 1 1 1.06-1.06l6.22 6.22V3a.75.75 0 0 1 .75-.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function FI(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-4.28 9.22a.75.75 0 0 0 0 1.06l3 3a.75.75 0 1 0 1.06-1.06l-1.72-1.72h5.69a.75.75 0 0 0 0-1.5h-5.69l1.72-1.72a.75.75 0 0 0-1.06-1.06l-3 3Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function UI(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M7.5 3.75A1.5 1.5 0 0 0 6 5.25v13.5a1.5 1.5 0 0 0 1.5 1.5h6a1.5 1.5 0 0 0 1.5-1.5V15a.75.75 0 0 1 1.5 0v3.75a3 3 0 0 1-3 3h-6a3 3 0 0 1-3-3V5.25a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3V9A.75.75 0 0 1 15 9V5.25a1.5 1.5 0 0 0-1.5-1.5h-6Zm5.03 4.72a.75.75 0 0 1 0 1.06l-1.72 1.72h10.94a.75.75 0 0 1 0 1.5H10.81l1.72 1.72a.75.75 0 1 1-1.06 1.06l-3-3a.75.75 0 0 1 0-1.06l3-3a.75.75 0 0 1 1.06 0Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function $I(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M7.5 3.75A1.5 1.5 0 0 0 6 5.25v13.5a1.5 1.5 0 0 0 1.5 1.5h6a1.5 1.5 0 0 0 1.5-1.5V15a.75.75 0 0 1 1.5 0v3.75a3 3 0 0 1-3 3h-6a3 3 0 0 1-3-3V5.25a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3V9A.75.75 0 0 1 15 9V5.25a1.5 1.5 0 0 0-1.5-1.5h-6Zm5.03 4.72a.75.75 0 0 1 0 1.06l-1.72 1.72h10.94a.75.75 0 0 1 0 1.5H10.81l1.72 1.72a.75.75 0 1 1-1.06 1.06l-3-3a.75.75 0 0 1 0-1.06l3-3a.75.75 0 0 1 1.06 0Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function VI(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M16.5 3.75a1.5 1.5 0 0 1 1.5 1.5v13.5a1.5 1.5 0 0 1-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5V15a.75.75 0 0 0-1.5 0v3.75a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3V5.25a3 3 0 0 0-3-3h-6a3 3 0 0 0-3 3V9A.75.75 0 1 0 9 9V5.25a1.5 1.5 0 0 1 1.5-1.5h6ZM5.78 8.47a.75.75 0 0 0-1.06 0l-3 3a.75.75 0 0 0 0 1.06l3 3a.75.75 0 0 0 1.06-1.06l-1.72-1.72H15a.75.75 0 0 0 0-1.5H4.06l1.72-1.72a.75.75 0 0 0 0-1.06Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function HI(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M11.03 3.97a.75.75 0 0 1 0 1.06l-6.22 6.22H21a.75.75 0 0 1 0 1.5H4.81l6.22 6.22a.75.75 0 1 1-1.06 1.06l-7.5-7.5a.75.75 0 0 1 0-1.06l7.5-7.5a.75.75 0 0 1 1.06 0Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function GI(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M12 2.25a.75.75 0 0 1 .75.75v16.19l2.47-2.47a.75.75 0 1 1 1.06 1.06l-3.75 3.75a.75.75 0 0 1-1.06 0l-3.75-3.75a.75.75 0 1 1 1.06-1.06l2.47 2.47V3a.75.75 0 0 1 .75-.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function YI(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M7.28 7.72a.75.75 0 0 1 0 1.06l-2.47 2.47H21a.75.75 0 0 1 0 1.5H4.81l2.47 2.47a.75.75 0 1 1-1.06 1.06l-3.75-3.75a.75.75 0 0 1 0-1.06l3.75-3.75a.75.75 0 0 1 1.06 0Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function zI(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M16.72 7.72a.75.75 0 0 1 1.06 0l3.75 3.75a.75.75 0 0 1 0 1.06l-3.75 3.75a.75.75 0 1 1-1.06-1.06l2.47-2.47H3a.75.75 0 0 1 0-1.5h16.19l-2.47-2.47a.75.75 0 0 1 0-1.06Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function ZI(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M11.47 2.47a.75.75 0 0 1 1.06 0l3.75 3.75a.75.75 0 0 1-1.06 1.06l-2.47-2.47V21a.75.75 0 0 1-1.5 0V4.81L8.78 7.28a.75.75 0 0 1-1.06-1.06l3.75-3.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function qI(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M12 5.25c1.213 0 2.415.046 3.605.135a3.256 3.256 0 0 1 3.01 3.01c.044.583.077 1.17.1 1.759L17.03 8.47a.75.75 0 1 0-1.06 1.06l3 3a.75.75 0 0 0 1.06 0l3-3a.75.75 0 0 0-1.06-1.06l-1.752 1.751c-.023-.65-.06-1.296-.108-1.939a4.756 4.756 0 0 0-4.392-4.392 49.422 49.422 0 0 0-7.436 0A4.756 4.756 0 0 0 3.89 8.282c-.017.224-.033.447-.046.672a.75.75 0 1 0 1.497.092c.013-.217.028-.434.044-.651a3.256 3.256 0 0 1 3.01-3.01c1.19-.09 2.392-.135 3.605-.135Zm-6.97 6.22a.75.75 0 0 0-1.06 0l-3 3a.75.75 0 1 0 1.06 1.06l1.752-1.751c.023.65.06 1.296.108 1.939a4.756 4.756 0 0 0 4.392 4.392 49.413 49.413 0 0 0 7.436 0 4.756 4.756 0 0 0 4.392-4.392c.017-.223.032-.447.046-.672a.75.75 0 0 0-1.497-.092c-.013.217-.028.434-.044.651a3.256 3.256 0 0 1-3.01 3.01 47.953 47.953 0 0 1-7.21 0 3.256 3.256 0 0 1-3.01-3.01 47.759 47.759 0 0 1-.1-1.759L6.97 15.53a.75.75 0 0 0 1.06-1.06l-3-3Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function WI(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M4.755 10.059a7.5 7.5 0 0 1 12.548-3.364l1.903 1.903h-3.183a.75.75 0 1 0 0 1.5h4.992a.75.75 0 0 0 .75-.75V4.356a.75.75 0 0 0-1.5 0v3.18l-1.9-1.9A9 9 0 0 0 3.306 9.67a.75.75 0 1 0 1.45.388Zm15.408 3.352a.75.75 0 0 0-.919.53 7.5 7.5 0 0 1-12.548 3.364l-1.902-1.903h3.183a.75.75 0 0 0 0-1.5H2.984a.75.75 0 0 0-.75.75v4.992a.75.75 0 0 0 1.5 0v-3.18l1.9 1.9a9 9 0 0 0 15.059-4.035.75.75 0 0 0-.53-.918Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function jI(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm4.28 10.28a.75.75 0 0 0 0-1.06l-3-3a.75.75 0 1 0-1.06 1.06l1.72 1.72H8.25a.75.75 0 0 0 0 1.5h5.69l-1.72 1.72a.75.75 0 1 0 1.06 1.06l3-3Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function KI(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M16.5 3.75a1.5 1.5 0 0 1 1.5 1.5v13.5a1.5 1.5 0 0 1-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5V15a.75.75 0 0 0-1.5 0v3.75a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3V5.25a3 3 0 0 0-3-3h-6a3 3 0 0 0-3 3V9A.75.75 0 1 0 9 9V5.25a1.5 1.5 0 0 1 1.5-1.5h6Zm-5.03 4.72a.75.75 0 0 0 0 1.06l1.72 1.72H2.25a.75.75 0 0 0 0 1.5h10.94l-1.72 1.72a.75.75 0 1 0 1.06 1.06l3-3a.75.75 0 0 0 0-1.06l-3-3a.75.75 0 0 0-1.06 0Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function QI(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M7.5 3.75A1.5 1.5 0 0 0 6 5.25v13.5a1.5 1.5 0 0 0 1.5 1.5h6a1.5 1.5 0 0 0 1.5-1.5V15a.75.75 0 0 1 1.5 0v3.75a3 3 0 0 1-3 3h-6a3 3 0 0 1-3-3V5.25a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3V9A.75.75 0 0 1 15 9V5.25a1.5 1.5 0 0 0-1.5-1.5h-6Zm10.72 4.72a.75.75 0 0 1 1.06 0l3 3a.75.75 0 0 1 0 1.06l-3 3a.75.75 0 1 1-1.06-1.06l1.72-1.72H9a.75.75 0 0 1 0-1.5h10.94l-1.72-1.72a.75.75 0 0 1 0-1.06Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function XI(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M7.5 3.75A1.5 1.5 0 0 0 6 5.25v13.5a1.5 1.5 0 0 0 1.5 1.5h6a1.5 1.5 0 0 0 1.5-1.5V15a.75.75 0 0 1 1.5 0v3.75a3 3 0 0 1-3 3h-6a3 3 0 0 1-3-3V5.25a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3V9A.75.75 0 0 1 15 9V5.25a1.5 1.5 0 0 0-1.5-1.5h-6Zm10.72 4.72a.75.75 0 0 1 1.06 0l3 3a.75.75 0 0 1 0 1.06l-3 3a.75.75 0 1 1-1.06-1.06l1.72-1.72H9a.75.75 0 0 1 0-1.5h10.94l-1.72-1.72a.75.75 0 0 1 0-1.06Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function JI(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M12.97 3.97a.75.75 0 0 1 1.06 0l7.5 7.5a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 1 1-1.06-1.06l6.22-6.22H3a.75.75 0 0 1 0-1.5h16.19l-6.22-6.22a.75.75 0 0 1 0-1.06Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function eN(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M12 3.75a.75.75 0 0 1 .75.75v13.19l5.47-5.47a.75.75 0 1 1 1.06 1.06l-6.75 6.75a.75.75 0 0 1-1.06 0l-6.75-6.75a.75.75 0 1 1 1.06-1.06l5.47 5.47V4.5a.75.75 0 0 1 .75-.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function tN(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M20.25 12a.75.75 0 0 1-.75.75H6.31l5.47 5.47a.75.75 0 1 1-1.06 1.06l-6.75-6.75a.75.75 0 0 1 0-1.06l6.75-6.75a.75.75 0 1 1 1.06 1.06l-5.47 5.47H19.5a.75.75 0 0 1 .75.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function nN(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M3.75 12a.75.75 0 0 1 .75-.75h13.19l-5.47-5.47a.75.75 0 0 1 1.06-1.06l6.75 6.75a.75.75 0 0 1 0 1.06l-6.75 6.75a.75.75 0 1 1-1.06-1.06l5.47-5.47H4.5a.75.75 0 0 1-.75-.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function rN(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M12 20.25a.75.75 0 0 1-.75-.75V6.31l-5.47 5.47a.75.75 0 0 1-1.06-1.06l6.75-6.75a.75.75 0 0 1 1.06 0l6.75 6.75a.75.75 0 1 1-1.06 1.06l-5.47-5.47V19.5a.75.75 0 0 1-.75.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function aN(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M15.75 2.25H21a.75.75 0 0 1 .75.75v5.25a.75.75 0 0 1-1.5 0V4.81L8.03 17.03a.75.75 0 0 1-1.06-1.06L19.19 3.75h-3.44a.75.75 0 0 1 0-1.5Zm-10.5 4.5a1.5 1.5 0 0 0-1.5 1.5v10.5a1.5 1.5 0 0 0 1.5 1.5h10.5a1.5 1.5 0 0 0 1.5-1.5V10.5a.75.75 0 0 1 1.5 0v8.25a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3V8.25a3 3 0 0 1 3-3h8.25a.75.75 0 0 1 0 1.5H5.25Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function oN(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M1.72 5.47a.75.75 0 0 1 1.06 0L9 11.69l3.756-3.756a.75.75 0 0 1 .985-.066 12.698 12.698 0 0 1 4.575 6.832l.308 1.149 2.277-3.943a.75.75 0 1 1 1.299.75l-3.182 5.51a.75.75 0 0 1-1.025.275l-5.511-3.181a.75.75 0 0 1 .75-1.3l3.943 2.277-.308-1.149a11.194 11.194 0 0 0-3.528-5.617l-3.809 3.81a.75.75 0 0 1-1.06 0L1.72 6.53a.75.75 0 0 1 0-1.061Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function iN(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M15.22 6.268a.75.75 0 0 1 .968-.431l5.942 2.28a.75.75 0 0 1 .431.97l-2.28 5.94a.75.75 0 1 1-1.4-.537l1.63-4.251-1.086.484a11.2 11.2 0 0 0-5.45 5.173.75.75 0 0 1-1.199.19L9 12.312l-6.22 6.22a.75.75 0 0 1-1.06-1.061l6.75-6.75a.75.75 0 0 1 1.06 0l3.606 3.606a12.695 12.695 0 0 1 5.68-4.974l1.086-.483-4.251-1.632a.75.75 0 0 1-.432-.97Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function sN(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M20.239 3.749a.75.75 0 0 0-.75.75V15H5.549l2.47-2.47a.75.75 0 0 0-1.06-1.06l-3.75 3.75a.75.75 0 0 0 0 1.06l3.75 3.75a.75.75 0 1 0 1.06-1.06L5.55 16.5h14.69a.75.75 0 0 0 .75-.75V4.5a.75.75 0 0 0-.75-.751Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function lN(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M3.74 3.749a.75.75 0 0 1 .75.75V15h13.938l-2.47-2.47a.75.75 0 0 1 1.061-1.06l3.75 3.75a.75.75 0 0 1 0 1.06l-3.75 3.75a.75.75 0 0 1-1.06-1.06l2.47-2.47H3.738a.75.75 0 0 1-.75-.75V4.5a.75.75 0 0 1 .75-.751Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function cN(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M20.24 3.75a.75.75 0 0 1-.75.75H8.989v13.939l2.47-2.47a.75.75 0 1 1 1.06 1.061l-3.75 3.75a.75.75 0 0 1-1.06 0l-3.751-3.75a.75.75 0 1 1 1.06-1.06l2.47 2.469V3.75a.75.75 0 0 1 .75-.75H19.49a.75.75 0 0 1 .75.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function uN(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M20.24 20.249a.75.75 0 0 0-.75-.75H8.989V5.56l2.47 2.47a.75.75 0 0 0 1.06-1.061l-3.75-3.75a.75.75 0 0 0-1.06 0l-3.75 3.75a.75.75 0 1 0 1.06 1.06l2.47-2.469V20.25c0 .414.335.75.75.75h11.25a.75.75 0 0 0 .75-.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function dN(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M3.738 3.75c0 .414.336.75.75.75H14.99v13.939l-2.47-2.47a.75.75 0 0 0-1.06 1.061l3.75 3.75a.75.75 0 0 0 1.06 0l3.751-3.75a.75.75 0 0 0-1.06-1.06l-2.47 2.469V3.75a.75.75 0 0 0-.75-.75H4.487a.75.75 0 0 0-.75.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function _N(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M3.738 20.249a.75.75 0 0 1 .75-.75H14.99V5.56l-2.47 2.47a.75.75 0 0 1-1.06-1.061l3.75-3.75a.75.75 0 0 1 1.06 0l3.751 3.75a.75.75 0 0 1-1.06 1.06L16.49 5.56V20.25a.75.75 0 0 1-.75.75H4.487a.75.75 0 0 1-.75-.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function pN(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M20.239 20.25a.75.75 0 0 1-.75-.75V8.999H5.549l2.47 2.47a.75.75 0 0 1-1.06 1.06l-3.75-3.75a.75.75 0 0 1 0-1.06l3.75-3.75a.75.75 0 1 1 1.06 1.06l-2.47 2.47h14.69a.75.75 0 0 1 .75.75V19.5a.75.75 0 0 1-.75.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function mN(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M3.74 20.25a.75.75 0 0 0 .75-.75V8.999h13.938l-2.47 2.47a.75.75 0 0 0 1.061 1.06l3.75-3.75a.75.75 0 0 0 0-1.06l-3.75-3.75a.75.75 0 0 0-1.06 1.06l2.47 2.47H3.738a.75.75 0 0 0-.75.75V19.5c0 .414.336.75.75.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function gN(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm.53 5.47a.75.75 0 0 0-1.06 0l-3 3a.75.75 0 1 0 1.06 1.06l1.72-1.72v5.69a.75.75 0 0 0 1.5 0v-5.69l1.72 1.72a.75.75 0 1 0 1.06-1.06l-3-3Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function fN(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M5.25 6.31v9.44a.75.75 0 0 1-1.5 0V4.5a.75.75 0 0 1 .75-.75h11.25a.75.75 0 0 1 0 1.5H6.31l13.72 13.72a.75.75 0 1 1-1.06 1.06L5.25 6.31Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function hN(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M9.97.97a.75.75 0 0 1 1.06 0l3 3a.75.75 0 0 1-1.06 1.06l-1.72-1.72v3.44h-1.5V3.31L8.03 5.03a.75.75 0 0 1-1.06-1.06l3-3ZM9.75 6.75v6a.75.75 0 0 0 1.5 0v-6h3a3 3 0 0 1 3 3v7.5a3 3 0 0 1-3 3h-7.5a3 3 0 0 1-3-3v-7.5a3 3 0 0 1 3-3h3Z" }),
    d("path", { d: "M7.151 21.75a2.999 2.999 0 0 0 2.599 1.5h7.5a3 3 0 0 0 3-3v-7.5c0-1.11-.603-2.08-1.5-2.599v7.099a4.5 4.5 0 0 1-4.5 4.5H7.151Z" })
  ]);
}
function vN(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M11.47 1.72a.75.75 0 0 1 1.06 0l3 3a.75.75 0 0 1-1.06 1.06l-1.72-1.72V7.5h-1.5V4.06L9.53 5.78a.75.75 0 0 1-1.06-1.06l3-3ZM11.25 7.5V15a.75.75 0 0 0 1.5 0V7.5h3.75a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3h-9a3 3 0 0 1-3-3v-9a3 3 0 0 1 3-3h3.75Z" })
  ]);
}
function EN(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M8.25 3.75H19.5a.75.75 0 0 1 .75.75v11.25a.75.75 0 0 1-1.5 0V6.31L5.03 20.03a.75.75 0 0 1-1.06-1.06L17.69 5.25H8.25a.75.75 0 0 1 0-1.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function bN(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M11.47 2.47a.75.75 0 0 1 1.06 0l4.5 4.5a.75.75 0 0 1-1.06 1.06l-3.22-3.22V16.5a.75.75 0 0 1-1.5 0V4.81L8.03 8.03a.75.75 0 0 1-1.06-1.06l4.5-4.5ZM3 15.75a.75.75 0 0 1 .75.75v2.25a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5V16.5a.75.75 0 0 1 1.5 0v2.25a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3V16.5a.75.75 0 0 1 .75-.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function SN(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M11.47 2.47a.75.75 0 0 1 1.06 0l7.5 7.5a.75.75 0 1 1-1.06 1.06l-6.22-6.22V21a.75.75 0 0 1-1.5 0V4.81l-6.22 6.22a.75.75 0 1 1-1.06-1.06l7.5-7.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function wN(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M15 3.75A5.25 5.25 0 0 0 9.75 9v10.19l4.72-4.72a.75.75 0 1 1 1.06 1.06l-6 6a.75.75 0 0 1-1.06 0l-6-6a.75.75 0 1 1 1.06-1.06l4.72 4.72V9a6.75 6.75 0 0 1 13.5 0v3a.75.75 0 0 1-1.5 0V9c0-2.9-2.35-5.25-5.25-5.25Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function yN(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M9.53 2.47a.75.75 0 0 1 0 1.06L4.81 8.25H15a6.75 6.75 0 0 1 0 13.5h-3a.75.75 0 0 1 0-1.5h3a5.25 5.25 0 1 0 0-10.5H4.81l4.72 4.72a.75.75 0 1 1-1.06 1.06l-6-6a.75.75 0 0 1 0-1.06l6-6a.75.75 0 0 1 1.06 0Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function TN(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M14.47 2.47a.75.75 0 0 1 1.06 0l6 6a.75.75 0 0 1 0 1.06l-6 6a.75.75 0 1 1-1.06-1.06l4.72-4.72H9a5.25 5.25 0 1 0 0 10.5h3a.75.75 0 0 1 0 1.5H9a6.75 6.75 0 0 1 0-13.5h10.19l-4.72-4.72a.75.75 0 0 1 0-1.06Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function CN(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M21.53 9.53a.75.75 0 0 1-1.06 0l-4.72-4.72V15a6.75 6.75 0 0 1-13.5 0v-3a.75.75 0 0 1 1.5 0v3a5.25 5.25 0 1 0 10.5 0V4.81L9.53 9.53a.75.75 0 0 1-1.06-1.06l6-6a.75.75 0 0 1 1.06 0l6 6a.75.75 0 0 1 0 1.06Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function xN(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M3.22 3.22a.75.75 0 0 1 1.06 0l3.97 3.97V4.5a.75.75 0 0 1 1.5 0V9a.75.75 0 0 1-.75.75H4.5a.75.75 0 0 1 0-1.5h2.69L3.22 4.28a.75.75 0 0 1 0-1.06Zm17.56 0a.75.75 0 0 1 0 1.06l-3.97 3.97h2.69a.75.75 0 0 1 0 1.5H15a.75.75 0 0 1-.75-.75V4.5a.75.75 0 0 1 1.5 0v2.69l3.97-3.97a.75.75 0 0 1 1.06 0ZM3.75 15a.75.75 0 0 1 .75-.75H9a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-2.69l-3.97 3.97a.75.75 0 0 1-1.06-1.06l3.97-3.97H4.5a.75.75 0 0 1-.75-.75Zm10.5 0a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-2.69l3.97 3.97a.75.75 0 1 1-1.06 1.06l-3.97-3.97v2.69a.75.75 0 0 1-1.5 0V15Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function AN(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M15 3.75a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0V5.56l-3.97 3.97a.75.75 0 1 1-1.06-1.06l3.97-3.97h-2.69a.75.75 0 0 1-.75-.75Zm-12 0A.75.75 0 0 1 3.75 3h4.5a.75.75 0 0 1 0 1.5H5.56l3.97 3.97a.75.75 0 0 1-1.06 1.06L4.5 5.56v2.69a.75.75 0 0 1-1.5 0v-4.5Zm11.47 11.78a.75.75 0 1 1 1.06-1.06l3.97 3.97v-2.69a.75.75 0 0 1 1.5 0v4.5a.75.75 0 0 1-.75.75h-4.5a.75.75 0 0 1 0-1.5h2.69l-3.97-3.97Zm-4.94-1.06a.75.75 0 0 1 0 1.06L5.56 19.5h2.69a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75v-4.5a.75.75 0 0 1 1.5 0v2.69l3.97-3.97a.75.75 0 0 1 1.06 0Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function RN(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M15.97 2.47a.75.75 0 0 1 1.06 0l4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5a.75.75 0 1 1-1.06-1.06l3.22-3.22H7.5a.75.75 0 0 1 0-1.5h11.69l-3.22-3.22a.75.75 0 0 1 0-1.06Zm-7.94 9a.75.75 0 0 1 0 1.06l-3.22 3.22H16.5a.75.75 0 0 1 0 1.5H4.81l3.22 3.22a.75.75 0 1 1-1.06 1.06l-4.5-4.5a.75.75 0 0 1 0-1.06l4.5-4.5a.75.75 0 0 1 1.06 0Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function ON(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M6.97 2.47a.75.75 0 0 1 1.06 0l4.5 4.5a.75.75 0 0 1-1.06 1.06L8.25 4.81V16.5a.75.75 0 0 1-1.5 0V4.81L3.53 8.03a.75.75 0 0 1-1.06-1.06l4.5-4.5Zm9.53 4.28a.75.75 0 0 1 .75.75v11.69l3.22-3.22a.75.75 0 1 1 1.06 1.06l-4.5 4.5a.75.75 0 0 1-1.06 0l-4.5-4.5a.75.75 0 1 1 1.06-1.06l3.22 3.22V7.5a.75.75 0 0 1 .75-.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function IN(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M17.834 6.166a8.25 8.25 0 1 0 0 11.668.75.75 0 0 1 1.06 1.06c-3.807 3.808-9.98 3.808-13.788 0-3.808-3.807-3.808-9.98 0-13.788 3.807-3.808 9.98-3.808 13.788 0A9.722 9.722 0 0 1 21.75 12c0 .975-.296 1.887-.809 2.571-.514.685-1.28 1.179-2.191 1.179-.904 0-1.666-.487-2.18-1.164a5.25 5.25 0 1 1-.82-6.26V8.25a.75.75 0 0 1 1.5 0V12c0 .682.208 1.27.509 1.671.3.401.659.579.991.579.332 0 .69-.178.991-.579.3-.4.509-.99.509-1.671a8.222 8.222 0 0 0-2.416-5.834ZM15.75 12a3.75 3.75 0 1 0-7.5 0 3.75 3.75 0 0 0 7.5 0Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function NN(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M2.515 10.674a1.875 1.875 0 0 0 0 2.652L8.89 19.7c.352.351.829.549 1.326.549H19.5a3 3 0 0 0 3-3V6.75a3 3 0 0 0-3-3h-9.284c-.497 0-.974.198-1.326.55l-6.375 6.374ZM12.53 9.22a.75.75 0 1 0-1.06 1.06L13.19 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06l1.72-1.72 1.72 1.72a.75.75 0 1 0 1.06-1.06L15.31 12l1.72-1.72a.75.75 0 1 0-1.06-1.06l-1.72 1.72-1.72-1.72Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function MN(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M9.195 18.44c1.25.714 2.805-.189 2.805-1.629v-2.34l6.945 3.968c1.25.715 2.805-.188 2.805-1.628V8.69c0-1.44-1.555-2.343-2.805-1.628L12 11.029v-2.34c0-1.44-1.555-2.343-2.805-1.628l-7.108 4.061c-1.26.72-1.26 2.536 0 3.256l7.108 4.061Z" })
  ]);
}
function DN(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M12 7.5a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5Z" }),
    d("path", {
      "fill-rule": "evenodd",
      d: "M1.5 4.875C1.5 3.839 2.34 3 3.375 3h17.25c1.035 0 1.875.84 1.875 1.875v9.75c0 1.036-.84 1.875-1.875 1.875H3.375A1.875 1.875 0 0 1 1.5 14.625v-9.75ZM8.25 9.75a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0ZM18.75 9a.75.75 0 0 0-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75V9.75a.75.75 0 0 0-.75-.75h-.008ZM4.5 9.75A.75.75 0 0 1 5.25 9h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75H5.25a.75.75 0 0 1-.75-.75V9.75Z",
      "clip-rule": "evenodd"
    }),
    d("path", { d: "M2.25 18a.75.75 0 0 0 0 1.5c5.4 0 10.63.722 15.6 2.075 1.19.324 2.4-.558 2.4-1.82V18.75a.75.75 0 0 0-.75-.75H2.25Z" })
  ]);
}
function kN(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M3 9a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 9Zm0 6.75a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function LN(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M3 6.75A.75.75 0 0 1 3.75 6h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 6.75ZM3 12a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 12Zm0 5.25a.75.75 0 0 1 .75-.75H12a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function PN(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M3 6.75A.75.75 0 0 1 3.75 6h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 6.75ZM3 12a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 12Zm8.25 5.25a.75.75 0 0 1 .75-.75h8.25a.75.75 0 0 1 0 1.5H12a.75.75 0 0 1-.75-.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function BN(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M3 6.75A.75.75 0 0 1 3.75 6h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 6.75ZM3 12a.75.75 0 0 1 .75-.75H12a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 12Zm0 5.25a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function FN(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M3 6.75A.75.75 0 0 1 3.75 6h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 6.75ZM3 12a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 12Zm0 5.25a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function UN(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M3 5.25a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 5.25Zm0 4.5A.75.75 0 0 1 3.75 9h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 9.75Zm0 4.5a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75Zm0 4.5a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function $N(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M2.25 4.5A.75.75 0 0 1 3 3.75h14.25a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75Zm0 4.5A.75.75 0 0 1 3 8.25h9.75a.75.75 0 0 1 0 1.5H3A.75.75 0 0 1 2.25 9Zm15-.75A.75.75 0 0 1 18 9v10.19l2.47-2.47a.75.75 0 1 1 1.06 1.06l-3.75 3.75a.75.75 0 0 1-1.06 0l-3.75-3.75a.75.75 0 1 1 1.06-1.06l2.47 2.47V9a.75.75 0 0 1 .75-.75Zm-15 5.25a.75.75 0 0 1 .75-.75h9.75a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function VN(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M2.25 4.5A.75.75 0 0 1 3 3.75h14.25a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75Zm14.47 3.97a.75.75 0 0 1 1.06 0l3.75 3.75a.75.75 0 1 1-1.06 1.06L18 10.81V21a.75.75 0 0 1-1.5 0V10.81l-2.47 2.47a.75.75 0 1 1-1.06-1.06l3.75-3.75ZM2.25 9A.75.75 0 0 1 3 8.25h9.75a.75.75 0 0 1 0 1.5H3A.75.75 0 0 1 2.25 9Zm0 4.5a.75.75 0 0 1 .75-.75h5.25a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function HN(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M.75 9.75a3 3 0 0 1 3-3h15a3 3 0 0 1 3 3v.038c.856.173 1.5.93 1.5 1.837v2.25c0 .907-.644 1.664-1.5 1.838v.037a3 3 0 0 1-3 3h-15a3 3 0 0 1-3-3v-6Zm19.5 0a1.5 1.5 0 0 0-1.5-1.5h-15a1.5 1.5 0 0 0-1.5 1.5v6a1.5 1.5 0 0 0 1.5 1.5h15a1.5 1.5 0 0 0 1.5-1.5v-6Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function GN(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M3.75 6.75a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3v-.037c.856-.174 1.5-.93 1.5-1.838v-2.25c0-.907-.644-1.664-1.5-1.837V9.75a3 3 0 0 0-3-3h-15Zm15 1.5a1.5 1.5 0 0 1 1.5 1.5v6a1.5 1.5 0 0 1-1.5 1.5h-15a1.5 1.5 0 0 1-1.5-1.5v-6a1.5 1.5 0 0 1 1.5-1.5h15ZM4.5 9.75a.75.75 0 0 0-.75.75V15c0 .414.336.75.75.75H18a.75.75 0 0 0 .75-.75v-4.5a.75.75 0 0 0-.75-.75H4.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function YN(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M4.5 9.75a.75.75 0 0 0-.75.75V15c0 .414.336.75.75.75h6.75A.75.75 0 0 0 12 15v-4.5a.75.75 0 0 0-.75-.75H4.5Z" }),
    d("path", {
      "fill-rule": "evenodd",
      d: "M3.75 6.75a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3v-.037c.856-.174 1.5-.93 1.5-1.838v-2.25c0-.907-.644-1.664-1.5-1.837V9.75a3 3 0 0 0-3-3h-15Zm15 1.5a1.5 1.5 0 0 1 1.5 1.5v6a1.5 1.5 0 0 1-1.5 1.5h-15a1.5 1.5 0 0 1-1.5-1.5v-6a1.5 1.5 0 0 1 1.5-1.5h15Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function zN(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M10.5 3.798v5.02a3 3 0 0 1-.879 2.121l-2.377 2.377a9.845 9.845 0 0 1 5.091 1.013 8.315 8.315 0 0 0 5.713.636l.285-.071-3.954-3.955a3 3 0 0 1-.879-2.121v-5.02a23.614 23.614 0 0 0-3 0Zm4.5.138a.75.75 0 0 0 .093-1.495A24.837 24.837 0 0 0 12 2.25a25.048 25.048 0 0 0-3.093.191A.75.75 0 0 0 9 3.936v4.882a1.5 1.5 0 0 1-.44 1.06l-6.293 6.294c-1.62 1.621-.903 4.475 1.471 4.88 2.686.46 5.447.698 8.262.698 2.816 0 5.576-.239 8.262-.697 2.373-.406 3.092-3.26 1.47-4.881L15.44 9.879A1.5 1.5 0 0 1 15 8.818V3.936Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function ZN(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M5.85 3.5a.75.75 0 0 0-1.117-1 9.719 9.719 0 0 0-2.348 4.876.75.75 0 0 0 1.479.248A8.219 8.219 0 0 1 5.85 3.5ZM19.267 2.5a.75.75 0 1 0-1.118 1 8.22 8.22 0 0 1 1.987 4.124.75.75 0 0 0 1.48-.248A9.72 9.72 0 0 0 19.266 2.5Z" }),
    d("path", {
      "fill-rule": "evenodd",
      d: "M12 2.25A6.75 6.75 0 0 0 5.25 9v.75a8.217 8.217 0 0 1-2.119 5.52.75.75 0 0 0 .298 1.206c1.544.57 3.16.99 4.831 1.243a3.75 3.75 0 1 0 7.48 0 24.583 24.583 0 0 0 4.83-1.244.75.75 0 0 0 .298-1.205 8.217 8.217 0 0 1-2.118-5.52V9A6.75 6.75 0 0 0 12 2.25ZM9.75 18c0-.034 0-.067.002-.1a25.05 25.05 0 0 0 4.496 0l.002.1a2.25 2.25 0 1 1-4.5 0Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function qN(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M3.53 2.47a.75.75 0 0 0-1.06 1.06l18 18a.75.75 0 1 0 1.06-1.06l-18-18ZM20.57 16.476c-.223.082-.448.161-.674.238L7.319 4.137A6.75 6.75 0 0 1 18.75 9v.75c0 2.123.8 4.057 2.118 5.52a.75.75 0 0 1-.297 1.206Z" }),
    d("path", {
      "fill-rule": "evenodd",
      d: "M5.25 9c0-.184.007-.366.022-.546l10.384 10.384a3.751 3.751 0 0 1-7.396-1.119 24.585 24.585 0 0 1-4.831-1.244.75.75 0 0 1-.298-1.205A8.217 8.217 0 0 0 5.25 9.75V9Zm4.502 8.9a2.25 2.25 0 1 0 4.496 0 25.057 25.057 0 0 1-4.496 0Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function WN(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M12 2.25A6.75 6.75 0 0 0 5.25 9v.75a8.217 8.217 0 0 1-2.119 5.52.75.75 0 0 0 .298 1.206c1.544.57 3.16.99 4.831 1.243a3.75 3.75 0 1 0 7.48 0 24.583 24.583 0 0 0 4.83-1.244.75.75 0 0 0 .298-1.205 8.217 8.217 0 0 1-2.118-5.52V9A6.75 6.75 0 0 0 12 2.25ZM9.75 18c0-.034 0-.067.002-.1a25.05 25.05 0 0 0 4.496 0l.002.1a2.25 2.25 0 1 1-4.5 0Zm.75-10.5a.75.75 0 0 0 0 1.5h1.599l-2.223 3.334A.75.75 0 0 0 10.5 13.5h3a.75.75 0 0 0 0-1.5h-1.599l2.223-3.334A.75.75 0 0 0 13.5 7.5h-3Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function jN(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M5.25 9a6.75 6.75 0 0 1 13.5 0v.75c0 2.123.8 4.057 2.118 5.52a.75.75 0 0 1-.297 1.206c-1.544.57-3.16.99-4.831 1.243a3.75 3.75 0 1 1-7.48 0 24.585 24.585 0 0 1-4.831-1.244.75.75 0 0 1-.298-1.205A8.217 8.217 0 0 0 5.25 9.75V9Zm4.502 8.9a2.25 2.25 0 1 0 4.496 0 25.057 25.057 0 0 1-4.496 0Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function KN(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M5.246 3.744a.75.75 0 0 1 .75-.75h7.125a4.875 4.875 0 0 1 3.346 8.422 5.25 5.25 0 0 1-2.97 9.58h-7.5a.75.75 0 0 1-.75-.75V3.744Zm7.125 6.75a2.625 2.625 0 0 0 0-5.25H8.246v5.25h4.125Zm-4.125 2.251v6h4.5a3 3 0 0 0 0-6h-4.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function QN(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "m20.798 11.012-3.188 3.416L9.462 6.28l4.24-4.542a.75.75 0 0 1 1.272.71L12.982 9.75h7.268a.75.75 0 0 1 .548 1.262ZM3.202 12.988 6.39 9.572l8.148 8.148-4.24 4.542a.75.75 0 0 1-1.272-.71l1.992-7.302H3.75a.75.75 0 0 1-.548-1.262ZM3.53 2.47a.75.75 0 0 0-1.06 1.06l18 18a.75.75 0 1 0 1.06-1.06l-18-18Z" })
  ]);
}
function XN(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M14.615 1.595a.75.75 0 0 1 .359.852L12.982 9.75h7.268a.75.75 0 0 1 .548 1.262l-10.5 11.25a.75.75 0 0 1-1.272-.71l1.992-7.302H3.75a.75.75 0 0 1-.548-1.262l10.5-11.25a.75.75 0 0 1 .913-.143Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function JN(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M11.25 4.533A9.707 9.707 0 0 0 6 3a9.735 9.735 0 0 0-3.25.555.75.75 0 0 0-.5.707v14.25a.75.75 0 0 0 1 .707A8.237 8.237 0 0 1 6 18.75c1.995 0 3.823.707 5.25 1.886V4.533ZM12.75 20.636A8.214 8.214 0 0 1 18 18.75c.966 0 1.89.166 2.75.47a.75.75 0 0 0 1-.708V4.262a.75.75 0 0 0-.5-.707A9.735 9.735 0 0 0 18 3a9.707 9.707 0 0 0-5.25 1.533v16.103Z" })
  ]);
}
function e9(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M3.53 2.47a.75.75 0 0 0-1.06 1.06l18 18a.75.75 0 1 0 1.06-1.06l-18-18ZM20.25 5.507v11.561L5.853 2.671c.15-.043.306-.075.467-.094a49.255 49.255 0 0 1 11.36 0c1.497.174 2.57 1.46 2.57 2.93ZM3.75 21V6.932l14.063 14.063L12 18.088l-7.165 3.583A.75.75 0 0 1 3.75 21Z" })
  ]);
}
function t9(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M6 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6Zm1.5 1.5a.75.75 0 0 0-.75.75V16.5a.75.75 0 0 0 1.085.67L12 15.089l4.165 2.083a.75.75 0 0 0 1.085-.671V5.25a.75.75 0 0 0-.75-.75h-9Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function n9(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M6.32 2.577a49.255 49.255 0 0 1 11.36 0c1.497.174 2.57 1.46 2.57 2.93V21a.75.75 0 0 1-1.085.67L12 18.089l-7.165 3.583A.75.75 0 0 1 3.75 21V5.507c0-1.47 1.073-2.756 2.57-2.93Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function r9(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M7.5 5.25a3 3 0 0 1 3-3h3a3 3 0 0 1 3 3v.205c.933.085 1.857.197 2.774.334 1.454.218 2.476 1.483 2.476 2.917v3.033c0 1.211-.734 2.352-1.936 2.752A24.726 24.726 0 0 1 12 15.75c-2.73 0-5.357-.442-7.814-1.259-1.202-.4-1.936-1.541-1.936-2.752V8.706c0-1.434 1.022-2.7 2.476-2.917A48.814 48.814 0 0 1 7.5 5.455V5.25Zm7.5 0v.09a49.488 49.488 0 0 0-6 0v-.09a1.5 1.5 0 0 1 1.5-1.5h3a1.5 1.5 0 0 1 1.5 1.5Zm-3 8.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
      "clip-rule": "evenodd"
    }),
    d("path", { d: "M3 18.4v-2.796a4.3 4.3 0 0 0 .713.31A26.226 26.226 0 0 0 12 17.25c2.892 0 5.68-.468 8.287-1.335.252-.084.49-.189.713-.311V18.4c0 1.452-1.047 2.728-2.523 2.923-2.12.282-4.282.427-6.477.427a49.19 49.19 0 0 1-6.477-.427C4.047 21.128 3 19.852 3 18.4Z" })
  ]);
}
function a9(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M8.478 1.6a.75.75 0 0 1 .273 1.026 3.72 3.72 0 0 0-.425 1.121c.058.058.118.114.18.168A4.491 4.491 0 0 1 12 2.25c1.413 0 2.673.651 3.497 1.668.06-.054.12-.11.178-.167a3.717 3.717 0 0 0-.426-1.125.75.75 0 1 1 1.298-.752 5.22 5.22 0 0 1 .671 2.046.75.75 0 0 1-.187.582c-.241.27-.505.52-.787.749a4.494 4.494 0 0 1 .216 2.1c-.106.792-.753 1.295-1.417 1.403-.182.03-.364.057-.547.081.152.227.273.476.359.742a23.122 23.122 0 0 0 3.832-.803 23.241 23.241 0 0 0-.345-2.634.75.75 0 0 1 1.474-.28c.21 1.115.348 2.256.404 3.418a.75.75 0 0 1-.516.75c-1.527.499-3.119.854-4.76 1.049-.074.38-.22.735-.423 1.05 2.066.209 4.058.672 5.943 1.358a.75.75 0 0 1 .492.75 24.665 24.665 0 0 1-1.189 6.25.75.75 0 0 1-1.425-.47 23.14 23.14 0 0 0 1.077-5.306c-.5-.169-1.009-.32-1.524-.455.068.234.104.484.104.746 0 3.956-2.521 7.5-6 7.5-3.478 0-6-3.544-6-7.5 0-.262.037-.511.104-.746-.514.135-1.022.286-1.522.455.154 1.838.52 3.616 1.077 5.307a.75.75 0 1 1-1.425.468 24.662 24.662 0 0 1-1.19-6.25.75.75 0 0 1 .493-.749 24.586 24.586 0 0 1 4.964-1.24h.01c.321-.046.644-.085.969-.118a2.983 2.983 0 0 1-.424-1.05 24.614 24.614 0 0 1-4.76-1.05.75.75 0 0 1-.516-.75c.057-1.16.194-2.302.405-3.417a.75.75 0 0 1 1.474.28c-.164.862-.28 1.74-.345 2.634 1.237.371 2.517.642 3.832.803.085-.266.207-.515.359-.742a18.698 18.698 0 0 1-.547-.08c-.664-.11-1.311-.612-1.417-1.404a4.535 4.535 0 0 1 .217-2.103 6.788 6.788 0 0 1-.788-.751.75.75 0 0 1-.187-.583 5.22 5.22 0 0 1 .67-2.04.75.75 0 0 1 1.026-.273Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function o9(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M11.584 2.376a.75.75 0 0 1 .832 0l9 6a.75.75 0 1 1-.832 1.248L12 3.901 3.416 9.624a.75.75 0 0 1-.832-1.248l9-6Z" }),
    d("path", {
      "fill-rule": "evenodd",
      d: "M20.25 10.332v9.918H21a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1 0-1.5h.75v-9.918a.75.75 0 0 1 .634-.74A49.109 49.109 0 0 1 12 9c2.59 0 5.134.202 7.616.592a.75.75 0 0 1 .634.74Zm-7.5 2.418a.75.75 0 0 0-1.5 0v6.75a.75.75 0 0 0 1.5 0v-6.75Zm3-.75a.75.75 0 0 1 .75.75v6.75a.75.75 0 0 1-1.5 0v-6.75a.75.75 0 0 1 .75-.75ZM9 12.75a.75.75 0 0 0-1.5 0v6.75a.75.75 0 0 0 1.5 0v-6.75Z",
      "clip-rule": "evenodd"
    }),
    d("path", { d: "M12 7.875a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25Z" })
  ]);
}
function i9(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M3 2.25a.75.75 0 0 0 0 1.5v16.5h-.75a.75.75 0 0 0 0 1.5H15v-18a.75.75 0 0 0 0-1.5H3ZM6.75 19.5v-2.25a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75v2.25a.75.75 0 0 1-.75.75h-3a.75.75 0 0 1-.75-.75ZM6 6.75A.75.75 0 0 1 6.75 6h.75a.75.75 0 0 1 0 1.5h-.75A.75.75 0 0 1 6 6.75ZM6.75 9a.75.75 0 0 0 0 1.5h.75a.75.75 0 0 0 0-1.5h-.75ZM6 12.75a.75.75 0 0 1 .75-.75h.75a.75.75 0 0 1 0 1.5h-.75a.75.75 0 0 1-.75-.75ZM10.5 6a.75.75 0 0 0 0 1.5h.75a.75.75 0 0 0 0-1.5h-.75Zm-.75 3.75A.75.75 0 0 1 10.5 9h.75a.75.75 0 0 1 0 1.5h-.75a.75.75 0 0 1-.75-.75ZM10.5 12a.75.75 0 0 0 0 1.5h.75a.75.75 0 0 0 0-1.5h-.75ZM16.5 6.75v15h5.25a.75.75 0 0 0 0-1.5H21v-12a.75.75 0 0 0 0-1.5h-4.5Zm1.5 4.5a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75h-.008a.75.75 0 0 1-.75-.75v-.008Zm.75 2.25a.75.75 0 0 0-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75v-.008a.75.75 0 0 0-.75-.75h-.008ZM18 17.25a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75h-.008a.75.75 0 0 1-.75-.75v-.008Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function s9(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M4.5 2.25a.75.75 0 0 0 0 1.5v16.5h-.75a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5h-.75V3.75a.75.75 0 0 0 0-1.5h-15ZM9 6a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5H9Zm-.75 3.75A.75.75 0 0 1 9 9h1.5a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75ZM9 12a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5H9Zm3.75-5.25A.75.75 0 0 1 13.5 6H15a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75ZM13.5 9a.75.75 0 0 0 0 1.5H15A.75.75 0 0 0 15 9h-1.5Zm-.75 3.75a.75.75 0 0 1 .75-.75H15a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75ZM9 19.5v-2.25a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 .75.75v2.25a.75.75 0 0 1-.75.75h-4.5A.75.75 0 0 1 9 19.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function l9(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M5.223 2.25c-.497 0-.974.198-1.325.55l-1.3 1.298A3.75 3.75 0 0 0 7.5 9.75c.627.47 1.406.75 2.25.75.844 0 1.624-.28 2.25-.75.626.47 1.406.75 2.25.75.844 0 1.623-.28 2.25-.75a3.75 3.75 0 0 0 4.902-5.652l-1.3-1.299a1.875 1.875 0 0 0-1.325-.549H5.223Z" }),
    d("path", {
      "fill-rule": "evenodd",
      d: "M3 20.25v-8.755c1.42.674 3.08.673 4.5 0A5.234 5.234 0 0 0 9.75 12c.804 0 1.568-.182 2.25-.506a5.234 5.234 0 0 0 2.25.506c.804 0 1.567-.182 2.25-.506 1.42.674 3.08.675 4.5.001v8.755h.75a.75.75 0 0 1 0 1.5H2.25a.75.75 0 0 1 0-1.5H3Zm3-6a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-.75.75h-3a.75.75 0 0 1-.75-.75v-3Zm8.25-.75a.75.75 0 0 0-.75.75v5.25c0 .414.336.75.75.75h3a.75.75 0 0 0 .75-.75v-5.25a.75.75 0 0 0-.75-.75h-3Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function c9(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "m15 1.784-.796.795a1.125 1.125 0 1 0 1.591 0L15 1.784ZM12 1.784l-.796.795a1.125 1.125 0 1 0 1.591 0L12 1.784ZM9 1.784l-.796.795a1.125 1.125 0 1 0 1.591 0L9 1.784ZM9.75 7.547c.498-.021.998-.035 1.5-.042V6.75a.75.75 0 0 1 1.5 0v.755c.502.007 1.002.021 1.5.042V6.75a.75.75 0 0 1 1.5 0v.88l.307.022c1.55.117 2.693 1.427 2.693 2.946v1.018a62.182 62.182 0 0 0-13.5 0v-1.018c0-1.519 1.143-2.829 2.693-2.946l.307-.022v-.88a.75.75 0 0 1 1.5 0v.797ZM12 12.75c-2.472 0-4.9.184-7.274.54-1.454.217-2.476 1.482-2.476 2.916v.384a4.104 4.104 0 0 1 2.585.364 2.605 2.605 0 0 0 2.33 0 4.104 4.104 0 0 1 3.67 0 2.605 2.605 0 0 0 2.33 0 4.104 4.104 0 0 1 3.67 0 2.605 2.605 0 0 0 2.33 0 4.104 4.104 0 0 1 2.585-.364v-.384c0-1.434-1.022-2.7-2.476-2.917A49.138 49.138 0 0 0 12 12.75ZM21.75 18.131a2.604 2.604 0 0 0-1.915.165 4.104 4.104 0 0 1-3.67 0 2.605 2.605 0 0 0-2.33 0 4.104 4.104 0 0 1-3.67 0 2.605 2.605 0 0 0-2.33 0 4.104 4.104 0 0 1-3.67 0 2.604 2.604 0 0 0-1.915-.165v2.494c0 1.035.84 1.875 1.875 1.875h15.75c1.035 0 1.875-.84 1.875-1.875v-2.494Z" })
  ]);
}
function u9(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M6.32 1.827a49.255 49.255 0 0 1 11.36 0c1.497.174 2.57 1.46 2.57 2.93V19.5a3 3 0 0 1-3 3H6.75a3 3 0 0 1-3-3V4.757c0-1.47 1.073-2.756 2.57-2.93ZM7.5 11.25a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75H8.25a.75.75 0 0 1-.75-.75v-.008Zm.75 1.5a.75.75 0 0 0-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75V13.5a.75.75 0 0 0-.75-.75H8.25Zm-.75 3a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75H8.25a.75.75 0 0 1-.75-.75v-.008Zm.75 1.5a.75.75 0 0 0-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75V18a.75.75 0 0 0-.75-.75H8.25Zm1.748-6a.75.75 0 0 1 .75-.75h.007a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75h-.007a.75.75 0 0 1-.75-.75v-.008Zm.75 1.5a.75.75 0 0 0-.75.75v.008c0 .414.335.75.75.75h.007a.75.75 0 0 0 .75-.75V13.5a.75.75 0 0 0-.75-.75h-.007Zm-.75 3a.75.75 0 0 1 .75-.75h.007a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75h-.007a.75.75 0 0 1-.75-.75v-.008Zm.75 1.5a.75.75 0 0 0-.75.75v.008c0 .414.335.75.75.75h.007a.75.75 0 0 0 .75-.75V18a.75.75 0 0 0-.75-.75h-.007Zm1.754-6a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75h-.008a.75.75 0 0 1-.75-.75v-.008Zm.75 1.5a.75.75 0 0 0-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75V13.5a.75.75 0 0 0-.75-.75h-.008Zm-.75 3a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75h-.008a.75.75 0 0 1-.75-.75v-.008Zm.75 1.5a.75.75 0 0 0-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75V18a.75.75 0 0 0-.75-.75h-.008Zm1.748-6a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75h-.008a.75.75 0 0 1-.75-.75v-.008Zm.75 1.5a.75.75 0 0 0-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75V13.5a.75.75 0 0 0-.75-.75h-.008Zm-8.25-6A.75.75 0 0 1 8.25 6h7.5a.75.75 0 0 1 .75.75v.75a.75.75 0 0 1-.75.75h-7.5a.75.75 0 0 1-.75-.75v-.75Zm9 9a.75.75 0 0 0-1.5 0V18a.75.75 0 0 0 1.5 0v-2.25Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function d9(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M12 11.993a.75.75 0 0 0-.75.75v.006c0 .414.336.75.75.75h.006a.75.75 0 0 0 .75-.75v-.006a.75.75 0 0 0-.75-.75H12ZM12 16.494a.75.75 0 0 0-.75.75v.005c0 .414.335.75.75.75h.005a.75.75 0 0 0 .75-.75v-.005a.75.75 0 0 0-.75-.75H12ZM8.999 17.244a.75.75 0 0 1 .75-.75h.006a.75.75 0 0 1 .75.75v.006a.75.75 0 0 1-.75.75h-.006a.75.75 0 0 1-.75-.75v-.006ZM7.499 16.494a.75.75 0 0 0-.75.75v.005c0 .414.336.75.75.75h.005a.75.75 0 0 0 .75-.75v-.005a.75.75 0 0 0-.75-.75H7.5ZM13.499 14.997a.75.75 0 0 1 .75-.75h.006a.75.75 0 0 1 .75.75v.005a.75.75 0 0 1-.75.75h-.006a.75.75 0 0 1-.75-.75v-.005ZM14.25 16.494a.75.75 0 0 0-.75.75v.006c0 .414.335.75.75.75h.005a.75.75 0 0 0 .75-.75v-.006a.75.75 0 0 0-.75-.75h-.005ZM15.75 14.995a.75.75 0 0 1 .75-.75h.005a.75.75 0 0 1 .75.75v.006a.75.75 0 0 1-.75.75H16.5a.75.75 0 0 1-.75-.75v-.006ZM13.498 12.743a.75.75 0 0 1 .75-.75h2.25a.75.75 0 1 1 0 1.5h-2.25a.75.75 0 0 1-.75-.75ZM6.748 14.993a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75Z" }),
    d("path", {
      "fill-rule": "evenodd",
      d: "M18 2.993a.75.75 0 0 0-1.5 0v1.5h-9V2.994a.75.75 0 1 0-1.5 0v1.497h-.752a3 3 0 0 0-3 3v11.252a3 3 0 0 0 3 3h13.5a3 3 0 0 0 3-3V7.492a3 3 0 0 0-3-3H18V2.993ZM3.748 18.743v-7.5a1.5 1.5 0 0 1 1.5-1.5h13.5a1.5 1.5 0 0 1 1.5 1.5v7.5a1.5 1.5 0 0 1-1.5 1.5h-13.5a1.5 1.5 0 0 1-1.5-1.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function _9(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M12.75 12.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM7.5 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM8.25 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM9.75 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM10.5 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM12 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM12.75 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM14.25 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM15 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM16.5 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM15 12.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM16.5 13.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z" }),
    d("path", {
      "fill-rule": "evenodd",
      d: "M6.75 2.25A.75.75 0 0 1 7.5 3v1.5h9V3A.75.75 0 0 1 18 3v1.5h.75a3 3 0 0 1 3 3v11.25a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3V7.5a3 3 0 0 1 3-3H6V3a.75.75 0 0 1 .75-.75Zm13.5 9a1.5 1.5 0 0 0-1.5-1.5H5.25a1.5 1.5 0 0 0-1.5 1.5v7.5a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5v-7.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function p9(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M6.75 2.25A.75.75 0 0 1 7.5 3v1.5h9V3A.75.75 0 0 1 18 3v1.5h.75a3 3 0 0 1 3 3v11.25a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3V7.5a3 3 0 0 1 3-3H6V3a.75.75 0 0 1 .75-.75Zm13.5 9a1.5 1.5 0 0 0-1.5-1.5H5.25a1.5 1.5 0 0 0-1.5 1.5v7.5a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5v-7.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function m9(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M12 9a3.75 3.75 0 1 0 0 7.5A3.75 3.75 0 0 0 12 9Z" }),
    d("path", {
      "fill-rule": "evenodd",
      d: "M9.344 3.071a49.52 49.52 0 0 1 5.312 0c.967.052 1.83.585 2.332 1.39l.821 1.317c.24.383.645.643 1.11.71.386.054.77.113 1.152.177 1.432.239 2.429 1.493 2.429 2.909V18a3 3 0 0 1-3 3h-15a3 3 0 0 1-3-3V9.574c0-1.416.997-2.67 2.429-2.909.382-.064.766-.123 1.151-.178a1.56 1.56 0 0 0 1.11-.71l.822-1.315a2.942 2.942 0 0 1 2.332-1.39ZM6.75 12.75a5.25 5.25 0 1 1 10.5 0 5.25 5.25 0 0 1-10.5 0Zm12-1.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function g9(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm4.5 7.5a.75.75 0 0 1 .75.75v2.25a.75.75 0 0 1-1.5 0v-2.25a.75.75 0 0 1 .75-.75Zm3.75-1.5a.75.75 0 0 0-1.5 0v4.5a.75.75 0 0 0 1.5 0V12Zm2.25-3a.75.75 0 0 1 .75.75v6.75a.75.75 0 0 1-1.5 0V9.75A.75.75 0 0 1 13.5 9Zm3.75-1.5a.75.75 0 0 0-1.5 0v9a.75.75 0 0 0 1.5 0v-9Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function f9(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M18.375 2.25c-1.035 0-1.875.84-1.875 1.875v15.75c0 1.035.84 1.875 1.875 1.875h.75c1.035 0 1.875-.84 1.875-1.875V4.125c0-1.036-.84-1.875-1.875-1.875h-.75ZM9.75 8.625c0-1.036.84-1.875 1.875-1.875h.75c1.036 0 1.875.84 1.875 1.875v11.25c0 1.035-.84 1.875-1.875 1.875h-.75a1.875 1.875 0 0 1-1.875-1.875V8.625ZM3 13.125c0-1.036.84-1.875 1.875-1.875h.75c1.036 0 1.875.84 1.875 1.875v6.75c0 1.035-.84 1.875-1.875 1.875h-.75A1.875 1.875 0 0 1 3 19.875v-6.75Z" })
  ]);
}
function h9(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M2.25 13.5a8.25 8.25 0 0 1 8.25-8.25.75.75 0 0 1 .75.75v6.75H18a.75.75 0 0 1 .75.75 8.25 8.25 0 0 1-16.5 0Z",
      "clip-rule": "evenodd"
    }),
    d("path", {
      "fill-rule": "evenodd",
      d: "M12.75 3a.75.75 0 0 1 .75-.75 8.25 8.25 0 0 1 8.25 8.25.75.75 0 0 1-.75.75h-7.5a.75.75 0 0 1-.75-.75V3Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function v9(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M4.848 2.771A49.144 49.144 0 0 1 12 2.25c2.43 0 4.817.178 7.152.52 1.978.292 3.348 2.024 3.348 3.97v6.02c0 1.946-1.37 3.678-3.348 3.97a48.901 48.901 0 0 1-3.476.383.39.39 0 0 0-.297.17l-2.755 4.133a.75.75 0 0 1-1.248 0l-2.755-4.133a.39.39 0 0 0-.297-.17 48.9 48.9 0 0 1-3.476-.384c-1.978-.29-3.348-2.024-3.348-3.97V6.741c0-1.946 1.37-3.68 3.348-3.97ZM6.75 8.25a.75.75 0 0 1 .75-.75h9a.75.75 0 0 1 0 1.5h-9a.75.75 0 0 1-.75-.75Zm.75 2.25a.75.75 0 0 0 0 1.5H12a.75.75 0 0 0 0-1.5H7.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function E9(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M4.848 2.771A49.144 49.144 0 0 1 12 2.25c2.43 0 4.817.178 7.152.52 1.978.292 3.348 2.024 3.348 3.97v6.02c0 1.946-1.37 3.678-3.348 3.97a48.901 48.901 0 0 1-3.476.383.39.39 0 0 0-.297.17l-2.755 4.133a.75.75 0 0 1-1.248 0l-2.755-4.133a.39.39 0 0 0-.297-.17 48.9 48.9 0 0 1-3.476-.384c-1.978-.29-3.348-2.024-3.348-3.97V6.741c0-1.946 1.37-3.68 3.348-3.97Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function b9(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M12 2.25c-2.429 0-4.817.178-7.152.521C2.87 3.061 1.5 4.795 1.5 6.741v6.018c0 1.946 1.37 3.68 3.348 3.97.877.129 1.761.234 2.652.316V21a.75.75 0 0 0 1.28.53l4.184-4.183a.39.39 0 0 1 .266-.112c2.006-.05 3.982-.22 5.922-.506 1.978-.29 3.348-2.023 3.348-3.97V6.741c0-1.947-1.37-3.68-3.348-3.97A49.145 49.145 0 0 0 12 2.25ZM8.25 8.625a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25Zm2.625 1.125a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Zm4.875-1.125a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function S9(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M4.913 2.658c2.075-.27 4.19-.408 6.337-.408 2.147 0 4.262.139 6.337.408 1.922.25 3.291 1.861 3.405 3.727a4.403 4.403 0 0 0-1.032-.211 50.89 50.89 0 0 0-8.42 0c-2.358.196-4.04 2.19-4.04 4.434v4.286a4.47 4.47 0 0 0 2.433 3.984L7.28 21.53A.75.75 0 0 1 6 21v-4.03a48.527 48.527 0 0 1-1.087-.128C2.905 16.58 1.5 14.833 1.5 12.862V6.638c0-1.97 1.405-3.718 3.413-3.979Z" }),
    d("path", { d: "M15.75 7.5c-1.376 0-2.739.057-4.086.169C10.124 7.797 9 9.103 9 10.609v4.285c0 1.507 1.128 2.814 2.67 2.94 1.243.102 2.5.157 3.768.165l2.782 2.781a.75.75 0 0 0 1.28-.53v-2.39l.33-.026c1.542-.125 2.67-1.433 2.67-2.94v-4.286c0-1.505-1.125-2.811-2.664-2.94A49.392 49.392 0 0 0 15.75 7.5Z" })
  ]);
}
function w9(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M4.848 2.771A49.144 49.144 0 0 1 12 2.25c2.43 0 4.817.178 7.152.52 1.978.292 3.348 2.024 3.348 3.97v6.02c0 1.946-1.37 3.678-3.348 3.97-1.94.284-3.916.455-5.922.505a.39.39 0 0 0-.266.112L8.78 21.53A.75.75 0 0 1 7.5 21v-3.955a48.842 48.842 0 0 1-2.652-.316c-1.978-.29-3.348-2.024-3.348-3.97V6.741c0-1.946 1.37-3.68 3.348-3.97Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function y9(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M4.804 21.644A6.707 6.707 0 0 0 6 21.75a6.721 6.721 0 0 0 3.583-1.029c.774.182 1.584.279 2.417.279 5.322 0 9.75-3.97 9.75-9 0-5.03-4.428-9-9.75-9s-9.75 3.97-9.75 9c0 2.409 1.025 4.587 2.674 6.192.232.226.277.428.254.543a3.73 3.73 0 0 1-.814 1.686.75.75 0 0 0 .44 1.223ZM8.25 10.875a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25ZM10.875 12a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Zm4.875-1.125a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function T9(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M5.337 21.718a6.707 6.707 0 0 1-.533-.074.75.75 0 0 1-.44-1.223 3.73 3.73 0 0 0 .814-1.686c.023-.115-.022-.317-.254-.543C3.274 16.587 2.25 14.41 2.25 12c0-5.03 4.428-9 9.75-9s9.75 3.97 9.75 9c0 5.03-4.428 9-9.75 9-.833 0-1.643-.097-2.417-.279a6.721 6.721 0 0 1-4.246.997Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function C9(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M8.603 3.799A4.49 4.49 0 0 1 12 2.25c1.357 0 2.573.6 3.397 1.549a4.49 4.49 0 0 1 3.498 1.307 4.491 4.491 0 0 1 1.307 3.497A4.49 4.49 0 0 1 21.75 12a4.49 4.49 0 0 1-1.549 3.397 4.491 4.491 0 0 1-1.307 3.497 4.491 4.491 0 0 1-3.497 1.307A4.49 4.49 0 0 1 12 21.75a4.49 4.49 0 0 1-3.397-1.549 4.49 4.49 0 0 1-3.498-1.306 4.491 4.491 0 0 1-1.307-3.498A4.49 4.49 0 0 1 2.25 12c0-1.357.6-2.573 1.549-3.397a4.49 4.49 0 0 1 1.307-3.497 4.49 4.49 0 0 1 3.497-1.307Zm7.007 6.387a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function x9(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function A9(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M19.916 4.626a.75.75 0 0 1 .208 1.04l-9 13.5a.75.75 0 0 1-1.154.114l-6-6a.75.75 0 0 1 1.06-1.06l5.353 5.353 8.493-12.74a.75.75 0 0 1 1.04-.207Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function R9(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M11.47 13.28a.75.75 0 0 0 1.06 0l7.5-7.5a.75.75 0 0 0-1.06-1.06L12 11.69 5.03 4.72a.75.75 0 0 0-1.06 1.06l7.5 7.5Z",
      "clip-rule": "evenodd"
    }),
    d("path", {
      "fill-rule": "evenodd",
      d: "M11.47 19.28a.75.75 0 0 0 1.06 0l7.5-7.5a.75.75 0 1 0-1.06-1.06L12 17.69l-6.97-6.97a.75.75 0 0 0-1.06 1.06l7.5 7.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function O9(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M10.72 11.47a.75.75 0 0 0 0 1.06l7.5 7.5a.75.75 0 1 0 1.06-1.06L12.31 12l6.97-6.97a.75.75 0 0 0-1.06-1.06l-7.5 7.5Z",
      "clip-rule": "evenodd"
    }),
    d("path", {
      "fill-rule": "evenodd",
      d: "M4.72 11.47a.75.75 0 0 0 0 1.06l7.5 7.5a.75.75 0 1 0 1.06-1.06L6.31 12l6.97-6.97a.75.75 0 0 0-1.06-1.06l-7.5 7.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function I9(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M13.28 11.47a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 0 1-1.06-1.06L11.69 12 4.72 5.03a.75.75 0 0 1 1.06-1.06l7.5 7.5Z",
      "clip-rule": "evenodd"
    }),
    d("path", {
      "fill-rule": "evenodd",
      d: "M19.28 11.47a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 1 1-1.06-1.06L17.69 12l-6.97-6.97a.75.75 0 0 1 1.06-1.06l7.5 7.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function N9(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M11.47 10.72a.75.75 0 0 1 1.06 0l7.5 7.5a.75.75 0 1 1-1.06 1.06L12 12.31l-6.97 6.97a.75.75 0 0 1-1.06-1.06l7.5-7.5Z",
      "clip-rule": "evenodd"
    }),
    d("path", {
      "fill-rule": "evenodd",
      d: "M11.47 4.72a.75.75 0 0 1 1.06 0l7.5 7.5a.75.75 0 1 1-1.06 1.06L12 6.31l-6.97 6.97a.75.75 0 0 1-1.06-1.06l7.5-7.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function M9(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M12.53 16.28a.75.75 0 0 1-1.06 0l-7.5-7.5a.75.75 0 0 1 1.06-1.06L12 14.69l6.97-6.97a.75.75 0 1 1 1.06 1.06l-7.5 7.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function D9(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M7.72 12.53a.75.75 0 0 1 0-1.06l7.5-7.5a.75.75 0 1 1 1.06 1.06L9.31 12l6.97 6.97a.75.75 0 1 1-1.06 1.06l-7.5-7.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function k9(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M16.28 11.47a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 0 1-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 0 1 1.06-1.06l7.5 7.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function L9(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M11.47 4.72a.75.75 0 0 1 1.06 0l3.75 3.75a.75.75 0 0 1-1.06 1.06L12 6.31 8.78 9.53a.75.75 0 0 1-1.06-1.06l3.75-3.75Zm-3.75 9.75a.75.75 0 0 1 1.06 0L12 17.69l3.22-3.22a.75.75 0 1 1 1.06 1.06l-3.75 3.75a.75.75 0 0 1-1.06 0l-3.75-3.75a.75.75 0 0 1 0-1.06Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function P9(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M11.47 7.72a.75.75 0 0 1 1.06 0l7.5 7.5a.75.75 0 1 1-1.06 1.06L12 9.31l-6.97 6.97a.75.75 0 0 1-1.06-1.06l7.5-7.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function B9(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M21 6.375c0 2.692-4.03 4.875-9 4.875S3 9.067 3 6.375 7.03 1.5 12 1.5s9 2.183 9 4.875Z" }),
    d("path", { d: "M12 12.75c2.685 0 5.19-.586 7.078-1.609a8.283 8.283 0 0 0 1.897-1.384c.016.121.025.244.025.368C21 12.817 16.97 15 12 15s-9-2.183-9-4.875c0-.124.009-.247.025-.368a8.285 8.285 0 0 0 1.897 1.384C6.809 12.164 9.315 12.75 12 12.75Z" }),
    d("path", { d: "M12 16.5c2.685 0 5.19-.586 7.078-1.609a8.282 8.282 0 0 0 1.897-1.384c.016.121.025.244.025.368 0 2.692-4.03 4.875-9 4.875s-9-2.183-9-4.875c0-.124.009-.247.025-.368a8.284 8.284 0 0 0 1.897 1.384C6.809 15.914 9.315 16.5 12 16.5Z" }),
    d("path", { d: "M12 20.25c2.685 0 5.19-.586 7.078-1.609a8.282 8.282 0 0 0 1.897-1.384c.016.121.025.244.025.368 0 2.692-4.03 4.875-9 4.875s-9-2.183-9-4.875c0-.124.009-.247.025-.368a8.284 8.284 0 0 0 1.897 1.384C6.809 19.664 9.315 20.25 12 20.25Z" })
  ]);
}
function F9(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M7.502 6h7.128A3.375 3.375 0 0 1 18 9.375v9.375a3 3 0 0 0 3-3V6.108c0-1.505-1.125-2.811-2.664-2.94a48.972 48.972 0 0 0-.673-.05A3 3 0 0 0 15 1.5h-1.5a3 3 0 0 0-2.663 1.618c-.225.015-.45.032-.673.05C8.662 3.295 7.554 4.542 7.502 6ZM13.5 3A1.5 1.5 0 0 0 12 4.5h4.5A1.5 1.5 0 0 0 15 3h-1.5Z",
      "clip-rule": "evenodd"
    }),
    d("path", {
      "fill-rule": "evenodd",
      d: "M3 9.375C3 8.339 3.84 7.5 4.875 7.5h9.75c1.036 0 1.875.84 1.875 1.875v11.25c0 1.035-.84 1.875-1.875 1.875h-9.75A1.875 1.875 0 0 1 3 20.625V9.375Zm9.586 4.594a.75.75 0 0 0-1.172-.938l-2.476 3.096-.908-.907a.75.75 0 0 0-1.06 1.06l1.5 1.5a.75.75 0 0 0 1.116-.062l3-3.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function U9(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M7.502 6h7.128A3.375 3.375 0 0 1 18 9.375v9.375a3 3 0 0 0 3-3V6.108c0-1.505-1.125-2.811-2.664-2.94a48.972 48.972 0 0 0-.673-.05A3 3 0 0 0 15 1.5h-1.5a3 3 0 0 0-2.663 1.618c-.225.015-.45.032-.673.05C8.662 3.295 7.554 4.542 7.502 6ZM13.5 3A1.5 1.5 0 0 0 12 4.5h4.5A1.5 1.5 0 0 0 15 3h-1.5Z",
      "clip-rule": "evenodd"
    }),
    d("path", {
      "fill-rule": "evenodd",
      d: "M3 9.375C3 8.339 3.84 7.5 4.875 7.5h9.75c1.036 0 1.875.84 1.875 1.875v11.25c0 1.035-.84 1.875-1.875 1.875h-9.75A1.875 1.875 0 0 1 3 20.625V9.375ZM6 12a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75H6.75a.75.75 0 0 1-.75-.75V12Zm2.25 0a.75.75 0 0 1 .75-.75h3.75a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75ZM6 15a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75H6.75a.75.75 0 0 1-.75-.75V15Zm2.25 0a.75.75 0 0 1 .75-.75h3.75a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75ZM6 18a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75H6.75a.75.75 0 0 1-.75-.75V18Zm2.25 0a.75.75 0 0 1 .75-.75h3.75a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function $9(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M17.663 3.118c.225.015.45.032.673.05C19.876 3.298 21 4.604 21 6.109v9.642a3 3 0 0 1-3 3V16.5c0-5.922-4.576-10.775-10.384-11.217.324-1.132 1.3-2.01 2.548-2.114.224-.019.448-.036.673-.051A3 3 0 0 1 13.5 1.5H15a3 3 0 0 1 2.663 1.618ZM12 4.5A1.5 1.5 0 0 1 13.5 3H15a1.5 1.5 0 0 1 1.5 1.5H12Z",
      "clip-rule": "evenodd"
    }),
    d("path", { d: "M3 8.625c0-1.036.84-1.875 1.875-1.875h.375A3.75 3.75 0 0 1 9 10.5v1.875c0 1.036.84 1.875 1.875 1.875h1.875A3.75 3.75 0 0 1 16.5 18v2.625c0 1.035-.84 1.875-1.875 1.875h-9.75A1.875 1.875 0 0 1 3 20.625v-12Z" }),
    d("path", { d: "M10.5 10.5a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963 5.23 5.23 0 0 0-3.434-1.279h-1.875a.375.375 0 0 1-.375-.375V10.5Z" })
  ]);
}
function V9(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M10.5 3A1.501 1.501 0 0 0 9 4.5h6A1.5 1.5 0 0 0 13.5 3h-3Zm-2.693.178A3 3 0 0 1 10.5 1.5h3a3 3 0 0 1 2.694 1.678c.497.042.992.092 1.486.15 1.497.173 2.57 1.46 2.57 2.929V19.5a3 3 0 0 1-3 3H6.75a3 3 0 0 1-3-3V6.257c0-1.47 1.073-2.756 2.57-2.93.493-.057.989-.107 1.487-.15Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function H9(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 6a.75.75 0 0 0-1.5 0v6c0 .414.336.75.75.75h4.5a.75.75 0 0 0 0-1.5h-3.75V6Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function G9(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M10.5 3.75a6 6 0 0 0-5.98 6.496A5.25 5.25 0 0 0 6.75 20.25H18a4.5 4.5 0 0 0 2.206-8.423 3.75 3.75 0 0 0-4.133-4.303A6.001 6.001 0 0 0 10.5 3.75Zm2.25 6a.75.75 0 0 0-1.5 0v4.94l-1.72-1.72a.75.75 0 0 0-1.06 1.06l3 3a.75.75 0 0 0 1.06 0l3-3a.75.75 0 1 0-1.06-1.06l-1.72 1.72V9.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Y9(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M10.5 3.75a6 6 0 0 0-5.98 6.496A5.25 5.25 0 0 0 6.75 20.25H18a4.5 4.5 0 0 0 2.206-8.423 3.75 3.75 0 0 0-4.133-4.303A6.001 6.001 0 0 0 10.5 3.75Zm2.03 5.47a.75.75 0 0 0-1.06 0l-3 3a.75.75 0 1 0 1.06 1.06l1.72-1.72v4.94a.75.75 0 0 0 1.5 0v-4.94l1.72 1.72a.75.75 0 1 0 1.06-1.06l-3-3Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function z9(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M4.5 9.75a6 6 0 0 1 11.573-2.226 3.75 3.75 0 0 1 4.133 4.303A4.5 4.5 0 0 1 18 20.25H6.75a5.25 5.25 0 0 1-2.23-10.004 6.072 6.072 0 0 1-.02-.496Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Z9(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm14.25 6a.75.75 0 0 1-.22.53l-2.25 2.25a.75.75 0 1 1-1.06-1.06L15.44 12l-1.72-1.72a.75.75 0 1 1 1.06-1.06l2.25 2.25c.141.14.22.331.22.53Zm-10.28-.53a.75.75 0 0 0 0 1.06l2.25 2.25a.75.75 0 1 0 1.06-1.06L8.56 12l1.72-1.72a.75.75 0 1 0-1.06-1.06l-2.25 2.25Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function q9(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M14.447 3.026a.75.75 0 0 1 .527.921l-4.5 16.5a.75.75 0 0 1-1.448-.394l4.5-16.5a.75.75 0 0 1 .921-.527ZM16.72 6.22a.75.75 0 0 1 1.06 0l5.25 5.25a.75.75 0 0 1 0 1.06l-5.25 5.25a.75.75 0 1 1-1.06-1.06L21.44 12l-4.72-4.72a.75.75 0 0 1 0-1.06Zm-9.44 0a.75.75 0 0 1 0 1.06L2.56 12l4.72 4.72a.75.75 0 0 1-1.06 1.06L.97 12.53a.75.75 0 0 1 0-1.06l5.25-5.25a.75.75 0 0 1 1.06 0Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function W9(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M11.078 2.25c-.917 0-1.699.663-1.85 1.567L9.05 4.889c-.02.12-.115.26-.297.348a7.493 7.493 0 0 0-.986.57c-.166.115-.334.126-.45.083L6.3 5.508a1.875 1.875 0 0 0-2.282.819l-.922 1.597a1.875 1.875 0 0 0 .432 2.385l.84.692c.095.078.17.229.154.43a7.598 7.598 0 0 0 0 1.139c.015.2-.059.352-.153.43l-.841.692a1.875 1.875 0 0 0-.432 2.385l.922 1.597a1.875 1.875 0 0 0 2.282.818l1.019-.382c.115-.043.283-.031.45.082.312.214.641.405.985.57.182.088.277.228.297.35l.178 1.071c.151.904.933 1.567 1.85 1.567h1.844c.916 0 1.699-.663 1.85-1.567l.178-1.072c.02-.12.114-.26.297-.349.344-.165.673-.356.985-.57.167-.114.335-.125.45-.082l1.02.382a1.875 1.875 0 0 0 2.28-.819l.923-1.597a1.875 1.875 0 0 0-.432-2.385l-.84-.692c-.095-.078-.17-.229-.154-.43a7.614 7.614 0 0 0 0-1.139c-.016-.2.059-.352.153-.43l.84-.692c.708-.582.891-1.59.433-2.385l-.922-1.597a1.875 1.875 0 0 0-2.282-.818l-1.02.382c-.114.043-.282.031-.449-.083a7.49 7.49 0 0 0-.985-.57c-.183-.087-.277-.227-.297-.348l-.179-1.072a1.875 1.875 0 0 0-1.85-1.567h-1.843ZM12 15.75a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function j9(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M11.828 2.25c-.916 0-1.699.663-1.85 1.567l-.091.549a.798.798 0 0 1-.517.608 7.45 7.45 0 0 0-.478.198.798.798 0 0 1-.796-.064l-.453-.324a1.875 1.875 0 0 0-2.416.2l-.243.243a1.875 1.875 0 0 0-.2 2.416l.324.453a.798.798 0 0 1 .064.796 7.448 7.448 0 0 0-.198.478.798.798 0 0 1-.608.517l-.55.092a1.875 1.875 0 0 0-1.566 1.849v.344c0 .916.663 1.699 1.567 1.85l.549.091c.281.047.508.25.608.517.06.162.127.321.198.478a.798.798 0 0 1-.064.796l-.324.453a1.875 1.875 0 0 0 .2 2.416l.243.243c.648.648 1.67.733 2.416.2l.453-.324a.798.798 0 0 1 .796-.064c.157.071.316.137.478.198.267.1.47.327.517.608l.092.55c.15.903.932 1.566 1.849 1.566h.344c.916 0 1.699-.663 1.85-1.567l.091-.549a.798.798 0 0 1 .517-.608 7.52 7.52 0 0 0 .478-.198.798.798 0 0 1 .796.064l.453.324a1.875 1.875 0 0 0 2.416-.2l.243-.243c.648-.648.733-1.67.2-2.416l-.324-.453a.798.798 0 0 1-.064-.796c.071-.157.137-.316.198-.478.1-.267.327-.47.608-.517l.55-.091a1.875 1.875 0 0 0 1.566-1.85v-.344c0-.916-.663-1.699-1.567-1.85l-.549-.091a.798.798 0 0 1-.608-.517 7.507 7.507 0 0 0-.198-.478.798.798 0 0 1 .064-.796l.324-.453a1.875 1.875 0 0 0-.2-2.416l-.243-.243a1.875 1.875 0 0 0-2.416-.2l-.453.324a.798.798 0 0 1-.796.064 7.462 7.462 0 0 0-.478-.198.798.798 0 0 1-.517-.608l-.091-.55a1.875 1.875 0 0 0-1.85-1.566h-.344ZM12 15.75a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function K9(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M17.004 10.407c.138.435-.216.842-.672.842h-3.465a.75.75 0 0 1-.65-.375l-1.732-3c-.229-.396-.053-.907.393-1.004a5.252 5.252 0 0 1 6.126 3.537ZM8.12 8.464c.307-.338.838-.235 1.066.16l1.732 3a.75.75 0 0 1 0 .75l-1.732 3c-.229.397-.76.5-1.067.161A5.23 5.23 0 0 1 6.75 12a5.23 5.23 0 0 1 1.37-3.536ZM10.878 17.13c-.447-.098-.623-.608-.394-1.004l1.733-3.002a.75.75 0 0 1 .65-.375h3.465c.457 0 .81.407.672.842a5.252 5.252 0 0 1-6.126 3.539Z" }),
    d("path", {
      "fill-rule": "evenodd",
      d: "M21 12.75a.75.75 0 1 0 0-1.5h-.783a8.22 8.22 0 0 0-.237-1.357l.734-.267a.75.75 0 1 0-.513-1.41l-.735.268a8.24 8.24 0 0 0-.689-1.192l.6-.503a.75.75 0 1 0-.964-1.149l-.6.504a8.3 8.3 0 0 0-1.054-.885l.391-.678a.75.75 0 1 0-1.299-.75l-.39.676a8.188 8.188 0 0 0-1.295-.47l.136-.77a.75.75 0 0 0-1.477-.26l-.136.77a8.36 8.36 0 0 0-1.377 0l-.136-.77a.75.75 0 1 0-1.477.26l.136.77c-.448.121-.88.28-1.294.47l-.39-.676a.75.75 0 0 0-1.3.75l.392.678a8.29 8.29 0 0 0-1.054.885l-.6-.504a.75.75 0 1 0-.965 1.149l.6.503a8.243 8.243 0 0 0-.689 1.192L3.8 8.216a.75.75 0 1 0-.513 1.41l.735.267a8.222 8.222 0 0 0-.238 1.356h-.783a.75.75 0 0 0 0 1.5h.783c.042.464.122.917.238 1.356l-.735.268a.75.75 0 0 0 .513 1.41l.735-.268c.197.417.428.816.69 1.191l-.6.504a.75.75 0 0 0 .963 1.15l.601-.505c.326.323.679.62 1.054.885l-.392.68a.75.75 0 0 0 1.3.75l.39-.679c.414.192.847.35 1.294.471l-.136.77a.75.75 0 0 0 1.477.261l.137-.772a8.332 8.332 0 0 0 1.376 0l.136.772a.75.75 0 1 0 1.477-.26l-.136-.771a8.19 8.19 0 0 0 1.294-.47l.391.677a.75.75 0 0 0 1.3-.75l-.393-.679a8.29 8.29 0 0 0 1.054-.885l.601.504a.75.75 0 0 0 .964-1.15l-.6-.503c.261-.375.492-.774.69-1.191l.735.267a.75.75 0 1 0 .512-1.41l-.734-.267c.115-.439.195-.892.237-1.356h.784Zm-2.657-3.06a6.744 6.744 0 0 0-1.19-2.053 6.784 6.784 0 0 0-1.82-1.51A6.705 6.705 0 0 0 12 5.25a6.8 6.8 0 0 0-1.225.11 6.7 6.7 0 0 0-2.15.793 6.784 6.784 0 0 0-2.952 3.489.76.76 0 0 1-.036.098A6.74 6.74 0 0 0 5.251 12a6.74 6.74 0 0 0 3.366 5.842l.009.005a6.704 6.704 0 0 0 2.18.798l.022.003a6.792 6.792 0 0 0 2.368-.004 6.704 6.704 0 0 0 2.205-.811 6.785 6.785 0 0 0 1.762-1.484l.009-.01.009-.01a6.743 6.743 0 0 0 1.18-2.066c.253-.707.39-1.469.39-2.263a6.74 6.74 0 0 0-.408-2.309Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Q9(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M2.25 6a3 3 0 0 1 3-3h13.5a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3V6Zm3.97.97a.75.75 0 0 1 1.06 0l2.25 2.25a.75.75 0 0 1 0 1.06l-2.25 2.25a.75.75 0 0 1-1.06-1.06l1.72-1.72-1.72-1.72a.75.75 0 0 1 0-1.06Zm4.28 4.28a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5h-3Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function X9(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M2.25 5.25a3 3 0 0 1 3-3h13.5a3 3 0 0 1 3 3V15a3 3 0 0 1-3 3h-3v.257c0 .597.237 1.17.659 1.591l.621.622a.75.75 0 0 1-.53 1.28h-9a.75.75 0 0 1-.53-1.28l.621-.622a2.25 2.25 0 0 0 .659-1.59V18h-3a3 3 0 0 1-3-3V5.25Zm1.5 0v7.5a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5v-7.5a1.5 1.5 0 0 0-1.5-1.5H5.25a1.5 1.5 0 0 0-1.5 1.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function J9(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M16.5 7.5h-9v9h9v-9Z" }),
    d("path", {
      "fill-rule": "evenodd",
      d: "M8.25 2.25A.75.75 0 0 1 9 3v.75h2.25V3a.75.75 0 0 1 1.5 0v.75H15V3a.75.75 0 0 1 1.5 0v.75h.75a3 3 0 0 1 3 3v.75H21A.75.75 0 0 1 21 9h-.75v2.25H21a.75.75 0 0 1 0 1.5h-.75V15H21a.75.75 0 0 1 0 1.5h-.75v.75a3 3 0 0 1-3 3h-.75V21a.75.75 0 0 1-1.5 0v-.75h-2.25V21a.75.75 0 0 1-1.5 0v-.75H9V21a.75.75 0 0 1-1.5 0v-.75h-.75a3 3 0 0 1-3-3v-.75H3A.75.75 0 0 1 3 15h.75v-2.25H3a.75.75 0 0 1 0-1.5h.75V9H3a.75.75 0 0 1 0-1.5h.75v-.75a3 3 0 0 1 3-3h.75V3a.75.75 0 0 1 .75-.75ZM6 6.75A.75.75 0 0 1 6.75 6h10.5a.75.75 0 0 1 .75.75v10.5a.75.75 0 0 1-.75.75H6.75a.75.75 0 0 1-.75-.75V6.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function eM(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M4.5 3.75a3 3 0 0 0-3 3v.75h21v-.75a3 3 0 0 0-3-3h-15Z" }),
    d("path", {
      "fill-rule": "evenodd",
      d: "M22.5 9.75h-21v7.5a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3v-7.5Zm-18 3.75a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75Zm.75 2.25a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5h-3Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function tM(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M11.622 1.602a.75.75 0 0 1 .756 0l2.25 1.313a.75.75 0 0 1-.756 1.295L12 3.118 10.128 4.21a.75.75 0 1 1-.756-1.295l2.25-1.313ZM5.898 5.81a.75.75 0 0 1-.27 1.025l-1.14.665 1.14.665a.75.75 0 1 1-.756 1.295L3.75 8.806v.944a.75.75 0 0 1-1.5 0V7.5a.75.75 0 0 1 .372-.648l2.25-1.312a.75.75 0 0 1 1.026.27Zm12.204 0a.75.75 0 0 1 1.026-.27l2.25 1.312a.75.75 0 0 1 .372.648v2.25a.75.75 0 0 1-1.5 0v-.944l-1.122.654a.75.75 0 1 1-.756-1.295l1.14-.665-1.14-.665a.75.75 0 0 1-.27-1.025Zm-9 5.25a.75.75 0 0 1 1.026-.27L12 11.882l1.872-1.092a.75.75 0 1 1 .756 1.295l-1.878 1.096V15a.75.75 0 0 1-1.5 0v-1.82l-1.878-1.095a.75.75 0 0 1-.27-1.025ZM3 13.5a.75.75 0 0 1 .75.75v1.82l1.878 1.095a.75.75 0 1 1-.756 1.295l-2.25-1.312a.75.75 0 0 1-.372-.648v-2.25A.75.75 0 0 1 3 13.5Zm18 0a.75.75 0 0 1 .75.75v2.25a.75.75 0 0 1-.372.648l-2.25 1.312a.75.75 0 1 1-.756-1.295l1.878-1.096V14.25a.75.75 0 0 1 .75-.75Zm-9 5.25a.75.75 0 0 1 .75.75v.944l1.122-.654a.75.75 0 1 1 .756 1.295l-2.25 1.313a.75.75 0 0 1-.756 0l-2.25-1.313a.75.75 0 1 1 .756-1.295l1.122.654V19.5a.75.75 0 0 1 .75-.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function nM(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M12.378 1.602a.75.75 0 0 0-.756 0L3 6.632l9 5.25 9-5.25-8.622-5.03ZM21.75 7.93l-9 5.25v9l8.628-5.032a.75.75 0 0 0 .372-.648V7.93ZM11.25 22.18v-9l-9-5.25v8.57a.75.75 0 0 0 .372.648l8.628 5.033Z" })
  ]);
}
function rM(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M12 21.75c5.385 0 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25 2.25 6.615 2.25 12s4.365 9.75 9.75 9.75ZM10.5 7.963a1.5 1.5 0 0 0-2.17-1.341l-.415.207a.75.75 0 0 0 .67 1.342L9 7.963V9.75h-.75a.75.75 0 1 0 0 1.5H9v4.688c0 .563.26 1.198.867 1.525A4.501 4.501 0 0 0 16.41 14.4c.199-.977-.636-1.649-1.415-1.649h-.745a.75.75 0 1 0 0 1.5h.656a3.002 3.002 0 0 1-4.327 1.893.113.113 0 0 1-.045-.051.336.336 0 0 1-.034-.154V11.25h5.25a.75.75 0 0 0 0-1.5H10.5V7.963Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function aM(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M10.464 8.746c.227-.18.497-.311.786-.394v2.795a2.252 2.252 0 0 1-.786-.393c-.394-.313-.546-.681-.546-1.004 0-.323.152-.691.546-1.004ZM12.75 15.662v-2.824c.347.085.664.228.921.421.427.32.579.686.579.991 0 .305-.152.671-.579.991a2.534 2.534 0 0 1-.921.42Z" }),
    d("path", {
      "fill-rule": "evenodd",
      d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 6a.75.75 0 0 0-1.5 0v.816a3.836 3.836 0 0 0-1.72.756c-.712.566-1.112 1.35-1.112 2.178 0 .829.4 1.612 1.113 2.178.502.4 1.102.647 1.719.756v2.978a2.536 2.536 0 0 1-.921-.421l-.879-.66a.75.75 0 0 0-.9 1.2l.879.66c.533.4 1.169.645 1.821.75V18a.75.75 0 0 0 1.5 0v-.81a4.124 4.124 0 0 0 1.821-.749c.745-.559 1.179-1.344 1.179-2.191 0-.847-.434-1.632-1.179-2.191a4.122 4.122 0 0 0-1.821-.75V8.354c.29.082.559.213.786.393l.415.33a.75.75 0 0 0 .933-1.175l-.415-.33a3.836 3.836 0 0 0-1.719-.755V6Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function oM(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.902 7.098a3.75 3.75 0 0 1 3.903-.884.75.75 0 1 0 .498-1.415A5.25 5.25 0 0 0 8.005 9.75H7.5a.75.75 0 0 0 0 1.5h.054a5.281 5.281 0 0 0 0 1.5H7.5a.75.75 0 0 0 0 1.5h.505a5.25 5.25 0 0 0 6.494 2.701.75.75 0 1 0-.498-1.415 3.75 3.75 0 0 1-4.252-1.286h3.001a.75.75 0 0 0 0-1.5H9.075a3.77 3.77 0 0 1 0-1.5h3.675a.75.75 0 0 0 0-1.5h-3c.105-.14.221-.274.348-.402Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function iM(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM9.763 9.51a2.25 2.25 0 0 1 3.828-1.351.75.75 0 0 0 1.06-1.06 3.75 3.75 0 0 0-6.38 2.252c-.033.307 0 .595.032.822l.154 1.077H8.25a.75.75 0 0 0 0 1.5h.421l.138.964a3.75 3.75 0 0 1-.358 2.208l-.122.242a.75.75 0 0 0 .908 1.047l1.539-.512a1.5 1.5 0 0 1 .948 0l.655.218a3 3 0 0 0 2.29-.163l.666-.333a.75.75 0 1 0-.67-1.342l-.667.333a1.5 1.5 0 0 1-1.145.082l-.654-.218a3 3 0 0 0-1.898 0l-.06.02a5.25 5.25 0 0 0 .053-1.794l-.108-.752H12a.75.75 0 0 0 0-1.5H9.972l-.184-1.29a1.863 1.863 0 0 1-.025-.45Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function sM(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM9 7.5A.75.75 0 0 0 9 9h1.5c.98 0 1.813.626 2.122 1.5H9A.75.75 0 0 0 9 12h3.622a2.251 2.251 0 0 1-2.122 1.5H9a.75.75 0 0 0-.53 1.28l3 3a.75.75 0 1 0 1.06-1.06L10.8 14.988A3.752 3.752 0 0 0 14.175 12H15a.75.75 0 0 0 0-1.5h-.825A3.733 3.733 0 0 0 13.5 9H15a.75.75 0 0 0 0-1.5H9Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function lM(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM9.624 7.084a.75.75 0 0 0-1.248.832l2.223 3.334H9a.75.75 0 0 0 0 1.5h2.25v1.5H9a.75.75 0 0 0 0 1.5h2.25v1.5a.75.75 0 0 0 1.5 0v-1.5H15a.75.75 0 0 0 0-1.5h-2.25v-1.5H15a.75.75 0 0 0 0-1.5h-1.599l2.223-3.334a.75.75 0 1 0-1.248-.832L12 10.648 9.624 7.084Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function cM(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M12 1.5a.75.75 0 0 1 .75.75V4.5a.75.75 0 0 1-1.5 0V2.25A.75.75 0 0 1 12 1.5ZM5.636 4.136a.75.75 0 0 1 1.06 0l1.592 1.591a.75.75 0 0 1-1.061 1.06l-1.591-1.59a.75.75 0 0 1 0-1.061Zm12.728 0a.75.75 0 0 1 0 1.06l-1.591 1.592a.75.75 0 0 1-1.06-1.061l1.59-1.591a.75.75 0 0 1 1.061 0Zm-6.816 4.496a.75.75 0 0 1 .82.311l5.228 7.917a.75.75 0 0 1-.777 1.148l-2.097-.43 1.045 3.9a.75.75 0 0 1-1.45.388l-1.044-3.899-1.601 1.42a.75.75 0 0 1-1.247-.606l.569-9.47a.75.75 0 0 1 .554-.68ZM3 10.5a.75.75 0 0 1 .75-.75H6a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 10.5Zm14.25 0a.75.75 0 0 1 .75-.75h2.25a.75.75 0 0 1 0 1.5H18a.75.75 0 0 1-.75-.75Zm-8.962 3.712a.75.75 0 0 1 0 1.061l-1.591 1.591a.75.75 0 1 1-1.061-1.06l1.591-1.592a.75.75 0 0 1 1.06 0Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function uM(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M17.303 5.197A7.5 7.5 0 0 0 6.697 15.803a.75.75 0 0 1-1.061 1.061A9 9 0 1 1 21 10.5a.75.75 0 0 1-1.5 0c0-1.92-.732-3.839-2.197-5.303Zm-2.121 2.121a4.5 4.5 0 0 0-6.364 6.364.75.75 0 1 1-1.06 1.06A6 6 0 1 1 18 10.5a.75.75 0 0 1-1.5 0c0-1.153-.44-2.303-1.318-3.182Zm-3.634 1.314a.75.75 0 0 1 .82.311l5.228 7.917a.75.75 0 0 1-.777 1.148l-2.097-.43 1.045 3.9a.75.75 0 0 1-1.45.388l-1.044-3.899-1.601 1.42a.75.75 0 0 1-1.247-.606l.569-9.47a.75.75 0 0 1 .554-.68Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function dM(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M10.5 18.75a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5h-3Z" }),
    d("path", {
      "fill-rule": "evenodd",
      d: "M8.625.75A3.375 3.375 0 0 0 5.25 4.125v15.75a3.375 3.375 0 0 0 3.375 3.375h6.75a3.375 3.375 0 0 0 3.375-3.375V4.125A3.375 3.375 0 0 0 15.375.75h-6.75ZM7.5 4.125C7.5 3.504 8.004 3 8.625 3H9.75v.375c0 .621.504 1.125 1.125 1.125h2.25c.621 0 1.125-.504 1.125-1.125V3h1.125c.621 0 1.125.504 1.125 1.125v15.75c0 .621-.504 1.125-1.125 1.125h-6.75A1.125 1.125 0 0 1 7.5 19.875V4.125Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function _M(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M10.5 18a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5h-3Z" }),
    d("path", {
      "fill-rule": "evenodd",
      d: "M7.125 1.5A3.375 3.375 0 0 0 3.75 4.875v14.25A3.375 3.375 0 0 0 7.125 22.5h9.75a3.375 3.375 0 0 0 3.375-3.375V4.875A3.375 3.375 0 0 0 16.875 1.5h-9.75ZM6 4.875c0-.621.504-1.125 1.125-1.125h9.75c.621 0 1.125.504 1.125 1.125v14.25c0 .621-.504 1.125-1.125 1.125h-9.75A1.125 1.125 0 0 1 6 19.125V4.875Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function pM(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M10.874 5.248a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Zm-7.125 6.75a.75.75 0 0 1 .75-.75h15a.75.75 0 0 1 0 1.5h-15a.75.75 0 0 1-.75-.75Zm7.125 6.753a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function mM(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875Zm5.845 17.03a.75.75 0 0 0 1.06 0l3-3a.75.75 0 1 0-1.06-1.06l-1.72 1.72V12a.75.75 0 0 0-1.5 0v4.19l-1.72-1.72a.75.75 0 0 0-1.06 1.06l3 3Z",
      "clip-rule": "evenodd"
    }),
    d("path", { d: "M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" })
  ]);
}
function gM(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875Zm6.905 9.97a.75.75 0 0 0-1.06 0l-3 3a.75.75 0 1 0 1.06 1.06l1.72-1.72V18a.75.75 0 0 0 1.5 0v-4.19l1.72 1.72a.75.75 0 1 0 1.06-1.06l-3-3Z",
      "clip-rule": "evenodd"
    }),
    d("path", { d: "M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" })
  ]);
}
function fM(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875ZM9.75 17.25a.75.75 0 0 0-1.5 0V18a.75.75 0 0 0 1.5 0v-.75Zm2.25-3a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-3a.75.75 0 0 1 .75-.75Zm3.75-1.5a.75.75 0 0 0-1.5 0V18a.75.75 0 0 0 1.5 0v-5.25Z",
      "clip-rule": "evenodd"
    }),
    d("path", { d: "M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" })
  ]);
}
function hM(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M9 1.5H5.625c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0 0 16.5 9h-1.875a1.875 1.875 0 0 1-1.875-1.875V5.25A3.75 3.75 0 0 0 9 1.5Zm6.61 10.936a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 14.47a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z",
      "clip-rule": "evenodd"
    }),
    d("path", { d: "M12.971 1.816A5.23 5.23 0 0 1 14.25 5.25v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 0 1 3.434 1.279 9.768 9.768 0 0 0-6.963-6.963Z" })
  ]);
}
function vM(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M3.75 3.375c0-1.036.84-1.875 1.875-1.875H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375Zm10.5 1.875a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Zm-3.75 5.56c0-1.336-1.616-2.005-2.56-1.06l-.22.22a.75.75 0 0 0 1.06 1.06l.22-.22v1.94h-.75a.75.75 0 0 0 0 1.5H9v3c0 .671.307 1.453 1.068 1.815a4.5 4.5 0 0 0 5.993-2.123c.233-.487.14-1-.136-1.37A1.459 1.459 0 0 0 14.757 15h-.507a.75.75 0 0 0 0 1.5h.349a2.999 2.999 0 0 1-3.887 1.21c-.091-.043-.212-.186-.212-.46v-3h5.25a.75.75 0 1 0 0-1.5H10.5v-1.94Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function EM(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M3.75 3.375c0-1.036.84-1.875 1.875-1.875H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375Zm10.5 1.875a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25ZM12 10.5a.75.75 0 0 1 .75.75v.028a9.727 9.727 0 0 1 1.687.28.75.75 0 1 1-.374 1.452 8.207 8.207 0 0 0-1.313-.226v1.68l.969.332c.67.23 1.281.85 1.281 1.704 0 .158-.007.314-.02.468-.083.931-.83 1.582-1.669 1.695a9.776 9.776 0 0 1-.561.059v.028a.75.75 0 0 1-1.5 0v-.029a9.724 9.724 0 0 1-1.687-.278.75.75 0 0 1 .374-1.453c.425.11.864.186 1.313.226v-1.68l-.968-.332C9.612 14.974 9 14.354 9 13.5c0-.158.007-.314.02-.468.083-.931.831-1.582 1.67-1.694.185-.025.372-.045.56-.06v-.028a.75.75 0 0 1 .75-.75Zm-1.11 2.324c.119-.016.239-.03.36-.04v1.166l-.482-.165c-.208-.072-.268-.211-.268-.285 0-.113.005-.225.015-.336.013-.146.14-.309.374-.34Zm1.86 4.392V16.05l.482.165c.208.072.268.211.268.285 0 .113-.005.225-.015.336-.012.146-.14.309-.374.34-.12.016-.24.03-.361.04Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function bM(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M3.75 3.375c0-1.036.84-1.875 1.875-1.875H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375Zm7.464 9.442c.459-.573 1.019-.817 1.536-.817.517 0 1.077.244 1.536.817a.75.75 0 1 0 1.171-.937c-.713-.892-1.689-1.38-2.707-1.38-1.018 0-1.994.488-2.707 1.38a4.61 4.61 0 0 0-.705 1.245H8.25a.75.75 0 0 0 0 1.5h.763c-.017.25-.017.5 0 .75H8.25a.75.75 0 0 0 0 1.5h1.088c.17.449.406.87.705 1.245.713.892 1.689 1.38 2.707 1.38 1.018 0 1.994-.488 2.707-1.38a.75.75 0 0 0-1.171-.937c-.459.573-1.019.817-1.536.817-.517 0-1.077-.244-1.536-.817-.078-.098-.15-.2-.215-.308h1.751a.75.75 0 0 0 0-1.5h-2.232a3.965 3.965 0 0 1 0-.75h2.232a.75.75 0 0 0 0-1.5H11c.065-.107.136-.21.214-.308Z",
      "clip-rule": "evenodd"
    }),
    d("path", { d: "M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" })
  ]);
}
function SM(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M3.75 3.375c0-1.036.84-1.875 1.875-1.875H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375Zm10.5 1.875a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Zm-3.674 9.583a2.249 2.249 0 0 1 3.765-2.174.75.75 0 0 0 1.06-1.06A3.75 3.75 0 0 0 9.076 15H8.25a.75.75 0 0 0 0 1.5h1.156a3.75 3.75 0 0 1-.206 1.559l-.156.439a.75.75 0 0 0 1.042.923l.439-.22a2.113 2.113 0 0 1 1.613-.115 3.613 3.613 0 0 0 2.758-.196l.44-.22a.75.75 0 1 0-.671-1.341l-.44.22a2.113 2.113 0 0 1-1.613.114 3.612 3.612 0 0 0-1.745-.134c.048-.341.062-.686.042-1.029H12a.75.75 0 0 0 0-1.5h-1.379l-.045-.167Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function wM(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M3.75 3.375c0-1.036.84-1.875 1.875-1.875H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375Zm10.5 1.875a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Zm-4.5 5.25a.75.75 0 0 0 0 1.5h.375c.769 0 1.43.463 1.719 1.125H9.75a.75.75 0 0 0 0 1.5h2.094a1.875 1.875 0 0 1-1.719 1.125H9.75a.75.75 0 0 0-.53 1.28l2.25 2.25a.75.75 0 0 0 1.06-1.06l-1.193-1.194a3.382 3.382 0 0 0 2.08-2.401h.833a.75.75 0 0 0 0-1.5h-.834A3.357 3.357 0 0 0 12.932 12h1.318a.75.75 0 0 0 0-1.5H10.5c-.04 0-.08.003-.12.01a3.425 3.425 0 0 0-.255-.01H9.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function yM(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M3.75 3.375c0-1.036.84-1.875 1.875-1.875H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375Zm10.5 1.875a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Zm-3.9 5.55a.75.75 0 0 0-1.2.9l1.912 2.55H9.75a.75.75 0 0 0 0 1.5h1.5v.75h-1.5a.75.75 0 0 0 0 1.5h1.5v.75a.75.75 0 1 0 1.5 0V18h1.5a.75.75 0 1 0 0-1.5h-1.5v-.75h1.5a.75.75 0 1 0 0-1.5h-1.313l1.913-2.55a.75.75 0 1 0-1.2-.9L12 13l-1.65-2.2Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function TM(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M7.5 3.375c0-1.036.84-1.875 1.875-1.875h.375a3.75 3.75 0 0 1 3.75 3.75v1.875C13.5 8.161 14.34 9 15.375 9h1.875A3.75 3.75 0 0 1 21 12.75v3.375C21 17.16 20.16 18 19.125 18h-9.75A1.875 1.875 0 0 1 7.5 16.125V3.375Z" }),
    d("path", { d: "M15 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 17.25 7.5h-1.875A.375.375 0 0 1 15 7.125V5.25ZM4.875 6H6v10.125A3.375 3.375 0 0 0 9.375 19.5H16.5v1.125c0 1.035-.84 1.875-1.875 1.875h-9.75A1.875 1.875 0 0 1 3 20.625V7.875C3 6.839 3.84 6 4.875 6Z" })
  ]);
}
function CM(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M11.625 16.5a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z" }),
    d("path", {
      "fill-rule": "evenodd",
      d: "M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875Zm6 16.5c.66 0 1.277-.19 1.797-.518l1.048 1.048a.75.75 0 0 0 1.06-1.06l-1.047-1.048A3.375 3.375 0 1 0 11.625 18Z",
      "clip-rule": "evenodd"
    }),
    d("path", { d: "M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" })
  ]);
}
function xM(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875ZM9.75 14.25a.75.75 0 0 0 0 1.5H15a.75.75 0 0 0 0-1.5H9.75Z",
      "clip-rule": "evenodd"
    }),
    d("path", { d: "M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" })
  ]);
}
function AM(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875ZM12.75 12a.75.75 0 0 0-1.5 0v2.25H9a.75.75 0 0 0 0 1.5h2.25V18a.75.75 0 0 0 1.5 0v-2.25H15a.75.75 0 0 0 0-1.5h-2.25V12Z",
      "clip-rule": "evenodd"
    }),
    d("path", { d: "M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" })
  ]);
}
function RM(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M5.625 1.5c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0 0 16.5 9h-1.875a1.875 1.875 0 0 1-1.875-1.875V5.25A3.75 3.75 0 0 0 9 1.5H5.625ZM7.5 15a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 7.5 15Zm.75 2.25a.75.75 0 0 0 0 1.5H12a.75.75 0 0 0 0-1.5H8.25Z",
      "clip-rule": "evenodd"
    }),
    d("path", { d: "M12.971 1.816A5.23 5.23 0 0 1 14.25 5.25v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 0 1 3.434 1.279 9.768 9.768 0 0 0-6.963-6.963Z" })
  ]);
}
function OM(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M5.625 1.5c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0 0 16.5 9h-1.875a1.875 1.875 0 0 1-1.875-1.875V5.25A3.75 3.75 0 0 0 9 1.5H5.625Z" }),
    d("path", { d: "M12.971 1.816A5.23 5.23 0 0 1 14.25 5.25v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 0 1 3.434 1.279 9.768 9.768 0 0 0-6.963-6.963Z" })
  ]);
}
function IM(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm0 8.625a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25ZM15.375 12a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0ZM7.5 10.875a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function NM(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M4.5 12a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm6 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm6 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function MM(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M10.5 6a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm0 6a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm0 6a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function DM(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M19.5 22.5a3 3 0 0 0 3-3v-8.174l-6.879 4.022 3.485 1.876a.75.75 0 1 1-.712 1.321l-5.683-3.06a1.5 1.5 0 0 0-1.422 0l-5.683 3.06a.75.75 0 0 1-.712-1.32l3.485-1.877L1.5 11.326V19.5a3 3 0 0 0 3 3h15Z" }),
    d("path", { d: "M1.5 9.589v-.745a3 3 0 0 1 1.578-2.642l7.5-4.038a3 3 0 0 1 2.844 0l7.5 4.038A3 3 0 0 1 22.5 8.844v.745l-8.426 4.926-.652-.351a3 3 0 0 0-2.844 0l-.652.351L1.5 9.589Z" })
  ]);
}
function kM(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M1.5 8.67v8.58a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3V8.67l-8.928 5.493a3 3 0 0 1-3.144 0L1.5 8.67Z" }),
    d("path", { d: "M22.5 6.908V6.75a3 3 0 0 0-3-3h-15a3 3 0 0 0-3 3v.158l9.714 5.978a1.5 1.5 0 0 0 1.572 0L22.5 6.908Z" })
  ]);
}
function LM(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M3.748 8.248a.75.75 0 0 1 .75-.75h15a.75.75 0 0 1 0 1.5h-15a.75.75 0 0 1-.75-.75ZM3.748 15.75a.75.75 0 0 1 .75-.751h15a.75.75 0 0 1 0 1.5h-15a.75.75 0 0 1-.75-.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function PM(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12ZM12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75Zm0 8.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function BM(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003ZM12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75Zm0 8.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function FM(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M16.098 2.598a3.75 3.75 0 1 1 3.622 6.275l-1.72.46V12a.75.75 0 0 1-.22.53l-.75.75a.75.75 0 0 1-1.06 0l-.97-.97-7.94 7.94a2.56 2.56 0 0 1-1.81.75 1.06 1.06 0 0 0-.75.31l-.97.97a.75.75 0 0 1-1.06 0l-.75-.75a.75.75 0 0 1 0-1.06l.97-.97a1.06 1.06 0 0 0 .31-.75c0-.68.27-1.33.75-1.81L11.69 9l-.97-.97a.75.75 0 0 1 0-1.06l.75-.75A.75.75 0 0 1 12 6h2.666l.461-1.72c.165-.617.49-1.2.971-1.682Zm-3.348 7.463L4.81 18a1.06 1.06 0 0 0-.31.75c0 .318-.06.63-.172.922a2.56 2.56 0 0 1 .922-.172c.281 0 .551-.112.75-.31l7.94-7.94-1.19-1.19Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function UM(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M3.53 2.47a.75.75 0 0 0-1.06 1.06l18 18a.75.75 0 1 0 1.06-1.06l-18-18ZM22.676 12.553a11.249 11.249 0 0 1-2.631 4.31l-3.099-3.099a5.25 5.25 0 0 0-6.71-6.71L7.759 4.577a11.217 11.217 0 0 1 4.242-.827c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113Z" }),
    d("path", { d: "M15.75 12c0 .18-.013.357-.037.53l-4.244-4.243A3.75 3.75 0 0 1 15.75 12ZM12.53 15.713l-4.243-4.244a3.75 3.75 0 0 0 4.244 4.243Z" }),
    d("path", { d: "M6.75 12c0-.619.107-1.213.304-1.764l-3.1-3.1a11.25 11.25 0 0 0-2.63 4.31c-.12.362-.12.752 0 1.114 1.489 4.467 5.704 7.69 10.675 7.69 1.5 0 2.933-.294 4.242-.827l-2.477-2.477A5.25 5.25 0 0 1 6.75 12Z" })
  ]);
}
function $M(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" }),
    d("path", {
      "fill-rule": "evenodd",
      d: "M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 0 1 0-1.113ZM17.25 12a5.25 5.25 0 1 1-10.5 0 5.25 5.25 0 0 1 10.5 0Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function VM(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-2.625 6c-.54 0-.828.419-.936.634a1.96 1.96 0 0 0-.189.866c0 .298.059.605.189.866.108.215.395.634.936.634.54 0 .828-.419.936-.634.13-.26.189-.568.189-.866 0-.298-.059-.605-.189-.866-.108-.215-.395-.634-.936-.634Zm4.314.634c.108-.215.395-.634.936-.634.54 0 .828.419.936.634.13.26.189.568.189.866 0 .298-.059.605-.189.866-.108.215-.395.634-.936.634-.54 0-.828-.419-.936-.634a1.96 1.96 0 0 1-.189-.866c0-.298.059-.605.189-.866Zm-4.34 7.964a.75.75 0 0 1-1.061-1.06 5.236 5.236 0 0 1 3.73-1.538 5.236 5.236 0 0 1 3.695 1.538.75.75 0 1 1-1.061 1.06 3.736 3.736 0 0 0-2.639-1.098 3.736 3.736 0 0 0-2.664 1.098Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function HM(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-2.625 6c-.54 0-.828.419-.936.634a1.96 1.96 0 0 0-.189.866c0 .298.059.605.189.866.108.215.395.634.936.634.54 0 .828-.419.936-.634.13-.26.189-.568.189-.866 0-.298-.059-.605-.189-.866-.108-.215-.395-.634-.936-.634Zm4.314.634c.108-.215.395-.634.936-.634.54 0 .828.419.936.634.13.26.189.568.189.866 0 .298-.059.605-.189.866-.108.215-.395.634-.936.634-.54 0-.828-.419-.936-.634a1.96 1.96 0 0 1-.189-.866c0-.298.059-.605.189-.866Zm2.023 6.828a.75.75 0 1 0-1.06-1.06 3.75 3.75 0 0 1-5.304 0 .75.75 0 0 0-1.06 1.06 5.25 5.25 0 0 0 7.424 0Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function GM(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M1.5 5.625c0-1.036.84-1.875 1.875-1.875h17.25c1.035 0 1.875.84 1.875 1.875v12.75c0 1.035-.84 1.875-1.875 1.875H3.375A1.875 1.875 0 0 1 1.5 18.375V5.625Zm1.5 0v1.5c0 .207.168.375.375.375h1.5a.375.375 0 0 0 .375-.375v-1.5a.375.375 0 0 0-.375-.375h-1.5A.375.375 0 0 0 3 5.625Zm16.125-.375a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h1.5A.375.375 0 0 0 21 7.125v-1.5a.375.375 0 0 0-.375-.375h-1.5ZM21 9.375A.375.375 0 0 0 20.625 9h-1.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h1.5a.375.375 0 0 0 .375-.375v-1.5Zm0 3.75a.375.375 0 0 0-.375-.375h-1.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h1.5a.375.375 0 0 0 .375-.375v-1.5Zm0 3.75a.375.375 0 0 0-.375-.375h-1.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h1.5a.375.375 0 0 0 .375-.375v-1.5ZM4.875 18.75a.375.375 0 0 0 .375-.375v-1.5a.375.375 0 0 0-.375-.375h-1.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h1.5ZM3.375 15h1.5a.375.375 0 0 0 .375-.375v-1.5a.375.375 0 0 0-.375-.375h-1.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375Zm0-3.75h1.5a.375.375 0 0 0 .375-.375v-1.5A.375.375 0 0 0 4.875 9h-1.5A.375.375 0 0 0 3 9.375v1.5c0 .207.168.375.375.375Zm4.125 0a.75.75 0 0 0 0 1.5h9a.75.75 0 0 0 0-1.5h-9Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function YM(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M12 3.75a6.715 6.715 0 0 0-3.722 1.118.75.75 0 1 1-.828-1.25 8.25 8.25 0 0 1 12.8 6.883c0 3.014-.574 5.897-1.62 8.543a.75.75 0 0 1-1.395-.551A21.69 21.69 0 0 0 18.75 10.5 6.75 6.75 0 0 0 12 3.75ZM6.157 5.739a.75.75 0 0 1 .21 1.04A6.715 6.715 0 0 0 5.25 10.5c0 1.613-.463 3.12-1.265 4.393a.75.75 0 0 1-1.27-.8A6.715 6.715 0 0 0 3.75 10.5c0-1.68.503-3.246 1.367-4.55a.75.75 0 0 1 1.04-.211ZM12 7.5a3 3 0 0 0-3 3c0 3.1-1.176 5.927-3.105 8.056a.75.75 0 1 1-1.112-1.008A10.459 10.459 0 0 0 7.5 10.5a4.5 4.5 0 1 1 9 0c0 .547-.022 1.09-.067 1.626a.75.75 0 0 1-1.495-.123c.041-.495.062-.996.062-1.503a3 3 0 0 0-3-3Zm0 2.25a.75.75 0 0 1 .75.75c0 3.908-1.424 7.485-3.781 10.238a.75.75 0 0 1-1.14-.975A14.19 14.19 0 0 0 11.25 10.5a.75.75 0 0 1 .75-.75Zm3.239 5.183a.75.75 0 0 1 .515.927 19.417 19.417 0 0 1-2.585 5.544.75.75 0 0 1-1.243-.84 17.915 17.915 0 0 0 2.386-5.116.75.75 0 0 1 .927-.515Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function zM(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M12.963 2.286a.75.75 0 0 0-1.071-.136 9.742 9.742 0 0 0-3.539 6.176 7.547 7.547 0 0 1-1.705-1.715.75.75 0 0 0-1.152-.082A9 9 0 1 0 15.68 4.534a7.46 7.46 0 0 1-2.717-2.248ZM15.75 14.25a3.75 3.75 0 1 1-7.313-1.172c.628.465 1.35.81 2.133 1a5.99 5.99 0 0 1 1.925-3.546 3.75 3.75 0 0 1 3.255 3.718Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function ZM(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M3 2.25a.75.75 0 0 1 .75.75v.54l1.838-.46a9.75 9.75 0 0 1 6.725.738l.108.054A8.25 8.25 0 0 0 18 4.524l3.11-.732a.75.75 0 0 1 .917.81 47.784 47.784 0 0 0 .005 10.337.75.75 0 0 1-.574.812l-3.114.733a9.75 9.75 0 0 1-6.594-.77l-.108-.054a8.25 8.25 0 0 0-5.69-.625l-2.202.55V21a.75.75 0 0 1-1.5 0V3A.75.75 0 0 1 3 2.25Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function qM(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M19.5 21a3 3 0 0 0 3-3V9a3 3 0 0 0-3-3h-5.379a.75.75 0 0 1-.53-.22L11.47 3.66A2.25 2.25 0 0 0 9.879 3H4.5a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h15Zm-6.75-10.5a.75.75 0 0 0-1.5 0v4.19l-1.72-1.72a.75.75 0 0 0-1.06 1.06l3 3a.75.75 0 0 0 1.06 0l3-3a.75.75 0 1 0-1.06-1.06l-1.72 1.72V10.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function WM(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M19.5 21a3 3 0 0 0 3-3V9a3 3 0 0 0-3-3h-5.379a.75.75 0 0 1-.53-.22L11.47 3.66A2.25 2.25 0 0 0 9.879 3H4.5a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h15ZM9 12.75a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5H9Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function jM(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M19.906 9c.382 0 .749.057 1.094.162V9a3 3 0 0 0-3-3h-3.879a.75.75 0 0 1-.53-.22L11.47 3.66A2.25 2.25 0 0 0 9.879 3H6a3 3 0 0 0-3 3v3.162A3.756 3.756 0 0 1 4.094 9h15.812ZM4.094 10.5a2.25 2.25 0 0 0-2.227 2.568l.857 6A2.25 2.25 0 0 0 4.951 21H19.05a2.25 2.25 0 0 0 2.227-1.932l.857-6a2.25 2.25 0 0 0-2.227-2.568H4.094Z" })
  ]);
}
function KM(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M19.5 21a3 3 0 0 0 3-3V9a3 3 0 0 0-3-3h-5.379a.75.75 0 0 1-.53-.22L11.47 3.66A2.25 2.25 0 0 0 9.879 3H4.5a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h15Zm-6.75-10.5a.75.75 0 0 0-1.5 0v2.25H9a.75.75 0 0 0 0 1.5h2.25v2.25a.75.75 0 0 0 1.5 0v-2.25H15a.75.75 0 0 0 0-1.5h-2.25V10.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function QM(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M19.5 21a3 3 0 0 0 3-3v-4.5a3 3 0 0 0-3-3h-15a3 3 0 0 0-3 3V18a3 3 0 0 0 3 3h15ZM1.5 10.146V6a3 3 0 0 1 3-3h5.379a2.25 2.25 0 0 1 1.59.659l2.122 2.121c.14.141.331.22.53.22H19.5a3 3 0 0 1 3 3v1.146A4.483 4.483 0 0 0 19.5 9h-15a4.483 4.483 0 0 0-3 1.146Z" })
  ]);
}
function XM(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M5.055 7.06C3.805 6.347 2.25 7.25 2.25 8.69v8.122c0 1.44 1.555 2.343 2.805 1.628L12 14.471v2.34c0 1.44 1.555 2.343 2.805 1.628l7.108-4.061c1.26-.72 1.26-2.536 0-3.256l-7.108-4.061C13.555 6.346 12 7.249 12 8.689v2.34L5.055 7.061Z" })
  ]);
}
function JM(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M3.792 2.938A49.069 49.069 0 0 1 12 2.25c2.797 0 5.54.236 8.209.688a1.857 1.857 0 0 1 1.541 1.836v1.044a3 3 0 0 1-.879 2.121l-6.182 6.182a1.5 1.5 0 0 0-.439 1.061v2.927a3 3 0 0 1-1.658 2.684l-1.757.878A.75.75 0 0 1 9.75 21v-5.818a1.5 1.5 0 0 0-.44-1.06L3.13 7.938a3 3 0 0 1-.879-2.121V4.774c0-.897.64-1.683 1.542-1.836Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function eD(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M4.5 3.75a3 3 0 0 0-3 3v10.5a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3V6.75a3 3 0 0 0-3-3h-15Zm9 4.5a.75.75 0 0 0-1.5 0v7.5a.75.75 0 0 0 1.5 0v-7.5Zm1.5 0a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5H16.5v2.25H18a.75.75 0 0 1 0 1.5h-1.5v3a.75.75 0 0 1-1.5 0v-7.5ZM6.636 9.78c.404-.575.867-.78 1.25-.78s.846.205 1.25.78a.75.75 0 0 0 1.228-.863C9.738 8.027 8.853 7.5 7.886 7.5c-.966 0-1.852.527-2.478 1.417-.62.882-.908 2-.908 3.083 0 1.083.288 2.201.909 3.083.625.89 1.51 1.417 2.477 1.417.967 0 1.852-.527 2.478-1.417a.75.75 0 0 0 .136-.431V12a.75.75 0 0 0-.75-.75h-1.5a.75.75 0 0 0 0 1.5H9v1.648c-.37.44-.774.602-1.114.602-.383 0-.846-.205-1.25-.78C6.226 13.638 6 12.837 6 12c0-.837.226-1.638.636-2.22Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function tD(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M11.25 3v4.046a3 3 0 0 0-4.277 4.204H1.5v-6A2.25 2.25 0 0 1 3.75 3h7.5ZM12.75 3v4.011a3 3 0 0 1 4.239 4.239H22.5v-6A2.25 2.25 0 0 0 20.25 3h-7.5ZM22.5 12.75h-8.983a4.125 4.125 0 0 0 4.108 3.75.75.75 0 0 1 0 1.5 5.623 5.623 0 0 1-4.875-2.817V21h7.5a2.25 2.25 0 0 0 2.25-2.25v-6ZM11.25 21v-5.817A5.623 5.623 0 0 1 6.375 18a.75.75 0 0 1 0-1.5 4.126 4.126 0 0 0 4.108-3.75H1.5v6A2.25 2.25 0 0 0 3.75 21h7.5Z" }),
    d("path", { d: "M11.085 10.354c.03.297.038.575.036.805a7.484 7.484 0 0 1-.805-.036c-.833-.084-1.677-.325-2.195-.843a1.5 1.5 0 0 1 2.122-2.12c.517.517.759 1.36.842 2.194ZM12.877 10.354c-.03.297-.038.575-.036.805.23.002.508-.006.805-.036.833-.084 1.677-.325 2.195-.843A1.5 1.5 0 0 0 13.72 8.16c-.518.518-.76 1.362-.843 2.194Z" })
  ]);
}
function nD(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M9.375 3a1.875 1.875 0 0 0 0 3.75h1.875v4.5H3.375A1.875 1.875 0 0 1 1.5 9.375v-.75c0-1.036.84-1.875 1.875-1.875h3.193A3.375 3.375 0 0 1 12 2.753a3.375 3.375 0 0 1 5.432 3.997h3.943c1.035 0 1.875.84 1.875 1.875v.75c0 1.036-.84 1.875-1.875 1.875H12.75v-4.5h1.875a1.875 1.875 0 1 0-1.875-1.875V6.75h-1.5V4.875C11.25 3.839 10.41 3 9.375 3ZM11.25 12.75H3v6.75a2.25 2.25 0 0 0 2.25 2.25h6v-9ZM12.75 12.75v9h6.75a2.25 2.25 0 0 0 2.25-2.25v-6.75h-9Z" })
  ]);
}
function rD(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M21.721 12.752a9.711 9.711 0 0 0-.945-5.003 12.754 12.754 0 0 1-4.339 2.708 18.991 18.991 0 0 1-.214 4.772 17.165 17.165 0 0 0 5.498-2.477ZM14.634 15.55a17.324 17.324 0 0 0 .332-4.647c-.952.227-1.945.347-2.966.347-1.021 0-2.014-.12-2.966-.347a17.515 17.515 0 0 0 .332 4.647 17.385 17.385 0 0 0 5.268 0ZM9.772 17.119a18.963 18.963 0 0 0 4.456 0A17.182 17.182 0 0 1 12 21.724a17.18 17.18 0 0 1-2.228-4.605ZM7.777 15.23a18.87 18.87 0 0 1-.214-4.774 12.753 12.753 0 0 1-4.34-2.708 9.711 9.711 0 0 0-.944 5.004 17.165 17.165 0 0 0 5.498 2.477ZM21.356 14.752a9.765 9.765 0 0 1-7.478 6.817 18.64 18.64 0 0 0 1.988-4.718 18.627 18.627 0 0 0 5.49-2.098ZM2.644 14.752c1.682.971 3.53 1.688 5.49 2.099a18.64 18.64 0 0 0 1.988 4.718 9.765 9.765 0 0 1-7.478-6.816ZM13.878 2.43a9.755 9.755 0 0 1 6.116 3.986 11.267 11.267 0 0 1-3.746 2.504 18.63 18.63 0 0 0-2.37-6.49ZM12 2.276a17.152 17.152 0 0 1 2.805 7.121c-.897.23-1.837.353-2.805.353-.968 0-1.908-.122-2.805-.353A17.151 17.151 0 0 1 12 2.276ZM10.122 2.43a18.629 18.629 0 0 0-2.37 6.49 11.266 11.266 0 0 1-3.746-2.504 9.754 9.754 0 0 1 6.116-3.985Z" })
  ]);
}
function aD(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM6.262 6.072a8.25 8.25 0 1 0 10.562-.766 4.5 4.5 0 0 1-1.318 1.357L14.25 7.5l.165.33a.809.809 0 0 1-1.086 1.085l-.604-.302a1.125 1.125 0 0 0-1.298.21l-.132.131c-.439.44-.439 1.152 0 1.591l.296.296c.256.257.622.374.98.314l1.17-.195c.323-.054.654.036.905.245l1.33 1.108c.32.267.46.694.358 1.1a8.7 8.7 0 0 1-2.288 4.04l-.723.724a1.125 1.125 0 0 1-1.298.21l-.153-.076a1.125 1.125 0 0 1-.622-1.006v-1.089c0-.298-.119-.585-.33-.796l-1.347-1.347a1.125 1.125 0 0 1-.21-1.298L9.75 12l-1.64-1.64a6 6 0 0 1-1.676-3.257l-.172-1.03Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function oD(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M15.75 8.25a.75.75 0 0 1 .75.75c0 1.12-.492 2.126-1.27 2.812a.75.75 0 1 1-.992-1.124A2.243 2.243 0 0 0 15 9a.75.75 0 0 1 .75-.75Z" }),
    d("path", {
      "fill-rule": "evenodd",
      d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM4.575 15.6a8.25 8.25 0 0 0 9.348 4.425 1.966 1.966 0 0 0-1.84-1.275.983.983 0 0 1-.97-.822l-.073-.437c-.094-.565.25-1.11.8-1.267l.99-.282c.427-.123.783-.418.982-.816l.036-.073a1.453 1.453 0 0 1 2.328-.377L16.5 15h.628a2.25 2.25 0 0 1 1.983 1.186 8.25 8.25 0 0 0-6.345-12.4c.044.262.18.503.389.676l1.068.89c.442.369.535 1.01.216 1.49l-.51.766a2.25 2.25 0 0 1-1.161.886l-.143.048a1.107 1.107 0 0 0-.57 1.664c.369.555.169 1.307-.427 1.605L9 13.125l.423 1.059a.956.956 0 0 1-1.652.928l-.679-.906a1.125 1.125 0 0 0-1.906.172L4.575 15.6Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function iD(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM8.547 4.505a8.25 8.25 0 1 0 11.672 8.214l-.46-.46a2.252 2.252 0 0 1-.422-.586l-1.08-2.16a.414.414 0 0 0-.663-.107.827.827 0 0 1-.812.21l-1.273-.363a.89.89 0 0 0-.738 1.595l.587.39c.59.395.674 1.23.172 1.732l-.2.2c-.211.212-.33.498-.33.796v.41c0 .409-.11.809-.32 1.158l-1.315 2.191a2.11 2.11 0 0 1-1.81 1.025 1.055 1.055 0 0 1-1.055-1.055v-1.172c0-.92-.56-1.747-1.414-2.089l-.654-.261a2.25 2.25 0 0 1-1.384-2.46l.007-.042a2.25 2.25 0 0 1 .29-.787l.09-.15a2.25 2.25 0 0 1 2.37-1.048l1.178.236a1.125 1.125 0 0 0 1.302-.795l.208-.73a1.125 1.125 0 0 0-.578-1.315l-.665-.332-.091.091a2.25 2.25 0 0 1-1.591.659h-.18c-.249 0-.487.1-.662.274a.931.931 0 0 1-1.458-1.137l1.279-2.132Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function sD(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M2.243 3.743a.75.75 0 0 1 .75.75v6.75h9v-6.75a.75.75 0 1 1 1.5 0v15.002a.75.75 0 1 1-1.5 0v-6.751h-9v6.75a.75.75 0 1 1-1.5 0v-15a.75.75 0 0 1 .75-.75Zm17.605 4.964a.75.75 0 0 1 .396.661v9.376h1.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5h1.5V10.77l-1.084.722a.75.75 0 1 1-.832-1.248l2.25-1.5a.75.75 0 0 1 .77-.037Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function lD(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M2.246 3.743a.75.75 0 0 1 .75.75v6.75h9v-6.75a.75.75 0 0 1 1.5 0v15.002a.75.75 0 1 1-1.5 0v-6.751h-9v6.75a.75.75 0 1 1-1.5 0v-15a.75.75 0 0 1 .75-.75ZM18.75 10.5c-.727 0-1.441.054-2.138.16a.75.75 0 1 1-.223-1.484 15.867 15.867 0 0 1 3.635-.125c1.149.092 2.153.923 2.348 2.115.084.516.128 1.045.128 1.584 0 1.065-.676 1.927-1.531 2.354l-2.89 1.445a1.5 1.5 0 0 0-.829 1.342v.86h4.5a.75.75 0 1 1 0 1.5H16.5a.75.75 0 0 1-.75-.75v-1.61a3 3 0 0 1 1.659-2.684l2.89-1.445c.447-.223.701-.62.701-1.012a8.32 8.32 0 0 0-.108-1.342c-.075-.457-.47-.82-.987-.862a14.45 14.45 0 0 0-1.155-.046Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function cD(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M12.749 3.743a.75.75 0 0 1 .75.75v15.002a.75.75 0 1 1-1.5 0v-6.75H2.997v6.75a.75.75 0 0 1-1.5 0V4.494a.75.75 0 1 1 1.5 0v6.75H12v-6.75a.75.75 0 0 1 .75-.75ZM18.75 10.5c-.727 0-1.441.055-2.139.16a.75.75 0 1 1-.223-1.483 15.87 15.87 0 0 1 3.82-.11c.95.088 1.926.705 2.168 1.794a5.265 5.265 0 0 1-.579 3.765 5.265 5.265 0 0 1 .578 3.765c-.24 1.088-1.216 1.706-2.167 1.793a15.942 15.942 0 0 1-3.82-.109.75.75 0 0 1 .223-1.483 14.366 14.366 0 0 0 3.46.099c.467-.043.773-.322.84-.624a3.768 3.768 0 0 0-.413-2.691H18a.75.75 0 0 1 0-1.5h2.498a3.768 3.768 0 0 0 .413-2.69c-.067-.303-.373-.582-.84-.625-.435-.04-.876-.06-1.321-.06Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function uD(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M10.5 1.875a1.125 1.125 0 0 1 2.25 0v8.219c.517.162 1.02.382 1.5.659V3.375a1.125 1.125 0 0 1 2.25 0v10.937a4.505 4.505 0 0 0-3.25 2.373 8.963 8.963 0 0 1 4-.935A.75.75 0 0 0 18 15v-2.266a3.368 3.368 0 0 1 .988-2.37 1.125 1.125 0 0 1 1.591 1.59 1.118 1.118 0 0 0-.329.79v3.006h-.005a6 6 0 0 1-1.752 4.007l-1.736 1.736a6 6 0 0 1-4.242 1.757H10.5a7.5 7.5 0 0 1-7.5-7.5V6.375a1.125 1.125 0 0 1 2.25 0v5.519c.46-.452.965-.832 1.5-1.141V3.375a1.125 1.125 0 0 1 2.25 0v6.526c.495-.1.997-.151 1.5-.151V1.875Z" })
  ]);
}
function dD(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M15.73 5.5h1.035A7.465 7.465 0 0 1 18 9.625a7.465 7.465 0 0 1-1.235 4.125h-.148c-.806 0-1.534.446-2.031 1.08a9.04 9.04 0 0 1-2.861 2.4c-.723.384-1.35.956-1.653 1.715a4.499 4.499 0 0 0-.322 1.672v.633A.75.75 0 0 1 9 22a2.25 2.25 0 0 1-2.25-2.25c0-1.152.26-2.243.723-3.218.266-.558-.107-1.282-.725-1.282H3.622c-1.026 0-1.945-.694-2.054-1.715A12.137 12.137 0 0 1 1.5 12.25c0-2.848.992-5.464 2.649-7.521C4.537 4.247 5.136 4 5.754 4H9.77a4.5 4.5 0 0 1 1.423.23l3.114 1.04a4.5 4.5 0 0 0 1.423.23ZM21.669 14.023c.536-1.362.831-2.845.831-4.398 0-1.22-.182-2.398-.52-3.507-.26-.85-1.084-1.368-1.973-1.368H19.1c-.445 0-.72.498-.523.898.591 1.2.924 2.55.924 3.977a8.958 8.958 0 0 1-1.302 4.666c-.245.403.028.959.5.959h1.053c.832 0 1.612-.453 1.918-1.227Z" })
  ]);
}
function _D(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M7.493 18.5c-.425 0-.82-.236-.975-.632A7.48 7.48 0 0 1 6 15.125c0-1.75.599-3.358 1.602-4.634.151-.192.373-.309.6-.397.473-.183.89-.514 1.212-.924a9.042 9.042 0 0 1 2.861-2.4c.723-.384 1.35-.956 1.653-1.715a4.498 4.498 0 0 0 .322-1.672V2.75A.75.75 0 0 1 15 2a2.25 2.25 0 0 1 2.25 2.25c0 1.152-.26 2.243-.723 3.218-.266.558.107 1.282.725 1.282h3.126c1.026 0 1.945.694 2.054 1.715.045.422.068.85.068 1.285a11.95 11.95 0 0 1-2.649 7.521c-.388.482-.987.729-1.605.729H14.23c-.483 0-.964-.078-1.423-.23l-3.114-1.04a4.501 4.501 0 0 0-1.423-.23h-.777ZM2.331 10.727a11.969 11.969 0 0 0-.831 4.398 12 12 0 0 0 .52 3.507C2.28 19.482 3.105 20 3.994 20H4.9c.445 0 .72-.498.523-.898a8.963 8.963 0 0 1-.924-3.977c0-1.708.476-3.305 1.302-4.666.245-.403-.028-.959-.5-.959H4.25c-.832 0-1.612.453-1.918 1.227Z" })
  ]);
}
function pD(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M11.097 1.515a.75.75 0 0 1 .589.882L10.666 7.5h4.47l1.079-5.397a.75.75 0 1 1 1.47.294L16.665 7.5h3.585a.75.75 0 0 1 0 1.5h-3.885l-1.2 6h3.585a.75.75 0 0 1 0 1.5h-3.885l-1.08 5.397a.75.75 0 1 1-1.47-.294l1.02-5.103h-4.47l-1.08 5.397a.75.75 0 1 1-1.47-.294l1.02-5.103H3.75a.75.75 0 0 1 0-1.5h3.885l1.2-6H5.25a.75.75 0 0 1 0-1.5h3.885l1.08-5.397a.75.75 0 0 1 .882-.588ZM10.365 9l-1.2 6h4.47l1.2-6h-4.47Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function mD(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "m11.645 20.91-.007-.003-.022-.012a15.247 15.247 0 0 1-.383-.218 25.18 25.18 0 0 1-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25 2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0 1 12 5.052 5.5 5.5 0 0 1 16.313 3c2.973 0 5.437 2.322 5.437 5.25 0 3.925-2.438 7.111-4.739 9.256a25.175 25.175 0 0 1-4.244 3.17 15.247 15.247 0 0 1-.383.219l-.022.012-.007.004-.003.001a.752.752 0 0 1-.704 0l-.003-.001Z" })
  ]);
}
function gD(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M19.006 3.705a.75.75 0 1 0-.512-1.41L6 6.838V3a.75.75 0 0 0-.75-.75h-1.5A.75.75 0 0 0 3 3v4.93l-1.006.365a.75.75 0 0 0 .512 1.41l16.5-6Z" }),
    d("path", {
      "fill-rule": "evenodd",
      d: "M3.019 11.114 18 5.667v3.421l4.006 1.457a.75.75 0 1 1-.512 1.41l-.494-.18v8.475h.75a.75.75 0 0 1 0 1.5H2.25a.75.75 0 0 1 0-1.5H3v-9.129l.019-.007ZM18 20.25v-9.566l1.5.546v9.02H18Zm-9-6a.75.75 0 0 0-.75.75v4.5c0 .414.336.75.75.75h3a.75.75 0 0 0 .75-.75V15a.75.75 0 0 0-.75-.75H9Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function fD(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M11.47 3.841a.75.75 0 0 1 1.06 0l8.69 8.69a.75.75 0 1 0 1.06-1.061l-8.689-8.69a2.25 2.25 0 0 0-3.182 0l-8.69 8.69a.75.75 0 1 0 1.061 1.06l8.69-8.689Z" }),
    d("path", { d: "m12 5.432 8.159 8.159c.03.03.06.058.091.086v6.198c0 1.035-.84 1.875-1.875 1.875H15a.75.75 0 0 1-.75-.75v-4.5a.75.75 0 0 0-.75-.75h-3a.75.75 0 0 0-.75.75V21a.75.75 0 0 1-.75.75H5.625a1.875 1.875 0 0 1-1.875-1.875v-6.198a2.29 2.29 0 0 0 .091-.086L12 5.432Z" })
  ]);
}
function hD(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M4.5 3.75a3 3 0 0 0-3 3v10.5a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3V6.75a3 3 0 0 0-3-3h-15Zm4.125 3a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5Zm-3.873 8.703a4.126 4.126 0 0 1 7.746 0 .75.75 0 0 1-.351.92 7.47 7.47 0 0 1-3.522.877 7.47 7.47 0 0 1-3.522-.877.75.75 0 0 1-.351-.92ZM15 8.25a.75.75 0 0 0 0 1.5h3.75a.75.75 0 0 0 0-1.5H15ZM14.25 12a.75.75 0 0 1 .75-.75h3.75a.75.75 0 0 1 0 1.5H15a.75.75 0 0 1-.75-.75Zm.75 2.25a.75.75 0 0 0 0 1.5h3.75a.75.75 0 0 0 0-1.5H15Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function vD(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M5.478 5.559A1.5 1.5 0 0 1 6.912 4.5H9A.75.75 0 0 0 9 3H6.912a3 3 0 0 0-2.868 2.118l-2.411 7.838a3 3 0 0 0-.133.882V18a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3v-4.162c0-.299-.045-.596-.133-.882l-2.412-7.838A3 3 0 0 0 17.088 3H15a.75.75 0 0 0 0 1.5h2.088a1.5 1.5 0 0 1 1.434 1.059l2.213 7.191H17.89a3 3 0 0 0-2.684 1.658l-.256.513a1.5 1.5 0 0 1-1.342.829h-3.218a1.5 1.5 0 0 1-1.342-.83l-.256-.512a3 3 0 0 0-2.684-1.658H3.265l2.213-7.191Z",
      "clip-rule": "evenodd"
    }),
    d("path", {
      "fill-rule": "evenodd",
      d: "M12 2.25a.75.75 0 0 1 .75.75v6.44l1.72-1.72a.75.75 0 1 1 1.06 1.06l-3 3a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 0 1 1.06-1.06l1.72 1.72V3a.75.75 0 0 1 .75-.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function ED(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M1.5 9.832v1.793c0 1.036.84 1.875 1.875 1.875h17.25c1.035 0 1.875-.84 1.875-1.875V9.832a3 3 0 0 0-.722-1.952l-3.285-3.832A3 3 0 0 0 16.215 3h-8.43a3 3 0 0 0-2.278 1.048L2.222 7.88A3 3 0 0 0 1.5 9.832ZM7.785 4.5a1.5 1.5 0 0 0-1.139.524L3.881 8.25h3.165a3 3 0 0 1 2.496 1.336l.164.246a1.5 1.5 0 0 0 1.248.668h2.092a1.5 1.5 0 0 0 1.248-.668l.164-.246a3 3 0 0 1 2.496-1.336h3.165l-2.765-3.226a1.5 1.5 0 0 0-1.139-.524h-8.43Z",
      "clip-rule": "evenodd"
    }),
    d("path", { d: "M2.813 15c-.725 0-1.313.588-1.313 1.313V18a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3v-1.688c0-.724-.588-1.312-1.313-1.312h-4.233a3 3 0 0 0-2.496 1.336l-.164.246a1.5 1.5 0 0 1-1.248.668h-2.092a1.5 1.5 0 0 1-1.248-.668l-.164-.246A3 3 0 0 0 7.046 15H2.812Z" })
  ]);
}
function bD(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M6.912 3a3 3 0 0 0-2.868 2.118l-2.411 7.838a3 3 0 0 0-.133.882V18a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3v-4.162c0-.299-.045-.596-.133-.882l-2.412-7.838A3 3 0 0 0 17.088 3H6.912Zm13.823 9.75-2.213-7.191A1.5 1.5 0 0 0 17.088 4.5H6.912a1.5 1.5 0 0 0-1.434 1.059L3.265 12.75H6.11a3 3 0 0 1 2.684 1.658l.256.513a1.5 1.5 0 0 0 1.342.829h3.218a1.5 1.5 0 0 0 1.342-.83l.256-.512a3 3 0 0 1 2.684-1.658h2.844Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function SD(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function wD(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M10.497 3.744a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-3.275l-5.357 15.002h2.632a.75.75 0 1 1 0 1.5h-7.5a.75.75 0 1 1 0-1.5h3.275l5.357-15.002h-2.632a.75.75 0 0 1-.75-.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function yD(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M15.75 1.5a6.75 6.75 0 0 0-6.651 7.906c.067.39-.032.717-.221.906l-6.5 6.499a3 3 0 0 0-.878 2.121v2.818c0 .414.336.75.75.75H6a.75.75 0 0 0 .75-.75v-1.5h1.5A.75.75 0 0 0 9 19.5V18h1.5a.75.75 0 0 0 .53-.22l2.658-2.658c.19-.189.517-.288.906-.22A6.75 6.75 0 1 0 15.75 1.5Zm0 3a.75.75 0 0 0 0 1.5A2.25 2.25 0 0 1 18 8.25a.75.75 0 0 0 1.5 0 3.75 3.75 0 0 0-3.75-3.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function TD(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M9 2.25a.75.75 0 0 1 .75.75v1.506a49.384 49.384 0 0 1 5.343.371.75.75 0 1 1-.186 1.489c-.66-.083-1.323-.151-1.99-.206a18.67 18.67 0 0 1-2.97 6.323c.318.384.65.753 1 1.107a.75.75 0 0 1-1.07 1.052A18.902 18.902 0 0 1 9 13.687a18.823 18.823 0 0 1-5.656 4.482.75.75 0 0 1-.688-1.333 17.323 17.323 0 0 0 5.396-4.353A18.72 18.72 0 0 1 5.89 8.598a.75.75 0 0 1 1.388-.568A17.21 17.21 0 0 0 9 11.224a17.168 17.168 0 0 0 2.391-5.165 48.04 48.04 0 0 0-8.298.307.75.75 0 0 1-.186-1.489 49.159 49.159 0 0 1 5.343-.371V3A.75.75 0 0 1 9 2.25ZM15.75 9a.75.75 0 0 1 .68.433l5.25 11.25a.75.75 0 1 1-1.36.634l-1.198-2.567h-6.744l-1.198 2.567a.75.75 0 0 1-1.36-.634l5.25-11.25A.75.75 0 0 1 15.75 9Zm-2.672 8.25h5.344l-2.672-5.726-2.672 5.726Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function CD(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M19.449 8.448 16.388 11a4.52 4.52 0 0 1 0 2.002l3.061 2.55a8.275 8.275 0 0 0 0-7.103ZM15.552 19.45 13 16.388a4.52 4.52 0 0 1-2.002 0l-2.55 3.061a8.275 8.275 0 0 0 7.103 0ZM4.55 15.552 7.612 13a4.52 4.52 0 0 1 0-2.002L4.551 8.45a8.275 8.275 0 0 0 0 7.103ZM8.448 4.55 11 7.612a4.52 4.52 0 0 1 2.002 0l2.55-3.061a8.275 8.275 0 0 0-7.103 0Zm8.657-.86a9.776 9.776 0 0 1 1.79 1.415 9.776 9.776 0 0 1 1.414 1.788 9.764 9.764 0 0 1 0 10.211 9.777 9.777 0 0 1-1.415 1.79 9.777 9.777 0 0 1-1.788 1.414 9.764 9.764 0 0 1-10.212 0 9.776 9.776 0 0 1-1.788-1.415 9.776 9.776 0 0 1-1.415-1.788 9.764 9.764 0 0 1 0-10.212 9.774 9.774 0 0 1 1.415-1.788A9.774 9.774 0 0 1 6.894 3.69a9.764 9.764 0 0 1 10.211 0ZM14.121 9.88a2.985 2.985 0 0 0-1.11-.704 3.015 3.015 0 0 0-2.022 0 2.985 2.985 0 0 0-1.11.704c-.326.325-.56.705-.704 1.11a3.015 3.015 0 0 0 0 2.022c.144.405.378.785.704 1.11.325.326.705.56 1.11.704.652.233 1.37.233 2.022 0a2.985 2.985 0 0 0 1.11-.704c.326-.325.56-.705.704-1.11a3.016 3.016 0 0 0 0-2.022 2.985 2.985 0 0 0-.704-1.11Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function xD(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M12 .75a8.25 8.25 0 0 0-4.135 15.39c.686.398 1.115 1.008 1.134 1.623a.75.75 0 0 0 .577.706c.352.083.71.148 1.074.195.323.041.6-.218.6-.544v-4.661a6.714 6.714 0 0 1-.937-.171.75.75 0 1 1 .374-1.453 5.261 5.261 0 0 0 2.626 0 .75.75 0 1 1 .374 1.452 6.712 6.712 0 0 1-.937.172v4.66c0 .327.277.586.6.545.364-.047.722-.112 1.074-.195a.75.75 0 0 0 .577-.706c.02-.615.448-1.225 1.134-1.623A8.25 8.25 0 0 0 12 .75Z" }),
    d("path", {
      "fill-rule": "evenodd",
      d: "M9.013 19.9a.75.75 0 0 1 .877-.597 11.319 11.319 0 0 0 4.22 0 .75.75 0 1 1 .28 1.473 12.819 12.819 0 0 1-4.78 0 .75.75 0 0 1-.597-.876ZM9.754 22.344a.75.75 0 0 1 .824-.668 13.682 13.682 0 0 0 2.844 0 .75.75 0 1 1 .156 1.492 15.156 15.156 0 0 1-3.156 0 .75.75 0 0 1-.668-.824Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function AD(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M19.892 4.09a3.75 3.75 0 0 0-5.303 0l-4.5 4.5c-.074.074-.144.15-.21.229l4.965 4.966a3.75 3.75 0 0 0-1.986-4.428.75.75 0 0 1 .646-1.353 5.253 5.253 0 0 1 2.502 6.944l5.515 5.515a.75.75 0 0 1-1.061 1.06l-18-18.001A.75.75 0 0 1 3.521 2.46l5.294 5.295a5.31 5.31 0 0 1 .213-.227l4.5-4.5a5.25 5.25 0 1 1 7.425 7.425l-1.757 1.757a.75.75 0 1 1-1.06-1.06l1.756-1.757a3.75 3.75 0 0 0 0-5.304ZM5.846 11.773a.75.75 0 0 1 0 1.06l-1.757 1.758a3.75 3.75 0 0 0 5.303 5.304l3.129-3.13a.75.75 0 1 1 1.06 1.061l-3.128 3.13a5.25 5.25 0 1 1-7.425-7.426l1.757-1.757a.75.75 0 0 1 1.061 0Zm2.401.26a.75.75 0 0 1 .957.458c.18.512.474.992.885 1.403.31.311.661.555 1.035.733a.75.75 0 0 1-.647 1.354 5.244 5.244 0 0 1-1.449-1.026 5.232 5.232 0 0 1-1.24-1.965.75.75 0 0 1 .46-.957Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function RD(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M19.902 4.098a3.75 3.75 0 0 0-5.304 0l-4.5 4.5a3.75 3.75 0 0 0 1.035 6.037.75.75 0 0 1-.646 1.353 5.25 5.25 0 0 1-1.449-8.45l4.5-4.5a5.25 5.25 0 1 1 7.424 7.424l-1.757 1.757a.75.75 0 1 1-1.06-1.06l1.757-1.757a3.75 3.75 0 0 0 0-5.304Zm-7.389 4.267a.75.75 0 0 1 1-.353 5.25 5.25 0 0 1 1.449 8.45l-4.5 4.5a5.25 5.25 0 1 1-7.424-7.424l1.757-1.757a.75.75 0 1 1 1.06 1.06l-1.757 1.757a3.75 3.75 0 1 0 5.304 5.304l4.5-4.5a3.75 3.75 0 0 0-1.035-6.037.75.75 0 0 1-.354-1Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function OD(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M2.625 6.75a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Zm4.875 0A.75.75 0 0 1 8.25 6h12a.75.75 0 0 1 0 1.5h-12a.75.75 0 0 1-.75-.75ZM2.625 12a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0ZM7.5 12a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5h-12A.75.75 0 0 1 7.5 12Zm-4.875 5.25a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Zm4.875 0a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5h-12a.75.75 0 0 1-.75-.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function ID(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M12 1.5a5.25 5.25 0 0 0-5.25 5.25v3a3 3 0 0 0-3 3v6.75a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3v-6.75a3 3 0 0 0-3-3v-3c0-2.9-2.35-5.25-5.25-5.25Zm3.75 8.25v-3a3.75 3.75 0 1 0-7.5 0v3h7.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function ND(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M18 1.5c2.9 0 5.25 2.35 5.25 5.25v3.75a.75.75 0 0 1-1.5 0V6.75a3.75 3.75 0 1 0-7.5 0v3a3 3 0 0 1 3 3v6.75a3 3 0 0 1-3 3H3.75a3 3 0 0 1-3-3v-6.75a3 3 0 0 1 3-3h9v-3c0-2.9 2.35-5.25 5.25-5.25Z" })
  ]);
}
function MD(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M8.25 10.875a2.625 2.625 0 1 1 5.25 0 2.625 2.625 0 0 1-5.25 0Z" }),
    d("path", {
      "fill-rule": "evenodd",
      d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.125 4.5a4.125 4.125 0 1 0 2.338 7.524l2.007 2.006a.75.75 0 1 0 1.06-1.06l-2.006-2.007a4.125 4.125 0 0 0-3.399-6.463Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function DD(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M10.5 3.75a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5ZM2.25 10.5a8.25 8.25 0 1 1 14.59 5.28l4.69 4.69a.75.75 0 1 1-1.06 1.06l-4.69-4.69A8.25 8.25 0 0 1 2.25 10.5Zm4.5 0a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function kD(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M10.5 3.75a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5ZM2.25 10.5a8.25 8.25 0 1 1 14.59 5.28l4.69 4.69a.75.75 0 1 1-1.06 1.06l-4.69-4.69A8.25 8.25 0 0 1 2.25 10.5Zm8.25-3.75a.75.75 0 0 1 .75.75v2.25h2.25a.75.75 0 0 1 0 1.5h-2.25v2.25a.75.75 0 0 1-1.5 0v-2.25H7.5a.75.75 0 0 1 0-1.5h2.25V7.5a.75.75 0 0 1 .75-.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function LD(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M10.5 3.75a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5ZM2.25 10.5a8.25 8.25 0 1 1 14.59 5.28l4.69 4.69a.75.75 0 1 1-1.06 1.06l-4.69-4.69A8.25 8.25 0 0 1 2.25 10.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function PD(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "m11.54 22.351.07.04.028.016a.76.76 0 0 0 .723 0l.028-.015.071-.041a16.975 16.975 0 0 0 1.144-.742 19.58 19.58 0 0 0 2.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 0 0-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 0 0 2.682 2.282 16.975 16.975 0 0 0 1.145.742ZM12 13.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function BD(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M8.161 2.58a1.875 1.875 0 0 1 1.678 0l4.993 2.498c.106.052.23.052.336 0l3.869-1.935A1.875 1.875 0 0 1 21.75 4.82v12.485c0 .71-.401 1.36-1.037 1.677l-4.875 2.437a1.875 1.875 0 0 1-1.676 0l-4.994-2.497a.375.375 0 0 0-.336 0l-3.868 1.935A1.875 1.875 0 0 1 2.25 19.18V6.695c0-.71.401-1.36 1.036-1.677l4.875-2.437ZM9 6a.75.75 0 0 1 .75.75V15a.75.75 0 0 1-1.5 0V6.75A.75.75 0 0 1 9 6Zm6.75 3a.75.75 0 0 0-1.5 0v8.25a.75.75 0 0 0 1.5 0V9Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function FD(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M16.881 4.345A23.112 23.112 0 0 1 8.25 6H7.5a5.25 5.25 0 0 0-.88 10.427 21.593 21.593 0 0 0 1.378 3.94c.464 1.004 1.674 1.32 2.582.796l.657-.379c.88-.508 1.165-1.593.772-2.468a17.116 17.116 0 0 1-.628-1.607c1.918.258 3.76.75 5.5 1.446A21.727 21.727 0 0 0 18 11.25c0-2.414-.393-4.735-1.119-6.905ZM18.26 3.74a23.22 23.22 0 0 1 1.24 7.51 23.22 23.22 0 0 1-1.41 7.992.75.75 0 1 0 1.409.516 24.555 24.555 0 0 0 1.415-6.43 2.992 2.992 0 0 0 .836-2.078c0-.807-.319-1.54-.836-2.078a24.65 24.65 0 0 0-1.415-6.43.75.75 0 1 0-1.409.516c.059.16.116.321.17.483Z" })
  ]);
}
function UD(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M8.25 4.5a3.75 3.75 0 1 1 7.5 0v8.25a3.75 3.75 0 1 1-7.5 0V4.5Z" }),
    d("path", { d: "M6 10.5a.75.75 0 0 1 .75.75v1.5a5.25 5.25 0 1 0 10.5 0v-1.5a.75.75 0 0 1 1.5 0v1.5a6.751 6.751 0 0 1-6 6.709v2.291h3a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1 0-1.5h3v-2.291a6.751 6.751 0 0 1-6-6.709v-1.5A.75.75 0 0 1 6 10.5Z" })
  ]);
}
function $D(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm3 10.5a.75.75 0 0 0 0-1.5H9a.75.75 0 0 0 0 1.5h6Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function VD(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M5.25 12a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function HD(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M4.25 12a.75.75 0 0 1 .75-.75h14a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function GD(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M9.528 1.718a.75.75 0 0 1 .162.819A8.97 8.97 0 0 0 9 6a9 9 0 0 0 9 9 8.97 8.97 0 0 0 3.463-.69.75.75 0 0 1 .981.98 10.503 10.503 0 0 1-9.694 6.46c-5.799 0-10.5-4.7-10.5-10.5 0-4.368 2.667-8.112 6.46-9.694a.75.75 0 0 1 .818.162Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function YD(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M19.952 1.651a.75.75 0 0 1 .298.599V16.303a3 3 0 0 1-2.176 2.884l-1.32.377a2.553 2.553 0 1 1-1.403-4.909l2.311-.66a1.5 1.5 0 0 0 1.088-1.442V6.994l-9 2.572v9.737a3 3 0 0 1-2.176 2.884l-1.32.377a2.553 2.553 0 1 1-1.402-4.909l2.31-.66a1.5 1.5 0 0 0 1.088-1.442V5.25a.75.75 0 0 1 .544-.721l10.5-3a.75.75 0 0 1 .658.122Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function zD(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M4.125 3C3.089 3 2.25 3.84 2.25 4.875V18a3 3 0 0 0 3 3h15a3 3 0 0 1-3-3V4.875C17.25 3.839 16.41 3 15.375 3H4.125ZM12 9.75a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5H12Zm-.75-2.25a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 0 1.5H12a.75.75 0 0 1-.75-.75ZM6 12.75a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5H6Zm-.75 3.75a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75ZM6 6.75a.75.75 0 0 0-.75.75v3c0 .414.336.75.75.75h3a.75.75 0 0 0 .75-.75v-3A.75.75 0 0 0 9 6.75H6Z",
      "clip-rule": "evenodd"
    }),
    d("path", { d: "M18.75 6.75h1.875c.621 0 1.125.504 1.125 1.125V18a1.5 1.5 0 0 1-3 0V6.75Z" })
  ]);
}
function ZD(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "m6.72 5.66 11.62 11.62A8.25 8.25 0 0 0 6.72 5.66Zm10.56 12.68L5.66 6.72a8.25 8.25 0 0 0 11.62 11.62ZM5.105 5.106c3.807-3.808 9.98-3.808 13.788 0 3.808 3.807 3.808 9.98 0 13.788-3.807 3.808-9.98 3.808-13.788 0-3.808-3.807-3.808-9.98 0-13.788Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function qD(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M7.491 5.992a.75.75 0 0 1 .75-.75h12a.75.75 0 1 1 0 1.5h-12a.75.75 0 0 1-.75-.75ZM7.49 11.995a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5h-12a.75.75 0 0 1-.75-.75ZM7.491 17.994a.75.75 0 0 1 .75-.75h12a.75.75 0 1 1 0 1.5h-12a.75.75 0 0 1-.75-.75ZM2.24 3.745a.75.75 0 0 1 .75-.75h1.125a.75.75 0 0 1 .75.75v3h.375a.75.75 0 0 1 0 1.5H2.99a.75.75 0 0 1 0-1.5h.375v-2.25H2.99a.75.75 0 0 1-.75-.75ZM2.79 10.602a.75.75 0 0 1 0-1.06 1.875 1.875 0 1 1 2.652 2.651l-.55.55h.35a.75.75 0 0 1 0 1.5h-2.16a.75.75 0 0 1-.53-1.281l1.83-1.83a.375.375 0 0 0-.53-.53.75.75 0 0 1-1.062 0ZM2.24 15.745a.75.75 0 0 1 .75-.75h1.125a1.875 1.875 0 0 1 1.501 2.999 1.875 1.875 0 0 1-1.501 3H2.99a.75.75 0 0 1 0-1.501h1.125a.375.375 0 0 0 .036-.748H3.74a.75.75 0 0 1-.75-.75v-.002a.75.75 0 0 1 .75-.75h.411a.375.375 0 0 0-.036-.748H2.99a.75.75 0 0 1-.75-.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function WD(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M20.599 1.5c-.376 0-.743.111-1.055.32l-5.08 3.385a18.747 18.747 0 0 0-3.471 2.987 10.04 10.04 0 0 1 4.815 4.815 18.748 18.748 0 0 0 2.987-3.472l3.386-5.079A1.902 1.902 0 0 0 20.599 1.5Zm-8.3 14.025a18.76 18.76 0 0 0 1.896-1.207 8.026 8.026 0 0 0-4.513-4.513A18.75 18.75 0 0 0 8.475 11.7l-.278.5a5.26 5.26 0 0 1 3.601 3.602l.502-.278ZM6.75 13.5A3.75 3.75 0 0 0 3 17.25a1.5 1.5 0 0 1-1.601 1.497.75.75 0 0 0-.7 1.123 5.25 5.25 0 0 0 9.8-2.62 3.75 3.75 0 0 0-3.75-3.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function jD(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M3.478 2.404a.75.75 0 0 0-.926.941l2.432 7.905H13.5a.75.75 0 0 1 0 1.5H4.984l-2.432 7.905a.75.75 0 0 0 .926.94 60.519 60.519 0 0 0 18.445-8.986.75.75 0 0 0 0-1.218A60.517 60.517 0 0 0 3.478 2.404Z" })
  ]);
}
function KD(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M18.97 3.659a2.25 2.25 0 0 0-3.182 0l-10.94 10.94a3.75 3.75 0 1 0 5.304 5.303l7.693-7.693a.75.75 0 0 1 1.06 1.06l-7.693 7.693a5.25 5.25 0 1 1-7.424-7.424l10.939-10.94a3.75 3.75 0 1 1 5.303 5.304L9.097 18.835l-.008.008-.007.007-.002.002-.003.002A2.25 2.25 0 0 1 5.91 15.66l7.81-7.81a.75.75 0 0 1 1.061 1.06l-7.81 7.81a.75.75 0 0 0 1.054 1.068L18.97 6.84a2.25 2.25 0 0 0 0-3.182Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function QD(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12ZM9 8.25a.75.75 0 0 0-.75.75v6c0 .414.336.75.75.75h.75a.75.75 0 0 0 .75-.75V9a.75.75 0 0 0-.75-.75H9Zm5.25 0a.75.75 0 0 0-.75.75v6c0 .414.336.75.75.75H15a.75.75 0 0 0 .75-.75V9a.75.75 0 0 0-.75-.75h-.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function XD(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M6.75 5.25a.75.75 0 0 1 .75-.75H9a.75.75 0 0 1 .75.75v13.5a.75.75 0 0 1-.75.75H7.5a.75.75 0 0 1-.75-.75V5.25Zm7.5 0A.75.75 0 0 1 15 4.5h1.5a.75.75 0 0 1 .75.75v13.5a.75.75 0 0 1-.75.75H15a.75.75 0 0 1-.75-.75V5.25Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function JD(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M21.731 2.269a2.625 2.625 0 0 0-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 0 0 0-3.712ZM19.513 8.199l-3.712-3.712-8.4 8.4a5.25 5.25 0 0 0-1.32 2.214l-.8 2.685a.75.75 0 0 0 .933.933l2.685-.8a5.25 5.25 0 0 0 2.214-1.32l8.4-8.4Z" }),
    d("path", { d: "M5.25 5.25a3 3 0 0 0-3 3v10.5a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3V13.5a.75.75 0 0 0-1.5 0v5.25a1.5 1.5 0 0 1-1.5 1.5H5.25a1.5 1.5 0 0 1-1.5-1.5V8.25a1.5 1.5 0 0 1 1.5-1.5h5.25a.75.75 0 0 0 0-1.5H5.25Z" })
  ]);
}
function ek(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M21.731 2.269a2.625 2.625 0 0 0-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 0 0 0-3.712ZM19.513 8.199l-3.712-3.712-12.15 12.15a5.25 5.25 0 0 0-1.32 2.214l-.8 2.685a.75.75 0 0 0 .933.933l2.685-.8a5.25 5.25 0 0 0 2.214-1.32L19.513 8.2Z" })
  ]);
}
function tk(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M11.99 2.243a4.49 4.49 0 0 0-3.398 1.55 4.49 4.49 0 0 0-3.497 1.306 4.491 4.491 0 0 0-1.307 3.498 4.491 4.491 0 0 0-1.548 3.397c0 1.357.6 2.573 1.548 3.397a4.491 4.491 0 0 0 1.307 3.498 4.49 4.49 0 0 0 3.498 1.307 4.49 4.49 0 0 0 3.397 1.549 4.49 4.49 0 0 0 3.397-1.549 4.49 4.49 0 0 0 3.497-1.307 4.491 4.491 0 0 0 1.306-3.497 4.491 4.491 0 0 0 1.55-3.398c0-1.357-.601-2.573-1.549-3.397a4.491 4.491 0 0 0-1.307-3.498 4.49 4.49 0 0 0-3.498-1.307 4.49 4.49 0 0 0-3.396-1.549Zm3.53 7.28a.75.75 0 0 0-1.06-1.06l-6 6a.75.75 0 1 0 1.06 1.06l6-6Zm-5.78-.905a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25Zm4.5 4.5a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function nk(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M19.5 9.75a.75.75 0 0 1-.75.75h-4.5a.75.75 0 0 1-.75-.75v-4.5a.75.75 0 0 1 1.5 0v2.69l4.72-4.72a.75.75 0 1 1 1.06 1.06L16.06 9h2.69a.75.75 0 0 1 .75.75Z",
      "clip-rule": "evenodd"
    }),
    d("path", {
      "fill-rule": "evenodd",
      d: "M1.5 4.5a3 3 0 0 1 3-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 0 1-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 0 0 6.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 0 1 1.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 0 1-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function rk(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M15 3.75a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0V5.56l-4.72 4.72a.75.75 0 1 1-1.06-1.06l4.72-4.72h-2.69a.75.75 0 0 1-.75-.75Z",
      "clip-rule": "evenodd"
    }),
    d("path", {
      "fill-rule": "evenodd",
      d: "M1.5 4.5a3 3 0 0 1 3-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 0 1-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 0 0 6.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 0 1 1.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 0 1-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function ak(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M15.22 3.22a.75.75 0 0 1 1.06 0L18 4.94l1.72-1.72a.75.75 0 1 1 1.06 1.06L19.06 6l1.72 1.72a.75.75 0 0 1-1.06 1.06L18 7.06l-1.72 1.72a.75.75 0 1 1-1.06-1.06L16.94 6l-1.72-1.72a.75.75 0 0 1 0-1.06ZM1.5 4.5a3 3 0 0 1 3-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 0 1-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 0 0 6.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 0 1 1.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 0 1-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function ok(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M1.5 4.5a3 3 0 0 1 3-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 0 1-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 0 0 6.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 0 1 1.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 0 1-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function ik(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M1.5 6a2.25 2.25 0 0 1 2.25-2.25h16.5A2.25 2.25 0 0 1 22.5 6v12a2.25 2.25 0 0 1-2.25 2.25H3.75A2.25 2.25 0 0 1 1.5 18V6ZM3 16.06V18c0 .414.336.75.75.75h16.5A.75.75 0 0 0 21 18v-1.94l-2.69-2.689a1.5 1.5 0 0 0-2.12 0l-.88.879.97.97a.75.75 0 1 1-1.06 1.06l-5.16-5.159a1.5 1.5 0 0 0-2.12 0L3 16.061Zm10.125-7.81a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function sk(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm14.024-.983a1.125 1.125 0 0 1 0 1.966l-5.603 3.113A1.125 1.125 0 0 1 9 15.113V8.887c0-.857.921-1.4 1.671-.983l5.603 3.113Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function lk(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M15 6.75a.75.75 0 0 0-.75.75V18a.75.75 0 0 0 .75.75h.75a.75.75 0 0 0 .75-.75V7.5a.75.75 0 0 0-.75-.75H15ZM20.25 6.75a.75.75 0 0 0-.75.75V18c0 .414.336.75.75.75H21a.75.75 0 0 0 .75-.75V7.5a.75.75 0 0 0-.75-.75h-.75ZM5.055 7.06C3.805 6.347 2.25 7.25 2.25 8.69v8.122c0 1.44 1.555 2.343 2.805 1.628l7.108-4.061c1.26-.72 1.26-2.536 0-3.256L5.055 7.061Z" })
  ]);
}
function ck(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M4.5 5.653c0-1.427 1.529-2.33 2.779-1.643l11.54 6.347c1.295.712 1.295 2.573 0 3.286L7.28 19.99c-1.25.687-2.779-.217-2.779-1.643V5.653Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function uk(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 9a.75.75 0 0 0-1.5 0v2.25H9a.75.75 0 0 0 0 1.5h2.25V15a.75.75 0 0 0 1.5 0v-2.25H15a.75.75 0 0 0 0-1.5h-2.25V9Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function dk(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M12 5.25a.75.75 0 0 1 .75.75v5.25H18a.75.75 0 0 1 0 1.5h-5.25V18a.75.75 0 0 1-1.5 0v-5.25H6a.75.75 0 0 1 0-1.5h5.25V6a.75.75 0 0 1 .75-.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function _k(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M12 3.75a.75.75 0 0 1 .75.75v6.75h6.75a.75.75 0 0 1 0 1.5h-6.75v6.75a.75.75 0 0 1-1.5 0v-6.75H4.5a.75.75 0 0 1 0-1.5h6.75V4.5a.75.75 0 0 1 .75-.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function pk(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M12 2.25a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-1.5 0V3a.75.75 0 0 1 .75-.75ZM6.166 5.106a.75.75 0 0 1 0 1.06 8.25 8.25 0 1 0 11.668 0 .75.75 0 1 1 1.06-1.06c3.808 3.807 3.808 9.98 0 13.788-3.807 3.808-9.98 3.808-13.788 0-3.808-3.807-3.808-9.98 0-13.788a.75.75 0 0 1 1.06 0Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function mk(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M2.25 2.25a.75.75 0 0 0 0 1.5H3v10.5a3 3 0 0 0 3 3h1.21l-1.172 3.513a.75.75 0 0 0 1.424.474l.329-.987h8.418l.33.987a.75.75 0 0 0 1.422-.474l-1.17-3.513H18a3 3 0 0 0 3-3V3.75h.75a.75.75 0 0 0 0-1.5H2.25Zm6.04 16.5.5-1.5h6.42l.5 1.5H8.29Zm7.46-12a.75.75 0 0 0-1.5 0v6a.75.75 0 0 0 1.5 0v-6Zm-3 2.25a.75.75 0 0 0-1.5 0v3.75a.75.75 0 0 0 1.5 0V9Zm-3 2.25a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 0 1.5 0v-1.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function gk(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M2.25 2.25a.75.75 0 0 0 0 1.5H3v10.5a3 3 0 0 0 3 3h1.21l-1.172 3.513a.75.75 0 0 0 1.424.474l.329-.987h8.418l.33.987a.75.75 0 0 0 1.422-.474l-1.17-3.513H18a3 3 0 0 0 3-3V3.75h.75a.75.75 0 0 0 0-1.5H2.25Zm6.54 15h6.42l.5 1.5H8.29l.5-1.5Zm8.085-8.995a.75.75 0 1 0-.75-1.299 12.81 12.81 0 0 0-3.558 3.05L11.03 8.47a.75.75 0 0 0-1.06 0l-3 3a.75.75 0 1 0 1.06 1.06l2.47-2.47 1.617 1.618a.75.75 0 0 0 1.146-.102 11.312 11.312 0 0 1 3.612-3.321Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function fk(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M7.875 1.5C6.839 1.5 6 2.34 6 3.375v2.99c-.426.053-.851.11-1.274.174-1.454.218-2.476 1.483-2.476 2.917v6.294a3 3 0 0 0 3 3h.27l-.155 1.705A1.875 1.875 0 0 0 7.232 22.5h9.536a1.875 1.875 0 0 0 1.867-2.045l-.155-1.705h.27a3 3 0 0 0 3-3V9.456c0-1.434-1.022-2.7-2.476-2.917A48.716 48.716 0 0 0 18 6.366V3.375c0-1.036-.84-1.875-1.875-1.875h-8.25ZM16.5 6.205v-2.83A.375.375 0 0 0 16.125 3h-8.25a.375.375 0 0 0-.375.375v2.83a49.353 49.353 0 0 1 9 0Zm-.217 8.265c.178.018.317.16.333.337l.526 5.784a.375.375 0 0 1-.374.409H7.232a.375.375 0 0 1-.374-.409l.526-5.784a.373.373 0 0 1 .333-.337 41.741 41.741 0 0 1 8.566 0Zm.967-3.97a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75H18a.75.75 0 0 1-.75-.75V10.5ZM15 9.75a.75.75 0 0 0-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75V10.5a.75.75 0 0 0-.75-.75H15Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function hk(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M11.25 5.337c0-.355-.186-.676-.401-.959a1.647 1.647 0 0 1-.349-1.003c0-1.036 1.007-1.875 2.25-1.875S15 2.34 15 3.375c0 .369-.128.713-.349 1.003-.215.283-.401.604-.401.959 0 .332.278.598.61.578 1.91-.114 3.79-.342 5.632-.676a.75.75 0 0 1 .878.645 49.17 49.17 0 0 1 .376 5.452.657.657 0 0 1-.66.664c-.354 0-.675-.186-.958-.401a1.647 1.647 0 0 0-1.003-.349c-1.035 0-1.875 1.007-1.875 2.25s.84 2.25 1.875 2.25c.369 0 .713-.128 1.003-.349.283-.215.604-.401.959-.401.31 0 .557.262.534.571a48.774 48.774 0 0 1-.595 4.845.75.75 0 0 1-.61.61c-1.82.317-3.673.533-5.555.642a.58.58 0 0 1-.611-.581c0-.355.186-.676.401-.959.221-.29.349-.634.349-1.003 0-1.035-1.007-1.875-2.25-1.875s-2.25.84-2.25 1.875c0 .369.128.713.349 1.003.215.283.401.604.401.959a.641.641 0 0 1-.658.643 49.118 49.118 0 0 1-4.708-.36.75.75 0 0 1-.645-.878c.293-1.614.504-3.257.629-4.924A.53.53 0 0 0 5.337 15c-.355 0-.676.186-.959.401-.29.221-.634.349-1.003.349-1.036 0-1.875-1.007-1.875-2.25s.84-2.25 1.875-2.25c.369 0 .713.128 1.003.349.283.215.604.401.959.401a.656.656 0 0 0 .659-.663 47.703 47.703 0 0 0-.31-4.82.75.75 0 0 1 .83-.832c1.343.155 2.703.254 4.077.294a.64.64 0 0 0 .657-.642Z" })
  ]);
}
function vk(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M3 4.875C3 3.839 3.84 3 4.875 3h4.5c1.036 0 1.875.84 1.875 1.875v4.5c0 1.036-.84 1.875-1.875 1.875h-4.5A1.875 1.875 0 0 1 3 9.375v-4.5ZM4.875 4.5a.375.375 0 0 0-.375.375v4.5c0 .207.168.375.375.375h4.5a.375.375 0 0 0 .375-.375v-4.5a.375.375 0 0 0-.375-.375h-4.5Zm7.875.375c0-1.036.84-1.875 1.875-1.875h4.5C20.16 3 21 3.84 21 4.875v4.5c0 1.036-.84 1.875-1.875 1.875h-4.5a1.875 1.875 0 0 1-1.875-1.875v-4.5Zm1.875-.375a.375.375 0 0 0-.375.375v4.5c0 .207.168.375.375.375h4.5a.375.375 0 0 0 .375-.375v-4.5a.375.375 0 0 0-.375-.375h-4.5ZM6 6.75A.75.75 0 0 1 6.75 6h.75a.75.75 0 0 1 .75.75v.75a.75.75 0 0 1-.75.75h-.75A.75.75 0 0 1 6 7.5v-.75Zm9.75 0A.75.75 0 0 1 16.5 6h.75a.75.75 0 0 1 .75.75v.75a.75.75 0 0 1-.75.75h-.75a.75.75 0 0 1-.75-.75v-.75ZM3 14.625c0-1.036.84-1.875 1.875-1.875h4.5c1.036 0 1.875.84 1.875 1.875v4.5c0 1.035-.84 1.875-1.875 1.875h-4.5A1.875 1.875 0 0 1 3 19.125v-4.5Zm1.875-.375a.375.375 0 0 0-.375.375v4.5c0 .207.168.375.375.375h4.5a.375.375 0 0 0 .375-.375v-4.5a.375.375 0 0 0-.375-.375h-4.5Zm7.875-.75a.75.75 0 0 1 .75-.75h.75a.75.75 0 0 1 .75.75v.75a.75.75 0 0 1-.75.75h-.75a.75.75 0 0 1-.75-.75v-.75Zm6 0a.75.75 0 0 1 .75-.75h.75a.75.75 0 0 1 .75.75v.75a.75.75 0 0 1-.75.75h-.75a.75.75 0 0 1-.75-.75v-.75ZM6 16.5a.75.75 0 0 1 .75-.75h.75a.75.75 0 0 1 .75.75v.75a.75.75 0 0 1-.75.75h-.75a.75.75 0 0 1-.75-.75v-.75Zm9.75 0a.75.75 0 0 1 .75-.75h.75a.75.75 0 0 1 .75.75v.75a.75.75 0 0 1-.75.75h-.75a.75.75 0 0 1-.75-.75v-.75Zm-3 3a.75.75 0 0 1 .75-.75h.75a.75.75 0 0 1 .75.75v.75a.75.75 0 0 1-.75.75h-.75a.75.75 0 0 1-.75-.75v-.75Zm6 0a.75.75 0 0 1 .75-.75h.75a.75.75 0 0 1 .75.75v.75a.75.75 0 0 1-.75.75h-.75a.75.75 0 0 1-.75-.75v-.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Ek(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm11.378-3.917c-.89-.777-2.366-.777-3.255 0a.75.75 0 0 1-.988-1.129c1.454-1.272 3.776-1.272 5.23 0 1.513 1.324 1.513 3.518 0 4.842a3.75 3.75 0 0 1-.837.552c-.676.328-1.028.774-1.028 1.152v.75a.75.75 0 0 1-1.5 0v-.75c0-1.279 1.06-2.107 1.875-2.502.182-.088.351-.199.503-.331.83-.727.83-1.857 0-2.584ZM12 18a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function bk(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M5.625 3.75a2.625 2.625 0 1 0 0 5.25h12.75a2.625 2.625 0 0 0 0-5.25H5.625ZM3.75 11.25a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5H3.75ZM3 15.75a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75ZM3.75 18.75a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5H3.75Z" })
  ]);
}
function Sk(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M20.432 4.103a.75.75 0 0 0-.364-1.456L4.128 6.632l-.2.033C2.498 6.904 1.5 8.158 1.5 9.574v9.176a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3V9.574c0-1.416-.997-2.67-2.429-2.909a49.017 49.017 0 0 0-7.255-.658l7.616-1.904Zm-9.585 8.56a.75.75 0 0 1 0 1.06l-.005.006a.75.75 0 0 1-1.06 0l-.006-.006a.75.75 0 0 1 0-1.06l.005-.005a.75.75 0 0 1 1.06 0l.006.005ZM9.781 15.85a.75.75 0 0 0 1.061 0l.005-.005a.75.75 0 0 0 0-1.061l-.005-.005a.75.75 0 0 0-1.06 0l-.006.005a.75.75 0 0 0 0 1.06l.005.006Zm-1.055-1.066a.75.75 0 0 1 0 1.06l-.005.006a.75.75 0 0 1-1.061 0l-.005-.005a.75.75 0 0 1 0-1.06l.005-.006a.75.75 0 0 1 1.06 0l.006.005ZM7.66 13.73a.75.75 0 0 0 1.061 0l.005-.006a.75.75 0 0 0 0-1.06l-.005-.006a.75.75 0 0 0-1.06 0l-.006.006a.75.75 0 0 0 0 1.06l.005.006ZM9.255 9.75a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75h-.008a.75.75 0 0 1-.75-.75V10.5a.75.75 0 0 1 .75-.75h.008Zm3.624 3.28a.75.75 0 0 0 .275-1.025L13.15 12a.75.75 0 0 0-1.025-.275l-.006.004a.75.75 0 0 0-.275 1.024l.004.007a.75.75 0 0 0 1.025.274l.006-.003Zm-1.38 5.126a.75.75 0 0 1-1.024-.275l-.004-.006a.75.75 0 0 1 .275-1.025l.006-.004a.75.75 0 0 1 1.025.275l.004.007a.75.75 0 0 1-.275 1.024l-.006.004Zm.282-6.776a.75.75 0 0 0-.274-1.025l-.007-.003a.75.75 0 0 0-1.024.274l-.004.007a.75.75 0 0 0 .274 1.024l.007.004a.75.75 0 0 0 1.024-.275l.004-.006Zm1.369 5.129a.75.75 0 0 1-1.025.274l-.006-.004a.75.75 0 0 1-.275-1.024l.004-.007a.75.75 0 0 1 1.025-.274l.006.004a.75.75 0 0 1 .275 1.024l-.004.007Zm-.145-1.502a.75.75 0 0 0 .75-.75v-.007a.75.75 0 0 0-.75-.75h-.008a.75.75 0 0 0-.75.75v.007c0 .415.336.75.75.75h.008Zm-3.75 2.243a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75h-.008a.75.75 0 0 1-.75-.75V18a.75.75 0 0 1 .75-.75h.008Zm-2.871-.47a.75.75 0 0 0 .274-1.025l-.003-.006a.75.75 0 0 0-1.025-.275l-.006.004a.75.75 0 0 0-.275 1.024l.004.007a.75.75 0 0 0 1.024.274l.007-.003Zm1.366-5.12a.75.75 0 0 1-1.025-.274l-.004-.006a.75.75 0 0 1 .275-1.025l.006-.004a.75.75 0 0 1 1.025.275l.004.006a.75.75 0 0 1-.275 1.025l-.006.004Zm.281 6.215a.75.75 0 0 0-.275-1.024l-.006-.004a.75.75 0 0 0-1.025.274l-.003.007a.75.75 0 0 0 .274 1.024l.007.004a.75.75 0 0 0 1.024-.274l.004-.007Zm-1.376-5.116a.75.75 0 0 1-1.025.274l-.006-.003a.75.75 0 0 1-.275-1.025l.004-.007a.75.75 0 0 1 1.025-.274l.006.004a.75.75 0 0 1 .275 1.024l-.004.007Zm-1.15 2.248a.75.75 0 0 0 .75-.75v-.007a.75.75 0 0 0-.75-.75h-.008a.75.75 0 0 0-.75.75v.007c0 .415.336.75.75.75h.008ZM17.25 10.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm1.5 6a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function wk(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M12 1.5c-1.921 0-3.816.111-5.68.327-1.497.174-2.57 1.46-2.57 2.93V21.75a.75.75 0 0 0 1.029.696l3.471-1.388 3.472 1.388a.75.75 0 0 0 .556 0l3.472-1.388 3.471 1.388a.75.75 0 0 0 1.029-.696V4.757c0-1.47-1.073-2.756-2.57-2.93A49.255 49.255 0 0 0 12 1.5Zm3.53 7.28a.75.75 0 0 0-1.06-1.06l-6 6a.75.75 0 1 0 1.06 1.06l6-6ZM8.625 9a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Zm5.625 3.375a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function yk(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M12 1.5c-1.921 0-3.816.111-5.68.327-1.497.174-2.57 1.46-2.57 2.93V21.75a.75.75 0 0 0 1.029.696l3.471-1.388 3.472 1.388a.75.75 0 0 0 .556 0l3.472-1.388 3.471 1.388a.75.75 0 0 0 1.029-.696V4.757c0-1.47-1.073-2.756-2.57-2.93A49.255 49.255 0 0 0 12 1.5Zm-.97 6.53a.75.75 0 1 0-1.06-1.06L7.72 9.22a.75.75 0 0 0 0 1.06l2.25 2.25a.75.75 0 1 0 1.06-1.06l-.97-.97h3.065a1.875 1.875 0 0 1 0 3.75H12a.75.75 0 0 0 0 1.5h1.125a3.375 3.375 0 1 0 0-6.75h-3.064l.97-.97Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Tk(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M1.5 7.125c0-1.036.84-1.875 1.875-1.875h6c1.036 0 1.875.84 1.875 1.875v3.75c0 1.036-.84 1.875-1.875 1.875h-6A1.875 1.875 0 0 1 1.5 10.875v-3.75Zm12 1.5c0-1.036.84-1.875 1.875-1.875h5.25c1.035 0 1.875.84 1.875 1.875v8.25c0 1.035-.84 1.875-1.875 1.875h-5.25a1.875 1.875 0 0 1-1.875-1.875v-8.25ZM3 16.125c0-1.036.84-1.875 1.875-1.875h5.25c1.036 0 1.875.84 1.875 1.875v2.25c0 1.035-.84 1.875-1.875 1.875h-5.25A1.875 1.875 0 0 1 3 18.375v-2.25Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Ck(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M5.566 4.657A4.505 4.505 0 0 1 6.75 4.5h10.5c.41 0 .806.055 1.183.157A3 3 0 0 0 15.75 3h-7.5a3 3 0 0 0-2.684 1.657ZM2.25 12a3 3 0 0 1 3-3h13.5a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3v-6ZM5.25 7.5c-.41 0-.806.055-1.184.157A3 3 0 0 1 6.75 6h10.5a3 3 0 0 1 2.683 1.657A4.505 4.505 0 0 0 18.75 7.5H5.25Z" })
  ]);
}
function xk(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M9.315 7.584C12.195 3.883 16.695 1.5 21.75 1.5a.75.75 0 0 1 .75.75c0 5.056-2.383 9.555-6.084 12.436A6.75 6.75 0 0 1 9.75 22.5a.75.75 0 0 1-.75-.75v-4.131A15.838 15.838 0 0 1 6.382 15H2.25a.75.75 0 0 1-.75-.75 6.75 6.75 0 0 1 7.815-6.666ZM15 6.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5Z",
      "clip-rule": "evenodd"
    }),
    d("path", { d: "M5.26 17.242a.75.75 0 1 0-.897-1.203 5.243 5.243 0 0 0-2.05 5.022.75.75 0 0 0 .625.627 5.243 5.243 0 0 0 5.022-2.051.75.75 0 1 0-1.202-.897 3.744 3.744 0 0 1-3.008 1.51c0-1.23.592-2.323 1.51-3.008Z" })
  ]);
}
function Ak(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M3.75 4.5a.75.75 0 0 1 .75-.75h.75c8.284 0 15 6.716 15 15v.75a.75.75 0 0 1-.75.75h-.75a.75.75 0 0 1-.75-.75v-.75C18 11.708 12.292 6 5.25 6H4.5a.75.75 0 0 1-.75-.75V4.5Zm0 6.75a.75.75 0 0 1 .75-.75h.75a8.25 8.25 0 0 1 8.25 8.25v.75a.75.75 0 0 1-.75.75H12a.75.75 0 0 1-.75-.75v-.75a6 6 0 0 0-6-6H4.5a.75.75 0 0 1-.75-.75v-.75Zm0 7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Rk(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M12 2.25a.75.75 0 0 1 .75.75v.756a49.106 49.106 0 0 1 9.152 1 .75.75 0 0 1-.152 1.485h-1.918l2.474 10.124a.75.75 0 0 1-.375.84A6.723 6.723 0 0 1 18.75 18a6.723 6.723 0 0 1-3.181-.795.75.75 0 0 1-.375-.84l2.474-10.124H12.75v13.28c1.293.076 2.534.343 3.697.776a.75.75 0 0 1-.262 1.453h-8.37a.75.75 0 0 1-.262-1.453c1.162-.433 2.404-.7 3.697-.775V6.24H6.332l2.474 10.124a.75.75 0 0 1-.375.84A6.723 6.723 0 0 1 5.25 18a6.723 6.723 0 0 1-3.181-.795.75.75 0 0 1-.375-.84L4.168 6.241H2.25a.75.75 0 0 1-.152-1.485 49.105 49.105 0 0 1 9.152-1V3a.75.75 0 0 1 .75-.75Zm4.878 13.543 1.872-7.662 1.872 7.662h-3.744Zm-9.756 0L5.25 8.131l-1.872 7.662h3.744Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Ok(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M8.128 9.155a3.751 3.751 0 1 1 .713-1.321l1.136.656a.75.75 0 0 1 .222 1.104l-.006.007a.75.75 0 0 1-1.032.157 1.421 1.421 0 0 0-.113-.072l-.92-.531Zm-4.827-3.53a2.25 2.25 0 0 1 3.994 2.063.756.756 0 0 0-.122.23 2.25 2.25 0 0 1-3.872-2.293ZM13.348 8.272a5.073 5.073 0 0 0-3.428 3.57 5.08 5.08 0 0 0-.165 1.202 1.415 1.415 0 0 1-.707 1.201l-.96.554a3.751 3.751 0 1 0 .734 1.309l13.729-7.926a.75.75 0 0 0-.181-1.374l-.803-.215a5.25 5.25 0 0 0-2.894.05l-5.325 1.629Zm-9.223 7.03a2.25 2.25 0 1 0 2.25 3.897 2.25 2.25 0 0 0-2.25-3.897ZM12 12.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
      "clip-rule": "evenodd"
    }),
    d("path", { d: "M16.372 12.615a.75.75 0 0 1 .75 0l5.43 3.135a.75.75 0 0 1-.182 1.374l-.802.215a5.25 5.25 0 0 1-2.894-.051l-5.147-1.574a.75.75 0 0 1-.156-1.367l3-1.732Z" })
  ]);
}
function Ik(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M5.507 4.048A3 3 0 0 1 7.785 3h8.43a3 3 0 0 1 2.278 1.048l1.722 2.008A4.533 4.533 0 0 0 19.5 6h-15c-.243 0-.482.02-.715.056l1.722-2.008Z" }),
    d("path", {
      "fill-rule": "evenodd",
      d: "M1.5 10.5a3 3 0 0 1 3-3h15a3 3 0 1 1 0 6h-15a3 3 0 0 1-3-3Zm15 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm2.25.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM4.5 15a3 3 0 1 0 0 6h15a3 3 0 1 0 0-6h-15Zm11.25 3.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM19.5 18a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Nk(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M4.08 5.227A3 3 0 0 1 6.979 3H17.02a3 3 0 0 1 2.9 2.227l2.113 7.926A5.228 5.228 0 0 0 18.75 12H5.25a5.228 5.228 0 0 0-3.284 1.153L4.08 5.227Z" }),
    d("path", {
      "fill-rule": "evenodd",
      d: "M5.25 13.5a3.75 3.75 0 1 0 0 7.5h13.5a3.75 3.75 0 1 0 0-7.5H5.25Zm10.5 4.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm3.75-.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Mk(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M15.75 4.5a3 3 0 1 1 .825 2.066l-8.421 4.679a3.002 3.002 0 0 1 0 1.51l8.421 4.679a3 3 0 1 1-.729 1.31l-8.421-4.678a3 3 0 1 1 0-4.132l8.421-4.679a3 3 0 0 1-.096-.755Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Dk(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M12.516 2.17a.75.75 0 0 0-1.032 0 11.209 11.209 0 0 1-7.877 3.08.75.75 0 0 0-.722.515A12.74 12.74 0 0 0 2.25 9.75c0 5.942 4.064 10.933 9.563 12.348a.749.749 0 0 0 .374 0c5.499-1.415 9.563-6.406 9.563-12.348 0-1.39-.223-2.73-.635-3.985a.75.75 0 0 0-.722-.516l-.143.001c-2.996 0-5.717-1.17-7.734-3.08Zm3.094 8.016a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function kk(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M11.484 2.17a.75.75 0 0 1 1.032 0 11.209 11.209 0 0 0 7.877 3.08.75.75 0 0 1 .722.515 12.74 12.74 0 0 1 .635 3.985c0 5.942-4.064 10.933-9.563 12.348a.749.749 0 0 1-.374 0C6.314 20.683 2.25 15.692 2.25 9.75c0-1.39.223-2.73.635-3.985a.75.75 0 0 1 .722-.516l.143.001c2.996 0 5.718-1.17 7.734-3.08ZM12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75ZM12 15a.75.75 0 0 0-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75v-.008a.75.75 0 0 0-.75-.75H12Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Lk(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M7.5 6v.75H5.513c-.96 0-1.764.724-1.865 1.679l-1.263 12A1.875 1.875 0 0 0 4.25 22.5h15.5a1.875 1.875 0 0 0 1.865-2.071l-1.263-12a1.875 1.875 0 0 0-1.865-1.679H16.5V6a4.5 4.5 0 1 0-9 0ZM12 3a3 3 0 0 0-3 3v.75h6V6a3 3 0 0 0-3-3Zm-3 8.25a3 3 0 1 0 6 0v-.75a.75.75 0 0 1 1.5 0v.75a4.5 4.5 0 1 1-9 0v-.75a.75.75 0 0 1 1.5 0v.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Pk(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M2.25 2.25a.75.75 0 0 0 0 1.5h1.386c.17 0 .318.114.362.278l2.558 9.592a3.752 3.752 0 0 0-2.806 3.63c0 .414.336.75.75.75h15.75a.75.75 0 0 0 0-1.5H5.378A2.25 2.25 0 0 1 7.5 15h11.218a.75.75 0 0 0 .674-.421 60.358 60.358 0 0 0 2.96-7.228.75.75 0 0 0-.525-.965A60.864 60.864 0 0 0 5.68 4.509l-.232-.867A1.875 1.875 0 0 0 3.636 2.25H2.25ZM3.75 20.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM16.5 20.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z" })
  ]);
}
function Bk(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M2.47 2.47a.75.75 0 0 1 1.06 0l8.407 8.407a1.125 1.125 0 0 1 1.186 1.186l1.462 1.461a3.001 3.001 0 0 0-.464-3.645.75.75 0 1 1 1.061-1.061 4.501 4.501 0 0 1 .486 5.79l1.072 1.072a6.001 6.001 0 0 0-.497-7.923.75.75 0 0 1 1.06-1.06 7.501 7.501 0 0 1 .505 10.05l1.064 1.065a9 9 0 0 0-.508-12.176.75.75 0 0 1 1.06-1.06c3.923 3.922 4.093 10.175.512 14.3l1.594 1.594a.75.75 0 1 1-1.06 1.06l-2.106-2.105-2.121-2.122h-.001l-4.705-4.706a.747.747 0 0 1-.127-.126L2.47 3.53a.75.75 0 0 1 0-1.061Zm1.189 4.422a.75.75 0 0 1 .326 1.01 9.004 9.004 0 0 0 1.651 10.462.75.75 0 1 1-1.06 1.06C1.27 16.12.63 11.165 2.648 7.219a.75.75 0 0 1 1.01-.326ZM5.84 9.134a.75.75 0 0 1 .472.95 6 6 0 0 0 1.444 6.159.75.75 0 0 1-1.06 1.06A7.5 7.5 0 0 1 4.89 9.606a.75.75 0 0 1 .95-.472Zm2.341 2.653a.75.75 0 0 1 .848.638c.088.62.37 1.218.849 1.696a.75.75 0 0 1-1.061 1.061 4.483 4.483 0 0 1-1.273-2.546.75.75 0 0 1 .637-.848Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Fk(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M5.636 4.575a.75.75 0 0 1 0 1.061 9 9 0 0 0 0 12.728.75.75 0 1 1-1.06 1.06c-4.101-4.1-4.101-10.748 0-14.849a.75.75 0 0 1 1.06 0Zm12.728 0a.75.75 0 0 1 1.06 0c4.101 4.1 4.101 10.75 0 14.85a.75.75 0 1 1-1.06-1.061 9 9 0 0 0 0-12.728.75.75 0 0 1 0-1.06ZM7.757 6.697a.75.75 0 0 1 0 1.06 6 6 0 0 0 0 8.486.75.75 0 0 1-1.06 1.06 7.5 7.5 0 0 1 0-10.606.75.75 0 0 1 1.06 0Zm8.486 0a.75.75 0 0 1 1.06 0 7.5 7.5 0 0 1 0 10.606.75.75 0 0 1-1.06-1.06 6 6 0 0 0 0-8.486.75.75 0 0 1 0-1.06ZM9.879 8.818a.75.75 0 0 1 0 1.06 3 3 0 0 0 0 4.243.75.75 0 1 1-1.061 1.061 4.5 4.5 0 0 1 0-6.364.75.75 0 0 1 1.06 0Zm4.242 0a.75.75 0 0 1 1.061 0 4.5 4.5 0 0 1 0 6.364.75.75 0 0 1-1.06-1.06 3 3 0 0 0 0-4.243.75.75 0 0 1 0-1.061ZM10.875 12a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Uk(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M15.256 3.042a.75.75 0 0 1 .449.962l-6 16.5a.75.75 0 1 1-1.41-.513l6-16.5a.75.75 0 0 1 .961-.449Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function $k(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M9 4.5a.75.75 0 0 1 .721.544l.813 2.846a3.75 3.75 0 0 0 2.576 2.576l2.846.813a.75.75 0 0 1 0 1.442l-2.846.813a3.75 3.75 0 0 0-2.576 2.576l-.813 2.846a.75.75 0 0 1-1.442 0l-.813-2.846a3.75 3.75 0 0 0-2.576-2.576l-2.846-.813a.75.75 0 0 1 0-1.442l2.846-.813A3.75 3.75 0 0 0 7.466 7.89l.813-2.846A.75.75 0 0 1 9 4.5ZM18 1.5a.75.75 0 0 1 .728.568l.258 1.036c.236.94.97 1.674 1.91 1.91l1.036.258a.75.75 0 0 1 0 1.456l-1.036.258c-.94.236-1.674.97-1.91 1.91l-.258 1.036a.75.75 0 0 1-1.456 0l-.258-1.036a2.625 2.625 0 0 0-1.91-1.91l-1.036-.258a.75.75 0 0 1 0-1.456l1.036-.258a2.625 2.625 0 0 0 1.91-1.91l.258-1.036A.75.75 0 0 1 18 1.5ZM16.5 15a.75.75 0 0 1 .712.513l.394 1.183c.15.447.5.799.948.948l1.183.395a.75.75 0 0 1 0 1.422l-1.183.395c-.447.15-.799.5-.948.948l-.395 1.183a.75.75 0 0 1-1.422 0l-.395-1.183a1.5 1.5 0 0 0-.948-.948l-1.183-.395a.75.75 0 0 1 0-1.422l1.183-.395c.447-.15.799-.5.948-.948l.395-1.183A.75.75 0 0 1 16.5 15Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Vk(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M13.5 4.06c0-1.336-1.616-2.005-2.56-1.06l-4.5 4.5H4.508c-1.141 0-2.318.664-2.66 1.905A9.76 9.76 0 0 0 1.5 12c0 .898.121 1.768.35 2.595.341 1.24 1.518 1.905 2.659 1.905h1.93l4.5 4.5c.945.945 2.561.276 2.561-1.06V4.06ZM18.584 5.106a.75.75 0 0 1 1.06 0c3.808 3.807 3.808 9.98 0 13.788a.75.75 0 0 1-1.06-1.06 8.25 8.25 0 0 0 0-11.668.75.75 0 0 1 0-1.06Z" }),
    d("path", { d: "M15.932 7.757a.75.75 0 0 1 1.061 0 6 6 0 0 1 0 8.486.75.75 0 0 1-1.06-1.061 4.5 4.5 0 0 0 0-6.364.75.75 0 0 1 0-1.06Z" })
  ]);
}
function Hk(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M13.5 4.06c0-1.336-1.616-2.005-2.56-1.06l-4.5 4.5H4.508c-1.141 0-2.318.664-2.66 1.905A9.76 9.76 0 0 0 1.5 12c0 .898.121 1.768.35 2.595.341 1.24 1.518 1.905 2.659 1.905h1.93l4.5 4.5c.945.945 2.561.276 2.561-1.06V4.06ZM17.78 9.22a.75.75 0 1 0-1.06 1.06L18.44 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06l1.72-1.72 1.72 1.72a.75.75 0 1 0 1.06-1.06L20.56 12l1.72-1.72a.75.75 0 1 0-1.06-1.06l-1.72 1.72-1.72-1.72Z" })
  ]);
}
function Gk(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M16.5 6a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3v7.5a3 3 0 0 0 3 3v-6A4.5 4.5 0 0 1 10.5 6h6Z" }),
    d("path", { d: "M18 7.5a3 3 0 0 1 3 3V18a3 3 0 0 1-3 3h-7.5a3 3 0 0 1-3-3v-7.5a3 3 0 0 1 3-3H18Z" })
  ]);
}
function Yk(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M11.644 1.59a.75.75 0 0 1 .712 0l9.75 5.25a.75.75 0 0 1 0 1.32l-9.75 5.25a.75.75 0 0 1-.712 0l-9.75-5.25a.75.75 0 0 1 0-1.32l9.75-5.25Z" }),
    d("path", { d: "m3.265 10.602 7.668 4.129a2.25 2.25 0 0 0 2.134 0l7.668-4.13 1.37.739a.75.75 0 0 1 0 1.32l-9.75 5.25a.75.75 0 0 1-.71 0l-9.75-5.25a.75.75 0 0 1 0-1.32l1.37-.738Z" }),
    d("path", { d: "m10.933 19.231-7.668-4.13-1.37.739a.75.75 0 0 0 0 1.32l9.75 5.25c.221.12.489.12.71 0l9.75-5.25a.75.75 0 0 0 0-1.32l-1.37-.738-7.668 4.13a2.25 2.25 0 0 1-2.134-.001Z" })
  ]);
}
function zk(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M3 6a3 3 0 0 1 3-3h2.25a3 3 0 0 1 3 3v2.25a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm9.75 0a3 3 0 0 1 3-3H18a3 3 0 0 1 3 3v2.25a3 3 0 0 1-3 3h-2.25a3 3 0 0 1-3-3V6ZM3 15.75a3 3 0 0 1 3-3h2.25a3 3 0 0 1 3 3V18a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-2.25Zm9.75 0a3 3 0 0 1 3-3H18a3 3 0 0 1 3 3V18a3 3 0 0 1-3 3h-2.25a3 3 0 0 1-3-3v-2.25Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Zk(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M6 3a3 3 0 0 0-3 3v2.25a3 3 0 0 0 3 3h2.25a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6ZM15.75 3a3 3 0 0 0-3 3v2.25a3 3 0 0 0 3 3H18a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3h-2.25ZM6 12.75a3 3 0 0 0-3 3V18a3 3 0 0 0 3 3h2.25a3 3 0 0 0 3-3v-2.25a3 3 0 0 0-3-3H6ZM17.625 13.5a.75.75 0 0 0-1.5 0v2.625H13.5a.75.75 0 0 0 0 1.5h2.625v2.625a.75.75 0 0 0 1.5 0v-2.625h2.625a.75.75 0 0 0 0-1.5h-2.625V13.5Z" })
  ]);
}
function qk(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Wk(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm6-2.438c0-.724.588-1.312 1.313-1.312h4.874c.725 0 1.313.588 1.313 1.313v4.874c0 .725-.588 1.313-1.313 1.313H9.564a1.312 1.312 0 0 1-1.313-1.313V9.564Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function jk(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M4.5 7.5a3 3 0 0 1 3-3h9a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3h-9a3 3 0 0 1-3-3v-9Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Kk(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M9.657 4.728c-1.086.385-1.766 1.057-1.979 1.85-.214.8.046 1.733.81 2.616.746.862 1.93 1.612 3.388 2.003.07.019.14.037.21.053h8.163a.75.75 0 0 1 0 1.5h-8.24a.66.66 0 0 1-.02 0H3.75a.75.75 0 0 1 0-1.5h4.78a7.108 7.108 0 0 1-1.175-1.074C6.372 9.042 5.849 7.61 6.229 6.19c.377-1.408 1.528-2.38 2.927-2.876 1.402-.497 3.127-.55 4.855-.086A8.937 8.937 0 0 1 16.94 4.6a.75.75 0 0 1-.881 1.215 7.437 7.437 0 0 0-2.436-1.14c-1.473-.394-2.885-.331-3.966.052Zm6.533 9.632a.75.75 0 0 1 1.03.25c.592.974.846 2.094.55 3.2-.378 1.408-1.529 2.38-2.927 2.876-1.402.497-3.127.55-4.855.087-1.712-.46-3.168-1.354-4.134-2.47a.75.75 0 0 1 1.134-.982c.746.862 1.93 1.612 3.388 2.003 1.473.394 2.884.331 3.966-.052 1.085-.384 1.766-1.056 1.978-1.85.169-.628.046-1.33-.381-2.032a.75.75 0 0 1 .25-1.03Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Qk(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M12 2.25a.75.75 0 0 1 .75.75v2.25a.75.75 0 0 1-1.5 0V3a.75.75 0 0 1 .75-.75ZM7.5 12a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0ZM18.894 6.166a.75.75 0 0 0-1.06-1.06l-1.591 1.59a.75.75 0 1 0 1.06 1.061l1.591-1.59ZM21.75 12a.75.75 0 0 1-.75.75h-2.25a.75.75 0 0 1 0-1.5H21a.75.75 0 0 1 .75.75ZM17.834 18.894a.75.75 0 0 0 1.06-1.06l-1.59-1.591a.75.75 0 1 0-1.061 1.06l1.59 1.591ZM12 18a.75.75 0 0 1 .75.75V21a.75.75 0 0 1-1.5 0v-2.25A.75.75 0 0 1 12 18ZM7.758 17.303a.75.75 0 0 0-1.061-1.06l-1.591 1.59a.75.75 0 0 0 1.06 1.061l1.591-1.59ZM6 12a.75.75 0 0 1-.75.75H3a.75.75 0 0 1 0-1.5h2.25A.75.75 0 0 1 6 12ZM6.697 7.757a.75.75 0 0 0 1.06-1.06l-1.59-1.591a.75.75 0 0 0-1.061 1.06l1.59 1.591Z" })
  ]);
}
function Xk(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M2.25 4.125c0-1.036.84-1.875 1.875-1.875h5.25c1.036 0 1.875.84 1.875 1.875V17.25a4.5 4.5 0 1 1-9 0V4.125Zm4.5 14.25a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25Z",
      "clip-rule": "evenodd"
    }),
    d("path", { d: "M10.719 21.75h9.156c1.036 0 1.875-.84 1.875-1.875v-5.25c0-1.036-.84-1.875-1.875-1.875h-.14l-8.742 8.743c-.09.089-.18.175-.274.257ZM12.738 17.625l6.474-6.474a1.875 1.875 0 0 0 0-2.651L15.5 4.787a1.875 1.875 0 0 0-2.651 0l-.1.099V17.25c0 .126-.003.251-.01.375Z" })
  ]);
}
function Jk(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M1.5 5.625c0-1.036.84-1.875 1.875-1.875h17.25c1.035 0 1.875.84 1.875 1.875v12.75c0 1.035-.84 1.875-1.875 1.875H3.375A1.875 1.875 0 0 1 1.5 18.375V5.625ZM21 9.375A.375.375 0 0 0 20.625 9h-7.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h7.5a.375.375 0 0 0 .375-.375v-1.5Zm0 3.75a.375.375 0 0 0-.375-.375h-7.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h7.5a.375.375 0 0 0 .375-.375v-1.5Zm0 3.75a.375.375 0 0 0-.375-.375h-7.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h7.5a.375.375 0 0 0 .375-.375v-1.5ZM10.875 18.75a.375.375 0 0 0 .375-.375v-1.5a.375.375 0 0 0-.375-.375h-7.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h7.5ZM3.375 15h7.5a.375.375 0 0 0 .375-.375v-1.5a.375.375 0 0 0-.375-.375h-7.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375Zm0-3.75h7.5a.375.375 0 0 0 .375-.375v-1.5A.375.375 0 0 0 10.875 9h-7.5A.375.375 0 0 0 3 9.375v1.5c0 .207.168.375.375.375Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function eL(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M5.25 2.25a3 3 0 0 0-3 3v4.318a3 3 0 0 0 .879 2.121l9.58 9.581c.92.92 2.39 1.186 3.548.428a18.849 18.849 0 0 0 5.441-5.44c.758-1.16.492-2.629-.428-3.548l-9.58-9.581a3 3 0 0 0-2.122-.879H5.25ZM6.375 7.5a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function tL(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M1.5 6.375c0-1.036.84-1.875 1.875-1.875h17.25c1.035 0 1.875.84 1.875 1.875v3.026a.75.75 0 0 1-.375.65 2.249 2.249 0 0 0 0 3.898.75.75 0 0 1 .375.65v3.026c0 1.035-.84 1.875-1.875 1.875H3.375A1.875 1.875 0 0 1 1.5 17.625v-3.026a.75.75 0 0 1 .374-.65 2.249 2.249 0 0 0 0-3.898.75.75 0 0 1-.374-.65V6.375Zm15-1.125a.75.75 0 0 1 .75.75v.75a.75.75 0 0 1-1.5 0V6a.75.75 0 0 1 .75-.75Zm.75 4.5a.75.75 0 0 0-1.5 0v.75a.75.75 0 0 0 1.5 0v-.75Zm-.75 3a.75.75 0 0 1 .75.75v.75a.75.75 0 0 1-1.5 0v-.75a.75.75 0 0 1 .75-.75Zm.75 4.5a.75.75 0 0 0-1.5 0V18a.75.75 0 0 0 1.5 0v-.75ZM6 12a.75.75 0 0 1 .75-.75H12a.75.75 0 0 1 0 1.5H6.75A.75.75 0 0 1 6 12Zm.75 2.25a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5h-3Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function nL(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M16.5 4.478v.227a48.816 48.816 0 0 1 3.878.512.75.75 0 1 1-.256 1.478l-.209-.035-1.005 13.07a3 3 0 0 1-2.991 2.77H8.084a3 3 0 0 1-2.991-2.77L4.087 6.66l-.209.035a.75.75 0 0 1-.256-1.478A48.567 48.567 0 0 1 7.5 4.705v-.227c0-1.564 1.213-2.9 2.816-2.951a52.662 52.662 0 0 1 3.369 0c1.603.051 2.815 1.387 2.815 2.951Zm-6.136-1.452a51.196 51.196 0 0 1 3.273 0C14.39 3.05 15 3.684 15 4.478v.113a49.488 49.488 0 0 0-6 0v-.113c0-.794.609-1.428 1.364-1.452Zm-.355 5.945a.75.75 0 1 0-1.5.058l.347 9a.75.75 0 1 0 1.499-.058l-.346-9Zm5.48.058a.75.75 0 1 0-1.498-.058l-.347 9a.75.75 0 0 0 1.5.058l.345-9Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function rL(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M5.166 2.621v.858c-1.035.148-2.059.33-3.071.543a.75.75 0 0 0-.584.859 6.753 6.753 0 0 0 6.138 5.6 6.73 6.73 0 0 0 2.743 1.346A6.707 6.707 0 0 1 9.279 15H8.54c-1.036 0-1.875.84-1.875 1.875V19.5h-.75a2.25 2.25 0 0 0-2.25 2.25c0 .414.336.75.75.75h15a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-2.25-2.25h-.75v-2.625c0-1.036-.84-1.875-1.875-1.875h-.739a6.706 6.706 0 0 1-1.112-3.173 6.73 6.73 0 0 0 2.743-1.347 6.753 6.753 0 0 0 6.139-5.6.75.75 0 0 0-.585-.858 47.077 47.077 0 0 0-3.07-.543V2.62a.75.75 0 0 0-.658-.744 49.22 49.22 0 0 0-6.093-.377c-2.063 0-4.096.128-6.093.377a.75.75 0 0 0-.657.744Zm0 2.629c0 1.196.312 2.32.857 3.294A5.266 5.266 0 0 1 3.16 5.337a45.6 45.6 0 0 1 2.006-.343v.256Zm13.5 0v-.256c.674.1 1.343.214 2.006.343a5.265 5.265 0 0 1-2.863 3.207 6.72 6.72 0 0 0 .857-3.294Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function aL(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M3.375 4.5C2.339 4.5 1.5 5.34 1.5 6.375V13.5h12V6.375c0-1.036-.84-1.875-1.875-1.875h-8.25ZM13.5 15h-12v2.625c0 1.035.84 1.875 1.875 1.875h.375a3 3 0 1 1 6 0h3a.75.75 0 0 0 .75-.75V15Z" }),
    d("path", { d: "M8.25 19.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0ZM15.75 6.75a.75.75 0 0 0-.75.75v11.25c0 .087.015.17.042.248a3 3 0 0 1 5.958.464c.853-.175 1.522-.935 1.464-1.883a18.659 18.659 0 0 0-3.732-10.104 1.837 1.837 0 0 0-1.47-.725H15.75Z" }),
    d("path", { d: "M19.5 19.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z" })
  ]);
}
function oL(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M19.5 6h-15v9h15V6Z" }),
    d("path", {
      "fill-rule": "evenodd",
      d: "M3.375 3C2.339 3 1.5 3.84 1.5 4.875v11.25C1.5 17.16 2.34 18 3.375 18H9.75v1.5H6A.75.75 0 0 0 6 21h12a.75.75 0 0 0 0-1.5h-3.75V18h6.375c1.035 0 1.875-.84 1.875-1.875V4.875C22.5 3.839 21.66 3 20.625 3H3.375Zm0 13.5h17.25a.375.375 0 0 0 .375-.375V4.875a.375.375 0 0 0-.375-.375H3.375A.375.375 0 0 0 3 4.875v11.25c0 .207.168.375.375.375Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function iL(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M5.995 2.994a.75.75 0 0 1 .75.75v7.5a5.25 5.25 0 1 0 10.5 0v-7.5a.75.75 0 0 1 1.5 0v7.5a6.75 6.75 0 1 1-13.5 0v-7.5a.75.75 0 0 1 .75-.75Zm-3 17.252a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5h-16.5a.75.75 0 0 1-.75-.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function sL(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M18.685 19.097A9.723 9.723 0 0 0 21.75 12c0-5.385-4.365-9.75-9.75-9.75S2.25 6.615 2.25 12a9.723 9.723 0 0 0 3.065 7.097A9.716 9.716 0 0 0 12 21.75a9.716 9.716 0 0 0 6.685-2.653Zm-12.54-1.285A7.486 7.486 0 0 1 12 15a7.486 7.486 0 0 1 5.855 2.812A8.224 8.224 0 0 1 12 20.25a8.224 8.224 0 0 1-5.855-2.438ZM15.75 9a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function lL(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M8.25 6.75a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0ZM15.75 9.75a3 3 0 1 1 6 0 3 3 0 0 1-6 0ZM2.25 9.75a3 3 0 1 1 6 0 3 3 0 0 1-6 0ZM6.31 15.117A6.745 6.745 0 0 1 12 12a6.745 6.745 0 0 1 6.709 7.498.75.75 0 0 1-.372.568A12.696 12.696 0 0 1 12 21.75c-2.305 0-4.47-.612-6.337-1.684a.75.75 0 0 1-.372-.568 6.787 6.787 0 0 1 1.019-4.38Z",
      "clip-rule": "evenodd"
    }),
    d("path", { d: "M5.082 14.254a8.287 8.287 0 0 0-1.308 5.135 9.687 9.687 0 0 1-1.764-.44l-.115-.04a.563.563 0 0 1-.373-.487l-.01-.121a3.75 3.75 0 0 1 3.57-4.047ZM20.226 19.389a8.287 8.287 0 0 0-1.308-5.135 3.75 3.75 0 0 1 3.57 4.047l-.01.121a.563.563 0 0 1-.373.486l-.115.04c-.567.2-1.156.349-1.764.441Z" })
  ]);
}
function cL(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M10.375 2.25a4.125 4.125 0 1 0 0 8.25 4.125 4.125 0 0 0 0-8.25ZM10.375 12a7.125 7.125 0 0 0-7.124 7.247.75.75 0 0 0 .363.63 13.067 13.067 0 0 0 6.761 1.873c2.472 0 4.786-.684 6.76-1.873a.75.75 0 0 0 .364-.63l.001-.12v-.002A7.125 7.125 0 0 0 10.375 12ZM16 9.75a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5h-6Z" })
  ]);
}
function uL(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M5.25 6.375a4.125 4.125 0 1 1 8.25 0 4.125 4.125 0 0 1-8.25 0ZM2.25 19.125a7.125 7.125 0 0 1 14.25 0v.003l-.001.119a.75.75 0 0 1-.363.63 13.067 13.067 0 0 1-6.761 1.873c-2.472 0-4.786-.684-6.76-1.873a.75.75 0 0 1-.364-.63l-.001-.122ZM18.75 7.5a.75.75 0 0 0-1.5 0v2.25H15a.75.75 0 0 0 0 1.5h2.25v2.25a.75.75 0 0 0 1.5 0v-2.25H21a.75.75 0 0 0 0-1.5h-2.25V7.5Z" })
  ]);
}
function dL(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M7.5 6a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0ZM3.751 20.105a8.25 8.25 0 0 1 16.498 0 .75.75 0 0 1-.437.695A18.683 18.683 0 0 1 12 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 0 1-.437-.695Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function _L(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M4.5 6.375a4.125 4.125 0 1 1 8.25 0 4.125 4.125 0 0 1-8.25 0ZM14.25 8.625a3.375 3.375 0 1 1 6.75 0 3.375 3.375 0 0 1-6.75 0ZM1.5 19.125a7.125 7.125 0 0 1 14.25 0v.003l-.001.119a.75.75 0 0 1-.363.63 13.067 13.067 0 0 1-6.761 1.873c-2.472 0-4.786-.684-6.76-1.873a.75.75 0 0 1-.364-.63l-.001-.122ZM17.25 19.128l-.001.144a2.25 2.25 0 0 1-.233.96 10.088 10.088 0 0 0 5.06-1.01.75.75 0 0 0 .42-.643 4.875 4.875 0 0 0-6.957-4.611 8.586 8.586 0 0 1 1.71 5.157v.003Z" })
  ]);
}
function pL(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M19.253 2.292a.75.75 0 0 1 .955.461A28.123 28.123 0 0 1 21.75 12c0 3.266-.547 6.388-1.542 9.247a.75.75 0 1 1-1.416-.494c.94-2.7 1.458-5.654 1.458-8.753s-.519-6.054-1.458-8.754a.75.75 0 0 1 .461-.954Zm-14.227.013a.75.75 0 0 1 .414.976A23.183 23.183 0 0 0 3.75 12c0 3.085.6 6.027 1.69 8.718a.75.75 0 0 1-1.39.563c-1.161-2.867-1.8-6-1.8-9.281 0-3.28.639-6.414 1.8-9.281a.75.75 0 0 1 .976-.414Zm4.275 5.052a1.5 1.5 0 0 1 2.21.803l.716 2.148L13.6 8.246a2.438 2.438 0 0 1 2.978-.892l.213.09a.75.75 0 1 1-.584 1.381l-.214-.09a.937.937 0 0 0-1.145.343l-2.021 3.033 1.084 3.255 1.445-.89a.75.75 0 1 1 .786 1.278l-1.444.889a1.5 1.5 0 0 1-2.21-.803l-.716-2.148-1.374 2.062a2.437 2.437 0 0 1-2.978.892l-.213-.09a.75.75 0 0 1 .584-1.381l.214.09a.938.938 0 0 0 1.145-.344l2.021-3.032-1.084-3.255-1.445.89a.75.75 0 1 1-.786-1.278l1.444-.89Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function mL(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M.97 3.97a.75.75 0 0 1 1.06 0l15 15a.75.75 0 1 1-1.06 1.06l-15-15a.75.75 0 0 1 0-1.06ZM17.25 16.06l2.69 2.69c.944.945 2.56.276 2.56-1.06V6.31c0-1.336-1.616-2.005-2.56-1.06l-2.69 2.69v8.12ZM15.75 7.5v8.068L4.682 4.5h8.068a3 3 0 0 1 3 3ZM1.5 16.5V7.682l11.773 11.773c-.17.03-.345.045-.523.045H4.5a3 3 0 0 1-3-3Z" })
  ]);
}
function gL(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M4.5 4.5a3 3 0 0 0-3 3v9a3 3 0 0 0 3 3h8.25a3 3 0 0 0 3-3v-9a3 3 0 0 0-3-3H4.5ZM19.94 18.75l-2.69-2.69V7.94l2.69-2.69c.944-.945 2.56-.276 2.56 1.06v11.38c0 1.336-1.616 2.005-2.56 1.06Z" })
  ]);
}
function fL(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M15 3.75H9v16.5h6V3.75ZM16.5 20.25h3.375c1.035 0 1.875-.84 1.875-1.875V5.625c0-1.036-.84-1.875-1.875-1.875H16.5v16.5ZM4.125 3.75H7.5v16.5H4.125a1.875 1.875 0 0 1-1.875-1.875V5.625c0-1.036.84-1.875 1.875-1.875Z" })
  ]);
}
function hL(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M6 3a3 3 0 0 0-3 3v1.5a.75.75 0 0 0 1.5 0V6A1.5 1.5 0 0 1 6 4.5h1.5a.75.75 0 0 0 0-1.5H6ZM16.5 3a.75.75 0 0 0 0 1.5H18A1.5 1.5 0 0 1 19.5 6v1.5a.75.75 0 0 0 1.5 0V6a3 3 0 0 0-3-3h-1.5ZM12 8.25a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5ZM4.5 16.5a.75.75 0 0 0-1.5 0V18a3 3 0 0 0 3 3h1.5a.75.75 0 0 0 0-1.5H6A1.5 1.5 0 0 1 4.5 18v-1.5ZM21 16.5a.75.75 0 0 0-1.5 0V18a1.5 1.5 0 0 1-1.5 1.5h-1.5a.75.75 0 0 0 0 1.5H18a3 3 0 0 0 3-3v-1.5Z" })
  ]);
}
function vL(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", { d: "M2.273 5.625A4.483 4.483 0 0 1 5.25 4.5h13.5c1.141 0 2.183.425 2.977 1.125A3 3 0 0 0 18.75 3H5.25a3 3 0 0 0-2.977 2.625ZM2.273 8.625A4.483 4.483 0 0 1 5.25 7.5h13.5c1.141 0 2.183.425 2.977 1.125A3 3 0 0 0 18.75 6H5.25a3 3 0 0 0-2.977 2.625ZM5.25 9a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h13.5a3 3 0 0 0 3-3v-6a3 3 0 0 0-3-3H15a.75.75 0 0 0-.75.75 2.25 2.25 0 0 1-4.5 0A.75.75 0 0 0 9 9H5.25Z" })
  ]);
}
function EL(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M1.371 8.143c5.858-5.857 15.356-5.857 21.213 0a.75.75 0 0 1 0 1.061l-.53.53a.75.75 0 0 1-1.06 0c-4.98-4.979-13.053-4.979-18.032 0a.75.75 0 0 1-1.06 0l-.53-.53a.75.75 0 0 1 0-1.06Zm3.182 3.182c4.1-4.1 10.749-4.1 14.85 0a.75.75 0 0 1 0 1.061l-.53.53a.75.75 0 0 1-1.062 0 8.25 8.25 0 0 0-11.667 0 .75.75 0 0 1-1.06 0l-.53-.53a.75.75 0 0 1 0-1.06Zm3.204 3.182a6 6 0 0 1 8.486 0 .75.75 0 0 1 0 1.061l-.53.53a.75.75 0 0 1-1.061 0 3.75 3.75 0 0 0-5.304 0 .75.75 0 0 1-1.06 0l-.53-.53a.75.75 0 0 1 0-1.06Zm3.182 3.182a1.5 1.5 0 0 1 2.122 0 .75.75 0 0 1 0 1.061l-.53.53a.75.75 0 0 1-1.061 0l-.53-.53a.75.75 0 0 1 0-1.06Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function bL(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M2.25 6a3 3 0 0 1 3-3h13.5a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3V6Zm18 3H3.75v9a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5V9Zm-15-3.75A.75.75 0 0 0 4.5 6v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75V6a.75.75 0 0 0-.75-.75H5.25Zm1.5.75a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75H7.5a.75.75 0 0 1-.75-.75V6Zm3-.75A.75.75 0 0 0 9 6v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75V6a.75.75 0 0 0-.75-.75H9.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function SL(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M12 6.75a5.25 5.25 0 0 1 6.775-5.025.75.75 0 0 1 .313 1.248l-3.32 3.319c.063.475.276.934.641 1.299.365.365.824.578 1.3.64l3.318-3.319a.75.75 0 0 1 1.248.313 5.25 5.25 0 0 1-5.472 6.756c-1.018-.086-1.87.1-2.309.634L7.344 21.3A3.298 3.298 0 1 1 2.7 16.657l8.684-7.151c.533-.44.72-1.291.634-2.309A5.342 5.342 0 0 1 12 6.75ZM4.117 19.125a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75h-.008a.75.75 0 0 1-.75-.75v-.008Z",
      "clip-rule": "evenodd"
    }),
    d("path", { d: "m10.076 8.64-2.201-2.2V4.874a.75.75 0 0 0-.364-.643l-3.75-2.25a.75.75 0 0 0-.916.113l-.75.75a.75.75 0 0 0-.113.916l2.25 3.75a.75.75 0 0 0 .643.364h1.564l2.062 2.062 1.575-1.297Z" }),
    d("path", {
      "fill-rule": "evenodd",
      d: "m12.556 17.329 4.183 4.182a3.375 3.375 0 0 0 4.773-4.773l-3.306-3.305a6.803 6.803 0 0 1-1.53.043c-.394-.034-.682-.006-.867.042a.589.589 0 0 0-.167.063l-3.086 3.748Zm3.414-1.36a.75.75 0 0 1 1.06 0l1.875 1.876a.75.75 0 1 1-1.06 1.06L15.97 17.03a.75.75 0 0 1 0-1.06Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function wL(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M12 6.75a5.25 5.25 0 0 1 6.775-5.025.75.75 0 0 1 .313 1.248l-3.32 3.319c.063.475.276.934.641 1.299.365.365.824.578 1.3.64l3.318-3.319a.75.75 0 0 1 1.248.313 5.25 5.25 0 0 1-5.472 6.756c-1.018-.086-1.87.1-2.309.634L7.344 21.3A3.298 3.298 0 1 1 2.7 16.657l8.684-7.151c.533-.44.72-1.291.634-2.309A5.342 5.342 0 0 1 12 6.75ZM4.117 19.125a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75h-.008a.75.75 0 0 1-.75-.75v-.008Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function yL(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function TL(t, n) {
  return c(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    d("path", {
      "fill-rule": "evenodd",
      d: "M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z",
      "clip-rule": "evenodd"
    })
  ]);
}
const CL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AcademicCapIcon: CI,
  AdjustmentsHorizontalIcon: xI,
  AdjustmentsVerticalIcon: AI,
  ArchiveBoxArrowDownIcon: RI,
  ArchiveBoxIcon: II,
  ArchiveBoxXMarkIcon: OI,
  ArrowDownCircleIcon: NI,
  ArrowDownIcon: BI,
  ArrowDownLeftIcon: MI,
  ArrowDownOnSquareIcon: kI,
  ArrowDownOnSquareStackIcon: DI,
  ArrowDownRightIcon: LI,
  ArrowDownTrayIcon: PI,
  ArrowLeftCircleIcon: FI,
  ArrowLeftEndOnRectangleIcon: UI,
  ArrowLeftIcon: HI,
  ArrowLeftOnRectangleIcon: $I,
  ArrowLeftStartOnRectangleIcon: VI,
  ArrowLongDownIcon: GI,
  ArrowLongLeftIcon: YI,
  ArrowLongRightIcon: zI,
  ArrowLongUpIcon: ZI,
  ArrowPathIcon: WI,
  ArrowPathRoundedSquareIcon: qI,
  ArrowRightCircleIcon: jI,
  ArrowRightEndOnRectangleIcon: KI,
  ArrowRightIcon: JI,
  ArrowRightOnRectangleIcon: QI,
  ArrowRightStartOnRectangleIcon: XI,
  ArrowSmallDownIcon: eN,
  ArrowSmallLeftIcon: tN,
  ArrowSmallRightIcon: nN,
  ArrowSmallUpIcon: rN,
  ArrowTopRightOnSquareIcon: aN,
  ArrowTrendingDownIcon: oN,
  ArrowTrendingUpIcon: iN,
  ArrowTurnDownLeftIcon: sN,
  ArrowTurnDownRightIcon: lN,
  ArrowTurnLeftDownIcon: cN,
  ArrowTurnLeftUpIcon: uN,
  ArrowTurnRightDownIcon: dN,
  ArrowTurnRightUpIcon: _N,
  ArrowTurnUpLeftIcon: pN,
  ArrowTurnUpRightIcon: mN,
  ArrowUpCircleIcon: gN,
  ArrowUpIcon: SN,
  ArrowUpLeftIcon: fN,
  ArrowUpOnSquareIcon: vN,
  ArrowUpOnSquareStackIcon: hN,
  ArrowUpRightIcon: EN,
  ArrowUpTrayIcon: bN,
  ArrowUturnDownIcon: wN,
  ArrowUturnLeftIcon: yN,
  ArrowUturnRightIcon: TN,
  ArrowUturnUpIcon: CN,
  ArrowsPointingInIcon: xN,
  ArrowsPointingOutIcon: AN,
  ArrowsRightLeftIcon: RN,
  ArrowsUpDownIcon: ON,
  AtSymbolIcon: IN,
  BackspaceIcon: NN,
  BackwardIcon: MN,
  BanknotesIcon: DN,
  Bars2Icon: kN,
  Bars3BottomLeftIcon: LN,
  Bars3BottomRightIcon: PN,
  Bars3CenterLeftIcon: BN,
  Bars3Icon: FN,
  Bars4Icon: UN,
  BarsArrowDownIcon: $N,
  BarsArrowUpIcon: VN,
  Battery0Icon: HN,
  Battery100Icon: GN,
  Battery50Icon: YN,
  BeakerIcon: zN,
  BellAlertIcon: ZN,
  BellIcon: jN,
  BellSlashIcon: qN,
  BellSnoozeIcon: WN,
  BoldIcon: KN,
  BoltIcon: XN,
  BoltSlashIcon: QN,
  BookOpenIcon: JN,
  BookmarkIcon: n9,
  BookmarkSlashIcon: e9,
  BookmarkSquareIcon: t9,
  BriefcaseIcon: r9,
  BugAntIcon: a9,
  BuildingLibraryIcon: o9,
  BuildingOffice2Icon: i9,
  BuildingOfficeIcon: s9,
  BuildingStorefrontIcon: l9,
  CakeIcon: c9,
  CalculatorIcon: u9,
  CalendarDateRangeIcon: d9,
  CalendarDaysIcon: _9,
  CalendarIcon: p9,
  CameraIcon: m9,
  ChartBarIcon: f9,
  ChartBarSquareIcon: g9,
  ChartPieIcon: h9,
  ChatBubbleBottomCenterIcon: E9,
  ChatBubbleBottomCenterTextIcon: v9,
  ChatBubbleLeftEllipsisIcon: b9,
  ChatBubbleLeftIcon: w9,
  ChatBubbleLeftRightIcon: S9,
  ChatBubbleOvalLeftEllipsisIcon: y9,
  ChatBubbleOvalLeftIcon: T9,
  CheckBadgeIcon: C9,
  CheckCircleIcon: x9,
  CheckIcon: A9,
  ChevronDoubleDownIcon: R9,
  ChevronDoubleLeftIcon: O9,
  ChevronDoubleRightIcon: I9,
  ChevronDoubleUpIcon: N9,
  ChevronDownIcon: M9,
  ChevronLeftIcon: D9,
  ChevronRightIcon: k9,
  ChevronUpDownIcon: L9,
  ChevronUpIcon: P9,
  CircleStackIcon: B9,
  ClipboardDocumentCheckIcon: F9,
  ClipboardDocumentIcon: $9,
  ClipboardDocumentListIcon: U9,
  ClipboardIcon: V9,
  ClockIcon: H9,
  CloudArrowDownIcon: G9,
  CloudArrowUpIcon: Y9,
  CloudIcon: z9,
  CodeBracketIcon: q9,
  CodeBracketSquareIcon: Z9,
  Cog6ToothIcon: W9,
  Cog8ToothIcon: j9,
  CogIcon: K9,
  CommandLineIcon: Q9,
  ComputerDesktopIcon: X9,
  CpuChipIcon: J9,
  CreditCardIcon: eM,
  CubeIcon: nM,
  CubeTransparentIcon: tM,
  CurrencyBangladeshiIcon: rM,
  CurrencyDollarIcon: aM,
  CurrencyEuroIcon: oM,
  CurrencyPoundIcon: iM,
  CurrencyRupeeIcon: sM,
  CurrencyYenIcon: lM,
  CursorArrowRaysIcon: cM,
  CursorArrowRippleIcon: uM,
  DevicePhoneMobileIcon: dM,
  DeviceTabletIcon: _M,
  DivideIcon: pM,
  DocumentArrowDownIcon: mM,
  DocumentArrowUpIcon: gM,
  DocumentChartBarIcon: fM,
  DocumentCheckIcon: hM,
  DocumentCurrencyBangladeshiIcon: vM,
  DocumentCurrencyDollarIcon: EM,
  DocumentCurrencyEuroIcon: bM,
  DocumentCurrencyPoundIcon: SM,
  DocumentCurrencyRupeeIcon: wM,
  DocumentCurrencyYenIcon: yM,
  DocumentDuplicateIcon: TM,
  DocumentIcon: OM,
  DocumentMagnifyingGlassIcon: CM,
  DocumentMinusIcon: xM,
  DocumentPlusIcon: AM,
  DocumentTextIcon: RM,
  EllipsisHorizontalCircleIcon: IM,
  EllipsisHorizontalIcon: NM,
  EllipsisVerticalIcon: MM,
  EnvelopeIcon: kM,
  EnvelopeOpenIcon: DM,
  EqualsIcon: LM,
  ExclamationCircleIcon: PM,
  ExclamationTriangleIcon: BM,
  EyeDropperIcon: FM,
  EyeIcon: $M,
  EyeSlashIcon: UM,
  FaceFrownIcon: VM,
  FaceSmileIcon: HM,
  FilmIcon: GM,
  FingerPrintIcon: YM,
  FireIcon: zM,
  FlagIcon: ZM,
  FolderArrowDownIcon: qM,
  FolderIcon: QM,
  FolderMinusIcon: WM,
  FolderOpenIcon: jM,
  FolderPlusIcon: KM,
  ForwardIcon: XM,
  FunnelIcon: JM,
  GifIcon: eD,
  GiftIcon: nD,
  GiftTopIcon: tD,
  GlobeAltIcon: rD,
  GlobeAmericasIcon: aD,
  GlobeAsiaAustraliaIcon: oD,
  GlobeEuropeAfricaIcon: iD,
  H1Icon: sD,
  H2Icon: lD,
  H3Icon: cD,
  HandRaisedIcon: uD,
  HandThumbDownIcon: dD,
  HandThumbUpIcon: _D,
  HashtagIcon: pD,
  HeartIcon: mD,
  HomeIcon: fD,
  HomeModernIcon: gD,
  IdentificationIcon: hD,
  InboxArrowDownIcon: vD,
  InboxIcon: bD,
  InboxStackIcon: ED,
  InformationCircleIcon: SD,
  ItalicIcon: wD,
  KeyIcon: yD,
  LanguageIcon: TD,
  LifebuoyIcon: CD,
  LightBulbIcon: xD,
  LinkIcon: RD,
  LinkSlashIcon: AD,
  ListBulletIcon: OD,
  LockClosedIcon: ID,
  LockOpenIcon: ND,
  MagnifyingGlassCircleIcon: MD,
  MagnifyingGlassIcon: LD,
  MagnifyingGlassMinusIcon: DD,
  MagnifyingGlassPlusIcon: kD,
  MapIcon: BD,
  MapPinIcon: PD,
  MegaphoneIcon: FD,
  MicrophoneIcon: UD,
  MinusCircleIcon: $D,
  MinusIcon: HD,
  MinusSmallIcon: VD,
  MoonIcon: GD,
  MusicalNoteIcon: YD,
  NewspaperIcon: zD,
  NoSymbolIcon: ZD,
  NumberedListIcon: qD,
  PaintBrushIcon: WD,
  PaperAirplaneIcon: jD,
  PaperClipIcon: KD,
  PauseCircleIcon: QD,
  PauseIcon: XD,
  PencilIcon: ek,
  PencilSquareIcon: JD,
  PercentBadgeIcon: tk,
  PhoneArrowDownLeftIcon: nk,
  PhoneArrowUpRightIcon: rk,
  PhoneIcon: ok,
  PhoneXMarkIcon: ak,
  PhotoIcon: ik,
  PlayCircleIcon: sk,
  PlayIcon: ck,
  PlayPauseIcon: lk,
  PlusCircleIcon: uk,
  PlusIcon: _k,
  PlusSmallIcon: dk,
  PowerIcon: pk,
  PresentationChartBarIcon: mk,
  PresentationChartLineIcon: gk,
  PrinterIcon: fk,
  PuzzlePieceIcon: hk,
  QrCodeIcon: vk,
  QuestionMarkCircleIcon: Ek,
  QueueListIcon: bk,
  RadioIcon: Sk,
  ReceiptPercentIcon: wk,
  ReceiptRefundIcon: yk,
  RectangleGroupIcon: Tk,
  RectangleStackIcon: Ck,
  RocketLaunchIcon: xk,
  RssIcon: Ak,
  ScaleIcon: Rk,
  ScissorsIcon: Ok,
  ServerIcon: Nk,
  ServerStackIcon: Ik,
  ShareIcon: Mk,
  ShieldCheckIcon: Dk,
  ShieldExclamationIcon: kk,
  ShoppingBagIcon: Lk,
  ShoppingCartIcon: Pk,
  SignalIcon: Fk,
  SignalSlashIcon: Bk,
  SlashIcon: Uk,
  SparklesIcon: $k,
  SpeakerWaveIcon: Vk,
  SpeakerXMarkIcon: Hk,
  Square2StackIcon: Gk,
  Square3Stack3DIcon: Yk,
  Squares2X2Icon: zk,
  SquaresPlusIcon: Zk,
  StarIcon: qk,
  StopCircleIcon: Wk,
  StopIcon: jk,
  StrikethroughIcon: Kk,
  SunIcon: Qk,
  SwatchIcon: Xk,
  TableCellsIcon: Jk,
  TagIcon: eL,
  TicketIcon: tL,
  TrashIcon: nL,
  TrophyIcon: rL,
  TruckIcon: aL,
  TvIcon: oL,
  UnderlineIcon: iL,
  UserCircleIcon: sL,
  UserGroupIcon: lL,
  UserIcon: dL,
  UserMinusIcon: cL,
  UserPlusIcon: uL,
  UsersIcon: _L,
  VariableIcon: pL,
  VideoCameraIcon: gL,
  VideoCameraSlashIcon: mL,
  ViewColumnsIcon: fL,
  ViewfinderCircleIcon: hL,
  WalletIcon: vL,
  WifiIcon: EL,
  WindowIcon: bL,
  WrenchIcon: wL,
  WrenchScrewdriverIcon: SL,
  XCircleIcon: yL,
  XMarkIcon: TL
}, Symbol.toStringTag, { value: "Module" })), xL = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function AL(t, n) {
  return c(), _("svg", xL, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      d: "M8.75 3.75h2.5v2.5h-2.5zM8.75 8.75h2.5v2.5h-2.5zM11.25 13.75h-2.5v2.5h2.5z"
    }, null, -1)
  ])]);
}
const RL = { render: AL }, OL = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function IL(t, n) {
  return c(), _("svg", OL, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      d: "M9.063 10.938v5.312h1.874v-5.312h5.313V9.062h-5.312V3.75H9.062v5.313H3.75v1.874z"
    }, null, -1)
  ])]);
}
const NL = { render: IL }, ML = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function DL(t, n) {
  return c(), _("svg", ML, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6 1h2v2h8V1h2v2h3a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3V1M3 5h18v16H3zm6 10h6a4 4 0 0 0 0-8H9a4 4 0 1 0 0 8m6-6a2 2 0 1 1 0 4H9a2 2 0 1 1 0-4zm-2 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0m2 7a1 1 0 0 1-1 1h-4a1 1 0 1 1 0-2h4a1 1 0 0 1 1 1",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const kL = { render: DL }, LL = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function PL(t, n) {
  return c(), _("svg", LL, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      d: "m13.123 3.053-3.75 3.375 1.254 1.394 2.186-1.967V15h1.875V5.855l2.185 1.967 1.254-1.394-3.75-3.375a.94.94 0 0 0-1.254 0M5.623 16.947l-3.75-3.375 1.254-1.394 2.186 1.967V5h1.875v9.145l2.185-1.967 1.254 1.394-3.75 3.375a.937.937 0 0 1-1.254 0"
    }, null, -1)
  ])]);
}
const BL = { render: PL }, FL = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
};
function UL(t, n) {
  return c(), _("svg", FL, [...n[0] || (n[0] = [
    mi('<g fill="currentColor" fill-rule="evenodd" clip-path="url(#a)" clip-rule="evenodd"><path d="M0 10C0 4.477 4.477 0 10 0s10 4.477 10 10-4.477 10-10 10S0 15.523 0 10m10-8.182a8.182 8.182 0 1 0 0 16.364 8.182 8.182 0 0 0 0-16.364"></path><path d="M5.682 5.636c0-.477.386-.863.863-.863h6.91c.477 0 .863.386.863.863v8.615a.864.864 0 0 1-1.25.773l-1.25-.625-1.432.716a.86.86 0 0 1-.772 0l-1.432-.716-1.25.625a.864.864 0 0 1-1.25-.773zm1.363.5v7.306l.75-.375a.86.86 0 0 1 .773 0l1.432.716 1.432-.716a.86.86 0 0 1 .772 0l.75.375V6.136z"></path><path d="M6.364 8.636c0-.25.203-.454.454-.454h.168a.455.455 0 0 1 0 .909h-.168a.455.455 0 0 1-.454-.455m1.423 0c0-.25.204-.454.455-.454h.335a.455.455 0 1 1 0 .909h-.335a.455.455 0 0 1-.455-.455m1.591 0c0-.25.203-.454.455-.454h.335a.454.454 0 1 1 0 .909h-.335a.455.455 0 0 1-.455-.455m1.59 0c0-.25.204-.454.456-.454h.334a.454.454 0 1 1 0 .909h-.334a.455.455 0 0 1-.455-.455m1.592 0c0-.25.203-.454.454-.454h.168a.455.455 0 0 1 0 .909h-.168a.455.455 0 0 1-.454-.455"></path></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h20v20H0z"></path></clipPath></defs>', 2)
  ])]);
}
const $L = { render: UL }, VL = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
};
function HL(t, n) {
  return c(), _("svg", VL, [...n[0] || (n[0] = [
    mi('<g fill="currentColor" fill-rule="evenodd" clip-path="url(#a)" clip-rule="evenodd"><path d="M0 10C0 4.477 4.477 0 10 0s10 4.477 10 10-4.477 10-10 10S0 15.523 0 10m10-8.182a8.182 8.182 0 1 0 0 16.364 8.182 8.182 0 0 0 0-16.364"></path><path d="M6.364 10a.91.91 0 0 1 .909-.91h5.454a.91.91 0 1 1 0 1.82H7.273a.91.91 0 0 1-.91-.91M6.364 13.636a.91.91 0 0 1 .909-.909H9.09a.91.91 0 1 1 0 1.819H7.273a.91.91 0 0 1-.91-.91M6.364 6.364a.91.91 0 0 1 .909-.91h4.545a.91.91 0 1 1 0 1.819H7.273a.91.91 0 0 1-.91-.91"></path></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h20v20H0z"></path></clipPath></defs>', 2)
  ])]);
}
const GL = { render: HL }, YL = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
};
function zL(t, n) {
  return c(), _("svg", YL, [...n[0] || (n[0] = [
    mi('<g fill="currentColor" clip-path="url(#a)"><path fill-rule="evenodd" d="M8.05.19a10.05 10.05 0 0 1 3.9 0l-.352 1.784a8.2 8.2 0 0 0-3.196 0zm7.507 1.495a10 10 0 0 1 2.758 2.758l-1.51 1.012a8.2 8.2 0 0 0-2.26-2.26zM1.685 4.443a10 10 0 0 1 2.758-2.758l1.012 1.51a8.2 8.2 0 0 0-2.26 2.26zM19.81 8.05a10 10 0 0 1 0 3.902l-1.784-.353a8.2 8.2 0 0 0 0-3.196zM0 10q.001-1.002.19-1.95l1.784.352a8.2 8.2 0 0 0 0 3.196L.19 11.95A10 10 0 0 1 0 10m18.315 5.557a10 10 0 0 1-2.758 2.758l-1.012-1.51a8.2 8.2 0 0 0 2.26-2.26zM4.443 18.315a10 10 0 0 1-2.758-2.758l1.51-1.012a8.2 8.2 0 0 0 2.26 2.26zM10 20a10 10 0 0 1-1.95-.19l.352-1.784a8.2 8.2 0 0 0 3.196 0l.353 1.784A10 10 0 0 1 10 20" clip-rule="evenodd"></path><path d="M10 11.818a1.818 1.818 0 1 1 0-3.636 1.818 1.818 0 0 1 0 3.636"></path></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h20v20H0z"></path></clipPath></defs>', 2)
  ])]);
}
const ZL = { render: zL }, qL = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
};
function WL(t, n) {
  return c(), _("svg", qL, [...n[0] || (n[0] = [
    mi('<g fill="currentColor" clip-path="url(#a)"><path fill-rule="evenodd" d="M0 10C0 4.477 4.477 0 10 0s10 4.477 10 10-4.477 10-10 10S0 15.523 0 10m10-8.182a8.182 8.182 0 1 0 0 16.364 8.182 8.182 0 0 0 0-16.364" clip-rule="evenodd"></path><path fill-rule="evenodd" d="M11.472 10.024a.9.9 0 0 0-.637.083L2.3 14.652a.909.909 0 1 0 .855 1.605l8.232-4.384 6.586 1.557a.91.91 0 0 0 .418-1.77z" clip-rule="evenodd"></path><path d="M6.073 9.09a1.364 1.364 0 1 1 0-2.726 1.364 1.364 0 0 1 0 2.727"></path></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h20v20H0z"></path></clipPath></defs>', 2)
  ])]);
}
const jL = { render: WL }, KL = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
};
function QL(t, n) {
  return c(), _("svg", KL, [...n[0] || (n[0] = [
    mi('<g fill="currentColor" fill-rule="evenodd" clip-path="url(#a)" clip-rule="evenodd"><path d="M0 10C0 4.477 4.477 0 10 0s10 4.477 10 10-4.477 10-10 10S0 15.523 0 10m10-8.182a8.182 8.182 0 1 0 0 16.364 8.182 8.182 0 0 0 0-16.364"></path><path d="M5.682 5.636c0-.477.386-.863.863-.863h6.91c.477 0 .863.386.863.863v8.615a.864.864 0 0 1-1.25.773l-1.25-.625-1.432.716a.86.86 0 0 1-.772 0l-1.432-.716-1.25.625a.864.864 0 0 1-1.25-.773zm1.363.5v7.306l.75-.375a.86.86 0 0 1 .773 0l1.432.716 1.432-.716a.86.86 0 0 1 .772 0l.75.375V6.136z"></path><path d="M6.364 8.636c0-.25.203-.454.454-.454h.168a.455.455 0 0 1 0 .909h-.168a.455.455 0 0 1-.454-.455m1.423 0c0-.25.204-.454.455-.454h.335a.455.455 0 1 1 0 .909h-.335a.455.455 0 0 1-.455-.455m1.591 0c0-.25.203-.454.455-.454h.335a.454.454 0 1 1 0 .909h-.335a.455.455 0 0 1-.455-.455m1.59 0c0-.25.204-.454.456-.454h.334a.454.454 0 1 1 0 .909h-.334a.455.455 0 0 1-.455-.455m1.592 0c0-.25.203-.454.454-.454h.168a.455.455 0 0 1 0 .909h-.168a.455.455 0 0 1-.454-.455"></path></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h20v20H0z"></path></clipPath></defs>', 2)
  ])]);
}
const XL = { render: QL }, JL = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
};
function eP(t, n) {
  return c(), _("svg", JL, [...n[0] || (n[0] = [
    mi('<g fill="currentColor" clip-path="url(#a)"><path fill-rule="evenodd" d="M0 10C0 4.477 4.477 0 10 0s10 4.477 10 10-4.477 10-10 10S0 15.523 0 10m10-8.182a8.182 8.182 0 1 0 0 16.364 8.182 8.182 0 0 0 0-16.364" clip-rule="evenodd"></path><path d="M8.182 5.455H6.364a.91.91 0 0 0-.91.909v1.818c0 .502.408.909.91.909h1.818a.91.91 0 0 0 .909-.91V6.365a.91.91 0 0 0-.91-.91M13.636 5.455h-1.818a.91.91 0 0 0-.909.909v1.818c0 .502.407.909.91.909h1.817a.91.91 0 0 0 .91-.91V6.365a.91.91 0 0 0-.91-.91M13.636 10.91h-1.818a.91.91 0 0 0-.909.908v1.818c0 .502.407.91.91.91h1.817a.91.91 0 0 0 .91-.91v-1.818a.91.91 0 0 0-.91-.909M8.182 10.91H6.364a.91.91 0 0 0-.91.908v1.818c0 .502.408.91.91.91h1.818a.91.91 0 0 0 .909-.91v-1.818a.91.91 0 0 0-.91-.909"></path></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h20v20H0z"></path></clipPath></defs>', 2)
  ])]);
}
const tP = { render: eP }, nP = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function rP(t, n) {
  return c(), _("svg", nP, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M17.5 10a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0m-6.562-3.75v5H9.062v-5zm-1.876 8.125V12.5h1.876v1.875z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const aP = { render: rP }, oP = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function iP(t, n) {
  return c(), _("svg", oP, [...n[0] || (n[0] = [
    mi('<rect width="12" height="13" x="6" y="8" stroke="currentColor" stroke-width="2" rx="2"></rect><rect width="4" height="4" x="10" y="2" fill="currentColor" rx="2"></rect><rect width="2" height="3" x="9" y="11" fill="currentColor" rx="1"></rect><path fill="currentColor" d="M9 16.667c0-.369.298-.667.667-.667h4.666c.368 0 .667.299.667.667 0 .736-.597 1.333-1.333 1.333h-3.334A1.333 1.333 0 0 1 9 16.667"></path><rect width="2" height="3" x="13" y="11" fill="currentColor" rx="1"></rect><rect width="2" height="8" x="2" y="10" fill="currentColor" rx="1"></rect><rect width="2" height="8" x="20" y="10" fill="currentColor" rx="1"></rect>', 7)
  ])]);
}
const sP = { render: iP }, lP = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function cP(t, n) {
  return c(), _("svg", lP, [...n[0] || (n[0] = [
    d("path", {
      stroke: "currentColor",
      "stroke-width": "2",
      d: "M2 5a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v9.586a1 1 0 0 1-.293.707l-4.414 4.414a1 1 0 0 1-.707.293H3a1 1 0 0 1-1-1z"
    }, null, -1),
    d("path", {
      stroke: "currentColor",
      "stroke-width": "1.5",
      d: "M12 9V7m0 10v-2m-3.5.5L10 14M8.5 8.5 10 10m-3 2h2"
    }, null, -1)
  ])]);
}
const uP = { render: cP }, dP = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function _P(t, n) {
  return c(), _("svg", dP, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      d: "M2.65 3a.64.64 0 0 0-.642.744l2.72 16.528c.07.418.43.724.853.728h13.05a.64.64 0 0 0 .64-.539l2.72-16.714a.64.64 0 0 0-.64-.744zm11.453 11.946H9.938L8.81 9.048h6.303z"
    }, null, -1)
  ])]);
}
const pP = { render: _P }, mP = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function gP(t, n) {
  return c(), _("svg", mP, [...n[0] || (n[0] = [
    mi('<path fill="#2684FF" d="M2.65 3a.64.64 0 0 0-.642.743l2.72 16.514c.07.417.43.724.853.727h13.05a.64.64 0 0 0 .64-.538l2.72-16.7a.64.64 0 0 0-.64-.743zm11.453 11.935H9.938L8.81 9.043h6.303z"></path><path fill="url(#a)" fill-rule="evenodd" d="M21.11 9.035h-6.009l-1.008 5.887H9.93l-4.915 5.833c.156.135.355.21.56.212H18.62a.64.64 0 0 0 .64-.538z" clip-rule="evenodd"></path><defs><linearGradient id="a" x1="1753.33" x2="1059.18" y1="173.91" y2="1159.52" gradientUnits="userSpaceOnUse"><stop offset=".18" stop-color="#0052CC"></stop><stop offset="1" stop-color="#2684FF"></stop></linearGradient></defs>', 3)
  ])]);
}
const fP = { render: gP }, hP = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function vP(t, n) {
  return c(), _("svg", hP, [...n[0] || (n[0] = [
    d("path", {
      stroke: "currentColor",
      "stroke-width": "2",
      d: "M2 5a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v9.586a1 1 0 0 1-.293.707l-4.414 4.414a1 1 0 0 1-.707.293H3a1 1 0 0 1-1-1zM2.356 20.235l19-16"
    }, null, -1)
  ])]);
}
const EP = { render: vP }, bP = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function SP(t, n) {
  return c(), _("svg", bP, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "m15.725 6.845-6.154 7.5a.94.94 0 0 1-1.38.076l-3.845-3.75L5.655 9.33l3.114 3.037 5.506-6.71z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const wP = { render: SP }, yP = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function TP(t, n) {
  return c(), _("svg", yP, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10 17.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15m-3.663-5.163L8.674 10 6.337 7.663l1.326-1.326L10 8.674l2.337-2.337 1.326 1.326L11.326 10l2.337 2.337-1.326 1.326L10 11.326l-2.337 2.337z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const CP = { render: TP }, xP = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function AP(t, n) {
  return c(), _("svg", xP, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      d: "m8.674 10-4.337 4.337 1.326 1.326L10 11.326l4.337 4.337 1.326-1.326L11.326 10l4.337-4.337-1.326-1.326L10 8.674 5.663 4.337 4.337 5.663z"
    }, null, -1)
  ])]);
}
const RP = { render: AP }, OP = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function IP(t, n) {
  return c(), _("svg", OP, [...n[0] || (n[0] = [
    d("path", {
      stroke: "currentColor",
      "stroke-width": "2",
      d: "M2 5a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v9.586a1 1 0 0 1-.293.707l-4.414 4.414a1 1 0 0 1-.707.293H3a1 1 0 0 1-1-1z"
    }, null, -1),
    d("path", {
      stroke: "currentColor",
      "stroke-width": "2",
      d: "M7 11.333 10.438 15 17 8"
    }, null, -1)
  ])]);
}
const NP = { render: IP }, MP = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function DP(t, n) {
  return c(), _("svg", MP, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      d: "M7.625 2.5c-.76 0-1.375.616-1.375 1.375v9.75c0 .76.616 1.375 1.375 1.375h7.25c.76 0 1.375-.616 1.375-1.375v-9.75c0-.76-.616-1.375-1.375-1.375z"
    }, null, -1),
    d("path", {
      fill: "currentColor",
      d: "M2.813 5v9.375a4.06 4.06 0 0 0 4.062 4.063h6.875v-1.875H6.875a2.19 2.19 0 0 1-2.187-2.188V5z"
    }, null, -1)
  ])]);
}
const kP = { render: DP }, LP = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function PP(t, n) {
  return c(), _("svg", LP, [...n[0] || (n[0] = [
    d("path", {
      stroke: "currentColor",
      "stroke-width": "2",
      d: "M2 5a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v9.586a1 1 0 0 1-.293.707l-4.414 4.414a1 1 0 0 1-.707.293H3a1 1 0 0 1-1-1z"
    }, null, -1),
    d("path", {
      fill: "currentColor",
      d: "M12.5 11H16l-4.5 6.5V13H8l4.5-6.5z"
    }, null, -1)
  ])]);
}
const BP = { render: PP }, FP = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function UP(t, n) {
  return c(), _("svg", FP, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      d: "M13.75 3.75c0-.69.56-1.25 1.25-1.25h1.25c.69 0 1.25.56 1.25 1.25v12.5c0 .69-.56 1.25-1.25 1.25H15c-.69 0-1.25-.56-1.25-1.25zM8.125 7.5c0-.69.56-1.25 1.25-1.25h1.25c.69 0 1.25.56 1.25 1.25v8.75c0 .69-.56 1.25-1.25 1.25h-1.25c-.69 0-1.25-.56-1.25-1.25zM3.75 10c-.69 0-1.25.56-1.25 1.25v5c0 .69.56 1.25 1.25 1.25H5c.69 0 1.25-.56 1.25-1.25v-5C6.25 10.56 5.69 10 5 10z"
    }, null, -1)
  ])]);
}
const $P = { render: UP }, VP = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function HP(t, n) {
  return c(), _("svg", VP, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      d: "M5.313 1.25H3.75v2.813h-.937c-.69 0-1.25.56-1.25 1.25V7.5h16.875V5.313c0-.69-.56-1.25-1.25-1.25h-.938V1.25h-1.562v2.813H5.313zM18.438 9.375H1.563v7.813c0 .69.56 1.25 1.25 1.25h14.375c.69 0 1.25-.56 1.25-1.25z"
    }, null, -1)
  ])]);
}
const GP = { render: HP }, YP = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function zP(t, n) {
  return c(), _("svg", YP, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M14.688 5h2.5v1.875H16.08l-.977 10.738a1.25 1.25 0 0 1-1.245 1.137H6.142a1.25 1.25 0 0 1-1.245-1.137L3.92 6.875H2.813V5h2.5V3.438c0-1.209.979-2.188 2.187-2.188h5c1.208 0 2.188.98 2.188 2.188zM7.5 3.125a.31.31 0 0 0-.312.313V5h5.625V3.438a.31.31 0 0 0-.313-.313zM7.188 7.5v8.75h1.875V7.5zm3.75 0v8.75h1.874V7.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const ZP = { render: zP }, qP = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function WP(t, n) {
  return c(), _("svg", qP, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      d: "M5.75 3.75h2.5v2.5h-2.5zM5.75 8.75h2.5v2.5h-2.5zM5.75 13.75h2.5v2.5h-2.5zM11.75 3.75h2.5v2.5h-2.5zM11.75 8.75h2.5v2.5h-2.5zM11.75 13.75h2.5v2.5h-2.5z"
    }, null, -1)
  ])]);
}
const jP = { render: WP }, KP = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function QP(t, n) {
  return c(), _("svg", KP, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      d: "m10.616 11.956 3.75-3.272-1.232-1.413-2.197 1.917V2.5H9.064v6.688L6.866 7.27 5.634 8.684l3.75 3.272a.94.94 0 0 0 1.232 0"
    }, null, -1),
    d("path", {
      fill: "currentColor",
      d: "M4.688 11.563H2.813v4.062c0 .863.699 1.563 1.562 1.563h11.25c.863 0 1.563-.7 1.563-1.563v-4.062h-1.875v3.75H4.688z"
    }, null, -1)
  ])]);
}
const XP = { render: QP }, JP = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 756.26 596.9"
};
function eB(t, n) {
  return c(), _("svg", JP, [...n[0] || (n[0] = [
    d("path", {
      d: "M743.96 245.25c-18.54-12.48-67.26-17.81-102.68-8.27-1.91-35.28-20.1-65.01-53.38-90.95l-12.32-8.27-8.21 12.4c-16.14 24.5-22.94 57.14-20.53 86.81 1.9 18.28 8.26 38.83 20.53 53.74-46.1 26.74-88.59 20.67-276.77 20.67H.06c-.85 42.49 5.98 124.23 57.96 190.77 5.74 7.35 12.04 14.46 18.87 21.31 42.26 42.32 106.11 73.35 201.59 73.44 145.66.13 270.46-78.6 346.37-268.97 24.98.41 90.92 4.48 123.19-57.88.79-1.05 8.21-16.54 8.21-16.54l-12.3-8.27Zm-554.29-38.86h-81.7v81.7h81.7zm105.55 0h-81.7v81.7h81.7zm105.55 0h-81.7v81.7h81.7zm105.55 0h-81.7v81.7h81.7zm-422.2 0H2.42v81.7h81.7zM189.67 103.2h-81.7v81.7h81.7zm105.55 0h-81.7v81.7h81.7zm105.55 0h-81.7v81.7h81.7zm0-103.2h-81.7v81.7h81.7z",
      style: { fill: "currentColor", "stroke-width": "0" }
    }, null, -1)
  ])]);
}
const tB = { render: eB }, nB = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function rB(t, n) {
  return c(), _("svg", nB, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      d: "m16.837 1.837 1.326 1.326-1.243 1.243-1.326-1.326zM8.75 11.25h1.326l5.588-5.588-1.326-1.326L8.75 9.924z"
    }, null, -1),
    d("path", {
      fill: "currentColor",
      d: "M4.688 5c0-.173.14-.312.312-.312h5V2.813H5c-1.208 0-2.187.979-2.187 2.187v10c0 1.208.979 2.188 2.187 2.188h10c1.208 0 2.188-.98 2.188-2.188v-5h-1.875v5c0 .173-.14.313-.313.313H5A.31.31 0 0 1 4.688 15z"
    }, null, -1)
  ])]);
}
const aB = { render: rB }, oB = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function iB(t, n) {
  return c(), _("svg", oB, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2.242 15.657 8.899 3.294a1.25 1.25 0 0 1 2.201 0l6.78 12.59a1.096 1.096 0 0 1-.966 1.616H3.343a1.25 1.25 0 0 1-1.101-1.843M10.937 7.5v5H9.062v-5zm-1.875 6.25h1.875v1.875H9.062z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const sB = { render: iB }, lB = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function cB(t, n) {
  return c(), _("svg", lB, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      d: "M16.25 3.813h-5v1.874h2.737l-4.65 4.65 1.326 1.326 4.65-4.65V9.75h1.874v-5a.937.937 0 0 0-.937-.937"
    }, null, -1),
    d("path", {
      fill: "currentColor",
      d: "M5.938 7.25c0-.173.14-.312.312-.312h2.5V5.063h-2.5c-1.208 0-2.187.979-2.187 2.187v7.5c0 1.208.979 2.188 2.187 2.188h7.5c1.208 0 2.188-.98 2.188-2.188v-2.5h-1.876v2.5c0 .173-.14.313-.312.313h-7.5a.31.31 0 0 1-.312-.313z"
    }, null, -1)
  ])]);
}
const uB = { render: cB }, dB = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function _B(t, n) {
  return c(), _("svg", dB, [...n[0] || (n[0] = [
    d("path", {
      stroke: "currentColor",
      "stroke-width": "2",
      d: "M2 5a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v9.586a1 1 0 0 1-.293.707l-4.414 4.414a1 1 0 0 1-.707.293H3a1 1 0 0 1-1-1zM16 8l-4 4m0 0-4 4m4-4 4 4m-4-4L8 8"
    }, null, -1)
  ])]);
}
const pB = { render: _B }, mB = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function gB(t, n) {
  return c(), _("svg", mB, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7.5 1.563a.937.937 0 0 0-.938.937v4.7L3.31 11.752c-1.625 2.275.002 5.435 2.798 5.435h7.784c2.796 0 4.422-3.16 2.797-5.435L13.437 7.2V2.5a.937.937 0 0 0-.937-.937zM8.437 7.5V3.438h3.125V7.5c0 .195.061.386.175.545l1.62 2.268H6.643l1.62-2.268a.94.94 0 0 0 .174-.545",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const fB = { render: gB }, hB = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function vB(t, n) {
  return c(), _("svg", hB, [...n[0] || (n[0] = [
    d("path", {
      stroke: "currentColor",
      "stroke-width": "2",
      d: "M12.222 16.353A2.657 2.657 0 0 1 9.556 19a2.657 2.657 0 0 1-2.667-2.647m5.333 0a2.657 2.657 0 0 0-2.666-2.647 2.657 2.657 0 0 0-2.667 2.647m5.333 0h4.89m-10.223 0C5.259 16.353 2 15.383 2 11.5s3.26-4.853 4.889-4.853m5.333 0a2.657 2.657 0 0 1-2.666 2.647 2.657 2.657 0 0 1-2.667-2.647m5.333 0A2.657 2.657 0 0 0 9.556 4a2.657 2.657 0 0 0-2.667 2.647m5.333 0h4.89m4.888 0a2.657 2.657 0 0 1-2.667 2.647 2.657 2.657 0 0 1-2.666-2.647A2.657 2.657 0 0 1 19.333 4 2.657 2.657 0 0 1 22 6.647Zm0 9.706A2.657 2.657 0 0 1 19.333 19a2.657 2.657 0 0 1-2.666-2.647 2.657 2.657 0 0 1 2.666-2.647A2.657 2.657 0 0 1 22 16.353Z"
    }, null, -1)
  ])]);
}
const EB = { render: vB }, bB = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function SB(t, n) {
  return c(), _("svg", bB, [...n[0] || (n[0] = [
    d("path", {
      stroke: "currentColor",
      "stroke-width": "2",
      d: "M12.222 16.353A2.657 2.657 0 0 1 9.556 19a2.657 2.657 0 0 1-2.667-2.647m5.333 0a2.657 2.657 0 0 0-2.666-2.647 2.657 2.657 0 0 0-2.667 2.647m5.333 0h4.89m-10.223 0C5.259 16.353 2 15.383 2 11.5s3.26-4.853 4.889-4.853m5.333 0a2.657 2.657 0 0 1-2.666 2.647 2.657 2.657 0 0 1-2.667-2.647m5.333 0A2.657 2.657 0 0 0 9.556 4a2.657 2.657 0 0 0-2.667 2.647m5.333 0h6.9M22 16.353A2.657 2.657 0 0 1 19.333 19a2.657 2.657 0 0 1-2.666-2.647 2.657 2.657 0 0 1 2.666-2.647A2.657 2.657 0 0 1 22 16.353ZM19.121 4.414 21.5 6.535l-2.379 2.122z"
    }, null, -1)
  ])]);
}
const wB = { render: SB }, yB = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function TB(t, n) {
  return c(), _("svg", yB, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      d: "M8.75 2.813h-5a.94.94 0 0 0-.937.937v5h1.874V6.013l2.775 2.775 1.326-1.326-2.775-2.774H8.75zM16.25 2.813h-5v1.874h2.737l-2.775 2.775 1.326 1.326 2.774-2.775V8.75h1.876v-5a.94.94 0 0 0-.938-.937M16.25 17.188h-5v-1.875h2.737l-2.775-2.775 1.326-1.326 2.774 2.775V11.25h1.876v5c0 .518-.42.938-.938.938M3.75 17.188h5v-1.875H6.013l2.775-2.775-1.326-1.326-2.774 2.775V11.25H2.813v5c0 .518.42.938.937.938"
    }, null, -1)
  ])]);
}
const CB = { render: TB }, xB = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function AB(t, n) {
  return c(), _("svg", xB, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10 4.688a5.313 5.313 0 0 0-4.062 8.736V11.25h1.875v4.164c0 .518-.42.937-.938.937H2.5v-1.875h1.876A7.187 7.187 0 0 1 10 2.812zm2.188-.102c0-.518.42-.937.937-.937H17.5v1.875h-1.876A7.188 7.188 0 0 1 10 17.188v-1.875a5.313 5.313 0 0 0 4.062-8.737V8.75h-1.876z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const RB = { render: AB }, OB = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 496 512"
};
function IB(t, n) {
  return c(), _("svg", OB, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      d: "M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6m-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3m44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9M244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8M97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1m-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7m32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1m-11.4-14.7c-1.6 1-1.6 3.6 0 5.9s4.3 3.3 5.6 2.3c1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2"
    }, null, -1)
  ])]);
}
const NB = { render: IB }, MB = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function DB(t, n) {
  return c(), _("svg", MB, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      d: "m21.667 9.586-.028-.072-2.722-7.068a.71.71 0 0 0-.704-.444.73.73 0 0 0-.41.153.73.73 0 0 0-.241.364l-1.838 5.595H8.281L6.443 2.52a.71.71 0 0 0-.65-.518.713.713 0 0 0-.704.444L2.36 9.51l-.027.072a5 5 0 0 0-.138 3.185 5.03 5.03 0 0 0 1.815 2.627l.009.007.025.018 4.147 3.09 2.051 1.545 1.25.938a.84.84 0 0 0 1.016 0l1.25-.938 2.051-1.545 4.172-3.109.01-.008a5.03 5.03 0 0 0 1.811-2.625 5 5 0 0 0-.136-3.181"
    }, null, -1)
  ])]);
}
const kB = { render: DB }, LB = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function PB(t, n) {
  return c(), _("svg", LB, [...n[0] || (n[0] = [
    d("path", {
      fill: "#E24329",
      d: "m21.667 9.586-.028-.072-2.722-7.068a.71.71 0 0 0-.704-.444.73.73 0 0 0-.41.153.73.73 0 0 0-.241.364l-1.838 5.595H8.281L6.443 2.52a.71.71 0 0 0-.65-.518.713.713 0 0 0-.704.444L2.36 9.51l-.027.072a5 5 0 0 0-.138 3.185 5.03 5.03 0 0 0 1.815 2.627l.009.007.025.018 4.147 3.09 2.051 1.545 1.25.938a.84.84 0 0 0 1.016 0l1.25-.938 2.051-1.545 4.172-3.109.01-.008a5.03 5.03 0 0 0 1.811-2.625 5 5 0 0 0-.136-3.181"
    }, null, -1),
    d("path", {
      fill: "#FC6D26",
      d: "m21.667 9.586-.028-.072a9.2 9.2 0 0 0-3.66 1.637L12 15.65l3.808 2.864 4.172-3.109.01-.008a5.03 5.03 0 0 0 1.814-2.627 5 5 0 0 0-.137-3.183"
    }, null, -1),
    d("path", {
      fill: "#FCA326",
      d: "m8.192 18.513 2.051 1.545 1.25.939a.84.84 0 0 0 1.016 0l1.25-.94 2.051-1.544s-1.774-1.336-3.81-2.864c-2.036 1.528-3.808 2.864-3.808 2.864"
    }, null, -1),
    d("path", {
      fill: "#FC6D26",
      d: "M6.02 11.152A9.2 9.2 0 0 0 2.361 9.51l-.027.072a5 5 0 0 0-.138 3.185 5.03 5.03 0 0 0 1.815 2.627l.009.008.025.017 4.147 3.09L12 15.645z"
    }, null, -1)
  ])]);
}
const BB = { render: PB }, FB = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 488 512"
};
function UB(t, n) {
  return c(), _("svg", FB, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      d: "M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4"
    }, null, -1)
  ])]);
}
const $B = { render: UB }, VB = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function HB(t, n) {
  return c(), _("svg", VB, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      d: "m7.226 6.349.593-.522c.266-.277 1.08-.83 2.202-.827 1.402.004 2.772.86 3.067 2.371.235 1.209-.513 2.173-.917 2.505a5 5 0 0 1-.694.46c-.339.178-.611.416-.611.588v.967H9.172v-.967c0-.243.053-.904.616-1.445.45-.433.84-.641.98-.692.22-.12.66-.473.66-.864 0-.487-.221-.994-1.086-1.193-.692-.16-1.278.226-1.485.439l-.52.454zM9.168 13.302V15h1.698v-1.698z"
    }, null, -1),
    d("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10 1.563a8.438 8.438 0 1 0 0 16.875 8.438 8.438 0 0 0 0-16.875M3.313 10a6.688 6.688 0 1 1 13.375 0 6.688 6.688 0 0 1-13.375 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const GB = { render: HB }, YB = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function zB(t, n) {
  return c(), _("svg", YB, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      d: "M12.088.673a.335.335 0 0 0-.582.089L8.527 8.703a.344.344 0 0 1-.614.06L5.936 5.57a.328.328 0 0 0-.529-.047c-.793.92-2.907 3.621-2.907 6.3 0 4.161 3.358 7.534 7.5 7.534s7.5-3.373 7.5-7.534c0-3.7-4.138-9.462-5.412-11.15"
    }, null, -1)
  ])]);
}
const ZB = { render: zB }, qB = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function WB(t, n) {
  return c(), _("svg", qB, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      d: "M3 17.5a.75.75 0 0 0 1.219.586L10 13.46l5.781 4.626A.75.75 0 0 0 17 17.5V8.75a.75.75 0 0 0-.282-.586l-6.25-5a.75.75 0 0 0-.937 0l-6.25 5A.75.75 0 0 0 3 8.75z"
    }, null, -1)
  ])]);
}
const jB = { render: WB }, KB = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function QB(t, n) {
  return c(), _("svg", KB, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      d: "M3 5.75a.75.75 0 0 1 1.219-.586L10 9.79l5.781-4.626A.75.75 0 0 1 17 5.75V9.5a.75.75 0 0 1-.282.586l-6.25 5a.75.75 0 0 1-.937 0l-6.25-5A.75.75 0 0 1 3 9.5z"
    }, null, -1)
  ])]);
}
const XB = { render: QB }, JB = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function eF(t, n) {
  return c(), _("svg", JB, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      d: "M3 3.75a.75.75 0 0 1 1.219-.586L10 7.79l5.781-4.626A.75.75 0 0 1 17 3.75v8.75a.75.75 0 0 1-.282.586l-6.25 5a.75.75 0 0 1-.937 0l-6.25-5A.75.75 0 0 1 3 12.5z"
    }, null, -1)
  ])]);
}
const tF = { render: eF }, nF = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function rF(t, n) {
  return c(), _("svg", nF, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      d: "M3 14.5a.75.75 0 0 0 1.219.586L10 10.46l5.781 4.626A.75.75 0 0 0 17 14.5v-3.75a.75.75 0 0 0-.282-.586l-6.25-5a.75.75 0 0 0-.937 0l-6.25 5A.75.75 0 0 0 3 10.75z"
    }, null, -1)
  ])]);
}
const aF = { render: rF }, oF = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function iF(t, n) {
  return c(), _("svg", oF, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10 4.688A2.813 2.813 0 0 0 7.188 7.5H5.313a4.688 4.688 0 1 1 7.586 3.684c-.54.425-1.046.85-1.419 1.309-.368.453-.543.861-.543 1.257H9.064c0-.985.442-1.8.962-2.44.516-.635 1.17-1.17 1.714-1.6A2.813 2.813 0 0 0 10 4.688",
      "clip-rule": "evenodd"
    }, null, -1),
    d("path", {
      fill: "currentColor",
      d: "M9.063 15.313h1.875v1.875H9.063z"
    }, null, -1)
  ])]);
}
const sF = { render: iF }, lF = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function cF(t, n) {
  return c(), _("svg", lF, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      d: "M9.063 5v1.875h1.874V5zM9.063 8.125V15h1.874V8.125z"
    }, null, -1),
    d("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10 1.563a8.438 8.438 0 1 0 0 16.875 8.438 8.438 0 0 0 0-16.875M3.313 10a6.688 6.688 0 1 1 13.375 0 6.688 6.688 0 0 1-13.375 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const uF = { render: cF }, dF = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function _F(t, n) {
  return c(), _("svg", dF, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      d: "M3.75 3.75h2.5v2.5h-2.5zM3.75 8.75h2.5v2.5h-2.5zM8.75 8.75h2.5v2.5h-2.5zM16.25 8.75h-2.5v2.5h2.5zM11.25 3.75h-2.5v2.5h2.5zM13.75 3.75h2.5v2.5h-2.5zM6.25 13.75h-2.5v2.5h2.5zM8.75 13.75h2.5v2.5h-2.5zM16.25 13.75h-2.5v2.5h2.5z"
    }, null, -1)
  ])]);
}
const pF = { render: _F }, mF = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function gF(t, n) {
  return c(), _("svg", mF, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      d: "M2.5 4.688h15V2.813h-15zM2.5 13.02h15v-1.874h-15zM17.5 8.854h-15V6.98h15zM2.5 17.188h15v-1.875h-15z"
    }, null, -1)
  ])]);
}
const fF = { render: gF }, hF = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function vF(t, n) {
  return c(), _("svg", hF, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1 5a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v9.586A2 2 0 0 1 22.414 16L18 20.414a2 2 0 0 1-1.414.586H3a2 2 0 0 1-2-2zm20 0H3v14h13.586L21 14.586z",
      "clip-rule": "evenodd"
    }, null, -1),
    d("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.5 13V7h3v6zm0 4v-2h3v2z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const EF = { render: vF }, bF = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function SF(t, n) {
  return c(), _("svg", bF, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      d: "M17.5 5.938h-15V4.063h15zM17.5 10.938h-15V9.062h15zM2.5 15.938h15v-1.876h-15z"
    }, null, -1)
  ])]);
}
const wF = { render: SF }, yF = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function TF(t, n) {
  return c(), _("svg", yF, [...n[0] || (n[0] = [
    d("path", {
      fill: "#F25022",
      d: "M2 2h9.489v9.5H2z"
    }, null, -1),
    d("path", {
      fill: "#7FBA00",
      d: "M12.488 2h9.489v9.5h-9.49z"
    }, null, -1),
    d("path", {
      fill: "#00A4EF",
      d: "M2 12.5h9.489V22H2z"
    }, null, -1),
    d("path", {
      fill: "#FFB900",
      d: "M12.488 12.5h9.489V22h-9.49z"
    }, null, -1)
  ])]);
}
const CF = { render: TF }, xF = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function AF(t, n) {
  return c(), _("svg", xF, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      d: "M2 2h9.489v9.5H2zM12.488 2h9.489v9.5h-9.49zM2 12.5h9.489V22H2zM12.488 12.5h9.489V22h-9.49z"
    }, null, -1)
  ])]);
}
const RF = { render: AF }, OF = {
  xmlns: "http://www.w3.org/2000/svg",
  version: "1.0",
  viewBox: "0 0 300 300"
};
function IF(t, n) {
  return c(), _("svg", OF, [...n[0] || (n[0] = [
    d("g", { fill: "currentColor" }, [
      d("path", { d: "M140 2.7c0 3.3 1.7 24.7 2.5 31.5l.6 4.8H135v4.2c0 2.4.7 10.6 1.5 18.3s1.5 14.8 1.5 15.7c0 1.6 1.2 1.8 10.8 1.8h10.8l2.8-34.3c1.5-18.8 3-36.6 3.3-39.5l.6-5.2H140zM99.3 7.7c-7.2 2.7-9.3 3.9-9.3 5.4 0 1 3.4 9.2 7.5 18.1l7.4 16.3-3 1.3c-1.6.7-3.2 1.8-3.5 2.5-.4 1 14.6 34 16.1 35.6.2.1 4.1-1.2 8.7-2.9 4.6-1.8 9-3.5 9.9-3.9 1.4-.5.4-5.1-7.7-34.6-5.2-18.7-9.9-35.7-10.4-37.8-1.4-4.7-3.2-4.7-15.7 0M191.7 7.3c-.8 1.2-3.4 9.5-5.8 18.5l-4.4 16.3-4.1-.7c-3.5-.5-4.3-.3-4.8 1.3-.3 1-2.4 9-4.6 17.8-2.3 8.8-4.3 16.7-4.6 17.6-.3 1.3.5 1.8 3.3 2.4 2 .3 6.5 1.8 10 3.2s6.5 2.4 6.7 2.2 7.7-16.3 16.7-35.7c13.7-29.9 16-35.5 14.8-36.6-.8-.7-6-2.9-11.6-4.9L193 5.1zM55.1 32.5c-5 4.2-9.1 8.2-9.1 8.8 0 .5 5.9 7 13.2 14.4L72.4 69l-2.2 2.3c-1.2 1.3-2.2 3-2.2 3.8 0 1.7 26 27.9 27.7 27.9.7 0 1.3-.4 1.3-1 0-.5 3.1-3.5 7-6.6s7-6 7-6.4c0-1.2-44.4-63.3-45.6-63.7-.6-.2-5.2 3.1-10.3 7.2M227.4 44c-5.8 8.2-11.2 15-11.9 15s-1.8-.7-2.5-1.5c-.7-.9-2.1-1.5-3.1-1.3-1.6.3-22.9 29.8-22.9 31.7 0 .4 1.9 2.2 4.3 3.9 2.3 1.7 5.6 4.5 7.4 6.1 1.8 1.7 3.6 3.1 4 3.1s13.1-12.3 28.2-27.4c17.6-17.6 27.2-27.9 27-28.9-.5-2-16.8-15.7-18.6-15.7-.7 0-6 6.7-11.9 15M20.8 71.9c-3.2 5.5-5.5 10.6-5.2 11.4s8.1 5 17.3 9.3l16.8 7.9-1.5 3.3c-2.3 4.7-3.8 3.7 28.5 18.3l6.3 2.8 1.9-4.5c1.1-2.5 3.4-6.5 5.1-9 1.6-2.5 3-4.8 3-5.2-.1-1.2-62.3-43.5-64.5-43.9-1.6-.3-3.1 1.6-7.7 9.6M258.5 77c-7.7 5.5-14.5 9.9-15.1 10-.7 0-1.9-1.1-2.8-2.5s-2.1-2.5-2.7-2.5c-1.6 0-31.8 21.3-31.9 22.5 0 .6 1.6 3.4 3.6 6.4 2 2.9 4.2 6.8 5 8.7 1.2 2.8 1.8 3.3 3.2 2.6.9-.5 16.9-8 35.4-16.8 18.6-8.7 34-16.4 34.2-17 .3-.7-2.1-5.6-5.2-11-4-6.9-6.3-10-7.7-10.1-1.2-.1-7.9 4-16 9.7M3.5 111.2c-2.3 10.6-3.6 21.1-2.7 22 .5.5 8.3 1.6 17.3 2.4 22.1 2 20.9 1.7 20.2 5.8-.3 2-.1 3.6.6 4.1.7.4 9.5 1.4 19.7 2.2 14.7 1.3 18.8 1.3 19.4.4.7-1.2 2.1-11.4 2.4-17.5l.1-2.9-35.5-9.3c-19.5-5.1-36.7-9.3-38.2-9.4-2.1 0-2.9.6-3.3 2.2M275.8 118.9c-17.4 4.7-17.8 4.7-17.8 2.6 0-1.2-.6-3-1.4-4-1.3-1.8-1.9-1.7-19.2 3-9.9 2.6-18.3 5.2-18.8 5.6-.4.4-.1 3.9.8 7.7.9 3.9 1.6 8.5 1.6 10.1 0 3.6-.5 3.5 13.6 2.1 14.2-1.4 63.3-6 64.5-6 1.4 0 1.1-7.4-.6-16.3-1.7-8.7-2.1-9.7-3.8-9.6-.7 0-9.2 2.2-18.9 4.8M221 155.2c0 2.4-.7 7-1.4 10.3-.8 3.3-1.4 6.1-1.2 6.2.1.1 16.6 4.5 36.7 9.8 31.8 8.3 40.9 10.3 40.9 9.2 0-.1.9-5.4 2-11.7 1.7-10 1.8-11.6.5-12.6-.8-.6-8.5-1.6-17.2-2.3-21-1.7-20.5-1.6-19.7-5.6.4-2.1.1-3.5-.7-4.1-1.3-.8-27.2-3.3-35.1-3.4H221zM38.5 156.6c-18.7 1.8-35 3.3-36.2 3.3-2 .1-2.3.6-2.3 4.5 0 5.4 2.6 19.6 3.9 20.9.5.5 8.1-1 18.4-3.7 9.6-2.5 18-4.6 18.6-4.6s1.1.9 1.1 1.9c0 3.1 1.1 5.1 2.9 5.1.9 0 9.5-2.2 19.1-4.9 15.1-4.1 17.5-5.1 17.4-6.7-.2-2.2-2.5-16.3-3-18.2-.4-1.5.6-1.6-39.9 2.4M215.1 179.3c-.6 1.8-2.7 5.6-4.6 8.6-1.9 2.9-3.5 5.6-3.5 5.9.1 1.2 62.2 43.5 64.4 43.9 1.7.4 3.1-1.3 7.8-9.8 3.1-5.6 5.4-10.7 5.2-11.4-.3-.7-8.1-4.8-17.3-9.1l-16.9-7.8 1.6-3.3c1.4-2.9 1.4-3.5.1-4.7-1.7-1.7-32.5-15.6-34.4-15.6-.7 0-1.8 1.5-2.4 3.3M47.3 194.3c-18.9 8.9-34.5 16.7-34.7 17.3-.8 2 10.7 21.4 12.6 21.4.9 0 8.5-4.7 16.7-10.4L57 212.1l1.7 3c1.1 1.9 2.5 2.9 3.6 2.7 2.2-.3 31.6-20.9 31.7-22.1 0-.5-1.3-2.7-2.9-5-1.5-2.3-3.8-6.1-5-8.5-1.2-2.3-2.7-4.2-3.4-4.2-.6 0-16.6 7.4-35.4 16.3M199 201.6c-2.5 2.5-5.7 5.3-7.2 6.2-1.6.9-2.8 2.2-2.8 2.8 0 1.9 44.4 63.9 45.8 63.9 2.4 0 18.2-13.9 18.2-16 0-1.3-4.8-6.8-12.9-14.9l-13-12.9 2.5-1.9c1.3-1.1 2.4-2.8 2.4-3.8 0-1.6-26.3-28-27.9-28-.4 0-2.7 2.1-5.1 4.6M69.1 226.4c-16.6 16.7-27.2 27.9-27 28.8.5 1.9 16.9 15.8 18.6 15.8.7 0 6-6.8 11.9-15 5.9-8.3 11.3-15 12-15 .6 0 1.7.7 2.4 1.5 2.7 3.2 4.6 1.4 15.3-14 5.9-8.6 10.7-16 10.7-16.5s-1.6-2-3.5-3.3-5.3-4-7.5-6.1c-2.1-2-4.3-3.6-4.7-3.6-.5 0-13.1 12.3-28.2 27.4M182.7 213.6c-.3.3-4.3 1.9-8.9 3.5-4.7 1.6-8.3 3.4-8.2 4.1.1 1.4 17.8 65.9 19.5 71.6 1.3 4.1 2.3 4.1 14.8-.4 8-2.9 10.1-4 10.1-5.5 0-1.1-3.4-9.2-7.5-18.1-7.4-16-7.8-17.7-3.9-17.8.6 0 1.7-.7 2.4-1.5 1-1.2-.3-4.6-7.1-19-7.5-15.9-9.4-18.7-11.2-16.9M100.1 249.6c-9.2 19.9-16 35.9-15.5 36.4 1.4 1.3 19.3 8 21.5 8 2.4 0 2.3.3 8-20 3.4-12.3 4.9-16.4 6-16.1 6 1.7 6.7 1.4 7.8-2.5 7.4-28.6 9-34.8 8.8-34.9-.7-.3-19.6-6.5-19.9-6.5s-7.8 16-16.7 35.6M139.6 229.4c-.3 4.4-1.7 21.8-3.1 38.6s-2.5 30.8-2.5 31.2c0 .5 5.9.8 13 .8h13v-2.8c0-3.2-1.7-24.6-2.5-31.5l-.6-4.7h8.1v-4.3c0-2.3-.7-10.5-1.5-18.2s-1.5-14.7-1.5-15.6c0-1.5-1.4-1.7-10.9-1.7l-10.8.1z" })
    ], -1)
  ])]);
}
const NF = { render: IF }, MF = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  viewBox: "0 0 70 70"
};
function DF(t, n) {
  return c(), _("svg", MF, [...n[0] || (n[0] = [
    d("path", {
      d: "m59.4 49.7-2.6-2.9-2.7 2.9H37.4V36.2h-5.3l6.6-15.1h6.4l2.3 5.2v-5.2h8l1.4 3.9 1.4-3.9h6.1v-2.3c0-1.4-1.1-2.5-2.5-2.5H8.2c-1.4 0-2.5 1.1-2.5 2.5v32.5c0 1.4 1.1 2.5 2.5 2.5h53.6c1.4 0 2.5-1.1 2.5-2.5v-1.6z",
      style: { fill: "#0071ce" }
    }, null, -1),
    d("path", {
      d: "M60.1 48.1h4.2l-5.5-5.9 5.5-5.8h-4.1l-3.5 3.8-3.4-3.8h-4.2l5.6 5.9-5.6 5.8h4.1l3.5-3.8z",
      style: { fill: "#0071ce" }
    }, null, -1),
    d("path", {
      d: "M42.4 45.4v-1.8H49v-2.7h-6.6v-1.8h6.7v-2.7h-9.9v11.7h9.9v-2.7zM61.2 34.7h3V22.9l-4.8.1-2.6 7.3-2.7-7.3h-5v11.7h3.2v-8.2l3 8.2h2.8l3.1-8.2z",
      style: { fill: "#0071ce" }
    }, null, -1),
    d("path", {
      d: "M44 23h-4.1l-5.2 11.7h3.5l1-2.3h5.4l1 2.3h3.6zm-3.7 6.7 1.6-3.8 1.6 3.8zM61.4 41.9l2.9 3.2v-6.4z",
      style: { fill: "#0071ce" }
    }, null, -1)
  ])]);
}
const kF = { render: DF }, LF = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "203.209",
  height: "144",
  viewBox: "0 0 152.407 108"
};
function PF(t, n) {
  return c(), _("svg", LF, [...n[0] || (n[0] = [
    d("path", {
      d: "M0 0h152.407v108H0z",
      style: { fill: "none" }
    }, null, -1),
    d("path", {
      d: "M60.412 25.697h31.5v56.606h-31.5z",
      style: { fill: "#ff5f00" }
    }, null, -1),
    d("path", {
      d: "M382.208 306a35.94 35.94 0 0 1 13.75-28.303 36 36 0 1 0 0 56.606A35.94 35.94 0 0 1 382.208 306",
      style: { fill: "#eb001b" },
      transform: "translate(-319.796 -252)"
    }, null, -1),
    d("path", {
      d: "M454.203 306a35.999 35.999 0 0 1-58.245 28.303 36.005 36.005 0 0 0 0-56.606A35.999 35.999 0 0 1 454.203 306M450.769 328.308v-1.16h.467v-.235h-1.19v.236h.468v1.159Zm2.31 0v-1.398h-.364l-.42.962-.42-.962h-.365v1.398h.258v-1.054l.393.908h.267l.394-.91v1.056Z",
      style: { fill: "#f79e1b" },
      transform: "translate(-319.796 -252)"
    }, null, -1)
  ])]);
}
const BF = { render: PF }, FF = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  width: "1000",
  height: "324.683",
  overflow: "visible",
  style: { overflow: "visible" },
  viewBox: "0 0 1000 324.684"
};
function UF(t, n) {
  return c(), _("svg", FF, [...n[0] || (n[0] = [
    d("path", {
      d: "M651.185.5c-70.933 0-134.322 36.766-134.322 104.694 0 77.9 112.423 83.28 112.423 122.415 0 16.478-18.884 31.229-51.137 31.229-45.773 0-79.984-20.611-79.984-20.611l-14.638 68.547s39.41 17.41 91.734 17.41c77.552 0 138.576-38.572 138.576-107.66 0-82.316-112.89-87.537-112.89-123.86 0-12.91 15.501-27.053 47.662-27.053 36.286 0 65.892 14.99 65.892 14.99l14.326-66.204S696.614.5 651.185.5M2.218 5.497.5 15.49s29.842 5.461 56.719 16.356c34.606 12.492 37.072 19.765 42.9 42.353l63.51 244.832h85.138L379.927 5.497h-84.942L210.707 218.67l-34.39-180.696c-3.154-20.68-19.13-32.477-38.685-32.477zm411.865 0L347.449 319.03h80.999l66.4-313.534zm451.759 0c-19.532 0-29.88 10.457-37.474 28.73L709.699 319.03h84.942l16.434-47.468h103.483l9.994 47.468H999.5L934.115 5.497zm11.047 84.707 25.178 117.653h-67.454z",
      style: { fill: "#1434cb", "fill-opacity": "1", stroke: "none" }
    }, null, -1)
  ])]);
}
const $F = { render: UF }, VF = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function HF(t, n) {
  return c(), _("svg", VF, [...n[0] || (n[0] = [
    d("path", {
      stroke: "currentColor",
      "stroke-width": "2",
      d: "M2 5a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v9.586a1 1 0 0 1-.293.707l-4.414 4.414a1 1 0 0 1-.707.293H3a1 1 0 0 1-1-1z"
    }, null, -1),
    d("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "2",
      d: "M8 12h8"
    }, null, -1)
  ])]);
}
const GF = { render: HF }, YF = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function zF(t, n) {
  return c(), _("svg", YF, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      d: "M5.625 3.75v12.5h2.5V3.75zM11.875 3.75v12.5h2.5V3.75z"
    }, null, -1)
  ])]);
}
const ZF = { render: zF }, qF = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function WF(t, n) {
  return c(), _("svg", qF, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      d: "M7.813 9.375c.517 0 .937.42.937.938v1.874a.937.937 0 1 1-1.875 0v-1.874c0-.518.42-.938.938-.938M13.125 10.313a.937.937 0 1 0-1.875 0v1.874a.937.937 0 1 0 1.875 0z"
    }, null, -1),
    d("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.625 4.245a1.563 1.563 0 1 0-1.25 0v1.068h-3.75a2.813 2.813 0 0 0-2.812 2.812v1.594a1.563 1.563 0 0 0 0 3.062v1.594a2.813 2.813 0 0 0 2.812 2.813h8.75a2.813 2.813 0 0 0 2.813-2.813v-1.594a1.563 1.563 0 0 0 0-3.062V8.125a2.813 2.813 0 0 0-2.813-2.812h-3.75zm4.688 3.88v6.25c0 .518-.42.938-.938.938h-8.75a.937.937 0 0 1-.937-.938v-6.25c0-.518.42-.937.937-.937h8.75c.518 0 .938.42.938.937",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const jF = { render: WF }, KF = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function QF(t, n) {
  return c(), _("svg", KF, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      d: "M5 4.688A.31.31 0 0 0 4.688 5v10c0 .173.14.313.312.313h8.75v1.874H5A2.19 2.19 0 0 1 2.813 15V5c0-1.208.979-2.187 2.187-2.187h7.5c1.208 0 2.188.979 2.188 2.187v1.25h-1.876V5a.31.31 0 0 0-.312-.312z"
    }, null, -1),
    d("path", {
      fill: "currentColor",
      d: "m9.337 5.587-2.5 2.5a.937.937 0 0 0 0 1.326l2.5 2.5 1.326-1.326-.9-.9h3.987V7.814H9.763l.9-.9zM18.163 13.163a.937.937 0 0 0 0-1.326l-2.5-2.5-1.326 1.326.9.9H11.25v1.875h3.987l-.9.9 1.326 1.325z"
    }, null, -1)
  ])]);
}
const XF = { render: QF }, JF = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function eU(t, n) {
  return c(), _("svg", JF, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      d: "M7.69 5.44c-.802.211-1.032 1.219-.419 1.832l5.457 5.456c.613.613 1.62.383 1.831-.418l1.94-7.398c.219-.83-.581-1.63-1.411-1.412zM2.485 16.41a.781.781 0 0 0 1.105 1.105l5.088-5.088a.781.781 0 1 0-1.105-1.104zM10.874 13.532c.307.303.31.798.007 1.105l-1.026 1.037a.781.781 0 1 1-1.11-1.098l1.025-1.038a.78.78 0 0 1 1.104-.006M5.36 9.123 3.823 10.66a.781.781 0 1 0 1.105 1.105l1.537-1.538A.781.781 0 0 0 5.36 9.123"
    }, null, -1)
  ])]);
}
const tU = { render: eU }, nU = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function rU(t, n) {
  return c(), _("svg", nU, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      d: "M9.062 17.5v-5.876l-5.088 2.938-.938-1.624L8.248 9.93 3.28 7.062l.938-1.624 4.843 2.797V2.5h1.875v5.876l5.09-2.938.937 1.624-4.966 2.867 5.211 3.01-.937 1.623-5.335-3.08V17.5z"
    }, null, -1)
  ])]);
}
const aU = { render: rU }, oU = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function iU(t, n) {
  return c(), _("svg", oU, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M15 8.438a3.44 3.44 0 0 1-3.308-2.5H7.263l6.061 6.06a3.437 3.437 0 1 1-1.326 1.326l-6.06-6.06v4.428A3.439 3.439 0 0 1 5 18.438a3.437 3.437 0 0 1-.937-6.746V6.977a2.188 2.188 0 1 1 2.914-2.915h4.715A3.439 3.439 0 0 1 18.438 5 3.437 3.437 0 0 1 15 8.438m0-5a1.563 1.563 0 1 0 0 3.125 1.563 1.563 0 0 0 0-3.125m-10 10a1.563 1.563 0 1 0 0 3.125 1.563 1.563 0 0 0 0-3.125M13.438 15a1.563 1.563 0 1 1 3.125 0 1.563 1.563 0 0 1-3.125 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const sU = { render: iU }, lU = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function cU(t, n) {
  return c(), _("svg", lU, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.692 4.063A3.439 3.439 0 0 1 18.438 5a3.437 3.437 0 0 1-6.746.938H6.977a2.2 2.2 0 0 1-1.04 1.039v4.715A3.439 3.439 0 0 1 5 18.438a3.437 3.437 0 0 1-.937-6.746V6.977a2.188 2.188 0 1 1 2.914-2.915zM15 3.438a1.563 1.563 0 1 0 0 3.125 1.563 1.563 0 0 0 0-3.125m-10 10a1.563 1.563 0 1 0 0 3.125 1.563 1.563 0 0 0 0-3.125",
      "clip-rule": "evenodd"
    }, null, -1),
    d("path", {
      fill: "currentColor",
      d: "M12.386 10.107c-.511-.313-1.136.099-1.136.749v5.788c0 .65.625 1.062 1.136.749l4.717-2.894c.53-.325.53-1.173 0-1.498z"
    }, null, -1)
  ])]);
}
const uU = { render: cU }, dU = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function _U(t, n) {
  return c(), _("svg", dU, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      d: "M17.85 5.468A9.06 9.06 0 0 0 10 .938v1.875a7.19 7.19 0 0 1 6.226 3.593zM14.872 7.187A5.62 5.62 0 0 0 10 4.375V6.25c1.388 0 2.6.754 3.248 1.875zM2.813 10c0-1.31.35-2.537.961-3.594L2.15 5.468A9 9 0 0 0 .938 10a9 9 0 0 0 1.212 4.532l1.624-.938A7.15 7.15 0 0 1 2.813 10M4.375 10a5.6 5.6 0 0 1 .753-2.813l1.624.938A3.73 3.73 0 0 0 6.25 10c0 .683.183 1.324.502 1.875l-1.624.938A5.6 5.6 0 0 1 4.375 10M10 12.188a2.188 2.188 0 1 0 0-4.376 2.188 2.188 0 0 0 0 4.376M14.872 12.813A5.62 5.62 0 0 1 10 15.625V13.75c1.388 0 2.6-.754 3.248-1.874zM10 19.063v-1.875a7.19 7.19 0 0 0 6.226-3.593l1.624.937a9.06 9.06 0 0 1-7.85 4.53"
    }, null, -1)
  ])]);
}
const pU = { render: _U }, mU = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function gU(t, n) {
  return c(), _("svg", mU, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4 4.598C4 3.384 5.2 2.615 6.181 3.2l9.057 5.402c1.016.606 1.016 2.19 0 2.796L6.182 16.8C5.2 17.385 4 16.616 4 15.402z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const fU = { render: gU }, hU = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 76 76"
};
function vU(t, n) {
  return c(), _("svg", hU, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M15.89 15.07 38 26.543v22.935l22.104-11.47.007.004V15.068l-.003.001L38 3.598z",
      "clip-rule": "evenodd"
    }, null, -1),
    d("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M15.89 15.07 38 26.543v22.935l22.104-11.47.007.004V15.068l-.003.001L38 3.598z",
      "clip-rule": "evenodd"
    }, null, -1),
    d("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M37.987 49.464 15.89 38v22.944l.013-.006L38 72.402V49.457z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const EU = { render: vU }, bU = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function SU(t, n) {
  return c(), _("svg", bU, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9.156 9.063a4.69 4.69 0 0 1 9.282.937 4.688 4.688 0 0 1-9.282.938H5.727a2.188 2.188 0 1 1 0-1.876zm4.594-1.876a2.813 2.813 0 1 0 0 5.626 2.813 2.813 0 0 0 0-5.626",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const wU = { render: SU }, yU = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function TU(t, n) {
  return c(), _("svg", yU, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M15 9.688a3.44 3.44 0 0 1-3.308-2.5H5.727a2.188 2.188 0 1 1 0-1.875h5.965a3.439 3.439 0 0 1 6.746.937A3.437 3.437 0 0 1 15 9.688m0-5a1.563 1.563 0 1 0 0 3.125 1.563 1.563 0 0 0 0-3.125",
      "clip-rule": "evenodd"
    }, null, -1),
    d("path", {
      fill: "currentColor",
      d: "M14.063 14.916a.625.625 0 0 0 0-1.082l-5.626-3.248a.625.625 0 0 0-.937.541v6.496c0 .48.52.781.938.54z"
    }, null, -1)
  ])]);
}
const CU = { render: TU }, xU = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function AU(t, n) {
  return c(), _("svg", xU, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      d: "M3.958 2.813c-.439 0-.708.267-.817.406a1.4 1.4 0 0 0-.22.418c-.077.232-.108.493-.108.738v11.25c0 .245.031.506.109.738.037.112.101.27.219.418.109.139.378.407.817.407h1.98v-1.875h-1.25V4.688h1.25V2.813zM16.042 2.813c.439 0 .708.267.817.406.117.149.182.306.22.418.077.232.108.493.108.738v11.25c0 .245-.031.506-.109.738a1.4 1.4 0 0 1-.219.418c-.109.139-.378.407-.817.407h-1.98v-1.875h1.25V4.688h-1.25V2.813zM10 8.31l1.72-2.58 1.56 1.04L11.127 10l2.153 3.23-1.56 1.04L10 11.69l-1.72 2.58-1.56-1.04L8.873 10 6.72 6.77l1.56-1.04z"
    }, null, -1)
  ])]);
}
const RU = { render: AU }, OU = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function IU(t, n) {
  return c(), _("svg", OU, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      d: "M7.341 5.626a2.659 2.659 0 1 1 5.158.912l1.467.536A4.221 4.221 0 1 0 7.263 8.84l-2.27 3.974a1.563 1.563 0 1 0 1.357.775l3.008-5.265-.677-.388a2.66 2.66 0 0 1-1.34-2.31"
    }, null, -1),
    d("path", {
      fill: "currentColor",
      d: "M11.35 6.414a1.563 1.563 0 1 0-1.357.775l3.01 5.269.68-.389a2.656 2.656 0 1 1-.718 4.014l-1.197 1.004a4.219 4.219 0 1 0 1.853-6.7z"
    }, null, -1),
    d("path", {
      fill: "currentColor",
      d: "M16.563 14.376a1.562 1.562 0 0 1-2.916.782h-4.5a4.22 4.22 0 1 1-4.874-4.938l.268 1.54a2.657 2.657 0 1 0 3.115 2.616v-.781h5.99a1.562 1.562 0 0 1 2.916.781"
    }, null, -1)
  ])]);
}
const NU = { render: IU }, MU = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.5",
  "aria-hidden": "true",
  class: "p-icon icons-doc__icon",
  viewBox: "0 0 24 24"
};
function DU(t, n) {
  return c(), _("svg", MU, [...n[0] || (n[0] = [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M8.25 3v1.5M4.5 8.25H3m18 0h-1.5M4.5 12H3m18 0h-1.5m-15 3.75H3m18 0h-1.5M8.25 19.5V21M12 3v1.5m0 15V21m3.75-18v1.5m0 15V21m-9-1.5h10.5a2.25 2.25 0 0 0 2.25-2.25V6.75a2.25 2.25 0 0 0-2.25-2.25H6.75A2.25 2.25 0 0 0 4.5 6.75v10.5a2.25 2.25 0 0 0 2.25 2.25m.75-12h9v9h-9z"
    }, null, -1)
  ])]);
}
const kU = { render: DU }, LU = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
function PU(t, n) {
  return c(), _("svg", LU, [...n[0] || (n[0] = [
    d("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "m4 16.01.01-.011M4 8.01l.01-.011M4 12.01l.01-.011M8 20.01l.01-.011M12 20.01l.01-.011M16 20.01l.01-.011M20 16.01l.01-.011M20 12.01l.01-.011M20 8.01l.01-.011M16 4.01l.01-.011M12 4.01l.01-.011M8 4.01l.01-.011M8 16V8h8v8z"
    }, null, -1)
  ])]);
}
const BU = { render: PU }, FU = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function UU(t, n) {
  return c(), _("svg", FU, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      d: "M10 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
    }, null, -1),
    d("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.775 9.063a6.3 6.3 0 0 1 5.288-5.288v-1.9h1.874v1.9a6.3 6.3 0 0 1 5.288 5.288h1.9v1.874h-1.9a6.3 6.3 0 0 1-5.288 5.288v1.9H9.064v-1.9a6.3 6.3 0 0 1-5.288-5.288h-1.9V9.064zM5.58 10a4.42 4.42 0 1 1 8.84 0 4.42 4.42 0 0 1-8.84 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const $U = { render: UU }, VU = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function HU(t, n) {
  return c(), _("svg", VU, [...n[0] || (n[0] = [
    d("path", {
      stroke: "currentColor",
      "stroke-width": "2",
      d: "M2 5a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v9.586a1 1 0 0 1-.293.707l-4.414 4.414a1 1 0 0 1-.707.293H3a1 1 0 0 1-1-1z"
    }, null, -1),
    d("path", {
      stroke: "currentColor",
      "stroke-width": "2",
      d: "m8 11 4 4 4-4M12 4v11"
    }, null, -1)
  ])]);
}
const GU = { render: HU }, YU = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function zU(t, n) {
  return c(), _("svg", YU, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.021 8.167a6.98 6.98 0 0 1 13.958 0c0 .502-.037 1-.152 1.513l-.204.915-1.83-.41.205-.915c.076-.34.106-.695.106-1.103A5.104 5.104 0 1 0 10 13.27h1.486l-2.004-2.004 1.326-1.326 3.604 3.605.039.04.623.624-.656.656-.01.01-3.6 3.6-1.326-1.326 2.004-2.004H10a6.98 6.98 0 0 1-6.979-6.98",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const ZU = { render: zU }, qU = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function WU(t, n) {
  return c(), _("svg", qU, [...n[0] || (n[0] = [
    d("path", {
      stroke: "currentColor",
      "stroke-width": "2",
      d: "M2 5a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v9.586a1 1 0 0 1-.293.707l-4.414 4.414a1 1 0 0 1-.707.293H3a1 1 0 0 1-1-1z"
    }, null, -1),
    d("path", {
      stroke: "currentColor",
      "stroke-width": "1.5",
      d: "M12 9V7m2 3 1.5-1.5M12 17v-2m-3.5.5L10 14M8.5 8.5 10 10m-3 2h2m8 0h-2m.5 3.5L14 14"
    }, null, -1)
  ])]);
}
const jU = { render: WU }, KU = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function QU(t, n) {
  return c(), _("svg", KU, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "m6.837 14.413-3.75-3.75a.937.937 0 0 1 0-1.326l3.75-3.75 1.326 1.326-2.15 2.15h9.3V5h1.874v5c0 .518-.42.938-.937.938H6.013l2.15 2.15z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const XU = { render: QU }, JU = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function e$(t, n) {
  return c(), _("svg", JU, [...n[0] || (n[0] = [
    d("path", {
      stroke: "currentColor",
      "stroke-width": "2",
      d: "M2 5a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v9.586a1 1 0 0 1-.293.707l-4.414 4.414a1 1 0 0 1-.707.293H3a1 1 0 0 1-1-1z"
    }, null, -1),
    d("path", {
      fill: "currentColor",
      d: "m9 16 7-4-7-4.5z"
    }, null, -1)
  ])]);
}
const t$ = { render: e$ }, n$ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function r$(t, n) {
  return c(), _("svg", n$, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.5 16.199a.53.53 0 0 0-.372-.497 6 6 0 0 1-.836-.346.53.53 0 0 0-.614.087l-.567.567a.5.5 0 0 1-.707 0L3.99 14.596a.5.5 0 0 1 0-.707l.566-.567a.53.53 0 0 0 .088-.614 6 6 0 0 1-.347-.836.53.53 0 0 0-.496-.372H3a.5.5 0 0 1-.5-.5V9a.5.5 0 0 1 .5-.5h.8a.53.53 0 0 0 .497-.372q.143-.435.347-.836a.53.53 0 0 0-.088-.614L3.99 6.11a.5.5 0 0 1 0-.707L5.404 3.99a.5.5 0 0 1 .707 0l.567.566a.53.53 0 0 0 .614.088q.402-.204.836-.346A.53.53 0 0 0 8.5 3.8V3a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5V3.8a.53.53 0 0 0 .372.497q.434.142.836.346a.53.53 0 0 0 .614-.087l.567-.567a.5.5 0 0 1 .707 0l1.414 1.414a.5.5 0 0 1 0 .707l-.567.567a.53.53 0 0 0-.088.614q.204.402.347.836a.53.53 0 0 0 .496.372H17a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-.802a.53.53 0 0 0-.496.372q-.143.434-.347.836a.53.53 0 0 0 .088.614l.567.567a.5.5 0 0 1 0 .707l-1.414 1.414a.5.5 0 0 1-.707 0l-.567-.567a.53.53 0 0 0-.614-.088 6 6 0 0 1-.836.347.53.53 0 0 0-.372.496V17a.5.5 0 0 1-.5.5H9a.5.5 0 0 1-.5-.5zm1.5-3.074a3.125 3.125 0 1 0 0-6.25 3.125 3.125 0 0 0 0 6.25",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const a$ = { render: r$ }, o$ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function i$(t, n) {
  return c(), _("svg", o$, [...n[0] || (n[0] = [
    d("path", {
      stroke: "currentColor",
      "stroke-width": "2",
      d: "M2 9h20M2 19V5a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v9.586a1 1 0 0 1-.293.707l-4.414 4.414a1 1 0 0 1-.707.293H3a1 1 0 0 1-1-1Z"
    }, null, -1),
    d("path", {
      fill: "currentColor",
      d: "M5 12h5v5H5z"
    }, null, -1)
  ])]);
}
const s$ = { render: i$ }, l$ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function c$(t, n) {
  return c(), _("svg", l$, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.75 4.688a4.062 4.062 0 1 0 0 8.124 4.062 4.062 0 0 0 0-8.124M2.813 8.75a5.938 5.938 0 1 1 10.769 3.451l4.01 4.011-1.325 1.326-4.002-4.002A5.937 5.937 0 0 1 2.813 8.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const u$ = { render: c$ }, d$ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function _$(t, n) {
  return c(), _("svg", d$, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "m15.663 8.163-5 5a.94.94 0 0 1-1.326 0l-5-5 1.326-1.326L10 11.174l4.337-4.337z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const p$ = { render: _$ }, m$ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
};
function g$(t, n) {
  return c(), _("svg", m$, [...n[0] || (n[0] = [
    d("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "3",
      d: "M15 23.333C8.557 23.333 5 28.557 5 35h11.667m6.666-23.333a6.667 6.667 0 1 1-13.333 0 6.667 6.667 0 0 1 13.333 0"
    }, null, -1),
    d("path", {
      stroke: "currentColor",
      "stroke-width": "3",
      d: "M25.826 19.229a2 2 0 0 1 3.348 0l1.093 1.672a2 2 0 0 0 1.564.903l1.994.11a2 2 0 0 1 1.675 2.9l-.902 1.782a2 2 0 0 0 0 1.806l.902 1.783a2 2 0 0 1-1.675 2.9l-1.994.11a2 2 0 0 0-1.564.903l-1.093 1.672a2 2 0 0 1-3.348 0l-1.093-1.672a2 2 0 0 0-1.564-.903l-1.994-.11a2 2 0 0 1-1.675-2.9l.902-1.783a2 2 0 0 0 0-1.806l-.902-1.782a2 2 0 0 1 1.675-2.9l1.994-.11a2 2 0 0 0 1.564-.903z"
    }, null, -1),
    d("circle", {
      cx: "27.5",
      cy: "27.5",
      r: "2.5",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const f$ = { render: g$ }, h$ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
};
function v$(t, n) {
  return c(), _("svg", h$, [...n[0] || (n[0] = [
    d("path", {
      fill: "#2EB67D",
      d: "M33 8a4 4 0 0 0-8 0v11a4 4 0 0 0 8 0zM43 19a4 4 0 0 1-4 4h-4v-4a4 4 0 0 1 8 0"
    }, null, -1),
    d("path", {
      fill: "#36C5F0",
      d: "M8 14a4 4 0 0 0 0 8h11a4 4 0 0 0 0-8zM19 4a4 4 0 0 1 4 4v4h-4a4 4 0 0 1 0-8"
    }, null, -1),
    d("path", {
      fill: "#E01E5A",
      d: "M14 39.006C14 41.212 15.791 43 18 43s4-1.788 4-3.994V28.022c0-2.206-1.791-3.994-4-3.994s-4 1.788-4 3.994zM4 28.022a3.997 3.997 0 0 1 4-3.994h4v3.994c0 2.206-1.791 3.994-4 3.994s-4-1.788-4-3.994"
    }, null, -1),
    d("path", {
      fill: "#ECB22E",
      d: "M39 33a4 4 0 0 0 0-8H28a4 4 0 0 0 0 8zM28 43a4 4 0 0 1-4-4v-4h4a4 4 0 0 1 0 8"
    }, null, -1)
  ])]);
}
const E$ = { render: v$ }, b$ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function S$(t, n) {
  return c(), _("svg", b$, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.179 4.97a.67.67 0 0 0-.622.708c.43 5.155.843 9.332 7.227 11.742a.62.62 0 0 0 .433 0c6.384-2.41 6.797-6.587 7.227-11.742a.67.67 0 0 0-.622-.709c-1.727-.14-4.572-.78-6.387-2.117a.74.74 0 0 0-.869 0C7.75 4.19 4.906 4.828 3.179 4.969m7.759 6.28v-5H9.063v5zm0 1.25H9.063v1.875h1.875z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const w$ = { render: S$ }, y$ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function T$(t, n) {
  return c(), _("svg", y$, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.179 4.97a.67.67 0 0 0-.622.708c.43 5.155.843 9.332 7.227 11.742a.62.62 0 0 0 .433 0c6.384-2.41 6.797-6.587 7.227-11.742a.67.67 0 0 0-.622-.709c-1.727-.14-4.572-.78-6.387-2.117a.74.74 0 0 0-.869 0C7.75 4.19 4.906 4.828 3.179 4.969m6.645 8.166 4.615-5-1.378-1.272-3.999 4.333-2.198-1.905-1.228 1.417 2.885 2.5c.382.331.96.299 1.303-.073",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const C$ = { render: T$ }, x$ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function A$(t, n) {
  return c(), _("svg", x$, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      d: "M3.333 2.5c-.92 0-1.666.746-1.666 1.667V5c0 .455.121.882.334 1.25h15.998c.212-.368.334-.795.334-1.25v-.833c0-.92-.746-1.667-1.666-1.667z"
    }, null, -1),
    d("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.333 15V7.5h13.333V15a2.5 2.5 0 0 1-2.5 2.5H5.833a2.5 2.5 0 0 1-2.5-2.5m8.565.624-1.933-1.932-1.932 1.933-1.192-1.192L8.773 12.5 6.84 10.567l1.192-1.192 1.933 1.933 1.933-1.932 1.192 1.192-1.933 1.932 1.933 1.932z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const R$ = { render: A$ }, O$ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function I$(t, n) {
  return c(), _("svg", O$, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M17.5 10a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0m-3.914-3.816 1.48 1.152-4.95 6.365a.938.938 0 0 1-1.404.087L5.55 10.625l1.326-1.326 2.412 2.412z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const N$ = { render: I$ }, M$ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function D$(t, n) {
  return c(), _("svg", M$, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      d: "M3.672 5.625 1.69 3.148l1.62-1.296L5 3.964l1.69-2.112 1.62 1.296L6.33 5.625 8.31 8.102 6.69 9.398 5 7.286 3.31 9.398 1.69 8.102zM13.672 5.625 11.69 3.148l1.62-1.296L15 3.964l1.69-2.112 1.62 1.296-1.981 2.477 1.981 2.477-1.62 1.296L15 7.286l-1.69 2.112-1.62-1.296z"
    }, null, -1),
    d("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6.4 15.368a.21.21 0 0 0-.3 0l-2.866 2.866-1.467-1.468L4.633 13.9a2.29 2.29 0 0 1 3.235 0l1.982 1.983a.21.21 0 0 0 .3 0l1.983-1.983a2.29 2.29 0 0 1 3.235 0l2.866 2.866-1.467 1.468-2.867-2.867a.21.21 0 0 0-.3 0l-1.982 1.983a2.29 2.29 0 0 1-3.235 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const k$ = { render: D$ }, L$ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function P$(t, n) {
  return c(), _("svg", L$, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.9 3.294 2.241 15.657a1.25 1.25 0 0 0 1.1 1.843h13.572c.83 0 1.359-.886.966-1.616L11.1 3.294a1.25 1.25 0 0 0-2.2 0m.058 3.268v5.626h2.084V6.562zm.104 7.5v1.876h1.875v-1.876z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const B$ = { render: P$ }, F$ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function U$(t, n) {
  return c(), _("svg", F$, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M15 4.166v-2.5h-1.666v2.5H6.667v-2.5H5v2.5h-.833A.833.833 0 0 0 3.334 5v10c0 .92.746 1.666 1.666 1.666h10c.92 0 1.667-.746 1.667-1.666V5a.833.833 0 0 0-.834-.834zm-5.834 6.667V6.666h1.667v4.167zm0 3.334V12.5h1.667v1.667z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const $$ = { render: U$ }, V$ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function H$(t, n) {
  return c(), _("svg", V$, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M17.5 10a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0m-8.75 3.75H6.875v-7.5H8.75zm2.5 0h1.875v-7.5H11.25z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const G$ = { render: H$ }, Y$ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function z$(t, n) {
  return c(), _("svg", Y$, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10 17.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15M7.5 8.75H5v2.5h2.5zm5 0H15v2.5h-2.5zm-3.75 0h2.5v2.5h-2.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const Z$ = { render: z$ }, q$ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function W$(t, n) {
  return c(), _("svg", q$, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.021 9.167a6.98 6.98 0 0 1 13.958 0c0 .502-.037 1-.152 1.513l-.204.915-1.83-.41.205-.915c.076-.34.106-.695.106-1.103A5.104 5.104 0 1 0 10 14.27h1.486l-2.004-2.004 1.326-1.326 3.604 3.605.039.04.623.624-.656.656-.01.01-3.6 3.6-1.326-1.326 2.004-2.004H10a6.98 6.98 0 0 1-6.979-6.98",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const j$ = { render: W$ }, K$ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function Q$(t, n) {
  return c(), _("svg", K$, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M17.5 10a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0m-3.437.541L8.436 13.79a.625.625 0 0 1-.937-.541V6.752c0-.48.52-.781.938-.54l5.624 3.247a.625.625 0 0 1 0 1.082",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const X$ = { render: Q$ }, J$ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function eV(t, n) {
  return c(), _("svg", J$, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M15 4.166v-2.5h-1.666v2.5H6.667v-2.5H5.001v2.5h-.834A.833.833 0 0 0 3.334 5v10c0 .92.746 1.666 1.667 1.666h10c.92 0 1.666-.746 1.666-1.666V5a.833.833 0 0 0-.833-.834zm-9.166 5h8.333V7.499H5.834z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const tV = { render: eV }, nV = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function rV(t, n) {
  return c(), _("svg", nV, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10 17.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15M9.063 11V5.063h1.874v5h3.75v1.874H10A.937.937 0 0 1 9.063 11",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const aV = { render: rV }, oV = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function iV(t, n) {
  return c(), _("svg", oV, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10 17.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15M7.819 5.827l-.593.522 1.11 1.274.52-.454c.208-.213.794-.599 1.486-.44.865.2 1.086.707 1.086 1.194 0 .39-.44.743-.66.864-.14.05-.53.26-.98.692a2.02 2.02 0 0 0-.617 1.445v.967h1.695v-.967c0-.172.272-.41.611-.587.271-.142.576-.367.694-.461.404-.332 1.152-1.296.917-2.505-.295-1.51-1.665-2.367-3.067-2.371-1.121-.004-1.936.55-2.202.827M9.168 15v-1.698h1.698V15z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const sV = { render: iV }, lV = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function cV(t, n) {
  return c(), _("svg", lV, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M16.25 10.938H3.75V9.062h12.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const uV = { render: cV }, dV = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function _V(t, n) {
  return c(), _("svg", dV, [...n[0] || (n[0] = [
    d("path", {
      stroke: "currentColor",
      "stroke-width": "2",
      d: "M21 12a9 9 0 0 1-9 9m9-9a9 9 0 0 0-9-9m9 9h3m-12 9a9 9 0 0 1-9-9m9 9v3M3 12a9 9 0 0 1 9-9m-9 9H0m12-9V0"
    }, null, -1),
    d("circle", {
      cx: "12",
      cy: "12",
      r: "3",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const pV = { render: _V }, mV = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function gV(t, n) {
  return c(), _("svg", mV, [...n[0] || (n[0] = [
    d("path", {
      stroke: "currentColor",
      "stroke-width": "2",
      d: "M12 5V1m0 4a7 7 0 0 0 0 14m0-14a7 7 0 1 1 0 14m0 4v-4"
    }, null, -1)
  ])]);
}
const fV = { render: gV }, hV = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function vV(t, n) {
  return c(), _("svg", hV, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      d: "M17.064 12.525c.151-.422-.338-.759-.748-.575A6.25 6.25 0 0 1 8.05 3.684c.185-.408-.152-.898-.574-.747a7.5 7.5 0 1 0 9.59 9.59"
    }, null, -1)
  ])]);
}
const EV = { render: vV }, bV = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function SV(t, n) {
  return c(), _("svg", bV, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      d: "M9.063 5V1.875h1.874V5zM3.592 4.918l2.21 2.21 1.325-1.326-2.21-2.21zM13.75 10a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0M5 10.938H1.875V9.062H5zM15.082 3.592l-2.21 2.21 1.326 1.325 2.21-2.21zM15 10.938h3.125V9.062H15zM15.082 16.408l-2.21-2.21 1.326-1.325 2.21 2.21zM9.063 15v3.125h1.874V15zM3.592 15.082l2.21-2.21 1.325 1.326-2.21 2.21z"
    }, null, -1)
  ])]);
}
const wV = { render: SV }, yV = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function TV(t, n) {
  return c(), _("svg", yV, [...n[0] || (n[0] = [
    d("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10 17.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15M9.063 11V5.063h1.874v5h3.75v1.874H10A.937.937 0 0 1 9.063 11",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const CV = { render: TV }, xV = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function AV(t, n) {
  return c(), _("svg", xV, [...n[0] || (n[0] = [
    mi('<path stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="m6 17 3.942-6.57a4 4 0 1 1 6.047-3.132"></path><path stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="m12 7 3.942 6.57a4 4 0 1 1-.406 6.581"></path><path fill="currentColor" d="M10 17v-.75h-.75V17zm-5.243-3.004a.75.75 0 1 0-.574-1.386zM6 20.25A3.25 3.25 0 0 1 2.75 17h-1.5A4.75 4.75 0 0 0 6 21.75zM9.25 17A3.25 3.25 0 0 1 6 20.25v1.5A4.75 4.75 0 0 0 10.75 17zm.75.75h8v-1.5h-8zm-5.817-5.14A4.75 4.75 0 0 0 1.25 17h1.5c0-1.353.827-2.515 2.007-3.004z"></path><rect width="4" height="4" x="10" y="5" fill="currentColor" rx="2"></rect><rect width="4" height="4" x="16" y="15" fill="currentColor" rx="2"></rect><rect width="4" height="4" x="4" y="15" fill="currentColor" rx="2"></rect>', 6)
  ])]);
}
const RV = { render: AV }, Yh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ActionsMenu: RL,
  Add: NL,
  Agent: kL,
  ArrowKeys: BL,
  Artifact: $L,
  ArtifactImage: jL,
  ArtifactMarkdown: GL,
  ArtifactProgress: ZL,
  ArtifactResult: XL,
  ArtifactTable: tP,
  Attention: aP,
  Automation: sP,
  AwaitingRetry: uP,
  BitbucketColoredIcon: fP,
  BitbucketIcon: pP,
  Cancelled: EP,
  Check: wP,
  ClearInput: CP,
  Close: RP,
  Completed: NP,
  Copy: kP,
  Crashed: BP,
  Dashboard: $P,
  Date: GP,
  Delete: ZP,
  Docker: tB,
  Download: XP,
  DragHandle: jP,
  Edit: aB,
  Error: sB,
  ExternalLink: uB,
  Failed: pB,
  FeaturePreview: fB,
  Flow: EB,
  FlowRun: wB,
  Fullscreen: CB,
  Generate: RB,
  GitHubIcon: NB,
  GitlabColoredIcon: BB,
  GitlabIcon: kB,
  GoogleIcon: $B,
  HelpNav: GB,
  IncidentSeverityCritical: ZB,
  IncidentSeverityHigh: jB,
  IncidentSeverityLow: XB,
  IncidentSeverityMinor: tF,
  IncidentSeverityModerate: aF,
  IncidentSeverityUnknown: sF,
  Info: uF,
  Late: EF,
  LayoutGrid: pF,
  LayoutList: fF,
  MainMenu: wF,
  MicrosoftColoredIcon: CF,
  MicrosoftIcon: RF,
  OktaIcon: NF,
  PAutomation: jF,
  PBlock: XF,
  PDeployment: tU,
  PEvent: aU,
  PFlow: sU,
  PFlowRun: uU,
  PIncident: pU,
  PTask: wU,
  PTaskRun: CU,
  PVariable: RU,
  PWebhook: NU,
  PWorkPool: kU,
  PWorker: BU,
  Pause: ZF,
  PayAmex: kF,
  PayMastercard: BF,
  PayVisa: $F,
  Pending: GF,
  Play: fU,
  Prefect: EU,
  Recenter: $U,
  RetrievedCache: GU,
  Retry: ZU,
  Retrying: jU,
  ReturnKey: XU,
  Running: t$,
  SSODisabled: w$,
  SSOEnabled: C$,
  Scheduled: s$,
  Search: u$,
  SelectIndicator: p$,
  ServiceAccount: f$,
  Settings: a$,
  Slack: E$,
  StateCancelling: R$,
  StateComplete: N$,
  StateCrashed: k$,
  StateFailed: B$,
  StateLate: $$,
  StatePaused: G$,
  StatePending: Z$,
  StateRetrying: j$,
  StateRunning: X$,
  StateScheduled: tV,
  StateTimedOut: aV,
  StateUnknown: sV,
  Subtract: uV,
  Target: pV,
  Task: fV,
  ThemeDark: EV,
  ThemeLight: wV,
  Time: CV,
  Webhook: RV
}, Symbol.toStringTag, { value: "Module" })), Dn = /* @__PURE__ */ W({
  __name: "PIcon",
  props: {
    icon: {},
    solid: { type: Boolean },
    size: {}
  },
  setup(t) {
    const n = t, a = M(() => i(n.icon) ? Yh[n.icon] : n.solid ? CL[n.icon] : TI[n.icon]);
    function i(u) {
      return Object.keys(Yh).includes(u);
    }
    const s = M(() => n.size && `p-icon--${n.size}`);
    return (u, p) => (c(), G(Hr(a.value), {
      class: Oe(["p-icon", s.value])
    }, null, 8, ["class"]));
  }
}), kd = /* @__PURE__ */ W({
  __name: "PLoadingIcon",
  props: {
    size: { default: "default" }
  },
  setup(t) {
    const n = t, a = M(() => `p-loading-icon--${n.size}`);
    return (i, s) => (c(), _("div", {
      class: Oe(["p-loading-icon", a.value])
    }, [...s[0] || (s[0] = [
      d("div", { class: "p-loading-icon__segment" }, null, -1),
      d("div", { class: "p-loading-icon__segment" }, null, -1),
      d("div", { class: "p-loading-icon__segment" }, null, -1),
      d("div", { class: "p-loading-icon__segment" }, null, -1)
    ])], 2));
  }
}), OV = (t) => {
  t.component("PLoadingIcon", kd);
}, IV = {
  key: 0,
  class: "p-base-input__prepend"
}, NV = {
  key: 1,
  class: "p-base-input__append"
}, MV = {
  key: 2,
  class: "p-base-input__failed-icon"
}, DV = {
  key: 3,
  class: "p-base-input__pending-icon"
}, mo = /* @__PURE__ */ W({
  inheritAttrs: !1,
  __name: "PBaseInput",
  props: {
    state: {},
    prepend: {},
    append: {},
    disabled: { type: Boolean },
    small: { type: Boolean }
  },
  setup(t, { expose: n }) {
    const a = t, { classes: i, listeners: s, styles: u, attrs: p } = iy(), g = M(() => a.state?.valid === !1 && a.state.validated && !a.state.pending), E = z();
    n({ el: E });
    const h = M(() => [
      ...cl(i.value),
      {
        "p-base-input--disabled": a.disabled,
        "p-base-input--failed": g.value,
        "p-base-input--pending": a.state?.pending,
        "p-base-input--small": a.small
      }
    ]), f = M(() => a.small ? "small" : void 0), b = M(() => ({
      ...p.value,
      disabled: a.disabled,
      class: {
        "p-base-input__control": !0,
        "p-base-input__control--small": a.small
      }
    }));
    return (w, x) => (c(), _("div", oe({
      ref_key: "el",
      ref: E,
      class: ["p-base-input", h.value],
      style: y(u)
    }, y(s)), [
      w.prepend ? (c(), _("div", IV, ye(w.prepend), 1)) : le("", !0),
      I(w.$slots, "prepend"),
      I(w.$slots, "control", { attrs: b.value }),
      w.append ? (c(), _("div", NV, ye(w.append), 1)) : le("", !0),
      I(w.$slots, "append"),
      g.value ? (c(), _("div", MV, [
        ne(Dn, {
          icon: "ExclamationCircleIcon",
          size: f.value
        }, null, 8, ["size"])
      ])) : le("", !0),
      w.state?.pending ? (c(), _("div", DV, [
        ne(y(kd), { size: f.value }, null, 8, ["size"])
      ])) : le("", !0)
    ], 16));
  }
}), kV = (t) => {
  t.component("PBaseInput", mo);
}, LV = { class: "p-bread-crumbs" }, PV = /* @__PURE__ */ W({
  __name: "PBreadCrumbs",
  props: {
    crumbs: {}
  },
  setup(t) {
    const n = M(() => ({
      link: (a) => ({
        "p-bread-crumb__crumb--link": !!a.to
      })
    }));
    return (a, i) => (c(), _("nav", LV, [
      (c(!0), _(Qe, null, Ye(a.crumbs, (s, u) => (c(), _("div", {
        key: u,
        class: "p-bread-crumbs__crumb"
      }, [
        (c(), G(Hr(s.to ? "router-link" : "span"), {
          class: Oe(n.value.link(s)),
          to: s.to
        }, {
          default: N(() => [
            Ne(ye(s.text), 1)
          ]),
          _: 2
        }, 1032, ["class", "to"]))
      ]))), 128))
    ]));
  }
}), BV = (t) => {
  t.component("PBreadCrumbs", PV);
};
function X7(t) {
  var n, a, i = "";
  if (typeof t == "string" || typeof t == "number") i += t;
  else if (typeof t == "object") if (Array.isArray(t)) {
    var s = t.length;
    for (n = 0; n < s; n++) t[n] && (a = X7(t[n])) && (i && (i += " "), i += a);
  } else for (a in t) t[a] && (i && (i += " "), i += a);
  return i;
}
function FV() {
  for (var t, n, a = 0, i = "", s = arguments.length; a < s; a++) (t = arguments[a]) && (n = X7(t)) && (i && (i += " "), i += n);
  return i;
}
const zh = (t) => typeof t == "boolean" ? `${t}` : t === 0 ? "0" : t, Zh = FV, Kf = (t, n) => (a) => {
  var i;
  if (n?.variants == null) return Zh(t, a?.class, a?.className);
  const { variants: s, defaultVariants: u } = n, p = Object.keys(s).map((h) => {
    const f = a?.[h], b = u?.[h];
    if (f === null) return null;
    const w = zh(f) || zh(b);
    return s[h][w];
  }), g = a && Object.entries(a).reduce((h, f) => {
    let [b, w] = f;
    return w === void 0 || (h[b] = w), h;
  }, {}), E = n == null || (i = n.compoundVariants) === null || i === void 0 ? void 0 : i.reduce((h, f) => {
    let { class: b, className: w, ...x } = f;
    return Object.entries(x).every((A) => {
      let [D, L] = A;
      return Array.isArray(L) ? L.includes({
        ...u,
        ...g
      }[D]) : {
        ...u,
        ...g
      }[D] === L;
    }) ? [
      ...h,
      b,
      w
    ] : h;
  }, []);
  return Zh(t, p, E, a?.class, a?.className);
}, UV = { class: "p-button__content" }, rn = /* @__PURE__ */ W({
  __name: "PButton",
  props: {
    variant: {},
    size: {},
    solid: { type: Boolean },
    solidAppend: { type: Boolean },
    primary: { type: Boolean },
    flat: { type: Boolean },
    selected: { type: Boolean },
    icon: {},
    iconAppend: {},
    dangerous: { type: Boolean },
    to: {},
    small: { type: Boolean },
    disabled: { type: Boolean },
    loading: { type: Boolean }
  },
  setup(t, { expose: n }) {
    const a = Kf(
      "p-button",
      {
        variants: {
          variant: {
            default: "p-button--default",
            destructive: "p-button--destructive",
            outline: "p-button--outline",
            ghost: "p-button--ghost",
            link: "p-button--link"
          },
          size: {
            default: "px-3 py-1.5",
            sm: "text-sm px-2 py-1",
            lg: "h-11 rounded-md px-8",
            icon: "h-10 w-10"
          },
          icon: {
            true: "h-10 w-10"
          }
        },
        compoundVariants: [
          {
            size: "sm",
            icon: !0,
            class: "max-h-[30px] max-w-[30px]"
          }
        ],
        defaultVariants: {
          variant: "outline",
          size: "default"
        }
      }
    ), i = t, s = z();
    n({
      el: s
    });
    const u = M(() => i.to ? Wf(i.to) ? "a" : "router-link" : "button"), p = M(() => u.value === "a" ? {
      role: "button",
      href: i.to
    } : u.value === "button" ? {
      type: "button"
    } : {
      role: "button",
      to: i.to
    }), g = M(() => i.size === "sm" ? "small" : i.size === "lg" ? "large" : "default"), E = M(() => i.dangerous || i.variant === "destructive" ? "destructive" : i.primary || i.variant === "default" ? "default" : i.flat || i.variant === "ghost" ? "ghost" : i.variant === "link" ? "link" : "outline"), h = M(() => i.size ? i.size : i.small ? "sm" : "default");
    return (f, b) => (c(), G(Hr(u.value), oe({
      ref_key: "el",
      ref: s,
      class: y(a)({ variant: E.value, size: h.value, icon: f.icon && !f.$slots.default }),
      disabled: f.disabled || f.loading,
      "aria-selected": f.selected
    }, p.value), {
      default: N(() => [
        d("div", UV, [
          f.icon ? (c(), G(Dn, {
            key: 0,
            size: g.value ?? f.size,
            icon: f.icon,
            solid: f.solid,
            class: "p-button__icon"
          }, null, 8, ["size", "icon", "solid"])) : le("", !0),
          I(f.$slots, "default"),
          f.iconAppend ? (c(), G(Dn, {
            key: 1,
            size: g.value ?? f.size,
            icon: f.iconAppend,
            solid: f.solidAppend ?? f.solid,
            class: "p-button__icon"
          }, null, 8, ["size", "icon", "solid"])) : le("", !0)
        ]),
        f.loading ? (c(), G(kd, {
          key: 0,
          class: "p-button__loading-icon"
        })) : le("", !0)
      ]),
      _: 3
    }, 16, ["class", "disabled", "aria-selected"]));
  }
}), $V = (t) => {
  t.component("PButton", rn);
};
function VV(t) {
  return typeof t == "object";
}
function M0(t) {
  return t !== null && typeof t == "object" && !Array.isArray(t) && !Vl(t);
}
const HV = ["span", "range", "period", "around"];
function ZQ(t) {
  return HV.includes(t);
}
function GV(t) {
  return M0(t) && t.type === "span" && P7(t.seconds);
}
function YV(t) {
  return M0(t) && t.type === "range" && Vl(t.startDate) && Vl(t.endDate);
}
const zV = ["Today"];
function J7(t) {
  return zV.includes(t);
}
function ZV(t) {
  return M0(t) && t.type === "period" && J7(t.period);
}
const qV = ["second", "minute", "hour", "day"];
function WV(t) {
  return qV.includes(t);
}
function jV(t) {
  return M0(t) && t.type === "around" && Vl(t.date) && P7(t.quantity) && WV(t.unit);
}
function qQ(t) {
  return t == null ? !0 : GV(t) || YV(t) || jV(t) || ZV(t);
}
const Ie = {
  backspace: "Backspace",
  tab: "Tab",
  enter: "Enter",
  shift: "Shift",
  ctrl: "Control",
  alt: "Alt",
  pauseBreak: "Pause",
  capsLock: "CapsLock",
  escape: "Escape",
  space: " ",
  pageUp: "PageUp",
  pageDown: "PageDown",
  end: "End",
  home: "Home",
  leftArrow: "ArrowLeft",
  upArrow: "ArrowUp",
  rightArrow: "ArrowRight",
  downArrow: "ArrowDown",
  printScreen: "PrintScreen",
  insert: "Insert",
  delete: "Delete",
  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  a: "a",
  b: "b",
  c: "c",
  d: "d",
  e: "e",
  f: "f",
  g: "g",
  h: "h",
  i: "i",
  j: "j",
  k: "k",
  l: "l",
  m: "m",
  n: "n",
  o: "o",
  p: "p",
  q: "q",
  r: "r",
  s: "s",
  t: "t",
  u: "u",
  v: "v",
  w: "w",
  x: "x",
  y: "y",
  z: "z",
  A: "A",
  B: "B",
  C: "C",
  D: "D",
  E: "E",
  F: "F",
  G: "G",
  H: "H",
  I: "I",
  J: "J",
  K: "K",
  L: "L",
  M: "M",
  N: "N",
  O: "O",
  P: "P",
  Q: "Q",
  R: "R",
  S: "S",
  T: "T",
  U: "U",
  V: "V",
  W: "W",
  X: "X",
  Y: "Y",
  Z: "Z",
  windowKey: "Meta",
  contextKey: "ContextMenu",
  numpad0: "0",
  numpad1: "1",
  numpad2: "2",
  numpad3: "3",
  numpad4: "4",
  numpad5: "5",
  numpad6: "6",
  numpad7: "7",
  numpad8: "8",
  numpad9: "9",
  multiply: "*",
  add: "+",
  subtract: "-",
  "decimal-point": ".",
  divide: "/",
  f1: "F1",
  f2: "F2",
  f3: "F3",
  f4: "F4",
  f5: "F5",
  f6: "F6",
  f7: "F7",
  f8: "F8",
  f9: "F9",
  f10: "F10",
  f11: "F11",
  f12: "F12",
  numLock: "NumLock",
  scrollLock: "ScrollLock",
  audioVolumeMute: "AudioVolumeMute",
  audioVolumeDown: "AudioVolumeDown",
  audioVolumeUp: "AudioVolumeUp",
  mediaPlayer: "LaunchMediaPlayer",
  launchApplication1: "LaunchApplication1",
  launchApplication2: "LaunchApplication2",
  semiColon: ";",
  equalSign: "=",
  comma: ",",
  dash: "-",
  period: ".",
  forwardSlash: "/",
  tick: "`",
  openBracket: "[",
  backSlash: "\\",
  closeBracket: "]",
  singleQuote: "'"
}, e3 = [
  Ie.a,
  Ie.b,
  Ie.c,
  Ie.d,
  Ie.e,
  Ie.f,
  Ie.g,
  Ie.h,
  Ie.i,
  Ie.j,
  Ie.k,
  Ie.l,
  Ie.m,
  Ie.n,
  Ie.o,
  Ie.p,
  Ie.q,
  Ie.r,
  Ie.s,
  Ie.t,
  Ie.u,
  Ie.v,
  Ie.w,
  Ie.x,
  Ie.y,
  Ie.z
];
function WQ(t) {
  return e3.includes(t);
}
const t3 = [
  Ie[0],
  Ie[1],
  Ie[2],
  Ie[3],
  Ie[4],
  Ie[5],
  Ie[6],
  Ie[7],
  Ie[8],
  Ie[9]
];
function jQ(t) {
  return t3.includes(t);
}
const KV = [...e3, ...t3];
function Qf(t) {
  return KV.includes(t);
}
const QV = ["left", "right", "top", "bottom"];
function KQ(t) {
  return QV.includes(t);
}
function I2(t) {
  return t === "left" || t === "right";
}
function n3(t) {
  return t !== null && typeof t == "object" && "label" in t && "value" in t;
}
function gl(t) {
  return t !== null && typeof t == "object" && "label" in t && "options" in t && Array.isArray(t.options);
}
function XV(t) {
  return gl(t) && t.options.every((n) => typeof n == "object");
}
function JV(t, n) {
  return {
    ...t,
    options: r3(t.options, n)
  };
}
function r3(t, n) {
  return t.map((a) => gl(a) ? JV(a, n) : a).filter((a) => gl(a) ? a.options.length > 0 : a3(a, n));
}
function a3(t, n) {
  return typeof n != "string" ? !0 : t.label.toLowerCase().includes(n.toLowerCase());
}
function Ei(t) {
  return n3(t) ? t : gl(t) ? {
    ...t,
    options: t.options.map(Ei)
  } : { label: t ? t.toLocaleString() : "", value: t };
}
function Gl(t) {
  return t.flatMap((n) => n3(n) ? n : Gl(n.options));
}
function eH(t) {
  return typeof t == "object" && t !== null && "label" in t;
}
function Xf(t) {
  return eH(t) ? t : {
    label: t
  };
}
function tH(t) {
  return t !== null && typeof t == "object" && "label" in t && typeof t.label == "string" && "value" in t;
}
function Jf(t) {
  return tH(t) ? t : {
    label: t,
    value: t
  };
}
const QQ = ["date-left", "date-right", "stacked-left", "stacked-right", "stacked-center"], nH = { class: "p-button-group" }, rH = /* @__PURE__ */ W({
  __name: "PButtonGroup",
  props: {
    options: {},
    modelValue: {},
    small: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: n }) {
    const a = t, i = n, s = M(() => a.options.map((g) => VV(g) ? g : {
      label: String(g),
      value: g
    })), u = M({
      get() {
        return a.modelValue;
      },
      set(g) {
        i("update:modelValue", g);
      }
    }), p = (g) => {
      u.value = g;
    };
    return (g, E) => (c(), _("div", nH, [
      (c(!0), _(Qe, null, Ye(s.value, (h) => (c(), G(rn, {
        key: h.value,
        disabled: h.disabled,
        small: g.small,
        class: "p-button-group__button",
        selected: h.value === g.modelValue,
        icon: h.icon,
        "aria-selected": h.value === g.modelValue,
        onClick: (f) => p(h.value)
      }, mn({ _: 2 }, [
        h.label || g.$slots.default ? {
          name: "default",
          fn: N(() => [
            I(g.$slots, "default", { button: h }, () => [
              Ne(ye(h.label), 1)
            ])
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["disabled", "small", "selected", "icon", "aria-selected", "onClick"]))), 128))
    ]));
  }
}), aH = (t) => {
  t.component("PButtonGroup", rH);
}, o3 = /* @__PURE__ */ W({
  inheritAttrs: !1,
  __name: "PTooltipContent",
  props: {
    forceMount: { type: Boolean },
    ariaLabel: {},
    asChild: { type: Boolean },
    as: {},
    side: {},
    sideOffset: { default: 4 },
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean }
  },
  emits: ["escapeKeyDown", "pointerDownOutside"],
  setup(t, { emit: n }) {
    const s = Wn(t, n);
    return (u, p) => (c(), G(y(ry), null, {
      default: N(() => [
        ne(y(ny), oe(y(s), { class: "p-tooltip" }), {
          default: N(() => [
            I(u.$slots, "default")
          ]),
          _: 3
        }, 16)
      ]),
      _: 3
    }));
  }
}), i3 = /* @__PURE__ */ W({
  __name: "PTooltipProvider",
  props: {
    delayDuration: {},
    skipDelayDuration: {},
    disableHoverableContent: { type: Boolean },
    disableClosingTrigger: { type: Boolean },
    disabled: { type: Boolean },
    ignoreNonKeyboardFocus: { type: Boolean }
  },
  setup(t) {
    const n = t;
    return (a, i) => (c(), G(y(Qw), ve(we(n)), {
      default: N(() => [
        I(a.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), s3 = /* @__PURE__ */ W({
  __name: "PTooltipRoot",
  props: {
    defaultOpen: { type: Boolean },
    open: { type: Boolean },
    delayDuration: {},
    disableHoverableContent: { type: Boolean },
    disableClosingTrigger: { type: Boolean },
    disabled: { type: Boolean },
    ignoreNonKeyboardFocus: { type: Boolean }
  },
  emits: ["update:open"],
  setup(t, { emit: n }) {
    const s = Wn(t, n);
    return (u, p) => (c(), G(y(Jw), ve(we(y(s))), {
      default: N(() => [
        I(u.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), l3 = /* @__PURE__ */ W({
  __name: "PTooltipTrigger",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(t) {
    const n = t;
    return (a, i) => (c(), G(y(ey), ve(we(n)), {
      default: N(() => [
        I(a.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), xd = /* @__PURE__ */ W({
  inheritAttrs: !1,
  __name: "PTooltip",
  props: {
    defaultOpen: { type: Boolean, default: !1 },
    open: { type: Boolean, default: void 0 },
    delayDuration: { default: void 0 },
    disableHoverableContent: { type: Boolean, default: void 0 },
    disableClosingTrigger: { type: Boolean, default: void 0 },
    disabled: { type: Boolean, default: void 0 },
    ignoreNonKeyboardFocus: { type: Boolean, default: void 0 },
    skipDelayDuration: {},
    forceMount: { type: Boolean },
    ariaLabel: {},
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    text: { default: void 0 },
    allowCollisions: { type: Boolean }
  },
  setup(t) {
    const n = t, a = M(() => {
      const { defaultOpen: u, open: p, delayDuration: g, disableHoverableContent: E, disableClosingTrigger: h, disabled: f, ignoreNonKeyboardFocus: b } = n;
      return { defaultOpen: u, open: p, delayDuration: g, disableHoverableContent: E, disableClosingTrigger: h, disabled: f, ignoreNonKeyboardFocus: b };
    }), i = M(() => {
      const { delayDuration: u, disableHoverableContent: p, disableClosingTrigger: g, disabled: E, ignoreNonKeyboardFocus: h, skipDelayDuration: f } = n;
      return { delayDuration: u, disableHoverableContent: p, disableClosingTrigger: g, disabled: E, ignoreNonKeyboardFocus: h, skipDelayDuration: f };
    }), s = M(() => {
      const { side: u, sideOffset: p, align: g, avoidCollisions: E, collisionBoundary: h, collisionPadding: f, arrowPadding: b, sticky: w, hideWhenDetached: x, ariaLabel: A, alignOffset: D } = n;
      return { side: u, sideOffset: p, align: g, avoidCollisions: E, collisionBoundary: h, collisionPadding: f, arrowPadding: b, sticky: w, hideWhenDetached: x, ariaLabel: A, alignOffset: D };
    });
    return (u, p) => (c(), G(i3, ve(we(i.value)), {
      default: N(() => [
        ne(s3, ve(we(a.value)), {
          default: N(() => [
            ne(l3, oe({ "as-child": "" }, u.$attrs), {
              default: N(() => [
                I(u.$slots, "default"),
                ne(o3, oe(s.value, {
                  "as-child": !!u.$slots.tooltip,
                  "avoid-collisions": !u.allowCollisions
                }), {
                  default: N(() => [
                    I(u.$slots, "tooltip", {}, () => [
                      I(u.$slots, "content", {}, () => [
                        Ne(ye(u.text), 1)
                      ])
                    ])
                  ]),
                  _: 3
                }, 16, ["as-child", "avoid-collisions"])
              ]),
              _: 3
            }, 16)
          ]),
          _: 3
        }, 16)
      ]),
      _: 3
    }, 16));
  }
}), oH = (t) => {
  t.component("PTooltip", xd), t.component("PTooltipRoot", s3), t.component("PTooltipProvider", i3), t.component("PTooltipTrigger", l3), t.component("PTooltipContent", o3);
}, iH = { class: "p-calendar-date-picker" }, sH = { class: "p-calendar-date-picker__days-of-week" }, lH = { class: "p-calendar-date-picker__dates" }, cH = { class: "p-calendar-date-picker__trigger" }, uH = /* @__PURE__ */ W({
  __name: "PCalendarDatePicker",
  props: {
    modelValue: {},
    viewingDate: {},
    min: {},
    minReason: {},
    max: {},
    maxReason: {}
  },
  emits: ["update:modelValue", "update:viewingDate", "mode"],
  setup(t, { emit: n }) {
    const a = t, i = n, s = M({
      get() {
        return a.modelValue;
      },
      set(A) {
        i("update:modelValue", A);
      }
    }), u = M({
      get() {
        return a.viewingDate;
      },
      set(A) {
        i("update:viewingDate", A);
      }
    }), p = yh({ start: _o(/* @__PURE__ */ new Date()), end: Th(/* @__PURE__ */ new Date()) }).map((A) => Mn(A, "EEEEEE")), g = M(() => {
      const A = Hf(u.value), D = _o(A), L = $f(u.value), $ = Th(L);
      return yh({ start: D, end: $ });
    });
    function E(A) {
      return !!(a.min && R0(A, a.min) || a.max && Zf(A, a.max));
    }
    function h(A) {
      const D = wC(A), L = E(A), $ = () => b(A), q = W2(u.value) && x7(A, u.value), P = W2(s.value) && $l(A, s.value);
      return {
        date: A,
        today: D,
        disabled: L,
        select: $,
        selected: P,
        inMonth: q
      };
    }
    function f(A) {
      const { today: D, selected: L, inMonth: $ } = h(A);
      return {
        "p-calendar-date-picker__date--today": D,
        "p-calendar-date-picker__date--selected": L,
        "p-calendar-date-picker__date--in-month": $,
        "p-calendar-date-picker__date--out-of-month": !$
      };
    }
    function b(A) {
      s.value = A;
    }
    function w(A) {
      return a.min && ec(A, a.min) ? a.minReason ?? "" : a.max && Jl(A, a.max) ? a.maxReason ?? "" : "";
    }
    function x(A) {
      return !w(A);
    }
    return (A, D) => {
      const L = ht("PButton");
      return c(), _("div", iH, [
        d("div", sH, [
          (c(!0), _(Qe, null, Ye(y(p), ($) => (c(), _("div", {
            key: $,
            class: "p-calendar-date-picker__day-of-week"
          }, ye($), 1))), 128))
        ]),
        d("div", lH, [
          (c(!0), _(Qe, null, Ye(g.value, ($) => (c(), G(y(xd), {
            key: $.getTime(),
            text: w($),
            disabled: x($)
          }, {
            default: N(() => [
              d("div", cH, [
                I(A.$slots, "date", oe({ ref_for: !0 }, h($)), () => [
                  ne(L, {
                    small: "",
                    flat: "",
                    class: Oe(["p-calendar-date-picker__date", f($)]),
                    disabled: E($),
                    onClick: (q) => b($)
                  }, {
                    default: N(() => [
                      Ne(ye($.getDate()), 1)
                    ]),
                    _: 2
                  }, 1032, ["class", "disabled", "onClick"])
                ])
              ])
            ]),
            _: 2
          }, 1032, ["text", "disabled"]))), 128))
        ])
      ]);
    };
  }
}), dH = { class: "p-calendar-header__before" }, _H = { class: "p-calendar-header__title" }, pH = { class: "p-calendar-header__after" }, mH = /* @__PURE__ */ W({
  __name: "PCalendarHeader",
  props: {
    modelValue: {},
    mode: {},
    min: {},
    max: {}
  },
  emits: ["update:modelValue", "update:mode"],
  setup(t, { emit: n }) {
    const a = t, i = n, s = M({
      get() {
        return a.modelValue;
      },
      set(h) {
        i("update:modelValue", h);
      }
    }), u = M(() => Mn(s.value, "MMMM")), p = M(() => Mn(s.value, "yyyy")), g = M(() => {
      if (!a.min)
        return !1;
      const h = Vd(s.value, -1);
      return R0($f(h), a.min);
    }), E = M(() => {
      if (!a.max)
        return !1;
      const h = Vd(s.value, 1);
      return Zf(Hf(h), a.max);
    });
    return (h, f) => {
      const b = ht("p-button");
      return c(), _("div", {
        class: Oe(["p-calendar-header", `p-calendar-header--${h.mode}`])
      }, [
        d("div", dH, [
          h.mode === "date" ? (c(), G(b, {
            key: 0,
            class: "p-calendar-header__arrow",
            icon: "ChevronLeftIcon",
            small: "",
            disabled: g.value,
            onClick: f[0] || (f[0] = (w) => s.value = y(Vd)(s.value, -1))
          }, null, 8, ["disabled"])) : (c(), G(b, {
            key: 1,
            class: "p-calendar-header__close",
            flat: "",
            icon: "XMarkIcon",
            small: "",
            onClick: f[1] || (f[1] = (w) => i("update:mode", "date"))
          }))
        ]),
        d("div", _H, [
          ne(b, {
            class: "p-date-picker__title-month",
            flat: "",
            onClick: f[2] || (f[2] = (w) => i("update:mode", "month"))
          }, {
            default: N(() => [
              Ne(ye(u.value), 1)
            ]),
            _: 1
          }),
          ne(b, {
            class: "p-date-picker__title-year",
            flat: "",
            onClick: f[3] || (f[3] = (w) => i("update:mode", "year"))
          }, {
            default: N(() => [
              Ne(ye(p.value), 1)
            ]),
            _: 1
          })
        ]),
        d("div", pH, [
          ne(b, {
            class: "p-calendar-header__arrow",
            icon: "ChevronRightIcon",
            small: "",
            disabled: E.value,
            onClick: f[4] || (f[4] = (w) => s.value = y(Vd)(s.value, 1))
          }, null, 8, ["disabled"])
        ])
      ], 2);
    };
  }
}), gH = { class: "p-calendar-month-picker" }, fH = ["data-month"], hH = /* @__PURE__ */ W({
  __name: "PCalendarMonthPicker",
  props: {
    modelValue: {},
    min: {},
    max: {}
  },
  emits: ["update:modelValue"],
  setup(t, { emit: n }) {
    const a = t, i = n, s = z([]), u = M(() => ({ min: a.min, max: a.max })), p = M({
      get() {
        return a.modelValue ?? /* @__PURE__ */ new Date();
      },
      set(b) {
        i("update:modelValue", A0(b, u.value));
      }
    }), g = Cy({ start: g7(/* @__PURE__ */ new Date()), end: xy(/* @__PURE__ */ new Date()) }).map((b) => ({
      value: b.getMonth(),
      label: Mn(b, "MMMM")
    }));
    function E(b) {
      return {
        "p-calendar-month-picker__month-button--selected": p.value.getMonth() === b
      };
    }
    function h(b) {
      const w = Nh(p.value, b);
      return !!u.value.min && R0($f(w), u.value.min) || !!u.value.max && Zf(Hf(w), u.value.max);
    }
    function f(b) {
      p.value = Nh(p.value, b);
    }
    return xt(() => {
      const b = p.value.getMonth(), w = s.value.find((x) => x.dataset.month === b.toString());
      w && Ct(() => w.parentElement?.focus());
    }), (b, w) => (c(), _("div", gH, [
      (c(!0), _(Qe, null, Ye(y(g), (x) => (c(), _("div", {
        key: x.value,
        class: "p-calendar-month-picker__month"
      }, [
        ne(rn, {
          small: "",
          class: Oe(["p-calendar-month-picker__month-button", E(x.value)]),
          disabled: h(x.value),
          onClick: (A) => f(x.value)
        }, {
          default: N(() => [
            d("span", {
              ref_for: !0,
              ref_key: "monthElements",
              ref: s,
              "data-month": x.value
            }, ye(x.label), 9, fH)
          ]),
          _: 2
        }, 1032, ["class", "disabled", "onClick"])
      ]))), 128))
    ]));
  }
}), vH = ["data-target"], EH = /* @__PURE__ */ W({
  __name: "ScrollingPicker",
  props: {
    modelValue: { type: [String, Number, Boolean, null] },
    options: {},
    preventFocus: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(t, { expose: n, emit: a }) {
    const i = t, s = a;
    n({ scrollToOption: b });
    const u = M({
      get() {
        return i.modelValue ?? null;
      },
      set(w) {
        s("update:modelValue", w);
      }
    }), p = M(() => i.options.map((w) => Ei(w))), g = z(), E = z([]), h = M(() => ({
      option: (w) => ({
        "scrolling-picker__option--selected": w.value === u.value,
        "scrolling-picker__option--disabled": w.disabled
      })
    }));
    function f(w) {
      u.value = w.value;
    }
    function b(w) {
      const x = E.value.find((A) => A.dataset.target === w?.toString());
      if (x && g.value) {
        const A = x.closest("button"), D = A.offsetTop - g.value.clientHeight / 2 + A.clientHeight / 2;
        g.value.scrollTop = D;
      }
      return x;
    }
    return pn(() => {
      b(u.value);
    }), xt(() => {
      const w = b(u.value);
      w && !i.preventFocus && w.parentElement?.focus();
    }), (w, x) => {
      const A = ht("p-button");
      return c(), _("div", {
        ref_key: "containerElement",
        ref: g,
        class: "scrolling-picker"
      }, [
        I(w.$slots, "before"),
        (c(!0), _(Qe, null, Ye(p.value, (D) => (c(), G(A, {
          key: D.value,
          small: "",
          flat: "",
          type: "button",
          class: Oe(["scrolling-picker__option", h.value.option(D)]),
          tabindex: 1,
          disabled: D.disabled,
          onClick: (L) => f(D)
        }, {
          default: N(() => [
            d("span", {
              ref_for: !0,
              ref_key: "optionElements",
              ref: E,
              "data-target": D.value
            }, ye(D.label), 9, vH)
          ]),
          _: 2
        }, 1032, ["disabled", "class", "onClick"]))), 128)),
        I(w.$slots, "after")
      ], 512);
    };
  }
}), il = 20, bH = /* @__PURE__ */ W({
  __name: "PCalendarYearPicker",
  props: {
    modelValue: {},
    min: {},
    max: {}
  },
  emits: ["update:modelValue"],
  setup(t, { emit: n }) {
    const a = t, i = n, s = M(() => ({ min: a.min, max: a.max })), u = M({
      get() {
        return a.modelValue ?? /* @__PURE__ */ new Date();
      },
      set(L) {
        i("update:modelValue", A0(L, s.value));
      }
    }), p = z(), g = z(), E = M(() => u.value.getFullYear()), h = z(E.value), f = z(), b = M(() => {
      const L = [], $ = h.value - il, q = h.value + il;
      for (let P = $ > 0 ? $ : 0; P < q; P++) {
        const k = Mh(u.value, P);
        L.push({
          label: P.toString(),
          value: P,
          disabled: !I7(k, s.value, "year")
        });
      }
      return L;
    });
    function w(L) {
      return L - il < 0;
    }
    function x(L) {
      u.value = Mh(u.value, L);
    }
    function A([L]) {
      if (L.isIntersecting)
        if (L.target.dataset.target === "top") {
          if (w(h.value - il)) {
            h.value = il;
            return;
          }
          h.value = h.value - il, Ct(() => f.value.scrollToOption(h.value));
        } else
          h.value = h.value + il;
    }
    const D = Md(A, {});
    return xt(() => {
      D.observe(p), D.observe(g);
    }), (L, $) => (c(), G(EH, {
      ref_key: "scrollingPicker",
      ref: f,
      "model-value": E.value,
      options: b.value,
      "onUpdate:modelValue": x
    }, {
      before: N(() => [
        d("div", {
          ref_key: "topElement",
          ref: p,
          class: "scrolling-picker__observer",
          "data-target": "top"
        }, null, 512)
      ]),
      after: N(() => [
        d("div", {
          ref_key: "bottomElement",
          ref: g,
          class: "scrolling-picker__observer",
          "data-target": "bottom"
        }, null, 512)
      ]),
      _: 1
    }, 8, ["model-value", "options"]));
  }
}), SH = { class: "p-calendar__mode" }, wH = {
  key: 0,
  class: "p-calendar__overlay"
}, c3 = /* @__PURE__ */ W({
  __name: "PCalendar",
  props: {
    modelValue: {},
    viewingDate: {},
    classes: {},
    min: {},
    minReason: {},
    max: {},
    maxReason: {}
  },
  emits: ["update:modelValue", "update:viewingDate"],
  setup(t, { emit: n }) {
    const a = t, i = n, s = z("date"), u = M(() => s.value !== "date"), p = z(a.modelValue ?? /* @__PURE__ */ new Date()), g = M({
      get() {
        return a.viewingDate ?? p.value;
      },
      set(h) {
        i("update:viewingDate", h), p.value = h;
      }
    }), E = M({
      get() {
        return a.modelValue;
      },
      set(h) {
        i("update:modelValue", h);
      }
    });
    return (h, f) => {
      const b = ht("p-content");
      return c(), G(b, {
        class: Oe(["p-calendar", `p-calendar--${s.value}`])
      }, {
        default: N(() => [
          ne(mH, oe({
            modelValue: g.value,
            "onUpdate:modelValue": f[0] || (f[0] = (w) => g.value = w),
            mode: s.value,
            "onUpdate:mode": f[1] || (f[1] = (w) => s.value = w)
          }, { min: h.min, max: h.max }), null, 16, ["modelValue", "mode"]),
          d("div", SH, [
            ne(uH, oe({
              modelValue: E.value,
              "onUpdate:modelValue": f[2] || (f[2] = (w) => E.value = w),
              class: h.classes
            }, { viewingDate: g.value, min: h.min, max: h.max, minReason: h.minReason, maxReason: h.maxReason }, {
              onMode: f[3] || (f[3] = (w) => s.value = w)
            }), {
              date: N((w) => [
                I(h.$slots, "date", ve(we(w)))
              ]),
              _: 3
            }, 16, ["modelValue", "class"]),
            u.value ? (c(), _("div", wH, [
              s.value === "year" ? (c(), G(bH, oe({
                key: 0,
                modelValue: g.value,
                "onUpdate:modelValue": f[4] || (f[4] = (w) => g.value = w)
              }, { min: h.min, max: h.max }, {
                "onUpdate:modelValue": f[5] || (f[5] = (w) => s.value = "date")
              }), null, 16, ["modelValue"])) : le("", !0),
              s.value === "month" ? (c(), G(hH, oe({
                key: 1,
                modelValue: g.value,
                "onUpdate:modelValue": f[6] || (f[6] = (w) => g.value = w)
              }, { min: h.min, max: h.max }, {
                "onUpdate:modelValue": f[7] || (f[7] = (w) => s.value = "date")
              }), null, 16, ["modelValue"])) : le("", !0)
            ])) : le("", !0)
          ])
        ]),
        _: 3
      }, 8, ["class"]);
    };
  }
}), yH = (t) => {
  t.component("PCalendar", c3);
}, TH = /* @__PURE__ */ W({
  __name: "PCardBase",
  props: {
    variant: {}
  },
  setup(t) {
    const n = Kf(
      "p-card p-background",
      {
        variants: {
          variant: {
            ghost: "p-card-ghost"
          }
        },
        defaultVariants: {
          variant: null
        }
      }
    );
    return (a, i) => (c(), _("div", {
      class: Oe(["p-card", y(n)({ variant: a.variant })])
    }, [
      I(a.$slots, "default")
    ], 2));
  }
}), CH = {}, xH = { class: "p-card-content" };
function AH(t, n) {
  return c(), _("div", xH, [
    I(t.$slots, "default")
  ]);
}
const RH = /* @__PURE__ */ Wt(CH, [["render", AH]]), OH = {}, IH = { class: "p-card-description" };
function NH(t, n) {
  return c(), _("p", IH, [
    I(t.$slots, "default")
  ]);
}
const MH = /* @__PURE__ */ Wt(OH, [["render", NH]]), DH = {}, kH = { class: "p-card-footer" };
function LH(t, n) {
  return c(), _("div", kH, [
    I(t.$slots, "default")
  ]);
}
const PH = /* @__PURE__ */ Wt(DH, [["render", LH]]), BH = {}, FH = { class: "p-card-header" };
function UH(t, n) {
  return c(), _("div", FH, [
    I(t.$slots, "default")
  ]);
}
const $H = /* @__PURE__ */ Wt(BH, [["render", UH]]), VH = {}, HH = { class: "p-card-title" };
function GH(t, n) {
  return c(), _("h3", HH, [
    I(t.$slots, "default")
  ]);
}
const YH = /* @__PURE__ */ Wt(VH, [["render", GH]]), tf = /* @__PURE__ */ W({
  __name: "PCard",
  props: {
    variant: {}
  },
  setup(t) {
    const n = t;
    return (a, i) => (c(), G(TH, {
      variant: n.variant
    }, {
      default: N(() => [
        a.$slots.header || a.$slots.title || a.$slots.description ? (c(), G($H, { key: 0 }, {
          default: N(() => [
            I(a.$slots, "header", {}, () => [
              a.$slots.title ? (c(), G(YH, { key: 0 }, {
                default: N(() => [
                  I(a.$slots, "title")
                ]),
                _: 3
              })) : le("", !0),
              a.$slots.description ? (c(), G(MH, { key: 1 }, {
                default: N(() => [
                  I(a.$slots, "description")
                ]),
                _: 3
              })) : le("", !0)
            ])
          ]),
          _: 3
        })) : le("", !0),
        ne(RH, null, {
          default: N(() => [
            I(a.$slots, "default")
          ]),
          _: 3
        }),
        a.$slots.footer ? (c(), G(PH, { key: 1 }, {
          default: N(() => [
            I(a.$slots, "footer")
          ]),
          _: 3
        })) : le("", !0)
      ]),
      _: 3
    }, 8, ["variant"]));
  }
}), zH = (t) => {
  t.component("PCard", tf);
}, ZH = { class: "p-cascade-panel" }, u3 = /* @__PURE__ */ W({
  __name: "PCascadePanel",
  props: {
    panelId: {}
  },
  setup(t) {
    const n = t, a = Y4(() => n.panelId);
    return (i, s) => (c(), _("div", ZH, [
      I(i.$slots, "default", ve(we(y(a))))
    ]));
  }
}), qH = { class: "p-cascade-panels" }, WH = /* @__PURE__ */ W({
  __name: "PCascadePanels",
  props: {
    panels: {},
    panelTransitionName: { default: "p-cascade-panels__panel-transition" },
    transitionName: { default: "p-cascade-panels__transition" }
  },
  setup(t, { expose: n }) {
    const a = t;
    function i(q) {
      return `${Qn(q.toString())}`;
    }
    const s = Ui(N0, void 0), u = Nd(s) && s.panels.value.every((q) => a.panels.find(({ id: P }) => P === q.id)) && a.panels.every((q) => s.panels.value.find(({ id: P }) => P === q.id)), {
      close: p,
      closeAll: g,
      closePanelById: E,
      getPanelById: h,
      getPanelIsOpenById: f,
      isOpen: b,
      open: w,
      openPanelById: x,
      openPanels: A,
      panels: D,
      toggle: L,
      togglePanelById: $
    } = u ? s : V4(() => a.panels);
    return n({
      close: p,
      closeAll: g,
      closePanelById: E,
      getPanelById: h,
      getPanelIsOpenById: f,
      isOpen: b,
      open: w,
      openPanelById: x,
      openPanels: A,
      panels: D,
      toggle: L,
      togglePanelById: $
    }), (q, P) => (c(), G(v0, { name: q.transitionName }, {
      default: N(() => [
        ur(d("div", qH, [
          (c(!0), _(Qe, null, Ye(y(D), ({ id: k }) => (c(), G(mv, {
            key: k,
            name: q.panelTransitionName
          }, {
            default: N(() => [
              ur((c(), G(y(u3), {
                key: k,
                "panel-id": k,
                class: "p-cascade-panels__panel"
              }, {
                default: N((U) => [
                  I(q.$slots, `${i(k)}`, oe({ ref_for: !0 }, U), () => [
                    Ne(ye(i(k)), 1)
                  ])
                ]),
                _: 2
              }, 1032, ["panel-id"])), [
                [Ll, y(f)(k)]
              ])
            ]),
            _: 2
          }, 1032, ["name"]))), 128))
        ], 512), [
          [Ll, y(b)]
        ])
      ]),
      _: 3
    }, 8, ["name"]));
  }
}), jH = (t) => {
  t.component("PCascadePanels", WH), t.component("PCascadePanel", u3);
}, KH = { class: "p-checkbox__label" }, QH = ["id", "disabled"], Ld = /* @__PURE__ */ W({
  inheritAttrs: !1,
  __name: "PCheckbox",
  props: {
    modelValue: { type: [Boolean, Array, null] },
    label: {},
    state: {},
    disabled: { type: Boolean },
    small: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: n }) {
    const a = t, i = n, s = Yr(), { classes: u, styles: p, attrs: g } = Xa(), E = M({
      get() {
        return a.modelValue ?? void 0;
      },
      set(b) {
        i("update:modelValue", b);
      }
    }), h = M(() => a.state?.valid === !1 && a.state.validated && !a.state.pending), f = M(() => ({
      checkbox: [
        u.value,
        {
          "p-checkbox--disabled": a.disabled,
          "p-checkbox--failed": h.value,
          "p-checkbox--pending": a.state?.pending,
          "p-checkbox--small": a.small
        }
      ],
      input: {
        "p-checkbox__input--small": a.small
      }
    }));
    return (b, w) => {
      const x = ht("PLabel");
      return c(), G(x, {
        class: Oe(["p-checkbox", f.value.checkbox]),
        style: Gr(y(p))
      }, mn({
        default: N(({ id: A }) => [
          ur(d("input", oe({ id: A }, y(g), {
            "onUpdate:modelValue": w[0] || (w[0] = (D) => E.value = D),
            type: "checkbox",
            disabled: b.disabled,
            class: ["p-checkbox__input", f.value.input]
          }), null, 16, QH), [
            [gv, E.value]
          ])
        ]),
        _: 2
      }, [
        y(s).label || y(Nd)(b.label) ? {
          name: "label",
          fn: N(() => [
            I(b.$slots, "label", {}, () => [
              d("span", KH, ye(b.label), 1)
            ])
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["class", "style"]);
    };
  }
}), XH = (t) => {
  t.component("PCheckbox", Ld);
}, JH = ["disabled"], eG = /* @__PURE__ */ W({
  inheritAttrs: !1,
  __name: "PCheckboxGroup",
  props: {
    modelValue: {},
    options: {},
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: n }) {
    const a = t, i = n, s = M({
      get() {
        return a.modelValue;
      },
      set(h) {
        i("update:modelValue", h);
      }
    }), u = M(() => a.options.map((h) => Ei(h))), { classes: p, styles: g, attrs: E } = Xa();
    return (h, f) => (c(), _("fieldset", {
      class: Oe(["p-checkbox-group", y(p)]),
      style: Gr(y(g)),
      disabled: h.disabled
    }, [
      (c(!0), _(Qe, null, Ye(u.value, (b, w) => (c(), G(y(Ld), oe({
        key: w,
        modelValue: s.value,
        "onUpdate:modelValue": f[0] || (f[0] = (x) => s.value = x)
      }, { ref_for: !0 }, y(E), {
        label: b.label,
        value: b.value,
        disabled: h.disabled || b.disabled
      }), {
        label: N(() => [
          I(h.$slots, "label", { option: b })
        ]),
        _: 2
      }, 1040, ["modelValue", "label", "value", "disabled"]))), 128))
    ], 14, JH));
  }
}), tG = (t) => {
  t.component("PCheckboxGroup", eG);
}, nG = {
  key: 0,
  class: "p-code-container"
}, rG = {
  key: 1,
  class: "p-code-container p-code-container--block"
}, Pd = /* @__PURE__ */ W({
  __name: "PCode",
  props: {
    inline: { type: Boolean }
  },
  setup(t) {
    return (n, a) => n.inline ? (c(), _("code", nG, [
      I(n.$slots, "default")
    ])) : (c(), _("pre", rG, [
      d("code", null, [
        I(n.$slots, "default")
      ])
    ]));
  }
}), aG = (t) => {
  t.component("PCode", Pd);
}, d3 = `(function(){"use strict";function Cc(t){return t&&t.__esModule&&Object.prototype.hasOwnProperty.call(t,"default")?t.default:t}var Tt,oi;function Nc(){if(oi)return Tt;oi=1;function t(u){return u instanceof Map?u.clear=u.delete=u.set=function(){throw new Error("map is read-only")}:u instanceof Set&&(u.add=u.clear=u.delete=function(){throw new Error("set is read-only")}),Object.freeze(u),Object.getOwnPropertyNames(u).forEach(b=>{const I=u[b],U=typeof I;(U==="object"||U==="function")&&!Object.isFrozen(I)&&t(I)}),u}class e{constructor(b){b.data===void 0&&(b.data={}),this.data=b.data,this.isMatchIgnored=!1}ignoreMatch(){this.isMatchIgnored=!0}}function n(u){return u.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;")}function a(u,...b){const I=Object.create(null);for(const U in u)I[U]=u[U];return b.forEach(function(U){for(const ae in U)I[ae]=U[ae]}),I}const r="</span>",i=u=>!!u.scope,s=(u,{prefix:b})=>{if(u.startsWith("language:"))return u.replace("language:","language-");if(u.includes(".")){const I=u.split(".");return[\`\${b}\${I.shift()}\`,...I.map((U,ae)=>\`\${U}\${"_".repeat(ae+1)}\`)].join(" ")}return\`\${b}\${u}\`};class o{constructor(b,I){this.buffer="",this.classPrefix=I.classPrefix,b.walk(this)}addText(b){this.buffer+=n(b)}openNode(b){if(!i(b))return;const I=s(b.scope,{prefix:this.classPrefix});this.span(I)}closeNode(b){i(b)&&(this.buffer+=r)}value(){return this.buffer}span(b){this.buffer+=\`<span class="\${b}">\`}}const _=(u={})=>{const b={children:[]};return Object.assign(b,u),b};class l{constructor(){this.rootNode=_(),this.stack=[this.rootNode]}get top(){return this.stack[this.stack.length-1]}get root(){return this.rootNode}add(b){this.top.children.push(b)}openNode(b){const I=_({scope:b});this.add(I),this.stack.push(I)}closeNode(){if(this.stack.length>1)return this.stack.pop()}closeAllNodes(){for(;this.closeNode(););}toJSON(){return JSON.stringify(this.rootNode,null,4)}walk(b){return this.constructor._walk(b,this.rootNode)}static _walk(b,I){return typeof I=="string"?b.addText(I):I.children&&(b.openNode(I),I.children.forEach(U=>this._walk(b,U)),b.closeNode(I)),b}static _collapse(b){typeof b!="string"&&b.children&&(b.children.every(I=>typeof I=="string")?b.children=[b.children.join("")]:b.children.forEach(I=>{l._collapse(I)}))}}class c extends l{constructor(b){super(),this.options=b}addText(b){b!==""&&this.add(b)}startScope(b){this.openNode(b)}endScope(){this.closeNode()}__addSublanguage(b,I){const U=b.root;I&&(U.scope=\`language:\${I}\`),this.add(U)}toHTML(){return new o(this,this.options).value()}finalize(){return this.closeAllNodes(),!0}}function d(u){return u?typeof u=="string"?u:u.source:null}function m(u){return g("(?=",u,")")}function p(u){return g("(?:",u,")*")}function E(u){return g("(?:",u,")?")}function g(...u){return u.map(I=>d(I)).join("")}function S(u){const b=u[u.length-1];return typeof b=="object"&&b.constructor===Object?(u.splice(u.length-1,1),b):{}}function T(...u){return"("+(S(u).capture?"":"?:")+u.map(U=>d(U)).join("|")+")"}function R(u){return new RegExp(u.toString()+"|").exec("").length-1}function f(u,b){const I=u&&u.exec(b);return I&&I.index===0}const A=/\\[(?:[^\\\\\\]]|\\\\.)*\\]|\\(\\??|\\\\([1-9][0-9]*)|\\\\./;function N(u,{joinWith:b}){let I=0;return u.map(U=>{I+=1;const ae=I;let re=d(U),L="";for(;re.length>0;){const h=A.exec(re);if(!h){L+=re;break}L+=re.substring(0,h.index),re=re.substring(h.index+h[0].length),h[0][0]==="\\\\"&&h[1]?L+="\\\\"+String(Number(h[1])+ae):(L+=h[0],h[0]==="("&&I++)}return L}).map(U=>\`(\${U})\`).join(b)}const C=/\\b\\B/,M="[a-zA-Z]\\\\w*",y="[a-zA-Z_]\\\\w*",x="\\\\b\\\\d+(\\\\.\\\\d+)?",G="(-?)(\\\\b0[xX][a-fA-F0-9]+|(\\\\b\\\\d+(\\\\.\\\\d*)?|\\\\.\\\\d+)([eE][-+]?\\\\d+)?)",w="\\\\b(0b[01]+)",H="!|!=|!==|%|%=|&|&&|&=|\\\\*|\\\\*=|\\\\+|\\\\+=|,|-|-=|/=|/|:|;|<<|<<=|<=|<|===|==|=|>>>=|>>=|>=|>>>|>>|>|\\\\?|\\\\[|\\\\{|\\\\(|\\\\^|\\\\^=|\\\\||\\\\|=|\\\\|\\\\||~",j=(u={})=>{const b=/^#![ ]*\\//;return u.binary&&(u.begin=g(b,/.*\\b/,u.binary,/\\b.*/)),a({scope:"meta",begin:b,end:/$/,relevance:0,"on:begin":(I,U)=>{I.index!==0&&U.ignoreMatch()}},u)},ee={begin:"\\\\\\\\[\\\\s\\\\S]",relevance:0},V={scope:"string",begin:"'",end:"'",illegal:"\\\\n",contains:[ee]},z={scope:"string",begin:'"',end:'"',illegal:"\\\\n",contains:[ee]},X={begin:/\\b(a|an|the|are|I'm|isn't|don't|doesn't|won't|but|just|should|pretty|simply|enough|gonna|going|wtf|so|such|will|you|your|they|like|more)\\b/},q=function(u,b,I={}){const U=a({scope:"comment",begin:u,end:b,contains:[]},I);U.contains.push({scope:"doctag",begin:"[ ]*(?=(TODO|FIXME|NOTE|BUG|OPTIMIZE|HACK|XXX):)",end:/(TODO|FIXME|NOTE|BUG|OPTIMIZE|HACK|XXX):/,excludeBegin:!0,relevance:0});const ae=T("I","a","is","so","us","to","at","if","in","it","on",/[A-Za-z]+['](d|ve|re|ll|t|s|n)/,/[A-Za-z]+[-][a-z]+/,/[A-Za-z][a-z]{2,}/);return U.contains.push({begin:g(/[ ]+/,"(",ae,/[.]?[:]?([.][ ]|[ ])/,"){3}")}),U},ie=q("//","$"),_e=q("/\\\\*","\\\\*/"),de=q("#","$"),Se={scope:"number",begin:x,relevance:0},ge={scope:"number",begin:G,relevance:0},Te={scope:"number",begin:w,relevance:0},se={scope:"regexp",begin:/\\/(?=[^/\\n]*\\/)/,end:/\\/[gimuy]*/,contains:[ee,{begin:/\\[/,end:/\\]/,relevance:0,contains:[ee]}]},ue={scope:"title",begin:M,relevance:0},Z={scope:"title",begin:y,relevance:0},K={begin:"\\\\.\\\\s*"+y,relevance:0};var ne=Object.freeze({__proto__:null,APOS_STRING_MODE:V,BACKSLASH_ESCAPE:ee,BINARY_NUMBER_MODE:Te,BINARY_NUMBER_RE:w,COMMENT:q,C_BLOCK_COMMENT_MODE:_e,C_LINE_COMMENT_MODE:ie,C_NUMBER_MODE:ge,C_NUMBER_RE:G,END_SAME_AS_BEGIN:function(u){return Object.assign(u,{"on:begin":(b,I)=>{I.data._beginMatch=b[1]},"on:end":(b,I)=>{I.data._beginMatch!==b[1]&&I.ignoreMatch()}})},HASH_COMMENT_MODE:de,IDENT_RE:M,MATCH_NOTHING_RE:C,METHOD_GUARD:K,NUMBER_MODE:Se,NUMBER_RE:x,PHRASAL_WORDS_MODE:X,QUOTE_STRING_MODE:z,REGEXP_MODE:se,RE_STARTERS_RE:H,SHEBANG:j,TITLE_MODE:ue,UNDERSCORE_IDENT_RE:y,UNDERSCORE_TITLE_MODE:Z});function le(u,b){u.input[u.index-1]==="."&&b.ignoreMatch()}function be(u,b){u.className!==void 0&&(u.scope=u.className,delete u.className)}function Ce(u,b){b&&u.beginKeywords&&(u.begin="\\\\b("+u.beginKeywords.split(" ").join("|")+")(?!\\\\.)(?=\\\\b|\\\\s)",u.__beforeBegin=le,u.keywords=u.keywords||u.beginKeywords,delete u.beginKeywords,u.relevance===void 0&&(u.relevance=0))}function qe(u,b){Array.isArray(u.illegal)&&(u.illegal=T(...u.illegal))}function it(u,b){if(u.match){if(u.begin||u.end)throw new Error("begin & end are not supported with match");u.begin=u.match,delete u.match}}function Ue(u,b){u.relevance===void 0&&(u.relevance=1)}const He=(u,b)=>{if(!u.beforeMatch)return;if(u.starts)throw new Error("beforeMatch cannot be used with starts");const I=Object.assign({},u);Object.keys(u).forEach(U=>{delete u[U]}),u.keywords=I.keywords,u.begin=g(I.beforeMatch,m(I.begin)),u.starts={relevance:0,contains:[Object.assign(I,{endsParent:!0})]},u.relevance=0,delete I.beforeMatch},Ve=["of","and","for","in","not","or","if","then","parent","list","value"],ot="keyword";function ze(u,b,I=ot){const U=Object.create(null);return typeof u=="string"?ae(I,u.split(" ")):Array.isArray(u)?ae(I,u):Object.keys(u).forEach(function(re){Object.assign(U,ze(u[re],b,re))}),U;function ae(re,L){b&&(L=L.map(h=>h.toLowerCase())),L.forEach(function(h){const k=h.split("|");U[k[0]]=[re,Fe(k[0],k[1])]})}}function Fe(u,b){return b?Number(b):st(u)?0:1}function st(u){return Ve.includes(u.toLowerCase())}const We={},ve=u=>{console.error(u)},xe=(u,...b)=>{console.log(\`WARN: \${u}\`,...b)},Re=(u,b)=>{We[\`\${u}/\${b}\`]||(console.log(\`Deprecated as of \${u}. \${b}\`),We[\`\${u}/\${b}\`]=!0)},we=new Error;function Ke(u,b,{key:I}){let U=0;const ae=u[I],re={},L={};for(let h=1;h<=b.length;h++)L[h+U]=ae[h],re[h+U]=!0,U+=R(b[h-1]);u[I]=L,u[I]._emit=re,u[I]._multi=!0}function $e(u){if(Array.isArray(u.begin)){if(u.skip||u.excludeBegin||u.returnBegin)throw ve("skip, excludeBegin, returnBegin not compatible with beginScope: {}"),we;if(typeof u.beginScope!="object"||u.beginScope===null)throw ve("beginScope must be object"),we;Ke(u,u.begin,{key:"beginScope"}),u.begin=N(u.begin,{joinWith:""})}}function Be(u){if(Array.isArray(u.end)){if(u.skip||u.excludeEnd||u.returnEnd)throw ve("skip, excludeEnd, returnEnd not compatible with endScope: {}"),we;if(typeof u.endScope!="object"||u.endScope===null)throw ve("endScope must be object"),we;Ke(u,u.end,{key:"endScope"}),u.end=N(u.end,{joinWith:""})}}function lt(u){u.scope&&typeof u.scope=="object"&&u.scope!==null&&(u.beginScope=u.scope,delete u.scope)}function Qe(u){lt(u),typeof u.beginScope=="string"&&(u.beginScope={_wrap:u.beginScope}),typeof u.endScope=="string"&&(u.endScope={_wrap:u.endScope}),$e(u),Be(u)}function ct(u){function b(L,h){return new RegExp(d(L),"m"+(u.case_insensitive?"i":"")+(u.unicodeRegex?"u":"")+(h?"g":""))}class I{constructor(){this.matchIndexes={},this.regexes=[],this.matchAt=1,this.position=0}addRule(h,k){k.position=this.position++,this.matchIndexes[this.matchAt]=k,this.regexes.push([k,h]),this.matchAt+=R(h)+1}compile(){this.regexes.length===0&&(this.exec=()=>null);const h=this.regexes.map(k=>k[1]);this.matcherRe=b(N(h,{joinWith:"|"}),!0),this.lastIndex=0}exec(h){this.matcherRe.lastIndex=this.lastIndex;const k=this.matcherRe.exec(h);if(!k)return null;const me=k.findIndex((Ye,mt)=>mt>0&&Ye!==void 0),oe=this.matchIndexes[me];return k.splice(0,me),Object.assign(k,oe)}}class U{constructor(){this.rules=[],this.multiRegexes=[],this.count=0,this.lastIndex=0,this.regexIndex=0}getMatcher(h){if(this.multiRegexes[h])return this.multiRegexes[h];const k=new I;return this.rules.slice(h).forEach(([me,oe])=>k.addRule(me,oe)),k.compile(),this.multiRegexes[h]=k,k}resumingScanAtSamePosition(){return this.regexIndex!==0}considerAll(){this.regexIndex=0}addRule(h,k){this.rules.push([h,k]),k.type==="begin"&&this.count++}exec(h){const k=this.getMatcher(this.regexIndex);k.lastIndex=this.lastIndex;let me=k.exec(h);if(this.resumingScanAtSamePosition()&&!(me&&me.index===this.lastIndex)){const oe=this.getMatcher(0);oe.lastIndex=this.lastIndex+1,me=oe.exec(h)}return me&&(this.regexIndex+=me.position+1,this.regexIndex===this.count&&this.considerAll()),me}}function ae(L){const h=new U;return L.contains.forEach(k=>h.addRule(k.begin,{rule:k,type:"begin"})),L.terminatorEnd&&h.addRule(L.terminatorEnd,{type:"end"}),L.illegal&&h.addRule(L.illegal,{type:"illegal"}),h}function re(L,h){const k=L;if(L.isCompiled)return k;[be,it,Qe,He].forEach(oe=>oe(L,h)),u.compilerExtensions.forEach(oe=>oe(L,h)),L.__beforeBegin=null,[Ce,qe,Ue].forEach(oe=>oe(L,h)),L.isCompiled=!0;let me=null;return typeof L.keywords=="object"&&L.keywords.$pattern&&(L.keywords=Object.assign({},L.keywords),me=L.keywords.$pattern,delete L.keywords.$pattern),me=me||/\\w+/,L.keywords&&(L.keywords=ze(L.keywords,u.case_insensitive)),k.keywordPatternRe=b(me,!0),h&&(L.begin||(L.begin=/\\B|\\b/),k.beginRe=b(k.begin),!L.end&&!L.endsWithParent&&(L.end=/\\B|\\b/),L.end&&(k.endRe=b(k.end)),k.terminatorEnd=d(k.end)||"",L.endsWithParent&&h.terminatorEnd&&(k.terminatorEnd+=(L.end?"|":"")+h.terminatorEnd)),L.illegal&&(k.illegalRe=b(L.illegal)),L.contains||(L.contains=[]),L.contains=[].concat(...L.contains.map(function(oe){return _t(oe==="self"?L:oe)})),L.contains.forEach(function(oe){re(oe,k)}),L.starts&&re(L.starts,h),k.matcher=ae(k),k}if(u.compilerExtensions||(u.compilerExtensions=[]),u.contains&&u.contains.includes("self"))throw new Error("ERR: contains \`self\` is not supported at the top-level of a language.  See documentation.");return u.classNameAliases=a(u.classNameAliases||{}),re(u)}function Xe(u){return u?u.endsWithParent||Xe(u.starts):!1}function _t(u){return u.variants&&!u.cachedVariants&&(u.cachedVariants=u.variants.map(function(b){return a(u,{variants:null},b)})),u.cachedVariants?u.cachedVariants:Xe(u)?a(u,{starts:u.starts?a(u.starts):null}):Object.isFrozen(u)?a(u):u}var dt="11.11.1";class ut extends Error{constructor(b,I){super(b),this.name="HTMLInjectionError",this.html=I}}const Ge=n,Ze=a,$=Symbol("nomatch"),Pe=7,he=function(u){const b=Object.create(null),I=Object.create(null),U=[];let ae=!0;const re="Could not find the language '{}', did you forget to load/include a language module?",L={disableAutodetect:!0,name:"Plain text",contains:[]};let h={ignoreUnescapedHTML:!1,throwUnescapedHTML:!1,noHighlightRe:/^(no-?highlight)$/i,languageDetectRe:/\\blang(?:uage)?-([\\w-]+)\\b/i,classPrefix:"hljs-",cssSelector:"pre code",languages:null,__emitter:c};function k(O){return h.noHighlightRe.test(O)}function me(O){let P=O.className+" ";P+=O.parentNode?O.parentNode.className:"";const Y=h.languageDetectRe.exec(P);if(Y){const J=Me(Y[1]);return J||(xe(re.replace("{}",Y[1])),xe("Falling back to no-highlight mode for this block.",O)),J?Y[1]:"no-highlight"}return P.split(/\\s+/).find(J=>k(J)||Me(J))}function oe(O,P,Y){let J="",ce="";typeof P=="object"?(J=O,Y=P.ignoreIllegals,ce=P.language):(Re("10.7.0","highlight(lang, code, ...args) has been deprecated."),Re("10.7.0",\`Please use highlight(code, options) instead.
https://github.com/highlightjs/highlight.js/issues/2277\`),ce=O,J=P),Y===void 0&&(Y=!0);const Ne={code:J,language:ce};je("before:highlight",Ne);const Le=Ne.result?Ne.result:Ye(Ne.language,Ne.code,Y);return Le.code=Ne.code,je("after:highlight",Le),Le}function Ye(O,P,Y,J){const ce=Object.create(null);function Ne(v,D){return v.keywords[D]}function Le(){if(!F.keywords){pe.addText(Q);return}let v=0;F.keywordPatternRe.lastIndex=0;let D=F.keywordPatternRe.exec(Q),B="";for(;D;){B+=Q.substring(v,D.index);const W=Oe.case_insensitive?D[0].toLowerCase():D[0],Ee=Ne(F,W);if(Ee){const[Ie,Rc]=Ee;if(pe.addText(B),B="",ce[W]=(ce[W]||0)+1,ce[W]<=Pe&&(ke+=Rc),Ie.startsWith("_"))B+=D[0];else{const fc=Oe.classNameAliases[Ie]||Ie;Ae(D[0],fc)}}else B+=D[0];v=F.keywordPatternRe.lastIndex,D=F.keywordPatternRe.exec(Q)}B+=Q.substring(v),pe.addText(B)}function et(){if(Q==="")return;let v=null;if(typeof F.subLanguage=="string"){if(!b[F.subLanguage]){pe.addText(Q);return}v=Ye(F.subLanguage,Q,!0,St[F.subLanguage]),St[F.subLanguage]=v._top}else v=pt(Q,F.subLanguage.length?F.subLanguage:null);F.relevance>0&&(ke+=v.relevance),pe.__addSublanguage(v._emitter,v.language)}function fe(){F.subLanguage!=null?et():Le(),Q=""}function Ae(v,D){v!==""&&(pe.startScope(D),pe.addText(v),pe.endScope())}function ni(v,D){let B=1;const W=D.length-1;for(;B<=W;){if(!v._emit[B]){B++;continue}const Ee=Oe.classNameAliases[v[B]]||v[B],Ie=D[B];Ee?Ae(Ie,Ee):(Q=Ie,Le(),Q=""),B++}}function ai(v,D){return v.scope&&typeof v.scope=="string"&&pe.openNode(Oe.classNameAliases[v.scope]||v.scope),v.beginScope&&(v.beginScope._wrap?(Ae(Q,Oe.classNameAliases[v.beginScope._wrap]||v.beginScope._wrap),Q=""):v.beginScope._multi&&(ni(v.beginScope,D),Q="")),F=Object.create(v,{parent:{value:F}}),F}function ri(v,D,B){let W=f(v.endRe,B);if(W){if(v["on:end"]){const Ee=new e(v);v["on:end"](D,Ee),Ee.isMatchIgnored&&(W=!1)}if(W){for(;v.endsParent&&v.parent;)v=v.parent;return v}}if(v.endsWithParent)return ri(v.parent,D,B)}function gc(v){return F.matcher.regexIndex===0?(Q+=v[0],1):(rt=!0,0)}function Sc(v){const D=v[0],B=v.rule,W=new e(B),Ee=[B.__beforeBegin,B["on:begin"]];for(const Ie of Ee)if(Ie&&(Ie(v,W),W.isMatchIgnored))return gc(D);return B.skip?Q+=D:(B.excludeBegin&&(Q+=D),fe(),!B.returnBegin&&!B.excludeBegin&&(Q=D)),ai(B,v),B.returnBegin?0:D.length}function Tc(v){const D=v[0],B=P.substring(v.index),W=ri(F,v,B);if(!W)return $;const Ee=F;F.endScope&&F.endScope._wrap?(fe(),Ae(D,F.endScope._wrap)):F.endScope&&F.endScope._multi?(fe(),ni(F.endScope,v)):Ee.skip?Q+=D:(Ee.returnEnd||Ee.excludeEnd||(Q+=D),fe(),Ee.excludeEnd&&(Q=D));do F.scope&&pe.closeNode(),!F.skip&&!F.subLanguage&&(ke+=F.relevance),F=F.parent;while(F!==W.parent);return W.starts&&ai(W.starts,v),Ee.returnEnd?0:D.length}function bc(){const v=[];for(let D=F;D!==Oe;D=D.parent)D.scope&&v.unshift(D.scope);v.forEach(D=>pe.openNode(D))}let tt={};function gt(v,D){const B=D&&D[0];if(Q+=v,B==null)return fe(),0;if(tt.type==="begin"&&D.type==="end"&&tt.index===D.index&&B===""){if(Q+=P.slice(D.index,D.index+1),!ae){const W=new Error(\`0 width match regex (\${O})\`);throw W.languageName=O,W.badRule=tt.rule,W}return 1}if(tt=D,D.type==="begin")return Sc(D);if(D.type==="illegal"&&!Y){const W=new Error('Illegal lexeme "'+B+'" for mode "'+(F.scope||"<unnamed>")+'"');throw W.mode=F,W}else if(D.type==="end"){const W=Tc(D);if(W!==$)return W}if(D.type==="illegal"&&B==="")return Q+=\`
\`,1;if(at>1e5&&at>D.index*3)throw new Error("potential infinite loop, way more iterations than matches");return Q+=B,B.length}const Oe=Me(O);if(!Oe)throw ve(re.replace("{}",O)),new Error('Unknown language: "'+O+'"');const ii=ct(Oe);let nt="",F=J||ii;const St={},pe=new h.__emitter(h);bc();let Q="",ke=0,ye=0,at=0,rt=!1;try{if(Oe.__emitTokens)Oe.__emitTokens(P,pe);else{for(F.matcher.considerAll();;){at++,rt?rt=!1:F.matcher.considerAll(),F.matcher.lastIndex=ye;const v=F.matcher.exec(P);if(!v)break;const D=P.substring(ye,v.index),B=gt(D,v);ye=v.index+B}gt(P.substring(ye))}return pe.finalize(),nt=pe.toHTML(),{language:O,value:nt,relevance:ke,illegal:!1,_emitter:pe,_top:F}}catch(v){if(v.message&&v.message.includes("Illegal"))return{language:O,value:Ge(P),illegal:!0,relevance:0,_illegalBy:{message:v.message,index:ye,context:P.slice(ye-100,ye+100),mode:v.mode,resultSoFar:nt},_emitter:pe};if(ae)return{language:O,value:Ge(P),illegal:!1,relevance:0,errorRaised:v,_emitter:pe,_top:F};throw v}}function mt(O){const P={value:Ge(O),illegal:!1,relevance:0,_top:L,_emitter:new h.__emitter(h)};return P._emitter.addText(O),P}function pt(O,P){P=P||h.languages||Object.keys(b);const Y=mt(O),J=P.filter(Me).filter(ti).map(fe=>Ye(fe,O,!1));J.unshift(Y);const ce=J.sort((fe,Ae)=>{if(fe.relevance!==Ae.relevance)return Ae.relevance-fe.relevance;if(fe.language&&Ae.language){if(Me(fe.language).supersetOf===Ae.language)return 1;if(Me(Ae.language).supersetOf===fe.language)return-1}return 0}),[Ne,Le]=ce,et=Ne;return et.secondBest=Le,et}function ic(O,P,Y){const J=P&&I[P]||Y;O.classList.add("hljs"),O.classList.add(\`language-\${J}\`)}function Et(O){let P=null;const Y=me(O);if(k(Y))return;if(je("before:highlightElement",{el:O,language:Y}),O.dataset.highlighted){console.log("Element previously highlighted. To highlight again, first unset \`dataset.highlighted\`.",O);return}if(O.children.length>0&&(h.ignoreUnescapedHTML||(console.warn("One of your code blocks includes unescaped HTML. This is a potentially serious security risk."),console.warn("https://github.com/highlightjs/highlight.js/wiki/security"),console.warn("The element with unescaped HTML:"),console.warn(O)),h.throwUnescapedHTML))throw new ut("One of your code blocks includes unescaped HTML.",O.innerHTML);P=O;const J=P.textContent,ce=Y?oe(J,{language:Y,ignoreIllegals:!0}):pt(J);O.innerHTML=ce.value,O.dataset.highlighted="yes",ic(O,Y,ce.language),O.result={language:ce.language,re:ce.relevance,relevance:ce.relevance},ce.secondBest&&(O.secondBest={language:ce.secondBest.language,relevance:ce.secondBest.relevance}),je("after:highlightElement",{el:O,result:ce,text:J})}function oc(O){h=Ze(h,O)}const sc=()=>{Je(),Re("10.6.0","initHighlighting() deprecated.  Use highlightAll() now.")};function lc(){Je(),Re("10.6.0","initHighlightingOnLoad() deprecated.  Use highlightAll() now.")}let jr=!1;function Je(){function O(){Je()}if(document.readyState==="loading"){jr||window.addEventListener("DOMContentLoaded",O,!1),jr=!0;return}document.querySelectorAll(h.cssSelector).forEach(Et)}function cc(O,P){let Y=null;try{Y=P(u)}catch(J){if(ve("Language definition for '{}' could not be registered.".replace("{}",O)),ae)ve(J);else throw J;Y=L}Y.name||(Y.name=O),b[O]=Y,Y.rawDefinition=P.bind(null,u),Y.aliases&&ei(Y.aliases,{languageName:O})}function _c(O){delete b[O];for(const P of Object.keys(I))I[P]===O&&delete I[P]}function dc(){return Object.keys(b)}function Me(O){return O=(O||"").toLowerCase(),b[O]||b[I[O]]}function ei(O,{languageName:P}){typeof O=="string"&&(O=[O]),O.forEach(Y=>{I[Y.toLowerCase()]=P})}function ti(O){const P=Me(O);return P&&!P.disableAutodetect}function uc(O){O["before:highlightBlock"]&&!O["before:highlightElement"]&&(O["before:highlightElement"]=P=>{O["before:highlightBlock"](Object.assign({block:P.el},P))}),O["after:highlightBlock"]&&!O["after:highlightElement"]&&(O["after:highlightElement"]=P=>{O["after:highlightBlock"](Object.assign({block:P.el},P))})}function mc(O){uc(O),U.push(O)}function pc(O){const P=U.indexOf(O);P!==-1&&U.splice(P,1)}function je(O,P){const Y=O;U.forEach(function(J){J[Y]&&J[Y](P)})}function Ec(O){return Re("10.7.0","highlightBlock will be removed entirely in v12.0"),Re("10.7.0","Please use highlightElement now."),Et(O)}Object.assign(u,{highlight:oe,highlightAuto:pt,highlightAll:Je,highlightElement:Et,highlightBlock:Ec,configure:oc,initHighlighting:sc,initHighlightingOnLoad:lc,registerLanguage:cc,unregisterLanguage:_c,listLanguages:dc,getLanguage:Me,registerAliases:ei,autoDetection:ti,inherit:Ze,addPlugin:mc,removePlugin:pc}),u.debugMode=function(){ae=!1},u.safeMode=function(){ae=!0},u.versionString=dt,u.regex={concat:g,lookahead:m,either:T,optional:E,anyNumberOfTimes:p};for(const O in ne)typeof ne[O]=="object"&&t(ne[O]);return Object.assign(u,ne),u},De=he({});return De.newInstance=()=>he({}),Tt=De,De.HighlightJS=De,De.default=De,Tt}var bt,si;function Oc(){if(si)return bt;si=1;function t(e){const n="[A-Za-zА-Яа-яёЁ_][A-Za-zА-Яа-яёЁ_0-9]+",i="далее "+"возврат вызватьисключение выполнить для если и из или иначе иначеесли исключение каждого конецесли конецпопытки конеццикла не новый перейти перем по пока попытка прервать продолжить тогда цикл экспорт ",_="загрузитьизфайла "+"вебклиент вместо внешнеесоединение клиент конецобласти мобильноеприложениеклиент мобильноеприложениесервер наклиенте наклиентенасервере наклиентенасерверебезконтекста насервере насерверебезконтекста область перед после сервер толстыйклиентобычноеприложение толстыйклиентуправляемоеприложение тонкийклиент ",p="разделительстраниц разделительстрок символтабуляции "+"ansitooem oemtoansi ввестивидсубконто ввестиперечисление ввестипериод ввестиплансчетов выбранныйплансчетов датагод датамесяц датачисло заголовоксистемы значениевстроку значениеизстроки каталогиб каталогпользователя кодсимв конгода конецпериодаби конецрассчитанногопериодаби конецстандартногоинтервала конквартала конмесяца коннедели лог лог10 максимальноеколичествосубконто названиеинтерфейса названиенабораправ назначитьвид назначитьсчет найтиссылки началопериодаби началостандартногоинтервала начгода начквартала начмесяца начнедели номерднягода номерднянедели номернеделигода обработкаожидания основнойжурналрасчетов основнойплансчетов основнойязык очиститьокносообщений периодстр получитьвремята получитьдатута получитьдокументта получитьзначенияотбора получитьпозициюта получитьпустоезначение получитьта префиксавтонумерации пропись пустоезначение разм разобратьпозициюдокумента рассчитатьрегистрына рассчитатьрегистрыпо симв создатьобъект статусвозврата стрколичествострок сформироватьпозициюдокумента счетпокоду текущеевремя типзначения типзначениястр установитьтана установитьтапо фиксшаблон шаблон "+"acos asin atan base64значение base64строка cos exp log log10 pow sin sqrt tan xmlзначение xmlстрока xmlтип xmlтипзнч активноеокно безопасныйрежим безопасныйрежимразделенияданных булево ввестидату ввестизначение ввестистроку ввестичисло возможностьчтенияxml вопрос восстановитьзначение врег выгрузитьжурналрегистрации выполнитьобработкуоповещения выполнитьпроверкуправдоступа вычислить год данныеформывзначение дата день деньгода деньнедели добавитьмесяц заблокироватьданныедляредактирования заблокироватьработупользователя завершитьработусистемы загрузитьвнешнююкомпоненту закрытьсправку записатьjson записатьxml записатьдатуjson записьжурналарегистрации заполнитьзначениясвойств запроситьразрешениепользователя запуститьприложение запуститьсистему зафиксироватьтранзакцию значениевданныеформы значениевстрокувнутр значениевфайл значениезаполнено значениеизстрокивнутр значениеизфайла изxmlтипа импортмоделиxdto имякомпьютера имяпользователя инициализироватьпредопределенныеданные информацияобошибке каталогбиблиотекимобильногоустройства каталогвременныхфайлов каталогдокументов каталогпрограммы кодироватьстроку кодлокализацииинформационнойбазы кодсимвола командасистемы конецгода конецдня конецквартала конецмесяца конецминуты конецнедели конецчаса конфигурациябазыданныхизмененадинамически конфигурацияизменена копироватьданныеформы копироватьфайл краткоепредставлениеошибки лев макс местноевремя месяц мин минута монопольныйрежим найти найтинедопустимыесимволыxml найтиокнопонавигационнойссылке найтипомеченныенаудаление найтипоссылкам найтифайлы началогода началодня началоквартала началомесяца началоминуты началонедели началочаса начатьзапросразрешенияпользователя начатьзапускприложения начатькопированиефайла начатьперемещениефайла начатьподключениевнешнейкомпоненты начатьподключениерасширенияработыскриптографией начатьподключениерасширенияработысфайлами начатьпоискфайлов начатьполучениекаталогавременныхфайлов начатьполучениекаталогадокументов начатьполучениерабочегокаталогаданныхпользователя начатьполучениефайлов начатьпомещениефайла начатьпомещениефайлов начатьсозданиедвоичныхданныхизфайла начатьсозданиекаталога начатьтранзакцию начатьудалениефайлов начатьустановкувнешнейкомпоненты начатьустановкурасширенияработыскриптографией начатьустановкурасширенияработысфайлами неделягода необходимостьзавершениясоединения номерсеансаинформационнойбазы номерсоединенияинформационнойбазы нрег нстр обновитьинтерфейс обновитьнумерациюобъектов обновитьповторноиспользуемыезначения обработкапрерыванияпользователя объединитьфайлы окр описаниеошибки оповестить оповеститьобизменении отключитьобработчикзапросанастроекклиенталицензирования отключитьобработчикожидания отключитьобработчикоповещения открытьзначение открытьиндекссправки открытьсодержаниесправки открытьсправку открытьформу открытьформумодально отменитьтранзакцию очиститьжурналрегистрации очиститьнастройкипользователя очиститьсообщения параметрыдоступа перейтипонавигационнойссылке переместитьфайл подключитьвнешнююкомпоненту подключитьобработчикзапросанастроекклиенталицензирования подключитьобработчикожидания подключитьобработчикоповещения подключитьрасширениеработыскриптографией подключитьрасширениеработысфайлами подробноепредставлениеошибки показатьвводдаты показатьвводзначения показатьвводстроки показатьвводчисла показатьвопрос показатьзначение показатьинформациюобошибке показатьнакарте показатьоповещениепользователя показатьпредупреждение полноеимяпользователя получитьcomобъект получитьxmlтип получитьадреспоместоположению получитьблокировкусеансов получитьвремязавершенияспящегосеанса получитьвремязасыпанияпассивногосеанса получитьвремяожиданияблокировкиданных получитьданныевыбора получитьдополнительныйпараметрклиенталицензирования получитьдопустимыекодылокализации получитьдопустимыечасовыепояса получитьзаголовокклиентскогоприложения получитьзаголовоксистемы получитьзначенияотборажурналарегистрации получитьидентификаторконфигурации получитьизвременногохранилища получитьимявременногофайла получитьимяклиенталицензирования получитьинформациюэкрановклиента получитьиспользованиежурналарегистрации получитьиспользованиесобытияжурналарегистрации получитькраткийзаголовокприложения получитьмакетоформления получитьмаскувсефайлы получитьмаскувсефайлыклиента получитьмаскувсефайлысервера получитьместоположениепоадресу получитьминимальнуюдлинупаролейпользователей получитьнавигационнуюссылку получитьнавигационнуюссылкуинформационнойбазы получитьобновлениеконфигурациибазыданных получитьобновлениепредопределенныхданныхинформационнойбазы получитьобщиймакет получитьобщуюформу получитьокна получитьоперативнуюотметкувремени получитьотключениебезопасногорежима получитьпараметрыфункциональныхопцийинтерфейса получитьполноеимяпредопределенногозначения получитьпредставлениянавигационныхссылок получитьпроверкусложностипаролейпользователей получитьразделительпути получитьразделительпутиклиента получитьразделительпутисервера получитьсеансыинформационнойбазы получитьскоростьклиентскогосоединения получитьсоединенияинформационнойбазы получитьсообщенияпользователю получитьсоответствиеобъектаиформы получитьсоставстандартногоинтерфейсаodata получитьструктурухранениябазыданных получитьтекущийсеансинформационнойбазы получитьфайл получитьфайлы получитьформу получитьфункциональнуюопцию получитьфункциональнуюопциюинтерфейса получитьчасовойпоясинформационнойбазы пользователиос поместитьвовременноехранилище поместитьфайл поместитьфайлы прав праводоступа предопределенноезначение представлениекодалокализации представлениепериода представлениеправа представлениеприложения представлениесобытияжурналарегистрации представлениечасовогопояса предупреждение прекратитьработусистемы привилегированныйрежим продолжитьвызов прочитатьjson прочитатьxml прочитатьдатуjson пустаястрока рабочийкаталогданныхпользователя разблокироватьданныедляредактирования разделитьфайл разорватьсоединениесвнешнимисточникомданных раскодироватьстроку рольдоступна секунда сигнал символ скопироватьжурналрегистрации смещениелетнеговремени смещениестандартноговремени соединитьбуферыдвоичныхданных создатькаталог создатьфабрикуxdto сокрл сокрлп сокрп сообщить состояние сохранитьзначение сохранитьнастройкипользователя сред стрдлина стрзаканчиваетсяна стрзаменить стрнайти стрначинаетсяс строка строкасоединенияинформационнойбазы стрполучитьстроку стрразделить стрсоединить стрсравнить стрчисловхождений стрчислострок стршаблон текущаядата текущаядатасеанса текущаяуниверсальнаядата текущаяуниверсальнаядатавмиллисекундах текущийвариантинтерфейсаклиентскогоприложения текущийвариантосновногошрифтаклиентскогоприложения текущийкодлокализации текущийрежимзапуска текущийязык текущийязыксистемы тип типзнч транзакцияактивна трег удалитьданныеинформационнойбазы удалитьизвременногохранилища удалитьобъекты удалитьфайлы универсальноевремя установитьбезопасныйрежим установитьбезопасныйрежимразделенияданных установитьблокировкусеансов установитьвнешнююкомпоненту установитьвремязавершенияспящегосеанса установитьвремязасыпанияпассивногосеанса установитьвремяожиданияблокировкиданных установитьзаголовокклиентскогоприложения установитьзаголовоксистемы установитьиспользованиежурналарегистрации установитьиспользованиесобытияжурналарегистрации установитькраткийзаголовокприложения установитьминимальнуюдлинупаролейпользователей установитьмонопольныйрежим установитьнастройкиклиенталицензирования установитьобновлениепредопределенныхданныхинформационнойбазы установитьотключениебезопасногорежима установитьпараметрыфункциональныхопцийинтерфейса установитьпривилегированныйрежим установитьпроверкусложностипаролейпользователей установитьрасширениеработыскриптографией установитьрасширениеработысфайлами установитьсоединениесвнешнимисточникомданных установитьсоответствиеобъектаиформы установитьсоставстандартногоинтерфейсаodata установитьчасовойпоясинформационнойбазы установитьчасовойпояссеанса формат цел час часовойпояс часовойпояссеанса число числопрописью этоадресвременногохранилища "+"wsссылки библиотекакартинок библиотекамакетовоформлениякомпоновкиданных библиотекастилей бизнеспроцессы внешниеисточникиданных внешниеобработки внешниеотчеты встроенныепокупки главныйинтерфейс главныйстиль документы доставляемыеуведомления журналыдокументов задачи информацияобинтернетсоединении использованиерабочейдаты историяработыпользователя константы критерииотбора метаданные обработки отображениерекламы отправкадоставляемыхуведомлений отчеты панельзадачос параметрзапуска параметрысеанса перечисления планывидоврасчета планывидовхарактеристик планыобмена планысчетов полнотекстовыйпоиск пользователиинформационнойбазы последовательности проверкавстроенныхпокупок рабочаядата расширенияконфигурации регистрыбухгалтерии регистрынакопления регистрырасчета регистрысведений регламентныезадания сериализаторxdto справочники средствагеопозиционирования средствакриптографии средствамультимедиа средстваотображениярекламы средствапочты средствателефонии фабрикаxdto файловыепотоки фоновыезадания хранилищанастроек хранилищевариантовотчетов хранилищенастроекданныхформ хранилищеобщихнастроек хранилищепользовательскихнастроекдинамическихсписков хранилищепользовательскихнастроекотчетов хранилищесистемныхнастроек ",_e="webцвета windowsцвета windowsшрифты библиотекакартинок рамкистиля символы цветастиля шрифтыстиля "+"автоматическоесохранениеданныхформывнастройках автонумерациявформе автораздвижениесерий анимациядиаграммы вариантвыравниванияэлементовизаголовков вариантуправлениявысотойтаблицы вертикальнаяпрокруткаформы вертикальноеположение вертикальноеположениеэлемента видгруппыформы виддекорацииформы виддополненияэлементаформы видизмененияданных видкнопкиформы видпереключателя видподписейкдиаграмме видполяформы видфлажка влияниеразмеранапузырекдиаграммы горизонтальноеположение горизонтальноеположениеэлемента группировкаколонок группировкаподчиненныхэлементовформы группыиэлементы действиеперетаскивания дополнительныйрежимотображения допустимыедействияперетаскивания интервалмеждуэлементамиформы использованиевывода использованиеполосыпрокрутки используемоезначениеточкибиржевойдиаграммы историявыборапривводе источникзначенийоситочекдиаграммы источникзначенияразмерапузырькадиаграммы категориягруппыкоманд максимумсерий начальноеотображениедерева начальноеотображениесписка обновлениетекстаредактирования ориентациядендрограммы ориентациядиаграммы ориентацияметокдиаграммы ориентацияметоксводнойдиаграммы ориентацияэлементаформы отображениевдиаграмме отображениевлегендедиаграммы отображениегруппыкнопок отображениезаголовкашкалыдиаграммы отображениезначенийсводнойдиаграммы отображениезначенияизмерительнойдиаграммы отображениеинтерваладиаграммыганта отображениекнопки отображениекнопкивыбора отображениеобсужденийформы отображениеобычнойгруппы отображениеотрицательныхзначенийпузырьковойдиаграммы отображениепанелипоиска отображениеподсказки отображениепредупрежденияприредактировании отображениеразметкиполосырегулирования отображениестраницформы отображениетаблицы отображениетекстазначениядиаграммыганта отображениеуправленияобычнойгруппы отображениефигурыкнопки палитрацветовдиаграммы поведениеобычнойгруппы поддержкамасштабадендрограммы поддержкамасштабадиаграммыганта поддержкамасштабасводнойдиаграммы поисквтаблицепривводе положениезаголовкаэлементаформы положениекартинкикнопкиформы положениекартинкиэлементаграфическойсхемы положениекоманднойпанелиформы положениекоманднойпанелиэлементаформы положениеопорнойточкиотрисовки положениеподписейкдиаграмме положениеподписейшкалызначенийизмерительнойдиаграммы положениесостоянияпросмотра положениестрокипоиска положениетекстасоединительнойлинии положениеуправленияпоиском положениешкалывремени порядокотображенияточекгоризонтальнойгистограммы порядоксерийвлегендедиаграммы размеркартинки расположениезаголовкашкалыдиаграммы растягиваниеповертикалидиаграммыганта режимавтоотображениясостояния режимвводастроктаблицы режимвыборанезаполненного режимвыделениядаты режимвыделениястрокитаблицы режимвыделениятаблицы режимизмененияразмера режимизменениясвязанногозначения режимиспользованиядиалогапечати режимиспользованияпараметракоманды режиммасштабированияпросмотра режимосновногоокнаклиентскогоприложения режимоткрытияокнаформы режимотображениявыделения режимотображениягеографическойсхемы режимотображениязначенийсерии режимотрисовкисеткиграфическойсхемы режимполупрозрачностидиаграммы режимпробеловдиаграммы режимразмещениянастранице режимредактированияколонки режимсглаживаниядиаграммы режимсглаживанияиндикатора режимсписказадач сквозноевыравнивание сохранениеданныхформывнастройках способзаполнениятекстазаголовкашкалыдиаграммы способопределенияограничивающегозначениядиаграммы стандартнаягруппакоманд стандартноеоформление статусоповещенияпользователя стильстрелки типаппроксимациилиниитрендадиаграммы типдиаграммы типединицышкалывремени типимпортасерийслоягеографическойсхемы типлиниигеографическойсхемы типлиниидиаграммы типмаркерагеографическойсхемы типмаркерадиаграммы типобластиоформления типорганизацииисточникаданныхгеографическойсхемы типотображениясериислоягеографическойсхемы типотображенияточечногообъектагеографическойсхемы типотображенияшкалыэлементалегендыгеографическойсхемы типпоискаобъектовгеографическойсхемы типпроекциигеографическойсхемы типразмещенияизмерений типразмещенияреквизитовизмерений типрамкиэлементауправления типсводнойдиаграммы типсвязидиаграммыганта типсоединениязначенийпосериямдиаграммы типсоединенияточекдиаграммы типсоединительнойлинии типстороныэлементаграфическойсхемы типформыотчета типшкалырадарнойдиаграммы факторлиниитрендадиаграммы фигуракнопки фигурыграфическойсхемы фиксациявтаблице форматдняшкалывремени форматкартинки ширинаподчиненныхэлементовформы "+"виддвижениябухгалтерии виддвижениянакопления видпериодарегистрарасчета видсчета видточкимаршрутабизнеспроцесса использованиеагрегатарегистранакопления использованиегруппиэлементов использованиережимапроведения использованиесреза периодичностьагрегатарегистранакопления режимавтовремя режимзаписидокумента режимпроведениядокумента "+"авторегистрацияизменений допустимыйномерсообщения отправкаэлементаданных получениеэлементаданных "+"использованиерасшифровкитабличногодокумента ориентациястраницы положениеитоговколоноксводнойтаблицы положениеитоговстроксводнойтаблицы положениетекстаотносительнокартинки расположениезаголовкагруппировкитабличногодокумента способчтениязначенийтабличногодокумента типдвустороннейпечати типзаполненияобластитабличногодокумента типкурсоровтабличногодокумента типлиниирисункатабличногодокумента типлинииячейкитабличногодокумента типнаправленияпереходатабличногодокумента типотображениявыделениятабличногодокумента типотображениялинийсводнойтаблицы типразмещениятекстатабличногодокумента типрисункатабличногодокумента типсмещениятабличногодокумента типузоратабличногодокумента типфайлатабличногодокумента точностьпечати чередованиерасположениястраниц "+"отображениевремениэлементовпланировщика "+"типфайлаформатированногодокумента "+"обходрезультатазапроса типзаписизапроса "+"видзаполнениярасшифровкипостроителяотчета типдобавленияпредставлений типизмеренияпостроителяотчета типразмещенияитогов "+"доступкфайлу режимдиалогавыборафайла режимоткрытияфайла "+"типизмеренияпостроителязапроса "+"видданныханализа методкластеризации типединицыинтервалавременианализаданных типзаполнениятаблицырезультатаанализаданных типиспользованиячисловыхзначенийанализаданных типисточникаданныхпоискаассоциаций типколонкианализаданныхдереворешений типколонкианализаданныхкластеризация типколонкианализаданныхобщаястатистика типколонкианализаданныхпоискассоциаций типколонкианализаданныхпоискпоследовательностей типколонкимоделипрогноза типмерырасстоянияанализаданных типотсеченияправилассоциации типполяанализаданных типстандартизациианализаданных типупорядочиванияправилассоциациианализаданных типупорядочиванияшаблоновпоследовательностейанализаданных типупрощениядереварешений "+"wsнаправлениепараметра вариантxpathxs вариантзаписидатыjson вариантпростоготипаxs видгруппымоделиxs видфасетаxdto действиепостроителяdom завершенностьпростоготипаxs завершенностьсоставноготипаxs завершенностьсхемыxs запрещенныеподстановкиxs исключениягруппподстановкиxs категорияиспользованияатрибутаxs категорияограниченияидентичностиxs категорияограниченияпространствименxs методнаследованияxs модельсодержимогоxs назначениетипаxml недопустимыеподстановкиxs обработкапробельныхсимволовxs обработкасодержимогоxs ограничениезначенияxs параметрыотбораузловdom переносстрокjson позициявдокументеdom пробельныесимволыxml типатрибутаxml типзначенияjson типканоническогоxml типкомпонентыxs типпроверкиxml типрезультатаdomxpath типузлаdom типузлаxml формаxml формапредставленияxs форматдатыjson экранированиесимволовjson "+"видсравнениякомпоновкиданных действиеобработкирасшифровкикомпоновкиданных направлениесортировкикомпоновкиданных расположениевложенныхэлементоврезультатакомпоновкиданных расположениеитоговкомпоновкиданных расположениегруппировкикомпоновкиданных расположениеполейгруппировкикомпоновкиданных расположениеполякомпоновкиданных расположениереквизитовкомпоновкиданных расположениересурсовкомпоновкиданных типбухгалтерскогоостаткакомпоновкиданных типвыводатекстакомпоновкиданных типгруппировкикомпоновкиданных типгруппыэлементовотборакомпоновкиданных типдополненияпериодакомпоновкиданных типзаголовкаполейкомпоновкиданных типмакетагруппировкикомпоновкиданных типмакетаобластикомпоновкиданных типостаткакомпоновкиданных типпериодакомпоновкиданных типразмещениятекстакомпоновкиданных типсвязинаборовданныхкомпоновкиданных типэлементарезультатакомпоновкиданных расположениелегендыдиаграммыкомпоновкиданных типпримененияотборакомпоновкиданных режимотображенияэлементанастройкикомпоновкиданных режимотображениянастроеккомпоновкиданных состояниеэлементанастройкикомпоновкиданных способвосстановлениянастроеккомпоновкиданных режимкомпоновкирезультата использованиепараметракомпоновкиданных автопозицияресурсовкомпоновкиданных вариантиспользованиягруппировкикомпоновкиданных расположениересурсоввдиаграммекомпоновкиданных фиксациякомпоновкиданных использованиеусловногооформлениякомпоновкиданных "+"важностьинтернетпочтовогосообщения обработкатекстаинтернетпочтовогосообщения способкодированияинтернетпочтовоговложения способкодированиянеasciiсимволовинтернетпочтовогосообщения типтекстапочтовогосообщения протоколинтернетпочты статусразборапочтовогосообщения "+"режимтранзакциизаписижурналарегистрации статустранзакциизаписижурналарегистрации уровеньжурналарегистрации "+"расположениехранилищасертификатовкриптографии режимвключениясертификатовкриптографии режимпроверкисертификатакриптографии типхранилищасертификатовкриптографии "+"кодировкаименфайловвzipфайле методсжатияzip методшифрованияzip режимвосстановленияпутейфайловzip режимобработкиподкаталоговzip режимсохраненияпутейzip уровеньсжатияzip "+"звуковоеоповещение направлениепереходакстроке позициявпотоке порядокбайтов режимблокировкиданных режимуправленияблокировкойданных сервисвстроенныхпокупок состояниефоновогозадания типподписчикадоставляемыхуведомлений уровеньиспользованиязащищенногосоединенияftp "+"направлениепорядкасхемызапроса типдополненияпериодамисхемызапроса типконтрольнойточкисхемызапроса типобъединениясхемызапроса типпараметрадоступнойтаблицысхемызапроса типсоединениясхемызапроса "+"httpметод автоиспользованиеобщегореквизита автопрефиксномеразадачи вариантвстроенногоязыка видиерархии видрегистранакопления видтаблицывнешнегоисточникаданных записьдвиженийприпроведении заполнениепоследовательностей индексирование использованиебазыпланавидоврасчета использованиебыстроговыбора использованиеобщегореквизита использованиеподчинения использованиеполнотекстовогопоиска использованиеразделяемыхданныхобщегореквизита использованиереквизита назначениеиспользованияприложения назначениерасширенияконфигурации направлениепередачи обновлениепредопределенныхданных оперативноепроведение основноепредставлениевидарасчета основноепредставлениевидахарактеристики основноепредставлениезадачи основноепредставлениепланаобмена основноепредставлениесправочника основноепредставлениесчета перемещениеграницыприпроведении периодичностьномерабизнеспроцесса периодичностьномерадокумента периодичностьрегистрарасчета периодичностьрегистрасведений повторноеиспользованиевозвращаемыхзначений полнотекстовыйпоискпривводепостроке принадлежностьобъекта проведение разделениеаутентификацииобщегореквизита разделениеданныхобщегореквизита разделениерасширенийконфигурацииобщегореквизита режимавтонумерацииобъектов режимзаписирегистра режимиспользованиямодальности режимиспользованиясинхронныхвызововрасширенийплатформыивнешнихкомпонент режимповторногоиспользованиясеансов режимполученияданныхвыборапривводепостроке режимсовместимости режимсовместимостиинтерфейса режимуправленияблокировкойданныхпоумолчанию сериикодовпланавидовхарактеристик сериикодовпланасчетов сериикодовсправочника созданиепривводе способвыбора способпоискастрокипривводепостроке способредактирования типданныхтаблицывнешнегоисточникаданных типкодапланавидоврасчета типкодасправочника типмакета типномерабизнеспроцесса типномерадокумента типномеразадачи типформы удалениедвижений "+"важностьпроблемыприменениярасширенияконфигурации вариантинтерфейсаклиентскогоприложения вариантмасштабаформклиентскогоприложения вариантосновногошрифтаклиентскогоприложения вариантстандартногопериода вариантстандартнойдатыначала видграницы видкартинки видотображенияполнотекстовогопоиска видрамки видсравнения видцвета видчисловогозначения видшрифта допустимаядлина допустимыйзнак использованиеbyteordermark использованиеметаданныхполнотекстовогопоиска источникрасширенийконфигурации клавиша кодвозвратадиалога кодировкаxbase кодировкатекста направлениепоиска направлениесортировки обновлениепредопределенныхданных обновлениеприизмененииданных отображениепанелиразделов проверказаполнения режимдиалогавопрос режимзапускаклиентскогоприложения режимокругления режимоткрытияформприложения режимполнотекстовогопоиска скоростьклиентскогосоединения состояниевнешнегоисточникаданных состояниеобновленияконфигурациибазыданных способвыборасертификатаwindows способкодированиястроки статуссообщения типвнешнейкомпоненты типплатформы типповеденияклавишиenter типэлементаинформацииовыполненииобновленияконфигурациибазыданных уровеньизоляциитранзакций хешфункция частидаты",ge="comобъект ftpсоединение httpзапрос httpсервисответ httpсоединение wsопределения wsпрокси xbase анализданных аннотацияxs блокировкаданных буфердвоичныхданных включениеxs выражениекомпоновкиданных генераторслучайныхчисел географическаясхема географическиекоординаты графическаясхема группамоделиxs данныерасшифровкикомпоновкиданных двоичныеданные дендрограмма диаграмма диаграммаганта диалогвыборафайла диалогвыборацвета диалогвыборашрифта диалограсписаниярегламентногозадания диалогредактированиястандартногопериода диапазон документdom документhtml документацияxs доставляемоеуведомление записьdom записьfastinfoset записьhtml записьjson записьxml записьzipфайла записьданных записьтекста записьузловdom запрос защищенноесоединениеopenssl значенияполейрасшифровкикомпоновкиданных извлечениетекста импортxs интернетпочта интернетпочтовоесообщение интернетпочтовыйпрофиль интернетпрокси интернетсоединение информациядляприложенияxs использованиеатрибутаxs использованиесобытияжурналарегистрации источникдоступныхнастроеккомпоновкиданных итераторузловdom картинка квалификаторыдаты квалификаторыдвоичныхданных квалификаторыстроки квалификаторычисла компоновщикмакетакомпоновкиданных компоновщикнастроеккомпоновкиданных конструктормакетаоформлениякомпоновкиданных конструкторнастроеккомпоновкиданных конструкторформатнойстроки линия макеткомпоновкиданных макетобластикомпоновкиданных макетоформлениякомпоновкиданных маскаxs менеджеркриптографии наборсхемxml настройкикомпоновкиданных настройкисериализацииjson обработкакартинок обработкарасшифровкикомпоновкиданных обходдереваdom объявлениеатрибутаxs объявлениенотацииxs объявлениеэлементаxs описаниеиспользованиясобытиядоступжурналарегистрации описаниеиспользованиясобытияотказвдоступежурналарегистрации описаниеобработкирасшифровкикомпоновкиданных описаниепередаваемогофайла описаниетипов определениегруппыатрибутовxs определениегруппымоделиxs определениеограниченияидентичностиxs определениепростоготипаxs определениесоставноготипаxs определениетипадокументаdom определенияxpathxs отборкомпоновкиданных пакетотображаемыхдокументов параметрвыбора параметркомпоновкиданных параметрызаписиjson параметрызаписиxml параметрычтенияxml переопределениеxs планировщик полеанализаданных полекомпоновкиданных построительdom построительзапроса построительотчета построительотчетаанализаданных построительсхемxml поток потоквпамяти почта почтовоесообщение преобразованиеxsl преобразованиекканоническомуxml процессорвыводарезультатакомпоновкиданныхвколлекциюзначений процессорвыводарезультатакомпоновкиданныхвтабличныйдокумент процессоркомпоновкиданных разыменовательпространствименdom рамка расписаниерегламентногозадания расширенноеимяxml результатчтенияданных своднаядиаграмма связьпараметравыбора связьпотипу связьпотипукомпоновкиданных сериализаторxdto сертификатклиентаwindows сертификатклиентафайл сертификаткриптографии сертификатыудостоверяющихцентровwindows сертификатыудостоверяющихцентровфайл сжатиеданных системнаяинформация сообщениепользователю сочетаниеклавиш сравнениезначений стандартнаядатаначала стандартныйпериод схемаxml схемакомпоновкиданных табличныйдокумент текстовыйдокумент тестируемоеприложение типданныхxml уникальныйидентификатор фабрикаxdto файл файловыйпоток фасетдлиныxs фасетколичестваразрядовдробнойчастиxs фасетмаксимальноговключающегозначенияxs фасетмаксимальногоисключающегозначенияxs фасетмаксимальнойдлиныxs фасетминимальноговключающегозначенияxs фасетминимальногоисключающегозначенияxs фасетминимальнойдлиныxs фасетобразцаxs фасетобщегоколичестваразрядовxs фасетперечисленияxs фасетпробельныхсимволовxs фильтрузловdom форматированнаястрока форматированныйдокумент фрагментxs хешированиеданных хранилищезначения цвет чтениеfastinfoset чтениеhtml чтениеjson чтениеxml чтениеzipфайла чтениеданных чтениетекста чтениеузловdom шрифт элементрезультатакомпоновкиданных "+"comsafearray деревозначений массив соответствие списокзначений структура таблицазначений фиксированнаяструктура фиксированноесоответствие фиксированныймассив ",Te="null истина ложь неопределено",se=e.inherit(e.NUMBER_MODE),ue={className:"string",begin:'"|\\\\|',end:'"|$',contains:[{begin:'""'}]},Z={begin:"'",end:"'",excludeBegin:!0,excludeEnd:!0,contains:[{className:"number",begin:"\\\\d{4}([\\\\.\\\\\\\\/:-]?\\\\d{2}){0,5}"}]},K={match:/[;()+\\-:=,]/,className:"punctuation",relevance:0},te=e.inherit(e.C_LINE_COMMENT_MODE),ne={className:"meta",begin:"#|&",end:"$",keywords:{$pattern:n,keyword:i+_},contains:[te]},le={className:"symbol",begin:"~",end:";|:",excludeEnd:!0},be={className:"function",variants:[{begin:"процедура|функция",end:"\\\\)",keywords:"процедура функция"},{begin:"конецпроцедуры|конецфункции",keywords:"конецпроцедуры конецфункции"}],contains:[{begin:"\\\\(",end:"\\\\)",endsParent:!0,contains:[{className:"params",begin:n,end:",",excludeEnd:!0,endsWithParent:!0,keywords:{$pattern:n,keyword:"знач",literal:Te},contains:[se,ue,Z]},te]},e.inherit(e.TITLE_MODE,{begin:n})]};return{name:"1C:Enterprise",case_insensitive:!0,keywords:{$pattern:n,keyword:i,built_in:p,class:_e,type:ge,literal:Te},contains:[ne,be,te,le,se,ue,Z,K]}}return bt=t,bt}var Rt,li;function Ic(){if(li)return Rt;li=1;function t(e){const n=e.regex,a=/^[a-zA-Z][a-zA-Z0-9-]*/,r=["ALPHA","BIT","CHAR","CR","CRLF","CTL","DIGIT","DQUOTE","HEXDIG","HTAB","LF","LWSP","OCTET","SP","VCHAR","WSP"],i=e.COMMENT(/;/,/$/),s={scope:"symbol",match:/%b[0-1]+(-[0-1]+|(\\.[0-1]+)+)?/},o={scope:"symbol",match:/%d[0-9]+(-[0-9]+|(\\.[0-9]+)+)?/},_={scope:"symbol",match:/%x[0-9A-F]+(-[0-9A-F]+|(\\.[0-9A-F]+)+)?/},l={scope:"symbol",match:/%[si](?=".*")/},c={scope:"attribute",match:n.concat(a,/(?=\\s*=)/)};return{name:"Augmented Backus-Naur Form",illegal:/[!@#$^&',?+~\`|:]/,keywords:r,contains:[{scope:"operator",match:/=\\/?/},c,i,s,o,_,l,e.QUOTE_STRING_MODE,e.NUMBER_MODE]}}return Rt=t,Rt}var ft,ci;function Ac(){if(ci)return ft;ci=1;function t(e){const n=e.regex,a=["GET","POST","HEAD","PUT","DELETE","CONNECT","OPTIONS","PATCH","TRACE"];return{name:"Apache Access Log",contains:[{className:"number",begin:/^\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}(:\\d{1,5})?\\b/,relevance:5},{className:"number",begin:/\\b\\d+\\b/,relevance:0},{className:"string",begin:n.concat(/"/,n.either(...a)),end:/"/,keywords:a,illegal:/\\n/,relevance:5,contains:[{begin:/HTTP\\/[12]\\.\\d'/,relevance:5}]},{className:"string",begin:/\\[\\d[^\\]\\n]{8,}\\]/,illegal:/\\n/,relevance:1},{className:"string",begin:/\\[/,end:/\\]/,illegal:/\\n/,relevance:0},{className:"string",begin:/"Mozilla\\/\\d\\.\\d \\(/,end:/"/,illegal:/\\n/,relevance:3},{className:"string",begin:/"/,end:/"/,illegal:/\\n/,relevance:0}]}}return ft=t,ft}var Ct,_i;function vc(){if(_i)return Ct;_i=1;function t(e){const n=e.regex,a=/[a-zA-Z_$][a-zA-Z0-9_$]*/,r=n.concat(a,n.concat("(\\\\.",a,")*")),i=/([*]|[a-zA-Z_$][a-zA-Z0-9_$]*)/,s={className:"rest_arg",begin:/[.]{3}/,end:a,relevance:10};return{name:"ActionScript",aliases:["as"],keywords:{keyword:["as","break","case","catch","class","const","continue","default","delete","do","dynamic","each","else","extends","final","finally","for","function","get","if","implements","import","in","include","instanceof","interface","internal","is","namespace","native","new","override","package","private","protected","public","return","set","static","super","switch","this","throw","try","typeof","use","var","void","while","with"],literal:["true","false","null","undefined"]},contains:[e.APOS_STRING_MODE,e.QUOTE_STRING_MODE,e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,e.C_NUMBER_MODE,{match:[/\\bpackage/,/\\s+/,r],className:{1:"keyword",3:"title.class"}},{match:[/\\b(?:class|interface|extends|implements)/,/\\s+/,a],className:{1:"keyword",3:"title.class"}},{className:"meta",beginKeywords:"import include",end:/;/,keywords:{keyword:"import include"}},{beginKeywords:"function",end:/[{;]/,excludeEnd:!0,illegal:/\\S/,contains:[e.inherit(e.TITLE_MODE,{className:"title.function"}),{className:"params",begin:/\\(/,end:/\\)/,contains:[e.APOS_STRING_MODE,e.QUOTE_STRING_MODE,e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,s]},{begin:n.concat(/:\\s*/,i)}]},e.METHOD_GUARD],illegal:/#/}}return Ct=t,Ct}var Nt,di;function yc(){if(di)return Nt;di=1;function t(e){const n="\\\\d(_|\\\\d)*",a="[eE][-+]?"+n,r=n+"(\\\\."+n+")?("+a+")?",i="\\\\w+",o="\\\\b("+(n+"#"+i+"(\\\\."+i+")?#("+a+")?")+"|"+r+")",_="[A-Za-z](_?[A-Za-z0-9.])*",l=\`[]\\\\{\\\\}%#'"\`,c=e.COMMENT("--","$"),d={begin:"\\\\s+:\\\\s+",end:"\\\\s*(:=|;|\\\\)|=>|$)",illegal:l,contains:[{beginKeywords:"loop for declare others",endsParent:!0},{className:"keyword",beginKeywords:"not null constant access function procedure in out aliased exception"},{className:"type",begin:_,endsParent:!0,relevance:0}]};return{name:"Ada",case_insensitive:!0,keywords:{keyword:["abort","else","new","return","abs","elsif","not","reverse","abstract","end","accept","entry","select","access","exception","of","separate","aliased","exit","or","some","all","others","subtype","and","for","out","synchronized","array","function","overriding","at","tagged","generic","package","task","begin","goto","pragma","terminate","body","private","then","if","procedure","type","case","in","protected","constant","interface","is","raise","use","declare","range","delay","limited","record","when","delta","loop","rem","while","digits","renames","with","do","mod","requeue","xor"],literal:["True","False"]},contains:[c,{className:"string",begin:/"/,end:/"/,contains:[{begin:/""/,relevance:0}]},{className:"string",begin:/'.'/},{className:"number",begin:o,relevance:0},{className:"symbol",begin:"'"+_},{className:"title",begin:"(\\\\bwith\\\\s+)?(\\\\bprivate\\\\s+)?\\\\bpackage\\\\s+(\\\\bbody\\\\s+)?",end:"(is|$)",keywords:"package body",excludeBegin:!0,excludeEnd:!0,illegal:l},{begin:"(\\\\b(with|overriding)\\\\s+)?\\\\b(function|procedure)\\\\s+",end:"(\\\\bis|\\\\bwith|\\\\brenames|\\\\)\\\\s*;)",keywords:"overriding function procedure with is renames return",returnBegin:!0,contains:[c,{className:"title",begin:"(\\\\bwith\\\\s+)?\\\\b(function|procedure)\\\\s+",end:"(\\\\(|\\\\s+|$)",excludeBegin:!0,excludeEnd:!0,illegal:l},d,{className:"type",begin:"\\\\breturn\\\\s+",end:"(\\\\s+|;|$)",keywords:"return",excludeBegin:!0,excludeEnd:!0,endsParent:!0,illegal:l}]},{className:"type",begin:"\\\\b(sub)?type\\\\s+",end:"\\\\s+",keywords:"type",excludeBegin:!0,illegal:l},d]}}return Nt=t,Nt}var Ot,ui;function hc(){if(ui)return Ot;ui=1;function t(e){const n={className:"built_in",begin:"\\\\b(void|bool|int8|int16|int32|int64|int|uint8|uint16|uint32|uint64|uint|string|ref|array|double|float|auto|dictionary)"},a={className:"symbol",begin:"[a-zA-Z0-9_]+@"},r={className:"keyword",begin:"<",end:">",contains:[n,a]};return n.contains=[r],a.contains=[r],{name:"AngelScript",aliases:["asc"],keywords:["for","in|0","break","continue","while","do|0","return","if","else","case","switch","namespace","is","cast","or","and","xor","not","get|0","in","inout|10","out","override","set|0","private","public","const","default|0","final","shared","external","mixin|10","enum","typedef","funcdef","this","super","import","from","interface","abstract|0","try","catch","protected","explicit","property"],illegal:"(^using\\\\s+[A-Za-z0-9_\\\\.]+;$|\\\\bfunction\\\\s*[^\\\\(])",contains:[{className:"string",begin:"'",end:"'",illegal:"\\\\n",contains:[e.BACKSLASH_ESCAPE],relevance:0},{className:"string",begin:'"""',end:'"""'},{className:"string",begin:'"',end:'"',illegal:"\\\\n",contains:[e.BACKSLASH_ESCAPE],relevance:0},e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,{className:"string",begin:"^\\\\s*\\\\[",end:"\\\\]"},{beginKeywords:"interface namespace",end:/\\{/,illegal:"[;.\\\\-]",contains:[{className:"symbol",begin:"[a-zA-Z0-9_]+"}]},{beginKeywords:"class",end:/\\{/,illegal:"[;.\\\\-]",contains:[{className:"symbol",begin:"[a-zA-Z0-9_]+",contains:[{begin:"[:,]\\\\s*",contains:[{className:"symbol",begin:"[a-zA-Z0-9_]+"}]}]}]},n,a,{className:"literal",begin:"\\\\b(null|true|false)"},{className:"number",relevance:0,begin:"(-?)(\\\\b0[xXbBoOdD][a-fA-F0-9]+|(\\\\b\\\\d+(\\\\.\\\\d*)?f?|\\\\.\\\\d+f?)([eE][-+]?\\\\d+f?)?)"}]}}return Ot=t,Ot}var It,mi;function Dc(){if(mi)return It;mi=1;function t(e){const n={className:"number",begin:/[$%]\\d+/},a={className:"number",begin:/\\b\\d+/},r={className:"number",begin:/\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}(:\\d{1,5})?/},i={className:"number",begin:/:\\d{1,5}/};return{name:"Apache config",aliases:["apacheconf"],case_insensitive:!0,contains:[e.HASH_COMMENT_MODE,{className:"section",begin:/<\\/?/,end:/>/,contains:[r,i,e.inherit(e.QUOTE_STRING_MODE,{relevance:0})]},{className:"attribute",begin:/\\w+/,relevance:0,keywords:{_:["order","deny","allow","setenv","rewriterule","rewriteengine","rewritecond","documentroot","sethandler","errordocument","loadmodule","options","header","listen","serverroot","servername"]},starts:{end:/$/,relevance:0,keywords:{literal:"on off all deny allow"},contains:[{scope:"punctuation",match:/\\\\\\n/},{className:"meta",begin:/\\s\\[/,end:/\\]$/},{className:"variable",begin:/[\\$%]\\{/,end:/\\}/,contains:["self",n]},r,a,e.QUOTE_STRING_MODE]}}],illegal:/\\S/}}return It=t,It}var At,pi;function Mc(){if(pi)return At;pi=1;function t(e){const n=e.regex,a=e.inherit(e.QUOTE_STRING_MODE,{illegal:null}),r={className:"params",begin:/\\(/,end:/\\)/,contains:["self",e.C_NUMBER_MODE,a]},i=e.COMMENT(/--/,/$/),s=e.COMMENT(/\\(\\*/,/\\*\\)/,{contains:["self",i]}),o=[i,s,e.HASH_COMMENT_MODE],_=[/apart from/,/aside from/,/instead of/,/out of/,/greater than/,/isn't|(doesn't|does not) (equal|come before|come after|contain)/,/(greater|less) than( or equal)?/,/(starts?|ends|begins?) with/,/contained by/,/comes (before|after)/,/a (ref|reference)/,/POSIX (file|path)/,/(date|time) string/,/quoted form/],l=[/clipboard info/,/the clipboard/,/info for/,/list (disks|folder)/,/mount volume/,/path to/,/(close|open for) access/,/(get|set) eof/,/current date/,/do shell script/,/get volume settings/,/random number/,/set volume/,/system attribute/,/system info/,/time to GMT/,/(load|run|store) script/,/scripting components/,/ASCII (character|number)/,/localized string/,/choose (application|color|file|file name|folder|from list|remote application|URL)/,/display (alert|dialog)/];return{name:"AppleScript",aliases:["osascript"],keywords:{keyword:"about above after against and around as at back before beginning behind below beneath beside between but by considering contain contains continue copy div does eighth else end equal equals error every exit fifth first for fourth from front get given global if ignoring in into is it its last local me middle mod my ninth not of on onto or over prop property put ref reference repeat returning script second set seventh since sixth some tell tenth that the|0 then third through thru timeout times to transaction try until where while whose with without",literal:"AppleScript false linefeed return pi quote result space tab true",built_in:"alias application boolean class constant date file integer list number real record string text activate beep count delay launch log offset read round run say summarize write character characters contents day frontmost id item length month name|0 paragraph paragraphs rest reverse running time version weekday word words year"},contains:[a,e.C_NUMBER_MODE,{className:"built_in",begin:n.concat(/\\b/,n.either(...l),/\\b/)},{className:"built_in",begin:/^\\s*return\\b/},{className:"literal",begin:/\\b(text item delimiters|current application|missing value)\\b/},{className:"keyword",begin:n.concat(/\\b/,n.either(..._),/\\b/)},{beginKeywords:"on",illegal:/[\${=;\\n]/,contains:[e.UNDERSCORE_TITLE_MODE,r]},...o],illegal:/\\/\\/|->|=>|\\[\\[/}}return At=t,At}var vt,Ei;function Lc(){if(Ei)return vt;Ei=1;function t(e){const n=e.regex,a="[A-Za-z_][0-9A-Za-z_]*",r={keyword:["break","case","catch","continue","debugger","do","else","export","for","function","if","import","in","new","of","return","switch","try","var","void","while"],literal:["BackSlash","DoubleQuote","ForwardSlash","Infinity","NaN","NewLine","PI","SingleQuote","Tab","TextFormatting","false","null","true","undefined"],built_in:["Abs","Acos","All","Angle","Any","Area","AreaGeodetic","Array","Asin","Atan","Atan2","Attachments","Average","Back","Bearing","Boolean","Buffer","BufferGeodetic","Ceil","Centroid","ChangeTimeZone","Clip","Concatenate","Console","Constrain","Contains","ConvertDirection","ConvexHull","Cos","Count","Crosses","Cut","Date|0","DateAdd","DateDiff","DateOnly","Day","Decode","DefaultValue","Densify","DensifyGeodetic","Dictionary","Difference","Disjoint","Distance","DistanceGeodetic","DistanceToCoordinate","Distinct","Domain","DomainCode","DomainName","EnvelopeIntersects","Equals","Erase","Exp","Expects","Extent","Feature","FeatureInFilter","FeatureSet","FeatureSetByAssociation","FeatureSetById","FeatureSetByName","FeatureSetByPortalItem","FeatureSetByRelationshipClass","FeatureSetByRelationshipName","Filter","FilterBySubtypeCode","Find","First|0","Floor","FromCharCode","FromCodePoint","FromJSON","Front","GdbVersion","Generalize","Geometry","GetEnvironment","GetFeatureSet","GetFeatureSetInfo","GetUser","GroupBy","Guid","HasKey","HasValue","Hash","Hour","IIf","ISOMonth","ISOWeek","ISOWeekday","ISOYear","Includes","IndexOf","Insert","Intersection","Intersects","IsEmpty","IsNan","IsSelfIntersecting","IsSimple","KnowledgeGraphByPortalItem","Left|0","Length","Length3D","LengthGeodetic","Log","Lower","Map","Max","Mean","MeasureToCoordinate","Mid","Millisecond","Min","Minute","Month","MultiPartToSinglePart","Multipoint","NearestCoordinate","NearestVertex","NextSequenceValue","None","Now","Number","Offset","OrderBy","Overlaps","Point","PointToCoordinate","Polygon","Polyline","Pop","Portal","Pow","Proper","Push","QueryGraph","Random","Reduce","Relate","Replace","Resize","Reverse","Right|0","RingIsClockwise","Rotate","Round","Schema","Second","SetGeometry","Simplify","Sin","Slice","Sort","Splice","Split","Sqrt","StandardizeFilename","StandardizeGuid","Stdev","SubtypeCode","SubtypeName","Subtypes","Sum","SymmetricDifference","Tan","Text","Time","TimeZone","TimeZoneOffset","Timestamp","ToCharCode","ToCodePoint","ToHex","ToLocal","ToUTC","Today","Top|0","Touches","TrackAccelerationAt","TrackAccelerationWindow","TrackCurrentAcceleration","TrackCurrentDistance","TrackCurrentSpeed","TrackCurrentTime","TrackDistanceAt","TrackDistanceWindow","TrackDuration","TrackFieldWindow","TrackGeometryWindow","TrackIndex","TrackSpeedAt","TrackSpeedWindow","TrackStartTime","TrackWindow","Trim","TypeOf","Union","Upper","UrlEncode","Variance","Week","Weekday","When|0","Within","Year|0"]},i=["aggregatedFeatures","analytic","config","datapoint","datastore","editcontext","feature","featureSet","feedfeature","fencefeature","fencenotificationtype","graph","join","layer","locationupdate","map","measure","measure","originalFeature","record","reference","rowindex","sourcedatastore","sourcefeature","sourcelayer","target","targetdatastore","targetfeature","targetlayer","userInput","value","variables","view"],s={className:"symbol",begin:"\\\\$"+n.either(...i)},o={className:"number",variants:[{begin:"\\\\b(0[bB][01]+)"},{begin:"\\\\b(0[oO][0-7]+)"},{begin:e.C_NUMBER_RE}],relevance:0},_={className:"subst",begin:"\\\\$\\\\{",end:"\\\\}",keywords:r,contains:[]},l={className:"string",begin:"\`",end:"\`",contains:[e.BACKSLASH_ESCAPE,_]};_.contains=[e.APOS_STRING_MODE,e.QUOTE_STRING_MODE,l,o,e.REGEXP_MODE];const c=_.contains.concat([e.C_BLOCK_COMMENT_MODE,e.C_LINE_COMMENT_MODE]);return{name:"ArcGIS Arcade",case_insensitive:!0,keywords:r,contains:[e.APOS_STRING_MODE,e.QUOTE_STRING_MODE,l,e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,s,o,{begin:/[{,]\\s*/,relevance:0,contains:[{begin:a+"\\\\s*:",returnBegin:!0,relevance:0,contains:[{className:"attr",begin:a,relevance:0}]}]},{begin:"("+e.RE_STARTERS_RE+"|\\\\b(return)\\\\b)\\\\s*",keywords:"return",contains:[e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,e.REGEXP_MODE,{className:"function",begin:"(\\\\(.*?\\\\)|"+a+")\\\\s*=>",returnBegin:!0,end:"\\\\s*=>",contains:[{className:"params",variants:[{begin:a},{begin:/\\(\\s*\\)/},{begin:/\\(/,end:/\\)/,excludeBegin:!0,excludeEnd:!0,keywords:r,contains:c}]}]}],relevance:0},{beginKeywords:"function",end:/\\{/,excludeEnd:!0,contains:[e.inherit(e.TITLE_MODE,{className:"title.function",begin:a}),{className:"params",begin:/\\(/,end:/\\)/,excludeBegin:!0,excludeEnd:!0,contains:c}],illegal:/\\[|%/},{begin:/\\$[(.]/}],illegal:/#(?!!)/}}return vt=t,vt}var yt,gi;function xc(){if(gi)return yt;gi=1;function t(n){const a=n.regex,r=n.COMMENT("//","$",{contains:[{begin:/\\\\\\n/}]}),i="decltype\\\\(auto\\\\)",s="[a-zA-Z_]\\\\w*::",_="(?!struct)("+i+"|"+a.optional(s)+"[a-zA-Z_]\\\\w*"+a.optional("<[^<>]+>")+")",l={className:"type",begin:"\\\\b[a-z\\\\d_]*_t\\\\b"},d={className:"string",variants:[{begin:'(u8?|U|L)?"',end:'"',illegal:"\\\\n",contains:[n.BACKSLASH_ESCAPE]},{begin:"(u8?|U|L)?'("+"\\\\\\\\(x[0-9A-Fa-f]{2}|u[0-9A-Fa-f]{4,8}|[0-7]{3}|\\\\S)"+"|.)",end:"'",illegal:"."},n.END_SAME_AS_BEGIN({begin:/(?:u8?|U|L)?R"([^()\\\\ ]{0,16})\\(/,end:/\\)([^()\\\\ ]{0,16})"/})]},m={className:"number",variants:[{begin:"[+-]?(?:(?:[0-9](?:'?[0-9])*\\\\.(?:[0-9](?:'?[0-9])*)?|\\\\.[0-9](?:'?[0-9])*)(?:[Ee][+-]?[0-9](?:'?[0-9])*)?|[0-9](?:'?[0-9])*[Ee][+-]?[0-9](?:'?[0-9])*|0[Xx](?:[0-9A-Fa-f](?:'?[0-9A-Fa-f])*(?:\\\\.(?:[0-9A-Fa-f](?:'?[0-9A-Fa-f])*)?)?|\\\\.[0-9A-Fa-f](?:'?[0-9A-Fa-f])*)[Pp][+-]?[0-9](?:'?[0-9])*)(?:[Ff](?:16|32|64|128)?|(BF|bf)16|[Ll]|)"},{begin:"[+-]?\\\\b(?:0[Bb][01](?:'?[01])*|0[Xx][0-9A-Fa-f](?:'?[0-9A-Fa-f])*|0(?:'?[0-7])*|[1-9](?:'?[0-9])*)(?:[Uu](?:LL?|ll?)|[Uu][Zz]?|(?:LL?|ll?)[Uu]?|[Zz][Uu]|)"}],relevance:0},p={className:"meta",begin:/#\\s*[a-z]+\\b/,end:/$/,keywords:{keyword:"if else elif endif define undef warning error line pragma _Pragma ifdef ifndef include"},contains:[{begin:/\\\\\\n/,relevance:0},n.inherit(d,{className:"string"}),{className:"string",begin:/<.*?>/},r,n.C_BLOCK_COMMENT_MODE]},E={className:"title",begin:a.optional(s)+n.IDENT_RE,relevance:0},g=a.optional(s)+n.IDENT_RE+"\\\\s*\\\\(",S=["alignas","alignof","and","and_eq","asm","atomic_cancel","atomic_commit","atomic_noexcept","auto","bitand","bitor","break","case","catch","class","co_await","co_return","co_yield","compl","concept","const_cast|10","consteval","constexpr","constinit","continue","decltype","default","delete","do","dynamic_cast|10","else","enum","explicit","export","extern","false","final","for","friend","goto","if","import","inline","module","mutable","namespace","new","noexcept","not","not_eq","nullptr","operator","or","or_eq","override","private","protected","public","reflexpr","register","reinterpret_cast|10","requires","return","sizeof","static_assert","static_cast|10","struct","switch","synchronized","template","this","thread_local","throw","transaction_safe","transaction_safe_dynamic","true","try","typedef","typeid","typename","union","using","virtual","volatile","while","xor","xor_eq"],T=["bool","char","char16_t","char32_t","char8_t","double","float","int","long","short","void","wchar_t","unsigned","signed","const","static"],R=["any","auto_ptr","barrier","binary_semaphore","bitset","complex","condition_variable","condition_variable_any","counting_semaphore","deque","false_type","flat_map","flat_set","future","imaginary","initializer_list","istringstream","jthread","latch","lock_guard","multimap","multiset","mutex","optional","ostringstream","packaged_task","pair","promise","priority_queue","queue","recursive_mutex","recursive_timed_mutex","scoped_lock","set","shared_future","shared_lock","shared_mutex","shared_timed_mutex","shared_ptr","stack","string_view","stringstream","timed_mutex","thread","true_type","tuple","unique_lock","unique_ptr","unordered_map","unordered_multimap","unordered_multiset","unordered_set","variant","vector","weak_ptr","wstring","wstring_view"],f=["abort","abs","acos","apply","as_const","asin","atan","atan2","calloc","ceil","cerr","cin","clog","cos","cosh","cout","declval","endl","exchange","exit","exp","fabs","floor","fmod","forward","fprintf","fputs","free","frexp","fscanf","future","invoke","isalnum","isalpha","iscntrl","isdigit","isgraph","islower","isprint","ispunct","isspace","isupper","isxdigit","labs","launder","ldexp","log","log10","make_pair","make_shared","make_shared_for_overwrite","make_tuple","make_unique","malloc","memchr","memcmp","memcpy","memset","modf","move","pow","printf","putchar","puts","realloc","scanf","sin","sinh","snprintf","sprintf","sqrt","sscanf","std","stderr","stdin","stdout","strcat","strchr","strcmp","strcpy","strcspn","strlen","strncat","strncmp","strncpy","strpbrk","strrchr","strspn","strstr","swap","tan","tanh","terminate","to_underlying","tolower","toupper","vfprintf","visit","vprintf","vsprintf"],C={type:T,keyword:S,literal:["NULL","false","nullopt","nullptr","true"],built_in:["_Pragma"],_type_hints:R},M={className:"function.dispatch",relevance:0,keywords:{_hint:f},begin:a.concat(/\\b/,/(?!decltype)/,/(?!if)/,/(?!for)/,/(?!switch)/,/(?!while)/,n.IDENT_RE,a.lookahead(/(<[^<>]+>|)\\s*\\(/))},y=[M,p,l,r,n.C_BLOCK_COMMENT_MODE,m,d],x={variants:[{begin:/=/,end:/;/},{begin:/\\(/,end:/\\)/},{beginKeywords:"new throw return else",end:/;/}],keywords:C,contains:y.concat([{begin:/\\(/,end:/\\)/,keywords:C,contains:y.concat(["self"]),relevance:0}]),relevance:0},G={className:"function",begin:"("+_+"[\\\\*&\\\\s]+)+"+g,returnBegin:!0,end:/[{;=]/,excludeEnd:!0,keywords:C,illegal:/[^\\w\\s\\*&:<>.]/,contains:[{begin:i,keywords:C,relevance:0},{begin:g,returnBegin:!0,contains:[E],relevance:0},{begin:/::/,relevance:0},{begin:/:/,endsWithParent:!0,contains:[d,m]},{relevance:0,match:/,/},{className:"params",begin:/\\(/,end:/\\)/,keywords:C,relevance:0,contains:[r,n.C_BLOCK_COMMENT_MODE,d,m,l,{begin:/\\(/,end:/\\)/,keywords:C,relevance:0,contains:["self",r,n.C_BLOCK_COMMENT_MODE,d,m,l]}]},l,r,n.C_BLOCK_COMMENT_MODE,p]};return{name:"C++",aliases:["cc","c++","h++","hpp","hh","hxx","cxx"],keywords:C,illegal:"</",classNameAliases:{"function.dispatch":"built_in"},contains:[].concat(x,G,M,y,[p,{begin:"\\\\b(deque|list|queue|priority_queue|pair|stack|vector|map|set|bitset|multiset|multimap|unordered_map|unordered_set|unordered_multiset|unordered_multimap|array|tuple|optional|variant|function|flat_map|flat_set)\\\\s*<(?!<)",end:">",keywords:C,contains:["self",l]},{begin:n.IDENT_RE+"::",keywords:C},{match:[/\\b(?:enum(?:\\s+(?:class|struct))?|class|struct|union)/,/\\s+/,/\\w+/],className:{1:"keyword",3:"title.class"}}])}}function e(n){const a={type:["boolean","byte","word","String"],built_in:["KeyboardController","MouseController","SoftwareSerial","EthernetServer","EthernetClient","LiquidCrystal","RobotControl","GSMVoiceCall","EthernetUDP","EsploraTFT","HttpClient","RobotMotor","WiFiClient","GSMScanner","FileSystem","Scheduler","GSMServer","YunClient","YunServer","IPAddress","GSMClient","GSMModem","Keyboard","Ethernet","Console","GSMBand","Esplora","Stepper","Process","WiFiUDP","GSM_SMS","Mailbox","USBHost","Firmata","PImage","Client","Server","GSMPIN","FileIO","Bridge","Serial","EEPROM","Stream","Mouse","Audio","Servo","File","Task","GPRS","WiFi","Wire","TFT","GSM","SPI","SD"],_hints:["setup","loop","runShellCommandAsynchronously","analogWriteResolution","retrieveCallingNumber","printFirmwareVersion","analogReadResolution","sendDigitalPortPair","noListenOnLocalhost","readJoystickButton","setFirmwareVersion","readJoystickSwitch","scrollDisplayRight","getVoiceCallStatus","scrollDisplayLeft","writeMicroseconds","delayMicroseconds","beginTransmission","getSignalStrength","runAsynchronously","getAsynchronously","listenOnLocalhost","getCurrentCarrier","readAccelerometer","messageAvailable","sendDigitalPorts","lineFollowConfig","countryNameWrite","runShellCommand","readStringUntil","rewindDirectory","readTemperature","setClockDivider","readLightSensor","endTransmission","analogReference","detachInterrupt","countryNameRead","attachInterrupt","encryptionType","readBytesUntil","robotNameWrite","readMicrophone","robotNameRead","cityNameWrite","userNameWrite","readJoystickY","readJoystickX","mouseReleased","openNextFile","scanNetworks","noInterrupts","digitalWrite","beginSpeaker","mousePressed","isActionDone","mouseDragged","displayLogos","noAutoscroll","addParameter","remoteNumber","getModifiers","keyboardRead","userNameRead","waitContinue","processInput","parseCommand","printVersion","readNetworks","writeMessage","blinkVersion","cityNameRead","readMessage","setDataMode","parsePacket","isListening","setBitOrder","beginPacket","isDirectory","motorsWrite","drawCompass","digitalRead","clearScreen","serialEvent","rightToLeft","setTextSize","leftToRight","requestFrom","keyReleased","compassRead","analogWrite","interrupts","WiFiServer","disconnect","playMelody","parseFloat","autoscroll","getPINUsed","setPINUsed","setTimeout","sendAnalog","readSlider","analogRead","beginWrite","createChar","motorsStop","keyPressed","tempoWrite","readButton","subnetMask","debugPrint","macAddress","writeGreen","randomSeed","attachGPRS","readString","sendString","remotePort","releaseAll","mouseMoved","background","getXChange","getYChange","answerCall","getResult","voiceCall","endPacket","constrain","getSocket","writeJSON","getButton","available","connected","findUntil","readBytes","exitValue","readGreen","writeBlue","startLoop","IPAddress","isPressed","sendSysex","pauseMode","gatewayIP","setCursor","getOemKey","tuneWrite","noDisplay","loadImage","switchPIN","onRequest","onReceive","changePIN","playFile","noBuffer","parseInt","overflow","checkPIN","knobRead","beginTFT","bitClear","updateIR","bitWrite","position","writeRGB","highByte","writeRed","setSpeed","readBlue","noStroke","remoteIP","transfer","shutdown","hangCall","beginSMS","endWrite","attached","maintain","noCursor","checkReg","checkPUK","shiftOut","isValid","shiftIn","pulseIn","connect","println","localIP","pinMode","getIMEI","display","noBlink","process","getBand","running","beginSD","drawBMP","lowByte","setBand","release","bitRead","prepare","pointTo","readRed","setMode","noFill","remove","listen","stroke","detach","attach","noTone","exists","buffer","height","bitSet","circle","config","cursor","random","IRread","setDNS","endSMS","getKey","micros","millis","begin","print","write","ready","flush","width","isPIN","blink","clear","press","mkdir","rmdir","close","point","yield","image","BSSID","click","delay","read","text","move","peek","beep","rect","line","open","seek","fill","size","turn","stop","home","find","step","tone","sqrt","RSSI","SSID","end","bit","tan","cos","sin","pow","map","abs","max","min","get","run","put"],literal:["DIGITAL_MESSAGE","FIRMATA_STRING","ANALOG_MESSAGE","REPORT_DIGITAL","REPORT_ANALOG","INPUT_PULLUP","SET_PIN_MODE","INTERNAL2V56","SYSTEM_RESET","LED_BUILTIN","INTERNAL1V1","SYSEX_START","INTERNAL","EXTERNAL","DEFAULT","OUTPUT","INPUT","HIGH","LOW"]},r=t(n),i=r.keywords;return i.type=[...i.type,...a.type],i.literal=[...i.literal,...a.literal],i.built_in=[...i.built_in,...a.built_in],i._hints=a._hints,r.name="Arduino",r.aliases=["ino"],r.supersetOf="cpp",r}return yt=e,yt}var ht,Si;function wc(){if(Si)return ht;Si=1;function t(e){const n={variants:[e.COMMENT("^[ \\\\t]*(?=#)","$",{relevance:0,excludeBegin:!0}),e.COMMENT("[;@]","$",{relevance:0}),e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE]};return{name:"ARM Assembly",case_insensitive:!0,aliases:["arm"],keywords:{$pattern:"\\\\.?"+e.IDENT_RE,meta:".2byte .4byte .align .ascii .asciz .balign .byte .code .data .else .end .endif .endm .endr .equ .err .exitm .extern .global .hword .if .ifdef .ifndef .include .irp .long .macro .rept .req .section .set .skip .space .text .word .arm .thumb .code16 .code32 .force_thumb .thumb_func .ltorg ALIAS ALIGN ARM AREA ASSERT ATTR CN CODE CODE16 CODE32 COMMON CP DATA DCB DCD DCDU DCDO DCFD DCFDU DCI DCQ DCQU DCW DCWU DN ELIF ELSE END ENDFUNC ENDIF ENDP ENTRY EQU EXPORT EXPORTAS EXTERN FIELD FILL FUNCTION GBLA GBLL GBLS GET GLOBAL IF IMPORT INCBIN INCLUDE INFO KEEP LCLA LCLL LCLS LTORG MACRO MAP MEND MEXIT NOFP OPT PRESERVE8 PROC QN READONLY RELOC REQUIRE REQUIRE8 RLIST FN ROUT SETA SETL SETS SN SPACE SUBT THUMB THUMBX TTL WHILE WEND ",built_in:"r0 r1 r2 r3 r4 r5 r6 r7 r8 r9 r10 r11 r12 r13 r14 r15 w0 w1 w2 w3 w4 w5 w6 w7 w8 w9 w10 w11 w12 w13 w14 w15 w16 w17 w18 w19 w20 w21 w22 w23 w24 w25 w26 w27 w28 w29 w30 x0 x1 x2 x3 x4 x5 x6 x7 x8 x9 x10 x11 x12 x13 x14 x15 x16 x17 x18 x19 x20 x21 x22 x23 x24 x25 x26 x27 x28 x29 x30 pc lr sp ip sl sb fp a1 a2 a3 a4 v1 v2 v3 v4 v5 v6 v7 v8 f0 f1 f2 f3 f4 f5 f6 f7 p0 p1 p2 p3 p4 p5 p6 p7 p8 p9 p10 p11 p12 p13 p14 p15 c0 c1 c2 c3 c4 c5 c6 c7 c8 c9 c10 c11 c12 c13 c14 c15 q0 q1 q2 q3 q4 q5 q6 q7 q8 q9 q10 q11 q12 q13 q14 q15 cpsr_c cpsr_x cpsr_s cpsr_f cpsr_cx cpsr_cxs cpsr_xs cpsr_xsf cpsr_sf cpsr_cxsf spsr_c spsr_x spsr_s spsr_f spsr_cx spsr_cxs spsr_xs spsr_xsf spsr_sf spsr_cxsf s0 s1 s2 s3 s4 s5 s6 s7 s8 s9 s10 s11 s12 s13 s14 s15 s16 s17 s18 s19 s20 s21 s22 s23 s24 s25 s26 s27 s28 s29 s30 s31 d0 d1 d2 d3 d4 d5 d6 d7 d8 d9 d10 d11 d12 d13 d14 d15 d16 d17 d18 d19 d20 d21 d22 d23 d24 d25 d26 d27 d28 d29 d30 d31 {PC} {VAR} {TRUE} {FALSE} {OPT} {CONFIG} {ENDIAN} {CODESIZE} {CPU} {FPU} {ARCHITECTURE} {PCSTOREOFFSET} {ARMASM_VERSION} {INTER} {ROPI} {RWPI} {SWST} {NOSWST} . @"},contains:[{className:"keyword",begin:"\\\\b(adc|(qd?|sh?|u[qh]?)?add(8|16)?|usada?8|(q|sh?|u[qh]?)?(as|sa)x|and|adrl?|sbc|rs[bc]|asr|b[lx]?|blx|bxj|cbn?z|tb[bh]|bic|bfc|bfi|[su]bfx|bkpt|cdp2?|clz|clrex|cmp|cmn|cpsi[ed]|cps|setend|dbg|dmb|dsb|eor|isb|it[te]{0,3}|lsl|lsr|ror|rrx|ldm(([id][ab])|f[ds])?|ldr((s|ex)?[bhd])?|movt?|mvn|mra|mar|mul|[us]mull|smul[bwt][bt]|smu[as]d|smmul|smmla|mla|umlaal|smlal?([wbt][bt]|d)|mls|smlsl?[ds]|smc|svc|sev|mia([bt]{2}|ph)?|mrr?c2?|mcrr2?|mrs|msr|orr|orn|pkh(tb|bt)|rbit|rev(16|sh)?|sel|[su]sat(16)?|nop|pop|push|rfe([id][ab])?|stm([id][ab])?|str(ex)?[bhd]?|(qd?)?sub|(sh?|q|u[qh]?)?sub(8|16)|[su]xt(a?h|a?b(16)?)|srs([id][ab])?|swpb?|swi|smi|tst|teq|wfe|wfi|yield)(eq|ne|cs|cc|mi|pl|vs|vc|hi|ls|ge|lt|gt|le|al|hs|lo)?[sptrx]?(?=\\\\s)"},n,e.QUOTE_STRING_MODE,{className:"string",begin:"'",end:"[^\\\\\\\\]'",relevance:0},{className:"title",begin:"\\\\|",end:"\\\\|",illegal:"\\\\n",relevance:0},{className:"number",variants:[{begin:"[#$=]?0x[0-9a-f]+"},{begin:"[#$=]?0b[01]+"},{begin:"[#$=]\\\\d+"},{begin:"\\\\b\\\\d+"}],relevance:0},{className:"symbol",variants:[{begin:"^[ \\\\t]*[a-z_\\\\.\\\\$][a-z0-9_\\\\.\\\\$]+:"},{begin:"^[a-z_\\\\.\\\\$][a-z0-9_\\\\.\\\\$]+"},{begin:"[=#]\\\\w+"}],relevance:0}]}}return ht=t,ht}var Dt,Ti;function Pc(){if(Ti)return Dt;Ti=1;function t(e){const n=e.regex,a=n.concat(/[\\p{L}_]/u,n.optional(/[\\p{L}0-9_.-]*:/u),/[\\p{L}0-9_.-]*/u),r=/[\\p{L}0-9._:-]+/u,i={className:"symbol",begin:/&[a-z]+;|&#[0-9]+;|&#x[a-f0-9]+;/},s={begin:/\\s/,contains:[{className:"keyword",begin:/#?[a-z_][a-z1-9_-]+/,illegal:/\\n/}]},o=e.inherit(s,{begin:/\\(/,end:/\\)/}),_=e.inherit(e.APOS_STRING_MODE,{className:"string"}),l=e.inherit(e.QUOTE_STRING_MODE,{className:"string"}),c={endsWithParent:!0,illegal:/</,relevance:0,contains:[{className:"attr",begin:r,relevance:0},{begin:/=\\s*/,relevance:0,contains:[{className:"string",endsParent:!0,variants:[{begin:/"/,end:/"/,contains:[i]},{begin:/'/,end:/'/,contains:[i]},{begin:/[^\\s"'=<>\`]+/}]}]}]};return{name:"HTML, XML",aliases:["html","xhtml","rss","atom","xjb","xsd","xsl","plist","wsf","svg"],case_insensitive:!0,unicodeRegex:!0,contains:[{className:"meta",begin:/<![a-z]/,end:/>/,relevance:10,contains:[s,l,_,o,{begin:/\\[/,end:/\\]/,contains:[{className:"meta",begin:/<![a-z]/,end:/>/,contains:[s,o,l,_]}]}]},e.COMMENT(/<!--/,/-->/,{relevance:10}),{begin:/<!\\[CDATA\\[/,end:/\\]\\]>/,relevance:10},i,{className:"meta",end:/\\?>/,variants:[{begin:/<\\?xml/,relevance:10,contains:[l]},{begin:/<\\?[a-z][a-z0-9]+/}]},{className:"tag",begin:/<style(?=\\s|>)/,end:/>/,keywords:{name:"style"},contains:[c],starts:{end:/<\\/style>/,returnEnd:!0,subLanguage:["css","xml"]}},{className:"tag",begin:/<script(?=\\s|>)/,end:/>/,keywords:{name:"script"},contains:[c],starts:{end:/<\\/script>/,returnEnd:!0,subLanguage:["javascript","handlebars","xml"]}},{className:"tag",begin:/<>|<\\/>/},{className:"tag",begin:n.concat(/</,n.lookahead(n.concat(a,n.either(/\\/>/,/>/,/\\s/)))),end:/\\/?>/,contains:[{className:"name",begin:a,relevance:0,starts:c}]},{className:"tag",begin:n.concat(/<\\//,n.lookahead(n.concat(a,/>/))),contains:[{className:"name",begin:a,relevance:0},{begin:/>/,relevance:0,endsParent:!0}]}]}}return Dt=t,Dt}var Mt,bi;function kc(){if(bi)return Mt;bi=1;function t(e){const n=e.regex,a={begin:"^'{3,}[ \\\\t]*$",relevance:10},r=[{begin:/\\\\[*_\`]/},{begin:/\\\\\\\\\\*{2}[^\\n]*?\\*{2}/},{begin:/\\\\\\\\_{2}[^\\n]*_{2}/},{begin:/\\\\\\\\\`{2}[^\\n]*\`{2}/},{begin:/[:;}][*_\`](?![*_\`])/}],i=[{className:"strong",begin:/\\*{2}([^\\n]+?)\\*{2}/},{className:"strong",begin:n.concat(/\\*\\*/,/((\\*(?!\\*)|\\\\[^\\n]|[^*\\n\\\\])+\\n)+/,/(\\*(?!\\*)|\\\\[^\\n]|[^*\\n\\\\])*/,/\\*\\*/),relevance:0},{className:"strong",begin:/\\B\\*(\\S|\\S[^\\n]*?\\S)\\*(?!\\w)/},{className:"strong",begin:/\\*[^\\s]([^\\n]+\\n)+([^\\n]+)\\*/}],s=[{className:"emphasis",begin:/_{2}([^\\n]+?)_{2}/},{className:"emphasis",begin:n.concat(/__/,/((_(?!_)|\\\\[^\\n]|[^_\\n\\\\])+\\n)+/,/(_(?!_)|\\\\[^\\n]|[^_\\n\\\\])*/,/__/),relevance:0},{className:"emphasis",begin:/\\b_(\\S|\\S[^\\n]*?\\S)_(?!\\w)/},{className:"emphasis",begin:/_[^\\s]([^\\n]+\\n)+([^\\n]+)_/},{className:"emphasis",begin:"\\\\B'(?!['\\\\s])",end:"(\\\\n{2}|')",contains:[{begin:"\\\\\\\\'\\\\w",relevance:0}],relevance:0}],o={className:"symbol",begin:"^(NOTE|TIP|IMPORTANT|WARNING|CAUTION):\\\\s+",relevance:10},_={className:"bullet",begin:"^(\\\\*+|-+|\\\\.+|[^\\\\n]+?::)\\\\s+"};return{name:"AsciiDoc",aliases:["adoc"],contains:[e.COMMENT("^/{4,}\\\\n","\\\\n/{4,}$",{relevance:10}),e.COMMENT("^//","$",{relevance:0}),{className:"title",begin:"^\\\\.\\\\w.*$"},{begin:"^[=\\\\*]{4,}\\\\n",end:"\\\\n^[=\\\\*]{4,}$",relevance:10},{className:"section",relevance:10,variants:[{begin:"^(={1,6})[ 	].+?([ 	]\\\\1)?$"},{begin:"^[^\\\\[\\\\]\\\\n]+?\\\\n[=\\\\-~\\\\^\\\\+]{2,}$"}]},{className:"meta",begin:"^:.+?:",end:"\\\\s",excludeEnd:!0,relevance:10},{className:"meta",begin:"^\\\\[.+?\\\\]$",relevance:0},{className:"quote",begin:"^_{4,}\\\\n",end:"\\\\n_{4,}$",relevance:10},{className:"code",begin:"^[\\\\-\\\\.]{4,}\\\\n",end:"\\\\n[\\\\-\\\\.]{4,}$",relevance:10},{begin:"^\\\\+{4,}\\\\n",end:"\\\\n\\\\+{4,}$",contains:[{begin:"<",end:">",subLanguage:"xml",relevance:0}],relevance:10},_,o,...r,...i,...s,{className:"string",variants:[{begin:"\`\`.+?''"},{begin:"\`.+?'"}]},{className:"code",begin:/\`{2}/,end:/(\\n{2}|\`{2})/},{className:"code",begin:"(\`.+?\`|\\\\+.+?\\\\+)",relevance:0},{className:"code",begin:"^[ \\\\t]",end:"$",relevance:0},a,{begin:"(link:)?(http|https|ftp|file|irc|image:?):\\\\S+?\\\\[[^[]*?\\\\]",returnBegin:!0,contains:[{begin:"(link|image:?):",relevance:0},{className:"link",begin:"\\\\w",end:"[^\\\\[]+",relevance:0},{className:"string",begin:"\\\\[",end:"\\\\]",excludeBegin:!0,excludeEnd:!0,relevance:0}],relevance:10}]}}return Mt=t,Mt}var Lt,Ri;function Uc(){if(Ri)return Lt;Ri=1;function t(e){const n=e.regex,a=["false","synchronized","int","abstract","float","private","char","boolean","static","null","if","const","for","true","while","long","throw","strictfp","finally","protected","import","native","final","return","void","enum","else","extends","implements","break","transient","new","catch","instanceof","byte","super","volatile","case","assert","short","package","default","double","public","try","this","switch","continue","throws","privileged","aspectOf","adviceexecution","proceed","cflowbelow","cflow","initialization","preinitialization","staticinitialization","withincode","target","within","execution","getWithinTypeName","handler","thisJoinPoint","thisJoinPointStaticPart","thisEnclosingJoinPointStaticPart","declare","parents","warning","error","soft","precedence","thisAspectInstance"],r=["get","set","args","call"];return{name:"AspectJ",keywords:a,illegal:/<\\/|#/,contains:[e.COMMENT(/\\/\\*\\*/,/\\*\\//,{relevance:0,contains:[{begin:/\\w+@/,relevance:0},{className:"doctag",begin:/@[A-Za-z]+/}]}),e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,e.APOS_STRING_MODE,e.QUOTE_STRING_MODE,{className:"class",beginKeywords:"aspect",end:/[{;=]/,excludeEnd:!0,illegal:/[:;"\\[\\]]/,contains:[{beginKeywords:"extends implements pertypewithin perthis pertarget percflowbelow percflow issingleton"},e.UNDERSCORE_TITLE_MODE,{begin:/\\([^\\)]*/,end:/[)]+/,keywords:a.concat(r),excludeEnd:!1}]},{className:"class",beginKeywords:"class interface",end:/[{;=]/,excludeEnd:!0,relevance:0,keywords:"class interface",illegal:/[:"\\[\\]]/,contains:[{beginKeywords:"extends implements"},e.UNDERSCORE_TITLE_MODE]},{beginKeywords:"pointcut after before around throwing returning",end:/[)]/,excludeEnd:!1,illegal:/["\\[\\]]/,contains:[{begin:n.concat(e.UNDERSCORE_IDENT_RE,/\\s*\\(/),returnBegin:!0,contains:[e.UNDERSCORE_TITLE_MODE]}]},{begin:/[:]/,returnBegin:!0,end:/[{;]/,relevance:0,excludeEnd:!1,keywords:a,illegal:/["\\[\\]]/,contains:[{begin:n.concat(e.UNDERSCORE_IDENT_RE,/\\s*\\(/),keywords:a.concat(r),relevance:0},e.QUOTE_STRING_MODE]},{beginKeywords:"new throw",relevance:0},{className:"function",begin:/\\w+ +\\w+(\\.\\w+)?\\s*\\([^\\)]*\\)\\s*((throws)[\\w\\s,]+)?[\\{;]/,returnBegin:!0,end:/[{;=]/,keywords:a,excludeEnd:!0,contains:[{begin:n.concat(e.UNDERSCORE_IDENT_RE,/\\s*\\(/),returnBegin:!0,relevance:0,contains:[e.UNDERSCORE_TITLE_MODE]},{className:"params",begin:/\\(/,end:/\\)/,relevance:0,keywords:a,contains:[e.APOS_STRING_MODE,e.QUOTE_STRING_MODE,e.C_NUMBER_MODE,e.C_BLOCK_COMMENT_MODE]},e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE]},e.C_NUMBER_MODE,{className:"meta",begin:/@[A-Za-z]+/}]}}return Lt=t,Lt}var xt,fi;function Fc(){if(fi)return xt;fi=1;function t(e){const n={begin:"\`[\\\\s\\\\S]"};return{name:"AutoHotkey",case_insensitive:!0,aliases:["ahk"],keywords:{keyword:"Break Continue Critical Exit ExitApp Gosub Goto New OnExit Pause return SetBatchLines SetTimer Suspend Thread Throw Until ahk_id ahk_class ahk_pid ahk_exe ahk_group",literal:"true false NOT AND OR",built_in:"ComSpec Clipboard ClipboardAll ErrorLevel"},contains:[n,e.inherit(e.QUOTE_STRING_MODE,{contains:[n]}),e.COMMENT(";","$",{relevance:0}),e.C_BLOCK_COMMENT_MODE,{className:"number",begin:e.NUMBER_RE,relevance:0},{className:"variable",begin:"%[a-zA-Z0-9#_$@]+%"},{className:"built_in",begin:"^\\\\s*\\\\w+\\\\s*(,|%)"},{className:"title",variants:[{begin:'^[^\\\\n";]+::(?!=)'},{begin:'^[^\\\\n";]+:(?!=)',relevance:0}]},{className:"meta",begin:"^\\\\s*#\\\\w+",end:"$",relevance:0},{className:"built_in",begin:"A_[a-zA-Z0-9]+"},{begin:",\\\\s*,"}]}}return xt=t,xt}var wt,Ci;function Bc(){if(Ci)return wt;Ci=1;function t(e){const n="ByRef Case Const ContinueCase ContinueLoop Dim Do Else ElseIf EndFunc EndIf EndSelect EndSwitch EndWith Enum Exit ExitLoop For Func Global If In Local Next ReDim Return Select Static Step Switch Then To Until Volatile WEnd While With",a=["EndRegion","forcedef","forceref","ignorefunc","include","include-once","NoTrayIcon","OnAutoItStartRegister","pragma","Region","RequireAdmin","Tidy_Off","Tidy_On","Tidy_Parameters"],r="True False And Null Not Or Default",i="Abs ACos AdlibRegister AdlibUnRegister Asc AscW ASin Assign ATan AutoItSetOption AutoItWinGetTitle AutoItWinSetTitle Beep Binary BinaryLen BinaryMid BinaryToString BitAND BitNOT BitOR BitRotate BitShift BitXOR BlockInput Break Call CDTray Ceiling Chr ChrW ClipGet ClipPut ConsoleRead ConsoleWrite ConsoleWriteError ControlClick ControlCommand ControlDisable ControlEnable ControlFocus ControlGetFocus ControlGetHandle ControlGetPos ControlGetText ControlHide ControlListView ControlMove ControlSend ControlSetText ControlShow ControlTreeView Cos Dec DirCopy DirCreate DirGetSize DirMove DirRemove DllCall DllCallAddress DllCallbackFree DllCallbackGetPtr DllCallbackRegister DllClose DllOpen DllStructCreate DllStructGetData DllStructGetPtr DllStructGetSize DllStructSetData DriveGetDrive DriveGetFileSystem DriveGetLabel DriveGetSerial DriveGetType DriveMapAdd DriveMapDel DriveMapGet DriveSetLabel DriveSpaceFree DriveSpaceTotal DriveStatus EnvGet EnvSet EnvUpdate Eval Execute Exp FileChangeDir FileClose FileCopy FileCreateNTFSLink FileCreateShortcut FileDelete FileExists FileFindFirstFile FileFindNextFile FileFlush FileGetAttrib FileGetEncoding FileGetLongName FileGetPos FileGetShortcut FileGetShortName FileGetSize FileGetTime FileGetVersion FileInstall FileMove FileOpen FileOpenDialog FileRead FileReadLine FileReadToArray FileRecycle FileRecycleEmpty FileSaveDialog FileSelectFolder FileSetAttrib FileSetEnd FileSetPos FileSetTime FileWrite FileWriteLine Floor FtpSetProxy FuncName GUICreate GUICtrlCreateAvi GUICtrlCreateButton GUICtrlCreateCheckbox GUICtrlCreateCombo GUICtrlCreateContextMenu GUICtrlCreateDate GUICtrlCreateDummy GUICtrlCreateEdit GUICtrlCreateGraphic GUICtrlCreateGroup GUICtrlCreateIcon GUICtrlCreateInput GUICtrlCreateLabel GUICtrlCreateList GUICtrlCreateListView GUICtrlCreateListViewItem GUICtrlCreateMenu GUICtrlCreateMenuItem GUICtrlCreateMonthCal GUICtrlCreateObj GUICtrlCreatePic GUICtrlCreateProgress GUICtrlCreateRadio GUICtrlCreateSlider GUICtrlCreateTab GUICtrlCreateTabItem GUICtrlCreateTreeView GUICtrlCreateTreeViewItem GUICtrlCreateUpdown GUICtrlDelete GUICtrlGetHandle GUICtrlGetState GUICtrlRead GUICtrlRecvMsg GUICtrlRegisterListViewSort GUICtrlSendMsg GUICtrlSendToDummy GUICtrlSetBkColor GUICtrlSetColor GUICtrlSetCursor GUICtrlSetData GUICtrlSetDefBkColor GUICtrlSetDefColor GUICtrlSetFont GUICtrlSetGraphic GUICtrlSetImage GUICtrlSetLimit GUICtrlSetOnEvent GUICtrlSetPos GUICtrlSetResizing GUICtrlSetState GUICtrlSetStyle GUICtrlSetTip GUIDelete GUIGetCursorInfo GUIGetMsg GUIGetStyle GUIRegisterMsg GUISetAccelerators GUISetBkColor GUISetCoord GUISetCursor GUISetFont GUISetHelp GUISetIcon GUISetOnEvent GUISetState GUISetStyle GUIStartGroup GUISwitch Hex HotKeySet HttpSetProxy HttpSetUserAgent HWnd InetClose InetGet InetGetInfo InetGetSize InetRead IniDelete IniRead IniReadSection IniReadSectionNames IniRenameSection IniWrite IniWriteSection InputBox Int IsAdmin IsArray IsBinary IsBool IsDeclared IsDllStruct IsFloat IsFunc IsHWnd IsInt IsKeyword IsNumber IsObj IsPtr IsString Log MemGetStats Mod MouseClick MouseClickDrag MouseDown MouseGetCursor MouseGetPos MouseMove MouseUp MouseWheel MsgBox Number ObjCreate ObjCreateInterface ObjEvent ObjGet ObjName OnAutoItExitRegister OnAutoItExitUnRegister Ping PixelChecksum PixelGetColor PixelSearch ProcessClose ProcessExists ProcessGetStats ProcessList ProcessSetPriority ProcessWait ProcessWaitClose ProgressOff ProgressOn ProgressSet Ptr Random RegDelete RegEnumKey RegEnumVal RegRead RegWrite Round Run RunAs RunAsWait RunWait Send SendKeepActive SetError SetExtended ShellExecute ShellExecuteWait Shutdown Sin Sleep SoundPlay SoundSetWaveVolume SplashImageOn SplashOff SplashTextOn Sqrt SRandom StatusbarGetText StderrRead StdinWrite StdioClose StdoutRead String StringAddCR StringCompare StringFormat StringFromASCIIArray StringInStr StringIsAlNum StringIsAlpha StringIsASCII StringIsDigit StringIsFloat StringIsInt StringIsLower StringIsSpace StringIsUpper StringIsXDigit StringLeft StringLen StringLower StringMid StringRegExp StringRegExpReplace StringReplace StringReverse StringRight StringSplit StringStripCR StringStripWS StringToASCIIArray StringToBinary StringTrimLeft StringTrimRight StringUpper Tan TCPAccept TCPCloseSocket TCPConnect TCPListen TCPNameToIP TCPRecv TCPSend TCPShutdown, UDPShutdown TCPStartup, UDPStartup TimerDiff TimerInit ToolTip TrayCreateItem TrayCreateMenu TrayGetMsg TrayItemDelete TrayItemGetHandle TrayItemGetState TrayItemGetText TrayItemSetOnEvent TrayItemSetState TrayItemSetText TraySetClick TraySetIcon TraySetOnEvent TraySetPauseIcon TraySetState TraySetToolTip TrayTip UBound UDPBind UDPCloseSocket UDPOpen UDPRecv UDPSend VarGetType WinActivate WinActive WinClose WinExists WinFlash WinGetCaretPos WinGetClassList WinGetClientSize WinGetHandle WinGetPos WinGetProcess WinGetState WinGetText WinGetTitle WinKill WinList WinMenuSelectItem WinMinimizeAll WinMinimizeAllUndo WinMove WinSetOnTop WinSetState WinSetTitle WinSetTrans WinWait WinWaitActive WinWaitClose WinWaitNotActive",s={variants:[e.COMMENT(";","$",{relevance:0}),e.COMMENT("#cs","#ce"),e.COMMENT("#comments-start","#comments-end")]},o={begin:"\\\\$[A-z0-9_]+"},_={className:"string",variants:[{begin:/"/,end:/"/,contains:[{begin:/""/,relevance:0}]},{begin:/'/,end:/'/,contains:[{begin:/''/,relevance:0}]}]},l={variants:[e.BINARY_NUMBER_MODE,e.C_NUMBER_MODE]},c={className:"meta",begin:"#",end:"$",keywords:{keyword:a},contains:[{begin:/\\\\\\n/,relevance:0},{beginKeywords:"include",keywords:{keyword:"include"},end:"$",contains:[_,{className:"string",variants:[{begin:"<",end:">"},{begin:/"/,end:/"/,contains:[{begin:/""/,relevance:0}]},{begin:/'/,end:/'/,contains:[{begin:/''/,relevance:0}]}]}]},_,s]},d={className:"symbol",begin:"@[A-z0-9_]+"},m={beginKeywords:"Func",end:"$",illegal:"\\\\$|\\\\[|%",contains:[e.inherit(e.UNDERSCORE_TITLE_MODE,{className:"title.function"}),{className:"params",begin:"\\\\(",end:"\\\\)",contains:[o,_,l]}]};return{name:"AutoIt",case_insensitive:!0,illegal:/\\/\\*/,keywords:{keyword:n,built_in:i,literal:r},contains:[s,o,_,l,c,d,m]}}return wt=t,wt}var Pt,Ni;function Gc(){if(Ni)return Pt;Ni=1;function t(e){return{name:"AVR Assembly",case_insensitive:!0,keywords:{$pattern:"\\\\.?"+e.IDENT_RE,keyword:"adc add adiw and andi asr bclr bld brbc brbs brcc brcs break breq brge brhc brhs brid brie brlo brlt brmi brne brpl brsh brtc brts brvc brvs bset bst call cbi cbr clc clh cli cln clr cls clt clv clz com cp cpc cpi cpse dec eicall eijmp elpm eor fmul fmuls fmulsu icall ijmp in inc jmp ld ldd ldi lds lpm lsl lsr mov movw mul muls mulsu neg nop or ori out pop push rcall ret reti rjmp rol ror sbc sbr sbrc sbrs sec seh sbi sbci sbic sbis sbiw sei sen ser ses set sev sez sleep spm st std sts sub subi swap tst wdr",built_in:"r0 r1 r2 r3 r4 r5 r6 r7 r8 r9 r10 r11 r12 r13 r14 r15 r16 r17 r18 r19 r20 r21 r22 r23 r24 r25 r26 r27 r28 r29 r30 r31 x|0 xh xl y|0 yh yl z|0 zh zl ucsr1c udr1 ucsr1a ucsr1b ubrr1l ubrr1h ucsr0c ubrr0h tccr3c tccr3a tccr3b tcnt3h tcnt3l ocr3ah ocr3al ocr3bh ocr3bl ocr3ch ocr3cl icr3h icr3l etimsk etifr tccr1c ocr1ch ocr1cl twcr twdr twar twsr twbr osccal xmcra xmcrb eicra spmcsr spmcr portg ddrg ping portf ddrf sreg sph spl xdiv rampz eicrb eimsk gimsk gicr eifr gifr timsk tifr mcucr mcucsr tccr0 tcnt0 ocr0 assr tccr1a tccr1b tcnt1h tcnt1l ocr1ah ocr1al ocr1bh ocr1bl icr1h icr1l tccr2 tcnt2 ocr2 ocdr wdtcr sfior eearh eearl eedr eecr porta ddra pina portb ddrb pinb portc ddrc pinc portd ddrd pind spdr spsr spcr udr0 ucsr0a ucsr0b ubrr0l acsr admux adcsr adch adcl porte ddre pine pinf",meta:".byte .cseg .db .def .device .dseg .dw .endmacro .equ .eseg .exit .include .list .listmac .macro .nolist .org .set"},contains:[e.C_BLOCK_COMMENT_MODE,e.COMMENT(";","$",{relevance:0}),e.C_NUMBER_MODE,e.BINARY_NUMBER_MODE,{className:"number",begin:"\\\\b(\\\\$[a-zA-Z0-9]+|0o[0-7]+)"},e.QUOTE_STRING_MODE,{className:"string",begin:"'",end:"[^\\\\\\\\]'",illegal:"[^\\\\\\\\][^']"},{className:"symbol",begin:"^[A-Za-z0-9_.$]+:"},{className:"meta",begin:"#",end:"$"},{className:"subst",begin:"@[0-9]+"}]}}return Pt=t,Pt}var kt,Oi;function Yc(){if(Oi)return kt;Oi=1;function t(e){const n={className:"variable",variants:[{begin:/\\$[\\w\\d#@][\\w\\d_]*/},{begin:/\\$\\{(.*?)\\}/}]},a="BEGIN END if else while do for in break continue delete next nextfile function func exit|10",r={className:"string",contains:[e.BACKSLASH_ESCAPE],variants:[{begin:/(u|b)?r?'''/,end:/'''/,relevance:10},{begin:/(u|b)?r?"""/,end:/"""/,relevance:10},{begin:/(u|r|ur)'/,end:/'/,relevance:10},{begin:/(u|r|ur)"/,end:/"/,relevance:10},{begin:/(b|br)'/,end:/'/},{begin:/(b|br)"/,end:/"/},e.APOS_STRING_MODE,e.QUOTE_STRING_MODE]};return{name:"Awk",keywords:{keyword:a},contains:[n,r,e.REGEXP_MODE,e.HASH_COMMENT_MODE,e.NUMBER_MODE]}}return kt=t,kt}var Ut,Ii;function qc(){if(Ii)return Ut;Ii=1;function t(e){const n=e.UNDERSCORE_IDENT_RE,s={keyword:["abstract","as","asc","avg","break","breakpoint","by","byref","case","catch","changecompany","class","client","client","common","const","continue","count","crosscompany","delegate","delete_from","desc","display","div","do","edit","else","eventhandler","exists","extends","final","finally","firstfast","firstonly","firstonly1","firstonly10","firstonly100","firstonly1000","flush","for","forceliterals","forcenestedloop","forceplaceholders","forceselectorder","forupdate","from","generateonly","group","hint","if","implements","in","index","insert_recordset","interface","internal","is","join","like","maxof","minof","mod","namespace","new","next","nofetch","notexists","optimisticlock","order","outer","pessimisticlock","print","private","protected","public","readonly","repeatableread","retry","return","reverse","select","server","setting","static","sum","super","switch","this","throw","try","ttsabort","ttsbegin","ttscommit","unchecked","update_recordset","using","validtimestate","void","where","while"],built_in:["anytype","boolean","byte","char","container","date","double","enum","guid","int","int64","long","real","short","str","utcdatetime","var"],literal:["default","false","null","true"]},o={variants:[{match:[/(class|interface)\\s+/,n,/\\s+(extends|implements)\\s+/,n]},{match:[/class\\s+/,n]}],scope:{2:"title.class",4:"title.class.inherited"},keywords:s};return{name:"X++",aliases:["x++"],keywords:s,contains:[e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,e.APOS_STRING_MODE,e.QUOTE_STRING_MODE,e.C_NUMBER_MODE,{className:"meta",begin:"#",end:"$"},o]}}return Ut=t,Ut}var Ft,Ai;function Hc(){if(Ai)return Ft;Ai=1;function t(e){const n=e.regex,a={},r={begin:/\\$\\{/,end:/\\}/,contains:["self",{begin:/:-/,contains:[a]}]};Object.assign(a,{className:"variable",variants:[{begin:n.concat(/\\$[\\w\\d#@][\\w\\d_]*/,"(?![\\\\w\\\\d])(?![$])")},r]});const i={className:"subst",begin:/\\$\\(/,end:/\\)/,contains:[e.BACKSLASH_ESCAPE]},s=e.inherit(e.COMMENT(),{match:[/(^|\\s)/,/#.*$/],scope:{2:"comment"}}),o={begin:/<<-?\\s*(?=\\w+)/,starts:{contains:[e.END_SAME_AS_BEGIN({begin:/(\\w+)/,end:/(\\w+)/,className:"string"})]}},_={className:"string",begin:/"/,end:/"/,contains:[e.BACKSLASH_ESCAPE,a,i]};i.contains.push(_);const l={match:/\\\\"/},c={className:"string",begin:/'/,end:/'/},d={match:/\\\\'/},m={begin:/\\$?\\(\\(/,end:/\\)\\)/,contains:[{begin:/\\d+#[0-9a-f]+/,className:"number"},e.NUMBER_MODE,a]},p=["fish","bash","zsh","sh","csh","ksh","tcsh","dash","scsh"],E=e.SHEBANG({binary:\`(\${p.join("|")})\`,relevance:10}),g={className:"function",begin:/\\w[\\w\\d_]*\\s*\\(\\s*\\)\\s*\\{/,returnBegin:!0,contains:[e.inherit(e.TITLE_MODE,{begin:/\\w[\\w\\d_]*/})],relevance:0},S=["if","then","else","elif","fi","time","for","while","until","in","do","done","case","esac","coproc","function","select"],T=["true","false"],R={match:/(\\/[a-z._-]+)+/},f=["break","cd","continue","eval","exec","exit","export","getopts","hash","pwd","readonly","return","shift","test","times","trap","umask","unset"],A=["alias","bind","builtin","caller","command","declare","echo","enable","help","let","local","logout","mapfile","printf","read","readarray","source","sudo","type","typeset","ulimit","unalias"],N=["autoload","bg","bindkey","bye","cap","chdir","clone","comparguments","compcall","compctl","compdescribe","compfiles","compgroups","compquote","comptags","comptry","compvalues","dirs","disable","disown","echotc","echoti","emulate","fc","fg","float","functions","getcap","getln","history","integer","jobs","kill","limit","log","noglob","popd","print","pushd","pushln","rehash","sched","setcap","setopt","stat","suspend","ttyctl","unfunction","unhash","unlimit","unsetopt","vared","wait","whence","where","which","zcompile","zformat","zftp","zle","zmodload","zparseopts","zprof","zpty","zregexparse","zsocket","zstyle","ztcp"],C=["chcon","chgrp","chown","chmod","cp","dd","df","dir","dircolors","ln","ls","mkdir","mkfifo","mknod","mktemp","mv","realpath","rm","rmdir","shred","sync","touch","truncate","vdir","b2sum","base32","base64","cat","cksum","comm","csplit","cut","expand","fmt","fold","head","join","md5sum","nl","numfmt","od","paste","ptx","pr","sha1sum","sha224sum","sha256sum","sha384sum","sha512sum","shuf","sort","split","sum","tac","tail","tr","tsort","unexpand","uniq","wc","arch","basename","chroot","date","dirname","du","echo","env","expr","factor","groups","hostid","id","link","logname","nice","nohup","nproc","pathchk","pinky","printenv","printf","pwd","readlink","runcon","seq","sleep","stat","stdbuf","stty","tee","test","timeout","tty","uname","unlink","uptime","users","who","whoami","yes"];return{name:"Bash",aliases:["sh","zsh"],keywords:{$pattern:/\\b[a-z][a-z0-9._-]+\\b/,keyword:S,literal:T,built_in:[...f,...A,"set","shopt",...N,...C]},contains:[E,e.SHEBANG(),g,m,s,o,R,_,l,c,d,a]}}return Ft=t,Ft}var Bt,vi;function Vc(){if(vi)return Bt;vi=1;function t(e){return{name:"BASIC",case_insensitive:!0,illegal:"^.",keywords:{$pattern:"[a-zA-Z][a-zA-Z0-9_$%!#]*",keyword:["ABS","ASC","AND","ATN","AUTO|0","BEEP","BLOAD|10","BSAVE|10","CALL","CALLS","CDBL","CHAIN","CHDIR","CHR$|10","CINT","CIRCLE","CLEAR","CLOSE","CLS","COLOR","COM","COMMON","CONT","COS","CSNG","CSRLIN","CVD","CVI","CVS","DATA","DATE$","DEFDBL","DEFINT","DEFSNG","DEFSTR","DEF|0","SEG","USR","DELETE","DIM","DRAW","EDIT","END","ENVIRON","ENVIRON$","EOF","EQV","ERASE","ERDEV","ERDEV$","ERL","ERR","ERROR","EXP","FIELD","FILES","FIX","FOR|0","FRE","GET","GOSUB|10","GOTO","HEX$","IF","THEN","ELSE|0","INKEY$","INP","INPUT","INPUT#","INPUT$","INSTR","IMP","INT","IOCTL","IOCTL$","KEY","ON","OFF","LIST","KILL","LEFT$","LEN","LET","LINE","LLIST","LOAD","LOC","LOCATE","LOF","LOG","LPRINT","USING","LSET","MERGE","MID$","MKDIR","MKD$","MKI$","MKS$","MOD","NAME","NEW","NEXT","NOISE","NOT","OCT$","ON","OR","PEN","PLAY","STRIG","OPEN","OPTION","BASE","OUT","PAINT","PALETTE","PCOPY","PEEK","PMAP","POINT","POKE","POS","PRINT","PRINT]","PSET","PRESET","PUT","RANDOMIZE","READ","REM","RENUM","RESET|0","RESTORE","RESUME","RETURN|0","RIGHT$","RMDIR","RND","RSET","RUN","SAVE","SCREEN","SGN","SHELL","SIN","SOUND","SPACE$","SPC","SQR","STEP","STICK","STOP","STR$","STRING$","SWAP","SYSTEM","TAB","TAN","TIME$","TIMER","TROFF","TRON","TO","USR","VAL","VARPTR","VARPTR$","VIEW","WAIT","WHILE","WEND","WIDTH","WINDOW","WRITE","XOR"]},contains:[{scope:"string",begin:/"/,end:/"|$/,contains:[e.BACKSLASH_ESCAPE]},e.COMMENT("REM","$",{relevance:10}),e.COMMENT("'","$",{relevance:0}),{className:"symbol",begin:"^[0-9]+ ",relevance:10},{className:"number",begin:"\\\\b\\\\d+(\\\\.\\\\d+)?([edED]\\\\d+)?[#!]?",relevance:0},{className:"number",begin:"(&[hH][0-9a-fA-F]{1,4})"},{className:"number",begin:"(&[oO][0-7]{1,6})"}]}}return Bt=t,Bt}var Gt,yi;function zc(){if(yi)return Gt;yi=1;function t(e){return{name:"Backus–Naur Form",contains:[{className:"attribute",begin:/</,end:/>/},{begin:/::=/,end:/$/,contains:[{begin:/</,end:/>/},e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,e.APOS_STRING_MODE,e.QUOTE_STRING_MODE]}]}}return Gt=t,Gt}var Yt,hi;function Wc(){if(hi)return Yt;hi=1;function t(e){const n={className:"literal",begin:/[+-]+/,relevance:0};return{name:"Brainfuck",aliases:["bf"],contains:[e.COMMENT(/[^\\[\\]\\.,\\+\\-<> \\r\\n]/,/[\\[\\]\\.,\\+\\-<> \\r\\n]/,{contains:[{match:/[ ]+[^\\[\\]\\.,\\+\\-<> \\r\\n]/,relevance:0}],returnEnd:!0,relevance:0}),{className:"title",begin:"[\\\\[\\\\]]",relevance:0},{className:"string",begin:"[\\\\.,]",relevance:0},{begin:/(?=\\+\\+|--)/,contains:[n]},n]}}return Yt=t,Yt}var qt,Di;function Kc(){if(Di)return qt;Di=1;function t(e){const n=e.regex,a=e.COMMENT("//","$",{contains:[{begin:/\\\\\\n/}]}),r="decltype\\\\(auto\\\\)",i="[a-zA-Z_]\\\\w*::",o="("+r+"|"+n.optional(i)+"[a-zA-Z_]\\\\w*"+n.optional("<[^<>]+>")+")",_={className:"type",variants:[{begin:"\\\\b[a-z\\\\d_]*_t\\\\b"},{match:/\\batomic_[a-z]{3,6}\\b/}]},c={className:"string",variants:[{begin:'(u8?|U|L)?"',end:'"',illegal:"\\\\n",contains:[e.BACKSLASH_ESCAPE]},{begin:"(u8?|U|L)?'("+"\\\\\\\\(x[0-9A-Fa-f]{2}|u[0-9A-Fa-f]{4,8}|[0-7]{3}|\\\\S)"+"|.)",end:"'",illegal:"."},e.END_SAME_AS_BEGIN({begin:/(?:u8?|U|L)?R"([^()\\\\ ]{0,16})\\(/,end:/\\)([^()\\\\ ]{0,16})"/})]},d={className:"number",variants:[{match:/\\b(0b[01']+)/},{match:/(-?)\\b([\\d']+(\\.[\\d']*)?|\\.[\\d']+)((ll|LL|l|L)(u|U)?|(u|U)(ll|LL|l|L)?|f|F|b|B)/},{match:/(-?)\\b(0[xX][a-fA-F0-9]+(?:'[a-fA-F0-9]+)*(?:\\.[a-fA-F0-9]*(?:'[a-fA-F0-9]*)*)?(?:[pP][-+]?[0-9]+)?(l|L)?(u|U)?)/},{match:/(-?)\\b\\d+(?:'\\d+)*(?:\\.\\d*(?:'\\d*)*)?(?:[eE][-+]?\\d+)?/}],relevance:0},m={className:"meta",begin:/#\\s*[a-z]+\\b/,end:/$/,keywords:{keyword:"if else elif endif define undef warning error line pragma _Pragma ifdef ifndef elifdef elifndef include"},contains:[{begin:/\\\\\\n/,relevance:0},e.inherit(c,{className:"string"}),{className:"string",begin:/<.*?>/},a,e.C_BLOCK_COMMENT_MODE]},p={className:"title",begin:n.optional(i)+e.IDENT_RE,relevance:0},E=n.optional(i)+e.IDENT_RE+"\\\\s*\\\\(",T={keyword:["asm","auto","break","case","continue","default","do","else","enum","extern","for","fortran","goto","if","inline","register","restrict","return","sizeof","typeof","typeof_unqual","struct","switch","typedef","union","volatile","while","_Alignas","_Alignof","_Atomic","_Generic","_Noreturn","_Static_assert","_Thread_local","alignas","alignof","noreturn","static_assert","thread_local","_Pragma"],type:["float","double","signed","unsigned","int","short","long","char","void","_Bool","_BitInt","_Complex","_Imaginary","_Decimal32","_Decimal64","_Decimal96","_Decimal128","_Decimal64x","_Decimal128x","_Float16","_Float32","_Float64","_Float128","_Float32x","_Float64x","_Float128x","const","static","constexpr","complex","bool","imaginary"],literal:"true false NULL",built_in:"std string wstring cin cout cerr clog stdin stdout stderr stringstream istringstream ostringstream auto_ptr deque list queue stack vector map set pair bitset multiset multimap unordered_set unordered_map unordered_multiset unordered_multimap priority_queue make_pair array shared_ptr abort terminate abs acos asin atan2 atan calloc ceil cosh cos exit exp fabs floor fmod fprintf fputs free frexp fscanf future isalnum isalpha iscntrl isdigit isgraph islower isprint ispunct isspace isupper isxdigit tolower toupper labs ldexp log10 log malloc realloc memchr memcmp memcpy memset modf pow printf putchar puts scanf sinh sin snprintf sprintf sqrt sscanf strcat strchr strcmp strcpy strcspn strlen strncat strncmp strncpy strpbrk strrchr strspn strstr tanh tan vfprintf vprintf vsprintf endl initializer_list unique_ptr"},R=[m,_,a,e.C_BLOCK_COMMENT_MODE,d,c],f={variants:[{begin:/=/,end:/;/},{begin:/\\(/,end:/\\)/},{beginKeywords:"new throw return else",end:/;/}],keywords:T,contains:R.concat([{begin:/\\(/,end:/\\)/,keywords:T,contains:R.concat(["self"]),relevance:0}]),relevance:0},A={begin:"("+o+"[\\\\*&\\\\s]+)+"+E,returnBegin:!0,end:/[{;=]/,excludeEnd:!0,keywords:T,illegal:/[^\\w\\s\\*&:<>.]/,contains:[{begin:r,keywords:T,relevance:0},{begin:E,returnBegin:!0,contains:[e.inherit(p,{className:"title.function"})],relevance:0},{relevance:0,match:/,/},{className:"params",begin:/\\(/,end:/\\)/,keywords:T,relevance:0,contains:[a,e.C_BLOCK_COMMENT_MODE,c,d,_,{begin:/\\(/,end:/\\)/,keywords:T,relevance:0,contains:["self",a,e.C_BLOCK_COMMENT_MODE,c,d,_]}]},_,a,e.C_BLOCK_COMMENT_MODE,m]};return{name:"C",aliases:["h"],keywords:T,disableAutodetect:!0,illegal:"</",contains:[].concat(f,A,R,[m,{begin:e.IDENT_RE+"::",keywords:T},{className:"class",beginKeywords:"enum class struct union",end:/[{;:<>=]/,contains:[{beginKeywords:"final class struct"},e.TITLE_MODE]}]),exports:{preprocessor:m,strings:c,keywords:T}}}return qt=t,qt}var Ht,Mi;function $c(){if(Mi)return Ht;Mi=1;function t(e){const n=e.regex,a=["div","mod","in","and","or","not","xor","asserterror","begin","case","do","downto","else","end","exit","for","local","if","of","repeat","then","to","until","while","with","var"],r="false true",i=[e.C_LINE_COMMENT_MODE,e.COMMENT(/\\{/,/\\}/,{relevance:0}),e.COMMENT(/\\(\\*/,/\\*\\)/,{relevance:10})],s={className:"string",begin:/'/,end:/'/,contains:[{begin:/''/}]},o={className:"string",begin:/(#\\d+)+/},_={className:"number",begin:"\\\\b\\\\d+(\\\\.\\\\d+)?(DT|D|T)",relevance:0},l={className:"string",begin:'"',end:'"'},c={match:[/procedure/,/\\s+/,/[a-zA-Z_][\\w@]*/,/\\s*/],scope:{1:"keyword",3:"title.function"},contains:[{className:"params",begin:/\\(/,end:/\\)/,keywords:a,contains:[s,o,e.NUMBER_MODE]},...i]},d=["Table","Form","Report","Dataport","Codeunit","XMLport","MenuSuite","Page","Query"],m={match:[/OBJECT/,/\\s+/,n.either(...d),/\\s+/,/\\d+/,/\\s+(?=[^\\s])/,/.*/,/$/],relevance:3,scope:{1:"keyword",3:"type",5:"number",7:"title"}};return{name:"C/AL",case_insensitive:!0,keywords:{keyword:a,literal:r},illegal:/\\/\\*/,contains:[{match:/[\\w]+(?=\\=)/,scope:"attribute",relevance:0},s,o,_,l,e.NUMBER_MODE,m,c]}}return Ht=t,Ht}var Vt,Li;function Qc(){if(Li)return Vt;Li=1;function t(e){const n=["struct","enum","interface","union","group","import","using","const","annotation","extends","in","of","on","as","with","from","fixed"],a=["Void","Bool","Int8","Int16","Int32","Int64","UInt8","UInt16","UInt32","UInt64","Float32","Float64","Text","Data","AnyPointer","AnyStruct","Capability","List"],r=["true","false"],i={variants:[{match:[/(struct|enum|interface)/,/\\s+/,e.IDENT_RE]},{match:[/extends/,/\\s*\\(/,e.IDENT_RE,/\\s*\\)/]}],scope:{1:"keyword",3:"title.class"}};return{name:"Cap’n Proto",aliases:["capnp"],keywords:{keyword:n,type:a,literal:r},contains:[e.QUOTE_STRING_MODE,e.NUMBER_MODE,e.HASH_COMMENT_MODE,{className:"meta",begin:/@0x[\\w\\d]{16};/,illegal:/\\n/},{className:"symbol",begin:/@\\d+\\b/},i]}}return Vt=t,Vt}var zt,xi;function Xc(){if(xi)return zt;xi=1;function t(e){const n=["assembly","module","package","import","alias","class","interface","object","given","value","assign","void","function","new","of","extends","satisfies","abstracts","in","out","return","break","continue","throw","assert","dynamic","if","else","switch","case","for","while","try","catch","finally","then","let","this","outer","super","is","exists","nonempty"],a=["shared","abstract","formal","default","actual","variable","late","native","deprecated","final","sealed","annotation","suppressWarnings","small"],r=["doc","by","license","see","throws","tagged"],i={className:"subst",excludeBegin:!0,excludeEnd:!0,begin:/\`\`/,end:/\`\`/,keywords:n,relevance:10},s=[{className:"string",begin:'"""',end:'"""',relevance:10},{className:"string",begin:'"',end:'"',contains:[i]},{className:"string",begin:"'",end:"'"},{className:"number",begin:"#[0-9a-fA-F_]+|\\\\$[01_]+|[0-9_]+(?:\\\\.[0-9_](?:[eE][+-]?\\\\d+)?)?[kMGTPmunpf]?",relevance:0}];return i.contains=s,{name:"Ceylon",keywords:{keyword:n.concat(a),meta:r},illegal:"\\\\$[^01]|#[^0-9a-fA-F]",contains:[e.C_LINE_COMMENT_MODE,e.COMMENT("/\\\\*","\\\\*/",{contains:["self"]}),{className:"meta",begin:'@[a-z]\\\\w*(?::"[^"]*")?'}].concat(s)}}return zt=t,zt}var Wt,wi;function Zc(){if(wi)return Wt;wi=1;function t(e){return{name:"Clean",aliases:["icl","dcl"],keywords:{keyword:["if","let","in","with","where","case","of","class","instance","otherwise","implementation","definition","system","module","from","import","qualified","as","special","code","inline","foreign","export","ccall","stdcall","generic","derive","infix","infixl","infixr"],built_in:"Int Real Char Bool",literal:"True False"},contains:[e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,e.APOS_STRING_MODE,e.QUOTE_STRING_MODE,e.C_NUMBER_MODE,{begin:"->|<-[|:]?|#!?|>>=|\\\\{\\\\||\\\\|\\\\}|:==|=:|<>"}]}}return Wt=t,Wt}var Kt,Pi;function Jc(){if(Pi)return Kt;Pi=1;function t(e){const n="a-zA-Z_\\\\-!.?+*=<>&'",a="[#]?["+n+"]["+n+"0-9/;:$#]*",r="def defonce defprotocol defstruct defmulti defmethod defn- defn defmacro deftype defrecord",i={$pattern:a,built_in:r+" cond apply if-not if-let if not not= =|0 <|0 >|0 <=|0 >=|0 ==|0 +|0 /|0 *|0 -|0 rem quot neg? pos? delay? symbol? keyword? true? false? integer? empty? coll? list? set? ifn? fn? associative? sequential? sorted? counted? reversible? number? decimal? class? distinct? isa? float? rational? reduced? ratio? odd? even? char? seq? vector? string? map? nil? contains? zero? instance? not-every? not-any? libspec? -> ->> .. . inc compare do dotimes mapcat take remove take-while drop letfn drop-last take-last drop-while while intern condp case reduced cycle split-at split-with repeat replicate iterate range merge zipmap declare line-seq sort comparator sort-by dorun doall nthnext nthrest partition eval doseq await await-for let agent atom send send-off release-pending-sends add-watch mapv filterv remove-watch agent-error restart-agent set-error-handler error-handler set-error-mode! error-mode shutdown-agents quote var fn loop recur throw try monitor-enter monitor-exit macroexpand macroexpand-1 for dosync and or when when-not when-let comp juxt partial sequence memoize constantly complement identity assert peek pop doto proxy first rest cons cast coll last butlast sigs reify second ffirst fnext nfirst nnext meta with-meta ns in-ns create-ns import refer keys select-keys vals key val rseq name namespace promise into transient persistent! conj! assoc! dissoc! pop! disj! use class type num float double short byte boolean bigint biginteger bigdec print-method print-dup throw-if printf format load compile get-in update-in pr pr-on newline flush read slurp read-line subvec with-open memfn time re-find re-groups rand-int rand mod locking assert-valid-fdecl alias resolve ref deref refset swap! reset! set-validator! compare-and-set! alter-meta! reset-meta! commute get-validator alter ref-set ref-history-count ref-min-history ref-max-history ensure sync io! new next conj set! to-array future future-call into-array aset gen-class reduce map filter find empty hash-map hash-set sorted-map sorted-map-by sorted-set sorted-set-by vec vector seq flatten reverse assoc dissoc list disj get union difference intersection extend extend-type extend-protocol int nth delay count concat chunk chunk-buffer chunk-append chunk-first chunk-rest max min dec unchecked-inc-int unchecked-inc unchecked-dec-inc unchecked-dec unchecked-negate unchecked-add-int unchecked-add unchecked-subtract-int unchecked-subtract chunk-next chunk-cons chunked-seq? prn vary-meta lazy-seq spread list* str find-keyword keyword symbol gensym force rationalize"},s={begin:a,relevance:0},o={scope:"number",relevance:0,variants:[{match:/[-+]?0[xX][0-9a-fA-F]+N?/},{match:/[-+]?0[0-7]+N?/},{match:/[-+]?[1-9][0-9]?[rR][0-9a-zA-Z]+N?/},{match:/[-+]?[0-9]+\\/[0-9]+N?/},{match:/[-+]?[0-9]+((\\.[0-9]*([eE][+-]?[0-9]+)?M?)|([eE][+-]?[0-9]+M?|M))/},{match:/[-+]?([1-9][0-9]*|0)N?/}]},_={scope:"character",variants:[{match:/\\\\o[0-3]?[0-7]{1,2}/},{match:/\\\\u[0-9a-fA-F]{4}/},{match:/\\\\(newline|space|tab|formfeed|backspace|return)/},{match:/\\\\\\S/,relevance:0}]},l={scope:"regex",begin:/#"/,end:/"/,contains:[e.BACKSLASH_ESCAPE]},c=e.inherit(e.QUOTE_STRING_MODE,{illegal:null}),d={scope:"punctuation",match:/,/,relevance:0},m=e.COMMENT(";","$",{relevance:0}),p={className:"literal",begin:/\\b(true|false|nil)\\b/},E={begin:"\\\\[|(#::?"+a+")?\\\\{",end:"[\\\\]\\\\}]",relevance:0},g={className:"symbol",begin:"[:]{1,2}"+a},S={begin:"\\\\(",end:"\\\\)"},T={endsWithParent:!0,relevance:0},R={keywords:i,className:"name",begin:a,relevance:0,starts:T},f=[d,S,_,l,c,m,g,E,o,p,s],A={beginKeywords:r,keywords:{$pattern:a,keyword:r},end:'(\\\\[|#|\\\\d|"|:|\\\\{|\\\\)|\\\\(|$)',contains:[{className:"title",begin:a,relevance:0,excludeEnd:!0,endsParent:!0}].concat(f)};return S.contains=[A,R,T],T.contains=f,E.contains=f,{name:"Clojure",aliases:["clj","edn"],illegal:/\\S/,contains:[d,S,_,l,c,m,g,E,o,p]}}return Kt=t,Kt}var $t,ki;function jc(){if(ki)return $t;ki=1;function t(e){return{name:"Clojure REPL",contains:[{className:"meta.prompt",begin:/^([\\w.-]+|\\s*#_)?=>/,starts:{end:/$/,subLanguage:"clojure"}}]}}return $t=t,$t}var Qt,Ui;function e_(){if(Ui)return Qt;Ui=1;function t(e){return{name:"CMake",aliases:["cmake.in"],case_insensitive:!0,keywords:{keyword:"break cmake_host_system_information cmake_minimum_required cmake_parse_arguments cmake_policy configure_file continue elseif else endforeach endfunction endif endmacro endwhile execute_process file find_file find_library find_package find_path find_program foreach function get_cmake_property get_directory_property get_filename_component get_property if include include_guard list macro mark_as_advanced math message option return separate_arguments set_directory_properties set_property set site_name string unset variable_watch while add_compile_definitions add_compile_options add_custom_command add_custom_target add_definitions add_dependencies add_executable add_library add_link_options add_subdirectory add_test aux_source_directory build_command create_test_sourcelist define_property enable_language enable_testing export fltk_wrap_ui get_source_file_property get_target_property get_test_property include_directories include_external_msproject include_regular_expression install link_directories link_libraries load_cache project qt_wrap_cpp qt_wrap_ui remove_definitions set_source_files_properties set_target_properties set_tests_properties source_group target_compile_definitions target_compile_features target_compile_options target_include_directories target_link_directories target_link_libraries target_link_options target_sources try_compile try_run ctest_build ctest_configure ctest_coverage ctest_empty_binary_directory ctest_memcheck ctest_read_custom_files ctest_run_script ctest_sleep ctest_start ctest_submit ctest_test ctest_update ctest_upload build_name exec_program export_library_dependencies install_files install_programs install_targets load_command make_directory output_required_files remove subdir_depends subdirs use_mangled_mesa utility_source variable_requires write_file qt5_use_modules qt5_use_package qt5_wrap_cpp on off true false and or not command policy target test exists is_newer_than is_directory is_symlink is_absolute matches less greater equal less_equal greater_equal strless strgreater strequal strless_equal strgreater_equal version_less version_greater version_equal version_less_equal version_greater_equal in_list defined"},contains:[{className:"variable",begin:/\\$\\{/,end:/\\}/},e.COMMENT(/#\\[\\[/,/]]/),e.HASH_COMMENT_MODE,e.QUOTE_STRING_MODE,e.NUMBER_MODE]}}return Qt=t,Qt}var Xt,Fi;function t_(){if(Fi)return Xt;Fi=1;const t=["as","in","of","if","for","while","finally","var","new","function","do","return","void","else","break","catch","instanceof","with","throw","case","default","try","switch","continue","typeof","delete","let","yield","const","class","debugger","async","await","static","import","from","export","extends","using"],e=["true","false","null","undefined","NaN","Infinity"],n=["Object","Function","Boolean","Symbol","Math","Date","Number","BigInt","String","RegExp","Array","Float32Array","Float64Array","Int8Array","Uint8Array","Uint8ClampedArray","Int16Array","Int32Array","Uint16Array","Uint32Array","BigInt64Array","BigUint64Array","Set","Map","WeakSet","WeakMap","ArrayBuffer","SharedArrayBuffer","Atomics","DataView","JSON","Promise","Generator","GeneratorFunction","AsyncFunction","Reflect","Proxy","Intl","WebAssembly"],a=["Error","EvalError","InternalError","RangeError","ReferenceError","SyntaxError","TypeError","URIError"],r=["setInterval","setTimeout","clearInterval","clearTimeout","require","exports","eval","isFinite","isNaN","parseFloat","parseInt","decodeURI","decodeURIComponent","encodeURI","encodeURIComponent","escape","unescape"],i=[].concat(r,n,a);function s(o){const _=["npm","print"],l=["yes","no","on","off"],c=["then","unless","until","loop","by","when","and","or","is","isnt","not"],d=["var","const","let","function","static"],m=N=>C=>!N.includes(C),p={keyword:t.concat(c).filter(m(d)),literal:e.concat(l),built_in:i.concat(_)},E="[A-Za-z$_][0-9A-Za-z$_]*",g={className:"subst",begin:/#\\{/,end:/\\}/,keywords:p},S=[o.BINARY_NUMBER_MODE,o.inherit(o.C_NUMBER_MODE,{starts:{end:"(\\\\s*/)?",relevance:0}}),{className:"string",variants:[{begin:/'''/,end:/'''/,contains:[o.BACKSLASH_ESCAPE]},{begin:/'/,end:/'/,contains:[o.BACKSLASH_ESCAPE]},{begin:/"""/,end:/"""/,contains:[o.BACKSLASH_ESCAPE,g]},{begin:/"/,end:/"/,contains:[o.BACKSLASH_ESCAPE,g]}]},{className:"regexp",variants:[{begin:"///",end:"///",contains:[g,o.HASH_COMMENT_MODE]},{begin:"//[gim]{0,3}(?=\\\\W)",relevance:0},{begin:/\\/(?![ *]).*?(?![\\\\]).\\/[gim]{0,3}(?=\\W)/}]},{begin:"@"+E},{subLanguage:"javascript",excludeBegin:!0,excludeEnd:!0,variants:[{begin:"\`\`\`",end:"\`\`\`"},{begin:"\`",end:"\`"}]}];g.contains=S;const T=o.inherit(o.TITLE_MODE,{begin:E}),R="(\\\\(.*\\\\)\\\\s*)?\\\\B[-=]>",f={className:"params",begin:"\\\\([^\\\\(]",returnBegin:!0,contains:[{begin:/\\(/,end:/\\)/,keywords:p,contains:["self"].concat(S)}]},A={variants:[{match:[/class\\s+/,E,/\\s+extends\\s+/,E]},{match:[/class\\s+/,E]}],scope:{2:"title.class",4:"title.class.inherited"},keywords:p};return{name:"CoffeeScript",aliases:["coffee","cson","iced"],keywords:p,illegal:/\\/\\*/,contains:[...S,o.COMMENT("###","###"),o.HASH_COMMENT_MODE,{className:"function",begin:"^\\\\s*"+E+"\\\\s*=\\\\s*"+R,end:"[-=]>",returnBegin:!0,contains:[T,f]},{begin:/[:\\(,=]\\s*/,relevance:0,contains:[{className:"function",begin:R,end:"[-=]>",returnBegin:!0,contains:[f]}]},A,{begin:E+":",end:":",returnBegin:!0,returnEnd:!0,relevance:0}]}}return Xt=s,Xt}var Zt,Bi;function n_(){if(Bi)return Zt;Bi=1;function t(e){return{name:"Coq",keywords:{keyword:["_|0","as","at","cofix","else","end","exists","exists2","fix","for","forall","fun","if","IF","in","let","match","mod","Prop","return","Set","then","Type","using","where","with","Abort","About","Add","Admit","Admitted","All","Arguments","Assumptions","Axiom","Back","BackTo","Backtrack","Bind","Blacklist","Canonical","Cd","Check","Class","Classes","Close","Coercion","Coercions","CoFixpoint","CoInductive","Collection","Combined","Compute","Conjecture","Conjectures","Constant","constr","Constraint","Constructors","Context","Corollary","CreateHintDb","Cut","Declare","Defined","Definition","Delimit","Dependencies","Dependent","Derive","Drop","eauto","End","Equality","Eval","Example","Existential","Existentials","Existing","Export","exporting","Extern","Extract","Extraction","Fact","Field","Fields","File","Fixpoint","Focus","for","From","Function","Functional","Generalizable","Global","Goal","Grab","Grammar","Graph","Guarded","Heap","Hint","HintDb","Hints","Hypotheses","Hypothesis","ident","Identity","If","Immediate","Implicit","Import","Include","Inductive","Infix","Info","Initial","Inline","Inspect","Instance","Instances","Intro","Intros","Inversion","Inversion_clear","Language","Left","Lemma","Let","Libraries","Library","Load","LoadPath","Local","Locate","Ltac","ML","Mode","Module","Modules","Monomorphic","Morphism","Next","NoInline","Notation","Obligation","Obligations","Opaque","Open","Optimize","Options","Parameter","Parameters","Parametric","Path","Paths","pattern","Polymorphic","Preterm","Print","Printing","Program","Projections","Proof","Proposition","Pwd","Qed","Quit","Rec","Record","Recursive","Redirect","Relation","Remark","Remove","Require","Reserved","Reset","Resolve","Restart","Rewrite","Right","Ring","Rings","Save","Scheme","Scope","Scopes","Script","Search","SearchAbout","SearchHead","SearchPattern","SearchRewrite","Section","Separate","Set","Setoid","Show","Solve","Sorted","Step","Strategies","Strategy","Structure","SubClass","Table","Tables","Tactic","Term","Test","Theorem","Time","Timeout","Transparent","Type","Typeclasses","Types","Undelimit","Undo","Unfocus","Unfocused","Unfold","Universe","Universes","Unset","Unshelve","using","Variable","Variables","Variant","Verbose","Visibility","where","with"],built_in:["abstract","absurd","admit","after","apply","as","assert","assumption","at","auto","autorewrite","autounfold","before","bottom","btauto","by","case","case_eq","cbn","cbv","change","classical_left","classical_right","clear","clearbody","cofix","compare","compute","congruence","constr_eq","constructor","contradict","contradiction","cut","cutrewrite","cycle","decide","decompose","dependent","destruct","destruction","dintuition","discriminate","discrR","do","double","dtauto","eapply","eassumption","eauto","ecase","econstructor","edestruct","ediscriminate","eelim","eexact","eexists","einduction","einjection","eleft","elim","elimtype","enough","equality","erewrite","eright","esimplify_eq","esplit","evar","exact","exactly_once","exfalso","exists","f_equal","fail","field","field_simplify","field_simplify_eq","first","firstorder","fix","fold","fourier","functional","generalize","generalizing","gfail","give_up","has_evar","hnf","idtac","in","induction","injection","instantiate","intro","intro_pattern","intros","intuition","inversion","inversion_clear","is_evar","is_var","lapply","lazy","left","lia","lra","move","native_compute","nia","nsatz","omega","once","pattern","pose","progress","proof","psatz","quote","record","red","refine","reflexivity","remember","rename","repeat","replace","revert","revgoals","rewrite","rewrite_strat","right","ring","ring_simplify","rtauto","set","setoid_reflexivity","setoid_replace","setoid_rewrite","setoid_symmetry","setoid_transitivity","shelve","shelve_unifiable","simpl","simple","simplify_eq","solve","specialize","split","split_Rabs","split_Rmult","stepl","stepr","subst","sum","swap","symmetry","tactic","tauto","time","timeout","top","transitivity","trivial","try","tryif","unfold","unify","until","using","vm_compute","with"]},contains:[e.QUOTE_STRING_MODE,e.COMMENT("\\\\(\\\\*","\\\\*\\\\)"),e.C_NUMBER_MODE,{className:"type",excludeBegin:!0,begin:"\\\\|\\\\s*",end:"\\\\w+"},{begin:/[-=]>/}]}}return Zt=t,Zt}var Jt,Gi;function a_(){if(Gi)return Jt;Gi=1;function t(e){return{name:"Caché Object Script",case_insensitive:!0,aliases:["cls"],keywords:"property parameter class classmethod clientmethod extends as break catch close continue do d|0 else elseif for goto halt hang h|0 if job j|0 kill k|0 lock l|0 merge new open quit q|0 read r|0 return set s|0 tcommit throw trollback try tstart use view while write w|0 xecute x|0 zkill znspace zn ztrap zwrite zw zzdump zzwrite print zbreak zinsert zload zprint zremove zsave zzprint mv mvcall mvcrt mvdim mvprint zquit zsync ascii",contains:[{className:"number",begin:"\\\\b(\\\\d+(\\\\.\\\\d*)?|\\\\.\\\\d+)",relevance:0},{className:"string",variants:[{begin:'"',end:'"',contains:[{begin:'""',relevance:0}]}]},e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,{className:"comment",begin:/;/,end:"$",relevance:0},{className:"built_in",begin:/(?:\\$\\$?|\\.\\.)\\^?[a-zA-Z]+/},{className:"built_in",begin:/\\$\\$\\$[a-zA-Z]+/},{className:"built_in",begin:/%[a-z]+(?:\\.[a-z]+)*/},{className:"symbol",begin:/\\^%?[a-zA-Z][\\w]*/},{className:"keyword",begin:/##class|##super|#define|#dim/},{begin:/&sql\\(/,end:/\\)/,excludeBegin:!0,excludeEnd:!0,subLanguage:"sql"},{begin:/&(js|jscript|javascript)</,end:/>/,excludeBegin:!0,excludeEnd:!0,subLanguage:"javascript"},{begin:/&html<\\s*</,end:/>\\s*>/,subLanguage:"xml"}]}}return Jt=t,Jt}var jt,Yi;function r_(){if(Yi)return jt;Yi=1;function t(e){const n=e.regex,a=e.COMMENT("//","$",{contains:[{begin:/\\\\\\n/}]}),r="decltype\\\\(auto\\\\)",i="[a-zA-Z_]\\\\w*::",o="(?!struct)("+r+"|"+n.optional(i)+"[a-zA-Z_]\\\\w*"+n.optional("<[^<>]+>")+")",_={className:"type",begin:"\\\\b[a-z\\\\d_]*_t\\\\b"},c={className:"string",variants:[{begin:'(u8?|U|L)?"',end:'"',illegal:"\\\\n",contains:[e.BACKSLASH_ESCAPE]},{begin:"(u8?|U|L)?'("+"\\\\\\\\(x[0-9A-Fa-f]{2}|u[0-9A-Fa-f]{4,8}|[0-7]{3}|\\\\S)"+"|.)",end:"'",illegal:"."},e.END_SAME_AS_BEGIN({begin:/(?:u8?|U|L)?R"([^()\\\\ ]{0,16})\\(/,end:/\\)([^()\\\\ ]{0,16})"/})]},d={className:"number",variants:[{begin:"[+-]?(?:(?:[0-9](?:'?[0-9])*\\\\.(?:[0-9](?:'?[0-9])*)?|\\\\.[0-9](?:'?[0-9])*)(?:[Ee][+-]?[0-9](?:'?[0-9])*)?|[0-9](?:'?[0-9])*[Ee][+-]?[0-9](?:'?[0-9])*|0[Xx](?:[0-9A-Fa-f](?:'?[0-9A-Fa-f])*(?:\\\\.(?:[0-9A-Fa-f](?:'?[0-9A-Fa-f])*)?)?|\\\\.[0-9A-Fa-f](?:'?[0-9A-Fa-f])*)[Pp][+-]?[0-9](?:'?[0-9])*)(?:[Ff](?:16|32|64|128)?|(BF|bf)16|[Ll]|)"},{begin:"[+-]?\\\\b(?:0[Bb][01](?:'?[01])*|0[Xx][0-9A-Fa-f](?:'?[0-9A-Fa-f])*|0(?:'?[0-7])*|[1-9](?:'?[0-9])*)(?:[Uu](?:LL?|ll?)|[Uu][Zz]?|(?:LL?|ll?)[Uu]?|[Zz][Uu]|)"}],relevance:0},m={className:"meta",begin:/#\\s*[a-z]+\\b/,end:/$/,keywords:{keyword:"if else elif endif define undef warning error line pragma _Pragma ifdef ifndef include"},contains:[{begin:/\\\\\\n/,relevance:0},e.inherit(c,{className:"string"}),{className:"string",begin:/<.*?>/},a,e.C_BLOCK_COMMENT_MODE]},p={className:"title",begin:n.optional(i)+e.IDENT_RE,relevance:0},E=n.optional(i)+e.IDENT_RE+"\\\\s*\\\\(",g=["alignas","alignof","and","and_eq","asm","atomic_cancel","atomic_commit","atomic_noexcept","auto","bitand","bitor","break","case","catch","class","co_await","co_return","co_yield","compl","concept","const_cast|10","consteval","constexpr","constinit","continue","decltype","default","delete","do","dynamic_cast|10","else","enum","explicit","export","extern","false","final","for","friend","goto","if","import","inline","module","mutable","namespace","new","noexcept","not","not_eq","nullptr","operator","or","or_eq","override","private","protected","public","reflexpr","register","reinterpret_cast|10","requires","return","sizeof","static_assert","static_cast|10","struct","switch","synchronized","template","this","thread_local","throw","transaction_safe","transaction_safe_dynamic","true","try","typedef","typeid","typename","union","using","virtual","volatile","while","xor","xor_eq"],S=["bool","char","char16_t","char32_t","char8_t","double","float","int","long","short","void","wchar_t","unsigned","signed","const","static"],T=["any","auto_ptr","barrier","binary_semaphore","bitset","complex","condition_variable","condition_variable_any","counting_semaphore","deque","false_type","flat_map","flat_set","future","imaginary","initializer_list","istringstream","jthread","latch","lock_guard","multimap","multiset","mutex","optional","ostringstream","packaged_task","pair","promise","priority_queue","queue","recursive_mutex","recursive_timed_mutex","scoped_lock","set","shared_future","shared_lock","shared_mutex","shared_timed_mutex","shared_ptr","stack","string_view","stringstream","timed_mutex","thread","true_type","tuple","unique_lock","unique_ptr","unordered_map","unordered_multimap","unordered_multiset","unordered_set","variant","vector","weak_ptr","wstring","wstring_view"],R=["abort","abs","acos","apply","as_const","asin","atan","atan2","calloc","ceil","cerr","cin","clog","cos","cosh","cout","declval","endl","exchange","exit","exp","fabs","floor","fmod","forward","fprintf","fputs","free","frexp","fscanf","future","invoke","isalnum","isalpha","iscntrl","isdigit","isgraph","islower","isprint","ispunct","isspace","isupper","isxdigit","labs","launder","ldexp","log","log10","make_pair","make_shared","make_shared_for_overwrite","make_tuple","make_unique","malloc","memchr","memcmp","memcpy","memset","modf","move","pow","printf","putchar","puts","realloc","scanf","sin","sinh","snprintf","sprintf","sqrt","sscanf","std","stderr","stdin","stdout","strcat","strchr","strcmp","strcpy","strcspn","strlen","strncat","strncmp","strncpy","strpbrk","strrchr","strspn","strstr","swap","tan","tanh","terminate","to_underlying","tolower","toupper","vfprintf","visit","vprintf","vsprintf"],N={type:S,keyword:g,literal:["NULL","false","nullopt","nullptr","true"],built_in:["_Pragma"],_type_hints:T},C={className:"function.dispatch",relevance:0,keywords:{_hint:R},begin:n.concat(/\\b/,/(?!decltype)/,/(?!if)/,/(?!for)/,/(?!switch)/,/(?!while)/,e.IDENT_RE,n.lookahead(/(<[^<>]+>|)\\s*\\(/))},M=[C,m,_,a,e.C_BLOCK_COMMENT_MODE,d,c],y={variants:[{begin:/=/,end:/;/},{begin:/\\(/,end:/\\)/},{beginKeywords:"new throw return else",end:/;/}],keywords:N,contains:M.concat([{begin:/\\(/,end:/\\)/,keywords:N,contains:M.concat(["self"]),relevance:0}]),relevance:0},x={className:"function",begin:"("+o+"[\\\\*&\\\\s]+)+"+E,returnBegin:!0,end:/[{;=]/,excludeEnd:!0,keywords:N,illegal:/[^\\w\\s\\*&:<>.]/,contains:[{begin:r,keywords:N,relevance:0},{begin:E,returnBegin:!0,contains:[p],relevance:0},{begin:/::/,relevance:0},{begin:/:/,endsWithParent:!0,contains:[c,d]},{relevance:0,match:/,/},{className:"params",begin:/\\(/,end:/\\)/,keywords:N,relevance:0,contains:[a,e.C_BLOCK_COMMENT_MODE,c,d,_,{begin:/\\(/,end:/\\)/,keywords:N,relevance:0,contains:["self",a,e.C_BLOCK_COMMENT_MODE,c,d,_]}]},_,a,e.C_BLOCK_COMMENT_MODE,m]};return{name:"C++",aliases:["cc","c++","h++","hpp","hh","hxx","cxx"],keywords:N,illegal:"</",classNameAliases:{"function.dispatch":"built_in"},contains:[].concat(y,x,C,M,[m,{begin:"\\\\b(deque|list|queue|priority_queue|pair|stack|vector|map|set|bitset|multiset|multimap|unordered_map|unordered_set|unordered_multiset|unordered_multimap|array|tuple|optional|variant|function|flat_map|flat_set)\\\\s*<(?!<)",end:">",keywords:N,contains:["self",_]},{begin:e.IDENT_RE+"::",keywords:N},{match:[/\\b(?:enum(?:\\s+(?:class|struct))?|class|struct|union)/,/\\s+/,/\\w+/],className:{1:"keyword",3:"title.class"}}])}}return jt=t,jt}var en,qi;function i_(){if(qi)return en;qi=1;function t(e){const n="primitive rsc_template",a="group clone ms master location colocation order fencing_topology rsc_ticket acl_target acl_group user role tag xml";return{name:"crmsh",aliases:["crm","pcmk"],case_insensitive:!0,keywords:{keyword:"params meta operations op rule attributes utilization"+" "+"read write deny defined not_defined in_range date spec in ref reference attribute type xpath version and or lt gt tag lte gte eq ne \\\\"+" "+"number string",literal:"Master Started Slave Stopped start promote demote stop monitor true false"},contains:[e.HASH_COMMENT_MODE,{beginKeywords:"node",starts:{end:"\\\\s*([\\\\w_-]+:)?",starts:{className:"title",end:"\\\\s*[\\\\$\\\\w_][\\\\w_-]*"}}},{beginKeywords:n,starts:{className:"title",end:"\\\\s*[\\\\$\\\\w_][\\\\w_-]*",starts:{end:"\\\\s*@?[\\\\w_][\\\\w_\\\\.:-]*"}}},{begin:"\\\\b("+a.split(" ").join("|")+")\\\\s+",keywords:a,starts:{className:"title",end:"[\\\\$\\\\w_][\\\\w_-]*"}},{beginKeywords:"property rsc_defaults op_defaults",starts:{className:"title",end:"\\\\s*([\\\\w_-]+:)?"}},e.QUOTE_STRING_MODE,{className:"meta",begin:"(ocf|systemd|service|lsb):[\\\\w_:-]+",relevance:0},{className:"number",begin:"\\\\b\\\\d+(\\\\.\\\\d+)?(ms|s|h|m)?",relevance:0},{className:"literal",begin:"[-]?(infinity|inf)",relevance:0},{className:"attr",begin:/([A-Za-z$_#][\\w_-]+)=/,relevance:0},{className:"tag",begin:"</?",end:"/?>",relevance:0}]}}return en=t,en}var tn,Hi;function o_(){if(Hi)return tn;Hi=1;function t(e){const n="(_?[ui](8|16|32|64|128))?",a="(_?f(32|64))?",r="[a-zA-Z_]\\\\w*[!?=]?",i="[a-zA-Z_]\\\\w*[!?=]?|[-+~]@|<<|>>|[=!]~|===?|<=>|[<>]=?|\\\\*\\\\*|[-/+%^&*~|]|//|//=|&[-+*]=?|&\\\\*\\\\*|\\\\[\\\\][=?]?",s="[A-Za-z_]\\\\w*(::\\\\w+)*(\\\\?|!)?",o={$pattern:r,keyword:"abstract alias annotation as as? asm begin break case class def do else elsif end ensure enum extend for fun if include instance_sizeof is_a? lib macro module next nil? of out pointerof private protected rescue responds_to? return require select self sizeof struct super then type typeof union uninitialized unless until verbatim when while with yield __DIR__ __END_LINE__ __FILE__ __LINE__",literal:"false nil true"},_={className:"subst",begin:/#\\{/,end:/\\}/,keywords:o},l={className:"variable",begin:"(\\\\$\\\\W)|((\\\\$|@@?)(\\\\w+))(?=[^@$?])(?![A-Za-z])(?![@$?'])"},c={className:"template-variable",variants:[{begin:"\\\\{\\\\{",end:"\\\\}\\\\}"},{begin:"\\\\{%",end:"%\\\\}"}],keywords:o};function d(R,f){const A=[{begin:R,end:f}];return A[0].contains=A,A}const m={className:"string",contains:[e.BACKSLASH_ESCAPE,_],variants:[{begin:/'/,end:/'/},{begin:/"/,end:/"/},{begin:/\`/,end:/\`/},{begin:"%[Qwi]?\\\\(",end:"\\\\)",contains:d("\\\\(","\\\\)")},{begin:"%[Qwi]?\\\\[",end:"\\\\]",contains:d("\\\\[","\\\\]")},{begin:"%[Qwi]?\\\\{",end:/\\}/,contains:d(/\\{/,/\\}/)},{begin:"%[Qwi]?<",end:">",contains:d("<",">")},{begin:"%[Qwi]?\\\\|",end:"\\\\|"},{begin:/<<-\\w+$/,end:/^\\s*\\w+$/}],relevance:0},p={className:"string",variants:[{begin:"%q\\\\(",end:"\\\\)",contains:d("\\\\(","\\\\)")},{begin:"%q\\\\[",end:"\\\\]",contains:d("\\\\[","\\\\]")},{begin:"%q\\\\{",end:/\\}/,contains:d(/\\{/,/\\}/)},{begin:"%q<",end:">",contains:d("<",">")},{begin:"%q\\\\|",end:"\\\\|"},{begin:/<<-'\\w+'$/,end:/^\\s*\\w+$/}],relevance:0},E={begin:"(?!%\\\\})("+e.RE_STARTERS_RE+"|\\\\n|\\\\b(case|if|select|unless|until|when|while)\\\\b)\\\\s*",keywords:"case if select unless until when while",contains:[{className:"regexp",contains:[e.BACKSLASH_ESCAPE,_],variants:[{begin:"//[a-z]*",relevance:0},{begin:"/(?!\\\\/)",end:"/[a-z]*"}]}],relevance:0},g={className:"regexp",contains:[e.BACKSLASH_ESCAPE,_],variants:[{begin:"%r\\\\(",end:"\\\\)",contains:d("\\\\(","\\\\)")},{begin:"%r\\\\[",end:"\\\\]",contains:d("\\\\[","\\\\]")},{begin:"%r\\\\{",end:/\\}/,contains:d(/\\{/,/\\}/)},{begin:"%r<",end:">",contains:d("<",">")},{begin:"%r\\\\|",end:"\\\\|"}],relevance:0},S={className:"meta",begin:"@\\\\[",end:"\\\\]",contains:[e.inherit(e.QUOTE_STRING_MODE,{className:"string"})]},T=[c,m,p,g,E,S,l,e.HASH_COMMENT_MODE,{className:"class",beginKeywords:"class module struct",end:"$|;",illegal:/=/,contains:[e.HASH_COMMENT_MODE,e.inherit(e.TITLE_MODE,{begin:s}),{begin:"<"}]},{className:"class",beginKeywords:"lib enum union",end:"$|;",illegal:/=/,contains:[e.HASH_COMMENT_MODE,e.inherit(e.TITLE_MODE,{begin:s})]},{beginKeywords:"annotation",end:"$|;",illegal:/=/,contains:[e.HASH_COMMENT_MODE,e.inherit(e.TITLE_MODE,{begin:s})],relevance:2},{className:"function",beginKeywords:"def",end:/\\B\\b/,contains:[e.inherit(e.TITLE_MODE,{begin:i,endsParent:!0})]},{className:"function",beginKeywords:"fun macro",end:/\\B\\b/,contains:[e.inherit(e.TITLE_MODE,{begin:i,endsParent:!0})],relevance:2},{className:"symbol",begin:e.UNDERSCORE_IDENT_RE+"(!|\\\\?)?:",relevance:0},{className:"symbol",begin:":",contains:[m,{begin:i}],relevance:0},{className:"number",variants:[{begin:"\\\\b0b([01_]+)"+n},{begin:"\\\\b0o([0-7_]+)"+n},{begin:"\\\\b0x([A-Fa-f0-9_]+)"+n},{begin:"\\\\b([1-9][0-9_]*[0-9]|[0-9])(\\\\.[0-9][0-9_]*)?([eE]_?[-+]?[0-9_]*)?"+a+"(?!_)"},{begin:"\\\\b([1-9][0-9_]*|0)"+n}],relevance:0}];return _.contains=T,c.contains=T.slice(1),{name:"Crystal",aliases:["cr"],keywords:o,contains:T}}return tn=t,tn}var nn,Vi;function s_(){if(Vi)return nn;Vi=1;function t(e){const n=["bool","byte","char","decimal","delegate","double","dynamic","enum","float","int","long","nint","nuint","object","sbyte","short","string","ulong","uint","ushort"],a=["public","private","protected","static","internal","protected","abstract","async","extern","override","unsafe","virtual","new","sealed","partial"],r=["default","false","null","true"],i=["abstract","as","base","break","case","catch","class","const","continue","do","else","event","explicit","extern","finally","fixed","for","foreach","goto","if","implicit","in","interface","internal","is","lock","namespace","new","operator","out","override","params","private","protected","public","readonly","record","ref","return","scoped","sealed","sizeof","stackalloc","static","struct","switch","this","throw","try","typeof","unchecked","unsafe","using","virtual","void","volatile","while"],s=["add","alias","and","ascending","args","async","await","by","descending","dynamic","equals","file","from","get","global","group","init","into","join","let","nameof","not","notnull","on","or","orderby","partial","record","remove","required","scoped","select","set","unmanaged","value|0","var","when","where","with","yield"],o={keyword:i.concat(s),built_in:n,literal:r},_=e.inherit(e.TITLE_MODE,{begin:"[a-zA-Z](\\\\.?\\\\w)*"}),l={className:"number",variants:[{begin:"\\\\b(0b[01']+)"},{begin:"(-?)\\\\b([\\\\d']+(\\\\.[\\\\d']*)?|\\\\.[\\\\d']+)(u|U|l|L|ul|UL|f|F|b|B)"},{begin:"(-?)(\\\\b0[xX][a-fA-F0-9']+|(\\\\b[\\\\d']+(\\\\.[\\\\d']*)?|\\\\.[\\\\d']+)([eE][-+]?[\\\\d']+)?)"}],relevance:0},c={className:"string",begin:/"""("*)(?!")(.|\\n)*?"""\\1/,relevance:1},d={className:"string",begin:'@"',end:'"',contains:[{begin:'""'}]},m=e.inherit(d,{illegal:/\\n/}),p={className:"subst",begin:/\\{/,end:/\\}/,keywords:o},E=e.inherit(p,{illegal:/\\n/}),g={className:"string",begin:/\\$"/,end:'"',illegal:/\\n/,contains:[{begin:/\\{\\{/},{begin:/\\}\\}/},e.BACKSLASH_ESCAPE,E]},S={className:"string",begin:/\\$@"/,end:'"',contains:[{begin:/\\{\\{/},{begin:/\\}\\}/},{begin:'""'},p]},T=e.inherit(S,{illegal:/\\n/,contains:[{begin:/\\{\\{/},{begin:/\\}\\}/},{begin:'""'},E]});p.contains=[S,g,d,e.APOS_STRING_MODE,e.QUOTE_STRING_MODE,l,e.C_BLOCK_COMMENT_MODE],E.contains=[T,g,m,e.APOS_STRING_MODE,e.QUOTE_STRING_MODE,l,e.inherit(e.C_BLOCK_COMMENT_MODE,{illegal:/\\n/})];const R={variants:[c,S,g,d,e.APOS_STRING_MODE,e.QUOTE_STRING_MODE]},f={begin:"<",end:">",contains:[{beginKeywords:"in out"},_]},A=e.IDENT_RE+"(<"+e.IDENT_RE+"(\\\\s*,\\\\s*"+e.IDENT_RE+")*>)?(\\\\[\\\\])?",N={begin:"@"+e.IDENT_RE,relevance:0};return{name:"C#",aliases:["cs","c#"],keywords:o,illegal:/::/,contains:[e.COMMENT("///","$",{returnBegin:!0,contains:[{className:"doctag",variants:[{begin:"///",relevance:0},{begin:"<!--|-->"},{begin:"</?",end:">"}]}]}),e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,{className:"meta",begin:"#",end:"$",keywords:{keyword:"if else elif endif define undef warning error line region endregion pragma checksum"}},R,l,{beginKeywords:"class interface",relevance:0,end:/[{;=]/,illegal:/[^\\s:,]/,contains:[{beginKeywords:"where class"},_,f,e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE]},{beginKeywords:"namespace",relevance:0,end:/[{;=]/,illegal:/[^\\s:]/,contains:[_,e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE]},{beginKeywords:"record",relevance:0,end:/[{;=]/,illegal:/[^\\s:]/,contains:[_,f,e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE]},{className:"meta",begin:"^\\\\s*\\\\[(?=[\\\\w])",excludeBegin:!0,end:"\\\\]",excludeEnd:!0,contains:[{className:"string",begin:/"/,end:/"/}]},{beginKeywords:"new return throw await else",relevance:0},{className:"function",begin:"("+A+"\\\\s+)+"+e.IDENT_RE+"\\\\s*(<[^=]+>\\\\s*)?\\\\(",returnBegin:!0,end:/\\s*[{;=]/,excludeEnd:!0,keywords:o,contains:[{beginKeywords:a.join(" "),relevance:0},{begin:e.IDENT_RE+"\\\\s*(<[^=]+>\\\\s*)?\\\\(",returnBegin:!0,contains:[e.TITLE_MODE,f],relevance:0},{match:/\\(\\)/},{className:"params",begin:/\\(/,end:/\\)/,excludeBegin:!0,excludeEnd:!0,keywords:o,relevance:0,contains:[R,l,e.C_BLOCK_COMMENT_MODE]},e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE]},N]}}return nn=t,nn}var an,zi;function l_(){if(zi)return an;zi=1;function t(e){return{name:"CSP",case_insensitive:!1,keywords:{$pattern:"[a-zA-Z][a-zA-Z0-9_-]*",keyword:["base-uri","child-src","connect-src","default-src","font-src","form-action","frame-ancestors","frame-src","img-src","manifest-src","media-src","object-src","plugin-types","report-uri","sandbox","script-src","style-src","trusted-types","unsafe-hashes","worker-src"]},contains:[{className:"string",begin:"'",end:"'"},{className:"attribute",begin:"^Content",end:":",excludeEnd:!0}]}}return an=t,an}var rn,Wi;function c_(){if(Wi)return rn;Wi=1;const t=l=>({IMPORTANT:{scope:"meta",begin:"!important"},BLOCK_COMMENT:l.C_BLOCK_COMMENT_MODE,HEXCOLOR:{scope:"number",begin:/#(([0-9a-fA-F]{3,4})|(([0-9a-fA-F]{2}){3,4}))\\b/},FUNCTION_DISPATCH:{className:"built_in",begin:/[\\w-]+(?=\\()/},ATTRIBUTE_SELECTOR_MODE:{scope:"selector-attr",begin:/\\[/,end:/\\]/,illegal:"$",contains:[l.APOS_STRING_MODE,l.QUOTE_STRING_MODE]},CSS_NUMBER_MODE:{scope:"number",begin:l.NUMBER_RE+"(%|em|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc|px|deg|grad|rad|turn|s|ms|Hz|kHz|dpi|dpcm|dppx)?",relevance:0},CSS_VARIABLE:{className:"attr",begin:/--[A-Za-z_][A-Za-z0-9_-]*/}}),e=["a","abbr","address","article","aside","audio","b","blockquote","body","button","canvas","caption","cite","code","dd","del","details","dfn","div","dl","dt","em","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","header","hgroup","html","i","iframe","img","input","ins","kbd","label","legend","li","main","mark","menu","nav","object","ol","optgroup","option","p","picture","q","quote","samp","section","select","source","span","strong","summary","sup","table","tbody","td","textarea","tfoot","th","thead","time","tr","ul","var","video"],n=["defs","g","marker","mask","pattern","svg","switch","symbol","feBlend","feColorMatrix","feComponentTransfer","feComposite","feConvolveMatrix","feDiffuseLighting","feDisplacementMap","feFlood","feGaussianBlur","feImage","feMerge","feMorphology","feOffset","feSpecularLighting","feTile","feTurbulence","linearGradient","radialGradient","stop","circle","ellipse","image","line","path","polygon","polyline","rect","text","use","textPath","tspan","foreignObject","clipPath"],a=[...e,...n],r=["any-hover","any-pointer","aspect-ratio","color","color-gamut","color-index","device-aspect-ratio","device-height","device-width","display-mode","forced-colors","grid","height","hover","inverted-colors","monochrome","orientation","overflow-block","overflow-inline","pointer","prefers-color-scheme","prefers-contrast","prefers-reduced-motion","prefers-reduced-transparency","resolution","scan","scripting","update","width","min-width","max-width","min-height","max-height"].sort().reverse(),i=["active","any-link","blank","checked","current","default","defined","dir","disabled","drop","empty","enabled","first","first-child","first-of-type","fullscreen","future","focus","focus-visible","focus-within","has","host","host-context","hover","indeterminate","in-range","invalid","is","lang","last-child","last-of-type","left","link","local-link","not","nth-child","nth-col","nth-last-child","nth-last-col","nth-last-of-type","nth-of-type","only-child","only-of-type","optional","out-of-range","past","placeholder-shown","read-only","read-write","required","right","root","scope","target","target-within","user-invalid","valid","visited","where"].sort().reverse(),s=["after","backdrop","before","cue","cue-region","first-letter","first-line","grammar-error","marker","part","placeholder","selection","slotted","spelling-error"].sort().reverse(),o=["accent-color","align-content","align-items","align-self","alignment-baseline","all","anchor-name","animation","animation-composition","animation-delay","animation-direction","animation-duration","animation-fill-mode","animation-iteration-count","animation-name","animation-play-state","animation-range","animation-range-end","animation-range-start","animation-timeline","animation-timing-function","appearance","aspect-ratio","backdrop-filter","backface-visibility","background","background-attachment","background-blend-mode","background-clip","background-color","background-image","background-origin","background-position","background-position-x","background-position-y","background-repeat","background-size","baseline-shift","block-size","border","border-block","border-block-color","border-block-end","border-block-end-color","border-block-end-style","border-block-end-width","border-block-start","border-block-start-color","border-block-start-style","border-block-start-width","border-block-style","border-block-width","border-bottom","border-bottom-color","border-bottom-left-radius","border-bottom-right-radius","border-bottom-style","border-bottom-width","border-collapse","border-color","border-end-end-radius","border-end-start-radius","border-image","border-image-outset","border-image-repeat","border-image-slice","border-image-source","border-image-width","border-inline","border-inline-color","border-inline-end","border-inline-end-color","border-inline-end-style","border-inline-end-width","border-inline-start","border-inline-start-color","border-inline-start-style","border-inline-start-width","border-inline-style","border-inline-width","border-left","border-left-color","border-left-style","border-left-width","border-radius","border-right","border-right-color","border-right-style","border-right-width","border-spacing","border-start-end-radius","border-start-start-radius","border-style","border-top","border-top-color","border-top-left-radius","border-top-right-radius","border-top-style","border-top-width","border-width","bottom","box-align","box-decoration-break","box-direction","box-flex","box-flex-group","box-lines","box-ordinal-group","box-orient","box-pack","box-shadow","box-sizing","break-after","break-before","break-inside","caption-side","caret-color","clear","clip","clip-path","clip-rule","color","color-interpolation","color-interpolation-filters","color-profile","color-rendering","color-scheme","column-count","column-fill","column-gap","column-rule","column-rule-color","column-rule-style","column-rule-width","column-span","column-width","columns","contain","contain-intrinsic-block-size","contain-intrinsic-height","contain-intrinsic-inline-size","contain-intrinsic-size","contain-intrinsic-width","container","container-name","container-type","content","content-visibility","counter-increment","counter-reset","counter-set","cue","cue-after","cue-before","cursor","cx","cy","direction","display","dominant-baseline","empty-cells","enable-background","field-sizing","fill","fill-opacity","fill-rule","filter","flex","flex-basis","flex-direction","flex-flow","flex-grow","flex-shrink","flex-wrap","float","flood-color","flood-opacity","flow","font","font-display","font-family","font-feature-settings","font-kerning","font-language-override","font-optical-sizing","font-palette","font-size","font-size-adjust","font-smooth","font-smoothing","font-stretch","font-style","font-synthesis","font-synthesis-position","font-synthesis-small-caps","font-synthesis-style","font-synthesis-weight","font-variant","font-variant-alternates","font-variant-caps","font-variant-east-asian","font-variant-emoji","font-variant-ligatures","font-variant-numeric","font-variant-position","font-variation-settings","font-weight","forced-color-adjust","gap","glyph-orientation-horizontal","glyph-orientation-vertical","grid","grid-area","grid-auto-columns","grid-auto-flow","grid-auto-rows","grid-column","grid-column-end","grid-column-start","grid-gap","grid-row","grid-row-end","grid-row-start","grid-template","grid-template-areas","grid-template-columns","grid-template-rows","hanging-punctuation","height","hyphenate-character","hyphenate-limit-chars","hyphens","icon","image-orientation","image-rendering","image-resolution","ime-mode","initial-letter","initial-letter-align","inline-size","inset","inset-area","inset-block","inset-block-end","inset-block-start","inset-inline","inset-inline-end","inset-inline-start","isolation","justify-content","justify-items","justify-self","kerning","left","letter-spacing","lighting-color","line-break","line-height","line-height-step","list-style","list-style-image","list-style-position","list-style-type","margin","margin-block","margin-block-end","margin-block-start","margin-bottom","margin-inline","margin-inline-end","margin-inline-start","margin-left","margin-right","margin-top","margin-trim","marker","marker-end","marker-mid","marker-start","marks","mask","mask-border","mask-border-mode","mask-border-outset","mask-border-repeat","mask-border-slice","mask-border-source","mask-border-width","mask-clip","mask-composite","mask-image","mask-mode","mask-origin","mask-position","mask-repeat","mask-size","mask-type","masonry-auto-flow","math-depth","math-shift","math-style","max-block-size","max-height","max-inline-size","max-width","min-block-size","min-height","min-inline-size","min-width","mix-blend-mode","nav-down","nav-index","nav-left","nav-right","nav-up","none","normal","object-fit","object-position","offset","offset-anchor","offset-distance","offset-path","offset-position","offset-rotate","opacity","order","orphans","outline","outline-color","outline-offset","outline-style","outline-width","overflow","overflow-anchor","overflow-block","overflow-clip-margin","overflow-inline","overflow-wrap","overflow-x","overflow-y","overlay","overscroll-behavior","overscroll-behavior-block","overscroll-behavior-inline","overscroll-behavior-x","overscroll-behavior-y","padding","padding-block","padding-block-end","padding-block-start","padding-bottom","padding-inline","padding-inline-end","padding-inline-start","padding-left","padding-right","padding-top","page","page-break-after","page-break-before","page-break-inside","paint-order","pause","pause-after","pause-before","perspective","perspective-origin","place-content","place-items","place-self","pointer-events","position","position-anchor","position-visibility","print-color-adjust","quotes","r","resize","rest","rest-after","rest-before","right","rotate","row-gap","ruby-align","ruby-position","scale","scroll-behavior","scroll-margin","scroll-margin-block","scroll-margin-block-end","scroll-margin-block-start","scroll-margin-bottom","scroll-margin-inline","scroll-margin-inline-end","scroll-margin-inline-start","scroll-margin-left","scroll-margin-right","scroll-margin-top","scroll-padding","scroll-padding-block","scroll-padding-block-end","scroll-padding-block-start","scroll-padding-bottom","scroll-padding-inline","scroll-padding-inline-end","scroll-padding-inline-start","scroll-padding-left","scroll-padding-right","scroll-padding-top","scroll-snap-align","scroll-snap-stop","scroll-snap-type","scroll-timeline","scroll-timeline-axis","scroll-timeline-name","scrollbar-color","scrollbar-gutter","scrollbar-width","shape-image-threshold","shape-margin","shape-outside","shape-rendering","speak","speak-as","src","stop-color","stop-opacity","stroke","stroke-dasharray","stroke-dashoffset","stroke-linecap","stroke-linejoin","stroke-miterlimit","stroke-opacity","stroke-width","tab-size","table-layout","text-align","text-align-all","text-align-last","text-anchor","text-combine-upright","text-decoration","text-decoration-color","text-decoration-line","text-decoration-skip","text-decoration-skip-ink","text-decoration-style","text-decoration-thickness","text-emphasis","text-emphasis-color","text-emphasis-position","text-emphasis-style","text-indent","text-justify","text-orientation","text-overflow","text-rendering","text-shadow","text-size-adjust","text-transform","text-underline-offset","text-underline-position","text-wrap","text-wrap-mode","text-wrap-style","timeline-scope","top","touch-action","transform","transform-box","transform-origin","transform-style","transition","transition-behavior","transition-delay","transition-duration","transition-property","transition-timing-function","translate","unicode-bidi","user-modify","user-select","vector-effect","vertical-align","view-timeline","view-timeline-axis","view-timeline-inset","view-timeline-name","view-transition-name","visibility","voice-balance","voice-duration","voice-family","voice-pitch","voice-range","voice-rate","voice-stress","voice-volume","white-space","white-space-collapse","widows","width","will-change","word-break","word-spacing","word-wrap","writing-mode","x","y","z-index","zoom"].sort().reverse();function _(l){const c=l.regex,d=t(l),m={begin:/-(webkit|moz|ms|o)-(?=[a-z])/},p="and or not only",E=/@-?\\w[\\w]*(-\\w+)*/,g="[a-zA-Z-][a-zA-Z0-9_-]*",S=[l.APOS_STRING_MODE,l.QUOTE_STRING_MODE];return{name:"CSS",case_insensitive:!0,illegal:/[=|'\\$]/,keywords:{keyframePosition:"from to"},classNameAliases:{keyframePosition:"selector-tag"},contains:[d.BLOCK_COMMENT,m,d.CSS_NUMBER_MODE,{className:"selector-id",begin:/#[A-Za-z0-9_-]+/,relevance:0},{className:"selector-class",begin:"\\\\."+g,relevance:0},d.ATTRIBUTE_SELECTOR_MODE,{className:"selector-pseudo",variants:[{begin:":("+i.join("|")+")"},{begin:":(:)?("+s.join("|")+")"}]},d.CSS_VARIABLE,{className:"attribute",begin:"\\\\b("+o.join("|")+")\\\\b"},{begin:/:/,end:/[;}{]/,contains:[d.BLOCK_COMMENT,d.HEXCOLOR,d.IMPORTANT,d.CSS_NUMBER_MODE,...S,{begin:/(url|data-uri)\\(/,end:/\\)/,relevance:0,keywords:{built_in:"url data-uri"},contains:[...S,{className:"string",begin:/[^)]/,endsWithParent:!0,excludeEnd:!0}]},d.FUNCTION_DISPATCH]},{begin:c.lookahead(/@/),end:"[{;]",relevance:0,illegal:/:/,contains:[{className:"keyword",begin:E},{begin:/\\s/,endsWithParent:!0,excludeEnd:!0,relevance:0,keywords:{$pattern:/[a-z-]+/,keyword:p,attribute:r.join(" ")},contains:[{begin:/[a-z-]+(?=:)/,className:"attribute"},...S,d.CSS_NUMBER_MODE]}]},{className:"selector-tag",begin:"\\\\b("+a.join("|")+")\\\\b"}]}}return rn=_,rn}var on,Ki;function __(){if(Ki)return on;Ki=1;function t(e){const n={$pattern:e.UNDERSCORE_IDENT_RE,keyword:"abstract alias align asm assert auto body break byte case cast catch class const continue debug default delete deprecated do else enum export extern final finally for foreach foreach_reverse|10 goto if immutable import in inout int interface invariant is lazy macro mixin module new nothrow out override package pragma private protected public pure ref return scope shared static struct super switch synchronized template this throw try typedef typeid typeof union unittest version void volatile while with __FILE__ __LINE__ __gshared|10 __thread __traits __DATE__ __EOF__ __TIME__ __TIMESTAMP__ __VENDOR__ __VERSION__",built_in:"bool cdouble cent cfloat char creal dchar delegate double dstring float function idouble ifloat ireal long real short string ubyte ucent uint ulong ushort wchar wstring",literal:"false null true"},a="(0|[1-9][\\\\d_]*)",r="(0|[1-9][\\\\d_]*|\\\\d[\\\\d_]*|[\\\\d_]+?\\\\d)",i="0[bB][01_]+",s="([\\\\da-fA-F][\\\\da-fA-F_]*|_[\\\\da-fA-F][\\\\da-fA-F_]*)",o="0[xX]"+s,_="([eE][+-]?"+r+")",l="("+r+"(\\\\.\\\\d*|"+_+")|\\\\d+\\\\."+r+"|\\\\."+a+_+"?)",c="(0[xX]("+s+"\\\\."+s+"|\\\\.?"+s+")[pP][+-]?"+r+")",d="("+a+"|"+i+"|"+o+")",m="("+c+"|"+l+")",p=\`\\\\\\\\(['"\\\\?\\\\\\\\abfnrtv]|u[\\\\dA-Fa-f]{4}|[0-7]{1,3}|x[\\\\dA-Fa-f]{2}|U[\\\\dA-Fa-f]{8})|&[a-zA-Z\\\\d]{2,};\`,E={className:"number",begin:"\\\\b"+d+"(L|u|U|Lu|LU|uL|UL)?",relevance:0},g={className:"number",begin:"\\\\b("+m+"([fF]|L|i|[fF]i|Li)?|"+d+"(i|[fF]i|Li))",relevance:0},S={className:"string",begin:"'("+p+"|.)",end:"'",illegal:"."},R={className:"string",begin:'"',contains:[{begin:p,relevance:0}],end:'"[cwd]?'},f={className:"string",begin:'[rq]"',end:'"[cwd]?',relevance:5},A={className:"string",begin:"\`",end:"\`[cwd]?"},N={className:"string",begin:'x"[\\\\da-fA-F\\\\s\\\\n\\\\r]*"[cwd]?',relevance:10},C={className:"string",begin:'q"\\\\{',end:'\\\\}"'},M={className:"meta",begin:"^#!",end:"$",relevance:5},y={className:"meta",begin:"#(line)",end:"$",relevance:5},x={className:"keyword",begin:"@[a-zA-Z_][a-zA-Z_\\\\d]*"},G=e.COMMENT("\\\\/\\\\+","\\\\+\\\\/",{contains:["self"],relevance:10});return{name:"D",keywords:n,contains:[e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,G,N,R,f,A,C,g,E,S,M,y,x]}}return on=t,on}var sn,$i;function d_(){if($i)return sn;$i=1;function t(e){const n=e.regex,a={begin:/<\\/?[A-Za-z_]/,end:">",subLanguage:"xml",relevance:0},r={begin:"^[-\\\\*]{3,}",end:"$"},i={className:"code",variants:[{begin:"(\`{3,})[^\`](.|\\\\n)*?\\\\1\`*[ ]*"},{begin:"(~{3,})[^~](.|\\\\n)*?\\\\1~*[ ]*"},{begin:"\`\`\`",end:"\`\`\`+[ ]*$"},{begin:"~~~",end:"~~~+[ ]*$"},{begin:"\`.+?\`"},{begin:"(?=^( {4}|\\\\t))",contains:[{begin:"^( {4}|\\\\t)",end:"(\\\\n)$"}],relevance:0}]},s={className:"bullet",begin:"^[ 	]*([*+-]|(\\\\d+\\\\.))(?=\\\\s+)",end:"\\\\s+",excludeEnd:!0},o={begin:/^\\[[^\\n]+\\]:/,returnBegin:!0,contains:[{className:"symbol",begin:/\\[/,end:/\\]/,excludeBegin:!0,excludeEnd:!0},{className:"link",begin:/:\\s*/,end:/$/,excludeBegin:!0}]},_=/[A-Za-z][A-Za-z0-9+.-]*/,l={variants:[{begin:/\\[.+?\\]\\[.*?\\]/,relevance:0},{begin:/\\[.+?\\]\\(((data|javascript|mailto):|(?:http|ftp)s?:\\/\\/).*?\\)/,relevance:2},{begin:n.concat(/\\[.+?\\]\\(/,_,/:\\/\\/.*?\\)/),relevance:2},{begin:/\\[.+?\\]\\([./?&#].*?\\)/,relevance:1},{begin:/\\[.*?\\]\\(.*?\\)/,relevance:0}],returnBegin:!0,contains:[{match:/\\[(?=\\])/},{className:"string",relevance:0,begin:"\\\\[",end:"\\\\]",excludeBegin:!0,returnEnd:!0},{className:"link",relevance:0,begin:"\\\\]\\\\(",end:"\\\\)",excludeBegin:!0,excludeEnd:!0},{className:"symbol",relevance:0,begin:"\\\\]\\\\[",end:"\\\\]",excludeBegin:!0,excludeEnd:!0}]},c={className:"strong",contains:[],variants:[{begin:/_{2}(?!\\s)/,end:/_{2}/},{begin:/\\*{2}(?!\\s)/,end:/\\*{2}/}]},d={className:"emphasis",contains:[],variants:[{begin:/\\*(?![*\\s])/,end:/\\*/},{begin:/_(?![_\\s])/,end:/_/,relevance:0}]},m=e.inherit(c,{contains:[]}),p=e.inherit(d,{contains:[]});c.contains.push(p),d.contains.push(m);let E=[a,l];return[c,d,m,p].forEach(R=>{R.contains=R.contains.concat(E)}),E=E.concat(c,d),{name:"Markdown",aliases:["md","mkdown","mkd"],contains:[{className:"section",variants:[{begin:"^#{1,6}",end:"$",contains:E},{begin:"(?=^.+?\\\\n[=-]{2,}$)",contains:[{begin:"^[=-]*$"},{begin:"^",end:"\\\\n",contains:E}]}]},a,s,c,d,{className:"quote",begin:"^>\\\\s+",contains:E,end:"$"},i,r,l,o,{scope:"literal",match:/&([a-zA-Z0-9]+|#[0-9]{1,7}|#[Xx][0-9a-fA-F]{1,6});/}]}}return sn=t,sn}var ln,Qi;function u_(){if(Qi)return ln;Qi=1;function t(e){const n={className:"subst",variants:[{begin:"\\\\$[A-Za-z0-9_]+"}]},a={className:"subst",variants:[{begin:/\\$\\{/,end:/\\}/}],keywords:"true false null this is new super"},r={className:"number",relevance:0,variants:[{match:/\\b[0-9][0-9_]*(\\.[0-9][0-9_]*)?([eE][+-]?[0-9][0-9_]*)?\\b/},{match:/\\b0[xX][0-9A-Fa-f][0-9A-Fa-f_]*\\b/}]},i={className:"string",variants:[{begin:"r'''",end:"'''"},{begin:'r"""',end:'"""'},{begin:"r'",end:"'",illegal:"\\\\n"},{begin:'r"',end:'"',illegal:"\\\\n"},{begin:"'''",end:"'''",contains:[e.BACKSLASH_ESCAPE,n,a]},{begin:'"""',end:'"""',contains:[e.BACKSLASH_ESCAPE,n,a]},{begin:"'",end:"'",illegal:"\\\\n",contains:[e.BACKSLASH_ESCAPE,n,a]},{begin:'"',end:'"',illegal:"\\\\n",contains:[e.BACKSLASH_ESCAPE,n,a]}]};a.contains=[r,i];const s=["Comparable","DateTime","Duration","Function","Iterable","Iterator","List","Map","Match","Object","Pattern","RegExp","Set","Stopwatch","String","StringBuffer","StringSink","Symbol","Type","Uri","bool","double","int","num","Element","ElementList"],o=s.map(c=>\`\${c}?\`);return{name:"Dart",keywords:{keyword:["abstract","as","assert","async","await","base","break","case","catch","class","const","continue","covariant","default","deferred","do","dynamic","else","enum","export","extends","extension","external","factory","false","final","finally","for","Function","get","hide","if","implements","import","in","interface","is","late","library","mixin","new","null","on","operator","part","required","rethrow","return","sealed","set","show","static","super","switch","sync","this","throw","true","try","typedef","var","void","when","while","with","yield"],built_in:s.concat(o).concat(["Never","Null","dynamic","print","document","querySelector","querySelectorAll","window"]),$pattern:/[A-Za-z][A-Za-z0-9_]*\\??/},contains:[i,e.COMMENT(/\\/\\*\\*(?!\\/)/,/\\*\\//,{subLanguage:"markdown",relevance:0}),e.COMMENT(/\\/{3,} ?/,/$/,{contains:[{subLanguage:"markdown",begin:".",end:"$",relevance:0}]}),e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,{className:"class",beginKeywords:"class interface",end:/\\{/,excludeEnd:!0,contains:[{beginKeywords:"extends implements"},e.UNDERSCORE_TITLE_MODE]},r,{className:"meta",begin:"@[A-Za-z]+"},{begin:"=>"}]}}return ln=t,ln}var cn,Xi;function m_(){if(Xi)return cn;Xi=1;function t(e){const n=["exports","register","file","shl","array","record","property","for","mod","while","set","ally","label","uses","raise","not","stored","class","safecall","var","interface","or","private","static","exit","index","inherited","to","else","stdcall","override","shr","asm","far","resourcestring","finalization","packed","virtual","out","and","protected","library","do","xorwrite","goto","near","function","end","div","overload","object","unit","begin","string","on","inline","repeat","until","destructor","write","message","program","with","read","initialization","except","default","nil","if","case","cdecl","in","downto","threadvar","of","try","pascal","const","external","constructor","type","public","then","implementation","finally","published","procedure","absolute","reintroduce","operator","as","is","abstract","alias","assembler","bitpacked","break","continue","cppdecl","cvar","enumerator","experimental","platform","deprecated","unimplemented","dynamic","export","far16","forward","generic","helper","implements","interrupt","iochecks","local","name","nodefault","noreturn","nostackframe","oldfpccall","otherwise","saveregisters","softfloat","specialize","strict","unaligned","varargs"],a=[e.C_LINE_COMMENT_MODE,e.COMMENT(/\\{/,/\\}/,{relevance:0}),e.COMMENT(/\\(\\*/,/\\*\\)/,{relevance:10})],r={className:"meta",variants:[{begin:/\\{\\$/,end:/\\}/},{begin:/\\(\\*\\$/,end:/\\*\\)/}]},i={className:"string",begin:/'/,end:/'/,contains:[{begin:/''/}]},s={className:"number",relevance:0,variants:[{match:/\\b\\d[\\d_]*(\\.\\d[\\d_]*)?/},{match:/\\$[\\dA-Fa-f_]+/},{match:/\\$/,relevance:0},{match:/&[0-7][0-7_]*/},{match:/%[01_]+/},{match:/%/,relevance:0}]},o={className:"string",variants:[{match:/#\\d[\\d_]*/},{match:/#\\$[\\dA-Fa-f][\\dA-Fa-f_]*/},{match:/#&[0-7][0-7_]*/},{match:/#%[01][01_]*/}]},_={begin:e.IDENT_RE+"\\\\s*=\\\\s*class\\\\s*\\\\(",returnBegin:!0,contains:[e.TITLE_MODE]},l={className:"function",beginKeywords:"function constructor destructor procedure",end:/[:;]/,keywords:"function constructor|10 destructor|10 procedure|10",contains:[e.TITLE_MODE,{className:"params",begin:/\\(/,end:/\\)/,keywords:n,contains:[i,o,r].concat(a)},r].concat(a)};return{name:"Delphi",aliases:["dpr","dfm","pas","pascal"],case_insensitive:!0,keywords:n,illegal:/"|\\$[G-Zg-z]|\\/\\*|<\\/|\\|/,contains:[i,o,s,_,l,r].concat(a)}}return cn=t,cn}var _n,Zi;function p_(){if(Zi)return _n;Zi=1;function t(e){const n=e.regex;return{name:"Diff",aliases:["patch"],contains:[{className:"meta",relevance:10,match:n.either(/^@@ +-\\d+,\\d+ +\\+\\d+,\\d+ +@@/,/^\\*\\*\\* +\\d+,\\d+ +\\*\\*\\*\\*$/,/^--- +\\d+,\\d+ +----$/)},{className:"comment",variants:[{begin:n.either(/Index: /,/^index/,/={3,}/,/^-{3}/,/^\\*{3} /,/^\\+{3}/,/^diff --git/),end:/$/},{match:/^\\*{15}$/}]},{className:"addition",begin:/^\\+/,end:/$/},{className:"deletion",begin:/^-/,end:/$/},{className:"addition",begin:/^!/,end:/$/}]}}return _n=t,_n}var dn,Ji;function E_(){if(Ji)return dn;Ji=1;function t(e){const n={begin:/\\|[A-Za-z]+:?/,keywords:{name:"truncatewords removetags linebreaksbr yesno get_digit timesince random striptags filesizeformat escape linebreaks length_is ljust rjust cut urlize fix_ampersands title floatformat capfirst pprint divisibleby add make_list unordered_list urlencode timeuntil urlizetrunc wordcount stringformat linenumbers slice date dictsort dictsortreversed default_if_none pluralize lower join center default truncatewords_html upper length phone2numeric wordwrap time addslashes slugify first escapejs force_escape iriencode last safe safeseq truncatechars localize unlocalize localtime utc timezone"},contains:[e.QUOTE_STRING_MODE,e.APOS_STRING_MODE]};return{name:"Django",aliases:["jinja"],case_insensitive:!0,subLanguage:"xml",contains:[e.COMMENT(/\\{%\\s*comment\\s*%\\}/,/\\{%\\s*endcomment\\s*%\\}/),e.COMMENT(/\\{#/,/#\\}/),{className:"template-tag",begin:/\\{%/,end:/%\\}/,contains:[{className:"name",begin:/\\w+/,keywords:{name:"comment endcomment load templatetag ifchanged endifchanged if endif firstof for endfor ifnotequal endifnotequal widthratio extends include spaceless endspaceless regroup ifequal endifequal ssi now with cycle url filter endfilter debug block endblock else autoescape endautoescape csrf_token empty elif endwith static trans blocktrans endblocktrans get_static_prefix get_media_prefix plural get_current_language language get_available_languages get_current_language_bidi get_language_info get_language_info_list localize endlocalize localtime endlocaltime timezone endtimezone get_current_timezone verbatim"},starts:{endsWithParent:!0,keywords:"in by as",contains:[n],relevance:0}}]},{className:"template-variable",begin:/\\{\\{/,end:/\\}\\}/,contains:[n]}]}}return dn=t,dn}var un,ji;function g_(){if(ji)return un;ji=1;function t(e){return{name:"DNS Zone",aliases:["bind","zone"],keywords:["IN","A","AAAA","AFSDB","APL","CAA","CDNSKEY","CDS","CERT","CNAME","DHCID","DLV","DNAME","DNSKEY","DS","HIP","IPSECKEY","KEY","KX","LOC","MX","NAPTR","NS","NSEC","NSEC3","NSEC3PARAM","PTR","RRSIG","RP","SIG","SOA","SRV","SSHFP","TA","TKEY","TLSA","TSIG","TXT"],contains:[e.COMMENT(";","$",{relevance:0}),{className:"meta",begin:/^\\$(TTL|GENERATE|INCLUDE|ORIGIN)\\b/},{className:"number",begin:"((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\\\\d|1\\\\d\\\\d|[1-9]?\\\\d)(\\\\.(25[0-5]|2[0-4]\\\\d|1\\\\d\\\\d|[1-9]?\\\\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\\\\d|1\\\\d\\\\d|[1-9]?\\\\d)(\\\\.(25[0-5]|2[0-4]\\\\d|1\\\\d\\\\d|[1-9]?\\\\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\\\\d|1\\\\d\\\\d|[1-9]?\\\\d)(\\\\.(25[0-5]|2[0-4]\\\\d|1\\\\d\\\\d|[1-9]?\\\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\\\\d|1\\\\d\\\\d|[1-9]?\\\\d)(\\\\.(25[0-5]|2[0-4]\\\\d|1\\\\d\\\\d|[1-9]?\\\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\\\\d|1\\\\d\\\\d|[1-9]?\\\\d)(\\\\.(25[0-5]|2[0-4]\\\\d|1\\\\d\\\\d|[1-9]?\\\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\\\\d|1\\\\d\\\\d|[1-9]?\\\\d)(\\\\.(25[0-5]|2[0-4]\\\\d|1\\\\d\\\\d|[1-9]?\\\\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\\\\d|1\\\\d\\\\d|[1-9]?\\\\d)(\\\\.(25[0-5]|2[0-4]\\\\d|1\\\\d\\\\d|[1-9]?\\\\d)){3}))|:)))\\\\b"},{className:"number",begin:"((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]).){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\\\\b"},e.inherit(e.NUMBER_MODE,{begin:/\\b\\d+[dhwm]?/})]}}return un=t,un}var mn,eo;function S_(){if(eo)return mn;eo=1;function t(e){return{name:"Dockerfile",aliases:["docker"],case_insensitive:!0,keywords:["from","maintainer","expose","env","arg","user","onbuild","stopsignal"],contains:[e.HASH_COMMENT_MODE,e.APOS_STRING_MODE,e.QUOTE_STRING_MODE,e.NUMBER_MODE,{beginKeywords:"run cmd entrypoint volume add copy workdir label healthcheck shell",starts:{end:/[^\\\\]$/,subLanguage:"bash"}}],illegal:"</"}}return mn=t,mn}var pn,to;function T_(){if(to)return pn;to=1;function t(e){const n=e.COMMENT(/^\\s*@?rem\\b/,/$/,{relevance:10});return{name:"Batch file (DOS)",aliases:["bat","cmd"],case_insensitive:!0,illegal:/\\/\\*/,keywords:{keyword:["if","else","goto","for","in","do","call","exit","not","exist","errorlevel","defined","equ","neq","lss","leq","gtr","geq"],built_in:["prn","nul","lpt3","lpt2","lpt1","con","com4","com3","com2","com1","aux","shift","cd","dir","echo","setlocal","endlocal","set","pause","copy","append","assoc","at","attrib","break","cacls","cd","chcp","chdir","chkdsk","chkntfs","cls","cmd","color","comp","compact","convert","date","dir","diskcomp","diskcopy","doskey","erase","fs","find","findstr","format","ftype","graftabl","help","keyb","label","md","mkdir","mode","more","move","path","pause","print","popd","pushd","promt","rd","recover","rem","rename","replace","restore","rmdir","shift","sort","start","subst","time","title","tree","type","ver","verify","vol","ping","net","ipconfig","taskkill","xcopy","ren","del"]},contains:[{className:"variable",begin:/%%[^ ]|%[^ ]+?%|![^ ]+?!/},{className:"function",begin:{begin:"^\\\\s*[A-Za-z._?][A-Za-z0-9_$#@~.?]*(:|\\\\s+label)"}.begin,end:"goto:eof",contains:[e.inherit(e.TITLE_MODE,{begin:"([_a-zA-Z]\\\\w*\\\\.)*([_a-zA-Z]\\\\w*:)?[_a-zA-Z]\\\\w*"}),n]},{className:"number",begin:"\\\\b\\\\d+",relevance:0},n]}}return pn=t,pn}var En,no;function b_(){if(no)return En;no=1;function t(e){return{keywords:"dsconfig",contains:[{className:"keyword",begin:"^dsconfig",end:/\\s/,excludeEnd:!0,relevance:10},{className:"built_in",begin:/(list|create|get|set|delete)-(\\w+)/,end:/\\s/,excludeEnd:!0,illegal:"!@#$%^&*()",relevance:10},{className:"built_in",begin:/--(\\w+)/,end:/\\s/,excludeEnd:!0},{className:"string",begin:/"/,end:/"/},{className:"string",begin:/'/,end:/'/},{className:"string",begin:/[\\w\\-?]+:\\w+/,end:/\\W/,relevance:0},{className:"string",begin:/\\w+(\\-\\w+)*/,end:/(?=\\W)/,relevance:0},e.HASH_COMMENT_MODE]}}return En=t,En}var gn,ao;function R_(){if(ao)return gn;ao=1;function t(e){const n={className:"string",variants:[e.inherit(e.QUOTE_STRING_MODE,{begin:'((u8?|U)|L)?"'}),{begin:'(u8?|U)?R"',end:'"',contains:[e.BACKSLASH_ESCAPE]},{begin:"'\\\\\\\\?.",end:"'",illegal:"."}]},a={className:"number",variants:[{begin:"\\\\b(\\\\d+(\\\\.\\\\d*)?|\\\\.\\\\d+)(u|U|l|L|ul|UL|f|F)"},{begin:e.C_NUMBER_RE}],relevance:0},r={className:"meta",begin:"#",end:"$",keywords:{keyword:"if else elif endif define undef ifdef ifndef"},contains:[{begin:/\\\\\\n/,relevance:0},{beginKeywords:"include",end:"$",keywords:{keyword:"include"},contains:[e.inherit(n,{className:"string"}),{className:"string",begin:"<",end:">",illegal:"\\\\n"}]},n,e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE]},i={className:"variable",begin:/&[a-z\\d_]*\\b/},s={className:"keyword",begin:"/[a-z][a-z\\\\d-]*/"},o={className:"symbol",begin:"^\\\\s*[a-zA-Z_][a-zA-Z\\\\d_]*:"},_={className:"params",relevance:0,begin:"<",end:">",contains:[a,i]},l={className:"title.class",begin:/[a-zA-Z_][a-zA-Z\\d_@-]*(?=\\s\\{)/,relevance:.2},c={className:"title.class",begin:/^\\/(?=\\s*\\{)/,relevance:10},d={match:/[a-z][a-z-,]+(?=;)/,relevance:0,scope:"attr"},m={relevance:0,match:[/[a-z][a-z-,]+/,/\\s*/,/=/],scope:{1:"attr",3:"operator"}},p={scope:"punctuation",relevance:0,match:/\\};|[;{}]/};return{name:"Device Tree",contains:[c,i,s,o,l,m,d,_,e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,a,n,r,p,{begin:e.IDENT_RE+"::",keywords:""}]}}return gn=t,gn}var Sn,ro;function f_(){if(ro)return Sn;ro=1;function t(e){return{name:"Dust",aliases:["dst"],case_insensitive:!0,subLanguage:"xml",contains:[{className:"template-tag",begin:/\\{[#\\/]/,end:/\\}/,illegal:/;/,contains:[{className:"name",begin:/[a-zA-Z\\.-]+/,starts:{endsWithParent:!0,relevance:0,contains:[e.QUOTE_STRING_MODE]}}]},{className:"template-variable",begin:/\\{/,end:/\\}/,illegal:/;/,keywords:"if eq ne lt lte gt gte select default math sep"}]}}return Sn=t,Sn}var Tn,io;function C_(){if(io)return Tn;io=1;function t(e){const n=e.COMMENT(/\\(\\*/,/\\*\\)/),a={className:"attribute",begin:/^[ ]*[a-zA-Z]+([\\s_-]+[a-zA-Z]+)*/},i={begin:/=/,end:/[.;]/,contains:[n,{className:"meta",begin:/\\?.*\\?/},{className:"string",variants:[e.APOS_STRING_MODE,e.QUOTE_STRING_MODE,{begin:"\`",end:"\`"}]}]};return{name:"Extended Backus-Naur Form",illegal:/\\S/,contains:[n,a,i]}}return Tn=t,Tn}var bn,oo;function N_(){if(oo)return bn;oo=1;function t(e){const n=e.regex,a="[a-zA-Z_][a-zA-Z0-9_.]*(!|\\\\?)?",r="[a-zA-Z_]\\\\w*[!?=]?|[-+~]@|<<|>>|=~|===?|<=>|[<>]=?|\\\\*\\\\*|[-/+%^&*~\`|]|\\\\[\\\\]=?",o={$pattern:a,keyword:["after","alias","and","case","catch","cond","defstruct","defguard","do","else","end","fn","for","if","import","in","not","or","quote","raise","receive","require","reraise","rescue","try","unless","unquote","unquote_splicing","use","when","with|0"],literal:["false","nil","true"]},_={className:"subst",begin:/#\\{/,end:/\\}/,keywords:o},l={className:"number",begin:"(\\\\b0o[0-7_]+)|(\\\\b0b[01_]+)|(\\\\b0x[0-9a-fA-F_]+)|(-?\\\\b[0-9][0-9_]*(\\\\.[0-9_]+([eE][-+]?[0-9]+)?)?)",relevance:0},d={match:/\\\\[\\s\\S]/,scope:"char.escape",relevance:0},m=\`[/|([{<"']\`,p=[{begin:/"/,end:/"/},{begin:/'/,end:/'/},{begin:/\\//,end:/\\//},{begin:/\\|/,end:/\\|/},{begin:/\\(/,end:/\\)/},{begin:/\\[/,end:/\\]/},{begin:/\\{/,end:/\\}/},{begin:/</,end:/>/}],E=C=>({scope:"char.escape",begin:n.concat(/\\\\/,C),relevance:0}),g={className:"string",begin:"~[a-z](?="+m+")",contains:p.map(C=>e.inherit(C,{contains:[E(C.end),d,_]}))},S={className:"string",begin:"~[A-Z](?="+m+")",contains:p.map(C=>e.inherit(C,{contains:[E(C.end)]}))},T={className:"regex",variants:[{begin:"~r(?="+m+")",contains:p.map(C=>e.inherit(C,{end:n.concat(C.end,/[uismxfU]{0,7}/),contains:[E(C.end),d,_]}))},{begin:"~R(?="+m+")",contains:p.map(C=>e.inherit(C,{end:n.concat(C.end,/[uismxfU]{0,7}/),contains:[E(C.end)]}))}]},R={className:"string",contains:[e.BACKSLASH_ESCAPE,_],variants:[{begin:/"""/,end:/"""/},{begin:/'''/,end:/'''/},{begin:/~S"""/,end:/"""/,contains:[]},{begin:/~S"/,end:/"/,contains:[]},{begin:/~S'''/,end:/'''/,contains:[]},{begin:/~S'/,end:/'/,contains:[]},{begin:/'/,end:/'/},{begin:/"/,end:/"/}]},f={className:"function",beginKeywords:"def defp defmacro defmacrop",end:/\\B\\b/,contains:[e.inherit(e.TITLE_MODE,{begin:a,endsParent:!0})]},A=e.inherit(f,{className:"class",beginKeywords:"defimpl defmodule defprotocol defrecord",end:/\\bdo\\b|$|;/}),N=[R,T,S,g,e.HASH_COMMENT_MODE,A,f,{begin:"::"},{className:"symbol",begin:":(?![\\\\s:])",contains:[R,{begin:r}],relevance:0},{className:"symbol",begin:a+":(?!:)",relevance:0},{className:"title.class",begin:/(\\b[A-Z][a-zA-Z0-9_]+)/,relevance:0},l,{className:"variable",begin:"(\\\\$\\\\W)|((\\\\$|@@?)(\\\\w+))"}];return _.contains=N,{name:"Elixir",aliases:["ex","exs"],keywords:o,contains:N}}return bn=t,bn}var Rn,so;function O_(){if(so)return Rn;so=1;function t(e){const n={variants:[e.COMMENT("--","$"),e.COMMENT(/\\{-/,/-\\}/,{contains:["self"]})]},a={className:"type",begin:"\\\\b[A-Z][\\\\w']*",relevance:0},r={begin:"\\\\(",end:"\\\\)",illegal:'"',contains:[{className:"type",begin:"\\\\b[A-Z][\\\\w]*(\\\\((\\\\.\\\\.|,|\\\\w+)\\\\))?"},n]},i={begin:/\\{/,end:/\\}/,contains:r.contains},s={className:"string",begin:"'\\\\\\\\?.",end:"'",illegal:"."};return{name:"Elm",keywords:["let","in","if","then","else","case","of","where","module","import","exposing","type","alias","as","infix","infixl","infixr","port","effect","command","subscription"],contains:[{beginKeywords:"port effect module",end:"exposing",keywords:"port effect module where command subscription exposing",contains:[r,n],illegal:"\\\\W\\\\.|;"},{begin:"import",end:"$",keywords:"import as exposing",contains:[r,n],illegal:"\\\\W\\\\.|;"},{begin:"type",end:"$",keywords:"type alias",contains:[a,r,i,n]},{beginKeywords:"infix infixl infixr",end:"$",contains:[e.C_NUMBER_MODE,n]},{begin:"port",end:"$",keywords:"port",contains:[n]},s,e.QUOTE_STRING_MODE,e.C_NUMBER_MODE,a,e.inherit(e.TITLE_MODE,{begin:"^[_a-z][\\\\w']*"}),n,{begin:"->|<-"}],illegal:/;/}}return Rn=t,Rn}var fn,lo;function I_(){if(lo)return fn;lo=1;function t(e){const n=e.regex,a="([a-zA-Z_]\\\\w*[!?=]?|[-+~]@|<<|>>|=~|===?|<=>|[<>]=?|\\\\*\\\\*|[-/+%^&*~\`|]|\\\\[\\\\]=?)",r=n.either(/\\b([A-Z]+[a-z0-9]+)+/,/\\b([A-Z]+[a-z0-9]+)+[A-Z]+/),i=n.concat(r,/(::\\w+)*/),o={"variable.constant":["__FILE__","__LINE__","__ENCODING__"],"variable.language":["self","super"],keyword:["alias","and","begin","BEGIN","break","case","class","defined","do","else","elsif","end","END","ensure","for","if","in","module","next","not","or","redo","require","rescue","retry","return","then","undef","unless","until","when","while","yield",...["include","extend","prepend","public","private","protected","raise","throw"]],built_in:["proc","lambda","attr_accessor","attr_reader","attr_writer","define_method","private_constant","module_function"],literal:["true","false","nil"]},_={className:"doctag",begin:"@[A-Za-z]+"},l={begin:"#<",end:">"},c=[e.COMMENT("#","$",{contains:[_]}),e.COMMENT("^=begin","^=end",{contains:[_],relevance:10}),e.COMMENT("^__END__",e.MATCH_NOTHING_RE)],d={className:"subst",begin:/#\\{/,end:/\\}/,keywords:o},m={className:"string",contains:[e.BACKSLASH_ESCAPE,d],variants:[{begin:/'/,end:/'/},{begin:/"/,end:/"/},{begin:/\`/,end:/\`/},{begin:/%[qQwWx]?\\(/,end:/\\)/},{begin:/%[qQwWx]?\\[/,end:/\\]/},{begin:/%[qQwWx]?\\{/,end:/\\}/},{begin:/%[qQwWx]?</,end:/>/},{begin:/%[qQwWx]?\\//,end:/\\//},{begin:/%[qQwWx]?%/,end:/%/},{begin:/%[qQwWx]?-/,end:/-/},{begin:/%[qQwWx]?\\|/,end:/\\|/},{begin:/\\B\\?(\\\\\\d{1,3})/},{begin:/\\B\\?(\\\\x[A-Fa-f0-9]{1,2})/},{begin:/\\B\\?(\\\\u\\{?[A-Fa-f0-9]{1,6}\\}?)/},{begin:/\\B\\?(\\\\M-\\\\C-|\\\\M-\\\\c|\\\\c\\\\M-|\\\\M-|\\\\C-\\\\M-)[\\x20-\\x7e]/},{begin:/\\B\\?\\\\(c|C-)[\\x20-\\x7e]/},{begin:/\\B\\?\\\\?\\S/},{begin:n.concat(/<<[-~]?'?/,n.lookahead(/(\\w+)(?=\\W)[^\\n]*\\n(?:[^\\n]*\\n)*?\\s*\\1\\b/)),contains:[e.END_SAME_AS_BEGIN({begin:/(\\w+)/,end:/(\\w+)/,contains:[e.BACKSLASH_ESCAPE,d]})]}]},p="[1-9](_?[0-9])*|0",E="[0-9](_?[0-9])*",g={className:"number",relevance:0,variants:[{begin:\`\\\\b(\${p})(\\\\.(\${E}))?([eE][+-]?(\${E})|r)?i?\\\\b\`},{begin:"\\\\b0[dD][0-9](_?[0-9])*r?i?\\\\b"},{begin:"\\\\b0[bB][0-1](_?[0-1])*r?i?\\\\b"},{begin:"\\\\b0[oO][0-7](_?[0-7])*r?i?\\\\b"},{begin:"\\\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*r?i?\\\\b"},{begin:"\\\\b0(_?[0-7])+r?i?\\\\b"}]},S={variants:[{match:/\\(\\)/},{className:"params",begin:/\\(/,end:/(?=\\))/,excludeBegin:!0,endsParent:!0,keywords:o}]},M=[m,{variants:[{match:[/class\\s+/,i,/\\s+<\\s+/,i]},{match:[/\\b(class|module)\\s+/,i]}],scope:{2:"title.class",4:"title.class.inherited"},keywords:o},{match:[/(include|extend)\\s+/,i],scope:{2:"title.class"},keywords:o},{relevance:0,match:[i,/\\.new[. (]/],scope:{1:"title.class"}},{relevance:0,match:/\\b[A-Z][A-Z_0-9]+\\b/,className:"variable.constant"},{relevance:0,match:r,scope:"title.class"},{match:[/def/,/\\s+/,a],scope:{1:"keyword",3:"title.function"},contains:[S]},{begin:e.IDENT_RE+"::"},{className:"symbol",begin:e.UNDERSCORE_IDENT_RE+"(!|\\\\?)?:",relevance:0},{className:"symbol",begin:":(?!\\\\s)",contains:[m,{begin:a}],relevance:0},g,{className:"variable",begin:"(\\\\$\\\\W)|((\\\\$|@@?)(\\\\w+))(?=[^@$?])(?![A-Za-z])(?![@$?'])"},{className:"params",begin:/\\|(?!=)/,end:/\\|/,excludeBegin:!0,excludeEnd:!0,relevance:0,keywords:o},{begin:"("+e.RE_STARTERS_RE+"|unless)\\\\s*",keywords:"unless",contains:[{className:"regexp",contains:[e.BACKSLASH_ESCAPE,d],illegal:/\\n/,variants:[{begin:"/",end:"/[a-z]*"},{begin:/%r\\{/,end:/\\}[a-z]*/},{begin:"%r\\\\(",end:"\\\\)[a-z]*"},{begin:"%r!",end:"![a-z]*"},{begin:"%r\\\\[",end:"\\\\][a-z]*"}]}].concat(l,c),relevance:0}].concat(l,c);d.contains=M,S.contains=M;const w=[{begin:/^\\s*=>/,starts:{end:"$",contains:M}},{className:"meta.prompt",begin:"^("+"[>?]>"+"|"+"[\\\\w#]+\\\\(\\\\w+\\\\):\\\\d+:\\\\d+[>*]"+"|"+"(\\\\w+-)?\\\\d+\\\\.\\\\d+\\\\.\\\\d+(p\\\\d+)?[^\\\\d][^>]+>"+")(?=[ ])",starts:{end:"$",keywords:o,contains:M}}];return c.unshift(l),{name:"Ruby",aliases:["rb","gemspec","podspec","thor","irb"],keywords:o,illegal:/\\/\\*/,contains:[e.SHEBANG({binary:"ruby"})].concat(w).concat(c).concat(M)}}return fn=t,fn}var Cn,co;function A_(){if(co)return Cn;co=1;function t(e){return{name:"ERB",subLanguage:"xml",contains:[e.COMMENT("<%#","%>"),{begin:"<%[%=-]?",end:"[%-]?%>",subLanguage:"ruby",excludeBegin:!0,excludeEnd:!0}]}}return Cn=t,Cn}var Nn,_o;function v_(){if(_o)return Nn;_o=1;function t(e){const n=e.regex;return{name:"Erlang REPL",keywords:{built_in:"spawn spawn_link self",keyword:"after and andalso|10 band begin bnot bor bsl bsr bxor case catch cond div end fun if let not of or orelse|10 query receive rem try when xor"},contains:[{className:"meta.prompt",begin:"^[0-9]+> ",relevance:10},e.COMMENT("%","$"),{className:"number",begin:"\\\\b(\\\\d+(_\\\\d+)*#[a-fA-F0-9]+(_[a-fA-F0-9]+)*|\\\\d+(_\\\\d+)*(\\\\.\\\\d+(_\\\\d+)*)?([eE][-+]?\\\\d+)?)",relevance:0},e.APOS_STRING_MODE,e.QUOTE_STRING_MODE,{begin:n.concat(/\\?(::)?/,/([A-Z]\\w*)/,/((::)[A-Z]\\w*)*/)},{begin:"->"},{begin:"ok"},{begin:"!"},{begin:"(\\\\b[a-z'][a-zA-Z0-9_']*:[a-z'][a-zA-Z0-9_']*)|(\\\\b[a-z'][a-zA-Z0-9_']*)",relevance:0},{begin:"[A-Z][a-zA-Z0-9_']*",relevance:0}]}}return Nn=t,Nn}var On,uo;function y_(){if(uo)return On;uo=1;function t(e){const n="[a-z'][a-zA-Z0-9_']*",a="("+n+":"+n+"|"+n+")",r={keyword:"after and andalso|10 band begin bnot bor bsl bzr bxor case catch cond div end fun if let not of orelse|10 query receive rem try when xor maybe else",literal:"false true"},i=e.COMMENT("%","$"),s={className:"number",begin:"\\\\b(\\\\d+(_\\\\d+)*#[a-fA-F0-9]+(_[a-fA-F0-9]+)*|\\\\d+(_\\\\d+)*(\\\\.\\\\d+(_\\\\d+)*)?([eE][-+]?\\\\d+)?)",relevance:0},o={begin:"fun\\\\s+"+n+"/\\\\d+"},_={begin:a+"\\\\(",end:"\\\\)",returnBegin:!0,relevance:0,contains:[{begin:a,relevance:0},{begin:"\\\\(",end:"\\\\)",endsWithParent:!0,returnEnd:!0,relevance:0}]},l={begin:/\\{/,end:/\\}/,relevance:0},c={begin:"\\\\b_([A-Z][A-Za-z0-9_]*)?",relevance:0},d={begin:"[A-Z][a-zA-Z0-9_]*",relevance:0},m={begin:"#"+e.UNDERSCORE_IDENT_RE,relevance:0,returnBegin:!0,contains:[{begin:"#"+e.UNDERSCORE_IDENT_RE,relevance:0},{begin:/\\{/,end:/\\}/,relevance:0}]},p={scope:"string",match:/\\$(\\\\([^0-9]|[0-9]{1,3}|)|.)/},E={scope:"string",match:/"""("*)(?!")[\\s\\S]*?"""\\1/},g={scope:"string",contains:[e.BACKSLASH_ESCAPE],variants:[{match:/~\\w?"""("*)(?!")[\\s\\S]*?"""\\1/},{begin:/~\\w?\\(/,end:/\\)/},{begin:/~\\w?\\[/,end:/\\]/},{begin:/~\\w?{/,end:/}/},{begin:/~\\w?</,end:/>/},{begin:/~\\w?\\//,end:/\\//},{begin:/~\\w?\\|/,end:/\\|/},{begin:/~\\w?'/,end:/'/},{begin:/~\\w?"/,end:/"/},{begin:/~\\w?\`/,end:/\`/},{begin:/~\\w?#/,end:/#/}]},S={beginKeywords:"fun receive if try case maybe",end:"end",keywords:r};S.contains=[i,o,e.inherit(e.APOS_STRING_MODE,{className:""}),S,_,g,E,e.QUOTE_STRING_MODE,s,l,c,d,m,p];const T=[i,o,S,_,g,E,e.QUOTE_STRING_MODE,s,l,c,d,m,p];_.contains[1].contains=T,l.contains=T,m.contains[1].contains=T;const R=["-module","-record","-undef","-export","-ifdef","-ifndef","-author","-copyright","-doc","-moduledoc","-vsn","-import","-include","-include_lib","-compile","-define","-else","-endif","-file","-behaviour","-behavior","-spec","-on_load","-nifs"],f={className:"params",begin:"\\\\(",end:"\\\\)",contains:T};return{name:"Erlang",aliases:["erl"],keywords:r,illegal:"(</|\\\\*=|\\\\+=|-=|/\\\\*|\\\\*/|\\\\(\\\\*|\\\\*\\\\))",contains:[{className:"function",begin:"^"+n+"\\\\s*\\\\(",end:"->",returnBegin:!0,illegal:"\\\\(|#|//|/\\\\*|\\\\\\\\|:|;",contains:[f,e.inherit(e.TITLE_MODE,{begin:n})],starts:{end:";|\\\\.",keywords:r,contains:T}},i,{begin:"^-",end:"\\\\.",relevance:0,excludeEnd:!0,returnBegin:!0,keywords:{$pattern:"-"+e.IDENT_RE,keyword:R.map(A=>\`\${A}|1.5\`).join(" ")},contains:[f,g,E,e.QUOTE_STRING_MODE]},s,g,E,e.QUOTE_STRING_MODE,m,c,d,l,p,{begin:/\\.$/}]}}return On=t,On}var In,mo;function h_(){if(mo)return In;mo=1;function t(e){return{name:"Excel formulae",aliases:["xlsx","xls"],case_insensitive:!0,keywords:{$pattern:/[a-zA-Z][\\w\\.]*/,built_in:["ABS","ACCRINT","ACCRINTM","ACOS","ACOSH","ACOT","ACOTH","AGGREGATE","ADDRESS","AMORDEGRC","AMORLINC","AND","ARABIC","AREAS","ARRAYTOTEXT","ASC","ASIN","ASINH","ATAN","ATAN2","ATANH","AVEDEV","AVERAGE","AVERAGEA","AVERAGEIF","AVERAGEIFS","BAHTTEXT","BASE","BESSELI","BESSELJ","BESSELK","BESSELY","BETADIST","BETA.DIST","BETAINV","BETA.INV","BIN2DEC","BIN2HEX","BIN2OCT","BINOMDIST","BINOM.DIST","BINOM.DIST.RANGE","BINOM.INV","BITAND","BITLSHIFT","BITOR","BITRSHIFT","BITXOR","BYCOL","BYROW","CALL","CEILING","CEILING.MATH","CEILING.PRECISE","CELL","CHAR","CHIDIST","CHIINV","CHITEST","CHISQ.DIST","CHISQ.DIST.RT","CHISQ.INV","CHISQ.INV.RT","CHISQ.TEST","CHOOSE","CHOOSECOLS","CHOOSEROWS","CLEAN","CODE","COLUMN","COLUMNS","COMBIN","COMBINA","COMPLEX","CONCAT","CONCATENATE","CONFIDENCE","CONFIDENCE.NORM","CONFIDENCE.T","CONVERT","CORREL","COS","COSH","COT","COTH","COUNT","COUNTA","COUNTBLANK","COUNTIF","COUNTIFS","COUPDAYBS","COUPDAYS","COUPDAYSNC","COUPNCD","COUPNUM","COUPPCD","COVAR","COVARIANCE.P","COVARIANCE.S","CRITBINOM","CSC","CSCH","CUBEKPIMEMBER","CUBEMEMBER","CUBEMEMBERPROPERTY","CUBERANKEDMEMBER","CUBESET","CUBESETCOUNT","CUBEVALUE","CUMIPMT","CUMPRINC","DATE","DATEDIF","DATEVALUE","DAVERAGE","DAY","DAYS","DAYS360","DB","DBCS","DCOUNT","DCOUNTA","DDB","DEC2BIN","DEC2HEX","DEC2OCT","DECIMAL","DEGREES","DELTA","DEVSQ","DGET","DISC","DMAX","DMIN","DOLLAR","DOLLARDE","DOLLARFR","DPRODUCT","DROP","DSTDEV","DSTDEVP","DSUM","DURATION","DVAR","DVARP","EDATE","EFFECT","ENCODEURL","EOMONTH","ERF","ERF.PRECISE","ERFC","ERFC.PRECISE","ERROR.TYPE","EUROCONVERT","EVEN","EXACT","EXP","EXPAND","EXPON.DIST","EXPONDIST","FACT","FACTDOUBLE","FALSE","F.DIST","FDIST","F.DIST.RT","FILTER","FILTERXML","FIND","FINDB","F.INV","F.INV.RT","FINV","FISHER","FISHERINV","FIXED","FLOOR","FLOOR.MATH","FLOOR.PRECISE","FORECAST","FORECAST.ETS","FORECAST.ETS.CONFINT","FORECAST.ETS.SEASONALITY","FORECAST.ETS.STAT","FORECAST.LINEAR","FORMULATEXT","FREQUENCY","F.TEST","FTEST","FV","FVSCHEDULE","GAMMA","GAMMA.DIST","GAMMADIST","GAMMA.INV","GAMMAINV","GAMMALN","GAMMALN.PRECISE","GAUSS","GCD","GEOMEAN","GESTEP","GETPIVOTDATA","GROWTH","HARMEAN","HEX2BIN","HEX2DEC","HEX2OCT","HLOOKUP","HOUR","HSTACK","HYPERLINK","HYPGEOM.DIST","HYPGEOMDIST","IF","IFERROR","IFNA","IFS","IMABS","IMAGE","IMAGINARY","IMARGUMENT","IMCONJUGATE","IMCOS","IMCOSH","IMCOT","IMCSC","IMCSCH","IMDIV","IMEXP","IMLN","IMLOG10","IMLOG2","IMPOWER","IMPRODUCT","IMREAL","IMSEC","IMSECH","IMSIN","IMSINH","IMSQRT","IMSUB","IMSUM","IMTAN","INDEX","INDIRECT","INFO","INT","INTERCEPT","INTRATE","IPMT","IRR","ISBLANK","ISERR","ISERROR","ISEVEN","ISFORMULA","ISLOGICAL","ISNA","ISNONTEXT","ISNUMBER","ISODD","ISOMITTED","ISREF","ISTEXT","ISO.CEILING","ISOWEEKNUM","ISPMT","JIS","KURT","LAMBDA","LARGE","LCM","LEFT","LEFTB","LEN","LENB","LET","LINEST","LN","LOG","LOG10","LOGEST","LOGINV","LOGNORM.DIST","LOGNORMDIST","LOGNORM.INV","LOOKUP","LOWER","MAKEARRAY","MAP","MATCH","MAX","MAXA","MAXIFS","MDETERM","MDURATION","MEDIAN","MID","MIDB","MIN","MINIFS","MINA","MINUTE","MINVERSE","MIRR","MMULT","MOD","MODE","MODE.MULT","MODE.SNGL","MONTH","MROUND","MULTINOMIAL","MUNIT","N","NA","NEGBINOM.DIST","NEGBINOMDIST","NETWORKDAYS","NETWORKDAYS.INTL","NOMINAL","NORM.DIST","NORMDIST","NORMINV","NORM.INV","NORM.S.DIST","NORMSDIST","NORM.S.INV","NORMSINV","NOT","NOW","NPER","NPV","NUMBERVALUE","OCT2BIN","OCT2DEC","OCT2HEX","ODD","ODDFPRICE","ODDFYIELD","ODDLPRICE","ODDLYIELD","OFFSET","OR","PDURATION","PEARSON","PERCENTILE.EXC","PERCENTILE.INC","PERCENTILE","PERCENTRANK.EXC","PERCENTRANK.INC","PERCENTRANK","PERMUT","PERMUTATIONA","PHI","PHONETIC","PI","PMT","POISSON.DIST","POISSON","POWER","PPMT","PRICE","PRICEDISC","PRICEMAT","PROB","PRODUCT","PROPER","PV","QUARTILE","QUARTILE.EXC","QUARTILE.INC","QUOTIENT","RADIANS","RAND","RANDARRAY","RANDBETWEEN","RANK.AVG","RANK.EQ","RANK","RATE","RECEIVED","REDUCE","REGISTER.ID","REPLACE","REPLACEB","REPT","RIGHT","RIGHTB","ROMAN","ROUND","ROUNDDOWN","ROUNDUP","ROW","ROWS","RRI","RSQ","RTD","SCAN","SEARCH","SEARCHB","SEC","SECH","SECOND","SEQUENCE","SERIESSUM","SHEET","SHEETS","SIGN","SIN","SINH","SKEW","SKEW.P","SLN","SLOPE","SMALL","SORT","SORTBY","SQRT","SQRTPI","SQL.REQUEST","STANDARDIZE","STOCKHISTORY","STDEV","STDEV.P","STDEV.S","STDEVA","STDEVP","STDEVPA","STEYX","SUBSTITUTE","SUBTOTAL","SUM","SUMIF","SUMIFS","SUMPRODUCT","SUMSQ","SUMX2MY2","SUMX2PY2","SUMXMY2","SWITCH","SYD","T","TAN","TANH","TAKE","TBILLEQ","TBILLPRICE","TBILLYIELD","T.DIST","T.DIST.2T","T.DIST.RT","TDIST","TEXT","TEXTAFTER","TEXTBEFORE","TEXTJOIN","TEXTSPLIT","TIME","TIMEVALUE","T.INV","T.INV.2T","TINV","TOCOL","TOROW","TODAY","TRANSPOSE","TREND","TRIM","TRIMMEAN","TRUE","TRUNC","T.TEST","TTEST","TYPE","UNICHAR","UNICODE","UNIQUE","UPPER","VALUE","VALUETOTEXT","VAR","VAR.P","VAR.S","VARA","VARP","VARPA","VDB","VLOOKUP","VSTACK","WEBSERVICE","WEEKDAY","WEEKNUM","WEIBULL","WEIBULL.DIST","WORKDAY","WORKDAY.INTL","WRAPCOLS","WRAPROWS","XIRR","XLOOKUP","XMATCH","XNPV","XOR","YEAR","YEARFRAC","YIELD","YIELDDISC","YIELDMAT","Z.TEST","ZTEST"]},contains:[{begin:/^=/,end:/[^=]/,returnEnd:!0,illegal:/=/,relevance:10},{className:"symbol",begin:/\\b[A-Z]{1,2}\\d+\\b/,end:/[^\\d]/,excludeEnd:!0,relevance:0},{className:"symbol",begin:/[A-Z]{0,2}\\d*:[A-Z]{0,2}\\d*/,relevance:0},e.BACKSLASH_ESCAPE,e.QUOTE_STRING_MODE,{className:"number",begin:e.NUMBER_RE+"(%)?",relevance:0},e.COMMENT(/\\bN\\(/,/\\)/,{excludeBegin:!0,excludeEnd:!0,illegal:/\\n/})]}}return In=t,In}var An,po;function D_(){if(po)return An;po=1;function t(e){return{name:"FIX",contains:[{begin:/[^\\u2401\\u0001]+/,end:/[\\u2401\\u0001]/,excludeEnd:!0,returnBegin:!0,returnEnd:!1,contains:[{begin:/([^\\u2401\\u0001=]+)/,end:/=([^\\u2401\\u0001=]+)/,returnEnd:!0,returnBegin:!1,className:"attr"},{begin:/=/,end:/([\\u2401\\u0001])/,excludeEnd:!0,excludeBegin:!0,className:"string"}]}],case_insensitive:!0}}return An=t,An}var vn,Eo;function M_(){if(Eo)return vn;Eo=1;function t(e){const n={className:"string",begin:/'(.|\\\\[xXuU][a-zA-Z0-9]+)'/},a={className:"string",variants:[{begin:'"',end:'"'}]},i={className:"function",beginKeywords:"def",end:/[:={\\[(\\n;]/,excludeEnd:!0,contains:[{className:"title",relevance:0,begin:/[^0-9\\n\\t "'(),.\`{}\\[\\]:;][^\\n\\t "'(),.\`{}\\[\\]:;]+|[^0-9\\n\\t "'(),.\`{}\\[\\]:;=]/}]};return{name:"Flix",keywords:{keyword:["case","class","def","else","enum","if","impl","import","in","lat","rel","index","let","match","namespace","switch","type","yield","with"],literal:["true","false"]},contains:[e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,n,a,i,e.C_NUMBER_MODE]}}return vn=t,vn}var yn,go;function L_(){if(go)return yn;go=1;function t(e){const n=e.regex,a={className:"params",begin:"\\\\(",end:"\\\\)"},r={variants:[e.COMMENT("!","$",{relevance:0}),e.COMMENT("^C[ ]","$",{relevance:0}),e.COMMENT("^C$","$",{relevance:0})]},i=/(_[a-z_\\d]+)?/,s=/([de][+-]?\\d+)?/,o={className:"number",variants:[{begin:n.concat(/\\b\\d+/,/\\.(\\d*)/,s,i)},{begin:n.concat(/\\b\\d+/,s,i)},{begin:n.concat(/\\.\\d+/,s,i)}],relevance:0},_={className:"function",beginKeywords:"subroutine function program",illegal:"[\${=\\\\n]",contains:[e.UNDERSCORE_TITLE_MODE,a]},l={className:"string",relevance:0,variants:[e.APOS_STRING_MODE,e.QUOTE_STRING_MODE]};return{name:"Fortran",case_insensitive:!0,aliases:["f90","f95"],keywords:{$pattern:/\\b[a-z][a-z0-9_]+\\b|\\.[a-z][a-z0-9_]+\\./,keyword:["kind","do","concurrent","local","shared","while","private","call","intrinsic","where","elsewhere","type","endtype","endmodule","endselect","endinterface","end","enddo","endif","if","forall","endforall","only","contains","default","return","stop","then","block","endblock","endassociate","public","subroutine|10","function","program",".and.",".or.",".not.",".le.",".eq.",".ge.",".gt.",".lt.","goto","save","else","use","module","select","case","access","blank","direct","exist","file","fmt","form","formatted","iostat","name","named","nextrec","number","opened","rec","recl","sequential","status","unformatted","unit","continue","format","pause","cycle","exit","c_null_char","c_alert","c_backspace","c_form_feed","flush","wait","decimal","round","iomsg","synchronous","nopass","non_overridable","pass","protected","volatile","abstract","extends","import","non_intrinsic","value","deferred","generic","final","enumerator","class","associate","bind","enum","c_int","c_short","c_long","c_long_long","c_signed_char","c_size_t","c_int8_t","c_int16_t","c_int32_t","c_int64_t","c_int_least8_t","c_int_least16_t","c_int_least32_t","c_int_least64_t","c_int_fast8_t","c_int_fast16_t","c_int_fast32_t","c_int_fast64_t","c_intmax_t","C_intptr_t","c_float","c_double","c_long_double","c_float_complex","c_double_complex","c_long_double_complex","c_bool","c_char","c_null_ptr","c_null_funptr","c_new_line","c_carriage_return","c_horizontal_tab","c_vertical_tab","iso_c_binding","c_loc","c_funloc","c_associated","c_f_pointer","c_ptr","c_funptr","iso_fortran_env","character_storage_size","error_unit","file_storage_size","input_unit","iostat_end","iostat_eor","numeric_storage_size","output_unit","c_f_procpointer","ieee_arithmetic","ieee_support_underflow_control","ieee_get_underflow_mode","ieee_set_underflow_mode","newunit","contiguous","recursive","pad","position","action","delim","readwrite","eor","advance","nml","interface","procedure","namelist","include","sequence","elemental","pure","impure","integer","real","character","complex","logical","codimension","dimension","allocatable|10","parameter","external","implicit|10","none","double","precision","assign","intent","optional","pointer","target","in","out","common","equivalence","data"],literal:[".False.",".True."],built_in:["alog","alog10","amax0","amax1","amin0","amin1","amod","cabs","ccos","cexp","clog","csin","csqrt","dabs","dacos","dasin","datan","datan2","dcos","dcosh","ddim","dexp","dint","dlog","dlog10","dmax1","dmin1","dmod","dnint","dsign","dsin","dsinh","dsqrt","dtan","dtanh","float","iabs","idim","idint","idnint","ifix","isign","max0","max1","min0","min1","sngl","algama","cdabs","cdcos","cdexp","cdlog","cdsin","cdsqrt","cqabs","cqcos","cqexp","cqlog","cqsin","cqsqrt","dcmplx","dconjg","derf","derfc","dfloat","dgamma","dimag","dlgama","iqint","qabs","qacos","qasin","qatan","qatan2","qcmplx","qconjg","qcos","qcosh","qdim","qerf","qerfc","qexp","qgamma","qimag","qlgama","qlog","qlog10","qmax1","qmin1","qmod","qnint","qsign","qsin","qsinh","qsqrt","qtan","qtanh","abs","acos","aimag","aint","anint","asin","atan","atan2","char","cmplx","conjg","cos","cosh","exp","ichar","index","int","log","log10","max","min","nint","sign","sin","sinh","sqrt","tan","tanh","print","write","dim","lge","lgt","lle","llt","mod","nullify","allocate","deallocate","adjustl","adjustr","all","allocated","any","associated","bit_size","btest","ceiling","count","cshift","date_and_time","digits","dot_product","eoshift","epsilon","exponent","floor","fraction","huge","iand","ibclr","ibits","ibset","ieor","ior","ishft","ishftc","lbound","len_trim","matmul","maxexponent","maxloc","maxval","merge","minexponent","minloc","minval","modulo","mvbits","nearest","pack","present","product","radix","random_number","random_seed","range","repeat","reshape","rrspacing","scale","scan","selected_int_kind","selected_real_kind","set_exponent","shape","size","spacing","spread","sum","system_clock","tiny","transpose","trim","ubound","unpack","verify","achar","iachar","transfer","dble","entry","dprod","cpu_time","command_argument_count","get_command","get_command_argument","get_environment_variable","is_iostat_end","ieee_arithmetic","ieee_support_underflow_control","ieee_get_underflow_mode","ieee_set_underflow_mode","is_iostat_eor","move_alloc","new_line","selected_char_kind","same_type_as","extends_type_of","acosh","asinh","atanh","bessel_j0","bessel_j1","bessel_jn","bessel_y0","bessel_y1","bessel_yn","erf","erfc","erfc_scaled","gamma","log_gamma","hypot","norm2","atomic_define","atomic_ref","execute_command_line","leadz","trailz","storage_size","merge_bits","bge","bgt","ble","blt","dshiftl","dshiftr","findloc","iall","iany","iparity","image_index","lcobound","ucobound","maskl","maskr","num_images","parity","popcnt","poppar","shifta","shiftl","shiftr","this_image","sync","change","team","co_broadcast","co_max","co_min","co_sum","co_reduce"]},illegal:/\\/\\*/,contains:[l,_,{begin:/^C\\s*=(?!=)/,relevance:0},r,o]}}return yn=t,yn}var hn,So;function x_(){if(So)return hn;So=1;function t(o){return new RegExp(o.replace(/[-/\\\\^$*+?.()|[\\]{}]/g,"\\\\$&"),"m")}function e(o){return o?typeof o=="string"?o:o.source:null}function n(o){return a("(?=",o,")")}function a(...o){return o.map(l=>e(l)).join("")}function r(o){const _=o[o.length-1];return typeof _=="object"&&_.constructor===Object?(o.splice(o.length-1,1),_):{}}function i(...o){return"("+(r(o).capture?"":"?:")+o.map(c=>e(c)).join("|")+")"}function s(o){const _=["abstract","and","as","assert","base","begin","class","default","delegate","do","done","downcast","downto","elif","else","end","exception","extern","finally","fixed","for","fun","function","global","if","in","inherit","inline","interface","internal","lazy","let","match","member","module","mutable","namespace","new","of","open","or","override","private","public","rec","return","static","struct","then","to","try","type","upcast","use","val","void","when","while","with","yield"],l={scope:"keyword",match:/\\b(yield|return|let|do|match|use)!/},c=["if","else","endif","line","nowarn","light","r","i","I","load","time","help","quit"],d=["true","false","null","Some","None","Ok","Error","infinity","infinityf","nan","nanf"],m=["__LINE__","__SOURCE_DIRECTORY__","__SOURCE_FILE__"],p=["bool","byte","sbyte","int8","int16","int32","uint8","uint16","uint32","int","uint","int64","uint64","nativeint","unativeint","decimal","float","double","float32","single","char","string","unit","bigint","option","voption","list","array","seq","byref","exn","inref","nativeptr","obj","outref","voidptr","Result"],g={keyword:_,literal:d,built_in:["not","ref","raise","reraise","dict","readOnlyDict","set","get","enum","sizeof","typeof","typedefof","nameof","nullArg","invalidArg","invalidOp","id","fst","snd","ignore","lock","using","box","unbox","tryUnbox","printf","printfn","sprintf","eprintf","eprintfn","fprintf","fprintfn","failwith","failwithf"],"variable.constant":m},T={variants:[o.COMMENT(/\\(\\*(?!\\))/,/\\*\\)/,{contains:["self"]}),o.C_LINE_COMMENT_MODE]},R=/[a-zA-Z_](\\w|')*/,f={scope:"variable",begin:/\`\`/,end:/\`\`/},A=/\\B('|\\^)/,N={scope:"symbol",variants:[{match:a(A,/\`\`.*?\`\`/)},{match:a(A,o.UNDERSCORE_IDENT_RE)}],relevance:0},C=function({includeEqual:se}){let ue;se?ue="!%&*+-/<=>@^|~?":ue="!%&*+-/<>@^|~?";const Z=Array.from(ue),K=a("[",...Z.map(t),"]"),te=i(K,/\\./),ne=a(te,n(te)),le=i(a(ne,te,"*"),a(K,"+"));return{scope:"operator",match:i(le,/:\\?>/,/:\\?/,/:>/,/:=/,/::?/,/\\$/),relevance:0}},M=C({includeEqual:!0}),y=C({includeEqual:!1}),x=function(se,ue){return{begin:a(se,n(a(/\\s*/,i(/\\w/,/'/,/\\^/,/#/,/\`\`/,/\\(/,/{\\|/)))),beginScope:ue,end:n(i(/\\n/,/=/)),relevance:0,keywords:o.inherit(g,{type:p}),contains:[T,N,o.inherit(f,{scope:null}),y]}},G=x(/:/,"operator"),w=x(/\\bof\\b/,"keyword"),H={begin:[/(^|\\s+)/,/type/,/\\s+/,R],beginScope:{2:"keyword",4:"title.class"},end:n(/\\(|=|$/),keywords:g,contains:[T,o.inherit(f,{scope:null}),N,{scope:"operator",match:/<|>/},G]},j={scope:"computation-expression",match:/\\b[_a-z]\\w*(?=\\s*\\{)/},ee={begin:[/^\\s*/,a(/#/,i(...c)),/\\b/],beginScope:{2:"meta"},end:n(/\\s|$/)},V={variants:[o.BINARY_NUMBER_MODE,o.C_NUMBER_MODE]},z={scope:"string",begin:/"/,end:/"/,contains:[o.BACKSLASH_ESCAPE]},X={scope:"string",begin:/@"/,end:/"/,contains:[{match:/""/},o.BACKSLASH_ESCAPE]},q={scope:"string",begin:/"""/,end:/"""/,relevance:2},ie={scope:"subst",begin:/\\{/,end:/\\}/,keywords:g},_e={scope:"string",begin:/\\$"/,end:/"/,contains:[{match:/\\{\\{/},{match:/\\}\\}/},o.BACKSLASH_ESCAPE,ie]},de={scope:"string",begin:/(\\$@|@\\$)"/,end:/"/,contains:[{match:/\\{\\{/},{match:/\\}\\}/},{match:/""/},o.BACKSLASH_ESCAPE,ie]},Se={scope:"string",begin:/\\$"""/,end:/"""/,contains:[{match:/\\{\\{/},{match:/\\}\\}/},ie],relevance:2},ge={scope:"string",match:a(/'/,i(/[^\\\\']/,/\\\\(?:.|\\d{3}|x[a-fA-F\\d]{2}|u[a-fA-F\\d]{4}|U[a-fA-F\\d]{8})/),/'/)};return ie.contains=[de,_e,X,z,ge,l,T,f,G,j,ee,V,N,M],{name:"F#",aliases:["fs","f#"],keywords:g,illegal:/\\/\\*/,classNameAliases:{"computation-expression":"keyword"},contains:[l,{variants:[Se,de,_e,q,X,z,ge]},T,f,H,{scope:"meta",begin:/\\[</,end:/>\\]/,relevance:2,contains:[f,q,X,z,ge,V]},w,G,j,ee,V,N,M]}}return hn=s,hn}var Dn,To;function w_(){if(To)return Dn;To=1;function t(e){const n=e.regex,a={keyword:"abort acronym acronyms alias all and assign binary card diag display else eq file files for free ge gt if integer le loop lt maximizing minimizing model models ne negative no not option options or ord positive prod put putpage puttl repeat sameas semicont semiint smax smin solve sos1 sos2 sum system table then until using while xor yes",literal:"eps inf na",built_in:"abs arccos arcsin arctan arctan2 Beta betaReg binomial ceil centropy cos cosh cvPower div div0 eDist entropy errorf execSeed exp fact floor frac gamma gammaReg log logBeta logGamma log10 log2 mapVal max min mod ncpCM ncpF ncpVUpow ncpVUsin normal pi poly power randBinomial randLinear randTriangle round rPower sigmoid sign signPower sin sinh slexp sllog10 slrec sqexp sqlog10 sqr sqrec sqrt tan tanh trunc uniform uniformInt vcPower bool_and bool_eqv bool_imp bool_not bool_or bool_xor ifThen rel_eq rel_ge rel_gt rel_le rel_lt rel_ne gday gdow ghour gleap gmillisec gminute gmonth gsecond gyear jdate jnow jstart jtime errorLevel execError gamsRelease gamsVersion handleCollect handleDelete handleStatus handleSubmit heapFree heapLimit heapSize jobHandle jobKill jobStatus jobTerminate licenseLevel licenseStatus maxExecError sleep timeClose timeComp timeElapsed timeExec timeStart"},r={className:"params",begin:/\\(/,end:/\\)/,excludeBegin:!0,excludeEnd:!0},i={className:"symbol",variants:[{begin:/=[lgenxc]=/},{begin:/\\$/}]},s={className:"comment",variants:[{begin:"'",end:"'"},{begin:'"',end:'"'}],illegal:"\\\\n",contains:[e.BACKSLASH_ESCAPE]},o={begin:"/",end:"/",keywords:a,contains:[s,e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,e.QUOTE_STRING_MODE,e.APOS_STRING_MODE,e.C_NUMBER_MODE]},_=/[a-z0-9&#*=?@\\\\><:,()$[\\]_.{}!+%^-]+/,l={begin:/[a-z][a-z0-9_]*(\\([a-z0-9_, ]*\\))?[ \\t]+/,excludeBegin:!0,end:"$",endsWithParent:!0,contains:[s,o,{className:"comment",begin:n.concat(_,n.anyNumberOfTimes(n.concat(/[ ]+/,_))),relevance:0}]};return{name:"GAMS",aliases:["gms"],case_insensitive:!0,keywords:a,contains:[e.COMMENT(/^\\$ontext/,/^\\$offtext/),{className:"meta",begin:"^\\\\$[a-z0-9]+",end:"$",returnBegin:!0,contains:[{className:"keyword",begin:"^\\\\$[a-z0-9]+"}]},e.COMMENT("^\\\\*","$"),e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,e.QUOTE_STRING_MODE,e.APOS_STRING_MODE,{beginKeywords:"set sets parameter parameters variable variables scalar scalars equation equations",end:";",contains:[e.COMMENT("^\\\\*","$"),e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,e.QUOTE_STRING_MODE,e.APOS_STRING_MODE,o,l]},{beginKeywords:"table",end:";",returnBegin:!0,contains:[{beginKeywords:"table",end:"$",contains:[l]},e.COMMENT("^\\\\*","$"),e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,e.QUOTE_STRING_MODE,e.APOS_STRING_MODE,e.C_NUMBER_MODE]},{className:"function",begin:/^[a-z][a-z0-9_,\\-+' ()$]+\\.{2}/,returnBegin:!0,contains:[{className:"title",begin:/^[a-z0-9_]+/},r,i]},e.C_NUMBER_MODE,i]}}return Dn=t,Dn}var Mn,bo;function P_(){if(bo)return Mn;bo=1;function t(e){const n={keyword:"bool break call callexe checkinterrupt clear clearg closeall cls comlog compile continue create debug declare delete disable dlibrary dllcall do dos ed edit else elseif enable end endfor endif endp endo errorlog errorlogat expr external fn for format goto gosub graph if keyword let lib library line load loadarray loadexe loadf loadk loadm loadp loads loadx local locate loopnextindex lprint lpwidth lshow matrix msym ndpclex new open output outwidth plot plotsym pop prcsn print printdos proc push retp return rndcon rndmod rndmult rndseed run save saveall screen scroll setarray show sparse stop string struct system trace trap threadfor threadendfor threadbegin threadjoin threadstat threadend until use while winprint ne ge le gt lt and xor or not eq eqv",built_in:"abs acf aconcat aeye amax amean AmericanBinomCall AmericanBinomCall_Greeks AmericanBinomCall_ImpVol AmericanBinomPut AmericanBinomPut_Greeks AmericanBinomPut_ImpVol AmericanBSCall AmericanBSCall_Greeks AmericanBSCall_ImpVol AmericanBSPut AmericanBSPut_Greeks AmericanBSPut_ImpVol amin amult annotationGetDefaults annotationSetBkd annotationSetFont annotationSetLineColor annotationSetLineStyle annotationSetLineThickness annualTradingDays arccos arcsin areshape arrayalloc arrayindex arrayinit arraytomat asciiload asclabel astd astds asum atan atan2 atranspose axmargin balance band bandchol bandcholsol bandltsol bandrv bandsolpd bar base10 begwind besselj bessely beta box boxcox cdfBeta cdfBetaInv cdfBinomial cdfBinomialInv cdfBvn cdfBvn2 cdfBvn2e cdfCauchy cdfCauchyInv cdfChic cdfChii cdfChinc cdfChincInv cdfExp cdfExpInv cdfFc cdfFnc cdfFncInv cdfGam cdfGenPareto cdfHyperGeo cdfLaplace cdfLaplaceInv cdfLogistic cdfLogisticInv cdfmControlCreate cdfMvn cdfMvn2e cdfMvnce cdfMvne cdfMvt2e cdfMvtce cdfMvte cdfN cdfN2 cdfNc cdfNegBinomial cdfNegBinomialInv cdfNi cdfPoisson cdfPoissonInv cdfRayleigh cdfRayleighInv cdfTc cdfTci cdfTnc cdfTvn cdfWeibull cdfWeibullInv cdir ceil ChangeDir chdir chiBarSquare chol choldn cholsol cholup chrs close code cols colsf combinate combinated complex con cond conj cons ConScore contour conv convertsatostr convertstrtosa corrm corrms corrvc corrx corrxs cos cosh counts countwts crossprd crout croutp csrcol csrlin csvReadM csvReadSA cumprodc cumsumc curve cvtos datacreate datacreatecomplex datalist dataload dataloop dataopen datasave date datestr datestring datestrymd dayinyr dayofweek dbAddDatabase dbClose dbCommit dbCreateQuery dbExecQuery dbGetConnectOptions dbGetDatabaseName dbGetDriverName dbGetDrivers dbGetHostName dbGetLastErrorNum dbGetLastErrorText dbGetNumericalPrecPolicy dbGetPassword dbGetPort dbGetTableHeaders dbGetTables dbGetUserName dbHasFeature dbIsDriverAvailable dbIsOpen dbIsOpenError dbOpen dbQueryBindValue dbQueryClear dbQueryCols dbQueryExecPrepared dbQueryFetchAllM dbQueryFetchAllSA dbQueryFetchOneM dbQueryFetchOneSA dbQueryFinish dbQueryGetBoundValue dbQueryGetBoundValues dbQueryGetField dbQueryGetLastErrorNum dbQueryGetLastErrorText dbQueryGetLastInsertID dbQueryGetLastQuery dbQueryGetPosition dbQueryIsActive dbQueryIsForwardOnly dbQueryIsNull dbQueryIsSelect dbQueryIsValid dbQueryPrepare dbQueryRows dbQuerySeek dbQuerySeekFirst dbQuerySeekLast dbQuerySeekNext dbQuerySeekPrevious dbQuerySetForwardOnly dbRemoveDatabase dbRollback dbSetConnectOptions dbSetDatabaseName dbSetHostName dbSetNumericalPrecPolicy dbSetPort dbSetUserName dbTransaction DeleteFile delif delrows denseToSp denseToSpRE denToZero design det detl dfft dffti diag diagrv digamma doswin DOSWinCloseall DOSWinOpen dotfeq dotfeqmt dotfge dotfgemt dotfgt dotfgtmt dotfle dotflemt dotflt dotfltmt dotfne dotfnemt draw drop dsCreate dstat dstatmt dstatmtControlCreate dtdate dtday dttime dttodtv dttostr dttoutc dtvnormal dtvtodt dtvtoutc dummy dummybr dummydn eig eigh eighv eigv elapsedTradingDays endwind envget eof eqSolve eqSolvemt eqSolvemtControlCreate eqSolvemtOutCreate eqSolveset erf erfc erfccplx erfcplx error etdays ethsec etstr EuropeanBinomCall EuropeanBinomCall_Greeks EuropeanBinomCall_ImpVol EuropeanBinomPut EuropeanBinomPut_Greeks EuropeanBinomPut_ImpVol EuropeanBSCall EuropeanBSCall_Greeks EuropeanBSCall_ImpVol EuropeanBSPut EuropeanBSPut_Greeks EuropeanBSPut_ImpVol exctsmpl exec execbg exp extern eye fcheckerr fclearerr feq feqmt fflush fft ffti fftm fftmi fftn fge fgemt fgets fgetsa fgetsat fgetst fgt fgtmt fileinfo filesa fle flemt floor flt fltmt fmod fne fnemt fonts fopen formatcv formatnv fputs fputst fseek fstrerror ftell ftocv ftos ftostrC gamma gammacplx gammaii gausset gdaAppend gdaCreate gdaDStat gdaDStatMat gdaGetIndex gdaGetName gdaGetNames gdaGetOrders gdaGetType gdaGetTypes gdaGetVarInfo gdaIsCplx gdaLoad gdaPack gdaRead gdaReadByIndex gdaReadSome gdaReadSparse gdaReadStruct gdaReportVarInfo gdaSave gdaUpdate gdaUpdateAndPack gdaVars gdaWrite gdaWrite32 gdaWriteSome getarray getdims getf getGAUSShome getmatrix getmatrix4D getname getnamef getNextTradingDay getNextWeekDay getnr getorders getpath getPreviousTradingDay getPreviousWeekDay getRow getscalar3D getscalar4D getTrRow getwind glm gradcplx gradMT gradMTm gradMTT gradMTTm gradp graphprt graphset hasimag header headermt hess hessMT hessMTg hessMTgw hessMTm hessMTmw hessMTT hessMTTg hessMTTgw hessMTTm hessMTw hessp hist histf histp hsec imag indcv indexcat indices indices2 indicesf indicesfn indnv indsav integrate1d integrateControlCreate intgrat2 intgrat3 inthp1 inthp2 inthp3 inthp4 inthpControlCreate intquad1 intquad2 intquad3 intrleav intrleavsa intrsect intsimp inv invpd invswp iscplx iscplxf isden isinfnanmiss ismiss key keyav keyw lag lag1 lagn lapEighb lapEighi lapEighvb lapEighvi lapgEig lapgEigh lapgEighv lapgEigv lapgSchur lapgSvdcst lapgSvds lapgSvdst lapSvdcusv lapSvds lapSvdusv ldlp ldlsol linSolve listwise ln lncdfbvn lncdfbvn2 lncdfmvn lncdfn lncdfn2 lncdfnc lnfact lngammacplx lnpdfmvn lnpdfmvt lnpdfn lnpdft loadd loadstruct loadwind loess loessmt loessmtControlCreate log loglog logx logy lower lowmat lowmat1 ltrisol lu lusol machEpsilon make makevars makewind margin matalloc matinit mattoarray maxbytes maxc maxindc maxv maxvec mbesselei mbesselei0 mbesselei1 mbesseli mbesseli0 mbesseli1 meanc median mergeby mergevar minc minindc minv miss missex missrv moment momentd movingave movingaveExpwgt movingaveWgt nextindex nextn nextnevn nextwind ntos null null1 numCombinations ols olsmt olsmtControlCreate olsqr olsqr2 olsqrmt ones optn optnevn orth outtyp pacf packedToSp packr parse pause pdfCauchy pdfChi pdfExp pdfGenPareto pdfHyperGeo pdfLaplace pdfLogistic pdfn pdfPoisson pdfRayleigh pdfWeibull pi pinv pinvmt plotAddArrow plotAddBar plotAddBox plotAddHist plotAddHistF plotAddHistP plotAddPolar plotAddScatter plotAddShape plotAddTextbox plotAddTS plotAddXY plotArea plotBar plotBox plotClearLayout plotContour plotCustomLayout plotGetDefaults plotHist plotHistF plotHistP plotLayout plotLogLog plotLogX plotLogY plotOpenWindow plotPolar plotSave plotScatter plotSetAxesPen plotSetBar plotSetBarFill plotSetBarStacked plotSetBkdColor plotSetFill plotSetGrid plotSetLegend plotSetLineColor plotSetLineStyle plotSetLineSymbol plotSetLineThickness plotSetNewWindow plotSetTitle plotSetWhichYAxis plotSetXAxisShow plotSetXLabel plotSetXRange plotSetXTicInterval plotSetXTicLabel plotSetYAxisShow plotSetYLabel plotSetYRange plotSetZAxisShow plotSetZLabel plotSurface plotTS plotXY polar polychar polyeval polygamma polyint polymake polymat polymroot polymult polyroot pqgwin previousindex princomp printfm printfmt prodc psi putarray putf putvals pvCreate pvGetIndex pvGetParNames pvGetParVector pvLength pvList pvPack pvPacki pvPackm pvPackmi pvPacks pvPacksi pvPacksm pvPacksmi pvPutParVector pvTest pvUnpack QNewton QNewtonmt QNewtonmtControlCreate QNewtonmtOutCreate QNewtonSet QProg QProgmt QProgmtInCreate qqr qqre qqrep qr qre qrep qrsol qrtsol qtyr qtyre qtyrep quantile quantiled qyr qyre qyrep qz rank rankindx readr real reclassify reclassifyCuts recode recserar recsercp recserrc rerun rescale reshape rets rev rfft rffti rfftip rfftn rfftnp rfftp rndBernoulli rndBeta rndBinomial rndCauchy rndChiSquare rndCon rndCreateState rndExp rndGamma rndGeo rndGumbel rndHyperGeo rndi rndKMbeta rndKMgam rndKMi rndKMn rndKMnb rndKMp rndKMu rndKMvm rndLaplace rndLCbeta rndLCgam rndLCi rndLCn rndLCnb rndLCp rndLCu rndLCvm rndLogNorm rndMTu rndMVn rndMVt rndn rndnb rndNegBinomial rndp rndPoisson rndRayleigh rndStateSkip rndu rndvm rndWeibull rndWishart rotater round rows rowsf rref sampleData satostrC saved saveStruct savewind scale scale3d scalerr scalinfnanmiss scalmiss schtoc schur searchsourcepath seekr select selif seqa seqm setdif setdifsa setvars setvwrmode setwind shell shiftr sin singleindex sinh sleep solpd sortc sortcc sortd sorthc sorthcc sortind sortindc sortmc sortr sortrc spBiconjGradSol spChol spConjGradSol spCreate spDenseSubmat spDiagRvMat spEigv spEye spLDL spline spLU spNumNZE spOnes spreadSheetReadM spreadSheetReadSA spreadSheetWrite spScale spSubmat spToDense spTrTDense spTScalar spZeros sqpSolve sqpSolveMT sqpSolveMTControlCreate sqpSolveMTlagrangeCreate sqpSolveMToutCreate sqpSolveSet sqrt statements stdc stdsc stocv stof strcombine strindx strlen strput strrindx strsect strsplit strsplitPad strtodt strtof strtofcplx strtriml strtrimr strtrunc strtruncl strtruncpad strtruncr submat subscat substute subvec sumc sumr surface svd svd1 svd2 svdcusv svds svdusv sysstate tab tan tanh tempname time timedt timestr timeutc title tkf2eps tkf2ps tocart todaydt toeplitz token topolar trapchk trigamma trimr trunc type typecv typef union unionsa uniqindx uniqindxsa unique uniquesa upmat upmat1 upper utctodt utctodtv utrisol vals varCovMS varCovXS varget vargetl varmall varmares varput varputl vartypef vcm vcms vcx vcxs vec vech vecr vector vget view viewxyz vlist vnamecv volume vput vread vtypecv wait waitc walkindex where window writer xlabel xlsGetSheetCount xlsGetSheetSize xlsGetSheetTypes xlsMakeRange xlsReadM xlsReadSA xlsWrite xlsWriteM xlsWriteSA xpnd xtics xy xyz ylabel ytics zeros zeta zlabel ztics cdfEmpirical dot h5create h5open h5read h5readAttribute h5write h5writeAttribute ldl plotAddErrorBar plotAddSurface plotCDFEmpirical plotSetColormap plotSetContourLabels plotSetLegendFont plotSetTextInterpreter plotSetXTicCount plotSetYTicCount plotSetZLevels powerm strjoin sylvester strtrim",literal:"DB_AFTER_LAST_ROW DB_ALL_TABLES DB_BATCH_OPERATIONS DB_BEFORE_FIRST_ROW DB_BLOB DB_EVENT_NOTIFICATIONS DB_FINISH_QUERY DB_HIGH_PRECISION DB_LAST_INSERT_ID DB_LOW_PRECISION_DOUBLE DB_LOW_PRECISION_INT32 DB_LOW_PRECISION_INT64 DB_LOW_PRECISION_NUMBERS DB_MULTIPLE_RESULT_SETS DB_NAMED_PLACEHOLDERS DB_POSITIONAL_PLACEHOLDERS DB_PREPARED_QUERIES DB_QUERY_SIZE DB_SIMPLE_LOCKING DB_SYSTEM_TABLES DB_TABLES DB_TRANSACTIONS DB_UNICODE DB_VIEWS __STDIN __STDOUT __STDERR __FILE_DIR"},a=e.COMMENT("@","@"),r={className:"meta",begin:"#",end:"$",keywords:{keyword:"define definecs|10 undef ifdef ifndef iflight ifdllcall ifmac ifos2win ifunix else endif lineson linesoff srcfile srcline"},contains:[{begin:/\\\\\\n/,relevance:0},{beginKeywords:"include",end:"$",keywords:{keyword:"include"},contains:[{className:"string",begin:'"',end:'"',illegal:"\\\\n"}]},e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,a]},i={begin:/\\bstruct\\s+/,end:/\\s/,keywords:"struct",contains:[{className:"type",begin:e.UNDERSCORE_IDENT_RE,relevance:0}]},s=[{className:"params",begin:/\\(/,end:/\\)/,excludeBegin:!0,excludeEnd:!0,endsWithParent:!0,relevance:0,contains:[{className:"literal",begin:/\\.\\.\\./},e.C_NUMBER_MODE,e.C_BLOCK_COMMENT_MODE,a,i]}],o={className:"title",begin:e.UNDERSCORE_IDENT_RE,relevance:0},_=function(p,E,g){const S=e.inherit({className:"function",beginKeywords:p,end:E,excludeEnd:!0,contains:[].concat(s)},{});return S.contains.push(o),S.contains.push(e.C_NUMBER_MODE),S.contains.push(e.C_BLOCK_COMMENT_MODE),S.contains.push(a),S},l={className:"built_in",begin:"\\\\b("+n.built_in.split(" ").join("|")+")\\\\b"},c={className:"string",begin:'"',end:'"',contains:[e.BACKSLASH_ESCAPE],relevance:0},d={begin:e.UNDERSCORE_IDENT_RE+"\\\\s*\\\\(",returnBegin:!0,keywords:n,relevance:0,contains:[{beginKeywords:n.keyword},l,{className:"built_in",begin:e.UNDERSCORE_IDENT_RE,relevance:0}]},m={begin:/\\(/,end:/\\)/,relevance:0,keywords:{built_in:n.built_in,literal:n.literal},contains:[e.C_NUMBER_MODE,e.C_BLOCK_COMMENT_MODE,a,l,d,c,"self"]};return d.contains.push(m),{name:"GAUSS",aliases:["gss"],case_insensitive:!0,keywords:n,illegal:/(\\{[%#]|[%#]\\}| <- )/,contains:[e.C_NUMBER_MODE,e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,a,c,r,{className:"keyword",begin:/\\bexternal (matrix|string|array|sparse matrix|struct|proc|keyword|fn)/},_("proc keyword",";"),_("fn","="),{beginKeywords:"for threadfor",end:/;/,relevance:0,contains:[e.C_BLOCK_COMMENT_MODE,a,m]},{variants:[{begin:e.UNDERSCORE_IDENT_RE+"\\\\."+e.UNDERSCORE_IDENT_RE},{begin:e.UNDERSCORE_IDENT_RE+"\\\\s*="}],relevance:0},d,i]}}return Mn=t,Mn}var Ln,Ro;function k_(){if(Ro)return Ln;Ro=1;function t(e){const n=e.regex,a={$pattern:/[A-Z]+|%/,keyword:["THEN","ELSE","ENDIF","IF","GOTO","DO","WHILE","WH","END","CALL","SUB","ENDSUB","EQ","NE","LT","GT","LE","GE","AND","OR","XOR","%"],built_in:["ATAN","ABS","ACOS","ASIN","COS","EXP","FIX","FUP","ROUND","LN","SIN","SQRT","TAN","EXISTS"]},r=/\\b/;function i(E,g){if(E.index===0)return;const S=E.input[E.index-1];S>="0"&&S<="9"||S!=="_"&&g.ignoreMatch()}const s=/[+-]?((\\.\\d+)|(\\d+)(\\.\\d*)?)/,o=/[GM]\\s*\\d+(\\.\\d+)?/,_=/T\\s*\\d+/,l=/O\\s*\\d+/,c=/O<.+>/,d=/[ABCUVWXYZ]\\s*/,m=/[FHIJKPQRS]\\s*/,p=[e.COMMENT(/\\(/,/\\)/),e.COMMENT(/;/,/$/),e.APOS_STRING_MODE,e.QUOTE_STRING_MODE,e.C_NUMBER_MODE,{scope:"title.function",variants:[{match:n.concat(r,o)},{begin:o,"on:begin":i},{match:n.concat(r,_)},{begin:_,"on:begin":i}]},{scope:"symbol",variants:[{match:n.concat(r,l)},{begin:l,"on:begin":i},{match:n.concat(r,c)},{begin:c,"on:begin":i},{match:/\\*\\s*\\d+\\s*$/}]},{scope:"operator",match:/^N\\s*\\d+/},{scope:"variable",match:/-?#\\s*\\d+/},{scope:"property",variants:[{match:n.concat(r,d,s)},{begin:n.concat(d,s),"on:begin":i}]},{scope:"params",variants:[{match:n.concat(r,m,s)},{begin:n.concat(m,s),"on:begin":i}]}];return{name:"G-code (ISO 6983)",aliases:["nc"],case_insensitive:!0,disableAutodetect:!0,keywords:a,contains:p}}return Ln=t,Ln}var xn,fo;function U_(){if(fo)return xn;fo=1;function t(e){return{name:"Gherkin",aliases:["feature"],keywords:"Feature Background Ability Business Need Scenario Scenarios Scenario Outline Scenario Template Examples Given And Then But When",contains:[{className:"symbol",begin:"\\\\*",relevance:0},{className:"meta",begin:"@[^@\\\\s]+"},{begin:"\\\\|",end:"\\\\|\\\\w*$",contains:[{className:"string",begin:"[^|]+"}]},{className:"variable",begin:"<",end:">"},e.HASH_COMMENT_MODE,{className:"string",begin:'"""',end:'"""'},e.QUOTE_STRING_MODE]}}return xn=t,xn}var wn,Co;function F_(){if(Co)return wn;Co=1;function t(e){return{name:"GLSL",keywords:{keyword:"break continue discard do else for if return while switch case default attribute binding buffer ccw centroid centroid varying coherent column_major const cw depth_any depth_greater depth_less depth_unchanged early_fragment_tests equal_spacing flat fractional_even_spacing fractional_odd_spacing highp in index inout invariant invocations isolines layout line_strip lines lines_adjacency local_size_x local_size_y local_size_z location lowp max_vertices mediump noperspective offset origin_upper_left out packed patch pixel_center_integer point_mode points precise precision quads r11f_g11f_b10f r16 r16_snorm r16f r16i r16ui r32f r32i r32ui r8 r8_snorm r8i r8ui readonly restrict rg16 rg16_snorm rg16f rg16i rg16ui rg32f rg32i rg32ui rg8 rg8_snorm rg8i rg8ui rgb10_a2 rgb10_a2ui rgba16 rgba16_snorm rgba16f rgba16i rgba16ui rgba32f rgba32i rgba32ui rgba8 rgba8_snorm rgba8i rgba8ui row_major sample shared smooth std140 std430 stream triangle_strip triangles triangles_adjacency uniform varying vertices volatile writeonly",type:"atomic_uint bool bvec2 bvec3 bvec4 dmat2 dmat2x2 dmat2x3 dmat2x4 dmat3 dmat3x2 dmat3x3 dmat3x4 dmat4 dmat4x2 dmat4x3 dmat4x4 double dvec2 dvec3 dvec4 float iimage1D iimage1DArray iimage2D iimage2DArray iimage2DMS iimage2DMSArray iimage2DRect iimage3D iimageBuffer iimageCube iimageCubeArray image1D image1DArray image2D image2DArray image2DMS image2DMSArray image2DRect image3D imageBuffer imageCube imageCubeArray int isampler1D isampler1DArray isampler2D isampler2DArray isampler2DMS isampler2DMSArray isampler2DRect isampler3D isamplerBuffer isamplerCube isamplerCubeArray ivec2 ivec3 ivec4 mat2 mat2x2 mat2x3 mat2x4 mat3 mat3x2 mat3x3 mat3x4 mat4 mat4x2 mat4x3 mat4x4 sampler1D sampler1DArray sampler1DArrayShadow sampler1DShadow sampler2D sampler2DArray sampler2DArrayShadow sampler2DMS sampler2DMSArray sampler2DRect sampler2DRectShadow sampler2DShadow sampler3D samplerBuffer samplerCube samplerCubeArray samplerCubeArrayShadow samplerCubeShadow image1D uimage1DArray uimage2D uimage2DArray uimage2DMS uimage2DMSArray uimage2DRect uimage3D uimageBuffer uimageCube uimageCubeArray uint usampler1D usampler1DArray usampler2D usampler2DArray usampler2DMS usampler2DMSArray usampler2DRect usampler3D samplerBuffer usamplerCube usamplerCubeArray uvec2 uvec3 uvec4 vec2 vec3 vec4 void",built_in:"gl_MaxAtomicCounterBindings gl_MaxAtomicCounterBufferSize gl_MaxClipDistances gl_MaxClipPlanes gl_MaxCombinedAtomicCounterBuffers gl_MaxCombinedAtomicCounters gl_MaxCombinedImageUniforms gl_MaxCombinedImageUnitsAndFragmentOutputs gl_MaxCombinedTextureImageUnits gl_MaxComputeAtomicCounterBuffers gl_MaxComputeAtomicCounters gl_MaxComputeImageUniforms gl_MaxComputeTextureImageUnits gl_MaxComputeUniformComponents gl_MaxComputeWorkGroupCount gl_MaxComputeWorkGroupSize gl_MaxDrawBuffers gl_MaxFragmentAtomicCounterBuffers gl_MaxFragmentAtomicCounters gl_MaxFragmentImageUniforms gl_MaxFragmentInputComponents gl_MaxFragmentInputVectors gl_MaxFragmentUniformComponents gl_MaxFragmentUniformVectors gl_MaxGeometryAtomicCounterBuffers gl_MaxGeometryAtomicCounters gl_MaxGeometryImageUniforms gl_MaxGeometryInputComponents gl_MaxGeometryOutputComponents gl_MaxGeometryOutputVertices gl_MaxGeometryTextureImageUnits gl_MaxGeometryTotalOutputComponents gl_MaxGeometryUniformComponents gl_MaxGeometryVaryingComponents gl_MaxImageSamples gl_MaxImageUnits gl_MaxLights gl_MaxPatchVertices gl_MaxProgramTexelOffset gl_MaxTessControlAtomicCounterBuffers gl_MaxTessControlAtomicCounters gl_MaxTessControlImageUniforms gl_MaxTessControlInputComponents gl_MaxTessControlOutputComponents gl_MaxTessControlTextureImageUnits gl_MaxTessControlTotalOutputComponents gl_MaxTessControlUniformComponents gl_MaxTessEvaluationAtomicCounterBuffers gl_MaxTessEvaluationAtomicCounters gl_MaxTessEvaluationImageUniforms gl_MaxTessEvaluationInputComponents gl_MaxTessEvaluationOutputComponents gl_MaxTessEvaluationTextureImageUnits gl_MaxTessEvaluationUniformComponents gl_MaxTessGenLevel gl_MaxTessPatchComponents gl_MaxTextureCoords gl_MaxTextureImageUnits gl_MaxTextureUnits gl_MaxVaryingComponents gl_MaxVaryingFloats gl_MaxVaryingVectors gl_MaxVertexAtomicCounterBuffers gl_MaxVertexAtomicCounters gl_MaxVertexAttribs gl_MaxVertexImageUniforms gl_MaxVertexOutputComponents gl_MaxVertexOutputVectors gl_MaxVertexTextureImageUnits gl_MaxVertexUniformComponents gl_MaxVertexUniformVectors gl_MaxViewports gl_MinProgramTexelOffset gl_BackColor gl_BackLightModelProduct gl_BackLightProduct gl_BackMaterial gl_BackSecondaryColor gl_ClipDistance gl_ClipPlane gl_ClipVertex gl_Color gl_DepthRange gl_EyePlaneQ gl_EyePlaneR gl_EyePlaneS gl_EyePlaneT gl_Fog gl_FogCoord gl_FogFragCoord gl_FragColor gl_FragCoord gl_FragData gl_FragDepth gl_FrontColor gl_FrontFacing gl_FrontLightModelProduct gl_FrontLightProduct gl_FrontMaterial gl_FrontSecondaryColor gl_GlobalInvocationID gl_InstanceID gl_InvocationID gl_Layer gl_LightModel gl_LightSource gl_LocalInvocationID gl_LocalInvocationIndex gl_ModelViewMatrix gl_ModelViewMatrixInverse gl_ModelViewMatrixInverseTranspose gl_ModelViewMatrixTranspose gl_ModelViewProjectionMatrix gl_ModelViewProjectionMatrixInverse gl_ModelViewProjectionMatrixInverseTranspose gl_ModelViewProjectionMatrixTranspose gl_MultiTexCoord0 gl_MultiTexCoord1 gl_MultiTexCoord2 gl_MultiTexCoord3 gl_MultiTexCoord4 gl_MultiTexCoord5 gl_MultiTexCoord6 gl_MultiTexCoord7 gl_Normal gl_NormalMatrix gl_NormalScale gl_NumSamples gl_NumWorkGroups gl_ObjectPlaneQ gl_ObjectPlaneR gl_ObjectPlaneS gl_ObjectPlaneT gl_PatchVerticesIn gl_Point gl_PointCoord gl_PointSize gl_Position gl_PrimitiveID gl_PrimitiveIDIn gl_ProjectionMatrix gl_ProjectionMatrixInverse gl_ProjectionMatrixInverseTranspose gl_ProjectionMatrixTranspose gl_SampleID gl_SampleMask gl_SampleMaskIn gl_SamplePosition gl_SecondaryColor gl_TessCoord gl_TessLevelInner gl_TessLevelOuter gl_TexCoord gl_TextureEnvColor gl_TextureMatrix gl_TextureMatrixInverse gl_TextureMatrixInverseTranspose gl_TextureMatrixTranspose gl_Vertex gl_VertexID gl_ViewportIndex gl_WorkGroupID gl_WorkGroupSize gl_in gl_out EmitStreamVertex EmitVertex EndPrimitive EndStreamPrimitive abs acos acosh all any asin asinh atan atanh atomicAdd atomicAnd atomicCompSwap atomicCounter atomicCounterDecrement atomicCounterIncrement atomicExchange atomicMax atomicMin atomicOr atomicXor barrier bitCount bitfieldExtract bitfieldInsert bitfieldReverse ceil clamp cos cosh cross dFdx dFdy degrees determinant distance dot equal exp exp2 faceforward findLSB findMSB floatBitsToInt floatBitsToUint floor fma fract frexp ftransform fwidth greaterThan greaterThanEqual groupMemoryBarrier imageAtomicAdd imageAtomicAnd imageAtomicCompSwap imageAtomicExchange imageAtomicMax imageAtomicMin imageAtomicOr imageAtomicXor imageLoad imageSize imageStore imulExtended intBitsToFloat interpolateAtCentroid interpolateAtOffset interpolateAtSample inverse inversesqrt isinf isnan ldexp length lessThan lessThanEqual log log2 matrixCompMult max memoryBarrier memoryBarrierAtomicCounter memoryBarrierBuffer memoryBarrierImage memoryBarrierShared min mix mod modf noise1 noise2 noise3 noise4 normalize not notEqual outerProduct packDouble2x32 packHalf2x16 packSnorm2x16 packSnorm4x8 packUnorm2x16 packUnorm4x8 pow radians reflect refract round roundEven shadow1D shadow1DLod shadow1DProj shadow1DProjLod shadow2D shadow2DLod shadow2DProj shadow2DProjLod sign sin sinh smoothstep sqrt step tan tanh texelFetch texelFetchOffset texture texture1D texture1DLod texture1DProj texture1DProjLod texture2D texture2DLod texture2DProj texture2DProjLod texture3D texture3DLod texture3DProj texture3DProjLod textureCube textureCubeLod textureGather textureGatherOffset textureGatherOffsets textureGrad textureGradOffset textureLod textureLodOffset textureOffset textureProj textureProjGrad textureProjGradOffset textureProjLod textureProjLodOffset textureProjOffset textureQueryLevels textureQueryLod textureSize transpose trunc uaddCarry uintBitsToFloat umulExtended unpackDouble2x32 unpackHalf2x16 unpackSnorm2x16 unpackSnorm4x8 unpackUnorm2x16 unpackUnorm4x8 usubBorrow",literal:"true false"},illegal:'"',contains:[e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,e.C_NUMBER_MODE,{className:"meta",begin:"#",end:"$"}]}}return wn=t,wn}var Pn,No;function B_(){if(No)return Pn;No=1;function t(e){return{name:"GML",case_insensitive:!1,keywords:{keyword:["#endregion","#macro","#region","and","begin","break","case","constructor","continue","default","delete","div","do","else","end","enum","exit","for","function","globalvar","if","mod","new","not","or","repeat","return","static","switch","then","until","var","while","with","xor"],built_in:["abs","alarm_get","alarm_set","angle_difference","animcurve_channel_evaluate","animcurve_channel_new","animcurve_create","animcurve_destroy","animcurve_exists","animcurve_get","animcurve_get_channel","animcurve_get_channel_index","animcurve_point_new","ansi_char","application_get_position","application_surface_draw_enable","application_surface_enable","application_surface_is_enabled","arccos","arcsin","arctan","arctan2","array_all","array_any","array_concat","array_contains","array_contains_ext","array_copy","array_copy_while","array_create","array_create_ext","array_delete","array_equals","array_filter","array_filter_ext","array_find_index","array_first","array_foreach","array_get","array_get_index","array_insert","array_intersection","array_last","array_length","array_map","array_map_ext","array_pop","array_push","array_reduce","array_resize","array_reverse","array_reverse_ext","array_set","array_shuffle","array_shuffle_ext","array_sort","array_union","array_unique","array_unique_ext","asset_add_tags","asset_clear_tags","asset_get_ids","asset_get_index","asset_get_tags","asset_get_type","asset_has_any_tag","asset_has_tags","asset_remove_tags","audio_bus_clear_emitters","audio_bus_create","audio_bus_get_emitters","audio_channel_num","audio_create_buffer_sound","audio_create_play_queue","audio_create_stream","audio_create_sync_group","audio_debug","audio_destroy_stream","audio_destroy_sync_group","audio_effect_create","audio_emitter_bus","audio_emitter_create","audio_emitter_exists","audio_emitter_falloff","audio_emitter_free","audio_emitter_gain","audio_emitter_get_bus","audio_emitter_get_gain","audio_emitter_get_listener_mask","audio_emitter_get_pitch","audio_emitter_get_vx","audio_emitter_get_vy","audio_emitter_get_vz","audio_emitter_get_x","audio_emitter_get_y","audio_emitter_get_z","audio_emitter_pitch","audio_emitter_position","audio_emitter_set_listener_mask","audio_emitter_velocity","audio_exists","audio_falloff_set_model","audio_free_buffer_sound","audio_free_play_queue","audio_get_listener_count","audio_get_listener_info","audio_get_listener_mask","audio_get_master_gain","audio_get_name","audio_get_recorder_count","audio_get_recorder_info","audio_get_type","audio_group_get_assets","audio_group_get_gain","audio_group_is_loaded","audio_group_load","audio_group_load_progress","audio_group_name","audio_group_set_gain","audio_group_stop_all","audio_group_unload","audio_is_paused","audio_is_playing","audio_listener_get_data","audio_listener_orientation","audio_listener_position","audio_listener_set_orientation","audio_listener_set_position","audio_listener_set_velocity","audio_listener_velocity","audio_master_gain","audio_pause_all","audio_pause_sound","audio_pause_sync_group","audio_play_in_sync_group","audio_play_sound","audio_play_sound_at","audio_play_sound_ext","audio_play_sound_on","audio_queue_sound","audio_resume_all","audio_resume_sound","audio_resume_sync_group","audio_set_listener_mask","audio_set_master_gain","audio_sound_gain","audio_sound_get_audio_group","audio_sound_get_gain","audio_sound_get_listener_mask","audio_sound_get_loop","audio_sound_get_loop_end","audio_sound_get_loop_start","audio_sound_get_pitch","audio_sound_get_track_position","audio_sound_is_playable","audio_sound_length","audio_sound_loop","audio_sound_loop_end","audio_sound_loop_start","audio_sound_pitch","audio_sound_set_listener_mask","audio_sound_set_track_position","audio_start_recording","audio_start_sync_group","audio_stop_all","audio_stop_recording","audio_stop_sound","audio_stop_sync_group","audio_sync_group_debug","audio_sync_group_get_track_pos","audio_sync_group_is_paused","audio_sync_group_is_playing","audio_system_is_available","audio_system_is_initialised","base64_decode","base64_encode","bool","browser_input_capture","buffer_async_group_begin","buffer_async_group_end","buffer_async_group_option","buffer_base64_decode","buffer_base64_decode_ext","buffer_base64_encode","buffer_compress","buffer_copy","buffer_copy_from_vertex_buffer","buffer_copy_stride","buffer_crc32","buffer_create","buffer_create_from_vertex_buffer","buffer_create_from_vertex_buffer_ext","buffer_decompress","buffer_delete","buffer_exists","buffer_fill","buffer_get_address","buffer_get_alignment","buffer_get_size","buffer_get_surface","buffer_get_type","buffer_load","buffer_load_async","buffer_load_ext","buffer_load_partial","buffer_md5","buffer_peek","buffer_poke","buffer_read","buffer_resize","buffer_save","buffer_save_async","buffer_save_ext","buffer_seek","buffer_set_surface","buffer_set_used_size","buffer_sha1","buffer_sizeof","buffer_tell","buffer_write","call_cancel","call_later","camera_apply","camera_copy_transforms","camera_create","camera_create_view","camera_destroy","camera_get_active","camera_get_begin_script","camera_get_default","camera_get_end_script","camera_get_proj_mat","camera_get_update_script","camera_get_view_angle","camera_get_view_border_x","camera_get_view_border_y","camera_get_view_height","camera_get_view_mat","camera_get_view_speed_x","camera_get_view_speed_y","camera_get_view_target","camera_get_view_width","camera_get_view_x","camera_get_view_y","camera_set_begin_script","camera_set_default","camera_set_end_script","camera_set_proj_mat","camera_set_update_script","camera_set_view_angle","camera_set_view_border","camera_set_view_mat","camera_set_view_pos","camera_set_view_size","camera_set_view_speed","camera_set_view_target","ceil","choose","chr","clamp","clickable_add","clickable_add_ext","clickable_change","clickable_change_ext","clickable_delete","clickable_exists","clickable_set_style","clipboard_get_text","clipboard_has_text","clipboard_set_text","cloud_file_save","cloud_string_save","cloud_synchronise","code_is_compiled","collision_circle","collision_circle_list","collision_ellipse","collision_ellipse_list","collision_line","collision_line_list","collision_point","collision_point_list","collision_rectangle","collision_rectangle_list","color_get_blue","color_get_green","color_get_hue","color_get_red","color_get_saturation","color_get_value","colour_get_blue","colour_get_green","colour_get_hue","colour_get_red","colour_get_saturation","colour_get_value","cos","darccos","darcsin","darctan","darctan2","date_compare_date","date_compare_datetime","date_compare_time","date_create_datetime","date_current_datetime","date_date_of","date_date_string","date_datetime_string","date_day_span","date_days_in_month","date_days_in_year","date_get_day","date_get_day_of_year","date_get_hour","date_get_hour_of_year","date_get_minute","date_get_minute_of_year","date_get_month","date_get_second","date_get_second_of_year","date_get_timezone","date_get_week","date_get_weekday","date_get_year","date_hour_span","date_inc_day","date_inc_hour","date_inc_minute","date_inc_month","date_inc_second","date_inc_week","date_inc_year","date_is_today","date_leap_year","date_minute_span","date_month_span","date_second_span","date_set_timezone","date_time_of","date_time_string","date_valid_datetime","date_week_span","date_year_span","db_to_lin","dbg_add_font_glyphs","dbg_button","dbg_checkbox","dbg_color","dbg_colour","dbg_drop_down","dbg_same_line","dbg_section","dbg_section_delete","dbg_section_exists","dbg_slider","dbg_slider_int","dbg_sprite","dbg_text","dbg_text_input","dbg_view","dbg_view_delete","dbg_view_exists","dbg_watch","dcos","debug_event","debug_get_callstack","degtorad","device_get_tilt_x","device_get_tilt_y","device_get_tilt_z","device_is_keypad_open","device_mouse_check_button","device_mouse_check_button_pressed","device_mouse_check_button_released","device_mouse_dbclick_enable","device_mouse_raw_x","device_mouse_raw_y","device_mouse_x","device_mouse_x_to_gui","device_mouse_y","device_mouse_y_to_gui","directory_create","directory_destroy","directory_exists","display_get_dpi_x","display_get_dpi_y","display_get_frequency","display_get_gui_height","display_get_gui_width","display_get_height","display_get_orientation","display_get_sleep_margin","display_get_timing_method","display_get_width","display_mouse_get_x","display_mouse_get_y","display_mouse_set","display_reset","display_set_gui_maximise","display_set_gui_maximize","display_set_gui_size","display_set_sleep_margin","display_set_timing_method","display_set_ui_visibility","distance_to_object","distance_to_point","dot_product","dot_product_3d","dot_product_3d_normalised","dot_product_3d_normalized","dot_product_normalised","dot_product_normalized","draw_arrow","draw_button","draw_circle","draw_circle_color","draw_circle_colour","draw_clear","draw_clear_alpha","draw_ellipse","draw_ellipse_color","draw_ellipse_colour","draw_enable_drawevent","draw_enable_skeleton_blendmodes","draw_enable_swf_aa","draw_flush","draw_get_alpha","draw_get_color","draw_get_colour","draw_get_enable_skeleton_blendmodes","draw_get_font","draw_get_halign","draw_get_lighting","draw_get_swf_aa_level","draw_get_valign","draw_getpixel","draw_getpixel_ext","draw_healthbar","draw_highscore","draw_light_define_ambient","draw_light_define_direction","draw_light_define_point","draw_light_enable","draw_light_get","draw_light_get_ambient","draw_line","draw_line_color","draw_line_colour","draw_line_width","draw_line_width_color","draw_line_width_colour","draw_path","draw_point","draw_point_color","draw_point_colour","draw_primitive_begin","draw_primitive_begin_texture","draw_primitive_end","draw_rectangle","draw_rectangle_color","draw_rectangle_colour","draw_roundrect","draw_roundrect_color","draw_roundrect_color_ext","draw_roundrect_colour","draw_roundrect_colour_ext","draw_roundrect_ext","draw_self","draw_set_alpha","draw_set_circle_precision","draw_set_color","draw_set_colour","draw_set_font","draw_set_halign","draw_set_lighting","draw_set_swf_aa_level","draw_set_valign","draw_skeleton","draw_skeleton_collision","draw_skeleton_instance","draw_skeleton_time","draw_sprite","draw_sprite_ext","draw_sprite_general","draw_sprite_part","draw_sprite_part_ext","draw_sprite_pos","draw_sprite_stretched","draw_sprite_stretched_ext","draw_sprite_tiled","draw_sprite_tiled_ext","draw_surface","draw_surface_ext","draw_surface_general","draw_surface_part","draw_surface_part_ext","draw_surface_stretched","draw_surface_stretched_ext","draw_surface_tiled","draw_surface_tiled_ext","draw_text","draw_text_color","draw_text_colour","draw_text_ext","draw_text_ext_color","draw_text_ext_colour","draw_text_ext_transformed","draw_text_ext_transformed_color","draw_text_ext_transformed_colour","draw_text_transformed","draw_text_transformed_color","draw_text_transformed_colour","draw_texture_flush","draw_tile","draw_tilemap","draw_triangle","draw_triangle_color","draw_triangle_colour","draw_vertex","draw_vertex_color","draw_vertex_colour","draw_vertex_texture","draw_vertex_texture_color","draw_vertex_texture_colour","ds_exists","ds_grid_add","ds_grid_add_disk","ds_grid_add_grid_region","ds_grid_add_region","ds_grid_clear","ds_grid_copy","ds_grid_create","ds_grid_destroy","ds_grid_get","ds_grid_get_disk_max","ds_grid_get_disk_mean","ds_grid_get_disk_min","ds_grid_get_disk_sum","ds_grid_get_max","ds_grid_get_mean","ds_grid_get_min","ds_grid_get_sum","ds_grid_height","ds_grid_multiply","ds_grid_multiply_disk","ds_grid_multiply_grid_region","ds_grid_multiply_region","ds_grid_read","ds_grid_resize","ds_grid_set","ds_grid_set_disk","ds_grid_set_grid_region","ds_grid_set_region","ds_grid_shuffle","ds_grid_sort","ds_grid_to_mp_grid","ds_grid_value_disk_exists","ds_grid_value_disk_x","ds_grid_value_disk_y","ds_grid_value_exists","ds_grid_value_x","ds_grid_value_y","ds_grid_width","ds_grid_write","ds_list_add","ds_list_clear","ds_list_copy","ds_list_create","ds_list_delete","ds_list_destroy","ds_list_empty","ds_list_find_index","ds_list_find_value","ds_list_insert","ds_list_is_list","ds_list_is_map","ds_list_mark_as_list","ds_list_mark_as_map","ds_list_read","ds_list_replace","ds_list_set","ds_list_shuffle","ds_list_size","ds_list_sort","ds_list_write","ds_map_add","ds_map_add_list","ds_map_add_map","ds_map_clear","ds_map_copy","ds_map_create","ds_map_delete","ds_map_destroy","ds_map_empty","ds_map_exists","ds_map_find_first","ds_map_find_last","ds_map_find_next","ds_map_find_previous","ds_map_find_value","ds_map_is_list","ds_map_is_map","ds_map_keys_to_array","ds_map_read","ds_map_replace","ds_map_replace_list","ds_map_replace_map","ds_map_secure_load","ds_map_secure_load_buffer","ds_map_secure_save","ds_map_secure_save_buffer","ds_map_set","ds_map_size","ds_map_values_to_array","ds_map_write","ds_priority_add","ds_priority_change_priority","ds_priority_clear","ds_priority_copy","ds_priority_create","ds_priority_delete_max","ds_priority_delete_min","ds_priority_delete_value","ds_priority_destroy","ds_priority_empty","ds_priority_find_max","ds_priority_find_min","ds_priority_find_priority","ds_priority_read","ds_priority_size","ds_priority_write","ds_queue_clear","ds_queue_copy","ds_queue_create","ds_queue_dequeue","ds_queue_destroy","ds_queue_empty","ds_queue_enqueue","ds_queue_head","ds_queue_read","ds_queue_size","ds_queue_tail","ds_queue_write","ds_set_precision","ds_stack_clear","ds_stack_copy","ds_stack_create","ds_stack_destroy","ds_stack_empty","ds_stack_pop","ds_stack_push","ds_stack_read","ds_stack_size","ds_stack_top","ds_stack_write","dsin","dtan","effect_clear","effect_create_above","effect_create_below","effect_create_depth","effect_create_layer","environment_get_variable","event_inherited","event_perform","event_perform_async","event_perform_object","event_user","exception_unhandled_handler","exp","extension_exists","extension_get_option_count","extension_get_option_names","extension_get_option_value","extension_get_options","extension_get_version","external_call","external_define","external_free","file_attributes","file_bin_close","file_bin_open","file_bin_position","file_bin_read_byte","file_bin_rewrite","file_bin_seek","file_bin_size","file_bin_write_byte","file_copy","file_delete","file_exists","file_find_close","file_find_first","file_find_next","file_rename","file_text_close","file_text_eof","file_text_eoln","file_text_open_append","file_text_open_from_string","file_text_open_read","file_text_open_write","file_text_read_real","file_text_read_string","file_text_readln","file_text_write_real","file_text_write_string","file_text_writeln","filename_change_ext","filename_dir","filename_drive","filename_ext","filename_name","filename_path","floor","font_add","font_add_enable_aa","font_add_get_enable_aa","font_add_sprite","font_add_sprite_ext","font_cache_glyph","font_delete","font_enable_effects","font_enable_sdf","font_exists","font_get_bold","font_get_first","font_get_fontname","font_get_info","font_get_italic","font_get_last","font_get_name","font_get_sdf_enabled","font_get_sdf_spread","font_get_size","font_get_texture","font_get_uvs","font_replace_sprite","font_replace_sprite_ext","font_sdf_spread","font_set_cache_size","frac","fx_create","fx_get_name","fx_get_parameter","fx_get_parameter_names","fx_get_parameters","fx_get_single_layer","fx_set_parameter","fx_set_parameters","fx_set_single_layer","game_change","game_end","game_get_speed","game_load","game_load_buffer","game_restart","game_save","game_save_buffer","game_set_speed","gamepad_axis_count","gamepad_axis_value","gamepad_button_check","gamepad_button_check_pressed","gamepad_button_check_released","gamepad_button_count","gamepad_button_value","gamepad_get_axis_deadzone","gamepad_get_button_threshold","gamepad_get_description","gamepad_get_device_count","gamepad_get_guid","gamepad_get_mapping","gamepad_get_option","gamepad_hat_count","gamepad_hat_value","gamepad_is_connected","gamepad_is_supported","gamepad_remove_mapping","gamepad_set_axis_deadzone","gamepad_set_button_threshold","gamepad_set_color","gamepad_set_colour","gamepad_set_option","gamepad_set_vibration","gamepad_test_mapping","gc_collect","gc_enable","gc_get_stats","gc_get_target_frame_time","gc_is_enabled","gc_target_frame_time","gesture_double_tap_distance","gesture_double_tap_time","gesture_drag_distance","gesture_drag_time","gesture_flick_speed","gesture_get_double_tap_distance","gesture_get_double_tap_time","gesture_get_drag_distance","gesture_get_drag_time","gesture_get_flick_speed","gesture_get_pinch_angle_away","gesture_get_pinch_angle_towards","gesture_get_pinch_distance","gesture_get_rotate_angle","gesture_get_rotate_time","gesture_get_tap_count","gesture_pinch_angle_away","gesture_pinch_angle_towards","gesture_pinch_distance","gesture_rotate_angle","gesture_rotate_time","gesture_tap_count","get_integer","get_integer_async","get_login_async","get_open_filename","get_open_filename_ext","get_save_filename","get_save_filename_ext","get_string","get_string_async","get_timer","gif_add_surface","gif_open","gif_save","gif_save_buffer","gml_pragma","gml_release_mode","gpu_get_alphatestenable","gpu_get_alphatestref","gpu_get_blendenable","gpu_get_blendmode","gpu_get_blendmode_dest","gpu_get_blendmode_destalpha","gpu_get_blendmode_ext","gpu_get_blendmode_ext_sepalpha","gpu_get_blendmode_src","gpu_get_blendmode_srcalpha","gpu_get_colorwriteenable","gpu_get_colourwriteenable","gpu_get_cullmode","gpu_get_depth","gpu_get_fog","gpu_get_state","gpu_get_tex_filter","gpu_get_tex_filter_ext","gpu_get_tex_max_aniso","gpu_get_tex_max_aniso_ext","gpu_get_tex_max_mip","gpu_get_tex_max_mip_ext","gpu_get_tex_min_mip","gpu_get_tex_min_mip_ext","gpu_get_tex_mip_bias","gpu_get_tex_mip_bias_ext","gpu_get_tex_mip_enable","gpu_get_tex_mip_enable_ext","gpu_get_tex_mip_filter","gpu_get_tex_mip_filter_ext","gpu_get_tex_repeat","gpu_get_tex_repeat_ext","gpu_get_texfilter","gpu_get_texfilter_ext","gpu_get_texrepeat","gpu_get_texrepeat_ext","gpu_get_zfunc","gpu_get_ztestenable","gpu_get_zwriteenable","gpu_pop_state","gpu_push_state","gpu_set_alphatestenable","gpu_set_alphatestref","gpu_set_blendenable","gpu_set_blendmode","gpu_set_blendmode_ext","gpu_set_blendmode_ext_sepalpha","gpu_set_colorwriteenable","gpu_set_colourwriteenable","gpu_set_cullmode","gpu_set_depth","gpu_set_fog","gpu_set_state","gpu_set_tex_filter","gpu_set_tex_filter_ext","gpu_set_tex_max_aniso","gpu_set_tex_max_aniso_ext","gpu_set_tex_max_mip","gpu_set_tex_max_mip_ext","gpu_set_tex_min_mip","gpu_set_tex_min_mip_ext","gpu_set_tex_mip_bias","gpu_set_tex_mip_bias_ext","gpu_set_tex_mip_enable","gpu_set_tex_mip_enable_ext","gpu_set_tex_mip_filter","gpu_set_tex_mip_filter_ext","gpu_set_tex_repeat","gpu_set_tex_repeat_ext","gpu_set_texfilter","gpu_set_texfilter_ext","gpu_set_texrepeat","gpu_set_texrepeat_ext","gpu_set_zfunc","gpu_set_ztestenable","gpu_set_zwriteenable","handle_parse","highscore_add","highscore_clear","highscore_name","highscore_value","http_get","http_get_file","http_get_request_crossorigin","http_post_string","http_request","http_set_request_crossorigin","iap_acquire","iap_activate","iap_consume","iap_enumerate_products","iap_product_details","iap_purchase_details","iap_restore_all","iap_status","ini_close","ini_key_delete","ini_key_exists","ini_open","ini_open_from_string","ini_read_real","ini_read_string","ini_section_delete","ini_section_exists","ini_write_real","ini_write_string","instance_activate_all","instance_activate_layer","instance_activate_object","instance_activate_region","instance_change","instance_copy","instance_create_depth","instance_create_layer","instance_deactivate_all","instance_deactivate_layer","instance_deactivate_object","instance_deactivate_region","instance_destroy","instance_exists","instance_find","instance_furthest","instance_id_get","instance_nearest","instance_number","instance_place","instance_place_list","instance_position","instance_position_list","instanceof","int64","io_clear","irandom","irandom_range","is_array","is_bool","is_callable","is_debug_overlay_open","is_handle","is_infinity","is_instanceof","is_int32","is_int64","is_keyboard_used_debug_overlay","is_method","is_mouse_over_debug_overlay","is_nan","is_numeric","is_ptr","is_real","is_string","is_struct","is_undefined","json_decode","json_encode","json_parse","json_stringify","keyboard_check","keyboard_check_direct","keyboard_check_pressed","keyboard_check_released","keyboard_clear","keyboard_get_map","keyboard_get_numlock","keyboard_key_press","keyboard_key_release","keyboard_set_map","keyboard_set_numlock","keyboard_unset_map","keyboard_virtual_height","keyboard_virtual_hide","keyboard_virtual_show","keyboard_virtual_status","layer_add_instance","layer_background_alpha","layer_background_blend","layer_background_change","layer_background_create","layer_background_destroy","layer_background_exists","layer_background_get_alpha","layer_background_get_blend","layer_background_get_htiled","layer_background_get_id","layer_background_get_index","layer_background_get_speed","layer_background_get_sprite","layer_background_get_stretch","layer_background_get_visible","layer_background_get_vtiled","layer_background_get_xscale","layer_background_get_yscale","layer_background_htiled","layer_background_index","layer_background_speed","layer_background_sprite","layer_background_stretch","layer_background_visible","layer_background_vtiled","layer_background_xscale","layer_background_yscale","layer_clear_fx","layer_create","layer_depth","layer_destroy","layer_destroy_instances","layer_element_move","layer_enable_fx","layer_exists","layer_force_draw_depth","layer_fx_is_enabled","layer_get_all","layer_get_all_elements","layer_get_depth","layer_get_element_layer","layer_get_element_type","layer_get_forced_depth","layer_get_fx","layer_get_hspeed","layer_get_id","layer_get_id_at_depth","layer_get_name","layer_get_script_begin","layer_get_script_end","layer_get_shader","layer_get_target_room","layer_get_visible","layer_get_vspeed","layer_get_x","layer_get_y","layer_has_instance","layer_hspeed","layer_instance_get_instance","layer_is_draw_depth_forced","layer_reset_target_room","layer_script_begin","layer_script_end","layer_sequence_angle","layer_sequence_create","layer_sequence_destroy","layer_sequence_exists","layer_sequence_get_angle","layer_sequence_get_headdir","layer_sequence_get_headpos","layer_sequence_get_instance","layer_sequence_get_length","layer_sequence_get_sequence","layer_sequence_get_speedscale","layer_sequence_get_x","layer_sequence_get_xscale","layer_sequence_get_y","layer_sequence_get_yscale","layer_sequence_headdir","layer_sequence_headpos","layer_sequence_is_finished","layer_sequence_is_paused","layer_sequence_pause","layer_sequence_play","layer_sequence_speedscale","layer_sequence_x","layer_sequence_xscale","layer_sequence_y","layer_sequence_yscale","layer_set_fx","layer_set_target_room","layer_set_visible","layer_shader","layer_sprite_alpha","layer_sprite_angle","layer_sprite_blend","layer_sprite_change","layer_sprite_create","layer_sprite_destroy","layer_sprite_exists","layer_sprite_get_alpha","layer_sprite_get_angle","layer_sprite_get_blend","layer_sprite_get_id","layer_sprite_get_index","layer_sprite_get_speed","layer_sprite_get_sprite","layer_sprite_get_x","layer_sprite_get_xscale","layer_sprite_get_y","layer_sprite_get_yscale","layer_sprite_index","layer_sprite_speed","layer_sprite_x","layer_sprite_xscale","layer_sprite_y","layer_sprite_yscale","layer_tile_alpha","layer_tile_blend","layer_tile_change","layer_tile_create","layer_tile_destroy","layer_tile_exists","layer_tile_get_alpha","layer_tile_get_blend","layer_tile_get_region","layer_tile_get_sprite","layer_tile_get_visible","layer_tile_get_x","layer_tile_get_xscale","layer_tile_get_y","layer_tile_get_yscale","layer_tile_region","layer_tile_visible","layer_tile_x","layer_tile_xscale","layer_tile_y","layer_tile_yscale","layer_tilemap_create","layer_tilemap_destroy","layer_tilemap_exists","layer_tilemap_get_id","layer_vspeed","layer_x","layer_y","lengthdir_x","lengthdir_y","lerp","lin_to_db","ln","load_csv","log10","log2","logn","make_color_hsv","make_color_rgb","make_colour_hsv","make_colour_rgb","math_get_epsilon","math_set_epsilon","matrix_build","matrix_build_identity","matrix_build_lookat","matrix_build_projection_ortho","matrix_build_projection_perspective","matrix_build_projection_perspective_fov","matrix_get","matrix_multiply","matrix_set","matrix_stack_clear","matrix_stack_is_empty","matrix_stack_pop","matrix_stack_push","matrix_stack_set","matrix_stack_top","matrix_transform_vertex","max","md5_file","md5_string_unicode","md5_string_utf8","mean","median","merge_color","merge_colour","method","method_call","method_get_index","method_get_self","min","motion_add","motion_set","mouse_check_button","mouse_check_button_pressed","mouse_check_button_released","mouse_clear","mouse_wheel_down","mouse_wheel_up","move_and_collide","move_bounce_all","move_bounce_solid","move_contact_all","move_contact_solid","move_outside_all","move_outside_solid","move_random","move_snap","move_towards_point","move_wrap","mp_grid_add_cell","mp_grid_add_instances","mp_grid_add_rectangle","mp_grid_clear_all","mp_grid_clear_cell","mp_grid_clear_rectangle","mp_grid_create","mp_grid_destroy","mp_grid_draw","mp_grid_get_cell","mp_grid_path","mp_grid_to_ds_grid","mp_linear_path","mp_linear_path_object","mp_linear_step","mp_linear_step_object","mp_potential_path","mp_potential_path_object","mp_potential_settings","mp_potential_step","mp_potential_step_object","nameof","network_connect","network_connect_async","network_connect_raw","network_connect_raw_async","network_create_server","network_create_server_raw","network_create_socket","network_create_socket_ext","network_destroy","network_resolve","network_send_broadcast","network_send_packet","network_send_raw","network_send_udp","network_send_udp_raw","network_set_config","network_set_timeout","object_exists","object_get_mask","object_get_name","object_get_parent","object_get_persistent","object_get_physics","object_get_solid","object_get_sprite","object_get_visible","object_is_ancestor","object_set_mask","object_set_persistent","object_set_solid","object_set_sprite","object_set_visible","ord","os_check_permission","os_get_config","os_get_info","os_get_language","os_get_region","os_is_network_connected","os_is_paused","os_lock_orientation","os_powersave_enable","os_request_permission","os_set_orientation_lock","parameter_count","parameter_string","part_emitter_burst","part_emitter_clear","part_emitter_create","part_emitter_delay","part_emitter_destroy","part_emitter_destroy_all","part_emitter_enable","part_emitter_exists","part_emitter_interval","part_emitter_region","part_emitter_relative","part_emitter_stream","part_particles_burst","part_particles_clear","part_particles_count","part_particles_create","part_particles_create_color","part_particles_create_colour","part_system_angle","part_system_automatic_draw","part_system_automatic_update","part_system_clear","part_system_color","part_system_colour","part_system_create","part_system_create_layer","part_system_depth","part_system_destroy","part_system_draw_order","part_system_drawit","part_system_exists","part_system_get_info","part_system_get_layer","part_system_global_space","part_system_layer","part_system_position","part_system_update","part_type_alpha1","part_type_alpha2","part_type_alpha3","part_type_blend","part_type_clear","part_type_color1","part_type_color2","part_type_color3","part_type_color_hsv","part_type_color_mix","part_type_color_rgb","part_type_colour1","part_type_colour2","part_type_colour3","part_type_colour_hsv","part_type_colour_mix","part_type_colour_rgb","part_type_create","part_type_death","part_type_destroy","part_type_direction","part_type_exists","part_type_gravity","part_type_life","part_type_orientation","part_type_scale","part_type_shape","part_type_size","part_type_size_x","part_type_size_y","part_type_speed","part_type_sprite","part_type_step","part_type_subimage","particle_exists","particle_get_info","path_add","path_add_point","path_append","path_assign","path_change_point","path_clear_points","path_delete","path_delete_point","path_duplicate","path_end","path_exists","path_flip","path_get_closed","path_get_kind","path_get_length","path_get_name","path_get_number","path_get_point_speed","path_get_point_x","path_get_point_y","path_get_precision","path_get_speed","path_get_x","path_get_y","path_insert_point","path_mirror","path_rescale","path_reverse","path_rotate","path_set_closed","path_set_kind","path_set_precision","path_shift","path_start","physics_apply_angular_impulse","physics_apply_force","physics_apply_impulse","physics_apply_local_force","physics_apply_local_impulse","physics_apply_torque","physics_draw_debug","physics_fixture_add_point","physics_fixture_bind","physics_fixture_bind_ext","physics_fixture_create","physics_fixture_delete","physics_fixture_set_angular_damping","physics_fixture_set_awake","physics_fixture_set_box_shape","physics_fixture_set_chain_shape","physics_fixture_set_circle_shape","physics_fixture_set_collision_group","physics_fixture_set_density","physics_fixture_set_edge_shape","physics_fixture_set_friction","physics_fixture_set_kinematic","physics_fixture_set_linear_damping","physics_fixture_set_polygon_shape","physics_fixture_set_restitution","physics_fixture_set_sensor","physics_get_density","physics_get_friction","physics_get_restitution","physics_joint_delete","physics_joint_distance_create","physics_joint_enable_motor","physics_joint_friction_create","physics_joint_gear_create","physics_joint_get_value","physics_joint_prismatic_create","physics_joint_pulley_create","physics_joint_revolute_create","physics_joint_rope_create","physics_joint_set_value","physics_joint_weld_create","physics_joint_wheel_create","physics_mass_properties","physics_particle_count","physics_particle_create","physics_particle_delete","physics_particle_delete_region_box","physics_particle_delete_region_circle","physics_particle_delete_region_poly","physics_particle_draw","physics_particle_draw_ext","physics_particle_get_damping","physics_particle_get_data","physics_particle_get_data_particle","physics_particle_get_density","physics_particle_get_gravity_scale","physics_particle_get_group_flags","physics_particle_get_max_count","physics_particle_get_radius","physics_particle_group_add_point","physics_particle_group_begin","physics_particle_group_box","physics_particle_group_circle","physics_particle_group_count","physics_particle_group_delete","physics_particle_group_end","physics_particle_group_get_ang_vel","physics_particle_group_get_angle","physics_particle_group_get_centre_x","physics_particle_group_get_centre_y","physics_particle_group_get_data","physics_particle_group_get_inertia","physics_particle_group_get_mass","physics_particle_group_get_vel_x","physics_particle_group_get_vel_y","physics_particle_group_get_x","physics_particle_group_get_y","physics_particle_group_join","physics_particle_group_polygon","physics_particle_set_category_flags","physics_particle_set_damping","physics_particle_set_density","physics_particle_set_flags","physics_particle_set_gravity_scale","physics_particle_set_group_flags","physics_particle_set_max_count","physics_particle_set_radius","physics_pause_enable","physics_remove_fixture","physics_set_density","physics_set_friction","physics_set_restitution","physics_test_overlap","physics_world_create","physics_world_draw_debug","physics_world_gravity","physics_world_update_iterations","physics_world_update_speed","place_empty","place_free","place_meeting","place_snapped","point_direction","point_distance","point_distance_3d","point_in_circle","point_in_rectangle","point_in_triangle","position_change","position_destroy","position_empty","position_meeting","power","ptr","radtodeg","random","random_get_seed","random_range","random_set_seed","randomise","randomize","real","rectangle_in_circle","rectangle_in_rectangle","rectangle_in_triangle","ref_create","rollback_chat","rollback_create_game","rollback_define_extra_network_latency","rollback_define_input","rollback_define_input_frame_delay","rollback_define_mock_input","rollback_define_player","rollback_display_events","rollback_get_info","rollback_get_input","rollback_get_player_prefs","rollback_join_game","rollback_leave_game","rollback_set_player_prefs","rollback_start_game","rollback_sync_on_frame","rollback_use_late_join","rollback_use_manual_start","rollback_use_player_prefs","rollback_use_random_input","room_add","room_assign","room_duplicate","room_exists","room_get_camera","room_get_info","room_get_name","room_get_viewport","room_goto","room_goto_next","room_goto_previous","room_instance_add","room_instance_clear","room_next","room_previous","room_restart","room_set_camera","room_set_height","room_set_persistent","room_set_view_enabled","room_set_viewport","room_set_width","round","scheduler_resolution_get","scheduler_resolution_set","screen_save","screen_save_part","script_execute","script_execute_ext","script_exists","script_get_name","sequence_create","sequence_destroy","sequence_exists","sequence_get","sequence_get_objects","sequence_instance_override_object","sequence_keyframe_new","sequence_keyframedata_new","sequence_track_new","sha1_file","sha1_string_unicode","sha1_string_utf8","shader_current","shader_enable_corner_id","shader_get_name","shader_get_sampler_index","shader_get_uniform","shader_is_compiled","shader_reset","shader_set","shader_set_uniform_f","shader_set_uniform_f_array","shader_set_uniform_f_buffer","shader_set_uniform_i","shader_set_uniform_i_array","shader_set_uniform_matrix","shader_set_uniform_matrix_array","shaders_are_supported","shop_leave_rating","show_debug_message","show_debug_message_ext","show_debug_overlay","show_error","show_message","show_message_async","show_question","show_question_async","sign","sin","skeleton_animation_clear","skeleton_animation_get","skeleton_animation_get_duration","skeleton_animation_get_event_frames","skeleton_animation_get_ext","skeleton_animation_get_frame","skeleton_animation_get_frames","skeleton_animation_get_position","skeleton_animation_is_finished","skeleton_animation_is_looping","skeleton_animation_list","skeleton_animation_mix","skeleton_animation_set","skeleton_animation_set_ext","skeleton_animation_set_frame","skeleton_animation_set_position","skeleton_attachment_create","skeleton_attachment_create_color","skeleton_attachment_create_colour","skeleton_attachment_destroy","skeleton_attachment_exists","skeleton_attachment_get","skeleton_attachment_replace","skeleton_attachment_replace_color","skeleton_attachment_replace_colour","skeleton_attachment_set","skeleton_bone_data_get","skeleton_bone_data_set","skeleton_bone_list","skeleton_bone_state_get","skeleton_bone_state_set","skeleton_collision_draw_set","skeleton_find_slot","skeleton_get_bounds","skeleton_get_minmax","skeleton_get_num_bounds","skeleton_skin_create","skeleton_skin_get","skeleton_skin_list","skeleton_skin_set","skeleton_slot_alpha_get","skeleton_slot_color_get","skeleton_slot_color_set","skeleton_slot_colour_get","skeleton_slot_colour_set","skeleton_slot_data","skeleton_slot_data_instance","skeleton_slot_list","sprite_add","sprite_add_ext","sprite_add_from_surface","sprite_assign","sprite_collision_mask","sprite_create_from_surface","sprite_delete","sprite_duplicate","sprite_exists","sprite_flush","sprite_flush_multi","sprite_get_bbox_bottom","sprite_get_bbox_left","sprite_get_bbox_mode","sprite_get_bbox_right","sprite_get_bbox_top","sprite_get_height","sprite_get_info","sprite_get_name","sprite_get_nineslice","sprite_get_number","sprite_get_speed","sprite_get_speed_type","sprite_get_texture","sprite_get_tpe","sprite_get_uvs","sprite_get_width","sprite_get_xoffset","sprite_get_yoffset","sprite_merge","sprite_nineslice_create","sprite_prefetch","sprite_prefetch_multi","sprite_replace","sprite_save","sprite_save_strip","sprite_set_alpha_from_sprite","sprite_set_bbox","sprite_set_bbox_mode","sprite_set_cache_size","sprite_set_cache_size_ext","sprite_set_nineslice","sprite_set_offset","sprite_set_speed","sqr","sqrt","static_get","static_set","string","string_byte_at","string_byte_length","string_char_at","string_concat","string_concat_ext","string_copy","string_count","string_delete","string_digits","string_ends_with","string_ext","string_foreach","string_format","string_hash_to_newline","string_height","string_height_ext","string_insert","string_join","string_join_ext","string_last_pos","string_last_pos_ext","string_length","string_letters","string_lettersdigits","string_lower","string_ord_at","string_pos","string_pos_ext","string_repeat","string_replace","string_replace_all","string_set_byte_at","string_split","string_split_ext","string_starts_with","string_trim","string_trim_end","string_trim_start","string_upper","string_width","string_width_ext","struct_exists","struct_foreach","struct_get","struct_get_from_hash","struct_get_names","struct_names_count","struct_remove","struct_set","struct_set_from_hash","surface_copy","surface_copy_part","surface_create","surface_create_ext","surface_depth_disable","surface_exists","surface_format_is_supported","surface_free","surface_get_depth_disable","surface_get_format","surface_get_height","surface_get_target","surface_get_target_ext","surface_get_texture","surface_get_width","surface_getpixel","surface_getpixel_ext","surface_reset_target","surface_resize","surface_save","surface_save_part","surface_set_target","surface_set_target_ext","tag_get_asset_ids","tag_get_assets","tan","texture_debug_messages","texture_flush","texture_get_height","texture_get_texel_height","texture_get_texel_width","texture_get_uvs","texture_get_width","texture_global_scale","texture_is_ready","texture_prefetch","texture_set_stage","texturegroup_get_fonts","texturegroup_get_names","texturegroup_get_sprites","texturegroup_get_status","texturegroup_get_textures","texturegroup_get_tilesets","texturegroup_load","texturegroup_set_mode","texturegroup_unload","tile_get_empty","tile_get_flip","tile_get_index","tile_get_mirror","tile_get_rotate","tile_set_empty","tile_set_flip","tile_set_index","tile_set_mirror","tile_set_rotate","tilemap_clear","tilemap_get","tilemap_get_at_pixel","tilemap_get_cell_x_at_pixel","tilemap_get_cell_y_at_pixel","tilemap_get_frame","tilemap_get_global_mask","tilemap_get_height","tilemap_get_mask","tilemap_get_tile_height","tilemap_get_tile_width","tilemap_get_tileset","tilemap_get_width","tilemap_get_x","tilemap_get_y","tilemap_set","tilemap_set_at_pixel","tilemap_set_global_mask","tilemap_set_height","tilemap_set_mask","tilemap_set_width","tilemap_tileset","tilemap_x","tilemap_y","tileset_get_info","tileset_get_name","tileset_get_texture","tileset_get_uvs","time_bpm_to_seconds","time_seconds_to_bpm","time_source_create","time_source_destroy","time_source_exists","time_source_get_children","time_source_get_parent","time_source_get_period","time_source_get_reps_completed","time_source_get_reps_remaining","time_source_get_state","time_source_get_time_remaining","time_source_get_units","time_source_pause","time_source_reconfigure","time_source_reset","time_source_resume","time_source_start","time_source_stop","timeline_add","timeline_clear","timeline_delete","timeline_exists","timeline_get_name","timeline_max_moment","timeline_moment_add_script","timeline_moment_clear","timeline_size","typeof","url_get_domain","url_open","url_open_ext","url_open_full","uwp_device_touchscreen_available","uwp_livetile_badge_clear","uwp_livetile_badge_notification","uwp_livetile_notification_begin","uwp_livetile_notification_end","uwp_livetile_notification_expiry","uwp_livetile_notification_image_add","uwp_livetile_notification_secondary_begin","uwp_livetile_notification_tag","uwp_livetile_notification_template_add","uwp_livetile_notification_text_add","uwp_livetile_queue_enable","uwp_livetile_tile_clear","uwp_secondarytile_badge_clear","uwp_secondarytile_badge_notification","uwp_secondarytile_delete","uwp_secondarytile_pin","uwp_secondarytile_tile_clear","variable_clone","variable_get_hash","variable_global_exists","variable_global_get","variable_global_set","variable_instance_exists","variable_instance_get","variable_instance_get_names","variable_instance_names_count","variable_instance_set","variable_struct_exists","variable_struct_get","variable_struct_get_names","variable_struct_names_count","variable_struct_remove","variable_struct_set","vertex_argb","vertex_begin","vertex_color","vertex_colour","vertex_create_buffer","vertex_create_buffer_ext","vertex_create_buffer_from_buffer","vertex_create_buffer_from_buffer_ext","vertex_delete_buffer","vertex_end","vertex_float1","vertex_float2","vertex_float3","vertex_float4","vertex_format_add_color","vertex_format_add_colour","vertex_format_add_custom","vertex_format_add_normal","vertex_format_add_position","vertex_format_add_position_3d","vertex_format_add_texcoord","vertex_format_begin","vertex_format_delete","vertex_format_end","vertex_format_get_info","vertex_freeze","vertex_get_buffer_size","vertex_get_number","vertex_normal","vertex_position","vertex_position_3d","vertex_submit","vertex_submit_ext","vertex_texcoord","vertex_ubyte4","vertex_update_buffer_from_buffer","vertex_update_buffer_from_vertex","video_close","video_draw","video_enable_loop","video_get_duration","video_get_format","video_get_position","video_get_status","video_get_volume","video_is_looping","video_open","video_pause","video_resume","video_seek_to","video_set_volume","view_get_camera","view_get_hport","view_get_surface_id","view_get_visible","view_get_wport","view_get_xport","view_get_yport","view_set_camera","view_set_hport","view_set_surface_id","view_set_visible","view_set_wport","view_set_xport","view_set_yport","virtual_key_add","virtual_key_delete","virtual_key_hide","virtual_key_show","wallpaper_set_config","wallpaper_set_subscriptions","weak_ref_alive","weak_ref_any_alive","weak_ref_create","window_center","window_device","window_enable_borderless_fullscreen","window_get_borderless_fullscreen","window_get_caption","window_get_color","window_get_colour","window_get_cursor","window_get_fullscreen","window_get_height","window_get_showborder","window_get_visible_rects","window_get_width","window_get_x","window_get_y","window_handle","window_has_focus","window_mouse_get_delta_x","window_mouse_get_delta_y","window_mouse_get_locked","window_mouse_get_x","window_mouse_get_y","window_mouse_set","window_mouse_set_locked","window_set_caption","window_set_color","window_set_colour","window_set_cursor","window_set_fullscreen","window_set_max_height","window_set_max_width","window_set_min_height","window_set_min_width","window_set_position","window_set_rectangle","window_set_showborder","window_set_size","window_view_mouse_get_x","window_view_mouse_get_y","window_views_mouse_get_x","window_views_mouse_get_y","winphone_tile_background_color","winphone_tile_background_colour","zip_add_file","zip_create","zip_save","zip_unzip","zip_unzip_async"],symbol:["AudioEffect","AudioEffectType","AudioLFOType","GM_build_date","GM_build_type","GM_is_sandboxed","GM_project_filename","GM_runtime_version","GM_version","NaN","_GMFILE_","_GMFUNCTION_","_GMLINE_","alignmentH","alignmentV","all","animcurvetype_bezier","animcurvetype_catmullrom","animcurvetype_linear","asset_animationcurve","asset_font","asset_object","asset_path","asset_room","asset_script","asset_sequence","asset_shader","asset_sound","asset_sprite","asset_tiles","asset_timeline","asset_unknown","audio_3D","audio_bus_main","audio_falloff_exponent_distance","audio_falloff_exponent_distance_clamped","audio_falloff_exponent_distance_scaled","audio_falloff_inverse_distance","audio_falloff_inverse_distance_clamped","audio_falloff_inverse_distance_scaled","audio_falloff_linear_distance","audio_falloff_linear_distance_clamped","audio_falloff_none","audio_mono","audio_stereo","bboxkind_diamond","bboxkind_ellipse","bboxkind_precise","bboxkind_rectangular","bboxmode_automatic","bboxmode_fullimage","bboxmode_manual","bm_add","bm_dest_alpha","bm_dest_color","bm_dest_colour","bm_inv_dest_alpha","bm_inv_dest_color","bm_inv_dest_colour","bm_inv_src_alpha","bm_inv_src_color","bm_inv_src_colour","bm_max","bm_normal","bm_one","bm_src_alpha","bm_src_alpha_sat","bm_src_color","bm_src_colour","bm_subtract","bm_zero","browser_chrome","browser_edge","browser_firefox","browser_ie","browser_ie_mobile","browser_not_a_browser","browser_opera","browser_safari","browser_safari_mobile","browser_tizen","browser_unknown","browser_windows_store","buffer_bool","buffer_f16","buffer_f32","buffer_f64","buffer_fast","buffer_fixed","buffer_grow","buffer_s16","buffer_s32","buffer_s8","buffer_seek_end","buffer_seek_relative","buffer_seek_start","buffer_string","buffer_text","buffer_u16","buffer_u32","buffer_u64","buffer_u8","buffer_vbuffer","buffer_wrap","c_aqua","c_black","c_blue","c_dkgray","c_dkgrey","c_fuchsia","c_gray","c_green","c_grey","c_lime","c_ltgray","c_ltgrey","c_maroon","c_navy","c_olive","c_orange","c_purple","c_red","c_silver","c_teal","c_white","c_yellow","cache_directory","characterSpacing","cmpfunc_always","cmpfunc_equal","cmpfunc_greater","cmpfunc_greaterequal","cmpfunc_less","cmpfunc_lessequal","cmpfunc_never","cmpfunc_notequal","coreColor","coreColour","cr_appstart","cr_arrow","cr_beam","cr_cross","cr_default","cr_drag","cr_handpoint","cr_hourglass","cr_none","cr_size_all","cr_size_nesw","cr_size_ns","cr_size_nwse","cr_size_we","cr_uparrow","cull_clockwise","cull_counterclockwise","cull_noculling","device_emulator","device_ios_ipad","device_ios_ipad_retina","device_ios_iphone","device_ios_iphone5","device_ios_iphone6","device_ios_iphone6plus","device_ios_iphone_retina","device_ios_unknown","device_tablet","display_landscape","display_landscape_flipped","display_portrait","display_portrait_flipped","dll_cdecl","dll_stdcall","dropShadowEnabled","dropShadowEnabled","ds_type_grid","ds_type_list","ds_type_map","ds_type_priority","ds_type_queue","ds_type_stack","ef_cloud","ef_ellipse","ef_explosion","ef_firework","ef_flare","ef_rain","ef_ring","ef_smoke","ef_smokeup","ef_snow","ef_spark","ef_star","effectsEnabled","effectsEnabled","ev_alarm","ev_animation_end","ev_animation_event","ev_animation_update","ev_async_audio_playback","ev_async_audio_playback_ended","ev_async_audio_recording","ev_async_dialog","ev_async_push_notification","ev_async_save_load","ev_async_save_load","ev_async_social","ev_async_system_event","ev_async_web","ev_async_web_cloud","ev_async_web_iap","ev_async_web_image_load","ev_async_web_networking","ev_async_web_steam","ev_audio_playback","ev_audio_playback_ended","ev_audio_recording","ev_boundary","ev_boundary_view0","ev_boundary_view1","ev_boundary_view2","ev_boundary_view3","ev_boundary_view4","ev_boundary_view5","ev_boundary_view6","ev_boundary_view7","ev_broadcast_message","ev_cleanup","ev_collision","ev_create","ev_destroy","ev_dialog_async","ev_draw","ev_draw_begin","ev_draw_end","ev_draw_normal","ev_draw_post","ev_draw_pre","ev_end_of_path","ev_game_end","ev_game_start","ev_gesture","ev_gesture_double_tap","ev_gesture_drag_end","ev_gesture_drag_start","ev_gesture_dragging","ev_gesture_flick","ev_gesture_pinch_end","ev_gesture_pinch_in","ev_gesture_pinch_out","ev_gesture_pinch_start","ev_gesture_rotate_end","ev_gesture_rotate_start","ev_gesture_rotating","ev_gesture_tap","ev_global_gesture_double_tap","ev_global_gesture_drag_end","ev_global_gesture_drag_start","ev_global_gesture_dragging","ev_global_gesture_flick","ev_global_gesture_pinch_end","ev_global_gesture_pinch_in","ev_global_gesture_pinch_out","ev_global_gesture_pinch_start","ev_global_gesture_rotate_end","ev_global_gesture_rotate_start","ev_global_gesture_rotating","ev_global_gesture_tap","ev_global_left_button","ev_global_left_press","ev_global_left_release","ev_global_middle_button","ev_global_middle_press","ev_global_middle_release","ev_global_right_button","ev_global_right_press","ev_global_right_release","ev_gui","ev_gui_begin","ev_gui_end","ev_joystick1_button1","ev_joystick1_button2","ev_joystick1_button3","ev_joystick1_button4","ev_joystick1_button5","ev_joystick1_button6","ev_joystick1_button7","ev_joystick1_button8","ev_joystick1_down","ev_joystick1_left","ev_joystick1_right","ev_joystick1_up","ev_joystick2_button1","ev_joystick2_button2","ev_joystick2_button3","ev_joystick2_button4","ev_joystick2_button5","ev_joystick2_button6","ev_joystick2_button7","ev_joystick2_button8","ev_joystick2_down","ev_joystick2_left","ev_joystick2_right","ev_joystick2_up","ev_keyboard","ev_keypress","ev_keyrelease","ev_left_button","ev_left_press","ev_left_release","ev_middle_button","ev_middle_press","ev_middle_release","ev_mouse","ev_mouse_enter","ev_mouse_leave","ev_mouse_wheel_down","ev_mouse_wheel_up","ev_no_button","ev_no_more_health","ev_no_more_lives","ev_other","ev_outside","ev_outside_view0","ev_outside_view1","ev_outside_view2","ev_outside_view3","ev_outside_view4","ev_outside_view5","ev_outside_view6","ev_outside_view7","ev_pre_create","ev_push_notification","ev_right_button","ev_right_press","ev_right_release","ev_room_end","ev_room_start","ev_social","ev_step","ev_step_begin","ev_step_end","ev_step_normal","ev_system_event","ev_trigger","ev_user0","ev_user1","ev_user10","ev_user11","ev_user12","ev_user13","ev_user14","ev_user15","ev_user2","ev_user3","ev_user4","ev_user5","ev_user6","ev_user7","ev_user8","ev_user9","ev_web_async","ev_web_cloud","ev_web_iap","ev_web_image_load","ev_web_networking","ev_web_sound_load","ev_web_steam","fa_archive","fa_bottom","fa_center","fa_directory","fa_hidden","fa_left","fa_middle","fa_none","fa_readonly","fa_right","fa_sysfile","fa_top","fa_volumeid","false","frameSizeX","frameSizeY","gamespeed_fps","gamespeed_microseconds","global","glowColor","glowColour","glowEnabled","glowEnabled","glowEnd","glowStart","gp_axis_acceleration_x","gp_axis_acceleration_y","gp_axis_acceleration_z","gp_axis_angular_velocity_x","gp_axis_angular_velocity_y","gp_axis_angular_velocity_z","gp_axis_orientation_w","gp_axis_orientation_x","gp_axis_orientation_y","gp_axis_orientation_z","gp_axislh","gp_axislv","gp_axisrh","gp_axisrv","gp_face1","gp_face2","gp_face3","gp_face4","gp_padd","gp_padl","gp_padr","gp_padu","gp_select","gp_shoulderl","gp_shoulderlb","gp_shoulderr","gp_shoulderrb","gp_start","gp_stickl","gp_stickr","iap_available","iap_canceled","iap_ev_consume","iap_ev_product","iap_ev_purchase","iap_ev_restore","iap_ev_storeload","iap_failed","iap_purchased","iap_refunded","iap_status_available","iap_status_loading","iap_status_processing","iap_status_restoring","iap_status_unavailable","iap_status_uninitialised","iap_storeload_failed","iap_storeload_ok","iap_unavailable","infinity","kbv_autocapitalize_characters","kbv_autocapitalize_none","kbv_autocapitalize_sentences","kbv_autocapitalize_words","kbv_returnkey_continue","kbv_returnkey_default","kbv_returnkey_done","kbv_returnkey_emergency","kbv_returnkey_go","kbv_returnkey_google","kbv_returnkey_join","kbv_returnkey_next","kbv_returnkey_route","kbv_returnkey_search","kbv_returnkey_send","kbv_returnkey_yahoo","kbv_type_ascii","kbv_type_default","kbv_type_email","kbv_type_numbers","kbv_type_phone","kbv_type_phone_name","kbv_type_url","layerelementtype_background","layerelementtype_instance","layerelementtype_oldtilemap","layerelementtype_particlesystem","layerelementtype_sequence","layerelementtype_sprite","layerelementtype_tile","layerelementtype_tilemap","layerelementtype_undefined","leaderboard_type_number","leaderboard_type_time_mins_secs","lighttype_dir","lighttype_point","lineSpacing","m_axisx","m_axisx_gui","m_axisy","m_axisy_gui","m_scroll_down","m_scroll_up","matrix_projection","matrix_view","matrix_world","mb_any","mb_left","mb_middle","mb_none","mb_right","mb_side1","mb_side2","mip_markedonly","mip_off","mip_on","network_config_avoid_time_wait","network_config_connect_timeout","network_config_disable_multicast","network_config_disable_reliable_udp","network_config_enable_multicast","network_config_enable_reliable_udp","network_config_use_non_blocking_socket","network_config_websocket_protocol","network_connect_active","network_connect_blocking","network_connect_nonblocking","network_connect_none","network_connect_passive","network_send_binary","network_send_text","network_socket_bluetooth","network_socket_tcp","network_socket_udp","network_socket_ws","network_socket_wss","network_type_connect","network_type_data","network_type_disconnect","network_type_down","network_type_non_blocking_connect","network_type_up","network_type_up_failed","nineslice_blank","nineslice_bottom","nineslice_center","nineslice_centre","nineslice_hide","nineslice_left","nineslice_mirror","nineslice_repeat","nineslice_right","nineslice_stretch","nineslice_top","noone","of_challenge_lose","of_challenge_tie","of_challenge_win","os_android","os_gdk","os_gxgames","os_ios","os_linux","os_macosx","os_operagx","os_permission_denied","os_permission_denied_dont_request","os_permission_granted","os_ps3","os_ps4","os_ps5","os_psvita","os_switch","os_tvos","os_unknown","os_uwp","os_win8native","os_windows","os_winphone","os_xboxone","os_xboxseriesxs","other","outlineColor","outlineColour","outlineDist","outlineEnabled","outlineEnabled","paragraphSpacing","path_action_continue","path_action_restart","path_action_reverse","path_action_stop","phy_debug_render_aabb","phy_debug_render_collision_pairs","phy_debug_render_coms","phy_debug_render_core_shapes","phy_debug_render_joints","phy_debug_render_obb","phy_debug_render_shapes","phy_joint_anchor_1_x","phy_joint_anchor_1_y","phy_joint_anchor_2_x","phy_joint_anchor_2_y","phy_joint_angle","phy_joint_angle_limits","phy_joint_damping_ratio","phy_joint_frequency","phy_joint_length_1","phy_joint_length_2","phy_joint_lower_angle_limit","phy_joint_max_force","phy_joint_max_length","phy_joint_max_motor_force","phy_joint_max_motor_torque","phy_joint_max_torque","phy_joint_motor_force","phy_joint_motor_speed","phy_joint_motor_torque","phy_joint_reaction_force_x","phy_joint_reaction_force_y","phy_joint_reaction_torque","phy_joint_speed","phy_joint_translation","phy_joint_upper_angle_limit","phy_particle_data_flag_category","phy_particle_data_flag_color","phy_particle_data_flag_colour","phy_particle_data_flag_position","phy_particle_data_flag_typeflags","phy_particle_data_flag_velocity","phy_particle_flag_colormixing","phy_particle_flag_colourmixing","phy_particle_flag_elastic","phy_particle_flag_powder","phy_particle_flag_spring","phy_particle_flag_tensile","phy_particle_flag_viscous","phy_particle_flag_wall","phy_particle_flag_water","phy_particle_flag_zombie","phy_particle_group_flag_rigid","phy_particle_group_flag_solid","pi","pointer_invalid","pointer_null","pr_linelist","pr_linestrip","pr_pointlist","pr_trianglefan","pr_trianglelist","pr_trianglestrip","ps_distr_gaussian","ps_distr_invgaussian","ps_distr_linear","ps_mode_burst","ps_mode_stream","ps_shape_diamond","ps_shape_ellipse","ps_shape_line","ps_shape_rectangle","pt_shape_circle","pt_shape_cloud","pt_shape_disk","pt_shape_explosion","pt_shape_flare","pt_shape_line","pt_shape_pixel","pt_shape_ring","pt_shape_smoke","pt_shape_snow","pt_shape_spark","pt_shape_sphere","pt_shape_square","pt_shape_star","rollback_chat_message","rollback_connect_error","rollback_connect_info","rollback_connected_to_peer","rollback_connection_rejected","rollback_disconnected_from_peer","rollback_end_game","rollback_game_full","rollback_game_info","rollback_game_interrupted","rollback_game_resumed","rollback_high_latency","rollback_player_prefs","rollback_protocol_rejected","rollback_synchronized_with_peer","rollback_synchronizing_with_peer","self","seqaudiokey_loop","seqaudiokey_oneshot","seqdir_left","seqdir_right","seqinterpolation_assign","seqinterpolation_lerp","seqplay_loop","seqplay_oneshot","seqplay_pingpong","seqtextkey_bottom","seqtextkey_center","seqtextkey_justify","seqtextkey_left","seqtextkey_middle","seqtextkey_right","seqtextkey_top","seqtracktype_audio","seqtracktype_bool","seqtracktype_clipmask","seqtracktype_clipmask_mask","seqtracktype_clipmask_subject","seqtracktype_color","seqtracktype_colour","seqtracktype_empty","seqtracktype_graphic","seqtracktype_group","seqtracktype_instance","seqtracktype_message","seqtracktype_moment","seqtracktype_particlesystem","seqtracktype_real","seqtracktype_sequence","seqtracktype_spriteframes","seqtracktype_string","seqtracktype_text","shadowColor","shadowColour","shadowOffsetX","shadowOffsetY","shadowSoftness","sprite_add_ext_error_cancelled","sprite_add_ext_error_decompressfailed","sprite_add_ext_error_loadfailed","sprite_add_ext_error_setupfailed","sprite_add_ext_error_spritenotfound","sprite_add_ext_error_unknown","spritespeed_framespergameframe","spritespeed_framespersecond","surface_r16float","surface_r32float","surface_r8unorm","surface_rg8unorm","surface_rgba16float","surface_rgba32float","surface_rgba4unorm","surface_rgba8unorm","texturegroup_status_fetched","texturegroup_status_loaded","texturegroup_status_loading","texturegroup_status_unloaded","tf_anisotropic","tf_linear","tf_point","thickness","tile_flip","tile_index_mask","tile_mirror","tile_rotate","time_source_expire_after","time_source_expire_nearest","time_source_game","time_source_global","time_source_state_active","time_source_state_initial","time_source_state_paused","time_source_state_stopped","time_source_units_frames","time_source_units_seconds","timezone_local","timezone_utc","tm_countvsyncs","tm_sleep","tm_systemtiming","true","ty_real","ty_string","undefined","vertex_type_color","vertex_type_colour","vertex_type_float1","vertex_type_float2","vertex_type_float3","vertex_type_float4","vertex_type_ubyte4","vertex_usage_binormal","vertex_usage_blendindices","vertex_usage_blendweight","vertex_usage_color","vertex_usage_colour","vertex_usage_depth","vertex_usage_fog","vertex_usage_normal","vertex_usage_position","vertex_usage_psize","vertex_usage_sample","vertex_usage_tangent","vertex_usage_texcoord","video_format_rgba","video_format_yuv","video_status_closed","video_status_paused","video_status_playing","video_status_preparing","vk_add","vk_alt","vk_anykey","vk_backspace","vk_control","vk_decimal","vk_delete","vk_divide","vk_down","vk_end","vk_enter","vk_escape","vk_f1","vk_f10","vk_f11","vk_f12","vk_f2","vk_f3","vk_f4","vk_f5","vk_f6","vk_f7","vk_f8","vk_f9","vk_home","vk_insert","vk_lalt","vk_lcontrol","vk_left","vk_lshift","vk_multiply","vk_nokey","vk_numpad0","vk_numpad1","vk_numpad2","vk_numpad3","vk_numpad4","vk_numpad5","vk_numpad6","vk_numpad7","vk_numpad8","vk_numpad9","vk_pagedown","vk_pageup","vk_pause","vk_printscreen","vk_ralt","vk_rcontrol","vk_return","vk_right","vk_rshift","vk_shift","vk_space","vk_subtract","vk_tab","vk_up","wallpaper_config","wallpaper_subscription_data","wrap"],"variable.language":["alarm","application_surface","argument","argument0","argument1","argument2","argument3","argument4","argument5","argument6","argument7","argument8","argument9","argument10","argument11","argument12","argument13","argument14","argument15","argument_count","async_load","background_color","background_colour","background_showcolor","background_showcolour","bbox_bottom","bbox_left","bbox_right","bbox_top","browser_height","browser_width","colour?ColourTrack","current_day","current_hour","current_minute","current_month","current_second","current_time","current_weekday","current_year","cursor_sprite","debug_mode","delta_time","depth","direction","display_aa","drawn_by_sequence","event_action","event_data","event_number","event_object","event_type","font_texture_page_size","fps","fps_real","friction","game_display_name","game_id","game_project_name","game_save_id","gravity","gravity_direction","health","hspeed","iap_data","id","image_alpha","image_angle","image_blend","image_index","image_number","image_speed","image_xscale","image_yscale","in_collision_tree","in_sequence","instance_count","instance_id","keyboard_key","keyboard_lastchar","keyboard_lastkey","keyboard_string","layer","lives","longMessage","managed","mask_index","message","mouse_button","mouse_lastbutton","mouse_x","mouse_y","object_index","os_browser","os_device","os_type","os_version","path_endaction","path_index","path_orientation","path_position","path_positionprevious","path_scale","path_speed","persistent","phy_active","phy_angular_damping","phy_angular_velocity","phy_bullet","phy_col_normal_x","phy_col_normal_y","phy_collision_points","phy_collision_x","phy_collision_y","phy_com_x","phy_com_y","phy_dynamic","phy_fixed_rotation","phy_inertia","phy_kinematic","phy_linear_damping","phy_linear_velocity_x","phy_linear_velocity_y","phy_mass","phy_position_x","phy_position_xprevious","phy_position_y","phy_position_yprevious","phy_rotation","phy_sleeping","phy_speed","phy_speed_x","phy_speed_y","player_avatar_sprite","player_avatar_url","player_id","player_local","player_type","player_user_id","program_directory","rollback_api_server","rollback_confirmed_frame","rollback_current_frame","rollback_event_id","rollback_event_param","rollback_game_running","room","room_first","room_height","room_last","room_persistent","room_speed","room_width","score","script","sequence_instance","solid","speed","sprite_height","sprite_index","sprite_width","sprite_xoffset","sprite_yoffset","stacktrace","temp_directory","timeline_index","timeline_loop","timeline_position","timeline_running","timeline_speed","view_camera","view_current","view_enabled","view_hport","view_surface_id","view_visible","view_wport","view_xport","view_yport","visible","vspeed","webgl_enabled","working_directory","x","xprevious","xstart","y","yprevious","ystart"]},contains:[e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,e.APOS_STRING_MODE,e.QUOTE_STRING_MODE,e.C_NUMBER_MODE]}}return Pn=t,Pn}var kn,Oo;function G_(){if(Oo)return kn;Oo=1;function t(e){const s={keyword:["break","case","chan","const","continue","default","defer","else","fallthrough","for","func","go","goto","if","import","interface","map","package","range","return","select","struct","switch","type","var"],type:["bool","byte","complex64","complex128","error","float32","float64","int8","int16","int32","int64","string","uint8","uint16","uint32","uint64","int","uint","uintptr","rune"],literal:["true","false","iota","nil"],built_in:["append","cap","close","complex","copy","imag","len","make","new","panic","print","println","real","recover","delete"]};return{name:"Go",aliases:["golang"],keywords:s,illegal:"</",contains:[e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,{className:"string",variants:[e.QUOTE_STRING_MODE,e.APOS_STRING_MODE,{begin:"\`",end:"\`"}]},{className:"number",variants:[{match:/-?\\b0[xX]\\.[a-fA-F0-9](_?[a-fA-F0-9])*[pP][+-]?\\d(_?\\d)*i?/,relevance:0},{match:/-?\\b0[xX](_?[a-fA-F0-9])+((\\.([a-fA-F0-9](_?[a-fA-F0-9])*)?)?[pP][+-]?\\d(_?\\d)*)?i?/,relevance:0},{match:/-?\\b0[oO](_?[0-7])*i?/,relevance:0},{match:/-?\\.\\d(_?\\d)*([eE][+-]?\\d(_?\\d)*)?i?/,relevance:0},{match:/-?\\b\\d(_?\\d)*(\\.(\\d(_?\\d)*)?)?([eE][+-]?\\d(_?\\d)*)?i?/,relevance:0}]},{begin:/:=/},{className:"function",beginKeywords:"func",end:"\\\\s*(\\\\{|$)",excludeEnd:!0,contains:[e.TITLE_MODE,{className:"params",begin:/\\(/,end:/\\)/,endsParent:!0,keywords:s,illegal:/["']/}]}]}}return kn=t,kn}var Un,Io;function Y_(){if(Io)return Un;Io=1;function t(e){return{name:"Golo",keywords:{keyword:["println","readln","print","import","module","function","local","return","let","var","while","for","foreach","times","in","case","when","match","with","break","continue","augment","augmentation","each","find","filter","reduce","if","then","else","otherwise","try","catch","finally","raise","throw","orIfNull","DynamicObject|10","DynamicVariable","struct","Observable","map","set","vector","list","array"],literal:["true","false","null"]},contains:[e.HASH_COMMENT_MODE,e.QUOTE_STRING_MODE,e.C_NUMBER_MODE,{className:"meta",begin:"@[A-Za-z]+"}]}}return Un=t,Un}var Fn,Ao;function q_(){if(Ao)return Fn;Ao=1;function t(e){return{name:"Gradle",case_insensitive:!0,keywords:["task","project","allprojects","subprojects","artifacts","buildscript","configurations","dependencies","repositories","sourceSets","description","delete","from","into","include","exclude","source","classpath","destinationDir","includes","options","sourceCompatibility","targetCompatibility","group","flatDir","doLast","doFirst","flatten","todir","fromdir","ant","def","abstract","break","case","catch","continue","default","do","else","extends","final","finally","for","if","implements","instanceof","native","new","private","protected","public","return","static","switch","synchronized","throw","throws","transient","try","volatile","while","strictfp","package","import","false","null","super","this","true","antlrtask","checkstyle","codenarc","copy","boolean","byte","char","class","double","float","int","interface","long","short","void","compile","runTime","file","fileTree","abs","any","append","asList","asWritable","call","collect","compareTo","count","div","dump","each","eachByte","eachFile","eachLine","every","find","findAll","flatten","getAt","getErr","getIn","getOut","getText","grep","immutable","inject","inspect","intersect","invokeMethods","isCase","join","leftShift","minus","multiply","newInputStream","newOutputStream","newPrintWriter","newReader","newWriter","next","plus","pop","power","previous","print","println","push","putAt","read","readBytes","readLines","reverse","reverseEach","round","size","sort","splitEachLine","step","subMap","times","toInteger","toList","tokenize","upto","waitForOrKill","withPrintWriter","withReader","withStream","withWriter","withWriterAppend","write","writeLine"],contains:[e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,e.APOS_STRING_MODE,e.QUOTE_STRING_MODE,e.NUMBER_MODE,e.REGEXP_MODE]}}return Fn=t,Fn}var Bn,vo;function H_(){if(vo)return Bn;vo=1;function t(e){const n=e.regex,a=/[_A-Za-z][_0-9A-Za-z]*/;return{name:"GraphQL",aliases:["gql"],case_insensitive:!0,disableAutodetect:!1,keywords:{keyword:["query","mutation","subscription","type","input","schema","directive","interface","union","scalar","fragment","enum","on"],literal:["true","false","null"]},contains:[e.HASH_COMMENT_MODE,e.QUOTE_STRING_MODE,e.NUMBER_MODE,{scope:"punctuation",match:/[.]{3}/,relevance:0},{scope:"punctuation",begin:/[\\!\\(\\)\\:\\=\\[\\]\\{\\|\\}]{1}/,relevance:0},{scope:"variable",begin:/\\$/,end:/\\W/,excludeEnd:!0,relevance:0},{scope:"meta",match:/@\\w+/,excludeEnd:!0},{scope:"symbol",begin:n.concat(a,n.lookahead(/\\s*:/)),relevance:0}],illegal:[/[;<']/,/BEGIN/]}}return Bn=t,Bn}var Gn,yo;function V_(){if(yo)return Gn;yo=1;function t(n,a={}){return a.variants=n,a}function e(n){const a=n.regex,r="[A-Za-z0-9_$]+",i=t([n.C_LINE_COMMENT_MODE,n.C_BLOCK_COMMENT_MODE,n.COMMENT("/\\\\*\\\\*","\\\\*/",{relevance:0,contains:[{begin:/\\w+@/,relevance:0},{className:"doctag",begin:"@[A-Za-z]+"}]})]),s={className:"regexp",begin:/~?\\/[^\\/\\n]+\\//,contains:[n.BACKSLASH_ESCAPE]},o=t([n.BINARY_NUMBER_MODE,n.C_NUMBER_MODE]),_=t([{begin:/"""/,end:/"""/},{begin:/'''/,end:/'''/},{begin:"\\\\$/",end:"/\\\\$",relevance:10},n.APOS_STRING_MODE,n.QUOTE_STRING_MODE],{className:"string"}),l={match:[/(class|interface|trait|enum|record|extends|implements)/,/\\s+/,n.UNDERSCORE_IDENT_RE],scope:{1:"keyword",3:"title.class"}};return{name:"Groovy",keywords:{"variable.language":"this super",literal:"true false null",type:["byte","short","char","int","long","boolean","float","double","void"],keyword:["def","as","in","assert","trait","abstract","static","volatile","transient","public","private","protected","synchronized","final","class","interface","enum","if","else","for","while","switch","case","break","default","continue","throw","throws","try","catch","finally","implements","extends","new","import","package","return","instanceof","var"]},contains:[n.SHEBANG({binary:"groovy",relevance:10}),i,_,s,o,l,{className:"meta",begin:"@[A-Za-z]+",relevance:0},{className:"attr",begin:r+"[ 	]*:",relevance:0},{begin:/\\?/,end:/:/,relevance:0,contains:[i,_,s,o,"self"]},{className:"symbol",begin:"^[ 	]*"+a.lookahead(r+":"),excludeBegin:!0,end:r+":",relevance:0}],illegal:/#|<\\//}}return Gn=e,Gn}var Yn,ho;function z_(){if(ho)return Yn;ho=1;function t(e){return{name:"HAML",case_insensitive:!0,contains:[{className:"meta",begin:"^!!!( (5|1\\\\.1|Strict|Frameset|Basic|Mobile|RDFa|XML\\\\b.*))?$",relevance:10},e.COMMENT("^\\\\s*(!=#|=#|-#|/).*$",null,{relevance:0}),{begin:"^\\\\s*(-|=|!=)(?!#)",end:/$/,subLanguage:"ruby",excludeBegin:!0,excludeEnd:!0},{className:"tag",begin:"^\\\\s*%",contains:[{className:"selector-tag",begin:"\\\\w+"},{className:"selector-id",begin:"#[\\\\w-]+"},{className:"selector-class",begin:"\\\\.[\\\\w-]+"},{begin:/\\{\\s*/,end:/\\s*\\}/,contains:[{begin:":\\\\w+\\\\s*=>",end:",\\\\s+",returnBegin:!0,endsWithParent:!0,contains:[{className:"attr",begin:":\\\\w+"},e.APOS_STRING_MODE,e.QUOTE_STRING_MODE,{begin:"\\\\w+",relevance:0}]}]},{begin:"\\\\(\\\\s*",end:"\\\\s*\\\\)",excludeEnd:!0,contains:[{begin:"\\\\w+\\\\s*=",end:"\\\\s+",returnBegin:!0,endsWithParent:!0,contains:[{className:"attr",begin:"\\\\w+",relevance:0},e.APOS_STRING_MODE,e.QUOTE_STRING_MODE,{begin:"\\\\w+",relevance:0}]}]}]},{begin:"^\\\\s*[=~]\\\\s*"},{begin:/#\\{/,end:/\\}/,subLanguage:"ruby",excludeBegin:!0,excludeEnd:!0}]}}return Yn=t,Yn}var qn,Do;function W_(){if(Do)return qn;Do=1;function t(e){const n=e.regex,a={$pattern:/[\\w.\\/]+/,built_in:["action","bindattr","collection","component","concat","debugger","each","each-in","get","hash","if","in","input","link-to","loc","log","lookup","mut","outlet","partial","query-params","render","template","textarea","unbound","unless","view","with","yield"]},r={$pattern:/[\\w.\\/]+/,literal:["true","false","undefined","null"]},i=/""|"[^"]+"/,s=/''|'[^']+'/,o=/\\[\\]|\\[[^\\]]+\\]/,_=/[^\\s!"#%&'()*+,.\\/;<=>@\\[\\\\\\]^\`{|}~]+/,l=/(\\.|\\/)/,c=n.either(i,s,o,_),d=n.concat(n.optional(/\\.|\\.\\/|\\//),c,n.anyNumberOfTimes(n.concat(l,c))),m=n.concat("(",o,"|",_,")(?==)"),p={begin:d},E=e.inherit(p,{keywords:r}),g={begin:/\\(/,end:/\\)/},S={className:"attr",begin:m,relevance:0,starts:{begin:/=/,end:/=/,starts:{contains:[e.NUMBER_MODE,e.QUOTE_STRING_MODE,e.APOS_STRING_MODE,E,g]}}},T={begin:/as\\s+\\|/,keywords:{keyword:"as"},end:/\\|/,contains:[{begin:/\\w+/}]},R={contains:[e.NUMBER_MODE,e.QUOTE_STRING_MODE,e.APOS_STRING_MODE,T,S,E,g],returnEnd:!0},f=e.inherit(p,{className:"name",keywords:a,starts:e.inherit(R,{end:/\\)/})});g.contains=[f];const A=e.inherit(p,{keywords:a,className:"name",starts:e.inherit(R,{end:/\\}\\}/})}),N=e.inherit(p,{keywords:a,className:"name"}),C=e.inherit(p,{className:"name",keywords:a,starts:e.inherit(R,{end:/\\}\\}/})});return{name:"Handlebars",aliases:["hbs","html.hbs","html.handlebars","htmlbars"],case_insensitive:!0,subLanguage:"xml",contains:[{begin:/\\\\\\{\\{/,skip:!0},{begin:/\\\\\\\\(?=\\{\\{)/,skip:!0},e.COMMENT(/\\{\\{!--/,/--\\}\\}/),e.COMMENT(/\\{\\{!/,/\\}\\}/),{className:"template-tag",begin:/\\{\\{\\{\\{(?!\\/)/,end:/\\}\\}\\}\\}/,contains:[A],starts:{end:/\\{\\{\\{\\{\\//,returnEnd:!0,subLanguage:"xml"}},{className:"template-tag",begin:/\\{\\{\\{\\{\\//,end:/\\}\\}\\}\\}/,contains:[N]},{className:"template-tag",begin:/\\{\\{#/,end:/\\}\\}/,contains:[A]},{className:"template-tag",begin:/\\{\\{(?=else\\}\\})/,end:/\\}\\}/,keywords:"else"},{className:"template-tag",begin:/\\{\\{(?=else if)/,end:/\\}\\}/,keywords:"else if"},{className:"template-tag",begin:/\\{\\{\\//,end:/\\}\\}/,contains:[N]},{className:"template-variable",begin:/\\{\\{\\{/,end:/\\}\\}\\}/,contains:[C]},{className:"template-variable",begin:/\\{\\{/,end:/\\}\\}/,contains:[C]}]}}return qn=t,qn}var Hn,Mo;function K_(){if(Mo)return Hn;Mo=1;function t(e){const n="([0-9]_*)+",a="([0-9a-fA-F]_*)+",r="([01]_*)+",i="([0-7]_*)+",l="([!#$%&*+.\\\\/<=>?@\\\\\\\\^~-]|(?!([(),;\\\\[\\\\]\`|{}]|[_:\\"']))(\\\\p{S}|\\\\p{P}))",c={variants:[e.COMMENT("--+","$"),e.COMMENT(/\\{-/,/-\\}/,{contains:["self"]})]},d={className:"meta",begin:/\\{-#/,end:/#-\\}/},m={className:"meta",begin:"^#",end:"$"},p={className:"type",begin:"\\\\b[A-Z][\\\\w']*",relevance:0},E={begin:"\\\\(",end:"\\\\)",illegal:'"',contains:[d,m,{className:"type",begin:"\\\\b[A-Z][\\\\w]*(\\\\((\\\\.\\\\.|,|\\\\w+)\\\\))?"},e.inherit(e.TITLE_MODE,{begin:"[_a-z][\\\\w']*"}),c]},g={begin:/\\{/,end:/\\}/,contains:E.contains},S={className:"number",relevance:0,variants:[{match:\`\\\\b(\${n})(\\\\.(\${n}))?([eE][+-]?(\${n}))?\\\\b\`},{match:\`\\\\b0[xX]_*(\${a})(\\\\.(\${a}))?([pP][+-]?(\${n}))?\\\\b\`},{match:\`\\\\b0[oO](\${i})\\\\b\`},{match:\`\\\\b0[bB](\${r})\\\\b\`}]};return{name:"Haskell",aliases:["hs"],keywords:"let in if then else case of where do module import hiding qualified type data newtype deriving class instance as default infix infixl infixr foreign export ccall stdcall cplusplus jvm dotnet safe unsafe family forall mdo proc rec",unicodeRegex:!0,contains:[{beginKeywords:"module",end:"where",keywords:"module where",contains:[E,c],illegal:"\\\\W\\\\.|;"},{begin:"\\\\bimport\\\\b",end:"$",keywords:"import qualified as hiding",contains:[E,c],illegal:"\\\\W\\\\.|;"},{className:"class",begin:"^(\\\\s*)?(class|instance)\\\\b",end:"where",keywords:"class family instance where",contains:[p,E,c]},{className:"class",begin:"\\\\b(data|(new)?type)\\\\b",end:"$",keywords:"data family type newtype deriving",contains:[d,p,E,g,c]},{beginKeywords:"default",end:"$",contains:[p,E,c]},{beginKeywords:"infix infixl infixr",end:"$",contains:[e.C_NUMBER_MODE,c]},{begin:"\\\\bforeign\\\\b",end:"$",keywords:"foreign import export ccall stdcall cplusplus jvm dotnet safe unsafe",contains:[p,e.QUOTE_STRING_MODE,c]},{className:"meta",begin:"#!\\\\/usr\\\\/bin\\\\/env runhaskell",end:"$"},d,m,{scope:"string",begin:/'(?=\\\\?.')/,end:/'/,contains:[{scope:"char.escape",match:/\\\\./}]},e.QUOTE_STRING_MODE,S,p,e.inherit(e.TITLE_MODE,{begin:"^[_a-z][\\\\w']*"}),{begin:\`(?!-)\${l}--+|--+(?!-)\${l}\`},c,{begin:"->|<-"}]}}return Hn=t,Hn}var Vn,Lo;function $_(){if(Lo)return Vn;Lo=1;function t(e){const n="[a-zA-Z_$][a-zA-Z0-9_$]*",a=/(-?)(\\b0[xX][a-fA-F0-9_]+|(\\b\\d+(\\.[\\d_]*)?|\\.[\\d_]+)(([eE][-+]?\\d+)|i32|u32|i64|f64)?)/;return{name:"Haxe",aliases:["hx"],keywords:{keyword:"abstract break case cast catch continue default do dynamic else enum extern final for function here if import in inline is macro never new override package private get set public return static super switch this throw trace try typedef untyped using var while "+"Int Float String Bool Dynamic Void Array ",built_in:"trace this",literal:"true false null _"},contains:[{className:"string",begin:"'",end:"'",contains:[e.BACKSLASH_ESCAPE,{className:"subst",begin:/\\$\\{/,end:/\\}/},{className:"subst",begin:/\\$/,end:/\\W\\}/}]},e.QUOTE_STRING_MODE,e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,{className:"number",begin:a,relevance:0},{className:"variable",begin:"\\\\$"+n},{className:"meta",begin:/@:?/,end:/\\(|$/,excludeEnd:!0},{className:"meta",begin:"#",end:"$",keywords:{keyword:"if else elseif end error"}},{className:"type",begin:/:[ \\t]*/,end:/[^A-Za-z0-9_ \\t\\->]/,excludeBegin:!0,excludeEnd:!0,relevance:0},{className:"type",begin:/:[ \\t]*/,end:/\\W/,excludeBegin:!0,excludeEnd:!0},{className:"type",beginKeywords:"new",end:/\\W/,excludeBegin:!0,excludeEnd:!0},{className:"title.class",beginKeywords:"enum",end:/\\{/,contains:[e.TITLE_MODE]},{className:"title.class",begin:"\\\\babstract\\\\b(?=\\\\s*"+e.IDENT_RE+"\\\\s*\\\\()",end:/[\\{$]/,contains:[{className:"type",begin:/\\(/,end:/\\)/,excludeBegin:!0,excludeEnd:!0},{className:"type",begin:/from +/,end:/\\W/,excludeBegin:!0,excludeEnd:!0},{className:"type",begin:/to +/,end:/\\W/,excludeBegin:!0,excludeEnd:!0},e.TITLE_MODE],keywords:{keyword:"abstract from to"}},{className:"title.class",begin:/\\b(class|interface) +/,end:/[\\{$]/,excludeEnd:!0,keywords:"class interface",contains:[{className:"keyword",begin:/\\b(extends|implements) +/,keywords:"extends implements",contains:[{className:"type",begin:e.IDENT_RE,relevance:0}]},e.TITLE_MODE]},{className:"title.function",beginKeywords:"function",end:/\\(/,excludeEnd:!0,illegal:/\\S/,contains:[e.TITLE_MODE]}],illegal:/<\\//}}return Vn=t,Vn}var zn,xo;function Q_(){if(xo)return zn;xo=1;function t(e){return{name:"HSP",case_insensitive:!0,keywords:{$pattern:/[\\w._]+/,keyword:"goto gosub return break repeat loop continue wait await dim sdim foreach dimtype dup dupptr end stop newmod delmod mref run exgoto on mcall assert logmes newlab resume yield onexit onerror onkey onclick oncmd exist delete mkdir chdir dirlist bload bsave bcopy memfile if else poke wpoke lpoke getstr chdpm memexpand memcpy memset notesel noteadd notedel noteload notesave randomize noteunsel noteget split strrep setease button chgdisp exec dialog mmload mmplay mmstop mci pset pget syscolor mes print title pos circle cls font sysfont objsize picload color palcolor palette redraw width gsel gcopy gzoom gmode bmpsave hsvcolor getkey listbox chkbox combox input mesbox buffer screen bgscr mouse objsel groll line clrobj boxf objprm objmode stick grect grotate gsquare gradf objimage objskip objenable celload celdiv celput newcom querycom delcom cnvstow comres axobj winobj sendmsg comevent comevarg sarrayconv callfunc cnvwtos comevdisp libptr system hspstat hspver stat cnt err strsize looplev sublev iparam wparam lparam refstr refdval int rnd strlen length length2 length3 length4 vartype gettime peek wpeek lpeek varptr varuse noteinfo instr abs limit getease str strmid strf getpath strtrim sin cos tan atan sqrt double absf expf logf limitf powf geteasef mousex mousey mousew hwnd hinstance hdc ginfo objinfo dirinfo sysinfo thismod __hspver__ __hsp30__ __date__ __time__ __line__ __file__ _debug __hspdef__ and or xor not screen_normal screen_palette screen_hide screen_fixedsize screen_tool screen_frame gmode_gdi gmode_mem gmode_rgb0 gmode_alpha gmode_rgb0alpha gmode_add gmode_sub gmode_pixela ginfo_mx ginfo_my ginfo_act ginfo_sel ginfo_wx1 ginfo_wy1 ginfo_wx2 ginfo_wy2 ginfo_vx ginfo_vy ginfo_sizex ginfo_sizey ginfo_winx ginfo_winy ginfo_mesx ginfo_mesy ginfo_r ginfo_g ginfo_b ginfo_paluse ginfo_dispx ginfo_dispy ginfo_cx ginfo_cy ginfo_intid ginfo_newid ginfo_sx ginfo_sy objinfo_mode objinfo_bmscr objinfo_hwnd notemax notesize dir_cur dir_exe dir_win dir_sys dir_cmdline dir_desktop dir_mydoc dir_tv font_normal font_bold font_italic font_underline font_strikeout font_antialias objmode_normal objmode_guifont objmode_usefont gsquare_grad msgothic msmincho do until while wend for next _break _continue switch case default swbreak swend ddim ldim alloc m_pi rad2deg deg2rad ease_linear ease_quad_in ease_quad_out ease_quad_inout ease_cubic_in ease_cubic_out ease_cubic_inout ease_quartic_in ease_quartic_out ease_quartic_inout ease_bounce_in ease_bounce_out ease_bounce_inout ease_shake_in ease_shake_out ease_shake_inout ease_loop"},contains:[e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,e.QUOTE_STRING_MODE,e.APOS_STRING_MODE,{className:"string",begin:/\\{"/,end:/"\\}/,contains:[e.BACKSLASH_ESCAPE]},e.COMMENT(";","$",{relevance:0}),{className:"meta",begin:"#",end:"$",keywords:{keyword:"addion cfunc cmd cmpopt comfunc const defcfunc deffunc define else endif enum epack func global if ifdef ifndef include modcfunc modfunc modinit modterm module pack packopt regcmd runtime undef usecom uselib"},contains:[e.inherit(e.QUOTE_STRING_MODE,{className:"string"}),e.NUMBER_MODE,e.C_NUMBER_MODE,e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE]},{className:"symbol",begin:"^\\\\*(\\\\w+|@)"},e.NUMBER_MODE,e.C_NUMBER_MODE]}}return zn=t,zn}var Wn,wo;function X_(){if(wo)return Wn;wo=1;function t(e){const n=e.regex,a="HTTP/([32]|1\\\\.[01])",r=/[A-Za-z][A-Za-z0-9-]*/,i={className:"attribute",begin:n.concat("^",r,"(?=\\\\:\\\\s)"),starts:{contains:[{className:"punctuation",begin:/: /,relevance:0,starts:{end:"$",relevance:0}}]}},s=[i,{begin:"\\\\n\\\\n",starts:{subLanguage:[],endsWithParent:!0}}];return{name:"HTTP",aliases:["https"],illegal:/\\S/,contains:[{begin:"^(?="+a+" \\\\d{3})",end:/$/,contains:[{className:"meta",begin:a},{className:"number",begin:"\\\\b\\\\d{3}\\\\b"}],starts:{end:/\\b\\B/,illegal:/\\S/,contains:s}},{begin:"(?=^[A-Z]+ (.*?) "+a+"$)",end:/$/,contains:[{className:"string",begin:" ",end:" ",excludeBegin:!0,excludeEnd:!0},{className:"meta",begin:a},{className:"keyword",begin:"[A-Z]+"}],starts:{end:/\\b\\B/,illegal:/\\S/,contains:s}},e.inherit(i,{relevance:0})]}}return Wn=t,Wn}var Kn,Po;function Z_(){if(Po)return Kn;Po=1;function t(e){const n="a-zA-Z_\\\\-!.?+*=<>&#'",a="["+n+"]["+n+"0-9/;:]*",r={$pattern:a,built_in:"!= % %= & &= * ** **= *= *map + += , --build-class-- --import-- -= . / // //= /= < << <<= <= = > >= >> >>= @ @= ^ ^= abs accumulate all and any ap-compose ap-dotimes ap-each ap-each-while ap-filter ap-first ap-if ap-last ap-map ap-map-when ap-pipe ap-reduce ap-reject apply as-> ascii assert assoc bin break butlast callable calling-module-name car case cdr chain chr coll? combinations compile compress cond cons cons? continue count curry cut cycle dec def default-method defclass defmacro defmacro-alias defmacro/g! defmain defmethod defmulti defn defn-alias defnc defnr defreader defseq del delattr delete-route dict-comp dir disassemble dispatch-reader-macro distinct divmod do doto drop drop-last drop-while empty? end-sequence eval eval-and-compile eval-when-compile even? every? except exec filter first flatten float? fn fnc fnr for for* format fraction genexpr gensym get getattr global globals group-by hasattr hash hex id identity if if* if-not if-python2 import in inc input instance? integer integer-char? integer? interleave interpose is is-coll is-cons is-empty is-even is-every is-float is-instance is-integer is-integer-char is-iterable is-iterator is-keyword is-neg is-none is-not is-numeric is-odd is-pos is-string is-symbol is-zero isinstance islice issubclass iter iterable? iterate iterator? keyword keyword? lambda last len let lif lif-not list* list-comp locals loop macro-error macroexpand macroexpand-1 macroexpand-all map max merge-with method-decorator min multi-decorator multicombinations name neg? next none? nonlocal not not-in not? nth numeric? oct odd? open or ord partition permutations pos? post-route postwalk pow prewalk print product profile/calls profile/cpu put-route quasiquote quote raise range read read-str recursive-replace reduce remove repeat repeatedly repr require rest round route route-with-methods rwm second seq set-comp setattr setv some sorted string string? sum switch symbol? take take-nth take-while tee try unless unquote unquote-splicing vars walk when while with with* with-decorator with-gensyms xi xor yield yield-from zero? zip zip-longest | |= ~"},i="[-+]?\\\\d+(\\\\.\\\\d+)?",s={begin:a,relevance:0},o={className:"number",begin:i,relevance:0},_=e.inherit(e.QUOTE_STRING_MODE,{illegal:null}),l=e.COMMENT(";","$",{relevance:0}),c={className:"literal",begin:/\\b([Tt]rue|[Ff]alse|nil|None)\\b/},d={begin:"[\\\\[\\\\{]",end:"[\\\\]\\\\}]",relevance:0},m={className:"comment",begin:"\\\\^"+a},p=e.COMMENT("\\\\^\\\\{","\\\\}"),E={className:"symbol",begin:"[:]{1,2}"+a},g={begin:"\\\\(",end:"\\\\)"},S={endsWithParent:!0,relevance:0},T={className:"name",relevance:0,keywords:r,begin:a,starts:S},R=[g,_,m,p,l,E,d,o,c,s];return g.contains=[e.COMMENT("comment",""),T,S],S.contains=R,d.contains=R,{name:"Hy",aliases:["hylang"],illegal:/\\S/,contains:[e.SHEBANG(),g,_,m,p,l,E,d,o,c]}}return Kn=t,Kn}var $n,ko;function J_(){if(ko)return $n;ko=1;function t(e){const n="\\\\[",a="\\\\]";return{name:"Inform 7",aliases:["i7"],case_insensitive:!0,keywords:{keyword:"thing room person man woman animal container supporter backdrop door scenery open closed locked inside gender is are say understand kind of rule"},contains:[{className:"string",begin:'"',end:'"',relevance:0,contains:[{className:"subst",begin:n,end:a}]},{className:"section",begin:/^(Volume|Book|Part|Chapter|Section|Table)\\b/,end:"$"},{begin:/^(Check|Carry out|Report|Instead of|To|Rule|When|Before|After)\\b/,end:":",contains:[{begin:"\\\\(This",end:"\\\\)"}]},{className:"comment",begin:n,end:a,contains:["self"]}]}}return $n=t,$n}var Qn,Uo;function j_(){if(Uo)return Qn;Uo=1;function t(e){const n=e.regex,a={className:"number",relevance:0,variants:[{begin:/([+-]+)?[\\d]+_[\\d_]+/},{begin:e.NUMBER_RE}]},r=e.COMMENT();r.variants=[{begin:/;/,end:/$/},{begin:/#/,end:/$/}];const i={className:"variable",variants:[{begin:/\\$[\\w\\d"][\\w\\d_]*/},{begin:/\\$\\{(.*?)\\}/}]},s={className:"literal",begin:/\\bon|off|true|false|yes|no\\b/},o={className:"string",contains:[e.BACKSLASH_ESCAPE],variants:[{begin:"'''",end:"'''",relevance:10},{begin:'"""',end:'"""',relevance:10},{begin:'"',end:'"'},{begin:"'",end:"'"}]},_={begin:/\\[/,end:/\\]/,contains:[r,s,i,o,a,"self"],relevance:0},l=/[A-Za-z0-9_-]+/,c=/"(\\\\"|[^"])*"/,d=/'[^']*'/,m=n.either(l,c,d),p=n.concat(m,"(\\\\s*\\\\.\\\\s*",m,")*",n.lookahead(/\\s*=\\s*[^#\\s]/));return{name:"TOML, also INI",aliases:["toml"],case_insensitive:!0,illegal:/\\S/,contains:[r,{className:"section",begin:/\\[+/,end:/\\]+/},{begin:p,className:"attr",starts:{end:/$/,contains:[r,_,s,i,o,a]}}]}}return Qn=t,Qn}var Xn,Fo;function ed(){if(Fo)return Xn;Fo=1;function t(e){const n=e.regex,a={className:"params",begin:"\\\\(",end:"\\\\)"},r=/(_[a-z_\\d]+)?/,i=/([de][+-]?\\d+)?/,s={className:"number",variants:[{begin:n.concat(/\\b\\d+/,/\\.(\\d*)/,i,r)},{begin:n.concat(/\\b\\d+/,i,r)},{begin:n.concat(/\\.\\d+/,i,r)}],relevance:0};return{name:"IRPF90",case_insensitive:!0,keywords:{literal:".False. .True.",keyword:"kind do while private call intrinsic where elsewhere type endtype endmodule endselect endinterface end enddo endif if forall endforall only contains default return stop then public subroutine|10 function program .and. .or. .not. .le. .eq. .ge. .gt. .lt. goto save else use module select case access blank direct exist file fmt form formatted iostat name named nextrec number opened rec recl sequential status unformatted unit continue format pause cycle exit c_null_char c_alert c_backspace c_form_feed flush wait decimal round iomsg synchronous nopass non_overridable pass protected volatile abstract extends import non_intrinsic value deferred generic final enumerator class associate bind enum c_int c_short c_long c_long_long c_signed_char c_size_t c_int8_t c_int16_t c_int32_t c_int64_t c_int_least8_t c_int_least16_t c_int_least32_t c_int_least64_t c_int_fast8_t c_int_fast16_t c_int_fast32_t c_int_fast64_t c_intmax_t C_intptr_t c_float c_double c_long_double c_float_complex c_double_complex c_long_double_complex c_bool c_char c_null_ptr c_null_funptr c_new_line c_carriage_return c_horizontal_tab c_vertical_tab iso_c_binding c_loc c_funloc c_associated  c_f_pointer c_ptr c_funptr iso_fortran_env character_storage_size error_unit file_storage_size input_unit iostat_end iostat_eor numeric_storage_size output_unit c_f_procpointer ieee_arithmetic ieee_support_underflow_control ieee_get_underflow_mode ieee_set_underflow_mode newunit contiguous recursive pad position action delim readwrite eor advance nml interface procedure namelist include sequence elemental pure integer real character complex logical dimension allocatable|10 parameter external implicit|10 none double precision assign intent optional pointer target in out common equivalence data begin_provider &begin_provider end_provider begin_shell end_shell begin_template end_template subst assert touch soft_touch provide no_dep free irp_if irp_else irp_endif irp_write irp_read",built_in:"alog alog10 amax0 amax1 amin0 amin1 amod cabs ccos cexp clog csin csqrt dabs dacos dasin datan datan2 dcos dcosh ddim dexp dint dlog dlog10 dmax1 dmin1 dmod dnint dsign dsin dsinh dsqrt dtan dtanh float iabs idim idint idnint ifix isign max0 max1 min0 min1 sngl algama cdabs cdcos cdexp cdlog cdsin cdsqrt cqabs cqcos cqexp cqlog cqsin cqsqrt dcmplx dconjg derf derfc dfloat dgamma dimag dlgama iqint qabs qacos qasin qatan qatan2 qcmplx qconjg qcos qcosh qdim qerf qerfc qexp qgamma qimag qlgama qlog qlog10 qmax1 qmin1 qmod qnint qsign qsin qsinh qsqrt qtan qtanh abs acos aimag aint anint asin atan atan2 char cmplx conjg cos cosh exp ichar index int log log10 max min nint sign sin sinh sqrt tan tanh print write dim lge lgt lle llt mod nullify allocate deallocate adjustl adjustr all allocated any associated bit_size btest ceiling count cshift date_and_time digits dot_product eoshift epsilon exponent floor fraction huge iand ibclr ibits ibset ieor ior ishft ishftc lbound len_trim matmul maxexponent maxloc maxval merge minexponent minloc minval modulo mvbits nearest pack present product radix random_number random_seed range repeat reshape rrspacing scale scan selected_int_kind selected_real_kind set_exponent shape size spacing spread sum system_clock tiny transpose trim ubound unpack verify achar iachar transfer dble entry dprod cpu_time command_argument_count get_command get_command_argument get_environment_variable is_iostat_end ieee_arithmetic ieee_support_underflow_control ieee_get_underflow_mode ieee_set_underflow_mode is_iostat_eor move_alloc new_line selected_char_kind same_type_as extends_type_of acosh asinh atanh bessel_j0 bessel_j1 bessel_jn bessel_y0 bessel_y1 bessel_yn erf erfc erfc_scaled gamma log_gamma hypot norm2 atomic_define atomic_ref execute_command_line leadz trailz storage_size merge_bits bge bgt ble blt dshiftl dshiftr findloc iall iany iparity image_index lcobound ucobound maskl maskr num_images parity popcnt poppar shifta shiftl shiftr this_image IRP_ALIGN irp_here"},illegal:/\\/\\*/,contains:[e.inherit(e.APOS_STRING_MODE,{className:"string",relevance:0}),e.inherit(e.QUOTE_STRING_MODE,{className:"string",relevance:0}),{className:"function",beginKeywords:"subroutine function program",illegal:"[\${=\\\\n]",contains:[e.UNDERSCORE_TITLE_MODE,a]},e.COMMENT("!","$",{relevance:0}),e.COMMENT("begin_doc","end_doc",{relevance:10}),s]}}return Xn=t,Xn}var Zn,Bo;function td(){if(Bo)return Zn;Bo=1;function t(e){const n="[A-Za-zА-Яа-яёЁ_!][A-Za-zА-Яа-яёЁ_0-9]*",a="[A-Za-zА-Яа-яёЁ_][A-Za-zА-Яа-яёЁ_0-9]*",r="and и else иначе endexcept endfinally endforeach конецвсе endif конецесли endwhile конецпока except exitfor finally foreach все if если in в not не or или try while пока ",se="SYSRES_CONST_ACCES_RIGHT_TYPE_EDIT SYSRES_CONST_ACCES_RIGHT_TYPE_FULL SYSRES_CONST_ACCES_RIGHT_TYPE_VIEW SYSRES_CONST_ACCESS_MODE_REQUISITE_CODE SYSRES_CONST_ACCESS_NO_ACCESS_VIEW SYSRES_CONST_ACCESS_NO_ACCESS_VIEW_CODE SYSRES_CONST_ACCESS_RIGHTS_ADD_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_ADD_REQUISITE_YES_CODE SYSRES_CONST_ACCESS_RIGHTS_CHANGE_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_CHANGE_REQUISITE_YES_CODE SYSRES_CONST_ACCESS_RIGHTS_DELETE_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_DELETE_REQUISITE_YES_CODE SYSRES_CONST_ACCESS_RIGHTS_EXECUTE_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_EXECUTE_REQUISITE_YES_CODE SYSRES_CONST_ACCESS_RIGHTS_NO_ACCESS_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_NO_ACCESS_REQUISITE_YES_CODE SYSRES_CONST_ACCESS_RIGHTS_RATIFY_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_RATIFY_REQUISITE_YES_CODE SYSRES_CONST_ACCESS_RIGHTS_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_VIEW SYSRES_CONST_ACCESS_RIGHTS_VIEW_CODE SYSRES_CONST_ACCESS_RIGHTS_VIEW_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_VIEW_REQUISITE_YES_CODE SYSRES_CONST_ACCESS_TYPE_CHANGE SYSRES_CONST_ACCESS_TYPE_CHANGE_CODE SYSRES_CONST_ACCESS_TYPE_EXISTS SYSRES_CONST_ACCESS_TYPE_EXISTS_CODE SYSRES_CONST_ACCESS_TYPE_FULL SYSRES_CONST_ACCESS_TYPE_FULL_CODE SYSRES_CONST_ACCESS_TYPE_VIEW SYSRES_CONST_ACCESS_TYPE_VIEW_CODE SYSRES_CONST_ACTION_TYPE_ABORT SYSRES_CONST_ACTION_TYPE_ACCEPT SYSRES_CONST_ACTION_TYPE_ACCESS_RIGHTS SYSRES_CONST_ACTION_TYPE_ADD_ATTACHMENT SYSRES_CONST_ACTION_TYPE_CHANGE_CARD SYSRES_CONST_ACTION_TYPE_CHANGE_KIND SYSRES_CONST_ACTION_TYPE_CHANGE_STORAGE SYSRES_CONST_ACTION_TYPE_CONTINUE SYSRES_CONST_ACTION_TYPE_COPY SYSRES_CONST_ACTION_TYPE_CREATE SYSRES_CONST_ACTION_TYPE_CREATE_VERSION SYSRES_CONST_ACTION_TYPE_DELETE SYSRES_CONST_ACTION_TYPE_DELETE_ATTACHMENT SYSRES_CONST_ACTION_TYPE_DELETE_VERSION SYSRES_CONST_ACTION_TYPE_DISABLE_DELEGATE_ACCESS_RIGHTS SYSRES_CONST_ACTION_TYPE_ENABLE_DELEGATE_ACCESS_RIGHTS SYSRES_CONST_ACTION_TYPE_ENCRYPTION_BY_CERTIFICATE SYSRES_CONST_ACTION_TYPE_ENCRYPTION_BY_CERTIFICATE_AND_PASSWORD SYSRES_CONST_ACTION_TYPE_ENCRYPTION_BY_PASSWORD SYSRES_CONST_ACTION_TYPE_EXPORT_WITH_LOCK SYSRES_CONST_ACTION_TYPE_EXPORT_WITHOUT_LOCK SYSRES_CONST_ACTION_TYPE_IMPORT_WITH_UNLOCK SYSRES_CONST_ACTION_TYPE_IMPORT_WITHOUT_UNLOCK SYSRES_CONST_ACTION_TYPE_LIFE_CYCLE_STAGE SYSRES_CONST_ACTION_TYPE_LOCK SYSRES_CONST_ACTION_TYPE_LOCK_FOR_SERVER SYSRES_CONST_ACTION_TYPE_LOCK_MODIFY SYSRES_CONST_ACTION_TYPE_MARK_AS_READED SYSRES_CONST_ACTION_TYPE_MARK_AS_UNREADED SYSRES_CONST_ACTION_TYPE_MODIFY SYSRES_CONST_ACTION_TYPE_MODIFY_CARD SYSRES_CONST_ACTION_TYPE_MOVE_TO_ARCHIVE SYSRES_CONST_ACTION_TYPE_OFF_ENCRYPTION SYSRES_CONST_ACTION_TYPE_PASSWORD_CHANGE SYSRES_CONST_ACTION_TYPE_PERFORM SYSRES_CONST_ACTION_TYPE_RECOVER_FROM_LOCAL_COPY SYSRES_CONST_ACTION_TYPE_RESTART SYSRES_CONST_ACTION_TYPE_RESTORE_FROM_ARCHIVE SYSRES_CONST_ACTION_TYPE_REVISION SYSRES_CONST_ACTION_TYPE_SEND_BY_MAIL SYSRES_CONST_ACTION_TYPE_SIGN SYSRES_CONST_ACTION_TYPE_START SYSRES_CONST_ACTION_TYPE_UNLOCK SYSRES_CONST_ACTION_TYPE_UNLOCK_FROM_SERVER SYSRES_CONST_ACTION_TYPE_VERSION_STATE SYSRES_CONST_ACTION_TYPE_VERSION_VISIBILITY SYSRES_CONST_ACTION_TYPE_VIEW SYSRES_CONST_ACTION_TYPE_VIEW_SHADOW_COPY SYSRES_CONST_ACTION_TYPE_WORKFLOW_DESCRIPTION_MODIFY SYSRES_CONST_ACTION_TYPE_WRITE_HISTORY SYSRES_CONST_ACTIVE_VERSION_STATE_PICK_VALUE SYSRES_CONST_ADD_REFERENCE_MODE_NAME SYSRES_CONST_ADDITION_REQUISITE_CODE SYSRES_CONST_ADDITIONAL_PARAMS_REQUISITE_CODE SYSRES_CONST_ADITIONAL_JOB_END_DATE_REQUISITE_NAME SYSRES_CONST_ADITIONAL_JOB_READ_REQUISITE_NAME SYSRES_CONST_ADITIONAL_JOB_START_DATE_REQUISITE_NAME SYSRES_CONST_ADITIONAL_JOB_STATE_REQUISITE_NAME SYSRES_CONST_ADMINISTRATION_HISTORY_ADDING_USER_TO_GROUP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_ADDING_USER_TO_GROUP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_CREATION_COMP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_CREATION_COMP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_CREATION_GROUP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_CREATION_GROUP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_CREATION_USER_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_CREATION_USER_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_DATABASE_USER_CREATION SYSRES_CONST_ADMINISTRATION_HISTORY_DATABASE_USER_CREATION_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_DATABASE_USER_DELETION SYSRES_CONST_ADMINISTRATION_HISTORY_DATABASE_USER_DELETION_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_COMP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_COMP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_GROUP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_GROUP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_USER_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_USER_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_USER_FROM_GROUP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_USER_FROM_GROUP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_FILTERER_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_FILTERER_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_FILTERER_RESTRICTION_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_FILTERER_RESTRICTION_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_PRIVILEGE_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_PRIVILEGE_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_RIGHTS_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_RIGHTS_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_IS_MAIN_SERVER_CHANGED_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_IS_MAIN_SERVER_CHANGED_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_IS_PUBLIC_CHANGED_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_IS_PUBLIC_CHANGED_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_FILTERER_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_FILTERER_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_FILTERER_RESTRICTION_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_FILTERER_RESTRICTION_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_PRIVILEGE_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_PRIVILEGE_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_RIGHTS_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_RIGHTS_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_SERVER_LOGIN_CREATION SYSRES_CONST_ADMINISTRATION_HISTORY_SERVER_LOGIN_CREATION_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_SERVER_LOGIN_DELETION SYSRES_CONST_ADMINISTRATION_HISTORY_SERVER_LOGIN_DELETION_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_CATEGORY_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_CATEGORY_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_COMP_TITLE_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_COMP_TITLE_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_FULL_NAME_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_FULL_NAME_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_GROUP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_GROUP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_PARENT_GROUP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_PARENT_GROUP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_USER_AUTH_TYPE_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_USER_AUTH_TYPE_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_USER_LOGIN_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_USER_LOGIN_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_USER_STATUS_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_USER_STATUS_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_USER_PASSWORD_CHANGE SYSRES_CONST_ADMINISTRATION_HISTORY_USER_PASSWORD_CHANGE_ACTION SYSRES_CONST_ALL_ACCEPT_CONDITION_RUS SYSRES_CONST_ALL_USERS_GROUP SYSRES_CONST_ALL_USERS_GROUP_NAME SYSRES_CONST_ALL_USERS_SERVER_GROUP_NAME SYSRES_CONST_ALLOWED_ACCESS_TYPE_CODE SYSRES_CONST_ALLOWED_ACCESS_TYPE_NAME SYSRES_CONST_APP_VIEWER_TYPE_REQUISITE_CODE SYSRES_CONST_APPROVING_SIGNATURE_NAME SYSRES_CONST_APPROVING_SIGNATURE_REQUISITE_CODE SYSRES_CONST_ASSISTANT_SUBSTITUE_TYPE SYSRES_CONST_ASSISTANT_SUBSTITUE_TYPE_CODE SYSRES_CONST_ATTACH_TYPE_COMPONENT_TOKEN SYSRES_CONST_ATTACH_TYPE_DOC SYSRES_CONST_ATTACH_TYPE_EDOC SYSRES_CONST_ATTACH_TYPE_FOLDER SYSRES_CONST_ATTACH_TYPE_JOB SYSRES_CONST_ATTACH_TYPE_REFERENCE SYSRES_CONST_ATTACH_TYPE_TASK SYSRES_CONST_AUTH_ENCODED_PASSWORD SYSRES_CONST_AUTH_ENCODED_PASSWORD_CODE SYSRES_CONST_AUTH_NOVELL SYSRES_CONST_AUTH_PASSWORD SYSRES_CONST_AUTH_PASSWORD_CODE SYSRES_CONST_AUTH_WINDOWS SYSRES_CONST_AUTHENTICATING_SIGNATURE_NAME SYSRES_CONST_AUTHENTICATING_SIGNATURE_REQUISITE_CODE SYSRES_CONST_AUTO_ENUM_METHOD_FLAG SYSRES_CONST_AUTO_NUMERATION_CODE SYSRES_CONST_AUTO_STRONG_ENUM_METHOD_FLAG SYSRES_CONST_AUTOTEXT_NAME_REQUISITE_CODE SYSRES_CONST_AUTOTEXT_TEXT_REQUISITE_CODE SYSRES_CONST_AUTOTEXT_USAGE_ALL SYSRES_CONST_AUTOTEXT_USAGE_ALL_CODE SYSRES_CONST_AUTOTEXT_USAGE_SIGN SYSRES_CONST_AUTOTEXT_USAGE_SIGN_CODE SYSRES_CONST_AUTOTEXT_USAGE_WORK SYSRES_CONST_AUTOTEXT_USAGE_WORK_CODE SYSRES_CONST_AUTOTEXT_USE_ANYWHERE_CODE SYSRES_CONST_AUTOTEXT_USE_ON_SIGNING_CODE SYSRES_CONST_AUTOTEXT_USE_ON_WORK_CODE SYSRES_CONST_BEGIN_DATE_REQUISITE_CODE SYSRES_CONST_BLACK_LIFE_CYCLE_STAGE_FONT_COLOR SYSRES_CONST_BLUE_LIFE_CYCLE_STAGE_FONT_COLOR SYSRES_CONST_BTN_PART SYSRES_CONST_CALCULATED_ROLE_TYPE_CODE SYSRES_CONST_CALL_TYPE_VARIABLE_BUTTON_VALUE SYSRES_CONST_CALL_TYPE_VARIABLE_PROGRAM_VALUE SYSRES_CONST_CANCEL_MESSAGE_FUNCTION_RESULT SYSRES_CONST_CARD_PART SYSRES_CONST_CARD_REFERENCE_MODE_NAME SYSRES_CONST_CERTIFICATE_TYPE_REQUISITE_ENCRYPT_VALUE SYSRES_CONST_CERTIFICATE_TYPE_REQUISITE_SIGN_AND_ENCRYPT_VALUE SYSRES_CONST_CERTIFICATE_TYPE_REQUISITE_SIGN_VALUE SYSRES_CONST_CHECK_PARAM_VALUE_DATE_PARAM_TYPE SYSRES_CONST_CHECK_PARAM_VALUE_FLOAT_PARAM_TYPE SYSRES_CONST_CHECK_PARAM_VALUE_INTEGER_PARAM_TYPE SYSRES_CONST_CHECK_PARAM_VALUE_PICK_PARAM_TYPE SYSRES_CONST_CHECK_PARAM_VALUE_REEFRENCE_PARAM_TYPE SYSRES_CONST_CLOSED_RECORD_FLAG_VALUE_FEMININE SYSRES_CONST_CLOSED_RECORD_FLAG_VALUE_MASCULINE SYSRES_CONST_CODE_COMPONENT_TYPE_ADMIN SYSRES_CONST_CODE_COMPONENT_TYPE_DEVELOPER SYSRES_CONST_CODE_COMPONENT_TYPE_DOCS SYSRES_CONST_CODE_COMPONENT_TYPE_EDOC_CARDS SYSRES_CONST_CODE_COMPONENT_TYPE_EXTERNAL_EXECUTABLE SYSRES_CONST_CODE_COMPONENT_TYPE_OTHER SYSRES_CONST_CODE_COMPONENT_TYPE_REFERENCE SYSRES_CONST_CODE_COMPONENT_TYPE_REPORT SYSRES_CONST_CODE_COMPONENT_TYPE_SCRIPT SYSRES_CONST_CODE_COMPONENT_TYPE_URL SYSRES_CONST_CODE_REQUISITE_ACCESS SYSRES_CONST_CODE_REQUISITE_CODE SYSRES_CONST_CODE_REQUISITE_COMPONENT SYSRES_CONST_CODE_REQUISITE_DESCRIPTION SYSRES_CONST_CODE_REQUISITE_EXCLUDE_COMPONENT SYSRES_CONST_CODE_REQUISITE_RECORD SYSRES_CONST_COMMENT_REQ_CODE SYSRES_CONST_COMMON_SETTINGS_REQUISITE_CODE SYSRES_CONST_COMP_CODE_GRD SYSRES_CONST_COMPONENT_GROUP_TYPE_REQUISITE_CODE SYSRES_CONST_COMPONENT_TYPE_ADMIN_COMPONENTS SYSRES_CONST_COMPONENT_TYPE_DEVELOPER_COMPONENTS SYSRES_CONST_COMPONENT_TYPE_DOCS SYSRES_CONST_COMPONENT_TYPE_EDOC_CARDS SYSRES_CONST_COMPONENT_TYPE_EDOCS SYSRES_CONST_COMPONENT_TYPE_EXTERNAL_EXECUTABLE SYSRES_CONST_COMPONENT_TYPE_OTHER SYSRES_CONST_COMPONENT_TYPE_REFERENCE_TYPES SYSRES_CONST_COMPONENT_TYPE_REFERENCES SYSRES_CONST_COMPONENT_TYPE_REPORTS SYSRES_CONST_COMPONENT_TYPE_SCRIPTS SYSRES_CONST_COMPONENT_TYPE_URL SYSRES_CONST_COMPONENTS_REMOTE_SERVERS_VIEW_CODE SYSRES_CONST_CONDITION_BLOCK_DESCRIPTION SYSRES_CONST_CONST_FIRM_STATUS_COMMON SYSRES_CONST_CONST_FIRM_STATUS_INDIVIDUAL SYSRES_CONST_CONST_NEGATIVE_VALUE SYSRES_CONST_CONST_POSITIVE_VALUE SYSRES_CONST_CONST_SERVER_STATUS_DONT_REPLICATE SYSRES_CONST_CONST_SERVER_STATUS_REPLICATE SYSRES_CONST_CONTENTS_REQUISITE_CODE SYSRES_CONST_DATA_TYPE_BOOLEAN SYSRES_CONST_DATA_TYPE_DATE SYSRES_CONST_DATA_TYPE_FLOAT SYSRES_CONST_DATA_TYPE_INTEGER SYSRES_CONST_DATA_TYPE_PICK SYSRES_CONST_DATA_TYPE_REFERENCE SYSRES_CONST_DATA_TYPE_STRING SYSRES_CONST_DATA_TYPE_TEXT SYSRES_CONST_DATA_TYPE_VARIANT SYSRES_CONST_DATE_CLOSE_REQ_CODE SYSRES_CONST_DATE_FORMAT_DATE_ONLY_CHAR SYSRES_CONST_DATE_OPEN_REQ_CODE SYSRES_CONST_DATE_REQUISITE SYSRES_CONST_DATE_REQUISITE_CODE SYSRES_CONST_DATE_REQUISITE_NAME SYSRES_CONST_DATE_REQUISITE_TYPE SYSRES_CONST_DATE_TYPE_CHAR SYSRES_CONST_DATETIME_FORMAT_VALUE SYSRES_CONST_DEA_ACCESS_RIGHTS_ACTION_CODE SYSRES_CONST_DESCRIPTION_LOCALIZE_ID_REQUISITE_CODE SYSRES_CONST_DESCRIPTION_REQUISITE_CODE SYSRES_CONST_DET1_PART SYSRES_CONST_DET2_PART SYSRES_CONST_DET3_PART SYSRES_CONST_DET4_PART SYSRES_CONST_DET5_PART SYSRES_CONST_DET6_PART SYSRES_CONST_DETAIL_DATASET_KEY_REQUISITE_CODE SYSRES_CONST_DETAIL_PICK_REQUISITE_CODE SYSRES_CONST_DETAIL_REQ_CODE SYSRES_CONST_DO_NOT_USE_ACCESS_TYPE_CODE SYSRES_CONST_DO_NOT_USE_ACCESS_TYPE_NAME SYSRES_CONST_DO_NOT_USE_ON_VIEW_ACCESS_TYPE_CODE SYSRES_CONST_DO_NOT_USE_ON_VIEW_ACCESS_TYPE_NAME SYSRES_CONST_DOCUMENT_STORAGES_CODE SYSRES_CONST_DOCUMENT_TEMPLATES_TYPE_NAME SYSRES_CONST_DOUBLE_REQUISITE_CODE SYSRES_CONST_EDITOR_CLOSE_FILE_OBSERV_TYPE_CODE SYSRES_CONST_EDITOR_CLOSE_PROCESS_OBSERV_TYPE_CODE SYSRES_CONST_EDITOR_TYPE_REQUISITE_CODE SYSRES_CONST_EDITORS_APPLICATION_NAME_REQUISITE_CODE SYSRES_CONST_EDITORS_CREATE_SEVERAL_PROCESSES_REQUISITE_CODE SYSRES_CONST_EDITORS_EXTENSION_REQUISITE_CODE SYSRES_CONST_EDITORS_OBSERVER_BY_PROCESS_TYPE SYSRES_CONST_EDITORS_REFERENCE_CODE SYSRES_CONST_EDITORS_REPLACE_SPEC_CHARS_REQUISITE_CODE SYSRES_CONST_EDITORS_USE_PLUGINS_REQUISITE_CODE SYSRES_CONST_EDITORS_VIEW_DOCUMENT_OPENED_TO_EDIT_CODE SYSRES_CONST_EDOC_CARD_TYPE_REQUISITE_CODE SYSRES_CONST_EDOC_CARD_TYPES_LINK_REQUISITE_CODE SYSRES_CONST_EDOC_CERTIFICATE_AND_PASSWORD_ENCODE_CODE SYSRES_CONST_EDOC_CERTIFICATE_ENCODE_CODE SYSRES_CONST_EDOC_DATE_REQUISITE_CODE SYSRES_CONST_EDOC_KIND_REFERENCE_CODE SYSRES_CONST_EDOC_KINDS_BY_TEMPLATE_ACTION_CODE SYSRES_CONST_EDOC_MANAGE_ACCESS_CODE SYSRES_CONST_EDOC_NONE_ENCODE_CODE SYSRES_CONST_EDOC_NUMBER_REQUISITE_CODE SYSRES_CONST_EDOC_PASSWORD_ENCODE_CODE SYSRES_CONST_EDOC_READONLY_ACCESS_CODE SYSRES_CONST_EDOC_SHELL_LIFE_TYPE_VIEW_VALUE SYSRES_CONST_EDOC_SIZE_RESTRICTION_PRIORITY_REQUISITE_CODE SYSRES_CONST_EDOC_STORAGE_CHECK_ACCESS_RIGHTS_REQUISITE_CODE SYSRES_CONST_EDOC_STORAGE_COMPUTER_NAME_REQUISITE_CODE SYSRES_CONST_EDOC_STORAGE_DATABASE_NAME_REQUISITE_CODE SYSRES_CONST_EDOC_STORAGE_EDIT_IN_STORAGE_REQUISITE_CODE SYSRES_CONST_EDOC_STORAGE_LOCAL_PATH_REQUISITE_CODE SYSRES_CONST_EDOC_STORAGE_SHARED_SOURCE_NAME_REQUISITE_CODE SYSRES_CONST_EDOC_TEMPLATE_REQUISITE_CODE SYSRES_CONST_EDOC_TYPES_REFERENCE_CODE SYSRES_CONST_EDOC_VERSION_ACTIVE_STAGE_CODE SYSRES_CONST_EDOC_VERSION_DESIGN_STAGE_CODE SYSRES_CONST_EDOC_VERSION_OBSOLETE_STAGE_CODE SYSRES_CONST_EDOC_WRITE_ACCES_CODE SYSRES_CONST_EDOCUMENT_CARD_REQUISITES_REFERENCE_CODE_SELECTED_REQUISITE SYSRES_CONST_ENCODE_CERTIFICATE_TYPE_CODE SYSRES_CONST_END_DATE_REQUISITE_CODE SYSRES_CONST_ENUMERATION_TYPE_REQUISITE_CODE SYSRES_CONST_EXECUTE_ACCESS_RIGHTS_TYPE_CODE SYSRES_CONST_EXECUTIVE_FILE_STORAGE_TYPE SYSRES_CONST_EXIST_CONST SYSRES_CONST_EXIST_VALUE SYSRES_CONST_EXPORT_LOCK_TYPE_ASK SYSRES_CONST_EXPORT_LOCK_TYPE_WITH_LOCK SYSRES_CONST_EXPORT_LOCK_TYPE_WITHOUT_LOCK SYSRES_CONST_EXPORT_VERSION_TYPE_ASK SYSRES_CONST_EXPORT_VERSION_TYPE_LAST SYSRES_CONST_EXPORT_VERSION_TYPE_LAST_ACTIVE SYSRES_CONST_EXTENSION_REQUISITE_CODE SYSRES_CONST_FILTER_NAME_REQUISITE_CODE SYSRES_CONST_FILTER_REQUISITE_CODE SYSRES_CONST_FILTER_TYPE_COMMON_CODE SYSRES_CONST_FILTER_TYPE_COMMON_NAME SYSRES_CONST_FILTER_TYPE_USER_CODE SYSRES_CONST_FILTER_TYPE_USER_NAME SYSRES_CONST_FILTER_VALUE_REQUISITE_NAME SYSRES_CONST_FLOAT_NUMBER_FORMAT_CHAR SYSRES_CONST_FLOAT_REQUISITE_TYPE SYSRES_CONST_FOLDER_AUTHOR_VALUE SYSRES_CONST_FOLDER_KIND_ANY_OBJECTS SYSRES_CONST_FOLDER_KIND_COMPONENTS SYSRES_CONST_FOLDER_KIND_EDOCS SYSRES_CONST_FOLDER_KIND_JOBS SYSRES_CONST_FOLDER_KIND_TASKS SYSRES_CONST_FOLDER_TYPE_COMMON SYSRES_CONST_FOLDER_TYPE_COMPONENT SYSRES_CONST_FOLDER_TYPE_FAVORITES SYSRES_CONST_FOLDER_TYPE_INBOX SYSRES_CONST_FOLDER_TYPE_OUTBOX SYSRES_CONST_FOLDER_TYPE_QUICK_LAUNCH SYSRES_CONST_FOLDER_TYPE_SEARCH SYSRES_CONST_FOLDER_TYPE_SHORTCUTS SYSRES_CONST_FOLDER_TYPE_USER SYSRES_CONST_FROM_DICTIONARY_ENUM_METHOD_FLAG SYSRES_CONST_FULL_SUBSTITUTE_TYPE SYSRES_CONST_FULL_SUBSTITUTE_TYPE_CODE SYSRES_CONST_FUNCTION_CANCEL_RESULT SYSRES_CONST_FUNCTION_CATEGORY_SYSTEM SYSRES_CONST_FUNCTION_CATEGORY_USER SYSRES_CONST_FUNCTION_FAILURE_RESULT SYSRES_CONST_FUNCTION_SAVE_RESULT SYSRES_CONST_GENERATED_REQUISITE SYSRES_CONST_GREEN_LIFE_CYCLE_STAGE_FONT_COLOR SYSRES_CONST_GROUP_ACCOUNT_TYPE_VALUE_CODE SYSRES_CONST_GROUP_CATEGORY_NORMAL_CODE SYSRES_CONST_GROUP_CATEGORY_NORMAL_NAME SYSRES_CONST_GROUP_CATEGORY_SERVICE_CODE SYSRES_CONST_GROUP_CATEGORY_SERVICE_NAME SYSRES_CONST_GROUP_COMMON_CATEGORY_FIELD_VALUE SYSRES_CONST_GROUP_FULL_NAME_REQUISITE_CODE SYSRES_CONST_GROUP_NAME_REQUISITE_CODE SYSRES_CONST_GROUP_RIGHTS_T_REQUISITE_CODE SYSRES_CONST_GROUP_SERVER_CODES_REQUISITE_CODE SYSRES_CONST_GROUP_SERVER_NAME_REQUISITE_CODE SYSRES_CONST_GROUP_SERVICE_CATEGORY_FIELD_VALUE SYSRES_CONST_GROUP_USER_REQUISITE_CODE SYSRES_CONST_GROUPS_REFERENCE_CODE SYSRES_CONST_GROUPS_REQUISITE_CODE SYSRES_CONST_HIDDEN_MODE_NAME SYSRES_CONST_HIGH_LVL_REQUISITE_CODE SYSRES_CONST_HISTORY_ACTION_CREATE_CODE SYSRES_CONST_HISTORY_ACTION_DELETE_CODE SYSRES_CONST_HISTORY_ACTION_EDIT_CODE SYSRES_CONST_HOUR_CHAR SYSRES_CONST_ID_REQUISITE_CODE SYSRES_CONST_IDSPS_REQUISITE_CODE SYSRES_CONST_IMAGE_MODE_COLOR SYSRES_CONST_IMAGE_MODE_GREYSCALE SYSRES_CONST_IMAGE_MODE_MONOCHROME SYSRES_CONST_IMPORTANCE_HIGH SYSRES_CONST_IMPORTANCE_LOW SYSRES_CONST_IMPORTANCE_NORMAL SYSRES_CONST_IN_DESIGN_VERSION_STATE_PICK_VALUE SYSRES_CONST_INCOMING_WORK_RULE_TYPE_CODE SYSRES_CONST_INT_REQUISITE SYSRES_CONST_INT_REQUISITE_TYPE SYSRES_CONST_INTEGER_NUMBER_FORMAT_CHAR SYSRES_CONST_INTEGER_TYPE_CHAR SYSRES_CONST_IS_GENERATED_REQUISITE_NEGATIVE_VALUE SYSRES_CONST_IS_PUBLIC_ROLE_REQUISITE_CODE SYSRES_CONST_IS_REMOTE_USER_NEGATIVE_VALUE SYSRES_CONST_IS_REMOTE_USER_POSITIVE_VALUE SYSRES_CONST_IS_STORED_REQUISITE_NEGATIVE_VALUE SYSRES_CONST_IS_STORED_REQUISITE_STORED_VALUE SYSRES_CONST_ITALIC_LIFE_CYCLE_STAGE_DRAW_STYLE SYSRES_CONST_JOB_BLOCK_DESCRIPTION SYSRES_CONST_JOB_KIND_CONTROL_JOB SYSRES_CONST_JOB_KIND_JOB SYSRES_CONST_JOB_KIND_NOTICE SYSRES_CONST_JOB_STATE_ABORTED SYSRES_CONST_JOB_STATE_COMPLETE SYSRES_CONST_JOB_STATE_WORKING SYSRES_CONST_KIND_REQUISITE_CODE SYSRES_CONST_KIND_REQUISITE_NAME SYSRES_CONST_KINDS_CREATE_SHADOW_COPIES_REQUISITE_CODE SYSRES_CONST_KINDS_DEFAULT_EDOC_LIFE_STAGE_REQUISITE_CODE SYSRES_CONST_KINDS_EDOC_ALL_TEPLATES_ALLOWED_REQUISITE_CODE SYSRES_CONST_KINDS_EDOC_ALLOW_LIFE_CYCLE_STAGE_CHANGING_REQUISITE_CODE SYSRES_CONST_KINDS_EDOC_ALLOW_MULTIPLE_ACTIVE_VERSIONS_REQUISITE_CODE SYSRES_CONST_KINDS_EDOC_SHARE_ACCES_RIGHTS_BY_DEFAULT_CODE SYSRES_CONST_KINDS_EDOC_TEMPLATE_REQUISITE_CODE SYSRES_CONST_KINDS_EDOC_TYPE_REQUISITE_CODE SYSRES_CONST_KINDS_SIGNERS_REQUISITES_CODE SYSRES_CONST_KOD_INPUT_TYPE SYSRES_CONST_LAST_UPDATE_DATE_REQUISITE_CODE SYSRES_CONST_LIFE_CYCLE_START_STAGE_REQUISITE_CODE SYSRES_CONST_LILAC_LIFE_CYCLE_STAGE_FONT_COLOR SYSRES_CONST_LINK_OBJECT_KIND_COMPONENT SYSRES_CONST_LINK_OBJECT_KIND_DOCUMENT SYSRES_CONST_LINK_OBJECT_KIND_EDOC SYSRES_CONST_LINK_OBJECT_KIND_FOLDER SYSRES_CONST_LINK_OBJECT_KIND_JOB SYSRES_CONST_LINK_OBJECT_KIND_REFERENCE SYSRES_CONST_LINK_OBJECT_KIND_TASK SYSRES_CONST_LINK_REF_TYPE_REQUISITE_CODE SYSRES_CONST_LIST_REFERENCE_MODE_NAME SYSRES_CONST_LOCALIZATION_DICTIONARY_MAIN_VIEW_CODE SYSRES_CONST_MAIN_VIEW_CODE SYSRES_CONST_MANUAL_ENUM_METHOD_FLAG SYSRES_CONST_MASTER_COMP_TYPE_REQUISITE_CODE SYSRES_CONST_MASTER_TABLE_REC_ID_REQUISITE_CODE SYSRES_CONST_MAXIMIZED_MODE_NAME SYSRES_CONST_ME_VALUE SYSRES_CONST_MESSAGE_ATTENTION_CAPTION SYSRES_CONST_MESSAGE_CONFIRMATION_CAPTION SYSRES_CONST_MESSAGE_ERROR_CAPTION SYSRES_CONST_MESSAGE_INFORMATION_CAPTION SYSRES_CONST_MINIMIZED_MODE_NAME SYSRES_CONST_MINUTE_CHAR SYSRES_CONST_MODULE_REQUISITE_CODE SYSRES_CONST_MONITORING_BLOCK_DESCRIPTION SYSRES_CONST_MONTH_FORMAT_VALUE SYSRES_CONST_NAME_LOCALIZE_ID_REQUISITE_CODE SYSRES_CONST_NAME_REQUISITE_CODE SYSRES_CONST_NAME_SINGULAR_REQUISITE_CODE SYSRES_CONST_NAMEAN_INPUT_TYPE SYSRES_CONST_NEGATIVE_PICK_VALUE SYSRES_CONST_NEGATIVE_VALUE SYSRES_CONST_NO SYSRES_CONST_NO_PICK_VALUE SYSRES_CONST_NO_SIGNATURE_REQUISITE_CODE SYSRES_CONST_NO_VALUE SYSRES_CONST_NONE_ACCESS_RIGHTS_TYPE_CODE SYSRES_CONST_NONOPERATING_RECORD_FLAG_VALUE SYSRES_CONST_NONOPERATING_RECORD_FLAG_VALUE_MASCULINE SYSRES_CONST_NORMAL_ACCESS_RIGHTS_TYPE_CODE SYSRES_CONST_NORMAL_LIFE_CYCLE_STAGE_DRAW_STYLE SYSRES_CONST_NORMAL_MODE_NAME SYSRES_CONST_NOT_ALLOWED_ACCESS_TYPE_CODE SYSRES_CONST_NOT_ALLOWED_ACCESS_TYPE_NAME SYSRES_CONST_NOTE_REQUISITE_CODE SYSRES_CONST_NOTICE_BLOCK_DESCRIPTION SYSRES_CONST_NUM_REQUISITE SYSRES_CONST_NUM_STR_REQUISITE_CODE SYSRES_CONST_NUMERATION_AUTO_NOT_STRONG SYSRES_CONST_NUMERATION_AUTO_STRONG SYSRES_CONST_NUMERATION_FROM_DICTONARY SYSRES_CONST_NUMERATION_MANUAL SYSRES_CONST_NUMERIC_TYPE_CHAR SYSRES_CONST_NUMREQ_REQUISITE_CODE SYSRES_CONST_OBSOLETE_VERSION_STATE_PICK_VALUE SYSRES_CONST_OPERATING_RECORD_FLAG_VALUE SYSRES_CONST_OPERATING_RECORD_FLAG_VALUE_CODE SYSRES_CONST_OPERATING_RECORD_FLAG_VALUE_FEMININE SYSRES_CONST_OPERATING_RECORD_FLAG_VALUE_MASCULINE SYSRES_CONST_OPTIONAL_FORM_COMP_REQCODE_PREFIX SYSRES_CONST_ORANGE_LIFE_CYCLE_STAGE_FONT_COLOR SYSRES_CONST_ORIGINALREF_REQUISITE_CODE SYSRES_CONST_OURFIRM_REF_CODE SYSRES_CONST_OURFIRM_REQUISITE_CODE SYSRES_CONST_OURFIRM_VAR SYSRES_CONST_OUTGOING_WORK_RULE_TYPE_CODE SYSRES_CONST_PICK_NEGATIVE_RESULT SYSRES_CONST_PICK_POSITIVE_RESULT SYSRES_CONST_PICK_REQUISITE SYSRES_CONST_PICK_REQUISITE_TYPE SYSRES_CONST_PICK_TYPE_CHAR SYSRES_CONST_PLAN_STATUS_REQUISITE_CODE SYSRES_CONST_PLATFORM_VERSION_COMMENT SYSRES_CONST_PLUGINS_SETTINGS_DESCRIPTION_REQUISITE_CODE SYSRES_CONST_POSITIVE_PICK_VALUE SYSRES_CONST_POWER_TO_CREATE_ACTION_CODE SYSRES_CONST_POWER_TO_SIGN_ACTION_CODE SYSRES_CONST_PRIORITY_REQUISITE_CODE SYSRES_CONST_QUALIFIED_TASK_TYPE SYSRES_CONST_QUALIFIED_TASK_TYPE_CODE SYSRES_CONST_RECSTAT_REQUISITE_CODE SYSRES_CONST_RED_LIFE_CYCLE_STAGE_FONT_COLOR SYSRES_CONST_REF_ID_T_REF_TYPE_REQUISITE_CODE SYSRES_CONST_REF_REQUISITE SYSRES_CONST_REF_REQUISITE_TYPE SYSRES_CONST_REF_REQUISITES_REFERENCE_CODE_SELECTED_REQUISITE SYSRES_CONST_REFERENCE_RECORD_HISTORY_CREATE_ACTION_CODE SYSRES_CONST_REFERENCE_RECORD_HISTORY_DELETE_ACTION_CODE SYSRES_CONST_REFERENCE_RECORD_HISTORY_MODIFY_ACTION_CODE SYSRES_CONST_REFERENCE_TYPE_CHAR SYSRES_CONST_REFERENCE_TYPE_REQUISITE_NAME SYSRES_CONST_REFERENCES_ADD_PARAMS_REQUISITE_CODE SYSRES_CONST_REFERENCES_DISPLAY_REQUISITE_REQUISITE_CODE SYSRES_CONST_REMOTE_SERVER_STATUS_WORKING SYSRES_CONST_REMOTE_SERVER_TYPE_MAIN SYSRES_CONST_REMOTE_SERVER_TYPE_SECONDARY SYSRES_CONST_REMOTE_USER_FLAG_VALUE_CODE SYSRES_CONST_REPORT_APP_EDITOR_INTERNAL SYSRES_CONST_REPORT_BASE_REPORT_ID_REQUISITE_CODE SYSRES_CONST_REPORT_BASE_REPORT_REQUISITE_CODE SYSRES_CONST_REPORT_SCRIPT_REQUISITE_CODE SYSRES_CONST_REPORT_TEMPLATE_REQUISITE_CODE SYSRES_CONST_REPORT_VIEWER_CODE_REQUISITE_CODE SYSRES_CONST_REQ_ALLOW_COMPONENT_DEFAULT_VALUE SYSRES_CONST_REQ_ALLOW_RECORD_DEFAULT_VALUE SYSRES_CONST_REQ_ALLOW_SERVER_COMPONENT_DEFAULT_VALUE SYSRES_CONST_REQ_MODE_AVAILABLE_CODE SYSRES_CONST_REQ_MODE_EDIT_CODE SYSRES_CONST_REQ_MODE_HIDDEN_CODE SYSRES_CONST_REQ_MODE_NOT_AVAILABLE_CODE SYSRES_CONST_REQ_MODE_VIEW_CODE SYSRES_CONST_REQ_NUMBER_REQUISITE_CODE SYSRES_CONST_REQ_SECTION_VALUE SYSRES_CONST_REQ_TYPE_VALUE SYSRES_CONST_REQUISITE_FORMAT_BY_UNIT SYSRES_CONST_REQUISITE_FORMAT_DATE_FULL SYSRES_CONST_REQUISITE_FORMAT_DATE_TIME SYSRES_CONST_REQUISITE_FORMAT_LEFT SYSRES_CONST_REQUISITE_FORMAT_RIGHT SYSRES_CONST_REQUISITE_FORMAT_WITHOUT_UNIT SYSRES_CONST_REQUISITE_NUMBER_REQUISITE_CODE SYSRES_CONST_REQUISITE_SECTION_ACTIONS SYSRES_CONST_REQUISITE_SECTION_BUTTON SYSRES_CONST_REQUISITE_SECTION_BUTTONS SYSRES_CONST_REQUISITE_SECTION_CARD SYSRES_CONST_REQUISITE_SECTION_TABLE SYSRES_CONST_REQUISITE_SECTION_TABLE10 SYSRES_CONST_REQUISITE_SECTION_TABLE11 SYSRES_CONST_REQUISITE_SECTION_TABLE12 SYSRES_CONST_REQUISITE_SECTION_TABLE13 SYSRES_CONST_REQUISITE_SECTION_TABLE14 SYSRES_CONST_REQUISITE_SECTION_TABLE15 SYSRES_CONST_REQUISITE_SECTION_TABLE16 SYSRES_CONST_REQUISITE_SECTION_TABLE17 SYSRES_CONST_REQUISITE_SECTION_TABLE18 SYSRES_CONST_REQUISITE_SECTION_TABLE19 SYSRES_CONST_REQUISITE_SECTION_TABLE2 SYSRES_CONST_REQUISITE_SECTION_TABLE20 SYSRES_CONST_REQUISITE_SECTION_TABLE21 SYSRES_CONST_REQUISITE_SECTION_TABLE22 SYSRES_CONST_REQUISITE_SECTION_TABLE23 SYSRES_CONST_REQUISITE_SECTION_TABLE24 SYSRES_CONST_REQUISITE_SECTION_TABLE3 SYSRES_CONST_REQUISITE_SECTION_TABLE4 SYSRES_CONST_REQUISITE_SECTION_TABLE5 SYSRES_CONST_REQUISITE_SECTION_TABLE6 SYSRES_CONST_REQUISITE_SECTION_TABLE7 SYSRES_CONST_REQUISITE_SECTION_TABLE8 SYSRES_CONST_REQUISITE_SECTION_TABLE9 SYSRES_CONST_REQUISITES_PSEUDOREFERENCE_REQUISITE_NUMBER_REQUISITE_CODE SYSRES_CONST_RIGHT_ALIGNMENT_CODE SYSRES_CONST_ROLES_REFERENCE_CODE SYSRES_CONST_ROUTE_STEP_AFTER_RUS SYSRES_CONST_ROUTE_STEP_AND_CONDITION_RUS SYSRES_CONST_ROUTE_STEP_OR_CONDITION_RUS SYSRES_CONST_ROUTE_TYPE_COMPLEX SYSRES_CONST_ROUTE_TYPE_PARALLEL SYSRES_CONST_ROUTE_TYPE_SERIAL SYSRES_CONST_SBDATASETDESC_NEGATIVE_VALUE SYSRES_CONST_SBDATASETDESC_POSITIVE_VALUE SYSRES_CONST_SBVIEWSDESC_POSITIVE_VALUE SYSRES_CONST_SCRIPT_BLOCK_DESCRIPTION SYSRES_CONST_SEARCH_BY_TEXT_REQUISITE_CODE SYSRES_CONST_SEARCHES_COMPONENT_CONTENT SYSRES_CONST_SEARCHES_CRITERIA_ACTION_NAME SYSRES_CONST_SEARCHES_EDOC_CONTENT SYSRES_CONST_SEARCHES_FOLDER_CONTENT SYSRES_CONST_SEARCHES_JOB_CONTENT SYSRES_CONST_SEARCHES_REFERENCE_CODE SYSRES_CONST_SEARCHES_TASK_CONTENT SYSRES_CONST_SECOND_CHAR SYSRES_CONST_SECTION_REQUISITE_ACTIONS_VALUE SYSRES_CONST_SECTION_REQUISITE_CARD_VALUE SYSRES_CONST_SECTION_REQUISITE_CODE SYSRES_CONST_SECTION_REQUISITE_DETAIL_1_VALUE SYSRES_CONST_SECTION_REQUISITE_DETAIL_2_VALUE SYSRES_CONST_SECTION_REQUISITE_DETAIL_3_VALUE SYSRES_CONST_SECTION_REQUISITE_DETAIL_4_VALUE SYSRES_CONST_SECTION_REQUISITE_DETAIL_5_VALUE SYSRES_CONST_SECTION_REQUISITE_DETAIL_6_VALUE SYSRES_CONST_SELECT_REFERENCE_MODE_NAME SYSRES_CONST_SELECT_TYPE_SELECTABLE SYSRES_CONST_SELECT_TYPE_SELECTABLE_ONLY_CHILD SYSRES_CONST_SELECT_TYPE_SELECTABLE_WITH_CHILD SYSRES_CONST_SELECT_TYPE_UNSLECTABLE SYSRES_CONST_SERVER_TYPE_MAIN SYSRES_CONST_SERVICE_USER_CATEGORY_FIELD_VALUE SYSRES_CONST_SETTINGS_USER_REQUISITE_CODE SYSRES_CONST_SIGNATURE_AND_ENCODE_CERTIFICATE_TYPE_CODE SYSRES_CONST_SIGNATURE_CERTIFICATE_TYPE_CODE SYSRES_CONST_SINGULAR_TITLE_REQUISITE_CODE SYSRES_CONST_SQL_SERVER_AUTHENTIFICATION_FLAG_VALUE_CODE SYSRES_CONST_SQL_SERVER_ENCODE_AUTHENTIFICATION_FLAG_VALUE_CODE SYSRES_CONST_STANDART_ROUTE_REFERENCE_CODE SYSRES_CONST_STANDART_ROUTE_REFERENCE_COMMENT_REQUISITE_CODE SYSRES_CONST_STANDART_ROUTES_GROUPS_REFERENCE_CODE SYSRES_CONST_STATE_REQ_NAME SYSRES_CONST_STATE_REQUISITE_ACTIVE_VALUE SYSRES_CONST_STATE_REQUISITE_CLOSED_VALUE SYSRES_CONST_STATE_REQUISITE_CODE SYSRES_CONST_STATIC_ROLE_TYPE_CODE SYSRES_CONST_STATUS_PLAN_DEFAULT_VALUE SYSRES_CONST_STATUS_VALUE_AUTOCLEANING SYSRES_CONST_STATUS_VALUE_BLUE_SQUARE SYSRES_CONST_STATUS_VALUE_COMPLETE SYSRES_CONST_STATUS_VALUE_GREEN_SQUARE SYSRES_CONST_STATUS_VALUE_ORANGE_SQUARE SYSRES_CONST_STATUS_VALUE_PURPLE_SQUARE SYSRES_CONST_STATUS_VALUE_RED_SQUARE SYSRES_CONST_STATUS_VALUE_SUSPEND SYSRES_CONST_STATUS_VALUE_YELLOW_SQUARE SYSRES_CONST_STDROUTE_SHOW_TO_USERS_REQUISITE_CODE SYSRES_CONST_STORAGE_TYPE_FILE SYSRES_CONST_STORAGE_TYPE_SQL_SERVER SYSRES_CONST_STR_REQUISITE SYSRES_CONST_STRIKEOUT_LIFE_CYCLE_STAGE_DRAW_STYLE SYSRES_CONST_STRING_FORMAT_LEFT_ALIGN_CHAR SYSRES_CONST_STRING_FORMAT_RIGHT_ALIGN_CHAR SYSRES_CONST_STRING_REQUISITE_CODE SYSRES_CONST_STRING_REQUISITE_TYPE SYSRES_CONST_STRING_TYPE_CHAR SYSRES_CONST_SUBSTITUTES_PSEUDOREFERENCE_CODE SYSRES_CONST_SUBTASK_BLOCK_DESCRIPTION SYSRES_CONST_SYSTEM_SETTING_CURRENT_USER_PARAM_VALUE SYSRES_CONST_SYSTEM_SETTING_EMPTY_VALUE_PARAM_VALUE SYSRES_CONST_SYSTEM_VERSION_COMMENT SYSRES_CONST_TASK_ACCESS_TYPE_ALL SYSRES_CONST_TASK_ACCESS_TYPE_ALL_MEMBERS SYSRES_CONST_TASK_ACCESS_TYPE_MANUAL SYSRES_CONST_TASK_ENCODE_TYPE_CERTIFICATION SYSRES_CONST_TASK_ENCODE_TYPE_CERTIFICATION_AND_PASSWORD SYSRES_CONST_TASK_ENCODE_TYPE_NONE SYSRES_CONST_TASK_ENCODE_TYPE_PASSWORD SYSRES_CONST_TASK_ROUTE_ALL_CONDITION SYSRES_CONST_TASK_ROUTE_AND_CONDITION SYSRES_CONST_TASK_ROUTE_OR_CONDITION SYSRES_CONST_TASK_STATE_ABORTED SYSRES_CONST_TASK_STATE_COMPLETE SYSRES_CONST_TASK_STATE_CONTINUED SYSRES_CONST_TASK_STATE_CONTROL SYSRES_CONST_TASK_STATE_INIT SYSRES_CONST_TASK_STATE_WORKING SYSRES_CONST_TASK_TITLE SYSRES_CONST_TASK_TYPES_GROUPS_REFERENCE_CODE SYSRES_CONST_TASK_TYPES_REFERENCE_CODE SYSRES_CONST_TEMPLATES_REFERENCE_CODE SYSRES_CONST_TEST_DATE_REQUISITE_NAME SYSRES_CONST_TEST_DEV_DATABASE_NAME SYSRES_CONST_TEST_DEV_SYSTEM_CODE SYSRES_CONST_TEST_EDMS_DATABASE_NAME SYSRES_CONST_TEST_EDMS_MAIN_CODE SYSRES_CONST_TEST_EDMS_MAIN_DB_NAME SYSRES_CONST_TEST_EDMS_SECOND_CODE SYSRES_CONST_TEST_EDMS_SECOND_DB_NAME SYSRES_CONST_TEST_EDMS_SYSTEM_CODE SYSRES_CONST_TEST_NUMERIC_REQUISITE_NAME SYSRES_CONST_TEXT_REQUISITE SYSRES_CONST_TEXT_REQUISITE_CODE SYSRES_CONST_TEXT_REQUISITE_TYPE SYSRES_CONST_TEXT_TYPE_CHAR SYSRES_CONST_TYPE_CODE_REQUISITE_CODE SYSRES_CONST_TYPE_REQUISITE_CODE SYSRES_CONST_UNDEFINED_LIFE_CYCLE_STAGE_FONT_COLOR SYSRES_CONST_UNITS_SECTION_ID_REQUISITE_CODE SYSRES_CONST_UNITS_SECTION_REQUISITE_CODE SYSRES_CONST_UNOPERATING_RECORD_FLAG_VALUE_CODE SYSRES_CONST_UNSTORED_DATA_REQUISITE_CODE SYSRES_CONST_UNSTORED_DATA_REQUISITE_NAME SYSRES_CONST_USE_ACCESS_TYPE_CODE SYSRES_CONST_USE_ACCESS_TYPE_NAME SYSRES_CONST_USER_ACCOUNT_TYPE_VALUE_CODE SYSRES_CONST_USER_ADDITIONAL_INFORMATION_REQUISITE_CODE SYSRES_CONST_USER_AND_GROUP_ID_FROM_PSEUDOREFERENCE_REQUISITE_CODE SYSRES_CONST_USER_CATEGORY_NORMAL SYSRES_CONST_USER_CERTIFICATE_REQUISITE_CODE SYSRES_CONST_USER_CERTIFICATE_STATE_REQUISITE_CODE SYSRES_CONST_USER_CERTIFICATE_SUBJECT_NAME_REQUISITE_CODE SYSRES_CONST_USER_CERTIFICATE_THUMBPRINT_REQUISITE_CODE SYSRES_CONST_USER_COMMON_CATEGORY SYSRES_CONST_USER_COMMON_CATEGORY_CODE SYSRES_CONST_USER_FULL_NAME_REQUISITE_CODE SYSRES_CONST_USER_GROUP_TYPE_REQUISITE_CODE SYSRES_CONST_USER_LOGIN_REQUISITE_CODE SYSRES_CONST_USER_REMOTE_CONTROLLER_REQUISITE_CODE SYSRES_CONST_USER_REMOTE_SYSTEM_REQUISITE_CODE SYSRES_CONST_USER_RIGHTS_T_REQUISITE_CODE SYSRES_CONST_USER_SERVER_NAME_REQUISITE_CODE SYSRES_CONST_USER_SERVICE_CATEGORY SYSRES_CONST_USER_SERVICE_CATEGORY_CODE SYSRES_CONST_USER_STATUS_ADMINISTRATOR_CODE SYSRES_CONST_USER_STATUS_ADMINISTRATOR_NAME SYSRES_CONST_USER_STATUS_DEVELOPER_CODE SYSRES_CONST_USER_STATUS_DEVELOPER_NAME SYSRES_CONST_USER_STATUS_DISABLED_CODE SYSRES_CONST_USER_STATUS_DISABLED_NAME SYSRES_CONST_USER_STATUS_SYSTEM_DEVELOPER_CODE SYSRES_CONST_USER_STATUS_USER_CODE SYSRES_CONST_USER_STATUS_USER_NAME SYSRES_CONST_USER_STATUS_USER_NAME_DEPRECATED SYSRES_CONST_USER_TYPE_FIELD_VALUE_USER SYSRES_CONST_USER_TYPE_REQUISITE_CODE SYSRES_CONST_USERS_CONTROLLER_REQUISITE_CODE SYSRES_CONST_USERS_IS_MAIN_SERVER_REQUISITE_CODE SYSRES_CONST_USERS_REFERENCE_CODE SYSRES_CONST_USERS_REGISTRATION_CERTIFICATES_ACTION_NAME SYSRES_CONST_USERS_REQUISITE_CODE SYSRES_CONST_USERS_SYSTEM_REQUISITE_CODE SYSRES_CONST_USERS_USER_ACCESS_RIGHTS_TYPR_REQUISITE_CODE SYSRES_CONST_USERS_USER_AUTHENTICATION_REQUISITE_CODE SYSRES_CONST_USERS_USER_COMPONENT_REQUISITE_CODE SYSRES_CONST_USERS_USER_GROUP_REQUISITE_CODE SYSRES_CONST_USERS_VIEW_CERTIFICATES_ACTION_NAME SYSRES_CONST_VIEW_DEFAULT_CODE SYSRES_CONST_VIEW_DEFAULT_NAME SYSRES_CONST_VIEWER_REQUISITE_CODE SYSRES_CONST_WAITING_BLOCK_DESCRIPTION SYSRES_CONST_WIZARD_FORM_LABEL_TEST_STRING  SYSRES_CONST_WIZARD_QUERY_PARAM_HEIGHT_ETALON_STRING SYSRES_CONST_WIZARD_REFERENCE_COMMENT_REQUISITE_CODE SYSRES_CONST_WORK_RULES_DESCRIPTION_REQUISITE_CODE SYSRES_CONST_WORK_TIME_CALENDAR_REFERENCE_CODE SYSRES_CONST_WORK_WORKFLOW_HARD_ROUTE_TYPE_VALUE SYSRES_CONST_WORK_WORKFLOW_HARD_ROUTE_TYPE_VALUE_CODE SYSRES_CONST_WORK_WORKFLOW_HARD_ROUTE_TYPE_VALUE_CODE_RUS SYSRES_CONST_WORK_WORKFLOW_SOFT_ROUTE_TYPE_VALUE_CODE_RUS SYSRES_CONST_WORKFLOW_ROUTE_TYPR_HARD SYSRES_CONST_WORKFLOW_ROUTE_TYPR_SOFT SYSRES_CONST_XML_ENCODING SYSRES_CONST_XREC_STAT_REQUISITE_CODE SYSRES_CONST_XRECID_FIELD_NAME SYSRES_CONST_YES SYSRES_CONST_YES_NO_2_REQUISITE_CODE SYSRES_CONST_YES_NO_REQUISITE_CODE SYSRES_CONST_YES_NO_T_REF_TYPE_REQUISITE_CODE SYSRES_CONST_YES_PICK_VALUE SYSRES_CONST_YES_VALUE "+"CR FALSE nil NO_VALUE NULL TAB TRUE YES_VALUE "+"ADMINISTRATORS_GROUP_NAME CUSTOMIZERS_GROUP_NAME DEVELOPERS_GROUP_NAME SERVICE_USERS_GROUP_NAME "+"DECISION_BLOCK_FIRST_OPERAND_PROPERTY DECISION_BLOCK_NAME_PROPERTY DECISION_BLOCK_OPERATION_PROPERTY DECISION_BLOCK_RESULT_TYPE_PROPERTY DECISION_BLOCK_SECOND_OPERAND_PROPERTY "+"ANY_FILE_EXTENTION COMPRESSED_DOCUMENT_EXTENSION EXTENDED_DOCUMENT_EXTENSION SHORT_COMPRESSED_DOCUMENT_EXTENSION SHORT_EXTENDED_DOCUMENT_EXTENSION "+"JOB_BLOCK_ABORT_DEADLINE_PROPERTY JOB_BLOCK_AFTER_FINISH_EVENT JOB_BLOCK_AFTER_QUERY_PARAMETERS_EVENT JOB_BLOCK_ATTACHMENT_PROPERTY JOB_BLOCK_ATTACHMENTS_RIGHTS_GROUP_PROPERTY JOB_BLOCK_ATTACHMENTS_RIGHTS_TYPE_PROPERTY JOB_BLOCK_BEFORE_QUERY_PARAMETERS_EVENT JOB_BLOCK_BEFORE_START_EVENT JOB_BLOCK_CREATED_JOBS_PROPERTY JOB_BLOCK_DEADLINE_PROPERTY JOB_BLOCK_EXECUTION_RESULTS_PROPERTY JOB_BLOCK_IS_PARALLEL_PROPERTY JOB_BLOCK_IS_RELATIVE_ABORT_DEADLINE_PROPERTY JOB_BLOCK_IS_RELATIVE_DEADLINE_PROPERTY JOB_BLOCK_JOB_TEXT_PROPERTY JOB_BLOCK_NAME_PROPERTY JOB_BLOCK_NEED_SIGN_ON_PERFORM_PROPERTY JOB_BLOCK_PERFORMER_PROPERTY JOB_BLOCK_RELATIVE_ABORT_DEADLINE_TYPE_PROPERTY JOB_BLOCK_RELATIVE_DEADLINE_TYPE_PROPERTY JOB_BLOCK_SUBJECT_PROPERTY "+"ENGLISH_LANGUAGE_CODE RUSSIAN_LANGUAGE_CODE "+"smHidden smMaximized smMinimized smNormal wmNo wmYes "+"COMPONENT_TOKEN_LINK_KIND DOCUMENT_LINK_KIND EDOCUMENT_LINK_KIND FOLDER_LINK_KIND JOB_LINK_KIND REFERENCE_LINK_KIND TASK_LINK_KIND "+"COMPONENT_TOKEN_LOCK_TYPE EDOCUMENT_VERSION_LOCK_TYPE "+"MONITOR_BLOCK_AFTER_FINISH_EVENT MONITOR_BLOCK_BEFORE_START_EVENT MONITOR_BLOCK_DEADLINE_PROPERTY MONITOR_BLOCK_INTERVAL_PROPERTY MONITOR_BLOCK_INTERVAL_TYPE_PROPERTY MONITOR_BLOCK_IS_RELATIVE_DEADLINE_PROPERTY MONITOR_BLOCK_NAME_PROPERTY MONITOR_BLOCK_RELATIVE_DEADLINE_TYPE_PROPERTY MONITOR_BLOCK_SEARCH_SCRIPT_PROPERTY "+"NOTICE_BLOCK_AFTER_FINISH_EVENT NOTICE_BLOCK_ATTACHMENT_PROPERTY NOTICE_BLOCK_ATTACHMENTS_RIGHTS_GROUP_PROPERTY NOTICE_BLOCK_ATTACHMENTS_RIGHTS_TYPE_PROPERTY NOTICE_BLOCK_BEFORE_START_EVENT NOTICE_BLOCK_CREATED_NOTICES_PROPERTY NOTICE_BLOCK_DEADLINE_PROPERTY NOTICE_BLOCK_IS_RELATIVE_DEADLINE_PROPERTY NOTICE_BLOCK_NAME_PROPERTY NOTICE_BLOCK_NOTICE_TEXT_PROPERTY NOTICE_BLOCK_PERFORMER_PROPERTY NOTICE_BLOCK_RELATIVE_DEADLINE_TYPE_PROPERTY NOTICE_BLOCK_SUBJECT_PROPERTY "+"dseAfterCancel dseAfterClose dseAfterDelete dseAfterDeleteOutOfTransaction dseAfterInsert dseAfterOpen dseAfterScroll dseAfterUpdate dseAfterUpdateOutOfTransaction dseBeforeCancel dseBeforeClose dseBeforeDelete dseBeforeDetailUpdate dseBeforeInsert dseBeforeOpen dseBeforeUpdate dseOnAnyRequisiteChange dseOnCloseRecord dseOnDeleteError dseOnOpenRecord dseOnPrepareUpdate dseOnUpdateError dseOnUpdateRatifiedRecord dseOnValidDelete dseOnValidUpdate reOnChange reOnChangeValues SELECTION_BEGIN_ROUTE_EVENT SELECTION_END_ROUTE_EVENT "+"CURRENT_PERIOD_IS_REQUIRED PREVIOUS_CARD_TYPE_NAME SHOW_RECORD_PROPERTIES_FORM "+"ACCESS_RIGHTS_SETTING_DIALOG_CODE ADMINISTRATOR_USER_CODE ANALYTIC_REPORT_TYPE asrtHideLocal asrtHideRemote CALCULATED_ROLE_TYPE_CODE COMPONENTS_REFERENCE_DEVELOPER_VIEW_CODE DCTS_TEST_PROTOCOLS_FOLDER_PATH E_EDOC_VERSION_ALREADY_APPROVINGLY_SIGNED E_EDOC_VERSION_ALREADY_APPROVINGLY_SIGNED_BY_USER E_EDOC_VERSION_ALREDY_SIGNED E_EDOC_VERSION_ALREDY_SIGNED_BY_USER EDOC_TYPES_CODE_REQUISITE_FIELD_NAME EDOCUMENTS_ALIAS_NAME FILES_FOLDER_PATH FILTER_OPERANDS_DELIMITER FILTER_OPERATIONS_DELIMITER FORMCARD_NAME FORMLIST_NAME GET_EXTENDED_DOCUMENT_EXTENSION_CREATION_MODE GET_EXTENDED_DOCUMENT_EXTENSION_IMPORT_MODE INTEGRATED_REPORT_TYPE IS_BUILDER_APPLICATION_ROLE IS_BUILDER_APPLICATION_ROLE2 IS_BUILDER_USERS ISBSYSDEV LOG_FOLDER_PATH mbCancel mbNo mbNoToAll mbOK mbYes mbYesToAll MEMORY_DATASET_DESRIPTIONS_FILENAME mrNo mrNoToAll mrYes mrYesToAll MULTIPLE_SELECT_DIALOG_CODE NONOPERATING_RECORD_FLAG_FEMININE NONOPERATING_RECORD_FLAG_MASCULINE OPERATING_RECORD_FLAG_FEMININE OPERATING_RECORD_FLAG_MASCULINE PROFILING_SETTINGS_COMMON_SETTINGS_CODE_VALUE PROGRAM_INITIATED_LOOKUP_ACTION ratDelete ratEdit ratInsert REPORT_TYPE REQUIRED_PICK_VALUES_VARIABLE rmCard rmList SBRTE_PROGID_DEV SBRTE_PROGID_RELEASE STATIC_ROLE_TYPE_CODE SUPPRESS_EMPTY_TEMPLATE_CREATION SYSTEM_USER_CODE UPDATE_DIALOG_DATASET USED_IN_OBJECT_HINT_PARAM USER_INITIATED_LOOKUP_ACTION USER_NAME_FORMAT USER_SELECTION_RESTRICTIONS WORKFLOW_TEST_PROTOCOLS_FOLDER_PATH ELS_SUBTYPE_CONTROL_NAME ELS_FOLDER_KIND_CONTROL_NAME REPEAT_PROCESS_CURRENT_OBJECT_EXCEPTION_NAME "+"PRIVILEGE_COMPONENT_FULL_ACCESS PRIVILEGE_DEVELOPMENT_EXPORT PRIVILEGE_DEVELOPMENT_IMPORT PRIVILEGE_DOCUMENT_DELETE PRIVILEGE_ESD PRIVILEGE_FOLDER_DELETE PRIVILEGE_MANAGE_ACCESS_RIGHTS PRIVILEGE_MANAGE_REPLICATION PRIVILEGE_MANAGE_SESSION_SERVER PRIVILEGE_OBJECT_FULL_ACCESS PRIVILEGE_OBJECT_VIEW PRIVILEGE_RESERVE_LICENSE PRIVILEGE_SYSTEM_CUSTOMIZE PRIVILEGE_SYSTEM_DEVELOP PRIVILEGE_SYSTEM_INSTALL PRIVILEGE_TASK_DELETE PRIVILEGE_USER_PLUGIN_SETTINGS_CUSTOMIZE PRIVILEGES_PSEUDOREFERENCE_CODE "+"ACCESS_TYPES_PSEUDOREFERENCE_CODE ALL_AVAILABLE_COMPONENTS_PSEUDOREFERENCE_CODE ALL_AVAILABLE_PRIVILEGES_PSEUDOREFERENCE_CODE ALL_REPLICATE_COMPONENTS_PSEUDOREFERENCE_CODE AVAILABLE_DEVELOPERS_COMPONENTS_PSEUDOREFERENCE_CODE COMPONENTS_PSEUDOREFERENCE_CODE FILTRATER_SETTINGS_CONFLICTS_PSEUDOREFERENCE_CODE GROUPS_PSEUDOREFERENCE_CODE RECEIVE_PROTOCOL_PSEUDOREFERENCE_CODE REFERENCE_REQUISITE_PSEUDOREFERENCE_CODE REFERENCE_REQUISITES_PSEUDOREFERENCE_CODE REFTYPES_PSEUDOREFERENCE_CODE REPLICATION_SEANCES_DIARY_PSEUDOREFERENCE_CODE SEND_PROTOCOL_PSEUDOREFERENCE_CODE SUBSTITUTES_PSEUDOREFERENCE_CODE SYSTEM_SETTINGS_PSEUDOREFERENCE_CODE UNITS_PSEUDOREFERENCE_CODE USERS_PSEUDOREFERENCE_CODE VIEWERS_PSEUDOREFERENCE_CODE "+"CERTIFICATE_TYPE_ENCRYPT CERTIFICATE_TYPE_SIGN CERTIFICATE_TYPE_SIGN_AND_ENCRYPT "+"STORAGE_TYPE_FILE STORAGE_TYPE_NAS_CIFS STORAGE_TYPE_SAPERION STORAGE_TYPE_SQL_SERVER "+"COMPTYPE2_REQUISITE_DOCUMENTS_VALUE COMPTYPE2_REQUISITE_TASKS_VALUE COMPTYPE2_REQUISITE_FOLDERS_VALUE COMPTYPE2_REQUISITE_REFERENCES_VALUE "+"SYSREQ_CODE SYSREQ_COMPTYPE2 SYSREQ_CONST_AVAILABLE_FOR_WEB SYSREQ_CONST_COMMON_CODE SYSREQ_CONST_COMMON_VALUE SYSREQ_CONST_FIRM_CODE SYSREQ_CONST_FIRM_STATUS SYSREQ_CONST_FIRM_VALUE SYSREQ_CONST_SERVER_STATUS SYSREQ_CONTENTS SYSREQ_DATE_OPEN SYSREQ_DATE_CLOSE SYSREQ_DESCRIPTION SYSREQ_DESCRIPTION_LOCALIZE_ID SYSREQ_DOUBLE SYSREQ_EDOC_ACCESS_TYPE SYSREQ_EDOC_AUTHOR SYSREQ_EDOC_CREATED SYSREQ_EDOC_DELEGATE_RIGHTS_REQUISITE_CODE SYSREQ_EDOC_EDITOR SYSREQ_EDOC_ENCODE_TYPE SYSREQ_EDOC_ENCRYPTION_PLUGIN_NAME SYSREQ_EDOC_ENCRYPTION_PLUGIN_VERSION SYSREQ_EDOC_EXPORT_DATE SYSREQ_EDOC_EXPORTER SYSREQ_EDOC_KIND SYSREQ_EDOC_LIFE_STAGE_NAME SYSREQ_EDOC_LOCKED_FOR_SERVER_CODE SYSREQ_EDOC_MODIFIED SYSREQ_EDOC_NAME SYSREQ_EDOC_NOTE SYSREQ_EDOC_QUALIFIED_ID SYSREQ_EDOC_SESSION_KEY SYSREQ_EDOC_SESSION_KEY_ENCRYPTION_PLUGIN_NAME SYSREQ_EDOC_SESSION_KEY_ENCRYPTION_PLUGIN_VERSION SYSREQ_EDOC_SIGNATURE_TYPE SYSREQ_EDOC_SIGNED SYSREQ_EDOC_STORAGE SYSREQ_EDOC_STORAGES_ARCHIVE_STORAGE SYSREQ_EDOC_STORAGES_CHECK_RIGHTS SYSREQ_EDOC_STORAGES_COMPUTER_NAME SYSREQ_EDOC_STORAGES_EDIT_IN_STORAGE SYSREQ_EDOC_STORAGES_EXECUTIVE_STORAGE SYSREQ_EDOC_STORAGES_FUNCTION SYSREQ_EDOC_STORAGES_INITIALIZED SYSREQ_EDOC_STORAGES_LOCAL_PATH SYSREQ_EDOC_STORAGES_SAPERION_DATABASE_NAME SYSREQ_EDOC_STORAGES_SEARCH_BY_TEXT SYSREQ_EDOC_STORAGES_SERVER_NAME SYSREQ_EDOC_STORAGES_SHARED_SOURCE_NAME SYSREQ_EDOC_STORAGES_TYPE SYSREQ_EDOC_TEXT_MODIFIED SYSREQ_EDOC_TYPE_ACT_CODE SYSREQ_EDOC_TYPE_ACT_DESCRIPTION SYSREQ_EDOC_TYPE_ACT_DESCRIPTION_LOCALIZE_ID SYSREQ_EDOC_TYPE_ACT_ON_EXECUTE SYSREQ_EDOC_TYPE_ACT_ON_EXECUTE_EXISTS SYSREQ_EDOC_TYPE_ACT_SECTION SYSREQ_EDOC_TYPE_ADD_PARAMS SYSREQ_EDOC_TYPE_COMMENT SYSREQ_EDOC_TYPE_EVENT_TEXT SYSREQ_EDOC_TYPE_NAME_IN_SINGULAR SYSREQ_EDOC_TYPE_NAME_IN_SINGULAR_LOCALIZE_ID SYSREQ_EDOC_TYPE_NAME_LOCALIZE_ID SYSREQ_EDOC_TYPE_NUMERATION_METHOD SYSREQ_EDOC_TYPE_PSEUDO_REQUISITE_CODE SYSREQ_EDOC_TYPE_REQ_CODE SYSREQ_EDOC_TYPE_REQ_DESCRIPTION SYSREQ_EDOC_TYPE_REQ_DESCRIPTION_LOCALIZE_ID SYSREQ_EDOC_TYPE_REQ_IS_LEADING SYSREQ_EDOC_TYPE_REQ_IS_REQUIRED SYSREQ_EDOC_TYPE_REQ_NUMBER SYSREQ_EDOC_TYPE_REQ_ON_CHANGE SYSREQ_EDOC_TYPE_REQ_ON_CHANGE_EXISTS SYSREQ_EDOC_TYPE_REQ_ON_SELECT SYSREQ_EDOC_TYPE_REQ_ON_SELECT_KIND SYSREQ_EDOC_TYPE_REQ_SECTION SYSREQ_EDOC_TYPE_VIEW_CARD SYSREQ_EDOC_TYPE_VIEW_CODE SYSREQ_EDOC_TYPE_VIEW_COMMENT SYSREQ_EDOC_TYPE_VIEW_IS_MAIN SYSREQ_EDOC_TYPE_VIEW_NAME SYSREQ_EDOC_TYPE_VIEW_NAME_LOCALIZE_ID SYSREQ_EDOC_VERSION_AUTHOR SYSREQ_EDOC_VERSION_CRC SYSREQ_EDOC_VERSION_DATA SYSREQ_EDOC_VERSION_EDITOR SYSREQ_EDOC_VERSION_EXPORT_DATE SYSREQ_EDOC_VERSION_EXPORTER SYSREQ_EDOC_VERSION_HIDDEN SYSREQ_EDOC_VERSION_LIFE_STAGE SYSREQ_EDOC_VERSION_MODIFIED SYSREQ_EDOC_VERSION_NOTE SYSREQ_EDOC_VERSION_SIGNATURE_TYPE SYSREQ_EDOC_VERSION_SIGNED SYSREQ_EDOC_VERSION_SIZE SYSREQ_EDOC_VERSION_SOURCE SYSREQ_EDOC_VERSION_TEXT_MODIFIED SYSREQ_EDOCKIND_DEFAULT_VERSION_STATE_CODE SYSREQ_FOLDER_KIND SYSREQ_FUNC_CATEGORY SYSREQ_FUNC_COMMENT SYSREQ_FUNC_GROUP SYSREQ_FUNC_GROUP_COMMENT SYSREQ_FUNC_GROUP_NUMBER SYSREQ_FUNC_HELP SYSREQ_FUNC_PARAM_DEF_VALUE SYSREQ_FUNC_PARAM_IDENT SYSREQ_FUNC_PARAM_NUMBER SYSREQ_FUNC_PARAM_TYPE SYSREQ_FUNC_TEXT SYSREQ_GROUP_CATEGORY SYSREQ_ID SYSREQ_LAST_UPDATE SYSREQ_LEADER_REFERENCE SYSREQ_LINE_NUMBER SYSREQ_MAIN_RECORD_ID SYSREQ_NAME SYSREQ_NAME_LOCALIZE_ID SYSREQ_NOTE SYSREQ_ORIGINAL_RECORD SYSREQ_OUR_FIRM SYSREQ_PROFILING_SETTINGS_BATCH_LOGING SYSREQ_PROFILING_SETTINGS_BATCH_SIZE SYSREQ_PROFILING_SETTINGS_PROFILING_ENABLED SYSREQ_PROFILING_SETTINGS_SQL_PROFILING_ENABLED SYSREQ_PROFILING_SETTINGS_START_LOGGED SYSREQ_RECORD_STATUS SYSREQ_REF_REQ_FIELD_NAME SYSREQ_REF_REQ_FORMAT SYSREQ_REF_REQ_GENERATED SYSREQ_REF_REQ_LENGTH SYSREQ_REF_REQ_PRECISION SYSREQ_REF_REQ_REFERENCE SYSREQ_REF_REQ_SECTION SYSREQ_REF_REQ_STORED SYSREQ_REF_REQ_TOKENS SYSREQ_REF_REQ_TYPE SYSREQ_REF_REQ_VIEW SYSREQ_REF_TYPE_ACT_CODE SYSREQ_REF_TYPE_ACT_DESCRIPTION SYSREQ_REF_TYPE_ACT_DESCRIPTION_LOCALIZE_ID SYSREQ_REF_TYPE_ACT_ON_EXECUTE SYSREQ_REF_TYPE_ACT_ON_EXECUTE_EXISTS SYSREQ_REF_TYPE_ACT_SECTION SYSREQ_REF_TYPE_ADD_PARAMS SYSREQ_REF_TYPE_COMMENT SYSREQ_REF_TYPE_COMMON_SETTINGS SYSREQ_REF_TYPE_DISPLAY_REQUISITE_NAME SYSREQ_REF_TYPE_EVENT_TEXT SYSREQ_REF_TYPE_MAIN_LEADING_REF SYSREQ_REF_TYPE_NAME_IN_SINGULAR SYSREQ_REF_TYPE_NAME_IN_SINGULAR_LOCALIZE_ID SYSREQ_REF_TYPE_NAME_LOCALIZE_ID SYSREQ_REF_TYPE_NUMERATION_METHOD SYSREQ_REF_TYPE_REQ_CODE SYSREQ_REF_TYPE_REQ_DESCRIPTION SYSREQ_REF_TYPE_REQ_DESCRIPTION_LOCALIZE_ID SYSREQ_REF_TYPE_REQ_IS_CONTROL SYSREQ_REF_TYPE_REQ_IS_FILTER SYSREQ_REF_TYPE_REQ_IS_LEADING SYSREQ_REF_TYPE_REQ_IS_REQUIRED SYSREQ_REF_TYPE_REQ_NUMBER SYSREQ_REF_TYPE_REQ_ON_CHANGE SYSREQ_REF_TYPE_REQ_ON_CHANGE_EXISTS SYSREQ_REF_TYPE_REQ_ON_SELECT SYSREQ_REF_TYPE_REQ_ON_SELECT_KIND SYSREQ_REF_TYPE_REQ_SECTION SYSREQ_REF_TYPE_VIEW_CARD SYSREQ_REF_TYPE_VIEW_CODE SYSREQ_REF_TYPE_VIEW_COMMENT SYSREQ_REF_TYPE_VIEW_IS_MAIN SYSREQ_REF_TYPE_VIEW_NAME SYSREQ_REF_TYPE_VIEW_NAME_LOCALIZE_ID SYSREQ_REFERENCE_TYPE_ID SYSREQ_STATE SYSREQ_STATЕ SYSREQ_SYSTEM_SETTINGS_VALUE SYSREQ_TYPE SYSREQ_UNIT SYSREQ_UNIT_ID SYSREQ_USER_GROUPS_GROUP_FULL_NAME SYSREQ_USER_GROUPS_GROUP_NAME SYSREQ_USER_GROUPS_GROUP_SERVER_NAME SYSREQ_USERS_ACCESS_RIGHTS SYSREQ_USERS_AUTHENTICATION SYSREQ_USERS_CATEGORY SYSREQ_USERS_COMPONENT SYSREQ_USERS_COMPONENT_USER_IS_PUBLIC SYSREQ_USERS_DOMAIN SYSREQ_USERS_FULL_USER_NAME SYSREQ_USERS_GROUP SYSREQ_USERS_IS_MAIN_SERVER SYSREQ_USERS_LOGIN SYSREQ_USERS_REFERENCE_USER_IS_PUBLIC SYSREQ_USERS_STATUS SYSREQ_USERS_USER_CERTIFICATE SYSREQ_USERS_USER_CERTIFICATE_INFO SYSREQ_USERS_USER_CERTIFICATE_PLUGIN_NAME SYSREQ_USERS_USER_CERTIFICATE_PLUGIN_VERSION SYSREQ_USERS_USER_CERTIFICATE_STATE SYSREQ_USERS_USER_CERTIFICATE_SUBJECT_NAME SYSREQ_USERS_USER_CERTIFICATE_THUMBPRINT SYSREQ_USERS_USER_DEFAULT_CERTIFICATE SYSREQ_USERS_USER_DESCRIPTION SYSREQ_USERS_USER_GLOBAL_NAME SYSREQ_USERS_USER_LOGIN SYSREQ_USERS_USER_MAIN_SERVER SYSREQ_USERS_USER_TYPE SYSREQ_WORK_RULES_FOLDER_ID "+"RESULT_VAR_NAME RESULT_VAR_NAME_ENG "+"AUTO_NUMERATION_RULE_ID CANT_CHANGE_ID_REQUISITE_RULE_ID CANT_CHANGE_OURFIRM_REQUISITE_RULE_ID CHECK_CHANGING_REFERENCE_RECORD_USE_RULE_ID CHECK_CODE_REQUISITE_RULE_ID CHECK_DELETING_REFERENCE_RECORD_USE_RULE_ID CHECK_FILTRATER_CHANGES_RULE_ID CHECK_RECORD_INTERVAL_RULE_ID CHECK_REFERENCE_INTERVAL_RULE_ID CHECK_REQUIRED_DATA_FULLNESS_RULE_ID CHECK_REQUIRED_REQUISITES_FULLNESS_RULE_ID MAKE_RECORD_UNRATIFIED_RULE_ID RESTORE_AUTO_NUMERATION_RULE_ID SET_FIRM_CONTEXT_FROM_RECORD_RULE_ID SET_FIRST_RECORD_IN_LIST_FORM_RULE_ID SET_IDSPS_VALUE_RULE_ID SET_NEXT_CODE_VALUE_RULE_ID SET_OURFIRM_BOUNDS_RULE_ID SET_OURFIRM_REQUISITE_RULE_ID "+"SCRIPT_BLOCK_AFTER_FINISH_EVENT SCRIPT_BLOCK_BEFORE_START_EVENT SCRIPT_BLOCK_EXECUTION_RESULTS_PROPERTY SCRIPT_BLOCK_NAME_PROPERTY SCRIPT_BLOCK_SCRIPT_PROPERTY "+"SUBTASK_BLOCK_ABORT_DEADLINE_PROPERTY SUBTASK_BLOCK_AFTER_FINISH_EVENT SUBTASK_BLOCK_ASSIGN_PARAMS_EVENT SUBTASK_BLOCK_ATTACHMENTS_PROPERTY SUBTASK_BLOCK_ATTACHMENTS_RIGHTS_GROUP_PROPERTY SUBTASK_BLOCK_ATTACHMENTS_RIGHTS_TYPE_PROPERTY SUBTASK_BLOCK_BEFORE_START_EVENT SUBTASK_BLOCK_CREATED_TASK_PROPERTY SUBTASK_BLOCK_CREATION_EVENT SUBTASK_BLOCK_DEADLINE_PROPERTY SUBTASK_BLOCK_IMPORTANCE_PROPERTY SUBTASK_BLOCK_INITIATOR_PROPERTY SUBTASK_BLOCK_IS_RELATIVE_ABORT_DEADLINE_PROPERTY SUBTASK_BLOCK_IS_RELATIVE_DEADLINE_PROPERTY SUBTASK_BLOCK_JOBS_TYPE_PROPERTY SUBTASK_BLOCK_NAME_PROPERTY SUBTASK_BLOCK_PARALLEL_ROUTE_PROPERTY SUBTASK_BLOCK_PERFORMERS_PROPERTY SUBTASK_BLOCK_RELATIVE_ABORT_DEADLINE_TYPE_PROPERTY SUBTASK_BLOCK_RELATIVE_DEADLINE_TYPE_PROPERTY SUBTASK_BLOCK_REQUIRE_SIGN_PROPERTY SUBTASK_BLOCK_STANDARD_ROUTE_PROPERTY SUBTASK_BLOCK_START_EVENT SUBTASK_BLOCK_STEP_CONTROL_PROPERTY SUBTASK_BLOCK_SUBJECT_PROPERTY SUBTASK_BLOCK_TASK_CONTROL_PROPERTY SUBTASK_BLOCK_TEXT_PROPERTY SUBTASK_BLOCK_UNLOCK_ATTACHMENTS_ON_STOP_PROPERTY SUBTASK_BLOCK_USE_STANDARD_ROUTE_PROPERTY SUBTASK_BLOCK_WAIT_FOR_TASK_COMPLETE_PROPERTY "+"SYSCOMP_CONTROL_JOBS SYSCOMP_FOLDERS SYSCOMP_JOBS SYSCOMP_NOTICES SYSCOMP_TASKS "+"SYSDLG_CREATE_EDOCUMENT SYSDLG_CREATE_EDOCUMENT_VERSION SYSDLG_CURRENT_PERIOD SYSDLG_EDIT_FUNCTION_HELP SYSDLG_EDOCUMENT_KINDS_FOR_TEMPLATE SYSDLG_EXPORT_MULTIPLE_EDOCUMENTS SYSDLG_EXPORT_SINGLE_EDOCUMENT SYSDLG_IMPORT_EDOCUMENT SYSDLG_MULTIPLE_SELECT SYSDLG_SETUP_ACCESS_RIGHTS SYSDLG_SETUP_DEFAULT_RIGHTS SYSDLG_SETUP_FILTER_CONDITION SYSDLG_SETUP_SIGN_RIGHTS SYSDLG_SETUP_TASK_OBSERVERS SYSDLG_SETUP_TASK_ROUTE SYSDLG_SETUP_USERS_LIST SYSDLG_SIGN_EDOCUMENT SYSDLG_SIGN_MULTIPLE_EDOCUMENTS "+"SYSREF_ACCESS_RIGHTS_TYPES SYSREF_ADMINISTRATION_HISTORY SYSREF_ALL_AVAILABLE_COMPONENTS SYSREF_ALL_AVAILABLE_PRIVILEGES SYSREF_ALL_REPLICATING_COMPONENTS SYSREF_AVAILABLE_DEVELOPERS_COMPONENTS SYSREF_CALENDAR_EVENTS SYSREF_COMPONENT_TOKEN_HISTORY SYSREF_COMPONENT_TOKENS SYSREF_COMPONENTS SYSREF_CONSTANTS SYSREF_DATA_RECEIVE_PROTOCOL SYSREF_DATA_SEND_PROTOCOL SYSREF_DIALOGS SYSREF_DIALOGS_REQUISITES SYSREF_EDITORS SYSREF_EDOC_CARDS SYSREF_EDOC_TYPES SYSREF_EDOCUMENT_CARD_REQUISITES SYSREF_EDOCUMENT_CARD_TYPES SYSREF_EDOCUMENT_CARD_TYPES_REFERENCE SYSREF_EDOCUMENT_CARDS SYSREF_EDOCUMENT_HISTORY SYSREF_EDOCUMENT_KINDS SYSREF_EDOCUMENT_REQUISITES SYSREF_EDOCUMENT_SIGNATURES SYSREF_EDOCUMENT_TEMPLATES SYSREF_EDOCUMENT_TEXT_STORAGES SYSREF_EDOCUMENT_VIEWS SYSREF_FILTERER_SETUP_CONFLICTS SYSREF_FILTRATER_SETTING_CONFLICTS SYSREF_FOLDER_HISTORY SYSREF_FOLDERS SYSREF_FUNCTION_GROUPS SYSREF_FUNCTION_PARAMS SYSREF_FUNCTIONS SYSREF_JOB_HISTORY SYSREF_LINKS SYSREF_LOCALIZATION_DICTIONARY SYSREF_LOCALIZATION_LANGUAGES SYSREF_MODULES SYSREF_PRIVILEGES SYSREF_RECORD_HISTORY SYSREF_REFERENCE_REQUISITES SYSREF_REFERENCE_TYPE_VIEWS SYSREF_REFERENCE_TYPES SYSREF_REFERENCES SYSREF_REFERENCES_REQUISITES SYSREF_REMOTE_SERVERS SYSREF_REPLICATION_SESSIONS_LOG SYSREF_REPLICATION_SESSIONS_PROTOCOL SYSREF_REPORTS SYSREF_ROLES SYSREF_ROUTE_BLOCK_GROUPS SYSREF_ROUTE_BLOCKS SYSREF_SCRIPTS SYSREF_SEARCHES SYSREF_SERVER_EVENTS SYSREF_SERVER_EVENTS_HISTORY SYSREF_STANDARD_ROUTE_GROUPS SYSREF_STANDARD_ROUTES SYSREF_STATUSES SYSREF_SYSTEM_SETTINGS SYSREF_TASK_HISTORY SYSREF_TASK_KIND_GROUPS SYSREF_TASK_KINDS SYSREF_TASK_RIGHTS SYSREF_TASK_SIGNATURES SYSREF_TASKS SYSREF_UNITS SYSREF_USER_GROUPS SYSREF_USER_GROUPS_REFERENCE SYSREF_USER_SUBSTITUTION SYSREF_USERS SYSREF_USERS_REFERENCE SYSREF_VIEWERS SYSREF_WORKING_TIME_CALENDARS "+"ACCESS_RIGHTS_TABLE_NAME EDMS_ACCESS_TABLE_NAME EDOC_TYPES_TABLE_NAME "+"TEST_DEV_DB_NAME TEST_DEV_SYSTEM_CODE TEST_EDMS_DB_NAME TEST_EDMS_MAIN_CODE TEST_EDMS_MAIN_DB_NAME TEST_EDMS_SECOND_CODE TEST_EDMS_SECOND_DB_NAME TEST_EDMS_SYSTEM_CODE TEST_ISB5_MAIN_CODE TEST_ISB5_SECOND_CODE TEST_SQL_SERVER_2005_NAME TEST_SQL_SERVER_NAME "+"ATTENTION_CAPTION cbsCommandLinks cbsDefault CONFIRMATION_CAPTION ERROR_CAPTION INFORMATION_CAPTION mrCancel mrOk "+"EDOC_VERSION_ACTIVE_STAGE_CODE EDOC_VERSION_DESIGN_STAGE_CODE EDOC_VERSION_OBSOLETE_STAGE_CODE "+"cpDataEnciphermentEnabled cpDigitalSignatureEnabled cpID cpIssuer cpPluginVersion cpSerial cpSubjectName cpSubjSimpleName cpValidFromDate cpValidToDate "+"ISBL_SYNTAX NO_SYNTAX XML_SYNTAX "+"WAIT_BLOCK_AFTER_FINISH_EVENT WAIT_BLOCK_BEFORE_START_EVENT WAIT_BLOCK_DEADLINE_PROPERTY WAIT_BLOCK_IS_RELATIVE_DEADLINE_PROPERTY WAIT_BLOCK_NAME_PROPERTY WAIT_BLOCK_RELATIVE_DEADLINE_TYPE_PROPERTY "+"SYSRES_COMMON SYSRES_CONST SYSRES_MBFUNC SYSRES_SBDATA SYSRES_SBGUI SYSRES_SBINTF SYSRES_SBREFDSC SYSRES_SQLERRORS SYSRES_SYSCOMP ",gt="atUser atGroup atRole "+"aemEnabledAlways aemDisabledAlways aemEnabledOnBrowse aemEnabledOnEdit aemDisabledOnBrowseEmpty "+"apBegin apEnd "+"alLeft alRight "+"asmNever asmNoButCustomize asmAsLastTime asmYesButCustomize asmAlways "+"cirCommon cirRevoked "+"ctSignature ctEncode ctSignatureEncode "+"clbUnchecked clbChecked clbGrayed "+"ceISB ceAlways ceNever "+"ctDocument ctReference ctScript ctUnknown ctReport ctDialog ctFunction ctFolder ctEDocument ctTask ctJob ctNotice ctControlJob "+"cfInternal cfDisplay "+"ciUnspecified ciWrite ciRead "+"ckFolder ckEDocument ckTask ckJob ckComponentToken ckAny ckReference ckScript ckReport ckDialog "+"ctISBLEditor ctBevel ctButton ctCheckListBox ctComboBox ctComboEdit ctGrid ctDBCheckBox ctDBComboBox ctDBEdit ctDBEllipsis ctDBMemo ctDBNavigator ctDBRadioGroup ctDBStatusLabel ctEdit ctGroupBox ctInplaceHint ctMemo ctPanel ctListBox ctRadioButton ctRichEdit ctTabSheet ctWebBrowser ctImage ctHyperLink ctLabel ctDBMultiEllipsis ctRibbon ctRichView ctInnerPanel ctPanelGroup ctBitButton "+"cctDate cctInteger cctNumeric cctPick cctReference cctString cctText "+"cltInternal cltPrimary cltGUI "+"dseBeforeOpen dseAfterOpen dseBeforeClose dseAfterClose dseOnValidDelete dseBeforeDelete dseAfterDelete dseAfterDeleteOutOfTransaction dseOnDeleteError dseBeforeInsert dseAfterInsert dseOnValidUpdate dseBeforeUpdate dseOnUpdateRatifiedRecord dseAfterUpdate dseAfterUpdateOutOfTransaction dseOnUpdateError dseAfterScroll dseOnOpenRecord dseOnCloseRecord dseBeforeCancel dseAfterCancel dseOnUpdateDeadlockError dseBeforeDetailUpdate dseOnPrepareUpdate dseOnAnyRequisiteChange "+"dssEdit dssInsert dssBrowse dssInActive "+"dftDate dftShortDate dftDateTime dftTimeStamp "+"dotDays dotHours dotMinutes dotSeconds "+"dtkndLocal dtkndUTC "+"arNone arView arEdit arFull "+"ddaView ddaEdit "+"emLock emEdit emSign emExportWithLock emImportWithUnlock emChangeVersionNote emOpenForModify emChangeLifeStage emDelete emCreateVersion emImport emUnlockExportedWithLock emStart emAbort emReInit emMarkAsReaded emMarkAsUnreaded emPerform emAccept emResume emChangeRights emEditRoute emEditObserver emRecoveryFromLocalCopy emChangeWorkAccessType emChangeEncodeTypeToCertificate emChangeEncodeTypeToPassword emChangeEncodeTypeToNone emChangeEncodeTypeToCertificatePassword emChangeStandardRoute emGetText emOpenForView emMoveToStorage emCreateObject emChangeVersionHidden emDeleteVersion emChangeLifeCycleStage emApprovingSign emExport emContinue emLockFromEdit emUnLockForEdit emLockForServer emUnlockFromServer emDelegateAccessRights emReEncode "+"ecotFile ecotProcess "+"eaGet eaCopy eaCreate eaCreateStandardRoute "+"edltAll edltNothing edltQuery "+"essmText essmCard "+"esvtLast esvtLastActive esvtSpecified "+"edsfExecutive edsfArchive "+"edstSQLServer edstFile "+"edvstNone edvstEDocumentVersionCopy edvstFile edvstTemplate edvstScannedFile "+"vsDefault vsDesign vsActive vsObsolete "+"etNone etCertificate etPassword etCertificatePassword "+"ecException ecWarning ecInformation "+"estAll estApprovingOnly "+"evtLast evtLastActive evtQuery "+"fdtString fdtNumeric fdtInteger fdtDate fdtText fdtUnknown fdtWideString fdtLargeInteger "+"ftInbox ftOutbox ftFavorites ftCommonFolder ftUserFolder ftComponents ftQuickLaunch ftShortcuts ftSearch "+"grhAuto grhX1 grhX2 grhX3 "+"hltText hltRTF hltHTML "+"iffBMP iffJPEG iffMultiPageTIFF iffSinglePageTIFF iffTIFF iffPNG "+"im8bGrayscale im24bRGB im1bMonochrome "+"itBMP itJPEG itWMF itPNG "+"ikhInformation ikhWarning ikhError ikhNoIcon "+"icUnknown icScript icFunction icIntegratedReport icAnalyticReport icDataSetEventHandler icActionHandler icFormEventHandler icLookUpEventHandler icRequisiteChangeEventHandler icBeforeSearchEventHandler icRoleCalculation icSelectRouteEventHandler icBlockPropertyCalculation icBlockQueryParamsEventHandler icChangeSearchResultEventHandler icBlockEventHandler icSubTaskInitEventHandler icEDocDataSetEventHandler icEDocLookUpEventHandler icEDocActionHandler icEDocFormEventHandler icEDocRequisiteChangeEventHandler icStructuredConversionRule icStructuredConversionEventBefore icStructuredConversionEventAfter icWizardEventHandler icWizardFinishEventHandler icWizardStepEventHandler icWizardStepFinishEventHandler icWizardActionEnableEventHandler icWizardActionExecuteEventHandler icCreateJobsHandler icCreateNoticesHandler icBeforeLookUpEventHandler icAfterLookUpEventHandler icTaskAbortEventHandler icWorkflowBlockActionHandler icDialogDataSetEventHandler icDialogActionHandler icDialogLookUpEventHandler icDialogRequisiteChangeEventHandler icDialogFormEventHandler icDialogValidCloseEventHandler icBlockFormEventHandler icTaskFormEventHandler icReferenceMethod icEDocMethod icDialogMethod icProcessMessageHandler "+"isShow isHide isByUserSettings "+"jkJob jkNotice jkControlJob "+"jtInner jtLeft jtRight jtFull jtCross "+"lbpAbove lbpBelow lbpLeft lbpRight "+"eltPerConnection eltPerUser "+"sfcUndefined sfcBlack sfcGreen sfcRed sfcBlue sfcOrange sfcLilac "+"sfsItalic sfsStrikeout sfsNormal "+"ldctStandardRoute ldctWizard ldctScript ldctFunction ldctRouteBlock ldctIntegratedReport ldctAnalyticReport ldctReferenceType ldctEDocumentType ldctDialog ldctServerEvents "+"mrcrtNone mrcrtUser mrcrtMaximal mrcrtCustom "+"vtEqual vtGreaterOrEqual vtLessOrEqual vtRange "+"rdYesterday rdToday rdTomorrow rdThisWeek rdThisMonth rdThisYear rdNextMonth rdNextWeek rdLastWeek rdLastMonth "+"rdWindow rdFile rdPrinter "+"rdtString rdtNumeric rdtInteger rdtDate rdtReference rdtAccount rdtText rdtPick rdtUnknown rdtLargeInteger rdtDocument "+"reOnChange reOnChangeValues "+"ttGlobal ttLocal ttUser ttSystem "+"ssmBrowse ssmSelect ssmMultiSelect ssmBrowseModal "+"smSelect smLike smCard "+"stNone stAuthenticating stApproving "+"sctString sctStream "+"sstAnsiSort sstNaturalSort "+"svtEqual svtContain "+"soatString soatNumeric soatInteger soatDatetime soatReferenceRecord soatText soatPick soatBoolean soatEDocument soatAccount soatIntegerCollection soatNumericCollection soatStringCollection soatPickCollection soatDatetimeCollection soatBooleanCollection soatReferenceRecordCollection soatEDocumentCollection soatAccountCollection soatContents soatUnknown "+"tarAbortByUser tarAbortByWorkflowException "+"tvtAllWords tvtExactPhrase tvtAnyWord "+"usNone usCompleted usRedSquare usBlueSquare usYellowSquare usGreenSquare usOrangeSquare usPurpleSquare usFollowUp "+"utUnknown utUser utDeveloper utAdministrator utSystemDeveloper utDisconnected "+"btAnd btDetailAnd btOr btNotOr btOnly "+"vmView vmSelect vmNavigation "+"vsmSingle vsmMultiple vsmMultipleCheck vsmNoSelection "+"wfatPrevious wfatNext wfatCancel wfatFinish "+"wfepUndefined wfepText3 wfepText6 wfepText9 wfepSpinEdit wfepDropDown wfepRadioGroup wfepFlag wfepText12 wfepText15 wfepText18 wfepText21 wfepText24 wfepText27 wfepText30 wfepRadioGroupColumn1 wfepRadioGroupColumn2 wfepRadioGroupColumn3 "+"wfetQueryParameter wfetText wfetDelimiter wfetLabel "+"wptString wptInteger wptNumeric wptBoolean wptDateTime wptPick wptText wptUser wptUserList wptEDocumentInfo wptEDocumentInfoList wptReferenceRecordInfo wptReferenceRecordInfoList wptFolderInfo wptTaskInfo wptContents wptFileName wptDate "+"wsrComplete wsrGoNext wsrGoPrevious wsrCustom wsrCancel wsrGoFinal "+"wstForm wstEDocument wstTaskCard wstReferenceRecordCard wstFinal "+"waAll waPerformers waManual "+"wsbStart wsbFinish wsbNotice wsbStep wsbDecision wsbWait wsbMonitor wsbScript wsbConnector wsbSubTask wsbLifeCycleStage wsbPause "+"wdtInteger wdtFloat wdtString wdtPick wdtDateTime wdtBoolean wdtTask wdtJob wdtFolder wdtEDocument wdtReferenceRecord wdtUser wdtGroup wdtRole wdtIntegerCollection wdtFloatCollection wdtStringCollection wdtPickCollection wdtDateTimeCollection wdtBooleanCollection wdtTaskCollection wdtJobCollection wdtFolderCollection wdtEDocumentCollection wdtReferenceRecordCollection wdtUserCollection wdtGroupCollection wdtRoleCollection wdtContents wdtUserList wdtSearchDescription wdtDeadLine wdtPickSet wdtAccountCollection "+"wiLow wiNormal wiHigh "+"wrtSoft wrtHard "+"wsInit wsRunning wsDone wsControlled wsAborted wsContinued "+"wtmFull wtmFromCurrent wtmOnlyCurrent ",Oe="AddSubString AdjustLineBreaks AmountInWords Analysis ArrayDimCount ArrayHighBound ArrayLowBound ArrayOf ArrayReDim Assert Assigned BeginOfMonth BeginOfPeriod BuildProfilingOperationAnalysis CallProcedure CanReadFile CArrayElement CDataSetRequisite ChangeDate ChangeReferenceDataset Char CharPos CheckParam CheckParamValue CompareStrings ConstantExists ControlState ConvertDateStr Copy CopyFile CreateArray CreateCachedReference CreateConnection CreateDialog CreateDualListDialog CreateEditor CreateException CreateFile CreateFolderDialog CreateInputDialog CreateLinkFile CreateList CreateLock CreateMemoryDataSet CreateObject CreateOpenDialog CreateProgress CreateQuery CreateReference CreateReport CreateSaveDialog CreateScript CreateSQLPivotFunction CreateStringList CreateTreeListSelectDialog CSelectSQL CSQL CSubString CurrentUserID CurrentUserName CurrentVersion DataSetLocateEx DateDiff DateTimeDiff DateToStr DayOfWeek DeleteFile DirectoryExists DisableCheckAccessRights DisableCheckFullShowingRestriction DisableMassTaskSendingRestrictions DropTable DupeString EditText EnableCheckAccessRights EnableCheckFullShowingRestriction EnableMassTaskSendingRestrictions EndOfMonth EndOfPeriod ExceptionExists ExceptionsOff ExceptionsOn Execute ExecuteProcess Exit ExpandEnvironmentVariables ExtractFileDrive ExtractFileExt ExtractFileName ExtractFilePath ExtractParams FileExists FileSize FindFile FindSubString FirmContext ForceDirectories Format FormatDate FormatNumeric FormatSQLDate FormatString FreeException GetComponent GetComponentLaunchParam GetConstant GetLastException GetReferenceRecord GetRefTypeByRefID GetTableID GetTempFolder IfThen In IndexOf InputDialog InputDialogEx InteractiveMode IsFileLocked IsGraphicFile IsNumeric Length LoadString LoadStringFmt LocalTimeToUTC LowerCase Max MessageBox MessageBoxEx MimeDecodeBinary MimeDecodeString MimeEncodeBinary MimeEncodeString Min MoneyInWords MoveFile NewID Now OpenFile Ord Precision Raise ReadCertificateFromFile ReadFile ReferenceCodeByID ReferenceNumber ReferenceRequisiteMode ReferenceRequisiteValue RegionDateSettings RegionNumberSettings RegionTimeSettings RegRead RegWrite RenameFile Replace Round SelectServerCode SelectSQL ServerDateTime SetConstant SetManagedFolderFieldsState ShowConstantsInputDialog ShowMessage Sleep Split SQL SQL2XLSTAB SQLProfilingSendReport StrToDate SubString SubStringCount SystemSetting Time TimeDiff Today Transliterate Trim UpperCase UserStatus UTCToLocalTime ValidateXML VarIsClear VarIsEmpty VarIsNull WorkTimeDiff WriteFile WriteFileEx WriteObjectHistory Анализ БазаДанных БлокЕсть БлокЕстьРасш БлокИнфо БлокСнять БлокСнятьРасш БлокУстановить Ввод ВводМеню ВедС ВедСпр ВерхняяГраницаМассива ВнешПрогр Восст ВременнаяПапка Время ВыборSQL ВыбратьЗапись ВыделитьСтр Вызвать Выполнить ВыпПрогр ГрафическийФайл ГруппаДополнительно ДатаВремяСерв ДеньНедели ДиалогДаНет ДлинаСтр ДобПодстр ЕПусто ЕслиТо ЕЧисло ЗамПодстр ЗаписьСправочника ЗначПоляСпр ИДТипСпр ИзвлечьДиск ИзвлечьИмяФайла ИзвлечьПуть ИзвлечьРасширение ИзмДат ИзменитьРазмерМассива ИзмеренийМассива ИмяОрг ИмяПоляСпр Индекс ИндикаторЗакрыть ИндикаторОткрыть ИндикаторШаг ИнтерактивныйРежим ИтогТблСпр КодВидВедСпр КодВидСпрПоИД КодПоAnalit КодСимвола КодСпр КолПодстр КолПроп КонМес Конст КонстЕсть КонстЗнач КонТран КопироватьФайл КопияСтр КПериод КСтрТблСпр Макс МаксСтрТблСпр Массив Меню МенюРасш Мин НаборДанныхНайтиРасш НаимВидСпр НаимПоAnalit НаимСпр НастроитьПереводыСтрок НачМес НачТран НижняяГраницаМассива НомерСпр НПериод Окно Окр Окружение ОтлИнфДобавить ОтлИнфУдалить Отчет ОтчетАнал ОтчетИнт ПапкаСуществует Пауза ПВыборSQL ПереименоватьФайл Переменные ПереместитьФайл Подстр ПоискПодстр ПоискСтр ПолучитьИДТаблицы ПользовательДополнительно ПользовательИД ПользовательИмя ПользовательСтатус Прервать ПроверитьПараметр ПроверитьПараметрЗнач ПроверитьУсловие РазбСтр РазнВремя РазнДат РазнДатаВремя РазнРабВремя РегУстВрем РегУстДат РегУстЧсл РедТекст РеестрЗапись РеестрСписокИменПарам РеестрЧтение РеквСпр РеквСпрПр Сегодня Сейчас Сервер СерверПроцессИД СертификатФайлСчитать СжПроб Символ СистемаДиректумКод СистемаИнформация СистемаКод Содержит СоединениеЗакрыть СоединениеОткрыть СоздатьДиалог СоздатьДиалогВыбораИзДвухСписков СоздатьДиалогВыбораПапки СоздатьДиалогОткрытияФайла СоздатьДиалогСохраненияФайла СоздатьЗапрос СоздатьИндикатор СоздатьИсключение СоздатьКэшированныйСправочник СоздатьМассив СоздатьНаборДанных СоздатьОбъект СоздатьОтчет СоздатьПапку СоздатьРедактор СоздатьСоединение СоздатьСписок СоздатьСписокСтрок СоздатьСправочник СоздатьСценарий СоздСпр СостСпр Сохр СохрСпр СписокСистем Спр Справочник СпрБлокЕсть СпрБлокСнять СпрБлокСнятьРасш СпрБлокУстановить СпрИзмНабДан СпрКод СпрНомер СпрОбновить СпрОткрыть СпрОтменить СпрПарам СпрПолеЗнач СпрПолеИмя СпрРекв СпрРеквВведЗн СпрРеквНовые СпрРеквПр СпрРеквПредЗн СпрРеквРежим СпрРеквТипТекст СпрСоздать СпрСост СпрСохранить СпрТблИтог СпрТблСтр СпрТблСтрКол СпрТблСтрМакс СпрТблСтрМин СпрТблСтрПред СпрТблСтрСлед СпрТблСтрСозд СпрТблСтрУд СпрТекПредст СпрУдалить СравнитьСтр СтрВерхРегистр СтрНижнРегистр СтрТблСпр СумПроп Сценарий СценарийПарам ТекВерсия ТекОрг Точн Тран Транслитерация УдалитьТаблицу УдалитьФайл УдСпр УдСтрТблСпр Уст УстановкиКонстант ФайлАтрибутСчитать ФайлАтрибутУстановить ФайлВремя ФайлВремяУстановить ФайлВыбрать ФайлЗанят ФайлЗаписать ФайлИскать ФайлКопировать ФайлМожноЧитать ФайлОткрыть ФайлПереименовать ФайлПерекодировать ФайлПереместить ФайлПросмотреть ФайлРазмер ФайлСоздать ФайлСсылкаСоздать ФайлСуществует ФайлСчитать ФайлУдалить ФмтSQLДат ФмтДат ФмтСтр ФмтЧсл Формат ЦМассивЭлемент ЦНаборДанныхРеквизит ЦПодстр ",ii="AltState Application CallType ComponentTokens CreatedJobs CreatedNotices ControlState DialogResult Dialogs EDocuments EDocumentVersionSource Folders GlobalIDs Job Jobs InputValue LookUpReference LookUpRequisiteNames LookUpSearch Object ParentComponent Processes References Requisite ReportName Reports Result Scripts Searches SelectedAttachments SelectedItems SelectMode Sender ServerEvents ServiceFactory ShiftState SubTask SystemDialogs Tasks Wizard Wizards Work ВызовСпособ ИмяОтчета РеквЗнач ",nt="IApplication IAccessRights IAccountRepository IAccountSelectionRestrictions IAction IActionList IAdministrationHistoryDescription IAnchors IApplication IArchiveInfo IAttachment IAttachmentList ICheckListBox ICheckPointedList IColumn IComponent IComponentDescription IComponentToken IComponentTokenFactory IComponentTokenInfo ICompRecordInfo IConnection IContents IControl IControlJob IControlJobInfo IControlList ICrypto ICrypto2 ICustomJob ICustomJobInfo ICustomListBox ICustomObjectWizardStep ICustomWork ICustomWorkInfo IDataSet IDataSetAccessInfo IDataSigner IDateCriterion IDateRequisite IDateRequisiteDescription IDateValue IDeaAccessRights IDeaObjectInfo IDevelopmentComponentLock IDialog IDialogFactory IDialogPickRequisiteItems IDialogsFactory IDICSFactory IDocRequisite IDocumentInfo IDualListDialog IECertificate IECertificateInfo IECertificates IEditControl IEditorForm IEdmsExplorer IEdmsObject IEdmsObjectDescription IEdmsObjectFactory IEdmsObjectInfo IEDocument IEDocumentAccessRights IEDocumentDescription IEDocumentEditor IEDocumentFactory IEDocumentInfo IEDocumentStorage IEDocumentVersion IEDocumentVersionListDialog IEDocumentVersionSource IEDocumentWizardStep IEDocVerSignature IEDocVersionState IEnabledMode IEncodeProvider IEncrypter IEvent IEventList IException IExternalEvents IExternalHandler IFactory IField IFileDialog IFolder IFolderDescription IFolderDialog IFolderFactory IFolderInfo IForEach IForm IFormTitle IFormWizardStep IGlobalIDFactory IGlobalIDInfo IGrid IHasher IHistoryDescription IHyperLinkControl IImageButton IImageControl IInnerPanel IInplaceHint IIntegerCriterion IIntegerList IIntegerRequisite IIntegerValue IISBLEditorForm IJob IJobDescription IJobFactory IJobForm IJobInfo ILabelControl ILargeIntegerCriterion ILargeIntegerRequisite ILargeIntegerValue ILicenseInfo ILifeCycleStage IList IListBox ILocalIDInfo ILocalization ILock IMemoryDataSet IMessagingFactory IMetadataRepository INotice INoticeInfo INumericCriterion INumericRequisite INumericValue IObject IObjectDescription IObjectImporter IObjectInfo IObserver IPanelGroup IPickCriterion IPickProperty IPickRequisite IPickRequisiteDescription IPickRequisiteItem IPickRequisiteItems IPickValue IPrivilege IPrivilegeList IProcess IProcessFactory IProcessMessage IProgress IProperty IPropertyChangeEvent IQuery IReference IReferenceCriterion IReferenceEnabledMode IReferenceFactory IReferenceHistoryDescription IReferenceInfo IReferenceRecordCardWizardStep IReferenceRequisiteDescription IReferencesFactory IReferenceValue IRefRequisite IReport IReportFactory IRequisite IRequisiteDescription IRequisiteDescriptionList IRequisiteFactory IRichEdit IRouteStep IRule IRuleList ISchemeBlock IScript IScriptFactory ISearchCriteria ISearchCriterion ISearchDescription ISearchFactory ISearchFolderInfo ISearchForObjectDescription ISearchResultRestrictions ISecuredContext ISelectDialog IServerEvent IServerEventFactory IServiceDialog IServiceFactory ISignature ISignProvider ISignProvider2 ISignProvider3 ISimpleCriterion IStringCriterion IStringList IStringRequisite IStringRequisiteDescription IStringValue ISystemDialogsFactory ISystemInfo ITabSheet ITask ITaskAbortReasonInfo ITaskCardWizardStep ITaskDescription ITaskFactory ITaskInfo ITaskRoute ITextCriterion ITextRequisite ITextValue ITreeListSelectDialog IUser IUserList IValue IView IWebBrowserControl IWizard IWizardAction IWizardFactory IWizardFormElement IWizardParam IWizardPickParam IWizardReferenceParam IWizardStep IWorkAccessRights IWorkDescription IWorkflowAskableParam IWorkflowAskableParams IWorkflowBlock IWorkflowBlockResult IWorkflowEnabledMode IWorkflowParam IWorkflowPickParam IWorkflowReferenceParam IWorkState IWorkTreeCustomNode IWorkTreeJobNode IWorkTreeTaskNode IXMLEditorForm SBCrypto ",F=se+gt,St=ii,pe="null true false nil ",Q={className:"number",begin:e.NUMBER_RE,relevance:0},ke={className:"string",variants:[{begin:'"',end:'"'},{begin:"'",end:"'"}]},ye={className:"doctag",begin:"\\\\b(?:TODO|DONE|BEGIN|END|STUB|CHG|FIXME|NOTE|BUG|XXX)\\\\b",relevance:0},at={className:"comment",begin:"//",end:"$",relevance:0,contains:[e.PHRASAL_WORDS_MODE,ye]},rt={className:"comment",begin:"/\\\\*",end:"\\\\*/",relevance:0,contains:[e.PHRASAL_WORDS_MODE,ye]},v={variants:[at,rt]},D={$pattern:n,keyword:r,built_in:F,class:St,literal:pe},B={begin:"\\\\.\\\\s*"+e.UNDERSCORE_IDENT_RE,keywords:D,relevance:0},W={className:"type",begin:":[ \\\\t]*("+nt.trim().replace(/\\s/g,"|")+")",end:"[ \\\\t]*=",excludeEnd:!0},Ee={className:"variable",keywords:D,begin:n,relevance:0,contains:[W,B]},Ie=a+"\\\\(";return{name:"ISBL",case_insensitive:!0,keywords:D,illegal:"\\\\$|\\\\?|%|,|;$|~|#|@|</",contains:[{className:"function",begin:Ie,end:"\\\\)$",returnBegin:!0,keywords:D,illegal:"[\\\\[\\\\]\\\\|\\\\$\\\\?%,~#@]",contains:[{className:"title",keywords:{$pattern:n,built_in:Oe},begin:Ie,end:"\\\\(",returnBegin:!0,excludeEnd:!0},B,Ee,ke,Q,v]},W,B,Ee,ke,Q,v]}}return Zn=t,Zn}var Jn,Go;function nd(){if(Go)return Jn;Go=1;var t="[0-9](_*[0-9])*",e=\`\\\\.(\${t})\`,n="[0-9a-fA-F](_*[0-9a-fA-F])*",a={className:"number",variants:[{begin:\`(\\\\b(\${t})((\${e})|\\\\.)?|(\${e}))[eE][+-]?(\${t})[fFdD]?\\\\b\`},{begin:\`\\\\b(\${t})((\${e})[fFdD]?\\\\b|\\\\.([fFdD]\\\\b)?)\`},{begin:\`(\${e})[fFdD]?\\\\b\`},{begin:\`\\\\b(\${t})[fFdD]\\\\b\`},{begin:\`\\\\b0[xX]((\${n})\\\\.?|(\${n})?\\\\.(\${n}))[pP][+-]?(\${t})[fFdD]?\\\\b\`},{begin:"\\\\b(0|[1-9](_*[0-9])*)[lL]?\\\\b"},{begin:\`\\\\b0[xX](\${n})[lL]?\\\\b\`},{begin:"\\\\b0(_*[0-7])*[lL]?\\\\b"},{begin:"\\\\b0[bB][01](_*[01])*[lL]?\\\\b"}],relevance:0};function r(s,o,_){return _===-1?"":s.replace(o,l=>r(s,o,_-1))}function i(s){const o=s.regex,_="[À-ʸa-zA-Z_$][À-ʸa-zA-Z_$0-9]*",l=_+r("(?:<"+_+"~~~(?:\\\\s*,\\\\s*"+_+"~~~)*>)?",/~~~/g,2),E={keyword:["synchronized","abstract","private","var","static","if","const ","for","while","strictfp","finally","protected","import","native","final","void","enum","else","break","transient","catch","instanceof","volatile","case","assert","package","default","public","try","switch","continue","throws","protected","public","private","module","requires","exports","do","sealed","yield","permits","goto","when"],literal:["false","true","null"],type:["char","boolean","long","float","int","byte","short","double"],built_in:["super","this"]},g={className:"meta",begin:"@"+_,contains:[{begin:/\\(/,end:/\\)/,contains:["self"]}]},S={className:"params",begin:/\\(/,end:/\\)/,keywords:E,relevance:0,contains:[s.C_BLOCK_COMMENT_MODE],endsParent:!0};return{name:"Java",aliases:["jsp"],keywords:E,illegal:/<\\/|#/,contains:[s.COMMENT("/\\\\*\\\\*","\\\\*/",{relevance:0,contains:[{begin:/\\w+@/,relevance:0},{className:"doctag",begin:"@[A-Za-z]+"}]}),{begin:/import java\\.[a-z]+\\./,keywords:"import",relevance:2},s.C_LINE_COMMENT_MODE,s.C_BLOCK_COMMENT_MODE,{begin:/"""/,end:/"""/,className:"string",contains:[s.BACKSLASH_ESCAPE]},s.APOS_STRING_MODE,s.QUOTE_STRING_MODE,{match:[/\\b(?:class|interface|enum|extends|implements|new)/,/\\s+/,_],className:{1:"keyword",3:"title.class"}},{match:/non-sealed/,scope:"keyword"},{begin:[o.concat(/(?!else)/,_),/\\s+/,_,/\\s+/,/=(?!=)/],className:{1:"type",3:"variable",5:"operator"}},{begin:[/record/,/\\s+/,_],className:{1:"keyword",3:"title.class"},contains:[S,s.C_LINE_COMMENT_MODE,s.C_BLOCK_COMMENT_MODE]},{beginKeywords:"new throw return else",relevance:0},{begin:["(?:"+l+"\\\\s+)",s.UNDERSCORE_IDENT_RE,/\\s*(?=\\()/],className:{2:"title.function"},keywords:E,contains:[{className:"params",begin:/\\(/,end:/\\)/,keywords:E,relevance:0,contains:[g,s.APOS_STRING_MODE,s.QUOTE_STRING_MODE,a,s.C_BLOCK_COMMENT_MODE]},s.C_LINE_COMMENT_MODE,s.C_BLOCK_COMMENT_MODE]},a,g]}}return Jn=i,Jn}var jn,Yo;function ad(){if(Yo)return jn;Yo=1;const t="[A-Za-z$_][0-9A-Za-z$_]*",e=["as","in","of","if","for","while","finally","var","new","function","do","return","void","else","break","catch","instanceof","with","throw","case","default","try","switch","continue","typeof","delete","let","yield","const","class","debugger","async","await","static","import","from","export","extends","using"],n=["true","false","null","undefined","NaN","Infinity"],a=["Object","Function","Boolean","Symbol","Math","Date","Number","BigInt","String","RegExp","Array","Float32Array","Float64Array","Int8Array","Uint8Array","Uint8ClampedArray","Int16Array","Int32Array","Uint16Array","Uint32Array","BigInt64Array","BigUint64Array","Set","Map","WeakSet","WeakMap","ArrayBuffer","SharedArrayBuffer","Atomics","DataView","JSON","Promise","Generator","GeneratorFunction","AsyncFunction","Reflect","Proxy","Intl","WebAssembly"],r=["Error","EvalError","InternalError","RangeError","ReferenceError","SyntaxError","TypeError","URIError"],i=["setInterval","setTimeout","clearInterval","clearTimeout","require","exports","eval","isFinite","isNaN","parseFloat","parseInt","decodeURI","decodeURIComponent","encodeURI","encodeURIComponent","escape","unescape"],s=["arguments","this","super","console","window","document","localStorage","sessionStorage","module","global"],o=[].concat(i,a,r);function _(l){const c=l.regex,d=(Z,{after:K})=>{const te="</"+Z[0].slice(1);return Z.input.indexOf(te,K)!==-1},m=t,p={begin:"<>",end:"</>"},E=/<[A-Za-z0-9\\\\._:-]+\\s*\\/>/,g={begin:/<[A-Za-z0-9\\\\._:-]+/,end:/\\/[A-Za-z0-9\\\\._:-]+>|\\/>/,isTrulyOpeningTag:(Z,K)=>{const te=Z[0].length+Z.index,ne=Z.input[te];if(ne==="<"||ne===","){K.ignoreMatch();return}ne===">"&&(d(Z,{after:te})||K.ignoreMatch());let le;const be=Z.input.substring(te);if(le=be.match(/^\\s*=/)){K.ignoreMatch();return}if((le=be.match(/^\\s+extends\\s+/))&&le.index===0){K.ignoreMatch();return}}},S={$pattern:t,keyword:e,literal:n,built_in:o,"variable.language":s},T="[0-9](_?[0-9])*",R=\`\\\\.(\${T})\`,f="0|[1-9](_?[0-9])*|0[0-7]*[89][0-9]*",A={className:"number",variants:[{begin:\`(\\\\b(\${f})((\${R})|\\\\.)?|(\${R}))[eE][+-]?(\${T})\\\\b\`},{begin:\`\\\\b(\${f})\\\\b((\${R})\\\\b|\\\\.)?|(\${R})\\\\b\`},{begin:"\\\\b(0|[1-9](_?[0-9])*)n\\\\b"},{begin:"\\\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*n?\\\\b"},{begin:"\\\\b0[bB][0-1](_?[0-1])*n?\\\\b"},{begin:"\\\\b0[oO][0-7](_?[0-7])*n?\\\\b"},{begin:"\\\\b0[0-7]+n?\\\\b"}],relevance:0},N={className:"subst",begin:"\\\\$\\\\{",end:"\\\\}",keywords:S,contains:[]},C={begin:".?html\`",end:"",starts:{end:"\`",returnEnd:!1,contains:[l.BACKSLASH_ESCAPE,N],subLanguage:"xml"}},M={begin:".?css\`",end:"",starts:{end:"\`",returnEnd:!1,contains:[l.BACKSLASH_ESCAPE,N],subLanguage:"css"}},y={begin:".?gql\`",end:"",starts:{end:"\`",returnEnd:!1,contains:[l.BACKSLASH_ESCAPE,N],subLanguage:"graphql"}},x={className:"string",begin:"\`",end:"\`",contains:[l.BACKSLASH_ESCAPE,N]},w={className:"comment",variants:[l.COMMENT(/\\/\\*\\*(?!\\/)/,"\\\\*/",{relevance:0,contains:[{begin:"(?=@[A-Za-z]+)",relevance:0,contains:[{className:"doctag",begin:"@[A-Za-z]+"},{className:"type",begin:"\\\\{",end:"\\\\}",excludeEnd:!0,excludeBegin:!0,relevance:0},{className:"variable",begin:m+"(?=\\\\s*(-)|$)",endsParent:!0,relevance:0},{begin:/(?=[^\\n])\\s/,relevance:0}]}]}),l.C_BLOCK_COMMENT_MODE,l.C_LINE_COMMENT_MODE]},H=[l.APOS_STRING_MODE,l.QUOTE_STRING_MODE,C,M,y,x,{match:/\\$\\d+/},A];N.contains=H.concat({begin:/\\{/,end:/\\}/,keywords:S,contains:["self"].concat(H)});const j=[].concat(w,N.contains),ee=j.concat([{begin:/(\\s*)\\(/,end:/\\)/,keywords:S,contains:["self"].concat(j)}]),V={className:"params",begin:/(\\s*)\\(/,end:/\\)/,excludeBegin:!0,excludeEnd:!0,keywords:S,contains:ee},z={variants:[{match:[/class/,/\\s+/,m,/\\s+/,/extends/,/\\s+/,c.concat(m,"(",c.concat(/\\./,m),")*")],scope:{1:"keyword",3:"title.class",5:"keyword",7:"title.class.inherited"}},{match:[/class/,/\\s+/,m],scope:{1:"keyword",3:"title.class"}}]},X={relevance:0,match:c.either(/\\bJSON/,/\\b[A-Z][a-z]+([A-Z][a-z]*|\\d)*/,/\\b[A-Z]{2,}([A-Z][a-z]+|\\d)+([A-Z][a-z]*)*/,/\\b[A-Z]{2,}[a-z]+([A-Z][a-z]+|\\d)*([A-Z][a-z]*)*/),className:"title.class",keywords:{_:[...a,...r]}},q={label:"use_strict",className:"meta",relevance:10,begin:/^\\s*['"]use (strict|asm)['"]/},ie={variants:[{match:[/function/,/\\s+/,m,/(?=\\s*\\()/]},{match:[/function/,/\\s*(?=\\()/]}],className:{1:"keyword",3:"title.function"},label:"func.def",contains:[V],illegal:/%/},_e={relevance:0,match:/\\b[A-Z][A-Z_0-9]+\\b/,className:"variable.constant"};function de(Z){return c.concat("(?!",Z.join("|"),")")}const Se={match:c.concat(/\\b/,de([...i,"super","import"].map(Z=>\`\${Z}\\\\s*\\\\(\`)),m,c.lookahead(/\\s*\\(/)),className:"title.function",relevance:0},ge={begin:c.concat(/\\./,c.lookahead(c.concat(m,/(?![0-9A-Za-z$_(])/))),end:m,excludeBegin:!0,keywords:"prototype",className:"property",relevance:0},Te={match:[/get|set/,/\\s+/,m,/(?=\\()/],className:{1:"keyword",3:"title.function"},contains:[{begin:/\\(\\)/},V]},se="(\\\\([^()]*(\\\\([^()]*(\\\\([^()]*\\\\)[^()]*)*\\\\)[^()]*)*\\\\)|"+l.UNDERSCORE_IDENT_RE+")\\\\s*=>",ue={match:[/const|var|let/,/\\s+/,m,/\\s*/,/=\\s*/,/(async\\s*)?/,c.lookahead(se)],keywords:"async",className:{1:"keyword",3:"title.function"},contains:[V]};return{name:"JavaScript",aliases:["js","jsx","mjs","cjs"],keywords:S,exports:{PARAMS_CONTAINS:ee,CLASS_REFERENCE:X},illegal:/#(?![$_A-z])/,contains:[l.SHEBANG({label:"shebang",binary:"node",relevance:5}),q,l.APOS_STRING_MODE,l.QUOTE_STRING_MODE,C,M,y,x,w,{match:/\\$\\d+/},A,X,{scope:"attr",match:m+c.lookahead(":"),relevance:0},ue,{begin:"("+l.RE_STARTERS_RE+"|\\\\b(case|return|throw)\\\\b)\\\\s*",keywords:"return throw case",relevance:0,contains:[w,l.REGEXP_MODE,{className:"function",begin:se,returnBegin:!0,end:"\\\\s*=>",contains:[{className:"params",variants:[{begin:l.UNDERSCORE_IDENT_RE,relevance:0},{className:null,begin:/\\(\\s*\\)/,skip:!0},{begin:/(\\s*)\\(/,end:/\\)/,excludeBegin:!0,excludeEnd:!0,keywords:S,contains:ee}]}]},{begin:/,/,relevance:0},{match:/\\s+/,relevance:0},{variants:[{begin:p.begin,end:p.end},{match:E},{begin:g.begin,"on:begin":g.isTrulyOpeningTag,end:g.end}],subLanguage:"xml",contains:[{begin:g.begin,end:g.end,skip:!0,contains:["self"]}]}]},ie,{beginKeywords:"while if switch catch for"},{begin:"\\\\b(?!function)"+l.UNDERSCORE_IDENT_RE+"\\\\([^()]*(\\\\([^()]*(\\\\([^()]*\\\\)[^()]*)*\\\\)[^()]*)*\\\\)\\\\s*\\\\{",returnBegin:!0,label:"func.def",contains:[V,l.inherit(l.TITLE_MODE,{begin:m,className:"title.function"})]},{match:/\\.\\.\\./,relevance:0},ge,{match:"\\\\$"+m,relevance:0},{match:[/\\bconstructor(?=\\s*\\()/],className:{1:"title.function"},contains:[V]},Se,_e,z,Te,{match:/\\$[(.]/}]}}return jn=_,jn}var ea,qo;function rd(){if(qo)return ea;qo=1;function t(e){const a={className:"params",begin:/\\(/,end:/\\)/,contains:[{begin:/[\\w-]+ *=/,returnBegin:!0,relevance:0,contains:[{className:"attr",begin:/[\\w-]+/}]}],relevance:0},r={className:"function",begin:/:[\\w\\-.]+/,relevance:0},i={className:"string",begin:/\\B([\\/.])[\\w\\-.\\/=]+/},s={className:"params",begin:/--[\\w\\-=\\/]+/};return{name:"JBoss CLI",aliases:["wildfly-cli"],keywords:{$pattern:"[a-z-]+",keyword:"alias batch cd clear command connect connection-factory connection-info data-source deploy deployment-info deployment-overlay echo echo-dmr help history if jdbc-driver-info jms-queue|20 jms-topic|20 ls patch pwd quit read-attribute read-operation reload rollout-plan run-batch set shutdown try unalias undeploy unset version xa-data-source",literal:"true false"},contains:[e.HASH_COMMENT_MODE,e.QUOTE_STRING_MODE,s,r,i,a]}}return ea=t,ea}var ta,Ho;function id(){if(Ho)return ta;Ho=1;function t(e){const n={className:"attr",begin:/"(\\\\.|[^\\\\"\\r\\n])*"(?=\\s*:)/,relevance:1.01},a={match:/[{}[\\],:]/,className:"punctuation",relevance:0},r=["true","false","null"],i={scope:"literal",beginKeywords:r.join(" ")};return{name:"JSON",aliases:["jsonc"],keywords:{literal:r},contains:[n,a,e.QUOTE_STRING_MODE,i,e.C_NUMBER_MODE,e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE],illegal:"\\\\S"}}return ta=t,ta}var na,Vo;function od(){if(Vo)return na;Vo=1;function t(e){const n="[A-Za-z_\\\\u00A1-\\\\uFFFF][A-Za-z_0-9\\\\u00A1-\\\\uFFFF]*",s={$pattern:n,keyword:["baremodule","begin","break","catch","ccall","const","continue","do","else","elseif","end","export","false","finally","for","function","global","if","import","in","isa","let","local","macro","module","quote","return","true","try","using","where","while"],literal:["ARGS","C_NULL","DEPOT_PATH","ENDIAN_BOM","ENV","Inf","Inf16","Inf32","Inf64","InsertionSort","LOAD_PATH","MergeSort","NaN","NaN16","NaN32","NaN64","PROGRAM_FILE","QuickSort","RoundDown","RoundFromZero","RoundNearest","RoundNearestTiesAway","RoundNearestTiesUp","RoundToZero","RoundUp","VERSION|0","devnull","false","im","missing","nothing","pi","stderr","stdin","stdout","true","undef","π","ℯ"],built_in:["AbstractArray","AbstractChannel","AbstractChar","AbstractDict","AbstractDisplay","AbstractFloat","AbstractIrrational","AbstractMatrix","AbstractRange","AbstractSet","AbstractString","AbstractUnitRange","AbstractVecOrMat","AbstractVector","Any","ArgumentError","Array","AssertionError","BigFloat","BigInt","BitArray","BitMatrix","BitSet","BitVector","Bool","BoundsError","CapturedException","CartesianIndex","CartesianIndices","Cchar","Cdouble","Cfloat","Channel","Char","Cint","Cintmax_t","Clong","Clonglong","Cmd","Colon","Complex","ComplexF16","ComplexF32","ComplexF64","CompositeException","Condition","Cptrdiff_t","Cshort","Csize_t","Cssize_t","Cstring","Cuchar","Cuint","Cuintmax_t","Culong","Culonglong","Cushort","Cvoid","Cwchar_t","Cwstring","DataType","DenseArray","DenseMatrix","DenseVecOrMat","DenseVector","Dict","DimensionMismatch","Dims","DivideError","DomainError","EOFError","Enum","ErrorException","Exception","ExponentialBackOff","Expr","Float16","Float32","Float64","Function","GlobalRef","HTML","IO","IOBuffer","IOContext","IOStream","IdDict","IndexCartesian","IndexLinear","IndexStyle","InexactError","InitError","Int","Int128","Int16","Int32","Int64","Int8","Integer","InterruptException","InvalidStateException","Irrational","KeyError","LinRange","LineNumberNode","LinearIndices","LoadError","MIME","Matrix","Method","MethodError","Missing","MissingException","Module","NTuple","NamedTuple","Nothing","Number","OrdinalRange","OutOfMemoryError","OverflowError","Pair","PartialQuickSort","PermutedDimsArray","Pipe","ProcessFailedException","Ptr","QuoteNode","Rational","RawFD","ReadOnlyMemoryError","Real","ReentrantLock","Ref","Regex","RegexMatch","RoundingMode","SegmentationFault","Set","Signed","Some","StackOverflowError","StepRange","StepRangeLen","StridedArray","StridedMatrix","StridedVecOrMat","StridedVector","String","StringIndexError","SubArray","SubString","SubstitutionString","Symbol","SystemError","Task","TaskFailedException","Text","TextDisplay","Timer","Tuple","Type","TypeError","TypeVar","UInt","UInt128","UInt16","UInt32","UInt64","UInt8","UndefInitializer","UndefKeywordError","UndefRefError","UndefVarError","Union","UnionAll","UnitRange","Unsigned","Val","Vararg","VecElement","VecOrMat","Vector","VersionNumber","WeakKeyDict","WeakRef"]},o={keywords:s,illegal:/<\\//},_={className:"number",begin:/(\\b0x[\\d_]*(\\.[\\d_]*)?|0x\\.\\d[\\d_]*)p[-+]?\\d+|\\b0[box][a-fA-F0-9][a-fA-F0-9_]*|(\\b\\d[\\d_]*(\\.[\\d_]*)?|\\.\\d[\\d_]*)([eEfF][-+]?\\d+)?/,relevance:0},l={className:"string",begin:/'(.|\\\\[xXuU][a-zA-Z0-9]+)'/},c={className:"subst",begin:/\\$\\(/,end:/\\)/,keywords:s},d={className:"variable",begin:"\\\\$"+n},m={className:"string",contains:[e.BACKSLASH_ESCAPE,c,d],variants:[{begin:/\\w*"""/,end:/"""\\w*/,relevance:10},{begin:/\\w*"/,end:/"\\w*/}]},p={className:"string",contains:[e.BACKSLASH_ESCAPE,c,d],begin:"\`",end:"\`"},E={className:"meta",begin:"@"+n},g={className:"comment",variants:[{begin:"#=",end:"=#",relevance:10},{begin:"#",end:"$"}]};return o.name="Julia",o.contains=[_,l,m,p,E,g,e.HASH_COMMENT_MODE,{className:"keyword",begin:"\\\\b(((abstract|primitive)\\\\s+)type|(mutable\\\\s+)?struct)\\\\b"},{begin:/<:/}],c.contains=o.contains,o}return na=t,na}var aa,zo;function sd(){if(zo)return aa;zo=1;function t(e){return{name:"Julia REPL",contains:[{className:"meta.prompt",begin:/^julia>/,relevance:10,starts:{end:/^(?![ ]{6})/,subLanguage:"julia"}}],aliases:["jldoctest"]}}return aa=t,aa}var ra,Wo;function ld(){if(Wo)return ra;Wo=1;var t="[0-9](_*[0-9])*",e=\`\\\\.(\${t})\`,n="[0-9a-fA-F](_*[0-9a-fA-F])*",a={className:"number",variants:[{begin:\`(\\\\b(\${t})((\${e})|\\\\.)?|(\${e}))[eE][+-]?(\${t})[fFdD]?\\\\b\`},{begin:\`\\\\b(\${t})((\${e})[fFdD]?\\\\b|\\\\.([fFdD]\\\\b)?)\`},{begin:\`(\${e})[fFdD]?\\\\b\`},{begin:\`\\\\b(\${t})[fFdD]\\\\b\`},{begin:\`\\\\b0[xX]((\${n})\\\\.?|(\${n})?\\\\.(\${n}))[pP][+-]?(\${t})[fFdD]?\\\\b\`},{begin:"\\\\b(0|[1-9](_*[0-9])*)[lL]?\\\\b"},{begin:\`\\\\b0[xX](\${n})[lL]?\\\\b\`},{begin:"\\\\b0(_*[0-7])*[lL]?\\\\b"},{begin:"\\\\b0[bB][01](_*[01])*[lL]?\\\\b"}],relevance:0};function r(i){const s={keyword:"abstract as val var vararg get set class object open private protected public noinline crossinline dynamic final enum if else do while for when throw try catch finally import package is in fun override companion reified inline lateinit init interface annotation data sealed internal infix operator out by constructor super tailrec where const inner suspend typealias external expect actual",built_in:"Byte Short Char Int Long Boolean Float Double Void Unit Nothing",literal:"true false null"},o={className:"keyword",begin:/\\b(break|continue|return|this)\\b/,starts:{contains:[{className:"symbol",begin:/@\\w+/}]}},_={className:"symbol",begin:i.UNDERSCORE_IDENT_RE+"@"},l={className:"subst",begin:/\\$\\{/,end:/\\}/,contains:[i.C_NUMBER_MODE]},c={className:"variable",begin:"\\\\$"+i.UNDERSCORE_IDENT_RE},d={className:"string",variants:[{begin:'"""',end:'"""(?=[^"])',contains:[c,l]},{begin:"'",end:"'",illegal:/\\n/,contains:[i.BACKSLASH_ESCAPE]},{begin:'"',end:'"',illegal:/\\n/,contains:[i.BACKSLASH_ESCAPE,c,l]}]};l.contains.push(d);const m={className:"meta",begin:"@(?:file|property|field|get|set|receiver|param|setparam|delegate)\\\\s*:(?:\\\\s*"+i.UNDERSCORE_IDENT_RE+")?"},p={className:"meta",begin:"@"+i.UNDERSCORE_IDENT_RE,contains:[{begin:/\\(/,end:/\\)/,contains:[i.inherit(d,{className:"string"}),"self"]}]},E=a,g=i.COMMENT("/\\\\*","\\\\*/",{contains:[i.C_BLOCK_COMMENT_MODE]}),S={variants:[{className:"type",begin:i.UNDERSCORE_IDENT_RE},{begin:/\\(/,end:/\\)/,contains:[]}]},T=S;return T.variants[1].contains=[S],S.variants[1].contains=[T],{name:"Kotlin",aliases:["kt","kts"],keywords:s,contains:[i.COMMENT("/\\\\*\\\\*","\\\\*/",{relevance:0,contains:[{className:"doctag",begin:"@[A-Za-z]+"}]}),i.C_LINE_COMMENT_MODE,g,o,_,m,p,{className:"function",beginKeywords:"fun",end:"[(]|$",returnBegin:!0,excludeEnd:!0,keywords:s,relevance:5,contains:[{begin:i.UNDERSCORE_IDENT_RE+"\\\\s*\\\\(",returnBegin:!0,relevance:0,contains:[i.UNDERSCORE_TITLE_MODE]},{className:"type",begin:/</,end:/>/,keywords:"reified",relevance:0},{className:"params",begin:/\\(/,end:/\\)/,endsParent:!0,keywords:s,relevance:0,contains:[{begin:/:/,end:/[=,\\/]/,endsWithParent:!0,contains:[S,i.C_LINE_COMMENT_MODE,g],relevance:0},i.C_LINE_COMMENT_MODE,g,m,p,d,i.C_NUMBER_MODE]},g]},{begin:[/class|interface|trait/,/\\s+/,i.UNDERSCORE_IDENT_RE],beginScope:{3:"title.class"},keywords:"class interface trait",end:/[:\\{(]|$/,excludeEnd:!0,illegal:"extends implements",contains:[{beginKeywords:"public protected internal private constructor"},i.UNDERSCORE_TITLE_MODE,{className:"type",begin:/</,end:/>/,excludeBegin:!0,excludeEnd:!0,relevance:0},{className:"type",begin:/[,:]\\s*/,end:/[<\\(,){\\s]|$/,excludeBegin:!0,returnEnd:!0},m,p]},d,{className:"meta",begin:"^#!/usr/bin/env",end:"$",illegal:\`
\`},E]}}return ra=r,ra}var ia,Ko;function cd(){if(Ko)return ia;Ko=1;function t(e){const n="[a-zA-Z_][\\\\w.]*",a="<\\\\?(lasso(script)?|=)",r="\\\\]|\\\\?>",i={$pattern:n+"|&[lg]t;",literal:"true false none minimal full all void and or not bw nbw ew new cn ncn lt lte gt gte eq neq rx nrx ft",built_in:"array date decimal duration integer map pair string tag xml null boolean bytes keyword list locale queue set stack staticarray local var variable global data self inherited currentcapture givenblock",keyword:"cache database_names database_schemanames database_tablenames define_tag define_type email_batch encode_set html_comment handle handle_error header if inline iterate ljax_target link link_currentaction link_currentgroup link_currentrecord link_detail link_firstgroup link_firstrecord link_lastgroup link_lastrecord link_nextgroup link_nextrecord link_prevgroup link_prevrecord log loop namespace_using output_none portal private protect records referer referrer repeating resultset rows search_args search_arguments select sort_args sort_arguments thread_atomic value_list while abort case else fail_if fail_ifnot fail if_empty if_false if_null if_true loop_abort loop_continue loop_count params params_up return return_value run_children soap_definetag soap_lastrequest soap_lastresponse tag_name ascending average by define descending do equals frozen group handle_failure import in into join let match max min on order parent protected provide public require returnhome skip split_thread sum take thread to trait type where with yield yieldhome"},s=e.COMMENT("<!--","-->",{relevance:0}),o={className:"meta",begin:"\\\\[noprocess\\\\]",starts:{end:"\\\\[/noprocess\\\\]",returnEnd:!0,contains:[s]}},_={className:"meta",begin:"\\\\[/noprocess|"+a},l={className:"symbol",begin:"'"+n+"'"},c=[e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,e.inherit(e.C_NUMBER_MODE,{begin:e.C_NUMBER_RE+"|(-?infinity|NaN)\\\\b"}),e.inherit(e.APOS_STRING_MODE,{illegal:null}),e.inherit(e.QUOTE_STRING_MODE,{illegal:null}),{className:"string",begin:"\`",end:"\`"},{variants:[{begin:"[#$]"+n},{begin:"#",end:"\\\\d+",illegal:"\\\\W"}]},{className:"type",begin:"::\\\\s*",end:n,illegal:"\\\\W"},{className:"params",variants:[{begin:"-(?!infinity)"+n,relevance:0},{begin:"(\\\\.\\\\.\\\\.)"}]},{begin:/(->|\\.)\\s*/,relevance:0,contains:[l]},{className:"class",beginKeywords:"define",returnEnd:!0,end:"\\\\(|=>",contains:[e.inherit(e.TITLE_MODE,{begin:n+"(=(?!>))?|[-+*/%](?!>)"})]}];return{name:"Lasso",aliases:["ls","lassoscript"],case_insensitive:!0,keywords:i,contains:[{className:"meta",begin:r,relevance:0,starts:{end:"\\\\[|"+a,returnEnd:!0,relevance:0,contains:[s]}},o,_,{className:"meta",begin:"\\\\[no_square_brackets",starts:{end:"\\\\[/no_square_brackets\\\\]",keywords:i,contains:[{className:"meta",begin:r,relevance:0,starts:{end:"\\\\[noprocess\\\\]|"+a,returnEnd:!0,contains:[s]}},o,_].concat(c)}},{className:"meta",begin:"\\\\[",relevance:0},{className:"meta",begin:"^#!",end:"lasso9$",relevance:10}].concat(c)}}return ia=t,ia}var oa,$o;function _d(){if($o)return oa;$o=1;function t(e){const a=e.regex.either(...["(?:NeedsTeXFormat|RequirePackage|GetIdInfo)","Provides(?:Expl)?(?:Package|Class|File)","(?:DeclareOption|ProcessOptions)","(?:documentclass|usepackage|input|include)","makeat(?:letter|other)","ExplSyntax(?:On|Off)","(?:new|renew|provide)?command","(?:re)newenvironment","(?:New|Renew|Provide|Declare)(?:Expandable)?DocumentCommand","(?:New|Renew|Provide|Declare)DocumentEnvironment","(?:(?:e|g|x)?def|let)","(?:begin|end)","(?:part|chapter|(?:sub){0,2}section|(?:sub)?paragraph)","caption","(?:label|(?:eq|page|name)?ref|(?:paren|foot|super)?cite)","(?:alpha|beta|[Gg]amma|[Dd]elta|(?:var)?epsilon|zeta|eta|[Tt]heta|vartheta)","(?:iota|(?:var)?kappa|[Ll]ambda|mu|nu|[Xx]i|[Pp]i|varpi|(?:var)rho)","(?:[Ss]igma|varsigma|tau|[Uu]psilon|[Pp]hi|varphi|chi|[Pp]si|[Oo]mega)","(?:frac|sum|prod|lim|infty|times|sqrt|leq|geq|left|right|middle|[bB]igg?)","(?:[lr]angle|q?quad|[lcvdi]?dots|d?dot|hat|tilde|bar)"].map(w=>w+"(?![a-zA-Z@:_])")),r=new RegExp(["(?:__)?[a-zA-Z]{2,}_[a-zA-Z](?:_?[a-zA-Z])+:[a-zA-Z]*","[lgc]__?[a-zA-Z](?:_?[a-zA-Z])*_[a-zA-Z]{2,}","[qs]__?[a-zA-Z](?:_?[a-zA-Z])+","use(?:_i)?:[a-zA-Z]*","(?:else|fi|or):","(?:if|cs|exp):w","(?:hbox|vbox):n","::[a-zA-Z]_unbraced","::[a-zA-Z:]"].map(w=>w+"(?![a-zA-Z:_])").join("|")),i=[{begin:/[a-zA-Z@]+/},{begin:/[^a-zA-Z@]?/}],s=[{begin:/\\^{6}[0-9a-f]{6}/},{begin:/\\^{5}[0-9a-f]{5}/},{begin:/\\^{4}[0-9a-f]{4}/},{begin:/\\^{3}[0-9a-f]{3}/},{begin:/\\^{2}[0-9a-f]{2}/},{begin:/\\^{2}[\\u0000-\\u007f]/}],o={className:"keyword",begin:/\\\\/,relevance:0,contains:[{endsParent:!0,begin:a},{endsParent:!0,begin:r},{endsParent:!0,variants:s},{endsParent:!0,relevance:0,variants:i}]},_={className:"params",relevance:0,begin:/#+\\d?/},l={variants:s},c={className:"built_in",relevance:0,begin:/[$&^_]/},d={className:"meta",begin:/% ?!(T[eE]X|tex|BIB|bib)/,end:"$",relevance:10},m=e.COMMENT("%","$",{relevance:0}),p=[o,_,l,c,d,m],E={begin:/\\{/,end:/\\}/,relevance:0,contains:["self",...p]},g=e.inherit(E,{relevance:0,endsParent:!0,contains:[E,...p]}),S={begin:/\\[/,end:/\\]/,endsParent:!0,relevance:0,contains:[E,...p]},T={begin:/\\s+/,relevance:0},R=[g],f=[S],A=function(w,H){return{contains:[T],starts:{relevance:0,contains:w,starts:H}}},N=function(w,H){return{begin:"\\\\\\\\"+w+"(?![a-zA-Z@:_])",keywords:{$pattern:/\\\\[a-zA-Z]+/,keyword:"\\\\"+w},relevance:0,contains:[T],starts:H}},C=function(w,H){return e.inherit({begin:"\\\\\\\\begin(?=[ 	]*(\\\\r?\\\\n[ 	]*)?\\\\{"+w+"\\\\})",keywords:{$pattern:/\\\\[a-zA-Z]+/,keyword:"\\\\begin"},relevance:0},A(R,H))},M=(w="string")=>e.END_SAME_AS_BEGIN({className:w,begin:/(.|\\r?\\n)/,end:/(.|\\r?\\n)/,excludeBegin:!0,excludeEnd:!0,endsParent:!0}),y=function(w){return{className:"string",end:"(?=\\\\\\\\end\\\\{"+w+"\\\\})"}},x=(w="string")=>({relevance:0,begin:/\\{/,starts:{endsParent:!0,contains:[{className:w,end:/(?=\\})/,endsParent:!0,contains:[{begin:/\\{/,end:/\\}/,relevance:0,contains:["self"]}]}]}}),G=[...["verb","lstinline"].map(w=>N(w,{contains:[M()]})),N("mint",A(R,{contains:[M()]})),N("mintinline",A(R,{contains:[x(),M()]})),N("url",{contains:[x("link"),x("link")]}),N("hyperref",{contains:[x("link")]}),N("href",A(f,{contains:[x("link")]})),...[].concat(...["","\\\\*"].map(w=>[C("verbatim"+w,y("verbatim"+w)),C("filecontents"+w,A(R,y("filecontents"+w))),...["","B","L"].map(H=>C(H+"Verbatim"+w,A(f,y(H+"Verbatim"+w))))])),C("minted",A(f,A(R,y("minted"))))];return{name:"LaTeX",aliases:["tex"],contains:[...G,...p]}}return oa=t,oa}var sa,Qo;function dd(){if(Qo)return sa;Qo=1;function t(e){return{name:"LDIF",contains:[{className:"attribute",match:"^dn(?=:)",relevance:10},{className:"attribute",match:"^\\\\w+(?=:)"},{className:"literal",match:"^-"},e.HASH_COMMENT_MODE]}}return sa=t,sa}var la,Xo;function ud(){if(Xo)return la;Xo=1;function t(e){const n=/([A-Za-z_][A-Za-z_0-9]*)?/,r={scope:"params",begin:/\\(/,end:/\\)(?=\\:?)/,endsParent:!0,relevance:7,contains:[{scope:"string",begin:'"',end:'"'},{scope:"keyword",match:["true","false","in"].join("|")},{scope:"variable",match:/[A-Za-z_][A-Za-z_0-9]*/},{scope:"operator",match:/\\+|\\-|\\*|\\/|\\%|\\=\\=|\\=|\\!|\\>|\\<|\\&\\&|\\|\\|/}]},i={match:[n,/(?=\\()/],scope:{1:"keyword"},contains:[r]};return r.contains.unshift(i),{name:"Leaf",contains:[{match:[/#+/,n,/(?=\\()/],scope:{1:"punctuation",2:"keyword"},starts:{contains:[{match:/\\:/,scope:"punctuation"}]},contains:[r]},{match:[/#+/,n,/:?/],scope:{1:"punctuation",2:"keyword",3:"punctuation"}}]}}return la=t,la}var ca,Zo;function md(){if(Zo)return ca;Zo=1;const t=c=>({IMPORTANT:{scope:"meta",begin:"!important"},BLOCK_COMMENT:c.C_BLOCK_COMMENT_MODE,HEXCOLOR:{scope:"number",begin:/#(([0-9a-fA-F]{3,4})|(([0-9a-fA-F]{2}){3,4}))\\b/},FUNCTION_DISPATCH:{className:"built_in",begin:/[\\w-]+(?=\\()/},ATTRIBUTE_SELECTOR_MODE:{scope:"selector-attr",begin:/\\[/,end:/\\]/,illegal:"$",contains:[c.APOS_STRING_MODE,c.QUOTE_STRING_MODE]},CSS_NUMBER_MODE:{scope:"number",begin:c.NUMBER_RE+"(%|em|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc|px|deg|grad|rad|turn|s|ms|Hz|kHz|dpi|dpcm|dppx)?",relevance:0},CSS_VARIABLE:{className:"attr",begin:/--[A-Za-z_][A-Za-z0-9_-]*/}}),e=["a","abbr","address","article","aside","audio","b","blockquote","body","button","canvas","caption","cite","code","dd","del","details","dfn","div","dl","dt","em","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","header","hgroup","html","i","iframe","img","input","ins","kbd","label","legend","li","main","mark","menu","nav","object","ol","optgroup","option","p","picture","q","quote","samp","section","select","source","span","strong","summary","sup","table","tbody","td","textarea","tfoot","th","thead","time","tr","ul","var","video"],n=["defs","g","marker","mask","pattern","svg","switch","symbol","feBlend","feColorMatrix","feComponentTransfer","feComposite","feConvolveMatrix","feDiffuseLighting","feDisplacementMap","feFlood","feGaussianBlur","feImage","feMerge","feMorphology","feOffset","feSpecularLighting","feTile","feTurbulence","linearGradient","radialGradient","stop","circle","ellipse","image","line","path","polygon","polyline","rect","text","use","textPath","tspan","foreignObject","clipPath"],a=[...e,...n],r=["any-hover","any-pointer","aspect-ratio","color","color-gamut","color-index","device-aspect-ratio","device-height","device-width","display-mode","forced-colors","grid","height","hover","inverted-colors","monochrome","orientation","overflow-block","overflow-inline","pointer","prefers-color-scheme","prefers-contrast","prefers-reduced-motion","prefers-reduced-transparency","resolution","scan","scripting","update","width","min-width","max-width","min-height","max-height"].sort().reverse(),i=["active","any-link","blank","checked","current","default","defined","dir","disabled","drop","empty","enabled","first","first-child","first-of-type","fullscreen","future","focus","focus-visible","focus-within","has","host","host-context","hover","indeterminate","in-range","invalid","is","lang","last-child","last-of-type","left","link","local-link","not","nth-child","nth-col","nth-last-child","nth-last-col","nth-last-of-type","nth-of-type","only-child","only-of-type","optional","out-of-range","past","placeholder-shown","read-only","read-write","required","right","root","scope","target","target-within","user-invalid","valid","visited","where"].sort().reverse(),s=["after","backdrop","before","cue","cue-region","first-letter","first-line","grammar-error","marker","part","placeholder","selection","slotted","spelling-error"].sort().reverse(),o=["accent-color","align-content","align-items","align-self","alignment-baseline","all","anchor-name","animation","animation-composition","animation-delay","animation-direction","animation-duration","animation-fill-mode","animation-iteration-count","animation-name","animation-play-state","animation-range","animation-range-end","animation-range-start","animation-timeline","animation-timing-function","appearance","aspect-ratio","backdrop-filter","backface-visibility","background","background-attachment","background-blend-mode","background-clip","background-color","background-image","background-origin","background-position","background-position-x","background-position-y","background-repeat","background-size","baseline-shift","block-size","border","border-block","border-block-color","border-block-end","border-block-end-color","border-block-end-style","border-block-end-width","border-block-start","border-block-start-color","border-block-start-style","border-block-start-width","border-block-style","border-block-width","border-bottom","border-bottom-color","border-bottom-left-radius","border-bottom-right-radius","border-bottom-style","border-bottom-width","border-collapse","border-color","border-end-end-radius","border-end-start-radius","border-image","border-image-outset","border-image-repeat","border-image-slice","border-image-source","border-image-width","border-inline","border-inline-color","border-inline-end","border-inline-end-color","border-inline-end-style","border-inline-end-width","border-inline-start","border-inline-start-color","border-inline-start-style","border-inline-start-width","border-inline-style","border-inline-width","border-left","border-left-color","border-left-style","border-left-width","border-radius","border-right","border-right-color","border-right-style","border-right-width","border-spacing","border-start-end-radius","border-start-start-radius","border-style","border-top","border-top-color","border-top-left-radius","border-top-right-radius","border-top-style","border-top-width","border-width","bottom","box-align","box-decoration-break","box-direction","box-flex","box-flex-group","box-lines","box-ordinal-group","box-orient","box-pack","box-shadow","box-sizing","break-after","break-before","break-inside","caption-side","caret-color","clear","clip","clip-path","clip-rule","color","color-interpolation","color-interpolation-filters","color-profile","color-rendering","color-scheme","column-count","column-fill","column-gap","column-rule","column-rule-color","column-rule-style","column-rule-width","column-span","column-width","columns","contain","contain-intrinsic-block-size","contain-intrinsic-height","contain-intrinsic-inline-size","contain-intrinsic-size","contain-intrinsic-width","container","container-name","container-type","content","content-visibility","counter-increment","counter-reset","counter-set","cue","cue-after","cue-before","cursor","cx","cy","direction","display","dominant-baseline","empty-cells","enable-background","field-sizing","fill","fill-opacity","fill-rule","filter","flex","flex-basis","flex-direction","flex-flow","flex-grow","flex-shrink","flex-wrap","float","flood-color","flood-opacity","flow","font","font-display","font-family","font-feature-settings","font-kerning","font-language-override","font-optical-sizing","font-palette","font-size","font-size-adjust","font-smooth","font-smoothing","font-stretch","font-style","font-synthesis","font-synthesis-position","font-synthesis-small-caps","font-synthesis-style","font-synthesis-weight","font-variant","font-variant-alternates","font-variant-caps","font-variant-east-asian","font-variant-emoji","font-variant-ligatures","font-variant-numeric","font-variant-position","font-variation-settings","font-weight","forced-color-adjust","gap","glyph-orientation-horizontal","glyph-orientation-vertical","grid","grid-area","grid-auto-columns","grid-auto-flow","grid-auto-rows","grid-column","grid-column-end","grid-column-start","grid-gap","grid-row","grid-row-end","grid-row-start","grid-template","grid-template-areas","grid-template-columns","grid-template-rows","hanging-punctuation","height","hyphenate-character","hyphenate-limit-chars","hyphens","icon","image-orientation","image-rendering","image-resolution","ime-mode","initial-letter","initial-letter-align","inline-size","inset","inset-area","inset-block","inset-block-end","inset-block-start","inset-inline","inset-inline-end","inset-inline-start","isolation","justify-content","justify-items","justify-self","kerning","left","letter-spacing","lighting-color","line-break","line-height","line-height-step","list-style","list-style-image","list-style-position","list-style-type","margin","margin-block","margin-block-end","margin-block-start","margin-bottom","margin-inline","margin-inline-end","margin-inline-start","margin-left","margin-right","margin-top","margin-trim","marker","marker-end","marker-mid","marker-start","marks","mask","mask-border","mask-border-mode","mask-border-outset","mask-border-repeat","mask-border-slice","mask-border-source","mask-border-width","mask-clip","mask-composite","mask-image","mask-mode","mask-origin","mask-position","mask-repeat","mask-size","mask-type","masonry-auto-flow","math-depth","math-shift","math-style","max-block-size","max-height","max-inline-size","max-width","min-block-size","min-height","min-inline-size","min-width","mix-blend-mode","nav-down","nav-index","nav-left","nav-right","nav-up","none","normal","object-fit","object-position","offset","offset-anchor","offset-distance","offset-path","offset-position","offset-rotate","opacity","order","orphans","outline","outline-color","outline-offset","outline-style","outline-width","overflow","overflow-anchor","overflow-block","overflow-clip-margin","overflow-inline","overflow-wrap","overflow-x","overflow-y","overlay","overscroll-behavior","overscroll-behavior-block","overscroll-behavior-inline","overscroll-behavior-x","overscroll-behavior-y","padding","padding-block","padding-block-end","padding-block-start","padding-bottom","padding-inline","padding-inline-end","padding-inline-start","padding-left","padding-right","padding-top","page","page-break-after","page-break-before","page-break-inside","paint-order","pause","pause-after","pause-before","perspective","perspective-origin","place-content","place-items","place-self","pointer-events","position","position-anchor","position-visibility","print-color-adjust","quotes","r","resize","rest","rest-after","rest-before","right","rotate","row-gap","ruby-align","ruby-position","scale","scroll-behavior","scroll-margin","scroll-margin-block","scroll-margin-block-end","scroll-margin-block-start","scroll-margin-bottom","scroll-margin-inline","scroll-margin-inline-end","scroll-margin-inline-start","scroll-margin-left","scroll-margin-right","scroll-margin-top","scroll-padding","scroll-padding-block","scroll-padding-block-end","scroll-padding-block-start","scroll-padding-bottom","scroll-padding-inline","scroll-padding-inline-end","scroll-padding-inline-start","scroll-padding-left","scroll-padding-right","scroll-padding-top","scroll-snap-align","scroll-snap-stop","scroll-snap-type","scroll-timeline","scroll-timeline-axis","scroll-timeline-name","scrollbar-color","scrollbar-gutter","scrollbar-width","shape-image-threshold","shape-margin","shape-outside","shape-rendering","speak","speak-as","src","stop-color","stop-opacity","stroke","stroke-dasharray","stroke-dashoffset","stroke-linecap","stroke-linejoin","stroke-miterlimit","stroke-opacity","stroke-width","tab-size","table-layout","text-align","text-align-all","text-align-last","text-anchor","text-combine-upright","text-decoration","text-decoration-color","text-decoration-line","text-decoration-skip","text-decoration-skip-ink","text-decoration-style","text-decoration-thickness","text-emphasis","text-emphasis-color","text-emphasis-position","text-emphasis-style","text-indent","text-justify","text-orientation","text-overflow","text-rendering","text-shadow","text-size-adjust","text-transform","text-underline-offset","text-underline-position","text-wrap","text-wrap-mode","text-wrap-style","timeline-scope","top","touch-action","transform","transform-box","transform-origin","transform-style","transition","transition-behavior","transition-delay","transition-duration","transition-property","transition-timing-function","translate","unicode-bidi","user-modify","user-select","vector-effect","vertical-align","view-timeline","view-timeline-axis","view-timeline-inset","view-timeline-name","view-transition-name","visibility","voice-balance","voice-duration","voice-family","voice-pitch","voice-range","voice-rate","voice-stress","voice-volume","white-space","white-space-collapse","widows","width","will-change","word-break","word-spacing","word-wrap","writing-mode","x","y","z-index","zoom"].sort().reverse(),_=i.concat(s).sort().reverse();function l(c){const d=t(c),m=_,p="and or not only",E="[\\\\w-]+",g="("+E+"|@\\\\{"+E+"\\\\})",S=[],T=[],R=function(j){return{className:"string",begin:"~?"+j+".*?"+j}},f=function(j,ee,V){return{className:j,begin:ee,relevance:V}},A={$pattern:/[a-z-]+/,keyword:p,attribute:r.join(" ")},N={begin:"\\\\(",end:"\\\\)",contains:T,keywords:A,relevance:0};T.push(c.C_LINE_COMMENT_MODE,c.C_BLOCK_COMMENT_MODE,R("'"),R('"'),d.CSS_NUMBER_MODE,{begin:"(url|data-uri)\\\\(",starts:{className:"string",end:"[\\\\)\\\\n]",excludeEnd:!0}},d.HEXCOLOR,N,f("variable","@@?"+E,10),f("variable","@\\\\{"+E+"\\\\}"),f("built_in","~?\`[^\`]*?\`"),{className:"attribute",begin:E+"\\\\s*:",end:":",returnBegin:!0,excludeEnd:!0},d.IMPORTANT,{beginKeywords:"and not"},d.FUNCTION_DISPATCH);const C=T.concat({begin:/\\{/,end:/\\}/,contains:S}),M={beginKeywords:"when",endsWithParent:!0,contains:[{beginKeywords:"and not"}].concat(T)},y={begin:g+"\\\\s*:",returnBegin:!0,end:/[;}]/,relevance:0,contains:[{begin:/-(webkit|moz|ms|o)-/},d.CSS_VARIABLE,{className:"attribute",begin:"\\\\b("+o.join("|")+")\\\\b",end:/(?=:)/,starts:{endsWithParent:!0,illegal:"[<=$]",relevance:0,contains:T}}]},x={className:"keyword",begin:"@(import|media|charset|font-face|(-[a-z]+-)?keyframes|supports|document|namespace|page|viewport|host)\\\\b",starts:{end:"[;{}]",keywords:A,returnEnd:!0,contains:T,relevance:0}},G={className:"variable",variants:[{begin:"@"+E+"\\\\s*:",relevance:15},{begin:"@"+E}],starts:{end:"[;}]",returnEnd:!0,contains:C}},w={variants:[{begin:"[\\\\.#:&\\\\[>]",end:"[;{}]"},{begin:g,end:/\\{/}],returnBegin:!0,returnEnd:!0,illegal:\`[<='$"]\`,relevance:0,contains:[c.C_LINE_COMMENT_MODE,c.C_BLOCK_COMMENT_MODE,M,f("keyword","all\\\\b"),f("variable","@\\\\{"+E+"\\\\}"),{begin:"\\\\b("+a.join("|")+")\\\\b",className:"selector-tag"},d.CSS_NUMBER_MODE,f("selector-tag",g,0),f("selector-id","#"+g),f("selector-class","\\\\."+g,0),f("selector-tag","&",0),d.ATTRIBUTE_SELECTOR_MODE,{className:"selector-pseudo",begin:":("+i.join("|")+")"},{className:"selector-pseudo",begin:":(:)?("+s.join("|")+")"},{begin:/\\(/,end:/\\)/,relevance:0,contains:C},{begin:"!important"},d.FUNCTION_DISPATCH]},H={begin:E+\`:(:)?(\${m.join("|")})\`,returnBegin:!0,contains:[w]};return S.push(c.C_LINE_COMMENT_MODE,c.C_BLOCK_COMMENT_MODE,x,G,H,y,w,M,d.FUNCTION_DISPATCH),{name:"Less",case_insensitive:!0,illegal:\`[=>'/<($"]\`,contains:S}}return ca=l,ca}var _a,Jo;function pd(){if(Jo)return _a;Jo=1;function t(e){const n="[a-zA-Z_\\\\-+\\\\*\\\\/<=>&#][a-zA-Z0-9_\\\\-+*\\\\/<=>&#!]*",a="\\\\|[^]*?\\\\|",r="(-|\\\\+)?\\\\d+(\\\\.\\\\d+|\\\\/\\\\d+)?((d|e|f|l|s|D|E|F|L|S)(\\\\+|-)?\\\\d+)?",i={className:"literal",begin:"\\\\b(t{1}|nil)\\\\b"},s={className:"number",variants:[{begin:r,relevance:0},{begin:"#(b|B)[0-1]+(/[0-1]+)?"},{begin:"#(o|O)[0-7]+(/[0-7]+)?"},{begin:"#(x|X)[0-9a-fA-F]+(/[0-9a-fA-F]+)?"},{begin:"#(c|C)\\\\("+r+" +"+r,end:"\\\\)"}]},o=e.inherit(e.QUOTE_STRING_MODE,{illegal:null}),_=e.COMMENT(";","$",{relevance:0}),l={begin:"\\\\*",end:"\\\\*"},c={className:"symbol",begin:"[:&]"+n},d={begin:n,relevance:0},m={begin:a},E={contains:[s,o,l,c,{begin:"\\\\(",end:"\\\\)",contains:["self",i,o,s,d]},d],variants:[{begin:"['\`]\\\\(",end:"\\\\)"},{begin:"\\\\(quote ",end:"\\\\)",keywords:{name:"quote"}},{begin:"'"+a}]},g={variants:[{begin:"'"+n},{begin:"#'"+n+"(::"+n+")*"}]},S={begin:"\\\\(\\\\s*",end:"\\\\)"},T={endsWithParent:!0,relevance:0};return S.contains=[{className:"name",variants:[{begin:n,relevance:0},{begin:a}]},T],T.contains=[E,g,S,i,s,o,_,l,c,m,d],{name:"Lisp",illegal:/\\S/,contains:[s,e.SHEBANG(),i,o,_,E,g,S,d]}}return _a=t,_a}var da,jo;function Ed(){if(jo)return da;jo=1;function t(e){const n={className:"variable",variants:[{begin:"\\\\b([gtps][A-Z]{1}[a-zA-Z0-9]*)(\\\\[.+\\\\])?(?:\\\\s*?)"},{begin:"\\\\$_[A-Z]+"}],relevance:0},a=[e.C_BLOCK_COMMENT_MODE,e.HASH_COMMENT_MODE,e.COMMENT("--","$"),e.COMMENT("[^:]//","$")],r=e.inherit(e.TITLE_MODE,{variants:[{begin:"\\\\b_*rig[A-Z][A-Za-z0-9_\\\\-]*"},{begin:"\\\\b_[a-z0-9\\\\-]+"}]}),i=e.inherit(e.TITLE_MODE,{begin:"\\\\b([A-Za-z0-9_\\\\-]+)\\\\b"});return{name:"LiveCode",case_insensitive:!1,keywords:{keyword:"$_COOKIE $_FILES $_GET $_GET_BINARY $_GET_RAW $_POST $_POST_BINARY $_POST_RAW $_SESSION $_SERVER codepoint codepoints segment segments codeunit codeunits sentence sentences trueWord trueWords paragraph after byte bytes english the until http forever descending using line real8 with seventh for stdout finally element word words fourth before black ninth sixth characters chars stderr uInt1 uInt1s uInt2 uInt2s stdin string lines relative rel any fifth items from middle mid at else of catch then third it file milliseconds seconds second secs sec int1 int1s int4 int4s internet int2 int2s normal text item last long detailed effective uInt4 uInt4s repeat end repeat URL in try into switch to words https token binfile each tenth as ticks tick system real4 by dateItems without char character ascending eighth whole dateTime numeric short first ftp integer abbreviated abbr abbrev private case while if div mod wrap and or bitAnd bitNot bitOr bitXor among not in a an within contains ends with begins the keys of keys",literal:"SIX TEN FORMFEED NINE ZERO NONE SPACE FOUR FALSE COLON CRLF PI COMMA ENDOFFILE EOF EIGHT FIVE QUOTE EMPTY ONE TRUE RETURN CR LINEFEED RIGHT BACKSLASH NULL SEVEN TAB THREE TWO six ten formfeed nine zero none space four false colon crlf pi comma endoffile eof eight five quote empty one true return cr linefeed right backslash null seven tab three two RIVERSION RISTATE FILE_READ_MODE FILE_WRITE_MODE FILE_WRITE_MODE DIR_WRITE_MODE FILE_READ_UMASK FILE_WRITE_UMASK DIR_READ_UMASK DIR_WRITE_UMASK",built_in:"put abs acos aliasReference annuity arrayDecode arrayEncode asin atan atan2 average avg avgDev base64Decode base64Encode baseConvert binaryDecode binaryEncode byteOffset byteToNum cachedURL cachedURLs charToNum cipherNames codepointOffset codepointProperty codepointToNum codeunitOffset commandNames compound compress constantNames cos date dateFormat decompress difference directories diskSpace DNSServers exp exp1 exp2 exp10 extents files flushEvents folders format functionNames geometricMean global globals hasMemory harmonicMean hostAddress hostAddressToName hostName hostNameToAddress isNumber ISOToMac itemOffset keys len length libURLErrorData libUrlFormData libURLftpCommand libURLLastHTTPHeaders libURLLastRHHeaders libUrlMultipartFormAddPart libUrlMultipartFormData libURLVersion lineOffset ln ln1 localNames log log2 log10 longFilePath lower macToISO matchChunk matchText matrixMultiply max md5Digest median merge messageAuthenticationCode messageDigest millisec millisecs millisecond milliseconds min monthNames nativeCharToNum normalizeText num number numToByte numToChar numToCodepoint numToNativeChar offset open openfiles openProcesses openProcessIDs openSockets paragraphOffset paramCount param params peerAddress pendingMessages platform popStdDev populationStandardDeviation populationVariance popVariance processID random randomBytes replaceText result revCreateXMLTree revCreateXMLTreeFromFile revCurrentRecord revCurrentRecordIsFirst revCurrentRecordIsLast revDatabaseColumnCount revDatabaseColumnIsNull revDatabaseColumnLengths revDatabaseColumnNames revDatabaseColumnNamed revDatabaseColumnNumbered revDatabaseColumnTypes revDatabaseConnectResult revDatabaseCursors revDatabaseID revDatabaseTableNames revDatabaseType revDataFromQuery revdb_closeCursor revdb_columnbynumber revdb_columncount revdb_columnisnull revdb_columnlengths revdb_columnnames revdb_columntypes revdb_commit revdb_connect revdb_connections revdb_connectionerr revdb_currentrecord revdb_cursorconnection revdb_cursorerr revdb_cursors revdb_dbtype revdb_disconnect revdb_execute revdb_iseof revdb_isbof revdb_movefirst revdb_movelast revdb_movenext revdb_moveprev revdb_query revdb_querylist revdb_recordcount revdb_rollback revdb_tablenames revGetDatabaseDriverPath revNumberOfRecords revOpenDatabase revOpenDatabases revQueryDatabase revQueryDatabaseBlob revQueryResult revQueryIsAtStart revQueryIsAtEnd revUnixFromMacPath revXMLAttribute revXMLAttributes revXMLAttributeValues revXMLChildContents revXMLChildNames revXMLCreateTreeFromFileWithNamespaces revXMLCreateTreeWithNamespaces revXMLDataFromXPathQuery revXMLEvaluateXPath revXMLFirstChild revXMLMatchingNode revXMLNextSibling revXMLNodeContents revXMLNumberOfChildren revXMLParent revXMLPreviousSibling revXMLRootNode revXMLRPC_CreateRequest revXMLRPC_Documents revXMLRPC_Error revXMLRPC_GetHost revXMLRPC_GetMethod revXMLRPC_GetParam revXMLText revXMLRPC_Execute revXMLRPC_GetParamCount revXMLRPC_GetParamNode revXMLRPC_GetParamType revXMLRPC_GetPath revXMLRPC_GetPort revXMLRPC_GetProtocol revXMLRPC_GetRequest revXMLRPC_GetResponse revXMLRPC_GetSocket revXMLTree revXMLTrees revXMLValidateDTD revZipDescribeItem revZipEnumerateItems revZipOpenArchives round sampVariance sec secs seconds sentenceOffset sha1Digest shell shortFilePath sin specialFolderPath sqrt standardDeviation statRound stdDev sum sysError systemVersion tan tempName textDecode textEncode tick ticks time to tokenOffset toLower toUpper transpose truewordOffset trunc uniDecode uniEncode upper URLDecode URLEncode URLStatus uuid value variableNames variance version waitDepth weekdayNames wordOffset xsltApplyStylesheet xsltApplyStylesheetFromFile xsltLoadStylesheet xsltLoadStylesheetFromFile add breakpoint cancel clear local variable file word line folder directory URL close socket process combine constant convert create new alias folder directory decrypt delete variable word line folder directory URL dispatch divide do encrypt filter get include intersect kill libURLDownloadToFile libURLFollowHttpRedirects libURLftpUpload libURLftpUploadFile libURLresetAll libUrlSetAuthCallback libURLSetDriver libURLSetCustomHTTPHeaders libUrlSetExpect100 libURLSetFTPListCommand libURLSetFTPMode libURLSetFTPStopTime libURLSetStatusCallback load extension loadedExtensions multiply socket prepare process post seek rel relative read from process rename replace require resetAll resolve revAddXMLNode revAppendXML revCloseCursor revCloseDatabase revCommitDatabase revCopyFile revCopyFolder revCopyXMLNode revDeleteFolder revDeleteXMLNode revDeleteAllXMLTrees revDeleteXMLTree revExecuteSQL revGoURL revInsertXMLNode revMoveFolder revMoveToFirstRecord revMoveToLastRecord revMoveToNextRecord revMoveToPreviousRecord revMoveToRecord revMoveXMLNode revPutIntoXMLNode revRollBackDatabase revSetDatabaseDriverPath revSetXMLAttribute revXMLRPC_AddParam revXMLRPC_DeleteAllDocuments revXMLAddDTD revXMLRPC_Free revXMLRPC_FreeAll revXMLRPC_DeleteDocument revXMLRPC_DeleteParam revXMLRPC_SetHost revXMLRPC_SetMethod revXMLRPC_SetPort revXMLRPC_SetProtocol revXMLRPC_SetSocket revZipAddItemWithData revZipAddItemWithFile revZipAddUncompressedItemWithData revZipAddUncompressedItemWithFile revZipCancel revZipCloseArchive revZipDeleteItem revZipExtractItemToFile revZipExtractItemToVariable revZipSetProgressCallback revZipRenameItem revZipReplaceItemWithData revZipReplaceItemWithFile revZipOpenArchive send set sort split start stop subtract symmetric union unload vectorDotProduct wait write"},contains:[n,{className:"keyword",begin:"\\\\bend\\\\sif\\\\b"},{className:"function",beginKeywords:"function",end:"$",contains:[n,i,e.APOS_STRING_MODE,e.QUOTE_STRING_MODE,e.BINARY_NUMBER_MODE,e.C_NUMBER_MODE,r]},{className:"function",begin:"\\\\bend\\\\s+",end:"$",keywords:"end",contains:[i,r],relevance:0},{beginKeywords:"command on",end:"$",contains:[n,i,e.APOS_STRING_MODE,e.QUOTE_STRING_MODE,e.BINARY_NUMBER_MODE,e.C_NUMBER_MODE,r]},{className:"meta",variants:[{begin:"<\\\\?(rev|lc|livecode)",relevance:10},{begin:"<\\\\?"},{begin:"\\\\?>"}]},e.APOS_STRING_MODE,e.QUOTE_STRING_MODE,e.BINARY_NUMBER_MODE,e.C_NUMBER_MODE,r].concat(a),illegal:";$|^\\\\[|^=|&|\\\\{"}}return da=t,da}var ua,es;function gd(){if(es)return ua;es=1;const t=["as","in","of","if","for","while","finally","var","new","function","do","return","void","else","break","catch","instanceof","with","throw","case","default","try","switch","continue","typeof","delete","let","yield","const","class","debugger","async","await","static","import","from","export","extends","using"],e=["true","false","null","undefined","NaN","Infinity"],n=["Object","Function","Boolean","Symbol","Math","Date","Number","BigInt","String","RegExp","Array","Float32Array","Float64Array","Int8Array","Uint8Array","Uint8ClampedArray","Int16Array","Int32Array","Uint16Array","Uint32Array","BigInt64Array","BigUint64Array","Set","Map","WeakSet","WeakMap","ArrayBuffer","SharedArrayBuffer","Atomics","DataView","JSON","Promise","Generator","GeneratorFunction","AsyncFunction","Reflect","Proxy","Intl","WebAssembly"],a=["Error","EvalError","InternalError","RangeError","ReferenceError","SyntaxError","TypeError","URIError"],r=["setInterval","setTimeout","clearInterval","clearTimeout","require","exports","eval","isFinite","isNaN","parseFloat","parseInt","decodeURI","decodeURIComponent","encodeURI","encodeURIComponent","escape","unescape"],i=[].concat(r,n,a);function s(o){const _=["npm","print"],l=["yes","no","on","off","it","that","void"],c=["then","unless","until","loop","of","by","when","and","or","is","isnt","not","it","that","otherwise","from","to","til","fallthrough","case","enum","native","list","map","__hasProp","__extends","__slice","__bind","__indexOf"],d={keyword:t.concat(c),literal:e.concat(l),built_in:i.concat(_)},m="[A-Za-z$_](?:-[0-9A-Za-z$_]|[0-9A-Za-z$_])*",p=o.inherit(o.TITLE_MODE,{begin:m}),E={className:"subst",begin:/#\\{/,end:/\\}/,keywords:d},g={className:"subst",begin:/#[A-Za-z$_]/,end:/(?:-[0-9A-Za-z$_]|[0-9A-Za-z$_])*/,keywords:d},S=[o.BINARY_NUMBER_MODE,{className:"number",begin:"(\\\\b0[xX][a-fA-F0-9_]+)|(\\\\b\\\\d(\\\\d|_\\\\d)*(\\\\.(\\\\d(\\\\d|_\\\\d)*)?)?(_*[eE]([-+]\\\\d(_\\\\d|\\\\d)*)?)?[_a-z]*)",relevance:0,starts:{end:"(\\\\s*/)?",relevance:0}},{className:"string",variants:[{begin:/'''/,end:/'''/,contains:[o.BACKSLASH_ESCAPE]},{begin:/'/,end:/'/,contains:[o.BACKSLASH_ESCAPE]},{begin:/"""/,end:/"""/,contains:[o.BACKSLASH_ESCAPE,E,g]},{begin:/"/,end:/"/,contains:[o.BACKSLASH_ESCAPE,E,g]},{begin:/\\\\/,end:/(\\s|$)/,excludeEnd:!0}]},{className:"regexp",variants:[{begin:"//",end:"//[gim]*",contains:[E,o.HASH_COMMENT_MODE]},{begin:/\\/(?![ *])(\\\\.|[^\\\\\\n])*?\\/[gim]*(?=\\W)/}]},{begin:"@"+m},{begin:"\`\`",end:"\`\`",excludeBegin:!0,excludeEnd:!0,subLanguage:"javascript"}];E.contains=S;const T={className:"params",begin:"\\\\(",returnBegin:!0,contains:[{begin:/\\(/,end:/\\)/,keywords:d,contains:["self"].concat(S)}]},R={begin:"(#=>|=>|\\\\|>>|-?->|!->)"},f={variants:[{match:[/class\\s+/,m,/\\s+extends\\s+/,m]},{match:[/class\\s+/,m]}],scope:{2:"title.class",4:"title.class.inherited"},keywords:d};return{name:"LiveScript",aliases:["ls"],keywords:d,illegal:/\\/\\*/,contains:S.concat([o.COMMENT("\\\\/\\\\*","\\\\*\\\\/"),o.HASH_COMMENT_MODE,R,{className:"function",contains:[p,T],returnBegin:!0,variants:[{begin:"("+m+"\\\\s*(?:=|:=)\\\\s*)?(\\\\(.*\\\\)\\\\s*)?\\\\B->\\\\*?",end:"->\\\\*?"},{begin:"("+m+"\\\\s*(?:=|:=)\\\\s*)?!?(\\\\(.*\\\\)\\\\s*)?\\\\B[-~]{1,2}>\\\\*?",end:"[-~]{1,2}>\\\\*?"},{begin:"("+m+"\\\\s*(?:=|:=)\\\\s*)?(\\\\(.*\\\\)\\\\s*)?\\\\B!?[-~]{1,2}>\\\\*?",end:"!?[-~]{1,2}>\\\\*?"}]},f,{begin:m+":",end:":",returnBegin:!0,returnEnd:!0,relevance:0}])}}return ua=s,ua}var ma,ts;function Sd(){if(ts)return ma;ts=1;function t(e){const n=e.regex,a=/([-a-zA-Z$._][\\w$.-]*)/,r={className:"type",begin:/\\bi\\d+(?=\\s|\\b)/},i={className:"operator",relevance:0,begin:/=/},s={className:"punctuation",relevance:0,begin:/,/},o={className:"number",variants:[{begin:/[su]?0[xX][KMLHR]?[a-fA-F0-9]+/},{begin:/[-+]?\\d+(?:[.]\\d+)?(?:[eE][-+]?\\d+(?:[.]\\d+)?)?/}],relevance:0},_={className:"symbol",variants:[{begin:/^\\s*[a-z]+:/}],relevance:0},l={className:"variable",variants:[{begin:n.concat(/%/,a)},{begin:/%\\d+/},{begin:/#\\d+/}]},c={className:"title",variants:[{begin:n.concat(/@/,a)},{begin:/@\\d+/},{begin:n.concat(/!/,a)},{begin:n.concat(/!\\d+/,a)},{begin:/!\\d+/}]};return{name:"LLVM IR",keywords:{keyword:"begin end true false declare define global constant private linker_private internal available_externally linkonce linkonce_odr weak weak_odr appending dllimport dllexport common default hidden protected extern_weak external thread_local zeroinitializer undef null to tail target triple datalayout volatile nuw nsw nnan ninf nsz arcp fast exact inbounds align addrspace section alias module asm sideeffect gc dbg linker_private_weak attributes blockaddress initialexec localdynamic localexec prefix unnamed_addr ccc fastcc coldcc x86_stdcallcc x86_fastcallcc arm_apcscc arm_aapcscc arm_aapcs_vfpcc ptx_device ptx_kernel intel_ocl_bicc msp430_intrcc spir_func spir_kernel x86_64_sysvcc x86_64_win64cc x86_thiscallcc cc c signext zeroext inreg sret nounwind noreturn noalias nocapture byval nest readnone readonly inlinehint noinline alwaysinline optsize ssp sspreq noredzone noimplicitfloat naked builtin cold nobuiltin noduplicate nonlazybind optnone returns_twice sanitize_address sanitize_memory sanitize_thread sspstrong uwtable returned type opaque eq ne slt sgt sle sge ult ugt ule uge oeq one olt ogt ole oge ord uno ueq une x acq_rel acquire alignstack atomic catch cleanup filter inteldialect max min monotonic nand personality release seq_cst singlethread umax umin unordered xchg add fadd sub fsub mul fmul udiv sdiv fdiv urem srem frem shl lshr ashr and or xor icmp fcmp phi call trunc zext sext fptrunc fpext uitofp sitofp fptoui fptosi inttoptr ptrtoint bitcast addrspacecast select va_arg ret br switch invoke unwind unreachable indirectbr landingpad resume malloc alloca free load store getelementptr extractelement insertelement shufflevector getresult extractvalue insertvalue atomicrmw cmpxchg fence argmemonly",type:"void half bfloat float double fp128 x86_fp80 ppc_fp128 x86_amx x86_mmx ptr label token metadata opaque"},contains:[r,e.COMMENT(/;\\s*$/,null,{relevance:0}),e.COMMENT(/;/,/$/),{className:"string",begin:/"/,end:/"/,contains:[{className:"char.escape",match:/\\\\\\d\\d/}]},c,s,i,l,_,o]}}return ma=t,ma}var pa,ns;function Td(){if(ns)return pa;ns=1;function t(e){const a={className:"string",begin:'"',end:'"',contains:[{className:"subst",begin:/\\\\[tn"\\\\]/}]},r={className:"number",relevance:0,begin:e.C_NUMBER_RE},i={className:"literal",variants:[{begin:"\\\\b(PI|TWO_PI|PI_BY_TWO|DEG_TO_RAD|RAD_TO_DEG|SQRT2)\\\\b"},{begin:"\\\\b(XP_ERROR_(EXPERIENCES_DISABLED|EXPERIENCE_(DISABLED|SUSPENDED)|INVALID_(EXPERIENCE|PARAMETERS)|KEY_NOT_FOUND|MATURITY_EXCEEDED|NONE|NOT_(FOUND|PERMITTED(_LAND)?)|NO_EXPERIENCE|QUOTA_EXCEEDED|RETRY_UPDATE|STORAGE_EXCEPTION|STORE_DISABLED|THROTTLED|UNKNOWN_ERROR)|JSON_APPEND|STATUS_(PHYSICS|ROTATE_[XYZ]|PHANTOM|SANDBOX|BLOCK_GRAB(_OBJECT)?|(DIE|RETURN)_AT_EDGE|CAST_SHADOWS|OK|MALFORMED_PARAMS|TYPE_MISMATCH|BOUNDS_ERROR|NOT_(FOUND|SUPPORTED)|INTERNAL_ERROR|WHITELIST_FAILED)|AGENT(_(BY_(LEGACY_|USER)NAME|FLYING|ATTACHMENTS|SCRIPTED|MOUSELOOK|SITTING|ON_OBJECT|AWAY|WALKING|IN_AIR|TYPING|CROUCHING|BUSY|ALWAYS_RUN|AUTOPILOT|LIST_(PARCEL(_OWNER)?|REGION)))?|CAMERA_(PITCH|DISTANCE|BEHINDNESS_(ANGLE|LAG)|(FOCUS|POSITION)(_(THRESHOLD|LOCKED|LAG))?|FOCUS_OFFSET|ACTIVE)|ANIM_ON|LOOP|REVERSE|PING_PONG|SMOOTH|ROTATE|SCALE|ALL_SIDES|LINK_(ROOT|SET|ALL_(OTHERS|CHILDREN)|THIS)|ACTIVE|PASS(IVE|_(ALWAYS|IF_NOT_HANDLED|NEVER))|SCRIPTED|CONTROL_(FWD|BACK|(ROT_)?(LEFT|RIGHT)|UP|DOWN|(ML_)?LBUTTON)|PERMISSION_(RETURN_OBJECTS|DEBIT|OVERRIDE_ANIMATIONS|SILENT_ESTATE_MANAGEMENT|TAKE_CONTROLS|TRIGGER_ANIMATION|ATTACH|CHANGE_LINKS|(CONTROL|TRACK)_CAMERA|TELEPORT)|INVENTORY_(TEXTURE|SOUND|OBJECT|SCRIPT|LANDMARK|CLOTHING|NOTECARD|BODYPART|ANIMATION|GESTURE|ALL|NONE)|CHANGED_(INVENTORY|COLOR|SHAPE|SCALE|TEXTURE|LINK|ALLOWED_DROP|OWNER|REGION(_START)?|TELEPORT|MEDIA)|OBJECT_(CLICK_ACTION|HOVER_HEIGHT|LAST_OWNER_ID|(PHYSICS|SERVER|STREAMING)_COST|UNKNOWN_DETAIL|CHARACTER_TIME|PHANTOM|PHYSICS|TEMP_(ATTACHED|ON_REZ)|NAME|DESC|POS|PRIM_(COUNT|EQUIVALENCE)|RETURN_(PARCEL(_OWNER)?|REGION)|REZZER_KEY|ROO?T|VELOCITY|OMEGA|OWNER|GROUP(_TAG)?|CREATOR|ATTACHED_(POINT|SLOTS_AVAILABLE)|RENDER_WEIGHT|(BODY_SHAPE|PATHFINDING)_TYPE|(RUNNING|TOTAL)_SCRIPT_COUNT|TOTAL_INVENTORY_COUNT|SCRIPT_(MEMORY|TIME))|TYPE_(INTEGER|FLOAT|STRING|KEY|VECTOR|ROTATION|INVALID)|(DEBUG|PUBLIC)_CHANNEL|ATTACH_(AVATAR_CENTER|CHEST|HEAD|BACK|PELVIS|MOUTH|CHIN|NECK|NOSE|BELLY|[LR](SHOULDER|HAND|FOOT|EAR|EYE|[UL](ARM|LEG)|HIP)|(LEFT|RIGHT)_PEC|HUD_(CENTER_[12]|TOP_(RIGHT|CENTER|LEFT)|BOTTOM(_(RIGHT|LEFT))?)|[LR]HAND_RING1|TAIL_(BASE|TIP)|[LR]WING|FACE_(JAW|[LR]EAR|[LR]EYE|TOUNGE)|GROIN|HIND_[LR]FOOT)|LAND_(LEVEL|RAISE|LOWER|SMOOTH|NOISE|REVERT)|DATA_(ONLINE|NAME|BORN|SIM_(POS|STATUS|RATING)|PAYINFO)|PAYMENT_INFO_(ON_FILE|USED)|REMOTE_DATA_(CHANNEL|REQUEST|REPLY)|PSYS_(PART_(BF_(ZERO|ONE(_MINUS_(DEST_COLOR|SOURCE_(ALPHA|COLOR)))?|DEST_COLOR|SOURCE_(ALPHA|COLOR))|BLEND_FUNC_(DEST|SOURCE)|FLAGS|(START|END)_(COLOR|ALPHA|SCALE|GLOW)|MAX_AGE|(RIBBON|WIND|INTERP_(COLOR|SCALE)|BOUNCE|FOLLOW_(SRC|VELOCITY)|TARGET_(POS|LINEAR)|EMISSIVE)_MASK)|SRC_(MAX_AGE|PATTERN|ANGLE_(BEGIN|END)|BURST_(RATE|PART_COUNT|RADIUS|SPEED_(MIN|MAX))|ACCEL|TEXTURE|TARGET_KEY|OMEGA|PATTERN_(DROP|EXPLODE|ANGLE(_CONE(_EMPTY)?)?)))|VEHICLE_(REFERENCE_FRAME|TYPE_(NONE|SLED|CAR|BOAT|AIRPLANE|BALLOON)|(LINEAR|ANGULAR)_(FRICTION_TIMESCALE|MOTOR_DIRECTION)|LINEAR_MOTOR_OFFSET|HOVER_(HEIGHT|EFFICIENCY|TIMESCALE)|BUOYANCY|(LINEAR|ANGULAR)_(DEFLECTION_(EFFICIENCY|TIMESCALE)|MOTOR_(DECAY_)?TIMESCALE)|VERTICAL_ATTRACTION_(EFFICIENCY|TIMESCALE)|BANKING_(EFFICIENCY|MIX|TIMESCALE)|FLAG_(NO_DEFLECTION_UP|LIMIT_(ROLL_ONLY|MOTOR_UP)|HOVER_((WATER|TERRAIN|UP)_ONLY|GLOBAL_HEIGHT)|MOUSELOOK_(STEER|BANK)|CAMERA_DECOUPLED))|PRIM_(ALLOW_UNSIT|ALPHA_MODE(_(BLEND|EMISSIVE|MASK|NONE))?|NORMAL|SPECULAR|TYPE(_(BOX|CYLINDER|PRISM|SPHERE|TORUS|TUBE|RING|SCULPT))?|HOLE_(DEFAULT|CIRCLE|SQUARE|TRIANGLE)|MATERIAL(_(STONE|METAL|GLASS|WOOD|FLESH|PLASTIC|RUBBER))?|SHINY_(NONE|LOW|MEDIUM|HIGH)|BUMP_(NONE|BRIGHT|DARK|WOOD|BARK|BRICKS|CHECKER|CONCRETE|TILE|STONE|DISKS|GRAVEL|BLOBS|SIDING|LARGETILE|STUCCO|SUCTION|WEAVE)|TEXGEN_(DEFAULT|PLANAR)|SCRIPTED_SIT_ONLY|SCULPT_(TYPE_(SPHERE|TORUS|PLANE|CYLINDER|MASK)|FLAG_(MIRROR|INVERT))|PHYSICS(_(SHAPE_(CONVEX|NONE|PRIM|TYPE)))?|(POS|ROT)_LOCAL|SLICE|TEXT|FLEXIBLE|POINT_LIGHT|TEMP_ON_REZ|PHANTOM|POSITION|SIT_TARGET|SIZE|ROTATION|TEXTURE|NAME|OMEGA|DESC|LINK_TARGET|COLOR|BUMP_SHINY|FULLBRIGHT|TEXGEN|GLOW|MEDIA_(ALT_IMAGE_ENABLE|CONTROLS|(CURRENT|HOME)_URL|AUTO_(LOOP|PLAY|SCALE|ZOOM)|FIRST_CLICK_INTERACT|(WIDTH|HEIGHT)_PIXELS|WHITELIST(_ENABLE)?|PERMS_(INTERACT|CONTROL)|PARAM_MAX|CONTROLS_(STANDARD|MINI)|PERM_(NONE|OWNER|GROUP|ANYONE)|MAX_(URL_LENGTH|WHITELIST_(SIZE|COUNT)|(WIDTH|HEIGHT)_PIXELS)))|MASK_(BASE|OWNER|GROUP|EVERYONE|NEXT)|PERM_(TRANSFER|MODIFY|COPY|MOVE|ALL)|PARCEL_(MEDIA_COMMAND_(STOP|PAUSE|PLAY|LOOP|TEXTURE|URL|TIME|AGENT|UNLOAD|AUTO_ALIGN|TYPE|SIZE|DESC|LOOP_SET)|FLAG_(ALLOW_(FLY|(GROUP_)?SCRIPTS|LANDMARK|TERRAFORM|DAMAGE|CREATE_(GROUP_)?OBJECTS)|USE_(ACCESS_(GROUP|LIST)|BAN_LIST|LAND_PASS_LIST)|LOCAL_SOUND_ONLY|RESTRICT_PUSHOBJECT|ALLOW_(GROUP|ALL)_OBJECT_ENTRY)|COUNT_(TOTAL|OWNER|GROUP|OTHER|SELECTED|TEMP)|DETAILS_(NAME|DESC|OWNER|GROUP|AREA|ID|SEE_AVATARS))|LIST_STAT_(MAX|MIN|MEAN|MEDIAN|STD_DEV|SUM(_SQUARES)?|NUM_COUNT|GEOMETRIC_MEAN|RANGE)|PAY_(HIDE|DEFAULT)|REGION_FLAG_(ALLOW_DAMAGE|FIXED_SUN|BLOCK_TERRAFORM|SANDBOX|DISABLE_(COLLISIONS|PHYSICS)|BLOCK_FLY|ALLOW_DIRECT_TELEPORT|RESTRICT_PUSHOBJECT)|HTTP_(METHOD|MIMETYPE|BODY_(MAXLENGTH|TRUNCATED)|CUSTOM_HEADER|PRAGMA_NO_CACHE|VERBOSE_THROTTLE|VERIFY_CERT)|SIT_(INVALID_(AGENT|LINK_OBJECT)|NO(T_EXPERIENCE|_(ACCESS|EXPERIENCE_PERMISSION|SIT_TARGET)))|STRING_(TRIM(_(HEAD|TAIL))?)|CLICK_ACTION_(NONE|TOUCH|SIT|BUY|PAY|OPEN(_MEDIA)?|PLAY|ZOOM)|TOUCH_INVALID_FACE|PROFILE_(NONE|SCRIPT_MEMORY)|RC_(DATA_FLAGS|DETECT_PHANTOM|GET_(LINK_NUM|NORMAL|ROOT_KEY)|MAX_HITS|REJECT_(TYPES|AGENTS|(NON)?PHYSICAL|LAND))|RCERR_(CAST_TIME_EXCEEDED|SIM_PERF_LOW|UNKNOWN)|ESTATE_ACCESS_(ALLOWED_(AGENT|GROUP)_(ADD|REMOVE)|BANNED_AGENT_(ADD|REMOVE))|DENSITY|FRICTION|RESTITUTION|GRAVITY_MULTIPLIER|KFM_(COMMAND|CMD_(PLAY|STOP|PAUSE)|MODE|FORWARD|LOOP|PING_PONG|REVERSE|DATA|ROTATION|TRANSLATION)|ERR_(GENERIC|PARCEL_PERMISSIONS|MALFORMED_PARAMS|RUNTIME_PERMISSIONS|THROTTLED)|CHARACTER_(CMD_((SMOOTH_)?STOP|JUMP)|DESIRED_(TURN_)?SPEED|RADIUS|STAY_WITHIN_PARCEL|LENGTH|ORIENTATION|ACCOUNT_FOR_SKIPPED_FRAMES|AVOIDANCE_MODE|TYPE(_([ABCD]|NONE))?|MAX_(DECEL|TURN_RADIUS|(ACCEL|SPEED)))|PURSUIT_(OFFSET|FUZZ_FACTOR|GOAL_TOLERANCE|INTERCEPT)|REQUIRE_LINE_OF_SIGHT|FORCE_DIRECT_PATH|VERTICAL|HORIZONTAL|AVOID_(CHARACTERS|DYNAMIC_OBSTACLES|NONE)|PU_(EVADE_(HIDDEN|SPOTTED)|FAILURE_(DYNAMIC_PATHFINDING_DISABLED|INVALID_(GOAL|START)|NO_(NAVMESH|VALID_DESTINATION)|OTHER|TARGET_GONE|(PARCEL_)?UNREACHABLE)|(GOAL|SLOWDOWN_DISTANCE)_REACHED)|TRAVERSAL_TYPE(_(FAST|NONE|SLOW))?|CONTENT_TYPE_(ATOM|FORM|HTML|JSON|LLSD|RSS|TEXT|XHTML|XML)|GCNP_(RADIUS|STATIC)|(PATROL|WANDER)_PAUSE_AT_WAYPOINTS|OPT_(AVATAR|CHARACTER|EXCLUSION_VOLUME|LEGACY_LINKSET|MATERIAL_VOLUME|OTHER|STATIC_OBSTACLE|WALKABLE)|SIM_STAT_PCT_CHARS_STEPPED)\\\\b"},{begin:"\\\\b(FALSE|TRUE)\\\\b"},{begin:"\\\\b(ZERO_ROTATION)\\\\b"},{begin:"\\\\b(EOF|JSON_(ARRAY|DELETE|FALSE|INVALID|NULL|NUMBER|OBJECT|STRING|TRUE)|NULL_KEY|TEXTURE_(BLANK|DEFAULT|MEDIA|PLYWOOD|TRANSPARENT)|URL_REQUEST_(GRANTED|DENIED))\\\\b"},{begin:"\\\\b(ZERO_VECTOR|TOUCH_INVALID_(TEXCOORD|VECTOR))\\\\b"}]},s={className:"built_in",begin:"\\\\b(ll(AgentInExperience|(Create|DataSize|Delete|KeyCount|Keys|Read|Update)KeyValue|GetExperience(Details|ErrorMessage)|ReturnObjectsBy(ID|Owner)|Json(2List|[GS]etValue|ValueType)|Sin|Cos|Tan|Atan2|Sqrt|Pow|Abs|Fabs|Frand|Floor|Ceil|Round|Vec(Mag|Norm|Dist)|Rot(Between|2(Euler|Fwd|Left|Up))|(Euler|Axes)2Rot|Whisper|(Region|Owner)?Say|Shout|Listen(Control|Remove)?|Sensor(Repeat|Remove)?|Detected(Name|Key|Owner|Type|Pos|Vel|Grab|Rot|Group|LinkNumber)|Die|Ground|Wind|([GS]et)(AnimationOverride|MemoryLimit|PrimMediaParams|ParcelMusicURL|Object(Desc|Name)|PhysicsMaterial|Status|Scale|Color|Alpha|Texture|Pos|Rot|Force|Torque)|ResetAnimationOverride|(Scale|Offset|Rotate)Texture|(Rot)?Target(Remove)?|(Stop)?MoveToTarget|Apply(Rotational)?Impulse|Set(KeyframedMotion|ContentType|RegionPos|(Angular)?Velocity|Buoyancy|HoverHeight|ForceAndTorque|TimerEvent|ScriptState|Damage|TextureAnim|Sound(Queueing|Radius)|Vehicle(Type|(Float|Vector|Rotation)Param)|(Touch|Sit)?Text|Camera(Eye|At)Offset|PrimitiveParams|ClickAction|Link(Alpha|Color|PrimitiveParams(Fast)?|Texture(Anim)?|Camera|Media)|RemoteScriptAccessPin|PayPrice|LocalRot)|ScaleByFactor|Get((Max|Min)ScaleFactor|ClosestNavPoint|StaticPath|SimStats|Env|PrimitiveParams|Link(PrimitiveParams|Number(OfSides)?|Key|Name|Media)|HTTPHeader|FreeURLs|Object(Details|PermMask|PrimCount)|Parcel(MaxPrims|Details|Prim(Count|Owners))|Attached(List)?|(SPMax|Free|Used)Memory|Region(Name|TimeDilation|FPS|Corner|AgentCount)|Root(Position|Rotation)|UnixTime|(Parcel|Region)Flags|(Wall|GMT)clock|SimulatorHostname|BoundingBox|GeometricCenter|Creator|NumberOf(Prims|NotecardLines|Sides)|Animation(List)?|(Camera|Local)(Pos|Rot)|Vel|Accel|Omega|Time(stamp|OfDay)|(Object|CenterOf)?Mass|MassMKS|Energy|Owner|(Owner)?Key|SunDirection|Texture(Offset|Scale|Rot)|Inventory(Number|Name|Key|Type|Creator|PermMask)|Permissions(Key)?|StartParameter|List(Length|EntryType)|Date|Agent(Size|Info|Language|List)|LandOwnerAt|NotecardLine|Script(Name|State))|(Get|Reset|GetAndReset)Time|PlaySound(Slave)?|LoopSound(Master|Slave)?|(Trigger|Stop|Preload)Sound|((Get|Delete)Sub|Insert)String|To(Upper|Lower)|Give(InventoryList|Money)|RezObject|(Stop)?LookAt|Sleep|CollisionFilter|(Take|Release)Controls|DetachFromAvatar|AttachToAvatar(Temp)?|InstantMessage|(GetNext)?Email|StopHover|MinEventDelay|RotLookAt|String(Length|Trim)|(Start|Stop)Animation|TargetOmega|Request(Experience)?Permissions|(Create|Break)Link|BreakAllLinks|(Give|Remove)Inventory|Water|PassTouches|Request(Agent|Inventory)Data|TeleportAgent(Home|GlobalCoords)?|ModifyLand|CollisionSound|ResetScript|MessageLinked|PushObject|PassCollisions|AxisAngle2Rot|Rot2(Axis|Angle)|A(cos|sin)|AngleBetween|AllowInventoryDrop|SubStringIndex|List2(CSV|Integer|Json|Float|String|Key|Vector|Rot|List(Strided)?)|DeleteSubList|List(Statistics|Sort|Randomize|(Insert|Find|Replace)List)|EdgeOfWorld|AdjustSoundVolume|Key2Name|TriggerSoundLimited|EjectFromLand|(CSV|ParseString)2List|OverMyLand|SameGroup|UnSit|Ground(Slope|Normal|Contour)|GroundRepel|(Set|Remove)VehicleFlags|SitOnLink|(AvatarOn)?(Link)?SitTarget|Script(Danger|Profiler)|Dialog|VolumeDetect|ResetOtherScript|RemoteLoadScriptPin|(Open|Close)RemoteDataChannel|SendRemoteData|RemoteDataReply|(Integer|String)ToBase64|XorBase64|Log(10)?|Base64To(String|Integer)|ParseStringKeepNulls|RezAtRoot|RequestSimulatorData|ForceMouselook|(Load|Release|(E|Une)scape)URL|ParcelMedia(CommandList|Query)|ModPow|MapDestination|(RemoveFrom|AddTo|Reset)Land(Pass|Ban)List|(Set|Clear)CameraParams|HTTP(Request|Response)|TextBox|DetectedTouch(UV|Face|Pos|(N|Bin)ormal|ST)|(MD5|SHA1|DumpList2)String|Request(Secure)?URL|Clear(Prim|Link)Media|(Link)?ParticleSystem|(Get|Request)(Username|DisplayName)|RegionSayTo|CastRay|GenerateKey|TransferLindenDollars|ManageEstateAccess|(Create|Delete)Character|ExecCharacterCmd|Evade|FleeFrom|NavigateTo|PatrolPoints|Pursue|UpdateCharacter|WanderWithin))\\\\b"};return{name:"LSL (Linden Scripting Language)",illegal:":",contains:[a,{className:"comment",variants:[e.COMMENT("//","$"),e.COMMENT("/\\\\*","\\\\*/")],relevance:0},r,{className:"section",variants:[{begin:"\\\\b(state|default)\\\\b"},{begin:"\\\\b(state_(entry|exit)|touch(_(start|end))?|(land_)?collision(_(start|end))?|timer|listen|(no_)?sensor|control|(not_)?at_(rot_)?target|money|email|experience_permissions(_denied)?|run_time_permissions|changed|attach|dataserver|moving_(start|end)|link_message|(on|object)_rez|remote_data|http_re(sponse|quest)|path_update|transaction_result)\\\\b"}]},s,i,{className:"type",begin:"\\\\b(integer|float|string|key|vector|quaternion|rotation|list)\\\\b"}]}}return pa=t,pa}var Ea,as;function bd(){if(as)return Ea;as=1;function t(e){const n="\\\\[=*\\\\[",a="\\\\]=*\\\\]",r={begin:n,end:a,contains:["self"]},i=[e.COMMENT("--(?!"+n+")","$"),e.COMMENT("--"+n,a,{contains:[r],relevance:10})];return{name:"Lua",aliases:["pluto"],keywords:{$pattern:e.UNDERSCORE_IDENT_RE,literal:"true false nil",keyword:"and break do else elseif end for goto if in local not or repeat return then until while",built_in:"_G _ENV _VERSION __index __newindex __mode __call __metatable __tostring __len __gc __add __sub __mul __div __mod __pow __concat __unm __eq __lt __le assert collectgarbage dofile error getfenv getmetatable ipairs load loadfile loadstring module next pairs pcall print rawequal rawget rawset require select setfenv setmetatable tonumber tostring type unpack xpcall arg self coroutine resume yield status wrap create running debug getupvalue debug sethook getmetatable gethook setmetatable setlocal traceback setfenv getinfo setupvalue getlocal getregistry getfenv io lines write close flush open output type read stderr stdin input stdout popen tmpfile math log max acos huge ldexp pi cos tanh pow deg tan cosh sinh random randomseed frexp ceil floor rad abs sqrt modf asin min mod fmod log10 atan2 exp sin atan os exit setlocale date getenv difftime remove time clock tmpname rename execute package preload loadlib loaded loaders cpath config path seeall string sub upper len gfind rep find match char dump gmatch reverse byte format gsub lower table setn insert getn foreachi maxn foreach concat sort remove"},contains:i.concat([{className:"function",beginKeywords:"function",end:"\\\\)",contains:[e.inherit(e.TITLE_MODE,{begin:"([_a-zA-Z]\\\\w*\\\\.)*([_a-zA-Z]\\\\w*:)?[_a-zA-Z]\\\\w*"}),{className:"params",begin:"\\\\(",endsWithParent:!0,contains:i}].concat(i)},e.C_NUMBER_MODE,e.APOS_STRING_MODE,e.QUOTE_STRING_MODE,{className:"string",begin:n,end:a,contains:[r],relevance:5}])}}return Ea=t,Ea}var ga,rs;function Rd(){if(rs)return ga;rs=1;function t(e){const n={className:"variable",variants:[{begin:"\\\\$\\\\("+e.UNDERSCORE_IDENT_RE+"\\\\)",contains:[e.BACKSLASH_ESCAPE]},{begin:/\\$[@%<?\\^\\+\\*]/}]},a={className:"string",begin:/"/,end:/"/,contains:[e.BACKSLASH_ESCAPE,n]},r={className:"variable",begin:/\\$\\([\\w-]+\\s/,end:/\\)/,keywords:{built_in:"subst patsubst strip findstring filter filter-out sort word wordlist firstword lastword dir notdir suffix basename addsuffix addprefix join wildcard realpath abspath error warning shell origin flavor foreach if or and call eval file value"},contains:[n,a]},i={begin:"^"+e.UNDERSCORE_IDENT_RE+"\\\\s*(?=[:+?]?=)"},s={className:"meta",begin:/^\\.PHONY:/,end:/$/,keywords:{$pattern:/[\\.\\w]+/,keyword:".PHONY"}},o={className:"section",begin:/^[^\\s]+:/,end:/$/,contains:[n]};return{name:"Makefile",aliases:["mk","mak","make"],keywords:{$pattern:/[\\w-]+/,keyword:"define endef undefine ifdef ifndef ifeq ifneq else endif include -include sinclude override export unexport private vpath"},contains:[e.HASH_COMMENT_MODE,n,a,r,i,s,o]}}return ga=t,ga}var Sa,is;function fd(){if(is)return Sa;is=1;const t=["AASTriangle","AbelianGroup","Abort","AbortKernels","AbortProtect","AbortScheduledTask","Above","Abs","AbsArg","AbsArgPlot","Absolute","AbsoluteCorrelation","AbsoluteCorrelationFunction","AbsoluteCurrentValue","AbsoluteDashing","AbsoluteFileName","AbsoluteOptions","AbsolutePointSize","AbsoluteThickness","AbsoluteTime","AbsoluteTiming","AcceptanceThreshold","AccountingForm","Accumulate","Accuracy","AccuracyGoal","AcousticAbsorbingValue","AcousticImpedanceValue","AcousticNormalVelocityValue","AcousticPDEComponent","AcousticPressureCondition","AcousticRadiationValue","AcousticSoundHardValue","AcousticSoundSoftCondition","ActionDelay","ActionMenu","ActionMenuBox","ActionMenuBoxOptions","Activate","Active","ActiveClassification","ActiveClassificationObject","ActiveItem","ActivePrediction","ActivePredictionObject","ActiveStyle","AcyclicGraphQ","AddOnHelpPath","AddSides","AddTo","AddToSearchIndex","AddUsers","AdjacencyGraph","AdjacencyList","AdjacencyMatrix","AdjacentMeshCells","Adjugate","AdjustmentBox","AdjustmentBoxOptions","AdjustTimeSeriesForecast","AdministrativeDivisionData","AffineHalfSpace","AffineSpace","AffineStateSpaceModel","AffineTransform","After","AggregatedEntityClass","AggregationLayer","AircraftData","AirportData","AirPressureData","AirSoundAttenuation","AirTemperatureData","AiryAi","AiryAiPrime","AiryAiZero","AiryBi","AiryBiPrime","AiryBiZero","AlgebraicIntegerQ","AlgebraicNumber","AlgebraicNumberDenominator","AlgebraicNumberNorm","AlgebraicNumberPolynomial","AlgebraicNumberTrace","AlgebraicRules","AlgebraicRulesData","Algebraics","AlgebraicUnitQ","Alignment","AlignmentMarker","AlignmentPoint","All","AllowAdultContent","AllowChatServices","AllowedCloudExtraParameters","AllowedCloudParameterExtensions","AllowedDimensions","AllowedFrequencyRange","AllowedHeads","AllowGroupClose","AllowIncomplete","AllowInlineCells","AllowKernelInitialization","AllowLooseGrammar","AllowReverseGroupClose","AllowScriptLevelChange","AllowVersionUpdate","AllTrue","Alphabet","AlphabeticOrder","AlphabeticSort","AlphaChannel","AlternateImage","AlternatingFactorial","AlternatingGroup","AlternativeHypothesis","Alternatives","AltitudeMethod","AmbientLight","AmbiguityFunction","AmbiguityList","Analytic","AnatomyData","AnatomyForm","AnatomyPlot3D","AnatomySkinStyle","AnatomyStyling","AnchoredSearch","And","AndersonDarlingTest","AngerJ","AngleBisector","AngleBracket","AnglePath","AnglePath3D","AngleVector","AngularGauge","Animate","AnimatedImage","AnimationCycleOffset","AnimationCycleRepetitions","AnimationDirection","AnimationDisplayTime","AnimationRate","AnimationRepetitions","AnimationRunning","AnimationRunTime","AnimationTimeIndex","AnimationVideo","Animator","AnimatorBox","AnimatorBoxOptions","AnimatorElements","Annotate","Annotation","AnnotationDelete","AnnotationKeys","AnnotationRules","AnnotationValue","Annuity","AnnuityDue","Annulus","AnomalyDetection","AnomalyDetector","AnomalyDetectorFunction","Anonymous","Antialiasing","Antihermitian","AntihermitianMatrixQ","Antisymmetric","AntisymmetricMatrixQ","Antonyms","AnyOrder","AnySubset","AnyTrue","Apart","ApartSquareFree","APIFunction","Appearance","AppearanceElements","AppearanceRules","AppellF1","Append","AppendCheck","AppendLayer","AppendTo","Application","Apply","ApplyReaction","ApplySides","ApplyTo","ArcCos","ArcCosh","ArcCot","ArcCoth","ArcCsc","ArcCsch","ArcCurvature","ARCHProcess","ArcLength","ArcSec","ArcSech","ArcSin","ArcSinDistribution","ArcSinh","ArcTan","ArcTanh","Area","Arg","ArgMax","ArgMin","ArgumentCountQ","ArgumentsOptions","ARIMAProcess","ArithmeticGeometricMean","ARMAProcess","Around","AroundReplace","ARProcess","Array","ArrayComponents","ArrayDepth","ArrayFilter","ArrayFlatten","ArrayMesh","ArrayPad","ArrayPlot","ArrayPlot3D","ArrayQ","ArrayReduce","ArrayResample","ArrayReshape","ArrayRules","Arrays","Arrow","Arrow3DBox","ArrowBox","Arrowheads","ASATriangle","Ask","AskAppend","AskConfirm","AskDisplay","AskedQ","AskedValue","AskFunction","AskState","AskTemplateDisplay","AspectRatio","AspectRatioFixed","Assert","AssessmentFunction","AssessmentResultObject","AssociateTo","Association","AssociationFormat","AssociationMap","AssociationQ","AssociationThread","AssumeDeterministic","Assuming","Assumptions","AstroAngularSeparation","AstroBackground","AstroCenter","AstroDistance","AstroGraphics","AstroGridLines","AstroGridLinesStyle","AstronomicalData","AstroPosition","AstroProjection","AstroRange","AstroRangePadding","AstroReferenceFrame","AstroStyling","AstroZoomLevel","Asymptotic","AsymptoticDSolveValue","AsymptoticEqual","AsymptoticEquivalent","AsymptoticExpectation","AsymptoticGreater","AsymptoticGreaterEqual","AsymptoticIntegrate","AsymptoticLess","AsymptoticLessEqual","AsymptoticOutputTracker","AsymptoticProbability","AsymptoticProduct","AsymptoticRSolveValue","AsymptoticSolve","AsymptoticSum","Asynchronous","AsynchronousTaskObject","AsynchronousTasks","Atom","AtomCoordinates","AtomCount","AtomDiagramCoordinates","AtomLabels","AtomLabelStyle","AtomList","AtomQ","AttachCell","AttachedCell","AttentionLayer","Attributes","Audio","AudioAmplify","AudioAnnotate","AudioAnnotationLookup","AudioBlockMap","AudioCapture","AudioChannelAssignment","AudioChannelCombine","AudioChannelMix","AudioChannels","AudioChannelSeparate","AudioData","AudioDelay","AudioDelete","AudioDevice","AudioDistance","AudioEncoding","AudioFade","AudioFrequencyShift","AudioGenerator","AudioIdentify","AudioInputDevice","AudioInsert","AudioInstanceQ","AudioIntervals","AudioJoin","AudioLabel","AudioLength","AudioLocalMeasurements","AudioLooping","AudioLoudness","AudioMeasurements","AudioNormalize","AudioOutputDevice","AudioOverlay","AudioPad","AudioPan","AudioPartition","AudioPause","AudioPitchShift","AudioPlay","AudioPlot","AudioQ","AudioRecord","AudioReplace","AudioResample","AudioReverb","AudioReverse","AudioSampleRate","AudioSpectralMap","AudioSpectralTransformation","AudioSplit","AudioStop","AudioStream","AudioStreams","AudioTimeStretch","AudioTrackApply","AudioTrackSelection","AudioTrim","AudioType","AugmentedPolyhedron","AugmentedSymmetricPolynomial","Authenticate","Authentication","AuthenticationDialog","AutoAction","Autocomplete","AutocompletionFunction","AutoCopy","AutocorrelationTest","AutoDelete","AutoEvaluateEvents","AutoGeneratedPackage","AutoIndent","AutoIndentSpacings","AutoItalicWords","AutoloadPath","AutoMatch","Automatic","AutomaticImageSize","AutoMultiplicationSymbol","AutoNumberFormatting","AutoOpenNotebooks","AutoOpenPalettes","AutoOperatorRenderings","AutoQuoteCharacters","AutoRefreshed","AutoRemove","AutorunSequencing","AutoScaling","AutoScroll","AutoSpacing","AutoStyleOptions","AutoStyleWords","AutoSubmitting","Axes","AxesEdge","AxesLabel","AxesOrigin","AxesStyle","AxiomaticTheory","Axis","Axis3DBox","Axis3DBoxOptions","AxisBox","AxisBoxOptions","AxisLabel","AxisObject","AxisStyle","BabyMonsterGroupB","Back","BackFaceColor","BackFaceGlowColor","BackFaceOpacity","BackFaceSpecularColor","BackFaceSpecularExponent","BackFaceSurfaceAppearance","BackFaceTexture","Background","BackgroundAppearance","BackgroundTasksSettings","Backslash","Backsubstitution","Backward","Ball","Band","BandpassFilter","BandstopFilter","BarabasiAlbertGraphDistribution","BarChart","BarChart3D","BarcodeImage","BarcodeRecognize","BaringhausHenzeTest","BarLegend","BarlowProschanImportance","BarnesG","BarOrigin","BarSpacing","BartlettHannWindow","BartlettWindow","BaseDecode","BaseEncode","BaseForm","Baseline","BaselinePosition","BaseStyle","BasicRecurrentLayer","BatchNormalizationLayer","BatchSize","BatesDistribution","BattleLemarieWavelet","BayesianMaximization","BayesianMaximizationObject","BayesianMinimization","BayesianMinimizationObject","Because","BeckmannDistribution","Beep","Before","Begin","BeginDialogPacket","BeginPackage","BellB","BellY","Below","BenfordDistribution","BeniniDistribution","BenktanderGibratDistribution","BenktanderWeibullDistribution","BernoulliB","BernoulliDistribution","BernoulliGraphDistribution","BernoulliProcess","BernsteinBasis","BesagL","BesselFilterModel","BesselI","BesselJ","BesselJZero","BesselK","BesselY","BesselYZero","Beta","BetaBinomialDistribution","BetaDistribution","BetaNegativeBinomialDistribution","BetaPrimeDistribution","BetaRegularized","Between","BetweennessCentrality","Beveled","BeveledPolyhedron","BezierCurve","BezierCurve3DBox","BezierCurve3DBoxOptions","BezierCurveBox","BezierCurveBoxOptions","BezierFunction","BilateralFilter","BilateralLaplaceTransform","BilateralZTransform","Binarize","BinaryDeserialize","BinaryDistance","BinaryFormat","BinaryImageQ","BinaryRead","BinaryReadList","BinarySerialize","BinaryWrite","BinCounts","BinLists","BinnedVariogramList","Binomial","BinomialDistribution","BinomialPointProcess","BinomialProcess","BinormalDistribution","BiorthogonalSplineWavelet","BioSequence","BioSequenceBackTranslateList","BioSequenceComplement","BioSequenceInstances","BioSequenceModify","BioSequencePlot","BioSequenceQ","BioSequenceReverseComplement","BioSequenceTranscribe","BioSequenceTranslate","BipartiteGraphQ","BiquadraticFilterModel","BirnbaumImportance","BirnbaumSaundersDistribution","BitAnd","BitClear","BitGet","BitLength","BitNot","BitOr","BitRate","BitSet","BitShiftLeft","BitShiftRight","BitXor","BiweightLocation","BiweightMidvariance","Black","BlackmanHarrisWindow","BlackmanNuttallWindow","BlackmanWindow","Blank","BlankForm","BlankNullSequence","BlankSequence","Blend","Block","BlockchainAddressData","BlockchainBase","BlockchainBlockData","BlockchainContractValue","BlockchainData","BlockchainGet","BlockchainKeyEncode","BlockchainPut","BlockchainTokenData","BlockchainTransaction","BlockchainTransactionData","BlockchainTransactionSign","BlockchainTransactionSubmit","BlockDiagonalMatrix","BlockLowerTriangularMatrix","BlockMap","BlockRandom","BlockUpperTriangularMatrix","BlomqvistBeta","BlomqvistBetaTest","Blue","Blur","Blurring","BodePlot","BohmanWindow","Bold","Bond","BondCount","BondLabels","BondLabelStyle","BondList","BondQ","Bookmarks","Boole","BooleanConsecutiveFunction","BooleanConvert","BooleanCountingFunction","BooleanFunction","BooleanGraph","BooleanMaxterms","BooleanMinimize","BooleanMinterms","BooleanQ","BooleanRegion","Booleans","BooleanStrings","BooleanTable","BooleanVariables","BorderDimensions","BorelTannerDistribution","Bottom","BottomHatTransform","BoundaryDiscretizeGraphics","BoundaryDiscretizeRegion","BoundaryMesh","BoundaryMeshRegion","BoundaryMeshRegionQ","BoundaryStyle","BoundedRegionQ","BoundingRegion","Bounds","Box","BoxBaselineShift","BoxData","BoxDimensions","Boxed","Boxes","BoxForm","BoxFormFormatTypes","BoxFrame","BoxID","BoxMargins","BoxMatrix","BoxObject","BoxRatios","BoxRotation","BoxRotationPoint","BoxStyle","BoxWhiskerChart","Bra","BracketingBar","BraKet","BrayCurtisDistance","BreadthFirstScan","Break","BridgeData","BrightnessEqualize","BroadcastStationData","Brown","BrownForsytheTest","BrownianBridgeProcess","BrowserCategory","BSplineBasis","BSplineCurve","BSplineCurve3DBox","BSplineCurve3DBoxOptions","BSplineCurveBox","BSplineCurveBoxOptions","BSplineFunction","BSplineSurface","BSplineSurface3DBox","BSplineSurface3DBoxOptions","BubbleChart","BubbleChart3D","BubbleScale","BubbleSizes","BuckyballGraph","BuildCompiledComponent","BuildingData","BulletGauge","BusinessDayQ","ButterflyGraph","ButterworthFilterModel","Button","ButtonBar","ButtonBox","ButtonBoxOptions","ButtonCell","ButtonContents","ButtonData","ButtonEvaluator","ButtonExpandable","ButtonFrame","ButtonFunction","ButtonMargins","ButtonMinHeight","ButtonNote","ButtonNotebook","ButtonSource","ButtonStyle","ButtonStyleMenuListing","Byte","ByteArray","ByteArrayFormat","ByteArrayFormatQ","ByteArrayQ","ByteArrayToString","ByteCount","ByteOrdering","C","CachedValue","CacheGraphics","CachePersistence","CalendarConvert","CalendarData","CalendarType","Callout","CalloutMarker","CalloutStyle","CallPacket","CanberraDistance","Cancel","CancelButton","CandlestickChart","CanonicalGraph","CanonicalizePolygon","CanonicalizePolyhedron","CanonicalizeRegion","CanonicalName","CanonicalWarpingCorrespondence","CanonicalWarpingDistance","CantorMesh","CantorStaircase","Canvas","Cap","CapForm","CapitalDifferentialD","Capitalize","CapsuleShape","CaptureRunning","CaputoD","CardinalBSplineBasis","CarlemanLinearize","CarlsonRC","CarlsonRD","CarlsonRE","CarlsonRF","CarlsonRG","CarlsonRJ","CarlsonRK","CarlsonRM","CarmichaelLambda","CaseOrdering","Cases","CaseSensitive","Cashflow","Casoratian","Cast","Catalan","CatalanNumber","Catch","CategoricalDistribution","Catenate","CatenateLayer","CauchyDistribution","CauchyMatrix","CauchyPointProcess","CauchyWindow","CayleyGraph","CDF","CDFDeploy","CDFInformation","CDFWavelet","Ceiling","CelestialSystem","Cell","CellAutoOverwrite","CellBaseline","CellBoundingBox","CellBracketOptions","CellChangeTimes","CellContents","CellContext","CellDingbat","CellDingbatMargin","CellDynamicExpression","CellEditDuplicate","CellElementsBoundingBox","CellElementSpacings","CellEpilog","CellEvaluationDuplicate","CellEvaluationFunction","CellEvaluationLanguage","CellEventActions","CellFrame","CellFrameColor","CellFrameLabelMargins","CellFrameLabels","CellFrameMargins","CellFrameStyle","CellGroup","CellGroupData","CellGrouping","CellGroupingRules","CellHorizontalScrolling","CellID","CellInsertionPointCell","CellLabel","CellLabelAutoDelete","CellLabelMargins","CellLabelPositioning","CellLabelStyle","CellLabelTemplate","CellMargins","CellObject","CellOpen","CellPrint","CellProlog","Cells","CellSize","CellStyle","CellTags","CellTrayPosition","CellTrayWidgets","CellularAutomaton","CensoredDistribution","Censoring","Center","CenterArray","CenterDot","CenteredInterval","CentralFeature","CentralMoment","CentralMomentGeneratingFunction","Cepstrogram","CepstrogramArray","CepstrumArray","CForm","ChampernowneNumber","ChangeOptions","ChannelBase","ChannelBrokerAction","ChannelDatabin","ChannelHistoryLength","ChannelListen","ChannelListener","ChannelListeners","ChannelListenerWait","ChannelObject","ChannelPreSendFunction","ChannelReceiverFunction","ChannelSend","ChannelSubscribers","ChanVeseBinarize","Character","CharacterCounts","CharacterEncoding","CharacterEncodingsPath","CharacteristicFunction","CharacteristicPolynomial","CharacterName","CharacterNormalize","CharacterRange","Characters","ChartBaseStyle","ChartElementData","ChartElementDataFunction","ChartElementFunction","ChartElements","ChartLabels","ChartLayout","ChartLegends","ChartStyle","Chebyshev1FilterModel","Chebyshev2FilterModel","ChebyshevDistance","ChebyshevT","ChebyshevU","Check","CheckAbort","CheckAll","CheckArguments","Checkbox","CheckboxBar","CheckboxBox","CheckboxBoxOptions","ChemicalConvert","ChemicalData","ChemicalFormula","ChemicalInstance","ChemicalReaction","ChessboardDistance","ChiDistribution","ChineseRemainder","ChiSquareDistribution","ChoiceButtons","ChoiceDialog","CholeskyDecomposition","Chop","ChromaticityPlot","ChromaticityPlot3D","ChromaticPolynomial","Circle","CircleBox","CircleDot","CircleMinus","CirclePlus","CirclePoints","CircleThrough","CircleTimes","CirculantGraph","CircularArcThrough","CircularOrthogonalMatrixDistribution","CircularQuaternionMatrixDistribution","CircularRealMatrixDistribution","CircularSymplecticMatrixDistribution","CircularUnitaryMatrixDistribution","Circumsphere","CityData","ClassifierFunction","ClassifierInformation","ClassifierMeasurements","ClassifierMeasurementsObject","Classify","ClassPriors","Clear","ClearAll","ClearAttributes","ClearCookies","ClearPermissions","ClearSystemCache","ClebschGordan","ClickPane","ClickToCopy","ClickToCopyEnabled","Clip","ClipboardNotebook","ClipFill","ClippingStyle","ClipPlanes","ClipPlanesStyle","ClipRange","Clock","ClockGauge","ClockwiseContourIntegral","Close","Closed","CloseKernels","ClosenessCentrality","Closing","ClosingAutoSave","ClosingEvent","CloudAccountData","CloudBase","CloudConnect","CloudConnections","CloudDeploy","CloudDirectory","CloudDisconnect","CloudEvaluate","CloudExport","CloudExpression","CloudExpressions","CloudFunction","CloudGet","CloudImport","CloudLoggingData","CloudObject","CloudObjectInformation","CloudObjectInformationData","CloudObjectNameFormat","CloudObjects","CloudObjectURLType","CloudPublish","CloudPut","CloudRenderingMethod","CloudSave","CloudShare","CloudSubmit","CloudSymbol","CloudUnshare","CloudUserID","ClusterClassify","ClusterDissimilarityFunction","ClusteringComponents","ClusteringMeasurements","ClusteringTree","CMYKColor","Coarse","CodeAssistOptions","Coefficient","CoefficientArrays","CoefficientDomain","CoefficientList","CoefficientRules","CoifletWavelet","Collect","CollinearPoints","Colon","ColonForm","ColorBalance","ColorCombine","ColorConvert","ColorCoverage","ColorData","ColorDataFunction","ColorDetect","ColorDistance","ColorFunction","ColorFunctionBinning","ColorFunctionScaling","Colorize","ColorNegate","ColorOutput","ColorProfileData","ColorQ","ColorQuantize","ColorReplace","ColorRules","ColorSelectorSettings","ColorSeparate","ColorSetter","ColorSetterBox","ColorSetterBoxOptions","ColorSlider","ColorsNear","ColorSpace","ColorToneMapping","Column","ColumnAlignments","ColumnBackgrounds","ColumnForm","ColumnLines","ColumnsEqual","ColumnSpacings","ColumnWidths","CombinatorB","CombinatorC","CombinatorI","CombinatorK","CombinatorS","CombinatorW","CombinatorY","CombinedEntityClass","CombinerFunction","CometData","CommonDefaultFormatTypes","Commonest","CommonestFilter","CommonName","CommonUnits","CommunityBoundaryStyle","CommunityGraphPlot","CommunityLabels","CommunityRegionStyle","CompanyData","CompatibleUnitQ","CompilationOptions","CompilationTarget","Compile","Compiled","CompiledCodeFunction","CompiledComponent","CompiledExpressionDeclaration","CompiledFunction","CompiledLayer","CompilerCallback","CompilerEnvironment","CompilerEnvironmentAppend","CompilerEnvironmentAppendTo","CompilerEnvironmentObject","CompilerOptions","Complement","ComplementedEntityClass","CompleteGraph","CompleteGraphQ","CompleteIntegral","CompleteKaryTree","CompletionsListPacket","Complex","ComplexArrayPlot","ComplexContourPlot","Complexes","ComplexExpand","ComplexInfinity","ComplexityFunction","ComplexListPlot","ComplexPlot","ComplexPlot3D","ComplexRegionPlot","ComplexStreamPlot","ComplexVectorPlot","ComponentMeasurements","ComponentwiseContextMenu","Compose","ComposeList","ComposeSeries","CompositeQ","Composition","CompoundElement","CompoundExpression","CompoundPoissonDistribution","CompoundPoissonProcess","CompoundRenewalProcess","Compress","CompressedData","CompressionLevel","ComputeUncertainty","ConcaveHullMesh","Condition","ConditionalExpression","Conditioned","Cone","ConeBox","ConfidenceLevel","ConfidenceRange","ConfidenceTransform","ConfigurationPath","Confirm","ConfirmAssert","ConfirmBy","ConfirmMatch","ConfirmQuiet","ConformationMethod","ConformAudio","ConformImages","Congruent","ConicGradientFilling","ConicHullRegion","ConicHullRegion3DBox","ConicHullRegion3DBoxOptions","ConicHullRegionBox","ConicHullRegionBoxOptions","ConicOptimization","Conjugate","ConjugateTranspose","Conjunction","Connect","ConnectedComponents","ConnectedGraphComponents","ConnectedGraphQ","ConnectedMeshComponents","ConnectedMoleculeComponents","ConnectedMoleculeQ","ConnectionSettings","ConnectLibraryCallbackFunction","ConnectSystemModelComponents","ConnectSystemModelController","ConnesWindow","ConoverTest","ConservativeConvectionPDETerm","ConsoleMessage","Constant","ConstantArray","ConstantArrayLayer","ConstantImage","ConstantPlusLayer","ConstantRegionQ","Constants","ConstantTimesLayer","ConstellationData","ConstrainedMax","ConstrainedMin","Construct","Containing","ContainsAll","ContainsAny","ContainsExactly","ContainsNone","ContainsOnly","ContentDetectorFunction","ContentFieldOptions","ContentLocationFunction","ContentObject","ContentPadding","ContentsBoundingBox","ContentSelectable","ContentSize","Context","ContextMenu","Contexts","ContextToFileName","Continuation","Continue","ContinuedFraction","ContinuedFractionK","ContinuousAction","ContinuousMarkovProcess","ContinuousTask","ContinuousTimeModelQ","ContinuousWaveletData","ContinuousWaveletTransform","ContourDetect","ContourGraphics","ContourIntegral","ContourLabels","ContourLines","ContourPlot","ContourPlot3D","Contours","ContourShading","ContourSmoothing","ContourStyle","ContraharmonicMean","ContrastiveLossLayer","Control","ControlActive","ControlAlignment","ControlGroupContentsBox","ControllabilityGramian","ControllabilityMatrix","ControllableDecomposition","ControllableModelQ","ControllerDuration","ControllerInformation","ControllerInformationData","ControllerLinking","ControllerManipulate","ControllerMethod","ControllerPath","ControllerState","ControlPlacement","ControlsRendering","ControlType","ConvectionPDETerm","Convergents","ConversionOptions","ConversionRules","ConvertToPostScript","ConvertToPostScriptPacket","ConvexHullMesh","ConvexHullRegion","ConvexOptimization","ConvexPolygonQ","ConvexPolyhedronQ","ConvexRegionQ","ConvolutionLayer","Convolve","ConwayGroupCo1","ConwayGroupCo2","ConwayGroupCo3","CookieFunction","Cookies","CoordinateBoundingBox","CoordinateBoundingBoxArray","CoordinateBounds","CoordinateBoundsArray","CoordinateChartData","CoordinatesToolOptions","CoordinateTransform","CoordinateTransformData","CoplanarPoints","CoprimeQ","Coproduct","CopulaDistribution","Copyable","CopyDatabin","CopyDirectory","CopyFile","CopyFunction","CopyTag","CopyToClipboard","CoreNilpotentDecomposition","CornerFilter","CornerNeighbors","Correlation","CorrelationDistance","CorrelationFunction","CorrelationTest","Cos","Cosh","CoshIntegral","CosineDistance","CosineWindow","CosIntegral","Cot","Coth","CoulombF","CoulombG","CoulombH1","CoulombH2","Count","CountDistinct","CountDistinctBy","CounterAssignments","CounterBox","CounterBoxOptions","CounterClockwiseContourIntegral","CounterEvaluator","CounterFunction","CounterIncrements","CounterStyle","CounterStyleMenuListing","CountRoots","CountryData","Counts","CountsBy","Covariance","CovarianceEstimatorFunction","CovarianceFunction","CoxianDistribution","CoxIngersollRossProcess","CoxModel","CoxModelFit","CramerVonMisesTest","CreateArchive","CreateCellID","CreateChannel","CreateCloudExpression","CreateCompilerEnvironment","CreateDatabin","CreateDataStructure","CreateDataSystemModel","CreateDialog","CreateDirectory","CreateDocument","CreateFile","CreateIntermediateDirectories","CreateLicenseEntitlement","CreateManagedLibraryExpression","CreateNotebook","CreatePacletArchive","CreatePalette","CreatePermissionsGroup","CreateScheduledTask","CreateSearchIndex","CreateSystemModel","CreateTemporary","CreateTypeInstance","CreateUUID","CreateWindow","CriterionFunction","CriticalityFailureImportance","CriticalitySuccessImportance","CriticalSection","Cross","CrossEntropyLossLayer","CrossingCount","CrossingDetect","CrossingPolygon","CrossMatrix","Csc","Csch","CSGRegion","CSGRegionQ","CSGRegionTree","CTCLossLayer","Cube","CubeRoot","Cubics","Cuboid","CuboidBox","CuboidBoxOptions","Cumulant","CumulantGeneratingFunction","CumulativeFeatureImpactPlot","Cup","CupCap","Curl","CurlyDoubleQuote","CurlyQuote","CurrencyConvert","CurrentDate","CurrentImage","CurrentNotebookImage","CurrentScreenImage","CurrentValue","Curry","CurryApplied","CurvatureFlowFilter","CurveClosed","Cyan","CycleGraph","CycleIndexPolynomial","Cycles","CyclicGroup","Cyclotomic","Cylinder","CylinderBox","CylinderBoxOptions","CylindricalDecomposition","CylindricalDecompositionFunction","D","DagumDistribution","DamData","DamerauLevenshteinDistance","DampingFactor","Darker","Dashed","Dashing","DatabaseConnect","DatabaseDisconnect","DatabaseReference","Databin","DatabinAdd","DatabinRemove","Databins","DatabinSubmit","DatabinUpload","DataCompression","DataDistribution","DataRange","DataReversed","Dataset","DatasetDisplayPanel","DatasetTheme","DataStructure","DataStructureQ","Date","DateBounds","Dated","DateDelimiters","DateDifference","DatedUnit","DateFormat","DateFunction","DateGranularity","DateHistogram","DateInterval","DateList","DateListLogPlot","DateListPlot","DateListStepPlot","DateObject","DateObjectQ","DateOverlapsQ","DatePattern","DatePlus","DateRange","DateReduction","DateScale","DateSelect","DateString","DateTicksFormat","DateValue","DateWithinQ","DaubechiesWavelet","DavisDistribution","DawsonF","DayCount","DayCountConvention","DayHemisphere","DaylightQ","DayMatchQ","DayName","DayNightTerminator","DayPlus","DayRange","DayRound","DeBruijnGraph","DeBruijnSequence","Debug","DebugTag","Decapitalize","Decimal","DecimalForm","DeclareCompiledComponent","DeclareKnownSymbols","DeclarePackage","Decompose","DeconvolutionLayer","Decrement","Decrypt","DecryptFile","DedekindEta","DeepSpaceProbeData","Default","Default2DTool","Default3DTool","DefaultAttachedCellStyle","DefaultAxesStyle","DefaultBaseStyle","DefaultBoxStyle","DefaultButton","DefaultColor","DefaultControlPlacement","DefaultDockedCellStyle","DefaultDuplicateCellStyle","DefaultDuration","DefaultElement","DefaultFaceGridsStyle","DefaultFieldHintStyle","DefaultFont","DefaultFontProperties","DefaultFormatType","DefaultFrameStyle","DefaultFrameTicksStyle","DefaultGridLinesStyle","DefaultInlineFormatType","DefaultInputFormatType","DefaultLabelStyle","DefaultMenuStyle","DefaultNaturalLanguage","DefaultNewCellStyle","DefaultNewInlineCellStyle","DefaultNotebook","DefaultOptions","DefaultOutputFormatType","DefaultPrintPrecision","DefaultStyle","DefaultStyleDefinitions","DefaultTextFormatType","DefaultTextInlineFormatType","DefaultTicksStyle","DefaultTooltipStyle","DefaultValue","DefaultValues","Defer","DefineExternal","DefineInputStreamMethod","DefineOutputStreamMethod","DefineResourceFunction","Definition","Degree","DegreeCentrality","DegreeGraphDistribution","DegreeLexicographic","DegreeReverseLexicographic","DEigensystem","DEigenvalues","Deinitialization","Del","DelaunayMesh","Delayed","Deletable","Delete","DeleteAdjacentDuplicates","DeleteAnomalies","DeleteBorderComponents","DeleteCases","DeleteChannel","DeleteCloudExpression","DeleteContents","DeleteDirectory","DeleteDuplicates","DeleteDuplicatesBy","DeleteElements","DeleteFile","DeleteMissing","DeleteObject","DeletePermissionsKey","DeleteSearchIndex","DeleteSmallComponents","DeleteStopwords","DeleteWithContents","DeletionWarning","DelimitedArray","DelimitedSequence","Delimiter","DelimiterAutoMatching","DelimiterFlashTime","DelimiterMatching","Delimiters","DeliveryFunction","Dendrogram","Denominator","DensityGraphics","DensityHistogram","DensityPlot","DensityPlot3D","DependentVariables","Deploy","Deployed","Depth","DepthFirstScan","Derivative","DerivativeFilter","DerivativePDETerm","DerivedKey","DescriptorStateSpace","DesignMatrix","DestroyAfterEvaluation","Det","DeviceClose","DeviceConfigure","DeviceExecute","DeviceExecuteAsynchronous","DeviceObject","DeviceOpen","DeviceOpenQ","DeviceRead","DeviceReadBuffer","DeviceReadLatest","DeviceReadList","DeviceReadTimeSeries","Devices","DeviceStreams","DeviceWrite","DeviceWriteBuffer","DGaussianWavelet","DiacriticalPositioning","Diagonal","DiagonalizableMatrixQ","DiagonalMatrix","DiagonalMatrixQ","Dialog","DialogIndent","DialogInput","DialogLevel","DialogNotebook","DialogProlog","DialogReturn","DialogSymbols","Diamond","DiamondMatrix","DiceDissimilarity","DictionaryLookup","DictionaryWordQ","DifferenceDelta","DifferenceOrder","DifferenceQuotient","DifferenceRoot","DifferenceRootReduce","Differences","DifferentialD","DifferentialRoot","DifferentialRootReduce","DifferentiatorFilter","DiffusionPDETerm","DiggleGatesPointProcess","DiggleGrattonPointProcess","DigitalSignature","DigitBlock","DigitBlockMinimum","DigitCharacter","DigitCount","DigitQ","DihedralAngle","DihedralGroup","Dilation","DimensionalCombinations","DimensionalMeshComponents","DimensionReduce","DimensionReducerFunction","DimensionReduction","Dimensions","DiracComb","DiracDelta","DirectedEdge","DirectedEdges","DirectedGraph","DirectedGraphQ","DirectedInfinity","Direction","DirectionalLight","Directive","Directory","DirectoryName","DirectoryQ","DirectoryStack","DirichletBeta","DirichletCharacter","DirichletCondition","DirichletConvolve","DirichletDistribution","DirichletEta","DirichletL","DirichletLambda","DirichletTransform","DirichletWindow","DisableConsolePrintPacket","DisableFormatting","DiscreteAsymptotic","DiscreteChirpZTransform","DiscreteConvolve","DiscreteDelta","DiscreteHadamardTransform","DiscreteIndicator","DiscreteInputOutputModel","DiscreteLimit","DiscreteLQEstimatorGains","DiscreteLQRegulatorGains","DiscreteLyapunovSolve","DiscreteMarkovProcess","DiscreteMaxLimit","DiscreteMinLimit","DiscretePlot","DiscretePlot3D","DiscreteRatio","DiscreteRiccatiSolve","DiscreteShift","DiscreteTimeModelQ","DiscreteUniformDistribution","DiscreteVariables","DiscreteWaveletData","DiscreteWaveletPacketTransform","DiscreteWaveletTransform","DiscretizeGraphics","DiscretizeRegion","Discriminant","DisjointQ","Disjunction","Disk","DiskBox","DiskBoxOptions","DiskMatrix","DiskSegment","Dispatch","DispatchQ","DispersionEstimatorFunction","Display","DisplayAllSteps","DisplayEndPacket","DisplayForm","DisplayFunction","DisplayPacket","DisplayRules","DisplayString","DisplayTemporary","DisplayWith","DisplayWithRef","DisplayWithVariable","DistanceFunction","DistanceMatrix","DistanceTransform","Distribute","Distributed","DistributedContexts","DistributeDefinitions","DistributionChart","DistributionDomain","DistributionFitTest","DistributionParameterAssumptions","DistributionParameterQ","Dithering","Div","Divergence","Divide","DivideBy","Dividers","DivideSides","Divisible","Divisors","DivisorSigma","DivisorSum","DMSList","DMSString","Do","DockedCell","DockedCells","DocumentGenerator","DocumentGeneratorInformation","DocumentGeneratorInformationData","DocumentGenerators","DocumentNotebook","DocumentWeightingRules","Dodecahedron","DomainRegistrationInformation","DominantColors","DominatorTreeGraph","DominatorVertexList","DOSTextFormat","Dot","DotDashed","DotEqual","DotLayer","DotPlusLayer","Dotted","DoubleBracketingBar","DoubleContourIntegral","DoubleDownArrow","DoubleLeftArrow","DoubleLeftRightArrow","DoubleLeftTee","DoubleLongLeftArrow","DoubleLongLeftRightArrow","DoubleLongRightArrow","DoubleRightArrow","DoubleRightTee","DoubleUpArrow","DoubleUpDownArrow","DoubleVerticalBar","DoublyInfinite","Down","DownArrow","DownArrowBar","DownArrowUpArrow","DownLeftRightVector","DownLeftTeeVector","DownLeftVector","DownLeftVectorBar","DownRightTeeVector","DownRightVector","DownRightVectorBar","Downsample","DownTee","DownTeeArrow","DownValues","DownValuesFunction","DragAndDrop","DrawBackFaces","DrawEdges","DrawFrontFaces","DrawHighlighted","DrazinInverse","Drop","DropoutLayer","DropShadowing","DSolve","DSolveChangeVariables","DSolveValue","Dt","DualLinearProgramming","DualPlanarGraph","DualPolyhedron","DualSystemsModel","DumpGet","DumpSave","DuplicateFreeQ","Duration","Dynamic","DynamicBox","DynamicBoxOptions","DynamicEvaluationTimeout","DynamicGeoGraphics","DynamicImage","DynamicLocation","DynamicModule","DynamicModuleBox","DynamicModuleBoxOptions","DynamicModuleParent","DynamicModuleValues","DynamicName","DynamicNamespace","DynamicReference","DynamicSetting","DynamicUpdating","DynamicWrapper","DynamicWrapperBox","DynamicWrapperBoxOptions","E","EarthImpactData","EarthquakeData","EccentricityCentrality","Echo","EchoEvaluation","EchoFunction","EchoLabel","EchoTiming","EclipseType","EdgeAdd","EdgeBetweennessCentrality","EdgeCapacity","EdgeCapForm","EdgeChromaticNumber","EdgeColor","EdgeConnectivity","EdgeContract","EdgeCost","EdgeCount","EdgeCoverQ","EdgeCycleMatrix","EdgeDashing","EdgeDelete","EdgeDetect","EdgeForm","EdgeIndex","EdgeJoinForm","EdgeLabeling","EdgeLabels","EdgeLabelStyle","EdgeList","EdgeOpacity","EdgeQ","EdgeRenderingFunction","EdgeRules","EdgeShapeFunction","EdgeStyle","EdgeTaggedGraph","EdgeTaggedGraphQ","EdgeTags","EdgeThickness","EdgeTransitiveGraphQ","EdgeValueRange","EdgeValueSizes","EdgeWeight","EdgeWeightedGraphQ","Editable","EditButtonSettings","EditCellTagsSettings","EditDistance","EffectiveInterest","Eigensystem","Eigenvalues","EigenvectorCentrality","Eigenvectors","Element","ElementData","ElementwiseLayer","ElidedForms","Eliminate","EliminationOrder","Ellipsoid","EllipticE","EllipticExp","EllipticExpPrime","EllipticF","EllipticFilterModel","EllipticK","EllipticLog","EllipticNomeQ","EllipticPi","EllipticReducedHalfPeriods","EllipticTheta","EllipticThetaPrime","EmbedCode","EmbeddedHTML","EmbeddedService","EmbeddedSQLEntityClass","EmbeddedSQLExpression","EmbeddingLayer","EmbeddingObject","EmitSound","EmphasizeSyntaxErrors","EmpiricalDistribution","Empty","EmptyGraphQ","EmptyRegion","EmptySpaceF","EnableConsolePrintPacket","Enabled","Enclose","Encode","Encrypt","EncryptedObject","EncryptFile","End","EndAdd","EndDialogPacket","EndOfBuffer","EndOfFile","EndOfLine","EndOfString","EndPackage","EngineEnvironment","EngineeringForm","Enter","EnterExpressionPacket","EnterTextPacket","Entity","EntityClass","EntityClassList","EntityCopies","EntityFunction","EntityGroup","EntityInstance","EntityList","EntityPrefetch","EntityProperties","EntityProperty","EntityPropertyClass","EntityRegister","EntityStore","EntityStores","EntityTypeName","EntityUnregister","EntityValue","Entropy","EntropyFilter","Environment","Epilog","EpilogFunction","Equal","EqualColumns","EqualRows","EqualTilde","EqualTo","EquatedTo","Equilibrium","EquirippleFilterKernel","Equivalent","Erf","Erfc","Erfi","ErlangB","ErlangC","ErlangDistribution","Erosion","ErrorBox","ErrorBoxOptions","ErrorNorm","ErrorPacket","ErrorsDialogSettings","EscapeRadius","EstimatedBackground","EstimatedDistribution","EstimatedPointNormals","EstimatedPointProcess","EstimatedProcess","EstimatedVariogramModel","EstimatorGains","EstimatorRegulator","EuclideanDistance","EulerAngles","EulerCharacteristic","EulerE","EulerGamma","EulerianGraphQ","EulerMatrix","EulerPhi","Evaluatable","Evaluate","Evaluated","EvaluatePacket","EvaluateScheduledTask","EvaluationBox","EvaluationCell","EvaluationCompletionAction","EvaluationData","EvaluationElements","EvaluationEnvironment","EvaluationMode","EvaluationMonitor","EvaluationNotebook","EvaluationObject","EvaluationOrder","EvaluationPrivileges","EvaluationRateLimit","Evaluator","EvaluatorNames","EvenQ","EventData","EventEvaluator","EventHandler","EventHandlerTag","EventLabels","EventSeries","ExactBlackmanWindow","ExactNumberQ","ExactRootIsolation","ExampleData","Except","ExcludedContexts","ExcludedForms","ExcludedLines","ExcludedPhysicalQuantities","ExcludePods","Exclusions","ExclusionsStyle","Exists","Exit","ExitDialog","ExoplanetData","Exp","Expand","ExpandAll","ExpandDenominator","ExpandFileName","ExpandNumerator","Expectation","ExpectationE","ExpectedValue","ExpGammaDistribution","ExpIntegralE","ExpIntegralEi","ExpirationDate","Exponent","ExponentFunction","ExponentialDistribution","ExponentialFamily","ExponentialGeneratingFunction","ExponentialMovingAverage","ExponentialPowerDistribution","ExponentPosition","ExponentStep","Export","ExportAutoReplacements","ExportByteArray","ExportForm","ExportPacket","ExportString","Expression","ExpressionCell","ExpressionGraph","ExpressionPacket","ExpressionTree","ExpressionUUID","ExpToTrig","ExtendedEntityClass","ExtendedGCD","Extension","ExtentElementFunction","ExtentMarkers","ExtentSize","ExternalBundle","ExternalCall","ExternalDataCharacterEncoding","ExternalEvaluate","ExternalFunction","ExternalFunctionName","ExternalIdentifier","ExternalObject","ExternalOptions","ExternalSessionObject","ExternalSessions","ExternalStorageBase","ExternalStorageDownload","ExternalStorageGet","ExternalStorageObject","ExternalStoragePut","ExternalStorageUpload","ExternalTypeSignature","ExternalValue","Extract","ExtractArchive","ExtractLayer","ExtractPacletArchive","ExtremeValueDistribution","FaceAlign","FaceForm","FaceGrids","FaceGridsStyle","FaceRecognize","FacialFeatures","Factor","FactorComplete","Factorial","Factorial2","FactorialMoment","FactorialMomentGeneratingFunction","FactorialPower","FactorInteger","FactorList","FactorSquareFree","FactorSquareFreeList","FactorTerms","FactorTermsList","Fail","Failure","FailureAction","FailureDistribution","FailureQ","False","FareySequence","FARIMAProcess","FeatureDistance","FeatureExtract","FeatureExtraction","FeatureExtractor","FeatureExtractorFunction","FeatureImpactPlot","FeatureNames","FeatureNearest","FeatureSpacePlot","FeatureSpacePlot3D","FeatureTypes","FeatureValueDependencyPlot","FeatureValueImpactPlot","FEDisableConsolePrintPacket","FeedbackLinearize","FeedbackSector","FeedbackSectorStyle","FeedbackType","FEEnableConsolePrintPacket","FetalGrowthData","Fibonacci","Fibonorial","FieldCompletionFunction","FieldHint","FieldHintStyle","FieldMasked","FieldSize","File","FileBaseName","FileByteCount","FileConvert","FileDate","FileExistsQ","FileExtension","FileFormat","FileFormatProperties","FileFormatQ","FileHandler","FileHash","FileInformation","FileName","FileNameDepth","FileNameDialogSettings","FileNameDrop","FileNameForms","FileNameJoin","FileNames","FileNameSetter","FileNameSplit","FileNameTake","FileNameToFormatList","FilePrint","FileSize","FileSystemMap","FileSystemScan","FileSystemTree","FileTemplate","FileTemplateApply","FileType","FilledCurve","FilledCurveBox","FilledCurveBoxOptions","FilledTorus","FillForm","Filling","FillingStyle","FillingTransform","FilteredEntityClass","FilterRules","FinancialBond","FinancialData","FinancialDerivative","FinancialIndicator","Find","FindAnomalies","FindArgMax","FindArgMin","FindChannels","FindClique","FindClusters","FindCookies","FindCurvePath","FindCycle","FindDevices","FindDistribution","FindDistributionParameters","FindDivisions","FindEdgeColoring","FindEdgeCover","FindEdgeCut","FindEdgeIndependentPaths","FindEquationalProof","FindEulerianCycle","FindExternalEvaluators","FindFaces","FindFile","FindFit","FindFormula","FindFundamentalCycles","FindGeneratingFunction","FindGeoLocation","FindGeometricConjectures","FindGeometricTransform","FindGraphCommunities","FindGraphIsomorphism","FindGraphPartition","FindHamiltonianCycle","FindHamiltonianPath","FindHiddenMarkovStates","FindImageText","FindIndependentEdgeSet","FindIndependentVertexSet","FindInstance","FindIntegerNullVector","FindIsomers","FindIsomorphicSubgraph","FindKClan","FindKClique","FindKClub","FindKPlex","FindLibrary","FindLinearRecurrence","FindList","FindMatchingColor","FindMaximum","FindMaximumCut","FindMaximumFlow","FindMaxValue","FindMeshDefects","FindMinimum","FindMinimumCostFlow","FindMinimumCut","FindMinValue","FindMoleculeSubstructure","FindPath","FindPeaks","FindPermutation","FindPlanarColoring","FindPointProcessParameters","FindPostmanTour","FindProcessParameters","FindRegionTransform","FindRepeat","FindRoot","FindSequenceFunction","FindSettings","FindShortestPath","FindShortestTour","FindSpanningTree","FindSubgraphIsomorphism","FindSystemModelEquilibrium","FindTextualAnswer","FindThreshold","FindTransientRepeat","FindVertexColoring","FindVertexCover","FindVertexCut","FindVertexIndependentPaths","Fine","FinishDynamic","FiniteAbelianGroupCount","FiniteGroupCount","FiniteGroupData","First","FirstCase","FirstPassageTimeDistribution","FirstPosition","FischerGroupFi22","FischerGroupFi23","FischerGroupFi24Prime","FisherHypergeometricDistribution","FisherRatioTest","FisherZDistribution","Fit","FitAll","FitRegularization","FittedModel","FixedOrder","FixedPoint","FixedPointList","FlashSelection","Flat","FlatShading","Flatten","FlattenAt","FlattenLayer","FlatTopWindow","FlightData","FlipView","Floor","FlowPolynomial","Fold","FoldList","FoldPair","FoldPairList","FoldWhile","FoldWhileList","FollowRedirects","Font","FontColor","FontFamily","FontForm","FontName","FontOpacity","FontPostScriptName","FontProperties","FontReencoding","FontSize","FontSlant","FontSubstitutions","FontTracking","FontVariations","FontWeight","For","ForAll","ForAllType","ForceVersionInstall","Format","FormatRules","FormatType","FormatTypeAutoConvert","FormatValues","FormBox","FormBoxOptions","FormControl","FormFunction","FormLayoutFunction","FormObject","FormPage","FormProtectionMethod","FormTheme","FormulaData","FormulaLookup","FortranForm","Forward","ForwardBackward","ForwardCloudCredentials","Fourier","FourierCoefficient","FourierCosCoefficient","FourierCosSeries","FourierCosTransform","FourierDCT","FourierDCTFilter","FourierDCTMatrix","FourierDST","FourierDSTMatrix","FourierMatrix","FourierParameters","FourierSequenceTransform","FourierSeries","FourierSinCoefficient","FourierSinSeries","FourierSinTransform","FourierTransform","FourierTrigSeries","FoxH","FoxHReduce","FractionalBrownianMotionProcess","FractionalD","FractionalGaussianNoiseProcess","FractionalPart","FractionBox","FractionBoxOptions","FractionLine","Frame","FrameBox","FrameBoxOptions","Framed","FrameInset","FrameLabel","Frameless","FrameListVideo","FrameMargins","FrameRate","FrameStyle","FrameTicks","FrameTicksStyle","FRatioDistribution","FrechetDistribution","FreeQ","FrenetSerretSystem","FrequencySamplingFilterKernel","FresnelC","FresnelF","FresnelG","FresnelS","Friday","FrobeniusNumber","FrobeniusSolve","FromAbsoluteTime","FromCharacterCode","FromCoefficientRules","FromContinuedFraction","FromDate","FromDateString","FromDigits","FromDMS","FromEntity","FromJulianDate","FromLetterNumber","FromPolarCoordinates","FromRawPointer","FromRomanNumeral","FromSphericalCoordinates","FromUnixTime","Front","FrontEndDynamicExpression","FrontEndEventActions","FrontEndExecute","FrontEndObject","FrontEndResource","FrontEndResourceString","FrontEndStackSize","FrontEndToken","FrontEndTokenExecute","FrontEndValueCache","FrontEndVersion","FrontFaceColor","FrontFaceGlowColor","FrontFaceOpacity","FrontFaceSpecularColor","FrontFaceSpecularExponent","FrontFaceSurfaceAppearance","FrontFaceTexture","Full","FullAxes","FullDefinition","FullForm","FullGraphics","FullInformationOutputRegulator","FullOptions","FullRegion","FullSimplify","Function","FunctionAnalytic","FunctionBijective","FunctionCompile","FunctionCompileExport","FunctionCompileExportByteArray","FunctionCompileExportLibrary","FunctionCompileExportString","FunctionContinuous","FunctionConvexity","FunctionDeclaration","FunctionDiscontinuities","FunctionDomain","FunctionExpand","FunctionInjective","FunctionInterpolation","FunctionLayer","FunctionMeromorphic","FunctionMonotonicity","FunctionPeriod","FunctionPoles","FunctionRange","FunctionSign","FunctionSingularities","FunctionSpace","FunctionSurjective","FussellVeselyImportance","GaborFilter","GaborMatrix","GaborWavelet","GainMargins","GainPhaseMargins","GalaxyData","GalleryView","Gamma","GammaDistribution","GammaRegularized","GapPenalty","GARCHProcess","GatedRecurrentLayer","Gather","GatherBy","GaugeFaceElementFunction","GaugeFaceStyle","GaugeFrameElementFunction","GaugeFrameSize","GaugeFrameStyle","GaugeLabels","GaugeMarkers","GaugeStyle","GaussianFilter","GaussianIntegers","GaussianMatrix","GaussianOrthogonalMatrixDistribution","GaussianSymplecticMatrixDistribution","GaussianUnitaryMatrixDistribution","GaussianWindow","GCD","GegenbauerC","General","GeneralizedLinearModelFit","GenerateAsymmetricKeyPair","GenerateConditions","GeneratedAssetFormat","GeneratedAssetLocation","GeneratedCell","GeneratedCellStyles","GeneratedDocumentBinding","GenerateDerivedKey","GenerateDigitalSignature","GenerateDocument","GeneratedParameters","GeneratedQuantityMagnitudes","GenerateFileSignature","GenerateHTTPResponse","GenerateSecuredAuthenticationKey","GenerateSymmetricKey","GeneratingFunction","GeneratorDescription","GeneratorHistoryLength","GeneratorOutputType","Generic","GenericCylindricalDecomposition","GenomeData","GenomeLookup","GeoAntipode","GeoArea","GeoArraySize","GeoBackground","GeoBoundary","GeoBoundingBox","GeoBounds","GeoBoundsRegion","GeoBoundsRegionBoundary","GeoBubbleChart","GeoCenter","GeoCircle","GeoContourPlot","GeoDensityPlot","GeodesicClosing","GeodesicDilation","GeodesicErosion","GeodesicOpening","GeodesicPolyhedron","GeoDestination","GeodesyData","GeoDirection","GeoDisk","GeoDisplacement","GeoDistance","GeoDistanceList","GeoElevationData","GeoEntities","GeoGraphics","GeoGraphPlot","GeoGraphValuePlot","GeogravityModelData","GeoGridDirectionDifference","GeoGridLines","GeoGridLinesStyle","GeoGridPosition","GeoGridRange","GeoGridRangePadding","GeoGridUnitArea","GeoGridUnitDistance","GeoGridVector","GeoGroup","GeoHemisphere","GeoHemisphereBoundary","GeoHistogram","GeoIdentify","GeoImage","GeoLabels","GeoLength","GeoListPlot","GeoLocation","GeologicalPeriodData","GeomagneticModelData","GeoMarker","GeometricAssertion","GeometricBrownianMotionProcess","GeometricDistribution","GeometricMean","GeometricMeanFilter","GeometricOptimization","GeometricScene","GeometricStep","GeometricStylingRules","GeometricTest","GeometricTransformation","GeometricTransformation3DBox","GeometricTransformation3DBoxOptions","GeometricTransformationBox","GeometricTransformationBoxOptions","GeoModel","GeoNearest","GeoOrientationData","GeoPath","GeoPolygon","GeoPosition","GeoPositionENU","GeoPositionXYZ","GeoProjection","GeoProjectionData","GeoRange","GeoRangePadding","GeoRegionValuePlot","GeoResolution","GeoScaleBar","GeoServer","GeoSmoothHistogram","GeoStreamPlot","GeoStyling","GeoStylingImageFunction","GeoVariant","GeoVector","GeoVectorENU","GeoVectorPlot","GeoVectorXYZ","GeoVisibleRegion","GeoVisibleRegionBoundary","GeoWithinQ","GeoZoomLevel","GestureHandler","GestureHandlerTag","Get","GetContext","GetEnvironment","GetFileName","GetLinebreakInformationPacket","GibbsPointProcess","Glaisher","GlobalClusteringCoefficient","GlobalPreferences","GlobalSession","Glow","GoldenAngle","GoldenRatio","GompertzMakehamDistribution","GoochShading","GoodmanKruskalGamma","GoodmanKruskalGammaTest","Goto","GouraudShading","Grad","Gradient","GradientFilter","GradientFittedMesh","GradientOrientationFilter","GrammarApply","GrammarRules","GrammarToken","Graph","Graph3D","GraphAssortativity","GraphAutomorphismGroup","GraphCenter","GraphComplement","GraphData","GraphDensity","GraphDiameter","GraphDifference","GraphDisjointUnion","GraphDistance","GraphDistanceMatrix","GraphEmbedding","GraphHighlight","GraphHighlightStyle","GraphHub","Graphics","Graphics3D","Graphics3DBox","Graphics3DBoxOptions","GraphicsArray","GraphicsBaseline","GraphicsBox","GraphicsBoxOptions","GraphicsColor","GraphicsColumn","GraphicsComplex","GraphicsComplex3DBox","GraphicsComplex3DBoxOptions","GraphicsComplexBox","GraphicsComplexBoxOptions","GraphicsContents","GraphicsData","GraphicsGrid","GraphicsGridBox","GraphicsGroup","GraphicsGroup3DBox","GraphicsGroup3DBoxOptions","GraphicsGroupBox","GraphicsGroupBoxOptions","GraphicsGrouping","GraphicsHighlightColor","GraphicsRow","GraphicsSpacing","GraphicsStyle","GraphIntersection","GraphJoin","GraphLayerLabels","GraphLayers","GraphLayerStyle","GraphLayout","GraphLinkEfficiency","GraphPeriphery","GraphPlot","GraphPlot3D","GraphPower","GraphProduct","GraphPropertyDistribution","GraphQ","GraphRadius","GraphReciprocity","GraphRoot","GraphStyle","GraphSum","GraphTree","GraphUnion","Gray","GrayLevel","Greater","GreaterEqual","GreaterEqualLess","GreaterEqualThan","GreaterFullEqual","GreaterGreater","GreaterLess","GreaterSlantEqual","GreaterThan","GreaterTilde","GreekStyle","Green","GreenFunction","Grid","GridBaseline","GridBox","GridBoxAlignment","GridBoxBackground","GridBoxDividers","GridBoxFrame","GridBoxItemSize","GridBoxItemStyle","GridBoxOptions","GridBoxSpacings","GridCreationSettings","GridDefaultElement","GridElementStyleOptions","GridFrame","GridFrameMargins","GridGraph","GridLines","GridLinesStyle","GridVideo","GroebnerBasis","GroupActionBase","GroupBy","GroupCentralizer","GroupElementFromWord","GroupElementPosition","GroupElementQ","GroupElements","GroupElementToWord","GroupGenerators","Groupings","GroupMultiplicationTable","GroupOpenerColor","GroupOpenerInsideFrame","GroupOrbits","GroupOrder","GroupPageBreakWithin","GroupSetwiseStabilizer","GroupStabilizer","GroupStabilizerChain","GroupTogetherGrouping","GroupTogetherNestedGrouping","GrowCutComponents","Gudermannian","GuidedFilter","GumbelDistribution","HaarWavelet","HadamardMatrix","HalfLine","HalfNormalDistribution","HalfPlane","HalfSpace","HalftoneShading","HamiltonianGraphQ","HammingDistance","HammingWindow","HandlerFunctions","HandlerFunctionsKeys","HankelH1","HankelH2","HankelMatrix","HankelTransform","HannPoissonWindow","HannWindow","HaradaNortonGroupHN","HararyGraph","HardcorePointProcess","HarmonicMean","HarmonicMeanFilter","HarmonicNumber","Hash","HatchFilling","HatchShading","Haversine","HazardFunction","Head","HeadCompose","HeaderAlignment","HeaderBackground","HeaderDisplayFunction","HeaderLines","Headers","HeaderSize","HeaderStyle","Heads","HeatFluxValue","HeatInsulationValue","HeatOutflowValue","HeatRadiationValue","HeatSymmetryValue","HeatTemperatureCondition","HeatTransferPDEComponent","HeatTransferValue","HeavisideLambda","HeavisidePi","HeavisideTheta","HeldGroupHe","HeldPart","HelmholtzPDEComponent","HelpBrowserLookup","HelpBrowserNotebook","HelpBrowserSettings","HelpViewerSettings","Here","HermiteDecomposition","HermiteH","Hermitian","HermitianMatrixQ","HessenbergDecomposition","Hessian","HeunB","HeunBPrime","HeunC","HeunCPrime","HeunD","HeunDPrime","HeunG","HeunGPrime","HeunT","HeunTPrime","HexadecimalCharacter","Hexahedron","HexahedronBox","HexahedronBoxOptions","HiddenItems","HiddenMarkovProcess","HiddenSurface","Highlighted","HighlightGraph","HighlightImage","HighlightMesh","HighlightString","HighpassFilter","HigmanSimsGroupHS","HilbertCurve","HilbertFilter","HilbertMatrix","Histogram","Histogram3D","HistogramDistribution","HistogramList","HistogramPointDensity","HistogramTransform","HistogramTransformInterpolation","HistoricalPeriodData","HitMissTransform","HITSCentrality","HjorthDistribution","HodgeDual","HoeffdingD","HoeffdingDTest","Hold","HoldAll","HoldAllComplete","HoldComplete","HoldFirst","HoldForm","HoldPattern","HoldRest","HolidayCalendar","HomeDirectory","HomePage","Horizontal","HorizontalForm","HorizontalGauge","HorizontalScrollPosition","HornerForm","HostLookup","HotellingTSquareDistribution","HoytDistribution","HTMLSave","HTTPErrorResponse","HTTPRedirect","HTTPRequest","HTTPRequestData","HTTPResponse","Hue","HumanGrowthData","HumpDownHump","HumpEqual","HurwitzLerchPhi","HurwitzZeta","HyperbolicDistribution","HypercubeGraph","HyperexponentialDistribution","Hyperfactorial","Hypergeometric0F1","Hypergeometric0F1Regularized","Hypergeometric1F1","Hypergeometric1F1Regularized","Hypergeometric2F1","Hypergeometric2F1Regularized","HypergeometricDistribution","HypergeometricPFQ","HypergeometricPFQRegularized","HypergeometricU","Hyperlink","HyperlinkAction","HyperlinkCreationSettings","Hyperplane","Hyphenation","HyphenationOptions","HypoexponentialDistribution","HypothesisTestData","I","IconData","Iconize","IconizedObject","IconRules","Icosahedron","Identity","IdentityMatrix","If","IfCompiled","IgnoreCase","IgnoreDiacritics","IgnoreIsotopes","IgnorePunctuation","IgnoreSpellCheck","IgnoreStereochemistry","IgnoringInactive","Im","Image","Image3D","Image3DProjection","Image3DSlices","ImageAccumulate","ImageAdd","ImageAdjust","ImageAlign","ImageApply","ImageApplyIndexed","ImageAspectRatio","ImageAssemble","ImageAugmentationLayer","ImageBoundingBoxes","ImageCache","ImageCacheValid","ImageCapture","ImageCaptureFunction","ImageCases","ImageChannels","ImageClip","ImageCollage","ImageColorSpace","ImageCompose","ImageContainsQ","ImageContents","ImageConvolve","ImageCooccurrence","ImageCorners","ImageCorrelate","ImageCorrespondingPoints","ImageCrop","ImageData","ImageDeconvolve","ImageDemosaic","ImageDifference","ImageDimensions","ImageDisplacements","ImageDistance","ImageEditMode","ImageEffect","ImageExposureCombine","ImageFeatureTrack","ImageFileApply","ImageFileFilter","ImageFileScan","ImageFilter","ImageFocusCombine","ImageForestingComponents","ImageFormattingWidth","ImageForwardTransformation","ImageGraphics","ImageHistogram","ImageIdentify","ImageInstanceQ","ImageKeypoints","ImageLabels","ImageLegends","ImageLevels","ImageLines","ImageMargins","ImageMarker","ImageMarkers","ImageMeasurements","ImageMesh","ImageMultiply","ImageOffset","ImagePad","ImagePadding","ImagePartition","ImagePeriodogram","ImagePerspectiveTransformation","ImagePosition","ImagePreviewFunction","ImagePyramid","ImagePyramidApply","ImageQ","ImageRangeCache","ImageRecolor","ImageReflect","ImageRegion","ImageResize","ImageResolution","ImageRestyle","ImageRotate","ImageRotated","ImageSaliencyFilter","ImageScaled","ImageScan","ImageSize","ImageSizeAction","ImageSizeCache","ImageSizeMultipliers","ImageSizeRaw","ImageStitch","ImageSubtract","ImageTake","ImageTransformation","ImageTrim","ImageType","ImageValue","ImageValuePositions","ImageVectorscopePlot","ImageWaveformPlot","ImagingDevice","ImplicitD","ImplicitRegion","Implies","Import","ImportAutoReplacements","ImportByteArray","ImportedObject","ImportOptions","ImportString","ImprovementImportance","In","Inactivate","Inactive","InactiveStyle","IncidenceGraph","IncidenceList","IncidenceMatrix","IncludeAromaticBonds","IncludeConstantBasis","IncludedContexts","IncludeDefinitions","IncludeDirectories","IncludeFileExtension","IncludeGeneratorTasks","IncludeHydrogens","IncludeInflections","IncludeMetaInformation","IncludePods","IncludeQuantities","IncludeRelatedTables","IncludeSingularSolutions","IncludeSingularTerm","IncludeWindowTimes","Increment","IndefiniteMatrixQ","Indent","IndentingNewlineSpacings","IndentMaxFraction","IndependenceTest","IndependentEdgeSetQ","IndependentPhysicalQuantity","IndependentUnit","IndependentUnitDimension","IndependentVertexSetQ","Indeterminate","IndeterminateThreshold","IndexCreationOptions","Indexed","IndexEdgeTaggedGraph","IndexGraph","IndexTag","Inequality","InertEvaluate","InertExpression","InexactNumberQ","InexactNumbers","InfiniteFuture","InfiniteLine","InfiniteLineThrough","InfinitePast","InfinitePlane","Infinity","Infix","InflationAdjust","InflationMethod","Information","InformationData","InformationDataGrid","Inherited","InheritScope","InhomogeneousPoissonPointProcess","InhomogeneousPoissonProcess","InitialEvaluationHistory","Initialization","InitializationCell","InitializationCellEvaluation","InitializationCellWarning","InitializationObject","InitializationObjects","InitializationValue","Initialize","InitialSeeding","InlineCounterAssignments","InlineCounterIncrements","InlineRules","Inner","InnerPolygon","InnerPolyhedron","Inpaint","Input","InputAliases","InputAssumptions","InputAutoReplacements","InputField","InputFieldBox","InputFieldBoxOptions","InputForm","InputGrouping","InputNamePacket","InputNotebook","InputPacket","InputPorts","InputSettings","InputStream","InputString","InputStringPacket","InputToBoxFormPacket","Insert","InsertionFunction","InsertionPointObject","InsertLinebreaks","InsertResults","Inset","Inset3DBox","Inset3DBoxOptions","InsetBox","InsetBoxOptions","Insphere","Install","InstallService","InstanceNormalizationLayer","InString","Integer","IntegerDigits","IntegerExponent","IntegerLength","IntegerName","IntegerPart","IntegerPartitions","IntegerQ","IntegerReverse","Integers","IntegerString","Integral","Integrate","IntegrateChangeVariables","Interactive","InteractiveTradingChart","InterfaceSwitched","Interlaced","Interleaving","InternallyBalancedDecomposition","InterpolatingFunction","InterpolatingPolynomial","Interpolation","InterpolationOrder","InterpolationPoints","InterpolationPrecision","Interpretation","InterpretationBox","InterpretationBoxOptions","InterpretationFunction","Interpreter","InterpretTemplate","InterquartileRange","Interrupt","InterruptSettings","IntersectedEntityClass","IntersectingQ","Intersection","Interval","IntervalIntersection","IntervalMarkers","IntervalMarkersStyle","IntervalMemberQ","IntervalSlider","IntervalUnion","Into","Inverse","InverseBetaRegularized","InverseBilateralLaplaceTransform","InverseBilateralZTransform","InverseCDF","InverseChiSquareDistribution","InverseContinuousWaveletTransform","InverseDistanceTransform","InverseEllipticNomeQ","InverseErf","InverseErfc","InverseFourier","InverseFourierCosTransform","InverseFourierSequenceTransform","InverseFourierSinTransform","InverseFourierTransform","InverseFunction","InverseFunctions","InverseGammaDistribution","InverseGammaRegularized","InverseGaussianDistribution","InverseGudermannian","InverseHankelTransform","InverseHaversine","InverseImagePyramid","InverseJacobiCD","InverseJacobiCN","InverseJacobiCS","InverseJacobiDC","InverseJacobiDN","InverseJacobiDS","InverseJacobiNC","InverseJacobiND","InverseJacobiNS","InverseJacobiSC","InverseJacobiSD","InverseJacobiSN","InverseLaplaceTransform","InverseMellinTransform","InversePermutation","InverseRadon","InverseRadonTransform","InverseSeries","InverseShortTimeFourier","InverseSpectrogram","InverseSurvivalFunction","InverseTransformedRegion","InverseWaveletTransform","InverseWeierstrassP","InverseWishartMatrixDistribution","InverseZTransform","Invisible","InvisibleApplication","InvisibleTimes","IPAddress","IrreduciblePolynomialQ","IslandData","IsolatingInterval","IsomorphicGraphQ","IsomorphicSubgraphQ","IsotopeData","Italic","Item","ItemAspectRatio","ItemBox","ItemBoxOptions","ItemDisplayFunction","ItemSize","ItemStyle","ItoProcess","JaccardDissimilarity","JacobiAmplitude","Jacobian","JacobiCD","JacobiCN","JacobiCS","JacobiDC","JacobiDN","JacobiDS","JacobiEpsilon","JacobiNC","JacobiND","JacobiNS","JacobiP","JacobiSC","JacobiSD","JacobiSN","JacobiSymbol","JacobiZeta","JacobiZN","JankoGroupJ1","JankoGroupJ2","JankoGroupJ3","JankoGroupJ4","JarqueBeraALMTest","JohnsonDistribution","Join","JoinAcross","Joined","JoinedCurve","JoinedCurveBox","JoinedCurveBoxOptions","JoinForm","JordanDecomposition","JordanModelDecomposition","JulianDate","JuliaSetBoettcher","JuliaSetIterationCount","JuliaSetPlot","JuliaSetPoints","K","KagiChart","KaiserBesselWindow","KaiserWindow","KalmanEstimator","KalmanFilter","KarhunenLoeveDecomposition","KaryTree","KatzCentrality","KCoreComponents","KDistribution","KEdgeConnectedComponents","KEdgeConnectedGraphQ","KeepExistingVersion","KelvinBei","KelvinBer","KelvinKei","KelvinKer","KendallTau","KendallTauTest","KernelConfiguration","KernelExecute","KernelFunction","KernelMixtureDistribution","KernelObject","Kernels","Ket","Key","KeyCollisionFunction","KeyComplement","KeyDrop","KeyDropFrom","KeyExistsQ","KeyFreeQ","KeyIntersection","KeyMap","KeyMemberQ","KeypointStrength","Keys","KeySelect","KeySort","KeySortBy","KeyTake","KeyUnion","KeyValueMap","KeyValuePattern","Khinchin","KillProcess","KirchhoffGraph","KirchhoffMatrix","KleinInvariantJ","KnapsackSolve","KnightTourGraph","KnotData","KnownUnitQ","KochCurve","KolmogorovSmirnovTest","KroneckerDelta","KroneckerModelDecomposition","KroneckerProduct","KroneckerSymbol","KuiperTest","KumaraswamyDistribution","Kurtosis","KuwaharaFilter","KVertexConnectedComponents","KVertexConnectedGraphQ","LABColor","Label","Labeled","LabeledSlider","LabelingFunction","LabelingSize","LabelStyle","LabelVisibility","LaguerreL","LakeData","LambdaComponents","LambertW","LameC","LameCPrime","LameEigenvalueA","LameEigenvalueB","LameS","LameSPrime","LaminaData","LanczosWindow","LandauDistribution","Language","LanguageCategory","LanguageData","LanguageIdentify","LanguageOptions","LaplaceDistribution","LaplaceTransform","Laplacian","LaplacianFilter","LaplacianGaussianFilter","LaplacianPDETerm","Large","Larger","Last","Latitude","LatitudeLongitude","LatticeData","LatticeReduce","Launch","LaunchKernels","LayeredGraphPlot","LayeredGraphPlot3D","LayerSizeFunction","LayoutInformation","LCHColor","LCM","LeaderSize","LeafCount","LeapVariant","LeapYearQ","LearnDistribution","LearnedDistribution","LearningRate","LearningRateMultipliers","LeastSquares","LeastSquaresFilterKernel","Left","LeftArrow","LeftArrowBar","LeftArrowRightArrow","LeftDownTeeVector","LeftDownVector","LeftDownVectorBar","LeftRightArrow","LeftRightVector","LeftTee","LeftTeeArrow","LeftTeeVector","LeftTriangle","LeftTriangleBar","LeftTriangleEqual","LeftUpDownVector","LeftUpTeeVector","LeftUpVector","LeftUpVectorBar","LeftVector","LeftVectorBar","LegendAppearance","Legended","LegendFunction","LegendLabel","LegendLayout","LegendMargins","LegendMarkers","LegendMarkerSize","LegendreP","LegendreQ","LegendreType","Length","LengthWhile","LerchPhi","Less","LessEqual","LessEqualGreater","LessEqualThan","LessFullEqual","LessGreater","LessLess","LessSlantEqual","LessThan","LessTilde","LetterCharacter","LetterCounts","LetterNumber","LetterQ","Level","LeveneTest","LeviCivitaTensor","LevyDistribution","Lexicographic","LexicographicOrder","LexicographicSort","LibraryDataType","LibraryFunction","LibraryFunctionDeclaration","LibraryFunctionError","LibraryFunctionInformation","LibraryFunctionLoad","LibraryFunctionUnload","LibraryLoad","LibraryUnload","LicenseEntitlementObject","LicenseEntitlements","LicenseID","LicensingSettings","LiftingFilterData","LiftingWaveletTransform","LightBlue","LightBrown","LightCyan","Lighter","LightGray","LightGreen","Lighting","LightingAngle","LightMagenta","LightOrange","LightPink","LightPurple","LightRed","LightSources","LightYellow","Likelihood","Limit","LimitsPositioning","LimitsPositioningTokens","LindleyDistribution","Line","Line3DBox","Line3DBoxOptions","LinearFilter","LinearFractionalOptimization","LinearFractionalTransform","LinearGradientFilling","LinearGradientImage","LinearizingTransformationData","LinearLayer","LinearModelFit","LinearOffsetFunction","LinearOptimization","LinearProgramming","LinearRecurrence","LinearSolve","LinearSolveFunction","LineBox","LineBoxOptions","LineBreak","LinebreakAdjustments","LineBreakChart","LinebreakSemicolonWeighting","LineBreakWithin","LineColor","LineGraph","LineIndent","LineIndentMaxFraction","LineIntegralConvolutionPlot","LineIntegralConvolutionScale","LineLegend","LineOpacity","LineSpacing","LineWrapParts","LinkActivate","LinkClose","LinkConnect","LinkConnectedQ","LinkCreate","LinkError","LinkFlush","LinkFunction","LinkHost","LinkInterrupt","LinkLaunch","LinkMode","LinkObject","LinkOpen","LinkOptions","LinkPatterns","LinkProtocol","LinkRankCentrality","LinkRead","LinkReadHeld","LinkReadyQ","Links","LinkService","LinkWrite","LinkWriteHeld","LiouvilleLambda","List","Listable","ListAnimate","ListContourPlot","ListContourPlot3D","ListConvolve","ListCorrelate","ListCurvePathPlot","ListDeconvolve","ListDensityPlot","ListDensityPlot3D","Listen","ListFormat","ListFourierSequenceTransform","ListInterpolation","ListLineIntegralConvolutionPlot","ListLinePlot","ListLinePlot3D","ListLogLinearPlot","ListLogLogPlot","ListLogPlot","ListPicker","ListPickerBox","ListPickerBoxBackground","ListPickerBoxOptions","ListPlay","ListPlot","ListPlot3D","ListPointPlot3D","ListPolarPlot","ListQ","ListSliceContourPlot3D","ListSliceDensityPlot3D","ListSliceVectorPlot3D","ListStepPlot","ListStreamDensityPlot","ListStreamPlot","ListStreamPlot3D","ListSurfacePlot3D","ListVectorDensityPlot","ListVectorDisplacementPlot","ListVectorDisplacementPlot3D","ListVectorPlot","ListVectorPlot3D","ListZTransform","Literal","LiteralSearch","LiteralType","LoadCompiledComponent","LocalAdaptiveBinarize","LocalCache","LocalClusteringCoefficient","LocalEvaluate","LocalizeDefinitions","LocalizeVariables","LocalObject","LocalObjects","LocalResponseNormalizationLayer","LocalSubmit","LocalSymbol","LocalTime","LocalTimeZone","LocationEquivalenceTest","LocationTest","Locator","LocatorAutoCreate","LocatorBox","LocatorBoxOptions","LocatorCentering","LocatorPane","LocatorPaneBox","LocatorPaneBoxOptions","LocatorRegion","Locked","Log","Log10","Log2","LogBarnesG","LogGamma","LogGammaDistribution","LogicalExpand","LogIntegral","LogisticDistribution","LogisticSigmoid","LogitModelFit","LogLikelihood","LogLinearPlot","LogLogisticDistribution","LogLogPlot","LogMultinormalDistribution","LogNormalDistribution","LogPlot","LogRankTest","LogSeriesDistribution","LongEqual","Longest","LongestCommonSequence","LongestCommonSequencePositions","LongestCommonSubsequence","LongestCommonSubsequencePositions","LongestMatch","LongestOrderedSequence","LongForm","Longitude","LongLeftArrow","LongLeftRightArrow","LongRightArrow","LongShortTermMemoryLayer","Lookup","Loopback","LoopFreeGraphQ","Looping","LossFunction","LowerCaseQ","LowerLeftArrow","LowerRightArrow","LowerTriangularize","LowerTriangularMatrix","LowerTriangularMatrixQ","LowpassFilter","LQEstimatorGains","LQGRegulator","LQOutputRegulatorGains","LQRegulatorGains","LUBackSubstitution","LucasL","LuccioSamiComponents","LUDecomposition","LunarEclipse","LUVColor","LyapunovSolve","LyonsGroupLy","MachineID","MachineName","MachineNumberQ","MachinePrecision","MacintoshSystemPageSetup","Magenta","Magnification","Magnify","MailAddressValidation","MailExecute","MailFolder","MailItem","MailReceiverFunction","MailResponseFunction","MailSearch","MailServerConnect","MailServerConnection","MailSettings","MainSolve","MaintainDynamicCaches","Majority","MakeBoxes","MakeExpression","MakeRules","ManagedLibraryExpressionID","ManagedLibraryExpressionQ","MandelbrotSetBoettcher","MandelbrotSetDistance","MandelbrotSetIterationCount","MandelbrotSetMemberQ","MandelbrotSetPlot","MangoldtLambda","ManhattanDistance","Manipulate","Manipulator","MannedSpaceMissionData","MannWhitneyTest","MantissaExponent","Manual","Map","MapAll","MapApply","MapAt","MapIndexed","MAProcess","MapThread","MarchenkoPasturDistribution","MarcumQ","MardiaCombinedTest","MardiaKurtosisTest","MardiaSkewnessTest","MarginalDistribution","MarkovProcessProperties","Masking","MassConcentrationCondition","MassFluxValue","MassImpermeableBoundaryValue","MassOutflowValue","MassSymmetryValue","MassTransferValue","MassTransportPDEComponent","MatchingDissimilarity","MatchLocalNameQ","MatchLocalNames","MatchQ","Material","MaterialShading","MaternPointProcess","MathematicalFunctionData","MathematicaNotation","MathieuC","MathieuCharacteristicA","MathieuCharacteristicB","MathieuCharacteristicExponent","MathieuCPrime","MathieuGroupM11","MathieuGroupM12","MathieuGroupM22","MathieuGroupM23","MathieuGroupM24","MathieuS","MathieuSPrime","MathMLForm","MathMLText","Matrices","MatrixExp","MatrixForm","MatrixFunction","MatrixLog","MatrixNormalDistribution","MatrixPlot","MatrixPower","MatrixPropertyDistribution","MatrixQ","MatrixRank","MatrixTDistribution","Max","MaxBend","MaxCellMeasure","MaxColorDistance","MaxDate","MaxDetect","MaxDisplayedChildren","MaxDuration","MaxExtraBandwidths","MaxExtraConditions","MaxFeatureDisplacement","MaxFeatures","MaxFilter","MaximalBy","Maximize","MaxItems","MaxIterations","MaxLimit","MaxMemoryUsed","MaxMixtureKernels","MaxOverlapFraction","MaxPlotPoints","MaxPoints","MaxRecursion","MaxStableDistribution","MaxStepFraction","MaxSteps","MaxStepSize","MaxTrainingRounds","MaxValue","MaxwellDistribution","MaxWordGap","McLaughlinGroupMcL","Mean","MeanAbsoluteLossLayer","MeanAround","MeanClusteringCoefficient","MeanDegreeConnectivity","MeanDeviation","MeanFilter","MeanGraphDistance","MeanNeighborDegree","MeanPointDensity","MeanShift","MeanShiftFilter","MeanSquaredLossLayer","Median","MedianDeviation","MedianFilter","MedicalTestData","Medium","MeijerG","MeijerGReduce","MeixnerDistribution","MellinConvolve","MellinTransform","MemberQ","MemoryAvailable","MemoryConstrained","MemoryConstraint","MemoryInUse","MengerMesh","Menu","MenuAppearance","MenuCommandKey","MenuEvaluator","MenuItem","MenuList","MenuPacket","MenuSortingValue","MenuStyle","MenuView","Merge","MergeDifferences","MergingFunction","MersennePrimeExponent","MersennePrimeExponentQ","Mesh","MeshCellCentroid","MeshCellCount","MeshCellHighlight","MeshCellIndex","MeshCellLabel","MeshCellMarker","MeshCellMeasure","MeshCellQuality","MeshCells","MeshCellShapeFunction","MeshCellStyle","MeshConnectivityGraph","MeshCoordinates","MeshFunctions","MeshPrimitives","MeshQualityGoal","MeshRange","MeshRefinementFunction","MeshRegion","MeshRegionQ","MeshShading","MeshStyle","Message","MessageDialog","MessageList","MessageName","MessageObject","MessageOptions","MessagePacket","Messages","MessagesNotebook","MetaCharacters","MetaInformation","MeteorShowerData","Method","MethodOptions","MexicanHatWavelet","MeyerWavelet","Midpoint","MIMETypeToFormatList","Min","MinColorDistance","MinDate","MinDetect","MineralData","MinFilter","MinimalBy","MinimalPolynomial","MinimalStateSpaceModel","Minimize","MinimumTimeIncrement","MinIntervalSize","MinkowskiQuestionMark","MinLimit","MinMax","MinorPlanetData","Minors","MinPointSeparation","MinRecursion","MinSize","MinStableDistribution","Minus","MinusPlus","MinValue","Missing","MissingBehavior","MissingDataMethod","MissingDataRules","MissingQ","MissingString","MissingStyle","MissingValuePattern","MissingValueSynthesis","MittagLefflerE","MixedFractionParts","MixedGraphQ","MixedMagnitude","MixedRadix","MixedRadixQuantity","MixedUnit","MixtureDistribution","Mod","Modal","Mode","ModelPredictiveController","Modular","ModularInverse","ModularLambda","Module","Modulus","MoebiusMu","Molecule","MoleculeAlign","MoleculeContainsQ","MoleculeDraw","MoleculeEquivalentQ","MoleculeFreeQ","MoleculeGraph","MoleculeMatchQ","MoleculeMaximumCommonSubstructure","MoleculeModify","MoleculeName","MoleculePattern","MoleculePlot","MoleculePlot3D","MoleculeProperty","MoleculeQ","MoleculeRecognize","MoleculeSubstructureCount","MoleculeValue","Moment","MomentConvert","MomentEvaluate","MomentGeneratingFunction","MomentOfInertia","Monday","Monitor","MonomialList","MonomialOrder","MonsterGroupM","MoonPhase","MoonPosition","MorletWavelet","MorphologicalBinarize","MorphologicalBranchPoints","MorphologicalComponents","MorphologicalEulerNumber","MorphologicalGraph","MorphologicalPerimeter","MorphologicalTransform","MortalityData","Most","MountainData","MouseAnnotation","MouseAppearance","MouseAppearanceTag","MouseButtons","Mouseover","MousePointerNote","MousePosition","MovieData","MovingAverage","MovingMap","MovingMedian","MoyalDistribution","MultiaxisArrangement","Multicolumn","MultiedgeStyle","MultigraphQ","MultilaunchWarning","MultiLetterItalics","MultiLetterStyle","MultilineFunction","Multinomial","MultinomialDistribution","MultinormalDistribution","MultiplicativeOrder","Multiplicity","MultiplySides","MultiscriptBoxOptions","Multiselection","MultivariateHypergeometricDistribution","MultivariatePoissonDistribution","MultivariateTDistribution","N","NakagamiDistribution","NameQ","Names","NamespaceBox","NamespaceBoxOptions","Nand","NArgMax","NArgMin","NBernoulliB","NBodySimulation","NBodySimulationData","NCache","NCaputoD","NDEigensystem","NDEigenvalues","NDSolve","NDSolveValue","Nearest","NearestFunction","NearestMeshCells","NearestNeighborG","NearestNeighborGraph","NearestTo","NebulaData","NeedlemanWunschSimilarity","Needs","Negative","NegativeBinomialDistribution","NegativeDefiniteMatrixQ","NegativeIntegers","NegativelyOrientedPoints","NegativeMultinomialDistribution","NegativeRationals","NegativeReals","NegativeSemidefiniteMatrixQ","NeighborhoodData","NeighborhoodGraph","Nest","NestedGreaterGreater","NestedLessLess","NestedScriptRules","NestGraph","NestList","NestTree","NestWhile","NestWhileList","NetAppend","NetArray","NetArrayLayer","NetBidirectionalOperator","NetChain","NetDecoder","NetDelete","NetDrop","NetEncoder","NetEvaluationMode","NetExternalObject","NetExtract","NetFlatten","NetFoldOperator","NetGANOperator","NetGraph","NetInformation","NetInitialize","NetInsert","NetInsertSharedArrays","NetJoin","NetMapOperator","NetMapThreadOperator","NetMeasurements","NetModel","NetNestOperator","NetPairEmbeddingOperator","NetPort","NetPortGradient","NetPrepend","NetRename","NetReplace","NetReplacePart","NetSharedArray","NetStateObject","NetTake","NetTrain","NetTrainResultsObject","NetUnfold","NetworkPacketCapture","NetworkPacketRecording","NetworkPacketRecordingDuring","NetworkPacketTrace","NeumannValue","NevilleThetaC","NevilleThetaD","NevilleThetaN","NevilleThetaS","NewPrimitiveStyle","NExpectation","Next","NextCell","NextDate","NextPrime","NextScheduledTaskTime","NeymanScottPointProcess","NFractionalD","NHoldAll","NHoldFirst","NHoldRest","NicholsGridLines","NicholsPlot","NightHemisphere","NIntegrate","NMaximize","NMaxValue","NMinimize","NMinValue","NominalScale","NominalVariables","NonAssociative","NoncentralBetaDistribution","NoncentralChiSquareDistribution","NoncentralFRatioDistribution","NoncentralStudentTDistribution","NonCommutativeMultiply","NonConstants","NondimensionalizationTransform","None","NoneTrue","NonlinearModelFit","NonlinearStateSpaceModel","NonlocalMeansFilter","NonNegative","NonNegativeIntegers","NonNegativeRationals","NonNegativeReals","NonPositive","NonPositiveIntegers","NonPositiveRationals","NonPositiveReals","Nor","NorlundB","Norm","Normal","NormalDistribution","NormalGrouping","NormalizationLayer","Normalize","Normalized","NormalizedSquaredEuclideanDistance","NormalMatrixQ","NormalsFunction","NormFunction","Not","NotCongruent","NotCupCap","NotDoubleVerticalBar","Notebook","NotebookApply","NotebookAutoSave","NotebookBrowseDirectory","NotebookClose","NotebookConvertSettings","NotebookCreate","NotebookDefault","NotebookDelete","NotebookDirectory","NotebookDynamicExpression","NotebookEvaluate","NotebookEventActions","NotebookFileName","NotebookFind","NotebookGet","NotebookImport","NotebookInformation","NotebookInterfaceObject","NotebookLocate","NotebookObject","NotebookOpen","NotebookPath","NotebookPrint","NotebookPut","NotebookRead","Notebooks","NotebookSave","NotebookSelection","NotebooksMenu","NotebookTemplate","NotebookWrite","NotElement","NotEqualTilde","NotExists","NotGreater","NotGreaterEqual","NotGreaterFullEqual","NotGreaterGreater","NotGreaterLess","NotGreaterSlantEqual","NotGreaterTilde","Nothing","NotHumpDownHump","NotHumpEqual","NotificationFunction","NotLeftTriangle","NotLeftTriangleBar","NotLeftTriangleEqual","NotLess","NotLessEqual","NotLessFullEqual","NotLessGreater","NotLessLess","NotLessSlantEqual","NotLessTilde","NotNestedGreaterGreater","NotNestedLessLess","NotPrecedes","NotPrecedesEqual","NotPrecedesSlantEqual","NotPrecedesTilde","NotReverseElement","NotRightTriangle","NotRightTriangleBar","NotRightTriangleEqual","NotSquareSubset","NotSquareSubsetEqual","NotSquareSuperset","NotSquareSupersetEqual","NotSubset","NotSubsetEqual","NotSucceeds","NotSucceedsEqual","NotSucceedsSlantEqual","NotSucceedsTilde","NotSuperset","NotSupersetEqual","NotTilde","NotTildeEqual","NotTildeFullEqual","NotTildeTilde","NotVerticalBar","Now","NoWhitespace","NProbability","NProduct","NProductFactors","NRoots","NSolve","NSolveValues","NSum","NSumTerms","NuclearExplosionData","NuclearReactorData","Null","NullRecords","NullSpace","NullWords","Number","NumberCompose","NumberDecompose","NumberDigit","NumberExpand","NumberFieldClassNumber","NumberFieldDiscriminant","NumberFieldFundamentalUnits","NumberFieldIntegralBasis","NumberFieldNormRepresentatives","NumberFieldRegulator","NumberFieldRootsOfUnity","NumberFieldSignature","NumberForm","NumberFormat","NumberLinePlot","NumberMarks","NumberMultiplier","NumberPadding","NumberPoint","NumberQ","NumberSeparator","NumberSigns","NumberString","Numerator","NumeratorDenominator","NumericalOrder","NumericalSort","NumericArray","NumericArrayQ","NumericArrayType","NumericFunction","NumericQ","NuttallWindow","NValues","NyquistGridLines","NyquistPlot","O","ObjectExistsQ","ObservabilityGramian","ObservabilityMatrix","ObservableDecomposition","ObservableModelQ","OceanData","Octahedron","OddQ","Off","Offset","OLEData","On","ONanGroupON","Once","OneIdentity","Opacity","OpacityFunction","OpacityFunctionScaling","Open","OpenAppend","Opener","OpenerBox","OpenerBoxOptions","OpenerView","OpenFunctionInspectorPacket","Opening","OpenRead","OpenSpecialOptions","OpenTemporary","OpenWrite","Operate","OperatingSystem","OperatorApplied","OptimumFlowData","Optional","OptionalElement","OptionInspectorSettings","OptionQ","Options","OptionsPacket","OptionsPattern","OptionValue","OptionValueBox","OptionValueBoxOptions","Or","Orange","Order","OrderDistribution","OrderedQ","Ordering","OrderingBy","OrderingLayer","Orderless","OrderlessPatternSequence","OrdinalScale","OrnsteinUhlenbeckProcess","Orthogonalize","OrthogonalMatrixQ","Out","Outer","OuterPolygon","OuterPolyhedron","OutputAutoOverwrite","OutputControllabilityMatrix","OutputControllableModelQ","OutputForm","OutputFormData","OutputGrouping","OutputMathEditExpression","OutputNamePacket","OutputPorts","OutputResponse","OutputSizeLimit","OutputStream","Over","OverBar","OverDot","Overflow","OverHat","Overlaps","Overlay","OverlayBox","OverlayBoxOptions","OverlayVideo","Overscript","OverscriptBox","OverscriptBoxOptions","OverTilde","OverVector","OverwriteTarget","OwenT","OwnValues","Package","PackingMethod","PackPaclet","PacletDataRebuild","PacletDirectoryAdd","PacletDirectoryLoad","PacletDirectoryRemove","PacletDirectoryUnload","PacletDisable","PacletEnable","PacletFind","PacletFindRemote","PacletInformation","PacletInstall","PacletInstallSubmit","PacletNewerQ","PacletObject","PacletObjectQ","PacletSite","PacletSiteObject","PacletSiteRegister","PacletSites","PacletSiteUnregister","PacletSiteUpdate","PacletSymbol","PacletUninstall","PacletUpdate","PaddedForm","Padding","PaddingLayer","PaddingSize","PadeApproximant","PadLeft","PadRight","PageBreakAbove","PageBreakBelow","PageBreakWithin","PageFooterLines","PageFooters","PageHeaderLines","PageHeaders","PageHeight","PageRankCentrality","PageTheme","PageWidth","Pagination","PairCorrelationG","PairedBarChart","PairedHistogram","PairedSmoothHistogram","PairedTTest","PairedZTest","PaletteNotebook","PalettePath","PalettesMenuSettings","PalindromeQ","Pane","PaneBox","PaneBoxOptions","Panel","PanelBox","PanelBoxOptions","Paneled","PaneSelector","PaneSelectorBox","PaneSelectorBoxOptions","PaperWidth","ParabolicCylinderD","ParagraphIndent","ParagraphSpacing","ParallelArray","ParallelAxisPlot","ParallelCombine","ParallelDo","Parallelepiped","ParallelEvaluate","Parallelization","Parallelize","ParallelKernels","ParallelMap","ParallelNeeds","Parallelogram","ParallelProduct","ParallelSubmit","ParallelSum","ParallelTable","ParallelTry","Parameter","ParameterEstimator","ParameterMixtureDistribution","ParameterVariables","ParametricConvexOptimization","ParametricFunction","ParametricNDSolve","ParametricNDSolveValue","ParametricPlot","ParametricPlot3D","ParametricRampLayer","ParametricRegion","ParentBox","ParentCell","ParentConnect","ParentDirectory","ParentEdgeLabel","ParentEdgeLabelFunction","ParentEdgeLabelStyle","ParentEdgeShapeFunction","ParentEdgeStyle","ParentEdgeStyleFunction","ParentForm","Parenthesize","ParentList","ParentNotebook","ParetoDistribution","ParetoPickandsDistribution","ParkData","Part","PartBehavior","PartialCorrelationFunction","PartialD","ParticleAcceleratorData","ParticleData","Partition","PartitionGranularity","PartitionsP","PartitionsQ","PartLayer","PartOfSpeech","PartProtection","ParzenWindow","PascalDistribution","PassEventsDown","PassEventsUp","Paste","PasteAutoQuoteCharacters","PasteBoxFormInlineCells","PasteButton","Path","PathGraph","PathGraphQ","Pattern","PatternFilling","PatternReaction","PatternSequence","PatternTest","PauliMatrix","PaulWavelet","Pause","PausedTime","PDF","PeakDetect","PeanoCurve","PearsonChiSquareTest","PearsonCorrelationTest","PearsonDistribution","PenttinenPointProcess","PercentForm","PerfectNumber","PerfectNumberQ","PerformanceGoal","Perimeter","PeriodicBoundaryCondition","PeriodicInterpolation","Periodogram","PeriodogramArray","Permanent","Permissions","PermissionsGroup","PermissionsGroupMemberQ","PermissionsGroups","PermissionsKey","PermissionsKeys","PermutationCycles","PermutationCyclesQ","PermutationGroup","PermutationLength","PermutationList","PermutationListQ","PermutationMatrix","PermutationMax","PermutationMin","PermutationOrder","PermutationPower","PermutationProduct","PermutationReplace","Permutations","PermutationSupport","Permute","PeronaMalikFilter","Perpendicular","PerpendicularBisector","PersistenceLocation","PersistenceTime","PersistentObject","PersistentObjects","PersistentSymbol","PersistentValue","PersonData","PERTDistribution","PetersenGraph","PhaseMargins","PhaseRange","PhongShading","PhysicalSystemData","Pi","Pick","PickedElements","PickMode","PIDData","PIDDerivativeFilter","PIDFeedforward","PIDTune","Piecewise","PiecewiseExpand","PieChart","PieChart3D","PillaiTrace","PillaiTraceTest","PingTime","Pink","PitchRecognize","Pivoting","PixelConstrained","PixelValue","PixelValuePositions","Placed","Placeholder","PlaceholderLayer","PlaceholderReplace","Plain","PlanarAngle","PlanarFaceList","PlanarGraph","PlanarGraphQ","PlanckRadiationLaw","PlaneCurveData","PlanetaryMoonData","PlanetData","PlantData","Play","PlaybackSettings","PlayRange","Plot","Plot3D","Plot3Matrix","PlotDivision","PlotJoined","PlotLabel","PlotLabels","PlotLayout","PlotLegends","PlotMarkers","PlotPoints","PlotRange","PlotRangeClipping","PlotRangeClipPlanesStyle","PlotRangePadding","PlotRegion","PlotStyle","PlotTheme","Pluralize","Plus","PlusMinus","Pochhammer","PodStates","PodWidth","Point","Point3DBox","Point3DBoxOptions","PointBox","PointBoxOptions","PointCountDistribution","PointDensity","PointDensityFunction","PointFigureChart","PointLegend","PointLight","PointProcessEstimator","PointProcessFitTest","PointProcessParameterAssumptions","PointProcessParameterQ","PointSize","PointStatisticFunction","PointValuePlot","PoissonConsulDistribution","PoissonDistribution","PoissonPDEComponent","PoissonPointProcess","PoissonProcess","PoissonWindow","PolarAxes","PolarAxesOrigin","PolarGridLines","PolarPlot","PolarTicks","PoleZeroMarkers","PolyaAeppliDistribution","PolyGamma","Polygon","Polygon3DBox","Polygon3DBoxOptions","PolygonalNumber","PolygonAngle","PolygonBox","PolygonBoxOptions","PolygonCoordinates","PolygonDecomposition","PolygonHoleScale","PolygonIntersections","PolygonScale","Polyhedron","PolyhedronAngle","PolyhedronBox","PolyhedronBoxOptions","PolyhedronCoordinates","PolyhedronData","PolyhedronDecomposition","PolyhedronGenus","PolyLog","PolynomialExpressionQ","PolynomialExtendedGCD","PolynomialForm","PolynomialGCD","PolynomialLCM","PolynomialMod","PolynomialQ","PolynomialQuotient","PolynomialQuotientRemainder","PolynomialReduce","PolynomialRemainder","Polynomials","PolynomialSumOfSquaresList","PoolingLayer","PopupMenu","PopupMenuBox","PopupMenuBoxOptions","PopupView","PopupWindow","Position","PositionIndex","PositionLargest","PositionSmallest","Positive","PositiveDefiniteMatrixQ","PositiveIntegers","PositivelyOrientedPoints","PositiveRationals","PositiveReals","PositiveSemidefiniteMatrixQ","PossibleZeroQ","Postfix","PostScript","Power","PowerDistribution","PowerExpand","PowerMod","PowerModList","PowerRange","PowerSpectralDensity","PowersRepresentations","PowerSymmetricPolynomial","Precedence","PrecedenceForm","Precedes","PrecedesEqual","PrecedesSlantEqual","PrecedesTilde","Precision","PrecisionGoal","PreDecrement","Predict","PredictionRoot","PredictorFunction","PredictorInformation","PredictorMeasurements","PredictorMeasurementsObject","PreemptProtect","PreferencesPath","PreferencesSettings","Prefix","PreIncrement","Prepend","PrependLayer","PrependTo","PreprocessingRules","PreserveColor","PreserveImageOptions","Previous","PreviousCell","PreviousDate","PriceGraphDistribution","PrimaryPlaceholder","Prime","PrimeNu","PrimeOmega","PrimePi","PrimePowerQ","PrimeQ","Primes","PrimeZetaP","PrimitivePolynomialQ","PrimitiveRoot","PrimitiveRootList","PrincipalComponents","PrincipalValue","Print","PrintableASCIIQ","PrintAction","PrintForm","PrintingCopies","PrintingOptions","PrintingPageRange","PrintingStartingPageNumber","PrintingStyleEnvironment","Printout3D","Printout3DPreviewer","PrintPrecision","PrintTemporary","Prism","PrismBox","PrismBoxOptions","PrivateCellOptions","PrivateEvaluationOptions","PrivateFontOptions","PrivateFrontEndOptions","PrivateKey","PrivateNotebookOptions","PrivatePaths","Probability","ProbabilityDistribution","ProbabilityPlot","ProbabilityPr","ProbabilityScalePlot","ProbitModelFit","ProcessConnection","ProcessDirectory","ProcessEnvironment","Processes","ProcessEstimator","ProcessInformation","ProcessObject","ProcessParameterAssumptions","ProcessParameterQ","ProcessStateDomain","ProcessStatus","ProcessTimeDomain","Product","ProductDistribution","ProductLog","ProgressIndicator","ProgressIndicatorBox","ProgressIndicatorBoxOptions","ProgressReporting","Projection","Prolog","PromptForm","ProofObject","PropagateAborts","Properties","Property","PropertyList","PropertyValue","Proportion","Proportional","Protect","Protected","ProteinData","Pruning","PseudoInverse","PsychrometricPropertyData","PublicKey","PublisherID","PulsarData","PunctuationCharacter","Purple","Put","PutAppend","Pyramid","PyramidBox","PyramidBoxOptions","QBinomial","QFactorial","QGamma","QHypergeometricPFQ","QnDispersion","QPochhammer","QPolyGamma","QRDecomposition","QuadraticIrrationalQ","QuadraticOptimization","Quantile","QuantilePlot","Quantity","QuantityArray","QuantityDistribution","QuantityForm","QuantityMagnitude","QuantityQ","QuantityUnit","QuantityVariable","QuantityVariableCanonicalUnit","QuantityVariableDimensions","QuantityVariableIdentifier","QuantityVariablePhysicalQuantity","Quartics","QuartileDeviation","Quartiles","QuartileSkewness","Query","QuestionGenerator","QuestionInterface","QuestionObject","QuestionSelector","QueueingNetworkProcess","QueueingProcess","QueueProperties","Quiet","QuietEcho","Quit","Quotient","QuotientRemainder","RadialAxisPlot","RadialGradientFilling","RadialGradientImage","RadialityCentrality","RadicalBox","RadicalBoxOptions","RadioButton","RadioButtonBar","RadioButtonBox","RadioButtonBoxOptions","Radon","RadonTransform","RamanujanTau","RamanujanTauL","RamanujanTauTheta","RamanujanTauZ","Ramp","Random","RandomArrayLayer","RandomChoice","RandomColor","RandomComplex","RandomDate","RandomEntity","RandomFunction","RandomGeneratorState","RandomGeoPosition","RandomGraph","RandomImage","RandomInstance","RandomInteger","RandomPermutation","RandomPoint","RandomPointConfiguration","RandomPolygon","RandomPolyhedron","RandomPrime","RandomReal","RandomSample","RandomSeed","RandomSeeding","RandomTime","RandomTree","RandomVariate","RandomWalkProcess","RandomWord","Range","RangeFilter","RangeSpecification","RankedMax","RankedMin","RarerProbability","Raster","Raster3D","Raster3DBox","Raster3DBoxOptions","RasterArray","RasterBox","RasterBoxOptions","Rasterize","RasterSize","Rational","RationalExpressionQ","RationalFunctions","Rationalize","Rationals","Ratios","RawArray","RawBoxes","RawData","RawMedium","RayleighDistribution","Re","ReactionBalance","ReactionBalancedQ","ReactionPDETerm","Read","ReadByteArray","ReadLine","ReadList","ReadProtected","ReadString","Real","RealAbs","RealBlockDiagonalForm","RealDigits","RealExponent","Reals","RealSign","Reap","RebuildPacletData","RecalibrationFunction","RecognitionPrior","RecognitionThreshold","ReconstructionMesh","Record","RecordLists","RecordSeparators","Rectangle","RectangleBox","RectangleBoxOptions","RectangleChart","RectangleChart3D","RectangularRepeatingElement","RecurrenceFilter","RecurrenceTable","RecurringDigitsForm","Red","Reduce","RefBox","ReferenceLineStyle","ReferenceMarkers","ReferenceMarkerStyle","Refine","ReflectionMatrix","ReflectionTransform","Refresh","RefreshRate","Region","RegionBinarize","RegionBoundary","RegionBoundaryStyle","RegionBounds","RegionCentroid","RegionCongruent","RegionConvert","RegionDifference","RegionDilation","RegionDimension","RegionDisjoint","RegionDistance","RegionDistanceFunction","RegionEmbeddingDimension","RegionEqual","RegionErosion","RegionFillingStyle","RegionFit","RegionFunction","RegionImage","RegionIntersection","RegionMeasure","RegionMember","RegionMemberFunction","RegionMoment","RegionNearest","RegionNearestFunction","RegionPlot","RegionPlot3D","RegionProduct","RegionQ","RegionResize","RegionSimilar","RegionSize","RegionSymmetricDifference","RegionUnion","RegionWithin","RegisterExternalEvaluator","RegularExpression","Regularization","RegularlySampledQ","RegularPolygon","ReIm","ReImLabels","ReImPlot","ReImStyle","Reinstall","RelationalDatabase","RelationGraph","Release","ReleaseHold","ReliabilityDistribution","ReliefImage","ReliefPlot","RemoteAuthorizationCaching","RemoteBatchJobAbort","RemoteBatchJobObject","RemoteBatchJobs","RemoteBatchMapSubmit","RemoteBatchSubmissionEnvironment","RemoteBatchSubmit","RemoteConnect","RemoteConnectionObject","RemoteEvaluate","RemoteFile","RemoteInputFiles","RemoteKernelObject","RemoteProviderSettings","RemoteRun","RemoteRunProcess","RemovalConditions","Remove","RemoveAlphaChannel","RemoveAsynchronousTask","RemoveAudioStream","RemoveBackground","RemoveChannelListener","RemoveChannelSubscribers","Removed","RemoveDiacritics","RemoveInputStreamMethod","RemoveOutputStreamMethod","RemoveProperty","RemoveScheduledTask","RemoveUsers","RemoveVideoStream","RenameDirectory","RenameFile","RenderAll","RenderingOptions","RenewalProcess","RenkoChart","RepairMesh","Repeated","RepeatedNull","RepeatedString","RepeatedTiming","RepeatingElement","Replace","ReplaceAll","ReplaceAt","ReplaceHeldPart","ReplaceImageValue","ReplaceList","ReplacePart","ReplacePixelValue","ReplaceRepeated","ReplicateLayer","RequiredPhysicalQuantities","Resampling","ResamplingAlgorithmData","ResamplingMethod","Rescale","RescalingTransform","ResetDirectory","ResetScheduledTask","ReshapeLayer","Residue","ResidueSum","ResizeLayer","Resolve","ResolveContextAliases","ResourceAcquire","ResourceData","ResourceFunction","ResourceObject","ResourceRegister","ResourceRemove","ResourceSearch","ResourceSubmissionObject","ResourceSubmit","ResourceSystemBase","ResourceSystemPath","ResourceUpdate","ResourceVersion","ResponseForm","Rest","RestartInterval","Restricted","Resultant","ResumePacket","Return","ReturnCreatesNewCell","ReturnEntersInput","ReturnExpressionPacket","ReturnInputFormPacket","ReturnPacket","ReturnReceiptFunction","ReturnTextPacket","Reverse","ReverseApplied","ReverseBiorthogonalSplineWavelet","ReverseElement","ReverseEquilibrium","ReverseGraph","ReverseSort","ReverseSortBy","ReverseUpEquilibrium","RevolutionAxis","RevolutionPlot3D","RGBColor","RiccatiSolve","RiceDistribution","RidgeFilter","RiemannR","RiemannSiegelTheta","RiemannSiegelZ","RiemannXi","Riffle","Right","RightArrow","RightArrowBar","RightArrowLeftArrow","RightComposition","RightCosetRepresentative","RightDownTeeVector","RightDownVector","RightDownVectorBar","RightTee","RightTeeArrow","RightTeeVector","RightTriangle","RightTriangleBar","RightTriangleEqual","RightUpDownVector","RightUpTeeVector","RightUpVector","RightUpVectorBar","RightVector","RightVectorBar","RipleyK","RipleyRassonRegion","RiskAchievementImportance","RiskReductionImportance","RobustConvexOptimization","RogersTanimotoDissimilarity","RollPitchYawAngles","RollPitchYawMatrix","RomanNumeral","Root","RootApproximant","RootIntervals","RootLocusPlot","RootMeanSquare","RootOfUnityQ","RootReduce","Roots","RootSum","RootTree","Rotate","RotateLabel","RotateLeft","RotateRight","RotationAction","RotationBox","RotationBoxOptions","RotationMatrix","RotationTransform","Round","RoundImplies","RoundingRadius","Row","RowAlignments","RowBackgrounds","RowBox","RowHeights","RowLines","RowMinHeight","RowReduce","RowsEqual","RowSpacings","RSolve","RSolveValue","RudinShapiro","RudvalisGroupRu","Rule","RuleCondition","RuleDelayed","RuleForm","RulePlot","RulerUnits","RulesTree","Run","RunProcess","RunScheduledTask","RunThrough","RuntimeAttributes","RuntimeOptions","RussellRaoDissimilarity","SameAs","SameQ","SameTest","SameTestProperties","SampledEntityClass","SampleDepth","SampledSoundFunction","SampledSoundList","SampleRate","SamplingPeriod","SARIMAProcess","SARMAProcess","SASTriangle","SatelliteData","SatisfiabilityCount","SatisfiabilityInstances","SatisfiableQ","Saturday","Save","Saveable","SaveAutoDelete","SaveConnection","SaveDefinitions","SavitzkyGolayMatrix","SawtoothWave","Scale","Scaled","ScaleDivisions","ScaledMousePosition","ScaleOrigin","ScalePadding","ScaleRanges","ScaleRangeStyle","ScalingFunctions","ScalingMatrix","ScalingTransform","Scan","ScheduledTask","ScheduledTaskActiveQ","ScheduledTaskInformation","ScheduledTaskInformationData","ScheduledTaskObject","ScheduledTasks","SchurDecomposition","ScientificForm","ScientificNotationThreshold","ScorerGi","ScorerGiPrime","ScorerHi","ScorerHiPrime","ScreenRectangle","ScreenStyleEnvironment","ScriptBaselineShifts","ScriptForm","ScriptLevel","ScriptMinSize","ScriptRules","ScriptSizeMultipliers","Scrollbars","ScrollingOptions","ScrollPosition","SearchAdjustment","SearchIndexObject","SearchIndices","SearchQueryString","SearchResultObject","Sec","Sech","SechDistribution","SecondOrderConeOptimization","SectionGrouping","SectorChart","SectorChart3D","SectorOrigin","SectorSpacing","SecuredAuthenticationKey","SecuredAuthenticationKeys","SecurityCertificate","SeedRandom","Select","Selectable","SelectComponents","SelectedCells","SelectedNotebook","SelectFirst","Selection","SelectionAnimate","SelectionCell","SelectionCellCreateCell","SelectionCellDefaultStyle","SelectionCellParentStyle","SelectionCreateCell","SelectionDebuggerTag","SelectionEvaluate","SelectionEvaluateCreateCell","SelectionMove","SelectionPlaceholder","SelectWithContents","SelfLoops","SelfLoopStyle","SemanticImport","SemanticImportString","SemanticInterpretation","SemialgebraicComponentInstances","SemidefiniteOptimization","SendMail","SendMessage","Sequence","SequenceAlignment","SequenceAttentionLayer","SequenceCases","SequenceCount","SequenceFold","SequenceFoldList","SequenceForm","SequenceHold","SequenceIndicesLayer","SequenceLastLayer","SequenceMostLayer","SequencePosition","SequencePredict","SequencePredictorFunction","SequenceReplace","SequenceRestLayer","SequenceReverseLayer","SequenceSplit","Series","SeriesCoefficient","SeriesData","SeriesTermGoal","ServiceConnect","ServiceDisconnect","ServiceExecute","ServiceObject","ServiceRequest","ServiceResponse","ServiceSubmit","SessionSubmit","SessionTime","Set","SetAccuracy","SetAlphaChannel","SetAttributes","Setbacks","SetCloudDirectory","SetCookies","SetDelayed","SetDirectory","SetEnvironment","SetFileDate","SetFileFormatProperties","SetOptions","SetOptionsPacket","SetPermissions","SetPrecision","SetProperty","SetSecuredAuthenticationKey","SetSelectedNotebook","SetSharedFunction","SetSharedVariable","SetStreamPosition","SetSystemModel","SetSystemOptions","Setter","SetterBar","SetterBox","SetterBoxOptions","Setting","SetUsers","Shading","Shallow","ShannonWavelet","ShapiroWilkTest","Share","SharingList","Sharpen","ShearingMatrix","ShearingTransform","ShellRegion","ShenCastanMatrix","ShiftedGompertzDistribution","ShiftRegisterSequence","Short","ShortDownArrow","Shortest","ShortestMatch","ShortestPathFunction","ShortLeftArrow","ShortRightArrow","ShortTimeFourier","ShortTimeFourierData","ShortUpArrow","Show","ShowAutoConvert","ShowAutoSpellCheck","ShowAutoStyles","ShowCellBracket","ShowCellLabel","ShowCellTags","ShowClosedCellArea","ShowCodeAssist","ShowContents","ShowControls","ShowCursorTracker","ShowGroupOpenCloseIcon","ShowGroupOpener","ShowInvisibleCharacters","ShowPageBreaks","ShowPredictiveInterface","ShowSelection","ShowShortBoxForm","ShowSpecialCharacters","ShowStringCharacters","ShowSyntaxStyles","ShrinkingDelay","ShrinkWrapBoundingBox","SiderealTime","SiegelTheta","SiegelTukeyTest","SierpinskiCurve","SierpinskiMesh","Sign","Signature","SignedRankTest","SignedRegionDistance","SignificanceLevel","SignPadding","SignTest","SimilarityRules","SimpleGraph","SimpleGraphQ","SimplePolygonQ","SimplePolyhedronQ","Simplex","Simplify","Sin","Sinc","SinghMaddalaDistribution","SingleEvaluation","SingleLetterItalics","SingleLetterStyle","SingularValueDecomposition","SingularValueList","SingularValuePlot","SingularValues","Sinh","SinhIntegral","SinIntegral","SixJSymbol","Skeleton","SkeletonTransform","SkellamDistribution","Skewness","SkewNormalDistribution","SkinStyle","Skip","SliceContourPlot3D","SliceDensityPlot3D","SliceDistribution","SliceVectorPlot3D","Slider","Slider2D","Slider2DBox","Slider2DBoxOptions","SliderBox","SliderBoxOptions","SlideShowVideo","SlideView","Slot","SlotSequence","Small","SmallCircle","Smaller","SmithDecomposition","SmithDelayCompensator","SmithWatermanSimilarity","SmoothDensityHistogram","SmoothHistogram","SmoothHistogram3D","SmoothKernelDistribution","SmoothPointDensity","SnDispersion","Snippet","SnippetsVideo","SnubPolyhedron","SocialMediaData","Socket","SocketConnect","SocketListen","SocketListener","SocketObject","SocketOpen","SocketReadMessage","SocketReadyQ","Sockets","SocketWaitAll","SocketWaitNext","SoftmaxLayer","SokalSneathDissimilarity","SolarEclipse","SolarSystemFeatureData","SolarTime","SolidAngle","SolidBoundaryLoadValue","SolidData","SolidDisplacementCondition","SolidFixedCondition","SolidMechanicsPDEComponent","SolidMechanicsStrain","SolidMechanicsStress","SolidRegionQ","Solve","SolveAlways","SolveDelayed","SolveValues","Sort","SortBy","SortedBy","SortedEntityClass","Sound","SoundAndGraphics","SoundNote","SoundVolume","SourceLink","SourcePDETerm","Sow","Space","SpaceCurveData","SpaceForm","Spacer","Spacings","Span","SpanAdjustments","SpanCharacterRounding","SpanFromAbove","SpanFromBoth","SpanFromLeft","SpanLineThickness","SpanMaxSize","SpanMinSize","SpanningCharacters","SpanSymmetric","SparseArray","SparseArrayQ","SpatialBinnedPointData","SpatialBoundaryCorrection","SpatialEstimate","SpatialEstimatorFunction","SpatialGraphDistribution","SpatialJ","SpatialMedian","SpatialNoiseLevel","SpatialObservationRegionQ","SpatialPointData","SpatialPointSelect","SpatialRandomnessTest","SpatialTransformationLayer","SpatialTrendFunction","Speak","SpeakerMatchQ","SpearmanRankTest","SpearmanRho","SpeciesData","SpecificityGoal","SpectralLineData","Spectrogram","SpectrogramArray","Specularity","SpeechCases","SpeechInterpreter","SpeechRecognize","SpeechSynthesize","SpellingCorrection","SpellingCorrectionList","SpellingDictionaries","SpellingDictionariesPath","SpellingOptions","Sphere","SphereBox","SphereBoxOptions","SpherePoints","SphericalBesselJ","SphericalBesselY","SphericalHankelH1","SphericalHankelH2","SphericalHarmonicY","SphericalPlot3D","SphericalRegion","SphericalShell","SpheroidalEigenvalue","SpheroidalJoiningFactor","SpheroidalPS","SpheroidalPSPrime","SpheroidalQS","SpheroidalQSPrime","SpheroidalRadialFactor","SpheroidalS1","SpheroidalS1Prime","SpheroidalS2","SpheroidalS2Prime","Splice","SplicedDistribution","SplineClosed","SplineDegree","SplineKnots","SplineWeights","Split","SplitBy","SpokenString","SpotLight","Sqrt","SqrtBox","SqrtBoxOptions","Square","SquaredEuclideanDistance","SquareFreeQ","SquareIntersection","SquareMatrixQ","SquareRepeatingElement","SquaresR","SquareSubset","SquareSubsetEqual","SquareSuperset","SquareSupersetEqual","SquareUnion","SquareWave","SSSTriangle","StabilityMargins","StabilityMarginsStyle","StableDistribution","Stack","StackBegin","StackComplete","StackedDateListPlot","StackedListPlot","StackInhibit","StadiumShape","StandardAtmosphereData","StandardDeviation","StandardDeviationFilter","StandardForm","Standardize","Standardized","StandardOceanData","StandbyDistribution","Star","StarClusterData","StarData","StarGraph","StartAsynchronousTask","StartExternalSession","StartingStepSize","StartOfLine","StartOfString","StartProcess","StartScheduledTask","StartupSound","StartWebSession","StateDimensions","StateFeedbackGains","StateOutputEstimator","StateResponse","StateSpaceModel","StateSpaceRealization","StateSpaceTransform","StateTransformationLinearize","StationaryDistribution","StationaryWaveletPacketTransform","StationaryWaveletTransform","StatusArea","StatusCentrality","StepMonitor","StereochemistryElements","StieltjesGamma","StippleShading","StirlingS1","StirlingS2","StopAsynchronousTask","StoppingPowerData","StopScheduledTask","StrataVariables","StratonovichProcess","StraussHardcorePointProcess","StraussPointProcess","StreamColorFunction","StreamColorFunctionScaling","StreamDensityPlot","StreamMarkers","StreamPlot","StreamPlot3D","StreamPoints","StreamPosition","Streams","StreamScale","StreamStyle","StrictInequalities","String","StringBreak","StringByteCount","StringCases","StringContainsQ","StringCount","StringDelete","StringDrop","StringEndsQ","StringExpression","StringExtract","StringForm","StringFormat","StringFormatQ","StringFreeQ","StringInsert","StringJoin","StringLength","StringMatchQ","StringPadLeft","StringPadRight","StringPart","StringPartition","StringPosition","StringQ","StringRepeat","StringReplace","StringReplaceList","StringReplacePart","StringReverse","StringRiffle","StringRotateLeft","StringRotateRight","StringSkeleton","StringSplit","StringStartsQ","StringTake","StringTakeDrop","StringTemplate","StringToByteArray","StringToStream","StringTrim","StripBoxes","StripOnInput","StripStyleOnPaste","StripWrapperBoxes","StrokeForm","Struckthrough","StructuralImportance","StructuredArray","StructuredArrayHeadQ","StructuredSelection","StruveH","StruveL","Stub","StudentTDistribution","Style","StyleBox","StyleBoxAutoDelete","StyleData","StyleDefinitions","StyleForm","StyleHints","StyleKeyMapping","StyleMenuListing","StyleNameDialogSettings","StyleNames","StylePrint","StyleSheetPath","Subdivide","Subfactorial","Subgraph","SubMinus","SubPlus","SubresultantPolynomialRemainders","SubresultantPolynomials","Subresultants","Subscript","SubscriptBox","SubscriptBoxOptions","Subscripted","Subsequences","Subset","SubsetCases","SubsetCount","SubsetEqual","SubsetMap","SubsetPosition","SubsetQ","SubsetReplace","Subsets","SubStar","SubstitutionSystem","Subsuperscript","SubsuperscriptBox","SubsuperscriptBoxOptions","SubtitleEncoding","SubtitleTrackSelection","Subtract","SubtractFrom","SubtractSides","SubValues","Succeeds","SucceedsEqual","SucceedsSlantEqual","SucceedsTilde","Success","SuchThat","Sum","SumConvergence","SummationLayer","Sunday","SunPosition","Sunrise","Sunset","SuperDagger","SuperMinus","SupernovaData","SuperPlus","Superscript","SuperscriptBox","SuperscriptBoxOptions","Superset","SupersetEqual","SuperStar","Surd","SurdForm","SurfaceAppearance","SurfaceArea","SurfaceColor","SurfaceData","SurfaceGraphics","SurvivalDistribution","SurvivalFunction","SurvivalModel","SurvivalModelFit","SuspendPacket","SuzukiDistribution","SuzukiGroupSuz","SwatchLegend","Switch","Symbol","SymbolName","SymletWavelet","Symmetric","SymmetricDifference","SymmetricGroup","SymmetricKey","SymmetricMatrixQ","SymmetricPolynomial","SymmetricReduction","Symmetrize","SymmetrizedArray","SymmetrizedArrayRules","SymmetrizedDependentComponents","SymmetrizedIndependentComponents","SymmetrizedReplacePart","SynchronousInitialization","SynchronousUpdating","Synonyms","Syntax","SyntaxForm","SyntaxInformation","SyntaxLength","SyntaxPacket","SyntaxQ","SynthesizeMissingValues","SystemCredential","SystemCredentialData","SystemCredentialKey","SystemCredentialKeys","SystemCredentialStoreObject","SystemDialogInput","SystemException","SystemGet","SystemHelpPath","SystemInformation","SystemInformationData","SystemInstall","SystemModel","SystemModeler","SystemModelExamples","SystemModelLinearize","SystemModelMeasurements","SystemModelParametricSimulate","SystemModelPlot","SystemModelProgressReporting","SystemModelReliability","SystemModels","SystemModelSimulate","SystemModelSimulateSensitivity","SystemModelSimulationData","SystemOpen","SystemOptions","SystemProcessData","SystemProcesses","SystemsConnectionsModel","SystemsModelControllerData","SystemsModelDelay","SystemsModelDelayApproximate","SystemsModelDelete","SystemsModelDimensions","SystemsModelExtract","SystemsModelFeedbackConnect","SystemsModelLabels","SystemsModelLinearity","SystemsModelMerge","SystemsModelOrder","SystemsModelParallelConnect","SystemsModelSeriesConnect","SystemsModelStateFeedbackConnect","SystemsModelVectorRelativeOrders","SystemStub","SystemTest","Tab","TabFilling","Table","TableAlignments","TableDepth","TableDirections","TableForm","TableHeadings","TableSpacing","TableView","TableViewBox","TableViewBoxAlignment","TableViewBoxBackground","TableViewBoxHeaders","TableViewBoxItemSize","TableViewBoxItemStyle","TableViewBoxOptions","TabSpacings","TabView","TabViewBox","TabViewBoxOptions","TagBox","TagBoxNote","TagBoxOptions","TaggingRules","TagSet","TagSetDelayed","TagStyle","TagUnset","Take","TakeDrop","TakeLargest","TakeLargestBy","TakeList","TakeSmallest","TakeSmallestBy","TakeWhile","Tally","Tan","Tanh","TargetDevice","TargetFunctions","TargetSystem","TargetUnits","TaskAbort","TaskExecute","TaskObject","TaskRemove","TaskResume","Tasks","TaskSuspend","TaskWait","TautologyQ","TelegraphProcess","TemplateApply","TemplateArgBox","TemplateBox","TemplateBoxOptions","TemplateEvaluate","TemplateExpression","TemplateIf","TemplateObject","TemplateSequence","TemplateSlot","TemplateSlotSequence","TemplateUnevaluated","TemplateVerbatim","TemplateWith","TemporalData","TemporalRegularity","Temporary","TemporaryVariable","TensorContract","TensorDimensions","TensorExpand","TensorProduct","TensorQ","TensorRank","TensorReduce","TensorSymmetry","TensorTranspose","TensorWedge","TerminatedEvaluation","TernaryListPlot","TernaryPlotCorners","TestID","TestReport","TestReportObject","TestResultObject","Tetrahedron","TetrahedronBox","TetrahedronBoxOptions","TeXForm","TeXSave","Text","Text3DBox","Text3DBoxOptions","TextAlignment","TextBand","TextBoundingBox","TextBox","TextCases","TextCell","TextClipboardType","TextContents","TextData","TextElement","TextForm","TextGrid","TextJustification","TextLine","TextPacket","TextParagraph","TextPosition","TextRecognize","TextSearch","TextSearchReport","TextSentences","TextString","TextStructure","TextStyle","TextTranslation","Texture","TextureCoordinateFunction","TextureCoordinateScaling","TextWords","Therefore","ThermodynamicData","ThermometerGauge","Thick","Thickness","Thin","Thinning","ThisLink","ThomasPointProcess","ThompsonGroupTh","Thread","Threaded","ThreadingLayer","ThreeJSymbol","Threshold","Through","Throw","ThueMorse","Thumbnail","Thursday","TickDirection","TickLabelOrientation","TickLabelPositioning","TickLabels","TickLengths","TickPositions","Ticks","TicksStyle","TideData","Tilde","TildeEqual","TildeFullEqual","TildeTilde","TimeConstrained","TimeConstraint","TimeDirection","TimeFormat","TimeGoal","TimelinePlot","TimeObject","TimeObjectQ","TimeRemaining","Times","TimesBy","TimeSeries","TimeSeriesAggregate","TimeSeriesForecast","TimeSeriesInsert","TimeSeriesInvertibility","TimeSeriesMap","TimeSeriesMapThread","TimeSeriesModel","TimeSeriesModelFit","TimeSeriesResample","TimeSeriesRescale","TimeSeriesShift","TimeSeriesThread","TimeSeriesWindow","TimeSystem","TimeSystemConvert","TimeUsed","TimeValue","TimeWarpingCorrespondence","TimeWarpingDistance","TimeZone","TimeZoneConvert","TimeZoneOffset","Timing","Tiny","TitleGrouping","TitsGroupT","ToBoxes","ToCharacterCode","ToColor","ToContinuousTimeModel","ToDate","Today","ToDiscreteTimeModel","ToEntity","ToeplitzMatrix","ToExpression","ToFileName","Together","Toggle","ToggleFalse","Toggler","TogglerBar","TogglerBox","TogglerBoxOptions","ToHeldExpression","ToInvertibleTimeSeries","TokenWords","Tolerance","ToLowerCase","Tomorrow","ToNumberField","TooBig","Tooltip","TooltipBox","TooltipBoxOptions","TooltipDelay","TooltipStyle","ToonShading","Top","TopHatTransform","ToPolarCoordinates","TopologicalSort","ToRadicals","ToRawPointer","ToRules","Torus","TorusGraph","ToSphericalCoordinates","ToString","Total","TotalHeight","TotalLayer","TotalVariationFilter","TotalWidth","TouchPosition","TouchscreenAutoZoom","TouchscreenControlPlacement","ToUpperCase","TourVideo","Tr","Trace","TraceAbove","TraceAction","TraceBackward","TraceDepth","TraceDialog","TraceForward","TraceInternal","TraceLevel","TraceOff","TraceOn","TraceOriginal","TracePrint","TraceScan","TrackCellChangeTimes","TrackedSymbols","TrackingFunction","TracyWidomDistribution","TradingChart","TraditionalForm","TraditionalFunctionNotation","TraditionalNotation","TraditionalOrder","TrainImageContentDetector","TrainingProgressCheckpointing","TrainingProgressFunction","TrainingProgressMeasurements","TrainingProgressReporting","TrainingStoppingCriterion","TrainingUpdateSchedule","TrainTextContentDetector","TransferFunctionCancel","TransferFunctionExpand","TransferFunctionFactor","TransferFunctionModel","TransferFunctionPoles","TransferFunctionTransform","TransferFunctionZeros","TransformationClass","TransformationFunction","TransformationFunctions","TransformationMatrix","TransformedDistribution","TransformedField","TransformedProcess","TransformedRegion","TransitionDirection","TransitionDuration","TransitionEffect","TransitiveClosureGraph","TransitiveReductionGraph","Translate","TranslationOptions","TranslationTransform","Transliterate","Transparent","TransparentColor","Transpose","TransposeLayer","TrapEnterKey","TrapSelection","TravelDirections","TravelDirectionsData","TravelDistance","TravelDistanceList","TravelMethod","TravelTime","Tree","TreeCases","TreeChildren","TreeCount","TreeData","TreeDelete","TreeDepth","TreeElementCoordinates","TreeElementLabel","TreeElementLabelFunction","TreeElementLabelStyle","TreeElementShape","TreeElementShapeFunction","TreeElementSize","TreeElementSizeFunction","TreeElementStyle","TreeElementStyleFunction","TreeExpression","TreeExtract","TreeFold","TreeForm","TreeGraph","TreeGraphQ","TreeInsert","TreeLayout","TreeLeafCount","TreeLeafQ","TreeLeaves","TreeLevel","TreeMap","TreeMapAt","TreeOutline","TreePlot","TreePosition","TreeQ","TreeReplacePart","TreeRules","TreeScan","TreeSelect","TreeSize","TreeTraversalOrder","TrendStyle","Triangle","TriangleCenter","TriangleConstruct","TriangleMeasurement","TriangleWave","TriangularDistribution","TriangulateMesh","Trig","TrigExpand","TrigFactor","TrigFactorList","Trigger","TrigReduce","TrigToExp","TrimmedMean","TrimmedVariance","TropicalStormData","True","TrueQ","TruncatedDistribution","TruncatedPolyhedron","TsallisQExponentialDistribution","TsallisQGaussianDistribution","TTest","Tube","TubeBezierCurveBox","TubeBezierCurveBoxOptions","TubeBox","TubeBoxOptions","TubeBSplineCurveBox","TubeBSplineCurveBoxOptions","Tuesday","TukeyLambdaDistribution","TukeyWindow","TunnelData","Tuples","TuranGraph","TuringMachine","TuttePolynomial","TwoWayRule","Typed","TypeDeclaration","TypeEvaluate","TypeHint","TypeOf","TypeSpecifier","UnateQ","Uncompress","UnconstrainedParameters","Undefined","UnderBar","Underflow","Underlined","Underoverscript","UnderoverscriptBox","UnderoverscriptBoxOptions","Underscript","UnderscriptBox","UnderscriptBoxOptions","UnderseaFeatureData","UndirectedEdge","UndirectedGraph","UndirectedGraphQ","UndoOptions","UndoTrackedVariables","Unequal","UnequalTo","Unevaluated","UniformDistribution","UniformGraphDistribution","UniformPolyhedron","UniformSumDistribution","Uninstall","Union","UnionedEntityClass","UnionPlus","Unique","UniqueElements","UnitaryMatrixQ","UnitBox","UnitConvert","UnitDimensions","Unitize","UnitRootTest","UnitSimplify","UnitStep","UnitSystem","UnitTriangle","UnitVector","UnitVectorLayer","UnityDimensions","UniverseModelData","UniversityData","UnixTime","UnlabeledTree","UnmanageObject","Unprotect","UnregisterExternalEvaluator","UnsameQ","UnsavedVariables","Unset","UnsetShared","Until","UntrackedVariables","Up","UpArrow","UpArrowBar","UpArrowDownArrow","Update","UpdateDynamicObjects","UpdateDynamicObjectsSynchronous","UpdateInterval","UpdatePacletSites","UpdateSearchIndex","UpDownArrow","UpEquilibrium","UpperCaseQ","UpperLeftArrow","UpperRightArrow","UpperTriangularize","UpperTriangularMatrix","UpperTriangularMatrixQ","Upsample","UpSet","UpSetDelayed","UpTee","UpTeeArrow","UpTo","UpValues","URL","URLBuild","URLDecode","URLDispatcher","URLDownload","URLDownloadSubmit","URLEncode","URLExecute","URLExpand","URLFetch","URLFetchAsynchronous","URLParse","URLQueryDecode","URLQueryEncode","URLRead","URLResponseTime","URLSave","URLSaveAsynchronous","URLShorten","URLSubmit","UseEmbeddedLibrary","UseGraphicsRange","UserDefinedWavelet","Using","UsingFrontEnd","UtilityFunction","V2Get","ValenceErrorHandling","ValenceFilling","ValidationLength","ValidationSet","ValueBox","ValueBoxOptions","ValueDimensions","ValueForm","ValuePreprocessingFunction","ValueQ","Values","ValuesData","VandermondeMatrix","Variables","Variance","VarianceEquivalenceTest","VarianceEstimatorFunction","VarianceGammaDistribution","VarianceGammaPointProcess","VarianceTest","VariogramFunction","VariogramModel","VectorAngle","VectorAround","VectorAspectRatio","VectorColorFunction","VectorColorFunctionScaling","VectorDensityPlot","VectorDisplacementPlot","VectorDisplacementPlot3D","VectorGlyphData","VectorGreater","VectorGreaterEqual","VectorLess","VectorLessEqual","VectorMarkers","VectorPlot","VectorPlot3D","VectorPoints","VectorQ","VectorRange","Vectors","VectorScale","VectorScaling","VectorSizes","VectorStyle","Vee","Verbatim","Verbose","VerificationTest","VerifyConvergence","VerifyDerivedKey","VerifyDigitalSignature","VerifyFileSignature","VerifyInterpretation","VerifySecurityCertificates","VerifySolutions","VerifyTestAssumptions","VersionedPreferences","VertexAdd","VertexCapacity","VertexChromaticNumber","VertexColors","VertexComponent","VertexConnectivity","VertexContract","VertexCoordinateRules","VertexCoordinates","VertexCorrelationSimilarity","VertexCosineSimilarity","VertexCount","VertexCoverQ","VertexDataCoordinates","VertexDegree","VertexDelete","VertexDiceSimilarity","VertexEccentricity","VertexInComponent","VertexInComponentGraph","VertexInDegree","VertexIndex","VertexJaccardSimilarity","VertexLabeling","VertexLabels","VertexLabelStyle","VertexList","VertexNormals","VertexOutComponent","VertexOutComponentGraph","VertexOutDegree","VertexQ","VertexRenderingFunction","VertexReplace","VertexShape","VertexShapeFunction","VertexSize","VertexStyle","VertexTextureCoordinates","VertexTransitiveGraphQ","VertexWeight","VertexWeightedGraphQ","Vertical","VerticalBar","VerticalForm","VerticalGauge","VerticalSeparator","VerticalSlider","VerticalTilde","Video","VideoCapture","VideoCombine","VideoDelete","VideoEncoding","VideoExtractFrames","VideoFrameList","VideoFrameMap","VideoGenerator","VideoInsert","VideoIntervals","VideoJoin","VideoMap","VideoMapList","VideoMapTimeSeries","VideoPadding","VideoPause","VideoPlay","VideoQ","VideoRecord","VideoReplace","VideoScreenCapture","VideoSplit","VideoStop","VideoStream","VideoStreams","VideoTimeStretch","VideoTrackSelection","VideoTranscode","VideoTransparency","VideoTrim","ViewAngle","ViewCenter","ViewMatrix","ViewPoint","ViewPointSelectorSettings","ViewPort","ViewProjection","ViewRange","ViewVector","ViewVertical","VirtualGroupData","Visible","VisibleCell","VoiceStyleData","VoigtDistribution","VolcanoData","Volume","VonMisesDistribution","VoronoiMesh","WaitAll","WaitAsynchronousTask","WaitNext","WaitUntil","WakebyDistribution","WalleniusHypergeometricDistribution","WaringYuleDistribution","WarpingCorrespondence","WarpingDistance","WatershedComponents","WatsonUSquareTest","WattsStrogatzGraphDistribution","WaveletBestBasis","WaveletFilterCoefficients","WaveletImagePlot","WaveletListPlot","WaveletMapIndexed","WaveletMatrixPlot","WaveletPhi","WaveletPsi","WaveletScale","WaveletScalogram","WaveletThreshold","WavePDEComponent","WeaklyConnectedComponents","WeaklyConnectedGraphComponents","WeaklyConnectedGraphQ","WeakStationarity","WeatherData","WeatherForecastData","WebAudioSearch","WebColumn","WebElementObject","WeberE","WebExecute","WebImage","WebImageSearch","WebItem","WebPageMetaInformation","WebRow","WebSearch","WebSessionObject","WebSessions","WebWindowObject","Wedge","Wednesday","WeibullDistribution","WeierstrassE1","WeierstrassE2","WeierstrassE3","WeierstrassEta1","WeierstrassEta2","WeierstrassEta3","WeierstrassHalfPeriods","WeierstrassHalfPeriodW1","WeierstrassHalfPeriodW2","WeierstrassHalfPeriodW3","WeierstrassInvariantG2","WeierstrassInvariantG3","WeierstrassInvariants","WeierstrassP","WeierstrassPPrime","WeierstrassSigma","WeierstrassZeta","WeightedAdjacencyGraph","WeightedAdjacencyMatrix","WeightedData","WeightedGraphQ","Weights","WelchWindow","WheelGraph","WhenEvent","Which","While","White","WhiteNoiseProcess","WhitePoint","Whitespace","WhitespaceCharacter","WhittakerM","WhittakerW","WholeCellGroupOpener","WienerFilter","WienerProcess","WignerD","WignerSemicircleDistribution","WikidataData","WikidataSearch","WikipediaData","WikipediaSearch","WilksW","WilksWTest","WindDirectionData","WindingCount","WindingPolygon","WindowClickSelect","WindowElements","WindowFloating","WindowFrame","WindowFrameElements","WindowMargins","WindowMovable","WindowOpacity","WindowPersistentStyles","WindowSelected","WindowSize","WindowStatusArea","WindowTitle","WindowToolbars","WindowWidth","WindSpeedData","WindVectorData","WinsorizedMean","WinsorizedVariance","WishartMatrixDistribution","With","WithCleanup","WithLock","WolframAlpha","WolframAlphaDate","WolframAlphaQuantity","WolframAlphaResult","WolframCloudSettings","WolframLanguageData","Word","WordBoundary","WordCharacter","WordCloud","WordCount","WordCounts","WordData","WordDefinition","WordFrequency","WordFrequencyData","WordList","WordOrientation","WordSearch","WordSelectionFunction","WordSeparators","WordSpacings","WordStem","WordTranslation","WorkingPrecision","WrapAround","Write","WriteLine","WriteString","Wronskian","XMLElement","XMLObject","XMLTemplate","Xnor","Xor","XYZColor","Yellow","Yesterday","YuleDissimilarity","ZernikeR","ZeroSymmetric","ZeroTest","ZeroWidthTimes","Zeta","ZetaZero","ZIPCodeData","ZipfDistribution","ZoomCenter","ZoomFactor","ZTest","ZTransform","$Aborted","$ActivationGroupID","$ActivationKey","$ActivationUserRegistered","$AddOnsDirectory","$AllowDataUpdates","$AllowExternalChannelFunctions","$AllowInternet","$AssertFunction","$Assumptions","$AsynchronousTask","$AudioDecoders","$AudioEncoders","$AudioInputDevices","$AudioOutputDevices","$BaseDirectory","$BasePacletsDirectory","$BatchInput","$BatchOutput","$BlockchainBase","$BoxForms","$ByteOrdering","$CacheBaseDirectory","$Canceled","$ChannelBase","$CharacterEncoding","$CharacterEncodings","$CloudAccountName","$CloudBase","$CloudConnected","$CloudConnection","$CloudCreditsAvailable","$CloudEvaluation","$CloudExpressionBase","$CloudObjectNameFormat","$CloudObjectURLType","$CloudRootDirectory","$CloudSymbolBase","$CloudUserID","$CloudUserUUID","$CloudVersion","$CloudVersionNumber","$CloudWolframEngineVersionNumber","$CommandLine","$CompilationTarget","$CompilerEnvironment","$ConditionHold","$ConfiguredKernels","$Context","$ContextAliases","$ContextPath","$ControlActiveSetting","$Cookies","$CookieStore","$CreationDate","$CryptographicEllipticCurveNames","$CurrentLink","$CurrentTask","$CurrentWebSession","$DataStructures","$DateStringFormat","$DefaultAudioInputDevice","$DefaultAudioOutputDevice","$DefaultFont","$DefaultFrontEnd","$DefaultImagingDevice","$DefaultKernels","$DefaultLocalBase","$DefaultLocalKernel","$DefaultMailbox","$DefaultNetworkInterface","$DefaultPath","$DefaultProxyRules","$DefaultRemoteBatchSubmissionEnvironment","$DefaultRemoteKernel","$DefaultSystemCredentialStore","$Display","$DisplayFunction","$DistributedContexts","$DynamicEvaluation","$Echo","$EmbedCodeEnvironments","$EmbeddableServices","$EntityStores","$Epilog","$EvaluationCloudBase","$EvaluationCloudObject","$EvaluationEnvironment","$ExportFormats","$ExternalIdentifierTypes","$ExternalStorageBase","$Failed","$FinancialDataSource","$FontFamilies","$FormatType","$FrontEnd","$FrontEndSession","$GeneratedAssetLocation","$GeoEntityTypes","$GeoLocation","$GeoLocationCity","$GeoLocationCountry","$GeoLocationPrecision","$GeoLocationSource","$HistoryLength","$HomeDirectory","$HTMLExportRules","$HTTPCookies","$HTTPRequest","$IgnoreEOF","$ImageFormattingWidth","$ImageResolution","$ImagingDevice","$ImagingDevices","$ImportFormats","$IncomingMailSettings","$InitialDirectory","$Initialization","$InitializationContexts","$Input","$InputFileName","$InputStreamMethods","$Inspector","$InstallationDate","$InstallationDirectory","$InterfaceEnvironment","$InterpreterTypes","$IterationLimit","$KernelCount","$KernelID","$Language","$LaunchDirectory","$LibraryPath","$LicenseExpirationDate","$LicenseID","$LicenseProcesses","$LicenseServer","$LicenseSubprocesses","$LicenseType","$Line","$Linked","$LinkSupported","$LoadedFiles","$LocalBase","$LocalSymbolBase","$MachineAddresses","$MachineDomain","$MachineDomains","$MachineEpsilon","$MachineID","$MachineName","$MachinePrecision","$MachineType","$MaxDisplayedChildren","$MaxExtraPrecision","$MaxLicenseProcesses","$MaxLicenseSubprocesses","$MaxMachineNumber","$MaxNumber","$MaxPiecewiseCases","$MaxPrecision","$MaxRootDegree","$MessageGroups","$MessageList","$MessagePrePrint","$Messages","$MinMachineNumber","$MinNumber","$MinorReleaseNumber","$MinPrecision","$MobilePhone","$ModuleNumber","$NetworkConnected","$NetworkInterfaces","$NetworkLicense","$NewMessage","$NewSymbol","$NotebookInlineStorageLimit","$Notebooks","$NoValue","$NumberMarks","$Off","$OperatingSystem","$Output","$OutputForms","$OutputSizeLimit","$OutputStreamMethods","$Packages","$ParentLink","$ParentProcessID","$PasswordFile","$PatchLevelID","$Path","$PathnameSeparator","$PerformanceGoal","$Permissions","$PermissionsGroupBase","$PersistenceBase","$PersistencePath","$PipeSupported","$PlotTheme","$Post","$Pre","$PreferencesDirectory","$PreInitialization","$PrePrint","$PreRead","$PrintForms","$PrintLiteral","$Printout3DPreviewer","$ProcessID","$ProcessorCount","$ProcessorType","$ProductInformation","$ProgramName","$ProgressReporting","$PublisherID","$RandomGeneratorState","$RandomState","$RecursionLimit","$RegisteredDeviceClasses","$RegisteredUserName","$ReleaseNumber","$RequesterAddress","$RequesterCloudUserID","$RequesterCloudUserUUID","$RequesterWolframID","$RequesterWolframUUID","$ResourceSystemBase","$ResourceSystemPath","$RootDirectory","$ScheduledTask","$ScriptCommandLine","$ScriptInputString","$SecuredAuthenticationKeyTokens","$ServiceCreditsAvailable","$Services","$SessionID","$SetParentLink","$SharedFunctions","$SharedVariables","$SoundDisplay","$SoundDisplayFunction","$SourceLink","$SSHAuthentication","$SubtitleDecoders","$SubtitleEncoders","$SummaryBoxDataSizeLimit","$SuppressInputFormHeads","$SynchronousEvaluation","$SyntaxHandler","$System","$SystemCharacterEncoding","$SystemCredentialStore","$SystemID","$SystemMemory","$SystemShell","$SystemTimeZone","$SystemWordLength","$TargetSystems","$TemplatePath","$TemporaryDirectory","$TemporaryPrefix","$TestFileName","$TextStyle","$TimedOut","$TimeUnit","$TimeZone","$TimeZoneEntity","$TopDirectory","$TraceOff","$TraceOn","$TracePattern","$TracePostAction","$TracePreAction","$UnitSystem","$Urgent","$UserAddOnsDirectory","$UserAgentLanguages","$UserAgentMachine","$UserAgentName","$UserAgentOperatingSystem","$UserAgentString","$UserAgentVersion","$UserBaseDirectory","$UserBasePacletsDirectory","$UserDocumentsDirectory","$Username","$UserName","$UserURLBase","$Version","$VersionNumber","$VideoDecoders","$VideoEncoders","$VoiceStyles","$WolframDocumentsDirectory","$WolframID","$WolframUUID"];function e(n){const a=n.regex,r=/([2-9]|[1-2]\\d|[3][0-5])\\^\\^/,i=/(\\w*\\.\\w+|\\w+\\.\\w*|\\w+)/,s=/(\\d*\\.\\d+|\\d+\\.\\d*|\\d+)/,o=a.either(a.concat(r,i),s),_=/\`\`[+-]?(\\d*\\.\\d+|\\d+\\.\\d*|\\d+)/,l=/\`([+-]?(\\d*\\.\\d+|\\d+\\.\\d*|\\d+))?/,c=a.either(_,l),d=/\\*\\^[+-]?\\d+/,p={className:"number",relevance:0,begin:a.concat(o,a.optional(c),a.optional(d))},E=/[a-zA-Z$][a-zA-Z0-9$]*/,g=new Set(t),S={variants:[{className:"builtin-symbol",begin:E,"on:begin":(M,y)=>{g.has(M[0])||y.ignoreMatch()}},{className:"symbol",relevance:0,begin:E}]},T={className:"named-character",begin:/\\\\\\[[$a-zA-Z][$a-zA-Z0-9]+\\]/},R={className:"operator",relevance:0,begin:/[+\\-*/,;.:@~=><&|_\`'^?!%]+/},f={className:"pattern",relevance:0,begin:/([a-zA-Z$][a-zA-Z0-9$]*)?_+([a-zA-Z$][a-zA-Z0-9$]*)?/},A={className:"slot",relevance:0,begin:/#[a-zA-Z$][a-zA-Z0-9$]*|#+[0-9]?/},N={className:"brace",relevance:0,begin:/[[\\](){}]/},C={className:"message-name",relevance:0,begin:a.concat("::",E)};return{name:"Mathematica",aliases:["mma","wl"],classNameAliases:{brace:"punctuation",pattern:"type",slot:"type",symbol:"variable","named-character":"variable","builtin-symbol":"built_in","message-name":"string"},contains:[n.COMMENT(/\\(\\*/,/\\*\\)/,{contains:["self"]}),f,A,C,S,T,n.QUOTE_STRING_MODE,p,R,N]}}return Sa=e,Sa}var Ta,os;function Cd(){if(os)return Ta;os=1;function t(e){const n="('|\\\\.')+",a={relevance:0,contains:[{begin:n}]};return{name:"Matlab",keywords:{keyword:"arguments break case catch classdef continue else elseif end enumeration events for function global if methods otherwise parfor persistent properties return spmd switch try while",built_in:"sin sind sinh asin asind asinh cos cosd cosh acos acosd acosh tan tand tanh atan atand atan2 atanh sec secd sech asec asecd asech csc cscd csch acsc acscd acsch cot cotd coth acot acotd acoth hypot exp expm1 log log1p log10 log2 pow2 realpow reallog realsqrt sqrt nthroot nextpow2 abs angle complex conj imag real unwrap isreal cplxpair fix floor ceil round mod rem sign airy besselj bessely besselh besseli besselk beta betainc betaln ellipj ellipke erf erfc erfcx erfinv expint gamma gammainc gammaln psi legendre cross dot factor isprime primes gcd lcm rat rats perms nchoosek factorial cart2sph cart2pol pol2cart sph2cart hsv2rgb rgb2hsv zeros ones eye repmat rand randn linspace logspace freqspace meshgrid accumarray size length ndims numel disp isempty isequal isequalwithequalnans cat reshape diag blkdiag tril triu fliplr flipud flipdim rot90 find sub2ind ind2sub bsxfun ndgrid permute ipermute shiftdim circshift squeeze isscalar isvector ans eps realmax realmin pi i|0 inf nan isnan isinf isfinite j|0 why compan gallery hadamard hankel hilb invhilb magic pascal rosser toeplitz vander wilkinson max min nanmax nanmin mean nanmean type table readtable writetable sortrows sort figure plot plot3 scatter scatter3 cellfun legend intersect ismember procrustes hold num2cell "},illegal:'(//|"|#|/\\\\*|\\\\s+/\\\\w+)',contains:[{className:"function",beginKeywords:"function",end:"$",contains:[e.UNDERSCORE_TITLE_MODE,{className:"params",variants:[{begin:"\\\\(",end:"\\\\)"},{begin:"\\\\[",end:"\\\\]"}]}]},{className:"built_in",begin:/true|false/,relevance:0,starts:a},{begin:"[a-zA-Z][a-zA-Z_0-9]*"+n,relevance:0},{className:"number",begin:e.C_NUMBER_RE,relevance:0,starts:a},{className:"string",begin:"'",end:"'",contains:[{begin:"''"}]},{begin:/\\]|\\}|\\)/,relevance:0,starts:a},{className:"string",begin:'"',end:'"',contains:[{begin:'""'}],starts:a},e.COMMENT("^\\\\s*%\\\\{\\\\s*$","^\\\\s*%\\\\}\\\\s*$"),e.COMMENT("%","$")]}}return Ta=t,Ta}var ba,ss;function Nd(){if(ss)return ba;ss=1;function t(e){return{name:"Maxima",keywords:{$pattern:"[A-Za-z_%][0-9A-Za-z_%]*",keyword:"if then else elseif for thru do while unless step in and or not",literal:"true false unknown inf minf ind und %e %i %pi %phi %gamma",built_in:" abasep abs absint absolute_real_time acos acosh acot acoth acsc acsch activate addcol add_edge add_edges addmatrices addrow add_vertex add_vertices adjacency_matrix adjoin adjoint af agd airy airy_ai airy_bi airy_dai airy_dbi algsys alg_type alias allroots alphacharp alphanumericp amortization %and annuity_fv annuity_pv antid antidiff AntiDifference append appendfile apply apply1 apply2 applyb1 apropos args arit_amortization arithmetic arithsum array arrayapply arrayinfo arraymake arraysetapply ascii asec asech asin asinh askinteger asksign assoc assoc_legendre_p assoc_legendre_q assume assume_external_byte_order asympa at atan atan2 atanh atensimp atom atvalue augcoefmatrix augmented_lagrangian_method av average_degree backtrace bars barsplot barsplot_description base64 base64_decode bashindices batch batchload bc2 bdvac belln benefit_cost bern bernpoly bernstein_approx bernstein_expand bernstein_poly bessel bessel_i bessel_j bessel_k bessel_simplify bessel_y beta beta_incomplete beta_incomplete_generalized beta_incomplete_regularized bezout bfallroots bffac bf_find_root bf_fmin_cobyla bfhzeta bfloat bfloatp bfpsi bfpsi0 bfzeta biconnected_components bimetric binomial bipartition block blockmatrixp bode_gain bode_phase bothcoef box boxplot boxplot_description break bug_report build_info|10 buildq build_sample burn cabs canform canten cardinality carg cartan cartesian_product catch cauchy_matrix cbffac cdf_bernoulli cdf_beta cdf_binomial cdf_cauchy cdf_chi2 cdf_continuous_uniform cdf_discrete_uniform cdf_exp cdf_f cdf_gamma cdf_general_finite_discrete cdf_geometric cdf_gumbel cdf_hypergeometric cdf_laplace cdf_logistic cdf_lognormal cdf_negative_binomial cdf_noncentral_chi2 cdf_noncentral_student_t cdf_normal cdf_pareto cdf_poisson cdf_rank_sum cdf_rayleigh cdf_signed_rank cdf_student_t cdf_weibull cdisplay ceiling central_moment cequal cequalignore cf cfdisrep cfexpand cgeodesic cgreaterp cgreaterpignore changename changevar chaosgame charat charfun charfun2 charlist charp charpoly chdir chebyshev_t chebyshev_u checkdiv check_overlaps chinese cholesky christof chromatic_index chromatic_number cint circulant_graph clear_edge_weight clear_rules clear_vertex_label clebsch_gordan clebsch_graph clessp clesspignore close closefile cmetric coeff coefmatrix cograd col collapse collectterms columnop columnspace columnswap columnvector combination combine comp2pui compare compfile compile compile_file complement_graph complete_bipartite_graph complete_graph complex_number_p components compose_functions concan concat conjugate conmetderiv connected_components connect_vertices cons constant constantp constituent constvalue cont2part content continuous_freq contortion contour_plot contract contract_edge contragrad contrib_ode convert coord copy copy_file copy_graph copylist copymatrix cor cos cosh cot coth cov cov1 covdiff covect covers crc24sum create_graph create_list csc csch csetup cspline ctaylor ct_coordsys ctransform ctranspose cube_graph cuboctahedron_graph cunlisp cv cycle_digraph cycle_graph cylindrical days360 dblint deactivate declare declare_constvalue declare_dimensions declare_fundamental_dimensions declare_fundamental_units declare_qty declare_translated declare_unit_conversion declare_units declare_weights decsym defcon define define_alt_display define_variable defint defmatch defrule defstruct deftaylor degree_sequence del delete deleten delta demo demoivre denom depends derivdegree derivlist describe desolve determinant dfloat dgauss_a dgauss_b dgeev dgemm dgeqrf dgesv dgesvd diag diagmatrix diag_matrix diagmatrixp diameter diff digitcharp dimacs_export dimacs_import dimension dimensionless dimensions dimensions_as_list direct directory discrete_freq disjoin disjointp disolate disp dispcon dispform dispfun dispJordan display disprule dispterms distrib divide divisors divsum dkummer_m dkummer_u dlange dodecahedron_graph dotproduct dotsimp dpart draw draw2d draw3d drawdf draw_file draw_graph dscalar echelon edge_coloring edge_connectivity edges eigens_by_jacobi eigenvalues eigenvectors eighth einstein eivals eivects elapsed_real_time elapsed_run_time ele2comp ele2polynome ele2pui elem elementp elevation_grid elim elim_allbut eliminate eliminate_using ellipse elliptic_e elliptic_ec elliptic_eu elliptic_f elliptic_kc elliptic_pi ematrix empty_graph emptyp endcons entermatrix entertensor entier equal equalp equiv_classes erf erfc erf_generalized erfi errcatch error errormsg errors euler ev eval_string evenp every evolution evolution2d evundiff example exp expand expandwrt expandwrt_factored expint expintegral_chi expintegral_ci expintegral_e expintegral_e1 expintegral_ei expintegral_e_simplify expintegral_li expintegral_shi expintegral_si explicit explose exponentialize express expt exsec extdiff extract_linear_equations extremal_subset ezgcd %f f90 facsum factcomb factor factorfacsum factorial factorout factorsum facts fast_central_elements fast_linsolve fasttimes featurep fernfale fft fib fibtophi fifth filename_merge file_search file_type fillarray findde find_root find_root_abs find_root_error find_root_rel first fix flatten flength float floatnump floor flower_snark flush flush1deriv flushd flushnd flush_output fmin_cobyla forget fortran fourcos fourexpand fourier fourier_elim fourint fourintcos fourintsin foursimp foursin fourth fposition frame_bracket freeof freshline fresnel_c fresnel_s from_adjacency_matrix frucht_graph full_listify fullmap fullmapl fullratsimp fullratsubst fullsetify funcsolve fundamental_dimensions fundamental_units fundef funmake funp fv g0 g1 gamma gamma_greek gamma_incomplete gamma_incomplete_generalized gamma_incomplete_regularized gauss gauss_a gauss_b gaussprob gcd gcdex gcdivide gcfac gcfactor gd generalized_lambert_w genfact gen_laguerre genmatrix gensym geo_amortization geo_annuity_fv geo_annuity_pv geomap geometric geometric_mean geosum get getcurrentdirectory get_edge_weight getenv get_lu_factors get_output_stream_string get_pixel get_plot_option get_tex_environment get_tex_environment_default get_vertex_label gfactor gfactorsum ggf girth global_variances gn gnuplot_close gnuplot_replot gnuplot_reset gnuplot_restart gnuplot_start go Gosper GosperSum gr2d gr3d gradef gramschmidt graph6_decode graph6_encode graph6_export graph6_import graph_center graph_charpoly graph_eigenvalues graph_flow graph_order graph_periphery graph_product graph_size graph_union great_rhombicosidodecahedron_graph great_rhombicuboctahedron_graph grid_graph grind grobner_basis grotzch_graph hamilton_cycle hamilton_path hankel hankel_1 hankel_2 harmonic harmonic_mean hav heawood_graph hermite hessian hgfred hilbertmap hilbert_matrix hipow histogram histogram_description hodge horner hypergeometric i0 i1 %ibes ic1 ic2 ic_convert ichr1 ichr2 icosahedron_graph icosidodecahedron_graph icurvature ident identfor identity idiff idim idummy ieqn %if ifactors iframes ifs igcdex igeodesic_coords ilt image imagpart imetric implicit implicit_derivative implicit_plot indexed_tensor indices induced_subgraph inferencep inference_result infix info_display init_atensor init_ctensor in_neighbors innerproduct inpart inprod inrt integerp integer_partitions integrate intersect intersection intervalp intopois intosum invariant1 invariant2 inverse_fft inverse_jacobi_cd inverse_jacobi_cn inverse_jacobi_cs inverse_jacobi_dc inverse_jacobi_dn inverse_jacobi_ds inverse_jacobi_nc inverse_jacobi_nd inverse_jacobi_ns inverse_jacobi_sc inverse_jacobi_sd inverse_jacobi_sn invert invert_by_adjoint invert_by_lu inv_mod irr is is_biconnected is_bipartite is_connected is_digraph is_edge_in_graph is_graph is_graph_or_digraph ishow is_isomorphic isolate isomorphism is_planar isqrt isreal_p is_sconnected is_tree is_vertex_in_graph items_inference %j j0 j1 jacobi jacobian jacobi_cd jacobi_cn jacobi_cs jacobi_dc jacobi_dn jacobi_ds jacobi_nc jacobi_nd jacobi_ns jacobi_p jacobi_sc jacobi_sd jacobi_sn JF jn join jordan julia julia_set julia_sin %k kdels kdelta kill killcontext kostka kron_delta kronecker_product kummer_m kummer_u kurtosis kurtosis_bernoulli kurtosis_beta kurtosis_binomial kurtosis_chi2 kurtosis_continuous_uniform kurtosis_discrete_uniform kurtosis_exp kurtosis_f kurtosis_gamma kurtosis_general_finite_discrete kurtosis_geometric kurtosis_gumbel kurtosis_hypergeometric kurtosis_laplace kurtosis_logistic kurtosis_lognormal kurtosis_negative_binomial kurtosis_noncentral_chi2 kurtosis_noncentral_student_t kurtosis_normal kurtosis_pareto kurtosis_poisson kurtosis_rayleigh kurtosis_student_t kurtosis_weibull label labels lagrange laguerre lambda lambert_w laplace laplacian_matrix last lbfgs lc2kdt lcharp lc_l lcm lc_u ldefint ldisp ldisplay legendre_p legendre_q leinstein length let letrules letsimp levi_civita lfreeof lgtreillis lhs li liediff limit Lindstedt linear linearinterpol linear_program linear_regression line_graph linsolve listarray list_correlations listify list_matrix_entries list_nc_monomials listoftens listofvars listp lmax lmin load loadfile local locate_matrix_entry log logcontract log_gamma lopow lorentz_gauge lowercasep lpart lratsubst lreduce lriemann lsquares_estimates lsquares_estimates_approximate lsquares_estimates_exact lsquares_mse lsquares_residual_mse lsquares_residuals lsum ltreillis lu_backsub lucas lu_factor %m macroexpand macroexpand1 make_array makebox makefact makegamma make_graph make_level_picture makelist makeOrders make_poly_continent make_poly_country make_polygon make_random_state make_rgb_picture makeset make_string_input_stream make_string_output_stream make_transform mandelbrot mandelbrot_set map mapatom maplist matchdeclare matchfix mat_cond mat_fullunblocker mat_function mathml_display mat_norm matrix matrixmap matrixp matrix_size mattrace mat_trace mat_unblocker max max_clique max_degree max_flow maximize_lp max_independent_set max_matching maybe md5sum mean mean_bernoulli mean_beta mean_binomial mean_chi2 mean_continuous_uniform mean_deviation mean_discrete_uniform mean_exp mean_f mean_gamma mean_general_finite_discrete mean_geometric mean_gumbel mean_hypergeometric mean_laplace mean_logistic mean_lognormal mean_negative_binomial mean_noncentral_chi2 mean_noncentral_student_t mean_normal mean_pareto mean_poisson mean_rayleigh mean_student_t mean_weibull median median_deviation member mesh metricexpandall mgf1_sha1 min min_degree min_edge_cut minfactorial minimalPoly minimize_lp minimum_spanning_tree minor minpack_lsquares minpack_solve min_vertex_cover min_vertex_cut mkdir mnewton mod mode_declare mode_identity ModeMatrix moebius mon2schur mono monomial_dimensions multibernstein_poly multi_display_for_texinfo multi_elem multinomial multinomial_coeff multi_orbit multiplot_mode multi_pui multsym multthru mycielski_graph nary natural_unit nc_degree ncexpt ncharpoly negative_picture neighbors new newcontext newdet new_graph newline newton new_variable next_prime nicedummies niceindices ninth nofix nonarray noncentral_moment nonmetricity nonnegintegerp nonscalarp nonzeroandfreeof notequal nounify nptetrad npv nroots nterms ntermst nthroot nullity nullspace num numbered_boundaries numberp number_to_octets num_distinct_partitions numerval numfactor num_partitions nusum nzeta nzetai nzetar octets_to_number octets_to_oid odd_girth oddp ode2 ode_check odelin oid_to_octets op opena opena_binary openr openr_binary openw openw_binary operatorp opsubst optimize %or orbit orbits ordergreat ordergreatp orderless orderlessp orthogonal_complement orthopoly_recur orthopoly_weight outermap out_neighbors outofpois pade parabolic_cylinder_d parametric parametric_surface parg parGosper parse_string parse_timedate part part2cont partfrac partition partition_set partpol path_digraph path_graph pathname_directory pathname_name pathname_type pdf_bernoulli pdf_beta pdf_binomial pdf_cauchy pdf_chi2 pdf_continuous_uniform pdf_discrete_uniform pdf_exp pdf_f pdf_gamma pdf_general_finite_discrete pdf_geometric pdf_gumbel pdf_hypergeometric pdf_laplace pdf_logistic pdf_lognormal pdf_negative_binomial pdf_noncentral_chi2 pdf_noncentral_student_t pdf_normal pdf_pareto pdf_poisson pdf_rank_sum pdf_rayleigh pdf_signed_rank pdf_student_t pdf_weibull pearson_skewness permanent permut permutation permutations petersen_graph petrov pickapart picture_equalp picturep piechart piechart_description planar_embedding playback plog plot2d plot3d plotdf ploteq plsquares pochhammer points poisdiff poisexpt poisint poismap poisplus poissimp poissubst poistimes poistrim polar polarform polartorect polar_to_xy poly_add poly_buchberger poly_buchberger_criterion poly_colon_ideal poly_content polydecomp poly_depends_p poly_elimination_ideal poly_exact_divide poly_expand poly_expt poly_gcd polygon poly_grobner poly_grobner_equal poly_grobner_member poly_grobner_subsetp poly_ideal_intersection poly_ideal_polysaturation poly_ideal_polysaturation1 poly_ideal_saturation poly_ideal_saturation1 poly_lcm poly_minimization polymod poly_multiply polynome2ele polynomialp poly_normal_form poly_normalize poly_normalize_list poly_polysaturation_extension poly_primitive_part poly_pseudo_divide poly_reduced_grobner poly_reduction poly_saturation_extension poly_s_polynomial poly_subtract polytocompanion pop postfix potential power_mod powerseries powerset prefix prev_prime primep primes principal_components print printf printfile print_graph printpois printprops prodrac product properties propvars psi psubst ptriangularize pui pui2comp pui2ele pui2polynome pui_direct puireduc push put pv qput qrange qty quad_control quad_qag quad_qagi quad_qagp quad_qags quad_qawc quad_qawf quad_qawo quad_qaws quadrilateral quantile quantile_bernoulli quantile_beta quantile_binomial quantile_cauchy quantile_chi2 quantile_continuous_uniform quantile_discrete_uniform quantile_exp quantile_f quantile_gamma quantile_general_finite_discrete quantile_geometric quantile_gumbel quantile_hypergeometric quantile_laplace quantile_logistic quantile_lognormal quantile_negative_binomial quantile_noncentral_chi2 quantile_noncentral_student_t quantile_normal quantile_pareto quantile_poisson quantile_rayleigh quantile_student_t quantile_weibull quartile_skewness quit qunit quotient racah_v racah_w radcan radius random random_bernoulli random_beta random_binomial random_bipartite_graph random_cauchy random_chi2 random_continuous_uniform random_digraph random_discrete_uniform random_exp random_f random_gamma random_general_finite_discrete random_geometric random_graph random_graph1 random_gumbel random_hypergeometric random_laplace random_logistic random_lognormal random_negative_binomial random_network random_noncentral_chi2 random_noncentral_student_t random_normal random_pareto random_permutation random_poisson random_rayleigh random_regular_graph random_student_t random_tournament random_tree random_weibull range rank rat ratcoef ratdenom ratdiff ratdisrep ratexpand ratinterpol rational rationalize ratnumer ratnump ratp ratsimp ratsubst ratvars ratweight read read_array read_binary_array read_binary_list read_binary_matrix readbyte readchar read_hashed_array readline read_list read_matrix read_nested_list readonly read_xpm real_imagpart_to_conjugate realpart realroots rearray rectangle rectform rectform_log_if_constant recttopolar rediff reduce_consts reduce_order region region_boundaries region_boundaries_plus rem remainder remarray rembox remcomps remcon remcoord remfun remfunction remlet remove remove_constvalue remove_dimensions remove_edge remove_fundamental_dimensions remove_fundamental_units remove_plot_option remove_vertex rempart remrule remsym remvalue rename rename_file reset reset_displays residue resolvante resolvante_alternee1 resolvante_bipartite resolvante_diedrale resolvante_klein resolvante_klein3 resolvante_produit_sym resolvante_unitaire resolvante_vierer rest resultant return reveal reverse revert revert2 rgb2level rhs ricci riemann rinvariant risch rk rmdir rncombine romberg room rootscontract round row rowop rowswap rreduce run_testsuite %s save saving scalarp scaled_bessel_i scaled_bessel_i0 scaled_bessel_i1 scalefactors scanmap scatterplot scatterplot_description scene schur2comp sconcat scopy scsimp scurvature sdowncase sec sech second sequal sequalignore set_alt_display setdifference set_draw_defaults set_edge_weight setelmx setequalp setify setp set_partitions set_plot_option set_prompt set_random_state set_tex_environment set_tex_environment_default setunits setup_autoload set_up_dot_simplifications set_vertex_label seventh sexplode sf sha1sum sha256sum shortest_path shortest_weighted_path show showcomps showratvars sierpinskiale sierpinskimap sign signum similaritytransform simp_inequality simplify_sum simplode simpmetderiv simtran sin sinh sinsert sinvertcase sixth skewness skewness_bernoulli skewness_beta skewness_binomial skewness_chi2 skewness_continuous_uniform skewness_discrete_uniform skewness_exp skewness_f skewness_gamma skewness_general_finite_discrete skewness_geometric skewness_gumbel skewness_hypergeometric skewness_laplace skewness_logistic skewness_lognormal skewness_negative_binomial skewness_noncentral_chi2 skewness_noncentral_student_t skewness_normal skewness_pareto skewness_poisson skewness_rayleigh skewness_student_t skewness_weibull slength smake small_rhombicosidodecahedron_graph small_rhombicuboctahedron_graph smax smin smismatch snowmap snub_cube_graph snub_dodecahedron_graph solve solve_rec solve_rec_rat some somrac sort sparse6_decode sparse6_encode sparse6_export sparse6_import specint spherical spherical_bessel_j spherical_bessel_y spherical_hankel1 spherical_hankel2 spherical_harmonic spherical_to_xyz splice split sposition sprint sqfr sqrt sqrtdenest sremove sremovefirst sreverse ssearch ssort sstatus ssubst ssubstfirst staircase standardize standardize_inverse_trig starplot starplot_description status std std1 std_bernoulli std_beta std_binomial std_chi2 std_continuous_uniform std_discrete_uniform std_exp std_f std_gamma std_general_finite_discrete std_geometric std_gumbel std_hypergeometric std_laplace std_logistic std_lognormal std_negative_binomial std_noncentral_chi2 std_noncentral_student_t std_normal std_pareto std_poisson std_rayleigh std_student_t std_weibull stemplot stirling stirling1 stirling2 strim striml strimr string stringout stringp strong_components struve_h struve_l sublis sublist sublist_indices submatrix subsample subset subsetp subst substinpart subst_parallel substpart substring subvar subvarp sum sumcontract summand_to_rec supcase supcontext symbolp symmdifference symmetricp system take_channel take_inference tan tanh taylor taylorinfo taylorp taylor_simplifier taytorat tcl_output tcontract tellrat tellsimp tellsimpafter tentex tenth test_mean test_means_difference test_normality test_proportion test_proportions_difference test_rank_sum test_sign test_signed_rank test_variance test_variance_ratio tex tex1 tex_display texput %th third throw time timedate timer timer_info tldefint tlimit todd_coxeter toeplitz tokens to_lisp topological_sort to_poly to_poly_solve totaldisrep totalfourier totient tpartpol trace tracematrix trace_options transform_sample translate translate_file transpose treefale tree_reduce treillis treinat triangle triangularize trigexpand trigrat trigreduce trigsimp trunc truncate truncated_cube_graph truncated_dodecahedron_graph truncated_icosahedron_graph truncated_tetrahedron_graph tr_warnings_get tube tutte_graph ueivects uforget ultraspherical underlying_graph undiff union unique uniteigenvectors unitp units unit_step unitvector unorder unsum untellrat untimer untrace uppercasep uricci uriemann uvect vandermonde_matrix var var1 var_bernoulli var_beta var_binomial var_chi2 var_continuous_uniform var_discrete_uniform var_exp var_f var_gamma var_general_finite_discrete var_geometric var_gumbel var_hypergeometric var_laplace var_logistic var_lognormal var_negative_binomial var_noncentral_chi2 var_noncentral_student_t var_normal var_pareto var_poisson var_rayleigh var_student_t var_weibull vector vectorpotential vectorsimp verbify vers vertex_coloring vertex_connectivity vertex_degree vertex_distance vertex_eccentricity vertex_in_degree vertex_out_degree vertices vertices_to_cycle vertices_to_path %w weyl wheel_graph wiener_index wigner_3j wigner_6j wigner_9j with_stdout write_binary_data writebyte write_data writefile wronskian xreduce xthru %y Zeilberger zeroequiv zerofor zeromatrix zeromatrixp zeta zgeev zheev zlange zn_add_table zn_carmichael_lambda zn_characteristic_factors zn_determinant zn_factor_generators zn_invert_by_lu zn_log zn_mult_table absboxchar activecontexts adapt_depth additive adim aform algebraic algepsilon algexact aliases allbut all_dotsimp_denoms allocation allsym alphabetic animation antisymmetric arrays askexp assume_pos assume_pos_pred assumescalar asymbol atomgrad atrig1 axes axis_3d axis_bottom axis_left axis_right axis_top azimuth background background_color backsubst berlefact bernstein_explicit besselexpand beta_args_sum_to_integer beta_expand bftorat bftrunc bindtest border boundaries_array box boxchar breakup %c capping cauchysum cbrange cbtics center cflength cframe_flag cnonmet_flag color color_bar color_bar_tics colorbox columns commutative complex cone context contexts contour contour_levels cosnpiflag ctaypov ctaypt ctayswitch ctayvar ct_coords ctorsion_flag ctrgsimp cube current_let_rule_package cylinder data_file_name debugmode decreasing default_let_rule_package delay dependencies derivabbrev derivsubst detout diagmetric diff dim dimensions dispflag display2d|10 display_format_internal distribute_over doallmxops domain domxexpt domxmxops domxnctimes dontfactor doscmxops doscmxplus dot0nscsimp dot0simp dot1simp dotassoc dotconstrules dotdistrib dotexptsimp dotident dotscrules draw_graph_program draw_realpart edge_color edge_coloring edge_partition edge_type edge_width %edispflag elevation %emode endphi endtheta engineering_format_floats enhanced3d %enumer epsilon_lp erfflag erf_representation errormsg error_size error_syms error_type %e_to_numlog eval even evenfun evflag evfun ev_point expandwrt_denom expintexpand expintrep expon expop exptdispflag exptisolate exptsubst facexpand facsum_combine factlim factorflag factorial_expand factors_only fb feature features file_name file_output_append file_search_demo file_search_lisp file_search_maxima|10 file_search_tests file_search_usage file_type_lisp file_type_maxima|10 fill_color fill_density filled_func fixed_vertices flipflag float2bf font font_size fortindent fortspaces fpprec fpprintprec functions gamma_expand gammalim gdet genindex gensumnum GGFCFMAX GGFINFINITY globalsolve gnuplot_command gnuplot_curve_styles gnuplot_curve_titles gnuplot_default_term_command gnuplot_dumb_term_command gnuplot_file_args gnuplot_file_name gnuplot_out_file gnuplot_pdf_term_command gnuplot_pm3d gnuplot_png_term_command gnuplot_postamble gnuplot_preamble gnuplot_ps_term_command gnuplot_svg_term_command gnuplot_term gnuplot_view_args Gosper_in_Zeilberger gradefs grid grid2d grind halfangles head_angle head_both head_length head_type height hypergeometric_representation %iargs ibase icc1 icc2 icounter idummyx ieqnprint ifb ifc1 ifc2 ifg ifgi ifr iframe_bracket_form ifri igeowedge_flag ikt1 ikt2 imaginary inchar increasing infeval infinity inflag infolists inm inmc1 inmc2 intanalysis integer integervalued integrate_use_rootsof integration_constant integration_constant_counter interpolate_color intfaclim ip_grid ip_grid_in irrational isolate_wrt_times iterations itr julia_parameter %k1 %k2 keepfloat key key_pos kinvariant kt label label_alignment label_orientation labels lassociative lbfgs_ncorrections lbfgs_nfeval_max leftjust legend letrat let_rule_packages lfg lg lhospitallim limsubst linear linear_solver linechar linel|10 linenum line_type linewidth line_width linsolve_params linsolvewarn lispdisp listarith listconstvars listdummyvars lmxchar load_pathname loadprint logabs logarc logcb logconcoeffp logexpand lognegint logsimp logx logx_secondary logy logy_secondary logz lriem m1pbranch macroexpansion macros mainvar manual_demo maperror mapprint matrix_element_add matrix_element_mult matrix_element_transpose maxapplydepth maxapplyheight maxima_tempdir|10 maxima_userdir|10 maxnegex MAX_ORD maxposex maxpsifracdenom maxpsifracnum maxpsinegint maxpsiposint maxtayorder mesh_lines_color method mod_big_prime mode_check_errorp mode_checkp mode_check_warnp mod_test mod_threshold modular_linear_solver modulus multiplicative multiplicities myoptions nary negdistrib negsumdispflag newline newtonepsilon newtonmaxiter nextlayerfactor niceindicespref nm nmc noeval nolabels nonegative_lp noninteger nonscalar noun noundisp nouns np npi nticks ntrig numer numer_pbranch obase odd oddfun opacity opproperties opsubst optimprefix optionset orientation origin orthopoly_returns_intervals outative outchar packagefile palette partswitch pdf_file pfeformat phiresolution %piargs piece pivot_count_sx pivot_max_sx plot_format plot_options plot_realpart png_file pochhammer_max_index points pointsize point_size points_joined point_type poislim poisson poly_coefficient_ring poly_elimination_order polyfactor poly_grobner_algorithm poly_grobner_debug poly_monomial_order poly_primary_elimination_order poly_return_term_list poly_secondary_elimination_order poly_top_reduction_only posfun position powerdisp pred prederror primep_number_of_tests product_use_gamma program programmode promote_float_to_bigfloat prompt proportional_axes props psexpand ps_file radexpand radius radsubstflag rassociative ratalgdenom ratchristof ratdenomdivide rateinstein ratepsilon ratfac rational ratmx ratprint ratriemann ratsimpexpons ratvarswitch ratweights ratweyl ratwtlvl real realonly redraw refcheck resolution restart resultant ric riem rmxchar %rnum_list rombergabs rombergit rombergmin rombergtol rootsconmode rootsepsilon run_viewer same_xy same_xyz savedef savefactors scalar scalarmatrixp scale scale_lp setcheck setcheckbreak setval show_edge_color show_edges show_edge_type show_edge_width show_id show_label showtime show_vertex_color show_vertex_size show_vertex_type show_vertices show_weight simp simplified_output simplify_products simpproduct simpsum sinnpiflag solvedecomposes solveexplicit solvefactors solvenullwarn solveradcan solvetrigwarn space sparse sphere spring_embedding_depth sqrtdispflag stardisp startphi starttheta stats_numer stringdisp structures style sublis_apply_lambda subnumsimp sumexpand sumsplitfact surface surface_hide svg_file symmetric tab taylordepth taylor_logexpand taylor_order_coefficients taylor_truncate_polynomials tensorkill terminal testsuite_files thetaresolution timer_devalue title tlimswitch tr track transcompile transform transform_xy translate_fast_arrays transparent transrun tr_array_as_ref tr_bound_function_applyp tr_file_tty_messagesp tr_float_can_branch_complex tr_function_call_default trigexpandplus trigexpandtimes triginverses trigsign trivial_solutions tr_numer tr_optimize_max_loop tr_semicompile tr_state_vars tr_warn_bad_function_calls tr_warn_fexpr tr_warn_meval tr_warn_mode tr_warn_undeclared tr_warn_undefined_variable tstep ttyoff tube_extremes ufg ug %unitexpand unit_vectors uric uriem use_fast_arrays user_preamble usersetunits values vect_cross verbose vertex_color vertex_coloring vertex_partition vertex_size vertex_type view warnings weyl width windowname windowtitle wired_surface wireframe xaxis xaxis_color xaxis_secondary xaxis_type xaxis_width xlabel xlabel_secondary xlength xrange xrange_secondary xtics xtics_axis xtics_rotate xtics_rotate_secondary xtics_secondary xtics_secondary_axis xu_grid x_voxel xy_file xyplane xy_scale yaxis yaxis_color yaxis_secondary yaxis_type yaxis_width ylabel ylabel_secondary ylength yrange yrange_secondary ytics ytics_axis ytics_rotate ytics_rotate_secondary ytics_secondary ytics_secondary_axis yv_grid y_voxel yx_ratio zaxis zaxis_color zaxis_type zaxis_width zeroa zerob zerobern zeta%pi zlabel zlabel_rotate zlength zmin zn_primroot_limit zn_primroot_pretest",symbol:"_ __ %|0 %%|0"},contains:[{className:"comment",begin:"/\\\\*",end:"\\\\*/",contains:["self"]},e.QUOTE_STRING_MODE,{className:"number",relevance:0,variants:[{begin:"\\\\b(\\\\d+|\\\\d+\\\\.|\\\\.\\\\d+|\\\\d+\\\\.\\\\d+)[Ee][-+]?\\\\d+\\\\b"},{begin:"\\\\b(\\\\d+|\\\\d+\\\\.|\\\\.\\\\d+|\\\\d+\\\\.\\\\d+)[Bb][-+]?\\\\d+\\\\b",relevance:10},{begin:"\\\\b(\\\\.\\\\d+|\\\\d+\\\\.\\\\d+)\\\\b"},{begin:"\\\\b(\\\\d+|0[0-9A-Za-z]+)\\\\.?\\\\b"}]}],illegal:/@/}}return ba=t,ba}var Ra,ls;function Od(){if(ls)return Ra;ls=1;function t(e){return{name:"MEL",keywords:"int float string vector matrix if else switch case default while do for in break continue global proc return about abs addAttr addAttributeEditorNodeHelp addDynamic addNewShelfTab addPP addPanelCategory addPrefixToName advanceToNextDrivenKey affectedNet affects aimConstraint air alias aliasAttr align alignCtx alignCurve alignSurface allViewFit ambientLight angle angleBetween animCone animCurveEditor animDisplay animView annotate appendStringArray applicationName applyAttrPreset applyTake arcLenDimContext arcLengthDimension arclen arrayMapper art3dPaintCtx artAttrCtx artAttrPaintVertexCtx artAttrSkinPaintCtx artAttrTool artBuildPaintMenu artFluidAttrCtx artPuttyCtx artSelectCtx artSetPaintCtx artUserPaintCtx assignCommand assignInputDevice assignViewportFactories attachCurve attachDeviceAttr attachSurface attrColorSliderGrp attrCompatibility attrControlGrp attrEnumOptionMenu attrEnumOptionMenuGrp attrFieldGrp attrFieldSliderGrp attrNavigationControlGrp attrPresetEditWin attributeExists attributeInfo attributeMenu attributeQuery autoKeyframe autoPlace bakeClip bakeFluidShading bakePartialHistory bakeResults bakeSimulation basename basenameEx batchRender bessel bevel bevelPlus binMembership bindSkin blend2 blendShape blendShapeEditor blendShapePanel blendTwoAttr blindDataType boneLattice boundary boxDollyCtx boxZoomCtx bufferCurve buildBookmarkMenu buildKeyframeMenu button buttonManip CBG cacheFile cacheFileCombine cacheFileMerge cacheFileTrack camera cameraView canCreateManip canvas capitalizeString catch catchQuiet ceil changeSubdivComponentDisplayLevel changeSubdivRegion channelBox character characterMap characterOutlineEditor characterize chdir checkBox checkBoxGrp checkDefaultRenderGlobals choice circle circularFillet clamp clear clearCache clip clipEditor clipEditorCurrentTimeCtx clipSchedule clipSchedulerOutliner clipTrimBefore closeCurve closeSurface cluster cmdFileOutput cmdScrollFieldExecuter cmdScrollFieldReporter cmdShell coarsenSubdivSelectionList collision color colorAtPoint colorEditor colorIndex colorIndexSliderGrp colorSliderButtonGrp colorSliderGrp columnLayout commandEcho commandLine commandPort compactHairSystem componentEditor compositingInterop computePolysetVolume condition cone confirmDialog connectAttr connectControl connectDynamic connectJoint connectionInfo constrain constrainValue constructionHistory container containsMultibyte contextInfo control convertFromOldLayers convertIffToPsd convertLightmap convertSolidTx convertTessellation convertUnit copyArray copyFlexor copyKey copySkinWeights cos cpButton cpCache cpClothSet cpCollision cpConstraint cpConvClothToMesh cpForces cpGetSolverAttr cpPanel cpProperty cpRigidCollisionFilter cpSeam cpSetEdit cpSetSolverAttr cpSolver cpSolverTypes cpTool cpUpdateClothUVs createDisplayLayer createDrawCtx createEditor createLayeredPsdFile createMotionField createNewShelf createNode createRenderLayer createSubdivRegion cross crossProduct ctxAbort ctxCompletion ctxEditMode ctxTraverse currentCtx currentTime currentTimeCtx currentUnit curve curveAddPtCtx curveCVCtx curveEPCtx curveEditorCtx curveIntersect curveMoveEPCtx curveOnSurface curveSketchCtx cutKey cycleCheck cylinder dagPose date defaultLightListCheckBox defaultNavigation defineDataServer defineVirtualDevice deformer deg_to_rad delete deleteAttr deleteShadingGroupsAndMaterials deleteShelfTab deleteUI deleteUnusedBrushes delrandstr detachCurve detachDeviceAttr detachSurface deviceEditor devicePanel dgInfo dgdirty dgeval dgtimer dimWhen directKeyCtx directionalLight dirmap dirname disable disconnectAttr disconnectJoint diskCache displacementToPoly displayAffected displayColor displayCull displayLevelOfDetail displayPref displayRGBColor displaySmoothness displayStats displayString displaySurface distanceDimContext distanceDimension doBlur dolly dollyCtx dopeSheetEditor dot dotProduct doubleProfileBirailSurface drag dragAttrContext draggerContext dropoffLocator duplicate duplicateCurve duplicateSurface dynCache dynControl dynExport dynExpression dynGlobals dynPaintEditor dynParticleCtx dynPref dynRelEdPanel dynRelEditor dynamicLoad editAttrLimits editDisplayLayerGlobals editDisplayLayerMembers editRenderLayerAdjustment editRenderLayerGlobals editRenderLayerMembers editor editorTemplate effector emit emitter enableDevice encodeString endString endsWith env equivalent equivalentTol erf error eval evalDeferred evalEcho event exactWorldBoundingBox exclusiveLightCheckBox exec executeForEachObject exists exp expression expressionEditorListen extendCurve extendSurface extrude fcheck fclose feof fflush fgetline fgetword file fileBrowserDialog fileDialog fileExtension fileInfo filetest filletCurve filter filterCurve filterExpand filterStudioImport findAllIntersections findAnimCurves findKeyframe findMenuItem findRelatedSkinCluster finder firstParentOf fitBspline flexor floatEq floatField floatFieldGrp floatScrollBar floatSlider floatSlider2 floatSliderButtonGrp floatSliderGrp floor flow fluidCacheInfo fluidEmitter fluidVoxelInfo flushUndo fmod fontDialog fopen formLayout format fprint frameLayout fread freeFormFillet frewind fromNativePath fwrite gamma gauss geometryConstraint getApplicationVersionAsFloat getAttr getClassification getDefaultBrush getFileList getFluidAttr getInputDeviceRange getMayaPanelTypes getModifiers getPanel getParticleAttr getPluginResource getenv getpid glRender glRenderEditor globalStitch gmatch goal gotoBindPose grabColor gradientControl gradientControlNoAttr graphDollyCtx graphSelectContext graphTrackCtx gravity grid gridLayout group groupObjectsByName HfAddAttractorToAS HfAssignAS HfBuildEqualMap HfBuildFurFiles HfBuildFurImages HfCancelAFR HfConnectASToHF HfCreateAttractor HfDeleteAS HfEditAS HfPerformCreateAS HfRemoveAttractorFromAS HfSelectAttached HfSelectAttractors HfUnAssignAS hardenPointCurve hardware hardwareRenderPanel headsUpDisplay headsUpMessage help helpLine hermite hide hilite hitTest hotBox hotkey hotkeyCheck hsv_to_rgb hudButton hudSlider hudSliderButton hwReflectionMap hwRender hwRenderLoad hyperGraph hyperPanel hyperShade hypot iconTextButton iconTextCheckBox iconTextRadioButton iconTextRadioCollection iconTextScrollList iconTextStaticLabel ikHandle ikHandleCtx ikHandleDisplayScale ikSolver ikSplineHandleCtx ikSystem ikSystemInfo ikfkDisplayMethod illustratorCurves image imfPlugins inheritTransform insertJoint insertJointCtx insertKeyCtx insertKnotCurve insertKnotSurface instance instanceable instancer intField intFieldGrp intScrollBar intSlider intSliderGrp interToUI internalVar intersect iprEngine isAnimCurve isConnected isDirty isParentOf isSameObject isTrue isValidObjectName isValidString isValidUiName isolateSelect itemFilter itemFilterAttr itemFilterRender itemFilterType joint jointCluster jointCtx jointDisplayScale jointLattice keyTangent keyframe keyframeOutliner keyframeRegionCurrentTimeCtx keyframeRegionDirectKeyCtx keyframeRegionDollyCtx keyframeRegionInsertKeyCtx keyframeRegionMoveKeyCtx keyframeRegionScaleKeyCtx keyframeRegionSelectKeyCtx keyframeRegionSetKeyCtx keyframeRegionTrackCtx keyframeStats lassoContext lattice latticeDeformKeyCtx launch launchImageEditor layerButton layeredShaderPort layeredTexturePort layout layoutDialog lightList lightListEditor lightListPanel lightlink lineIntersection linearPrecision linstep listAnimatable listAttr listCameras listConnections listDeviceAttachments listHistory listInputDeviceAxes listInputDeviceButtons listInputDevices listMenuAnnotation listNodeTypes listPanelCategories listRelatives listSets listTransforms listUnselected listerEditor loadFluid loadNewShelf loadPlugin loadPluginLanguageResources loadPrefObjects localizedPanelLabel lockNode loft log longNameOf lookThru ls lsThroughFilter lsType lsUI Mayatomr mag makeIdentity makeLive makePaintable makeRoll makeSingleSurface makeTubeOn makebot manipMoveContext manipMoveLimitsCtx manipOptions manipRotateContext manipRotateLimitsCtx manipScaleContext manipScaleLimitsCtx marker match max memory menu menuBarLayout menuEditor menuItem menuItemToShelf menuSet menuSetPref messageLine min minimizeApp mirrorJoint modelCurrentTimeCtx modelEditor modelPanel mouse movIn movOut move moveIKtoFK moveKeyCtx moveVertexAlongDirection multiProfileBirailSurface mute nParticle nameCommand nameField namespace namespaceInfo newPanelItems newton nodeCast nodeIconButton nodeOutliner nodePreset nodeType noise nonLinear normalConstraint normalize nurbsBoolean nurbsCopyUVSet nurbsCube nurbsEditUV nurbsPlane nurbsSelect nurbsSquare nurbsToPoly nurbsToPolygonsPref nurbsToSubdiv nurbsToSubdivPref nurbsUVSet nurbsViewDirectionVector objExists objectCenter objectLayer objectType objectTypeUI obsoleteProc oceanNurbsPreviewPlane offsetCurve offsetCurveOnSurface offsetSurface openGLExtension openMayaPref optionMenu optionMenuGrp optionVar orbit orbitCtx orientConstraint outlinerEditor outlinerPanel overrideModifier paintEffectsDisplay pairBlend palettePort paneLayout panel panelConfiguration panelHistory paramDimContext paramDimension paramLocator parent parentConstraint particle particleExists particleInstancer particleRenderInfo partition pasteKey pathAnimation pause pclose percent performanceOptions pfxstrokes pickWalk picture pixelMove planarSrf plane play playbackOptions playblast plugAttr plugNode pluginInfo pluginResourceUtil pointConstraint pointCurveConstraint pointLight pointMatrixMult pointOnCurve pointOnSurface pointPosition poleVectorConstraint polyAppend polyAppendFacetCtx polyAppendVertex polyAutoProjection polyAverageNormal polyAverageVertex polyBevel polyBlendColor polyBlindData polyBoolOp polyBridgeEdge polyCacheMonitor polyCheck polyChipOff polyClipboard polyCloseBorder polyCollapseEdge polyCollapseFacet polyColorBlindData polyColorDel polyColorPerVertex polyColorSet polyCompare polyCone polyCopyUV polyCrease polyCreaseCtx polyCreateFacet polyCreateFacetCtx polyCube polyCut polyCutCtx polyCylinder polyCylindricalProjection polyDelEdge polyDelFacet polyDelVertex polyDuplicateAndConnect polyDuplicateEdge polyEditUV polyEditUVShell polyEvaluate polyExtrudeEdge polyExtrudeFacet polyExtrudeVertex polyFlipEdge polyFlipUV polyForceUV polyGeoSampler polyHelix polyInfo polyInstallAction polyLayoutUV polyListComponentConversion polyMapCut polyMapDel polyMapSew polyMapSewMove polyMergeEdge polyMergeEdgeCtx polyMergeFacet polyMergeFacetCtx polyMergeUV polyMergeVertex polyMirrorFace polyMoveEdge polyMoveFacet polyMoveFacetUV polyMoveUV polyMoveVertex polyNormal polyNormalPerVertex polyNormalizeUV polyOptUvs polyOptions polyOutput polyPipe polyPlanarProjection polyPlane polyPlatonicSolid polyPoke polyPrimitive polyPrism polyProjection polyPyramid polyQuad polyQueryBlindData polyReduce polySelect polySelectConstraint polySelectConstraintMonitor polySelectCtx polySelectEditCtx polySeparate polySetToFaceNormal polySewEdge polyShortestPathCtx polySmooth polySoftEdge polySphere polySphericalProjection polySplit polySplitCtx polySplitEdge polySplitRing polySplitVertex polyStraightenUVBorder polySubdivideEdge polySubdivideFacet polyToSubdiv polyTorus polyTransfer polyTriangulate polyUVSet polyUnite polyWedgeFace popen popupMenu pose pow preloadRefEd print progressBar progressWindow projFileViewer projectCurve projectTangent projectionContext projectionManip promptDialog propModCtx propMove psdChannelOutliner psdEditTextureFile psdExport psdTextureFile putenv pwd python querySubdiv quit rad_to_deg radial radioButton radioButtonGrp radioCollection radioMenuItemCollection rampColorPort rand randomizeFollicles randstate rangeControl readTake rebuildCurve rebuildSurface recordAttr recordDevice redo reference referenceEdit referenceQuery refineSubdivSelectionList refresh refreshAE registerPluginResource rehash reloadImage removeJoint removeMultiInstance removePanelCategory rename renameAttr renameSelectionList renameUI render renderGlobalsNode renderInfo renderLayerButton renderLayerParent renderLayerPostProcess renderLayerUnparent renderManip renderPartition renderQualityNode renderSettings renderThumbnailUpdate renderWindowEditor renderWindowSelectContext renderer reorder reorderDeformers requires reroot resampleFluid resetAE resetPfxToPolyCamera resetTool resolutionNode retarget reverseCurve reverseSurface revolve rgb_to_hsv rigidBody rigidSolver roll rollCtx rootOf rot rotate rotationInterpolation roundConstantRadius rowColumnLayout rowLayout runTimeCommand runup sampleImage saveAllShelves saveAttrPreset saveFluid saveImage saveInitialState saveMenu savePrefObjects savePrefs saveShelf saveToolSettings scale scaleBrushBrightness scaleComponents scaleConstraint scaleKey scaleKeyCtx sceneEditor sceneUIReplacement scmh scriptCtx scriptEditorInfo scriptJob scriptNode scriptTable scriptToShelf scriptedPanel scriptedPanelType scrollField scrollLayout sculpt searchPathArray seed selLoadSettings select selectContext selectCurveCV selectKey selectKeyCtx selectKeyframeRegionCtx selectMode selectPref selectPriority selectType selectedNodes selectionConnection separator setAttr setAttrEnumResource setAttrMapping setAttrNiceNameResource setConstraintRestPosition setDefaultShadingGroup setDrivenKeyframe setDynamic setEditCtx setEditor setFluidAttr setFocus setInfinity setInputDeviceMapping setKeyCtx setKeyPath setKeyframe setKeyframeBlendshapeTargetWts setMenuMode setNodeNiceNameResource setNodeTypeFlag setParent setParticleAttr setPfxToPolyCamera setPluginResource setProject setStampDensity setStartupMessage setState setToolTo setUITemplate setXformManip sets shadingConnection shadingGeometryRelCtx shadingLightRelCtx shadingNetworkCompare shadingNode shapeCompare shelfButton shelfLayout shelfTabLayout shellField shortNameOf showHelp showHidden showManipCtx showSelectionInTitle showShadingGroupAttrEditor showWindow sign simplify sin singleProfileBirailSurface size sizeBytes skinCluster skinPercent smoothCurve smoothTangentSurface smoothstep snap2to2 snapKey snapMode snapTogetherCtx snapshot soft softMod softModCtx sort sound soundControl source spaceLocator sphere sphrand spotLight spotLightPreviewPort spreadSheetEditor spring sqrt squareSurface srtContext stackTrace startString startsWith stitchAndExplodeShell stitchSurface stitchSurfacePoints strcmp stringArrayCatenate stringArrayContains stringArrayCount stringArrayInsertAtIndex stringArrayIntersector stringArrayRemove stringArrayRemoveAtIndex stringArrayRemoveDuplicates stringArrayRemoveExact stringArrayToString stringToStringArray strip stripPrefixFromName stroke subdAutoProjection subdCleanTopology subdCollapse subdDuplicateAndConnect subdEditUV subdListComponentConversion subdMapCut subdMapSewMove subdMatchTopology subdMirror subdToBlind subdToPoly subdTransferUVsToCache subdiv subdivCrease subdivDisplaySmoothness substitute substituteAllString substituteGeometry substring surface surfaceSampler surfaceShaderList swatchDisplayPort switchTable symbolButton symbolCheckBox sysFile system tabLayout tan tangentConstraint texLatticeDeformContext texManipContext texMoveContext texMoveUVShellContext texRotateContext texScaleContext texSelectContext texSelectShortestPathCtx texSmudgeUVContext texWinToolCtx text textCurves textField textFieldButtonGrp textFieldGrp textManip textScrollList textToShelf textureDisplacePlane textureHairColor texturePlacementContext textureWindow threadCount threePointArcCtx timeControl timePort timerX toNativePath toggle toggleAxis toggleWindowVisibility tokenize tokenizeList tolerance tolower toolButton toolCollection toolDropped toolHasOptions toolPropertyWindow torus toupper trace track trackCtx transferAttributes transformCompare transformLimits translator trim trunc truncateFluidCache truncateHairCache tumble tumbleCtx turbulence twoPointArcCtx uiRes uiTemplate unassignInputDevice undo undoInfo ungroup uniform unit unloadPlugin untangleUV untitledFileName untrim upAxis updateAE userCtx uvLink uvSnapshot validateShelfName vectorize view2dToolCtx viewCamera viewClipPlane viewFit viewHeadOn viewLookAt viewManip viewPlace viewSet visor volumeAxis vortex waitCursor warning webBrowser webBrowserPrefs whatIs window windowPref wire wireContext workspace wrinkle wrinkleContext writeTake xbmLangPathList xform",illegal:"</",contains:[e.C_NUMBER_MODE,e.APOS_STRING_MODE,e.QUOTE_STRING_MODE,{className:"string",begin:"\`",end:"\`",contains:[e.BACKSLASH_ESCAPE]},{begin:/[$%@](\\^\\w\\b|#\\w+|[^\\s\\w{]|\\{\\w+\\}|\\w+)/},e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE]}}return Ra=t,Ra}var fa,cs;function Id(){if(cs)return fa;cs=1;function t(e){const n={keyword:"module use_module import_module include_module end_module initialise mutable initialize finalize finalise interface implementation pred mode func type inst solver any_pred any_func is semidet det nondet multi erroneous failure cc_nondet cc_multi typeclass instance where pragma promise external trace atomic or_else require_complete_switch require_det require_semidet require_multi require_nondet require_cc_multi require_cc_nondet require_erroneous require_failure",meta:"inline no_inline type_spec source_file fact_table obsolete memo loop_check minimal_model terminates does_not_terminate check_termination promise_equivalent_clauses foreign_proc foreign_decl foreign_code foreign_type foreign_import_module foreign_export_enum foreign_export foreign_enum may_call_mercury will_not_call_mercury thread_safe not_thread_safe maybe_thread_safe promise_pure promise_semipure tabled_for_io local untrailed trailed attach_to_io_state can_pass_as_mercury_type stable will_not_throw_exception may_modify_trail will_not_modify_trail may_duplicate may_not_duplicate affects_liveness does_not_affect_liveness doesnt_affect_liveness no_sharing unknown_sharing sharing",built_in:"some all not if then else true fail false try catch catch_any semidet_true semidet_false semidet_fail impure_true impure semipure"},a=e.COMMENT("%","$"),r={className:"number",begin:"0'.\\\\|0[box][0-9a-fA-F]*"},i=e.inherit(e.APOS_STRING_MODE,{relevance:0}),s=e.inherit(e.QUOTE_STRING_MODE,{relevance:0}),o={className:"subst",begin:"\\\\\\\\[abfnrtv]\\\\|\\\\\\\\x[0-9a-fA-F]*\\\\\\\\\\\\|%[-+# *.0-9]*[dioxXucsfeEgGp]",relevance:0};return s.contains=s.contains.slice(),s.contains.push(o),{name:"Mercury",aliases:["m","moo"],keywords:n,contains:[{className:"built_in",variants:[{begin:"<=>"},{begin:"<=",relevance:0},{begin:"=>",relevance:0},{begin:"/\\\\\\\\"},{begin:"\\\\\\\\/"}]},{className:"built_in",variants:[{begin:":-\\\\|-->"},{begin:"=",relevance:0}]},a,e.C_BLOCK_COMMENT_MODE,r,e.NUMBER_MODE,i,s,{begin:/:-/},{begin:/\\.$/}]}}return fa=t,fa}var Ca,_s;function Ad(){if(_s)return Ca;_s=1;function t(e){return{name:"MIPS Assembly",case_insensitive:!0,aliases:["mips"],keywords:{$pattern:"\\\\.?"+e.IDENT_RE,meta:".2byte .4byte .align .ascii .asciz .balign .byte .code .data .else .end .endif .endm .endr .equ .err .exitm .extern .global .hword .if .ifdef .ifndef .include .irp .long .macro .rept .req .section .set .skip .space .text .word .ltorg ",built_in:"$0 $1 $2 $3 $4 $5 $6 $7 $8 $9 $10 $11 $12 $13 $14 $15 $16 $17 $18 $19 $20 $21 $22 $23 $24 $25 $26 $27 $28 $29 $30 $31 zero at v0 v1 a0 a1 a2 a3 a4 a5 a6 a7 t0 t1 t2 t3 t4 t5 t6 t7 t8 t9 s0 s1 s2 s3 s4 s5 s6 s7 s8 k0 k1 gp sp fp ra $f0 $f1 $f2 $f2 $f4 $f5 $f6 $f7 $f8 $f9 $f10 $f11 $f12 $f13 $f14 $f15 $f16 $f17 $f18 $f19 $f20 $f21 $f22 $f23 $f24 $f25 $f26 $f27 $f28 $f29 $f30 $f31 Context Random EntryLo0 EntryLo1 Context PageMask Wired EntryHi HWREna BadVAddr Count Compare SR IntCtl SRSCtl SRSMap Cause EPC PRId EBase Config Config1 Config2 Config3 LLAddr Debug DEPC DESAVE CacheErr ECC ErrorEPC TagLo DataLo TagHi DataHi WatchLo WatchHi PerfCtl PerfCnt "},contains:[{className:"keyword",begin:"\\\\b(addi?u?|andi?|b(al)?|beql?|bgez(al)?l?|bgtzl?|blezl?|bltz(al)?l?|bnel?|cl[oz]|divu?|ext|ins|j(al)?|jalr(\\\\.hb)?|jr(\\\\.hb)?|lbu?|lhu?|ll|lui|lw[lr]?|maddu?|mfhi|mflo|movn|movz|move|msubu?|mthi|mtlo|mul|multu?|nop|nor|ori?|rotrv?|sb|sc|se[bh]|sh|sllv?|slti?u?|srav?|srlv?|subu?|sw[lr]?|xori?|wsbh|abs\\\\.[sd]|add\\\\.[sd]|alnv.ps|bc1[ft]l?|c\\\\.(s?f|un|u?eq|[ou]lt|[ou]le|ngle?|seq|l[et]|ng[et])\\\\.[sd]|(ceil|floor|round|trunc)\\\\.[lw]\\\\.[sd]|cfc1|cvt\\\\.d\\\\.[lsw]|cvt\\\\.l\\\\.[dsw]|cvt\\\\.ps\\\\.s|cvt\\\\.s\\\\.[dlw]|cvt\\\\.s\\\\.p[lu]|cvt\\\\.w\\\\.[dls]|div\\\\.[ds]|ldx?c1|luxc1|lwx?c1|madd\\\\.[sd]|mfc1|mov[fntz]?\\\\.[ds]|msub\\\\.[sd]|mth?c1|mul\\\\.[ds]|neg\\\\.[ds]|nmadd\\\\.[ds]|nmsub\\\\.[ds]|p[lu][lu]\\\\.ps|recip\\\\.fmt|r?sqrt\\\\.[ds]|sdx?c1|sub\\\\.[ds]|suxc1|swx?c1|break|cache|d?eret|[de]i|ehb|mfc0|mtc0|pause|prefx?|rdhwr|rdpgpr|sdbbp|ssnop|synci?|syscall|teqi?|tgei?u?|tlb(p|r|w[ir])|tlti?u?|tnei?|wait|wrpgpr)",end:"\\\\s"},e.COMMENT("[;#](?!\\\\s*$)","$"),e.C_BLOCK_COMMENT_MODE,e.QUOTE_STRING_MODE,{className:"string",begin:"'",end:"[^\\\\\\\\]'",relevance:0},{className:"title",begin:"\\\\|",end:"\\\\|",illegal:"\\\\n",relevance:0},{className:"number",variants:[{begin:"0x[0-9a-f]+"},{begin:"\\\\b-?\\\\d+"}],relevance:0},{className:"symbol",variants:[{begin:"^\\\\s*[a-z_\\\\.\\\\$][a-z0-9_\\\\.\\\\$]+:"},{begin:"^\\\\s*[0-9]+:"},{begin:"[0-9]+[bf]"}],relevance:0}],illegal:/\\//}}return Ca=t,Ca}var Na,ds;function vd(){if(ds)return Na;ds=1;function t(e){return{name:"Mizar",keywords:"environ vocabularies notations constructors definitions registrations theorems schemes requirements begin end definition registration cluster existence pred func defpred deffunc theorem proof let take assume then thus hence ex for st holds consider reconsider such that and in provided of as from be being by means equals implies iff redefine define now not or attr is mode suppose per cases set thesis contradiction scheme reserve struct correctness compatibility coherence symmetry assymetry reflexivity irreflexivity connectedness uniqueness commutativity idempotence involutiveness projectivity",contains:[e.COMMENT("::","$")]}}return Na=t,Na}var Oa,us;function yd(){if(us)return Oa;us=1;function t(e){const n=e.regex,a=["abs","accept","alarm","and","atan2","bind","binmode","bless","break","caller","chdir","chmod","chomp","chop","chown","chr","chroot","class","close","closedir","connect","continue","cos","crypt","dbmclose","dbmopen","defined","delete","die","do","dump","each","else","elsif","endgrent","endhostent","endnetent","endprotoent","endpwent","endservent","eof","eval","exec","exists","exit","exp","fcntl","field","fileno","flock","for","foreach","fork","format","formline","getc","getgrent","getgrgid","getgrnam","gethostbyaddr","gethostbyname","gethostent","getlogin","getnetbyaddr","getnetbyname","getnetent","getpeername","getpgrp","getpriority","getprotobyname","getprotobynumber","getprotoent","getpwent","getpwnam","getpwuid","getservbyname","getservbyport","getservent","getsockname","getsockopt","given","glob","gmtime","goto","grep","gt","hex","if","index","int","ioctl","join","keys","kill","last","lc","lcfirst","length","link","listen","local","localtime","log","lstat","lt","ma","map","method","mkdir","msgctl","msgget","msgrcv","msgsnd","my","ne","next","no","not","oct","open","opendir","or","ord","our","pack","package","pipe","pop","pos","print","printf","prototype","push","q|0","qq","quotemeta","qw","qx","rand","read","readdir","readline","readlink","readpipe","recv","redo","ref","rename","require","reset","return","reverse","rewinddir","rindex","rmdir","say","scalar","seek","seekdir","select","semctl","semget","semop","send","setgrent","sethostent","setnetent","setpgrp","setpriority","setprotoent","setpwent","setservent","setsockopt","shift","shmctl","shmget","shmread","shmwrite","shutdown","sin","sleep","socket","socketpair","sort","splice","split","sprintf","sqrt","srand","stat","state","study","sub","substr","symlink","syscall","sysopen","sysread","sysseek","system","syswrite","tell","telldir","tie","tied","time","times","tr","truncate","uc","ucfirst","umask","undef","unless","unlink","unpack","unshift","untie","until","use","utime","values","vec","wait","waitpid","wantarray","warn","when","while","write","x|0","xor","y|0"],r=/[dualxmsipngr]{0,12}/,i={$pattern:/[\\w.]+/,keyword:a.join(" ")},s={className:"subst",begin:"[$@]\\\\{",end:"\\\\}",keywords:i},o={begin:/->\\{/,end:/\\}/},_={scope:"attr",match:/\\s+:\\s*\\w+(\\s*\\(.*?\\))?/},l={scope:"variable",variants:[{begin:/\\$\\d/},{begin:n.concat(/[$%@](?!")(\\^\\w\\b|#\\w+(::\\w+)*|\\{\\w+\\}|\\w+(::\\w*)*)/,"(?![A-Za-z])(?![@$%])")},{begin:/[$%@](?!")[^\\s\\w{=]|\\$=/,relevance:0}],contains:[_]},c={className:"number",variants:[{match:/0?\\.[0-9][0-9_]+\\b/},{match:/\\bv?(0|[1-9][0-9_]*(\\.[0-9_]+)?|[1-9][0-9_]*)\\b/},{match:/\\b0[0-7][0-7_]*\\b/},{match:/\\b0x[0-9a-fA-F][0-9a-fA-F_]*\\b/},{match:/\\b0b[0-1][0-1_]*\\b/}],relevance:0},d=[e.BACKSLASH_ESCAPE,s,l],m=[/!/,/\\//,/\\|/,/\\?/,/'/,/"/,/#/],p=(S,T,R="\\\\1")=>{const f=R==="\\\\1"?R:n.concat(R,T);return n.concat(n.concat("(?:",S,")"),T,/(?:\\\\.|[^\\\\\\/])*?/,f,/(?:\\\\.|[^\\\\\\/])*?/,R,r)},E=(S,T,R)=>n.concat(n.concat("(?:",S,")"),T,/(?:\\\\.|[^\\\\\\/])*?/,R,r),g=[l,e.HASH_COMMENT_MODE,e.COMMENT(/^=\\w/,/=cut/,{endsWithParent:!0}),o,{className:"string",contains:d,variants:[{begin:"q[qwxr]?\\\\s*\\\\(",end:"\\\\)",relevance:5},{begin:"q[qwxr]?\\\\s*\\\\[",end:"\\\\]",relevance:5},{begin:"q[qwxr]?\\\\s*\\\\{",end:"\\\\}",relevance:5},{begin:"q[qwxr]?\\\\s*\\\\|",end:"\\\\|",relevance:5},{begin:"q[qwxr]?\\\\s*<",end:">",relevance:5},{begin:"qw\\\\s+q",end:"q",relevance:5},{begin:"'",end:"'",contains:[e.BACKSLASH_ESCAPE]},{begin:'"',end:'"'},{begin:"\`",end:"\`",contains:[e.BACKSLASH_ESCAPE]},{begin:/\\{\\w+\\}/,relevance:0},{begin:"-?\\\\w+\\\\s*=>",relevance:0}]},c,{begin:"(\\\\/\\\\/|"+e.RE_STARTERS_RE+"|\\\\b(split|return|print|reverse|grep)\\\\b)\\\\s*",keywords:"split return print reverse grep",relevance:0,contains:[e.HASH_COMMENT_MODE,{className:"regexp",variants:[{begin:p("s|tr|y",n.either(...m,{capture:!0}))},{begin:p("s|tr|y","\\\\(","\\\\)")},{begin:p("s|tr|y","\\\\[","\\\\]")},{begin:p("s|tr|y","\\\\{","\\\\}")}],relevance:2},{className:"regexp",variants:[{begin:/(m|qr)\\/\\//,relevance:0},{begin:E("(?:m|qr)?",/\\//,/\\//)},{begin:E("m|qr",n.either(...m,{capture:!0}),/\\1/)},{begin:E("m|qr",/\\(/,/\\)/)},{begin:E("m|qr",/\\[/,/\\]/)},{begin:E("m|qr",/\\{/,/\\}/)}]}]},{className:"function",beginKeywords:"sub method",end:"(\\\\s*\\\\(.*?\\\\))?[;{]",excludeEnd:!0,relevance:5,contains:[e.TITLE_MODE,_]},{className:"class",beginKeywords:"class",end:"[;{]",excludeEnd:!0,relevance:5,contains:[e.TITLE_MODE,_,c]},{begin:"-\\\\w\\\\b",relevance:0},{begin:"^__DATA__$",end:"^__END__$",subLanguage:"mojolicious",contains:[{begin:"^@@.*",end:"$",className:"comment"}]}];return s.contains=g,o.contains=g,{name:"Perl",aliases:["pl","pm"],keywords:i,contains:g}}return Oa=t,Oa}var Ia,ms;function hd(){if(ms)return Ia;ms=1;function t(e){return{name:"Mojolicious",subLanguage:"xml",contains:[{className:"meta",begin:"^__(END|DATA)__$"},{begin:"^\\\\s*%{1,2}={0,2}",end:"$",subLanguage:"perl"},{begin:"<%{1,2}={0,2}",end:"={0,1}%>",subLanguage:"perl",excludeBegin:!0,excludeEnd:!0}]}}return Ia=t,Ia}var Aa,ps;function Dd(){if(ps)return Aa;ps=1;function t(e){const n={className:"number",relevance:0,variants:[{begin:"[$][a-fA-F0-9]+"},e.NUMBER_MODE]},a={variants:[{match:[/(function|method)/,/\\s+/,e.UNDERSCORE_IDENT_RE]}],scope:{1:"keyword",3:"title.function"}},r={variants:[{match:[/(class|interface|extends|implements)/,/\\s+/,e.UNDERSCORE_IDENT_RE]}],scope:{1:"keyword",3:"title.class"}};return{name:"Monkey",case_insensitive:!0,keywords:{keyword:["public","private","property","continue","exit","extern","new","try","catch","eachin","not","abstract","final","select","case","default","const","local","global","field","end","if","then","else","elseif","endif","while","wend","repeat","until","forever","for","to","step","next","return","module","inline","throw","import","and","or","shl","shr","mod"],built_in:["DebugLog","DebugStop","Error","Print","ACos","ACosr","ASin","ASinr","ATan","ATan2","ATan2r","ATanr","Abs","Abs","Ceil","Clamp","Clamp","Cos","Cosr","Exp","Floor","Log","Max","Max","Min","Min","Pow","Sgn","Sgn","Sin","Sinr","Sqrt","Tan","Tanr","Seed","PI","HALFPI","TWOPI"],literal:["true","false","null"]},illegal:/\\/\\*/,contains:[e.COMMENT("#rem","#end"),e.COMMENT("'","$",{relevance:0}),a,r,{className:"variable.language",begin:/\\b(self|super)\\b/},{className:"meta",begin:/\\s*#/,end:"$",keywords:{keyword:"if else elseif endif end then"}},{match:[/^\\s*/,/strict\\b/],scope:{2:"meta"}},{beginKeywords:"alias",end:"=",contains:[e.UNDERSCORE_TITLE_MODE]},e.QUOTE_STRING_MODE,n]}}return Aa=t,Aa}var va,Es;function Md(){if(Es)return va;Es=1;function t(e){const n={keyword:"if then not for in while do return else elseif break continue switch and or unless when class extends super local import export from using",literal:"true false nil",built_in:"_G _VERSION assert collectgarbage dofile error getfenv getmetatable ipairs load loadfile loadstring module next pairs pcall print rawequal rawget rawset require select setfenv setmetatable tonumber tostring type unpack xpcall coroutine debug io math os package string table"},a="[A-Za-z$_][0-9A-Za-z$_]*",r={className:"subst",begin:/#\\{/,end:/\\}/,keywords:n},i=[e.inherit(e.C_NUMBER_MODE,{starts:{end:"(\\\\s*/)?",relevance:0}}),{className:"string",variants:[{begin:/'/,end:/'/,contains:[e.BACKSLASH_ESCAPE]},{begin:/"/,end:/"/,contains:[e.BACKSLASH_ESCAPE,r]}]},{className:"built_in",begin:"@__"+e.IDENT_RE},{begin:"@"+e.IDENT_RE},{begin:e.IDENT_RE+"\\\\\\\\"+e.IDENT_RE}];r.contains=i;const s=e.inherit(e.TITLE_MODE,{begin:a}),o="(\\\\(.*\\\\)\\\\s*)?\\\\B[-=]>",_={className:"params",begin:"\\\\([^\\\\(]",returnBegin:!0,contains:[{begin:/\\(/,end:/\\)/,keywords:n,contains:["self"].concat(i)}]};return{name:"MoonScript",aliases:["moon"],keywords:n,illegal:/\\/\\*/,contains:i.concat([e.COMMENT("--","$"),{className:"function",begin:"^\\\\s*"+a+"\\\\s*=\\\\s*"+o,end:"[-=]>",returnBegin:!0,contains:[s,_]},{begin:/[\\(,:=]\\s*/,relevance:0,contains:[{className:"function",begin:o,end:"[-=]>",returnBegin:!0,contains:[_]}]},{className:"class",beginKeywords:"class",end:"$",illegal:/[:="\\[\\]]/,contains:[{beginKeywords:"extends",endsWithParent:!0,illegal:/[:="\\[\\]]/,contains:[s]},s]},{className:"name",begin:a+":",end:":",returnBegin:!0,returnEnd:!0,relevance:0}])}}return va=t,va}var ya,gs;function Ld(){if(gs)return ya;gs=1;function t(e){return{name:"N1QL",case_insensitive:!0,contains:[{beginKeywords:"build create index delete drop explain infer|10 insert merge prepare select update upsert|10",end:/;/,keywords:{keyword:["all","alter","analyze","and","any","array","as","asc","begin","between","binary","boolean","break","bucket","build","by","call","case","cast","cluster","collate","collection","commit","connect","continue","correlate","cover","create","database","dataset","datastore","declare","decrement","delete","derived","desc","describe","distinct","do","drop","each","element","else","end","every","except","exclude","execute","exists","explain","fetch","first","flatten","for","force","from","function","grant","group","gsi","having","if","ignore","ilike","in","include","increment","index","infer","inline","inner","insert","intersect","into","is","join","key","keys","keyspace","known","last","left","let","letting","like","limit","lsm","map","mapping","matched","materialized","merge","minus","namespace","nest","not","number","object","offset","on","option","or","order","outer","over","parse","partition","password","path","pool","prepare","primary","private","privilege","procedure","public","raw","realm","reduce","rename","return","returning","revoke","right","role","rollback","satisfies","schema","select","self","semi","set","show","some","start","statistics","string","system","then","to","transaction","trigger","truncate","under","union","unique","unknown","unnest","unset","update","upsert","use","user","using","validate","value","valued","values","via","view","when","where","while","with","within","work","xor"],literal:["true","false","null","missing|5"],built_in:["array_agg","array_append","array_concat","array_contains","array_count","array_distinct","array_ifnull","array_length","array_max","array_min","array_position","array_prepend","array_put","array_range","array_remove","array_repeat","array_replace","array_reverse","array_sort","array_sum","avg","count","max","min","sum","greatest","least","ifmissing","ifmissingornull","ifnull","missingif","nullif","ifinf","ifnan","ifnanorinf","naninf","neginfif","posinfif","clock_millis","clock_str","date_add_millis","date_add_str","date_diff_millis","date_diff_str","date_part_millis","date_part_str","date_trunc_millis","date_trunc_str","duration_to_str","millis","str_to_millis","millis_to_str","millis_to_utc","millis_to_zone_name","now_millis","now_str","str_to_duration","str_to_utc","str_to_zone_name","decode_json","encode_json","encoded_size","poly_length","base64","base64_encode","base64_decode","meta","uuid","abs","acos","asin","atan","atan2","ceil","cos","degrees","e","exp","ln","log","floor","pi","power","radians","random","round","sign","sin","sqrt","tan","trunc","object_length","object_names","object_pairs","object_inner_pairs","object_values","object_inner_values","object_add","object_put","object_remove","object_unwrap","regexp_contains","regexp_like","regexp_position","regexp_replace","contains","initcap","length","lower","ltrim","position","repeat","replace","rtrim","split","substr","title","trim","upper","isarray","isatom","isboolean","isnumber","isobject","isstring","type","toarray","toatom","toboolean","tonumber","toobject","tostring"]},contains:[{className:"string",begin:"'",end:"'",contains:[e.BACKSLASH_ESCAPE]},{className:"string",begin:'"',end:'"',contains:[e.BACKSLASH_ESCAPE]},{className:"symbol",begin:"\`",end:"\`",contains:[e.BACKSLASH_ESCAPE]},e.C_NUMBER_MODE,e.C_BLOCK_COMMENT_MODE]},e.C_BLOCK_COMMENT_MODE]}}return ya=t,ya}var ha,Ss;function xd(){if(Ss)return ha;Ss=1;function t(e){const n={match:[/^\\s*(?=\\S)/,/[^:]+/,/:\\s*/,/$/],className:{2:"attribute",3:"punctuation"}},a={match:[/^\\s*(?=\\S)/,/[^:]*[^: ]/,/[ ]*:/,/[ ]/,/.*$/],className:{2:"attribute",3:"punctuation",5:"string"}},r={match:[/^\\s*/,/>/,/[ ]/,/.*$/],className:{2:"punctuation",4:"string"}},i={variants:[{match:[/^\\s*/,/-/,/[ ]/,/.*$/]},{match:[/^\\s*/,/-$/]}],className:{2:"bullet",4:"string"}};return{name:"Nested Text",aliases:["nt"],contains:[e.inherit(e.HASH_COMMENT_MODE,{begin:/^\\s*(?=#)/,excludeBegin:!0}),i,r,n,a]}}return ha=t,ha}var Da,Ts;function wd(){if(Ts)return Da;Ts=1;function t(e){const n=e.regex,a={className:"variable",variants:[{begin:/\\$\\d+/},{begin:/\\$\\{\\w+\\}/},{begin:n.concat(/[$@]/,e.UNDERSCORE_IDENT_RE)}]},i={endsWithParent:!0,keywords:{$pattern:/[a-z_]{2,}|\\/dev\\/poll/,literal:["on","off","yes","no","true","false","none","blocked","debug","info","notice","warn","error","crit","select","break","last","permanent","redirect","kqueue","rtsig","epoll","poll","/dev/poll"]},relevance:0,illegal:"=>",contains:[e.HASH_COMMENT_MODE,{className:"string",contains:[e.BACKSLASH_ESCAPE,a],variants:[{begin:/"/,end:/"/},{begin:/'/,end:/'/}]},{begin:"([a-z]+):/",end:"\\\\s",endsWithParent:!0,excludeEnd:!0,contains:[a]},{className:"regexp",contains:[e.BACKSLASH_ESCAPE,a],variants:[{begin:"\\\\s\\\\^",end:"\\\\s|\\\\{|;",returnEnd:!0},{begin:"~\\\\*?\\\\s+",end:"\\\\s|\\\\{|;",returnEnd:!0},{begin:"\\\\*(\\\\.[a-z\\\\-]+)+"},{begin:"([a-z\\\\-]+\\\\.)+\\\\*"}]},{className:"number",begin:"\\\\b\\\\d{1,3}\\\\.\\\\d{1,3}\\\\.\\\\d{1,3}\\\\.\\\\d{1,3}(:\\\\d{1,5})?\\\\b"},{className:"number",begin:"\\\\b\\\\d+[kKmMgGdshdwy]?\\\\b",relevance:0},a]};return{name:"Nginx config",aliases:["nginxconf"],contains:[e.HASH_COMMENT_MODE,{beginKeywords:"upstream location",end:/;|\\{/,contains:i.contains,keywords:{section:"upstream location"}},{className:"section",begin:n.concat(e.UNDERSCORE_IDENT_RE+n.lookahead(/\\s+\\{/)),relevance:0},{begin:n.lookahead(e.UNDERSCORE_IDENT_RE+"\\\\s"),end:";|\\\\{",contains:[{className:"attribute",begin:e.UNDERSCORE_IDENT_RE,starts:i}],relevance:0}],illegal:"[^\\\\s\\\\}\\\\{]"}}return Da=t,Da}var Ma,bs;function Pd(){if(bs)return Ma;bs=1;function t(e){return{name:"Nim",keywords:{keyword:["addr","and","as","asm","bind","block","break","case","cast","concept","const","continue","converter","defer","discard","distinct","div","do","elif","else","end","enum","except","export","finally","for","from","func","generic","guarded","if","import","in","include","interface","is","isnot","iterator","let","macro","method","mixin","mod","nil","not","notin","object","of","or","out","proc","ptr","raise","ref","return","shared","shl","shr","static","template","try","tuple","type","using","var","when","while","with","without","xor","yield"],literal:["true","false"],type:["int","int8","int16","int32","int64","uint","uint8","uint16","uint32","uint64","float","float32","float64","bool","char","string","cstring","pointer","expr","stmt","void","auto","any","range","array","openarray","varargs","seq","set","clong","culong","cchar","cschar","cshort","cint","csize","clonglong","cfloat","cdouble","clongdouble","cuchar","cushort","cuint","culonglong","cstringarray","semistatic"],built_in:["stdin","stdout","stderr","result"]},contains:[{className:"meta",begin:/\\{\\./,end:/\\.\\}/,relevance:10},{className:"string",begin:/[a-zA-Z]\\w*"/,end:/"/,contains:[{begin:/""/}]},{className:"string",begin:/([a-zA-Z]\\w*)?"""/,end:/"""/},e.QUOTE_STRING_MODE,{className:"type",begin:/\\b[A-Z]\\w+\\b/,relevance:0},{className:"number",relevance:0,variants:[{begin:/\\b(0[xX][0-9a-fA-F][_0-9a-fA-F]*)('?[iIuU](8|16|32|64))?/},{begin:/\\b(0o[0-7][_0-7]*)('?[iIuUfF](8|16|32|64))?/},{begin:/\\b(0(b|B)[01][_01]*)('?[iIuUfF](8|16|32|64))?/},{begin:/\\b(\\d[_\\d]*)('?[iIuUfF](8|16|32|64))?/}]},e.HASH_COMMENT_MODE]}}return Ma=t,Ma}var La,Rs;function kd(){if(Rs)return La;Rs=1;function t(e){const n=e.regex,a={keyword:["assert","else","if","in","inherit","let","or","rec","then","with"],literal:["true","false","null"],built_in:["abort","baseNameOf","builtins","derivation","derivationStrict","dirOf","fetchGit","fetchMercurial","fetchTarball","fetchTree","fromTOML","import","isNull","map","placeholder","removeAttrs","scopedImport","throw","toString"]},r={scope:"built_in",match:n.either(...["abort","add","addDrvOutputDependencies","addErrorContext","all","any","appendContext","attrNames","attrValues","baseNameOf","bitAnd","bitOr","bitXor","break","builtins","catAttrs","ceil","compareVersions","concatLists","concatMap","concatStringsSep","convertHash","currentSystem","currentTime","deepSeq","derivation","derivationStrict","dirOf","div","elem","elemAt","false","fetchGit","fetchMercurial","fetchTarball","fetchTree","fetchurl","filter","filterSource","findFile","flakeRefToString","floor","foldl'","fromJSON","fromTOML","functionArgs","genList","genericClosure","getAttr","getContext","getEnv","getFlake","groupBy","hasAttr","hasContext","hashFile","hashString","head","import","intersectAttrs","isAttrs","isBool","isFloat","isFunction","isInt","isList","isNull","isPath","isString","langVersion","length","lessThan","listToAttrs","map","mapAttrs","match","mul","nixPath","nixVersion","null","parseDrvName","parseFlakeRef","partition","path","pathExists","placeholder","readDir","readFile","readFileType","removeAttrs","replaceStrings","scopedImport","seq","sort","split","splitVersion","storeDir","storePath","stringLength","sub","substring","tail","throw","toFile","toJSON","toPath","toString","toXML","trace","traceVerbose","true","tryEval","typeOf","unsafeDiscardOutputDependency","unsafeDiscardStringContext","unsafeGetAttrPos","warn","zipAttrsWith"].map(M=>\`builtins\\\\.\${M}\`)),relevance:10},i="[A-Za-z_][A-Za-z0-9_'-]*",s={scope:"symbol",match:new RegExp(\`<\${i}(/\${i})*>\`)},o="[A-Za-z0-9_\\\\+\\\\.-]+",_={scope:"symbol",match:new RegExp(\`(\\\\.\\\\.|\\\\.|~)?/(\${o})?(/\${o})*(?=[\\\\s;])\`)},l=n.either("==","=","\\\\+\\\\+","\\\\+","<=","<\\\\|","<",">=",">","->","//","/","!=","!","\\\\|\\\\|","\\\\|>","\\\\?","\\\\*","&&"),c={scope:"operator",match:n.concat(l,/(?!-)/),relevance:0},d={scope:"number",match:new RegExp(\`\${e.NUMBER_RE}(?!-)\`),relevance:0},m={variants:[{scope:"operator",beforeMatch:/\\s/,begin:/-(?!>)/},{begin:[new RegExp(\`\${e.NUMBER_RE}\`),/-/,/(?!>)/],beginScope:{1:"number",2:"operator"}},{begin:[l,/-/,/(?!>)/],beginScope:{1:"operator",2:"operator"}}],relevance:0},p={beforeMatch:/(^|\\{|;)\\s*/,begin:new RegExp(\`\${i}(\\\\.\${i})*\\\\s*=(?!=)\`),returnBegin:!0,relevance:0,contains:[{scope:"attr",match:new RegExp(\`\${i}(\\\\.\${i})*(?=\\\\s*=)\`),relevance:.2}]},E={scope:"char.escape",match:/\\\\\\$/},g={scope:"char.escape",match:/''\\$/},S={scope:"subst",begin:/\\$\\{/,end:/\\}/,keywords:a},T={scope:"char.escape",match:/'''/},R={scope:"char.escape",match:/\\\\(?!\\$)./},f={scope:"string",variants:[{begin:"''",end:"''",contains:[g,S,T,R]},{begin:'"',end:'"',contains:[E,S,R]}]},A={scope:"params",match:new RegExp(\`\${i}\\\\s*:(?=\\\\s)\`)},N=[d,e.HASH_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,e.COMMENT(/\\/\\*\\*(?!\\/)/,/\\*\\//,{subLanguage:"markdown",relevance:0}),r,f,s,_,A,p,m,c];S.contains=N;const C=[{scope:"meta.prompt",match:/^nix-repl>(?=\\s)/,relevance:10},{scope:"meta",beforeMatch:/\\s+/,begin:/:([a-z]+|\\?)/}];return{name:"Nix",aliases:["nixos"],keywords:a,contains:N.concat(C)}}return La=t,La}var xa,fs;function Ud(){if(fs)return xa;fs=1;function t(e){return{name:"Node REPL",contains:[{className:"meta.prompt",starts:{end:/ |$/,starts:{end:"$",subLanguage:"javascript"}},variants:[{begin:/^>(?=[ ]|$)/},{begin:/^\\.\\.\\.(?=[ ]|$)/}]}]}}return xa=t,xa}var wa,Cs;function Fd(){if(Cs)return wa;Cs=1;function t(e){const n=e.regex,a=["ADMINTOOLS","APPDATA","CDBURN_AREA","CMDLINE","COMMONFILES32","COMMONFILES64","COMMONFILES","COOKIES","DESKTOP","DOCUMENTS","EXEDIR","EXEFILE","EXEPATH","FAVORITES","FONTS","HISTORY","HWNDPARENT","INSTDIR","INTERNET_CACHE","LANGUAGE","LOCALAPPDATA","MUSIC","NETHOOD","OUTDIR","PICTURES","PLUGINSDIR","PRINTHOOD","PROFILE","PROGRAMFILES32","PROGRAMFILES64","PROGRAMFILES","QUICKLAUNCH","RECENT","RESOURCES_LOCALIZED","RESOURCES","SENDTO","SMPROGRAMS","SMSTARTUP","STARTMENU","SYSDIR","TEMP","TEMPLATES","VIDEOS","WINDIR"],r=["ARCHIVE","FILE_ATTRIBUTE_ARCHIVE","FILE_ATTRIBUTE_NORMAL","FILE_ATTRIBUTE_OFFLINE","FILE_ATTRIBUTE_READONLY","FILE_ATTRIBUTE_SYSTEM","FILE_ATTRIBUTE_TEMPORARY","HKCR","HKCU","HKDD","HKEY_CLASSES_ROOT","HKEY_CURRENT_CONFIG","HKEY_CURRENT_USER","HKEY_DYN_DATA","HKEY_LOCAL_MACHINE","HKEY_PERFORMANCE_DATA","HKEY_USERS","HKLM","HKPD","HKU","IDABORT","IDCANCEL","IDIGNORE","IDNO","IDOK","IDRETRY","IDYES","MB_ABORTRETRYIGNORE","MB_DEFBUTTON1","MB_DEFBUTTON2","MB_DEFBUTTON3","MB_DEFBUTTON4","MB_ICONEXCLAMATION","MB_ICONINFORMATION","MB_ICONQUESTION","MB_ICONSTOP","MB_OK","MB_OKCANCEL","MB_RETRYCANCEL","MB_RIGHT","MB_RTLREADING","MB_SETFOREGROUND","MB_TOPMOST","MB_USERICON","MB_YESNO","NORMAL","OFFLINE","READONLY","SHCTX","SHELL_CONTEXT","SYSTEM|TEMPORARY"],i=["addincludedir","addplugindir","appendfile","assert","cd","define","delfile","echo","else","endif","error","execute","finalize","getdllversion","gettlbversion","if","ifdef","ifmacrodef","ifmacrondef","ifndef","include","insertmacro","macro","macroend","makensis","packhdr","searchparse","searchreplace","system","tempfile","undef","uninstfinalize","verbose","warning"],s={className:"variable.constant",begin:n.concat(/\\$/,n.either(...a))},o={className:"variable",begin:/\\$+\\{[\\!\\w.:-]+\\}/},_={className:"variable",begin:/\\$+\\w[\\w\\.]*/,illegal:/\\(\\)\\{\\}/},l={className:"variable",begin:/\\$+\\([\\w^.:!-]+\\)/},c={className:"params",begin:n.either(...r)},d={className:"keyword",begin:n.concat(/!/,n.either(...i))},m={className:"char.escape",begin:/\\$(\\\\[nrt]|\\$)/},p={className:"title.function",begin:/\\w+::\\w+/},E={className:"string",variants:[{begin:'"',end:'"'},{begin:"'",end:"'"},{begin:"\`",end:"\`"}],illegal:/\\n/,contains:[m,s,o,_,l]},g=["Abort","AddBrandingImage","AddSize","AllowRootDirInstall","AllowSkipFiles","AutoCloseWindow","BGFont","BGGradient","BrandingText","BringToFront","Call","CallInstDLL","Caption","ChangeUI","CheckBitmap","ClearErrors","CompletedText","ComponentText","CopyFiles","CRCCheck","CreateDirectory","CreateFont","CreateShortCut","Delete","DeleteINISec","DeleteINIStr","DeleteRegKey","DeleteRegValue","DetailPrint","DetailsButtonText","DirText","DirVar","DirVerify","EnableWindow","EnumRegKey","EnumRegValue","Exch","Exec","ExecShell","ExecShellWait","ExecWait","ExpandEnvStrings","File","FileBufSize","FileClose","FileErrorText","FileOpen","FileRead","FileReadByte","FileReadUTF16LE","FileReadWord","FileWriteUTF16LE","FileSeek","FileWrite","FileWriteByte","FileWriteWord","FindClose","FindFirst","FindNext","FindWindow","FlushINI","GetCurInstType","GetCurrentAddress","GetDlgItem","GetDLLVersion","GetDLLVersionLocal","GetErrorLevel","GetFileTime","GetFileTimeLocal","GetFullPathName","GetFunctionAddress","GetInstDirError","GetKnownFolderPath","GetLabelAddress","GetTempFileName","GetWinVer","Goto","HideWindow","Icon","IfAbort","IfErrors","IfFileExists","IfRebootFlag","IfRtlLanguage","IfShellVarContextAll","IfSilent","InitPluginsDir","InstallButtonText","InstallColors","InstallDir","InstallDirRegKey","InstProgressFlags","InstType","InstTypeGetText","InstTypeSetText","Int64Cmp","Int64CmpU","Int64Fmt","IntCmp","IntCmpU","IntFmt","IntOp","IntPtrCmp","IntPtrCmpU","IntPtrOp","IsWindow","LangString","LicenseBkColor","LicenseData","LicenseForceSelection","LicenseLangString","LicenseText","LoadAndSetImage","LoadLanguageFile","LockWindow","LogSet","LogText","ManifestDPIAware","ManifestLongPathAware","ManifestMaxVersionTested","ManifestSupportedOS","MessageBox","MiscButtonText","Name|0","Nop","OutFile","Page","PageCallbacks","PEAddResource","PEDllCharacteristics","PERemoveResource","PESubsysVer","Pop","Push","Quit","ReadEnvStr","ReadINIStr","ReadRegDWORD","ReadRegStr","Reboot","RegDLL","Rename","RequestExecutionLevel","ReserveFile","Return","RMDir","SearchPath","SectionGetFlags","SectionGetInstTypes","SectionGetSize","SectionGetText","SectionIn","SectionSetFlags","SectionSetInstTypes","SectionSetSize","SectionSetText","SendMessage","SetAutoClose","SetBrandingImage","SetCompress","SetCompressor","SetCompressorDictSize","SetCtlColors","SetCurInstType","SetDatablockOptimize","SetDateSave","SetDetailsPrint","SetDetailsView","SetErrorLevel","SetErrors","SetFileAttributes","SetFont","SetOutPath","SetOverwrite","SetRebootFlag","SetRegView","SetShellVarContext","SetSilent","ShowInstDetails","ShowUninstDetails","ShowWindow","SilentInstall","SilentUnInstall","Sleep","SpaceTexts","StrCmp","StrCmpS","StrCpy","StrLen","SubCaption","Unicode","UninstallButtonText","UninstallCaption","UninstallIcon","UninstallSubCaption","UninstallText","UninstPage","UnRegDLL","Var","VIAddVersionKey","VIFileVersion","VIProductVersion","WindowIcon","WriteINIStr","WriteRegBin","WriteRegDWORD","WriteRegExpandStr","WriteRegMultiStr","WriteRegNone","WriteRegStr","WriteUninstaller","XPStyle"],S=["admin","all","auto","both","bottom","bzip2","colored","components","current","custom","directory","false","force","hide","highest","ifdiff","ifnewer","instfiles","lastused","leave","left","license","listonly","lzma","nevershow","none","normal","notset","off","on","open","print","right","show","silent","silentlog","smooth","textonly","top","true","try","un.components","un.custom","un.directory","un.instfiles","un.license","uninstConfirm","user","Win10","Win7","Win8","WinVista","zlib"],T={match:[/Function/,/\\s+/,n.concat(/(\\.)?/,e.IDENT_RE)],scope:{1:"keyword",3:"title.function"}},f={match:[/Var/,/\\s+/,/(?:\\/GLOBAL\\s+)?/,/[A-Za-z][\\w.]*/],scope:{1:"keyword",3:"params",4:"variable"}};return{name:"NSIS",case_insensitive:!0,keywords:{keyword:g,literal:S},contains:[e.HASH_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,e.COMMENT(";","$",{relevance:0}),f,T,{beginKeywords:"Function PageEx Section SectionGroup FunctionEnd SectionEnd"},E,d,o,_,l,c,p,e.NUMBER_MODE]}}return wa=t,wa}var Pa,Ns;function Bd(){if(Ns)return Pa;Ns=1;function t(e){const n={className:"built_in",begin:"\\\\b(AV|CA|CF|CG|CI|CL|CM|CN|CT|MK|MP|MTK|MTL|NS|SCN|SK|UI|WK|XC)\\\\w+"},a=/[a-zA-Z@][a-zA-Z0-9_]*/,_={"variable.language":["this","super"],$pattern:a,keyword:["while","export","sizeof","typedef","const","struct","for","union","volatile","static","mutable","if","do","return","goto","enum","else","break","extern","asm","case","default","register","explicit","typename","switch","continue","inline","readonly","assign","readwrite","self","@synchronized","id","typeof","nonatomic","IBOutlet","IBAction","strong","weak","copy","in","out","inout","bycopy","byref","oneway","__strong","__weak","__block","__autoreleasing","@private","@protected","@public","@try","@property","@end","@throw","@catch","@finally","@autoreleasepool","@synthesize","@dynamic","@selector","@optional","@required","@encode","@package","@import","@defs","@compatibility_alias","__bridge","__bridge_transfer","__bridge_retained","__bridge_retain","__covariant","__contravariant","__kindof","_Nonnull","_Nullable","_Null_unspecified","__FUNCTION__","__PRETTY_FUNCTION__","__attribute__","getter","setter","retain","unsafe_unretained","nonnull","nullable","null_unspecified","null_resettable","class","instancetype","NS_DESIGNATED_INITIALIZER","NS_UNAVAILABLE","NS_REQUIRES_SUPER","NS_RETURNS_INNER_POINTER","NS_INLINE","NS_AVAILABLE","NS_DEPRECATED","NS_ENUM","NS_OPTIONS","NS_SWIFT_UNAVAILABLE","NS_ASSUME_NONNULL_BEGIN","NS_ASSUME_NONNULL_END","NS_REFINED_FOR_SWIFT","NS_SWIFT_NAME","NS_SWIFT_NOTHROW","NS_DURING","NS_HANDLER","NS_ENDHANDLER","NS_VALUERETURN","NS_VOIDRETURN"],literal:["false","true","FALSE","TRUE","nil","YES","NO","NULL"],built_in:["dispatch_once_t","dispatch_queue_t","dispatch_sync","dispatch_async","dispatch_once"],type:["int","float","char","unsigned","signed","short","long","double","wchar_t","unichar","void","bool","BOOL","id|0","_Bool"]},l={$pattern:a,keyword:["@interface","@class","@protocol","@implementation"]};return{name:"Objective-C",aliases:["mm","objc","obj-c","obj-c++","objective-c++"],keywords:_,illegal:"</",contains:[n,e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,e.C_NUMBER_MODE,e.QUOTE_STRING_MODE,e.APOS_STRING_MODE,{className:"string",variants:[{begin:'@"',end:'"',illegal:"\\\\n",contains:[e.BACKSLASH_ESCAPE]}]},{className:"meta",begin:/#\\s*[a-z]+\\b/,end:/$/,keywords:{keyword:"if else elif endif define undef warning error line pragma ifdef ifndef include"},contains:[{begin:/\\\\\\n/,relevance:0},e.inherit(e.QUOTE_STRING_MODE,{className:"string"}),{className:"string",begin:/<.*?>/,end:/$/,illegal:"\\\\n"},e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE]},{className:"class",begin:"("+l.keyword.join("|")+")\\\\b",end:/(\\{|$)/,excludeEnd:!0,keywords:l,contains:[e.UNDERSCORE_TITLE_MODE]},{begin:"\\\\."+e.UNDERSCORE_IDENT_RE,relevance:0}]}}return Pa=t,Pa}var ka,Os;function Gd(){if(Os)return ka;Os=1;function t(e){return{name:"OCaml",aliases:["ml"],keywords:{$pattern:"[a-z_]\\\\w*!?",keyword:"and as assert asr begin class constraint do done downto else end exception external for fun function functor if in include inherit! inherit initializer land lazy let lor lsl lsr lxor match method!|10 method mod module mutable new object of open! open or private rec sig struct then to try type val! val virtual when while with parser value",built_in:"array bool bytes char exn|5 float int int32 int64 list lazy_t|5 nativeint|5 string unit in_channel out_channel ref",literal:"true false"},illegal:/\\/\\/|>>/,contains:[{className:"literal",begin:"\\\\[(\\\\|\\\\|)?\\\\]|\\\\(\\\\)",relevance:0},e.COMMENT("\\\\(\\\\*","\\\\*\\\\)",{contains:["self"]}),{className:"symbol",begin:"'[A-Za-z_](?!')[\\\\w']*"},{className:"type",begin:"\`[A-Z][\\\\w']*"},{className:"type",begin:"\\\\b[A-Z][\\\\w']*",relevance:0},{begin:"[a-z_]\\\\w*'[\\\\w']*",relevance:0},e.inherit(e.APOS_STRING_MODE,{className:"string",relevance:0}),e.inherit(e.QUOTE_STRING_MODE,{illegal:null}),{className:"number",begin:"\\\\b(0[xX][a-fA-F0-9_]+[Lln]?|0[oO][0-7_]+[Lln]?|0[bB][01_]+[Lln]?|[0-9][0-9_]*([Lln]|(\\\\.[0-9_]*)?([eE][-+]?[0-9_]+)?)?)",relevance:0},{begin:/->/}]}}return ka=t,ka}var Ua,Is;function Yd(){if(Is)return Ua;Is=1;function t(e){const n={className:"keyword",begin:"\\\\$(f[asn]|t|vp[rtd]|children)"},a={className:"literal",begin:"false|true|PI|undef"},r={className:"number",begin:"\\\\b\\\\d+(\\\\.\\\\d+)?(e-?\\\\d+)?",relevance:0},i=e.inherit(e.QUOTE_STRING_MODE,{illegal:null}),s={className:"meta",keywords:{keyword:"include use"},begin:"include|use <",end:">"},o={className:"params",begin:"\\\\(",end:"\\\\)",contains:["self",r,i,n,a]},_={begin:"[*!#%]",relevance:0},l={className:"function",beginKeywords:"module function",end:/=|\\{/,contains:[o,e.UNDERSCORE_TITLE_MODE]};return{name:"OpenSCAD",aliases:["scad"],keywords:{keyword:"function module include use for intersection_for if else \\\\%",literal:"false true PI undef",built_in:"circle square polygon text sphere cube cylinder polyhedron translate rotate scale resize mirror multmatrix color offset hull minkowski union difference intersection abs sign sin cos tan acos asin atan atan2 floor round ceil ln log pow sqrt exp rands min max concat lookup str chr search version version_num norm cross parent_module echo import import_dxf dxf_linear_extrude linear_extrude rotate_extrude surface projection render children dxf_cross dxf_dim let assign"},contains:[e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,r,s,i,n,_,l]}}return Ua=t,Ua}var Fa,As;function qd(){if(As)return Fa;As=1;function t(e){const n={$pattern:/\\.?\\w+/,keyword:"abstract add and array as asc aspect assembly async begin break block by case class concat const copy constructor continue create default delegate desc distinct div do downto dynamic each else empty end ensure enum equals event except exit extension external false final finalize finalizer finally flags for forward from function future global group has if implementation implements implies in index inherited inline interface into invariants is iterator join locked locking loop matching method mod module namespace nested new nil not notify nullable of old on operator or order out override parallel params partial pinned private procedure property protected public queryable raise read readonly record reintroduce remove repeat require result reverse sealed select self sequence set shl shr skip static step soft take then to true try tuple type union unit unsafe until uses using var virtual raises volatile where while with write xor yield await mapped deprecated stdcall cdecl pascal register safecall overload library platform reference packed strict published autoreleasepool selector strong weak unretained"},a=e.COMMENT(/\\{/,/\\}/,{relevance:0}),r=e.COMMENT("\\\\(\\\\*","\\\\*\\\\)",{relevance:10}),i={className:"string",begin:"'",end:"'",contains:[{begin:"''"}]},s={className:"string",begin:"(#\\\\d+)+"},o={beginKeywords:"function constructor destructor procedure method",end:"[:;]",keywords:"function constructor|10 destructor|10 procedure|10 method|10",contains:[e.inherit(e.TITLE_MODE,{scope:"title.function"}),{className:"params",begin:"\\\\(",end:"\\\\)",keywords:n,contains:[i,s]},a,r]},_={scope:"punctuation",match:/;/,relevance:0};return{name:"Oxygene",case_insensitive:!0,keywords:n,illegal:'("|\\\\$[G-Zg-z]|\\\\/\\\\*|</|=>|->)',contains:[a,r,e.C_LINE_COMMENT_MODE,i,s,e.NUMBER_MODE,o,_]}}return Fa=t,Fa}var Ba,vs;function Hd(){if(vs)return Ba;vs=1;function t(e){const n=e.COMMENT(/\\{/,/\\}/,{contains:["self"]});return{name:"Parser3",subLanguage:"xml",relevance:0,contains:[e.COMMENT("^#","$"),e.COMMENT(/\\^rem\\{/,/\\}/,{relevance:10,contains:[n]}),{className:"meta",begin:"^@(?:BASE|USE|CLASS|OPTIONS)$",relevance:10},{className:"title",begin:"@[\\\\w\\\\-]+\\\\[[\\\\w^;\\\\-]*\\\\](?:\\\\[[\\\\w^;\\\\-]*\\\\])?(?:.*)$"},{className:"variable",begin:/\\$\\{?[\\w\\-.:]+\\}?/},{className:"keyword",begin:/\\^[\\w\\-.:]+/},{className:"number",begin:"\\\\^#[0-9a-fA-F]+"},e.C_NUMBER_MODE]}}return Ba=t,Ba}var Ga,ys;function Vd(){if(ys)return Ga;ys=1;function t(e){const n={className:"variable",begin:/\\$[\\w\\d#@][\\w\\d_]*/,relevance:0},a={className:"variable",begin:/<(?!\\/)/,end:/>/};return{name:"Packet Filter config",aliases:["pf.conf"],keywords:{$pattern:/[a-z0-9_<>-]+/,built_in:"block match pass load anchor|5 antispoof|10 set table",keyword:"in out log quick on rdomain inet inet6 proto from port os to route allow-opts divert-packet divert-reply divert-to flags group icmp-type icmp6-type label once probability recieved-on rtable prio queue tos tag tagged user keep fragment for os drop af-to|10 binat-to|10 nat-to|10 rdr-to|10 bitmask least-stats random round-robin source-hash static-port dup-to reply-to route-to parent bandwidth default min max qlimit block-policy debug fingerprints hostid limit loginterface optimization reassemble ruleset-optimization basic none profile skip state-defaults state-policy timeout const counters persist no modulate synproxy state|5 floating if-bound no-sync pflow|10 sloppy source-track global rule max-src-nodes max-src-states max-src-conn max-src-conn-rate overload flush scrub|5 max-mss min-ttl no-df|10 random-id",literal:"all any no-route self urpf-failed egress|5 unknown"},contains:[e.HASH_COMMENT_MODE,e.NUMBER_MODE,e.QUOTE_STRING_MODE,n,a]}}return Ga=t,Ga}var Ya,hs;function zd(){if(hs)return Ya;hs=1;function t(e){const n=e.COMMENT("--","$"),a="[a-zA-Z_][a-zA-Z_0-9$]*",r="\\\\$([a-zA-Z_]?|[a-zA-Z_][a-zA-Z_0-9]*)\\\\$",i="<<\\\\s*"+a+"\\\\s*>>",s="ABORT ALTER ANALYZE BEGIN CALL CHECKPOINT|10 CLOSE CLUSTER COMMENT COMMIT COPY CREATE DEALLOCATE DECLARE DELETE DISCARD DO DROP END EXECUTE EXPLAIN FETCH GRANT IMPORT INSERT LISTEN LOAD LOCK MOVE NOTIFY PREPARE REASSIGN|10 REFRESH REINDEX RELEASE RESET REVOKE ROLLBACK SAVEPOINT SECURITY SELECT SET SHOW START TRUNCATE UNLISTEN|10 UPDATE VACUUM|10 VALUES AGGREGATE COLLATION CONVERSION|10 DATABASE DEFAULT PRIVILEGES DOMAIN TRIGGER EXTENSION FOREIGN WRAPPER|10 TABLE FUNCTION GROUP LANGUAGE LARGE OBJECT MATERIALIZED VIEW OPERATOR CLASS FAMILY POLICY PUBLICATION|10 ROLE RULE SCHEMA SEQUENCE SERVER STATISTICS SUBSCRIPTION SYSTEM TABLESPACE CONFIGURATION DICTIONARY PARSER TEMPLATE TYPE USER MAPPING PREPARED ACCESS METHOD CAST AS TRANSFORM TRANSACTION OWNED TO INTO SESSION AUTHORIZATION INDEX PROCEDURE ASSERTION ALL ANALYSE AND ANY ARRAY ASC ASYMMETRIC|10 BOTH CASE CHECK COLLATE COLUMN CONCURRENTLY|10 CONSTRAINT CROSS DEFERRABLE RANGE DESC DISTINCT ELSE EXCEPT FOR FREEZE|10 FROM FULL HAVING ILIKE IN INITIALLY INNER INTERSECT IS ISNULL JOIN LATERAL LEADING LIKE LIMIT NATURAL NOT NOTNULL NULL OFFSET ON ONLY OR ORDER OUTER OVERLAPS PLACING PRIMARY REFERENCES RETURNING SIMILAR SOME SYMMETRIC TABLESAMPLE THEN TRAILING UNION UNIQUE USING VARIADIC|10 VERBOSE WHEN WHERE WINDOW WITH BY RETURNS INOUT OUT SETOF|10 IF STRICT CURRENT CONTINUE OWNER LOCATION OVER PARTITION WITHIN BETWEEN ESCAPE EXTERNAL INVOKER DEFINER WORK RENAME VERSION CONNECTION CONNECT TABLES TEMP TEMPORARY FUNCTIONS SEQUENCES TYPES SCHEMAS OPTION CASCADE RESTRICT ADD ADMIN EXISTS VALID VALIDATE ENABLE DISABLE REPLICA|10 ALWAYS PASSING COLUMNS PATH REF VALUE OVERRIDING IMMUTABLE STABLE VOLATILE BEFORE AFTER EACH ROW PROCEDURAL ROUTINE NO HANDLER VALIDATOR OPTIONS STORAGE OIDS|10 WITHOUT INHERIT DEPENDS CALLED INPUT LEAKPROOF|10 COST ROWS NOWAIT SEARCH UNTIL ENCRYPTED|10 PASSWORD CONFLICT|10 INSTEAD INHERITS CHARACTERISTICS WRITE CURSOR ALSO STATEMENT SHARE EXCLUSIVE INLINE ISOLATION REPEATABLE READ COMMITTED SERIALIZABLE UNCOMMITTED LOCAL GLOBAL SQL PROCEDURES RECURSIVE SNAPSHOT ROLLUP CUBE TRUSTED|10 INCLUDE FOLLOWING PRECEDING UNBOUNDED RANGE GROUPS UNENCRYPTED|10 SYSID FORMAT DELIMITER HEADER QUOTE ENCODING FILTER OFF FORCE_QUOTE FORCE_NOT_NULL FORCE_NULL COSTS BUFFERS TIMING SUMMARY DISABLE_PAGE_SKIPPING RESTART CYCLE GENERATED IDENTITY DEFERRED IMMEDIATE LEVEL LOGGED UNLOGGED OF NOTHING NONE EXCLUDE ATTRIBUTE USAGE ROUTINES TRUE FALSE NAN INFINITY ",o="SUPERUSER NOSUPERUSER CREATEDB NOCREATEDB CREATEROLE NOCREATEROLE INHERIT NOINHERIT LOGIN NOLOGIN REPLICATION NOREPLICATION BYPASSRLS NOBYPASSRLS ",_="ALIAS BEGIN CONSTANT DECLARE END EXCEPTION RETURN PERFORM|10 RAISE GET DIAGNOSTICS STACKED|10 FOREACH LOOP ELSIF EXIT WHILE REVERSE SLICE DEBUG LOG INFO NOTICE WARNING ASSERT OPEN ",l="BIGINT INT8 BIGSERIAL SERIAL8 BIT VARYING VARBIT BOOLEAN BOOL BOX BYTEA CHARACTER CHAR VARCHAR CIDR CIRCLE DATE DOUBLE PRECISION FLOAT8 FLOAT INET INTEGER INT INT4 INTERVAL JSON JSONB LINE LSEG|10 MACADDR MACADDR8 MONEY NUMERIC DEC DECIMAL PATH POINT POLYGON REAL FLOAT4 SMALLINT INT2 SMALLSERIAL|10 SERIAL2|10 SERIAL|10 SERIAL4|10 TEXT TIME ZONE TIMETZ|10 TIMESTAMP TIMESTAMPTZ|10 TSQUERY|10 TSVECTOR|10 TXID_SNAPSHOT|10 UUID XML NATIONAL NCHAR INT4RANGE|10 INT8RANGE|10 NUMRANGE|10 TSRANGE|10 TSTZRANGE|10 DATERANGE|10 ANYELEMENT ANYARRAY ANYNONARRAY ANYENUM ANYRANGE CSTRING INTERNAL RECORD PG_DDL_COMMAND VOID UNKNOWN OPAQUE REFCURSOR NAME OID REGPROC|10 REGPROCEDURE|10 REGOPER|10 REGOPERATOR|10 REGCLASS|10 REGTYPE|10 REGROLE|10 REGNAMESPACE|10 REGCONFIG|10 REGDICTIONARY|10 ",c=l.trim().split(" ").map(function(S){return S.split("|")[0]}).join("|"),d="CURRENT_TIME CURRENT_TIMESTAMP CURRENT_USER CURRENT_CATALOG|10 CURRENT_DATE LOCALTIME LOCALTIMESTAMP CURRENT_ROLE|10 CURRENT_SCHEMA|10 SESSION_USER PUBLIC ",m="FOUND NEW OLD TG_NAME|10 TG_WHEN|10 TG_LEVEL|10 TG_OP|10 TG_RELID|10 TG_RELNAME|10 TG_TABLE_NAME|10 TG_TABLE_SCHEMA|10 TG_NARGS|10 TG_ARGV|10 TG_EVENT|10 TG_TAG|10 ROW_COUNT RESULT_OID|10 PG_CONTEXT|10 RETURNED_SQLSTATE COLUMN_NAME CONSTRAINT_NAME PG_DATATYPE_NAME|10 MESSAGE_TEXT TABLE_NAME SCHEMA_NAME PG_EXCEPTION_DETAIL|10 PG_EXCEPTION_HINT|10 PG_EXCEPTION_CONTEXT|10 ",p="SQLSTATE SQLERRM|10 SUCCESSFUL_COMPLETION WARNING DYNAMIC_RESULT_SETS_RETURNED IMPLICIT_ZERO_BIT_PADDING NULL_VALUE_ELIMINATED_IN_SET_FUNCTION PRIVILEGE_NOT_GRANTED PRIVILEGE_NOT_REVOKED STRING_DATA_RIGHT_TRUNCATION DEPRECATED_FEATURE NO_DATA NO_ADDITIONAL_DYNAMIC_RESULT_SETS_RETURNED SQL_STATEMENT_NOT_YET_COMPLETE CONNECTION_EXCEPTION CONNECTION_DOES_NOT_EXIST CONNECTION_FAILURE SQLCLIENT_UNABLE_TO_ESTABLISH_SQLCONNECTION SQLSERVER_REJECTED_ESTABLISHMENT_OF_SQLCONNECTION TRANSACTION_RESOLUTION_UNKNOWN PROTOCOL_VIOLATION TRIGGERED_ACTION_EXCEPTION FEATURE_NOT_SUPPORTED INVALID_TRANSACTION_INITIATION LOCATOR_EXCEPTION INVALID_LOCATOR_SPECIFICATION INVALID_GRANTOR INVALID_GRANT_OPERATION INVALID_ROLE_SPECIFICATION DIAGNOSTICS_EXCEPTION STACKED_DIAGNOSTICS_ACCESSED_WITHOUT_ACTIVE_HANDLER CASE_NOT_FOUND CARDINALITY_VIOLATION DATA_EXCEPTION ARRAY_SUBSCRIPT_ERROR CHARACTER_NOT_IN_REPERTOIRE DATETIME_FIELD_OVERFLOW DIVISION_BY_ZERO ERROR_IN_ASSIGNMENT ESCAPE_CHARACTER_CONFLICT INDICATOR_OVERFLOW INTERVAL_FIELD_OVERFLOW INVALID_ARGUMENT_FOR_LOGARITHM INVALID_ARGUMENT_FOR_NTILE_FUNCTION INVALID_ARGUMENT_FOR_NTH_VALUE_FUNCTION INVALID_ARGUMENT_FOR_POWER_FUNCTION INVALID_ARGUMENT_FOR_WIDTH_BUCKET_FUNCTION INVALID_CHARACTER_VALUE_FOR_CAST INVALID_DATETIME_FORMAT INVALID_ESCAPE_CHARACTER INVALID_ESCAPE_OCTET INVALID_ESCAPE_SEQUENCE NONSTANDARD_USE_OF_ESCAPE_CHARACTER INVALID_INDICATOR_PARAMETER_VALUE INVALID_PARAMETER_VALUE INVALID_REGULAR_EXPRESSION INVALID_ROW_COUNT_IN_LIMIT_CLAUSE INVALID_ROW_COUNT_IN_RESULT_OFFSET_CLAUSE INVALID_TABLESAMPLE_ARGUMENT INVALID_TABLESAMPLE_REPEAT INVALID_TIME_ZONE_DISPLACEMENT_VALUE INVALID_USE_OF_ESCAPE_CHARACTER MOST_SPECIFIC_TYPE_MISMATCH NULL_VALUE_NOT_ALLOWED NULL_VALUE_NO_INDICATOR_PARAMETER NUMERIC_VALUE_OUT_OF_RANGE SEQUENCE_GENERATOR_LIMIT_EXCEEDED STRING_DATA_LENGTH_MISMATCH STRING_DATA_RIGHT_TRUNCATION SUBSTRING_ERROR TRIM_ERROR UNTERMINATED_C_STRING ZERO_LENGTH_CHARACTER_STRING FLOATING_POINT_EXCEPTION INVALID_TEXT_REPRESENTATION INVALID_BINARY_REPRESENTATION BAD_COPY_FILE_FORMAT UNTRANSLATABLE_CHARACTER NOT_AN_XML_DOCUMENT INVALID_XML_DOCUMENT INVALID_XML_CONTENT INVALID_XML_COMMENT INVALID_XML_PROCESSING_INSTRUCTION INTEGRITY_CONSTRAINT_VIOLATION RESTRICT_VIOLATION NOT_NULL_VIOLATION FOREIGN_KEY_VIOLATION UNIQUE_VIOLATION CHECK_VIOLATION EXCLUSION_VIOLATION INVALID_CURSOR_STATE INVALID_TRANSACTION_STATE ACTIVE_SQL_TRANSACTION BRANCH_TRANSACTION_ALREADY_ACTIVE HELD_CURSOR_REQUIRES_SAME_ISOLATION_LEVEL INAPPROPRIATE_ACCESS_MODE_FOR_BRANCH_TRANSACTION INAPPROPRIATE_ISOLATION_LEVEL_FOR_BRANCH_TRANSACTION NO_ACTIVE_SQL_TRANSACTION_FOR_BRANCH_TRANSACTION READ_ONLY_SQL_TRANSACTION SCHEMA_AND_DATA_STATEMENT_MIXING_NOT_SUPPORTED NO_ACTIVE_SQL_TRANSACTION IN_FAILED_SQL_TRANSACTION IDLE_IN_TRANSACTION_SESSION_TIMEOUT INVALID_SQL_STATEMENT_NAME TRIGGERED_DATA_CHANGE_VIOLATION INVALID_AUTHORIZATION_SPECIFICATION INVALID_PASSWORD DEPENDENT_PRIVILEGE_DESCRIPTORS_STILL_EXIST DEPENDENT_OBJECTS_STILL_EXIST INVALID_TRANSACTION_TERMINATION SQL_ROUTINE_EXCEPTION FUNCTION_EXECUTED_NO_RETURN_STATEMENT MODIFYING_SQL_DATA_NOT_PERMITTED PROHIBITED_SQL_STATEMENT_ATTEMPTED READING_SQL_DATA_NOT_PERMITTED INVALID_CURSOR_NAME EXTERNAL_ROUTINE_EXCEPTION CONTAINING_SQL_NOT_PERMITTED MODIFYING_SQL_DATA_NOT_PERMITTED PROHIBITED_SQL_STATEMENT_ATTEMPTED READING_SQL_DATA_NOT_PERMITTED EXTERNAL_ROUTINE_INVOCATION_EXCEPTION INVALID_SQLSTATE_RETURNED NULL_VALUE_NOT_ALLOWED TRIGGER_PROTOCOL_VIOLATED SRF_PROTOCOL_VIOLATED EVENT_TRIGGER_PROTOCOL_VIOLATED SAVEPOINT_EXCEPTION INVALID_SAVEPOINT_SPECIFICATION INVALID_CATALOG_NAME INVALID_SCHEMA_NAME TRANSACTION_ROLLBACK TRANSACTION_INTEGRITY_CONSTRAINT_VIOLATION SERIALIZATION_FAILURE STATEMENT_COMPLETION_UNKNOWN DEADLOCK_DETECTED SYNTAX_ERROR_OR_ACCESS_RULE_VIOLATION SYNTAX_ERROR INSUFFICIENT_PRIVILEGE CANNOT_COERCE GROUPING_ERROR WINDOWING_ERROR INVALID_RECURSION INVALID_FOREIGN_KEY INVALID_NAME NAME_TOO_LONG RESERVED_NAME DATATYPE_MISMATCH INDETERMINATE_DATATYPE COLLATION_MISMATCH INDETERMINATE_COLLATION WRONG_OBJECT_TYPE GENERATED_ALWAYS UNDEFINED_COLUMN UNDEFINED_FUNCTION UNDEFINED_TABLE UNDEFINED_PARAMETER UNDEFINED_OBJECT DUPLICATE_COLUMN DUPLICATE_CURSOR DUPLICATE_DATABASE DUPLICATE_FUNCTION DUPLICATE_PREPARED_STATEMENT DUPLICATE_SCHEMA DUPLICATE_TABLE DUPLICATE_ALIAS DUPLICATE_OBJECT AMBIGUOUS_COLUMN AMBIGUOUS_FUNCTION AMBIGUOUS_PARAMETER AMBIGUOUS_ALIAS INVALID_COLUMN_REFERENCE INVALID_COLUMN_DEFINITION INVALID_CURSOR_DEFINITION INVALID_DATABASE_DEFINITION INVALID_FUNCTION_DEFINITION INVALID_PREPARED_STATEMENT_DEFINITION INVALID_SCHEMA_DEFINITION INVALID_TABLE_DEFINITION INVALID_OBJECT_DEFINITION WITH_CHECK_OPTION_VIOLATION INSUFFICIENT_RESOURCES DISK_FULL OUT_OF_MEMORY TOO_MANY_CONNECTIONS CONFIGURATION_LIMIT_EXCEEDED PROGRAM_LIMIT_EXCEEDED STATEMENT_TOO_COMPLEX TOO_MANY_COLUMNS TOO_MANY_ARGUMENTS OBJECT_NOT_IN_PREREQUISITE_STATE OBJECT_IN_USE CANT_CHANGE_RUNTIME_PARAM LOCK_NOT_AVAILABLE OPERATOR_INTERVENTION QUERY_CANCELED ADMIN_SHUTDOWN CRASH_SHUTDOWN CANNOT_CONNECT_NOW DATABASE_DROPPED SYSTEM_ERROR IO_ERROR UNDEFINED_FILE DUPLICATE_FILE SNAPSHOT_TOO_OLD CONFIG_FILE_ERROR LOCK_FILE_EXISTS FDW_ERROR FDW_COLUMN_NAME_NOT_FOUND FDW_DYNAMIC_PARAMETER_VALUE_NEEDED FDW_FUNCTION_SEQUENCE_ERROR FDW_INCONSISTENT_DESCRIPTOR_INFORMATION FDW_INVALID_ATTRIBUTE_VALUE FDW_INVALID_COLUMN_NAME FDW_INVALID_COLUMN_NUMBER FDW_INVALID_DATA_TYPE FDW_INVALID_DATA_TYPE_DESCRIPTORS FDW_INVALID_DESCRIPTOR_FIELD_IDENTIFIER FDW_INVALID_HANDLE FDW_INVALID_OPTION_INDEX FDW_INVALID_OPTION_NAME FDW_INVALID_STRING_LENGTH_OR_BUFFER_LENGTH FDW_INVALID_STRING_FORMAT FDW_INVALID_USE_OF_NULL_POINTER FDW_TOO_MANY_HANDLES FDW_OUT_OF_MEMORY FDW_NO_SCHEMAS FDW_OPTION_NAME_NOT_FOUND FDW_REPLY_HANDLE FDW_SCHEMA_NOT_FOUND FDW_TABLE_NOT_FOUND FDW_UNABLE_TO_CREATE_EXECUTION FDW_UNABLE_TO_CREATE_REPLY FDW_UNABLE_TO_ESTABLISH_CONNECTION PLPGSQL_ERROR RAISE_EXCEPTION NO_DATA_FOUND TOO_MANY_ROWS ASSERT_FAILURE INTERNAL_ERROR DATA_CORRUPTED INDEX_CORRUPTED ",g="ARRAY_AGG AVG BIT_AND BIT_OR BOOL_AND BOOL_OR COUNT EVERY JSON_AGG JSONB_AGG JSON_OBJECT_AGG JSONB_OBJECT_AGG MAX MIN MODE STRING_AGG SUM XMLAGG CORR COVAR_POP COVAR_SAMP REGR_AVGX REGR_AVGY REGR_COUNT REGR_INTERCEPT REGR_R2 REGR_SLOPE REGR_SXX REGR_SXY REGR_SYY STDDEV STDDEV_POP STDDEV_SAMP VARIANCE VAR_POP VAR_SAMP PERCENTILE_CONT PERCENTILE_DISC ROW_NUMBER RANK DENSE_RANK PERCENT_RANK CUME_DIST NTILE LAG LEAD FIRST_VALUE LAST_VALUE NTH_VALUE NUM_NONNULLS NUM_NULLS ABS CBRT CEIL CEILING DEGREES DIV EXP FLOOR LN LOG MOD PI POWER RADIANS ROUND SCALE SIGN SQRT TRUNC WIDTH_BUCKET RANDOM SETSEED ACOS ACOSD ASIN ASIND ATAN ATAND ATAN2 ATAN2D COS COSD COT COTD SIN SIND TAN TAND BIT_LENGTH CHAR_LENGTH CHARACTER_LENGTH LOWER OCTET_LENGTH OVERLAY POSITION SUBSTRING TREAT TRIM UPPER ASCII BTRIM CHR CONCAT CONCAT_WS CONVERT CONVERT_FROM CONVERT_TO DECODE ENCODE INITCAP LEFT LENGTH LPAD LTRIM MD5 PARSE_IDENT PG_CLIENT_ENCODING QUOTE_IDENT|10 QUOTE_LITERAL|10 QUOTE_NULLABLE|10 REGEXP_MATCH REGEXP_MATCHES REGEXP_REPLACE REGEXP_SPLIT_TO_ARRAY REGEXP_SPLIT_TO_TABLE REPEAT REPLACE REVERSE RIGHT RPAD RTRIM SPLIT_PART STRPOS SUBSTR TO_ASCII TO_HEX TRANSLATE OCTET_LENGTH GET_BIT GET_BYTE SET_BIT SET_BYTE TO_CHAR TO_DATE TO_NUMBER TO_TIMESTAMP AGE CLOCK_TIMESTAMP|10 DATE_PART DATE_TRUNC ISFINITE JUSTIFY_DAYS JUSTIFY_HOURS JUSTIFY_INTERVAL MAKE_DATE MAKE_INTERVAL|10 MAKE_TIME MAKE_TIMESTAMP|10 MAKE_TIMESTAMPTZ|10 NOW STATEMENT_TIMESTAMP|10 TIMEOFDAY TRANSACTION_TIMESTAMP|10 ENUM_FIRST ENUM_LAST ENUM_RANGE AREA CENTER DIAMETER HEIGHT ISCLOSED ISOPEN NPOINTS PCLOSE POPEN RADIUS WIDTH BOX BOUND_BOX CIRCLE LINE LSEG PATH POLYGON ABBREV BROADCAST HOST HOSTMASK MASKLEN NETMASK NETWORK SET_MASKLEN TEXT INET_SAME_FAMILY INET_MERGE MACADDR8_SET7BIT ARRAY_TO_TSVECTOR GET_CURRENT_TS_CONFIG NUMNODE PLAINTO_TSQUERY PHRASETO_TSQUERY WEBSEARCH_TO_TSQUERY QUERYTREE SETWEIGHT STRIP TO_TSQUERY TO_TSVECTOR JSON_TO_TSVECTOR JSONB_TO_TSVECTOR TS_DELETE TS_FILTER TS_HEADLINE TS_RANK TS_RANK_CD TS_REWRITE TSQUERY_PHRASE TSVECTOR_TO_ARRAY TSVECTOR_UPDATE_TRIGGER TSVECTOR_UPDATE_TRIGGER_COLUMN XMLCOMMENT XMLCONCAT XMLELEMENT XMLFOREST XMLPI XMLROOT XMLEXISTS XML_IS_WELL_FORMED XML_IS_WELL_FORMED_DOCUMENT XML_IS_WELL_FORMED_CONTENT XPATH XPATH_EXISTS XMLTABLE XMLNAMESPACES TABLE_TO_XML TABLE_TO_XMLSCHEMA TABLE_TO_XML_AND_XMLSCHEMA QUERY_TO_XML QUERY_TO_XMLSCHEMA QUERY_TO_XML_AND_XMLSCHEMA CURSOR_TO_XML CURSOR_TO_XMLSCHEMA SCHEMA_TO_XML SCHEMA_TO_XMLSCHEMA SCHEMA_TO_XML_AND_XMLSCHEMA DATABASE_TO_XML DATABASE_TO_XMLSCHEMA DATABASE_TO_XML_AND_XMLSCHEMA XMLATTRIBUTES TO_JSON TO_JSONB ARRAY_TO_JSON ROW_TO_JSON JSON_BUILD_ARRAY JSONB_BUILD_ARRAY JSON_BUILD_OBJECT JSONB_BUILD_OBJECT JSON_OBJECT JSONB_OBJECT JSON_ARRAY_LENGTH JSONB_ARRAY_LENGTH JSON_EACH JSONB_EACH JSON_EACH_TEXT JSONB_EACH_TEXT JSON_EXTRACT_PATH JSONB_EXTRACT_PATH JSON_OBJECT_KEYS JSONB_OBJECT_KEYS JSON_POPULATE_RECORD JSONB_POPULATE_RECORD JSON_POPULATE_RECORDSET JSONB_POPULATE_RECORDSET JSON_ARRAY_ELEMENTS JSONB_ARRAY_ELEMENTS JSON_ARRAY_ELEMENTS_TEXT JSONB_ARRAY_ELEMENTS_TEXT JSON_TYPEOF JSONB_TYPEOF JSON_TO_RECORD JSONB_TO_RECORD JSON_TO_RECORDSET JSONB_TO_RECORDSET JSON_STRIP_NULLS JSONB_STRIP_NULLS JSONB_SET JSONB_INSERT JSONB_PRETTY CURRVAL LASTVAL NEXTVAL SETVAL COALESCE NULLIF GREATEST LEAST ARRAY_APPEND ARRAY_CAT ARRAY_NDIMS ARRAY_DIMS ARRAY_FILL ARRAY_LENGTH ARRAY_LOWER ARRAY_POSITION ARRAY_POSITIONS ARRAY_PREPEND ARRAY_REMOVE ARRAY_REPLACE ARRAY_TO_STRING ARRAY_UPPER CARDINALITY STRING_TO_ARRAY UNNEST ISEMPTY LOWER_INC UPPER_INC LOWER_INF UPPER_INF RANGE_MERGE GENERATE_SERIES GENERATE_SUBSCRIPTS CURRENT_DATABASE CURRENT_QUERY CURRENT_SCHEMA|10 CURRENT_SCHEMAS|10 INET_CLIENT_ADDR INET_CLIENT_PORT INET_SERVER_ADDR INET_SERVER_PORT ROW_SECURITY_ACTIVE FORMAT_TYPE TO_REGCLASS TO_REGPROC TO_REGPROCEDURE TO_REGOPER TO_REGOPERATOR TO_REGTYPE TO_REGNAMESPACE TO_REGROLE COL_DESCRIPTION OBJ_DESCRIPTION SHOBJ_DESCRIPTION TXID_CURRENT TXID_CURRENT_IF_ASSIGNED TXID_CURRENT_SNAPSHOT TXID_SNAPSHOT_XIP TXID_SNAPSHOT_XMAX TXID_SNAPSHOT_XMIN TXID_VISIBLE_IN_SNAPSHOT TXID_STATUS CURRENT_SETTING SET_CONFIG BRIN_SUMMARIZE_NEW_VALUES BRIN_SUMMARIZE_RANGE BRIN_DESUMMARIZE_RANGE GIN_CLEAN_PENDING_LIST SUPPRESS_REDUNDANT_UPDATES_TRIGGER LO_FROM_BYTEA LO_PUT LO_GET LO_CREAT LO_CREATE LO_UNLINK LO_IMPORT LO_EXPORT LOREAD LOWRITE GROUPING CAST ".trim().split(" ").map(function(S){return S.split("|")[0]}).join("|");return{name:"PostgreSQL",aliases:["postgres","postgresql"],supersetOf:"sql",case_insensitive:!0,keywords:{keyword:s+_+o,built_in:d+m+p},illegal:/:==|\\W\\s*\\(\\*|(^|\\s)\\$[a-z]|\\{\\{|[a-z]:\\s*$|\\.\\.\\.|TO:|DO:/,contains:[{className:"keyword",variants:[{begin:/\\bTEXT\\s*SEARCH\\b/},{begin:/\\b(PRIMARY|FOREIGN|FOR(\\s+NO)?)\\s+KEY\\b/},{begin:/\\bPARALLEL\\s+(UNSAFE|RESTRICTED|SAFE)\\b/},{begin:/\\bSTORAGE\\s+(PLAIN|EXTERNAL|EXTENDED|MAIN)\\b/},{begin:/\\bMATCH\\s+(FULL|PARTIAL|SIMPLE)\\b/},{begin:/\\bNULLS\\s+(FIRST|LAST)\\b/},{begin:/\\bEVENT\\s+TRIGGER\\b/},{begin:/\\b(MAPPING|OR)\\s+REPLACE\\b/},{begin:/\\b(FROM|TO)\\s+(PROGRAM|STDIN|STDOUT)\\b/},{begin:/\\b(SHARE|EXCLUSIVE)\\s+MODE\\b/},{begin:/\\b(LEFT|RIGHT)\\s+(OUTER\\s+)?JOIN\\b/},{begin:/\\b(FETCH|MOVE)\\s+(NEXT|PRIOR|FIRST|LAST|ABSOLUTE|RELATIVE|FORWARD|BACKWARD)\\b/},{begin:/\\bPRESERVE\\s+ROWS\\b/},{begin:/\\bDISCARD\\s+PLANS\\b/},{begin:/\\bREFERENCING\\s+(OLD|NEW)\\b/},{begin:/\\bSKIP\\s+LOCKED\\b/},{begin:/\\bGROUPING\\s+SETS\\b/},{begin:/\\b(BINARY|INSENSITIVE|SCROLL|NO\\s+SCROLL)\\s+(CURSOR|FOR)\\b/},{begin:/\\b(WITH|WITHOUT)\\s+HOLD\\b/},{begin:/\\bWITH\\s+(CASCADED|LOCAL)\\s+CHECK\\s+OPTION\\b/},{begin:/\\bEXCLUDE\\s+(TIES|NO\\s+OTHERS)\\b/},{begin:/\\bFORMAT\\s+(TEXT|XML|JSON|YAML)\\b/},{begin:/\\bSET\\s+((SESSION|LOCAL)\\s+)?NAMES\\b/},{begin:/\\bIS\\s+(NOT\\s+)?UNKNOWN\\b/},{begin:/\\bSECURITY\\s+LABEL\\b/},{begin:/\\bSTANDALONE\\s+(YES|NO|NO\\s+VALUE)\\b/},{begin:/\\bWITH\\s+(NO\\s+)?DATA\\b/},{begin:/\\b(FOREIGN|SET)\\s+DATA\\b/},{begin:/\\bSET\\s+(CATALOG|CONSTRAINTS)\\b/},{begin:/\\b(WITH|FOR)\\s+ORDINALITY\\b/},{begin:/\\bIS\\s+(NOT\\s+)?DOCUMENT\\b/},{begin:/\\bXML\\s+OPTION\\s+(DOCUMENT|CONTENT)\\b/},{begin:/\\b(STRIP|PRESERVE)\\s+WHITESPACE\\b/},{begin:/\\bNO\\s+(ACTION|MAXVALUE|MINVALUE)\\b/},{begin:/\\bPARTITION\\s+BY\\s+(RANGE|LIST|HASH)\\b/},{begin:/\\bAT\\s+TIME\\s+ZONE\\b/},{begin:/\\bGRANTED\\s+BY\\b/},{begin:/\\bRETURN\\s+(QUERY|NEXT)\\b/},{begin:/\\b(ATTACH|DETACH)\\s+PARTITION\\b/},{begin:/\\bFORCE\\s+ROW\\s+LEVEL\\s+SECURITY\\b/},{begin:/\\b(INCLUDING|EXCLUDING)\\s+(COMMENTS|CONSTRAINTS|DEFAULTS|IDENTITY|INDEXES|STATISTICS|STORAGE|ALL)\\b/},{begin:/\\bAS\\s+(ASSIGNMENT|IMPLICIT|PERMISSIVE|RESTRICTIVE|ENUM|RANGE)\\b/}]},{begin:/\\b(FORMAT|FAMILY|VERSION)\\s*\\(/},{begin:/\\bINCLUDE\\s*\\(/,keywords:"INCLUDE"},{begin:/\\bRANGE(?!\\s*(BETWEEN|UNBOUNDED|CURRENT|[-0-9]+))/},{begin:/\\b(VERSION|OWNER|TEMPLATE|TABLESPACE|CONNECTION\\s+LIMIT|PROCEDURE|RESTRICT|JOIN|PARSER|COPY|START|END|COLLATION|INPUT|ANALYZE|STORAGE|LIKE|DEFAULT|DELIMITER|ENCODING|COLUMN|CONSTRAINT|TABLE|SCHEMA)\\s*=/},{begin:/\\b(PG_\\w+?|HAS_[A-Z_]+_PRIVILEGE)\\b/,relevance:10},{begin:/\\bEXTRACT\\s*\\(/,end:/\\bFROM\\b/,returnEnd:!0,keywords:{type:"CENTURY DAY DECADE DOW DOY EPOCH HOUR ISODOW ISOYEAR MICROSECONDS MILLENNIUM MILLISECONDS MINUTE MONTH QUARTER SECOND TIMEZONE TIMEZONE_HOUR TIMEZONE_MINUTE WEEK YEAR"}},{begin:/\\b(XMLELEMENT|XMLPI)\\s*\\(\\s*NAME/,keywords:{keyword:"NAME"}},{begin:/\\b(XMLPARSE|XMLSERIALIZE)\\s*\\(\\s*(DOCUMENT|CONTENT)/,keywords:{keyword:"DOCUMENT CONTENT"}},{beginKeywords:"CACHE INCREMENT MAXVALUE MINVALUE",end:e.C_NUMBER_RE,returnEnd:!0,keywords:"BY CACHE INCREMENT MAXVALUE MINVALUE"},{className:"type",begin:/\\b(WITH|WITHOUT)\\s+TIME\\s+ZONE\\b/},{className:"type",begin:/\\bINTERVAL\\s+(YEAR|MONTH|DAY|HOUR|MINUTE|SECOND)(\\s+TO\\s+(MONTH|HOUR|MINUTE|SECOND))?\\b/},{begin:/\\bRETURNS\\s+(LANGUAGE_HANDLER|TRIGGER|EVENT_TRIGGER|FDW_HANDLER|INDEX_AM_HANDLER|TSM_HANDLER)\\b/,keywords:{keyword:"RETURNS",type:"LANGUAGE_HANDLER TRIGGER EVENT_TRIGGER FDW_HANDLER INDEX_AM_HANDLER TSM_HANDLER"}},{begin:"\\\\b("+g+")\\\\s*\\\\("},{begin:"\\\\.("+c+")\\\\b"},{begin:"\\\\b("+c+")\\\\s+PATH\\\\b",keywords:{keyword:"PATH",type:l.replace("PATH ","")}},{className:"type",begin:"\\\\b("+c+")\\\\b"},{className:"string",begin:"'",end:"'",contains:[{begin:"''"}]},{className:"string",begin:"(e|E|u&|U&)'",end:"'",contains:[{begin:"\\\\\\\\."}],relevance:10},e.END_SAME_AS_BEGIN({begin:r,end:r,contains:[{subLanguage:["pgsql","perl","python","tcl","r","lua","java","php","ruby","bash","scheme","xml","json"],endsWithParent:!0}]}),{begin:'"',end:'"',contains:[{begin:'""'}]},e.C_NUMBER_MODE,e.C_BLOCK_COMMENT_MODE,n,{className:"meta",variants:[{begin:"%(ROW)?TYPE",relevance:10},{begin:"\\\\$\\\\d+"},{begin:"^#\\\\w",end:"$"}]},{className:"symbol",begin:i,relevance:10}]}}return Ya=t,Ya}var qa,Ds;function Wd(){if(Ds)return qa;Ds=1;function t(e){const n=e.regex,a=/(?![A-Za-z0-9])(?![$])/,r=n.concat(/[a-zA-Z_\\x7f-\\xff][a-zA-Z0-9_\\x7f-\\xff]*/,a),i=n.concat(/(\\\\?[A-Z][a-z0-9_\\x7f-\\xff]+|\\\\?[A-Z]+(?=[A-Z][a-z0-9_\\x7f-\\xff])){1,}/,a),s=n.concat(/[A-Z]+/,a),o={scope:"variable",match:"\\\\$+"+r},_={scope:"meta",variants:[{begin:/<\\?php/,relevance:10},{begin:/<\\?=/},{begin:/<\\?/,relevance:.1},{begin:/\\?>/}]},l={scope:"subst",variants:[{begin:/\\$\\w+/},{begin:/\\{\\$/,end:/\\}/}]},c=e.inherit(e.APOS_STRING_MODE,{illegal:null}),d=e.inherit(e.QUOTE_STRING_MODE,{illegal:null,contains:e.QUOTE_STRING_MODE.contains.concat(l)}),m={begin:/<<<[ \\t]*(?:(\\w+)|"(\\w+)")\\n/,end:/[ \\t]*(\\w+)\\b/,contains:e.QUOTE_STRING_MODE.contains.concat(l),"on:begin":(V,z)=>{z.data._beginMatch=V[1]||V[2]},"on:end":(V,z)=>{z.data._beginMatch!==V[1]&&z.ignoreMatch()}},p=e.END_SAME_AS_BEGIN({begin:/<<<[ \\t]*'(\\w+)'\\n/,end:/[ \\t]*(\\w+)\\b/}),E=\`[ 	
]\`,g={scope:"string",variants:[d,c,m,p]},S={scope:"number",variants:[{begin:"\\\\b0[bB][01]+(?:_[01]+)*\\\\b"},{begin:"\\\\b0[oO][0-7]+(?:_[0-7]+)*\\\\b"},{begin:"\\\\b0[xX][\\\\da-fA-F]+(?:_[\\\\da-fA-F]+)*\\\\b"},{begin:"(?:\\\\b\\\\d+(?:_\\\\d+)*(\\\\.(?:\\\\d+(?:_\\\\d+)*))?|\\\\B\\\\.\\\\d+)(?:[eE][+-]?\\\\d+)?"}],relevance:0},T=["false","null","true"],R=["__CLASS__","__DIR__","__FILE__","__FUNCTION__","__COMPILER_HALT_OFFSET__","__LINE__","__METHOD__","__NAMESPACE__","__TRAIT__","die","echo","exit","include","include_once","print","require","require_once","array","abstract","and","as","binary","bool","boolean","break","callable","case","catch","class","clone","const","continue","declare","default","do","double","else","elseif","empty","enddeclare","endfor","endforeach","endif","endswitch","endwhile","enum","eval","extends","final","finally","float","for","foreach","from","global","goto","if","implements","instanceof","insteadof","int","integer","interface","isset","iterable","list","match|0","mixed","new","never","object","or","private","protected","public","readonly","real","return","string","switch","throw","trait","try","unset","use","var","void","while","xor","yield"],f=["Error|0","AppendIterator","ArgumentCountError","ArithmeticError","ArrayIterator","ArrayObject","AssertionError","BadFunctionCallException","BadMethodCallException","CachingIterator","CallbackFilterIterator","CompileError","Countable","DirectoryIterator","DivisionByZeroError","DomainException","EmptyIterator","ErrorException","Exception","FilesystemIterator","FilterIterator","GlobIterator","InfiniteIterator","InvalidArgumentException","IteratorIterator","LengthException","LimitIterator","LogicException","MultipleIterator","NoRewindIterator","OutOfBoundsException","OutOfRangeException","OuterIterator","OverflowException","ParentIterator","ParseError","RangeException","RecursiveArrayIterator","RecursiveCachingIterator","RecursiveCallbackFilterIterator","RecursiveDirectoryIterator","RecursiveFilterIterator","RecursiveIterator","RecursiveIteratorIterator","RecursiveRegexIterator","RecursiveTreeIterator","RegexIterator","RuntimeException","SeekableIterator","SplDoublyLinkedList","SplFileInfo","SplFileObject","SplFixedArray","SplHeap","SplMaxHeap","SplMinHeap","SplObjectStorage","SplObserver","SplPriorityQueue","SplQueue","SplStack","SplSubject","SplTempFileObject","TypeError","UnderflowException","UnexpectedValueException","UnhandledMatchError","ArrayAccess","BackedEnum","Closure","Fiber","Generator","Iterator","IteratorAggregate","Serializable","Stringable","Throwable","Traversable","UnitEnum","WeakReference","WeakMap","Directory","__PHP_Incomplete_Class","parent","php_user_filter","self","static","stdClass"],N={keyword:R,literal:(V=>{const z=[];return V.forEach(X=>{z.push(X),X.toLowerCase()===X?z.push(X.toUpperCase()):z.push(X.toLowerCase())}),z})(T),built_in:f},C=V=>V.map(z=>z.replace(/\\|\\d+$/,"")),M={variants:[{match:[/new/,n.concat(E,"+"),n.concat("(?!",C(f).join("\\\\b|"),"\\\\b)"),i],scope:{1:"keyword",4:"title.class"}}]},y=n.concat(r,"\\\\b(?!\\\\()"),x={variants:[{match:[n.concat(/::/,n.lookahead(/(?!class\\b)/)),y],scope:{2:"variable.constant"}},{match:[/::/,/class/],scope:{2:"variable.language"}},{match:[i,n.concat(/::/,n.lookahead(/(?!class\\b)/)),y],scope:{1:"title.class",3:"variable.constant"}},{match:[i,n.concat("::",n.lookahead(/(?!class\\b)/))],scope:{1:"title.class"}},{match:[i,/::/,/class/],scope:{1:"title.class",3:"variable.language"}}]},G={scope:"attr",match:n.concat(r,n.lookahead(":"),n.lookahead(/(?!::)/))},w={relevance:0,begin:/\\(/,end:/\\)/,keywords:N,contains:[G,o,x,e.C_BLOCK_COMMENT_MODE,g,S,M]},H={relevance:0,match:[/\\b/,n.concat("(?!fn\\\\b|function\\\\b|",C(R).join("\\\\b|"),"|",C(f).join("\\\\b|"),"\\\\b)"),r,n.concat(E,"*"),n.lookahead(/(?=\\()/)],scope:{3:"title.function.invoke"},contains:[w]};w.contains.push(H);const j=[G,x,e.C_BLOCK_COMMENT_MODE,g,S,M],ee={begin:n.concat(/#\\[\\s*\\\\?/,n.either(i,s)),beginScope:"meta",end:/]/,endScope:"meta",keywords:{literal:T,keyword:["new","array"]},contains:[{begin:/\\[/,end:/]/,keywords:{literal:T,keyword:["new","array"]},contains:["self",...j]},...j,{scope:"meta",variants:[{match:i},{match:s}]}]};return{case_insensitive:!1,keywords:N,contains:[ee,e.HASH_COMMENT_MODE,e.COMMENT("//","$"),e.COMMENT("/\\\\*","\\\\*/",{contains:[{scope:"doctag",match:"@[A-Za-z]+"}]}),{match:/__halt_compiler\\(\\);/,keywords:"__halt_compiler",starts:{scope:"comment",end:e.MATCH_NOTHING_RE,contains:[{match:/\\?>/,scope:"meta",endsParent:!0}]}},_,{scope:"variable.language",match:/\\$this\\b/},o,H,x,{match:[/const/,/\\s/,r],scope:{1:"keyword",3:"variable.constant"}},M,{scope:"function",relevance:0,beginKeywords:"fn function",end:/[;{]/,excludeEnd:!0,illegal:"[$%\\\\[]",contains:[{beginKeywords:"use"},e.UNDERSCORE_TITLE_MODE,{begin:"=>",endsParent:!0},{scope:"params",begin:"\\\\(",end:"\\\\)",excludeBegin:!0,excludeEnd:!0,keywords:N,contains:["self",ee,o,x,e.C_BLOCK_COMMENT_MODE,g,S]}]},{scope:"class",variants:[{beginKeywords:"enum",illegal:/[($"]/},{beginKeywords:"class interface trait",illegal:/[:($"]/}],relevance:0,end:/\\{/,excludeEnd:!0,contains:[{beginKeywords:"extends implements"},e.UNDERSCORE_TITLE_MODE]},{beginKeywords:"namespace",relevance:0,end:";",illegal:/[.']/,contains:[e.inherit(e.UNDERSCORE_TITLE_MODE,{scope:"title.class"})]},{beginKeywords:"use",relevance:0,end:";",contains:[{match:/\\b(as|const|function)\\b/,scope:"keyword"},e.UNDERSCORE_TITLE_MODE]},g,S]}}return qa=t,qa}var Ha,Ms;function Kd(){if(Ms)return Ha;Ms=1;function t(e){return{name:"PHP template",subLanguage:"xml",contains:[{begin:/<\\?(php|=)?/,end:/\\?>/,subLanguage:"php",contains:[{begin:"/\\\\*",end:"\\\\*/",skip:!0},{begin:'b"',end:'"',skip:!0},{begin:"b'",end:"'",skip:!0},e.inherit(e.APOS_STRING_MODE,{illegal:null,className:null,contains:null,skip:!0}),e.inherit(e.QUOTE_STRING_MODE,{illegal:null,className:null,contains:null,skip:!0})]}]}}return Ha=t,Ha}var Va,Ls;function $d(){if(Ls)return Va;Ls=1;function t(e){return{name:"Plain text",aliases:["text","txt"],disableAutodetect:!0}}return Va=t,Va}var za,xs;function Qd(){if(xs)return za;xs=1;function t(e){const n={keyword:"actor addressof and as be break class compile_error compile_intrinsic consume continue delegate digestof do else elseif embed end error for fun if ifdef in interface is isnt lambda let match new not object or primitive recover repeat return struct then trait try type until use var where while with xor",meta:"iso val tag trn box ref",literal:"this false true"},a={className:"string",begin:'"""',end:'"""',relevance:10},r={className:"string",begin:'"',end:'"',contains:[e.BACKSLASH_ESCAPE]},i={className:"string",begin:"'",end:"'",contains:[e.BACKSLASH_ESCAPE],relevance:0},s={className:"type",begin:"\\\\b_?[A-Z][\\\\w]*",relevance:0},o={begin:e.IDENT_RE+"'",relevance:0};return{name:"Pony",keywords:n,contains:[s,a,r,i,o,{className:"number",begin:"(-?)(\\\\b0[xX][a-fA-F0-9]+|\\\\b0[bB][01]+|(\\\\b\\\\d+(_\\\\d+)?(\\\\.\\\\d*)?|\\\\.\\\\d+)([eE][-+]?\\\\d+)?)",relevance:0},e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE]}}return za=t,za}var Wa,ws;function Xd(){if(ws)return Wa;ws=1;function t(e){const n=["string","char","byte","int","long","bool","decimal","single","double","DateTime","xml","array","hashtable","void"],a="Add|Clear|Close|Copy|Enter|Exit|Find|Format|Get|Hide|Join|Lock|Move|New|Open|Optimize|Pop|Push|Redo|Remove|Rename|Reset|Resize|Search|Select|Set|Show|Skip|Split|Step|Switch|Undo|Unlock|Watch|Backup|Checkpoint|Compare|Compress|Convert|ConvertFrom|ConvertTo|Dismount|Edit|Expand|Export|Group|Import|Initialize|Limit|Merge|Mount|Out|Publish|Restore|Save|Sync|Unpublish|Update|Approve|Assert|Build|Complete|Confirm|Deny|Deploy|Disable|Enable|Install|Invoke|Register|Request|Restart|Resume|Start|Stop|Submit|Suspend|Uninstall|Unregister|Wait|Debug|Measure|Ping|Repair|Resolve|Test|Trace|Connect|Disconnect|Read|Receive|Send|Write|Block|Grant|Protect|Revoke|Unblock|Unprotect|Use|ForEach|Sort|Tee|Where",r="-and|-as|-band|-bnot|-bor|-bxor|-casesensitive|-ccontains|-ceq|-cge|-cgt|-cle|-clike|-clt|-cmatch|-cne|-cnotcontains|-cnotlike|-cnotmatch|-contains|-creplace|-csplit|-eq|-exact|-f|-file|-ge|-gt|-icontains|-ieq|-ige|-igt|-ile|-ilike|-ilt|-imatch|-in|-ine|-inotcontains|-inotlike|-inotmatch|-ireplace|-is|-isnot|-isplit|-join|-le|-like|-lt|-match|-ne|-not|-notcontains|-notin|-notlike|-notmatch|-or|-regex|-replace|-shl|-shr|-split|-wildcard|-xor",i={$pattern:/-?[A-z\\.\\-]+\\b/,keyword:"if else foreach return do while until elseif begin for trap data dynamicparam end break throw param continue finally in switch exit filter try process catch hidden static parameter",built_in:"ac asnp cat cd CFS chdir clc clear clhy cli clp cls clv cnsn compare copy cp cpi cpp curl cvpa dbp del diff dir dnsn ebp echo|0 epal epcsv epsn erase etsn exsn fc fhx fl ft fw gal gbp gc gcb gci gcm gcs gdr gerr ghy gi gin gjb gl gm gmo gp gps gpv group gsn gsnp gsv gtz gu gv gwmi h history icm iex ihy ii ipal ipcsv ipmo ipsn irm ise iwmi iwr kill lp ls man md measure mi mount move mp mv nal ndr ni nmo npssc nsn nv ogv oh popd ps pushd pwd r rbp rcjb rcsn rd rdr ren ri rjb rm rmdir rmo rni rnp rp rsn rsnp rujb rv rvpa rwmi sajb sal saps sasv sbp sc scb select set shcm si sl sleep sls sort sp spjb spps spsv start stz sujb sv swmi tee trcm type wget where wjb write"},s=/\\w[\\w\\d]*((-)[\\w\\d]+)*/,o={begin:"\`[\\\\s\\\\S]",relevance:0},_={className:"variable",variants:[{begin:/\\$\\B/},{className:"keyword",begin:/\\$this/},{begin:/\\$[\\w\\d][\\w\\d_:]*/}]},l={className:"literal",begin:/\\$(null|true|false)\\b/},c={className:"string",variants:[{begin:/"/,end:/"/},{begin:/@"/,end:/^"@/}],contains:[o,_,{className:"variable",begin:/\\$[A-z]/,end:/[^A-z]/}]},d={className:"string",variants:[{begin:/'/,end:/'/},{begin:/@'/,end:/^'@/}]},m={className:"doctag",variants:[{begin:/\\.(synopsis|description|example|inputs|outputs|notes|link|component|role|functionality)/},{begin:/\\.(parameter|forwardhelptargetname|forwardhelpcategory|remotehelprunspace|externalhelp)\\s+\\S+/}]},p=e.inherit(e.COMMENT(null,null),{variants:[{begin:/#/,end:/$/},{begin:/<#/,end:/#>/}],contains:[m]}),E={className:"built_in",variants:[{begin:"(".concat(a,")+(-)[\\\\w\\\\d]+")}]},g={className:"class",beginKeywords:"class enum",end:/\\s*[{]/,excludeEnd:!0,relevance:0,contains:[e.TITLE_MODE]},S={className:"function",begin:/function\\s+/,end:/\\s*\\{|$/,excludeEnd:!0,returnBegin:!0,relevance:0,contains:[{begin:"function",relevance:0,className:"keyword"},{className:"title",begin:s,relevance:0},{begin:/\\(/,end:/\\)/,className:"params",relevance:0,contains:[_]}]},T={begin:/using\\s/,end:/$/,returnBegin:!0,contains:[c,d,{className:"keyword",begin:/(using|assembly|command|module|namespace|type)/}]},R={variants:[{className:"operator",begin:"(".concat(r,")\\\\b")},{className:"literal",begin:/(-){1,2}[\\w\\d-]+/,relevance:0}]},f={className:"selector-tag",begin:/@\\B/,relevance:0},A={className:"function",begin:/\\[.*\\]\\s*[\\w]+[ ]??\\(/,end:/$/,returnBegin:!0,relevance:0,contains:[{className:"keyword",begin:"(".concat(i.keyword.toString().replace(/\\s/g,"|"),")\\\\b"),endsParent:!0,relevance:0},e.inherit(e.TITLE_MODE,{endsParent:!0})]},N=[A,p,o,e.NUMBER_MODE,c,d,E,_,l,f],C={begin:/\\[/,end:/\\]/,excludeBegin:!0,excludeEnd:!0,relevance:0,contains:[].concat("self",N,{begin:"("+n.join("|")+")",className:"built_in",relevance:0},{className:"type",begin:/[\\.\\w\\d]+/,relevance:0})};return A.contains.unshift(C),{name:"PowerShell",aliases:["pwsh","ps","ps1"],case_insensitive:!0,keywords:i,contains:N.concat(g,S,T,R,C)}}return Wa=t,Wa}var Ka,Ps;function Zd(){if(Ps)return Ka;Ps=1;function t(e){const n=e.regex,a=["displayHeight","displayWidth","mouseY","mouseX","mousePressed","pmouseX","pmouseY","key","keyCode","pixels","focused","frameCount","frameRate","height","width","size","createGraphics","beginDraw","createShape","loadShape","PShape","arc","ellipse","line","point","quad","rect","triangle","bezier","bezierDetail","bezierPoint","bezierTangent","curve","curveDetail","curvePoint","curveTangent","curveTightness","shape","shapeMode","beginContour","beginShape","bezierVertex","curveVertex","endContour","endShape","quadraticVertex","vertex","ellipseMode","noSmooth","rectMode","smooth","strokeCap","strokeJoin","strokeWeight","mouseClicked","mouseDragged","mouseMoved","mousePressed","mouseReleased","mouseWheel","keyPressed","keyPressedkeyReleased","keyTyped","print","println","save","saveFrame","day","hour","millis","minute","month","second","year","background","clear","colorMode","fill","noFill","noStroke","stroke","alpha","blue","brightness","color","green","hue","lerpColor","red","saturation","modelX","modelY","modelZ","screenX","screenY","screenZ","ambient","emissive","shininess","specular","add","createImage","beginCamera","camera","endCamera","frustum","ortho","perspective","printCamera","printProjection","cursor","frameRate","noCursor","exit","loop","noLoop","popStyle","pushStyle","redraw","binary","boolean","byte","char","float","hex","int","str","unbinary","unhex","join","match","matchAll","nf","nfc","nfp","nfs","split","splitTokens","trim","append","arrayCopy","concat","expand","reverse","shorten","sort","splice","subset","box","sphere","sphereDetail","createInput","createReader","loadBytes","loadJSONArray","loadJSONObject","loadStrings","loadTable","loadXML","open","parseXML","saveTable","selectFolder","selectInput","beginRaw","beginRecord","createOutput","createWriter","endRaw","endRecord","PrintWritersaveBytes","saveJSONArray","saveJSONObject","saveStream","saveStrings","saveXML","selectOutput","popMatrix","printMatrix","pushMatrix","resetMatrix","rotate","rotateX","rotateY","rotateZ","scale","shearX","shearY","translate","ambientLight","directionalLight","lightFalloff","lights","lightSpecular","noLights","normal","pointLight","spotLight","image","imageMode","loadImage","noTint","requestImage","tint","texture","textureMode","textureWrap","blend","copy","filter","get","loadPixels","set","updatePixels","blendMode","loadShader","PShaderresetShader","shader","createFont","loadFont","text","textFont","textAlign","textLeading","textMode","textSize","textWidth","textAscent","textDescent","abs","ceil","constrain","dist","exp","floor","lerp","log","mag","map","max","min","norm","pow","round","sq","sqrt","acos","asin","atan","atan2","cos","degrees","radians","sin","tan","noise","noiseDetail","noiseSeed","random","randomGaussian","randomSeed"],r=e.IDENT_RE,i={variants:[{match:n.concat(n.either(...a),n.lookahead(/\\s*\\(/)),className:"built_in"},{relevance:0,match:n.concat(/\\b(?!for|if|while)/,r,n.lookahead(/\\s*\\(/)),className:"title.function"}]},s={match:[/new\\s+/,r],className:{1:"keyword",2:"class.title"}},o={relevance:0,match:[/\\./,r],className:{2:"property"}},_={variants:[{match:[/class/,/\\s+/,r,/\\s+/,/extends/,/\\s+/,r]},{match:[/class/,/\\s+/,r]}],className:{1:"keyword",3:"title.class",5:"keyword",7:"title.class.inherited"}},l=["boolean","byte","char","color","double","float","int","long","short"],c=["BufferedReader","PVector","PFont","PImage","PGraphics","HashMap","String","Array","FloatDict","ArrayList","FloatList","IntDict","IntList","JSONArray","JSONObject","Object","StringDict","StringList","Table","TableRow","XML"];return{name:"Processing",aliases:["pde"],keywords:{keyword:[...["abstract","assert","break","case","catch","const","continue","default","else","enum","final","finally","for","if","import","instanceof","long","native","new","package","private","private","protected","protected","public","public","return","static","strictfp","switch","synchronized","throw","throws","transient","try","void","volatile","while"]],literal:"P2D P3D HALF_PI PI QUARTER_PI TAU TWO_PI null true false",title:"setup draw",variable:"super this",built_in:[...a,...c],type:l},contains:[_,s,i,o,e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,e.APOS_STRING_MODE,e.QUOTE_STRING_MODE,e.C_NUMBER_MODE]}}return Ka=t,Ka}var $a,ks;function Jd(){if(ks)return $a;ks=1;function t(e){return{name:"Python profiler",contains:[e.C_NUMBER_MODE,{begin:"[a-zA-Z_][\\\\da-zA-Z_]+\\\\.[\\\\da-zA-Z_]{1,3}",end:":",excludeEnd:!0},{begin:"(ncalls|tottime|cumtime)",end:"$",keywords:"ncalls tottime|10 cumtime|10 filename",relevance:10},{begin:"function calls",end:"$",contains:[e.C_NUMBER_MODE],relevance:10},e.APOS_STRING_MODE,e.QUOTE_STRING_MODE,{className:"string",begin:"\\\\(",end:"\\\\)$",excludeBegin:!0,excludeEnd:!0,relevance:0}]}}return $a=t,$a}var Qa,Us;function jd(){if(Us)return Qa;Us=1;function t(e){const n={begin:/[a-z][A-Za-z0-9_]*/,relevance:0},a={className:"symbol",variants:[{begin:/[A-Z][a-zA-Z0-9_]*/},{begin:/_[A-Za-z0-9_]*/}],relevance:0},r={begin:/\\(/,end:/\\)/,relevance:0},i={begin:/\\[/,end:/\\]/},s={className:"comment",begin:/%/,end:/$/,contains:[e.PHRASAL_WORDS_MODE]},o={className:"string",begin:/\`/,end:/\`/,contains:[e.BACKSLASH_ESCAPE]},_={className:"string",begin:/0'(\\\\'|.)/},l={className:"string",begin:/0'\\\\s/},d=[n,a,r,{begin:/:-/},i,s,e.C_BLOCK_COMMENT_MODE,e.QUOTE_STRING_MODE,e.APOS_STRING_MODE,o,_,l,e.C_NUMBER_MODE];return r.contains=d,i.contains=d,{name:"Prolog",contains:d.concat([{begin:/\\.$/}])}}return Qa=t,Qa}var Xa,Fs;function eu(){if(Fs)return Xa;Fs=1;function t(e){const n="[ \\\\t\\\\f]*",a="[ \\\\t\\\\f]+",r=n+"[:=]"+n,i=a,s="("+r+"|"+i+")",o="([^\\\\\\\\:= \\\\t\\\\f\\\\n]|\\\\\\\\.)+",_={end:s,relevance:0,starts:{className:"string",end:/$/,relevance:0,contains:[{begin:"\\\\\\\\\\\\\\\\"},{begin:"\\\\\\\\\\\\n"}]}};return{name:".properties",disableAutodetect:!0,case_insensitive:!0,illegal:/\\S/,contains:[e.COMMENT("^\\\\s*[!#]","$"),{returnBegin:!0,variants:[{begin:o+r},{begin:o+i}],contains:[{className:"attr",begin:o,endsParent:!0}],starts:_},{className:"attr",begin:o+n+"$"}]}}return Xa=t,Xa}var Za,Bs;function tu(){if(Bs)return Za;Bs=1;function t(e){const n=["package","import","option","optional","required","repeated","group","oneof"],a=["double","float","int32","int64","uint32","uint64","sint32","sint64","fixed32","fixed64","sfixed32","sfixed64","bool","string","bytes"],r={match:[/(message|enum|service)\\s+/,e.IDENT_RE],scope:{1:"keyword",2:"title.class"}};return{name:"Protocol Buffers",aliases:["proto"],keywords:{keyword:n,type:a,literal:["true","false"]},contains:[e.QUOTE_STRING_MODE,e.NUMBER_MODE,e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,r,{className:"function",beginKeywords:"rpc",end:/[{;]/,excludeEnd:!0,keywords:"rpc returns"},{begin:/^\\s*[A-Z_]+(?=\\s*=[^\\n]+;$)/}]}}return Za=t,Za}var Ja,Gs;function nu(){if(Gs)return Ja;Gs=1;function t(e){const n={keyword:"and case default else elsif false if in import enherits node or true undef unless main settings $string ",literal:"alias audit before loglevel noop require subscribe tag owner ensure group mode name|0 changes context force incl lens load_path onlyif provider returns root show_diff type_check en_address ip_address realname command environment hour monute month monthday special target weekday creates cwd ogoutput refresh refreshonly tries try_sleep umask backup checksum content ctime force ignore links mtime purge recurse recurselimit replace selinux_ignore_defaults selrange selrole seltype seluser source souirce_permissions sourceselect validate_cmd validate_replacement allowdupe attribute_membership auth_membership forcelocal gid ia_load_module members system host_aliases ip allowed_trunk_vlans description device_url duplex encapsulation etherchannel native_vlan speed principals allow_root auth_class auth_type authenticate_user k_of_n mechanisms rule session_owner shared options device fstype enable hasrestart directory present absent link atboot blockdevice device dump pass remounts poller_tag use message withpath adminfile allow_virtual allowcdrom category configfiles flavor install_options instance package_settings platform responsefile status uninstall_options vendor unless_system_user unless_uid binary control flags hasstatus manifest pattern restart running start stop allowdupe auths expiry gid groups home iterations key_membership keys managehome membership password password_max_age password_min_age profile_membership profiles project purge_ssh_keys role_membership roles salt shell uid baseurl cost descr enabled enablegroups exclude failovermethod gpgcheck gpgkey http_caching include includepkgs keepalive metadata_expire metalink mirrorlist priority protect proxy proxy_password proxy_username repo_gpgcheck s3_enabled skip_if_unavailable sslcacert sslclientcert sslclientkey sslverify mounted",built_in:"architecture augeasversion blockdevices boardmanufacturer boardproductname boardserialnumber cfkey dhcp_servers domain ec2_ ec2_userdata facterversion filesystems ldom fqdn gid hardwareisa hardwaremodel hostname id|0 interfaces ipaddress ipaddress_ ipaddress6 ipaddress6_ iphostnumber is_virtual kernel kernelmajversion kernelrelease kernelversion kernelrelease kernelversion lsbdistcodename lsbdistdescription lsbdistid lsbdistrelease lsbmajdistrelease lsbminordistrelease lsbrelease macaddress macaddress_ macosx_buildversion macosx_productname macosx_productversion macosx_productverson_major macosx_productversion_minor manufacturer memoryfree memorysize netmask metmask_ network_ operatingsystem operatingsystemmajrelease operatingsystemrelease osfamily partitions path physicalprocessorcount processor processorcount productname ps puppetversion rubysitedir rubyversion selinux selinux_config_mode selinux_config_policy selinux_current_mode selinux_current_mode selinux_enforced selinux_policyversion serialnumber sp_ sshdsakey sshecdsakey sshrsakey swapencrypted swapfree swapsize timezone type uniqueid uptime uptime_days uptime_hours uptime_seconds uuid virtual vlans xendomains zfs_version zonenae zones zpool_version"},a=e.COMMENT("#","$"),r="([A-Za-z_]|::)(\\\\w|::)*",i=e.inherit(e.TITLE_MODE,{begin:r}),s={className:"variable",begin:"\\\\$"+r},o={className:"string",contains:[e.BACKSLASH_ESCAPE,s],variants:[{begin:/'/,end:/'/},{begin:/"/,end:/"/}]};return{name:"Puppet",aliases:["pp"],contains:[a,s,o,{beginKeywords:"class",end:"\\\\{|;",illegal:/=/,contains:[i,a]},{beginKeywords:"define",end:/\\{/,contains:[{className:"section",begin:e.IDENT_RE,endsParent:!0}]},{begin:e.IDENT_RE+"\\\\s+\\\\{",returnBegin:!0,end:/\\S/,contains:[{className:"keyword",begin:e.IDENT_RE,relevance:.2},{begin:/\\{/,end:/\\}/,keywords:n,relevance:0,contains:[o,a,{begin:"[a-zA-Z_]+\\\\s*=>",returnBegin:!0,end:"=>",contains:[{className:"attr",begin:e.IDENT_RE}]},{className:"number",begin:"(\\\\b0[0-7_]+)|(\\\\b0x[0-9a-fA-F_]+)|(\\\\b[1-9][0-9_]*(\\\\.[0-9_]+)?)|[0_]\\\\b",relevance:0},s]}],relevance:0}]}}return Ja=t,Ja}var ja,Ys;function au(){if(Ys)return ja;Ys=1;function t(e){const n={className:"string",begin:'(~)?"',end:'"',illegal:"\\\\n"},a={className:"symbol",begin:"#[a-zA-Z_]\\\\w*\\\\$?"};return{name:"PureBASIC",aliases:["pb","pbi"],keywords:"Align And Array As Break CallDebugger Case CompilerCase CompilerDefault CompilerElse CompilerElseIf CompilerEndIf CompilerEndSelect CompilerError CompilerIf CompilerSelect CompilerWarning Continue Data DataSection Debug DebugLevel Declare DeclareC DeclareCDLL DeclareDLL DeclareModule Default Define Dim DisableASM DisableDebugger DisableExplicit Else ElseIf EnableASM EnableDebugger EnableExplicit End EndDataSection EndDeclareModule EndEnumeration EndIf EndImport EndInterface EndMacro EndModule EndProcedure EndSelect EndStructure EndStructureUnion EndWith Enumeration EnumerationBinary Extends FakeReturn For ForEach ForEver Global Gosub Goto If Import ImportC IncludeBinary IncludeFile IncludePath Interface List Macro MacroExpandedCount Map Module NewList NewMap Next Not Or Procedure ProcedureC ProcedureCDLL ProcedureDLL ProcedureReturn Protected Prototype PrototypeC ReDim Read Repeat Restore Return Runtime Select Shared Static Step Structure StructureUnion Swap Threaded To UndefineMacro Until Until  UnuseModule UseModule Wend While With XIncludeFile XOr",contains:[e.COMMENT(";","$",{relevance:0}),{className:"function",begin:"\\\\b(Procedure|Declare)(C|CDLL|DLL)?\\\\b",end:"\\\\(",excludeEnd:!0,returnBegin:!0,contains:[{className:"keyword",begin:"(Procedure|Declare)(C|CDLL|DLL)?",excludeEnd:!0},{className:"type",begin:"\\\\.\\\\w*"},e.UNDERSCORE_TITLE_MODE]},n,a]}}return ja=t,ja}var er,qs;function ru(){if(qs)return er;qs=1;function t(e){const n=e.regex,a=new RegExp("[\\\\p{XID_Start}_]\\\\p{XID_Continue}*","u"),r=["and","as","assert","async","await","break","case","class","continue","def","del","elif","else","except","finally","for","from","global","if","import","in","is","lambda","match","nonlocal|10","not","or","pass","raise","return","try","while","with","yield"],_={$pattern:/[A-Za-z]\\w+|__\\w+__/,keyword:r,built_in:["__import__","abs","all","any","ascii","bin","bool","breakpoint","bytearray","bytes","callable","chr","classmethod","compile","complex","delattr","dict","dir","divmod","enumerate","eval","exec","filter","float","format","frozenset","getattr","globals","hasattr","hash","help","hex","id","input","int","isinstance","issubclass","iter","len","list","locals","map","max","memoryview","min","next","object","oct","open","ord","pow","print","property","range","repr","reversed","round","set","setattr","slice","sorted","staticmethod","str","sum","super","tuple","type","vars","zip"],literal:["__debug__","Ellipsis","False","None","NotImplemented","True"],type:["Any","Callable","Coroutine","Dict","List","Literal","Generic","Optional","Sequence","Set","Tuple","Type","Union"]},l={className:"meta",begin:/^(>>>|\\.\\.\\.) /},c={className:"subst",begin:/\\{/,end:/\\}/,keywords:_,illegal:/#/},d={begin:/\\{\\{/,relevance:0},m={className:"string",contains:[e.BACKSLASH_ESCAPE],variants:[{begin:/([uU]|[bB]|[rR]|[bB][rR]|[rR][bB])?'''/,end:/'''/,contains:[e.BACKSLASH_ESCAPE,l],relevance:10},{begin:/([uU]|[bB]|[rR]|[bB][rR]|[rR][bB])?"""/,end:/"""/,contains:[e.BACKSLASH_ESCAPE,l],relevance:10},{begin:/([fF][rR]|[rR][fF]|[fF])'''/,end:/'''/,contains:[e.BACKSLASH_ESCAPE,l,d,c]},{begin:/([fF][rR]|[rR][fF]|[fF])"""/,end:/"""/,contains:[e.BACKSLASH_ESCAPE,l,d,c]},{begin:/([uU]|[rR])'/,end:/'/,relevance:10},{begin:/([uU]|[rR])"/,end:/"/,relevance:10},{begin:/([bB]|[bB][rR]|[rR][bB])'/,end:/'/},{begin:/([bB]|[bB][rR]|[rR][bB])"/,end:/"/},{begin:/([fF][rR]|[rR][fF]|[fF])'/,end:/'/,contains:[e.BACKSLASH_ESCAPE,d,c]},{begin:/([fF][rR]|[rR][fF]|[fF])"/,end:/"/,contains:[e.BACKSLASH_ESCAPE,d,c]},e.APOS_STRING_MODE,e.QUOTE_STRING_MODE]},p="[0-9](_?[0-9])*",E=\`(\\\\b(\${p}))?\\\\.(\${p})|\\\\b(\${p})\\\\.\`,g=\`\\\\b|\${r.join("|")}\`,S={className:"number",relevance:0,variants:[{begin:\`(\\\\b(\${p})|(\${E}))[eE][+-]?(\${p})[jJ]?(?=\${g})\`},{begin:\`(\${E})[jJ]?\`},{begin:\`\\\\b([1-9](_?[0-9])*|0+(_?0)*)[lLjJ]?(?=\${g})\`},{begin:\`\\\\b0[bB](_?[01])+[lL]?(?=\${g})\`},{begin:\`\\\\b0[oO](_?[0-7])+[lL]?(?=\${g})\`},{begin:\`\\\\b0[xX](_?[0-9a-fA-F])+[lL]?(?=\${g})\`},{begin:\`\\\\b(\${p})[jJ](?=\${g})\`}]},T={className:"comment",begin:n.lookahead(/# type:/),end:/$/,keywords:_,contains:[{begin:/# type:/},{begin:/#/,end:/\\b\\B/,endsWithParent:!0}]},R={className:"params",variants:[{className:"",begin:/\\(\\s*\\)/,skip:!0},{begin:/\\(/,end:/\\)/,excludeBegin:!0,excludeEnd:!0,keywords:_,contains:["self",l,S,m,e.HASH_COMMENT_MODE]}]};return c.contains=[m,S,l],{name:"Python",aliases:["py","gyp","ipython"],unicodeRegex:!0,keywords:_,illegal:/(<\\/|\\?)|=>/,contains:[l,S,{scope:"variable.language",match:/\\bself\\b/},{beginKeywords:"if",relevance:0},{match:/\\bor\\b/,scope:"keyword"},m,T,e.HASH_COMMENT_MODE,{match:[/\\bdef/,/\\s+/,a],scope:{1:"keyword",3:"title.function"},contains:[R]},{variants:[{match:[/\\bclass/,/\\s+/,a,/\\s*/,/\\(\\s*/,a,/\\s*\\)/]},{match:[/\\bclass/,/\\s+/,a]}],scope:{1:"keyword",3:"title.class",6:"title.class.inherited"}},{className:"meta",begin:/^[\\t ]*@/,end:/(?=#)|$/,contains:[S,R,m]}]}}return er=t,er}var tr,Hs;function iu(){if(Hs)return tr;Hs=1;function t(e){return{aliases:["pycon"],contains:[{className:"meta.prompt",starts:{end:/ |$/,starts:{end:"$",subLanguage:"python"}},variants:[{begin:/^>>>(?=[ ]|$)/},{begin:/^\\.\\.\\.(?=[ ]|$)/}]}]}}return tr=t,tr}var nr,Vs;function ou(){if(Vs)return nr;Vs=1;function t(e){return{name:"Q",aliases:["k","kdb"],keywords:{$pattern:/(\`?)[A-Za-z0-9_]+\\b/,keyword:"do while select delete by update from",literal:"0b 1b",built_in:"neg not null string reciprocal floor ceiling signum mod xbar xlog and or each scan over prior mmu lsq inv md5 ltime gtime count first var dev med cov cor all any rand sums prds mins maxs fills deltas ratios avgs differ prev next rank reverse iasc idesc asc desc msum mcount mavg mdev xrank mmin mmax xprev rotate distinct group where flip type key til get value attr cut set upsert raze union inter except cross sv vs sublist enlist read0 read1 hopen hclose hdel hsym hcount peach system ltrim rtrim trim lower upper ssr view tables views cols xcols keys xkey xcol xasc xdesc fkeys meta lj aj aj0 ij pj asof uj ww wj wj1 fby xgroup ungroup ej save load rsave rload show csv parse eval min max avg wavg wsum sin cos tan sum",type:"\`float \`double int \`timestamp \`timespan \`datetime \`time \`boolean \`symbol \`char \`byte \`short \`long \`real \`month \`date \`minute \`second \`guid"},contains:[e.C_LINE_COMMENT_MODE,e.QUOTE_STRING_MODE,e.C_NUMBER_MODE]}}return nr=t,nr}var ar,zs;function su(){if(zs)return ar;zs=1;function t(e){const n=e.regex,a={keyword:"in of on if for while finally var new function do return void else break catch instanceof with throw case default try this switch continue typeof delete let yield const export super debugger as async await import",literal:"true false null undefined NaN Infinity",built_in:"eval isFinite isNaN parseFloat parseInt decodeURI decodeURIComponent encodeURI encodeURIComponent escape unescape Object Function Boolean Error EvalError InternalError RangeError ReferenceError StopIteration SyntaxError TypeError URIError Number Math Date String RegExp Array Float32Array Float64Array Int16Array Int32Array Int8Array Uint16Array Uint32Array Uint8Array Uint8ClampedArray ArrayBuffer DataView JSON Intl arguments require module console window document Symbol Set Map WeakSet WeakMap Proxy Reflect Behavior bool color coordinate date double enumeration font geocircle georectangle geoshape int list matrix4x4 parent point quaternion real rect size string url variant vector2d vector3d vector4d Promise"},r="[a-zA-Z_][a-zA-Z0-9\\\\._]*",i={className:"keyword",begin:"\\\\bproperty\\\\b",starts:{className:"string",end:"(:|=|;|,|//|/\\\\*|$)",returnEnd:!0}},s={className:"keyword",begin:"\\\\bsignal\\\\b",starts:{className:"string",end:"(\\\\(|:|=|;|,|//|/\\\\*|$)",returnEnd:!0}},o={className:"attribute",begin:"\\\\bid\\\\s*:",starts:{className:"string",end:r,returnEnd:!1}},_={begin:r+"\\\\s*:",returnBegin:!0,contains:[{className:"attribute",begin:r,end:"\\\\s*:",excludeEnd:!0,relevance:0}],relevance:0},l={begin:n.concat(r,/\\s*\\{/),end:/\\{/,returnBegin:!0,relevance:0,contains:[e.inherit(e.TITLE_MODE,{begin:r})]};return{name:"QML",aliases:["qt"],case_insensitive:!1,keywords:a,contains:[{className:"meta",begin:/^\\s*['"]use (strict|asm)['"]/},e.APOS_STRING_MODE,e.QUOTE_STRING_MODE,{className:"string",begin:"\`",end:"\`",contains:[e.BACKSLASH_ESCAPE,{className:"subst",begin:"\\\\$\\\\{",end:"\\\\}"}]},e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,{className:"number",variants:[{begin:"\\\\b(0[bB][01]+)"},{begin:"\\\\b(0[oO][0-7]+)"},{begin:e.C_NUMBER_RE}],relevance:0},{begin:"("+e.RE_STARTERS_RE+"|\\\\b(case|return|throw)\\\\b)\\\\s*",keywords:"return throw case",contains:[e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,e.REGEXP_MODE,{begin:/</,end:/>\\s*[);\\]]/,relevance:0,subLanguage:"xml"}],relevance:0},s,i,{className:"function",beginKeywords:"function",end:/\\{/,excludeEnd:!0,contains:[e.inherit(e.TITLE_MODE,{begin:/[A-Za-z$_][0-9A-Za-z$_]*/}),{className:"params",begin:/\\(/,end:/\\)/,excludeBegin:!0,excludeEnd:!0,contains:[e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE]}],illegal:/\\[|%/},{begin:"\\\\."+e.IDENT_RE,relevance:0},o,_,l],illegal:/#/}}return ar=t,ar}var rr,Ws;function lu(){if(Ws)return rr;Ws=1;function t(e){const n=e.regex,a=/(?:(?:[a-zA-Z]|\\.[._a-zA-Z])[._a-zA-Z0-9]*)|\\.(?!\\d)/,r=n.either(/0[xX][0-9a-fA-F]+\\.[0-9a-fA-F]*[pP][+-]?\\d+i?/,/0[xX][0-9a-fA-F]+(?:[pP][+-]?\\d+)?[Li]?/,/(?:\\d+(?:\\.\\d*)?|\\.\\d+)(?:[eE][+-]?\\d+)?[Li]?/),i=/[=!<>:]=|\\|\\||&&|:::?|<-|<<-|->>|->|\\|>|[-+*\\/?!$&|:<=>@^~]|\\*\\*/,s=n.either(/[()]/,/[{}]/,/\\[\\[/,/[[\\]]/,/\\\\/,/,/);return{name:"R",keywords:{$pattern:a,keyword:"function if in break next repeat else for while",literal:"NULL NA TRUE FALSE Inf NaN NA_integer_|10 NA_real_|10 NA_character_|10 NA_complex_|10",built_in:"LETTERS letters month.abb month.name pi T F abs acos acosh all any anyNA Arg as.call as.character as.complex as.double as.environment as.integer as.logical as.null.default as.numeric as.raw asin asinh atan atanh attr attributes baseenv browser c call ceiling class Conj cos cosh cospi cummax cummin cumprod cumsum digamma dim dimnames emptyenv exp expression floor forceAndCall gamma gc.time globalenv Im interactive invisible is.array is.atomic is.call is.character is.complex is.double is.environment is.expression is.finite is.function is.infinite is.integer is.language is.list is.logical is.matrix is.na is.name is.nan is.null is.numeric is.object is.pairlist is.raw is.recursive is.single is.symbol lazyLoadDBfetch length lgamma list log max min missing Mod names nargs nzchar oldClass on.exit pos.to.env proc.time prod quote range Re rep retracemem return round seq_along seq_len seq.int sign signif sin sinh sinpi sqrt standardGeneric substitute sum switch tan tanh tanpi tracemem trigamma trunc unclass untracemem UseMethod xtfrm"},contains:[e.COMMENT(/#'/,/$/,{contains:[{scope:"doctag",match:/@examples/,starts:{end:n.lookahead(n.either(/\\n^#'\\s*(?=@[a-zA-Z]+)/,/\\n^(?!#')/)),endsParent:!0}},{scope:"doctag",begin:"@param",end:/$/,contains:[{scope:"variable",variants:[{match:a},{match:/\`(?:\\\\.|[^\`\\\\])+\`/}],endsParent:!0}]},{scope:"doctag",match:/@[a-zA-Z]+/},{scope:"keyword",match:/\\\\[a-zA-Z]+/}]}),e.HASH_COMMENT_MODE,{scope:"string",contains:[e.BACKSLASH_ESCAPE],variants:[e.END_SAME_AS_BEGIN({begin:/[rR]"(-*)\\(/,end:/\\)(-*)"/}),e.END_SAME_AS_BEGIN({begin:/[rR]"(-*)\\{/,end:/\\}(-*)"/}),e.END_SAME_AS_BEGIN({begin:/[rR]"(-*)\\[/,end:/\\](-*)"/}),e.END_SAME_AS_BEGIN({begin:/[rR]'(-*)\\(/,end:/\\)(-*)'/}),e.END_SAME_AS_BEGIN({begin:/[rR]'(-*)\\{/,end:/\\}(-*)'/}),e.END_SAME_AS_BEGIN({begin:/[rR]'(-*)\\[/,end:/\\](-*)'/}),{begin:'"',end:'"',relevance:0},{begin:"'",end:"'",relevance:0}]},{relevance:0,variants:[{scope:{1:"operator",2:"number"},match:[i,r]},{scope:{1:"operator",2:"number"},match:[/%[^%]*%/,r]},{scope:{1:"punctuation",2:"number"},match:[s,r]},{scope:{2:"number"},match:[/[^a-zA-Z0-9._]|^/,r]}]},{scope:{3:"operator"},match:[a,/\\s+/,/<-/,/\\s+/]},{scope:"operator",relevance:0,variants:[{match:i},{match:/%[^%]*%/}]},{scope:"punctuation",relevance:0,match:s},{begin:"\`",end:"\`",contains:[{begin:/\\\\./}]}]}}return rr=t,rr}var ir,Ks;function cu(){if(Ks)return ir;Ks=1;function t(e){return{name:"ReasonML",aliases:["re"],keywords:{$pattern:/[a-z_]\\w*!?/,keyword:["and","as","asr","assert","begin","class","constraint","do","done","downto","else","end","esfun","exception","external","for","fun","function","functor","if","in","include","inherit","initializer","land","lazy","let","lor","lsl","lsr","lxor","mod","module","mutable","new","nonrec","object","of","open","or","pri","pub","rec","sig","struct","switch","then","to","try","type","val","virtual","when","while","with"],built_in:["array","bool","bytes","char","exn|5","float","int","int32","int64","list","lazy_t|5","nativeint|5","ref","string","unit"],literal:["true","false"]},illegal:/(:-|:=|\\$\\{|\\+=)/,contains:[{scope:"literal",match:/\\[(\\|\\|)?\\]|\\(\\)/,relevance:0},e.C_LINE_COMMENT_MODE,e.COMMENT(/\\/\\*/,/\\*\\//,{illegal:/^(#,\\/\\/)/}),{scope:"symbol",match:/\\'[A-Za-z_](?!\\')[\\w\\']*/},{scope:"type",match:/\`[A-Z][\\w\\']*/},{scope:"type",match:/\\b[A-Z][\\w\\']*/,relevance:0},{match:/[a-z_]\\w*\\'[\\w\\']*/,relevance:0},{scope:"operator",match:/\\s+(\\|\\||\\+[\\+\\.]?|\\*[\\*\\/\\.]?|\\/[\\.]?|\\.\\.\\.|\\|>|&&|===?)\\s+/,relevance:0},e.inherit(e.APOS_STRING_MODE,{scope:"string",relevance:0}),e.inherit(e.QUOTE_STRING_MODE,{illegal:null}),{scope:"number",variants:[{match:/\\b0[xX][a-fA-F0-9_]+[Lln]?/},{match:/\\b0[oO][0-7_]+[Lln]?/},{match:/\\b0[bB][01_]+[Lln]?/},{match:/\\b[0-9][0-9_]*([Lln]|(\\.[0-9_]*)?([eE][-+]?[0-9_]+)?)/}],relevance:0}]}}return ir=t,ir}var or,$s;function _u(){if($s)return or;$s=1;function t(e){return{name:"RenderMan RIB",keywords:"ArchiveRecord AreaLightSource Atmosphere Attribute AttributeBegin AttributeEnd Basis Begin Blobby Bound Clipping ClippingPlane Color ColorSamples ConcatTransform Cone CoordinateSystem CoordSysTransform CropWindow Curves Cylinder DepthOfField Detail DetailRange Disk Displacement Display End ErrorHandler Exposure Exterior Format FrameAspectRatio FrameBegin FrameEnd GeneralPolygon GeometricApproximation Geometry Hider Hyperboloid Identity Illuminate Imager Interior LightSource MakeCubeFaceEnvironment MakeLatLongEnvironment MakeShadow MakeTexture Matte MotionBegin MotionEnd NuPatch ObjectBegin ObjectEnd ObjectInstance Opacity Option Orientation Paraboloid Patch PatchMesh Perspective PixelFilter PixelSamples PixelVariance Points PointsGeneralPolygons PointsPolygons Polygon Procedural Projection Quantize ReadArchive RelativeDetail ReverseOrientation Rotate Scale ScreenWindow ShadingInterpolation ShadingRate Shutter Sides Skew SolidBegin SolidEnd Sphere SubdivisionMesh Surface TextureCoordinates Torus Transform TransformBegin TransformEnd TransformPoints Translate TrimCurve WorldBegin WorldEnd",illegal:"</",contains:[e.HASH_COMMENT_MODE,e.C_NUMBER_MODE,e.APOS_STRING_MODE,e.QUOTE_STRING_MODE]}}return or=t,or}var sr,Qs;function du(){if(Qs)return sr;Qs=1;function t(e){const n="[a-zA-Z-_][^\\\\n{]+\\\\{",a={className:"attribute",begin:/[a-zA-Z-_]+/,end:/\\s*:/,excludeEnd:!0,starts:{end:";",relevance:0,contains:[{className:"variable",begin:/\\.[a-zA-Z-_]+/},{className:"keyword",begin:/\\(optional\\)/}]}};return{name:"Roboconf",aliases:["graph","instances"],case_insensitive:!0,keywords:"import",contains:[{begin:"^facet "+n,end:/\\}/,keywords:"facet",contains:[a,e.HASH_COMMENT_MODE]},{begin:"^\\\\s*instance of "+n,end:/\\}/,keywords:"name count channels instance-data instance-state instance of",illegal:/\\S/,contains:["self",a,e.HASH_COMMENT_MODE]},{begin:"^"+n,end:/\\}/,contains:[a,e.HASH_COMMENT_MODE]},e.HASH_COMMENT_MODE]}}return sr=t,sr}var lr,Xs;function uu(){if(Xs)return lr;Xs=1;function t(e){const n="foreach do while for if from to step else on-error and or not in",a="global local beep delay put len typeof pick log time set find environment terminal error execute parse resolve toarray tobool toid toip toip6 tonum tostr totime",r="add remove enable disable set get print export edit find run debug error info warning",i="true false yes no nothing nil null",s="traffic-flow traffic-generator firewall scheduler aaa accounting address-list address align area bandwidth-server bfd bgp bridge client clock community config connection console customer default dhcp-client dhcp-server discovery dns e-mail ethernet filter firmware gps graphing group hardware health hotspot identity igmp-proxy incoming instance interface ip ipsec ipv6 irq l2tp-server lcd ldp logging mac-server mac-winbox mangle manual mirror mme mpls nat nd neighbor network note ntp ospf ospf-v3 ovpn-server page peer pim ping policy pool port ppp pppoe-client pptp-server prefix profile proposal proxy queue radius resource rip ripng route routing screen script security-profiles server service service-port settings shares smb sms sniffer snmp snooper socks sstp-server system tool tracking type upgrade upnp user-manager users user vlan secret vrrp watchdog web-access wireless pptp pppoe lan wan layer7-protocol lease simple raw",o={className:"variable",variants:[{begin:/\\$[\\w\\d#@][\\w\\d_]*/},{begin:/\\$\\{(.*?)\\}/}]},_={className:"string",begin:/"/,end:/"/,contains:[e.BACKSLASH_ESCAPE,o,{className:"variable",begin:/\\$\\(/,end:/\\)/,contains:[e.BACKSLASH_ESCAPE]}]},l={className:"string",begin:/'/,end:/'/};return{name:"MikroTik RouterOS script",aliases:["mikrotik"],case_insensitive:!0,keywords:{$pattern:/:?[\\w-]+/,literal:i,keyword:n+" :"+n.split(" ").join(" :")+" :"+a.split(" ").join(" :")},contains:[{variants:[{begin:/\\/\\*/,end:/\\*\\//},{begin:/\\/\\//,end:/$/},{begin:/<\\//,end:/>/}],illegal:/./},e.COMMENT("^#","$"),_,l,o,{begin:/[\\w-]+=([^\\s{}[\\]()>]+)/,relevance:0,returnBegin:!0,contains:[{className:"attribute",begin:/[^=]+/},{begin:/=/,endsWithParent:!0,relevance:0,contains:[_,l,o,{className:"literal",begin:"\\\\b("+i.split(" ").join("|")+")\\\\b"},{begin:/("[^"]*"|[^\\s{}[\\]]+)/}]}]},{className:"number",begin:/\\*[0-9a-fA-F]+/},{begin:"\\\\b("+r.split(" ").join("|")+")([\\\\s[(\\\\]|])",returnBegin:!0,contains:[{className:"built_in",begin:/\\w+/}]},{className:"built_in",variants:[{begin:"(\\\\.\\\\./|/|\\\\s)(("+s.split(" ").join("|")+");?\\\\s)+"},{begin:/\\.\\./,relevance:0}]}]}}return lr=t,lr}var cr,Zs;function mu(){if(Zs)return cr;Zs=1;function t(e){const n=["abs","acos","ambient","area","asin","atan","atmosphere","attribute","calculatenormal","ceil","cellnoise","clamp","comp","concat","cos","degrees","depth","Deriv","diffuse","distance","Du","Dv","environment","exp","faceforward","filterstep","floor","format","fresnel","incident","length","lightsource","log","match","max","min","mod","noise","normalize","ntransform","opposite","option","phong","pnoise","pow","printf","ptlined","radians","random","reflect","refract","renderinfo","round","setcomp","setxcomp","setycomp","setzcomp","shadow","sign","sin","smoothstep","specular","specularbrdf","spline","sqrt","step","tan","texture","textureinfo","trace","transform","vtransform","xcomp","ycomp","zcomp"],a=["matrix","float","color","point","normal","vector"],r=["while","for","if","do","return","else","break","extern","continue"],i={match:[/(surface|displacement|light|volume|imager)/,/\\s+/,e.IDENT_RE],scope:{1:"keyword",3:"title.class"}};return{name:"RenderMan RSL",keywords:{keyword:r,built_in:n,type:a},illegal:"</",contains:[e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,e.QUOTE_STRING_MODE,e.APOS_STRING_MODE,e.C_NUMBER_MODE,{className:"meta",begin:"#",end:"$"},i,{beginKeywords:"illuminate illuminance gather",end:"\\\\("}]}}return cr=t,cr}var _r,Js;function pu(){if(Js)return _r;Js=1;function t(e){return{name:"Oracle Rules Language",keywords:{keyword:"BILL_PERIOD BILL_START BILL_STOP RS_EFFECTIVE_START RS_EFFECTIVE_STOP RS_JURIS_CODE RS_OPCO_CODE INTDADDATTRIBUTE|5 INTDADDVMSG|5 INTDBLOCKOP|5 INTDBLOCKOPNA|5 INTDCLOSE|5 INTDCOUNT|5 INTDCOUNTSTATUSCODE|5 INTDCREATEMASK|5 INTDCREATEDAYMASK|5 INTDCREATEFACTORMASK|5 INTDCREATEHANDLE|5 INTDCREATEOVERRIDEDAYMASK|5 INTDCREATEOVERRIDEMASK|5 INTDCREATESTATUSCODEMASK|5 INTDCREATETOUPERIOD|5 INTDDELETE|5 INTDDIPTEST|5 INTDEXPORT|5 INTDGETERRORCODE|5 INTDGETERRORMESSAGE|5 INTDISEQUAL|5 INTDJOIN|5 INTDLOAD|5 INTDLOADACTUALCUT|5 INTDLOADDATES|5 INTDLOADHIST|5 INTDLOADLIST|5 INTDLOADLISTDATES|5 INTDLOADLISTENERGY|5 INTDLOADLISTHIST|5 INTDLOADRELATEDCHANNEL|5 INTDLOADSP|5 INTDLOADSTAGING|5 INTDLOADUOM|5 INTDLOADUOMDATES|5 INTDLOADUOMHIST|5 INTDLOADVERSION|5 INTDOPEN|5 INTDREADFIRST|5 INTDREADNEXT|5 INTDRECCOUNT|5 INTDRELEASE|5 INTDREPLACE|5 INTDROLLAVG|5 INTDROLLPEAK|5 INTDSCALAROP|5 INTDSCALE|5 INTDSETATTRIBUTE|5 INTDSETDSTPARTICIPANT|5 INTDSETSTRING|5 INTDSETVALUE|5 INTDSETVALUESTATUS|5 INTDSHIFTSTARTTIME|5 INTDSMOOTH|5 INTDSORT|5 INTDSPIKETEST|5 INTDSUBSET|5 INTDTOU|5 INTDTOURELEASE|5 INTDTOUVALUE|5 INTDUPDATESTATS|5 INTDVALUE|5 STDEV INTDDELETEEX|5 INTDLOADEXACTUAL|5 INTDLOADEXCUT|5 INTDLOADEXDATES|5 INTDLOADEX|5 INTDLOADEXRELATEDCHANNEL|5 INTDSAVEEX|5 MVLOAD|5 MVLOADACCT|5 MVLOADACCTDATES|5 MVLOADACCTHIST|5 MVLOADDATES|5 MVLOADHIST|5 MVLOADLIST|5 MVLOADLISTDATES|5 MVLOADLISTHIST|5 IF FOR NEXT DONE SELECT END CALL ABORT CLEAR CHANNEL FACTOR LIST NUMBER OVERRIDE SET WEEK DISTRIBUTIONNODE ELSE WHEN THEN OTHERWISE IENUM CSV INCLUDE LEAVE RIDER SAVE DELETE NOVALUE SECTION WARN SAVE_UPDATE DETERMINANT LABEL REPORT REVENUE EACH IN FROM TOTAL CHARGE BLOCK AND OR CSV_FILE RATE_CODE AUXILIARY_DEMAND UIDACCOUNT RS BILL_PERIOD_SELECT HOURS_PER_MONTH INTD_ERROR_STOP SEASON_SCHEDULE_NAME ACCOUNTFACTOR ARRAYUPPERBOUND CALLSTOREDPROC GETADOCONNECTION GETCONNECT GETDATASOURCE GETQUALIFIER GETUSERID HASVALUE LISTCOUNT LISTOP LISTUPDATE LISTVALUE PRORATEFACTOR RSPRORATE SETBINPATH SETDBMONITOR WQ_OPEN BILLINGHOURS DATE DATEFROMFLOAT DATETIMEFROMSTRING DATETIMETOSTRING DATETOFLOAT DAY DAYDIFF DAYNAME DBDATETIME HOUR MINUTE MONTH MONTHDIFF MONTHHOURS MONTHNAME ROUNDDATE SAMEWEEKDAYLASTYEAR SECOND WEEKDAY WEEKDIFF YEAR YEARDAY YEARSTR COMPSUM HISTCOUNT HISTMAX HISTMIN HISTMINNZ HISTVALUE MAXNRANGE MAXRANGE MINRANGE COMPIKVA COMPKVA COMPKVARFROMKQKW COMPLF IDATTR FLAG LF2KW LF2KWH MAXKW POWERFACTOR READING2USAGE AVGSEASON MAXSEASON MONTHLYMERGE SEASONVALUE SUMSEASON ACCTREADDATES ACCTTABLELOAD CONFIGADD CONFIGGET CREATEOBJECT CREATEREPORT EMAILCLIENT EXPBLKMDMUSAGE EXPMDMUSAGE EXPORT_USAGE FACTORINEFFECT GETUSERSPECIFIEDSTOP INEFFECT ISHOLIDAY RUNRATE SAVE_PROFILE SETREPORTTITLE USEREXIT WATFORRUNRATE TO TABLE ACOS ASIN ATAN ATAN2 BITAND CEIL COS COSECANT COSH COTANGENT DIVQUOT DIVREM EXP FABS FLOOR FMOD FREPM FREXPN LOG LOG10 MAX MAXN MIN MINNZ MODF POW ROUND ROUND2VALUE ROUNDINT SECANT SIN SINH SQROOT TAN TANH FLOAT2STRING FLOAT2STRINGNC INSTR LEFT LEN LTRIM MID RIGHT RTRIM STRING STRINGNC TOLOWER TOUPPER TRIM NUMDAYS READ_DATE STAGING",built_in:"IDENTIFIER OPTIONS XML_ELEMENT XML_OP XML_ELEMENT_OF DOMDOCCREATE DOMDOCLOADFILE DOMDOCLOADXML DOMDOCSAVEFILE DOMDOCGETROOT DOMDOCADDPI DOMNODEGETNAME DOMNODEGETTYPE DOMNODEGETVALUE DOMNODEGETCHILDCT DOMNODEGETFIRSTCHILD DOMNODEGETSIBLING DOMNODECREATECHILDELEMENT DOMNODESETATTRIBUTE DOMNODEGETCHILDELEMENTCT DOMNODEGETFIRSTCHILDELEMENT DOMNODEGETSIBLINGELEMENT DOMNODEGETATTRIBUTECT DOMNODEGETATTRIBUTEI DOMNODEGETATTRIBUTEBYNAME DOMNODEGETBYNAME"},contains:[e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,e.APOS_STRING_MODE,e.QUOTE_STRING_MODE,e.C_NUMBER_MODE,{className:"literal",variants:[{begin:"#\\\\s+",relevance:0},{begin:"#[a-zA-Z .]+"}]}]}}return _r=t,_r}var dr,js;function Eu(){if(js)return dr;js=1;function t(e){const n=e.regex,a=/(r#)?/,r=n.concat(a,e.UNDERSCORE_IDENT_RE),i=n.concat(a,e.IDENT_RE),s={className:"title.function.invoke",relevance:0,begin:n.concat(/\\b/,/(?!let|for|while|if|else|match\\b)/,i,n.lookahead(/\\s*\\(/))},o="([ui](8|16|32|64|128|size)|f(32|64))?",_=["abstract","as","async","await","become","box","break","const","continue","crate","do","dyn","else","enum","extern","false","final","fn","for","if","impl","in","let","loop","macro","match","mod","move","mut","override","priv","pub","ref","return","self","Self","static","struct","super","trait","true","try","type","typeof","union","unsafe","unsized","use","virtual","where","while","yield"],l=["true","false","Some","None","Ok","Err"],c=["drop ","Copy","Send","Sized","Sync","Drop","Fn","FnMut","FnOnce","ToOwned","Clone","Debug","PartialEq","PartialOrd","Eq","Ord","AsRef","AsMut","Into","From","Default","Iterator","Extend","IntoIterator","DoubleEndedIterator","ExactSizeIterator","SliceConcatExt","ToString","assert!","assert_eq!","bitflags!","bytes!","cfg!","col!","concat!","concat_idents!","debug_assert!","debug_assert_eq!","env!","eprintln!","panic!","file!","format!","format_args!","include_bytes!","include_str!","line!","local_data_key!","module_path!","option_env!","print!","println!","select!","stringify!","try!","unimplemented!","unreachable!","vec!","write!","writeln!","macro_rules!","assert_ne!","debug_assert_ne!"],d=["i8","i16","i32","i64","i128","isize","u8","u16","u32","u64","u128","usize","f32","f64","str","char","bool","Box","Option","Result","String","Vec"];return{name:"Rust",aliases:["rs"],keywords:{$pattern:e.IDENT_RE+"!?",type:d,keyword:_,literal:l,built_in:c},illegal:"</",contains:[e.C_LINE_COMMENT_MODE,e.COMMENT("/\\\\*","\\\\*/",{contains:["self"]}),e.inherit(e.QUOTE_STRING_MODE,{begin:/b?"/,illegal:null}),{className:"symbol",begin:/'[a-zA-Z_][a-zA-Z0-9_]*(?!')/},{scope:"string",variants:[{begin:/b?r(#*)"(.|\\n)*?"\\1(?!#)/},{begin:/b?'/,end:/'/,contains:[{scope:"char.escape",match:/\\\\('|\\w|x\\w{2}|u\\w{4}|U\\w{8})/}]}]},{className:"number",variants:[{begin:"\\\\b0b([01_]+)"+o},{begin:"\\\\b0o([0-7_]+)"+o},{begin:"\\\\b0x([A-Fa-f0-9_]+)"+o},{begin:"\\\\b(\\\\d[\\\\d_]*(\\\\.[0-9_]+)?([eE][+-]?[0-9_]+)?)"+o}],relevance:0},{begin:[/fn/,/\\s+/,r],className:{1:"keyword",3:"title.function"}},{className:"meta",begin:"#!?\\\\[",end:"\\\\]",contains:[{className:"string",begin:/"/,end:/"/,contains:[e.BACKSLASH_ESCAPE]}]},{begin:[/let/,/\\s+/,/(?:mut\\s+)?/,r],className:{1:"keyword",3:"keyword",4:"variable"}},{begin:[/for/,/\\s+/,r,/\\s+/,/in/],className:{1:"keyword",3:"variable",5:"keyword"}},{begin:[/type/,/\\s+/,r],className:{1:"keyword",3:"title.class"}},{begin:[/(?:trait|enum|struct|union|impl|for)/,/\\s+/,r],className:{1:"keyword",3:"title.class"}},{begin:e.IDENT_RE+"::",keywords:{keyword:"Self",built_in:c,type:d}},{className:"punctuation",begin:"->"},s]}}return dr=t,dr}var ur,el;function gu(){if(el)return ur;el=1;function t(e){const n=e.regex,a=["do","if","then","else","end","until","while","abort","array","attrib","by","call","cards","cards4","catname","continue","datalines","datalines4","delete","delim","delimiter","display","dm","drop","endsas","error","file","filename","footnote","format","goto","in","infile","informat","input","keep","label","leave","length","libname","link","list","lostcard","merge","missing","modify","options","output","out","page","put","redirect","remove","rename","replace","retain","return","select","set","skip","startsas","stop","title","update","waitsas","where","window","x|0","systask","add","and","alter","as","cascade","check","create","delete","describe","distinct","drop","foreign","from","group","having","index","insert","into","in","key","like","message","modify","msgtype","not","null","on","or","order","primary","references","reset","restrict","select","set","table","unique","update","validate","view","where"],r=["abs","addr","airy","arcos","arsin","atan","attrc","attrn","band","betainv","blshift","bnot","bor","brshift","bxor","byte","cdf","ceil","cexist","cinv","close","cnonct","collate","compbl","compound","compress","cos","cosh","css","curobs","cv","daccdb","daccdbsl","daccsl","daccsyd","dacctab","dairy","date","datejul","datepart","datetime","day","dclose","depdb","depdbsl","depdbsl","depsl","depsl","depsyd","depsyd","deptab","deptab","dequote","dhms","dif","digamma","dim","dinfo","dnum","dopen","doptname","doptnum","dread","dropnote","dsname","erf","erfc","exist","exp","fappend","fclose","fcol","fdelete","fetch","fetchobs","fexist","fget","fileexist","filename","fileref","finfo","finv","fipname","fipnamel","fipstate","floor","fnonct","fnote","fopen","foptname","foptnum","fpoint","fpos","fput","fread","frewind","frlen","fsep","fuzz","fwrite","gaminv","gamma","getoption","getvarc","getvarn","hbound","hms","hosthelp","hour","ibessel","index","indexc","indexw","input","inputc","inputn","int","intck","intnx","intrr","irr","jbessel","juldate","kurtosis","lag","lbound","left","length","lgamma","libname","libref","log","log10","log2","logpdf","logpmf","logsdf","lowcase","max","mdy","mean","min","minute","mod","month","mopen","mort","n","netpv","nmiss","normal","note","npv","open","ordinal","pathname","pdf","peek","peekc","pmf","point","poisson","poke","probbeta","probbnml","probchi","probf","probgam","probhypr","probit","probnegb","probnorm","probt","put","putc","putn","qtr","quote","ranbin","rancau","ranexp","rangam","range","rank","rannor","ranpoi","rantbl","rantri","ranuni","repeat","resolve","reverse","rewind","right","round","saving","scan","sdf","second","sign","sin","sinh","skewness","soundex","spedis","sqrt","std","stderr","stfips","stname","stnamel","substr","sum","symget","sysget","sysmsg","sysprod","sysrc","system","tan","tanh","time","timepart","tinv","tnonct","today","translate","tranwrd","trigamma","trim","trimn","trunc","uniform","upcase","uss","var","varfmt","varinfmt","varlabel","varlen","varname","varnum","varray","varrayx","vartype","verify","vformat","vformatd","vformatdx","vformatn","vformatnx","vformatw","vformatwx","vformatx","vinarray","vinarrayx","vinformat","vinformatd","vinformatdx","vinformatn","vinformatnx","vinformatw","vinformatwx","vinformatx","vlabel","vlabelx","vlength","vlengthx","vname","vnamex","vtype","vtypex","weekday","year","yyq","zipfips","zipname","zipnamel","zipstate"],i=["bquote","nrbquote","cmpres","qcmpres","compstor","datatyp","display","do","else","end","eval","global","goto","if","index","input","keydef","label","left","length","let","local","lowcase","macro","mend","nrbquote","nrquote","nrstr","put","qcmpres","qleft","qlowcase","qscan","qsubstr","qsysfunc","qtrim","quote","qupcase","scan","str","substr","superq","syscall","sysevalf","sysexec","sysfunc","sysget","syslput","sysprod","sysrc","sysrput","then","to","trim","unquote","until","upcase","verify","while","window"];return{name:"SAS",case_insensitive:!0,keywords:{literal:["null","missing","_all_","_automatic_","_character_","_infile_","_n_","_name_","_null_","_numeric_","_user_","_webout_"],keyword:a},contains:[{className:"keyword",begin:/^\\s*(proc [\\w\\d_]+|data|run|quit)[\\s;]/},{className:"variable",begin:/&[a-zA-Z_&][a-zA-Z0-9_]*\\.?/},{begin:[/^\\s*/,/datalines;|cards;/,/(?:.*\\n)+/,/^\\s*;\\s*$/],className:{2:"keyword",3:"string"}},{begin:[/%mend|%macro/,/\\s+/,/[a-zA-Z_&][a-zA-Z0-9_]*/],className:{1:"built_in",3:"title.function"}},{className:"built_in",begin:"%"+n.either(...i)},{className:"title.function",begin:/%[a-zA-Z_][a-zA-Z_0-9]*/},{className:"meta",begin:n.either(...r)+"(?=\\\\()"},{className:"string",variants:[e.APOS_STRING_MODE,e.QUOTE_STRING_MODE]},e.COMMENT("\\\\*",";"),e.C_BLOCK_COMMENT_MODE]}}return ur=t,ur}var mr,tl;function Su(){if(tl)return mr;tl=1;function t(e){const n=e.regex,a={className:"meta",begin:"@[A-Za-z]+"},r={className:"subst",variants:[{begin:"\\\\$[A-Za-z0-9_]+"},{begin:/\\$\\{/,end:/\\}/}]},i={className:"string",variants:[{begin:'"""',end:'"""'},{begin:'"',end:'"',illegal:"\\\\n",contains:[e.BACKSLASH_ESCAPE]},{begin:'[a-z]+"',end:'"',illegal:"\\\\n",contains:[e.BACKSLASH_ESCAPE,r]},{className:"string",begin:'[a-z]+"""',end:'"""',contains:[r],relevance:10}]},s={className:"type",begin:"\\\\b[A-Z][A-Za-z0-9_]*",relevance:0},o={className:"title",begin:/[^0-9\\n\\t "'(),.\`{}\\[\\]:;][^\\n\\t "'(),.\`{}\\[\\]:;]+|[^0-9\\n\\t "'(),.\`{}\\[\\]:;=]/,relevance:0},_={className:"class",beginKeywords:"class object trait type",end:/[:={\\[\\n;]/,excludeEnd:!0,contains:[e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,{beginKeywords:"extends with",relevance:10},{begin:/\\[/,end:/\\]/,excludeBegin:!0,excludeEnd:!0,relevance:0,contains:[s,e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE]},{className:"params",begin:/\\(/,end:/\\)/,excludeBegin:!0,excludeEnd:!0,relevance:0,contains:[s,e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE]},o]},l={className:"function",beginKeywords:"def",end:n.lookahead(/[:={\\[(\\n;]/),contains:[o]},c={begin:[/^\\s*/,"extension",/\\s+(?=[[(])/],beginScope:{2:"keyword"}},d={begin:[/^\\s*/,/end/,/\\s+/,/(extension\\b)?/],beginScope:{2:"keyword",4:"keyword"}},m=[{match:/\\.inline\\b/},{begin:/\\binline(?=\\s)/,keywords:"inline"}],p={begin:[/\\(\\s*/,/using/,/\\s+(?!\\))/],beginScope:{2:"keyword"}};return{name:"Scala",keywords:{literal:"true false null",keyword:"type yield lazy override def with val var sealed abstract private trait object if then forSome for while do throw finally protected extends import final return else break new catch super class case package default try this match continue throws implicit export enum given transparent"},contains:[{begin:["//>",/\\s+/,/using/,/\\s+/,/\\S+/],beginScope:{1:"comment",3:"keyword",5:"type"},end:/$/,contains:[{className:"string",begin:/\\S+/}]},e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,i,s,l,_,e.C_NUMBER_MODE,c,d,...m,p,a]}}return mr=t,mr}var pr,nl;function Tu(){if(nl)return pr;nl=1;function t(e){const n="[^\\\\(\\\\)\\\\[\\\\]\\\\{\\\\}\\",'\`;#|\\\\\\\\\\\\s]+",a="(-|\\\\+)?\\\\d+([./]\\\\d+)?",r=a+"[+\\\\-]"+a+"i",i={$pattern:n,built_in:"case-lambda call/cc class define-class exit-handler field import inherit init-field interface let*-values let-values let/ec mixin opt-lambda override protect provide public rename require require-for-syntax syntax syntax-case syntax-error unit/sig unless when with-syntax and begin call-with-current-continuation call-with-input-file call-with-output-file case cond define define-syntax delay do dynamic-wind else for-each if lambda let let* let-syntax letrec letrec-syntax map or syntax-rules ' * + , ,@ - ... / ; < <= = => > >= \` abs acos angle append apply asin assoc assq assv atan boolean? caar cadr call-with-input-file call-with-output-file call-with-values car cdddar cddddr cdr ceiling char->integer char-alphabetic? char-ci<=? char-ci<? char-ci=? char-ci>=? char-ci>? char-downcase char-lower-case? char-numeric? char-ready? char-upcase char-upper-case? char-whitespace? char<=? char<? char=? char>=? char>? char? close-input-port close-output-port complex? cons cos current-input-port current-output-port denominator display eof-object? eq? equal? eqv? eval even? exact->inexact exact? exp expt floor force gcd imag-part inexact->exact inexact? input-port? integer->char integer? interaction-environment lcm length list list->string list->vector list-ref list-tail list? load log magnitude make-polar make-rectangular make-string make-vector max member memq memv min modulo negative? newline not null-environment null? number->string number? numerator odd? open-input-file open-output-file output-port? pair? peek-char port? positive? procedure? quasiquote quote quotient rational? rationalize read read-char real-part real? remainder reverse round scheme-report-environment set! set-car! set-cdr! sin sqrt string string->list string->number string->symbol string-append string-ci<=? string-ci<? string-ci=? string-ci>=? string-ci>? string-copy string-fill! string-length string-ref string-set! string<=? string<? string=? string>=? string>? string? substring symbol->string symbol? tan transcript-off transcript-on truncate values vector vector->list vector-fill! vector-length vector-ref vector-set! with-input-from-file with-output-to-file write write-char zero?"},s={className:"literal",begin:"(#t|#f|#\\\\\\\\"+n+"|#\\\\\\\\.)"},o={className:"number",variants:[{begin:a,relevance:0},{begin:r,relevance:0},{begin:"#b[0-1]+(/[0-1]+)?"},{begin:"#o[0-7]+(/[0-7]+)?"},{begin:"#x[0-9a-f]+(/[0-9a-f]+)?"}]},_=e.QUOTE_STRING_MODE,l=[e.COMMENT(";","$",{relevance:0}),e.COMMENT("#\\\\|","\\\\|#")],c={begin:n,relevance:0},d={className:"symbol",begin:"'"+n},m={endsWithParent:!0,relevance:0},p={variants:[{begin:/'/},{begin:"\`"}],contains:[{begin:"\\\\(",end:"\\\\)",contains:["self",s,_,o,c,d]}]},E={className:"name",relevance:0,begin:n,keywords:i},S={variants:[{begin:"\\\\(",end:"\\\\)"},{begin:"\\\\[",end:"\\\\]"}],contains:[{begin:/lambda/,endsWithParent:!0,returnBegin:!0,contains:[E,{endsParent:!0,variants:[{begin:/\\(/,end:/\\)/},{begin:/\\[/,end:/\\]/}],contains:[c]}]},E,m]};return m.contains=[s,o,_,c,d,p,S].concat(l),{name:"Scheme",aliases:["scm"],illegal:/\\S/,contains:[e.SHEBANG(),o,_,d,p,S].concat(l)}}return pr=t,pr}var Er,al;function bu(){if(al)return Er;al=1;function t(e){const n=[e.C_NUMBER_MODE,{className:"string",begin:\`'|"\`,end:\`'|"\`,contains:[e.BACKSLASH_ESCAPE,{begin:"''"}]}];return{name:"Scilab",aliases:["sci"],keywords:{$pattern:/%?\\w+/,keyword:"abort break case clear catch continue do elseif else endfunction end for function global if pause return resume select try then while",literal:"%f %F %t %T %pi %eps %inf %nan %e %i %z %s",built_in:"abs and acos asin atan ceil cd chdir clearglobal cosh cos cumprod deff disp error exec execstr exists exp eye gettext floor fprintf fread fsolve imag isdef isempty isinfisnan isvector lasterror length load linspace list listfiles log10 log2 log max min msprintf mclose mopen ones or pathconvert poly printf prod pwd rand real round sinh sin size gsort sprintf sqrt strcat strcmps tring sum system tanh tan type typename warning zeros matrix"},illegal:'("|#|/\\\\*|\\\\s+/\\\\w+)',contains:[{className:"function",beginKeywords:"function",end:"$",contains:[e.UNDERSCORE_TITLE_MODE,{className:"params",begin:"\\\\(",end:"\\\\)"}]},{begin:"[a-zA-Z_][a-zA-Z_0-9]*[\\\\.']+",relevance:0},{begin:"\\\\[",end:"\\\\][\\\\.']*",relevance:0,contains:n},e.COMMENT("//","$")].concat(n)}}return Er=t,Er}var gr,rl;function Ru(){if(rl)return gr;rl=1;const t=l=>({IMPORTANT:{scope:"meta",begin:"!important"},BLOCK_COMMENT:l.C_BLOCK_COMMENT_MODE,HEXCOLOR:{scope:"number",begin:/#(([0-9a-fA-F]{3,4})|(([0-9a-fA-F]{2}){3,4}))\\b/},FUNCTION_DISPATCH:{className:"built_in",begin:/[\\w-]+(?=\\()/},ATTRIBUTE_SELECTOR_MODE:{scope:"selector-attr",begin:/\\[/,end:/\\]/,illegal:"$",contains:[l.APOS_STRING_MODE,l.QUOTE_STRING_MODE]},CSS_NUMBER_MODE:{scope:"number",begin:l.NUMBER_RE+"(%|em|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc|px|deg|grad|rad|turn|s|ms|Hz|kHz|dpi|dpcm|dppx)?",relevance:0},CSS_VARIABLE:{className:"attr",begin:/--[A-Za-z_][A-Za-z0-9_-]*/}}),e=["a","abbr","address","article","aside","audio","b","blockquote","body","button","canvas","caption","cite","code","dd","del","details","dfn","div","dl","dt","em","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","header","hgroup","html","i","iframe","img","input","ins","kbd","label","legend","li","main","mark","menu","nav","object","ol","optgroup","option","p","picture","q","quote","samp","section","select","source","span","strong","summary","sup","table","tbody","td","textarea","tfoot","th","thead","time","tr","ul","var","video"],n=["defs","g","marker","mask","pattern","svg","switch","symbol","feBlend","feColorMatrix","feComponentTransfer","feComposite","feConvolveMatrix","feDiffuseLighting","feDisplacementMap","feFlood","feGaussianBlur","feImage","feMerge","feMorphology","feOffset","feSpecularLighting","feTile","feTurbulence","linearGradient","radialGradient","stop","circle","ellipse","image","line","path","polygon","polyline","rect","text","use","textPath","tspan","foreignObject","clipPath"],a=[...e,...n],r=["any-hover","any-pointer","aspect-ratio","color","color-gamut","color-index","device-aspect-ratio","device-height","device-width","display-mode","forced-colors","grid","height","hover","inverted-colors","monochrome","orientation","overflow-block","overflow-inline","pointer","prefers-color-scheme","prefers-contrast","prefers-reduced-motion","prefers-reduced-transparency","resolution","scan","scripting","update","width","min-width","max-width","min-height","max-height"].sort().reverse(),i=["active","any-link","blank","checked","current","default","defined","dir","disabled","drop","empty","enabled","first","first-child","first-of-type","fullscreen","future","focus","focus-visible","focus-within","has","host","host-context","hover","indeterminate","in-range","invalid","is","lang","last-child","last-of-type","left","link","local-link","not","nth-child","nth-col","nth-last-child","nth-last-col","nth-last-of-type","nth-of-type","only-child","only-of-type","optional","out-of-range","past","placeholder-shown","read-only","read-write","required","right","root","scope","target","target-within","user-invalid","valid","visited","where"].sort().reverse(),s=["after","backdrop","before","cue","cue-region","first-letter","first-line","grammar-error","marker","part","placeholder","selection","slotted","spelling-error"].sort().reverse(),o=["accent-color","align-content","align-items","align-self","alignment-baseline","all","anchor-name","animation","animation-composition","animation-delay","animation-direction","animation-duration","animation-fill-mode","animation-iteration-count","animation-name","animation-play-state","animation-range","animation-range-end","animation-range-start","animation-timeline","animation-timing-function","appearance","aspect-ratio","backdrop-filter","backface-visibility","background","background-attachment","background-blend-mode","background-clip","background-color","background-image","background-origin","background-position","background-position-x","background-position-y","background-repeat","background-size","baseline-shift","block-size","border","border-block","border-block-color","border-block-end","border-block-end-color","border-block-end-style","border-block-end-width","border-block-start","border-block-start-color","border-block-start-style","border-block-start-width","border-block-style","border-block-width","border-bottom","border-bottom-color","border-bottom-left-radius","border-bottom-right-radius","border-bottom-style","border-bottom-width","border-collapse","border-color","border-end-end-radius","border-end-start-radius","border-image","border-image-outset","border-image-repeat","border-image-slice","border-image-source","border-image-width","border-inline","border-inline-color","border-inline-end","border-inline-end-color","border-inline-end-style","border-inline-end-width","border-inline-start","border-inline-start-color","border-inline-start-style","border-inline-start-width","border-inline-style","border-inline-width","border-left","border-left-color","border-left-style","border-left-width","border-radius","border-right","border-right-color","border-right-style","border-right-width","border-spacing","border-start-end-radius","border-start-start-radius","border-style","border-top","border-top-color","border-top-left-radius","border-top-right-radius","border-top-style","border-top-width","border-width","bottom","box-align","box-decoration-break","box-direction","box-flex","box-flex-group","box-lines","box-ordinal-group","box-orient","box-pack","box-shadow","box-sizing","break-after","break-before","break-inside","caption-side","caret-color","clear","clip","clip-path","clip-rule","color","color-interpolation","color-interpolation-filters","color-profile","color-rendering","color-scheme","column-count","column-fill","column-gap","column-rule","column-rule-color","column-rule-style","column-rule-width","column-span","column-width","columns","contain","contain-intrinsic-block-size","contain-intrinsic-height","contain-intrinsic-inline-size","contain-intrinsic-size","contain-intrinsic-width","container","container-name","container-type","content","content-visibility","counter-increment","counter-reset","counter-set","cue","cue-after","cue-before","cursor","cx","cy","direction","display","dominant-baseline","empty-cells","enable-background","field-sizing","fill","fill-opacity","fill-rule","filter","flex","flex-basis","flex-direction","flex-flow","flex-grow","flex-shrink","flex-wrap","float","flood-color","flood-opacity","flow","font","font-display","font-family","font-feature-settings","font-kerning","font-language-override","font-optical-sizing","font-palette","font-size","font-size-adjust","font-smooth","font-smoothing","font-stretch","font-style","font-synthesis","font-synthesis-position","font-synthesis-small-caps","font-synthesis-style","font-synthesis-weight","font-variant","font-variant-alternates","font-variant-caps","font-variant-east-asian","font-variant-emoji","font-variant-ligatures","font-variant-numeric","font-variant-position","font-variation-settings","font-weight","forced-color-adjust","gap","glyph-orientation-horizontal","glyph-orientation-vertical","grid","grid-area","grid-auto-columns","grid-auto-flow","grid-auto-rows","grid-column","grid-column-end","grid-column-start","grid-gap","grid-row","grid-row-end","grid-row-start","grid-template","grid-template-areas","grid-template-columns","grid-template-rows","hanging-punctuation","height","hyphenate-character","hyphenate-limit-chars","hyphens","icon","image-orientation","image-rendering","image-resolution","ime-mode","initial-letter","initial-letter-align","inline-size","inset","inset-area","inset-block","inset-block-end","inset-block-start","inset-inline","inset-inline-end","inset-inline-start","isolation","justify-content","justify-items","justify-self","kerning","left","letter-spacing","lighting-color","line-break","line-height","line-height-step","list-style","list-style-image","list-style-position","list-style-type","margin","margin-block","margin-block-end","margin-block-start","margin-bottom","margin-inline","margin-inline-end","margin-inline-start","margin-left","margin-right","margin-top","margin-trim","marker","marker-end","marker-mid","marker-start","marks","mask","mask-border","mask-border-mode","mask-border-outset","mask-border-repeat","mask-border-slice","mask-border-source","mask-border-width","mask-clip","mask-composite","mask-image","mask-mode","mask-origin","mask-position","mask-repeat","mask-size","mask-type","masonry-auto-flow","math-depth","math-shift","math-style","max-block-size","max-height","max-inline-size","max-width","min-block-size","min-height","min-inline-size","min-width","mix-blend-mode","nav-down","nav-index","nav-left","nav-right","nav-up","none","normal","object-fit","object-position","offset","offset-anchor","offset-distance","offset-path","offset-position","offset-rotate","opacity","order","orphans","outline","outline-color","outline-offset","outline-style","outline-width","overflow","overflow-anchor","overflow-block","overflow-clip-margin","overflow-inline","overflow-wrap","overflow-x","overflow-y","overlay","overscroll-behavior","overscroll-behavior-block","overscroll-behavior-inline","overscroll-behavior-x","overscroll-behavior-y","padding","padding-block","padding-block-end","padding-block-start","padding-bottom","padding-inline","padding-inline-end","padding-inline-start","padding-left","padding-right","padding-top","page","page-break-after","page-break-before","page-break-inside","paint-order","pause","pause-after","pause-before","perspective","perspective-origin","place-content","place-items","place-self","pointer-events","position","position-anchor","position-visibility","print-color-adjust","quotes","r","resize","rest","rest-after","rest-before","right","rotate","row-gap","ruby-align","ruby-position","scale","scroll-behavior","scroll-margin","scroll-margin-block","scroll-margin-block-end","scroll-margin-block-start","scroll-margin-bottom","scroll-margin-inline","scroll-margin-inline-end","scroll-margin-inline-start","scroll-margin-left","scroll-margin-right","scroll-margin-top","scroll-padding","scroll-padding-block","scroll-padding-block-end","scroll-padding-block-start","scroll-padding-bottom","scroll-padding-inline","scroll-padding-inline-end","scroll-padding-inline-start","scroll-padding-left","scroll-padding-right","scroll-padding-top","scroll-snap-align","scroll-snap-stop","scroll-snap-type","scroll-timeline","scroll-timeline-axis","scroll-timeline-name","scrollbar-color","scrollbar-gutter","scrollbar-width","shape-image-threshold","shape-margin","shape-outside","shape-rendering","speak","speak-as","src","stop-color","stop-opacity","stroke","stroke-dasharray","stroke-dashoffset","stroke-linecap","stroke-linejoin","stroke-miterlimit","stroke-opacity","stroke-width","tab-size","table-layout","text-align","text-align-all","text-align-last","text-anchor","text-combine-upright","text-decoration","text-decoration-color","text-decoration-line","text-decoration-skip","text-decoration-skip-ink","text-decoration-style","text-decoration-thickness","text-emphasis","text-emphasis-color","text-emphasis-position","text-emphasis-style","text-indent","text-justify","text-orientation","text-overflow","text-rendering","text-shadow","text-size-adjust","text-transform","text-underline-offset","text-underline-position","text-wrap","text-wrap-mode","text-wrap-style","timeline-scope","top","touch-action","transform","transform-box","transform-origin","transform-style","transition","transition-behavior","transition-delay","transition-duration","transition-property","transition-timing-function","translate","unicode-bidi","user-modify","user-select","vector-effect","vertical-align","view-timeline","view-timeline-axis","view-timeline-inset","view-timeline-name","view-transition-name","visibility","voice-balance","voice-duration","voice-family","voice-pitch","voice-range","voice-rate","voice-stress","voice-volume","white-space","white-space-collapse","widows","width","will-change","word-break","word-spacing","word-wrap","writing-mode","x","y","z-index","zoom"].sort().reverse();function _(l){const c=t(l),d=s,m=i,p="@[a-z-]+",E="and or not only",S={className:"variable",begin:"(\\\\$"+"[a-zA-Z-][a-zA-Z0-9_-]*"+")\\\\b",relevance:0};return{name:"SCSS",case_insensitive:!0,illegal:"[=/|']",contains:[l.C_LINE_COMMENT_MODE,l.C_BLOCK_COMMENT_MODE,c.CSS_NUMBER_MODE,{className:"selector-id",begin:"#[A-Za-z0-9_-]+",relevance:0},{className:"selector-class",begin:"\\\\.[A-Za-z0-9_-]+",relevance:0},c.ATTRIBUTE_SELECTOR_MODE,{className:"selector-tag",begin:"\\\\b("+a.join("|")+")\\\\b",relevance:0},{className:"selector-pseudo",begin:":("+m.join("|")+")"},{className:"selector-pseudo",begin:":(:)?("+d.join("|")+")"},S,{begin:/\\(/,end:/\\)/,contains:[c.CSS_NUMBER_MODE]},c.CSS_VARIABLE,{className:"attribute",begin:"\\\\b("+o.join("|")+")\\\\b"},{begin:"\\\\b(whitespace|wait|w-resize|visible|vertical-text|vertical-ideographic|uppercase|upper-roman|upper-alpha|underline|transparent|top|thin|thick|text|text-top|text-bottom|tb-rl|table-header-group|table-footer-group|sw-resize|super|strict|static|square|solid|small-caps|separate|se-resize|scroll|s-resize|rtl|row-resize|ridge|right|repeat|repeat-y|repeat-x|relative|progress|pointer|overline|outside|outset|oblique|nowrap|not-allowed|normal|none|nw-resize|no-repeat|no-drop|newspaper|ne-resize|n-resize|move|middle|medium|ltr|lr-tb|lowercase|lower-roman|lower-alpha|loose|list-item|line|line-through|line-edge|lighter|left|keep-all|justify|italic|inter-word|inter-ideograph|inside|inset|inline|inline-block|inherit|inactive|ideograph-space|ideograph-parenthesis|ideograph-numeric|ideograph-alpha|horizontal|hidden|help|hand|groove|fixed|ellipsis|e-resize|double|dotted|distribute|distribute-space|distribute-letter|distribute-all-lines|disc|disabled|default|decimal|dashed|crosshair|collapse|col-resize|circle|char|center|capitalize|break-word|break-all|bottom|both|bolder|bold|block|bidi-override|below|baseline|auto|always|all-scroll|absolute|table|table-cell)\\\\b"},{begin:/:/,end:/[;}{]/,relevance:0,contains:[c.BLOCK_COMMENT,S,c.HEXCOLOR,c.CSS_NUMBER_MODE,l.QUOTE_STRING_MODE,l.APOS_STRING_MODE,c.IMPORTANT,c.FUNCTION_DISPATCH]},{begin:"@(page|font-face)",keywords:{$pattern:p,keyword:"@page @font-face"}},{begin:"@",end:"[{;]",returnBegin:!0,keywords:{$pattern:/[a-z-]+/,keyword:E,attribute:r.join(" ")},contains:[{begin:p,className:"keyword"},{begin:/[a-z-]+(?=:)/,className:"attribute"},S,l.QUOTE_STRING_MODE,l.APOS_STRING_MODE,c.HEXCOLOR,c.CSS_NUMBER_MODE]},c.FUNCTION_DISPATCH]}}return gr=_,gr}var Sr,il;function fu(){if(il)return Sr;il=1;function t(e){return{name:"Shell Session",aliases:["console","shellsession"],contains:[{className:"meta.prompt",begin:/^\\s{0,3}[/~\\w\\d[\\]()@-]*[>%$#][ ]?/,starts:{end:/[^\\\\](?=\\s*$)/,subLanguage:"bash"}}]}}return Sr=t,Sr}var Tr,ol;function Cu(){if(ol)return Tr;ol=1;function t(e){const n=["add","and","cmp","cmpg","cmpl","const","div","double","float","goto","if","int","long","move","mul","neg","new","nop","not","or","rem","return","shl","shr","sput","sub","throw","ushr","xor"],a=["aget","aput","array","check","execute","fill","filled","goto/16","goto/32","iget","instance","invoke","iput","monitor","packed","sget","sparse"],r=["transient","constructor","abstract","final","synthetic","public","private","protected","static","bridge","system"];return{name:"Smali",contains:[{className:"string",begin:'"',end:'"',relevance:0},e.COMMENT("#","$",{relevance:0}),{className:"keyword",variants:[{begin:"\\\\s*\\\\.end\\\\s[a-zA-Z0-9]*"},{begin:"^[ ]*\\\\.[a-zA-Z]*",relevance:0},{begin:"\\\\s:[a-zA-Z_0-9]*",relevance:0},{begin:"\\\\s("+r.join("|")+")"}]},{className:"built_in",variants:[{begin:"\\\\s("+n.join("|")+")\\\\s"},{begin:"\\\\s("+n.join("|")+")((-|/)[a-zA-Z0-9]+)+\\\\s",relevance:10},{begin:"\\\\s("+a.join("|")+")((-|/)[a-zA-Z0-9]+)*\\\\s",relevance:10}]},{className:"class",begin:\`L[^(;:
]*;\`,relevance:0},{begin:"[vp][0-9]+"}]}}return Tr=t,Tr}var br,sl;function Nu(){if(sl)return br;sl=1;function t(e){const n="[a-z][a-zA-Z0-9_]*",a={className:"string",begin:"\\\\$.{1}"},r={className:"symbol",begin:"#"+e.UNDERSCORE_IDENT_RE};return{name:"Smalltalk",aliases:["st"],keywords:["self","super","nil","true","false","thisContext"],contains:[e.COMMENT('"','"'),e.APOS_STRING_MODE,{className:"type",begin:"\\\\b[A-Z][A-Za-z0-9_]*",relevance:0},{begin:n+":",relevance:0},e.C_NUMBER_MODE,r,a,{begin:"\\\\|[ ]*"+n+"([ ]+"+n+")*[ ]*\\\\|",returnBegin:!0,end:/\\|/,illegal:/\\S/,contains:[{begin:"(\\\\|[ ]*)?"+n}]},{begin:"#\\\\(",end:"\\\\)",contains:[e.APOS_STRING_MODE,a,e.C_NUMBER_MODE,r]}]}}return br=t,br}var Rr,ll;function Ou(){if(ll)return Rr;ll=1;function t(e){return{name:"SML (Standard ML)",aliases:["ml"],keywords:{$pattern:"[a-z_]\\\\w*!?",keyword:"abstype and andalso as case datatype do else end eqtype exception fn fun functor handle if in include infix infixr let local nonfix of op open orelse raise rec sharing sig signature struct structure then type val with withtype where while",built_in:"array bool char exn int list option order real ref string substring vector unit word",literal:"true false NONE SOME LESS EQUAL GREATER nil"},illegal:/\\/\\/|>>/,contains:[{className:"literal",begin:/\\[(\\|\\|)?\\]|\\(\\)/,relevance:0},e.COMMENT("\\\\(\\\\*","\\\\*\\\\)",{contains:["self"]}),{className:"symbol",begin:"'[A-Za-z_](?!')[\\\\w']*"},{className:"type",begin:"\`[A-Z][\\\\w']*"},{className:"type",begin:"\\\\b[A-Z][\\\\w']*",relevance:0},{begin:"[a-z_]\\\\w*'[\\\\w']*"},e.inherit(e.APOS_STRING_MODE,{className:"string",relevance:0}),e.inherit(e.QUOTE_STRING_MODE,{illegal:null}),{className:"number",begin:"\\\\b(0[xX][a-fA-F0-9_]+[Lln]?|0[oO][0-7_]+[Lln]?|0[bB][01_]+[Lln]?|[0-9][0-9_]*([Lln]|(\\\\.[0-9_]*)?([eE][-+]?[0-9_]+)?)?)",relevance:0},{begin:/[-=]>/}]}}return Rr=t,Rr}var fr,cl;function Iu(){if(cl)return fr;cl=1;function t(e){const n={className:"variable",begin:/\\b_+[a-zA-Z]\\w*/},a={className:"title",begin:/[a-zA-Z][a-zA-Z_0-9]*_fnc_[a-zA-Z_0-9]+/},r={className:"string",variants:[{begin:'"',end:'"',contains:[{begin:'""',relevance:0}]},{begin:"'",end:"'",contains:[{begin:"''",relevance:0}]}]},i=["break","breakWith","breakOut","breakTo","case","catch","continue","continueWith","default","do","else","exit","exitWith","for","forEach","from","if","local","private","switch","step","then","throw","to","try","waitUntil","while","with"],s=["blufor","civilian","configNull","controlNull","displayNull","diaryRecordNull","east","endl","false","grpNull","independent","lineBreak","locationNull","nil","objNull","opfor","pi","resistance","scriptNull","sideAmbientLife","sideEmpty","sideEnemy","sideFriendly","sideLogic","sideUnknown","taskNull","teamMemberNull","true","west"],o=["abs","accTime","acos","action","actionIDs","actionKeys","actionKeysEx","actionKeysImages","actionKeysNames","actionKeysNamesArray","actionName","actionParams","activateAddons","activatedAddons","activateKey","activeTitleEffectParams","add3DENConnection","add3DENEventHandler","add3DENLayer","addAction","addBackpack","addBackpackCargo","addBackpackCargoGlobal","addBackpackGlobal","addBinocularItem","addCamShake","addCuratorAddons","addCuratorCameraArea","addCuratorEditableObjects","addCuratorEditingArea","addCuratorPoints","addEditorObject","addEventHandler","addForce","addForceGeneratorRTD","addGoggles","addGroupIcon","addHandgunItem","addHeadgear","addItem","addItemCargo","addItemCargoGlobal","addItemPool","addItemToBackpack","addItemToUniform","addItemToVest","addLiveStats","addMagazine","addMagazineAmmoCargo","addMagazineCargo","addMagazineCargoGlobal","addMagazineGlobal","addMagazinePool","addMagazines","addMagazineTurret","addMenu","addMenuItem","addMissionEventHandler","addMPEventHandler","addMusicEventHandler","addonFiles","addOwnedMine","addPlayerScores","addPrimaryWeaponItem","addPublicVariableEventHandler","addRating","addResources","addScore","addScoreSide","addSecondaryWeaponItem","addSwitchableUnit","addTeamMember","addToRemainsCollector","addTorque","addUniform","addUserActionEventHandler","addVehicle","addVest","addWaypoint","addWeapon","addWeaponCargo","addWeaponCargoGlobal","addWeaponGlobal","addWeaponItem","addWeaponPool","addWeaponTurret","addWeaponWithAttachmentsCargo","addWeaponWithAttachmentsCargoGlobal","admin","agent","agents","AGLToASL","aimedAtTarget","aimPos","airDensityCurveRTD","airDensityRTD","airplaneThrottle","airportSide","AISFinishHeal","alive","all3DENEntities","allActiveTitleEffects","allAddonsInfo","allAirports","allControls","allCurators","allCutLayers","allDead","allDeadMen","allDiaryRecords","allDiarySubjects","allDisplays","allEnv3DSoundSources","allGroups","allLODs","allMapMarkers","allMines","allMissionObjects","allObjects","allow3DMode","allowCrewInImmobile","allowCuratorLogicIgnoreAreas","allowDamage","allowDammage","allowedService","allowFileOperations","allowFleeing","allowGetIn","allowService","allowSprint","allPlayers","allSimpleObjects","allSites","allTurrets","allUnits","allUnitsUAV","allUsers","allVariables","ambientTemperature","ammo","ammoOnPylon","and","animate","animateBay","animateDoor","animatePylon","animateSource","animationNames","animationPhase","animationSourcePhase","animationState","apertureParams","append","apply","armoryPoints","arrayIntersect","asin","ASLToAGL","ASLToATL","assert","assignAsCargo","assignAsCargoIndex","assignAsCommander","assignAsDriver","assignAsGunner","assignAsTurret","assignCurator","assignedCargo","assignedCommander","assignedDriver","assignedGroup","assignedGunner","assignedItems","assignedTarget","assignedTeam","assignedVehicle","assignedVehicleRole","assignedVehicles","assignItem","assignTeam","assignToAirport","atan","atan2","atg","ATLToASL","attachedObject","attachedObjects","attachedTo","attachObject","attachTo","attackEnabled","awake","backpack","backpackCargo","backpackContainer","backpackItems","backpackMagazines","backpackSpaceFor","behaviour","benchmark","bezierInterpolation","binocular","binocularItems","binocularMagazine","boundingBox","boundingBoxReal","boundingCenter","brakesDisabled","briefingName","buildingExit","buildingPos","buldozer_EnableRoadDiag","buldozer_IsEnabledRoadDiag","buldozer_LoadNewRoads","buldozer_reloadOperMap","buttonAction","buttonSetAction","cadetMode","calculatePath","calculatePlayerVisibilityByFriendly","call","callExtension","camCommand","camCommit","camCommitPrepared","camCommitted","camConstuctionSetParams","camCreate","camDestroy","cameraEffect","cameraEffectEnableHUD","cameraInterest","cameraOn","cameraView","campaignConfigFile","camPreload","camPreloaded","camPrepareBank","camPrepareDir","camPrepareDive","camPrepareFocus","camPrepareFov","camPrepareFovRange","camPreparePos","camPrepareRelPos","camPrepareTarget","camSetBank","camSetDir","camSetDive","camSetFocus","camSetFov","camSetFovRange","camSetPos","camSetRelPos","camSetTarget","camTarget","camUseNVG","canAdd","canAddItemToBackpack","canAddItemToUniform","canAddItemToVest","cancelSimpleTaskDestination","canDeployWeapon","canFire","canMove","canSlingLoad","canStand","canSuspend","canTriggerDynamicSimulation","canUnloadInCombat","canVehicleCargo","captive","captiveNum","cbChecked","cbSetChecked","ceil","channelEnabled","cheatsEnabled","checkAIFeature","checkVisibility","className","clear3DENAttribute","clear3DENInventory","clearAllItemsFromBackpack","clearBackpackCargo","clearBackpackCargoGlobal","clearForcesRTD","clearGroupIcons","clearItemCargo","clearItemCargoGlobal","clearItemPool","clearMagazineCargo","clearMagazineCargoGlobal","clearMagazinePool","clearOverlay","clearRadio","clearWeaponCargo","clearWeaponCargoGlobal","clearWeaponPool","clientOwner","closeDialog","closeDisplay","closeOverlay","collapseObjectTree","collect3DENHistory","collectiveRTD","collisionDisabledWith","combatBehaviour","combatMode","commandArtilleryFire","commandChat","commander","commandFire","commandFollow","commandFSM","commandGetOut","commandingMenu","commandMove","commandRadio","commandStop","commandSuppressiveFire","commandTarget","commandWatch","comment","commitOverlay","compatibleItems","compatibleMagazines","compile","compileFinal","compileScript","completedFSM","composeText","configClasses","configFile","configHierarchy","configName","configOf","configProperties","configSourceAddonList","configSourceMod","configSourceModList","confirmSensorTarget","connectTerminalToUAV","connectToServer","controlsGroupCtrl","conversationDisabled","copyFromClipboard","copyToClipboard","copyWaypoints","cos","count","countEnemy","countFriendly","countSide","countType","countUnknown","create3DENComposition","create3DENEntity","createAgent","createCenter","createDialog","createDiaryLink","createDiaryRecord","createDiarySubject","createDisplay","createGearDialog","createGroup","createGuardedPoint","createHashMap","createHashMapFromArray","createLocation","createMarker","createMarkerLocal","createMenu","createMine","createMissionDisplay","createMPCampaignDisplay","createSimpleObject","createSimpleTask","createSite","createSoundSource","createTask","createTeam","createTrigger","createUnit","createVehicle","createVehicleCrew","createVehicleLocal","crew","ctAddHeader","ctAddRow","ctClear","ctCurSel","ctData","ctFindHeaderRows","ctFindRowHeader","ctHeaderControls","ctHeaderCount","ctRemoveHeaders","ctRemoveRows","ctrlActivate","ctrlAddEventHandler","ctrlAngle","ctrlAnimateModel","ctrlAnimationPhaseModel","ctrlAt","ctrlAutoScrollDelay","ctrlAutoScrollRewind","ctrlAutoScrollSpeed","ctrlBackgroundColor","ctrlChecked","ctrlClassName","ctrlCommit","ctrlCommitted","ctrlCreate","ctrlDelete","ctrlEnable","ctrlEnabled","ctrlFade","ctrlFontHeight","ctrlForegroundColor","ctrlHTMLLoaded","ctrlIDC","ctrlIDD","ctrlMapAnimAdd","ctrlMapAnimClear","ctrlMapAnimCommit","ctrlMapAnimDone","ctrlMapCursor","ctrlMapMouseOver","ctrlMapPosition","ctrlMapScale","ctrlMapScreenToWorld","ctrlMapSetPosition","ctrlMapWorldToScreen","ctrlModel","ctrlModelDirAndUp","ctrlModelScale","ctrlMousePosition","ctrlParent","ctrlParentControlsGroup","ctrlPosition","ctrlRemoveAllEventHandlers","ctrlRemoveEventHandler","ctrlScale","ctrlScrollValues","ctrlSetActiveColor","ctrlSetAngle","ctrlSetAutoScrollDelay","ctrlSetAutoScrollRewind","ctrlSetAutoScrollSpeed","ctrlSetBackgroundColor","ctrlSetChecked","ctrlSetDisabledColor","ctrlSetEventHandler","ctrlSetFade","ctrlSetFocus","ctrlSetFont","ctrlSetFontH1","ctrlSetFontH1B","ctrlSetFontH2","ctrlSetFontH2B","ctrlSetFontH3","ctrlSetFontH3B","ctrlSetFontH4","ctrlSetFontH4B","ctrlSetFontH5","ctrlSetFontH5B","ctrlSetFontH6","ctrlSetFontH6B","ctrlSetFontHeight","ctrlSetFontHeightH1","ctrlSetFontHeightH2","ctrlSetFontHeightH3","ctrlSetFontHeightH4","ctrlSetFontHeightH5","ctrlSetFontHeightH6","ctrlSetFontHeightSecondary","ctrlSetFontP","ctrlSetFontPB","ctrlSetFontSecondary","ctrlSetForegroundColor","ctrlSetModel","ctrlSetModelDirAndUp","ctrlSetModelScale","ctrlSetMousePosition","ctrlSetPixelPrecision","ctrlSetPosition","ctrlSetPositionH","ctrlSetPositionW","ctrlSetPositionX","ctrlSetPositionY","ctrlSetScale","ctrlSetScrollValues","ctrlSetShadow","ctrlSetStructuredText","ctrlSetText","ctrlSetTextColor","ctrlSetTextColorSecondary","ctrlSetTextSecondary","ctrlSetTextSelection","ctrlSetTooltip","ctrlSetTooltipColorBox","ctrlSetTooltipColorShade","ctrlSetTooltipColorText","ctrlSetTooltipMaxWidth","ctrlSetURL","ctrlSetURLOverlayMode","ctrlShadow","ctrlShow","ctrlShown","ctrlStyle","ctrlText","ctrlTextColor","ctrlTextHeight","ctrlTextSecondary","ctrlTextSelection","ctrlTextWidth","ctrlTooltip","ctrlType","ctrlURL","ctrlURLOverlayMode","ctrlVisible","ctRowControls","ctRowCount","ctSetCurSel","ctSetData","ctSetHeaderTemplate","ctSetRowTemplate","ctSetValue","ctValue","curatorAddons","curatorCamera","curatorCameraArea","curatorCameraAreaCeiling","curatorCoef","curatorEditableObjects","curatorEditingArea","curatorEditingAreaType","curatorMouseOver","curatorPoints","curatorRegisteredObjects","curatorSelected","curatorWaypointCost","current3DENOperation","currentChannel","currentCommand","currentMagazine","currentMagazineDetail","currentMagazineDetailTurret","currentMagazineTurret","currentMuzzle","currentNamespace","currentPilot","currentTask","currentTasks","currentThrowable","currentVisionMode","currentWaypoint","currentWeapon","currentWeaponMode","currentWeaponTurret","currentZeroing","cursorObject","cursorTarget","customChat","customRadio","customWaypointPosition","cutFadeOut","cutObj","cutRsc","cutText","damage","date","dateToNumber","dayTime","deActivateKey","debriefingText","debugFSM","debugLog","decayGraphValues","deg","delete3DENEntities","deleteAt","deleteCenter","deleteCollection","deleteEditorObject","deleteGroup","deleteGroupWhenEmpty","deleteIdentity","deleteLocation","deleteMarker","deleteMarkerLocal","deleteRange","deleteResources","deleteSite","deleteStatus","deleteTeam","deleteVehicle","deleteVehicleCrew","deleteWaypoint","detach","detectedMines","diag_activeMissionFSMs","diag_activeScripts","diag_activeSQFScripts","diag_activeSQSScripts","diag_allMissionEventHandlers","diag_captureFrame","diag_captureFrameToFile","diag_captureSlowFrame","diag_codePerformance","diag_deltaTime","diag_drawmode","diag_dumpCalltraceToLog","diag_dumpScriptAssembly","diag_dumpTerrainSynth","diag_dynamicSimulationEnd","diag_enable","diag_enabled","diag_exportConfig","diag_exportTerrainSVG","diag_fps","diag_fpsmin","diag_frameno","diag_getTerrainSegmentOffset","diag_lightNewLoad","diag_list","diag_localized","diag_log","diag_logSlowFrame","diag_mergeConfigFile","diag_recordTurretLimits","diag_resetFSM","diag_resetshapes","diag_scope","diag_setLightNew","diag_stacktrace","diag_tickTime","diag_toggle","dialog","diarySubjectExists","didJIP","didJIPOwner","difficulty","difficultyEnabled","difficultyEnabledRTD","difficultyOption","direction","directionStabilizationEnabled","directSay","disableAI","disableBrakes","disableCollisionWith","disableConversation","disableDebriefingStats","disableMapIndicators","disableNVGEquipment","disableRemoteSensors","disableSerialization","disableTIEquipment","disableUAVConnectability","disableUserInput","displayAddEventHandler","displayChild","displayCtrl","displayParent","displayRemoveAllEventHandlers","displayRemoveEventHandler","displaySetEventHandler","displayUniqueName","displayUpdate","dissolveTeam","distance","distance2D","distanceSqr","distributionRegion","do3DENAction","doArtilleryFire","doFire","doFollow","doFSM","doGetOut","doMove","doorPhase","doStop","doSuppressiveFire","doTarget","doWatch","drawArrow","drawEllipse","drawIcon","drawIcon3D","drawLaser","drawLine","drawLine3D","drawLink","drawLocation","drawPolygon","drawRectangle","drawTriangle","driver","drop","dynamicSimulationDistance","dynamicSimulationDistanceCoef","dynamicSimulationEnabled","dynamicSimulationSystemEnabled","echo","edit3DENMissionAttributes","editObject","editorSetEventHandler","effectiveCommander","elevatePeriscope","emptyPositions","enableAI","enableAIFeature","enableAimPrecision","enableAttack","enableAudioFeature","enableAutoStartUpRTD","enableAutoTrimRTD","enableCamShake","enableCaustics","enableChannel","enableCollisionWith","enableCopilot","enableDebriefingStats","enableDiagLegend","enableDirectionStabilization","enableDynamicSimulation","enableDynamicSimulationSystem","enableEndDialog","enableEngineArtillery","enableEnvironment","enableFatigue","enableGunLights","enableInfoPanelComponent","enableIRLasers","enableMimics","enablePersonTurret","enableRadio","enableReload","enableRopeAttach","enableSatNormalOnDetail","enableSaving","enableSentences","enableSimulation","enableSimulationGlobal","enableStamina","enableStressDamage","enableTeamSwitch","enableTraffic","enableUAVConnectability","enableUAVWaypoints","enableVehicleCargo","enableVehicleSensor","enableWeaponDisassembly","endLoadingScreen","endMission","engineOn","enginesIsOnRTD","enginesPowerRTD","enginesRpmRTD","enginesTorqueRTD","entities","environmentEnabled","environmentVolume","equipmentDisabled","estimatedEndServerTime","estimatedTimeLeft","evalObjectArgument","everyBackpack","everyContainer","exec","execEditorScript","execFSM","execVM","exp","expectedDestination","exportJIPMessages","eyeDirection","eyePos","face","faction","fadeEnvironment","fadeMusic","fadeRadio","fadeSound","fadeSpeech","failMission","fileExists","fillWeaponsFromPool","find","findAny","findCover","findDisplay","findEditorObject","findEmptyPosition","findEmptyPositionReady","findIf","findNearestEnemy","finishMissionInit","finite","fire","fireAtTarget","firstBackpack","flag","flagAnimationPhase","flagOwner","flagSide","flagTexture","flatten","fleeing","floor","flyInHeight","flyInHeightASL","focusedCtrl","fog","fogForecast","fogParams","forceAddUniform","forceAtPositionRTD","forceCadetDifficulty","forcedMap","forceEnd","forceFlagTexture","forceFollowRoad","forceGeneratorRTD","forceMap","forceRespawn","forceSpeed","forceUnicode","forceWalk","forceWeaponFire","forceWeatherChange","forEachMember","forEachMemberAgent","forEachMemberTeam","forgetTarget","format","formation","formationDirection","formationLeader","formationMembers","formationPosition","formationTask","formatText","formLeader","freeExtension","freeLook","fromEditor","fuel","fullCrew","gearIDCAmmoCount","gearSlotAmmoCount","gearSlotData","gestureState","get","get3DENActionState","get3DENAttribute","get3DENCamera","get3DENConnections","get3DENEntity","get3DENEntityID","get3DENGrid","get3DENIconsVisible","get3DENLayerEntities","get3DENLinesVisible","get3DENMissionAttribute","get3DENMouseOver","get3DENSelected","getAimingCoef","getAllEnv3DSoundControllers","getAllEnvSoundControllers","getAllHitPointsDamage","getAllOwnedMines","getAllPylonsInfo","getAllSoundControllers","getAllUnitTraits","getAmmoCargo","getAnimAimPrecision","getAnimSpeedCoef","getArray","getArtilleryAmmo","getArtilleryComputerSettings","getArtilleryETA","getAssetDLCInfo","getAssignedCuratorLogic","getAssignedCuratorUnit","getAttackTarget","getAudioOptionVolumes","getBackpackCargo","getBleedingRemaining","getBurningValue","getCalculatePlayerVisibilityByFriendly","getCameraViewDirection","getCargoIndex","getCenterOfMass","getClientState","getClientStateNumber","getCompatiblePylonMagazines","getConnectedUAV","getConnectedUAVUnit","getContainerMaxLoad","getCorpse","getCruiseControl","getCursorObjectParams","getCustomAimCoef","getCustomSoundController","getCustomSoundControllerCount","getDammage","getDebriefingText","getDescription","getDir","getDirVisual","getDiverState","getDLCAssetsUsage","getDLCAssetsUsageByName","getDLCs","getDLCUsageTime","getEditorCamera","getEditorMode","getEditorObjectScope","getElevationOffset","getEngineTargetRPMRTD","getEnv3DSoundController","getEnvSoundController","getEventHandlerInfo","getFatigue","getFieldManualStartPage","getForcedFlagTexture","getForcedSpeed","getFriend","getFSMVariable","getFuelCargo","getGraphValues","getGroupIcon","getGroupIconParams","getGroupIcons","getHideFrom","getHit","getHitIndex","getHitPointDamage","getItemCargo","getLighting","getLightingAt","getLoadedModsInfo","getMagazineCargo","getMarkerColor","getMarkerPos","getMarkerSize","getMarkerType","getMass","getMissionConfig","getMissionConfigValue","getMissionDLCs","getMissionLayerEntities","getMissionLayers","getMissionPath","getModelInfo","getMousePosition","getMusicPlayedTime","getNumber","getObjectArgument","getObjectChildren","getObjectDLC","getObjectFOV","getObjectID","getObjectMaterials","getObjectProxy","getObjectScale","getObjectTextures","getObjectType","getObjectViewDistance","getOpticsMode","getOrDefault","getOrDefaultCall","getOxygenRemaining","getPersonUsedDLCs","getPilotCameraDirection","getPilotCameraPosition","getPilotCameraRotation","getPilotCameraTarget","getPiPViewDistance","getPlateNumber","getPlayerChannel","getPlayerID","getPlayerScores","getPlayerUID","getPlayerVoNVolume","getPos","getPosASL","getPosASLVisual","getPosASLW","getPosATL","getPosATLVisual","getPosVisual","getPosWorld","getPosWorldVisual","getPylonMagazines","getRelDir","getRelPos","getRemoteSensorsDisabled","getRepairCargo","getResolution","getRoadInfo","getRotorBrakeRTD","getSensorTargets","getSensorThreats","getShadowDistance","getShotParents","getSlingLoad","getSoundController","getSoundControllerResult","getSpeed","getStamina","getStatValue","getSteamFriendsServers","getSubtitleOptions","getSuppression","getTerrainGrid","getTerrainHeight","getTerrainHeightASL","getTerrainInfo","getText","getTextRaw","getTextureInfo","getTextWidth","getTiParameters","getTotalDLCUsageTime","getTrimOffsetRTD","getTurretLimits","getTurretOpticsMode","getUnitFreefallInfo","getUnitLoadout","getUnitTrait","getUnloadInCombat","getUserInfo","getUserMFDText","getUserMFDValue","getVariable","getVehicleCargo","getVehicleTiPars","getWeaponCargo","getWeaponSway","getWingsOrientationRTD","getWingsPositionRTD","getWPPos","glanceAt","globalChat","globalRadio","goggles","goto","group","groupChat","groupFromNetId","groupIconSelectable","groupIconsVisible","groupID","groupOwner","groupRadio","groups","groupSelectedUnits","groupSelectUnit","gunner","gusts","halt","handgunItems","handgunMagazine","handgunWeapon","handsHit","hashValue","hasInterface","hasPilotCamera","hasWeapon","hcAllGroups","hcGroupParams","hcLeader","hcRemoveAllGroups","hcRemoveGroup","hcSelected","hcSelectGroup","hcSetGroup","hcShowBar","hcShownBar","headgear","hideBody","hideObject","hideObjectGlobal","hideSelection","hint","hintC","hintCadet","hintSilent","hmd","hostMission","htmlLoad","HUDMovementLevels","humidity","image","importAllGroups","importance","in","inArea","inAreaArray","incapacitatedState","inflame","inflamed","infoPanel","infoPanelComponentEnabled","infoPanelComponents","infoPanels","inGameUISetEventHandler","inheritsFrom","initAmbientLife","inPolygon","inputAction","inputController","inputMouse","inRangeOfArtillery","insert","insertEditorObject","intersect","is3DEN","is3DENMultiplayer","is3DENPreview","isAbleToBreathe","isActionMenuVisible","isAgent","isAimPrecisionEnabled","isAllowedCrewInImmobile","isArray","isAutoHoverOn","isAutonomous","isAutoStartUpEnabledRTD","isAutotest","isAutoTrimOnRTD","isAwake","isBleeding","isBurning","isClass","isCollisionLightOn","isCopilotEnabled","isDamageAllowed","isDedicated","isDLCAvailable","isEngineOn","isEqualRef","isEqualTo","isEqualType","isEqualTypeAll","isEqualTypeAny","isEqualTypeArray","isEqualTypeParams","isFilePatchingEnabled","isFinal","isFlashlightOn","isFlatEmpty","isForcedWalk","isFormationLeader","isGameFocused","isGamePaused","isGroupDeletedWhenEmpty","isHidden","isInRemainsCollector","isInstructorFigureEnabled","isIRLaserOn","isKeyActive","isKindOf","isLaserOn","isLightOn","isLocalized","isManualFire","isMarkedForCollection","isMissionProfileNamespaceLoaded","isMultiplayer","isMultiplayerSolo","isNil","isNotEqualRef","isNotEqualTo","isNull","isNumber","isObjectHidden","isObjectRTD","isOnRoad","isPiPEnabled","isPlayer","isRealTime","isRemoteExecuted","isRemoteExecutedJIP","isSaving","isSensorTargetConfirmed","isServer","isShowing3DIcons","isSimpleObject","isSprintAllowed","isStaminaEnabled","isSteamMission","isSteamOverlayEnabled","isStreamFriendlyUIEnabled","isStressDamageEnabled","isText","isTouchingGround","isTurnedOut","isTutHintsEnabled","isUAVConnectable","isUAVConnected","isUIContext","isUniformAllowed","isVehicleCargo","isVehicleRadarOn","isVehicleSensorEnabled","isWalking","isWeaponDeployed","isWeaponRested","itemCargo","items","itemsWithMagazines","join","joinAs","joinAsSilent","joinSilent","joinString","kbAddDatabase","kbAddDatabaseTargets","kbAddTopic","kbHasTopic","kbReact","kbRemoveTopic","kbTell","kbWasSaid","keyImage","keyName","keys","knowsAbout","land","landAt","landResult","language","laserTarget","lbAdd","lbClear","lbColor","lbColorRight","lbCurSel","lbData","lbDelete","lbIsSelected","lbPicture","lbPictureRight","lbSelection","lbSetColor","lbSetColorRight","lbSetCurSel","lbSetData","lbSetPicture","lbSetPictureColor","lbSetPictureColorDisabled","lbSetPictureColorSelected","lbSetPictureRight","lbSetPictureRightColor","lbSetPictureRightColorDisabled","lbSetPictureRightColorSelected","lbSetSelectColor","lbSetSelectColorRight","lbSetSelected","lbSetText","lbSetTextRight","lbSetTooltip","lbSetValue","lbSize","lbSort","lbSortBy","lbSortByValue","lbText","lbTextRight","lbTooltip","lbValue","leader","leaderboardDeInit","leaderboardGetRows","leaderboardInit","leaderboardRequestRowsFriends","leaderboardRequestRowsGlobal","leaderboardRequestRowsGlobalAroundUser","leaderboardsRequestUploadScore","leaderboardsRequestUploadScoreKeepBest","leaderboardState","leaveVehicle","libraryCredits","libraryDisclaimers","lifeState","lightAttachObject","lightDetachObject","lightIsOn","lightnings","limitSpeed","linearConversion","lineIntersects","lineIntersectsObjs","lineIntersectsSurfaces","lineIntersectsWith","linkItem","list","listObjects","listRemoteTargets","listVehicleSensors","ln","lnbAddArray","lnbAddColumn","lnbAddRow","lnbClear","lnbColor","lnbColorRight","lnbCurSelRow","lnbData","lnbDeleteColumn","lnbDeleteRow","lnbGetColumnsPosition","lnbPicture","lnbPictureRight","lnbSetColor","lnbSetColorRight","lnbSetColumnsPos","lnbSetCurSelRow","lnbSetData","lnbSetPicture","lnbSetPictureColor","lnbSetPictureColorRight","lnbSetPictureColorSelected","lnbSetPictureColorSelectedRight","lnbSetPictureRight","lnbSetText","lnbSetTextRight","lnbSetTooltip","lnbSetValue","lnbSize","lnbSort","lnbSortBy","lnbSortByValue","lnbText","lnbTextRight","lnbValue","load","loadAbs","loadBackpack","loadConfig","loadFile","loadGame","loadIdentity","loadMagazine","loadOverlay","loadStatus","loadUniform","loadVest","localize","localNamespace","locationPosition","lock","lockCameraTo","lockCargo","lockDriver","locked","lockedCameraTo","lockedCargo","lockedDriver","lockedInventory","lockedTurret","lockIdentity","lockInventory","lockTurret","lockWp","log","logEntities","logNetwork","logNetworkTerminate","lookAt","lookAtPos","magazineCargo","magazines","magazinesAllTurrets","magazinesAmmo","magazinesAmmoCargo","magazinesAmmoFull","magazinesDetail","magazinesDetailBackpack","magazinesDetailUniform","magazinesDetailVest","magazinesTurret","magazineTurretAmmo","mapAnimAdd","mapAnimClear","mapAnimCommit","mapAnimDone","mapCenterOnCamera","mapGridPosition","markAsFinishedOnSteam","markerAlpha","markerBrush","markerChannel","markerColor","markerDir","markerPolyline","markerPos","markerShadow","markerShape","markerSize","markerText","markerType","matrixMultiply","matrixTranspose","max","maxLoad","members","menuAction","menuAdd","menuChecked","menuClear","menuCollapse","menuData","menuDelete","menuEnable","menuEnabled","menuExpand","menuHover","menuPicture","menuSetAction","menuSetCheck","menuSetData","menuSetPicture","menuSetShortcut","menuSetText","menuSetURL","menuSetValue","menuShortcut","menuShortcutText","menuSize","menuSort","menuText","menuURL","menuValue","merge","min","mineActive","mineDetectedBy","missileTarget","missileTargetPos","missionConfigFile","missionDifficulty","missionEnd","missionName","missionNameSource","missionNamespace","missionProfileNamespace","missionStart","missionVersion","mod","modelToWorld","modelToWorldVisual","modelToWorldVisualWorld","modelToWorldWorld","modParams","moonIntensity","moonPhase","morale","move","move3DENCamera","moveInAny","moveInCargo","moveInCommander","moveInDriver","moveInGunner","moveInTurret","moveObjectToEnd","moveOut","moveTime","moveTo","moveToCompleted","moveToFailed","musicVolume","name","namedProperties","nameSound","nearEntities","nearestBuilding","nearestLocation","nearestLocations","nearestLocationWithDubbing","nearestMines","nearestObject","nearestObjects","nearestTerrainObjects","nearObjects","nearObjectsReady","nearRoads","nearSupplies","nearTargets","needReload","needService","netId","netObjNull","newOverlay","nextMenuItemIndex","nextWeatherChange","nMenuItems","not","numberOfEnginesRTD","numberToDate","objectCurators","objectFromNetId","objectParent","objStatus","onBriefingGroup","onBriefingNotes","onBriefingPlan","onBriefingTeamSwitch","onCommandModeChanged","onDoubleClick","onEachFrame","onGroupIconClick","onGroupIconOverEnter","onGroupIconOverLeave","onHCGroupSelectionChanged","onMapSingleClick","onPlayerConnected","onPlayerDisconnected","onPreloadFinished","onPreloadStarted","onShowNewObject","onTeamSwitch","openCuratorInterface","openDLCPage","openGPS","openMap","openSteamApp","openYoutubeVideo","or","orderGetIn","overcast","overcastForecast","owner","param","params","parseNumber","parseSimpleArray","parseText","parsingNamespace","particlesQuality","periscopeElevation","pickWeaponPool","pitch","pixelGrid","pixelGridBase","pixelGridNoUIScale","pixelH","pixelW","playableSlotsNumber","playableUnits","playAction","playActionNow","player","playerRespawnTime","playerSide","playersNumber","playGesture","playMission","playMove","playMoveNow","playMusic","playScriptedMission","playSound","playSound3D","playSoundUI","pose","position","positionCameraToWorld","posScreenToWorld","posWorldToScreen","ppEffectAdjust","ppEffectCommit","ppEffectCommitted","ppEffectCreate","ppEffectDestroy","ppEffectEnable","ppEffectEnabled","ppEffectForceInNVG","precision","preloadCamera","preloadObject","preloadSound","preloadTitleObj","preloadTitleRsc","preprocessFile","preprocessFileLineNumbers","primaryWeapon","primaryWeaponItems","primaryWeaponMagazine","priority","processDiaryLink","productVersion","profileName","profileNamespace","profileNameSteam","progressLoadingScreen","progressPosition","progressSetPosition","publicVariable","publicVariableClient","publicVariableServer","pushBack","pushBackUnique","putWeaponPool","queryItemsPool","queryMagazinePool","queryWeaponPool","rad","radioChannelAdd","radioChannelCreate","radioChannelInfo","radioChannelRemove","radioChannelSetCallSign","radioChannelSetLabel","radioEnabled","radioVolume","rain","rainbow","rainParams","random","rank","rankId","rating","rectangular","regexFind","regexMatch","regexReplace","registeredTasks","registerTask","reload","reloadEnabled","remoteControl","remoteExec","remoteExecCall","remoteExecutedOwner","remove3DENConnection","remove3DENEventHandler","remove3DENLayer","removeAction","removeAll3DENEventHandlers","removeAllActions","removeAllAssignedItems","removeAllBinocularItems","removeAllContainers","removeAllCuratorAddons","removeAllCuratorCameraAreas","removeAllCuratorEditingAreas","removeAllEventHandlers","removeAllHandgunItems","removeAllItems","removeAllItemsWithMagazines","removeAllMissionEventHandlers","removeAllMPEventHandlers","removeAllMusicEventHandlers","removeAllOwnedMines","removeAllPrimaryWeaponItems","removeAllSecondaryWeaponItems","removeAllUserActionEventHandlers","removeAllWeapons","removeBackpack","removeBackpackGlobal","removeBinocularItem","removeCuratorAddons","removeCuratorCameraArea","removeCuratorEditableObjects","removeCuratorEditingArea","removeDiaryRecord","removeDiarySubject","removeDrawIcon","removeDrawLinks","removeEventHandler","removeFromRemainsCollector","removeGoggles","removeGroupIcon","removeHandgunItem","removeHeadgear","removeItem","removeItemFromBackpack","removeItemFromUniform","removeItemFromVest","removeItems","removeMagazine","removeMagazineGlobal","removeMagazines","removeMagazinesTurret","removeMagazineTurret","removeMenuItem","removeMissionEventHandler","removeMPEventHandler","removeMusicEventHandler","removeOwnedMine","removePrimaryWeaponItem","removeSecondaryWeaponItem","removeSimpleTask","removeSwitchableUnit","removeTeamMember","removeUniform","removeUserActionEventHandler","removeVest","removeWeapon","removeWeaponAttachmentCargo","removeWeaponCargo","removeWeaponGlobal","removeWeaponTurret","reportRemoteTarget","requiredVersion","resetCamShake","resetSubgroupDirection","resize","resources","respawnVehicle","restartEditorCamera","reveal","revealMine","reverse","reversedMouseY","roadAt","roadsConnectedTo","roleDescription","ropeAttachedObjects","ropeAttachedTo","ropeAttachEnabled","ropeAttachTo","ropeCreate","ropeCut","ropeDestroy","ropeDetach","ropeEndPosition","ropeLength","ropes","ropesAttachedTo","ropeSegments","ropeUnwind","ropeUnwound","rotorsForcesRTD","rotorsRpmRTD","round","runInitScript","safeZoneH","safeZoneW","safeZoneWAbs","safeZoneX","safeZoneXAbs","safeZoneY","save3DENInventory","saveGame","saveIdentity","saveJoysticks","saveMissionProfileNamespace","saveOverlay","saveProfileNamespace","saveStatus","saveVar","savingEnabled","say","say2D","say3D","scopeName","score","scoreSide","screenshot","screenToWorld","scriptDone","scriptName","scudState","secondaryWeapon","secondaryWeaponItems","secondaryWeaponMagazine","select","selectBestPlaces","selectDiarySubject","selectedEditorObjects","selectEditorObject","selectionNames","selectionPosition","selectionVectorDirAndUp","selectLeader","selectMax","selectMin","selectNoPlayer","selectPlayer","selectRandom","selectRandomWeighted","selectWeapon","selectWeaponTurret","sendAUMessage","sendSimpleCommand","sendTask","sendTaskResult","sendUDPMessage","sentencesEnabled","serverCommand","serverCommandAvailable","serverCommandExecutable","serverName","serverNamespace","serverTime","set","set3DENAttribute","set3DENAttributes","set3DENGrid","set3DENIconsVisible","set3DENLayer","set3DENLinesVisible","set3DENLogicType","set3DENMissionAttribute","set3DENMissionAttributes","set3DENModelsVisible","set3DENObjectType","set3DENSelected","setAccTime","setActualCollectiveRTD","setAirplaneThrottle","setAirportSide","setAmmo","setAmmoCargo","setAmmoOnPylon","setAnimSpeedCoef","setAperture","setApertureNew","setArmoryPoints","setAttributes","setAutonomous","setBehaviour","setBehaviourStrong","setBleedingRemaining","setBrakesRTD","setCameraInterest","setCamShakeDefParams","setCamShakeParams","setCamUseTi","setCaptive","setCenterOfMass","setCollisionLight","setCombatBehaviour","setCombatMode","setCompassOscillation","setConvoySeparation","setCruiseControl","setCuratorCameraAreaCeiling","setCuratorCoef","setCuratorEditingAreaType","setCuratorWaypointCost","setCurrentChannel","setCurrentTask","setCurrentWaypoint","setCustomAimCoef","SetCustomMissionData","setCustomSoundController","setCustomWeightRTD","setDamage","setDammage","setDate","setDebriefingText","setDefaultCamera","setDestination","setDetailMapBlendPars","setDiaryRecordText","setDiarySubjectPicture","setDir","setDirection","setDrawIcon","setDriveOnPath","setDropInterval","setDynamicSimulationDistance","setDynamicSimulationDistanceCoef","setEditorMode","setEditorObjectScope","setEffectCondition","setEffectiveCommander","setEngineRpmRTD","setFace","setFaceanimation","setFatigue","setFeatureType","setFlagAnimationPhase","setFlagOwner","setFlagSide","setFlagTexture","setFog","setForceGeneratorRTD","setFormation","setFormationTask","setFormDir","setFriend","setFromEditor","setFSMVariable","setFuel","setFuelCargo","setGroupIcon","setGroupIconParams","setGroupIconsSelectable","setGroupIconsVisible","setGroupid","setGroupIdGlobal","setGroupOwner","setGusts","setHideBehind","setHit","setHitIndex","setHitPointDamage","setHorizonParallaxCoef","setHUDMovementLevels","setHumidity","setIdentity","setImportance","setInfoPanel","setLeader","setLightAmbient","setLightAttenuation","setLightBrightness","setLightColor","setLightConePars","setLightDayLight","setLightFlareMaxDistance","setLightFlareSize","setLightIntensity","setLightIR","setLightnings","setLightUseFlare","setLightVolumeShape","setLocalWindParams","setMagazineTurretAmmo","setMarkerAlpha","setMarkerAlphaLocal","setMarkerBrush","setMarkerBrushLocal","setMarkerColor","setMarkerColorLocal","setMarkerDir","setMarkerDirLocal","setMarkerPolyline","setMarkerPolylineLocal","setMarkerPos","setMarkerPosLocal","setMarkerShadow","setMarkerShadowLocal","setMarkerShape","setMarkerShapeLocal","setMarkerSize","setMarkerSizeLocal","setMarkerText","setMarkerTextLocal","setMarkerType","setMarkerTypeLocal","setMass","setMaxLoad","setMimic","setMissileTarget","setMissileTargetPos","setMousePosition","setMusicEffect","setMusicEventHandler","setName","setNameSound","setObjectArguments","setObjectMaterial","setObjectMaterialGlobal","setObjectProxy","setObjectScale","setObjectTexture","setObjectTextureGlobal","setObjectViewDistance","setOpticsMode","setOvercast","setOwner","setOxygenRemaining","setParticleCircle","setParticleClass","setParticleFire","setParticleParams","setParticleRandom","setPilotCameraDirection","setPilotCameraRotation","setPilotCameraTarget","setPilotLight","setPiPEffect","setPiPViewDistance","setPitch","setPlateNumber","setPlayable","setPlayerRespawnTime","setPlayerVoNVolume","setPos","setPosASL","setPosASL2","setPosASLW","setPosATL","setPosition","setPosWorld","setPylonLoadout","setPylonsPriority","setRadioMsg","setRain","setRainbow","setRandomLip","setRank","setRectangular","setRepairCargo","setRotorBrakeRTD","setShadowDistance","setShotParents","setSide","setSimpleTaskAlwaysVisible","setSimpleTaskCustomData","setSimpleTaskDescription","setSimpleTaskDestination","setSimpleTaskTarget","setSimpleTaskType","setSimulWeatherLayers","setSize","setSkill","setSlingLoad","setSoundEffect","setSpeaker","setSpeech","setSpeedMode","setStamina","setStaminaScheme","setStatValue","setSuppression","setSystemOfUnits","setTargetAge","setTaskMarkerOffset","setTaskResult","setTaskState","setTerrainGrid","setTerrainHeight","setText","setTimeMultiplier","setTiParameter","setTitleEffect","setTowParent","setTrafficDensity","setTrafficDistance","setTrafficGap","setTrafficSpeed","setTriggerActivation","setTriggerArea","setTriggerInterval","setTriggerStatements","setTriggerText","setTriggerTimeout","setTriggerType","setTurretLimits","setTurretOpticsMode","setType","setUnconscious","setUnitAbility","setUnitCombatMode","setUnitFreefallHeight","setUnitLoadout","setUnitPos","setUnitPosWeak","setUnitRank","setUnitRecoilCoefficient","setUnitTrait","setUnloadInCombat","setUserActionText","setUserMFDText","setUserMFDValue","setVariable","setVectorDir","setVectorDirAndUp","setVectorUp","setVehicleAmmo","setVehicleAmmoDef","setVehicleArmor","setVehicleCargo","setVehicleId","setVehicleLock","setVehiclePosition","setVehicleRadar","setVehicleReceiveRemoteTargets","setVehicleReportOwnPosition","setVehicleReportRemoteTargets","setVehicleTiPars","setVehicleVarName","setVelocity","setVelocityModelSpace","setVelocityTransformation","setViewDistance","setVisibleIfTreeCollapsed","setWantedRPMRTD","setWaves","setWaypointBehaviour","setWaypointCombatMode","setWaypointCompletionRadius","setWaypointDescription","setWaypointForceBehaviour","setWaypointFormation","setWaypointHousePosition","setWaypointLoiterAltitude","setWaypointLoiterRadius","setWaypointLoiterType","setWaypointName","setWaypointPosition","setWaypointScript","setWaypointSpeed","setWaypointStatements","setWaypointTimeout","setWaypointType","setWaypointVisible","setWeaponReloadingTime","setWeaponZeroing","setWind","setWindDir","setWindForce","setWindStr","setWingForceScaleRTD","setWPPos","show3DIcons","showChat","showCinemaBorder","showCommandingMenu","showCompass","showCuratorCompass","showGps","showHUD","showLegend","showMap","shownArtilleryComputer","shownChat","shownCompass","shownCuratorCompass","showNewEditorObject","shownGps","shownHUD","shownMap","shownPad","shownRadio","shownScoretable","shownSubtitles","shownUAVFeed","shownWarrant","shownWatch","showPad","showRadio","showScoretable","showSubtitles","showUAVFeed","showWarrant","showWatch","showWaypoint","showWaypoints","side","sideChat","sideRadio","simpleTasks","simulationEnabled","simulCloudDensity","simulCloudOcclusion","simulInClouds","simulWeatherSync","sin","size","sizeOf","skill","skillFinal","skipTime","sleep","sliderPosition","sliderRange","sliderSetPosition","sliderSetRange","sliderSetSpeed","sliderSpeed","slingLoadAssistantShown","soldierMagazines","someAmmo","sort","soundVolume","spawn","speaker","speechVolume","speed","speedMode","splitString","sqrt","squadParams","stance","startLoadingScreen","stop","stopEngineRTD","stopped","str","sunOrMoon","supportInfo","suppressFor","surfaceIsWater","surfaceNormal","surfaceTexture","surfaceType","swimInDepth","switchableUnits","switchAction","switchCamera","switchGesture","switchLight","switchMove","synchronizedObjects","synchronizedTriggers","synchronizedWaypoints","synchronizeObjectsAdd","synchronizeObjectsRemove","synchronizeTrigger","synchronizeWaypoint","systemChat","systemOfUnits","systemTime","systemTimeUTC","tan","targetKnowledge","targets","targetsAggregate","targetsQuery","taskAlwaysVisible","taskChildren","taskCompleted","taskCustomData","taskDescription","taskDestination","taskHint","taskMarkerOffset","taskName","taskParent","taskResult","taskState","taskType","teamMember","teamName","teams","teamSwitch","teamSwitchEnabled","teamType","terminate","terrainIntersect","terrainIntersectASL","terrainIntersectAtASL","text","textLog","textLogFormat","tg","time","timeMultiplier","titleCut","titleFadeOut","titleObj","titleRsc","titleText","toArray","toFixed","toLower","toLowerANSI","toString","toUpper","toUpperANSI","triggerActivated","triggerActivation","triggerAmmo","triggerArea","triggerAttachedVehicle","triggerAttachObject","triggerAttachVehicle","triggerDynamicSimulation","triggerInterval","triggerStatements","triggerText","triggerTimeout","triggerTimeoutCurrent","triggerType","trim","turretLocal","turretOwner","turretUnit","tvAdd","tvClear","tvCollapse","tvCollapseAll","tvCount","tvCurSel","tvData","tvDelete","tvExpand","tvExpandAll","tvIsSelected","tvPicture","tvPictureRight","tvSelection","tvSetColor","tvSetCurSel","tvSetData","tvSetPicture","tvSetPictureColor","tvSetPictureColorDisabled","tvSetPictureColorSelected","tvSetPictureRight","tvSetPictureRightColor","tvSetPictureRightColorDisabled","tvSetPictureRightColorSelected","tvSetSelectColor","tvSetSelected","tvSetText","tvSetTooltip","tvSetValue","tvSort","tvSortAll","tvSortByValue","tvSortByValueAll","tvText","tvTooltip","tvValue","type","typeName","typeOf","UAVControl","uiNamespace","uiSleep","unassignCurator","unassignItem","unassignTeam","unassignVehicle","underwater","uniform","uniformContainer","uniformItems","uniformMagazines","uniqueUnitItems","unitAddons","unitAimPosition","unitAimPositionVisual","unitBackpack","unitCombatMode","unitIsUAV","unitPos","unitReady","unitRecoilCoefficient","units","unitsBelowHeight","unitTurret","unlinkItem","unlockAchievement","unregisterTask","updateDrawIcon","updateMenuItem","updateObjectTree","useAIOperMapObstructionTest","useAISteeringComponent","useAudioTimeForMoves","userInputDisabled","values","vectorAdd","vectorCos","vectorCrossProduct","vectorDiff","vectorDir","vectorDirVisual","vectorDistance","vectorDistanceSqr","vectorDotProduct","vectorFromTo","vectorLinearConversion","vectorMagnitude","vectorMagnitudeSqr","vectorModelToWorld","vectorModelToWorldVisual","vectorMultiply","vectorNormalized","vectorUp","vectorUpVisual","vectorWorldToModel","vectorWorldToModelVisual","vehicle","vehicleCargoEnabled","vehicleChat","vehicleMoveInfo","vehicleRadio","vehicleReceiveRemoteTargets","vehicleReportOwnPosition","vehicleReportRemoteTargets","vehicles","vehicleVarName","velocity","velocityModelSpace","verifySignature","vest","vestContainer","vestItems","vestMagazines","viewDistance","visibleCompass","visibleGps","visibleMap","visiblePosition","visiblePositionASL","visibleScoretable","visibleWatch","waves","waypointAttachedObject","waypointAttachedVehicle","waypointAttachObject","waypointAttachVehicle","waypointBehaviour","waypointCombatMode","waypointCompletionRadius","waypointDescription","waypointForceBehaviour","waypointFormation","waypointHousePosition","waypointLoiterAltitude","waypointLoiterRadius","waypointLoiterType","waypointName","waypointPosition","waypoints","waypointScript","waypointsEnabledUAV","waypointShow","waypointSpeed","waypointStatements","waypointTimeout","waypointTimeoutCurrent","waypointType","waypointVisible","weaponAccessories","weaponAccessoriesCargo","weaponCargo","weaponDirection","weaponInertia","weaponLowered","weaponReloadingTime","weapons","weaponsInfo","weaponsItems","weaponsItemsCargo","weaponState","weaponsTurret","weightRTD","WFSideText","wind","windDir","windRTD","windStr","wingsForcesRTD","worldName","worldSize","worldToModel","worldToModelVisual","worldToScreen"],_={className:"meta",begin:/#\\s*[a-z]+\\b/,end:/$/,keywords:"define undef ifdef ifndef else endif include if",contains:[{begin:/\\\\\\n/,relevance:0},e.inherit(r,{className:"string"}),{begin:/<[^\\n>]*>/,end:/$/,illegal:"\\\\n"},e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE]};return{name:"SQF",case_insensitive:!0,keywords:{keyword:i,built_in:o,literal:s},contains:[e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,e.NUMBER_MODE,n,a,r,_],illegal:[/\\$[^a-fA-F0-9]/,/\\w\\$/,/\\?/,/@/,/ \\| /,/[a-zA-Z_]\\./,/\\:\\=/,/\\[\\:/]}}return fr=t,fr}var Cr,_l;function Au(){if(_l)return Cr;_l=1;function t(e){const n=e.regex,a=e.COMMENT("--","$"),r={scope:"string",variants:[{begin:/'/,end:/'/,contains:[{match:/''/}]}]},i={begin:/"/,end:/"/,contains:[{match:/""/}]},s=["true","false","unknown"],o=["double precision","large object","with timezone","without timezone"],_=["bigint","binary","blob","boolean","char","character","clob","date","dec","decfloat","decimal","float","int","integer","interval","nchar","nclob","national","numeric","real","row","smallint","time","timestamp","varchar","varying","varbinary"],l=["add","asc","collation","desc","final","first","last","view"],c=["abs","acos","all","allocate","alter","and","any","are","array","array_agg","array_max_cardinality","as","asensitive","asin","asymmetric","at","atan","atomic","authorization","avg","begin","begin_frame","begin_partition","between","bigint","binary","blob","boolean","both","by","call","called","cardinality","cascaded","case","cast","ceil","ceiling","char","char_length","character","character_length","check","classifier","clob","close","coalesce","collate","collect","column","commit","condition","connect","constraint","contains","convert","copy","corr","corresponding","cos","cosh","count","covar_pop","covar_samp","create","cross","cube","cume_dist","current","current_catalog","current_date","current_default_transform_group","current_path","current_role","current_row","current_schema","current_time","current_timestamp","current_path","current_role","current_transform_group_for_type","current_user","cursor","cycle","date","day","deallocate","dec","decimal","decfloat","declare","default","define","delete","dense_rank","deref","describe","deterministic","disconnect","distinct","double","drop","dynamic","each","element","else","empty","end","end_frame","end_partition","end-exec","equals","escape","every","except","exec","execute","exists","exp","external","extract","false","fetch","filter","first_value","float","floor","for","foreign","frame_row","free","from","full","function","fusion","get","global","grant","group","grouping","groups","having","hold","hour","identity","in","indicator","initial","inner","inout","insensitive","insert","int","integer","intersect","intersection","interval","into","is","join","json_array","json_arrayagg","json_exists","json_object","json_objectagg","json_query","json_table","json_table_primitive","json_value","lag","language","large","last_value","lateral","lead","leading","left","like","like_regex","listagg","ln","local","localtime","localtimestamp","log","log10","lower","match","match_number","match_recognize","matches","max","member","merge","method","min","minute","mod","modifies","module","month","multiset","national","natural","nchar","nclob","new","no","none","normalize","not","nth_value","ntile","null","nullif","numeric","octet_length","occurrences_regex","of","offset","old","omit","on","one","only","open","or","order","out","outer","over","overlaps","overlay","parameter","partition","pattern","per","percent","percent_rank","percentile_cont","percentile_disc","period","portion","position","position_regex","power","precedes","precision","prepare","primary","procedure","ptf","range","rank","reads","real","recursive","ref","references","referencing","regr_avgx","regr_avgy","regr_count","regr_intercept","regr_r2","regr_slope","regr_sxx","regr_sxy","regr_syy","release","result","return","returns","revoke","right","rollback","rollup","row","row_number","rows","running","savepoint","scope","scroll","search","second","seek","select","sensitive","session_user","set","show","similar","sin","sinh","skip","smallint","some","specific","specifictype","sql","sqlexception","sqlstate","sqlwarning","sqrt","start","static","stddev_pop","stddev_samp","submultiset","subset","substring","substring_regex","succeeds","sum","symmetric","system","system_time","system_user","table","tablesample","tan","tanh","then","time","timestamp","timezone_hour","timezone_minute","to","trailing","translate","translate_regex","translation","treat","trigger","trim","trim_array","true","truncate","uescape","union","unique","unknown","unnest","update","upper","user","using","value","values","value_of","var_pop","var_samp","varbinary","varchar","varying","versioning","when","whenever","where","width_bucket","window","with","within","without","year"],d=["abs","acos","array_agg","asin","atan","avg","cast","ceil","ceiling","coalesce","corr","cos","cosh","count","covar_pop","covar_samp","cume_dist","dense_rank","deref","element","exp","extract","first_value","floor","json_array","json_arrayagg","json_exists","json_object","json_objectagg","json_query","json_table","json_table_primitive","json_value","lag","last_value","lead","listagg","ln","log","log10","lower","max","min","mod","nth_value","ntile","nullif","percent_rank","percentile_cont","percentile_disc","position","position_regex","power","rank","regr_avgx","regr_avgy","regr_count","regr_intercept","regr_r2","regr_slope","regr_sxx","regr_sxy","regr_syy","row_number","sin","sinh","sqrt","stddev_pop","stddev_samp","substring","substring_regex","sum","tan","tanh","translate","translate_regex","treat","trim","trim_array","unnest","upper","value_of","var_pop","var_samp","width_bucket"],m=["current_catalog","current_date","current_default_transform_group","current_path","current_role","current_schema","current_transform_group_for_type","current_user","session_user","system_time","system_user","current_time","localtime","current_timestamp","localtimestamp"],p=["create table","insert into","primary key","foreign key","not null","alter table","add constraint","grouping sets","on overflow","character set","respect nulls","ignore nulls","nulls first","nulls last","depth first","breadth first"],E=d,g=[...c,...l].filter(C=>!d.includes(C)),S={scope:"variable",match:/@[a-z0-9][a-z0-9_]*/},T={scope:"operator",match:/[-+*/=%^~]|&&?|\\|\\|?|!=?|<(?:=>?|<|>)?|>[>=]?/,relevance:0},R={match:n.concat(/\\b/,n.either(...E),/\\s*\\(/),relevance:0,keywords:{built_in:E}};function f(C){return n.concat(/\\b/,n.either(...C.map(M=>M.replace(/\\s+/,"\\\\s+"))),/\\b/)}const A={scope:"keyword",match:f(p),relevance:0};function N(C,{exceptions:M,when:y}={}){const x=y;return M=M||[],C.map(G=>G.match(/\\|\\d+$/)||M.includes(G)?G:x(G)?\`\${G}|0\`:G)}return{name:"SQL",case_insensitive:!0,illegal:/[{}]|<\\//,keywords:{$pattern:/\\b[\\w\\.]+/,keyword:N(g,{when:C=>C.length<3}),literal:s,type:_,built_in:m},contains:[{scope:"type",match:f(o)},A,R,S,r,i,e.C_NUMBER_MODE,e.C_BLOCK_COMMENT_MODE,a,T]}}return Cr=t,Cr}var Nr,dl;function vu(){if(dl)return Nr;dl=1;function t(e){const n=e.regex,a=["functions","model","data","parameters","quantities","transformed","generated"],r=["for","in","if","else","while","break","continue","return"],i=["array","tuple","complex","int","real","vector","complex_vector","ordered","positive_ordered","simplex","unit_vector","row_vector","complex_row_vector","matrix","complex_matrix","cholesky_factor_corr|10","cholesky_factor_cov|10","corr_matrix|10","cov_matrix|10","void"],s=["abs","acos","acosh","add_diag","algebra_solver","algebra_solver_newton","append_array","append_col","append_row","asin","asinh","atan","atan2","atanh","bessel_first_kind","bessel_second_kind","binary_log_loss","block","cbrt","ceil","chol2inv","cholesky_decompose","choose","col","cols","columns_dot_product","columns_dot_self","complex_schur_decompose","complex_schur_decompose_t","complex_schur_decompose_u","conj","cos","cosh","cov_exp_quad","crossprod","csr_extract","csr_extract_u","csr_extract_v","csr_extract_w","csr_matrix_times_vector","csr_to_dense_matrix","cumulative_sum","dae","dae_tol","determinant","diag_matrix","diagonal","diag_post_multiply","diag_pre_multiply","digamma","dims","distance","dot_product","dot_self","eigendecompose","eigendecompose_sym","eigenvalues","eigenvalues_sym","eigenvectors","eigenvectors_sym","erf","erfc","exp","exp2","expm1","falling_factorial","fdim","fft","fft2","floor","fma","fmax","fmin","fmod","gamma_p","gamma_q","generalized_inverse","get_imag","get_real","head","hmm_hidden_state_prob","hmm_marginal","hypot","identity_matrix","inc_beta","integrate_1d","integrate_ode","integrate_ode_adams","integrate_ode_bdf","integrate_ode_rk45","int_step","inv","inv_cloglog","inv_erfc","inverse","inverse_spd","inv_fft","inv_fft2","inv_inc_beta","inv_logit","inv_Phi","inv_sqrt","inv_square","is_inf","is_nan","lambert_w0","lambert_wm1","lbeta","lchoose","ldexp","lgamma","linspaced_array","linspaced_int_array","linspaced_row_vector","linspaced_vector","lmgamma","lmultiply","log","log1m","log1m_exp","log1m_inv_logit","log1p","log1p_exp","log_determinant","log_diff_exp","log_falling_factorial","log_inv_logit","log_inv_logit_diff","logit","log_mix","log_modified_bessel_first_kind","log_rising_factorial","log_softmax","log_sum_exp","machine_precision","map_rect","matrix_exp","matrix_exp_multiply","matrix_power","max","mdivide_left_spd","mdivide_left_tri_low","mdivide_right_spd","mdivide_right_tri_low","mean","min","modified_bessel_first_kind","modified_bessel_second_kind","multiply_lower_tri_self_transpose","negative_infinity","norm","norm1","norm2","not_a_number","num_elements","ode_adams","ode_adams_tol","ode_adjoint_tol_ctl","ode_bdf","ode_bdf_tol","ode_ckrk","ode_ckrk_tol","ode_rk45","ode_rk45_tol","one_hot_array","one_hot_int_array","one_hot_row_vector","one_hot_vector","ones_array","ones_int_array","ones_row_vector","ones_vector","owens_t","Phi","Phi_approx","polar","positive_infinity","pow","print","prod","proj","qr","qr_Q","qr_R","qr_thin","qr_thin_Q","qr_thin_R","quad_form","quad_form_diag","quad_form_sym","quantile","rank","reduce_sum","reject","rep_array","rep_matrix","rep_row_vector","rep_vector","reverse","rising_factorial","round","row","rows","rows_dot_product","rows_dot_self","scale_matrix_exp_multiply","sd","segment","sin","singular_values","sinh","size","softmax","sort_asc","sort_desc","sort_indices_asc","sort_indices_desc","sqrt","square","squared_distance","step","sub_col","sub_row","sum","svd","svd_U","svd_V","symmetrize_from_lower_tri","tail","tan","tanh","target","tcrossprod","tgamma","to_array_1d","to_array_2d","to_complex","to_int","to_matrix","to_row_vector","to_vector","trace","trace_gen_quad_form","trace_quad_form","trigamma","trunc","uniform_simplex","variance","zeros_array","zeros_int_array","zeros_row_vector"],o=["bernoulli","bernoulli_logit","bernoulli_logit_glm","beta","beta_binomial","beta_proportion","binomial","binomial_logit","categorical","categorical_logit","categorical_logit_glm","cauchy","chi_square","dirichlet","discrete_range","double_exponential","exp_mod_normal","exponential","frechet","gamma","gaussian_dlm_obs","gumbel","hmm_latent","hypergeometric","inv_chi_square","inv_gamma","inv_wishart","inv_wishart_cholesky","lkj_corr","lkj_corr_cholesky","logistic","loglogistic","lognormal","multi_gp","multi_gp_cholesky","multinomial","multinomial_logit","multi_normal","multi_normal_cholesky","multi_normal_prec","multi_student_cholesky_t","multi_student_t","multi_student_t_cholesky","neg_binomial","neg_binomial_2","neg_binomial_2_log","neg_binomial_2_log_glm","normal","normal_id_glm","ordered_logistic","ordered_logistic_glm","ordered_probit","pareto","pareto_type_2","poisson","poisson_log","poisson_log_glm","rayleigh","scaled_inv_chi_square","skew_double_exponential","skew_normal","std_normal","std_normal_log","student_t","uniform","von_mises","weibull","wiener","wishart","wishart_cholesky"],_=e.COMMENT(/\\/\\*/,/\\*\\//,{relevance:0,contains:[{scope:"doctag",match:/@(return|param)/}]}),l={scope:"meta",begin:/#include\\b/,end:/$/,contains:[{match:/[a-z][a-z-._]+/,scope:"string"},e.C_LINE_COMMENT_MODE]},c=["lower","upper","offset","multiplier"];return{name:"Stan",aliases:["stanfuncs"],keywords:{$pattern:e.IDENT_RE,title:a,type:i,keyword:r,built_in:s},contains:[e.C_LINE_COMMENT_MODE,l,e.HASH_COMMENT_MODE,_,{scope:"built_in",match:/\\s(pi|e|sqrt2|log2|log10)(?=\\()/,relevance:0},{match:n.concat(/[<,]\\s*/,n.either(...c),/\\s*=/),keywords:c},{scope:"keyword",match:/\\btarget(?=\\s*\\+=)/},{match:[/~\\s*/,n.either(...o),/(?:\\(\\))/,/\\s*T(?=\\s*\\[)/],scope:{2:"built_in",4:"keyword"}},{scope:"built_in",keywords:o,begin:n.concat(/\\w*/,n.either(...o),/(_lpdf|_lupdf|_lpmf|_cdf|_lcdf|_lccdf|_qf)(?=\\s*[\\(.*\\)])/)},{begin:[/~/,/\\s*/,n.concat(n.either(...o),/(?=\\s*[\\(.*\\)])/)],scope:{3:"built_in"}},{begin:[/~/,/\\s*\\w+(?=\\s*[\\(.*\\)])/,"(?!.*/\\b("+n.either(...o)+")\\b)"],scope:{2:"title.function"}},{scope:"title.function",begin:/\\w*(_lpdf|_lupdf|_lpmf|_cdf|_lcdf|_lccdf|_qf)(?=\\s*[\\(.*\\)])/},{scope:"number",match:n.concat(/(?:\\b\\d+(?:_\\d+)*(?:\\.(?:\\d+(?:_\\d+)*)?)?|\\B\\.\\d+(?:_\\d+)*)/,/(?:[eE][+-]?\\d+(?:_\\d+)*)?i?(?!\\w)/),relevance:0},{scope:"string",begin:/"/,end:/"/}]}}return Nr=t,Nr}var Or,ul;function yu(){if(ul)return Or;ul=1;function t(e){return{name:"Stata",aliases:["do","ado"],case_insensitive:!0,keywords:"if else in foreach for forv forva forval forvalu forvalue forvalues by bys bysort xi quietly qui capture about ac ac_7 acprplot acprplot_7 adjust ado adopath adoupdate alpha ameans an ano anov anova anova_estat anova_terms anovadef aorder ap app appe appen append arch arch_dr arch_estat arch_p archlm areg areg_p args arima arima_dr arima_estat arima_p as asmprobit asmprobit_estat asmprobit_lf asmprobit_mfx__dlg asmprobit_p ass asse asser assert avplot avplot_7 avplots avplots_7 bcskew0 bgodfrey bias binreg bip0_lf biplot bipp_lf bipr_lf bipr_p biprobit bitest bitesti bitowt blogit bmemsize boot bootsamp bootstrap bootstrap_8 boxco_l boxco_p boxcox boxcox_6 boxcox_p bprobit br break brier bro brow brows browse brr brrstat bs bs_7 bsampl_w bsample bsample_7 bsqreg bstat bstat_7 bstat_8 bstrap bstrap_7 bubble bubbleplot ca ca_estat ca_p cabiplot camat canon canon_8 canon_8_p canon_estat canon_p cap caprojection capt captu captur capture cat cc cchart cchart_7 cci cd censobs_table centile cf char chdir checkdlgfiles checkestimationsample checkhlpfiles checksum chelp ci cii cl class classutil clear cli clis clist clo clog clog_lf clog_p clogi clogi_sw clogit clogit_lf clogit_p clogitp clogl_sw cloglog clonevar clslistarray cluster cluster_measures cluster_stop cluster_tree cluster_tree_8 clustermat cmdlog cnr cnre cnreg cnreg_p cnreg_sw cnsreg codebook collaps4 collapse colormult_nb colormult_nw compare compress conf confi confir confirm conren cons const constr constra constrai constrain constraint continue contract copy copyright copysource cor corc corr corr2data corr_anti corr_kmo corr_smc corre correl correla correlat correlate corrgram cou coun count cox cox_p cox_sw coxbase coxhaz coxvar cprplot cprplot_7 crc cret cretu cretur creturn cross cs cscript cscript_log csi ct ct_is ctset ctst_5 ctst_st cttost cumsp cumsp_7 cumul cusum cusum_7 cutil d|0 datasig datasign datasigna datasignat datasignatu datasignatur datasignature datetof db dbeta de dec deco decod decode deff des desc descr descri describ describe destring dfbeta dfgls dfuller di di_g dir dirstats dis discard disp disp_res disp_s displ displa display distinct do doe doed doedi doedit dotplot dotplot_7 dprobit drawnorm drop ds ds_util dstdize duplicates durbina dwstat dydx e|0 ed edi edit egen eivreg emdef en enc enco encod encode eq erase ereg ereg_lf ereg_p ereg_sw ereghet ereghet_glf ereghet_glf_sh ereghet_gp ereghet_ilf ereghet_ilf_sh ereghet_ip eret eretu eretur ereturn err erro error esize est est_cfexist est_cfname est_clickable est_expand est_hold est_table est_unhold est_unholdok estat estat_default estat_summ estat_vce_only esti estimates etodow etof etomdy ex exi exit expand expandcl fac fact facto factor factor_estat factor_p factor_pca_rotated factor_rotate factormat fcast fcast_compute fcast_graph fdades fdadesc fdadescr fdadescri fdadescrib fdadescribe fdasav fdasave fdause fh_st file open file read file close file filefilter fillin find_hlp_file findfile findit findit_7 fit fl fli flis flist for5_0 forest forestplot form forma format fpredict frac_154 frac_adj frac_chk frac_cox frac_ddp frac_dis frac_dv frac_in frac_mun frac_pp frac_pq frac_pv frac_wgt frac_xo fracgen fracplot fracplot_7 fracpoly fracpred fron_ex fron_hn fron_p fron_tn fron_tn2 frontier ftodate ftoe ftomdy ftowdate funnel funnelplot g|0 gamhet_glf gamhet_gp gamhet_ilf gamhet_ip gamma gamma_d2 gamma_p gamma_sw gammahet gdi_hexagon gdi_spokes ge gen gene gener genera generat generate genrank genstd genvmean gettoken gl gladder gladder_7 glim_l01 glim_l02 glim_l03 glim_l04 glim_l05 glim_l06 glim_l07 glim_l08 glim_l09 glim_l10 glim_l11 glim_l12 glim_lf glim_mu glim_nw1 glim_nw2 glim_nw3 glim_p glim_v1 glim_v2 glim_v3 glim_v4 glim_v5 glim_v6 glim_v7 glm glm_6 glm_p glm_sw glmpred glo glob globa global glogit glogit_8 glogit_p gmeans gnbre_lf gnbreg gnbreg_5 gnbreg_p gomp_lf gompe_sw gomper_p gompertz gompertzhet gomphet_glf gomphet_glf_sh gomphet_gp gomphet_ilf gomphet_ilf_sh gomphet_ip gphdot gphpen gphprint gprefs gprobi_p gprobit gprobit_8 gr gr7 gr_copy gr_current gr_db gr_describe gr_dir gr_draw gr_draw_replay gr_drop gr_edit gr_editviewopts gr_example gr_example2 gr_export gr_print gr_qscheme gr_query gr_read gr_rename gr_replay gr_save gr_set gr_setscheme gr_table gr_undo gr_use graph graph7 grebar greigen greigen_7 greigen_8 grmeanby grmeanby_7 gs_fileinfo gs_filetype gs_graphinfo gs_stat gsort gwood h|0 hadimvo hareg hausman haver he heck_d2 heckma_p heckman heckp_lf heckpr_p heckprob hel help hereg hetpr_lf hetpr_p hetprob hettest hexdump hilite hist hist_7 histogram hlogit hlu hmeans hotel hotelling hprobit hreg hsearch icd9 icd9_ff icd9p iis impute imtest inbase include inf infi infil infile infix inp inpu input ins insheet insp inspe inspec inspect integ inten intreg intreg_7 intreg_p intrg2_ll intrg_ll intrg_ll2 ipolate iqreg ir irf irf_create irfm iri is_svy is_svysum isid istdize ivprob_1_lf ivprob_lf ivprobit ivprobit_p ivreg ivreg_footnote ivtob_1_lf ivtob_lf ivtobit ivtobit_p jackknife jacknife jknife jknife_6 jknife_8 jkstat joinby kalarma1 kap kap_3 kapmeier kappa kapwgt kdensity kdensity_7 keep ksm ksmirnov ktau kwallis l|0 la lab labbe labbeplot labe label labelbook ladder levels levelsof leverage lfit lfit_p li lincom line linktest lis list lloghet_glf lloghet_glf_sh lloghet_gp lloghet_ilf lloghet_ilf_sh lloghet_ip llogi_sw llogis_p llogist llogistic llogistichet lnorm_lf lnorm_sw lnorma_p lnormal lnormalhet lnormhet_glf lnormhet_glf_sh lnormhet_gp lnormhet_ilf lnormhet_ilf_sh lnormhet_ip lnskew0 loadingplot loc loca local log logi logis_lf logistic logistic_p logit logit_estat logit_p loglogs logrank loneway lookfor lookup lowess lowess_7 lpredict lrecomp lroc lroc_7 lrtest ls lsens lsens_7 lsens_x lstat ltable ltable_7 ltriang lv lvr2plot lvr2plot_7 m|0 ma mac macr macro makecns man manova manova_estat manova_p manovatest mantel mark markin markout marksample mat mat_capp mat_order mat_put_rr mat_rapp mata mata_clear mata_describe mata_drop mata_matdescribe mata_matsave mata_matuse mata_memory mata_mlib mata_mosave mata_rename mata_which matalabel matcproc matlist matname matr matri matrix matrix_input__dlg matstrik mcc mcci md0_ md1_ md1debug_ md2_ md2debug_ mds mds_estat mds_p mdsconfig mdslong mdsmat mdsshepard mdytoe mdytof me_derd mean means median memory memsize menl meqparse mer merg merge meta mfp mfx mhelp mhodds minbound mixed_ll mixed_ll_reparm mkassert mkdir mkmat mkspline ml ml_5 ml_adjs ml_bhhhs ml_c_d ml_check ml_clear ml_cnt ml_debug ml_defd ml_e0 ml_e0_bfgs ml_e0_cycle ml_e0_dfp ml_e0i ml_e1 ml_e1_bfgs ml_e1_bhhh ml_e1_cycle ml_e1_dfp ml_e2 ml_e2_cycle ml_ebfg0 ml_ebfr0 ml_ebfr1 ml_ebh0q ml_ebhh0 ml_ebhr0 ml_ebr0i ml_ecr0i ml_edfp0 ml_edfr0 ml_edfr1 ml_edr0i ml_eds ml_eer0i ml_egr0i ml_elf ml_elf_bfgs ml_elf_bhhh ml_elf_cycle ml_elf_dfp ml_elfi ml_elfs ml_enr0i ml_enrr0 ml_erdu0 ml_erdu0_bfgs ml_erdu0_bhhh ml_erdu0_bhhhq ml_erdu0_cycle ml_erdu0_dfp ml_erdu0_nrbfgs ml_exde ml_footnote ml_geqnr ml_grad0 ml_graph ml_hbhhh ml_hd0 ml_hold ml_init ml_inv ml_log ml_max ml_mlout ml_mlout_8 ml_model ml_nb0 ml_opt ml_p ml_plot ml_query ml_rdgrd ml_repor ml_s_e ml_score ml_searc ml_technique ml_unhold mleval mlf_ mlmatbysum mlmatsum mlog mlogi mlogit mlogit_footnote mlogit_p mlopts mlsum mlvecsum mnl0_ mor more mov move mprobit mprobit_lf mprobit_p mrdu0_ mrdu1_ mvdecode mvencode mvreg mvreg_estat n|0 nbreg nbreg_al nbreg_lf nbreg_p nbreg_sw nestreg net newey newey_7 newey_p news nl nl_7 nl_9 nl_9_p nl_p nl_p_7 nlcom nlcom_p nlexp2 nlexp2_7 nlexp2a nlexp2a_7 nlexp3 nlexp3_7 nlgom3 nlgom3_7 nlgom4 nlgom4_7 nlinit nllog3 nllog3_7 nllog4 nllog4_7 nlog_rd nlogit nlogit_p nlogitgen nlogittree nlpred no nobreak noi nois noisi noisil noisily note notes notes_dlg nptrend numlabel numlist odbc old_ver olo olog ologi ologi_sw ologit ologit_p ologitp on one onew onewa oneway op_colnm op_comp op_diff op_inv op_str opr opro oprob oprob_sw oprobi oprobi_p oprobit oprobitp opts_exclusive order orthog orthpoly ou out outf outfi outfil outfile outs outsh outshe outshee outsheet ovtest pac pac_7 palette parse parse_dissim pause pca pca_8 pca_display pca_estat pca_p pca_rotate pcamat pchart pchart_7 pchi pchi_7 pcorr pctile pentium pergram pergram_7 permute permute_8 personal peto_st pkcollapse pkcross pkequiv pkexamine pkexamine_7 pkshape pksumm pksumm_7 pl plo plot plugin pnorm pnorm_7 poisgof poiss_lf poiss_sw poisso_p poisson poisson_estat post postclose postfile postutil pperron pr prais prais_e prais_e2 prais_p predict predictnl preserve print pro prob probi probit probit_estat probit_p proc_time procoverlay procrustes procrustes_estat procrustes_p profiler prog progr progra program prop proportion prtest prtesti pwcorr pwd q\\\\s qby qbys qchi qchi_7 qladder qladder_7 qnorm qnorm_7 qqplot qqplot_7 qreg qreg_c qreg_p qreg_sw qu quadchk quantile quantile_7 que quer query range ranksum ratio rchart rchart_7 rcof recast reclink recode reg reg3 reg3_p regdw regr regre regre_p2 regres regres_p regress regress_estat regriv_p remap ren rena renam rename renpfix repeat replace report reshape restore ret retu retur return rm rmdir robvar roccomp roccomp_7 roccomp_8 rocf_lf rocfit rocfit_8 rocgold rocplot rocplot_7 roctab roctab_7 rolling rologit rologit_p rot rota rotat rotate rotatemat rreg rreg_p ru run runtest rvfplot rvfplot_7 rvpplot rvpplot_7 sa safesum sample sampsi sav save savedresults saveold sc sca scal scala scalar scatter scm_mine sco scob_lf scob_p scobi_sw scobit scor score scoreplot scoreplot_help scree screeplot screeplot_help sdtest sdtesti se search separate seperate serrbar serrbar_7 serset set set_defaults sfrancia sh she shel shell shewhart shewhart_7 signestimationsample signrank signtest simul simul_7 simulate simulate_8 sktest sleep slogit slogit_d2 slogit_p smooth snapspan so sor sort spearman spikeplot spikeplot_7 spikeplt spline_x split sqreg sqreg_p sret sretu sretur sreturn ssc st st_ct st_hc st_hcd st_hcd_sh st_is st_issys st_note st_promo st_set st_show st_smpl st_subid stack statsby statsby_8 stbase stci stci_7 stcox stcox_estat stcox_fr stcox_fr_ll stcox_p stcox_sw stcoxkm stcoxkm_7 stcstat stcurv stcurve stcurve_7 stdes stem stepwise stereg stfill stgen stir stjoin stmc stmh stphplot stphplot_7 stphtest stphtest_7 stptime strate strate_7 streg streg_sw streset sts sts_7 stset stsplit stsum sttocc sttoct stvary stweib su suest suest_8 sum summ summa summar summari summariz summarize sunflower sureg survcurv survsum svar svar_p svmat svy svy_disp svy_dreg svy_est svy_est_7 svy_estat svy_get svy_gnbreg_p svy_head svy_header svy_heckman_p svy_heckprob_p svy_intreg_p svy_ivreg_p svy_logistic_p svy_logit_p svy_mlogit_p svy_nbreg_p svy_ologit_p svy_oprobit_p svy_poisson_p svy_probit_p svy_regress_p svy_sub svy_sub_7 svy_x svy_x_7 svy_x_p svydes svydes_8 svygen svygnbreg svyheckman svyheckprob svyintreg svyintreg_7 svyintrg svyivreg svylc svylog_p svylogit svymarkout svymarkout_8 svymean svymlog svymlogit svynbreg svyolog svyologit svyoprob svyoprobit svyopts svypois svypois_7 svypoisson svyprobit svyprobt svyprop svyprop_7 svyratio svyreg svyreg_p svyregress svyset svyset_7 svyset_8 svytab svytab_7 svytest svytotal sw sw_8 swcnreg swcox swereg swilk swlogis swlogit swologit swoprbt swpois swprobit swqreg swtobit swweib symmetry symmi symplot symplot_7 syntax sysdescribe sysdir sysuse szroeter ta tab tab1 tab2 tab_or tabd tabdi tabdis tabdisp tabi table tabodds tabodds_7 tabstat tabu tabul tabula tabulat tabulate te tempfile tempname tempvar tes test testnl testparm teststd tetrachoric time_it timer tis tob tobi tobit tobit_p tobit_sw token tokeni tokeniz tokenize tostring total translate translator transmap treat_ll treatr_p treatreg trim trimfill trnb_cons trnb_mean trpoiss_d2 trunc_ll truncr_p truncreg tsappend tset tsfill tsline tsline_ex tsreport tsrevar tsrline tsset tssmooth tsunab ttest ttesti tut_chk tut_wait tutorial tw tware_st two twoway twoway__fpfit_serset twoway__function_gen twoway__histogram_gen twoway__ipoint_serset twoway__ipoints_serset twoway__kdensity_gen twoway__lfit_serset twoway__normgen_gen twoway__pci_serset twoway__qfit_serset twoway__scatteri_serset twoway__sunflower_gen twoway_ksm_serset ty typ type typeof u|0 unab unabbrev unabcmd update us use uselabel var var_mkcompanion var_p varbasic varfcast vargranger varirf varirf_add varirf_cgraph varirf_create varirf_ctable varirf_describe varirf_dir varirf_drop varirf_erase varirf_graph varirf_ograph varirf_rename varirf_set varirf_table varlist varlmar varnorm varsoc varstable varstable_w varstable_w2 varwle vce vec vec_fevd vec_mkphi vec_p vec_p_w vecirf_create veclmar veclmar_w vecnorm vecnorm_w vecrank vecstable verinst vers versi versio version view viewsource vif vwls wdatetof webdescribe webseek webuse weib1_lf weib2_lf weib_lf weib_lf0 weibhet_glf weibhet_glf_sh weibhet_glfa weibhet_glfa_sh weibhet_gp weibhet_ilf weibhet_ilf_sh weibhet_ilfa weibhet_ilfa_sh weibhet_ip weibu_sw weibul_p weibull weibull_c weibull_s weibullhet wh whelp whi which whil while wilc_st wilcoxon win wind windo window winexec wntestb wntestb_7 wntestq xchart xchart_7 xcorr xcorr_7 xi xi_6 xmlsav xmlsave xmluse xpose xsh xshe xshel xshell xt_iis xt_tis xtab_p xtabond xtbin_p xtclog xtcloglog xtcloglog_8 xtcloglog_d2 xtcloglog_pa_p xtcloglog_re_p xtcnt_p xtcorr xtdata xtdes xtfront_p xtfrontier xtgee xtgee_elink xtgee_estat xtgee_makeivar xtgee_p xtgee_plink xtgls xtgls_p xthaus xthausman xtht_p xthtaylor xtile xtint_p xtintreg xtintreg_8 xtintreg_d2 xtintreg_p xtivp_1 xtivp_2 xtivreg xtline xtline_ex xtlogit xtlogit_8 xtlogit_d2 xtlogit_fe_p xtlogit_pa_p xtlogit_re_p xtmixed xtmixed_estat xtmixed_p xtnb_fe xtnb_lf xtnbreg xtnbreg_pa_p xtnbreg_refe_p xtpcse xtpcse_p xtpois xtpoisson xtpoisson_d2 xtpoisson_pa_p xtpoisson_refe_p xtpred xtprobit xtprobit_8 xtprobit_d2 xtprobit_re_p xtps_fe xtps_lf xtps_ren xtps_ren_8 xtrar_p xtrc xtrc_p xtrchh xtrefe_p xtreg xtreg_be xtreg_fe xtreg_ml xtreg_pa_p xtreg_re xtregar xtrere_p xtset xtsf_ll xtsf_llti xtsum xttab xttest0 xttobit xttobit_8 xttobit_p xttrans yx yxview__barlike_draw yxview_area_draw yxview_bar_draw yxview_dot_draw yxview_dropline_draw yxview_function_draw yxview_iarrow_draw yxview_ilabels_draw yxview_normal_draw yxview_pcarrow_draw yxview_pcbarrow_draw yxview_pccapsym_draw yxview_pcscatter_draw yxview_pcspike_draw yxview_rarea_draw yxview_rbar_draw yxview_rbarm_draw yxview_rcap_draw yxview_rcapsym_draw yxview_rconnected_draw yxview_rline_draw yxview_rscatter_draw yxview_rspike_draw yxview_spike_draw yxview_sunflower_draw zap_s zinb zinb_llf zinb_plf zip zip_llf zip_p zip_plf zt_ct_5 zt_hc_5 zt_hcd_5 zt_is_5 zt_iss_5 zt_sho_5 zt_smp_5 ztbase_5 ztcox_5 ztdes_5 ztereg_5 ztfill_5 ztgen_5 ztir_5 ztjoin_5 ztnb ztnb_p ztp ztp_p zts_5 ztset_5 ztspli_5 ztsum_5 zttoct_5 ztvary_5 ztweib_5",contains:[{className:"symbol",begin:/\`[a-zA-Z0-9_]+'/},{className:"variable",begin:/\\$\\{?[a-zA-Z0-9_]+\\}?/,relevance:0},{className:"string",variants:[{begin:\`\\\`"[^\\r
]*?"'\`},{begin:\`"[^\\r
"]*"\`}]},{className:"built_in",variants:[{begin:"\\\\b(abs|acos|asin|atan|atan2|atanh|ceil|cloglog|comb|cos|digamma|exp|floor|invcloglog|invlogit|ln|lnfact|lnfactorial|lngamma|log|log10|max|min|mod|reldif|round|sign|sin|sqrt|sum|tan|tanh|trigamma|trunc|betaden|Binomial|binorm|binormal|chi2|chi2tail|dgammapda|dgammapdada|dgammapdadx|dgammapdx|dgammapdxdx|F|Fden|Ftail|gammaden|gammap|ibeta|invbinomial|invchi2|invchi2tail|invF|invFtail|invgammap|invibeta|invnchi2|invnFtail|invnibeta|invnorm|invnormal|invttail|nbetaden|nchi2|nFden|nFtail|nibeta|norm|normal|normalden|normd|npnchi2|tden|ttail|uniform|abbrev|char|index|indexnot|length|lower|ltrim|match|plural|proper|real|regexm|regexr|regexs|reverse|rtrim|string|strlen|strlower|strltrim|strmatch|strofreal|strpos|strproper|strreverse|strrtrim|strtrim|strupper|subinstr|subinword|substr|trim|upper|word|wordcount|_caller|autocode|byteorder|chop|clip|cond|e|epsdouble|epsfloat|group|inlist|inrange|irecode|matrix|maxbyte|maxdouble|maxfloat|maxint|maxlong|mi|minbyte|mindouble|minfloat|minint|minlong|missing|r|recode|replay|return|s|scalar|d|date|day|dow|doy|halfyear|mdy|month|quarter|week|year|d|daily|dofd|dofh|dofm|dofq|dofw|dofy|h|halfyearly|hofd|m|mofd|monthly|q|qofd|quarterly|tin|twithin|w|weekly|wofd|y|yearly|yh|ym|yofd|yq|yw|cholesky|colnumb|colsof|corr|det|diag|diag0cnt|el|get|hadamard|I|inv|invsym|issym|issymmetric|J|matmissing|matuniform|mreldif|nullmat|rownumb|rowsof|sweep|syminv|trace|vec|vecdiag)(?=\\\\()"}]},e.COMMENT("^[ 	]*\\\\*.*$",!1),e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE]}}return Or=t,Or}var Ir,ml;function hu(){if(ml)return Ir;ml=1;function t(e){return{name:"STEP Part 21",aliases:["p21","step","stp"],case_insensitive:!0,keywords:{$pattern:"[A-Z_][A-Z0-9_.]*",keyword:["HEADER","ENDSEC","DATA"]},contains:[{className:"meta",begin:"ISO-10303-21;",relevance:10},{className:"meta",begin:"END-ISO-10303-21;",relevance:10},e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,e.COMMENT("/\\\\*\\\\*!","\\\\*/"),e.C_NUMBER_MODE,e.inherit(e.APOS_STRING_MODE,{illegal:null}),e.inherit(e.QUOTE_STRING_MODE,{illegal:null}),{className:"string",begin:"'",end:"'"},{className:"symbol",variants:[{begin:"#",end:"\\\\d+",illegal:"\\\\W"}]}]}}return Ir=t,Ir}var Ar,pl;function Du(){if(pl)return Ar;pl=1;const t=l=>({IMPORTANT:{scope:"meta",begin:"!important"},BLOCK_COMMENT:l.C_BLOCK_COMMENT_MODE,HEXCOLOR:{scope:"number",begin:/#(([0-9a-fA-F]{3,4})|(([0-9a-fA-F]{2}){3,4}))\\b/},FUNCTION_DISPATCH:{className:"built_in",begin:/[\\w-]+(?=\\()/},ATTRIBUTE_SELECTOR_MODE:{scope:"selector-attr",begin:/\\[/,end:/\\]/,illegal:"$",contains:[l.APOS_STRING_MODE,l.QUOTE_STRING_MODE]},CSS_NUMBER_MODE:{scope:"number",begin:l.NUMBER_RE+"(%|em|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc|px|deg|grad|rad|turn|s|ms|Hz|kHz|dpi|dpcm|dppx)?",relevance:0},CSS_VARIABLE:{className:"attr",begin:/--[A-Za-z_][A-Za-z0-9_-]*/}}),e=["a","abbr","address","article","aside","audio","b","blockquote","body","button","canvas","caption","cite","code","dd","del","details","dfn","div","dl","dt","em","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","header","hgroup","html","i","iframe","img","input","ins","kbd","label","legend","li","main","mark","menu","nav","object","ol","optgroup","option","p","picture","q","quote","samp","section","select","source","span","strong","summary","sup","table","tbody","td","textarea","tfoot","th","thead","time","tr","ul","var","video"],n=["defs","g","marker","mask","pattern","svg","switch","symbol","feBlend","feColorMatrix","feComponentTransfer","feComposite","feConvolveMatrix","feDiffuseLighting","feDisplacementMap","feFlood","feGaussianBlur","feImage","feMerge","feMorphology","feOffset","feSpecularLighting","feTile","feTurbulence","linearGradient","radialGradient","stop","circle","ellipse","image","line","path","polygon","polyline","rect","text","use","textPath","tspan","foreignObject","clipPath"],a=[...e,...n],r=["any-hover","any-pointer","aspect-ratio","color","color-gamut","color-index","device-aspect-ratio","device-height","device-width","display-mode","forced-colors","grid","height","hover","inverted-colors","monochrome","orientation","overflow-block","overflow-inline","pointer","prefers-color-scheme","prefers-contrast","prefers-reduced-motion","prefers-reduced-transparency","resolution","scan","scripting","update","width","min-width","max-width","min-height","max-height"].sort().reverse(),i=["active","any-link","blank","checked","current","default","defined","dir","disabled","drop","empty","enabled","first","first-child","first-of-type","fullscreen","future","focus","focus-visible","focus-within","has","host","host-context","hover","indeterminate","in-range","invalid","is","lang","last-child","last-of-type","left","link","local-link","not","nth-child","nth-col","nth-last-child","nth-last-col","nth-last-of-type","nth-of-type","only-child","only-of-type","optional","out-of-range","past","placeholder-shown","read-only","read-write","required","right","root","scope","target","target-within","user-invalid","valid","visited","where"].sort().reverse(),s=["after","backdrop","before","cue","cue-region","first-letter","first-line","grammar-error","marker","part","placeholder","selection","slotted","spelling-error"].sort().reverse(),o=["accent-color","align-content","align-items","align-self","alignment-baseline","all","anchor-name","animation","animation-composition","animation-delay","animation-direction","animation-duration","animation-fill-mode","animation-iteration-count","animation-name","animation-play-state","animation-range","animation-range-end","animation-range-start","animation-timeline","animation-timing-function","appearance","aspect-ratio","backdrop-filter","backface-visibility","background","background-attachment","background-blend-mode","background-clip","background-color","background-image","background-origin","background-position","background-position-x","background-position-y","background-repeat","background-size","baseline-shift","block-size","border","border-block","border-block-color","border-block-end","border-block-end-color","border-block-end-style","border-block-end-width","border-block-start","border-block-start-color","border-block-start-style","border-block-start-width","border-block-style","border-block-width","border-bottom","border-bottom-color","border-bottom-left-radius","border-bottom-right-radius","border-bottom-style","border-bottom-width","border-collapse","border-color","border-end-end-radius","border-end-start-radius","border-image","border-image-outset","border-image-repeat","border-image-slice","border-image-source","border-image-width","border-inline","border-inline-color","border-inline-end","border-inline-end-color","border-inline-end-style","border-inline-end-width","border-inline-start","border-inline-start-color","border-inline-start-style","border-inline-start-width","border-inline-style","border-inline-width","border-left","border-left-color","border-left-style","border-left-width","border-radius","border-right","border-right-color","border-right-style","border-right-width","border-spacing","border-start-end-radius","border-start-start-radius","border-style","border-top","border-top-color","border-top-left-radius","border-top-right-radius","border-top-style","border-top-width","border-width","bottom","box-align","box-decoration-break","box-direction","box-flex","box-flex-group","box-lines","box-ordinal-group","box-orient","box-pack","box-shadow","box-sizing","break-after","break-before","break-inside","caption-side","caret-color","clear","clip","clip-path","clip-rule","color","color-interpolation","color-interpolation-filters","color-profile","color-rendering","color-scheme","column-count","column-fill","column-gap","column-rule","column-rule-color","column-rule-style","column-rule-width","column-span","column-width","columns","contain","contain-intrinsic-block-size","contain-intrinsic-height","contain-intrinsic-inline-size","contain-intrinsic-size","contain-intrinsic-width","container","container-name","container-type","content","content-visibility","counter-increment","counter-reset","counter-set","cue","cue-after","cue-before","cursor","cx","cy","direction","display","dominant-baseline","empty-cells","enable-background","field-sizing","fill","fill-opacity","fill-rule","filter","flex","flex-basis","flex-direction","flex-flow","flex-grow","flex-shrink","flex-wrap","float","flood-color","flood-opacity","flow","font","font-display","font-family","font-feature-settings","font-kerning","font-language-override","font-optical-sizing","font-palette","font-size","font-size-adjust","font-smooth","font-smoothing","font-stretch","font-style","font-synthesis","font-synthesis-position","font-synthesis-small-caps","font-synthesis-style","font-synthesis-weight","font-variant","font-variant-alternates","font-variant-caps","font-variant-east-asian","font-variant-emoji","font-variant-ligatures","font-variant-numeric","font-variant-position","font-variation-settings","font-weight","forced-color-adjust","gap","glyph-orientation-horizontal","glyph-orientation-vertical","grid","grid-area","grid-auto-columns","grid-auto-flow","grid-auto-rows","grid-column","grid-column-end","grid-column-start","grid-gap","grid-row","grid-row-end","grid-row-start","grid-template","grid-template-areas","grid-template-columns","grid-template-rows","hanging-punctuation","height","hyphenate-character","hyphenate-limit-chars","hyphens","icon","image-orientation","image-rendering","image-resolution","ime-mode","initial-letter","initial-letter-align","inline-size","inset","inset-area","inset-block","inset-block-end","inset-block-start","inset-inline","inset-inline-end","inset-inline-start","isolation","justify-content","justify-items","justify-self","kerning","left","letter-spacing","lighting-color","line-break","line-height","line-height-step","list-style","list-style-image","list-style-position","list-style-type","margin","margin-block","margin-block-end","margin-block-start","margin-bottom","margin-inline","margin-inline-end","margin-inline-start","margin-left","margin-right","margin-top","margin-trim","marker","marker-end","marker-mid","marker-start","marks","mask","mask-border","mask-border-mode","mask-border-outset","mask-border-repeat","mask-border-slice","mask-border-source","mask-border-width","mask-clip","mask-composite","mask-image","mask-mode","mask-origin","mask-position","mask-repeat","mask-size","mask-type","masonry-auto-flow","math-depth","math-shift","math-style","max-block-size","max-height","max-inline-size","max-width","min-block-size","min-height","min-inline-size","min-width","mix-blend-mode","nav-down","nav-index","nav-left","nav-right","nav-up","none","normal","object-fit","object-position","offset","offset-anchor","offset-distance","offset-path","offset-position","offset-rotate","opacity","order","orphans","outline","outline-color","outline-offset","outline-style","outline-width","overflow","overflow-anchor","overflow-block","overflow-clip-margin","overflow-inline","overflow-wrap","overflow-x","overflow-y","overlay","overscroll-behavior","overscroll-behavior-block","overscroll-behavior-inline","overscroll-behavior-x","overscroll-behavior-y","padding","padding-block","padding-block-end","padding-block-start","padding-bottom","padding-inline","padding-inline-end","padding-inline-start","padding-left","padding-right","padding-top","page","page-break-after","page-break-before","page-break-inside","paint-order","pause","pause-after","pause-before","perspective","perspective-origin","place-content","place-items","place-self","pointer-events","position","position-anchor","position-visibility","print-color-adjust","quotes","r","resize","rest","rest-after","rest-before","right","rotate","row-gap","ruby-align","ruby-position","scale","scroll-behavior","scroll-margin","scroll-margin-block","scroll-margin-block-end","scroll-margin-block-start","scroll-margin-bottom","scroll-margin-inline","scroll-margin-inline-end","scroll-margin-inline-start","scroll-margin-left","scroll-margin-right","scroll-margin-top","scroll-padding","scroll-padding-block","scroll-padding-block-end","scroll-padding-block-start","scroll-padding-bottom","scroll-padding-inline","scroll-padding-inline-end","scroll-padding-inline-start","scroll-padding-left","scroll-padding-right","scroll-padding-top","scroll-snap-align","scroll-snap-stop","scroll-snap-type","scroll-timeline","scroll-timeline-axis","scroll-timeline-name","scrollbar-color","scrollbar-gutter","scrollbar-width","shape-image-threshold","shape-margin","shape-outside","shape-rendering","speak","speak-as","src","stop-color","stop-opacity","stroke","stroke-dasharray","stroke-dashoffset","stroke-linecap","stroke-linejoin","stroke-miterlimit","stroke-opacity","stroke-width","tab-size","table-layout","text-align","text-align-all","text-align-last","text-anchor","text-combine-upright","text-decoration","text-decoration-color","text-decoration-line","text-decoration-skip","text-decoration-skip-ink","text-decoration-style","text-decoration-thickness","text-emphasis","text-emphasis-color","text-emphasis-position","text-emphasis-style","text-indent","text-justify","text-orientation","text-overflow","text-rendering","text-shadow","text-size-adjust","text-transform","text-underline-offset","text-underline-position","text-wrap","text-wrap-mode","text-wrap-style","timeline-scope","top","touch-action","transform","transform-box","transform-origin","transform-style","transition","transition-behavior","transition-delay","transition-duration","transition-property","transition-timing-function","translate","unicode-bidi","user-modify","user-select","vector-effect","vertical-align","view-timeline","view-timeline-axis","view-timeline-inset","view-timeline-name","view-transition-name","visibility","voice-balance","voice-duration","voice-family","voice-pitch","voice-range","voice-rate","voice-stress","voice-volume","white-space","white-space-collapse","widows","width","will-change","word-break","word-spacing","word-wrap","writing-mode","x","y","z-index","zoom"].sort().reverse();function _(l){const c=t(l),d="and or not only",m={className:"variable",begin:"\\\\$"+l.IDENT_RE},p=["charset","css","debug","extend","font-face","for","import","include","keyframes","media","mixin","page","warn","while"],E="(?=[.\\\\s\\\\n[:,(])";return{name:"Stylus",aliases:["styl"],case_insensitive:!1,keywords:"if else for in",illegal:"("+["\\\\?","(\\\\bReturn\\\\b)","(\\\\bEnd\\\\b)","(\\\\bend\\\\b)","(\\\\bdef\\\\b)",";","#\\\\s","\\\\*\\\\s","===\\\\s","\\\\|","%"].join("|")+")",contains:[l.QUOTE_STRING_MODE,l.APOS_STRING_MODE,l.C_LINE_COMMENT_MODE,l.C_BLOCK_COMMENT_MODE,c.HEXCOLOR,{begin:"\\\\.[a-zA-Z][a-zA-Z0-9_-]*"+E,className:"selector-class"},{begin:"#[a-zA-Z][a-zA-Z0-9_-]*"+E,className:"selector-id"},{begin:"\\\\b("+a.join("|")+")"+E,className:"selector-tag"},{className:"selector-pseudo",begin:"&?:("+i.join("|")+")"+E},{className:"selector-pseudo",begin:"&?:(:)?("+s.join("|")+")"+E},c.ATTRIBUTE_SELECTOR_MODE,{className:"keyword",begin:/@media/,starts:{end:/[{;}]/,keywords:{$pattern:/[a-z-]+/,keyword:d,attribute:r.join(" ")},contains:[c.CSS_NUMBER_MODE]}},{className:"keyword",begin:"@((-(o|moz|ms|webkit)-)?("+p.join("|")+"))\\\\b"},m,c.CSS_NUMBER_MODE,{className:"function",begin:"^[a-zA-Z][a-zA-Z0-9_-]*\\\\(.*\\\\)",illegal:"[\\\\n]",returnBegin:!0,contains:[{className:"title",begin:"\\\\b[a-zA-Z][a-zA-Z0-9_-]*"},{className:"params",begin:/\\(/,end:/\\)/,contains:[c.HEXCOLOR,m,l.APOS_STRING_MODE,c.CSS_NUMBER_MODE,l.QUOTE_STRING_MODE]}]},c.CSS_VARIABLE,{className:"attribute",begin:"\\\\b("+o.join("|")+")\\\\b",starts:{end:/;|$/,contains:[c.HEXCOLOR,m,l.APOS_STRING_MODE,l.QUOTE_STRING_MODE,c.CSS_NUMBER_MODE,l.C_BLOCK_COMMENT_MODE,c.IMPORTANT,c.FUNCTION_DISPATCH],illegal:/\\./,relevance:0}},c.FUNCTION_DISPATCH]}}return Ar=_,Ar}var vr,El;function Mu(){if(El)return vr;El=1;function t(e){return{name:"SubUnit",case_insensitive:!0,contains:[{className:"string",begin:\`\\\\[
(multipart)?\`,end:\`\\\\]
\`},{className:"string",begin:"\\\\d{4}-\\\\d{2}-\\\\d{2}(\\\\s+)\\\\d{2}:\\\\d{2}:\\\\d{2}.\\\\d+Z"},{className:"string",begin:"(\\\\+|-)\\\\d+"},{className:"keyword",relevance:10,variants:[{begin:"^(test|testing|success|successful|failure|error|skip|xfail|uxsuccess)(:?)\\\\s+(test)?"},{begin:"^progress(:?)(\\\\s+)?(pop|push)?"},{begin:"^tags:"},{begin:"^time:"}]}]}}return vr=t,vr}var yr,gl;function Lu(){if(gl)return yr;gl=1;function t(y){return y?typeof y=="string"?y:y.source:null}function e(y){return n("(?=",y,")")}function n(...y){return y.map(G=>t(G)).join("")}function a(y){const x=y[y.length-1];return typeof x=="object"&&x.constructor===Object?(y.splice(y.length-1,1),x):{}}function r(...y){return"("+(a(y).capture?"":"?:")+y.map(w=>t(w)).join("|")+")"}const i=y=>n(/\\b/,y,/\\w$/.test(y)?/\\b/:/\\B/),s=["Protocol","Type"].map(i),o=["init","self"].map(i),_=["Any","Self"],l=["actor","any","associatedtype","async","await",/as\\?/,/as!/,"as","borrowing","break","case","catch","class","consume","consuming","continue","convenience","copy","default","defer","deinit","didSet","distributed","do","dynamic","each","else","enum","extension","fallthrough",/fileprivate\\(set\\)/,"fileprivate","final","for","func","get","guard","if","import","indirect","infix",/init\\?/,/init!/,"inout",/internal\\(set\\)/,"internal","in","is","isolated","nonisolated","lazy","let","macro","mutating","nonmutating",/open\\(set\\)/,"open","operator","optional","override","package","postfix","precedencegroup","prefix",/private\\(set\\)/,"private","protocol",/public\\(set\\)/,"public","repeat","required","rethrows","return","set","some","static","struct","subscript","super","switch","throws","throw",/try\\?/,/try!/,"try","typealias",/unowned\\(safe\\)/,/unowned\\(unsafe\\)/,"unowned","var","weak","where","while","willSet"],c=["false","nil","true"],d=["assignment","associativity","higherThan","left","lowerThan","none","right"],m=["#colorLiteral","#column","#dsohandle","#else","#elseif","#endif","#error","#file","#fileID","#fileLiteral","#filePath","#function","#if","#imageLiteral","#keyPath","#line","#selector","#sourceLocation","#warning"],p=["abs","all","any","assert","assertionFailure","debugPrint","dump","fatalError","getVaList","isKnownUniquelyReferenced","max","min","numericCast","pointwiseMax","pointwiseMin","precondition","preconditionFailure","print","readLine","repeatElement","sequence","stride","swap","swift_unboxFromSwiftValueWithType","transcode","type","unsafeBitCast","unsafeDowncast","withExtendedLifetime","withUnsafeMutablePointer","withUnsafePointer","withVaList","withoutActuallyEscaping","zip"],E=r(/[/=\\-+!*%<>&|^~?]/,/[\\u00A1-\\u00A7]/,/[\\u00A9\\u00AB]/,/[\\u00AC\\u00AE]/,/[\\u00B0\\u00B1]/,/[\\u00B6\\u00BB\\u00BF\\u00D7\\u00F7]/,/[\\u2016-\\u2017]/,/[\\u2020-\\u2027]/,/[\\u2030-\\u203E]/,/[\\u2041-\\u2053]/,/[\\u2055-\\u205E]/,/[\\u2190-\\u23FF]/,/[\\u2500-\\u2775]/,/[\\u2794-\\u2BFF]/,/[\\u2E00-\\u2E7F]/,/[\\u3001-\\u3003]/,/[\\u3008-\\u3020]/,/[\\u3030]/),g=r(E,/[\\u0300-\\u036F]/,/[\\u1DC0-\\u1DFF]/,/[\\u20D0-\\u20FF]/,/[\\uFE00-\\uFE0F]/,/[\\uFE20-\\uFE2F]/),S=n(E,g,"*"),T=r(/[a-zA-Z_]/,/[\\u00A8\\u00AA\\u00AD\\u00AF\\u00B2-\\u00B5\\u00B7-\\u00BA]/,/[\\u00BC-\\u00BE\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u00FF]/,/[\\u0100-\\u02FF\\u0370-\\u167F\\u1681-\\u180D\\u180F-\\u1DBF]/,/[\\u1E00-\\u1FFF]/,/[\\u200B-\\u200D\\u202A-\\u202E\\u203F-\\u2040\\u2054\\u2060-\\u206F]/,/[\\u2070-\\u20CF\\u2100-\\u218F\\u2460-\\u24FF\\u2776-\\u2793]/,/[\\u2C00-\\u2DFF\\u2E80-\\u2FFF]/,/[\\u3004-\\u3007\\u3021-\\u302F\\u3031-\\u303F\\u3040-\\uD7FF]/,/[\\uF900-\\uFD3D\\uFD40-\\uFDCF\\uFDF0-\\uFE1F\\uFE30-\\uFE44]/,/[\\uFE47-\\uFEFE\\uFF00-\\uFFFD]/),R=r(T,/\\d/,/[\\u0300-\\u036F\\u1DC0-\\u1DFF\\u20D0-\\u20FF\\uFE20-\\uFE2F]/),f=n(T,R,"*"),A=n(/[A-Z]/,R,"*"),N=["attached","autoclosure",n(/convention\\(/,r("swift","block","c"),/\\)/),"discardableResult","dynamicCallable","dynamicMemberLookup","escaping","freestanding","frozen","GKInspectable","IBAction","IBDesignable","IBInspectable","IBOutlet","IBSegueAction","inlinable","main","nonobjc","NSApplicationMain","NSCopying","NSManaged",n(/objc\\(/,f,/\\)/),"objc","objcMembers","propertyWrapper","requires_stored_property_inits","resultBuilder","Sendable","testable","UIApplicationMain","unchecked","unknown","usableFromInline","warn_unqualified_access"],C=["iOS","iOSApplicationExtension","macOS","macOSApplicationExtension","macCatalyst","macCatalystApplicationExtension","watchOS","watchOSApplicationExtension","tvOS","tvOSApplicationExtension","swift"];function M(y){const x={match:/\\s+/,relevance:0},G=y.COMMENT("/\\\\*","\\\\*/",{contains:["self"]}),w=[y.C_LINE_COMMENT_MODE,G],H={match:[/\\./,r(...s,...o)],className:{2:"keyword"}},j={match:n(/\\./,r(...l)),relevance:0},ee=l.filter($=>typeof $=="string").concat(["_|0"]),V=l.filter($=>typeof $!="string").concat(_).map(i),z={variants:[{className:"keyword",match:r(...V,...o)}]},X={$pattern:r(/\\b\\w+/,/#\\w+/),keyword:ee.concat(m),literal:c},q=[H,j,z],ie={match:n(/\\./,r(...p)),relevance:0},_e={className:"built_in",match:n(/\\b/,r(...p),/(?=\\()/)},de=[ie,_e],Se={match:/->/,relevance:0},ge={className:"operator",relevance:0,variants:[{match:S},{match:\`\\\\.(\\\\.|\${g})+\`}]},Te=[Se,ge],se="([0-9]_*)+",ue="([0-9a-fA-F]_*)+",Z={className:"number",relevance:0,variants:[{match:\`\\\\b(\${se})(\\\\.(\${se}))?([eE][+-]?(\${se}))?\\\\b\`},{match:\`\\\\b0x(\${ue})(\\\\.(\${ue}))?([pP][+-]?(\${se}))?\\\\b\`},{match:/\\b0o([0-7]_*)+\\b/},{match:/\\b0b([01]_*)+\\b/}]},K=($="")=>({className:"subst",variants:[{match:n(/\\\\/,$,/[0\\\\tnr"']/)},{match:n(/\\\\/,$,/u\\{[0-9a-fA-F]{1,8}\\}/)}]}),te=($="")=>({className:"subst",match:n(/\\\\/,$,/[\\t ]*(?:[\\r\\n]|\\r\\n)/)}),ne=($="")=>({className:"subst",label:"interpol",begin:n(/\\\\/,$,/\\(/),end:/\\)/}),le=($="")=>({begin:n($,/"""/),end:n(/"""/,$),contains:[K($),te($),ne($)]}),be=($="")=>({begin:n($,/"/),end:n(/"/,$),contains:[K($),ne($)]}),Ce={className:"string",variants:[le(),le("#"),le("##"),le("###"),be(),be("#"),be("##"),be("###")]},qe=[y.BACKSLASH_ESCAPE,{begin:/\\[/,end:/\\]/,relevance:0,contains:[y.BACKSLASH_ESCAPE]}],it={begin:/\\/[^\\s](?=[^/\\n]*\\/)/,end:/\\//,contains:qe},Ue=$=>{const Pe=n($,/\\//),he=n(/\\//,$);return{begin:Pe,end:he,contains:[...qe,{scope:"comment",begin:\`#(?!.*\${he})\`,end:/$/}]}},He={scope:"regexp",variants:[Ue("###"),Ue("##"),Ue("#"),it]},Ve={match:n(/\`/,f,/\`/)},ot={className:"variable",match:/\\$\\d+/},ze={className:"variable",match:\`\\\\$\${R}+\`},Fe=[Ve,ot,ze],st={match:/(@|#(un)?)available/,scope:"keyword",starts:{contains:[{begin:/\\(/,end:/\\)/,keywords:C,contains:[...Te,Z,Ce]}]}},We={scope:"keyword",match:n(/@/,r(...N),e(r(/\\(/,/\\s+/)))},ve={scope:"meta",match:n(/@/,f)},xe=[st,We,ve],Re={match:e(/\\b[A-Z]/),relevance:0,contains:[{className:"type",match:n(/(AV|CA|CF|CG|CI|CL|CM|CN|CT|MK|MP|MTK|MTL|NS|SCN|SK|UI|WK|XC)/,R,"+")},{className:"type",match:A,relevance:0},{match:/[?!]+/,relevance:0},{match:/\\.\\.\\./,relevance:0},{match:n(/\\s+&\\s+/,e(A)),relevance:0}]},we={begin:/</,end:/>/,keywords:X,contains:[...w,...q,...xe,Se,Re]};Re.contains.push(we);const Ke={match:n(f,/\\s*:/),keywords:"_|0",relevance:0},$e={begin:/\\(/,end:/\\)/,relevance:0,keywords:X,contains:["self",Ke,...w,He,...q,...de,...Te,Z,Ce,...Fe,...xe,Re]},Be={begin:/</,end:/>/,keywords:"repeat each",contains:[...w,Re]},lt={begin:r(e(n(f,/\\s*:/)),e(n(f,/\\s+/,f,/\\s*:/))),end:/:/,relevance:0,contains:[{className:"keyword",match:/\\b_\\b/},{className:"params",match:f}]},Qe={begin:/\\(/,end:/\\)/,keywords:X,contains:[lt,...w,...q,...Te,Z,Ce,...xe,Re,$e],endsParent:!0,illegal:/["']/},ct={match:[/(func|macro)/,/\\s+/,r(Ve.match,f,S)],className:{1:"keyword",3:"title.function"},contains:[Be,Qe,x],illegal:[/\\[/,/%/]},Xe={match:[/\\b(?:subscript|init[?!]?)/,/\\s*(?=[<(])/],className:{1:"keyword"},contains:[Be,Qe,x],illegal:/\\[|%/},_t={match:[/operator/,/\\s+/,S],className:{1:"keyword",3:"title"}},dt={begin:[/precedencegroup/,/\\s+/,A],className:{1:"keyword",3:"title"},contains:[Re],keywords:[...d,...c],end:/}/},ut={match:[/class\\b/,/\\s+/,/func\\b/,/\\s+/,/\\b[A-Za-z_][A-Za-z0-9_]*\\b/],scope:{1:"keyword",3:"keyword",5:"title.function"}},Ge={match:[/class\\b/,/\\s+/,/var\\b/],scope:{1:"keyword",3:"keyword"}},Ze={begin:[/(struct|protocol|class|extension|enum|actor)/,/\\s+/,f,/\\s*/],beginScope:{1:"keyword",3:"title.class"},keywords:X,contains:[Be,...q,{begin:/:/,end:/\\{/,keywords:X,contains:[{scope:"title.class.inherited",match:A},...q],relevance:0}]};for(const $ of Ce.variants){const Pe=$.contains.find(De=>De.label==="interpol");Pe.keywords=X;const he=[...q,...de,...Te,Z,Ce,...Fe];Pe.contains=[...he,{begin:/\\(/,end:/\\)/,contains:["self",...he]}]}return{name:"Swift",keywords:X,contains:[...w,ct,Xe,ut,Ge,Ze,_t,dt,{beginKeywords:"import",end:/$/,contains:[...w],relevance:0},He,...q,...de,...Te,Z,Ce,...Fe,...xe,Re,$e]}}return yr=M,yr}var hr,Sl;function xu(){if(Sl)return hr;Sl=1;function t(e){return{name:"Tagger Script",contains:[{className:"comment",begin:/\\$noop\\(/,end:/\\)/,contains:[{begin:/\\\\[()]/},{begin:/\\(/,end:/\\)/,contains:[{begin:/\\\\[()]/},"self"]}],relevance:10},{className:"keyword",begin:/\\$[_a-zA-Z0-9]+(?=\\()/},{className:"variable",begin:/%[_a-zA-Z0-9:]+%/},{className:"symbol",begin:/\\\\[\\\\nt$%,()]/},{className:"symbol",begin:/\\\\u[a-fA-F0-9]{4}/}]}}return hr=t,hr}var Dr,Tl;function wu(){if(Tl)return Dr;Tl=1;function t(e){const n="true false yes no null",a="[\\\\w#;/?:@&=+$,.~*'()[\\\\]]+",r={className:"attr",variants:[{begin:/[\\w*@][\\w*@ :()\\./-]*:(?=[ \\t]|$)/},{begin:/"[\\w*@][\\w*@ :()\\./-]*":(?=[ \\t]|$)/},{begin:/'[\\w*@][\\w*@ :()\\./-]*':(?=[ \\t]|$)/}]},i={className:"template-variable",variants:[{begin:/\\{\\{/,end:/\\}\\}/},{begin:/%\\{/,end:/\\}/}]},s={className:"string",relevance:0,begin:/'/,end:/'/,contains:[{match:/''/,scope:"char.escape",relevance:0}]},o={className:"string",relevance:0,variants:[{begin:/"/,end:/"/},{begin:/\\S+/}],contains:[e.BACKSLASH_ESCAPE,i]},_=e.inherit(o,{variants:[{begin:/'/,end:/'/,contains:[{begin:/''/,relevance:0}]},{begin:/"/,end:/"/},{begin:/[^\\s,{}[\\]]+/}]}),p={className:"number",begin:"\\\\b"+"[0-9]{4}(-[0-9][0-9]){0,2}"+"([Tt \\\\t][0-9][0-9]?(:[0-9][0-9]){2})?"+"(\\\\.[0-9]*)?"+"([ \\\\t])*(Z|[-+][0-9][0-9]?(:[0-9][0-9])?)?"+"\\\\b"},E={end:",",endsWithParent:!0,excludeEnd:!0,keywords:n,relevance:0},g={begin:/\\{/,end:/\\}/,contains:[E],illegal:"\\\\n",relevance:0},S={begin:"\\\\[",end:"\\\\]",contains:[E],illegal:"\\\\n",relevance:0},T=[r,{className:"meta",begin:"^---\\\\s*$",relevance:10},{className:"string",begin:"[\\\\|>]([1-9]?[+-])?[ ]*\\\\n( +)[^ ][^\\\\n]*\\\\n(\\\\2[^\\\\n]+\\\\n?)*"},{begin:"<%[%=-]?",end:"[%-]?%>",subLanguage:"ruby",excludeBegin:!0,excludeEnd:!0,relevance:0},{className:"type",begin:"!\\\\w+!"+a},{className:"type",begin:"!<"+a+">"},{className:"type",begin:"!"+a},{className:"type",begin:"!!"+a},{className:"meta",begin:"&"+e.UNDERSCORE_IDENT_RE+"$"},{className:"meta",begin:"\\\\*"+e.UNDERSCORE_IDENT_RE+"$"},{className:"bullet",begin:"-(?=[ ]|$)",relevance:0},e.HASH_COMMENT_MODE,{beginKeywords:n,keywords:{literal:n}},p,{className:"number",begin:e.C_NUMBER_RE+"\\\\b",relevance:0},g,S,s,o],R=[...T];return R.pop(),R.push(_),E.contains=R,{name:"YAML",case_insensitive:!0,aliases:["yml"],contains:T}}return Dr=t,Dr}var Mr,bl;function Pu(){if(bl)return Mr;bl=1;function t(e){return{name:"Test Anything Protocol",case_insensitive:!0,contains:[e.HASH_COMMENT_MODE,{className:"meta",variants:[{begin:"^TAP version (\\\\d+)$"},{begin:"^1\\\\.\\\\.(\\\\d+)$"}]},{begin:/---$/,end:"\\\\.\\\\.\\\\.$",subLanguage:"yaml",relevance:0},{className:"number",begin:" (\\\\d+) "},{className:"symbol",variants:[{begin:"^ok"},{begin:"^not ok"}]}]}}return Mr=t,Mr}var Lr,Rl;function ku(){if(Rl)return Lr;Rl=1;function t(e){const n=e.regex,a=/[a-zA-Z_][a-zA-Z0-9_]*/,r={className:"number",variants:[e.BINARY_NUMBER_MODE,e.C_NUMBER_MODE]};return{name:"Tcl",aliases:["tk"],keywords:["after","append","apply","array","auto_execok","auto_import","auto_load","auto_mkindex","auto_mkindex_old","auto_qualify","auto_reset","bgerror","binary","break","catch","cd","chan","clock","close","concat","continue","dde","dict","encoding","eof","error","eval","exec","exit","expr","fblocked","fconfigure","fcopy","file","fileevent","filename","flush","for","foreach","format","gets","glob","global","history","http","if","incr","info","interp","join","lappend|10","lassign|10","lindex|10","linsert|10","list","llength|10","load","lrange|10","lrepeat|10","lreplace|10","lreverse|10","lsearch|10","lset|10","lsort|10","mathfunc","mathop","memory","msgcat","namespace","open","package","parray","pid","pkg::create","pkg_mkIndex","platform","platform::shell","proc","puts","pwd","read","refchan","regexp","registry","regsub|10","rename","return","safe","scan","seek","set","socket","source","split","string","subst","switch","tcl_endOfWord","tcl_findLibrary","tcl_startOfNextWord","tcl_startOfPreviousWord","tcl_wordBreakAfter","tcl_wordBreakBefore","tcltest","tclvars","tell","time","tm","trace","unknown","unload","unset","update","uplevel","upvar","variable","vwait","while"],contains:[e.COMMENT(";[ \\\\t]*#","$"),e.COMMENT("^[ \\\\t]*#","$"),{beginKeywords:"proc",end:"[\\\\{]",excludeEnd:!0,contains:[{className:"title",begin:"[ \\\\t\\\\n\\\\r]+(::)?[a-zA-Z_]((::)?[a-zA-Z0-9_])*",end:"[ \\\\t\\\\n\\\\r]",endsWithParent:!0,excludeEnd:!0}]},{className:"variable",variants:[{begin:n.concat(/\\$/,n.optional(/::/),a,"(::",a,")*")},{begin:"\\\\$\\\\{(::)?[a-zA-Z_]((::)?[a-zA-Z0-9_])*",end:"\\\\}",contains:[r]}]},{className:"string",contains:[e.BACKSLASH_ESCAPE],variants:[e.inherit(e.QUOTE_STRING_MODE,{illegal:null})]},r]}}return Lr=t,Lr}var xr,fl;function Uu(){if(fl)return xr;fl=1;function t(e){const n=["bool","byte","i16","i32","i64","double","string","binary"];return{name:"Thrift",keywords:{keyword:["namespace","const","typedef","struct","enum","service","exception","void","oneway","set","list","map","required","optional"],type:n,literal:"true false"},contains:[e.QUOTE_STRING_MODE,e.NUMBER_MODE,e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,{className:"class",beginKeywords:"struct enum service exception",end:/\\{/,illegal:/\\n/,contains:[e.inherit(e.TITLE_MODE,{starts:{endsWithParent:!0,excludeEnd:!0}})]},{begin:"\\\\b(set|list|map)\\\\s*<",keywords:{type:[...n,"set","list","map"]},end:">",contains:["self"]}]}}return xr=t,xr}var wr,Cl;function Fu(){if(Cl)return wr;Cl=1;function t(e){const n={className:"number",begin:"[1-9][0-9]*",relevance:0},a={className:"symbol",begin:":[^\\\\]]+"},r={className:"built_in",begin:"(AR|P|PAYLOAD|PR|R|SR|RSR|LBL|VR|UALM|MESSAGE|UTOOL|UFRAME|TIMER|TIMER_OVERFLOW|JOINT_MAX_SPEED|RESUME_PROG|DIAG_REC)\\\\[",end:"\\\\]",contains:["self",n,a]},i={className:"built_in",begin:"(AI|AO|DI|DO|F|RI|RO|UI|UO|GI|GO|SI|SO)\\\\[",end:"\\\\]",contains:["self",n,e.QUOTE_STRING_MODE,a]};return{name:"TP",keywords:{keyword:["ABORT","ACC","ADJUST","AND","AP_LD","BREAK","CALL","CNT","COL","CONDITION","CONFIG","DA","DB","DIV","DETECT","ELSE","END","ENDFOR","ERR_NUM","ERROR_PROG","FINE","FOR","GP","GUARD","INC","IF","JMP","LINEAR_MAX_SPEED","LOCK","MOD","MONITOR","OFFSET","Offset","OR","OVERRIDE","PAUSE","PREG","PTH","RT_LD","RUN","SELECT","SKIP","Skip","TA","TB","TO","TOOL_OFFSET","Tool_Offset","UF","UT","UFRAME_NUM","UTOOL_NUM","UNLOCK","WAIT","X","Y","Z","W","P","R","STRLEN","SUBSTR","FINDSTR","VOFFSET","PROG","ATTR","MN","POS"],literal:["ON","OFF","max_speed","LPOS","JPOS","ENABLE","DISABLE","START","STOP","RESET"]},contains:[r,i,{className:"keyword",begin:"/(PROG|ATTR|MN|POS|END)\\\\b"},{className:"keyword",begin:"(CALL|RUN|POINT_LOGIC|LBL)\\\\b"},{className:"keyword",begin:"\\\\b(ACC|CNT|Skip|Offset|PSPD|RT_LD|AP_LD|Tool_Offset)"},{className:"number",begin:"\\\\d+(sec|msec|mm/sec|cm/min|inch/min|deg/sec|mm|in|cm)?\\\\b",relevance:0},e.COMMENT("//","[;$]"),e.COMMENT("!","[;$]"),e.COMMENT("--eg:","$"),e.QUOTE_STRING_MODE,{className:"string",begin:"'",end:"'"},e.C_NUMBER_MODE,{className:"variable",begin:"\\\\$[A-Za-z0-9_]+"}]}}return wr=t,wr}var Pr,Nl;function Bu(){if(Nl)return Pr;Nl=1;function t(e){const n=e.regex,a=["absolute_url","asset|0","asset_version","attribute","block","constant","controller|0","country_timezones","csrf_token","cycle","date","dump","expression","form|0","form_end","form_errors","form_help","form_label","form_rest","form_row","form_start","form_widget","html_classes","include","is_granted","logout_path","logout_url","max","min","parent","path|0","random","range","relative_path","render","render_esi","source","template_from_string","url|0"],r=["abs","abbr_class","abbr_method","batch","capitalize","column","convert_encoding","country_name","currency_name","currency_symbol","data_uri","date","date_modify","default","escape","file_excerpt","file_link","file_relative","filter","first","format","format_args","format_args_as_text","format_currency","format_date","format_datetime","format_file","format_file_from_text","format_number","format_time","html_to_markdown","humanize","inky_to_html","inline_css","join","json_encode","keys","language_name","last","length","locale_name","lower","map","markdown","markdown_to_html","merge","nl2br","number_format","raw","reduce","replace","reverse","round","slice","slug","sort","spaceless","split","striptags","timezone_name","title","trans","transchoice","trim","u|0","upper","url_encode","yaml_dump","yaml_encode"];let i=["apply","autoescape","block","cache","deprecated","do","embed","extends","filter","flush","for","form_theme","from","if","import","include","macro","sandbox","set","stopwatch","trans","trans_default_domain","transchoice","use","verbatim","with"];i=i.concat(i.map(g=>\`end\${g}\`));const s={scope:"string",variants:[{begin:/'/,end:/'/},{begin:/"/,end:/"/}]},o={scope:"number",match:/\\d+/},_={begin:/\\(/,end:/\\)/,excludeBegin:!0,excludeEnd:!0,contains:[s,o]},l={beginKeywords:a.join(" "),keywords:{name:a},relevance:0,contains:[_]},c={match:/\\|(?=[A-Za-z_]+:?)/,beginScope:"punctuation",relevance:0,contains:[{match:/[A-Za-z_]+:?/,keywords:r}]},d=(g,{relevance:S})=>({beginScope:{1:"template-tag",3:"name"},relevance:S||2,endScope:"template-tag",begin:[/\\{%/,/\\s*/,n.either(...g)],end:/%\\}/,keywords:"in",contains:[c,l,s,o]}),m=/[a-z_]+/,p=d(i,{relevance:2}),E=d([m],{relevance:1});return{name:"Twig",aliases:["craftcms"],case_insensitive:!0,subLanguage:"xml",contains:[e.COMMENT(/\\{#/,/#\\}/),p,E,{className:"template-variable",begin:/\\{\\{/,end:/\\}\\}/,contains:["self",c,l,s,o]}]}}return Pr=t,Pr}var kr,Ol;function Gu(){if(Ol)return kr;Ol=1;const t="[A-Za-z$_][0-9A-Za-z$_]*",e=["as","in","of","if","for","while","finally","var","new","function","do","return","void","else","break","catch","instanceof","with","throw","case","default","try","switch","continue","typeof","delete","let","yield","const","class","debugger","async","await","static","import","from","export","extends","using"],n=["true","false","null","undefined","NaN","Infinity"],a=["Object","Function","Boolean","Symbol","Math","Date","Number","BigInt","String","RegExp","Array","Float32Array","Float64Array","Int8Array","Uint8Array","Uint8ClampedArray","Int16Array","Int32Array","Uint16Array","Uint32Array","BigInt64Array","BigUint64Array","Set","Map","WeakSet","WeakMap","ArrayBuffer","SharedArrayBuffer","Atomics","DataView","JSON","Promise","Generator","GeneratorFunction","AsyncFunction","Reflect","Proxy","Intl","WebAssembly"],r=["Error","EvalError","InternalError","RangeError","ReferenceError","SyntaxError","TypeError","URIError"],i=["setInterval","setTimeout","clearInterval","clearTimeout","require","exports","eval","isFinite","isNaN","parseFloat","parseInt","decodeURI","decodeURIComponent","encodeURI","encodeURIComponent","escape","unescape"],s=["arguments","this","super","console","window","document","localStorage","sessionStorage","module","global"],o=[].concat(i,a,r);function _(c){const d=c.regex,m=(K,{after:te})=>{const ne="</"+K[0].slice(1);return K.input.indexOf(ne,te)!==-1},p=t,E={begin:"<>",end:"</>"},g=/<[A-Za-z0-9\\\\._:-]+\\s*\\/>/,S={begin:/<[A-Za-z0-9\\\\._:-]+/,end:/\\/[A-Za-z0-9\\\\._:-]+>|\\/>/,isTrulyOpeningTag:(K,te)=>{const ne=K[0].length+K.index,le=K.input[ne];if(le==="<"||le===","){te.ignoreMatch();return}le===">"&&(m(K,{after:ne})||te.ignoreMatch());let be;const Ce=K.input.substring(ne);if(be=Ce.match(/^\\s*=/)){te.ignoreMatch();return}if((be=Ce.match(/^\\s+extends\\s+/))&&be.index===0){te.ignoreMatch();return}}},T={$pattern:t,keyword:e,literal:n,built_in:o,"variable.language":s},R="[0-9](_?[0-9])*",f=\`\\\\.(\${R})\`,A="0|[1-9](_?[0-9])*|0[0-7]*[89][0-9]*",N={className:"number",variants:[{begin:\`(\\\\b(\${A})((\${f})|\\\\.)?|(\${f}))[eE][+-]?(\${R})\\\\b\`},{begin:\`\\\\b(\${A})\\\\b((\${f})\\\\b|\\\\.)?|(\${f})\\\\b\`},{begin:"\\\\b(0|[1-9](_?[0-9])*)n\\\\b"},{begin:"\\\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*n?\\\\b"},{begin:"\\\\b0[bB][0-1](_?[0-1])*n?\\\\b"},{begin:"\\\\b0[oO][0-7](_?[0-7])*n?\\\\b"},{begin:"\\\\b0[0-7]+n?\\\\b"}],relevance:0},C={className:"subst",begin:"\\\\$\\\\{",end:"\\\\}",keywords:T,contains:[]},M={begin:".?html\`",end:"",starts:{end:"\`",returnEnd:!1,contains:[c.BACKSLASH_ESCAPE,C],subLanguage:"xml"}},y={begin:".?css\`",end:"",starts:{end:"\`",returnEnd:!1,contains:[c.BACKSLASH_ESCAPE,C],subLanguage:"css"}},x={begin:".?gql\`",end:"",starts:{end:"\`",returnEnd:!1,contains:[c.BACKSLASH_ESCAPE,C],subLanguage:"graphql"}},G={className:"string",begin:"\`",end:"\`",contains:[c.BACKSLASH_ESCAPE,C]},H={className:"comment",variants:[c.COMMENT(/\\/\\*\\*(?!\\/)/,"\\\\*/",{relevance:0,contains:[{begin:"(?=@[A-Za-z]+)",relevance:0,contains:[{className:"doctag",begin:"@[A-Za-z]+"},{className:"type",begin:"\\\\{",end:"\\\\}",excludeEnd:!0,excludeBegin:!0,relevance:0},{className:"variable",begin:p+"(?=\\\\s*(-)|$)",endsParent:!0,relevance:0},{begin:/(?=[^\\n])\\s/,relevance:0}]}]}),c.C_BLOCK_COMMENT_MODE,c.C_LINE_COMMENT_MODE]},j=[c.APOS_STRING_MODE,c.QUOTE_STRING_MODE,M,y,x,G,{match:/\\$\\d+/},N];C.contains=j.concat({begin:/\\{/,end:/\\}/,keywords:T,contains:["self"].concat(j)});const ee=[].concat(H,C.contains),V=ee.concat([{begin:/(\\s*)\\(/,end:/\\)/,keywords:T,contains:["self"].concat(ee)}]),z={className:"params",begin:/(\\s*)\\(/,end:/\\)/,excludeBegin:!0,excludeEnd:!0,keywords:T,contains:V},X={variants:[{match:[/class/,/\\s+/,p,/\\s+/,/extends/,/\\s+/,d.concat(p,"(",d.concat(/\\./,p),")*")],scope:{1:"keyword",3:"title.class",5:"keyword",7:"title.class.inherited"}},{match:[/class/,/\\s+/,p],scope:{1:"keyword",3:"title.class"}}]},q={relevance:0,match:d.either(/\\bJSON/,/\\b[A-Z][a-z]+([A-Z][a-z]*|\\d)*/,/\\b[A-Z]{2,}([A-Z][a-z]+|\\d)+([A-Z][a-z]*)*/,/\\b[A-Z]{2,}[a-z]+([A-Z][a-z]+|\\d)*([A-Z][a-z]*)*/),className:"title.class",keywords:{_:[...a,...r]}},ie={label:"use_strict",className:"meta",relevance:10,begin:/^\\s*['"]use (strict|asm)['"]/},_e={variants:[{match:[/function/,/\\s+/,p,/(?=\\s*\\()/]},{match:[/function/,/\\s*(?=\\()/]}],className:{1:"keyword",3:"title.function"},label:"func.def",contains:[z],illegal:/%/},de={relevance:0,match:/\\b[A-Z][A-Z_0-9]+\\b/,className:"variable.constant"};function Se(K){return d.concat("(?!",K.join("|"),")")}const ge={match:d.concat(/\\b/,Se([...i,"super","import"].map(K=>\`\${K}\\\\s*\\\\(\`)),p,d.lookahead(/\\s*\\(/)),className:"title.function",relevance:0},Te={begin:d.concat(/\\./,d.lookahead(d.concat(p,/(?![0-9A-Za-z$_(])/))),end:p,excludeBegin:!0,keywords:"prototype",className:"property",relevance:0},se={match:[/get|set/,/\\s+/,p,/(?=\\()/],className:{1:"keyword",3:"title.function"},contains:[{begin:/\\(\\)/},z]},ue="(\\\\([^()]*(\\\\([^()]*(\\\\([^()]*\\\\)[^()]*)*\\\\)[^()]*)*\\\\)|"+c.UNDERSCORE_IDENT_RE+")\\\\s*=>",Z={match:[/const|var|let/,/\\s+/,p,/\\s*/,/=\\s*/,/(async\\s*)?/,d.lookahead(ue)],keywords:"async",className:{1:"keyword",3:"title.function"},contains:[z]};return{name:"JavaScript",aliases:["js","jsx","mjs","cjs"],keywords:T,exports:{PARAMS_CONTAINS:V,CLASS_REFERENCE:q},illegal:/#(?![$_A-z])/,contains:[c.SHEBANG({label:"shebang",binary:"node",relevance:5}),ie,c.APOS_STRING_MODE,c.QUOTE_STRING_MODE,M,y,x,G,H,{match:/\\$\\d+/},N,q,{scope:"attr",match:p+d.lookahead(":"),relevance:0},Z,{begin:"("+c.RE_STARTERS_RE+"|\\\\b(case|return|throw)\\\\b)\\\\s*",keywords:"return throw case",relevance:0,contains:[H,c.REGEXP_MODE,{className:"function",begin:ue,returnBegin:!0,end:"\\\\s*=>",contains:[{className:"params",variants:[{begin:c.UNDERSCORE_IDENT_RE,relevance:0},{className:null,begin:/\\(\\s*\\)/,skip:!0},{begin:/(\\s*)\\(/,end:/\\)/,excludeBegin:!0,excludeEnd:!0,keywords:T,contains:V}]}]},{begin:/,/,relevance:0},{match:/\\s+/,relevance:0},{variants:[{begin:E.begin,end:E.end},{match:g},{begin:S.begin,"on:begin":S.isTrulyOpeningTag,end:S.end}],subLanguage:"xml",contains:[{begin:S.begin,end:S.end,skip:!0,contains:["self"]}]}]},_e,{beginKeywords:"while if switch catch for"},{begin:"\\\\b(?!function)"+c.UNDERSCORE_IDENT_RE+"\\\\([^()]*(\\\\([^()]*(\\\\([^()]*\\\\)[^()]*)*\\\\)[^()]*)*\\\\)\\\\s*\\\\{",returnBegin:!0,label:"func.def",contains:[z,c.inherit(c.TITLE_MODE,{begin:p,className:"title.function"})]},{match:/\\.\\.\\./,relevance:0},Te,{match:"\\\\$"+p,relevance:0},{match:[/\\bconstructor(?=\\s*\\()/],className:{1:"title.function"},contains:[z]},ge,de,X,se,{match:/\\$[(.]/}]}}function l(c){const d=c.regex,m=_(c),p=t,E=["any","void","number","boolean","string","object","never","symbol","bigint","unknown"],g={begin:[/namespace/,/\\s+/,c.IDENT_RE],beginScope:{1:"keyword",3:"title.class"}},S={beginKeywords:"interface",end:/\\{/,excludeEnd:!0,keywords:{keyword:"interface extends",built_in:E},contains:[m.exports.CLASS_REFERENCE]},T={className:"meta",relevance:10,begin:/^\\s*['"]use strict['"]/},R=["type","interface","public","private","protected","implements","declare","abstract","readonly","enum","override","satisfies"],f={$pattern:t,keyword:e.concat(R),literal:n,built_in:o.concat(E),"variable.language":s},A={className:"meta",begin:"@"+p},N=(x,G,w)=>{const H=x.contains.findIndex(j=>j.label===G);if(H===-1)throw new Error("can not find mode to replace");x.contains.splice(H,1,w)};Object.assign(m.keywords,f),m.exports.PARAMS_CONTAINS.push(A);const C=m.contains.find(x=>x.scope==="attr"),M=Object.assign({},C,{match:d.concat(p,d.lookahead(/\\s*\\?:/))});m.exports.PARAMS_CONTAINS.push([m.exports.CLASS_REFERENCE,C,M]),m.contains=m.contains.concat([A,g,S,M]),N(m,"shebang",c.SHEBANG()),N(m,"use_strict",T);const y=m.contains.find(x=>x.label==="func.def");return y.relevance=0,Object.assign(m,{name:"TypeScript",aliases:["ts","tsx","mts","cts"]}),m}return kr=l,kr}var Ur,Il;function Yu(){if(Il)return Ur;Il=1;function t(e){return{name:"Vala",keywords:{keyword:"char uchar unichar int uint long ulong short ushort int8 int16 int32 int64 uint8 uint16 uint32 uint64 float double bool struct enum string void weak unowned owned async signal static abstract interface override virtual delegate if while do for foreach else switch case break default return try catch public private protected internal using new this get set const stdout stdin stderr var",built_in:"DBus GLib CCode Gee Object Gtk Posix",literal:"false true null"},contains:[{className:"class",beginKeywords:"class interface namespace",end:/\\{/,excludeEnd:!0,illegal:"[^,:\\\\n\\\\s\\\\.]",contains:[e.UNDERSCORE_TITLE_MODE]},e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,{className:"string",begin:'"""',end:'"""',relevance:5},e.APOS_STRING_MODE,e.QUOTE_STRING_MODE,e.C_NUMBER_MODE,{className:"meta",begin:"^#",end:"$"}]}}return Ur=t,Ur}var Fr,Al;function qu(){if(Al)return Fr;Al=1;function t(e){const n=e.regex,a={className:"string",begin:/"(""|[^/n])"C\\b/},r={className:"string",begin:/"/,end:/"/,illegal:/\\n/,contains:[{begin:/""/}]},i=/\\d{1,2}\\/\\d{1,2}\\/\\d{4}/,s=/\\d{4}-\\d{1,2}-\\d{1,2}/,o=/(\\d|1[012])(:\\d+){0,2} *(AM|PM)/,_=/\\d{1,2}(:\\d{1,2}){1,2}/,l={className:"literal",variants:[{begin:n.concat(/# */,n.either(s,i),/ *#/)},{begin:n.concat(/# */,_,/ *#/)},{begin:n.concat(/# */,o,/ *#/)},{begin:n.concat(/# */,n.either(s,i),/ +/,n.either(o,_),/ *#/)}]},c={className:"number",relevance:0,variants:[{begin:/\\b\\d[\\d_]*((\\.[\\d_]+(E[+-]?[\\d_]+)?)|(E[+-]?[\\d_]+))[RFD@!#]?/},{begin:/\\b\\d[\\d_]*((U?[SIL])|[%&])?/},{begin:/&H[\\dA-F_]+((U?[SIL])|[%&])?/},{begin:/&O[0-7_]+((U?[SIL])|[%&])?/},{begin:/&B[01_]+((U?[SIL])|[%&])?/}]},d={className:"label",begin:/^\\w+:/},m=e.COMMENT(/'''/,/$/,{contains:[{className:"doctag",begin:/<\\/?/,end:/>/}]}),p=e.COMMENT(null,/$/,{variants:[{begin:/'/},{begin:/([\\t ]|^)REM(?=\\s)/}]});return{name:"Visual Basic .NET",aliases:["vb"],case_insensitive:!0,classNameAliases:{label:"symbol"},keywords:{keyword:"addhandler alias aggregate ansi as async assembly auto binary by byref byval call case catch class compare const continue custom declare default delegate dim distinct do each equals else elseif end enum erase error event exit explicit finally for friend from function get global goto group handles if implements imports in inherits interface into iterator join key let lib loop me mid module mustinherit mustoverride mybase myclass namespace narrowing new next notinheritable notoverridable of off on operator option optional order overloads overridable overrides paramarray partial preserve private property protected public raiseevent readonly redim removehandler resume return select set shadows shared skip static step stop structure strict sub synclock take text then throw to try unicode until using when where while widening with withevents writeonly yield",built_in:"addressof and andalso await directcast gettype getxmlnamespace is isfalse isnot istrue like mod nameof new not or orelse trycast typeof xor cbool cbyte cchar cdate cdbl cdec cint clng cobj csbyte cshort csng cstr cuint culng cushort",type:"boolean byte char date decimal double integer long object sbyte short single string uinteger ulong ushort",literal:"true false nothing"},illegal:"//|\\\\{|\\\\}|endif|gosub|variant|wend|^\\\\$ ",contains:[a,r,l,c,d,m,p,{className:"meta",begin:/[\\t ]*#(const|disable|else|elseif|enable|end|externalsource|if|region)\\b/,end:/$/,keywords:{keyword:"const disable else elseif enable end externalsource if region then"},contains:[p]}]}}return Fr=t,Fr}var Br,vl;function Hu(){if(vl)return Br;vl=1;function t(e){const n=e.regex,a=["lcase","month","vartype","instrrev","ubound","setlocale","getobject","rgb","getref","string","weekdayname","rnd","dateadd","monthname","now","day","minute","isarray","cbool","round","formatcurrency","conversions","csng","timevalue","second","year","space","abs","clng","timeserial","fixs","len","asc","isempty","maths","dateserial","atn","timer","isobject","filter","weekday","datevalue","ccur","isdate","instr","datediff","formatdatetime","replace","isnull","right","sgn","array","snumeric","log","cdbl","hex","chr","lbound","msgbox","ucase","getlocale","cos","cdate","cbyte","rtrim","join","hour","oct","typename","trim","strcomp","int","createobject","loadpicture","tan","formatnumber","mid","split","cint","sin","datepart","ltrim","sqr","time","derived","eval","date","formatpercent","exp","inputbox","left","ascw","chrw","regexp","cstr","err"],r=["server","response","request","scriptengine","scriptenginebuildversion","scriptengineminorversion","scriptenginemajorversion"],i={begin:n.concat(n.either(...a),"\\\\s*\\\\("),relevance:0,keywords:{built_in:a}};return{name:"VBScript",aliases:["vbs"],case_insensitive:!0,keywords:{keyword:["call","class","const","dim","do","loop","erase","execute","executeglobal","exit","for","each","next","function","if","then","else","on","error","option","explicit","new","private","property","let","get","public","randomize","redim","rem","select","case","set","stop","sub","while","wend","with","end","to","elseif","is","or","xor","and","not","class_initialize","class_terminate","default","preserve","in","me","byval","byref","step","resume","goto"],built_in:r,literal:["true","false","null","nothing","empty"]},illegal:"//",contains:[i,e.inherit(e.QUOTE_STRING_MODE,{contains:[{begin:'""'}]}),e.COMMENT(/'/,/$/,{relevance:0}),e.C_NUMBER_MODE]}}return Br=t,Br}var Gr,yl;function Vu(){if(yl)return Gr;yl=1;function t(e){return{name:"VBScript in HTML",subLanguage:"xml",contains:[{begin:"<%",end:"%>",subLanguage:"vbscript"}]}}return Gr=t,Gr}var Yr,hl;function zu(){if(hl)return Yr;hl=1;function t(e){const n=e.regex,a={$pattern:/\\$?[\\w]+(\\$[\\w]+)*/,keyword:["accept_on","alias","always","always_comb","always_ff","always_latch","and","assert","assign","assume","automatic","before","begin","bind","bins","binsof","bit","break","buf|0","bufif0","bufif1","byte","case","casex","casez","cell","chandle","checker","class","clocking","cmos","config","const","constraint","context","continue","cover","covergroup","coverpoint","cross","deassign","default","defparam","design","disable","dist","do","edge","else","end","endcase","endchecker","endclass","endclocking","endconfig","endfunction","endgenerate","endgroup","endinterface","endmodule","endpackage","endprimitive","endprogram","endproperty","endspecify","endsequence","endtable","endtask","enum","event","eventually","expect","export","extends","extern","final","first_match","for","force","foreach","forever","fork","forkjoin","function","generate|5","genvar","global","highz0","highz1","if","iff","ifnone","ignore_bins","illegal_bins","implements","implies","import","incdir","include","initial","inout","input","inside","instance","int","integer","interconnect","interface","intersect","join","join_any","join_none","large","let","liblist","library","local","localparam","logic","longint","macromodule","matches","medium","modport","module","nand","negedge","nettype","new","nexttime","nmos","nor","noshowcancelled","not","notif0","notif1","or","output","package","packed","parameter","pmos","posedge","primitive","priority","program","property","protected","pull0","pull1","pulldown","pullup","pulsestyle_ondetect","pulsestyle_onevent","pure","rand","randc","randcase","randsequence","rcmos","real","realtime","ref","reg","reject_on","release","repeat","restrict","return","rnmos","rpmos","rtran","rtranif0","rtranif1","s_always","s_eventually","s_nexttime","s_until","s_until_with","scalared","sequence","shortint","shortreal","showcancelled","signed","small","soft","solve","specify","specparam","static","string","strong","strong0","strong1","struct","super","supply0","supply1","sync_accept_on","sync_reject_on","table","tagged","task","this","throughout","time","timeprecision","timeunit","tran","tranif0","tranif1","tri","tri0","tri1","triand","trior","trireg","type","typedef","union","unique","unique0","unsigned","until","until_with","untyped","use","uwire","var","vectored","virtual","void","wait","wait_order","wand","weak","weak0","weak1","while","wildcard","wire","with","within","wor","xnor","xor"],literal:["null"],built_in:["$finish","$stop","$exit","$fatal","$error","$warning","$info","$realtime","$time","$printtimescale","$bitstoreal","$bitstoshortreal","$itor","$signed","$cast","$bits","$stime","$timeformat","$realtobits","$shortrealtobits","$rtoi","$unsigned","$asserton","$assertkill","$assertpasson","$assertfailon","$assertnonvacuouson","$assertoff","$assertcontrol","$assertpassoff","$assertfailoff","$assertvacuousoff","$isunbounded","$sampled","$fell","$changed","$past_gclk","$fell_gclk","$changed_gclk","$rising_gclk","$steady_gclk","$coverage_control","$coverage_get","$coverage_save","$set_coverage_db_name","$rose","$stable","$past","$rose_gclk","$stable_gclk","$future_gclk","$falling_gclk","$changing_gclk","$display","$coverage_get_max","$coverage_merge","$get_coverage","$load_coverage_db","$typename","$unpacked_dimensions","$left","$low","$increment","$clog2","$ln","$log10","$exp","$sqrt","$pow","$floor","$ceil","$sin","$cos","$tan","$countbits","$onehot","$isunknown","$fatal","$warning","$dimensions","$right","$high","$size","$asin","$acos","$atan","$atan2","$hypot","$sinh","$cosh","$tanh","$asinh","$acosh","$atanh","$countones","$onehot0","$error","$info","$random","$dist_chi_square","$dist_erlang","$dist_exponential","$dist_normal","$dist_poisson","$dist_t","$dist_uniform","$q_initialize","$q_remove","$q_exam","$async$and$array","$async$nand$array","$async$or$array","$async$nor$array","$sync$and$array","$sync$nand$array","$sync$or$array","$sync$nor$array","$q_add","$q_full","$psprintf","$async$and$plane","$async$nand$plane","$async$or$plane","$async$nor$plane","$sync$and$plane","$sync$nand$plane","$sync$or$plane","$sync$nor$plane","$system","$display","$displayb","$displayh","$displayo","$strobe","$strobeb","$strobeh","$strobeo","$write","$readmemb","$readmemh","$writememh","$value$plusargs","$dumpvars","$dumpon","$dumplimit","$dumpports","$dumpportson","$dumpportslimit","$writeb","$writeh","$writeo","$monitor","$monitorb","$monitorh","$monitoro","$writememb","$dumpfile","$dumpoff","$dumpall","$dumpflush","$dumpportsoff","$dumpportsall","$dumpportsflush","$fclose","$fdisplay","$fdisplayb","$fdisplayh","$fdisplayo","$fstrobe","$fstrobeb","$fstrobeh","$fstrobeo","$swrite","$swriteb","$swriteh","$swriteo","$fscanf","$fread","$fseek","$fflush","$feof","$fopen","$fwrite","$fwriteb","$fwriteh","$fwriteo","$fmonitor","$fmonitorb","$fmonitorh","$fmonitoro","$sformat","$sformatf","$fgetc","$ungetc","$fgets","$sscanf","$rewind","$ftell","$ferror"]},r=["__FILE__","__LINE__"],i=["begin_keywords","celldefine","default_nettype","default_decay_time","default_trireg_strength","define","delay_mode_distributed","delay_mode_path","delay_mode_unit","delay_mode_zero","else","elsif","end_keywords","endcelldefine","endif","ifdef","ifndef","include","line","nounconnected_drive","pragma","resetall","timescale","unconnected_drive","undef","undefineall"];return{name:"Verilog",aliases:["v","sv","svh"],case_insensitive:!1,keywords:a,contains:[e.C_BLOCK_COMMENT_MODE,e.C_LINE_COMMENT_MODE,e.QUOTE_STRING_MODE,{scope:"number",contains:[e.BACKSLASH_ESCAPE],variants:[{begin:/\\b((\\d+'([bhodBHOD]))[0-9xzXZa-fA-F_]+)/},{begin:/\\B(('([bhodBHOD]))[0-9xzXZa-fA-F_]+)/},{begin:/\\b[0-9][0-9_]*/,relevance:0}]},{scope:"variable",variants:[{begin:"#\\\\((?!parameter).+\\\\)"},{begin:"\\\\.\\\\w+",relevance:0}]},{scope:"variable.constant",match:n.concat(/\`/,n.either(...r))},{scope:"meta",begin:n.concat(/\`/,n.either(...i)),end:/$|\\/\\/|\\/\\*/,returnEnd:!0,keywords:i}]}}return Yr=t,Yr}var qr,Dl;function Wu(){if(Dl)return qr;Dl=1;function t(e){const n="\\\\d(_|\\\\d)*",a="[eE][-+]?"+n,r=n+"(\\\\."+n+")?("+a+")?",i="\\\\w+",o="\\\\b("+(n+"#"+i+"(\\\\."+i+")?#("+a+")?")+"|"+r+")";return{name:"VHDL",case_insensitive:!0,keywords:{keyword:["abs","access","after","alias","all","and","architecture","array","assert","assume","assume_guarantee","attribute","begin","block","body","buffer","bus","case","component","configuration","constant","context","cover","disconnect","downto","default","else","elsif","end","entity","exit","fairness","file","for","force","function","generate","generic","group","guarded","if","impure","in","inertial","inout","is","label","library","linkage","literal","loop","map","mod","nand","new","next","nor","not","null","of","on","open","or","others","out","package","parameter","port","postponed","procedure","process","property","protected","pure","range","record","register","reject","release","rem","report","restrict","restrict_guarantee","return","rol","ror","select","sequence","severity","shared","signal","sla","sll","sra","srl","strong","subtype","then","to","transport","type","unaffected","units","until","use","variable","view","vmode","vprop","vunit","wait","when","while","with","xnor","xor"],built_in:["boolean","bit","character","integer","time","delay_length","natural","positive","string","bit_vector","file_open_kind","file_open_status","std_logic","std_logic_vector","unsigned","signed","boolean_vector","integer_vector","std_ulogic","std_ulogic_vector","unresolved_unsigned","u_unsigned","unresolved_signed","u_signed","real_vector","time_vector"],literal:["false","true","note","warning","error","failure","line","text","side","width"]},illegal:/\\{/,contains:[e.C_BLOCK_COMMENT_MODE,e.COMMENT("--","$"),e.QUOTE_STRING_MODE,{className:"number",begin:o,relevance:0},{className:"string",begin:"'(U|X|0|1|Z|W|L|H|-)'",contains:[e.BACKSLASH_ESCAPE]},{className:"symbol",begin:"'[A-Za-z](_?[A-Za-z0-9])*",contains:[e.BACKSLASH_ESCAPE]}]}}return qr=t,qr}var Hr,Ml;function Ku(){if(Ml)return Hr;Ml=1;function t(e){return{name:"Vim Script",keywords:{$pattern:/[!#@\\w]+/,keyword:"N|0 P|0 X|0 a|0 ab abc abo al am an|0 ar arga argd arge argdo argg argl argu as au aug aun b|0 bN ba bad bd be bel bf bl bm bn bo bp br brea breaka breakd breakl bro bufdo buffers bun bw c|0 cN cNf ca cabc caddb cad caddf cal cat cb cc ccl cd ce cex cf cfir cgetb cgete cg changes chd che checkt cl cla clo cm cmapc cme cn cnew cnf cno cnorea cnoreme co col colo com comc comp con conf cope cp cpf cq cr cs cst cu cuna cunme cw delm deb debugg delc delf dif diffg diffo diffp diffpu diffs diffthis dig di dl dell dj dli do doautoa dp dr ds dsp e|0 ea ec echoe echoh echom echon el elsei em en endfo endf endt endw ene ex exe exi exu f|0 files filet fin fina fini fir fix fo foldc foldd folddoc foldo for fu go gr grepa gu gv ha helpf helpg helpt hi hid his ia iabc if ij il im imapc ime ino inorea inoreme int is isp iu iuna iunme j|0 ju k|0 keepa kee keepj lN lNf l|0 lad laddb laddf la lan lat lb lc lch lcl lcs le lefta let lex lf lfir lgetb lgete lg lgr lgrepa lh ll lla lli lmak lm lmapc lne lnew lnf ln loadk lo loc lockv lol lope lp lpf lr ls lt lu lua luad luaf lv lvimgrepa lw m|0 ma mak map mapc marks mat me menut mes mk mks mksp mkv mkvie mod mz mzf nbc nb nbs new nm nmapc nme nn nnoreme noa no noh norea noreme norm nu nun nunme ol o|0 om omapc ome on ono onoreme opt ou ounme ow p|0 profd prof pro promptr pc ped pe perld po popu pp pre prev ps pt ptN ptf ptj ptl ptn ptp ptr pts pu pw py3 python3 py3d py3f py pyd pyf quita qa rec red redi redr redraws reg res ret retu rew ri rightb rub rubyd rubyf rund ru rv sN san sa sal sav sb sbN sba sbf sbl sbm sbn sbp sbr scrip scripte scs se setf setg setl sf sfir sh sim sig sil sl sla sm smap smapc sme sn sni sno snor snoreme sor so spelld spe spelli spellr spellu spellw sp spr sre st sta startg startr star stopi stj sts sun sunm sunme sus sv sw sy synti sync tN tabN tabc tabdo tabe tabf tabfir tabl tabm tabnew tabn tabo tabp tabr tabs tab ta tags tc tcld tclf te tf th tj tl tm tn to tp tr try ts tu u|0 undoj undol una unh unl unlo unm unme uns up ve verb vert vim vimgrepa vi viu vie vm vmapc vme vne vn vnoreme vs vu vunme windo w|0 wN wa wh wi winc winp wn wp wq wqa ws wu wv x|0 xa xmapc xm xme xn xnoreme xu xunme y|0 z|0 ~ Next Print append abbreviate abclear aboveleft all amenu anoremenu args argadd argdelete argedit argglobal arglocal argument ascii autocmd augroup aunmenu buffer bNext ball badd bdelete behave belowright bfirst blast bmodified bnext botright bprevious brewind break breakadd breakdel breaklist browse bunload bwipeout change cNext cNfile cabbrev cabclear caddbuffer caddexpr caddfile call catch cbuffer cclose center cexpr cfile cfirst cgetbuffer cgetexpr cgetfile chdir checkpath checktime clist clast close cmap cmapclear cmenu cnext cnewer cnfile cnoremap cnoreabbrev cnoremenu copy colder colorscheme command comclear compiler continue confirm copen cprevious cpfile cquit crewind cscope cstag cunmap cunabbrev cunmenu cwindow delete delmarks debug debuggreedy delcommand delfunction diffupdate diffget diffoff diffpatch diffput diffsplit digraphs display deletel djump dlist doautocmd doautoall deletep drop dsearch dsplit edit earlier echo echoerr echohl echomsg else elseif emenu endif endfor endfunction endtry endwhile enew execute exit exusage file filetype find finally finish first fixdel fold foldclose folddoopen folddoclosed foldopen function global goto grep grepadd gui gvim hardcopy help helpfind helpgrep helptags highlight hide history insert iabbrev iabclear ijump ilist imap imapclear imenu inoremap inoreabbrev inoremenu intro isearch isplit iunmap iunabbrev iunmenu join jumps keepalt keepmarks keepjumps lNext lNfile list laddexpr laddbuffer laddfile last language later lbuffer lcd lchdir lclose lcscope left leftabove lexpr lfile lfirst lgetbuffer lgetexpr lgetfile lgrep lgrepadd lhelpgrep llast llist lmake lmap lmapclear lnext lnewer lnfile lnoremap loadkeymap loadview lockmarks lockvar lolder lopen lprevious lpfile lrewind ltag lunmap luado luafile lvimgrep lvimgrepadd lwindow move mark make mapclear match menu menutranslate messages mkexrc mksession mkspell mkvimrc mkview mode mzscheme mzfile nbclose nbkey nbsart next nmap nmapclear nmenu nnoremap nnoremenu noautocmd noremap nohlsearch noreabbrev noremenu normal number nunmap nunmenu oldfiles open omap omapclear omenu only onoremap onoremenu options ounmap ounmenu ownsyntax print profdel profile promptfind promptrepl pclose pedit perl perldo pop popup ppop preserve previous psearch ptag ptNext ptfirst ptjump ptlast ptnext ptprevious ptrewind ptselect put pwd py3do py3file python pydo pyfile quit quitall qall read recover redo redir redraw redrawstatus registers resize retab return rewind right rightbelow ruby rubydo rubyfile rundo runtime rviminfo substitute sNext sandbox sargument sall saveas sbuffer sbNext sball sbfirst sblast sbmodified sbnext sbprevious sbrewind scriptnames scriptencoding scscope set setfiletype setglobal setlocal sfind sfirst shell simalt sign silent sleep slast smagic smapclear smenu snext sniff snomagic snoremap snoremenu sort source spelldump spellgood spellinfo spellrepall spellundo spellwrong split sprevious srewind stop stag startgreplace startreplace startinsert stopinsert stjump stselect sunhide sunmap sunmenu suspend sview swapname syntax syntime syncbind tNext tabNext tabclose tabedit tabfind tabfirst tablast tabmove tabnext tabonly tabprevious tabrewind tag tcl tcldo tclfile tearoff tfirst throw tjump tlast tmenu tnext topleft tprevious trewind tselect tunmenu undo undojoin undolist unabbreviate unhide unlet unlockvar unmap unmenu unsilent update vglobal version verbose vertical vimgrep vimgrepadd visual viusage view vmap vmapclear vmenu vnew vnoremap vnoremenu vsplit vunmap vunmenu write wNext wall while winsize wincmd winpos wnext wprevious wqall wsverb wundo wviminfo xit xall xmapclear xmap xmenu xnoremap xnoremenu xunmap xunmenu yank",built_in:"synIDtrans atan2 range matcharg did_filetype asin feedkeys xor argv complete_check add getwinposx getqflist getwinposy screencol clearmatches empty extend getcmdpos mzeval garbagecollect setreg ceil sqrt diff_hlID inputsecret get getfperm getpid filewritable shiftwidth max sinh isdirectory synID system inputrestore winline atan visualmode inputlist tabpagewinnr round getregtype mapcheck hasmapto histdel argidx findfile sha256 exists toupper getcmdline taglist string getmatches bufnr strftime winwidth bufexists strtrans tabpagebuflist setcmdpos remote_read printf setloclist getpos getline bufwinnr float2nr len getcmdtype diff_filler luaeval resolve libcallnr foldclosedend reverse filter has_key bufname str2float strlen setline getcharmod setbufvar index searchpos shellescape undofile foldclosed setqflist buflisted strchars str2nr virtcol floor remove undotree remote_expr winheight gettabwinvar reltime cursor tabpagenr finddir localtime acos getloclist search tanh matchend rename gettabvar strdisplaywidth type abs py3eval setwinvar tolower wildmenumode log10 spellsuggest bufloaded synconcealed nextnonblank server2client complete settabwinvar executable input wincol setmatches getftype hlID inputsave searchpair or screenrow line settabvar histadd deepcopy strpart remote_peek and eval getftime submatch screenchar winsaveview matchadd mkdir screenattr getfontname libcall reltimestr getfsize winnr invert pow getbufline byte2line soundfold repeat fnameescape tagfiles sin strwidth spellbadword trunc maparg log lispindent hostname setpos globpath remote_foreground getchar synIDattr fnamemodify cscope_connection stridx winbufnr indent min complete_add nr2char searchpairpos inputdialog values matchlist items hlexists strridx browsedir expand fmod pathshorten line2byte argc count getwinvar glob foldtextresult getreg foreground cosh matchdelete has char2nr simplify histget searchdecl iconv winrestcmd pumvisible writefile foldlevel haslocaldir keys cos matchstr foldtext histnr tan tempname getcwd byteidx getbufvar islocked escape eventhandler remote_send serverlist winrestview synstack pyeval prevnonblank readfile cindent filereadable changenr exp"},illegal:/;/,contains:[e.NUMBER_MODE,{className:"string",begin:"'",end:"'",illegal:"\\\\n"},{className:"string",begin:/"(\\\\"|\\n\\\\|[^"\\n])*"/},e.COMMENT('"',"$"),{className:"variable",begin:/[bwtglsav]:[\\w\\d_]+/},{begin:[/\\b(?:function|function!)/,/\\s+/,e.IDENT_RE],className:{1:"keyword",3:"title"},end:"$",relevance:0,contains:[{className:"params",begin:"\\\\(",end:"\\\\)"}]},{className:"symbol",begin:/<[\\w-]+>/}]}}return Hr=t,Hr}var Vr,Ll;function $u(){if(Ll)return Vr;Ll=1;function t(e){e.regex;const n=e.COMMENT(/\\(;/,/;\\)/);n.contains.push("self");const a=e.COMMENT(/;;/,/$/),r=["anyfunc","block","br","br_if","br_table","call","call_indirect","data","drop","elem","else","end","export","func","global.get","global.set","local.get","local.set","local.tee","get_global","get_local","global","if","import","local","loop","memory","memory.grow","memory.size","module","mut","nop","offset","param","result","return","select","set_global","set_local","start","table","tee_local","then","type","unreachable"],i={begin:[/(?:func|call|call_indirect)/,/\\s+/,/\\$[^\\s)]+/],className:{1:"keyword",3:"title.function"}},s={className:"variable",begin:/\\$[\\w_]+/},o={match:/(\\((?!;)|\\))+/,className:"punctuation",relevance:0},_={className:"number",relevance:0,match:/[+-]?\\b(?:\\d(?:_?\\d)*(?:\\.\\d(?:_?\\d)*)?(?:[eE][+-]?\\d(?:_?\\d)*)?|0x[\\da-fA-F](?:_?[\\da-fA-F])*(?:\\.[\\da-fA-F](?:_?[\\da-fA-D])*)?(?:[pP][+-]?\\d(?:_?\\d)*)?)\\b|\\binf\\b|\\bnan(?::0x[\\da-fA-F](?:_?[\\da-fA-D])*)?\\b/},l={match:/(i32|i64|f32|f64)(?!\\.)/,className:"type"},c={className:"keyword",match:/\\b(f32|f64|i32|i64)(?:\\.(?:abs|add|and|ceil|clz|const|convert_[su]\\/i(?:32|64)|copysign|ctz|demote\\/f64|div(?:_[su])?|eqz?|extend_[su]\\/i32|floor|ge(?:_[su])?|gt(?:_[su])?|le(?:_[su])?|load(?:(?:8|16|32)_[su])?|lt(?:_[su])?|max|min|mul|nearest|neg?|or|popcnt|promote\\/f32|reinterpret\\/[fi](?:32|64)|rem_[su]|rot[lr]|shl|shr_[su]|store(?:8|16|32)?|sqrt|sub|trunc(?:_[su]\\/f(?:32|64))?|wrap\\/i64|xor))\\b/};return{name:"WebAssembly",keywords:{$pattern:/[\\w.]+/,keyword:r},contains:[a,n,{match:[/(?:offset|align)/,/\\s*/,/=/],className:{1:"keyword",3:"operator"}},s,o,i,e.QUOTE_STRING_MODE,l,c,_]}}return Vr=t,Vr}var zr,xl;function Qu(){if(xl)return zr;xl=1;function t(e){const n=e.regex,a=/[a-zA-Z]\\w*/,r=["as","break","class","construct","continue","else","for","foreign","if","import","in","is","return","static","var","while"],i=["true","false","null"],s=["this","super"],o=["Bool","Class","Fiber","Fn","List","Map","Null","Num","Object","Range","Sequence","String","System"],_=["-","~",/\\*/,"%",/\\.\\.\\./,/\\.\\./,/\\+/,"<<",">>",">=","<=","<",">",/\\^/,/!=/,/!/,/\\bis\\b/,"==","&&","&",/\\|\\|/,/\\|/,/\\?:/,"="],l={relevance:0,match:n.concat(/\\b(?!(if|while|for|else|super)\\b)/,a,/(?=\\s*[({])/),className:"title.function"},c={match:n.concat(n.either(n.concat(/\\b(?!(if|while|for|else|super)\\b)/,a),n.either(..._)),/(?=\\s*\\([^)]+\\)\\s*\\{)/),className:"title.function",starts:{contains:[{begin:/\\(/,end:/\\)/,contains:[{relevance:0,scope:"params",match:a}]}]}},d={variants:[{match:[/class\\s+/,a,/\\s+is\\s+/,a]},{match:[/class\\s+/,a]}],scope:{2:"title.class",4:"title.class.inherited"},keywords:r},m={relevance:0,match:n.either(..._),className:"operator"},p={className:"string",begin:/"""/,end:/"""/},E={className:"property",begin:n.concat(/\\./,n.lookahead(a)),end:a,excludeBegin:!0,relevance:0},g={relevance:0,match:n.concat(/\\b_/,a),scope:"variable"},S={relevance:0,match:/\\b[A-Z]+[a-z]+([A-Z]+[a-z]+)*/,scope:"title.class",keywords:{_:o}},T=e.C_NUMBER_MODE,R={match:[a,/\\s*/,/=/,/\\s*/,/\\(/,a,/\\)\\s*\\{/],scope:{1:"title.function",3:"operator",6:"params"}},f=e.COMMENT(/\\/\\*\\*/,/\\*\\//,{contains:[{match:/@[a-z]+/,scope:"doctag"},"self"]}),A={scope:"subst",begin:/%\\(/,end:/\\)/,contains:[T,S,l,g,m]},N={scope:"string",begin:/"/,end:/"/,contains:[A,{scope:"char.escape",variants:[{match:/\\\\\\\\|\\\\["0%abefnrtv]/},{match:/\\\\x[0-9A-F]{2}/},{match:/\\\\u[0-9A-F]{4}/},{match:/\\\\U[0-9A-F]{8}/}]}]};A.contains.push(N);const C=[...r,...s,...i],M={relevance:0,match:n.concat("\\\\b(?!",C.join("|"),"\\\\b)",/[a-zA-Z_]\\w*(?:[?!]|\\b)/),className:"variable"};return{name:"Wren",keywords:{keyword:r,"variable.language":s,literal:i},contains:[{scope:"comment",variants:[{begin:[/#!?/,/[A-Za-z_]+(?=\\()/],beginScope:{},keywords:{literal:i},contains:[],end:/\\)/},{begin:[/#!?/,/[A-Za-z_]+/],beginScope:{},end:/$/}]},T,N,p,f,e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,S,d,R,c,l,m,g,E,M]}}return zr=t,zr}var Wr,wl;function Xu(){if(wl)return Wr;wl=1;function t(e){return{name:"Intel x86 Assembly",case_insensitive:!0,keywords:{$pattern:"[.%]?"+e.IDENT_RE,keyword:"lock rep repe repz repne repnz xaquire xrelease bnd nobnd aaa aad aam aas adc add and arpl bb0_reset bb1_reset bound bsf bsr bswap bt btc btr bts call cbw cdq cdqe clc cld cli clts cmc cmp cmpsb cmpsd cmpsq cmpsw cmpxchg cmpxchg486 cmpxchg8b cmpxchg16b cpuid cpu_read cpu_write cqo cwd cwde daa das dec div dmint emms enter equ f2xm1 fabs fadd faddp fbld fbstp fchs fclex fcmovb fcmovbe fcmove fcmovnb fcmovnbe fcmovne fcmovnu fcmovu fcom fcomi fcomip fcomp fcompp fcos fdecstp fdisi fdiv fdivp fdivr fdivrp femms feni ffree ffreep fiadd ficom ficomp fidiv fidivr fild fimul fincstp finit fist fistp fisttp fisub fisubr fld fld1 fldcw fldenv fldl2e fldl2t fldlg2 fldln2 fldpi fldz fmul fmulp fnclex fndisi fneni fninit fnop fnsave fnstcw fnstenv fnstsw fpatan fprem fprem1 fptan frndint frstor fsave fscale fsetpm fsin fsincos fsqrt fst fstcw fstenv fstp fstsw fsub fsubp fsubr fsubrp ftst fucom fucomi fucomip fucomp fucompp fxam fxch fxtract fyl2x fyl2xp1 hlt ibts icebp idiv imul in inc incbin insb insd insw int int01 int1 int03 int3 into invd invpcid invlpg invlpga iret iretd iretq iretw jcxz jecxz jrcxz jmp jmpe lahf lar lds lea leave les lfence lfs lgdt lgs lidt lldt lmsw loadall loadall286 lodsb lodsd lodsq lodsw loop loope loopne loopnz loopz lsl lss ltr mfence monitor mov movd movq movsb movsd movsq movsw movsx movsxd movzx mul mwait neg nop not or out outsb outsd outsw packssdw packsswb packuswb paddb paddd paddsb paddsiw paddsw paddusb paddusw paddw pand pandn pause paveb pavgusb pcmpeqb pcmpeqd pcmpeqw pcmpgtb pcmpgtd pcmpgtw pdistib pf2id pfacc pfadd pfcmpeq pfcmpge pfcmpgt pfmax pfmin pfmul pfrcp pfrcpit1 pfrcpit2 pfrsqit1 pfrsqrt pfsub pfsubr pi2fd pmachriw pmaddwd pmagw pmulhriw pmulhrwa pmulhrwc pmulhw pmullw pmvgezb pmvlzb pmvnzb pmvzb pop popa popad popaw popf popfd popfq popfw por prefetch prefetchw pslld psllq psllw psrad psraw psrld psrlq psrlw psubb psubd psubsb psubsiw psubsw psubusb psubusw psubw punpckhbw punpckhdq punpckhwd punpcklbw punpckldq punpcklwd push pusha pushad pushaw pushf pushfd pushfq pushfw pxor rcl rcr rdshr rdmsr rdpmc rdtsc rdtscp ret retf retn rol ror rdm rsdc rsldt rsm rsts sahf sal salc sar sbb scasb scasd scasq scasw sfence sgdt shl shld shr shrd sidt sldt skinit smi smint smintold smsw stc std sti stosb stosd stosq stosw str sub svdc svldt svts swapgs syscall sysenter sysexit sysret test ud0 ud1 ud2b ud2 ud2a umov verr verw fwait wbinvd wrshr wrmsr xadd xbts xchg xlatb xlat xor cmove cmovz cmovne cmovnz cmova cmovnbe cmovae cmovnb cmovb cmovnae cmovbe cmovna cmovg cmovnle cmovge cmovnl cmovl cmovnge cmovle cmovng cmovc cmovnc cmovo cmovno cmovs cmovns cmovp cmovpe cmovnp cmovpo je jz jne jnz ja jnbe jae jnb jb jnae jbe jna jg jnle jge jnl jl jnge jle jng jc jnc jo jno js jns jpo jnp jpe jp sete setz setne setnz seta setnbe setae setnb setnc setb setnae setcset setbe setna setg setnle setge setnl setl setnge setle setng sets setns seto setno setpe setp setpo setnp addps addss andnps andps cmpeqps cmpeqss cmpleps cmpless cmpltps cmpltss cmpneqps cmpneqss cmpnleps cmpnless cmpnltps cmpnltss cmpordps cmpordss cmpunordps cmpunordss cmpps cmpss comiss cvtpi2ps cvtps2pi cvtsi2ss cvtss2si cvttps2pi cvttss2si divps divss ldmxcsr maxps maxss minps minss movaps movhps movlhps movlps movhlps movmskps movntps movss movups mulps mulss orps rcpps rcpss rsqrtps rsqrtss shufps sqrtps sqrtss stmxcsr subps subss ucomiss unpckhps unpcklps xorps fxrstor fxrstor64 fxsave fxsave64 xgetbv xsetbv xsave xsave64 xsaveopt xsaveopt64 xrstor xrstor64 prefetchnta prefetcht0 prefetcht1 prefetcht2 maskmovq movntq pavgb pavgw pextrw pinsrw pmaxsw pmaxub pminsw pminub pmovmskb pmulhuw psadbw pshufw pf2iw pfnacc pfpnacc pi2fw pswapd maskmovdqu clflush movntdq movnti movntpd movdqa movdqu movdq2q movq2dq paddq pmuludq pshufd pshufhw pshuflw pslldq psrldq psubq punpckhqdq punpcklqdq addpd addsd andnpd andpd cmpeqpd cmpeqsd cmplepd cmplesd cmpltpd cmpltsd cmpneqpd cmpneqsd cmpnlepd cmpnlesd cmpnltpd cmpnltsd cmpordpd cmpordsd cmpunordpd cmpunordsd cmppd comisd cvtdq2pd cvtdq2ps cvtpd2dq cvtpd2pi cvtpd2ps cvtpi2pd cvtps2dq cvtps2pd cvtsd2si cvtsd2ss cvtsi2sd cvtss2sd cvttpd2pi cvttpd2dq cvttps2dq cvttsd2si divpd divsd maxpd maxsd minpd minsd movapd movhpd movlpd movmskpd movupd mulpd mulsd orpd shufpd sqrtpd sqrtsd subpd subsd ucomisd unpckhpd unpcklpd xorpd addsubpd addsubps haddpd haddps hsubpd hsubps lddqu movddup movshdup movsldup clgi stgi vmcall vmclear vmfunc vmlaunch vmload vmmcall vmptrld vmptrst vmread vmresume vmrun vmsave vmwrite vmxoff vmxon invept invvpid pabsb pabsw pabsd palignr phaddw phaddd phaddsw phsubw phsubd phsubsw pmaddubsw pmulhrsw pshufb psignb psignw psignd extrq insertq movntsd movntss lzcnt blendpd blendps blendvpd blendvps dppd dpps extractps insertps movntdqa mpsadbw packusdw pblendvb pblendw pcmpeqq pextrb pextrd pextrq phminposuw pinsrb pinsrd pinsrq pmaxsb pmaxsd pmaxud pmaxuw pminsb pminsd pminud pminuw pmovsxbw pmovsxbd pmovsxbq pmovsxwd pmovsxwq pmovsxdq pmovzxbw pmovzxbd pmovzxbq pmovzxwd pmovzxwq pmovzxdq pmuldq pmulld ptest roundpd roundps roundsd roundss crc32 pcmpestri pcmpestrm pcmpistri pcmpistrm pcmpgtq popcnt getsec pfrcpv pfrsqrtv movbe aesenc aesenclast aesdec aesdeclast aesimc aeskeygenassist vaesenc vaesenclast vaesdec vaesdeclast vaesimc vaeskeygenassist vaddpd vaddps vaddsd vaddss vaddsubpd vaddsubps vandpd vandps vandnpd vandnps vblendpd vblendps vblendvpd vblendvps vbroadcastss vbroadcastsd vbroadcastf128 vcmpeq_ospd vcmpeqpd vcmplt_ospd vcmpltpd vcmple_ospd vcmplepd vcmpunord_qpd vcmpunordpd vcmpneq_uqpd vcmpneqpd vcmpnlt_uspd vcmpnltpd vcmpnle_uspd vcmpnlepd vcmpord_qpd vcmpordpd vcmpeq_uqpd vcmpnge_uspd vcmpngepd vcmpngt_uspd vcmpngtpd vcmpfalse_oqpd vcmpfalsepd vcmpneq_oqpd vcmpge_ospd vcmpgepd vcmpgt_ospd vcmpgtpd vcmptrue_uqpd vcmptruepd vcmplt_oqpd vcmple_oqpd vcmpunord_spd vcmpneq_uspd vcmpnlt_uqpd vcmpnle_uqpd vcmpord_spd vcmpeq_uspd vcmpnge_uqpd vcmpngt_uqpd vcmpfalse_ospd vcmpneq_ospd vcmpge_oqpd vcmpgt_oqpd vcmptrue_uspd vcmppd vcmpeq_osps vcmpeqps vcmplt_osps vcmpltps vcmple_osps vcmpleps vcmpunord_qps vcmpunordps vcmpneq_uqps vcmpneqps vcmpnlt_usps vcmpnltps vcmpnle_usps vcmpnleps vcmpord_qps vcmpordps vcmpeq_uqps vcmpnge_usps vcmpngeps vcmpngt_usps vcmpngtps vcmpfalse_oqps vcmpfalseps vcmpneq_oqps vcmpge_osps vcmpgeps vcmpgt_osps vcmpgtps vcmptrue_uqps vcmptrueps vcmplt_oqps vcmple_oqps vcmpunord_sps vcmpneq_usps vcmpnlt_uqps vcmpnle_uqps vcmpord_sps vcmpeq_usps vcmpnge_uqps vcmpngt_uqps vcmpfalse_osps vcmpneq_osps vcmpge_oqps vcmpgt_oqps vcmptrue_usps vcmpps vcmpeq_ossd vcmpeqsd vcmplt_ossd vcmpltsd vcmple_ossd vcmplesd vcmpunord_qsd vcmpunordsd vcmpneq_uqsd vcmpneqsd vcmpnlt_ussd vcmpnltsd vcmpnle_ussd vcmpnlesd vcmpord_qsd vcmpordsd vcmpeq_uqsd vcmpnge_ussd vcmpngesd vcmpngt_ussd vcmpngtsd vcmpfalse_oqsd vcmpfalsesd vcmpneq_oqsd vcmpge_ossd vcmpgesd vcmpgt_ossd vcmpgtsd vcmptrue_uqsd vcmptruesd vcmplt_oqsd vcmple_oqsd vcmpunord_ssd vcmpneq_ussd vcmpnlt_uqsd vcmpnle_uqsd vcmpord_ssd vcmpeq_ussd vcmpnge_uqsd vcmpngt_uqsd vcmpfalse_ossd vcmpneq_ossd vcmpge_oqsd vcmpgt_oqsd vcmptrue_ussd vcmpsd vcmpeq_osss vcmpeqss vcmplt_osss vcmpltss vcmple_osss vcmpless vcmpunord_qss vcmpunordss vcmpneq_uqss vcmpneqss vcmpnlt_usss vcmpnltss vcmpnle_usss vcmpnless vcmpord_qss vcmpordss vcmpeq_uqss vcmpnge_usss vcmpngess vcmpngt_usss vcmpngtss vcmpfalse_oqss vcmpfalsess vcmpneq_oqss vcmpge_osss vcmpgess vcmpgt_osss vcmpgtss vcmptrue_uqss vcmptruess vcmplt_oqss vcmple_oqss vcmpunord_sss vcmpneq_usss vcmpnlt_uqss vcmpnle_uqss vcmpord_sss vcmpeq_usss vcmpnge_uqss vcmpngt_uqss vcmpfalse_osss vcmpneq_osss vcmpge_oqss vcmpgt_oqss vcmptrue_usss vcmpss vcomisd vcomiss vcvtdq2pd vcvtdq2ps vcvtpd2dq vcvtpd2ps vcvtps2dq vcvtps2pd vcvtsd2si vcvtsd2ss vcvtsi2sd vcvtsi2ss vcvtss2sd vcvtss2si vcvttpd2dq vcvttps2dq vcvttsd2si vcvttss2si vdivpd vdivps vdivsd vdivss vdppd vdpps vextractf128 vextractps vhaddpd vhaddps vhsubpd vhsubps vinsertf128 vinsertps vlddqu vldqqu vldmxcsr vmaskmovdqu vmaskmovps vmaskmovpd vmaxpd vmaxps vmaxsd vmaxss vminpd vminps vminsd vminss vmovapd vmovaps vmovd vmovq vmovddup vmovdqa vmovqqa vmovdqu vmovqqu vmovhlps vmovhpd vmovhps vmovlhps vmovlpd vmovlps vmovmskpd vmovmskps vmovntdq vmovntqq vmovntdqa vmovntpd vmovntps vmovsd vmovshdup vmovsldup vmovss vmovupd vmovups vmpsadbw vmulpd vmulps vmulsd vmulss vorpd vorps vpabsb vpabsw vpabsd vpacksswb vpackssdw vpackuswb vpackusdw vpaddb vpaddw vpaddd vpaddq vpaddsb vpaddsw vpaddusb vpaddusw vpalignr vpand vpandn vpavgb vpavgw vpblendvb vpblendw vpcmpestri vpcmpestrm vpcmpistri vpcmpistrm vpcmpeqb vpcmpeqw vpcmpeqd vpcmpeqq vpcmpgtb vpcmpgtw vpcmpgtd vpcmpgtq vpermilpd vpermilps vperm2f128 vpextrb vpextrw vpextrd vpextrq vphaddw vphaddd vphaddsw vphminposuw vphsubw vphsubd vphsubsw vpinsrb vpinsrw vpinsrd vpinsrq vpmaddwd vpmaddubsw vpmaxsb vpmaxsw vpmaxsd vpmaxub vpmaxuw vpmaxud vpminsb vpminsw vpminsd vpminub vpminuw vpminud vpmovmskb vpmovsxbw vpmovsxbd vpmovsxbq vpmovsxwd vpmovsxwq vpmovsxdq vpmovzxbw vpmovzxbd vpmovzxbq vpmovzxwd vpmovzxwq vpmovzxdq vpmulhuw vpmulhrsw vpmulhw vpmullw vpmulld vpmuludq vpmuldq vpor vpsadbw vpshufb vpshufd vpshufhw vpshuflw vpsignb vpsignw vpsignd vpslldq vpsrldq vpsllw vpslld vpsllq vpsraw vpsrad vpsrlw vpsrld vpsrlq vptest vpsubb vpsubw vpsubd vpsubq vpsubsb vpsubsw vpsubusb vpsubusw vpunpckhbw vpunpckhwd vpunpckhdq vpunpckhqdq vpunpcklbw vpunpcklwd vpunpckldq vpunpcklqdq vpxor vrcpps vrcpss vrsqrtps vrsqrtss vroundpd vroundps vroundsd vroundss vshufpd vshufps vsqrtpd vsqrtps vsqrtsd vsqrtss vstmxcsr vsubpd vsubps vsubsd vsubss vtestps vtestpd vucomisd vucomiss vunpckhpd vunpckhps vunpcklpd vunpcklps vxorpd vxorps vzeroall vzeroupper pclmullqlqdq pclmulhqlqdq pclmullqhqdq pclmulhqhqdq pclmulqdq vpclmullqlqdq vpclmulhqlqdq vpclmullqhqdq vpclmulhqhqdq vpclmulqdq vfmadd132ps vfmadd132pd vfmadd312ps vfmadd312pd vfmadd213ps vfmadd213pd vfmadd123ps vfmadd123pd vfmadd231ps vfmadd231pd vfmadd321ps vfmadd321pd vfmaddsub132ps vfmaddsub132pd vfmaddsub312ps vfmaddsub312pd vfmaddsub213ps vfmaddsub213pd vfmaddsub123ps vfmaddsub123pd vfmaddsub231ps vfmaddsub231pd vfmaddsub321ps vfmaddsub321pd vfmsub132ps vfmsub132pd vfmsub312ps vfmsub312pd vfmsub213ps vfmsub213pd vfmsub123ps vfmsub123pd vfmsub231ps vfmsub231pd vfmsub321ps vfmsub321pd vfmsubadd132ps vfmsubadd132pd vfmsubadd312ps vfmsubadd312pd vfmsubadd213ps vfmsubadd213pd vfmsubadd123ps vfmsubadd123pd vfmsubadd231ps vfmsubadd231pd vfmsubadd321ps vfmsubadd321pd vfnmadd132ps vfnmadd132pd vfnmadd312ps vfnmadd312pd vfnmadd213ps vfnmadd213pd vfnmadd123ps vfnmadd123pd vfnmadd231ps vfnmadd231pd vfnmadd321ps vfnmadd321pd vfnmsub132ps vfnmsub132pd vfnmsub312ps vfnmsub312pd vfnmsub213ps vfnmsub213pd vfnmsub123ps vfnmsub123pd vfnmsub231ps vfnmsub231pd vfnmsub321ps vfnmsub321pd vfmadd132ss vfmadd132sd vfmadd312ss vfmadd312sd vfmadd213ss vfmadd213sd vfmadd123ss vfmadd123sd vfmadd231ss vfmadd231sd vfmadd321ss vfmadd321sd vfmsub132ss vfmsub132sd vfmsub312ss vfmsub312sd vfmsub213ss vfmsub213sd vfmsub123ss vfmsub123sd vfmsub231ss vfmsub231sd vfmsub321ss vfmsub321sd vfnmadd132ss vfnmadd132sd vfnmadd312ss vfnmadd312sd vfnmadd213ss vfnmadd213sd vfnmadd123ss vfnmadd123sd vfnmadd231ss vfnmadd231sd vfnmadd321ss vfnmadd321sd vfnmsub132ss vfnmsub132sd vfnmsub312ss vfnmsub312sd vfnmsub213ss vfnmsub213sd vfnmsub123ss vfnmsub123sd vfnmsub231ss vfnmsub231sd vfnmsub321ss vfnmsub321sd rdfsbase rdgsbase rdrand wrfsbase wrgsbase vcvtph2ps vcvtps2ph adcx adox rdseed clac stac xstore xcryptecb xcryptcbc xcryptctr xcryptcfb xcryptofb montmul xsha1 xsha256 llwpcb slwpcb lwpval lwpins vfmaddpd vfmaddps vfmaddsd vfmaddss vfmaddsubpd vfmaddsubps vfmsubaddpd vfmsubaddps vfmsubpd vfmsubps vfmsubsd vfmsubss vfnmaddpd vfnmaddps vfnmaddsd vfnmaddss vfnmsubpd vfnmsubps vfnmsubsd vfnmsubss vfrczpd vfrczps vfrczsd vfrczss vpcmov vpcomb vpcomd vpcomq vpcomub vpcomud vpcomuq vpcomuw vpcomw vphaddbd vphaddbq vphaddbw vphadddq vphaddubd vphaddubq vphaddubw vphaddudq vphadduwd vphadduwq vphaddwd vphaddwq vphsubbw vphsubdq vphsubwd vpmacsdd vpmacsdqh vpmacsdql vpmacssdd vpmacssdqh vpmacssdql vpmacsswd vpmacssww vpmacswd vpmacsww vpmadcsswd vpmadcswd vpperm vprotb vprotd vprotq vprotw vpshab vpshad vpshaq vpshaw vpshlb vpshld vpshlq vpshlw vbroadcasti128 vpblendd vpbroadcastb vpbroadcastw vpbroadcastd vpbroadcastq vpermd vpermpd vpermps vpermq vperm2i128 vextracti128 vinserti128 vpmaskmovd vpmaskmovq vpsllvd vpsllvq vpsravd vpsrlvd vpsrlvq vgatherdpd vgatherqpd vgatherdps vgatherqps vpgatherdd vpgatherqd vpgatherdq vpgatherqq xabort xbegin xend xtest andn bextr blci blcic blsi blsic blcfill blsfill blcmsk blsmsk blsr blcs bzhi mulx pdep pext rorx sarx shlx shrx tzcnt tzmsk t1mskc valignd valignq vblendmpd vblendmps vbroadcastf32x4 vbroadcastf64x4 vbroadcasti32x4 vbroadcasti64x4 vcompresspd vcompressps vcvtpd2udq vcvtps2udq vcvtsd2usi vcvtss2usi vcvttpd2udq vcvttps2udq vcvttsd2usi vcvttss2usi vcvtudq2pd vcvtudq2ps vcvtusi2sd vcvtusi2ss vexpandpd vexpandps vextractf32x4 vextractf64x4 vextracti32x4 vextracti64x4 vfixupimmpd vfixupimmps vfixupimmsd vfixupimmss vgetexppd vgetexpps vgetexpsd vgetexpss vgetmantpd vgetmantps vgetmantsd vgetmantss vinsertf32x4 vinsertf64x4 vinserti32x4 vinserti64x4 vmovdqa32 vmovdqa64 vmovdqu32 vmovdqu64 vpabsq vpandd vpandnd vpandnq vpandq vpblendmd vpblendmq vpcmpltd vpcmpled vpcmpneqd vpcmpnltd vpcmpnled vpcmpd vpcmpltq vpcmpleq vpcmpneqq vpcmpnltq vpcmpnleq vpcmpq vpcmpequd vpcmpltud vpcmpleud vpcmpnequd vpcmpnltud vpcmpnleud vpcmpud vpcmpequq vpcmpltuq vpcmpleuq vpcmpnequq vpcmpnltuq vpcmpnleuq vpcmpuq vpcompressd vpcompressq vpermi2d vpermi2pd vpermi2ps vpermi2q vpermt2d vpermt2pd vpermt2ps vpermt2q vpexpandd vpexpandq vpmaxsq vpmaxuq vpminsq vpminuq vpmovdb vpmovdw vpmovqb vpmovqd vpmovqw vpmovsdb vpmovsdw vpmovsqb vpmovsqd vpmovsqw vpmovusdb vpmovusdw vpmovusqb vpmovusqd vpmovusqw vpord vporq vprold vprolq vprolvd vprolvq vprord vprorq vprorvd vprorvq vpscatterdd vpscatterdq vpscatterqd vpscatterqq vpsraq vpsravq vpternlogd vpternlogq vptestmd vptestmq vptestnmd vptestnmq vpxord vpxorq vrcp14pd vrcp14ps vrcp14sd vrcp14ss vrndscalepd vrndscaleps vrndscalesd vrndscaless vrsqrt14pd vrsqrt14ps vrsqrt14sd vrsqrt14ss vscalefpd vscalefps vscalefsd vscalefss vscatterdpd vscatterdps vscatterqpd vscatterqps vshuff32x4 vshuff64x2 vshufi32x4 vshufi64x2 kandnw kandw kmovw knotw kortestw korw kshiftlw kshiftrw kunpckbw kxnorw kxorw vpbroadcastmb2q vpbroadcastmw2d vpconflictd vpconflictq vplzcntd vplzcntq vexp2pd vexp2ps vrcp28pd vrcp28ps vrcp28sd vrcp28ss vrsqrt28pd vrsqrt28ps vrsqrt28sd vrsqrt28ss vgatherpf0dpd vgatherpf0dps vgatherpf0qpd vgatherpf0qps vgatherpf1dpd vgatherpf1dps vgatherpf1qpd vgatherpf1qps vscatterpf0dpd vscatterpf0dps vscatterpf0qpd vscatterpf0qps vscatterpf1dpd vscatterpf1dps vscatterpf1qpd vscatterpf1qps prefetchwt1 bndmk bndcl bndcu bndcn bndmov bndldx bndstx sha1rnds4 sha1nexte sha1msg1 sha1msg2 sha256rnds2 sha256msg1 sha256msg2 hint_nop0 hint_nop1 hint_nop2 hint_nop3 hint_nop4 hint_nop5 hint_nop6 hint_nop7 hint_nop8 hint_nop9 hint_nop10 hint_nop11 hint_nop12 hint_nop13 hint_nop14 hint_nop15 hint_nop16 hint_nop17 hint_nop18 hint_nop19 hint_nop20 hint_nop21 hint_nop22 hint_nop23 hint_nop24 hint_nop25 hint_nop26 hint_nop27 hint_nop28 hint_nop29 hint_nop30 hint_nop31 hint_nop32 hint_nop33 hint_nop34 hint_nop35 hint_nop36 hint_nop37 hint_nop38 hint_nop39 hint_nop40 hint_nop41 hint_nop42 hint_nop43 hint_nop44 hint_nop45 hint_nop46 hint_nop47 hint_nop48 hint_nop49 hint_nop50 hint_nop51 hint_nop52 hint_nop53 hint_nop54 hint_nop55 hint_nop56 hint_nop57 hint_nop58 hint_nop59 hint_nop60 hint_nop61 hint_nop62 hint_nop63",built_in:"ip eip rip al ah bl bh cl ch dl dh sil dil bpl spl r8b r9b r10b r11b r12b r13b r14b r15b ax bx cx dx si di bp sp r8w r9w r10w r11w r12w r13w r14w r15w eax ebx ecx edx esi edi ebp esp eip r8d r9d r10d r11d r12d r13d r14d r15d rax rbx rcx rdx rsi rdi rbp rsp r8 r9 r10 r11 r12 r13 r14 r15 cs ds es fs gs ss st st0 st1 st2 st3 st4 st5 st6 st7 mm0 mm1 mm2 mm3 mm4 mm5 mm6 mm7 xmm0  xmm1  xmm2  xmm3  xmm4  xmm5  xmm6  xmm7  xmm8  xmm9 xmm10  xmm11 xmm12 xmm13 xmm14 xmm15 xmm16 xmm17 xmm18 xmm19 xmm20 xmm21 xmm22 xmm23 xmm24 xmm25 xmm26 xmm27 xmm28 xmm29 xmm30 xmm31 ymm0  ymm1  ymm2  ymm3  ymm4  ymm5  ymm6  ymm7  ymm8  ymm9 ymm10  ymm11 ymm12 ymm13 ymm14 ymm15 ymm16 ymm17 ymm18 ymm19 ymm20 ymm21 ymm22 ymm23 ymm24 ymm25 ymm26 ymm27 ymm28 ymm29 ymm30 ymm31 zmm0  zmm1  zmm2  zmm3  zmm4  zmm5  zmm6  zmm7  zmm8  zmm9 zmm10  zmm11 zmm12 zmm13 zmm14 zmm15 zmm16 zmm17 zmm18 zmm19 zmm20 zmm21 zmm22 zmm23 zmm24 zmm25 zmm26 zmm27 zmm28 zmm29 zmm30 zmm31 k0 k1 k2 k3 k4 k5 k6 k7 bnd0 bnd1 bnd2 bnd3 cr0 cr1 cr2 cr3 cr4 cr8 dr0 dr1 dr2 dr3 dr8 tr3 tr4 tr5 tr6 tr7 r0 r1 r2 r3 r4 r5 r6 r7 r0b r1b r2b r3b r4b r5b r6b r7b r0w r1w r2w r3w r4w r5w r6w r7w r0d r1d r2d r3d r4d r5d r6d r7d r0h r1h r2h r3h r0l r1l r2l r3l r4l r5l r6l r7l r8l r9l r10l r11l r12l r13l r14l r15l db dw dd dq dt ddq do dy dz resb resw resd resq rest resdq reso resy resz incbin equ times byte word dword qword nosplit rel abs seg wrt strict near far a32 ptr",meta:"%define %xdefine %+ %undef %defstr %deftok %assign %strcat %strlen %substr %rotate %elif %else %endif %if %ifmacro %ifctx %ifidn %ifidni %ifid %ifnum %ifstr %iftoken %ifempty %ifenv %error %warning %fatal %rep %endrep %include %push %pop %repl %pathsearch %depend %use %arg %stacksize %local %line %comment %endcomment .nolist __FILE__ __LINE__ __SECT__  __BITS__ __OUTPUT_FORMAT__ __DATE__ __TIME__ __DATE_NUM__ __TIME_NUM__ __UTC_DATE__ __UTC_TIME__ __UTC_DATE_NUM__ __UTC_TIME_NUM__  __PASS__ struc endstruc istruc at iend align alignb sectalign daz nodaz up down zero default option assume public bits use16 use32 use64 default section segment absolute extern global common cpu float __utf16__ __utf16le__ __utf16be__ __utf32__ __utf32le__ __utf32be__ __float8__ __float16__ __float32__ __float64__ __float80m__ __float80e__ __float128l__ __float128h__ __Infinity__ __QNaN__ __SNaN__ Inf NaN QNaN SNaN float8 float16 float32 float64 float80m float80e float128l float128h __FLOAT_DAZ__ __FLOAT_ROUND__ __FLOAT__"},contains:[e.COMMENT(";","$",{relevance:0}),{className:"number",variants:[{begin:"\\\\b(?:([0-9][0-9_]*)?\\\\.[0-9_]*(?:[eE][+-]?[0-9_]+)?|(0[Xx])?[0-9][0-9_]*(\\\\.[0-9_]*)?(?:[pP](?:[+-]?[0-9_]+)?)?)\\\\b",relevance:0},{begin:"\\\\$[0-9][0-9A-Fa-f]*",relevance:0},{begin:"\\\\b(?:[0-9A-Fa-f][0-9A-Fa-f_]*[Hh]|[0-9][0-9_]*[DdTt]?|[0-7][0-7_]*[QqOo]|[0-1][0-1_]*[BbYy])\\\\b"},{begin:"\\\\b(?:0[Xx][0-9A-Fa-f_]+|0[DdTt][0-9_]+|0[QqOo][0-7_]+|0[BbYy][0-1_]+)\\\\b"}]},e.QUOTE_STRING_MODE,{className:"string",variants:[{begin:"'",end:"[^\\\\\\\\]'"},{begin:"\`",end:"[^\\\\\\\\]\`"}],relevance:0},{className:"symbol",variants:[{begin:"^\\\\s*[A-Za-z._?][A-Za-z0-9_$#@~.?]*(:|\\\\s+label)"},{begin:"^\\\\s*%%[A-Za-z0-9_$#@~.?]*:"}],relevance:0},{className:"subst",begin:"%[0-9]+",relevance:0},{className:"subst",begin:"%!S+",relevance:0},{className:"meta",begin:/^\\s*\\.[\\w_-]+/}]}}return Wr=t,Wr}var Kr,Pl;function Zu(){if(Pl)return Kr;Pl=1;function t(e){const n=["if","then","else","do","while","until","for","loop","import","with","is","as","where","when","by","data","constant","integer","real","text","name","boolean","symbol","infix","prefix","postfix","block","tree"],a=["in","mod","rem","and","or","xor","not","abs","sign","floor","ceil","sqrt","sin","cos","tan","asin","acos","atan","exp","expm1","log","log2","log10","log1p","pi","at","text_length","text_range","text_find","text_replace","contains","page","slide","basic_slide","title_slide","title","subtitle","fade_in","fade_out","fade_at","clear_color","color","line_color","line_width","texture_wrap","texture_transform","texture","scale_?x","scale_?y","scale_?z?","translate_?x","translate_?y","translate_?z?","rotate_?x","rotate_?y","rotate_?z?","rectangle","circle","ellipse","sphere","path","line_to","move_to","quad_to","curve_to","theme","background","contents","locally","time","mouse_?x","mouse_?y","mouse_buttons"],r=["ObjectLoader","Animate","MovieCredits","Slides","Filters","Shading","Materials","LensFlare","Mapping","VLCAudioVideo","StereoDecoder","PointCloud","NetworkAccess","RemoteControl","RegExp","ChromaKey","Snowfall","NodeJS","Speech","Charts"],s={$pattern:/[a-zA-Z][a-zA-Z0-9_?]*/,keyword:n,literal:["true","false","nil"],built_in:a.concat(r)},o={className:"string",begin:'"',end:'"',illegal:"\\\\n"},_={className:"string",begin:"'",end:"'",illegal:"\\\\n"},l={className:"string",begin:"<<",end:">>"},c={className:"number",begin:"[0-9]+#[0-9A-Z_]+(\\\\.[0-9-A-Z_]+)?#?([Ee][+-]?[0-9]+)?"},d={beginKeywords:"import",end:"$",keywords:s,contains:[o]},m={className:"function",begin:/[a-z][^\\n]*->/,returnBegin:!0,end:/->/,contains:[e.inherit(e.TITLE_MODE,{starts:{endsWithParent:!0,keywords:s}})]};return{name:"XL",aliases:["tao"],keywords:s,contains:[e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,o,_,l,m,d,c,e.NUMBER_MODE]}}return Kr=t,Kr}var $r,kl;function Ju(){if(kl)return $r;kl=1;function t(e){return{name:"XQuery",aliases:["xpath","xq","xqm"],case_insensitive:!1,illegal:/(proc)|(abstract)|(extends)|(until)|(#)/,keywords:{$pattern:/[a-zA-Z$][a-zA-Z0-9_:-]*/,keyword:["module","schema","namespace","boundary-space","preserve","no-preserve","strip","default","collation","base-uri","ordering","context","decimal-format","decimal-separator","copy-namespaces","empty-sequence","except","exponent-separator","external","grouping-separator","inherit","no-inherit","lax","minus-sign","per-mille","percent","schema-attribute","schema-element","strict","unordered","zero-digit","declare","import","option","function","validate","variable","for","at","in","let","where","order","group","by","return","if","then","else","tumbling","sliding","window","start","when","only","end","previous","next","stable","ascending","descending","allowing","empty","greatest","least","some","every","satisfies","switch","case","typeswitch","try","catch","and","or","to","union","intersect","instance","of","treat","as","castable","cast","map","array","delete","insert","into","replace","value","rename","copy","modify","update"],type:["item","document-node","node","attribute","document","element","comment","namespace","namespace-node","processing-instruction","text","construction","xs:anyAtomicType","xs:untypedAtomic","xs:duration","xs:time","xs:decimal","xs:float","xs:double","xs:gYearMonth","xs:gYear","xs:gMonthDay","xs:gMonth","xs:gDay","xs:boolean","xs:base64Binary","xs:hexBinary","xs:anyURI","xs:QName","xs:NOTATION","xs:dateTime","xs:dateTimeStamp","xs:date","xs:string","xs:normalizedString","xs:token","xs:language","xs:NMTOKEN","xs:Name","xs:NCName","xs:ID","xs:IDREF","xs:ENTITY","xs:integer","xs:nonPositiveInteger","xs:negativeInteger","xs:long","xs:int","xs:short","xs:byte","xs:nonNegativeInteger","xs:unisignedLong","xs:unsignedInt","xs:unsignedShort","xs:unsignedByte","xs:positiveInteger","xs:yearMonthDuration","xs:dayTimeDuration"],literal:["eq","ne","lt","le","gt","ge","is","self::","child::","descendant::","descendant-or-self::","attribute::","following::","following-sibling::","parent::","ancestor::","ancestor-or-self::","preceding::","preceding-sibling::","NaN"]},contains:[{className:"variable",begin:/[$][\\w\\-:]+/},{className:"built_in",variants:[{begin:/\\barray:/,end:/(?:append|filter|flatten|fold-(?:left|right)|for-each(?:-pair)?|get|head|insert-before|join|put|remove|reverse|size|sort|subarray|tail)\\b/},{begin:/\\bmap:/,end:/(?:contains|entry|find|for-each|get|keys|merge|put|remove|size)\\b/},{begin:/\\bmath:/,end:/(?:a(?:cos|sin|tan[2]?)|cos|exp(?:10)?|log(?:10)?|pi|pow|sin|sqrt|tan)\\b/},{begin:/\\bop:/,end:/\\(/,excludeEnd:!0},{begin:/\\bfn:/,end:/\\(/,excludeEnd:!0},{begin:/[^</$:'"-]\\b(?:abs|accumulator-(?:after|before)|adjust-(?:date(?:Time)?|time)-to-timezone|analyze-string|apply|available-(?:environment-variables|system-properties)|avg|base-uri|boolean|ceiling|codepoints?-(?:equal|to-string)|collation-key|collection|compare|concat|contains(?:-token)?|copy-of|count|current(?:-)?(?:date(?:Time)?|time|group(?:ing-key)?|output-uri|merge-(?:group|key))?data|dateTime|days?-from-(?:date(?:Time)?|duration)|deep-equal|default-(?:collation|language)|distinct-values|document(?:-uri)?|doc(?:-available)?|element-(?:available|with-id)|empty|encode-for-uri|ends-with|environment-variable|error|escape-html-uri|exactly-one|exists|false|filter|floor|fold-(?:left|right)|for-each(?:-pair)?|format-(?:date(?:Time)?|time|integer|number)|function-(?:arity|available|lookup|name)|generate-id|has-children|head|hours-from-(?:dateTime|duration|time)|id(?:ref)?|implicit-timezone|in-scope-prefixes|index-of|innermost|insert-before|iri-to-uri|json-(?:doc|to-xml)|key|lang|last|load-xquery-module|local-name(?:-from-QName)?|(?:lower|upper)-case|matches|max|minutes-from-(?:dateTime|duration|time)|min|months?-from-(?:date(?:Time)?|duration)|name(?:space-uri-?(?:for-prefix|from-QName)?)?|nilled|node-name|normalize-(?:space|unicode)|not|number|one-or-more|outermost|parse-(?:ietf-date|json)|path|position|(?:prefix-from-)?QName|random-number-generator|regex-group|remove|replace|resolve-(?:QName|uri)|reverse|root|round(?:-half-to-even)?|seconds-from-(?:dateTime|duration|time)|snapshot|sort|starts-with|static-base-uri|stream-available|string-?(?:join|length|to-codepoints)?|subsequence|substring-?(?:after|before)?|sum|system-property|tail|timezone-from-(?:date(?:Time)?|time)|tokenize|trace|trans(?:form|late)|true|type-available|unordered|unparsed-(?:entity|text)?-?(?:public-id|uri|available|lines)?|uri-collection|xml-to-json|years?-from-(?:date(?:Time)?|duration)|zero-or-one)\\b/},{begin:/\\blocal:/,end:/\\(/,excludeEnd:!0},{begin:/\\bzip:/,end:/(?:zip-file|(?:xml|html|text|binary)-entry| (?:update-)?entries)\\b/},{begin:/\\b(?:util|db|functx|app|xdmp|xmldb):/,end:/\\(/,excludeEnd:!0}]},{className:"string",variants:[{begin:/"/,end:/"/,contains:[{begin:/""/,relevance:0}]},{begin:/'/,end:/'/,contains:[{begin:/''/,relevance:0}]}]},{className:"number",begin:/(\\b0[0-7_]+)|(\\b0x[0-9a-fA-F_]+)|(\\b[1-9][0-9_]*(\\.[0-9_]+)?)|[0_]\\b/,relevance:0},{className:"comment",begin:/\\(:/,end:/:\\)/,relevance:10,contains:[{className:"doctag",begin:/@\\w+/}]},{className:"meta",begin:/%[\\w\\-:]+/},{className:"title",begin:/\\bxquery version "[13]\\.[01]"\\s?(?:encoding ".+")?/,end:/;/},{beginKeywords:"element attribute comment document processing-instruction",end:/\\{/,excludeEnd:!0},{begin:/<([\\w._:-]+)(\\s+\\S*=('|").*('|"))?>/,end:/(\\/[\\w._:-]+>)/,subLanguage:"xml",contains:[{begin:/\\{/,end:/\\}/,subLanguage:"xquery"},"self"]}]}}return $r=t,$r}var Qr,Ul;function ju(){if(Ul)return Qr;Ul=1;function t(e){const n={className:"string",contains:[e.BACKSLASH_ESCAPE],variants:[e.inherit(e.APOS_STRING_MODE,{illegal:null}),e.inherit(e.QUOTE_STRING_MODE,{illegal:null})]},a=e.UNDERSCORE_TITLE_MODE,r={variants:[e.BINARY_NUMBER_MODE,e.C_NUMBER_MODE]},i="namespace class interface use extends function return abstract final public protected private static deprecated throw try catch Exception echo empty isset instanceof unset let var new const self require if else elseif switch case default do while loop for continue break likely unlikely __LINE__ __FILE__ __DIR__ __FUNCTION__ __CLASS__ __TRAIT__ __METHOD__ __NAMESPACE__ array boolean float double integer object resource string char long unsigned bool int uint ulong uchar true false null undefined";return{name:"Zephir",aliases:["zep"],keywords:i,contains:[e.C_LINE_COMMENT_MODE,e.COMMENT(/\\/\\*/,/\\*\\//,{contains:[{className:"doctag",begin:/@[A-Za-z]+/}]}),{className:"string",begin:/<<<['"]?\\w+['"]?$/,end:/^\\w+;/,contains:[e.BACKSLASH_ESCAPE]},{begin:/(::|->)+[a-zA-Z_\\x7f-\\xff][a-zA-Z0-9_\\x7f-\\xff]*/},{className:"function",beginKeywords:"function fn",end:/[;{]/,excludeEnd:!0,illegal:/\\$|\\[|%/,contains:[a,{className:"params",begin:/\\(/,end:/\\)/,keywords:i,contains:["self",e.C_BLOCK_COMMENT_MODE,n,r]}]},{className:"class",beginKeywords:"class interface",end:/\\{/,excludeEnd:!0,illegal:/[:($"]/,contains:[{beginKeywords:"extends implements"},a]},{beginKeywords:"namespace",end:/;/,illegal:/[.']/,contains:[a]},{beginKeywords:"use",end:/;/,contains:[a]},{begin:/=>/},n,r]}}return Qr=t,Qr}var Xr,Fl;function em(){if(Fl)return Xr;Fl=1;var t=Nc();return t.registerLanguage("1c",Oc()),t.registerLanguage("abnf",Ic()),t.registerLanguage("accesslog",Ac()),t.registerLanguage("actionscript",vc()),t.registerLanguage("ada",yc()),t.registerLanguage("angelscript",hc()),t.registerLanguage("apache",Dc()),t.registerLanguage("applescript",Mc()),t.registerLanguage("arcade",Lc()),t.registerLanguage("arduino",xc()),t.registerLanguage("armasm",wc()),t.registerLanguage("xml",Pc()),t.registerLanguage("asciidoc",kc()),t.registerLanguage("aspectj",Uc()),t.registerLanguage("autohotkey",Fc()),t.registerLanguage("autoit",Bc()),t.registerLanguage("avrasm",Gc()),t.registerLanguage("awk",Yc()),t.registerLanguage("axapta",qc()),t.registerLanguage("bash",Hc()),t.registerLanguage("basic",Vc()),t.registerLanguage("bnf",zc()),t.registerLanguage("brainfuck",Wc()),t.registerLanguage("c",Kc()),t.registerLanguage("cal",$c()),t.registerLanguage("capnproto",Qc()),t.registerLanguage("ceylon",Xc()),t.registerLanguage("clean",Zc()),t.registerLanguage("clojure",Jc()),t.registerLanguage("clojure-repl",jc()),t.registerLanguage("cmake",e_()),t.registerLanguage("coffeescript",t_()),t.registerLanguage("coq",n_()),t.registerLanguage("cos",a_()),t.registerLanguage("cpp",r_()),t.registerLanguage("crmsh",i_()),t.registerLanguage("crystal",o_()),t.registerLanguage("csharp",s_()),t.registerLanguage("csp",l_()),t.registerLanguage("css",c_()),t.registerLanguage("d",__()),t.registerLanguage("markdown",d_()),t.registerLanguage("dart",u_()),t.registerLanguage("delphi",m_()),t.registerLanguage("diff",p_()),t.registerLanguage("django",E_()),t.registerLanguage("dns",g_()),t.registerLanguage("dockerfile",S_()),t.registerLanguage("dos",T_()),t.registerLanguage("dsconfig",b_()),t.registerLanguage("dts",R_()),t.registerLanguage("dust",f_()),t.registerLanguage("ebnf",C_()),t.registerLanguage("elixir",N_()),t.registerLanguage("elm",O_()),t.registerLanguage("ruby",I_()),t.registerLanguage("erb",A_()),t.registerLanguage("erlang-repl",v_()),t.registerLanguage("erlang",y_()),t.registerLanguage("excel",h_()),t.registerLanguage("fix",D_()),t.registerLanguage("flix",M_()),t.registerLanguage("fortran",L_()),t.registerLanguage("fsharp",x_()),t.registerLanguage("gams",w_()),t.registerLanguage("gauss",P_()),t.registerLanguage("gcode",k_()),t.registerLanguage("gherkin",U_()),t.registerLanguage("glsl",F_()),t.registerLanguage("gml",B_()),t.registerLanguage("go",G_()),t.registerLanguage("golo",Y_()),t.registerLanguage("gradle",q_()),t.registerLanguage("graphql",H_()),t.registerLanguage("groovy",V_()),t.registerLanguage("haml",z_()),t.registerLanguage("handlebars",W_()),t.registerLanguage("haskell",K_()),t.registerLanguage("haxe",$_()),t.registerLanguage("hsp",Q_()),t.registerLanguage("http",X_()),t.registerLanguage("hy",Z_()),t.registerLanguage("inform7",J_()),t.registerLanguage("ini",j_()),t.registerLanguage("irpf90",ed()),t.registerLanguage("isbl",td()),t.registerLanguage("java",nd()),t.registerLanguage("javascript",ad()),t.registerLanguage("jboss-cli",rd()),t.registerLanguage("json",id()),t.registerLanguage("julia",od()),t.registerLanguage("julia-repl",sd()),t.registerLanguage("kotlin",ld()),t.registerLanguage("lasso",cd()),t.registerLanguage("latex",_d()),t.registerLanguage("ldif",dd()),t.registerLanguage("leaf",ud()),t.registerLanguage("less",md()),t.registerLanguage("lisp",pd()),t.registerLanguage("livecodeserver",Ed()),t.registerLanguage("livescript",gd()),t.registerLanguage("llvm",Sd()),t.registerLanguage("lsl",Td()),t.registerLanguage("lua",bd()),t.registerLanguage("makefile",Rd()),t.registerLanguage("mathematica",fd()),t.registerLanguage("matlab",Cd()),t.registerLanguage("maxima",Nd()),t.registerLanguage("mel",Od()),t.registerLanguage("mercury",Id()),t.registerLanguage("mipsasm",Ad()),t.registerLanguage("mizar",vd()),t.registerLanguage("perl",yd()),t.registerLanguage("mojolicious",hd()),t.registerLanguage("monkey",Dd()),t.registerLanguage("moonscript",Md()),t.registerLanguage("n1ql",Ld()),t.registerLanguage("nestedtext",xd()),t.registerLanguage("nginx",wd()),t.registerLanguage("nim",Pd()),t.registerLanguage("nix",kd()),t.registerLanguage("node-repl",Ud()),t.registerLanguage("nsis",Fd()),t.registerLanguage("objectivec",Bd()),t.registerLanguage("ocaml",Gd()),t.registerLanguage("openscad",Yd()),t.registerLanguage("oxygene",qd()),t.registerLanguage("parser3",Hd()),t.registerLanguage("pf",Vd()),t.registerLanguage("pgsql",zd()),t.registerLanguage("php",Wd()),t.registerLanguage("php-template",Kd()),t.registerLanguage("plaintext",$d()),t.registerLanguage("pony",Qd()),t.registerLanguage("powershell",Xd()),t.registerLanguage("processing",Zd()),t.registerLanguage("profile",Jd()),t.registerLanguage("prolog",jd()),t.registerLanguage("properties",eu()),t.registerLanguage("protobuf",tu()),t.registerLanguage("puppet",nu()),t.registerLanguage("purebasic",au()),t.registerLanguage("python",ru()),t.registerLanguage("python-repl",iu()),t.registerLanguage("q",ou()),t.registerLanguage("qml",su()),t.registerLanguage("r",lu()),t.registerLanguage("reasonml",cu()),t.registerLanguage("rib",_u()),t.registerLanguage("roboconf",du()),t.registerLanguage("routeros",uu()),t.registerLanguage("rsl",mu()),t.registerLanguage("ruleslanguage",pu()),t.registerLanguage("rust",Eu()),t.registerLanguage("sas",gu()),t.registerLanguage("scala",Su()),t.registerLanguage("scheme",Tu()),t.registerLanguage("scilab",bu()),t.registerLanguage("scss",Ru()),t.registerLanguage("shell",fu()),t.registerLanguage("smali",Cu()),t.registerLanguage("smalltalk",Nu()),t.registerLanguage("sml",Ou()),t.registerLanguage("sqf",Iu()),t.registerLanguage("sql",Au()),t.registerLanguage("stan",vu()),t.registerLanguage("stata",yu()),t.registerLanguage("step21",hu()),t.registerLanguage("stylus",Du()),t.registerLanguage("subunit",Mu()),t.registerLanguage("swift",Lu()),t.registerLanguage("taggerscript",xu()),t.registerLanguage("yaml",wu()),t.registerLanguage("tap",Pu()),t.registerLanguage("tcl",ku()),t.registerLanguage("thrift",Uu()),t.registerLanguage("tp",Fu()),t.registerLanguage("twig",Bu()),t.registerLanguage("typescript",Gu()),t.registerLanguage("vala",Yu()),t.registerLanguage("vbnet",qu()),t.registerLanguage("vbscript",Hu()),t.registerLanguage("vbscript-html",Vu()),t.registerLanguage("verilog",zu()),t.registerLanguage("vhdl",Wu()),t.registerLanguage("vim",Ku()),t.registerLanguage("wasm",$u()),t.registerLanguage("wren",Qu()),t.registerLanguage("x86asm",Xu()),t.registerLanguage("xl",Zu()),t.registerLanguage("xquery",Ju()),t.registerLanguage("zephir",ju()),t.HighlightJS=t,t.default=t,Xr=t,Xr}var tm=em(),Bl=Cc(tm);const nm=t=>({IMPORTANT:{scope:"meta",begin:"!important"},BLOCK_COMMENT:t.C_BLOCK_COMMENT_MODE,HEXCOLOR:{scope:"number",begin:/#(([0-9a-fA-F]{3,4})|(([0-9a-fA-F]{2}){3,4}))\\b/},FUNCTION_DISPATCH:{className:"built_in",begin:/[\\w-]+(?=\\()/},ATTRIBUTE_SELECTOR_MODE:{scope:"selector-attr",begin:/\\[/,end:/\\]/,illegal:"$",contains:[t.APOS_STRING_MODE,t.QUOTE_STRING_MODE]},CSS_NUMBER_MODE:{scope:"number",begin:t.NUMBER_RE+"(%|em|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc|px|deg|grad|rad|turn|s|ms|Hz|kHz|dpi|dpcm|dppx)?",relevance:0},CSS_VARIABLE:{className:"attr",begin:/--[A-Za-z_][A-Za-z0-9_-]*/}}),am=["a","abbr","address","article","aside","audio","b","blockquote","body","button","canvas","caption","cite","code","dd","del","details","dfn","div","dl","dt","em","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","header","hgroup","html","i","iframe","img","input","ins","kbd","label","legend","li","main","mark","menu","nav","object","ol","optgroup","option","p","picture","q","quote","samp","section","select","source","span","strong","summary","sup","table","tbody","td","textarea","tfoot","th","thead","time","tr","ul","var","video"],rm=["defs","g","marker","mask","pattern","svg","switch","symbol","feBlend","feColorMatrix","feComponentTransfer","feComposite","feConvolveMatrix","feDiffuseLighting","feDisplacementMap","feFlood","feGaussianBlur","feImage","feMerge","feMorphology","feOffset","feSpecularLighting","feTile","feTurbulence","linearGradient","radialGradient","stop","circle","ellipse","image","line","path","polygon","polyline","rect","text","use","textPath","tspan","foreignObject","clipPath"],im=[...am,...rm],om=["any-hover","any-pointer","aspect-ratio","color","color-gamut","color-index","device-aspect-ratio","device-height","device-width","display-mode","forced-colors","grid","height","hover","inverted-colors","monochrome","orientation","overflow-block","overflow-inline","pointer","prefers-color-scheme","prefers-contrast","prefers-reduced-motion","prefers-reduced-transparency","resolution","scan","scripting","update","width","min-width","max-width","min-height","max-height"].sort().reverse(),sm=["active","any-link","blank","checked","current","default","defined","dir","disabled","drop","empty","enabled","first","first-child","first-of-type","fullscreen","future","focus","focus-visible","focus-within","has","host","host-context","hover","indeterminate","in-range","invalid","is","lang","last-child","last-of-type","left","link","local-link","not","nth-child","nth-col","nth-last-child","nth-last-col","nth-last-of-type","nth-of-type","only-child","only-of-type","optional","out-of-range","past","placeholder-shown","read-only","read-write","required","right","root","scope","target","target-within","user-invalid","valid","visited","where"].sort().reverse(),lm=["after","backdrop","before","cue","cue-region","first-letter","first-line","grammar-error","marker","part","placeholder","selection","slotted","spelling-error"].sort().reverse(),cm=["accent-color","align-content","align-items","align-self","alignment-baseline","all","anchor-name","animation","animation-composition","animation-delay","animation-direction","animation-duration","animation-fill-mode","animation-iteration-count","animation-name","animation-play-state","animation-range","animation-range-end","animation-range-start","animation-timeline","animation-timing-function","appearance","aspect-ratio","backdrop-filter","backface-visibility","background","background-attachment","background-blend-mode","background-clip","background-color","background-image","background-origin","background-position","background-position-x","background-position-y","background-repeat","background-size","baseline-shift","block-size","border","border-block","border-block-color","border-block-end","border-block-end-color","border-block-end-style","border-block-end-width","border-block-start","border-block-start-color","border-block-start-style","border-block-start-width","border-block-style","border-block-width","border-bottom","border-bottom-color","border-bottom-left-radius","border-bottom-right-radius","border-bottom-style","border-bottom-width","border-collapse","border-color","border-end-end-radius","border-end-start-radius","border-image","border-image-outset","border-image-repeat","border-image-slice","border-image-source","border-image-width","border-inline","border-inline-color","border-inline-end","border-inline-end-color","border-inline-end-style","border-inline-end-width","border-inline-start","border-inline-start-color","border-inline-start-style","border-inline-start-width","border-inline-style","border-inline-width","border-left","border-left-color","border-left-style","border-left-width","border-radius","border-right","border-right-color","border-right-style","border-right-width","border-spacing","border-start-end-radius","border-start-start-radius","border-style","border-top","border-top-color","border-top-left-radius","border-top-right-radius","border-top-style","border-top-width","border-width","bottom","box-align","box-decoration-break","box-direction","box-flex","box-flex-group","box-lines","box-ordinal-group","box-orient","box-pack","box-shadow","box-sizing","break-after","break-before","break-inside","caption-side","caret-color","clear","clip","clip-path","clip-rule","color","color-interpolation","color-interpolation-filters","color-profile","color-rendering","color-scheme","column-count","column-fill","column-gap","column-rule","column-rule-color","column-rule-style","column-rule-width","column-span","column-width","columns","contain","contain-intrinsic-block-size","contain-intrinsic-height","contain-intrinsic-inline-size","contain-intrinsic-size","contain-intrinsic-width","container","container-name","container-type","content","content-visibility","counter-increment","counter-reset","counter-set","cue","cue-after","cue-before","cursor","cx","cy","direction","display","dominant-baseline","empty-cells","enable-background","field-sizing","fill","fill-opacity","fill-rule","filter","flex","flex-basis","flex-direction","flex-flow","flex-grow","flex-shrink","flex-wrap","float","flood-color","flood-opacity","flow","font","font-display","font-family","font-feature-settings","font-kerning","font-language-override","font-optical-sizing","font-palette","font-size","font-size-adjust","font-smooth","font-smoothing","font-stretch","font-style","font-synthesis","font-synthesis-position","font-synthesis-small-caps","font-synthesis-style","font-synthesis-weight","font-variant","font-variant-alternates","font-variant-caps","font-variant-east-asian","font-variant-emoji","font-variant-ligatures","font-variant-numeric","font-variant-position","font-variation-settings","font-weight","forced-color-adjust","gap","glyph-orientation-horizontal","glyph-orientation-vertical","grid","grid-area","grid-auto-columns","grid-auto-flow","grid-auto-rows","grid-column","grid-column-end","grid-column-start","grid-gap","grid-row","grid-row-end","grid-row-start","grid-template","grid-template-areas","grid-template-columns","grid-template-rows","hanging-punctuation","height","hyphenate-character","hyphenate-limit-chars","hyphens","icon","image-orientation","image-rendering","image-resolution","ime-mode","initial-letter","initial-letter-align","inline-size","inset","inset-area","inset-block","inset-block-end","inset-block-start","inset-inline","inset-inline-end","inset-inline-start","isolation","justify-content","justify-items","justify-self","kerning","left","letter-spacing","lighting-color","line-break","line-height","line-height-step","list-style","list-style-image","list-style-position","list-style-type","margin","margin-block","margin-block-end","margin-block-start","margin-bottom","margin-inline","margin-inline-end","margin-inline-start","margin-left","margin-right","margin-top","margin-trim","marker","marker-end","marker-mid","marker-start","marks","mask","mask-border","mask-border-mode","mask-border-outset","mask-border-repeat","mask-border-slice","mask-border-source","mask-border-width","mask-clip","mask-composite","mask-image","mask-mode","mask-origin","mask-position","mask-repeat","mask-size","mask-type","masonry-auto-flow","math-depth","math-shift","math-style","max-block-size","max-height","max-inline-size","max-width","min-block-size","min-height","min-inline-size","min-width","mix-blend-mode","nav-down","nav-index","nav-left","nav-right","nav-up","none","normal","object-fit","object-position","offset","offset-anchor","offset-distance","offset-path","offset-position","offset-rotate","opacity","order","orphans","outline","outline-color","outline-offset","outline-style","outline-width","overflow","overflow-anchor","overflow-block","overflow-clip-margin","overflow-inline","overflow-wrap","overflow-x","overflow-y","overlay","overscroll-behavior","overscroll-behavior-block","overscroll-behavior-inline","overscroll-behavior-x","overscroll-behavior-y","padding","padding-block","padding-block-end","padding-block-start","padding-bottom","padding-inline","padding-inline-end","padding-inline-start","padding-left","padding-right","padding-top","page","page-break-after","page-break-before","page-break-inside","paint-order","pause","pause-after","pause-before","perspective","perspective-origin","place-content","place-items","place-self","pointer-events","position","position-anchor","position-visibility","print-color-adjust","quotes","r","resize","rest","rest-after","rest-before","right","rotate","row-gap","ruby-align","ruby-position","scale","scroll-behavior","scroll-margin","scroll-margin-block","scroll-margin-block-end","scroll-margin-block-start","scroll-margin-bottom","scroll-margin-inline","scroll-margin-inline-end","scroll-margin-inline-start","scroll-margin-left","scroll-margin-right","scroll-margin-top","scroll-padding","scroll-padding-block","scroll-padding-block-end","scroll-padding-block-start","scroll-padding-bottom","scroll-padding-inline","scroll-padding-inline-end","scroll-padding-inline-start","scroll-padding-left","scroll-padding-right","scroll-padding-top","scroll-snap-align","scroll-snap-stop","scroll-snap-type","scroll-timeline","scroll-timeline-axis","scroll-timeline-name","scrollbar-color","scrollbar-gutter","scrollbar-width","shape-image-threshold","shape-margin","shape-outside","shape-rendering","speak","speak-as","src","stop-color","stop-opacity","stroke","stroke-dasharray","stroke-dashoffset","stroke-linecap","stroke-linejoin","stroke-miterlimit","stroke-opacity","stroke-width","tab-size","table-layout","text-align","text-align-all","text-align-last","text-anchor","text-combine-upright","text-decoration","text-decoration-color","text-decoration-line","text-decoration-skip","text-decoration-skip-ink","text-decoration-style","text-decoration-thickness","text-emphasis","text-emphasis-color","text-emphasis-position","text-emphasis-style","text-indent","text-justify","text-orientation","text-overflow","text-rendering","text-shadow","text-size-adjust","text-transform","text-underline-offset","text-underline-position","text-wrap","text-wrap-mode","text-wrap-style","timeline-scope","top","touch-action","transform","transform-box","transform-origin","transform-style","transition","transition-behavior","transition-delay","transition-duration","transition-property","transition-timing-function","translate","unicode-bidi","user-modify","user-select","vector-effect","vertical-align","view-timeline","view-timeline-axis","view-timeline-inset","view-timeline-name","view-transition-name","visibility","voice-balance","voice-duration","voice-family","voice-pitch","voice-range","voice-rate","voice-stress","voice-volume","white-space","white-space-collapse","widows","width","will-change","word-break","word-spacing","word-wrap","writing-mode","x","y","z-index","zoom"].sort().reverse();function Zr(t){const e=t.regex,n=nm(t),a={begin:/-(webkit|moz|ms|o)-(?=[a-z])/},r="and or not only",i=/@-?\\w[\\w]*(-\\w+)*/,s="[a-zA-Z-][a-zA-Z0-9_-]*",o=[t.APOS_STRING_MODE,t.QUOTE_STRING_MODE];return{name:"CSS",case_insensitive:!0,illegal:/[=|'\\$]/,keywords:{keyframePosition:"from to"},classNameAliases:{keyframePosition:"selector-tag"},contains:[n.BLOCK_COMMENT,a,n.CSS_NUMBER_MODE,{className:"selector-id",begin:/#[A-Za-z0-9_-]+/,relevance:0},{className:"selector-class",begin:"\\\\."+s,relevance:0},n.ATTRIBUTE_SELECTOR_MODE,{className:"selector-pseudo",variants:[{begin:":("+sm.join("|")+")"},{begin:":(:)?("+lm.join("|")+")"}]},n.CSS_VARIABLE,{className:"attribute",begin:"\\\\b("+cm.join("|")+")\\\\b"},{begin:/:/,end:/[;}{]/,contains:[n.BLOCK_COMMENT,n.HEXCOLOR,n.IMPORTANT,n.CSS_NUMBER_MODE,...o,{begin:/(url|data-uri)\\(/,end:/\\)/,relevance:0,keywords:{built_in:"url data-uri"},contains:[...o,{className:"string",begin:/[^)]/,endsWithParent:!0,excludeEnd:!0}]},n.FUNCTION_DISPATCH]},{begin:e.lookahead(/@/),end:"[{;]",relevance:0,illegal:/:/,contains:[{className:"keyword",begin:i},{begin:/\\s/,endsWithParent:!0,excludeEnd:!0,relevance:0,keywords:{$pattern:/[a-z-]+/,keyword:r,attribute:om.join(" ")},contains:[{begin:/[a-z-]+(?=:)/,className:"attribute"},...o,n.CSS_NUMBER_MODE]}]},{className:"selector-tag",begin:"\\\\b("+im.join("|")+")\\\\b"}]}}function _m(t){const e={begin:/\\|[A-Za-z]+:?/,keywords:{name:"truncatewords removetags linebreaksbr yesno get_digit timesince random striptags filesizeformat escape linebreaks length_is ljust rjust cut urlize fix_ampersands title floatformat capfirst pprint divisibleby add make_list unordered_list urlencode timeuntil urlizetrunc wordcount stringformat linenumbers slice date dictsort dictsortreversed default_if_none pluralize lower join center default truncatewords_html upper length phone2numeric wordwrap time addslashes slugify first escapejs force_escape iriencode last safe safeseq truncatechars localize unlocalize localtime utc timezone"},contains:[t.QUOTE_STRING_MODE,t.APOS_STRING_MODE]};return{name:"Django",aliases:["jinja"],case_insensitive:!0,subLanguage:"xml",contains:[t.COMMENT(/\\{%\\s*comment\\s*%\\}/,/\\{%\\s*endcomment\\s*%\\}/),t.COMMENT(/\\{#/,/#\\}/),{className:"template-tag",begin:/\\{%/,end:/%\\}/,contains:[{className:"name",begin:/\\w+/,keywords:{name:"comment endcomment load templatetag ifchanged endifchanged if endif firstof for endfor ifnotequal endifnotequal widthratio extends include spaceless endspaceless regroup ifequal endifequal ssi now with cycle url filter endfilter debug block endblock else autoescape endautoescape csrf_token empty elif endwith static trans blocktrans endblocktrans get_static_prefix get_media_prefix plural get_current_language language get_available_languages get_current_language_bidi get_language_info get_language_info_list localize endlocalize localtime endlocaltime timezone endtimezone get_current_timezone verbatim"},starts:{endsWithParent:!0,keywords:"in by as",contains:[e],relevance:0}}]},{className:"template-variable",begin:/\\{\\{/,end:/\\}\\}/,contains:[e]}]}}const Gl="[A-Za-z$_][0-9A-Za-z$_]*",dm=["as","in","of","if","for","while","finally","var","new","function","do","return","void","else","break","catch","instanceof","with","throw","case","default","try","switch","continue","typeof","delete","let","yield","const","class","debugger","async","await","static","import","from","export","extends","using"],um=["true","false","null","undefined","NaN","Infinity"],Yl=["Object","Function","Boolean","Symbol","Math","Date","Number","BigInt","String","RegExp","Array","Float32Array","Float64Array","Int8Array","Uint8Array","Uint8ClampedArray","Int16Array","Int32Array","Uint16Array","Uint32Array","BigInt64Array","BigUint64Array","Set","Map","WeakSet","WeakMap","ArrayBuffer","SharedArrayBuffer","Atomics","DataView","JSON","Promise","Generator","GeneratorFunction","AsyncFunction","Reflect","Proxy","Intl","WebAssembly"],ql=["Error","EvalError","InternalError","RangeError","ReferenceError","SyntaxError","TypeError","URIError"],Hl=["setInterval","setTimeout","clearInterval","clearTimeout","require","exports","eval","isFinite","isNaN","parseFloat","parseInt","decodeURI","decodeURIComponent","encodeURI","encodeURIComponent","escape","unescape"],mm=["arguments","this","super","console","window","document","localStorage","sessionStorage","module","global"],pm=[].concat(Hl,Yl,ql);function Jr(t){const e=t.regex,n=(q,{after:ie})=>{const _e="</"+q[0].slice(1);return q.input.indexOf(_e,ie)!==-1},a=Gl,r={begin:"<>",end:"</>"},i=/<[A-Za-z0-9\\\\._:-]+\\s*\\/>/,s={begin:/<[A-Za-z0-9\\\\._:-]+/,end:/\\/[A-Za-z0-9\\\\._:-]+>|\\/>/,isTrulyOpeningTag:(q,ie)=>{const _e=q[0].length+q.index,de=q.input[_e];if(de==="<"||de===","){ie.ignoreMatch();return}de===">"&&(n(q,{after:_e})||ie.ignoreMatch());let Se;const ge=q.input.substring(_e);if(Se=ge.match(/^\\s*=/)){ie.ignoreMatch();return}if((Se=ge.match(/^\\s+extends\\s+/))&&Se.index===0){ie.ignoreMatch();return}}},o={$pattern:Gl,keyword:dm,literal:um,built_in:pm,"variable.language":mm},_="[0-9](_?[0-9])*",l=\`\\\\.(\${_})\`,c="0|[1-9](_?[0-9])*|0[0-7]*[89][0-9]*",d={className:"number",variants:[{begin:\`(\\\\b(\${c})((\${l})|\\\\.)?|(\${l}))[eE][+-]?(\${_})\\\\b\`},{begin:\`\\\\b(\${c})\\\\b((\${l})\\\\b|\\\\.)?|(\${l})\\\\b\`},{begin:"\\\\b(0|[1-9](_?[0-9])*)n\\\\b"},{begin:"\\\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*n?\\\\b"},{begin:"\\\\b0[bB][0-1](_?[0-1])*n?\\\\b"},{begin:"\\\\b0[oO][0-7](_?[0-7])*n?\\\\b"},{begin:"\\\\b0[0-7]+n?\\\\b"}],relevance:0},m={className:"subst",begin:"\\\\$\\\\{",end:"\\\\}",keywords:o,contains:[]},p={begin:".?html\`",end:"",starts:{end:"\`",returnEnd:!1,contains:[t.BACKSLASH_ESCAPE,m],subLanguage:"xml"}},E={begin:".?css\`",end:"",starts:{end:"\`",returnEnd:!1,contains:[t.BACKSLASH_ESCAPE,m],subLanguage:"css"}},g={begin:".?gql\`",end:"",starts:{end:"\`",returnEnd:!1,contains:[t.BACKSLASH_ESCAPE,m],subLanguage:"graphql"}},S={className:"string",begin:"\`",end:"\`",contains:[t.BACKSLASH_ESCAPE,m]},R={className:"comment",variants:[t.COMMENT(/\\/\\*\\*(?!\\/)/,"\\\\*/",{relevance:0,contains:[{begin:"(?=@[A-Za-z]+)",relevance:0,contains:[{className:"doctag",begin:"@[A-Za-z]+"},{className:"type",begin:"\\\\{",end:"\\\\}",excludeEnd:!0,excludeBegin:!0,relevance:0},{className:"variable",begin:a+"(?=\\\\s*(-)|$)",endsParent:!0,relevance:0},{begin:/(?=[^\\n])\\s/,relevance:0}]}]}),t.C_BLOCK_COMMENT_MODE,t.C_LINE_COMMENT_MODE]},f=[t.APOS_STRING_MODE,t.QUOTE_STRING_MODE,p,E,g,S,{match:/\\$\\d+/},d];m.contains=f.concat({begin:/\\{/,end:/\\}/,keywords:o,contains:["self"].concat(f)});const A=[].concat(R,m.contains),N=A.concat([{begin:/(\\s*)\\(/,end:/\\)/,keywords:o,contains:["self"].concat(A)}]),C={className:"params",begin:/(\\s*)\\(/,end:/\\)/,excludeBegin:!0,excludeEnd:!0,keywords:o,contains:N},M={variants:[{match:[/class/,/\\s+/,a,/\\s+/,/extends/,/\\s+/,e.concat(a,"(",e.concat(/\\./,a),")*")],scope:{1:"keyword",3:"title.class",5:"keyword",7:"title.class.inherited"}},{match:[/class/,/\\s+/,a],scope:{1:"keyword",3:"title.class"}}]},y={relevance:0,match:e.either(/\\bJSON/,/\\b[A-Z][a-z]+([A-Z][a-z]*|\\d)*/,/\\b[A-Z]{2,}([A-Z][a-z]+|\\d)+([A-Z][a-z]*)*/,/\\b[A-Z]{2,}[a-z]+([A-Z][a-z]+|\\d)*([A-Z][a-z]*)*/),className:"title.class",keywords:{_:[...Yl,...ql]}},x={label:"use_strict",className:"meta",relevance:10,begin:/^\\s*['"]use (strict|asm)['"]/},G={variants:[{match:[/function/,/\\s+/,a,/(?=\\s*\\()/]},{match:[/function/,/\\s*(?=\\()/]}],className:{1:"keyword",3:"title.function"},label:"func.def",contains:[C],illegal:/%/},w={relevance:0,match:/\\b[A-Z][A-Z_0-9]+\\b/,className:"variable.constant"};function H(q){return e.concat("(?!",q.join("|"),")")}const j={match:e.concat(/\\b/,H([...Hl,"super","import"].map(q=>\`\${q}\\\\s*\\\\(\`)),a,e.lookahead(/\\s*\\(/)),className:"title.function",relevance:0},ee={begin:e.concat(/\\./,e.lookahead(e.concat(a,/(?![0-9A-Za-z$_(])/))),end:a,excludeBegin:!0,keywords:"prototype",className:"property",relevance:0},V={match:[/get|set/,/\\s+/,a,/(?=\\()/],className:{1:"keyword",3:"title.function"},contains:[{begin:/\\(\\)/},C]},z="(\\\\([^()]*(\\\\([^()]*(\\\\([^()]*\\\\)[^()]*)*\\\\)[^()]*)*\\\\)|"+t.UNDERSCORE_IDENT_RE+")\\\\s*=>",X={match:[/const|var|let/,/\\s+/,a,/\\s*/,/=\\s*/,/(async\\s*)?/,e.lookahead(z)],keywords:"async",className:{1:"keyword",3:"title.function"},contains:[C]};return{name:"JavaScript",aliases:["js","jsx","mjs","cjs"],keywords:o,exports:{PARAMS_CONTAINS:N,CLASS_REFERENCE:y},illegal:/#(?![$_A-z])/,contains:[t.SHEBANG({label:"shebang",binary:"node",relevance:5}),x,t.APOS_STRING_MODE,t.QUOTE_STRING_MODE,p,E,g,S,R,{match:/\\$\\d+/},d,y,{scope:"attr",match:a+e.lookahead(":"),relevance:0},X,{begin:"("+t.RE_STARTERS_RE+"|\\\\b(case|return|throw)\\\\b)\\\\s*",keywords:"return throw case",relevance:0,contains:[R,t.REGEXP_MODE,{className:"function",begin:z,returnBegin:!0,end:"\\\\s*=>",contains:[{className:"params",variants:[{begin:t.UNDERSCORE_IDENT_RE,relevance:0},{className:null,begin:/\\(\\s*\\)/,skip:!0},{begin:/(\\s*)\\(/,end:/\\)/,excludeBegin:!0,excludeEnd:!0,keywords:o,contains:N}]}]},{begin:/,/,relevance:0},{match:/\\s+/,relevance:0},{variants:[{begin:r.begin,end:r.end},{match:i},{begin:s.begin,"on:begin":s.isTrulyOpeningTag,end:s.end}],subLanguage:"xml",contains:[{begin:s.begin,end:s.end,skip:!0,contains:["self"]}]}]},G,{beginKeywords:"while if switch catch for"},{begin:"\\\\b(?!function)"+t.UNDERSCORE_IDENT_RE+"\\\\([^()]*(\\\\([^()]*(\\\\([^()]*\\\\)[^()]*)*\\\\)[^()]*)*\\\\)\\\\s*\\\\{",returnBegin:!0,label:"func.def",contains:[C,t.inherit(t.TITLE_MODE,{begin:a,className:"title.function"})]},{match:/\\.\\.\\./,relevance:0},ee,{match:"\\\\$"+a,relevance:0},{match:[/\\bconstructor(?=\\s*\\()/],className:{1:"title.function"},contains:[C]},j,w,M,V,{match:/\\$[(.]/}]}}function Em(t){const e=t.regex,n={begin:/<\\/?[A-Za-z_]/,end:">",subLanguage:"xml",relevance:0},a={begin:"^[-\\\\*]{3,}",end:"$"},r={className:"code",variants:[{begin:"(\`{3,})[^\`](.|\\\\n)*?\\\\1\`*[ ]*"},{begin:"(~{3,})[^~](.|\\\\n)*?\\\\1~*[ ]*"},{begin:"\`\`\`",end:"\`\`\`+[ ]*$"},{begin:"~~~",end:"~~~+[ ]*$"},{begin:"\`.+?\`"},{begin:"(?=^( {4}|\\\\t))",contains:[{begin:"^( {4}|\\\\t)",end:"(\\\\n)$"}],relevance:0}]},i={className:"bullet",begin:"^[ 	]*([*+-]|(\\\\d+\\\\.))(?=\\\\s+)",end:"\\\\s+",excludeEnd:!0},s={begin:/^\\[[^\\n]+\\]:/,returnBegin:!0,contains:[{className:"symbol",begin:/\\[/,end:/\\]/,excludeBegin:!0,excludeEnd:!0},{className:"link",begin:/:\\s*/,end:/$/,excludeBegin:!0}]},o=/[A-Za-z][A-Za-z0-9+.-]*/,_={variants:[{begin:/\\[.+?\\]\\[.*?\\]/,relevance:0},{begin:/\\[.+?\\]\\(((data|javascript|mailto):|(?:http|ftp)s?:\\/\\/).*?\\)/,relevance:2},{begin:e.concat(/\\[.+?\\]\\(/,o,/:\\/\\/.*?\\)/),relevance:2},{begin:/\\[.+?\\]\\([./?&#].*?\\)/,relevance:1},{begin:/\\[.*?\\]\\(.*?\\)/,relevance:0}],returnBegin:!0,contains:[{match:/\\[(?=\\])/},{className:"string",relevance:0,begin:"\\\\[",end:"\\\\]",excludeBegin:!0,returnEnd:!0},{className:"link",relevance:0,begin:"\\\\]\\\\(",end:"\\\\)",excludeBegin:!0,excludeEnd:!0},{className:"symbol",relevance:0,begin:"\\\\]\\\\[",end:"\\\\]",excludeBegin:!0,excludeEnd:!0}]},l={className:"strong",contains:[],variants:[{begin:/_{2}(?!\\s)/,end:/_{2}/},{begin:/\\*{2}(?!\\s)/,end:/\\*{2}/}]},c={className:"emphasis",contains:[],variants:[{begin:/\\*(?![*\\s])/,end:/\\*/},{begin:/_(?![_\\s])/,end:/_/,relevance:0}]},d=t.inherit(l,{contains:[]}),m=t.inherit(c,{contains:[]});l.contains.push(m),c.contains.push(d);let p=[n,_];return[l,c,d,m].forEach(T=>{T.contains=T.contains.concat(p)}),p=p.concat(l,c),{name:"Markdown",aliases:["md","mkdown","mkd"],contains:[{className:"section",variants:[{begin:"^#{1,6}",end:"$",contains:p},{begin:"(?=^.+?\\\\n[=-]{2,}$)",contains:[{begin:"^[=-]*$"},{begin:"^",end:"\\\\n",contains:p}]}]},n,i,l,c,{className:"quote",begin:"^>\\\\s+",contains:p,end:"$"},r,a,_,s,{scope:"literal",match:/&([a-zA-Z0-9]+|#[0-9]{1,7}|#[Xx][0-9a-fA-F]{1,6});/}]}}function Vl(t){const e=t.regex,n=new RegExp("[\\\\p{XID_Start}_]\\\\p{XID_Continue}*","u"),a=["and","as","assert","async","await","break","case","class","continue","def","del","elif","else","except","finally","for","from","global","if","import","in","is","lambda","match","nonlocal|10","not","or","pass","raise","return","try","while","with","yield"],o={$pattern:/[A-Za-z]\\w+|__\\w+__/,keyword:a,built_in:["__import__","abs","all","any","ascii","bin","bool","breakpoint","bytearray","bytes","callable","chr","classmethod","compile","complex","delattr","dict","dir","divmod","enumerate","eval","exec","filter","float","format","frozenset","getattr","globals","hasattr","hash","help","hex","id","input","int","isinstance","issubclass","iter","len","list","locals","map","max","memoryview","min","next","object","oct","open","ord","pow","print","property","range","repr","reversed","round","set","setattr","slice","sorted","staticmethod","str","sum","super","tuple","type","vars","zip"],literal:["__debug__","Ellipsis","False","None","NotImplemented","True"],type:["Any","Callable","Coroutine","Dict","List","Literal","Generic","Optional","Sequence","Set","Tuple","Type","Union"]},_={className:"meta",begin:/^(>>>|\\.\\.\\.) /},l={className:"subst",begin:/\\{/,end:/\\}/,keywords:o,illegal:/#/},c={begin:/\\{\\{/,relevance:0},d={className:"string",contains:[t.BACKSLASH_ESCAPE],variants:[{begin:/([uU]|[bB]|[rR]|[bB][rR]|[rR][bB])?'''/,end:/'''/,contains:[t.BACKSLASH_ESCAPE,_],relevance:10},{begin:/([uU]|[bB]|[rR]|[bB][rR]|[rR][bB])?"""/,end:/"""/,contains:[t.BACKSLASH_ESCAPE,_],relevance:10},{begin:/([fF][rR]|[rR][fF]|[fF])'''/,end:/'''/,contains:[t.BACKSLASH_ESCAPE,_,c,l]},{begin:/([fF][rR]|[rR][fF]|[fF])"""/,end:/"""/,contains:[t.BACKSLASH_ESCAPE,_,c,l]},{begin:/([uU]|[rR])'/,end:/'/,relevance:10},{begin:/([uU]|[rR])"/,end:/"/,relevance:10},{begin:/([bB]|[bB][rR]|[rR][bB])'/,end:/'/},{begin:/([bB]|[bB][rR]|[rR][bB])"/,end:/"/},{begin:/([fF][rR]|[rR][fF]|[fF])'/,end:/'/,contains:[t.BACKSLASH_ESCAPE,c,l]},{begin:/([fF][rR]|[rR][fF]|[fF])"/,end:/"/,contains:[t.BACKSLASH_ESCAPE,c,l]},t.APOS_STRING_MODE,t.QUOTE_STRING_MODE]},m="[0-9](_?[0-9])*",p=\`(\\\\b(\${m}))?\\\\.(\${m})|\\\\b(\${m})\\\\.\`,E=\`\\\\b|\${a.join("|")}\`,g={className:"number",relevance:0,variants:[{begin:\`(\\\\b(\${m})|(\${p}))[eE][+-]?(\${m})[jJ]?(?=\${E})\`},{begin:\`(\${p})[jJ]?\`},{begin:\`\\\\b([1-9](_?[0-9])*|0+(_?0)*)[lLjJ]?(?=\${E})\`},{begin:\`\\\\b0[bB](_?[01])+[lL]?(?=\${E})\`},{begin:\`\\\\b0[oO](_?[0-7])+[lL]?(?=\${E})\`},{begin:\`\\\\b0[xX](_?[0-9a-fA-F])+[lL]?(?=\${E})\`},{begin:\`\\\\b(\${m})[jJ](?=\${E})\`}]},S={className:"comment",begin:e.lookahead(/# type:/),end:/$/,keywords:o,contains:[{begin:/# type:/},{begin:/#/,end:/\\b\\B/,endsWithParent:!0}]},T={className:"params",variants:[{className:"",begin:/\\(\\s*\\)/,skip:!0},{begin:/\\(/,end:/\\)/,excludeBegin:!0,excludeEnd:!0,keywords:o,contains:["self",_,g,d,t.HASH_COMMENT_MODE]}]};return l.contains=[d,g,_],{name:"Python",aliases:["py","gyp","ipython"],unicodeRegex:!0,keywords:o,illegal:/(<\\/|\\?)|=>/,contains:[_,g,{scope:"variable.language",match:/\\bself\\b/},{beginKeywords:"if",relevance:0},{match:/\\bor\\b/,scope:"keyword"},d,S,t.HASH_COMMENT_MODE,{match:[/\\bdef/,/\\s+/,n],scope:{1:"keyword",3:"title.function"},contains:[T]},{variants:[{match:[/\\bclass/,/\\s+/,n,/\\s*/,/\\(\\s*/,n,/\\s*\\)/]},{match:[/\\bclass/,/\\s+/,n]}],scope:{1:"keyword",3:"title.class",6:"title.class.inherited"}},{className:"meta",begin:/^[\\t ]*@/,end:/(?=#)|$/,contains:[g,T,d]}]}}function gm(t){const e=t.regex,n=t.COMMENT("--","$"),a={scope:"string",variants:[{begin:/'/,end:/'/,contains:[{match:/''/}]}]},r={begin:/"/,end:/"/,contains:[{match:/""/}]},i=["true","false","unknown"],s=["double precision","large object","with timezone","without timezone"],o=["bigint","binary","blob","boolean","char","character","clob","date","dec","decfloat","decimal","float","int","integer","interval","nchar","nclob","national","numeric","real","row","smallint","time","timestamp","varchar","varying","varbinary"],_=["add","asc","collation","desc","final","first","last","view"],l=["abs","acos","all","allocate","alter","and","any","are","array","array_agg","array_max_cardinality","as","asensitive","asin","asymmetric","at","atan","atomic","authorization","avg","begin","begin_frame","begin_partition","between","bigint","binary","blob","boolean","both","by","call","called","cardinality","cascaded","case","cast","ceil","ceiling","char","char_length","character","character_length","check","classifier","clob","close","coalesce","collate","collect","column","commit","condition","connect","constraint","contains","convert","copy","corr","corresponding","cos","cosh","count","covar_pop","covar_samp","create","cross","cube","cume_dist","current","current_catalog","current_date","current_default_transform_group","current_path","current_role","current_row","current_schema","current_time","current_timestamp","current_path","current_role","current_transform_group_for_type","current_user","cursor","cycle","date","day","deallocate","dec","decimal","decfloat","declare","default","define","delete","dense_rank","deref","describe","deterministic","disconnect","distinct","double","drop","dynamic","each","element","else","empty","end","end_frame","end_partition","end-exec","equals","escape","every","except","exec","execute","exists","exp","external","extract","false","fetch","filter","first_value","float","floor","for","foreign","frame_row","free","from","full","function","fusion","get","global","grant","group","grouping","groups","having","hold","hour","identity","in","indicator","initial","inner","inout","insensitive","insert","int","integer","intersect","intersection","interval","into","is","join","json_array","json_arrayagg","json_exists","json_object","json_objectagg","json_query","json_table","json_table_primitive","json_value","lag","language","large","last_value","lateral","lead","leading","left","like","like_regex","listagg","ln","local","localtime","localtimestamp","log","log10","lower","match","match_number","match_recognize","matches","max","member","merge","method","min","minute","mod","modifies","module","month","multiset","national","natural","nchar","nclob","new","no","none","normalize","not","nth_value","ntile","null","nullif","numeric","octet_length","occurrences_regex","of","offset","old","omit","on","one","only","open","or","order","out","outer","over","overlaps","overlay","parameter","partition","pattern","per","percent","percent_rank","percentile_cont","percentile_disc","period","portion","position","position_regex","power","precedes","precision","prepare","primary","procedure","ptf","range","rank","reads","real","recursive","ref","references","referencing","regr_avgx","regr_avgy","regr_count","regr_intercept","regr_r2","regr_slope","regr_sxx","regr_sxy","regr_syy","release","result","return","returns","revoke","right","rollback","rollup","row","row_number","rows","running","savepoint","scope","scroll","search","second","seek","select","sensitive","session_user","set","show","similar","sin","sinh","skip","smallint","some","specific","specifictype","sql","sqlexception","sqlstate","sqlwarning","sqrt","start","static","stddev_pop","stddev_samp","submultiset","subset","substring","substring_regex","succeeds","sum","symmetric","system","system_time","system_user","table","tablesample","tan","tanh","then","time","timestamp","timezone_hour","timezone_minute","to","trailing","translate","translate_regex","translation","treat","trigger","trim","trim_array","true","truncate","uescape","union","unique","unknown","unnest","update","upper","user","using","value","values","value_of","var_pop","var_samp","varbinary","varchar","varying","versioning","when","whenever","where","width_bucket","window","with","within","without","year"],c=["abs","acos","array_agg","asin","atan","avg","cast","ceil","ceiling","coalesce","corr","cos","cosh","count","covar_pop","covar_samp","cume_dist","dense_rank","deref","element","exp","extract","first_value","floor","json_array","json_arrayagg","json_exists","json_object","json_objectagg","json_query","json_table","json_table_primitive","json_value","lag","last_value","lead","listagg","ln","log","log10","lower","max","min","mod","nth_value","ntile","nullif","percent_rank","percentile_cont","percentile_disc","position","position_regex","power","rank","regr_avgx","regr_avgy","regr_count","regr_intercept","regr_r2","regr_slope","regr_sxx","regr_sxy","regr_syy","row_number","sin","sinh","sqrt","stddev_pop","stddev_samp","substring","substring_regex","sum","tan","tanh","translate","translate_regex","treat","trim","trim_array","unnest","upper","value_of","var_pop","var_samp","width_bucket"],d=["current_catalog","current_date","current_default_transform_group","current_path","current_role","current_schema","current_transform_group_for_type","current_user","session_user","system_time","system_user","current_time","localtime","current_timestamp","localtimestamp"],m=["create table","insert into","primary key","foreign key","not null","alter table","add constraint","grouping sets","on overflow","character set","respect nulls","ignore nulls","nulls first","nulls last","depth first","breadth first"],p=c,E=[...l,..._].filter(N=>!c.includes(N)),g={scope:"variable",match:/@[a-z0-9][a-z0-9_]*/},S={scope:"operator",match:/[-+*/=%^~]|&&?|\\|\\|?|!=?|<(?:=>?|<|>)?|>[>=]?/,relevance:0},T={match:e.concat(/\\b/,e.either(...p),/\\s*\\(/),relevance:0,keywords:{built_in:p}};function R(N){return e.concat(/\\b/,e.either(...N.map(C=>C.replace(/\\s+/,"\\\\s+"))),/\\b/)}const f={scope:"keyword",match:R(m),relevance:0};function A(N,{exceptions:C,when:M}={}){const y=M;return C=C||[],N.map(x=>x.match(/\\|\\d+$/)||C.includes(x)?x:y(x)?\`\${x}|0\`:x)}return{name:"SQL",case_insensitive:!0,illegal:/[{}]|<\\//,keywords:{$pattern:/\\b[\\w\\.]+/,keyword:A(E,{when:N=>N.length<3}),literal:i,type:o,built_in:d},contains:[{scope:"type",match:R(s)},f,T,g,a,r,t.C_NUMBER_MODE,t.C_BLOCK_COMMENT_MODE,n,S]}}function zl(t){const e=t.regex,n=e.concat(/[\\p{L}_]/u,e.optional(/[\\p{L}0-9_.-]*:/u),/[\\p{L}0-9_.-]*/u),a=/[\\p{L}0-9._:-]+/u,r={className:"symbol",begin:/&[a-z]+;|&#[0-9]+;|&#x[a-f0-9]+;/},i={begin:/\\s/,contains:[{className:"keyword",begin:/#?[a-z_][a-z1-9_-]+/,illegal:/\\n/}]},s=t.inherit(i,{begin:/\\(/,end:/\\)/}),o=t.inherit(t.APOS_STRING_MODE,{className:"string"}),_=t.inherit(t.QUOTE_STRING_MODE,{className:"string"}),l={endsWithParent:!0,illegal:/</,relevance:0,contains:[{className:"attr",begin:a,relevance:0},{begin:/=\\s*/,relevance:0,contains:[{className:"string",endsParent:!0,variants:[{begin:/"/,end:/"/,contains:[r]},{begin:/'/,end:/'/,contains:[r]},{begin:/[^\\s"'=<>\`]+/}]}]}]};return{name:"HTML, XML",aliases:["html","xhtml","rss","atom","xjb","xsd","xsl","plist","wsf","svg"],case_insensitive:!0,unicodeRegex:!0,contains:[{className:"meta",begin:/<![a-z]/,end:/>/,relevance:10,contains:[i,_,o,s,{begin:/\\[/,end:/\\]/,contains:[{className:"meta",begin:/<![a-z]/,end:/>/,contains:[i,s,_,o]}]}]},t.COMMENT(/<!--/,/-->/,{relevance:10}),{begin:/<!\\[CDATA\\[/,end:/\\]\\]>/,relevance:10},r,{className:"meta",end:/\\?>/,variants:[{begin:/<\\?xml/,relevance:10,contains:[_]},{begin:/<\\?[a-z][a-z0-9]+/}]},{className:"tag",begin:/<style(?=\\s|>)/,end:/>/,keywords:{name:"style"},contains:[l],starts:{end:/<\\/style>/,returnEnd:!0,subLanguage:["css","xml"]}},{className:"tag",begin:/<script(?=\\s|>)/,end:/>/,keywords:{name:"script"},contains:[l],starts:{end:/<\\/script>/,returnEnd:!0,subLanguage:["javascript","handlebars","xml"]}},{className:"tag",begin:/<>|<\\/>/},{className:"tag",begin:e.concat(/</,e.lookahead(e.concat(n,e.either(/\\/>/,/>/,/\\s/)))),end:/\\/?>/,contains:[{className:"name",begin:n,relevance:0,starts:l}]},{className:"tag",begin:e.concat(/<\\//,e.lookahead(e.concat(n,/>/))),contains:[{className:"name",begin:n,relevance:0},{begin:/>/,relevance:0,endsParent:!0}]}]}}function Sm(t){const e="true false yes no null",n="[\\\\w#;/?:@&=+$,.~*'()[\\\\]]+",a={className:"attr",variants:[{begin:/[\\w*@][\\w*@ :()\\./-]*:(?=[ \\t]|$)/},{begin:/"[\\w*@][\\w*@ :()\\./-]*":(?=[ \\t]|$)/},{begin:/'[\\w*@][\\w*@ :()\\./-]*':(?=[ \\t]|$)/}]},r={className:"template-variable",variants:[{begin:/\\{\\{/,end:/\\}\\}/},{begin:/%\\{/,end:/\\}/}]},i={className:"string",relevance:0,begin:/'/,end:/'/,contains:[{match:/''/,scope:"char.escape",relevance:0}]},s={className:"string",relevance:0,variants:[{begin:/"/,end:/"/},{begin:/\\S+/}],contains:[t.BACKSLASH_ESCAPE,r]},o=t.inherit(s,{variants:[{begin:/'/,end:/'/,contains:[{begin:/''/,relevance:0}]},{begin:/"/,end:/"/},{begin:/[^\\s,{}[\\]]+/}]}),m={className:"number",begin:"\\\\b"+"[0-9]{4}(-[0-9][0-9]){0,2}"+"([Tt \\\\t][0-9][0-9]?(:[0-9][0-9]){2})?"+"(\\\\.[0-9]*)?"+"([ \\\\t])*(Z|[-+][0-9][0-9]?(:[0-9][0-9])?)?"+"\\\\b"},p={end:",",endsWithParent:!0,excludeEnd:!0,keywords:e,relevance:0},E={begin:/\\{/,end:/\\}/,contains:[p],illegal:"\\\\n",relevance:0},g={begin:"\\\\[",end:"\\\\]",contains:[p],illegal:"\\\\n",relevance:0},S=[a,{className:"meta",begin:"^---\\\\s*$",relevance:10},{className:"string",begin:"[\\\\|>]([1-9]?[+-])?[ ]*\\\\n( +)[^ ][^\\\\n]*\\\\n(\\\\2[^\\\\n]+\\\\n?)*"},{begin:"<%[%=-]?",end:"[%-]?%>",subLanguage:"ruby",excludeBegin:!0,excludeEnd:!0,relevance:0},{className:"type",begin:"!\\\\w+!"+n},{className:"type",begin:"!<"+n+">"},{className:"type",begin:"!"+n},{className:"type",begin:"!!"+n},{className:"meta",begin:"&"+t.UNDERSCORE_IDENT_RE+"$"},{className:"meta",begin:"\\\\*"+t.UNDERSCORE_IDENT_RE+"$"},{className:"bullet",begin:"-(?=[ ]|$)",relevance:0},t.HASH_COMMENT_MODE,{beginKeywords:e,keywords:{literal:e}},m,{className:"number",begin:t.C_NUMBER_RE+"\\\\b",relevance:0},E,g,i,s],T=[...S];return T.pop(),T.push(o),p.contains=T,{name:"YAML",case_insensitive:!0,aliases:["yml"],contains:S}}const Wl=["css"],Kl=["gh-markdown"],$l=["html","xml"],Ql=["javascript","js"],Xl=["jinja"],Zl=["json"],Jl=["markdown","md"],jl=["python","py"],ec=["vue"],tc=["yaml","yml"],nc=["sql"],Tm=[...Wl,...Kl,...$l,...Ql,...Xl,...Zl,...Jl,...jl,...ec,...tc,...nc];function bm(t){return Ql.includes(t)}function Rm(t){return Zl.includes(t)}function fm(t){return jl.includes(t)}function Cm(t){return ec.includes(t)}function Nm(t){return Jl.includes(t)}function Om(t){return Kl.includes(t)}function Im(t){return $l.includes(t)}function Am(t){return Wl.includes(t)}function vm(t){return Xl.includes(t)}function ym(t){return tc.includes(t)}function hm(t){return nc.includes(t)}const Dm=t=>{const e=t.COMMENT(/<!--/,/-->/,{relevance:10}),n={className:"code",variants:[...Tm.map(r=>({begin:\`\\\`\\\`\\\`\${r}
\`,end:"\`\`\`",subLanguage:r,relevance:0,excludeBegin:!0,excludeEnd:!0}))]};return{name:"markdown",subLanguage:"markdown",contains:[e,n,{className:"strikethrough",variants:[{begin:"(~{2,})[^~](.|\\\\n)*?\\\\1~*[ ]*"},{begin:"~~",end:"~~+[ ]*$"}]}],relevance:0}},ac=t=>({name:"vue",subLanguage:"xml",contains:[t.COMMENT("<!--","-->",{relevance:10}),{begin:/^(\\s*)(<script>)/gm,end:/^(\\s*)(<\\/script>)/gm,subLanguage:"javascript",excludeBegin:!0,excludeEnd:!0},{begin:/^(?:\\s*)(?:<script\\s+lang=(["'])ts\\1>)/gm,end:/^(\\s*)(<\\/script>)/gm,subLanguage:"typescript",excludeBegin:!0,excludeEnd:!0},{begin:/^(\\s*)(<style(\\s+scoped)?>)/gm,end:/^(\\s*)(<\\/style>)/gm,subLanguage:"css",excludeBegin:!0,excludeEnd:!0}]}),rc=new Set,Mm=(t,e)=>(wm(e),Bl.highlight(t,{language:e})),Lm=t=>{if(bm(t)||Rm(t))return{javascript:Jr};if(fm(t))return{python:Vl};if(ym(t))return{yaml:Sm};if(Am(t))return{css:Zr};if(vm(t))return{jinja:_m};if(Im(t)||Cm(t))return{xml:zl,css:Zr,javascript:Jr,vue:ac};if(Om(t)||Nm(t))return{"gh-markdown":Dm,markdown:Em,xml:zl,css:Zr,python:Vl,javascript:Jr,vueLanguage:ac};if(hm(t))return{sql:gm};throw new Error(\`Language \${t} is not supported\`)},xm=t=>rc.has(t),wm=t=>{if(xm(t))return;rc.add(t);const e=Lm(t);Object.entries(e).forEach(([n,a])=>Bl.registerLanguage(n,a))},Pm=t=>{const{id:e,text:n,lang:a}=t.data,{language:r,code:i,illegal:s,relevance:o,value:_}=Mm(n,a),l={id:e,unformatted:i,formatted:_,illegal:s,relevance:o,language:r};self.postMessage(l)};self.onmessage=Pm})();
`, qh = typeof self < "u" && self.Blob && new Blob(["(self.URL || self.webkitURL).revokeObjectURL(self.location.href);", d3], { type: "text/javascript;charset=utf-8" });
function oG(t) {
  let n;
  try {
    if (n = qh && (self.URL || self.webkitURL).createObjectURL(qh), !n) throw "";
    const a = new Worker(n, {
      name: t?.name
    });
    return a.addEventListener("error", () => {
      (self.URL || self.webkitURL).revokeObjectURL(n);
    }), a;
  } catch {
    return new Worker(
      "data:text/javascript;charset=utf-8," + encodeURIComponent(d3),
      {
        name: t?.name
      }
    );
  }
}
const nf = /* @__PURE__ */ new Map(), _3 = new oG();
_3.onmessage = (t) => {
  const { id: n } = t.data, a = nf.get(n);
  a && a(t.data);
};
function iG(t, n) {
  const a = ml(), i = z(""), s = z(!1), u = z(0), p = M(() => $r(t).split(`
`).length), g = (E) => {
    i.value = E.formatted, s.value = E.illegal, u.value = E.relevance;
  };
  return nf.set(a, g), pn(() => {
    const E = {
      id: a,
      text: $r(t),
      lang: $r(n)
    };
    _3.postMessage(E);
  }), zl(() => nf.delete(a)), { formatted: i, illegal: s, relevance: u, lines: p };
}
const sG = ["lines"], eh = /* @__PURE__ */ W({
  __name: "PCodeHighlight",
  props: {
    text: {},
    lang: {},
    showLineNumbers: { type: Boolean },
    inline: { type: Boolean }
  },
  setup(t) {
    const n = t, { formatted: a, lines: i } = iG(() => n.text, () => n.lang), s = M(() => !n.inline && n.showLineNumbers), u = M(() => ({
      root: {
        "p-code-highlight--inline": n.inline
      },
      codeWrapper: {
        "p-code-highlight__code-wrapper--show-line-numbers": s.value
      }
    }));
    return (p, g) => (c(), _("div", {
      class: Oe(["p-code-highlight", u.value.root]),
      lines: y(i)
    }, [
      s.value ? (c(), G(y(ih), {
        key: 0,
        class: "p-code-highlight__line-numbers",
        lines: y(i)
      }, null, 8, ["lines"])) : le("", !0),
      ne(y(Pd), {
        inline: p.inline,
        class: Oe(["p-code-highlight__code-wrapper", u.value.codeWrapper])
      }, {
        default: N(() => [
          ne(y(sh), { html: y(a) }, null, 8, ["html"])
        ]),
        _: 1
      }, 8, ["inline", "class"])
    ], 10, sG));
  }
}), lG = (t) => {
  t.component("PCodeHighlight", eh);
}, cG = ["placeholder", "rows"], uG = /* @__PURE__ */ W({
  __name: "PCodeInput",
  props: {
    modelValue: {},
    lang: {},
    showLineNumbers: { type: Boolean },
    placeholder: {},
    minLines: {}
  },
  emits: ["update:modelValue"],
  setup(t, { emit: n }) {
    const a = t, i = n, s = z(), u = k7(s), p = z(), { width: g } = tc(p), { source: E, target: h } = d6(), f = /\r|\r\n|\n/, b = M(() => A.value !== "" ? A.value.split(f) : a.placeholder ? a.placeholder.split(f) : []), w = M(() => Math.max(b.value.length, a.minLines ?? 1)), x = M(() => u.value ? parseFloat(u.value.lineHeight) : 0), A = M({
      get() {
        return a.modelValue ?? "";
      },
      set(q) {
        i("update:modelValue", q);
      }
    }), D = M(() => ({
      inputControl: {
        "p-code-input__control--show-line-numbers": a.showLineNumbers
      },
      textArea: {
        "p-code-input__textarea--show-line-numbers": a.showLineNumbers
      }
    })), L = M(() => ({
      textarea: {
        height: `${x.value * w.value}px`,
        width: g.value ? `${g.value}px` : "100%"
      },
      view: {
        height: `${x.value * w.value}px`
      }
    })), $ = () => {
      s.value && s.value.focus();
    };
    return (q, P) => {
      const k = ht("p-base-input");
      return c(), G(k, { class: "p-code-input" }, mn({
        control: N(({ attrs: U }) => [
          d("div", {
            ref_key: "source",
            ref: E,
            class: Oe(["p-code-input__control", D.value.inputControl]),
            onClick: xa($, ["self"])
          }, [
            ur(d("textarea", oe({
              ref_key: "textarea",
              ref: s,
              "onUpdate:modelValue": P[0] || (P[0] = (Z) => A.value = Z),
              spellcheck: "false",
              class: ["p-code-input__textarea", D.value.textArea],
              placeholder: q.placeholder,
              rows: w.value,
              style: L.value.textarea
            }, U), null, 16, cG), [
              [fl, A.value]
            ]),
            d("div", {
              ref_key: "view",
              ref: p,
              class: "p-code-input__view-container"
            }, [
              q.lang ? (c(), G(y(eh), oe({
                key: 0,
                lang: q.lang,
                text: A.value,
                class: "p-code-input__view",
                style: L.value.view
              }, U), null, 16, ["lang", "text", "style"])) : (c(), G(y(Pd), oe({
                key: 1,
                class: "p-code-input__view",
                style: L.value.view
              }, U), {
                default: N(() => [
                  Ne(ye(A.value), 1)
                ]),
                _: 1
              }, 16, ["style"]))
            ], 512)
          ], 2)
        ]),
        _: 2
      }, [
        Ye(q.$slots, (U, Z) => ({
          name: Z,
          fn: N((ee) => [
            I(q.$slots, Z, ve(we(ee)))
          ])
        })),
        q.showLineNumbers ? {
          name: "prepend",
          fn: N(() => [
            d("div", {
              ref_key: "target",
              ref: h,
              class: "p-code-input__line-numbers-wrapper"
            }, [
              ne(y(ih), {
                class: "p-code-input__line-numbers",
                lines: w.value
              }, null, 8, ["lines"])
            ], 512)
          ]),
          key: "0"
        } : void 0
      ]), 1024);
    };
  }
}), dG = (t) => {
  t.component("PCodeInput", uG);
}, _G = { class: "p-combobox__search-option" }, pG = { class: "p-combobox__options-empty" }, p3 = /* @__PURE__ */ W({
  __name: "PCombobox",
  props: {
    modelValue: { type: [String, Number, Boolean, null, Array] },
    options: {},
    allowUnknownValue: { type: Boolean },
    emptyMessage: { default: void 0 },
    placeholder: { default: "Search" },
    search: { default: void 0 },
    manual: { type: Boolean },
    optionsClass: { default: void 0 }
  },
  emits: ["update:modelValue", "update:search", "bottom"],
  setup(t, { emit: n }) {
    const a = t, i = n, s = M({
      get() {
        return a.modelValue ?? null;
      },
      set(X) {
        i("update:modelValue", X);
      }
    }), u = M(() => s.value ? Array.isArray(s.value) ? s.value.map((X) => X ? X.toString() : "") : [s.value.toString()] : []), p = M(() => a.options.map(Ei)), g = M(() => Gl(p.value)), E = M(() => u.value.filter((X) => !L(p.value, X))), h = M(() => {
      const X = [...p.value];
      if (s.value && a.allowUnknownValue) {
        const re = E.value.map((Q) => ({ label: `${Q}`, value: Q }));
        X.push(...re);
      }
      return w.value && a.allowUnknownValue && !L(X, w.value) && X.push({ label: `${w.value}`, value: w.value }), X;
    }), f = M(() => !w.value || a.manual ? h.value : r3(h.value, w.value)), b = z(null), w = M({
      get() {
        return a.search ?? b.value;
      },
      set(X) {
        b.value = X, i("update:search", X);
      }
    }), x = z();
    function A(X) {
      const re = D(X);
      return re ? re.label : X === null ? "" : X.toString();
    }
    function D(X) {
      return g.value.find((re) => re.value === X);
    }
    function L(X, re) {
      return re ? !!Gl(X).find((ce) => ce.value === re) : !0;
    }
    function $() {
      w.value = null;
    }
    function q(X) {
      [Ie.shift, Ie.capsLock, Ie.ctrl, Ie.windowKey, Ie.tab].includes(X.key) || P();
    }
    function P() {
      Ct(() => x.value?.el.focus());
    }
    function k(X) {
      X.key === Ie.space && U(X);
    }
    function U(X) {
      X.stopPropagation();
    }
    function Z() {
      x.value?.el.select();
    }
    function ee() {
      w.value = null;
    }
    return (X, re) => (c(), G(y(L0), {
      modelValue: s.value,
      "onUpdate:modelValue": [
        re[1] || (re[1] = (Q) => s.value = Q),
        $
      ],
      options: f.value,
      "options-class": X.optionsClass,
      "empty-message": X.emptyMessage,
      onClose: $,
      onOpen: P,
      onKeydown: q,
      onBottom: re[2] || (re[2] = (Q) => i("bottom"))
    }, mn({
      default: N(({ value: Q, option: ce }) => [
        I(X.$slots, "default", {
          value: Q,
          label: A(Q),
          option: ce
        }, () => [
          Ne(ye(A(Q)), 1)
        ])
      ]),
      "pre-options": N(() => [
        d("div", _G, [
          ne(y(P0), {
            ref_key: "textInput",
            ref: x,
            modelValue: w.value,
            "onUpdate:modelValue": re[0] || (re[0] = (Q) => w.value = Q),
            type: "search",
            placeholder: X.placeholder,
            class: "p-combobox__text-input",
            role: "combobox",
            tabindex: "-1",
            "aria-controls": "options",
            "aria-expanded": "false",
            small: "",
            onKeydown: k,
            onFocus: Z
          }, null, 8, ["modelValue", "placeholder"])
        ])
      ]),
      option: N(({ option: Q, ...ce }) => [
        I(X.$slots, "option", oe({ option: Q }, ce), () => [
          Ne(ye(Q.label), 1)
        ])
      ]),
      "options-empty": N((Q) => [
        d("div", pG, [
          I(X.$slots, "combobox-options-empty", ve(we(Q)), () => [
            w.value ? (c(), _(Qe, { key: 0 }, [
              d("span", null, 'No matches for "' + ye(w.value) + '"', 1),
              ne(y(rn), {
                secondary: "",
                small: "",
                onClick: xa(ee, ["stop"])
              }, {
                default: N(() => [...re[3] || (re[3] = [
                  Ne(" See All Options ", -1)
                ])]),
                _: 1
              })
            ], 64)) : le("", !0)
          ])
        ])
      ]),
      _: 2
    }, [
      Ye(X.$slots, (Q, ce) => ({
        name: ce,
        fn: N((me) => [
          I(X.$slots, ce, ve(we(me)))
        ])
      }))
    ]), 1032, ["modelValue", "options", "options-class", "empty-message"]));
  }
}), mG = (t) => {
  t.component("PCombobox", p3);
}, m3 = /* @__PURE__ */ W({
  __name: "PCommandBase",
  props: {
    modelValue: { default: "" },
    defaultValue: {},
    open: { type: Boolean, default: !0 },
    defaultOpen: { type: Boolean },
    searchTerm: {},
    selectedValue: {},
    multiple: { type: Boolean },
    disabled: { type: Boolean },
    name: {},
    dir: {},
    filterFunction: {},
    displayValue: {},
    resetSearchTermOnBlur: { type: Boolean },
    resetSearchTermOnSelect: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["update:modelValue", "update:open", "update:searchTerm", "update:selectedValue"],
  setup(t, { emit: n }) {
    const s = Wn(t, n);
    return (u, p) => (c(), G(y(rw), oe(y(s), { class: "p-command" }), {
      default: N(() => [
        I(u.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), g3 = /* @__PURE__ */ W({
  __name: "PCommandEmpty",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(t) {
    const n = t;
    return (a, i) => (c(), G(y(dw), oe(n, { class: "py-6 text-center text-sm" }), {
      default: N(() => [
        I(a.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), gG = {
  class: "flex items-center border-b px-3",
  "cmdk-input-wrapper": ""
}, f3 = /* @__PURE__ */ W({
  inheritAttrs: !1,
  __name: "PCommandInput",
  props: {
    type: {},
    disabled: { type: Boolean },
    autoFocus: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  setup(t) {
    const a = vl(t);
    return (i, s) => {
      const u = ht("p-icon");
      return c(), _("div", gG, [
        ne(u, {
          icon: "Search",
          class: "mr-2 h-4 w-4 shrink-0 opacity-50"
        }),
        ne(y(aw), oe({ ...y(a), ...i.$attrs }, {
          "auto-focus": "",
          class: "p-command-input"
        }), null, 16)
      ]);
    };
  }
}), fG = { role: "presentation" }, h3 = /* @__PURE__ */ W({
  __name: "PCommandList",
  props: {
    forceMount: { type: Boolean },
    position: {},
    bodyLock: { type: Boolean },
    dismissable: { type: Boolean, default: !1 },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {},
    disableOutsidePointerEvents: { type: Boolean }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside"],
  setup(t, { emit: n }) {
    const s = Wn(t, n);
    return (u, p) => (c(), G(y(uw), oe(y(s), { class: "p-command-list" }), {
      default: N(() => [
        d("div", fG, [
          I(u.$slots, "default")
        ])
      ]),
      _: 3
    }, 16));
  }
}), hG = /* @__PURE__ */ W({
  __name: "PCommand",
  props: {
    modelValue: { default: "" },
    defaultValue: {},
    open: { type: Boolean, default: !0 },
    defaultOpen: { type: Boolean },
    searchTerm: {},
    selectedValue: {},
    multiple: { type: Boolean },
    disabled: { type: Boolean },
    name: {},
    dir: {},
    filterFunction: {},
    displayValue: {},
    resetSearchTermOnBlur: { type: Boolean },
    resetSearchTermOnSelect: { type: Boolean },
    asChild: { type: Boolean },
    as: {},
    placeholder: { default: "Search..." },
    items: { default: () => ({}) }
  },
  emits: ["update:modelValue", "update:open", "update:searchTerm", "update:selectedValue"],
  setup(t, { emit: n }) {
    const s = Wn(t, n);
    return (u, p) => (c(), G(m3, oe({ class: "rounded-lg border shadow-md max-w-[450px]" }, y(s)), {
      default: N(() => [
        ne(f3, { placeholder: u.placeholder }, null, 8, ["placeholder"]),
        ne(h3, null, {
          default: N(() => [
            ne(g3, null, {
              default: N(() => [...p[0] || (p[0] = [
                Ne("No results found.", -1)
              ])]),
              _: 1
            }),
            I(u.$slots, "default")
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 16));
  }
}), vG = /* @__PURE__ */ W({
  __name: "PCommandGroup",
  props: {
    asChild: { type: Boolean },
    as: {},
    heading: {}
  },
  setup(t) {
    const n = t;
    return (a, i) => (c(), G(y(iw), oe(n, { class: "p-command-group" }), {
      default: N(() => [
        a.heading ? (c(), G(y(sw), {
          key: 0,
          class: "p-command-group-heading"
        }, {
          default: N(() => [
            Ne(ye(a.heading), 1)
          ]),
          _: 1
        })) : le("", !0),
        I(a.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), EG = /* @__PURE__ */ W({
  __name: "PCommandItem",
  props: {
    value: {},
    disabled: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["select"],
  setup(t, { emit: n }) {
    const s = Wn(t, n);
    return (u, p) => (c(), G(y(mw), oe(y(s), { class: "p-command-item" }), {
      default: N(() => [
        I(u.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), bG = /* @__PURE__ */ W({
  __name: "PCommandSeparator",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(t) {
    const n = t;
    return (a, i) => (c(), G(y(gw), oe(n, { class: "p-command-separator" }), {
      default: N(() => [
        I(a.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), SG = {}, wG = { class: "p-command-shortcut" };
function yG(t, n) {
  return c(), _("span", wG, [
    I(t.$slots, "default")
  ]);
}
const TG = /* @__PURE__ */ Wt(SG, [["render", yG]]), CG = (t) => {
  t.component("PCommand", hG);
}, xG = (t) => {
  t.component("PCommandBase", m3);
}, AG = (t) => {
  t.component("PCommandEmpty", g3);
}, RG = (t) => {
  t.component("PCommandGroup", vG);
}, OG = (t) => {
  t.component("PCommandInput", f3);
}, IG = (t) => {
  t.component("PCommandItem", EG);
}, NG = (t) => {
  t.component("PCommandList", h3);
}, MG = (t) => {
  t.component("PCommandSeparator", bG);
}, DG = (t) => {
  t.component("PCommandShortcut", TG);
}, p0 = /* @__PURE__ */ W({
  __name: "PContent",
  props: {
    secondary: { type: Boolean }
  },
  setup(t) {
    const n = t, a = M(() => ({
      "p-content--secondary": n.secondary
    }));
    return (i, s) => (c(), _("div", {
      class: Oe(["p-content", a.value])
    }, [
      I(i.$slots, "default")
    ], 2));
  }
}), kG = (t) => {
  t.component("PContent", p0);
}, LG = { class: "p-context-accordion-item" }, PG = { class: "p-context-accordion-item__title" }, BG = {
  key: 0,
  class: "p-context-accordion-item__contents"
}, FG = /* @__PURE__ */ W({
  __name: "PContextAccordionItem",
  props: {
    title: {},
    icon: {},
    children: {}
  },
  setup(t) {
    const n = t, a = hv(), i = Yr(), s = z(!1), u = M(() => !!i.default || n.children?.length), p = M(() => {
      if (!n.children)
        return !1;
      const h = a.matched.map(({ name: b }) => b);
      return n.children.map(({ to: b }) => L4(b)).some((b) => b && h.includes(b));
    }), g = M(() => ({
      header: {
        "p-context-accordion-item__header--highlighted": !s.value && p.value
      },
      indicator: {
        "p-context-accordion-item__indicator--open": s.value
      }
    }));
    function E() {
      s.value = !s.value;
    }
    return tt(p, (h) => {
      h && (s.value = !0);
    }), (h, f) => {
      const b = ht("router-link");
      return c(), _("div", LG, [
        d("button", {
          type: "button",
          class: Oe(["p-context-accordion-item__header", g.value.header]),
          onClick: E
        }, [
          h.icon ? (c(), G(Dn, {
            key: 0,
            icon: h.icon,
            class: "p-context-accordion-item__icon"
          }, null, 8, ["icon"])) : le("", !0),
          d("div", PG, ye(h.title), 1),
          u.value ? (c(), G(Dn, {
            key: 1,
            icon: "ChevronRightIcon",
            class: Oe(["p-context-accordion-item__indicator", g.value.indicator])
          }, null, 8, ["class"])) : le("", !0)
        ], 2),
        ne(Q7, null, {
          default: N(() => [
            s.value ? (c(), _("div", BG, [
              I(h.$slots, "default"),
              (c(!0), _(Qe, null, Ye(h.children, (w, x) => (c(), G(b, {
                key: x,
                to: w.to,
                class: "p-context-accordion-item__content-child",
                "active-class": "p-context-accordion-item__content-child--active"
              }, {
                default: N(() => [
                  Ne(ye(w.title), 1)
                ]),
                _: 2
              }, 1032, ["to"]))), 128))
            ])) : le("", !0)
          ]),
          _: 3
        })
      ]);
    };
  }
}), UG = (t) => {
  t.component("PContextAccordionItem", FG);
}, $G = {}, VG = { class: "p-context-sidebar-divider" };
function HG(t, n) {
  return c(), _("hr", VG);
}
const GG = /* @__PURE__ */ Wt($G, [["render", HG]]), YG = (t) => {
  t.component("PContextDivider", GG);
}, zG = {}, ZG = { class: "p-overflow-menu" };
function qG(t, n) {
  return c(), _("div", ZG, [
    I(t.$slots, "default")
  ]);
}
const th = /* @__PURE__ */ Wt(zG, [["render", qG]]), Sl = /* @__PURE__ */ W({
  inheritAttrs: !1,
  __name: "PPopOver",
  props: {
    placement: { type: [Function, Array], default: () => [l7, c7, s7, u7] },
    autoClose: { type: Boolean },
    to: { default: "body" },
    group: { default: () => ml() }
  },
  emits: ["open"],
  setup(t, { expose: n, emit: a }) {
    const i = t, s = a, u = z(!1), p = h0(), g = z(), { open: E } = u6(i.group), h = M(() => Array.isArray(i.placement) ? i.placement : [i.placement]), { target: f, content: b, styles: w } = Z4(h, { container: g });
    n({
      open: L,
      close: $,
      toggle: q,
      visible: u,
      target: f,
      content: b
    }), ul("click", A), ul("focusin", A), ul("contextmenu", A);
    function x() {
      return typeof i.to == "string" ? f.value.closest(i.to) ?? void 0 : i.to;
    }
    function A(P) {
      const k = P.target, U = P instanceof MouseEvent;
      !i.autoClose || f.value?.contains(k) || U && D(P, f.value) || b.value?.contains(k) || U && D(P, b.value) || k.closest(".p-pop-over-content") !== null || $();
    }
    function D(P, k) {
      if (!k)
        return !1;
      const U = k.getBoundingClientRect(), { clientX: Z, clientY: ee } = P;
      return !(Z < U.left || Z >= U.right || ee < U.top || ee >= U.bottom);
    }
    function L() {
      E($), g.value = x(), u.value = !0;
    }
    function $() {
      u.value = !1;
    }
    function q() {
      u.value ? $() : L();
    }
    return tt(u, (P) => s("open", P)), (P, k) => (c(), _(Qe, null, [
      d("div", oe({
        ref_key: "target",
        ref: f,
        class: "p-pop-over"
      }, y(p)), [
        I(P.$slots, "target", ve(we({ open: L, close: $, toggle: q, visible: u.value })))
      ], 16),
      u.value ? (c(), G(Rd, {
        key: 0,
        to: g.value
      }, [
        d("div", {
          ref_key: "content",
          ref: b,
          class: "p-pop-over-content",
          style: Gr(y(w))
        }, [
          I(P.$slots, "default", ve(we({ close: $ })))
        ], 4)
      ], 8, ["to"])) : le("", !0)
    ], 64));
  }
}), WG = /* @__PURE__ */ W({
  __name: "PContextMenu",
  props: {
    placement: { type: [Function, Array], default: void 0 },
    disableAutoClose: { type: Boolean },
    disableCloseOnEscape: { type: Boolean },
    disableCloseOnMenuClick: { type: Boolean },
    positionAtClick: { type: Boolean },
    group: { default: void 0 }
  },
  setup(t) {
    const n = t, a = z(), { positionAtLastClick: i } = h4(), s = M(() => n.placement ? n.placement : n.positionAtClick ? [
      Yd(i, Fi),
      Yd(i, Bi),
      Yd(i, Li),
      Yd(i, Pi)
    ] : [Li, Pi, Fi, Bi]);
    function u() {
      a.value?.close();
    }
    function p() {
      n.disableCloseOnMenuClick || u();
    }
    function g() {
      n.disableCloseOnEscape || u();
    }
    return O0(Ie.escape, g), (E, h) => (c(), G(Sl, {
      ref_key: "popOver",
      ref: a,
      class: "p-context-menu",
      placement: s.value,
      group: E.group,
      "auto-close": !E.disableAutoClose
    }, {
      target: N(({ toggle: f, open: b, close: w, visible: x }) => [
        I(E.$slots, "target", ve(we({ toggle: f, open: b, close: w, visible: x })))
      ]),
      default: N(({ close: f }) => [
        I(E.$slots, "context-menu", ve(we({ close: f })), () => [
          ne(th, {
            class: "p-context-menu__content",
            onClick: xa(p, ["stop"])
          }, {
            default: N(() => [
              I(E.$slots, "default", ve(we({ close: f })))
            ]),
            _: 2
          }, 1024)
        ])
      ]),
      _: 3
    }, 8, ["placement", "group", "auto-close"]));
  }
}), jG = (t) => {
  t.component("PContextMenu", WG);
}, KG = /* @__PURE__ */ W({
  __name: "PContextNavItem",
  props: {
    to: {},
    title: {},
    icon: {}
  },
  setup(t) {
    const n = t, a = M(() => n.to ? "router-link" : "button"), i = M(() => n.to ? {
      role: "button",
      to: n.to
    } : {
      type: "button"
    });
    return (s, u) => (c(), G(Hr(a.value), oe({
      "exact-active-class": "p-context-nav-item--active",
      class: "p-context-nav-item"
    }, i.value), {
      default: N(() => [
        s.icon ? (c(), G(Dn, {
          key: 0,
          icon: s.icon,
          class: "p-context-nav-item__icon"
        }, null, 8, ["icon"])) : le("", !0),
        I(s.$slots, "default", {}, () => [
          d("span", null, ye(s.title), 1)
        ])
      ]),
      _: 3
    }, 16));
  }
}), QG = (t) => {
  t.component("PContextNavItem", KG);
}, XG = {}, JG = { class: "p-context-sidebar" }, eY = {
  key: 0,
  class: "p-context-sidebar__header"
}, tY = { class: "p-context-sidebar__body" }, nY = {
  key: 1,
  class: "p-context-sidebar__footer"
};
function rY(t, n) {
  return c(), _("div", JG, [
    t.$slots.header ? (c(), _("div", eY, [
      I(t.$slots, "header")
    ])) : le("", !0),
    d("div", tY, [
      I(t.$slots, "default")
    ]),
    t.$slots.footer ? (c(), _("div", nY, [
      I(t.$slots, "footer")
    ])) : le("", !0)
  ]);
}
const aY = /* @__PURE__ */ Wt(XG, [["render", rY]]), oY = (t) => {
  t.component("PContextSidebar", aY);
}, iY = { class: "p-date-button__value" }, sY = { class: "p-date-button__actions" }, v3 = /* @__PURE__ */ W({
  __name: "PDateButton",
  props: {
    date: {},
    clearable: { type: Boolean },
    showTime: { type: Boolean }
  },
  emits: ["clear"],
  setup(t, { expose: n, emit: a }) {
    const i = t, s = a, u = z(), p = M(() => u.value), g = M(() => i.showTime ? "MMM do, yyyy 'at' h:mm a" : "MMM do, yyyy"), E = M(() => i.date ? Mn(i.date, g.value) : i.showTime ? "Select date and time" : "Select date");
    return n({ el: p }), (h, f) => (c(), G(mo, { class: "p-date-button" }, mn({
      control: N(({ attrs: b }) => [
        d("button", oe({
          ref_key: "buttonElement",
          ref: u,
          type: "button",
          class: "p-date-button__control",
          "aria-hidden": "true"
        }, b), [
          d("span", iY, [
            I(h.$slots, "default", {}, () => [
              Ne(ye(E.value), 1)
            ])
          ])
        ], 16)
      ]),
      append: N(() => [
        d("div", sY, [
          h.date && h.clearable ? (c(), G(rn, {
            key: 0,
            small: "",
            flat: "",
            icon: "XCircleIcon",
            onClick: f[0] || (f[0] = (b) => s("clear"))
          })) : le("", !0),
          ne(rn, {
            small: "",
            flat: "",
            icon: "CalendarIcon"
          })
        ])
      ]),
      _: 2
    }, [
      Ye(h.$slots, (b, w) => ({
        name: w,
        fn: N((x) => [
          I(h.$slots, w, ve(we(x)))
        ])
      }))
    ]), 1024));
  }
}), E3 = /* @__PURE__ */ W({
  __name: "PInputPopOver",
  props: {
    disabled: { type: Boolean }
  },
  setup(t) {
    const n = t, a = z(), i = M(() => a.value?.visible ?? !1);
    function s() {
      !i.value && !n.disabled && a.value.open();
    }
    function u() {
      i.value && a.value.close();
    }
    O0("Escape", p);
    function p(E) {
      Dd.hover && i.value && (u(), E.preventDefault());
    }
    function g(E) {
      switch (E.key) {
        case Ie.escape:
        case Ie.tab:
          u();
          break;
        case Ie.space:
          i.value || s(), E.preventDefault();
          break;
      }
    }
    return (E, h) => (c(), G(Sl, {
      ref_key: "popOver",
      ref: a,
      placement: [y(Pi), y(Li), y(Fi), y(Bi), y(Lf), y(Pf)],
      class: "p-input-pop-over",
      "auto-close": "",
      onKeydown: g
    }, {
      target: N((f) => [
        I(E.$slots, "input", ve(we(f)))
      ]),
      default: N((f) => [
        I(E.$slots, "default", ve(we(f)))
      ]),
      _: 3
    }, 8, ["placement"]));
  }
}), lY = {
  key: 0,
  class: "p-label__header"
}, cY = ["for"], uY = {
  key: 1,
  class: "p-label__description"
}, dY = { class: "p-label__body" }, nh = /* @__PURE__ */ W({
  __name: "PLabel",
  props: {
    label: {},
    message: {},
    state: {},
    description: {},
    for: {}
  },
  setup(t) {
    const n = t, a = Yr(), i = M(() => n.state && !n.state.valid && n.state.validated && !n.state.pending), s = M(() => n.for ?? ml()), u = M(() => ({
      root: {
        "p-label--failed": i.value
      },
      message: {
        "p-label__message--failed": i.value
      }
    }));
    function p(g) {
      return typeof g == "string" && g.length > 0;
    }
    return (g, E) => (c(), _("div", {
      class: Oe(["p-label", u.value.root])
    }, [
      y(a).label || p(g.label) || y(a).description || p(g.description) ? (c(), _("div", lY, [
        y(a).label || p(g.label) ? (c(), _("label", {
          key: 0,
          for: s.value,
          class: "p-label__label"
        }, [
          I(g.$slots, "label", { id: s.value }, () => [
            d("span", null, ye(g.label), 1)
          ])
        ], 8, cY)) : le("", !0),
        y(a).description || p(g.description) ? (c(), _("div", uY, [
          I(g.$slots, "description", { id: s.value }, () => [
            d("span", null, ye(g.description), 1)
          ])
        ])) : le("", !0)
      ])) : le("", !0),
      d("div", dY, [
        I(g.$slots, "default", { id: s.value })
      ]),
      y(a).message || p(g.message) ? (c(), _("div", {
        key: 1,
        class: Oe(["p-label__message", u.value.message])
      }, [
        I(g.$slots, "message", { id: s.value }, () => [
          d("span", null, ye(g.message), 1)
        ])
      ], 2)) : le("", !0)
    ], 2));
  }
}), _Y = ["min", "max"], rh = /* @__PURE__ */ W({
  __name: "PNativeDateInput",
  props: {
    modelValue: {},
    min: {},
    max: {},
    disablePicker: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(t, { expose: n, emit: a }) {
    const i = t, s = a, u = z();
    n({ el: ql(u) });
    const p = M({
      get() {
        return i.modelValue ? Mn(i.modelValue, "yyyy-MM-dd") : null;
      },
      set(f) {
        if (!f) {
          s("update:modelValue", null);
          return;
        }
        const b = yC(f);
        i.modelValue && (b.setHours(i.modelValue.getHours()), b.setMinutes(i.modelValue.getMinutes())), s("update:modelValue", b);
      }
    }), g = M(() => i.min ? Mn(i.min, "yyyy-MM-dd") : void 0), E = M(() => i.max ? Mn(i.max, "yyyy-MM-dd") : "2999-12-31");
    function h() {
      u.value?.showPicker();
    }
    return (f, b) => {
      const w = ht("PButton");
      return c(), G(mo, { class: "p-native-date-input" }, mn({
        control: N(({ attrs: x }) => [
          ur(d("input", oe({
            ref_key: "inputElement",
            ref: u,
            "onUpdate:modelValue": b[0] || (b[0] = (A) => p.value = A),
            type: "date",
            class: "p-native-date-input__control",
            min: g.value,
            max: E.value
          }, x), null, 16, _Y), [
            [fl, p.value]
          ])
        ]),
        _: 2
      }, [
        Ye(f.$slots, (x, A) => ({
          name: A,
          fn: N((D) => [
            I(f.$slots, A, ve(we(D)))
          ])
        })),
        f.disablePicker ? void 0 : {
          name: "append",
          fn: N(() => [
            ne(w, {
              icon: "CalendarIcon",
              small: "",
              flat: "",
              class: "p-native-date-input__picker",
              onClick: h
            })
          ]),
          key: "0"
        }
      ]), 1024);
    };
  }
}), pY = ["min", "max"], b3 = /* @__PURE__ */ W({
  __name: "PNativeTimeInput",
  props: {
    modelValue: {},
    min: {},
    max: {},
    disablePicker: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(t, { expose: n, emit: a }) {
    const i = t, s = a, u = z();
    n({ el: ql(u) });
    const p = M({
      get() {
        return i.modelValue ? Mn(i.modelValue, "HH:mm") : null;
      },
      set(f) {
        if (!f) {
          s("update:modelValue", null);
          return;
        }
        const b = i.modelValue ?? /* @__PURE__ */ new Date(), w = hC(f, "H:mm", b);
        s("update:modelValue", w);
      }
    }), g = M(() => i.min ? Mn(i.min, "yyyy-MM-dd") : void 0), E = M(() => i.max ? Mn(i.max, "yyyy-MM-dd") : void 0);
    function h() {
      u.value?.showPicker();
    }
    return (f, b) => {
      const w = ht("PButton");
      return c(), G(mo, { class: "p-native-time-input" }, mn({
        control: N(({ attrs: x }) => [
          ur(d("input", oe({
            ref_key: "inputElement",
            ref: u,
            "onUpdate:modelValue": b[0] || (b[0] = (A) => p.value = A),
            type: "time",
            class: "p-native-time-input__control",
            min: g.value,
            max: E.value
          }, x), null, 16, pY), [
            [fl, p.value]
          ])
        ]),
        _: 2
      }, [
        Ye(f.$slots, (x, A) => ({
          name: A,
          fn: N((D) => [
            I(f.$slots, A, ve(we(D)))
          ])
        })),
        f.disablePicker ? void 0 : {
          name: "append",
          fn: N(() => [
            ne(w, {
              icon: "ClockIcon",
              small: "",
              flat: "",
              class: "p-native-time-input__picker",
              onClick: h
            })
          ]),
          key: "0"
        }
      ]), 1024);
    };
  }
}), mY = { class: "p-date-time-input__header" }, rf = /* @__PURE__ */ W({
  __name: "PDateTimeInputGroup",
  props: {
    modelValue: {},
    label: {},
    showTime: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: n }) {
    const a = t, i = n, s = M({
      get() {
        return a.modelValue ?? null;
      },
      set(E) {
        i("update:modelValue", E);
      }
    }), u = M({
      get() {
        return a.modelValue ?? null;
      },
      set(E) {
        E && i("update:modelValue", E);
      }
    }), p = M(() => a.showTime ? "Now" : "Today");
    function g() {
      if (a.showTime) {
        i("update:modelValue", c0(/* @__PURE__ */ new Date()));
        return;
      }
      i("update:modelValue", R7());
    }
    return (E, h) => (c(), G(nh, { class: "p-date-time-input-group" }, {
      label: N(() => [
        d("div", mY, [
          Ne(ye(E.label) + " ", 1),
          ne(rn, {
            small: "",
            class: "ml-auto",
            onClick: g
          }, {
            default: N(() => [
              Ne(ye(p.value), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: N(() => [
        ne(p0, { secondary: "" }, {
          default: N(() => [
            ne(rh, {
              modelValue: s.value,
              "onUpdate:modelValue": h[0] || (h[0] = (f) => s.value = f),
              "disable-picker": "",
              small: ""
            }, null, 8, ["modelValue"]),
            E.showTime ? (c(), G(b3, {
              key: 0,
              modelValue: u.value,
              "onUpdate:modelValue": h[1] || (h[1] = (f) => u.value = f),
              "disable-picker": "",
              small: ""
            }, null, 8, ["modelValue"])) : le("", !0)
          ]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
}), gY = { class: "p-date-picker__footer" }, D0 = /* @__PURE__ */ W({
  __name: "PDatePicker",
  props: {
    modelValue: {},
    viewingDate: {},
    showTime: { type: Boolean },
    min: {},
    minReason: {},
    max: {},
    maxReason: {}
  },
  emits: ["update:modelValue", "update:viewingDate", "apply", "close"],
  setup(t, { emit: n }) {
    const a = t, i = n, s = M(() => ({ min: a.min, max: a.max })), u = z(a.modelValue), p = z(a.modelValue ?? /* @__PURE__ */ new Date()), g = M({
      get() {
        return a.viewingDate ?? p.value;
      },
      set(f) {
        i("update:viewingDate", f), p.value = f;
      }
    });
    function E() {
      const f = u.value ? A0(u.value, s.value) : null;
      i("update:modelValue", f), i("apply"), h();
    }
    function h() {
      i("close");
    }
    return (f, b) => (c(), G(p0, {
      class: "p-date-picker",
      secondary: ""
    }, {
      default: N(() => [
        ne(c3, oe({
          modelValue: u.value,
          "onUpdate:modelValue": b[0] || (b[0] = (w) => u.value = w),
          viewingDate: g.value,
          "onUpdate:viewingDate": b[1] || (b[1] = (w) => g.value = w)
        }, { min: f.min, max: f.max, minReason: f.minReason, maxReason: f.maxReason }), {
          date: N((w) => [
            I(f.$slots, "date", ve(we(w)))
          ]),
          _: 3
        }, 16, ["modelValue", "viewingDate"]),
        ne(p0, { class: "p-date-picker__controls" }, {
          default: N(() => [
            I(f.$slots, "controls", {}, () => [
              ne(rf, oe({
                modelValue: u.value,
                "onUpdate:modelValue": b[2] || (b[2] = (w) => u.value = w)
              }, { showTime: f.showTime }, { label: "Selected Date" }), null, 16, ["modelValue"])
            ]),
            I(f.$slots, "after-controls")
          ]),
          _: 3
        }),
        d("div", gY, [
          ne(rn, {
            small: "",
            onClick: h
          }, {
            default: N(() => [...b[3] || (b[3] = [
              Ne(" Cancel ", -1)
            ])]),
            _: 1
          }),
          ne(rn, {
            small: "",
            primary: "",
            onClick: E
          }, {
            default: N(() => [...b[4] || (b[4] = [
              Ne(" Apply ", -1)
            ])]),
            _: 1
          })
        ])
      ]),
      _: 3
    }));
  }
}), fY = /* @__PURE__ */ W({
  __name: "PDateInput",
  props: {
    modelValue: {},
    viewingDate: {},
    showTime: { type: Boolean },
    clearable: { type: Boolean },
    disabled: { type: Boolean },
    min: {},
    max: {}
  },
  emits: ["update:modelValue", "update:viewingDate"],
  setup(t, { emit: n }) {
    const a = t, i = n, s = M({
      get() {
        return a.modelValue ?? null;
      },
      set(E) {
        i("update:modelValue", A0(E, { min: a.min, max: a.max }));
      }
    }), u = M({
      get() {
        return a.viewingDate;
      },
      set(E) {
        i("update:viewingDate", E);
      }
    });
    function p(E) {
      return {
        "p-date-input--open": E
      };
    }
    function g() {
      i("update:modelValue", null);
    }
    return (E, h) => (c(), G(E3, { class: "p-date-input" }, {
      input: N(({ open: f, visible: b }) => [
        I(E.$slots, "default", ve(we({ open: f, visible: b })), () => [
          y(Dd).hover ? (c(), G(v3, oe({
            key: 0,
            date: s.value,
            class: p(b)
          }, { showTime: E.showTime, disabled: E.disabled, clearable: E.clearable }, {
            onClick: f,
            onClear: g
          }), null, 16, ["date", "class", "onClick"])) : (c(), G(rh, oe({
            key: 1,
            modelValue: s.value,
            "onUpdate:modelValue": h[0] || (h[0] = (w) => s.value = w)
          }, { min: E.min, max: E.max, disabled: E.disabled }), null, 16, ["modelValue"]))
        ])
      ]),
      default: N(({ close: f }) => [
        ne(D0, oe({
          modelValue: s.value,
          "onUpdate:modelValue": h[1] || (h[1] = (b) => s.value = b),
          "viewing-date": u.value,
          "onUpdate:viewingDate": h[2] || (h[2] = (b) => u.value = b)
        }, { min: E.min, max: E.max, showTime: E.showTime }, { onClose: f }), mn({ _: 2 }, [
          Ye(E.$slots, (b, w) => ({
            name: w,
            fn: N((x) => [
              I(E.$slots, w, ve(we(x)))
            ])
          }))
        ]), 1040, ["modelValue", "viewing-date", "onClose"])
      ]),
      _: 3
    }));
  }
}), hY = (t) => {
  t.component("PDateInput", fY);
}, vY = (t) => {
  t.component("PDatePicker", D0);
}, S3 = /* @__PURE__ */ W({
  __name: "PDateRangePicker",
  props: {
    startDate: {},
    endDate: {},
    viewingDate: {},
    showTime: { type: Boolean },
    min: {},
    max: {}
  },
  emits: ["update:startDate", "update:endDate", "update:viewingDate", "apply", "close"],
  setup(t, { emit: n }) {
    const a = t, i = n, s = z(a.startDate), u = z(a.endDate), p = M({
      get() {
        return a.viewingDate ?? null;
      },
      set(P) {
        i("update:viewingDate", P);
      }
    }), g = M(() => ({
      dateWrapper: (P) => ({
        "p-date-range-picker__date-wrapper--selected": E(P),
        "p-date-range-picker__date-wrapper--selected-start": h(P),
        "p-date-range-picker__date-wrapper--selected-end": f(P),
        "p-date-range-picker__date-wrapper--in-range": b(P)
      }),
      date: (P, k) => ({
        "p-date-range-picker__date--today": P,
        "p-date-range-picker__date--out-of-month": !k
      })
    }));
    function E(P) {
      return h(P) || f(P);
    }
    function h(P) {
      return !!s.value && $l(P, s.value);
    }
    function f(P) {
      return !!u.value && $l(P, u.value);
    }
    function b(P) {
      return !s.value || !u.value ? !1 : I7(P, { min: s.value, max: u.value }, "day");
    }
    function w(P) {
      if (s.value && R0(P, s.value)) {
        A(u.value ? null : s.value), x(P);
        return;
      }
      if (!s.value)
        return x(P);
      if (!u.value)
        return A(P);
      x(P), A(null);
    }
    function x(P) {
      s.value = P && pl(P);
    }
    function A(P) {
      u.value = P && Uf(P);
    }
    function D(P) {
      s.value = P && c0(P);
    }
    function L(P) {
      u.value = P && Ay(P);
    }
    function $() {
      i("update:startDate", s.value), i("update:endDate", u.value), i("apply"), q();
    }
    function q() {
      i("close");
    }
    return (P, k) => (c(), G(D0, oe({
      viewingDate: p.value,
      "onUpdate:viewingDate": k[0] || (k[0] = (U) => p.value = U),
      "model-value": P.startDate ?? P.endDate
    }, { min: P.min, max: P.max }, {
      class: "p-date-range-picker",
      "onUpdate:modelValue": $,
      onClose: q
    }), {
      date: N(({ date: U, disabled: Z, today: ee, inMonth: X }) => [
        d("div", {
          class: Oe(["p-date-range-picker__date-wrapper", g.value.dateWrapper(U)])
        }, [
          ne(rn, {
            class: Oe(["p-date-range-picker__date", g.value.date(ee, X)]),
            disabled: Z,
            small: "",
            flat: "",
            onClick: (re) => w(U)
          }, {
            default: N(() => [
              I(P.$slots, "date", {
                date: U,
                isSelected: E(U),
                isInSelectedRange: b(U)
              }, () => [
                Ne(ye(U.getDate()), 1)
              ])
            ]),
            _: 2
          }, 1032, ["class", "disabled", "onClick"])
        ], 2)
      ]),
      controls: N(() => [
        ne(rf, {
          "model-value": s.value,
          "show-time": P.showTime,
          label: "Start Date",
          "onUpdate:modelValue": D
        }, null, 8, ["model-value", "show-time"]),
        ne(rf, {
          "model-value": u.value,
          "show-time": P.showTime,
          label: "End Date",
          "onUpdate:modelValue": L
        }, null, 8, ["model-value", "show-time"])
      ]),
      _: 3
    }, 16, ["viewingDate", "model-value"]));
  }
}), EY = { class: "p-date-range-input__target" }, Wh = "MMM do, yyyy", bY = /* @__PURE__ */ W({
  __name: "PDateRangeInput",
  props: {
    startDate: {},
    endDate: {},
    viewingDate: {},
    showTime: { type: Boolean },
    clearable: { type: Boolean },
    disabled: { type: Boolean },
    min: {},
    max: {}
  },
  emits: ["update:startDate", "update:endDate", "update:viewingDate"],
  setup(t, { emit: n }) {
    const a = t, i = n, s = M(() => a.startDate && a.endDate ? `${Mn(a.startDate, Wh)} - ${Mn(a.endDate, Wh)}` : "Select dates"), u = M({
      get() {
        return a.startDate;
      },
      set(w) {
        i("update:startDate", w);
      }
    }), p = M({
      get() {
        return a.endDate;
      },
      set(w) {
        i("update:endDate", w);
      }
    }), g = M({
      get() {
        return a.viewingDate;
      },
      set(w) {
        i("update:viewingDate", w);
      }
    });
    function E(w) {
      return {
        "p-date-input--open": w
      };
    }
    function h(w) {
      u.value = w;
    }
    function f(w) {
      p.value = w;
    }
    function b() {
      h(null), f(null), i("update:startDate", null), i("update:endDate", null);
    }
    return (w, x) => (c(), G(E3, { class: "p-date-input" }, {
      input: N(({ open: A, visible: D }) => [
        I(w.$slots, "default", ve(we({ open: A, visible: D })), () => [
          ne(v3, oe({
            date: w.startDate ?? w.endDate,
            class: E(D)
          }, { showTime: w.showTime, disabled: w.disabled, clearable: w.clearable }, {
            onClick: A,
            onClear: b
          }), {
            default: N(() => [
              d("div", EY, ye(s.value), 1)
            ]),
            _: 1
          }, 16, ["date", "class", "onClick"])
        ])
      ]),
      default: N(({ close: A }) => [
        ne(S3, oe({
          "start-date": u.value,
          "onUpdate:startDate": x[0] || (x[0] = (D) => u.value = D),
          "end-date": p.value,
          "onUpdate:endDate": x[1] || (x[1] = (D) => p.value = D),
          "viewing-date": g.value,
          "onUpdate:viewingDate": x[2] || (x[2] = (D) => g.value = D)
        }, { min: w.min, max: w.max, showTime: w.showTime }, { onClose: A }), mn({ _: 2 }, [
          Ye(w.$slots, (D, L) => ({
            name: L,
            fn: N(($) => [
              I(w.$slots, L, ve(we($)))
            ])
          }))
        ]), 1040, ["start-date", "end-date", "viewing-date", "onClose"])
      ]),
      _: 3
    }));
  }
}), SY = (t) => {
  t.component("PDateRangeInput", bY);
}, wY = (t) => {
  t.component("PDateRangePicker", S3);
}, w3 = /* @__PURE__ */ W({
  __name: "PNumberInput",
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(t, { emit: n }) {
    const a = t, i = n, s = M({
      get() {
        return a.modelValue ?? "";
      },
      set(g) {
        if (typeof g == "number") {
          i("update:modelValue", g);
          return;
        }
        const E = parseFloat(g), h = isNaN(E) ? null : E;
        i("update:modelValue", h);
      }
    });
    function u(g) {
      (g.key === Ie.e || g.key === Ie.E) && g.preventDefault();
    }
    function p(g) {
      const E = /[^0-9.]/g, h = g.clipboardData?.getData("text");
      h && E.test(h) && g.preventDefault();
    }
    return (g, E) => (c(), G(mo, { class: "p-number-input" }, mn({
      control: N(({ attrs: h }) => [
        ur(d("input", oe({
          "onUpdate:modelValue": E[0] || (E[0] = (f) => s.value = f),
          type: "number",
          class: "p-number-input__control"
        }, h, {
          onKeydown: u,
          onPaste: p
        }), null, 16), [
          [fl, s.value]
        ])
      ]),
      _: 2
    }, [
      Ye(g.$slots, (h, f) => ({
        name: f,
        fn: N((b) => [
          I(g.$slots, f, ve(we(b)))
        ])
      }))
    ]), 1024));
  }
}), yY = ["multiple"], TY = ["label"], CY = ["value", "selected", "disabled"], xY = ["value", "selected", "disabled"], AY = { class: "p-native-select__icon" }, y3 = /* @__PURE__ */ W({
  __name: "PNativeSelect",
  props: {
    modelValue: { type: [String, Number, Boolean, null, Array] },
    options: {}
  },
  emits: ["update:modelValue"],
  setup(t, { emit: n }) {
    const a = t, i = n, s = M({
      get() {
        return a.modelValue ?? null;
      },
      set(E) {
        i("update:modelValue", E);
      }
    }), u = M(() => Array.isArray(s.value)), p = M(() => a.options.map((E) => {
      const h = Ei(E);
      return gl(h) ? {
        ...h,
        options: Gl(h.options)
      } : h;
    })), g = M(() => ({
      "p-native-select__control--multiple": u.value
    }));
    return (E, h) => (c(), G(mo, { class: "p-native-select" }, mn({
      control: N(({ attrs: f }) => [
        ur(d("select", oe({
          "onUpdate:modelValue": h[0] || (h[0] = (b) => s.value = b),
          class: ["p-native-select__control", g.value],
          multiple: u.value
        }, f), [
          (c(!0), _(Qe, null, Ye(p.value, (b, w) => (c(), _(Qe, { key: w }, [
            y(gl)(b) ? (c(), _("optgroup", {
              key: 0,
              label: b.label
            }, [
              (c(!0), _(Qe, null, Ye(b.options, (x, A) => (c(), _("option", {
                key: A,
                class: "p-native-select__option",
                value: x.value,
                selected: x.value === s.value,
                disabled: x.disabled
              }, ye(x.label), 9, CY))), 128))
            ], 8, TY)) : (c(), _("option", {
              key: 1,
              class: "p-native-select__option",
              value: b.value,
              selected: b.value === s.value,
              disabled: b.disabled
            }, ye(b.label), 9, xY))
          ], 64))), 128))
        ], 16, yY), [
          [pE, s.value]
        ]),
        d("select", oe({
          class: ["p-native-select__control p-native-select__control--placeholder", g.value]
        }, f), null, 16)
      ]),
      append: N(() => [
        d("span", AY, [
          ne(Dn, { icon: "ChevronUpDownIcon" })
        ])
      ]),
      _: 2
    }, [
      Ye(E.$slots, (f, b) => ({
        name: b,
        fn: N((w) => [
          I(E.$slots, b, ve(we(w)))
        ])
      }))
    ]), 1024));
  }
}), RY = { class: "p-select-button__icon" }, OY = /* @__PURE__ */ W({
  __name: "PSelectButton",
  props: {
    small: { type: Boolean }
  },
  setup(t, { expose: n }) {
    const a = z(), i = M(() => a.value?.el), s = z(), u = M(() => s.value);
    n({ el: u, wrapper: i });
    const p = t, g = M(() => ({
      value: {
        "p-select-button__value--small": p.small
      }
    }));
    return (E, h) => {
      const f = ht("PIcon");
      return c(), G(mo, {
        ref_key: "wrapperElement",
        ref: a,
        class: "p-select-button",
        small: E.small
      }, mn({
        control: N(({ attrs: b }) => [
          d("button", oe({
            ref_key: "buttonElement",
            ref: s,
            type: "button",
            class: "p-select-button__control"
          }, b), [
            d("span", {
              class: Oe(["p-select-button__value", g.value.value])
            }, [
              I(E.$slots, "default")
            ], 2)
          ], 16)
        ]),
        append: N(() => [
          d("span", RY, [
            ne(f, { icon: "ChevronUpDownIcon" })
          ])
        ]),
        _: 2
      }, [
        Ye(E.$slots, (b, w) => ({
          name: w,
          fn: N((x) => [
            I(E.$slots, w, ve(we(x)))
          ])
        }))
      ]), 1032, ["small"]);
    };
  }
}), IY = { class: "p-select-option__text" }, T3 = /* @__PURE__ */ W({
  __name: "PSelectOption",
  props: {
    modelValue: { type: [String, Number, Boolean, null, Array] },
    highlightedValue: { type: [String, Number, Boolean, null, Symbol] },
    option: { type: [String, Number, Boolean, Object] },
    multiple: { type: Boolean },
    small: { type: Boolean }
  },
  emits: ["update:modelValue", "update:highlightedValue"],
  setup(t, { emit: n }) {
    const a = t, i = n, { option: s } = Nr(a), u = M({
      get() {
        return a.modelValue;
      },
      set(D) {
        s.value.disabled || i("update:modelValue", D);
      }
    }), p = M(() => a.multiple || Array.isArray(u.value)), g = M(() => Array.isArray(u.value) ? u.value.includes(s.value.value) : s.value.value === u.value), E = M({
      get() {
        return a.highlightedValue;
      },
      set(D) {
        i("update:highlightedValue", D);
      }
    }), h = M(() => ({
      "p-select-option--selected": g.value,
      "p-select-option--highlighted": E.value === s.value.value,
      "p-select-option--disabled": s.value.disabled,
      "p-select-option--small": a.small
    }));
    function f() {
      if (p.value && g.value) {
        A();
        return;
      }
      x();
    }
    function b() {
      s.value.disabled || (E.value = s.value.value);
    }
    function w() {
      s.value.disabled || (E.value = void 0);
    }
    function x() {
      Array.isArray(u.value) ? u.value = [...u.value, s.value.value] : u.value = s.value.value;
    }
    function A() {
      Array.isArray(u.value) ? u.value = u.value.filter((D) => D !== s.value.value) : u.value = null;
    }
    return (D, L) => (c(), _("div", {
      class: Oe(["p-select-option", h.value]),
      role: "option",
      onClick: f,
      onMouseenter: b,
      onMouseleave: w
    }, [
      p.value ? (c(), G(Ld, {
        key: 0,
        "model-value": g.value,
        disabled: y(s).disabled,
        small: D.small
      }, null, 8, ["model-value", "disabled", "small"])) : le("", !0),
      d("span", IY, [
        I(D.$slots, "default", {
          option: y(s),
          selected: g.value,
          highlighted: E.value === u.value
        }, () => [
          Ne(ye(y(s).label), 1)
        ])
      ])
    ], 34));
  }
}), NY = { class: "p-select-option-group__label" }, C3 = /* @__PURE__ */ W({
  __name: "PSelectOptionGroup",
  props: {
    group: {},
    small: { type: Boolean }
  },
  setup(t) {
    const n = t, a = M(() => ({
      "p-select-option-group--small": n.small
    }));
    return (i, s) => (c(), _("div", {
      class: Oe(["p-select-option-group", a.value]),
      role: "group"
    }, [
      d("div", NY, [
        I(i.$slots, "default", { group: i.group }, () => [
          Ne(ye(i.group.label), 1)
        ])
      ])
    ], 2));
  }
}), MY = /* @__PURE__ */ W({
  __name: "PVirtualScrollerChunk",
  props: {
    height: {},
    observerOptions: {},
    forceVisible: { type: Boolean }
  },
  setup(t) {
    const n = t, a = M(() => ({
      height: s.value ? void 0 : `${u.value ?? n.height}px`
    })), i = z(), s = z(!1), u = z(null), { observe: p } = Md(E, n.observerOptions);
    function g() {
      setTimeout(() => {
        const h = i.value.getBoundingClientRect();
        u.value = h.height;
      });
    }
    function E(h) {
      h.forEach((f) => {
        f.isIntersecting || g(), setTimeout(() => {
          s.value = f.isIntersecting;
        });
      });
    }
    return xt(() => {
      p(i);
    }), (h, f) => (c(), _("div", {
      ref_key: "el",
      ref: i,
      class: "p-virtual-scroller-chunk",
      style: Gr(a.value)
    }, [
      h.forceVisible || s.value ? I(h.$slots, "default", { key: 0 }) : le("", !0)
    ], 4));
  }
}), m0 = /* @__PURE__ */ new Map(), DY = () => {
};
function kY(t, n) {
  m0.set(t, n);
}
function jh(t) {
  m0.delete(t);
}
function XQ(t) {
  return {
    makeItemVisible: (i) => {
      const s = m0.get(t), u = s?.makeItemVisible(i);
      return s || console.warn(`scroller for ${t} not found while attempting to call makeItemVisible for ${i}`), u ?? DY;
    },
    scrollItemIntoView: (i, s) => {
      const u = m0.get(t);
      return u || console.warn(`scroller for ${t} not found while attempting to call scrollItemIntoView for ${i}`), u?.scrollItemIntoView(i, s) ?? Promise.resolve();
    }
  };
}
const ah = /* @__PURE__ */ W({
  __name: "PVirtualScroller",
  props: {
    items: {},
    itemEstimateHeight: { default: 50 },
    itemKey: { default: "id" },
    chunkSize: { default: 50 },
    observerOptions: { default: () => ({
      rootMargin: "200px"
    }) },
    element: { default: "div" },
    name: { default: void 0 }
  },
  emits: ["bottom"],
  setup(t, { expose: n, emit: a }) {
    const i = t, s = a;
    n({
      scrollItemIntoView: x
    }), tt(() => i.name, (k, U) => {
      U && jh(U), k && kY(k, {
        makeItemVisible: w,
        scrollItemIntoView: x
      });
    }, { immediate: !0 }), tt(() => i.items, () => E(p)), xt(() => {
      g(p);
    }), zr(() => {
      i.name && jh(i.name);
    });
    const u = z(), p = z(), { observe: g, check: E } = Md(A, i.observerOptions), h = Mr(/* @__PURE__ */ new Set()), f = M(() => {
      const k = [], U = i.items;
      for (let Z = 0; Z < U.length; Z += i.chunkSize)
        k.push(U.slice(Z, Z + i.chunkSize));
      return k;
    });
    function b(k) {
      return f.value.findIndex((U) => U.some((Z) => Z[i.itemKey] === k));
    }
    function w(k) {
      const U = b(k);
      return h.add(U), () => h.delete(U);
    }
    function x(k, U) {
      const Z = w(k), ee = b(k), { promise: X, resolve: re } = Promise.withResolvers();
      return Ct(async () => {
        if (!u.value)
          return;
        const Q = u.value.querySelector(`#${P(ee)}`);
        if (!Q)
          return;
        await Uh(Q, { ...U, block: "nearest" });
        const ce = u.value.querySelector(`#${i.name}-${k}`);
        ce && (await Uh(ce, U), Z(), re());
      }), X;
    }
    function A(k) {
      k.forEach((U) => {
        U.isIntersecting && s("bottom");
      });
    }
    function D(k, U) {
      return i.chunkSize * k + U;
    }
    function L(k) {
      return i.itemEstimateHeight * f.value[k].length;
    }
    function $(k) {
      return h.has(k);
    }
    function q(k) {
      return `${i.name}-${k[i.itemKey]}`;
    }
    function P(k) {
      return `${i.name}-chunk-${k}`;
    }
    return (k, U) => (c(), G(Hr(k.element), {
      ref_key: "scrollerRef",
      ref: u,
      class: "p-virtual-scroller"
    }, {
      default: N(() => [
        (c(!0), _(Qe, null, Ye(f.value, (Z, ee) => (c(), G(MY, {
          key: ee,
          id: P(ee),
          height: L(ee),
          "force-visible": $(ee),
          "observer-options": k.observerOptions
        }, {
          default: N(() => [
            (c(!0), _(Qe, null, Ye(Z, (X, re) => I(k.$slots, "default", {
              key: X[k.itemKey],
              id: q(X),
              item: X,
              index: D(ee, re)
            })), 128))
          ]),
          _: 2
        }, 1032, ["id", "height", "force-visible", "observer-options"]))), 128)),
        I(k.$slots, "bottom"),
        d("div", {
          ref_key: "bottom",
          ref: p,
          class: "p-virtual-scroller__bottom"
        }, null, 512)
      ]),
      _: 3
    }, 512));
  }
}), Ol = Symbol();
function LY(t) {
  const n = z(t), a = M(() => n.value.filter((h) => !h.disabled).map(({ value: h }) => h)), i = z(Ol);
  function s(h) {
    return h === Ol;
  }
  function u() {
    const h = a.value.indexOf(i.value), f = Math.min(h + 1, a.value.length - 1);
    i.value = a.value[f];
  }
  function p() {
    if (i.value === Ol) {
      i.value = a.value[a.value.length - 1];
      return;
    }
    const h = a.value.indexOf(i.value), f = Math.max(h - 1, 0);
    i.value = a.value[f];
  }
  function g() {
    i.value = Ol;
  }
  return tt(a, (h) => {
    i.value !== Ol && (h.includes(i.value) || (i.value = Ol));
  }), {
    highlightedValue: i,
    isUnselected: s,
    setNextHighlightedValue: u,
    setPreviousHighlightedValue: p,
    setHighlightedValueUnselected: g
  };
}
const k0 = /* @__PURE__ */ W({
  __name: "PSelectOptions",
  props: {
    modelValue: { type: [String, Number, Boolean, null, Array] },
    options: {},
    multiple: { type: Boolean },
    small: { type: Boolean }
  },
  emits: ["update:modelValue", "bottom"],
  setup(t, { emit: n }) {
    const a = t, i = n, s = M({
      get() {
        return a.multiple ? a.modelValue ?? [] : a.modelValue ?? null;
      },
      set(U) {
        i("update:modelValue", U);
      }
    }), u = z(), p = z(), g = M(() => ({
      root: u.value,
      disconnectWhenVisible: !1
    })), { visible: E } = R4(p, g), h = M(() => ({
      root: {
        "p-select-options--end": E.value || a.options.length === 0,
        "p-select-options--small": a.small
      }
    }));
    function f(U) {
      return gl(U) ? [
        U,
        ...U.options.flatMap((Z) => f(Z))
      ] : [U];
    }
    function b(U) {
      if (Array.isArray(s.value)) {
        s.value = py(s.value, U);
        return;
      }
      s.value = U;
    }
    const w = M(() => a.options.map((U) => Ei(U))), x = M(() => w.value.flatMap((U) => f(U))), A = M(() => Gl(w.value)), { highlightedValue: D, isUnselected: L, setHighlightedValueUnselected: $, setNextHighlightedValue: q, setPreviousHighlightedValue: P } = LY(A);
    O0(["ArrowDown", "ArrowUp", " ", "Enter"], k);
    function k(U) {
      if (!Qf(U.key))
        switch (U.key) {
          case Ie.upArrow:
            P(), U.preventDefault();
            break;
          case Ie.downArrow:
            q(), U.preventDefault();
            break;
          case Ie.space:
          case Ie.enter:
            if (L(D.value))
              return;
            b(D.value), U.preventDefault();
            break;
        }
    }
    return (U, Z) => (c(), _("div", {
      ref_key: "root",
      ref: u,
      class: Oe(["p-select-options", h.value.root]),
      role: "listbox",
      onMouseleave: Z[3] || (Z[3] = //@ts-ignore
      (...ee) => y($) && y($)(...ee))
    }, [
      I(U.$slots, "pre-options"),
      ne(ah, {
        items: x.value,
        "item-key": "label",
        class: "p-select-options__options",
        onBottom: Z[2] || (Z[2] = (ee) => i("bottom"))
      }, {
        default: N(({ item: ee, index: X }) => [
          y(XV)(ee) ? (c(), G(C3, {
            key: 0,
            group: ee,
            small: U.small
          }, {
            default: N((re) => [
              I(U.$slots, "group", ve(we(re)))
            ]),
            _: 3
          }, 8, ["group", "small"])) : (c(), G(T3, {
            key: 1,
            modelValue: s.value,
            "onUpdate:modelValue": Z[0] || (Z[0] = (re) => s.value = re),
            highlightedValue: y(D),
            "onUpdate:highlightedValue": Z[1] || (Z[1] = (re) => pf(D) ? D.value = re : null),
            option: ee,
            multiple: U.multiple,
            small: U.small
          }, {
            default: N((re) => [
              I(U.$slots, "option", ve(we({ ...re, index: X })))
            ]),
            _: 2
          }, 1032, ["modelValue", "highlightedValue", "option", "multiple", "small"]))
        ]),
        bottom: N(() => [
          d("div", {
            ref_key: "end",
            ref: p
          }, null, 512),
          U.options.length ? I(U.$slots, "bottom", { key: 1 }) : I(U.$slots, "options-empty", { key: 0 }, () => [
            Z[4] || (Z[4] = d("div", { class: "p-select-options__options--empty" }, " No options ", -1))
          ])
        ]),
        _: 3
      }, 8, ["items"]),
      I(U.$slots, "post-options")
    ], 34));
  }
}), PY = {
  key: 0,
  class: "p-tag__icon"
}, Yl = /* @__PURE__ */ W({
  __name: "PTag",
  props: {
    icon: {},
    label: {},
    value: {},
    dismissible: { type: Boolean },
    small: { type: Boolean }
  },
  emits: ["dismiss"],
  setup(t, { emit: n }) {
    const a = t, i = n, s = M(() => Jf(a.value ?? a.label ?? "")), u = M(() => ({
      root: {
        "p-tag--dismissible": a.dismissible,
        "p-tag--small": a.small
      }
    }));
    return (p, g) => (c(), _("span", {
      class: Oe(["p-tag", u.value.root])
    }, [
      p.icon ? (c(), _("div", PY, [
        ne(Dn, {
          icon: p.icon,
          size: "small"
        }, null, 8, ["icon"])
      ])) : le("", !0),
      I(p.$slots, "default", {}, () => [
        Ne(ye(s.value.label), 1)
      ]),
      p.dismissible ? (c(), _("button", {
        key: 1,
        type: "button",
        class: "p-tag__dismiss",
        onClick: g[0] || (g[0] = xa((E) => i("dismiss", s.value), ["stop"]))
      }, [
        ne(Dn, {
          icon: "XMarkIcon",
          size: "small",
          class: "p-tag__icon p-tag__icon--dismiss"
        })
      ])) : le("", !0)
    ], 2));
  }
});
var zd = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Ed = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
var BY = Ed.exports, Kh;
function FY() {
  return Kh || (Kh = 1, function(t, n) {
    (function() {
      var a, i = "4.17.21", s = 200, u = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", p = "Expected a function", g = "Invalid `variable` option passed into `_.template`", E = "__lodash_hash_undefined__", h = 500, f = "__lodash_placeholder__", b = 1, w = 2, x = 4, A = 1, D = 2, L = 1, $ = 2, q = 4, P = 8, k = 16, U = 32, Z = 64, ee = 128, X = 256, re = 512, Q = 30, ce = "...", me = 800, Se = 16, Le = 1, qe = 2, _t = 3, ot = 1 / 0, st = 9007199254740991, Me = 17976931348623157e292, je = NaN, Fe = 4294967295, Pn = Fe - 1, Rt = Fe >>> 1, Zr = [
        ["ary", ee],
        ["bind", L],
        ["bindKey", $],
        ["curry", P],
        ["curryRight", k],
        ["flip", re],
        ["partial", U],
        ["partialRight", Z],
        ["rearg", X]
      ], De = "[object Arguments]", gn = "[object Array]", Ot = "[object AsyncFunction]", mt = "[object Boolean]", an = "[object Date]", ha = "[object DOMException]", pr = "[object Error]", Cn = "[object Function]", qr = "[object GeneratorFunction]", pt = "[object Map]", Xn = "[object Number]", go = "[object Null]", Ft = "[object Object]", va = "[object Promise]", Ja = "[object Proxy]", dr = "[object RegExp]", Ut = "[object Set]", mr = "[object String]", gr = "[object Symbol]", Ra = "[object Undefined]", xn = "[object WeakMap]", Ea = "[object WeakSet]", Bn = "[object ArrayBuffer]", An = "[object DataView]", Wr = "[object Float32Array]", fn = "[object Float64Array]", jr = "[object Int8Array]", fr = "[object Int16Array]", Dr = "[object Int32Array]", Rn = "[object Uint8Array]", Fn = "[object Uint8ClampedArray]", kr = "[object Uint16Array]", Lr = "[object Uint32Array]", $i = /\b__p \+= '';/g, _r = /\b(__p \+=) '' \+/g, Oa = /(__e\(.*?\)|\b__t\)) \+\n'';/g, fo = /&(?:amp|lt|gt|quot|#39);/g, Kr = /[&<>"']/g, ho = RegExp(fo.source), Ia = RegExp(Kr.source), qt = /<%-([\s\S]+?)%>/g, Pr = /<%([\s\S]+?)%>/g, Na = /<%=([\s\S]+?)%>/g, ba = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, vo = /^\w*$/, bi = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Sa = /[\\^$.*+?()[\]{}|]/g, Vi = RegExp(Sa.source), On = /^\s+/, Qr = /\s/, eo = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Br = /\{\n\/\* \[wrapped with (.+)\] \*/, Eo = /,? & /, Si = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, hr = /[()=,{}\[\]\/\s]/, wi = /\\(\\)?/g, yi = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, jn = /\w*$/, Ti = /^[-+]0x[0-9a-f]+$/i, Hi = /^0b[01]+$/i, Pe = /^\[object .+?Constructor\]$/, K = /^0o[0-7]+$/i, pe = /^(?:0|[1-9]\d*)$/, xe = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, ut = /($^)/, hn = /['\n\r\u2028\u2029\\]/g, bt = "\\ud800-\\udfff", In = "\\u0300-\\u036f", vr = "\\ufe20-\\ufe2f", Fr = "\\u20d0-\\u20ff", Ma = In + vr + Fr, on = "\\u2700-\\u27bf", Jn = "a-z\\xdf-\\xf6\\xf8-\\xff", Ci = "\\xac\\xb1\\xd7\\xf7", rc = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", ac = "\\u2000-\\u206f", oc = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Gi = "A-Z\\xc0-\\xd6\\xd8-\\xde", Yi = "\\ufe0e\\ufe0f", to = Ci + rc + ac + oc, bo = "['’]", So = "[" + bt + "]", xi = "[" + to + "]", wa = "[" + Ma + "]", zi = "\\d+", ic = "[" + on + "]", Zi = "[" + Jn + "]", qi = "[^" + bt + to + zi + on + Jn + Gi + "]", no = "\\ud83c[\\udffb-\\udfff]", sc = "(?:" + wa + "|" + no + ")", Wi = "[^" + bt + "]", ro = "(?:\\ud83c[\\udde6-\\uddff]){2}", ya = "[\\ud800-\\udbff][\\udc00-\\udfff]", Nn = "[" + Gi + "]", ji = "\\u200d", Ki = "(?:" + Zi + "|" + qi + ")", Ta = "(?:" + Nn + "|" + qi + ")", Qi = "(?:" + bo + "(?:d|ll|m|re|s|t|ve))?", Xi = "(?:" + bo + "(?:D|LL|M|RE|S|T|VE))?", Ji = sc + "?", es = "[" + Yi + "]?", lc = "(?:" + ji + "(?:" + [Wi, ro, ya].join("|") + ")" + es + Ji + ")*", Da = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", wl = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", ts = es + Ji + lc, Ai = "(?:" + [ic, ro, ya].join("|") + ")" + ts, cc = "(?:" + [Wi + wa + "?", wa, ro, ya, So].join("|") + ")", ns = RegExp(bo, "g"), uc = RegExp(wa, "g"), ao = RegExp(no + "(?=" + no + ")|" + cc + ts, "g"), yl = RegExp([
        Nn + "?" + Zi + "+" + Qi + "(?=" + [xi, Nn, "$"].join("|") + ")",
        Ta + "+" + Xi + "(?=" + [xi, Nn + Ki, "$"].join("|") + ")",
        Nn + "?" + Ki + "+" + Qi,
        Nn + "+" + Xi,
        wl,
        Da,
        zi,
        Ai
      ].join("|"), "g"), Tl = RegExp("[" + ji + bt + Ma + Yi + "]"), wo = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, Cl = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ], dc = -1, He = {};
      He[Wr] = He[fn] = He[jr] = He[fr] = He[Dr] = He[Rn] = He[Fn] = He[kr] = He[Lr] = !0, He[De] = He[gn] = He[Bn] = He[mt] = He[An] = He[an] = He[pr] = He[Cn] = He[pt] = He[Xn] = He[Ft] = He[dr] = He[Ut] = He[mr] = He[xn] = !1;
      var $e = {};
      $e[De] = $e[gn] = $e[Bn] = $e[An] = $e[mt] = $e[an] = $e[Wr] = $e[fn] = $e[jr] = $e[fr] = $e[Dr] = $e[pt] = $e[Xn] = $e[Ft] = $e[dr] = $e[Ut] = $e[mr] = $e[gr] = $e[Rn] = $e[Fn] = $e[kr] = $e[Lr] = !0, $e[pr] = $e[Cn] = $e[xn] = !1;
      var F = {
        // Latin-1 Supplement block.
        À: "A",
        Á: "A",
        Â: "A",
        Ã: "A",
        Ä: "A",
        Å: "A",
        à: "a",
        á: "a",
        â: "a",
        ã: "a",
        ä: "a",
        å: "a",
        Ç: "C",
        ç: "c",
        Ð: "D",
        ð: "d",
        È: "E",
        É: "E",
        Ê: "E",
        Ë: "E",
        è: "e",
        é: "e",
        ê: "e",
        ë: "e",
        Ì: "I",
        Í: "I",
        Î: "I",
        Ï: "I",
        ì: "i",
        í: "i",
        î: "i",
        ï: "i",
        Ñ: "N",
        ñ: "n",
        Ò: "O",
        Ó: "O",
        Ô: "O",
        Õ: "O",
        Ö: "O",
        Ø: "O",
        ò: "o",
        ó: "o",
        ô: "o",
        õ: "o",
        ö: "o",
        ø: "o",
        Ù: "U",
        Ú: "U",
        Û: "U",
        Ü: "U",
        ù: "u",
        ú: "u",
        û: "u",
        ü: "u",
        Ý: "Y",
        ý: "y",
        ÿ: "y",
        Æ: "Ae",
        æ: "ae",
        Þ: "Th",
        þ: "th",
        ß: "ss",
        // Latin Extended-A block.
        Ā: "A",
        Ă: "A",
        Ą: "A",
        ā: "a",
        ă: "a",
        ą: "a",
        Ć: "C",
        Ĉ: "C",
        Ċ: "C",
        Č: "C",
        ć: "c",
        ĉ: "c",
        ċ: "c",
        č: "c",
        Ď: "D",
        Đ: "D",
        ď: "d",
        đ: "d",
        Ē: "E",
        Ĕ: "E",
        Ė: "E",
        Ę: "E",
        Ě: "E",
        ē: "e",
        ĕ: "e",
        ė: "e",
        ę: "e",
        ě: "e",
        Ĝ: "G",
        Ğ: "G",
        Ġ: "G",
        Ģ: "G",
        ĝ: "g",
        ğ: "g",
        ġ: "g",
        ģ: "g",
        Ĥ: "H",
        Ħ: "H",
        ĥ: "h",
        ħ: "h",
        Ĩ: "I",
        Ī: "I",
        Ĭ: "I",
        Į: "I",
        İ: "I",
        ĩ: "i",
        ī: "i",
        ĭ: "i",
        į: "i",
        ı: "i",
        Ĵ: "J",
        ĵ: "j",
        Ķ: "K",
        ķ: "k",
        ĸ: "k",
        Ĺ: "L",
        Ļ: "L",
        Ľ: "L",
        Ŀ: "L",
        Ł: "L",
        ĺ: "l",
        ļ: "l",
        ľ: "l",
        ŀ: "l",
        ł: "l",
        Ń: "N",
        Ņ: "N",
        Ň: "N",
        Ŋ: "N",
        ń: "n",
        ņ: "n",
        ň: "n",
        ŋ: "n",
        Ō: "O",
        Ŏ: "O",
        Ő: "O",
        ō: "o",
        ŏ: "o",
        ő: "o",
        Ŕ: "R",
        Ŗ: "R",
        Ř: "R",
        ŕ: "r",
        ŗ: "r",
        ř: "r",
        Ś: "S",
        Ŝ: "S",
        Ş: "S",
        Š: "S",
        ś: "s",
        ŝ: "s",
        ş: "s",
        š: "s",
        Ţ: "T",
        Ť: "T",
        Ŧ: "T",
        ţ: "t",
        ť: "t",
        ŧ: "t",
        Ũ: "U",
        Ū: "U",
        Ŭ: "U",
        Ů: "U",
        Ű: "U",
        Ų: "U",
        ũ: "u",
        ū: "u",
        ŭ: "u",
        ů: "u",
        ű: "u",
        ų: "u",
        Ŵ: "W",
        ŵ: "w",
        Ŷ: "Y",
        ŷ: "y",
        Ÿ: "Y",
        Ź: "Z",
        Ż: "Z",
        Ž: "Z",
        ź: "z",
        ż: "z",
        ž: "z",
        Ĳ: "IJ",
        ĳ: "ij",
        Œ: "Oe",
        œ: "oe",
        ŉ: "'n",
        ſ: "s"
      }, J = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }, se = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      }, Re = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      }, It = parseFloat, Xe = parseInt, $t = typeof zd == "object" && zd && zd.Object === Object && zd, vn = typeof self == "object" && self && self.Object === Object && self, Ge = $t || vn || Function("return this")(), St = n && !n.nodeType && n, Nt = St && !0 && t && !t.nodeType && t, er = Nt && Nt.exports === St, sn = er && $t.process, it = function() {
        try {
          var R = Nt && Nt.require && Nt.require("util").types;
          return R || sn && sn.binding && sn.binding("util");
        } catch {
        }
      }(), Kn = it && it.isArrayBuffer, Ur = it && it.isDate, Er = it && it.isMap, Xr = it && it.isRegExp, Ri = it && it.isSet, oo = it && it.isTypedArray;
      function vt(R, V, B) {
        switch (B.length) {
          case 0:
            return R.call(V);
          case 1:
            return R.call(V, B[0]);
          case 2:
            return R.call(V, B[0], B[1]);
          case 3:
            return R.call(V, B[0], B[1], B[2]);
        }
        return R.apply(V, B);
      }
      function B0(R, V, B, ae) {
        for (var ge = -1, ke = R == null ? 0 : R.length; ++ge < ke; ) {
          var rt = R[ge];
          V(ae, rt, B(rt), R);
        }
        return ae;
      }
      function jt(R, V) {
        for (var B = -1, ae = R == null ? 0 : R.length; ++B < ae && V(R[B], B, R) !== !1; )
          ;
        return R;
      }
      function F0(R, V) {
        for (var B = R == null ? 0 : R.length; B-- && V(R[B], B, R) !== !1; )
          ;
        return R;
      }
      function _c(R, V) {
        for (var B = -1, ae = R == null ? 0 : R.length; ++B < ae; )
          if (!V(R[B], B, R))
            return !1;
        return !0;
      }
      function tr(R, V) {
        for (var B = -1, ae = R == null ? 0 : R.length, ge = 0, ke = []; ++B < ae; ) {
          var rt = R[B];
          V(rt, B, R) && (ke[ge++] = rt);
        }
        return ke;
      }
      function yo(R, V) {
        var B = R == null ? 0 : R.length;
        return !!B && Jr(R, V, 0) > -1;
      }
      function rs(R, V, B) {
        for (var ae = -1, ge = R == null ? 0 : R.length; ++ae < ge; )
          if (B(V, R[ae]))
            return !0;
        return !1;
      }
      function ze(R, V) {
        for (var B = -1, ae = R == null ? 0 : R.length, ge = Array(ae); ++B < ae; )
          ge[B] = V(R[B], B, R);
        return ge;
      }
      function nr(R, V) {
        for (var B = -1, ae = V.length, ge = R.length; ++B < ae; )
          R[ge + B] = V[B];
        return R;
      }
      function as(R, V, B, ae) {
        var ge = -1, ke = R == null ? 0 : R.length;
        for (ae && ke && (B = R[++ge]); ++ge < ke; )
          B = V(B, R[ge], ge, R);
        return B;
      }
      function U0(R, V, B, ae) {
        var ge = R == null ? 0 : R.length;
        for (ae && ge && (B = R[--ge]); ge--; )
          B = V(B, R[ge], ge, R);
        return B;
      }
      function os(R, V) {
        for (var B = -1, ae = R == null ? 0 : R.length; ++B < ae; )
          if (V(R[B], B, R))
            return !0;
        return !1;
      }
      var $0 = is("length");
      function V0(R) {
        return R.split("");
      }
      function H0(R) {
        return R.match(Si) || [];
      }
      function pc(R, V, B) {
        var ae;
        return B(R, function(ge, ke, rt) {
          if (V(ge, ke, rt))
            return ae = ke, !1;
        }), ae;
      }
      function To(R, V, B, ae) {
        for (var ge = R.length, ke = B + (ae ? 1 : -1); ae ? ke-- : ++ke < ge; )
          if (V(R[ke], ke, R))
            return ke;
        return -1;
      }
      function Jr(R, V, B) {
        return V === V ? e1(R, V, B) : To(R, mc, B);
      }
      function G0(R, V, B, ae) {
        for (var ge = B - 1, ke = R.length; ++ge < ke; )
          if (ae(R[ge], V))
            return ge;
        return -1;
      }
      function mc(R) {
        return R !== R;
      }
      function gc(R, V) {
        var B = R == null ? 0 : R.length;
        return B ? ls(R, V) / B : je;
      }
      function is(R) {
        return function(V) {
          return V == null ? a : V[R];
        };
      }
      function ss(R) {
        return function(V) {
          return R == null ? a : R[V];
        };
      }
      function fc(R, V, B, ae, ge) {
        return ge(R, function(ke, rt, Ve) {
          B = ae ? (ae = !1, ke) : V(B, ke, rt, Ve);
        }), B;
      }
      function Y0(R, V) {
        var B = R.length;
        for (R.sort(V); B--; )
          R[B] = R[B].value;
        return R;
      }
      function ls(R, V) {
        for (var B, ae = -1, ge = R.length; ++ae < ge; ) {
          var ke = V(R[ae]);
          ke !== a && (B = B === a ? ke : B + ke);
        }
        return B;
      }
      function cs(R, V) {
        for (var B = -1, ae = Array(R); ++B < R; )
          ae[B] = V(B);
        return ae;
      }
      function z0(R, V) {
        return ze(V, function(B) {
          return [B, R[B]];
        });
      }
      function hc(R) {
        return R && R.slice(0, Sc(R) + 1).replace(On, "");
      }
      function Ht(R) {
        return function(V) {
          return R(V);
        };
      }
      function us(R, V) {
        return ze(V, function(B) {
          return R[B];
        });
      }
      function ka(R, V) {
        return R.has(V);
      }
      function vc(R, V) {
        for (var B = -1, ae = R.length; ++B < ae && Jr(V, R[B], 0) > -1; )
          ;
        return B;
      }
      function Ec(R, V) {
        for (var B = R.length; B-- && Jr(V, R[B], 0) > -1; )
          ;
        return B;
      }
      function Z0(R, V) {
        for (var B = R.length, ae = 0; B--; )
          R[B] === V && ++ae;
        return ae;
      }
      var q0 = ss(F), W0 = ss(J);
      function j0(R) {
        return "\\" + Re[R];
      }
      function K0(R, V) {
        return R == null ? a : R[V];
      }
      function ea(R) {
        return Tl.test(R);
      }
      function Q0(R) {
        return wo.test(R);
      }
      function X0(R) {
        for (var V, B = []; !(V = R.next()).done; )
          B.push(V.value);
        return B;
      }
      function ds(R) {
        var V = -1, B = Array(R.size);
        return R.forEach(function(ae, ge) {
          B[++V] = [ge, ae];
        }), B;
      }
      function bc(R, V) {
        return function(B) {
          return R(V(B));
        };
      }
      function rr(R, V) {
        for (var B = -1, ae = R.length, ge = 0, ke = []; ++B < ae; ) {
          var rt = R[B];
          (rt === V || rt === f) && (R[B] = f, ke[ge++] = B);
        }
        return ke;
      }
      function Co(R) {
        var V = -1, B = Array(R.size);
        return R.forEach(function(ae) {
          B[++V] = ae;
        }), B;
      }
      function J0(R) {
        var V = -1, B = Array(R.size);
        return R.forEach(function(ae) {
          B[++V] = [ae, ae];
        }), B;
      }
      function e1(R, V, B) {
        for (var ae = B - 1, ge = R.length; ++ae < ge; )
          if (R[ae] === V)
            return ae;
        return -1;
      }
      function t1(R, V, B) {
        for (var ae = B + 1; ae--; )
          if (R[ae] === V)
            return ae;
        return ae;
      }
      function ta(R) {
        return ea(R) ? r1(R) : $0(R);
      }
      function ln(R) {
        return ea(R) ? a1(R) : V0(R);
      }
      function Sc(R) {
        for (var V = R.length; V-- && Qr.test(R.charAt(V)); )
          ;
        return V;
      }
      var n1 = ss(se);
      function r1(R) {
        for (var V = ao.lastIndex = 0; ao.test(R); )
          ++V;
        return V;
      }
      function a1(R) {
        return R.match(ao) || [];
      }
      function o1(R) {
        return R.match(yl) || [];
      }
      var i1 = function R(V) {
        V = V == null ? Ge : na.defaults(Ge.Object(), V, na.pick(Ge, Cl));
        var B = V.Array, ae = V.Date, ge = V.Error, ke = V.Function, rt = V.Math, Ve = V.Object, _s = V.RegExp, s1 = V.String, Kt = V.TypeError, xo = B.prototype, l1 = ke.prototype, ra = Ve.prototype, Ao = V["__core-js_shared__"], Ro = l1.toString, Ue = ra.hasOwnProperty, c1 = 0, wc = function() {
          var e = /[^.]+$/.exec(Ao && Ao.keys && Ao.keys.IE_PROTO || "");
          return e ? "Symbol(src)_1." + e : "";
        }(), Oo = ra.toString, u1 = Ro.call(Ve), d1 = Ge._, _1 = _s(
          "^" + Ro.call(Ue).replace(Sa, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
        ), Io = er ? V.Buffer : a, ar = V.Symbol, No = V.Uint8Array, yc = Io ? Io.allocUnsafe : a, Mo = bc(Ve.getPrototypeOf, Ve), Tc = Ve.create, Cc = ra.propertyIsEnumerable, Do = xo.splice, xc = ar ? ar.isConcatSpreadable : a, La = ar ? ar.iterator : a, br = ar ? ar.toStringTag : a, ko = function() {
          try {
            var e = Cr(Ve, "defineProperty");
            return e({}, "", {}), e;
          } catch {
          }
        }(), p1 = V.clearTimeout !== Ge.clearTimeout && V.clearTimeout, m1 = ae && ae.now !== Ge.Date.now && ae.now, g1 = V.setTimeout !== Ge.setTimeout && V.setTimeout, Lo = rt.ceil, Po = rt.floor, ps = Ve.getOwnPropertySymbols, f1 = Io ? Io.isBuffer : a, Ac = V.isFinite, h1 = xo.join, v1 = bc(Ve.keys, Ve), at = rt.max, gt = rt.min, E1 = ae.now, b1 = V.parseInt, Rc = rt.random, S1 = xo.reverse, ms = Cr(V, "DataView"), Pa = Cr(V, "Map"), gs = Cr(V, "Promise"), aa = Cr(V, "Set"), Ba = Cr(V, "WeakMap"), Fa = Cr(Ve, "create"), Bo = Ba && new Ba(), oa = {}, w1 = xr(ms), y1 = xr(Pa), T1 = xr(gs), C1 = xr(aa), x1 = xr(Ba), Fo = ar ? ar.prototype : a, Ua = Fo ? Fo.valueOf : a, Oc = Fo ? Fo.toString : a;
        function v(e) {
          if (Ke(e) && !fe(e) && !(e instanceof Ce)) {
            if (e instanceof Qt)
              return e;
            if (Ue.call(e, "__wrapped__"))
              return Iu(e);
          }
          return new Qt(e);
        }
        var ia = /* @__PURE__ */ function() {
          function e() {
          }
          return function(r) {
            if (!We(r))
              return {};
            if (Tc)
              return Tc(r);
            e.prototype = r;
            var o = new e();
            return e.prototype = a, o;
          };
        }();
        function Uo() {
        }
        function Qt(e, r) {
          this.__wrapped__ = e, this.__actions__ = [], this.__chain__ = !!r, this.__index__ = 0, this.__values__ = a;
        }
        v.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          escape: qt,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          evaluate: Pr,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          interpolate: Na,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          variable: "",
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          imports: {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            _: v
          }
        }, v.prototype = Uo.prototype, v.prototype.constructor = v, Qt.prototype = ia(Uo.prototype), Qt.prototype.constructor = Qt;
        function Ce(e) {
          this.__wrapped__ = e, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = Fe, this.__views__ = [];
        }
        function A1() {
          var e = new Ce(this.__wrapped__);
          return e.__actions__ = Mt(this.__actions__), e.__dir__ = this.__dir__, e.__filtered__ = this.__filtered__, e.__iteratees__ = Mt(this.__iteratees__), e.__takeCount__ = this.__takeCount__, e.__views__ = Mt(this.__views__), e;
        }
        function R1() {
          if (this.__filtered__) {
            var e = new Ce(this);
            e.__dir__ = -1, e.__filtered__ = !0;
          } else
            e = this.clone(), e.__dir__ *= -1;
          return e;
        }
        function O1() {
          var e = this.__wrapped__.value(), r = this.__dir__, o = fe(e), l = r < 0, m = o ? e.length : 0, S = V_(0, m, this.__views__), T = S.start, C = S.end, O = C - T, H = l ? C : T - 1, Y = this.__iteratees__, j = Y.length, te = 0, ie = gt(O, this.__takeCount__);
          if (!o || !l && m == O && ie == O)
            return Jc(e, this.__actions__);
          var de = [];
          e:
            for (; O-- && te < ie; ) {
              H += r;
              for (var Ee = -1, _e = e[H]; ++Ee < j; ) {
                var Te = Y[Ee], Ae = Te.iteratee, zt = Te.type, Tt = Ae(_e);
                if (zt == qe)
                  _e = Tt;
                else if (!Tt) {
                  if (zt == Le)
                    continue e;
                  break e;
                }
              }
              de[te++] = _e;
            }
          return de;
        }
        Ce.prototype = ia(Uo.prototype), Ce.prototype.constructor = Ce;
        function Sr(e) {
          var r = -1, o = e == null ? 0 : e.length;
          for (this.clear(); ++r < o; ) {
            var l = e[r];
            this.set(l[0], l[1]);
          }
        }
        function I1() {
          this.__data__ = Fa ? Fa(null) : {}, this.size = 0;
        }
        function N1(e) {
          var r = this.has(e) && delete this.__data__[e];
          return this.size -= r ? 1 : 0, r;
        }
        function M1(e) {
          var r = this.__data__;
          if (Fa) {
            var o = r[e];
            return o === E ? a : o;
          }
          return Ue.call(r, e) ? r[e] : a;
        }
        function D1(e) {
          var r = this.__data__;
          return Fa ? r[e] !== a : Ue.call(r, e);
        }
        function k1(e, r) {
          var o = this.__data__;
          return this.size += this.has(e) ? 0 : 1, o[e] = Fa && r === a ? E : r, this;
        }
        Sr.prototype.clear = I1, Sr.prototype.delete = N1, Sr.prototype.get = M1, Sr.prototype.has = D1, Sr.prototype.set = k1;
        function Un(e) {
          var r = -1, o = e == null ? 0 : e.length;
          for (this.clear(); ++r < o; ) {
            var l = e[r];
            this.set(l[0], l[1]);
          }
        }
        function L1() {
          this.__data__ = [], this.size = 0;
        }
        function P1(e) {
          var r = this.__data__, o = $o(r, e);
          if (o < 0)
            return !1;
          var l = r.length - 1;
          return o == l ? r.pop() : Do.call(r, o, 1), --this.size, !0;
        }
        function B1(e) {
          var r = this.__data__, o = $o(r, e);
          return o < 0 ? a : r[o][1];
        }
        function F1(e) {
          return $o(this.__data__, e) > -1;
        }
        function U1(e, r) {
          var o = this.__data__, l = $o(o, e);
          return l < 0 ? (++this.size, o.push([e, r])) : o[l][1] = r, this;
        }
        Un.prototype.clear = L1, Un.prototype.delete = P1, Un.prototype.get = B1, Un.prototype.has = F1, Un.prototype.set = U1;
        function $n(e) {
          var r = -1, o = e == null ? 0 : e.length;
          for (this.clear(); ++r < o; ) {
            var l = e[r];
            this.set(l[0], l[1]);
          }
        }
        function $1() {
          this.size = 0, this.__data__ = {
            hash: new Sr(),
            map: new (Pa || Un)(),
            string: new Sr()
          };
        }
        function V1(e) {
          var r = Xo(this, e).delete(e);
          return this.size -= r ? 1 : 0, r;
        }
        function H1(e) {
          return Xo(this, e).get(e);
        }
        function G1(e) {
          return Xo(this, e).has(e);
        }
        function Y1(e, r) {
          var o = Xo(this, e), l = o.size;
          return o.set(e, r), this.size += o.size == l ? 0 : 1, this;
        }
        $n.prototype.clear = $1, $n.prototype.delete = V1, $n.prototype.get = H1, $n.prototype.has = G1, $n.prototype.set = Y1;
        function wr(e) {
          var r = -1, o = e == null ? 0 : e.length;
          for (this.__data__ = new $n(); ++r < o; )
            this.add(e[r]);
        }
        function z1(e) {
          return this.__data__.set(e, E), this;
        }
        function Z1(e) {
          return this.__data__.has(e);
        }
        wr.prototype.add = wr.prototype.push = z1, wr.prototype.has = Z1;
        function cn(e) {
          var r = this.__data__ = new Un(e);
          this.size = r.size;
        }
        function q1() {
          this.__data__ = new Un(), this.size = 0;
        }
        function W1(e) {
          var r = this.__data__, o = r.delete(e);
          return this.size = r.size, o;
        }
        function j1(e) {
          return this.__data__.get(e);
        }
        function K1(e) {
          return this.__data__.has(e);
        }
        function Q1(e, r) {
          var o = this.__data__;
          if (o instanceof Un) {
            var l = o.__data__;
            if (!Pa || l.length < s - 1)
              return l.push([e, r]), this.size = ++o.size, this;
            o = this.__data__ = new $n(l);
          }
          return o.set(e, r), this.size = o.size, this;
        }
        cn.prototype.clear = q1, cn.prototype.delete = W1, cn.prototype.get = j1, cn.prototype.has = K1, cn.prototype.set = Q1;
        function Ic(e, r) {
          var o = fe(e), l = !o && Ar(e), m = !o && !l && cr(e), S = !o && !l && !m && ua(e), T = o || l || m || S, C = T ? cs(e.length, s1) : [], O = C.length;
          for (var H in e)
            (r || Ue.call(e, H)) && !(T && // Safari 9 has enumerable `arguments.length` in strict mode.
            (H == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            m && (H == "offset" || H == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            S && (H == "buffer" || H == "byteLength" || H == "byteOffset") || // Skip index properties.
            Yn(H, O))) && C.push(H);
          return C;
        }
        function Nc(e) {
          var r = e.length;
          return r ? e[xs(0, r - 1)] : a;
        }
        function X1(e, r) {
          return Jo(Mt(e), yr(r, 0, e.length));
        }
        function J1(e) {
          return Jo(Mt(e));
        }
        function fs(e, r, o) {
          (o !== a && !un(e[r], o) || o === a && !(r in e)) && Vn(e, r, o);
        }
        function $a(e, r, o) {
          var l = e[r];
          (!(Ue.call(e, r) && un(l, o)) || o === a && !(r in e)) && Vn(e, r, o);
        }
        function $o(e, r) {
          for (var o = e.length; o--; )
            if (un(e[o][0], r))
              return o;
          return -1;
        }
        function e_(e, r, o, l) {
          return or(e, function(m, S, T) {
            r(l, m, o(m), T);
          }), l;
        }
        function Mc(e, r) {
          return e && Sn(r, lt(r), e);
        }
        function t_(e, r) {
          return e && Sn(r, kt(r), e);
        }
        function Vn(e, r, o) {
          r == "__proto__" && ko ? ko(e, r, {
            configurable: !0,
            enumerable: !0,
            value: o,
            writable: !0
          }) : e[r] = o;
        }
        function hs(e, r) {
          for (var o = -1, l = r.length, m = B(l), S = e == null; ++o < l; )
            m[o] = S ? a : Qs(e, r[o]);
          return m;
        }
        function yr(e, r, o) {
          return e === e && (o !== a && (e = e <= o ? e : o), r !== a && (e = e >= r ? e : r)), e;
        }
        function Xt(e, r, o, l, m, S) {
          var T, C = r & b, O = r & w, H = r & x;
          if (o && (T = m ? o(e, l, m, S) : o(e)), T !== a)
            return T;
          if (!We(e))
            return e;
          var Y = fe(e);
          if (Y) {
            if (T = G_(e), !C)
              return Mt(e, T);
          } else {
            var j = ft(e), te = j == Cn || j == qr;
            if (cr(e))
              return nu(e, C);
            if (j == Ft || j == De || te && !m) {
              if (T = O || te ? {} : Su(e), !C)
                return O ? M_(e, t_(T, e)) : N_(e, Mc(T, e));
            } else {
              if (!$e[j])
                return m ? e : {};
              T = Y_(e, j, C);
            }
          }
          S || (S = new cn());
          var ie = S.get(e);
          if (ie)
            return ie;
          S.set(e, T), Ku(e) ? e.forEach(function(_e) {
            T.add(Xt(_e, r, o, _e, e, S));
          }) : Wu(e) && e.forEach(function(_e, Te) {
            T.set(Te, Xt(_e, r, o, Te, e, S));
          });
          var de = H ? O ? Bs : Ps : O ? kt : lt, Ee = Y ? a : de(e);
          return jt(Ee || e, function(_e, Te) {
            Ee && (Te = _e, _e = e[Te]), $a(T, Te, Xt(_e, r, o, Te, e, S));
          }), T;
        }
        function n_(e) {
          var r = lt(e);
          return function(o) {
            return Dc(o, e, r);
          };
        }
        function Dc(e, r, o) {
          var l = o.length;
          if (e == null)
            return !l;
          for (e = Ve(e); l--; ) {
            var m = o[l], S = r[m], T = e[m];
            if (T === a && !(m in e) || !S(T))
              return !1;
          }
          return !0;
        }
        function kc(e, r, o) {
          if (typeof e != "function")
            throw new Kt(p);
          return qa(function() {
            e.apply(a, o);
          }, r);
        }
        function Va(e, r, o, l) {
          var m = -1, S = yo, T = !0, C = e.length, O = [], H = r.length;
          if (!C)
            return O;
          o && (r = ze(r, Ht(o))), l ? (S = rs, T = !1) : r.length >= s && (S = ka, T = !1, r = new wr(r));
          e:
            for (; ++m < C; ) {
              var Y = e[m], j = o == null ? Y : o(Y);
              if (Y = l || Y !== 0 ? Y : 0, T && j === j) {
                for (var te = H; te--; )
                  if (r[te] === j)
                    continue e;
                O.push(Y);
              } else S(r, j, l) || O.push(Y);
            }
          return O;
        }
        var or = su(bn), Lc = su(Es, !0);
        function r_(e, r) {
          var o = !0;
          return or(e, function(l, m, S) {
            return o = !!r(l, m, S), o;
          }), o;
        }
        function Vo(e, r, o) {
          for (var l = -1, m = e.length; ++l < m; ) {
            var S = e[l], T = r(S);
            if (T != null && (C === a ? T === T && !Yt(T) : o(T, C)))
              var C = T, O = S;
          }
          return O;
        }
        function a_(e, r, o, l) {
          var m = e.length;
          for (o = he(o), o < 0 && (o = -o > m ? 0 : m + o), l = l === a || l > m ? m : he(l), l < 0 && (l += m), l = o > l ? 0 : Xu(l); o < l; )
            e[o++] = r;
          return e;
        }
        function Pc(e, r) {
          var o = [];
          return or(e, function(l, m, S) {
            r(l, m, S) && o.push(l);
          }), o;
        }
        function dt(e, r, o, l, m) {
          var S = -1, T = e.length;
          for (o || (o = Z_), m || (m = []); ++S < T; ) {
            var C = e[S];
            r > 0 && o(C) ? r > 1 ? dt(C, r - 1, o, l, m) : nr(m, C) : l || (m[m.length] = C);
          }
          return m;
        }
        var vs = lu(), Bc = lu(!0);
        function bn(e, r) {
          return e && vs(e, r, lt);
        }
        function Es(e, r) {
          return e && Bc(e, r, lt);
        }
        function Ho(e, r) {
          return tr(r, function(o) {
            return zn(e[o]);
          });
        }
        function Tr(e, r) {
          r = sr(r, e);
          for (var o = 0, l = r.length; e != null && o < l; )
            e = e[wn(r[o++])];
          return o && o == l ? e : a;
        }
        function Fc(e, r, o) {
          var l = r(e);
          return fe(e) ? l : nr(l, o(e));
        }
        function wt(e) {
          return e == null ? e === a ? Ra : go : br && br in Ve(e) ? $_(e) : J_(e);
        }
        function bs(e, r) {
          return e > r;
        }
        function o_(e, r) {
          return e != null && Ue.call(e, r);
        }
        function i_(e, r) {
          return e != null && r in Ve(e);
        }
        function s_(e, r, o) {
          return e >= gt(r, o) && e < at(r, o);
        }
        function Ss(e, r, o) {
          for (var l = o ? rs : yo, m = e[0].length, S = e.length, T = S, C = B(S), O = 1 / 0, H = []; T--; ) {
            var Y = e[T];
            T && r && (Y = ze(Y, Ht(r))), O = gt(Y.length, O), C[T] = !o && (r || m >= 120 && Y.length >= 120) ? new wr(T && Y) : a;
          }
          Y = e[0];
          var j = -1, te = C[0];
          e:
            for (; ++j < m && H.length < O; ) {
              var ie = Y[j], de = r ? r(ie) : ie;
              if (ie = o || ie !== 0 ? ie : 0, !(te ? ka(te, de) : l(H, de, o))) {
                for (T = S; --T; ) {
                  var Ee = C[T];
                  if (!(Ee ? ka(Ee, de) : l(e[T], de, o)))
                    continue e;
                }
                te && te.push(de), H.push(ie);
              }
            }
          return H;
        }
        function l_(e, r, o, l) {
          return bn(e, function(m, S, T) {
            r(l, o(m), S, T);
          }), l;
        }
        function Ha(e, r, o) {
          r = sr(r, e), e = Cu(e, r);
          var l = e == null ? e : e[wn(en(r))];
          return l == null ? a : vt(l, e, o);
        }
        function Uc(e) {
          return Ke(e) && wt(e) == De;
        }
        function c_(e) {
          return Ke(e) && wt(e) == Bn;
        }
        function u_(e) {
          return Ke(e) && wt(e) == an;
        }
        function Ga(e, r, o, l, m) {
          return e === r ? !0 : e == null || r == null || !Ke(e) && !Ke(r) ? e !== e && r !== r : d_(e, r, o, l, Ga, m);
        }
        function d_(e, r, o, l, m, S) {
          var T = fe(e), C = fe(r), O = T ? gn : ft(e), H = C ? gn : ft(r);
          O = O == De ? Ft : O, H = H == De ? Ft : H;
          var Y = O == Ft, j = H == Ft, te = O == H;
          if (te && cr(e)) {
            if (!cr(r))
              return !1;
            T = !0, Y = !1;
          }
          if (te && !Y)
            return S || (S = new cn()), T || ua(e) ? vu(e, r, o, l, m, S) : F_(e, r, O, o, l, m, S);
          if (!(o & A)) {
            var ie = Y && Ue.call(e, "__wrapped__"), de = j && Ue.call(r, "__wrapped__");
            if (ie || de) {
              var Ee = ie ? e.value() : e, _e = de ? r.value() : r;
              return S || (S = new cn()), m(Ee, _e, o, l, S);
            }
          }
          return te ? (S || (S = new cn()), U_(e, r, o, l, m, S)) : !1;
        }
        function __(e) {
          return Ke(e) && ft(e) == pt;
        }
        function ws(e, r, o, l) {
          var m = o.length, S = m, T = !l;
          if (e == null)
            return !S;
          for (e = Ve(e); m--; ) {
            var C = o[m];
            if (T && C[2] ? C[1] !== e[C[0]] : !(C[0] in e))
              return !1;
          }
          for (; ++m < S; ) {
            C = o[m];
            var O = C[0], H = e[O], Y = C[1];
            if (T && C[2]) {
              if (H === a && !(O in e))
                return !1;
            } else {
              var j = new cn();
              if (l)
                var te = l(H, Y, O, e, r, j);
              if (!(te === a ? Ga(Y, H, A | D, l, j) : te))
                return !1;
            }
          }
          return !0;
        }
        function $c(e) {
          if (!We(e) || W_(e))
            return !1;
          var r = zn(e) ? _1 : Pe;
          return r.test(xr(e));
        }
        function p_(e) {
          return Ke(e) && wt(e) == dr;
        }
        function m_(e) {
          return Ke(e) && ft(e) == Ut;
        }
        function g_(e) {
          return Ke(e) && oi(e.length) && !!He[wt(e)];
        }
        function Vc(e) {
          return typeof e == "function" ? e : e == null ? Lt : typeof e == "object" ? fe(e) ? Yc(e[0], e[1]) : Gc(e) : cd(e);
        }
        function ys(e) {
          if (!Za(e))
            return v1(e);
          var r = [];
          for (var o in Ve(e))
            Ue.call(e, o) && o != "constructor" && r.push(o);
          return r;
        }
        function f_(e) {
          if (!We(e))
            return X_(e);
          var r = Za(e), o = [];
          for (var l in e)
            l == "constructor" && (r || !Ue.call(e, l)) || o.push(l);
          return o;
        }
        function Ts(e, r) {
          return e < r;
        }
        function Hc(e, r) {
          var o = -1, l = Dt(e) ? B(e.length) : [];
          return or(e, function(m, S, T) {
            l[++o] = r(m, S, T);
          }), l;
        }
        function Gc(e) {
          var r = Us(e);
          return r.length == 1 && r[0][2] ? yu(r[0][0], r[0][1]) : function(o) {
            return o === e || ws(o, e, r);
          };
        }
        function Yc(e, r) {
          return Vs(e) && wu(r) ? yu(wn(e), r) : function(o) {
            var l = Qs(o, e);
            return l === a && l === r ? Xs(o, e) : Ga(r, l, A | D);
          };
        }
        function Go(e, r, o, l, m) {
          e !== r && vs(r, function(S, T) {
            if (m || (m = new cn()), We(S))
              h_(e, r, T, o, Go, l, m);
            else {
              var C = l ? l(Gs(e, T), S, T + "", e, r, m) : a;
              C === a && (C = S), fs(e, T, C);
            }
          }, kt);
        }
        function h_(e, r, o, l, m, S, T) {
          var C = Gs(e, o), O = Gs(r, o), H = T.get(O);
          if (H) {
            fs(e, o, H);
            return;
          }
          var Y = S ? S(C, O, o + "", e, r, T) : a, j = Y === a;
          if (j) {
            var te = fe(O), ie = !te && cr(O), de = !te && !ie && ua(O);
            Y = O, te || ie || de ? fe(C) ? Y = C : Je(C) ? Y = Mt(C) : ie ? (j = !1, Y = nu(O, !0)) : de ? (j = !1, Y = ru(O, !0)) : Y = [] : Wa(O) || Ar(O) ? (Y = C, Ar(C) ? Y = Ju(C) : (!We(C) || zn(C)) && (Y = Su(O))) : j = !1;
          }
          j && (T.set(O, Y), m(Y, O, l, S, T), T.delete(O)), fs(e, o, Y);
        }
        function zc(e, r) {
          var o = e.length;
          if (o)
            return r += r < 0 ? o : 0, Yn(r, o) ? e[r] : a;
        }
        function Zc(e, r, o) {
          r.length ? r = ze(r, function(S) {
            return fe(S) ? function(T) {
              return Tr(T, S.length === 1 ? S[0] : S);
            } : S;
          }) : r = [Lt];
          var l = -1;
          r = ze(r, Ht(ue()));
          var m = Hc(e, function(S, T, C) {
            var O = ze(r, function(H) {
              return H(S);
            });
            return { criteria: O, index: ++l, value: S };
          });
          return Y0(m, function(S, T) {
            return I_(S, T, o);
          });
        }
        function v_(e, r) {
          return qc(e, r, function(o, l) {
            return Xs(e, l);
          });
        }
        function qc(e, r, o) {
          for (var l = -1, m = r.length, S = {}; ++l < m; ) {
            var T = r[l], C = Tr(e, T);
            o(C, T) && Ya(S, sr(T, e), C);
          }
          return S;
        }
        function E_(e) {
          return function(r) {
            return Tr(r, e);
          };
        }
        function Cs(e, r, o, l) {
          var m = l ? G0 : Jr, S = -1, T = r.length, C = e;
          for (e === r && (r = Mt(r)), o && (C = ze(e, Ht(o))); ++S < T; )
            for (var O = 0, H = r[S], Y = o ? o(H) : H; (O = m(C, Y, O, l)) > -1; )
              C !== e && Do.call(C, O, 1), Do.call(e, O, 1);
          return e;
        }
        function Wc(e, r) {
          for (var o = e ? r.length : 0, l = o - 1; o--; ) {
            var m = r[o];
            if (o == l || m !== S) {
              var S = m;
              Yn(m) ? Do.call(e, m, 1) : Os(e, m);
            }
          }
          return e;
        }
        function xs(e, r) {
          return e + Po(Rc() * (r - e + 1));
        }
        function b_(e, r, o, l) {
          for (var m = -1, S = at(Lo((r - e) / (o || 1)), 0), T = B(S); S--; )
            T[l ? S : ++m] = e, e += o;
          return T;
        }
        function As(e, r) {
          var o = "";
          if (!e || r < 1 || r > st)
            return o;
          do
            r % 2 && (o += e), r = Po(r / 2), r && (e += e);
          while (r);
          return o;
        }
        function be(e, r) {
          return Ys(Tu(e, r, Lt), e + "");
        }
        function S_(e) {
          return Nc(da(e));
        }
        function w_(e, r) {
          var o = da(e);
          return Jo(o, yr(r, 0, o.length));
        }
        function Ya(e, r, o, l) {
          if (!We(e))
            return e;
          r = sr(r, e);
          for (var m = -1, S = r.length, T = S - 1, C = e; C != null && ++m < S; ) {
            var O = wn(r[m]), H = o;
            if (O === "__proto__" || O === "constructor" || O === "prototype")
              return e;
            if (m != T) {
              var Y = C[O];
              H = l ? l(Y, O, C) : a, H === a && (H = We(Y) ? Y : Yn(r[m + 1]) ? [] : {});
            }
            $a(C, O, H), C = C[O];
          }
          return e;
        }
        var jc = Bo ? function(e, r) {
          return Bo.set(e, r), e;
        } : Lt, y_ = ko ? function(e, r) {
          return ko(e, "toString", {
            configurable: !0,
            enumerable: !1,
            value: el(r),
            writable: !0
          });
        } : Lt;
        function T_(e) {
          return Jo(da(e));
        }
        function Jt(e, r, o) {
          var l = -1, m = e.length;
          r < 0 && (r = -r > m ? 0 : m + r), o = o > m ? m : o, o < 0 && (o += m), m = r > o ? 0 : o - r >>> 0, r >>>= 0;
          for (var S = B(m); ++l < m; )
            S[l] = e[l + r];
          return S;
        }
        function C_(e, r) {
          var o;
          return or(e, function(l, m, S) {
            return o = r(l, m, S), !o;
          }), !!o;
        }
        function Yo(e, r, o) {
          var l = 0, m = e == null ? l : e.length;
          if (typeof r == "number" && r === r && m <= Rt) {
            for (; l < m; ) {
              var S = l + m >>> 1, T = e[S];
              T !== null && !Yt(T) && (o ? T <= r : T < r) ? l = S + 1 : m = S;
            }
            return m;
          }
          return Rs(e, r, Lt, o);
        }
        function Rs(e, r, o, l) {
          var m = 0, S = e == null ? 0 : e.length;
          if (S === 0)
            return 0;
          r = o(r);
          for (var T = r !== r, C = r === null, O = Yt(r), H = r === a; m < S; ) {
            var Y = Po((m + S) / 2), j = o(e[Y]), te = j !== a, ie = j === null, de = j === j, Ee = Yt(j);
            if (T)
              var _e = l || de;
            else H ? _e = de && (l || te) : C ? _e = de && te && (l || !ie) : O ? _e = de && te && !ie && (l || !Ee) : ie || Ee ? _e = !1 : _e = l ? j <= r : j < r;
            _e ? m = Y + 1 : S = Y;
          }
          return gt(S, Pn);
        }
        function Kc(e, r) {
          for (var o = -1, l = e.length, m = 0, S = []; ++o < l; ) {
            var T = e[o], C = r ? r(T) : T;
            if (!o || !un(C, O)) {
              var O = C;
              S[m++] = T === 0 ? 0 : T;
            }
          }
          return S;
        }
        function Qc(e) {
          return typeof e == "number" ? e : Yt(e) ? je : +e;
        }
        function Gt(e) {
          if (typeof e == "string")
            return e;
          if (fe(e))
            return ze(e, Gt) + "";
          if (Yt(e))
            return Oc ? Oc.call(e) : "";
          var r = e + "";
          return r == "0" && 1 / e == -ot ? "-0" : r;
        }
        function ir(e, r, o) {
          var l = -1, m = yo, S = e.length, T = !0, C = [], O = C;
          if (o)
            T = !1, m = rs;
          else if (S >= s) {
            var H = r ? null : P_(e);
            if (H)
              return Co(H);
            T = !1, m = ka, O = new wr();
          } else
            O = r ? [] : C;
          e:
            for (; ++l < S; ) {
              var Y = e[l], j = r ? r(Y) : Y;
              if (Y = o || Y !== 0 ? Y : 0, T && j === j) {
                for (var te = O.length; te--; )
                  if (O[te] === j)
                    continue e;
                r && O.push(j), C.push(Y);
              } else m(O, j, o) || (O !== C && O.push(j), C.push(Y));
            }
          return C;
        }
        function Os(e, r) {
          return r = sr(r, e), e = Cu(e, r), e == null || delete e[wn(en(r))];
        }
        function Xc(e, r, o, l) {
          return Ya(e, r, o(Tr(e, r)), l);
        }
        function zo(e, r, o, l) {
          for (var m = e.length, S = l ? m : -1; (l ? S-- : ++S < m) && r(e[S], S, e); )
            ;
          return o ? Jt(e, l ? 0 : S, l ? S + 1 : m) : Jt(e, l ? S + 1 : 0, l ? m : S);
        }
        function Jc(e, r) {
          var o = e;
          return o instanceof Ce && (o = o.value()), as(r, function(l, m) {
            return m.func.apply(m.thisArg, nr([l], m.args));
          }, o);
        }
        function Is(e, r, o) {
          var l = e.length;
          if (l < 2)
            return l ? ir(e[0]) : [];
          for (var m = -1, S = B(l); ++m < l; )
            for (var T = e[m], C = -1; ++C < l; )
              C != m && (S[m] = Va(S[m] || T, e[C], r, o));
          return ir(dt(S, 1), r, o);
        }
        function eu(e, r, o) {
          for (var l = -1, m = e.length, S = r.length, T = {}; ++l < m; ) {
            var C = l < S ? r[l] : a;
            o(T, e[l], C);
          }
          return T;
        }
        function Ns(e) {
          return Je(e) ? e : [];
        }
        function Ms(e) {
          return typeof e == "function" ? e : Lt;
        }
        function sr(e, r) {
          return fe(e) ? e : Vs(e, r) ? [e] : Ou(Be(e));
        }
        var x_ = be;
        function lr(e, r, o) {
          var l = e.length;
          return o = o === a ? l : o, !r && o >= l ? e : Jt(e, r, o);
        }
        var tu = p1 || function(e) {
          return Ge.clearTimeout(e);
        };
        function nu(e, r) {
          if (r)
            return e.slice();
          var o = e.length, l = yc ? yc(o) : new e.constructor(o);
          return e.copy(l), l;
        }
        function Ds(e) {
          var r = new e.constructor(e.byteLength);
          return new No(r).set(new No(e)), r;
        }
        function A_(e, r) {
          var o = r ? Ds(e.buffer) : e.buffer;
          return new e.constructor(o, e.byteOffset, e.byteLength);
        }
        function R_(e) {
          var r = new e.constructor(e.source, jn.exec(e));
          return r.lastIndex = e.lastIndex, r;
        }
        function O_(e) {
          return Ua ? Ve(Ua.call(e)) : {};
        }
        function ru(e, r) {
          var o = r ? Ds(e.buffer) : e.buffer;
          return new e.constructor(o, e.byteOffset, e.length);
        }
        function au(e, r) {
          if (e !== r) {
            var o = e !== a, l = e === null, m = e === e, S = Yt(e), T = r !== a, C = r === null, O = r === r, H = Yt(r);
            if (!C && !H && !S && e > r || S && T && O && !C && !H || l && T && O || !o && O || !m)
              return 1;
            if (!l && !S && !H && e < r || H && o && m && !l && !S || C && o && m || !T && m || !O)
              return -1;
          }
          return 0;
        }
        function I_(e, r, o) {
          for (var l = -1, m = e.criteria, S = r.criteria, T = m.length, C = o.length; ++l < T; ) {
            var O = au(m[l], S[l]);
            if (O) {
              if (l >= C)
                return O;
              var H = o[l];
              return O * (H == "desc" ? -1 : 1);
            }
          }
          return e.index - r.index;
        }
        function ou(e, r, o, l) {
          for (var m = -1, S = e.length, T = o.length, C = -1, O = r.length, H = at(S - T, 0), Y = B(O + H), j = !l; ++C < O; )
            Y[C] = r[C];
          for (; ++m < T; )
            (j || m < S) && (Y[o[m]] = e[m]);
          for (; H--; )
            Y[C++] = e[m++];
          return Y;
        }
        function iu(e, r, o, l) {
          for (var m = -1, S = e.length, T = -1, C = o.length, O = -1, H = r.length, Y = at(S - C, 0), j = B(Y + H), te = !l; ++m < Y; )
            j[m] = e[m];
          for (var ie = m; ++O < H; )
            j[ie + O] = r[O];
          for (; ++T < C; )
            (te || m < S) && (j[ie + o[T]] = e[m++]);
          return j;
        }
        function Mt(e, r) {
          var o = -1, l = e.length;
          for (r || (r = B(l)); ++o < l; )
            r[o] = e[o];
          return r;
        }
        function Sn(e, r, o, l) {
          var m = !o;
          o || (o = {});
          for (var S = -1, T = r.length; ++S < T; ) {
            var C = r[S], O = l ? l(o[C], e[C], C, o, e) : a;
            O === a && (O = e[C]), m ? Vn(o, C, O) : $a(o, C, O);
          }
          return o;
        }
        function N_(e, r) {
          return Sn(e, $s(e), r);
        }
        function M_(e, r) {
          return Sn(e, Eu(e), r);
        }
        function Zo(e, r) {
          return function(o, l) {
            var m = fe(o) ? B0 : e_, S = r ? r() : {};
            return m(o, e, ue(l, 2), S);
          };
        }
        function sa(e) {
          return be(function(r, o) {
            var l = -1, m = o.length, S = m > 1 ? o[m - 1] : a, T = m > 2 ? o[2] : a;
            for (S = e.length > 3 && typeof S == "function" ? (m--, S) : a, T && yt(o[0], o[1], T) && (S = m < 3 ? a : S, m = 1), r = Ve(r); ++l < m; ) {
              var C = o[l];
              C && e(r, C, l, S);
            }
            return r;
          });
        }
        function su(e, r) {
          return function(o, l) {
            if (o == null)
              return o;
            if (!Dt(o))
              return e(o, l);
            for (var m = o.length, S = r ? m : -1, T = Ve(o); (r ? S-- : ++S < m) && l(T[S], S, T) !== !1; )
              ;
            return o;
          };
        }
        function lu(e) {
          return function(r, o, l) {
            for (var m = -1, S = Ve(r), T = l(r), C = T.length; C--; ) {
              var O = T[e ? C : ++m];
              if (o(S[O], O, S) === !1)
                break;
            }
            return r;
          };
        }
        function D_(e, r, o) {
          var l = r & L, m = za(e);
          function S() {
            var T = this && this !== Ge && this instanceof S ? m : e;
            return T.apply(l ? o : this, arguments);
          }
          return S;
        }
        function cu(e) {
          return function(r) {
            r = Be(r);
            var o = ea(r) ? ln(r) : a, l = o ? o[0] : r.charAt(0), m = o ? lr(o, 1).join("") : r.slice(1);
            return l[e]() + m;
          };
        }
        function la(e) {
          return function(r) {
            return as(sd(id(r).replace(ns, "")), e, "");
          };
        }
        function za(e) {
          return function() {
            var r = arguments;
            switch (r.length) {
              case 0:
                return new e();
              case 1:
                return new e(r[0]);
              case 2:
                return new e(r[0], r[1]);
              case 3:
                return new e(r[0], r[1], r[2]);
              case 4:
                return new e(r[0], r[1], r[2], r[3]);
              case 5:
                return new e(r[0], r[1], r[2], r[3], r[4]);
              case 6:
                return new e(r[0], r[1], r[2], r[3], r[4], r[5]);
              case 7:
                return new e(r[0], r[1], r[2], r[3], r[4], r[5], r[6]);
            }
            var o = ia(e.prototype), l = e.apply(o, r);
            return We(l) ? l : o;
          };
        }
        function k_(e, r, o) {
          var l = za(e);
          function m() {
            for (var S = arguments.length, T = B(S), C = S, O = ca(m); C--; )
              T[C] = arguments[C];
            var H = S < 3 && T[0] !== O && T[S - 1] !== O ? [] : rr(T, O);
            if (S -= H.length, S < o)
              return mu(
                e,
                r,
                qo,
                m.placeholder,
                a,
                T,
                H,
                a,
                a,
                o - S
              );
            var Y = this && this !== Ge && this instanceof m ? l : e;
            return vt(Y, this, T);
          }
          return m;
        }
        function uu(e) {
          return function(r, o, l) {
            var m = Ve(r);
            if (!Dt(r)) {
              var S = ue(o, 3);
              r = lt(r), o = function(C) {
                return S(m[C], C, m);
              };
            }
            var T = e(r, o, l);
            return T > -1 ? m[S ? r[T] : T] : a;
          };
        }
        function du(e) {
          return Gn(function(r) {
            var o = r.length, l = o, m = Qt.prototype.thru;
            for (e && r.reverse(); l--; ) {
              var S = r[l];
              if (typeof S != "function")
                throw new Kt(p);
              if (m && !T && Qo(S) == "wrapper")
                var T = new Qt([], !0);
            }
            for (l = T ? l : o; ++l < o; ) {
              S = r[l];
              var C = Qo(S), O = C == "wrapper" ? Fs(S) : a;
              O && Hs(O[0]) && O[1] == (ee | P | U | X) && !O[4].length && O[9] == 1 ? T = T[Qo(O[0])].apply(T, O[3]) : T = S.length == 1 && Hs(S) ? T[C]() : T.thru(S);
            }
            return function() {
              var H = arguments, Y = H[0];
              if (T && H.length == 1 && fe(Y))
                return T.plant(Y).value();
              for (var j = 0, te = o ? r[j].apply(this, H) : Y; ++j < o; )
                te = r[j].call(this, te);
              return te;
            };
          });
        }
        function qo(e, r, o, l, m, S, T, C, O, H) {
          var Y = r & ee, j = r & L, te = r & $, ie = r & (P | k), de = r & re, Ee = te ? a : za(e);
          function _e() {
            for (var Te = arguments.length, Ae = B(Te), zt = Te; zt--; )
              Ae[zt] = arguments[zt];
            if (ie)
              var Tt = ca(_e), Zt = Z0(Ae, Tt);
            if (l && (Ae = ou(Ae, l, m, ie)), S && (Ae = iu(Ae, S, T, ie)), Te -= Zt, ie && Te < H) {
              var et = rr(Ae, Tt);
              return mu(
                e,
                r,
                qo,
                _e.placeholder,
                o,
                Ae,
                et,
                C,
                O,
                H - Te
              );
            }
            var dn = j ? o : this, qn = te ? dn[e] : e;
            return Te = Ae.length, C ? Ae = ep(Ae, C) : de && Te > 1 && Ae.reverse(), Y && O < Te && (Ae.length = O), this && this !== Ge && this instanceof _e && (qn = Ee || za(qn)), qn.apply(dn, Ae);
          }
          return _e;
        }
        function _u(e, r) {
          return function(o, l) {
            return l_(o, e, r(l), {});
          };
        }
        function Wo(e, r) {
          return function(o, l) {
            var m;
            if (o === a && l === a)
              return r;
            if (o !== a && (m = o), l !== a) {
              if (m === a)
                return l;
              typeof o == "string" || typeof l == "string" ? (o = Gt(o), l = Gt(l)) : (o = Qc(o), l = Qc(l)), m = e(o, l);
            }
            return m;
          };
        }
        function ks(e) {
          return Gn(function(r) {
            return r = ze(r, Ht(ue())), be(function(o) {
              var l = this;
              return e(r, function(m) {
                return vt(m, l, o);
              });
            });
          });
        }
        function jo(e, r) {
          r = r === a ? " " : Gt(r);
          var o = r.length;
          if (o < 2)
            return o ? As(r, e) : r;
          var l = As(r, Lo(e / ta(r)));
          return ea(r) ? lr(ln(l), 0, e).join("") : l.slice(0, e);
        }
        function L_(e, r, o, l) {
          var m = r & L, S = za(e);
          function T() {
            for (var C = -1, O = arguments.length, H = -1, Y = l.length, j = B(Y + O), te = this && this !== Ge && this instanceof T ? S : e; ++H < Y; )
              j[H] = l[H];
            for (; O--; )
              j[H++] = arguments[++C];
            return vt(te, m ? o : this, j);
          }
          return T;
        }
        function pu(e) {
          return function(r, o, l) {
            return l && typeof l != "number" && yt(r, o, l) && (o = l = a), r = Zn(r), o === a ? (o = r, r = 0) : o = Zn(o), l = l === a ? r < o ? 1 : -1 : Zn(l), b_(r, o, l, e);
          };
        }
        function Ko(e) {
          return function(r, o) {
            return typeof r == "string" && typeof o == "string" || (r = tn(r), o = tn(o)), e(r, o);
          };
        }
        function mu(e, r, o, l, m, S, T, C, O, H) {
          var Y = r & P, j = Y ? T : a, te = Y ? a : T, ie = Y ? S : a, de = Y ? a : S;
          r |= Y ? U : Z, r &= ~(Y ? Z : U), r & q || (r &= -4);
          var Ee = [
            e,
            r,
            m,
            ie,
            j,
            de,
            te,
            C,
            O,
            H
          ], _e = o.apply(a, Ee);
          return Hs(e) && xu(_e, Ee), _e.placeholder = l, Au(_e, e, r);
        }
        function Ls(e) {
          var r = rt[e];
          return function(o, l) {
            if (o = tn(o), l = l == null ? 0 : gt(he(l), 292), l && Ac(o)) {
              var m = (Be(o) + "e").split("e"), S = r(m[0] + "e" + (+m[1] + l));
              return m = (Be(S) + "e").split("e"), +(m[0] + "e" + (+m[1] - l));
            }
            return r(o);
          };
        }
        var P_ = aa && 1 / Co(new aa([, -0]))[1] == ot ? function(e) {
          return new aa(e);
        } : rl;
        function gu(e) {
          return function(r) {
            var o = ft(r);
            return o == pt ? ds(r) : o == Ut ? J0(r) : z0(r, e(r));
          };
        }
        function Hn(e, r, o, l, m, S, T, C) {
          var O = r & $;
          if (!O && typeof e != "function")
            throw new Kt(p);
          var H = l ? l.length : 0;
          if (H || (r &= -97, l = m = a), T = T === a ? T : at(he(T), 0), C = C === a ? C : he(C), H -= m ? m.length : 0, r & Z) {
            var Y = l, j = m;
            l = m = a;
          }
          var te = O ? a : Fs(e), ie = [
            e,
            r,
            o,
            l,
            m,
            Y,
            j,
            S,
            T,
            C
          ];
          if (te && Q_(ie, te), e = ie[0], r = ie[1], o = ie[2], l = ie[3], m = ie[4], C = ie[9] = ie[9] === a ? O ? 0 : e.length : at(ie[9] - H, 0), !C && r & (P | k) && (r &= -25), !r || r == L)
            var de = D_(e, r, o);
          else r == P || r == k ? de = k_(e, r, C) : (r == U || r == (L | U)) && !m.length ? de = L_(e, r, o, l) : de = qo.apply(a, ie);
          var Ee = te ? jc : xu;
          return Au(Ee(de, ie), e, r);
        }
        function fu(e, r, o, l) {
          return e === a || un(e, ra[o]) && !Ue.call(l, o) ? r : e;
        }
        function hu(e, r, o, l, m, S) {
          return We(e) && We(r) && (S.set(r, e), Go(e, r, a, hu, S), S.delete(r)), e;
        }
        function B_(e) {
          return Wa(e) ? a : e;
        }
        function vu(e, r, o, l, m, S) {
          var T = o & A, C = e.length, O = r.length;
          if (C != O && !(T && O > C))
            return !1;
          var H = S.get(e), Y = S.get(r);
          if (H && Y)
            return H == r && Y == e;
          var j = -1, te = !0, ie = o & D ? new wr() : a;
          for (S.set(e, r), S.set(r, e); ++j < C; ) {
            var de = e[j], Ee = r[j];
            if (l)
              var _e = T ? l(Ee, de, j, r, e, S) : l(de, Ee, j, e, r, S);
            if (_e !== a) {
              if (_e)
                continue;
              te = !1;
              break;
            }
            if (ie) {
              if (!os(r, function(Te, Ae) {
                if (!ka(ie, Ae) && (de === Te || m(de, Te, o, l, S)))
                  return ie.push(Ae);
              })) {
                te = !1;
                break;
              }
            } else if (!(de === Ee || m(de, Ee, o, l, S))) {
              te = !1;
              break;
            }
          }
          return S.delete(e), S.delete(r), te;
        }
        function F_(e, r, o, l, m, S, T) {
          switch (o) {
            case An:
              if (e.byteLength != r.byteLength || e.byteOffset != r.byteOffset)
                return !1;
              e = e.buffer, r = r.buffer;
            case Bn:
              return !(e.byteLength != r.byteLength || !S(new No(e), new No(r)));
            case mt:
            case an:
            case Xn:
              return un(+e, +r);
            case pr:
              return e.name == r.name && e.message == r.message;
            case dr:
            case mr:
              return e == r + "";
            case pt:
              var C = ds;
            case Ut:
              var O = l & A;
              if (C || (C = Co), e.size != r.size && !O)
                return !1;
              var H = T.get(e);
              if (H)
                return H == r;
              l |= D, T.set(e, r);
              var Y = vu(C(e), C(r), l, m, S, T);
              return T.delete(e), Y;
            case gr:
              if (Ua)
                return Ua.call(e) == Ua.call(r);
          }
          return !1;
        }
        function U_(e, r, o, l, m, S) {
          var T = o & A, C = Ps(e), O = C.length, H = Ps(r), Y = H.length;
          if (O != Y && !T)
            return !1;
          for (var j = O; j--; ) {
            var te = C[j];
            if (!(T ? te in r : Ue.call(r, te)))
              return !1;
          }
          var ie = S.get(e), de = S.get(r);
          if (ie && de)
            return ie == r && de == e;
          var Ee = !0;
          S.set(e, r), S.set(r, e);
          for (var _e = T; ++j < O; ) {
            te = C[j];
            var Te = e[te], Ae = r[te];
            if (l)
              var zt = T ? l(Ae, Te, te, r, e, S) : l(Te, Ae, te, e, r, S);
            if (!(zt === a ? Te === Ae || m(Te, Ae, o, l, S) : zt)) {
              Ee = !1;
              break;
            }
            _e || (_e = te == "constructor");
          }
          if (Ee && !_e) {
            var Tt = e.constructor, Zt = r.constructor;
            Tt != Zt && "constructor" in e && "constructor" in r && !(typeof Tt == "function" && Tt instanceof Tt && typeof Zt == "function" && Zt instanceof Zt) && (Ee = !1);
          }
          return S.delete(e), S.delete(r), Ee;
        }
        function Gn(e) {
          return Ys(Tu(e, a, Du), e + "");
        }
        function Ps(e) {
          return Fc(e, lt, $s);
        }
        function Bs(e) {
          return Fc(e, kt, Eu);
        }
        var Fs = Bo ? function(e) {
          return Bo.get(e);
        } : rl;
        function Qo(e) {
          for (var r = e.name + "", o = oa[r], l = Ue.call(oa, r) ? o.length : 0; l--; ) {
            var m = o[l], S = m.func;
            if (S == null || S == e)
              return m.name;
          }
          return r;
        }
        function ca(e) {
          var r = Ue.call(v, "placeholder") ? v : e;
          return r.placeholder;
        }
        function ue() {
          var e = v.iteratee || tl;
          return e = e === tl ? Vc : e, arguments.length ? e(arguments[0], arguments[1]) : e;
        }
        function Xo(e, r) {
          var o = e.__data__;
          return q_(r) ? o[typeof r == "string" ? "string" : "hash"] : o.map;
        }
        function Us(e) {
          for (var r = lt(e), o = r.length; o--; ) {
            var l = r[o], m = e[l];
            r[o] = [l, m, wu(m)];
          }
          return r;
        }
        function Cr(e, r) {
          var o = K0(e, r);
          return $c(o) ? o : a;
        }
        function $_(e) {
          var r = Ue.call(e, br), o = e[br];
          try {
            e[br] = a;
            var l = !0;
          } catch {
          }
          var m = Oo.call(e);
          return l && (r ? e[br] = o : delete e[br]), m;
        }
        var $s = ps ? function(e) {
          return e == null ? [] : (e = Ve(e), tr(ps(e), function(r) {
            return Cc.call(e, r);
          }));
        } : al, Eu = ps ? function(e) {
          for (var r = []; e; )
            nr(r, $s(e)), e = Mo(e);
          return r;
        } : al, ft = wt;
        (ms && ft(new ms(new ArrayBuffer(1))) != An || Pa && ft(new Pa()) != pt || gs && ft(gs.resolve()) != va || aa && ft(new aa()) != Ut || Ba && ft(new Ba()) != xn) && (ft = function(e) {
          var r = wt(e), o = r == Ft ? e.constructor : a, l = o ? xr(o) : "";
          if (l)
            switch (l) {
              case w1:
                return An;
              case y1:
                return pt;
              case T1:
                return va;
              case C1:
                return Ut;
              case x1:
                return xn;
            }
          return r;
        });
        function V_(e, r, o) {
          for (var l = -1, m = o.length; ++l < m; ) {
            var S = o[l], T = S.size;
            switch (S.type) {
              case "drop":
                e += T;
                break;
              case "dropRight":
                r -= T;
                break;
              case "take":
                r = gt(r, e + T);
                break;
              case "takeRight":
                e = at(e, r - T);
                break;
            }
          }
          return { start: e, end: r };
        }
        function H_(e) {
          var r = e.match(Br);
          return r ? r[1].split(Eo) : [];
        }
        function bu(e, r, o) {
          r = sr(r, e);
          for (var l = -1, m = r.length, S = !1; ++l < m; ) {
            var T = wn(r[l]);
            if (!(S = e != null && o(e, T)))
              break;
            e = e[T];
          }
          return S || ++l != m ? S : (m = e == null ? 0 : e.length, !!m && oi(m) && Yn(T, m) && (fe(e) || Ar(e)));
        }
        function G_(e) {
          var r = e.length, o = new e.constructor(r);
          return r && typeof e[0] == "string" && Ue.call(e, "index") && (o.index = e.index, o.input = e.input), o;
        }
        function Su(e) {
          return typeof e.constructor == "function" && !Za(e) ? ia(Mo(e)) : {};
        }
        function Y_(e, r, o) {
          var l = e.constructor;
          switch (r) {
            case Bn:
              return Ds(e);
            case mt:
            case an:
              return new l(+e);
            case An:
              return A_(e, o);
            case Wr:
            case fn:
            case jr:
            case fr:
            case Dr:
            case Rn:
            case Fn:
            case kr:
            case Lr:
              return ru(e, o);
            case pt:
              return new l();
            case Xn:
            case mr:
              return new l(e);
            case dr:
              return R_(e);
            case Ut:
              return new l();
            case gr:
              return O_(e);
          }
        }
        function z_(e, r) {
          var o = r.length;
          if (!o)
            return e;
          var l = o - 1;
          return r[l] = (o > 1 ? "& " : "") + r[l], r = r.join(o > 2 ? ", " : " "), e.replace(eo, `{
/* [wrapped with ` + r + `] */
`);
        }
        function Z_(e) {
          return fe(e) || Ar(e) || !!(xc && e && e[xc]);
        }
        function Yn(e, r) {
          var o = typeof e;
          return r = r ?? st, !!r && (o == "number" || o != "symbol" && pe.test(e)) && e > -1 && e % 1 == 0 && e < r;
        }
        function yt(e, r, o) {
          if (!We(o))
            return !1;
          var l = typeof r;
          return (l == "number" ? Dt(o) && Yn(r, o.length) : l == "string" && r in o) ? un(o[r], e) : !1;
        }
        function Vs(e, r) {
          if (fe(e))
            return !1;
          var o = typeof e;
          return o == "number" || o == "symbol" || o == "boolean" || e == null || Yt(e) ? !0 : vo.test(e) || !ba.test(e) || r != null && e in Ve(r);
        }
        function q_(e) {
          var r = typeof e;
          return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? e !== "__proto__" : e === null;
        }
        function Hs(e) {
          var r = Qo(e), o = v[r];
          if (typeof o != "function" || !(r in Ce.prototype))
            return !1;
          if (e === o)
            return !0;
          var l = Fs(o);
          return !!l && e === l[0];
        }
        function W_(e) {
          return !!wc && wc in e;
        }
        var j_ = Ao ? zn : ol;
        function Za(e) {
          var r = e && e.constructor, o = typeof r == "function" && r.prototype || ra;
          return e === o;
        }
        function wu(e) {
          return e === e && !We(e);
        }
        function yu(e, r) {
          return function(o) {
            return o == null ? !1 : o[e] === r && (r !== a || e in Ve(o));
          };
        }
        function K_(e) {
          var r = ri(e, function(l) {
            return o.size === h && o.clear(), l;
          }), o = r.cache;
          return r;
        }
        function Q_(e, r) {
          var o = e[1], l = r[1], m = o | l, S = m < (L | $ | ee), T = l == ee && o == P || l == ee && o == X && e[7].length <= r[8] || l == (ee | X) && r[7].length <= r[8] && o == P;
          if (!(S || T))
            return e;
          l & L && (e[2] = r[2], m |= o & L ? 0 : q);
          var C = r[3];
          if (C) {
            var O = e[3];
            e[3] = O ? ou(O, C, r[4]) : C, e[4] = O ? rr(e[3], f) : r[4];
          }
          return C = r[5], C && (O = e[5], e[5] = O ? iu(O, C, r[6]) : C, e[6] = O ? rr(e[5], f) : r[6]), C = r[7], C && (e[7] = C), l & ee && (e[8] = e[8] == null ? r[8] : gt(e[8], r[8])), e[9] == null && (e[9] = r[9]), e[0] = r[0], e[1] = m, e;
        }
        function X_(e) {
          var r = [];
          if (e != null)
            for (var o in Ve(e))
              r.push(o);
          return r;
        }
        function J_(e) {
          return Oo.call(e);
        }
        function Tu(e, r, o) {
          return r = at(r === a ? e.length - 1 : r, 0), function() {
            for (var l = arguments, m = -1, S = at(l.length - r, 0), T = B(S); ++m < S; )
              T[m] = l[r + m];
            m = -1;
            for (var C = B(r + 1); ++m < r; )
              C[m] = l[m];
            return C[r] = o(T), vt(e, this, C);
          };
        }
        function Cu(e, r) {
          return r.length < 2 ? e : Tr(e, Jt(r, 0, -1));
        }
        function ep(e, r) {
          for (var o = e.length, l = gt(r.length, o), m = Mt(e); l--; ) {
            var S = r[l];
            e[l] = Yn(S, o) ? m[S] : a;
          }
          return e;
        }
        function Gs(e, r) {
          if (!(r === "constructor" && typeof e[r] == "function") && r != "__proto__")
            return e[r];
        }
        var xu = Ru(jc), qa = g1 || function(e, r) {
          return Ge.setTimeout(e, r);
        }, Ys = Ru(y_);
        function Au(e, r, o) {
          var l = r + "";
          return Ys(e, z_(l, tp(H_(l), o)));
        }
        function Ru(e) {
          var r = 0, o = 0;
          return function() {
            var l = E1(), m = Se - (l - o);
            if (o = l, m > 0) {
              if (++r >= me)
                return arguments[0];
            } else
              r = 0;
            return e.apply(a, arguments);
          };
        }
        function Jo(e, r) {
          var o = -1, l = e.length, m = l - 1;
          for (r = r === a ? l : r; ++o < r; ) {
            var S = xs(o, m), T = e[S];
            e[S] = e[o], e[o] = T;
          }
          return e.length = r, e;
        }
        var Ou = K_(function(e) {
          var r = [];
          return e.charCodeAt(0) === 46 && r.push(""), e.replace(bi, function(o, l, m, S) {
            r.push(m ? S.replace(wi, "$1") : l || o);
          }), r;
        });
        function wn(e) {
          if (typeof e == "string" || Yt(e))
            return e;
          var r = e + "";
          return r == "0" && 1 / e == -ot ? "-0" : r;
        }
        function xr(e) {
          if (e != null) {
            try {
              return Ro.call(e);
            } catch {
            }
            try {
              return e + "";
            } catch {
            }
          }
          return "";
        }
        function tp(e, r) {
          return jt(Zr, function(o) {
            var l = "_." + o[0];
            r & o[1] && !yo(e, l) && e.push(l);
          }), e.sort();
        }
        function Iu(e) {
          if (e instanceof Ce)
            return e.clone();
          var r = new Qt(e.__wrapped__, e.__chain__);
          return r.__actions__ = Mt(e.__actions__), r.__index__ = e.__index__, r.__values__ = e.__values__, r;
        }
        function np(e, r, o) {
          (o ? yt(e, r, o) : r === a) ? r = 1 : r = at(he(r), 0);
          var l = e == null ? 0 : e.length;
          if (!l || r < 1)
            return [];
          for (var m = 0, S = 0, T = B(Lo(l / r)); m < l; )
            T[S++] = Jt(e, m, m += r);
          return T;
        }
        function rp(e) {
          for (var r = -1, o = e == null ? 0 : e.length, l = 0, m = []; ++r < o; ) {
            var S = e[r];
            S && (m[l++] = S);
          }
          return m;
        }
        function ap() {
          var e = arguments.length;
          if (!e)
            return [];
          for (var r = B(e - 1), o = arguments[0], l = e; l--; )
            r[l - 1] = arguments[l];
          return nr(fe(o) ? Mt(o) : [o], dt(r, 1));
        }
        var op = be(function(e, r) {
          return Je(e) ? Va(e, dt(r, 1, Je, !0)) : [];
        }), ip = be(function(e, r) {
          var o = en(r);
          return Je(o) && (o = a), Je(e) ? Va(e, dt(r, 1, Je, !0), ue(o, 2)) : [];
        }), sp = be(function(e, r) {
          var o = en(r);
          return Je(o) && (o = a), Je(e) ? Va(e, dt(r, 1, Je, !0), a, o) : [];
        });
        function lp(e, r, o) {
          var l = e == null ? 0 : e.length;
          return l ? (r = o || r === a ? 1 : he(r), Jt(e, r < 0 ? 0 : r, l)) : [];
        }
        function cp(e, r, o) {
          var l = e == null ? 0 : e.length;
          return l ? (r = o || r === a ? 1 : he(r), r = l - r, Jt(e, 0, r < 0 ? 0 : r)) : [];
        }
        function up(e, r) {
          return e && e.length ? zo(e, ue(r, 3), !0, !0) : [];
        }
        function dp(e, r) {
          return e && e.length ? zo(e, ue(r, 3), !0) : [];
        }
        function _p(e, r, o, l) {
          var m = e == null ? 0 : e.length;
          return m ? (o && typeof o != "number" && yt(e, r, o) && (o = 0, l = m), a_(e, r, o, l)) : [];
        }
        function Nu(e, r, o) {
          var l = e == null ? 0 : e.length;
          if (!l)
            return -1;
          var m = o == null ? 0 : he(o);
          return m < 0 && (m = at(l + m, 0)), To(e, ue(r, 3), m);
        }
        function Mu(e, r, o) {
          var l = e == null ? 0 : e.length;
          if (!l)
            return -1;
          var m = l - 1;
          return o !== a && (m = he(o), m = o < 0 ? at(l + m, 0) : gt(m, l - 1)), To(e, ue(r, 3), m, !0);
        }
        function Du(e) {
          var r = e == null ? 0 : e.length;
          return r ? dt(e, 1) : [];
        }
        function pp(e) {
          var r = e == null ? 0 : e.length;
          return r ? dt(e, ot) : [];
        }
        function mp(e, r) {
          var o = e == null ? 0 : e.length;
          return o ? (r = r === a ? 1 : he(r), dt(e, r)) : [];
        }
        function gp(e) {
          for (var r = -1, o = e == null ? 0 : e.length, l = {}; ++r < o; ) {
            var m = e[r];
            l[m[0]] = m[1];
          }
          return l;
        }
        function ku(e) {
          return e && e.length ? e[0] : a;
        }
        function fp(e, r, o) {
          var l = e == null ? 0 : e.length;
          if (!l)
            return -1;
          var m = o == null ? 0 : he(o);
          return m < 0 && (m = at(l + m, 0)), Jr(e, r, m);
        }
        function hp(e) {
          var r = e == null ? 0 : e.length;
          return r ? Jt(e, 0, -1) : [];
        }
        var vp = be(function(e) {
          var r = ze(e, Ns);
          return r.length && r[0] === e[0] ? Ss(r) : [];
        }), Ep = be(function(e) {
          var r = en(e), o = ze(e, Ns);
          return r === en(o) ? r = a : o.pop(), o.length && o[0] === e[0] ? Ss(o, ue(r, 2)) : [];
        }), bp = be(function(e) {
          var r = en(e), o = ze(e, Ns);
          return r = typeof r == "function" ? r : a, r && o.pop(), o.length && o[0] === e[0] ? Ss(o, a, r) : [];
        });
        function Sp(e, r) {
          return e == null ? "" : h1.call(e, r);
        }
        function en(e) {
          var r = e == null ? 0 : e.length;
          return r ? e[r - 1] : a;
        }
        function wp(e, r, o) {
          var l = e == null ? 0 : e.length;
          if (!l)
            return -1;
          var m = l;
          return o !== a && (m = he(o), m = m < 0 ? at(l + m, 0) : gt(m, l - 1)), r === r ? t1(e, r, m) : To(e, mc, m, !0);
        }
        function yp(e, r) {
          return e && e.length ? zc(e, he(r)) : a;
        }
        var Tp = be(Lu);
        function Lu(e, r) {
          return e && e.length && r && r.length ? Cs(e, r) : e;
        }
        function Cp(e, r, o) {
          return e && e.length && r && r.length ? Cs(e, r, ue(o, 2)) : e;
        }
        function xp(e, r, o) {
          return e && e.length && r && r.length ? Cs(e, r, a, o) : e;
        }
        var Ap = Gn(function(e, r) {
          var o = e == null ? 0 : e.length, l = hs(e, r);
          return Wc(e, ze(r, function(m) {
            return Yn(m, o) ? +m : m;
          }).sort(au)), l;
        });
        function Rp(e, r) {
          var o = [];
          if (!(e && e.length))
            return o;
          var l = -1, m = [], S = e.length;
          for (r = ue(r, 3); ++l < S; ) {
            var T = e[l];
            r(T, l, e) && (o.push(T), m.push(l));
          }
          return Wc(e, m), o;
        }
        function zs(e) {
          return e == null ? e : S1.call(e);
        }
        function Op(e, r, o) {
          var l = e == null ? 0 : e.length;
          return l ? (o && typeof o != "number" && yt(e, r, o) ? (r = 0, o = l) : (r = r == null ? 0 : he(r), o = o === a ? l : he(o)), Jt(e, r, o)) : [];
        }
        function Ip(e, r) {
          return Yo(e, r);
        }
        function Np(e, r, o) {
          return Rs(e, r, ue(o, 2));
        }
        function Mp(e, r) {
          var o = e == null ? 0 : e.length;
          if (o) {
            var l = Yo(e, r);
            if (l < o && un(e[l], r))
              return l;
          }
          return -1;
        }
        function Dp(e, r) {
          return Yo(e, r, !0);
        }
        function kp(e, r, o) {
          return Rs(e, r, ue(o, 2), !0);
        }
        function Lp(e, r) {
          var o = e == null ? 0 : e.length;
          if (o) {
            var l = Yo(e, r, !0) - 1;
            if (un(e[l], r))
              return l;
          }
          return -1;
        }
        function Pp(e) {
          return e && e.length ? Kc(e) : [];
        }
        function Bp(e, r) {
          return e && e.length ? Kc(e, ue(r, 2)) : [];
        }
        function Fp(e) {
          var r = e == null ? 0 : e.length;
          return r ? Jt(e, 1, r) : [];
        }
        function Up(e, r, o) {
          return e && e.length ? (r = o || r === a ? 1 : he(r), Jt(e, 0, r < 0 ? 0 : r)) : [];
        }
        function $p(e, r, o) {
          var l = e == null ? 0 : e.length;
          return l ? (r = o || r === a ? 1 : he(r), r = l - r, Jt(e, r < 0 ? 0 : r, l)) : [];
        }
        function Vp(e, r) {
          return e && e.length ? zo(e, ue(r, 3), !1, !0) : [];
        }
        function Hp(e, r) {
          return e && e.length ? zo(e, ue(r, 3)) : [];
        }
        var Gp = be(function(e) {
          return ir(dt(e, 1, Je, !0));
        }), Yp = be(function(e) {
          var r = en(e);
          return Je(r) && (r = a), ir(dt(e, 1, Je, !0), ue(r, 2));
        }), zp = be(function(e) {
          var r = en(e);
          return r = typeof r == "function" ? r : a, ir(dt(e, 1, Je, !0), a, r);
        });
        function Zp(e) {
          return e && e.length ? ir(e) : [];
        }
        function qp(e, r) {
          return e && e.length ? ir(e, ue(r, 2)) : [];
        }
        function Wp(e, r) {
          return r = typeof r == "function" ? r : a, e && e.length ? ir(e, a, r) : [];
        }
        function Zs(e) {
          if (!(e && e.length))
            return [];
          var r = 0;
          return e = tr(e, function(o) {
            if (Je(o))
              return r = at(o.length, r), !0;
          }), cs(r, function(o) {
            return ze(e, is(o));
          });
        }
        function Pu(e, r) {
          if (!(e && e.length))
            return [];
          var o = Zs(e);
          return r == null ? o : ze(o, function(l) {
            return vt(r, a, l);
          });
        }
        var jp = be(function(e, r) {
          return Je(e) ? Va(e, r) : [];
        }), Kp = be(function(e) {
          return Is(tr(e, Je));
        }), Qp = be(function(e) {
          var r = en(e);
          return Je(r) && (r = a), Is(tr(e, Je), ue(r, 2));
        }), Xp = be(function(e) {
          var r = en(e);
          return r = typeof r == "function" ? r : a, Is(tr(e, Je), a, r);
        }), Jp = be(Zs);
        function e5(e, r) {
          return eu(e || [], r || [], $a);
        }
        function t5(e, r) {
          return eu(e || [], r || [], Ya);
        }
        var n5 = be(function(e) {
          var r = e.length, o = r > 1 ? e[r - 1] : a;
          return o = typeof o == "function" ? (e.pop(), o) : a, Pu(e, o);
        });
        function Bu(e) {
          var r = v(e);
          return r.__chain__ = !0, r;
        }
        function r5(e, r) {
          return r(e), e;
        }
        function ei(e, r) {
          return r(e);
        }
        var a5 = Gn(function(e) {
          var r = e.length, o = r ? e[0] : 0, l = this.__wrapped__, m = function(S) {
            return hs(S, e);
          };
          return r > 1 || this.__actions__.length || !(l instanceof Ce) || !Yn(o) ? this.thru(m) : (l = l.slice(o, +o + (r ? 1 : 0)), l.__actions__.push({
            func: ei,
            args: [m],
            thisArg: a
          }), new Qt(l, this.__chain__).thru(function(S) {
            return r && !S.length && S.push(a), S;
          }));
        });
        function o5() {
          return Bu(this);
        }
        function i5() {
          return new Qt(this.value(), this.__chain__);
        }
        function s5() {
          this.__values__ === a && (this.__values__ = Qu(this.value()));
          var e = this.__index__ >= this.__values__.length, r = e ? a : this.__values__[this.__index__++];
          return { done: e, value: r };
        }
        function l5() {
          return this;
        }
        function c5(e) {
          for (var r, o = this; o instanceof Uo; ) {
            var l = Iu(o);
            l.__index__ = 0, l.__values__ = a, r ? m.__wrapped__ = l : r = l;
            var m = l;
            o = o.__wrapped__;
          }
          return m.__wrapped__ = e, r;
        }
        function u5() {
          var e = this.__wrapped__;
          if (e instanceof Ce) {
            var r = e;
            return this.__actions__.length && (r = new Ce(this)), r = r.reverse(), r.__actions__.push({
              func: ei,
              args: [zs],
              thisArg: a
            }), new Qt(r, this.__chain__);
          }
          return this.thru(zs);
        }
        function d5() {
          return Jc(this.__wrapped__, this.__actions__);
        }
        var _5 = Zo(function(e, r, o) {
          Ue.call(e, o) ? ++e[o] : Vn(e, o, 1);
        });
        function p5(e, r, o) {
          var l = fe(e) ? _c : r_;
          return o && yt(e, r, o) && (r = a), l(e, ue(r, 3));
        }
        function m5(e, r) {
          var o = fe(e) ? tr : Pc;
          return o(e, ue(r, 3));
        }
        var g5 = uu(Nu), f5 = uu(Mu);
        function h5(e, r) {
          return dt(ti(e, r), 1);
        }
        function v5(e, r) {
          return dt(ti(e, r), ot);
        }
        function E5(e, r, o) {
          return o = o === a ? 1 : he(o), dt(ti(e, r), o);
        }
        function Fu(e, r) {
          var o = fe(e) ? jt : or;
          return o(e, ue(r, 3));
        }
        function Uu(e, r) {
          var o = fe(e) ? F0 : Lc;
          return o(e, ue(r, 3));
        }
        var b5 = Zo(function(e, r, o) {
          Ue.call(e, o) ? e[o].push(r) : Vn(e, o, [r]);
        });
        function S5(e, r, o, l) {
          e = Dt(e) ? e : da(e), o = o && !l ? he(o) : 0;
          var m = e.length;
          return o < 0 && (o = at(m + o, 0)), ii(e) ? o <= m && e.indexOf(r, o) > -1 : !!m && Jr(e, r, o) > -1;
        }
        var w5 = be(function(e, r, o) {
          var l = -1, m = typeof r == "function", S = Dt(e) ? B(e.length) : [];
          return or(e, function(T) {
            S[++l] = m ? vt(r, T, o) : Ha(T, r, o);
          }), S;
        }), y5 = Zo(function(e, r, o) {
          Vn(e, o, r);
        });
        function ti(e, r) {
          var o = fe(e) ? ze : Hc;
          return o(e, ue(r, 3));
        }
        function T5(e, r, o, l) {
          return e == null ? [] : (fe(r) || (r = r == null ? [] : [r]), o = l ? a : o, fe(o) || (o = o == null ? [] : [o]), Zc(e, r, o));
        }
        var C5 = Zo(function(e, r, o) {
          e[o ? 0 : 1].push(r);
        }, function() {
          return [[], []];
        });
        function x5(e, r, o) {
          var l = fe(e) ? as : fc, m = arguments.length < 3;
          return l(e, ue(r, 4), o, m, or);
        }
        function A5(e, r, o) {
          var l = fe(e) ? U0 : fc, m = arguments.length < 3;
          return l(e, ue(r, 4), o, m, Lc);
        }
        function R5(e, r) {
          var o = fe(e) ? tr : Pc;
          return o(e, ai(ue(r, 3)));
        }
        function O5(e) {
          var r = fe(e) ? Nc : S_;
          return r(e);
        }
        function I5(e, r, o) {
          (o ? yt(e, r, o) : r === a) ? r = 1 : r = he(r);
          var l = fe(e) ? X1 : w_;
          return l(e, r);
        }
        function N5(e) {
          var r = fe(e) ? J1 : T_;
          return r(e);
        }
        function M5(e) {
          if (e == null)
            return 0;
          if (Dt(e))
            return ii(e) ? ta(e) : e.length;
          var r = ft(e);
          return r == pt || r == Ut ? e.size : ys(e).length;
        }
        function D5(e, r, o) {
          var l = fe(e) ? os : C_;
          return o && yt(e, r, o) && (r = a), l(e, ue(r, 3));
        }
        var k5 = be(function(e, r) {
          if (e == null)
            return [];
          var o = r.length;
          return o > 1 && yt(e, r[0], r[1]) ? r = [] : o > 2 && yt(r[0], r[1], r[2]) && (r = [r[0]]), Zc(e, dt(r, 1), []);
        }), ni = m1 || function() {
          return Ge.Date.now();
        };
        function L5(e, r) {
          if (typeof r != "function")
            throw new Kt(p);
          return e = he(e), function() {
            if (--e < 1)
              return r.apply(this, arguments);
          };
        }
        function $u(e, r, o) {
          return r = o ? a : r, r = e && r == null ? e.length : r, Hn(e, ee, a, a, a, a, r);
        }
        function Vu(e, r) {
          var o;
          if (typeof r != "function")
            throw new Kt(p);
          return e = he(e), function() {
            return --e > 0 && (o = r.apply(this, arguments)), e <= 1 && (r = a), o;
          };
        }
        var qs = be(function(e, r, o) {
          var l = L;
          if (o.length) {
            var m = rr(o, ca(qs));
            l |= U;
          }
          return Hn(e, l, r, o, m);
        }), Hu = be(function(e, r, o) {
          var l = L | $;
          if (o.length) {
            var m = rr(o, ca(Hu));
            l |= U;
          }
          return Hn(r, l, e, o, m);
        });
        function Gu(e, r, o) {
          r = o ? a : r;
          var l = Hn(e, P, a, a, a, a, a, r);
          return l.placeholder = Gu.placeholder, l;
        }
        function Yu(e, r, o) {
          r = o ? a : r;
          var l = Hn(e, k, a, a, a, a, a, r);
          return l.placeholder = Yu.placeholder, l;
        }
        function zu(e, r, o) {
          var l, m, S, T, C, O, H = 0, Y = !1, j = !1, te = !0;
          if (typeof e != "function")
            throw new Kt(p);
          r = tn(r) || 0, We(o) && (Y = !!o.leading, j = "maxWait" in o, S = j ? at(tn(o.maxWait) || 0, r) : S, te = "trailing" in o ? !!o.trailing : te);
          function ie(et) {
            var dn = l, qn = m;
            return l = m = a, H = et, T = e.apply(qn, dn), T;
          }
          function de(et) {
            return H = et, C = qa(Te, r), Y ? ie(et) : T;
          }
          function Ee(et) {
            var dn = et - O, qn = et - H, ud = r - dn;
            return j ? gt(ud, S - qn) : ud;
          }
          function _e(et) {
            var dn = et - O, qn = et - H;
            return O === a || dn >= r || dn < 0 || j && qn >= S;
          }
          function Te() {
            var et = ni();
            if (_e(et))
              return Ae(et);
            C = qa(Te, Ee(et));
          }
          function Ae(et) {
            return C = a, te && l ? ie(et) : (l = m = a, T);
          }
          function zt() {
            C !== a && tu(C), H = 0, l = O = m = C = a;
          }
          function Tt() {
            return C === a ? T : Ae(ni());
          }
          function Zt() {
            var et = ni(), dn = _e(et);
            if (l = arguments, m = this, O = et, dn) {
              if (C === a)
                return de(O);
              if (j)
                return tu(C), C = qa(Te, r), ie(O);
            }
            return C === a && (C = qa(Te, r)), T;
          }
          return Zt.cancel = zt, Zt.flush = Tt, Zt;
        }
        var P5 = be(function(e, r) {
          return kc(e, 1, r);
        }), B5 = be(function(e, r, o) {
          return kc(e, tn(r) || 0, o);
        });
        function F5(e) {
          return Hn(e, re);
        }
        function ri(e, r) {
          if (typeof e != "function" || r != null && typeof r != "function")
            throw new Kt(p);
          var o = function() {
            var l = arguments, m = r ? r.apply(this, l) : l[0], S = o.cache;
            if (S.has(m))
              return S.get(m);
            var T = e.apply(this, l);
            return o.cache = S.set(m, T) || S, T;
          };
          return o.cache = new (ri.Cache || $n)(), o;
        }
        ri.Cache = $n;
        function ai(e) {
          if (typeof e != "function")
            throw new Kt(p);
          return function() {
            var r = arguments;
            switch (r.length) {
              case 0:
                return !e.call(this);
              case 1:
                return !e.call(this, r[0]);
              case 2:
                return !e.call(this, r[0], r[1]);
              case 3:
                return !e.call(this, r[0], r[1], r[2]);
            }
            return !e.apply(this, r);
          };
        }
        function U5(e) {
          return Vu(2, e);
        }
        var $5 = x_(function(e, r) {
          r = r.length == 1 && fe(r[0]) ? ze(r[0], Ht(ue())) : ze(dt(r, 1), Ht(ue()));
          var o = r.length;
          return be(function(l) {
            for (var m = -1, S = gt(l.length, o); ++m < S; )
              l[m] = r[m].call(this, l[m]);
            return vt(e, this, l);
          });
        }), Ws = be(function(e, r) {
          var o = rr(r, ca(Ws));
          return Hn(e, U, a, r, o);
        }), Zu = be(function(e, r) {
          var o = rr(r, ca(Zu));
          return Hn(e, Z, a, r, o);
        }), V5 = Gn(function(e, r) {
          return Hn(e, X, a, a, a, r);
        });
        function H5(e, r) {
          if (typeof e != "function")
            throw new Kt(p);
          return r = r === a ? r : he(r), be(e, r);
        }
        function G5(e, r) {
          if (typeof e != "function")
            throw new Kt(p);
          return r = r == null ? 0 : at(he(r), 0), be(function(o) {
            var l = o[r], m = lr(o, 0, r);
            return l && nr(m, l), vt(e, this, m);
          });
        }
        function Y5(e, r, o) {
          var l = !0, m = !0;
          if (typeof e != "function")
            throw new Kt(p);
          return We(o) && (l = "leading" in o ? !!o.leading : l, m = "trailing" in o ? !!o.trailing : m), zu(e, r, {
            leading: l,
            maxWait: r,
            trailing: m
          });
        }
        function z5(e) {
          return $u(e, 1);
        }
        function Z5(e, r) {
          return Ws(Ms(r), e);
        }
        function q5() {
          if (!arguments.length)
            return [];
          var e = arguments[0];
          return fe(e) ? e : [e];
        }
        function W5(e) {
          return Xt(e, x);
        }
        function j5(e, r) {
          return r = typeof r == "function" ? r : a, Xt(e, x, r);
        }
        function K5(e) {
          return Xt(e, b | x);
        }
        function Q5(e, r) {
          return r = typeof r == "function" ? r : a, Xt(e, b | x, r);
        }
        function X5(e, r) {
          return r == null || Dc(e, r, lt(r));
        }
        function un(e, r) {
          return e === r || e !== e && r !== r;
        }
        var J5 = Ko(bs), em = Ko(function(e, r) {
          return e >= r;
        }), Ar = Uc(/* @__PURE__ */ function() {
          return arguments;
        }()) ? Uc : function(e) {
          return Ke(e) && Ue.call(e, "callee") && !Cc.call(e, "callee");
        }, fe = B.isArray, tm = Kn ? Ht(Kn) : c_;
        function Dt(e) {
          return e != null && oi(e.length) && !zn(e);
        }
        function Je(e) {
          return Ke(e) && Dt(e);
        }
        function nm(e) {
          return e === !0 || e === !1 || Ke(e) && wt(e) == mt;
        }
        var cr = f1 || ol, rm = Ur ? Ht(Ur) : u_;
        function am(e) {
          return Ke(e) && e.nodeType === 1 && !Wa(e);
        }
        function om(e) {
          if (e == null)
            return !0;
          if (Dt(e) && (fe(e) || typeof e == "string" || typeof e.splice == "function" || cr(e) || ua(e) || Ar(e)))
            return !e.length;
          var r = ft(e);
          if (r == pt || r == Ut)
            return !e.size;
          if (Za(e))
            return !ys(e).length;
          for (var o in e)
            if (Ue.call(e, o))
              return !1;
          return !0;
        }
        function im(e, r) {
          return Ga(e, r);
        }
        function sm(e, r, o) {
          o = typeof o == "function" ? o : a;
          var l = o ? o(e, r) : a;
          return l === a ? Ga(e, r, a, o) : !!l;
        }
        function js(e) {
          if (!Ke(e))
            return !1;
          var r = wt(e);
          return r == pr || r == ha || typeof e.message == "string" && typeof e.name == "string" && !Wa(e);
        }
        function lm(e) {
          return typeof e == "number" && Ac(e);
        }
        function zn(e) {
          if (!We(e))
            return !1;
          var r = wt(e);
          return r == Cn || r == qr || r == Ot || r == Ja;
        }
        function qu(e) {
          return typeof e == "number" && e == he(e);
        }
        function oi(e) {
          return typeof e == "number" && e > -1 && e % 1 == 0 && e <= st;
        }
        function We(e) {
          var r = typeof e;
          return e != null && (r == "object" || r == "function");
        }
        function Ke(e) {
          return e != null && typeof e == "object";
        }
        var Wu = Er ? Ht(Er) : __;
        function cm(e, r) {
          return e === r || ws(e, r, Us(r));
        }
        function um(e, r, o) {
          return o = typeof o == "function" ? o : a, ws(e, r, Us(r), o);
        }
        function dm(e) {
          return ju(e) && e != +e;
        }
        function _m(e) {
          if (j_(e))
            throw new ge(u);
          return $c(e);
        }
        function pm(e) {
          return e === null;
        }
        function mm(e) {
          return e == null;
        }
        function ju(e) {
          return typeof e == "number" || Ke(e) && wt(e) == Xn;
        }
        function Wa(e) {
          if (!Ke(e) || wt(e) != Ft)
            return !1;
          var r = Mo(e);
          if (r === null)
            return !0;
          var o = Ue.call(r, "constructor") && r.constructor;
          return typeof o == "function" && o instanceof o && Ro.call(o) == u1;
        }
        var Ks = Xr ? Ht(Xr) : p_;
        function gm(e) {
          return qu(e) && e >= -st && e <= st;
        }
        var Ku = Ri ? Ht(Ri) : m_;
        function ii(e) {
          return typeof e == "string" || !fe(e) && Ke(e) && wt(e) == mr;
        }
        function Yt(e) {
          return typeof e == "symbol" || Ke(e) && wt(e) == gr;
        }
        var ua = oo ? Ht(oo) : g_;
        function fm(e) {
          return e === a;
        }
        function hm(e) {
          return Ke(e) && ft(e) == xn;
        }
        function vm(e) {
          return Ke(e) && wt(e) == Ea;
        }
        var Em = Ko(Ts), bm = Ko(function(e, r) {
          return e <= r;
        });
        function Qu(e) {
          if (!e)
            return [];
          if (Dt(e))
            return ii(e) ? ln(e) : Mt(e);
          if (La && e[La])
            return X0(e[La]());
          var r = ft(e), o = r == pt ? ds : r == Ut ? Co : da;
          return o(e);
        }
        function Zn(e) {
          if (!e)
            return e === 0 ? e : 0;
          if (e = tn(e), e === ot || e === -ot) {
            var r = e < 0 ? -1 : 1;
            return r * Me;
          }
          return e === e ? e : 0;
        }
        function he(e) {
          var r = Zn(e), o = r % 1;
          return r === r ? o ? r - o : r : 0;
        }
        function Xu(e) {
          return e ? yr(he(e), 0, Fe) : 0;
        }
        function tn(e) {
          if (typeof e == "number")
            return e;
          if (Yt(e))
            return je;
          if (We(e)) {
            var r = typeof e.valueOf == "function" ? e.valueOf() : e;
            e = We(r) ? r + "" : r;
          }
          if (typeof e != "string")
            return e === 0 ? e : +e;
          e = hc(e);
          var o = Hi.test(e);
          return o || K.test(e) ? Xe(e.slice(2), o ? 2 : 8) : Ti.test(e) ? je : +e;
        }
        function Ju(e) {
          return Sn(e, kt(e));
        }
        function Sm(e) {
          return e ? yr(he(e), -st, st) : e === 0 ? e : 0;
        }
        function Be(e) {
          return e == null ? "" : Gt(e);
        }
        var wm = sa(function(e, r) {
          if (Za(r) || Dt(r)) {
            Sn(r, lt(r), e);
            return;
          }
          for (var o in r)
            Ue.call(r, o) && $a(e, o, r[o]);
        }), ed = sa(function(e, r) {
          Sn(r, kt(r), e);
        }), si = sa(function(e, r, o, l) {
          Sn(r, kt(r), e, l);
        }), ym = sa(function(e, r, o, l) {
          Sn(r, lt(r), e, l);
        }), Tm = Gn(hs);
        function Cm(e, r) {
          var o = ia(e);
          return r == null ? o : Mc(o, r);
        }
        var xm = be(function(e, r) {
          e = Ve(e);
          var o = -1, l = r.length, m = l > 2 ? r[2] : a;
          for (m && yt(r[0], r[1], m) && (l = 1); ++o < l; )
            for (var S = r[o], T = kt(S), C = -1, O = T.length; ++C < O; ) {
              var H = T[C], Y = e[H];
              (Y === a || un(Y, ra[H]) && !Ue.call(e, H)) && (e[H] = S[H]);
            }
          return e;
        }), Am = be(function(e) {
          return e.push(a, hu), vt(td, a, e);
        });
        function Rm(e, r) {
          return pc(e, ue(r, 3), bn);
        }
        function Om(e, r) {
          return pc(e, ue(r, 3), Es);
        }
        function Im(e, r) {
          return e == null ? e : vs(e, ue(r, 3), kt);
        }
        function Nm(e, r) {
          return e == null ? e : Bc(e, ue(r, 3), kt);
        }
        function Mm(e, r) {
          return e && bn(e, ue(r, 3));
        }
        function Dm(e, r) {
          return e && Es(e, ue(r, 3));
        }
        function km(e) {
          return e == null ? [] : Ho(e, lt(e));
        }
        function Lm(e) {
          return e == null ? [] : Ho(e, kt(e));
        }
        function Qs(e, r, o) {
          var l = e == null ? a : Tr(e, r);
          return l === a ? o : l;
        }
        function Pm(e, r) {
          return e != null && bu(e, r, o_);
        }
        function Xs(e, r) {
          return e != null && bu(e, r, i_);
        }
        var Bm = _u(function(e, r, o) {
          r != null && typeof r.toString != "function" && (r = Oo.call(r)), e[r] = o;
        }, el(Lt)), Fm = _u(function(e, r, o) {
          r != null && typeof r.toString != "function" && (r = Oo.call(r)), Ue.call(e, r) ? e[r].push(o) : e[r] = [o];
        }, ue), Um = be(Ha);
        function lt(e) {
          return Dt(e) ? Ic(e) : ys(e);
        }
        function kt(e) {
          return Dt(e) ? Ic(e, !0) : f_(e);
        }
        function $m(e, r) {
          var o = {};
          return r = ue(r, 3), bn(e, function(l, m, S) {
            Vn(o, r(l, m, S), l);
          }), o;
        }
        function Vm(e, r) {
          var o = {};
          return r = ue(r, 3), bn(e, function(l, m, S) {
            Vn(o, m, r(l, m, S));
          }), o;
        }
        var Hm = sa(function(e, r, o) {
          Go(e, r, o);
        }), td = sa(function(e, r, o, l) {
          Go(e, r, o, l);
        }), Gm = Gn(function(e, r) {
          var o = {};
          if (e == null)
            return o;
          var l = !1;
          r = ze(r, function(S) {
            return S = sr(S, e), l || (l = S.length > 1), S;
          }), Sn(e, Bs(e), o), l && (o = Xt(o, b | w | x, B_));
          for (var m = r.length; m--; )
            Os(o, r[m]);
          return o;
        });
        function Ym(e, r) {
          return nd(e, ai(ue(r)));
        }
        var zm = Gn(function(e, r) {
          return e == null ? {} : v_(e, r);
        });
        function nd(e, r) {
          if (e == null)
            return {};
          var o = ze(Bs(e), function(l) {
            return [l];
          });
          return r = ue(r), qc(e, o, function(l, m) {
            return r(l, m[0]);
          });
        }
        function Zm(e, r, o) {
          r = sr(r, e);
          var l = -1, m = r.length;
          for (m || (m = 1, e = a); ++l < m; ) {
            var S = e == null ? a : e[wn(r[l])];
            S === a && (l = m, S = o), e = zn(S) ? S.call(e) : S;
          }
          return e;
        }
        function qm(e, r, o) {
          return e == null ? e : Ya(e, r, o);
        }
        function Wm(e, r, o, l) {
          return l = typeof l == "function" ? l : a, e == null ? e : Ya(e, r, o, l);
        }
        var rd = gu(lt), ad = gu(kt);
        function jm(e, r, o) {
          var l = fe(e), m = l || cr(e) || ua(e);
          if (r = ue(r, 4), o == null) {
            var S = e && e.constructor;
            m ? o = l ? new S() : [] : We(e) ? o = zn(S) ? ia(Mo(e)) : {} : o = {};
          }
          return (m ? jt : bn)(e, function(T, C, O) {
            return r(o, T, C, O);
          }), o;
        }
        function Km(e, r) {
          return e == null ? !0 : Os(e, r);
        }
        function Qm(e, r, o) {
          return e == null ? e : Xc(e, r, Ms(o));
        }
        function Xm(e, r, o, l) {
          return l = typeof l == "function" ? l : a, e == null ? e : Xc(e, r, Ms(o), l);
        }
        function da(e) {
          return e == null ? [] : us(e, lt(e));
        }
        function Jm(e) {
          return e == null ? [] : us(e, kt(e));
        }
        function eg(e, r, o) {
          return o === a && (o = r, r = a), o !== a && (o = tn(o), o = o === o ? o : 0), r !== a && (r = tn(r), r = r === r ? r : 0), yr(tn(e), r, o);
        }
        function tg(e, r, o) {
          return r = Zn(r), o === a ? (o = r, r = 0) : o = Zn(o), e = tn(e), s_(e, r, o);
        }
        function ng(e, r, o) {
          if (o && typeof o != "boolean" && yt(e, r, o) && (r = o = a), o === a && (typeof r == "boolean" ? (o = r, r = a) : typeof e == "boolean" && (o = e, e = a)), e === a && r === a ? (e = 0, r = 1) : (e = Zn(e), r === a ? (r = e, e = 0) : r = Zn(r)), e > r) {
            var l = e;
            e = r, r = l;
          }
          if (o || e % 1 || r % 1) {
            var m = Rc();
            return gt(e + m * (r - e + It("1e-" + ((m + "").length - 1))), r);
          }
          return xs(e, r);
        }
        var rg = la(function(e, r, o) {
          return r = r.toLowerCase(), e + (o ? od(r) : r);
        });
        function od(e) {
          return Js(Be(e).toLowerCase());
        }
        function id(e) {
          return e = Be(e), e && e.replace(xe, q0).replace(uc, "");
        }
        function ag(e, r, o) {
          e = Be(e), r = Gt(r);
          var l = e.length;
          o = o === a ? l : yr(he(o), 0, l);
          var m = o;
          return o -= r.length, o >= 0 && e.slice(o, m) == r;
        }
        function og(e) {
          return e = Be(e), e && Ia.test(e) ? e.replace(Kr, W0) : e;
        }
        function ig(e) {
          return e = Be(e), e && Vi.test(e) ? e.replace(Sa, "\\$&") : e;
        }
        var sg = la(function(e, r, o) {
          return e + (o ? "-" : "") + r.toLowerCase();
        }), lg = la(function(e, r, o) {
          return e + (o ? " " : "") + r.toLowerCase();
        }), cg = cu("toLowerCase");
        function ug(e, r, o) {
          e = Be(e), r = he(r);
          var l = r ? ta(e) : 0;
          if (!r || l >= r)
            return e;
          var m = (r - l) / 2;
          return jo(Po(m), o) + e + jo(Lo(m), o);
        }
        function dg(e, r, o) {
          e = Be(e), r = he(r);
          var l = r ? ta(e) : 0;
          return r && l < r ? e + jo(r - l, o) : e;
        }
        function _g(e, r, o) {
          e = Be(e), r = he(r);
          var l = r ? ta(e) : 0;
          return r && l < r ? jo(r - l, o) + e : e;
        }
        function pg(e, r, o) {
          return o || r == null ? r = 0 : r && (r = +r), b1(Be(e).replace(On, ""), r || 0);
        }
        function mg(e, r, o) {
          return (o ? yt(e, r, o) : r === a) ? r = 1 : r = he(r), As(Be(e), r);
        }
        function gg() {
          var e = arguments, r = Be(e[0]);
          return e.length < 3 ? r : r.replace(e[1], e[2]);
        }
        var fg = la(function(e, r, o) {
          return e + (o ? "_" : "") + r.toLowerCase();
        });
        function hg(e, r, o) {
          return o && typeof o != "number" && yt(e, r, o) && (r = o = a), o = o === a ? Fe : o >>> 0, o ? (e = Be(e), e && (typeof r == "string" || r != null && !Ks(r)) && (r = Gt(r), !r && ea(e)) ? lr(ln(e), 0, o) : e.split(r, o)) : [];
        }
        var vg = la(function(e, r, o) {
          return e + (o ? " " : "") + Js(r);
        });
        function Eg(e, r, o) {
          return e = Be(e), o = o == null ? 0 : yr(he(o), 0, e.length), r = Gt(r), e.slice(o, o + r.length) == r;
        }
        function bg(e, r, o) {
          var l = v.templateSettings;
          o && yt(e, r, o) && (r = a), e = Be(e), r = si({}, r, l, fu);
          var m = si({}, r.imports, l.imports, fu), S = lt(m), T = us(m, S), C, O, H = 0, Y = r.interpolate || ut, j = "__p += '", te = _s(
            (r.escape || ut).source + "|" + Y.source + "|" + (Y === Na ? yi : ut).source + "|" + (r.evaluate || ut).source + "|$",
            "g"
          ), ie = "//# sourceURL=" + (Ue.call(r, "sourceURL") ? (r.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++dc + "]") + `
`;
          e.replace(te, function(_e, Te, Ae, zt, Tt, Zt) {
            return Ae || (Ae = zt), j += e.slice(H, Zt).replace(hn, j0), Te && (C = !0, j += `' +
__e(` + Te + `) +
'`), Tt && (O = !0, j += `';
` + Tt + `;
__p += '`), Ae && (j += `' +
((__t = (` + Ae + `)) == null ? '' : __t) +
'`), H = Zt + _e.length, _e;
          }), j += `';
`;
          var de = Ue.call(r, "variable") && r.variable;
          if (!de)
            j = `with (obj) {
` + j + `
}
`;
          else if (hr.test(de))
            throw new ge(g);
          j = (O ? j.replace($i, "") : j).replace(_r, "$1").replace(Oa, "$1;"), j = "function(" + (de || "obj") + `) {
` + (de ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (C ? ", __e = _.escape" : "") + (O ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + j + `return __p
}`;
          var Ee = ld(function() {
            return ke(S, ie + "return " + j).apply(a, T);
          });
          if (Ee.source = j, js(Ee))
            throw Ee;
          return Ee;
        }
        function Sg(e) {
          return Be(e).toLowerCase();
        }
        function wg(e) {
          return Be(e).toUpperCase();
        }
        function yg(e, r, o) {
          if (e = Be(e), e && (o || r === a))
            return hc(e);
          if (!e || !(r = Gt(r)))
            return e;
          var l = ln(e), m = ln(r), S = vc(l, m), T = Ec(l, m) + 1;
          return lr(l, S, T).join("");
        }
        function Tg(e, r, o) {
          if (e = Be(e), e && (o || r === a))
            return e.slice(0, Sc(e) + 1);
          if (!e || !(r = Gt(r)))
            return e;
          var l = ln(e), m = Ec(l, ln(r)) + 1;
          return lr(l, 0, m).join("");
        }
        function Cg(e, r, o) {
          if (e = Be(e), e && (o || r === a))
            return e.replace(On, "");
          if (!e || !(r = Gt(r)))
            return e;
          var l = ln(e), m = vc(l, ln(r));
          return lr(l, m).join("");
        }
        function xg(e, r) {
          var o = Q, l = ce;
          if (We(r)) {
            var m = "separator" in r ? r.separator : m;
            o = "length" in r ? he(r.length) : o, l = "omission" in r ? Gt(r.omission) : l;
          }
          e = Be(e);
          var S = e.length;
          if (ea(e)) {
            var T = ln(e);
            S = T.length;
          }
          if (o >= S)
            return e;
          var C = o - ta(l);
          if (C < 1)
            return l;
          var O = T ? lr(T, 0, C).join("") : e.slice(0, C);
          if (m === a)
            return O + l;
          if (T && (C += O.length - C), Ks(m)) {
            if (e.slice(C).search(m)) {
              var H, Y = O;
              for (m.global || (m = _s(m.source, Be(jn.exec(m)) + "g")), m.lastIndex = 0; H = m.exec(Y); )
                var j = H.index;
              O = O.slice(0, j === a ? C : j);
            }
          } else if (e.indexOf(Gt(m), C) != C) {
            var te = O.lastIndexOf(m);
            te > -1 && (O = O.slice(0, te));
          }
          return O + l;
        }
        function Ag(e) {
          return e = Be(e), e && ho.test(e) ? e.replace(fo, n1) : e;
        }
        var Rg = la(function(e, r, o) {
          return e + (o ? " " : "") + r.toUpperCase();
        }), Js = cu("toUpperCase");
        function sd(e, r, o) {
          return e = Be(e), r = o ? a : r, r === a ? Q0(e) ? o1(e) : H0(e) : e.match(r) || [];
        }
        var ld = be(function(e, r) {
          try {
            return vt(e, a, r);
          } catch (o) {
            return js(o) ? o : new ge(o);
          }
        }), Og = Gn(function(e, r) {
          return jt(r, function(o) {
            o = wn(o), Vn(e, o, qs(e[o], e));
          }), e;
        });
        function Ig(e) {
          var r = e == null ? 0 : e.length, o = ue();
          return e = r ? ze(e, function(l) {
            if (typeof l[1] != "function")
              throw new Kt(p);
            return [o(l[0]), l[1]];
          }) : [], be(function(l) {
            for (var m = -1; ++m < r; ) {
              var S = e[m];
              if (vt(S[0], this, l))
                return vt(S[1], this, l);
            }
          });
        }
        function Ng(e) {
          return n_(Xt(e, b));
        }
        function el(e) {
          return function() {
            return e;
          };
        }
        function Mg(e, r) {
          return e == null || e !== e ? r : e;
        }
        var Dg = du(), kg = du(!0);
        function Lt(e) {
          return e;
        }
        function tl(e) {
          return Vc(typeof e == "function" ? e : Xt(e, b));
        }
        function Lg(e) {
          return Gc(Xt(e, b));
        }
        function Pg(e, r) {
          return Yc(e, Xt(r, b));
        }
        var Bg = be(function(e, r) {
          return function(o) {
            return Ha(o, e, r);
          };
        }), Fg = be(function(e, r) {
          return function(o) {
            return Ha(e, o, r);
          };
        });
        function nl(e, r, o) {
          var l = lt(r), m = Ho(r, l);
          o == null && !(We(r) && (m.length || !l.length)) && (o = r, r = e, e = this, m = Ho(r, lt(r)));
          var S = !(We(o) && "chain" in o) || !!o.chain, T = zn(e);
          return jt(m, function(C) {
            var O = r[C];
            e[C] = O, T && (e.prototype[C] = function() {
              var H = this.__chain__;
              if (S || H) {
                var Y = e(this.__wrapped__), j = Y.__actions__ = Mt(this.__actions__);
                return j.push({ func: O, args: arguments, thisArg: e }), Y.__chain__ = H, Y;
              }
              return O.apply(e, nr([this.value()], arguments));
            });
          }), e;
        }
        function Ug() {
          return Ge._ === this && (Ge._ = d1), this;
        }
        function rl() {
        }
        function $g(e) {
          return e = he(e), be(function(r) {
            return zc(r, e);
          });
        }
        var Vg = ks(ze), Hg = ks(_c), Gg = ks(os);
        function cd(e) {
          return Vs(e) ? is(wn(e)) : E_(e);
        }
        function Yg(e) {
          return function(r) {
            return e == null ? a : Tr(e, r);
          };
        }
        var zg = pu(), Zg = pu(!0);
        function al() {
          return [];
        }
        function ol() {
          return !1;
        }
        function qg() {
          return {};
        }
        function Wg() {
          return "";
        }
        function jg() {
          return !0;
        }
        function Kg(e, r) {
          if (e = he(e), e < 1 || e > st)
            return [];
          var o = Fe, l = gt(e, Fe);
          r = ue(r), e -= Fe;
          for (var m = cs(l, r); ++o < e; )
            r(o);
          return m;
        }
        function Qg(e) {
          return fe(e) ? ze(e, wn) : Yt(e) ? [e] : Mt(Ou(Be(e)));
        }
        function Xg(e) {
          var r = ++c1;
          return Be(e) + r;
        }
        var Jg = Wo(function(e, r) {
          return e + r;
        }, 0), e2 = Ls("ceil"), t2 = Wo(function(e, r) {
          return e / r;
        }, 1), n2 = Ls("floor");
        function r2(e) {
          return e && e.length ? Vo(e, Lt, bs) : a;
        }
        function a2(e, r) {
          return e && e.length ? Vo(e, ue(r, 2), bs) : a;
        }
        function o2(e) {
          return gc(e, Lt);
        }
        function i2(e, r) {
          return gc(e, ue(r, 2));
        }
        function s2(e) {
          return e && e.length ? Vo(e, Lt, Ts) : a;
        }
        function l2(e, r) {
          return e && e.length ? Vo(e, ue(r, 2), Ts) : a;
        }
        var c2 = Wo(function(e, r) {
          return e * r;
        }, 1), u2 = Ls("round"), d2 = Wo(function(e, r) {
          return e - r;
        }, 0);
        function _2(e) {
          return e && e.length ? ls(e, Lt) : 0;
        }
        function p2(e, r) {
          return e && e.length ? ls(e, ue(r, 2)) : 0;
        }
        return v.after = L5, v.ary = $u, v.assign = wm, v.assignIn = ed, v.assignInWith = si, v.assignWith = ym, v.at = Tm, v.before = Vu, v.bind = qs, v.bindAll = Og, v.bindKey = Hu, v.castArray = q5, v.chain = Bu, v.chunk = np, v.compact = rp, v.concat = ap, v.cond = Ig, v.conforms = Ng, v.constant = el, v.countBy = _5, v.create = Cm, v.curry = Gu, v.curryRight = Yu, v.debounce = zu, v.defaults = xm, v.defaultsDeep = Am, v.defer = P5, v.delay = B5, v.difference = op, v.differenceBy = ip, v.differenceWith = sp, v.drop = lp, v.dropRight = cp, v.dropRightWhile = up, v.dropWhile = dp, v.fill = _p, v.filter = m5, v.flatMap = h5, v.flatMapDeep = v5, v.flatMapDepth = E5, v.flatten = Du, v.flattenDeep = pp, v.flattenDepth = mp, v.flip = F5, v.flow = Dg, v.flowRight = kg, v.fromPairs = gp, v.functions = km, v.functionsIn = Lm, v.groupBy = b5, v.initial = hp, v.intersection = vp, v.intersectionBy = Ep, v.intersectionWith = bp, v.invert = Bm, v.invertBy = Fm, v.invokeMap = w5, v.iteratee = tl, v.keyBy = y5, v.keys = lt, v.keysIn = kt, v.map = ti, v.mapKeys = $m, v.mapValues = Vm, v.matches = Lg, v.matchesProperty = Pg, v.memoize = ri, v.merge = Hm, v.mergeWith = td, v.method = Bg, v.methodOf = Fg, v.mixin = nl, v.negate = ai, v.nthArg = $g, v.omit = Gm, v.omitBy = Ym, v.once = U5, v.orderBy = T5, v.over = Vg, v.overArgs = $5, v.overEvery = Hg, v.overSome = Gg, v.partial = Ws, v.partialRight = Zu, v.partition = C5, v.pick = zm, v.pickBy = nd, v.property = cd, v.propertyOf = Yg, v.pull = Tp, v.pullAll = Lu, v.pullAllBy = Cp, v.pullAllWith = xp, v.pullAt = Ap, v.range = zg, v.rangeRight = Zg, v.rearg = V5, v.reject = R5, v.remove = Rp, v.rest = H5, v.reverse = zs, v.sampleSize = I5, v.set = qm, v.setWith = Wm, v.shuffle = N5, v.slice = Op, v.sortBy = k5, v.sortedUniq = Pp, v.sortedUniqBy = Bp, v.split = hg, v.spread = G5, v.tail = Fp, v.take = Up, v.takeRight = $p, v.takeRightWhile = Vp, v.takeWhile = Hp, v.tap = r5, v.throttle = Y5, v.thru = ei, v.toArray = Qu, v.toPairs = rd, v.toPairsIn = ad, v.toPath = Qg, v.toPlainObject = Ju, v.transform = jm, v.unary = z5, v.union = Gp, v.unionBy = Yp, v.unionWith = zp, v.uniq = Zp, v.uniqBy = qp, v.uniqWith = Wp, v.unset = Km, v.unzip = Zs, v.unzipWith = Pu, v.update = Qm, v.updateWith = Xm, v.values = da, v.valuesIn = Jm, v.without = jp, v.words = sd, v.wrap = Z5, v.xor = Kp, v.xorBy = Qp, v.xorWith = Xp, v.zip = Jp, v.zipObject = e5, v.zipObjectDeep = t5, v.zipWith = n5, v.entries = rd, v.entriesIn = ad, v.extend = ed, v.extendWith = si, nl(v, v), v.add = Jg, v.attempt = ld, v.camelCase = rg, v.capitalize = od, v.ceil = e2, v.clamp = eg, v.clone = W5, v.cloneDeep = K5, v.cloneDeepWith = Q5, v.cloneWith = j5, v.conformsTo = X5, v.deburr = id, v.defaultTo = Mg, v.divide = t2, v.endsWith = ag, v.eq = un, v.escape = og, v.escapeRegExp = ig, v.every = p5, v.find = g5, v.findIndex = Nu, v.findKey = Rm, v.findLast = f5, v.findLastIndex = Mu, v.findLastKey = Om, v.floor = n2, v.forEach = Fu, v.forEachRight = Uu, v.forIn = Im, v.forInRight = Nm, v.forOwn = Mm, v.forOwnRight = Dm, v.get = Qs, v.gt = J5, v.gte = em, v.has = Pm, v.hasIn = Xs, v.head = ku, v.identity = Lt, v.includes = S5, v.indexOf = fp, v.inRange = tg, v.invoke = Um, v.isArguments = Ar, v.isArray = fe, v.isArrayBuffer = tm, v.isArrayLike = Dt, v.isArrayLikeObject = Je, v.isBoolean = nm, v.isBuffer = cr, v.isDate = rm, v.isElement = am, v.isEmpty = om, v.isEqual = im, v.isEqualWith = sm, v.isError = js, v.isFinite = lm, v.isFunction = zn, v.isInteger = qu, v.isLength = oi, v.isMap = Wu, v.isMatch = cm, v.isMatchWith = um, v.isNaN = dm, v.isNative = _m, v.isNil = mm, v.isNull = pm, v.isNumber = ju, v.isObject = We, v.isObjectLike = Ke, v.isPlainObject = Wa, v.isRegExp = Ks, v.isSafeInteger = gm, v.isSet = Ku, v.isString = ii, v.isSymbol = Yt, v.isTypedArray = ua, v.isUndefined = fm, v.isWeakMap = hm, v.isWeakSet = vm, v.join = Sp, v.kebabCase = sg, v.last = en, v.lastIndexOf = wp, v.lowerCase = lg, v.lowerFirst = cg, v.lt = Em, v.lte = bm, v.max = r2, v.maxBy = a2, v.mean = o2, v.meanBy = i2, v.min = s2, v.minBy = l2, v.stubArray = al, v.stubFalse = ol, v.stubObject = qg, v.stubString = Wg, v.stubTrue = jg, v.multiply = c2, v.nth = yp, v.noConflict = Ug, v.noop = rl, v.now = ni, v.pad = ug, v.padEnd = dg, v.padStart = _g, v.parseInt = pg, v.random = ng, v.reduce = x5, v.reduceRight = A5, v.repeat = mg, v.replace = gg, v.result = Zm, v.round = u2, v.runInContext = R, v.sample = O5, v.size = M5, v.snakeCase = fg, v.some = D5, v.sortedIndex = Ip, v.sortedIndexBy = Np, v.sortedIndexOf = Mp, v.sortedLastIndex = Dp, v.sortedLastIndexBy = kp, v.sortedLastIndexOf = Lp, v.startCase = vg, v.startsWith = Eg, v.subtract = d2, v.sum = _2, v.sumBy = p2, v.template = bg, v.times = Kg, v.toFinite = Zn, v.toInteger = he, v.toLength = Xu, v.toLower = Sg, v.toNumber = tn, v.toSafeInteger = Sm, v.toString = Be, v.toUpper = wg, v.trim = yg, v.trimEnd = Tg, v.trimStart = Cg, v.truncate = xg, v.unescape = Ag, v.uniqueId = Xg, v.upperCase = Rg, v.upperFirst = Js, v.each = Fu, v.eachRight = Uu, v.first = ku, nl(v, function() {
          var e = {};
          return bn(v, function(r, o) {
            Ue.call(v.prototype, o) || (e[o] = r);
          }), e;
        }(), { chain: !1 }), v.VERSION = i, jt(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(e) {
          v[e].placeholder = v;
        }), jt(["drop", "take"], function(e, r) {
          Ce.prototype[e] = function(o) {
            o = o === a ? 1 : at(he(o), 0);
            var l = this.__filtered__ && !r ? new Ce(this) : this.clone();
            return l.__filtered__ ? l.__takeCount__ = gt(o, l.__takeCount__) : l.__views__.push({
              size: gt(o, Fe),
              type: e + (l.__dir__ < 0 ? "Right" : "")
            }), l;
          }, Ce.prototype[e + "Right"] = function(o) {
            return this.reverse()[e](o).reverse();
          };
        }), jt(["filter", "map", "takeWhile"], function(e, r) {
          var o = r + 1, l = o == Le || o == _t;
          Ce.prototype[e] = function(m) {
            var S = this.clone();
            return S.__iteratees__.push({
              iteratee: ue(m, 3),
              type: o
            }), S.__filtered__ = S.__filtered__ || l, S;
          };
        }), jt(["head", "last"], function(e, r) {
          var o = "take" + (r ? "Right" : "");
          Ce.prototype[e] = function() {
            return this[o](1).value()[0];
          };
        }), jt(["initial", "tail"], function(e, r) {
          var o = "drop" + (r ? "" : "Right");
          Ce.prototype[e] = function() {
            return this.__filtered__ ? new Ce(this) : this[o](1);
          };
        }), Ce.prototype.compact = function() {
          return this.filter(Lt);
        }, Ce.prototype.find = function(e) {
          return this.filter(e).head();
        }, Ce.prototype.findLast = function(e) {
          return this.reverse().find(e);
        }, Ce.prototype.invokeMap = be(function(e, r) {
          return typeof e == "function" ? new Ce(this) : this.map(function(o) {
            return Ha(o, e, r);
          });
        }), Ce.prototype.reject = function(e) {
          return this.filter(ai(ue(e)));
        }, Ce.prototype.slice = function(e, r) {
          e = he(e);
          var o = this;
          return o.__filtered__ && (e > 0 || r < 0) ? new Ce(o) : (e < 0 ? o = o.takeRight(-e) : e && (o = o.drop(e)), r !== a && (r = he(r), o = r < 0 ? o.dropRight(-r) : o.take(r - e)), o);
        }, Ce.prototype.takeRightWhile = function(e) {
          return this.reverse().takeWhile(e).reverse();
        }, Ce.prototype.toArray = function() {
          return this.take(Fe);
        }, bn(Ce.prototype, function(e, r) {
          var o = /^(?:filter|find|map|reject)|While$/.test(r), l = /^(?:head|last)$/.test(r), m = v[l ? "take" + (r == "last" ? "Right" : "") : r], S = l || /^find/.test(r);
          m && (v.prototype[r] = function() {
            var T = this.__wrapped__, C = l ? [1] : arguments, O = T instanceof Ce, H = C[0], Y = O || fe(T), j = function(Te) {
              var Ae = m.apply(v, nr([Te], C));
              return l && te ? Ae[0] : Ae;
            };
            Y && o && typeof H == "function" && H.length != 1 && (O = Y = !1);
            var te = this.__chain__, ie = !!this.__actions__.length, de = S && !te, Ee = O && !ie;
            if (!S && Y) {
              T = Ee ? T : new Ce(this);
              var _e = e.apply(T, C);
              return _e.__actions__.push({ func: ei, args: [j], thisArg: a }), new Qt(_e, te);
            }
            return de && Ee ? e.apply(this, C) : (_e = this.thru(j), de ? l ? _e.value()[0] : _e.value() : _e);
          });
        }), jt(["pop", "push", "shift", "sort", "splice", "unshift"], function(e) {
          var r = xo[e], o = /^(?:push|sort|unshift)$/.test(e) ? "tap" : "thru", l = /^(?:pop|shift)$/.test(e);
          v.prototype[e] = function() {
            var m = arguments;
            if (l && !this.__chain__) {
              var S = this.value();
              return r.apply(fe(S) ? S : [], m);
            }
            return this[o](function(T) {
              return r.apply(fe(T) ? T : [], m);
            });
          };
        }), bn(Ce.prototype, function(e, r) {
          var o = v[r];
          if (o) {
            var l = o.name + "";
            Ue.call(oa, l) || (oa[l] = []), oa[l].push({ name: r, func: o });
          }
        }), oa[qo(a, $).name] = [{
          name: "wrapper",
          func: a
        }], Ce.prototype.clone = A1, Ce.prototype.reverse = R1, Ce.prototype.value = O1, v.prototype.at = a5, v.prototype.chain = o5, v.prototype.commit = i5, v.prototype.next = s5, v.prototype.plant = c5, v.prototype.reverse = u5, v.prototype.toJSON = v.prototype.valueOf = v.prototype.value = d5, v.prototype.first = v.prototype.head, La && (v.prototype[La] = l5), v;
      }, na = i1();
      Nt ? ((Nt.exports = na)._ = na, St._ = na) : Ge._ = na;
    }).call(BY);
  }(Ed, Ed.exports)), Ed.exports;
}
var UY = FY();
const N2 = "p-tag-wrapper__tag--invisible", Zd = "p-tag-wrapper__tag--hidden", x3 = /* @__PURE__ */ W({
  __name: "PTagWrapper",
  props: {
    tags: {},
    justify: {},
    inline: { type: Boolean },
    small: { type: Boolean }
  },
  setup(t, { expose: n }) {
    const a = t, i = z(), s = z(!1), u = z(0), p = z(), g = z(""), E = M(() => ({
      tagContainer: [
        `p-tag-wrapper--${a.justify ?? "left"}`,
        { "p-tag-wrapper--invisible": !s.value },
        { "p-tag-wrapper--inline": a.inline }
      ],
      overflowTag: [
        `p-tag-wrapper__tag--${a.justify ?? "left"}`,
        { "p-tag-wrapper__tag--hidden": !w.value }
      ],
      tag: [`p-tag-wrapper__tag--${a.justify ?? "left"}`]
    })), h = M(() => (a.tags ?? []).map(Jf));
    let f = null, b = null;
    const w = M(() => u.value > 0), x = (k, U) => {
      const { left: Z, right: ee } = k.getBoundingClientRect(), { left: X, right: re } = U.getBoundingClientRect();
      return a.justify === "right" ? Z < X : a.justify === "center" && Z < X || ee > re;
    }, A = () => {
      if (!i.value || !p.value)
        return;
      u.value = 0, g.value = "";
      const k = [], U = Array.from(i.value.children), Z = U.filter((Q) => !Q.isEqualNode(p.value));
      L(U);
      let ee = a.justify === "right" ? U.slice().reverse() : U.slice();
      a.inline && $(Z);
      let X = !1;
      for (; ee.length > 0; ) {
        const Q = ee.pop();
        if (!Q || (X = x(Q, i.value), X && !Q.isEqualNode(p.value) ? (D(Q, "hidden"), u.value++, Q.textContent && k.push(Q.textContent)) : D(Q, "visible"), u.value >= U.length - 1))
          break;
      }
      u.value > 0 ? D(p.value, "visible") : D(p.value, "hidden");
      let re = u.value > 0 && x(p.value, i.value);
      if (re)
        for (ee = Array.from(i.value.children).filter((Q) => !Q.isEqualNode(p.value) && !Q.classList.contains(Zd)); re; ) {
          const Q = ee.pop();
          if (!Q)
            break;
          D(Q, "hidden"), u.value++, Q.textContent && k.push(Q.textContent), re = x(p.value, i.value);
        }
      g.value = k.reverse().join(", "), s.value = !0;
    };
    function D(k, U) {
      switch (U) {
        case "invisible":
          k.classList.remove(Zd), k.classList.add(N2);
          break;
        case "hidden":
          k.classList.remove(N2), k.classList.add(Zd);
          break;
        case "visible":
          k.classList.remove(Zd), k.classList.remove(N2);
          break;
      }
    }
    function L(k) {
      for (const U of k)
        D(U, "invisible");
    }
    function $(k) {
      if (!i.value)
        return;
      const U = q(k), ee = getComputedStyle(i.value).getPropertyValue("column-gap"), X = parseFloat(ee), re = isNaN(X) ? 0 : (k.length - 1) * X, Q = U + re;
      i.value.style.width = `${Q}px`;
    }
    function q(k) {
      return Math.ceil(k.reduce((U, Z) => {
        const ee = Z.getBoundingClientRect();
        return U + ee.width;
      }, 0));
    }
    function P() {
      const k = UY.throttle(A, 100, { trailing: !0 });
      f = new ResizeObserver(k), b = new MutationObserver(k), i.value && (f.observe(i.value), b.observe(i.value, { childList: !0, subtree: !0 }));
    }
    return xt(() => {
      P();
    }), zr(() => {
      f?.disconnect(), b?.disconnect();
    }), tt(() => a.tags, () => {
      Ct(() => A());
    }, { deep: !0 }), n({
      calculateOverflow: A
    }), (k, U) => (c(), _("div", {
      ref_key: "container",
      ref: i,
      class: Oe(["p-tag-wrapper", E.value.tagContainer])
    }, [
      I(k.$slots, "default", {}, () => [
        (c(!0), _(Qe, null, Ye(h.value, (Z) => (c(), _("div", {
          key: Z.value,
          class: Oe(["p-tag-wrapper__tag", E.value.tag])
        }, [
          I(k.$slots, "tag", { tag: Z }, () => [
            ne(Yl, {
              value: Z,
              small: k.small
            }, null, 8, ["value", "small"])
          ])
        ], 2))), 128))
      ]),
      d("div", {
        ref_key: "overflowTag",
        ref: p,
        class: Oe(["p-tag-wrapper__tag-overflow", E.value.overflowTag])
      }, [
        I(k.$slots, "overflow", ve(we({ hiddenText: g.value, overflowCount: u.value })), () => [
          ne(xd, { text: g.value }, {
            default: N(() => [
              I(k.$slots, "overflow-tags", { overflowedChildren: u.value }, () => [
                ne(Yl, { small: k.small }, {
                  default: N(() => [
                    Ne(" +" + ye(u.value), 1)
                  ]),
                  _: 1
                }, 8, ["small"])
              ])
            ]),
            _: 3
          }, 8, ["text"])
        ])
      ], 2)
    ], 2));
  }
}), $Y = {
  key: 0,
  class: "p-select__empty-message"
}, L0 = /* @__PURE__ */ W({
  inheritAttrs: !1,
  __name: "PSelect",
  props: {
    modelValue: { type: [String, Number, Boolean, null, Array] },
    disabled: { type: Boolean },
    options: {},
    emptyMessage: {},
    multiple: { type: Boolean },
    small: { type: Boolean },
    optionsClass: {}
  },
  emits: ["update:modelValue", "open", "close", "bottom"],
  setup(t, { emit: n }) {
    const a = t, i = n, s = z(), u = M(() => s.value?.wrapper), { width: p } = tc(u), { classes: g, styles: E, attrs: h } = Xa(), f = z(), b = M({
      get() {
        return x.value ? a.modelValue ?? [] : a.modelValue ?? null;
      },
      set(Se) {
        i("update:modelValue", Se);
      }
    }), w = M(() => cl(b.value).map((Se) => ({
      label: q(Se),
      value: Se
    }))), x = M(() => a.multiple || Y2(a.modelValue)), A = M(() => f.value?.visible ?? !1), D = M(() => x.value ? cl(b.value).length === 0 : b.value === null), L = M(() => Gl(a.options.map(Ei)));
    function $(Se) {
      return L.value.find((Le) => Le.value === Se);
    }
    function q(Se) {
      return $(Se)?.label ?? "";
    }
    function P(Se) {
      Y2(b.value) && (b.value = b.value.filter((Le) => Le !== Se.value));
    }
    function k() {
      x.value || re();
    }
    function U(Se) {
      return a.disabled ? !1 : !$(Se.value)?.disabled;
    }
    const Z = M(() => ({
      control: {
        "p-select--open": A.value
      }
    })), ee = M(() => ({
      option: {
        minWidth: `${p.value}px`
      }
    }));
    function X() {
      !A.value && !a.disabled && f.value.open();
    }
    function re() {
      A.value && f.value.close();
    }
    function Q() {
      A.value ? re() : X();
    }
    function ce(Se) {
      Se ? i("open") : (i("close"), s.value?.el.focus());
    }
    function me(Se) {
      if (Qf(Se.key)) {
        X();
        return;
      }
      switch (Se.key) {
        case Ie.escape:
        case Ie.tab:
          re();
          break;
        case Ie.upArrow:
        case Ie.downArrow:
        case Ie.space:
          A.value || (X(), Se.preventDefault());
          break;
      }
    }
    return (Se, Le) => (c(), G(Sl, {
      ref_key: "popOver",
      ref: f,
      placement: [y(Fi), y(Bi), y(Pi), y(Li)],
      class: Oe(["p-select", y(g)]),
      styles: y(E),
      "auto-close": "",
      onOpen: ce,
      onKeydown: me
    }, {
      target: N(() => [
        y(Dd).hover ? (c(), G(OY, oe({
          key: 0,
          ref_key: "buttonElement",
          ref: s,
          modelValue: b.value,
          "onUpdate:modelValue": Le[0] || (Le[0] = (qe) => b.value = qe),
          class: Z.value.control,
          disabled: Se.disabled
        }, y(h), {
          small: Se.small,
          onClick: Q
        }), {
          default: N(() => [
            D.value ? (c(), _("span", $Y, [
              I(Se.$slots, "empty-message", {}, () => [
                Ne(ye(Se.emptyMessage), 1)
              ])
            ])) : x.value ? (c(), G(x3, {
              key: 1,
              tags: w.value,
              inline: "",
              small: Se.small
            }, {
              tag: N(({ tag: qe }) => [
                I(Se.$slots, "tag", {
                  label: qe.label,
                  value: qe.value,
                  dismiss: () => P(qe)
                }, () => [
                  ne(Yl, {
                    dismissible: U(qe),
                    small: Se.small,
                    onDismiss: (_t) => P(qe)
                  }, {
                    default: N(() => [
                      I(Se.$slots, "default", {
                        label: qe.label,
                        value: qe.value,
                        option: $(qe.value)
                      }, () => [
                        Ne(ye(qe.label), 1)
                      ])
                    ]),
                    _: 2
                  }, 1032, ["dismissible", "small", "onDismiss"])
                ])
              ]),
              "overflow-tags": N(({ overflowedChildren: qe }) => [
                d("span", null, "+" + ye(qe), 1)
              ]),
              _: 3
            }, 8, ["tags", "small"])) : Array.isArray(b.value) ? le("", !0) : I(Se.$slots, "default", {
              key: 2,
              label: q(b.value),
              value: b.value,
              option: $(b.value)
            }, () => [
              Ne(ye(q(b.value)), 1)
            ])
          ]),
          _: 3
        }, 16, ["modelValue", "class", "disabled", "small"])) : (c(), G(y3, oe({
          key: 1,
          modelValue: b.value,
          "onUpdate:modelValue": Le[1] || (Le[1] = (qe) => b.value = qe),
          size: "1",
          class: ["p-select__native", Z.value.control],
          disabled: Se.disabled
        }, y(h), {
          options: Se.options,
          onVnodeMounted: Le[2] || (Le[2] = (qe) => i("bottom"))
        }), null, 16, ["modelValue", "class", "disabled", "options"]))
      ]),
      default: N(() => [
        ne(k0, {
          modelValue: b.value,
          "onUpdate:modelValue": [
            Le[3] || (Le[3] = (qe) => b.value = qe),
            k
          ],
          class: Oe(["p-select__options", Se.optionsClass]),
          options: Se.options,
          style: Gr(ee.value.option),
          multiple: x.value,
          small: Se.small,
          onKeydown: me,
          onBottom: Le[4] || (Le[4] = (qe) => i("bottom"))
        }, mn({ _: 2 }, [
          Ye(Se.$slots, (qe, _t) => ({
            name: _t,
            fn: N((ot) => [
              I(Se.$slots, _t, ve(we({ ...ot, close: re })))
            ])
          }))
        ]), 1032, ["modelValue", "class", "options", "style", "multiple", "small"])
      ]),
      _: 3
    }, 8, ["placement", "class", "styles"]));
  }
}), VY = { class: "p-date-range-duration-input" }, HY = /* @__PURE__ */ W({
  __name: "PDateRangeDurationInput",
  props: {
    quantity: {},
    unit: {},
    small: { type: Boolean }
  },
  emits: ["update:quantity", "update:unit"],
  setup(t, { emit: n }) {
    const a = t, i = n, s = [
      { label: "Seconds", value: "second" },
      { label: "Minutes", value: "minute" },
      { label: "Hours", value: "hour" },
      { label: "Days", value: "day" }
    ], u = M({
      get() {
        return a.quantity;
      },
      set(g) {
        i("update:quantity", g);
      }
    }), p = M({
      get() {
        return a.unit;
      },
      set(g) {
        i("update:unit", g);
      }
    });
    return (g, E) => (c(), _("div", VY, [
      ne(w3, {
        modelValue: u.value,
        "onUpdate:modelValue": E[0] || (E[0] = (h) => u.value = h),
        prepend: "±",
        small: g.small
      }, null, 8, ["modelValue", "small"]),
      ne(L0, {
        modelValue: p.value,
        "onUpdate:modelValue": E[1] || (E[1] = (h) => p.value = h),
        options: s,
        small: g.small
      }, null, 8, ["modelValue", "small"])
    ]));
  }
}), GY = /* @__PURE__ */ W({
  __name: "PDateRangeSelectAround",
  emits: ["apply", "close"],
  setup(t, { emit: n }) {
    const a = n, i = z(null), s = z(15), u = z("second");
    function p() {
      if (i.value && s.value) {
        a("apply", { type: "around", date: i.value, quantity: s.value, unit: u.value });
        return;
      }
      a("apply", null);
    }
    function g() {
      a("close");
    }
    return (E, h) => (c(), G(D0, {
      modelValue: i.value,
      "onUpdate:modelValue": h[2] || (h[2] = (f) => i.value = f),
      "show-time": "",
      class: "p-date-range-select-around",
      onClose: g,
      onApply: p
    }, {
      "after-controls": N(() => [
        ne(nh, { label: "Duration" }, {
          default: N(({ id: f }) => [
            ne(HY, {
              id: f,
              quantity: s.value,
              "onUpdate:quantity": h[0] || (h[0] = (b) => s.value = b),
              unit: u.value,
              "onUpdate:unit": h[1] || (h[1] = (b) => u.value = b),
              small: ""
            }, null, 8, ["id", "quantity", "unit"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]));
  }
}), A3 = Qa * 7, R3 = Qa * 30, Jd = "MMM do", wd = "MMM do, yyyy", O3 = "hh:mm a", Qh = `${Jd} 'at' ${O3}`, af = `${wd} 'at' ${O3}`;
function YY(t) {
  if (!t)
    return null;
  const { type: n } = t;
  switch (n) {
    case "span":
      return zY(t);
    case "range":
      return ZY(t);
    case "around":
      return qY(t);
    case "period":
      return WY(t);
    default:
      const a = n;
      throw new Error(`Label not found for date range type: ${a}`);
  }
}
function zY({ seconds: t }) {
  const n = Math.abs(t);
  if (n === A3)
    return "Past 7 days";
  if (n === R3)
    return "Past 30 days";
  const a = {
    months: Math.floor(n / z2),
    weeks: Math.floor(n % z2 / o0),
    days: Math.floor(n % o0 / Qa),
    hours: Math.floor(n % Qa / _l),
    minutes: Math.floor(n % _l / Cd),
    seconds: Math.floor(n % Cd)
  }, i = Object.entries(a).reduce((u, [p, g]) => {
    if (g) {
      const E = p.slice(0, -1);
      if (g === 1)
        return u.push(E), u;
      u.push(`${g} ${_a(E, g)}`);
    }
    return u;
  }, []);
  return `${t < 0 ? "Past" : "Next"} ${i.join(" ")}`;
}
function ZY({ startDate: t, endDate: n }) {
  if (KY({ startDate: t, endDate: n })) {
    const s = Nl(t, /* @__PURE__ */ new Date()) ? Jd : wd;
    return Mn(t, s);
  }
  if (oh({ startDate: t, endDate: n })) {
    const s = Nl(t, /* @__PURE__ */ new Date()) ? Jd : wd, u = Nl(n, /* @__PURE__ */ new Date()) ? Jd : wd;
    return `${Mn(t, s)} - ${Mn(n, u)}`;
  }
  const a = Nl(t, /* @__PURE__ */ new Date()) ? Qh : af, i = Nl(n, /* @__PURE__ */ new Date()) ? Qh : af;
  return `${Mn(t, a)} - ${Mn(n, i)}`;
}
function qY({ date: t, quantity: n, unit: a }) {
  const i = I3(t) ? Mn(t, wd) : Mn(t, af);
  return `${n} ${_a(a, n)} around ${i}`;
}
function WY({ period: t }) {
  return t;
}
function I3(t) {
  return pl(t).getTime() === t.getTime();
}
function jY(t) {
  return Uf(t).getTime() === t.getTime();
}
function KY({ startDate: t, endDate: n }) {
  return oh({ startDate: t, endDate: n }) && $l(t, n);
}
function oh({ startDate: t, endDate: n }) {
  return I3(t) && jY(n);
}
const QY = /* @__PURE__ */ W({
  __name: "PDateRangeSelectOptions",
  props: {
    mode: {}
  },
  emits: ["update:mode", "apply"],
  setup(t, { emit: n }) {
    const a = t, i = n, s = M({
      get() {
        return a.mode;
      },
      set(p) {
        if (J7(p)) {
          i("apply", { type: "period", period: p });
          return;
        }
        if (typeof p == "number") {
          i("apply", { type: "span", seconds: p });
          return;
        }
        i("update:mode", p);
      }
    }), u = [
      { label: "Past hour", value: _l * -1 },
      { label: "Past day", value: Qa * -1 },
      { label: "Past 7 days", value: A3 * -1 },
      { label: "Past 30 days", value: R3 * -1 },
      { label: "Today", value: "Today" },
      { label: "Relative time", value: "span" },
      { label: "Around a time", value: "around" },
      { label: "Date range", value: "range" }
    ];
    return (p, g) => (c(), G(k0, {
      modelValue: s.value,
      "onUpdate:modelValue": g[0] || (g[0] = (E) => s.value = E),
      options: u,
      class: "p-date-range-select-options"
    }, null, 8, ["modelValue"]));
  }
}), XY = /* @__PURE__ */ W({
  __name: "PDateRangeSelectRange",
  props: {
    min: {},
    minReason: {},
    max: {},
    maxReason: {}
  },
  emits: ["apply", "close"],
  setup(t, { emit: n }) {
    const a = n, i = z(null), s = z(null);
    function u() {
      if (i.value && s.value) {
        a("apply", { type: "range", startDate: i.value, endDate: s.value });
        return;
      }
      a("apply", null);
    }
    function p() {
      a("close");
    }
    return (g, E) => {
      const h = ht("PDateRangePicker");
      return c(), G(h, oe({
        "start-date": i.value,
        "onUpdate:startDate": E[0] || (E[0] = (f) => i.value = f),
        "end-date": s.value,
        "onUpdate:endDate": E[1] || (E[1] = (f) => s.value = f),
        class: "p-date-range-select-range"
      }, { min: g.min, max: g.max, minReason: g.minReason, maxReason: g.maxReason }, {
        "show-time": "",
        onClose: p,
        onApply: u
      }), null, 16, ["start-date", "end-date"]);
    };
  }
}), P0 = /* @__PURE__ */ W({
  __name: "PTextInput",
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue", "focus"],
  setup(t, { expose: n, emit: a }) {
    const i = t, s = a, u = z(), p = M(() => u.value?.el), g = z(), E = M(() => g.value);
    n({ el: E, wrapper: p });
    const h = M({
      get() {
        return i.modelValue ?? "";
      },
      set(b) {
        s("update:modelValue", b);
      }
    }), f = () => {
      s("focus");
    };
    return (b, w) => (c(), G(mo, {
      ref_key: "wrapperElement",
      ref: u,
      class: "p-text-input"
    }, mn({
      control: N(({ attrs: x }) => [
        ur(d("input", oe({
          ref_key: "inputElement",
          ref: g,
          "onUpdate:modelValue": w[0] || (w[0] = (A) => h.value = A),
          type: "text",
          class: "p-text-input__control"
        }, x, { onFocus: f }), null, 16), [
          [fl, h.value]
        ])
      ]),
      _: 2
    }, [
      Ye(b.$slots, (x, A) => ({
        name: A,
        fn: N((D) => [
          I(b.$slots, A, ve(we(D)))
        ])
      }))
    ]), 1536));
  }
}), JY = { class: "p-1" }, ez = { class: "p-date-range-select-relative__option" }, tz = { class: "text-subdued font-mono" }, nz = /* @__PURE__ */ W({
  __name: "PDateRangeSelectRelative",
  props: {
    maxSpanInSeconds: {},
    min: {},
    max: {}
  },
  emits: ["apply"],
  setup(t, { emit: n }) {
    const a = t, i = n, s = z(), u = z(), p = z(""), g = M(() => {
      const [b = ""] = p.value.match(/\d+/) ?? [], [w = ""] = p.value.match(/[a-zA-Z]+/) ?? [], [x = ""] = p.value.match(/[+-]+/) ?? [], A = parseInt(b), D = isNaN(A) ? 1 : A, L = [
        { label: `Past ${D} ${_a("minute", D)}`, unit: "minute", quantity: D, value: D * Cd * -1 },
        { label: `Past ${D} ${_a("hour", D)}`, unit: "hour", quantity: D, value: D * _l * -1 },
        { label: `Past ${D} ${_a("day", D)}`, unit: "day", quantity: D, value: D * Qa * -1 },
        { label: `Past ${D} ${_a("week", D)}`, unit: "week", quantity: D, value: D * o0 * -1 },
        { label: `Next ${D} ${_a("minute", D)}`, unit: "minute", quantity: D, value: D * Cd },
        { label: `Next ${D} ${_a("hour", D)}`, unit: "hour", quantity: D, value: D * _l },
        { label: `Next ${D} ${_a("day", D)}`, unit: "day", quantity: D, value: D * Qa },
        { label: `Next ${D} ${_a("week", D)}`, unit: "week", quantity: D, value: D * o0 }
      ], $ = /* @__PURE__ */ new Date(), q = a.maxSpanInSeconds ?? z2 * 2;
      return L.filter((k) => {
        const U = Ul($, k.value);
        if (a.min && ec(U, a.min) || a.max && Jl(U, a.max))
          return !1;
        const Z = Math.abs(k.value) < q, ee = _a(k.unit, D).includes(w), X = h(k).includes(x);
        return Z && ee && X;
      });
    });
    xt(() => {
      s.value?.el?.focus();
    });
    function E(b) {
      const w = h(b), x = b.unit.slice(0, 1), A = `${b.quantity}${x}`;
      return w === "-" ? A : `${w}${A}`;
    }
    function h(b) {
      return b.value > 0 ? "+" : "-";
    }
    function f() {
      if (u.value) {
        i("apply", { type: "span", seconds: u.value });
        return;
      }
      i("apply", null);
    }
    return (b, w) => (c(), G(k0, {
      modelValue: u.value,
      "onUpdate:modelValue": [
        w[1] || (w[1] = (x) => u.value = x),
        f
      ],
      options: g.value,
      class: "p-date-range-select-relative"
    }, {
      "pre-options": N(() => [
        d("div", JY, [
          ne(P0, {
            ref_key: "input",
            ref: s,
            modelValue: p.value,
            "onUpdate:modelValue": w[0] || (w[0] = (x) => p.value = x),
            small: "",
            placeholder: "Relative time (15m, 1h, 1d, 1w)"
          }, null, 8, ["modelValue"])
        ])
      ]),
      option: N(({ option: x }) => [
        d("div", ez, [
          d("span", null, ye(x.label), 1),
          d("span", tz, ye(E(x)), 1)
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "options"]));
  }
}), rz = { class: "p-date-range-select__content" }, az = /* @__PURE__ */ W({
  __name: "PDateRangeSelect",
  props: /* @__PURE__ */ E0({
    placeholder: { default: "Select a time span" },
    maxSpanInSeconds: {},
    clearable: { type: Boolean },
    disabled: { type: Boolean },
    min: {},
    minReason: {},
    max: {},
    maxReason: {},
    size: { default: "default" }
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const n = Kf(
      "",
      {
        variants: {
          size: {
            default: "h-10",
            sm: "h-[30px]"
          }
        }
      }
    ), a = Ni(t, "modelValue");
    O0("Escape", () => {
      s.value?.close();
    });
    const i = [Fi, Bi, Pi, Li, Pf, Lf], s = z(), u = M(() => s.value?.target), { width: p } = tc(u), g = z(null), E = M(() => YY(a.value) ?? t.placeholder), h = M(() => ({
      label: {
        "p-date-range-select__label--placeholder": E.value === t.placeholder
      }
    })), f = M(() => ({
      options: {
        width: X2(p.value)
      }
    }));
    function b(k) {
      a.value = k, q();
    }
    function w() {
      return Dh(a.value)?.timeSpanInSeconds ?? 0;
    }
    const x = M(() => {
      const k = w(), { startDate: U } = $(k * -1) ?? {};
      return !U || !k || t.disabled ? !0 : t.min ? ec(U, t.min) : !1;
    });
    function A() {
      const k = w(), U = $(k * -1);
      if (U) {
        const { startDate: Z, endDate: ee } = U;
        a.value = { type: "range", startDate: Z, endDate: ee };
      }
    }
    const D = M(() => {
      const k = w(), { endDate: U } = $(k) ?? {};
      return !U || !k || t.disabled ? !0 : t.max ? Jl(U, t.max) : !1;
    });
    function L() {
      const k = w(), U = $(k);
      if (U) {
        const { startDate: Z, endDate: ee } = U;
        a.value = { type: "range", startDate: Z, endDate: ee };
      }
    }
    function $(k) {
      const U = Dh(a.value);
      if (!U)
        return null;
      const { startDate: Z, endDate: ee } = U;
      if (oh(U)) {
        const Q = Math.ceil(Math.abs(k) / Qa), ce = k < 0 ? -Q : Q, me = i0(Z, ce), Se = i0(ee, ce);
        return { startDate: me, endDate: Se };
      }
      const X = Ul(Z, k), re = Ul(ee, k);
      return { startDate: X, endDate: re };
    }
    function q() {
      s.value?.close();
    }
    function P() {
      a.value = null;
    }
    return tt(() => s.value?.visible, (k) => {
      k || (g.value = null);
    }), (k, U) => (c(), G(Sl, {
      ref_key: "popover",
      ref: s,
      class: "p-date-range-select",
      placement: i,
      "auto-close": ""
    }, {
      target: N(({ open: Z }) => [
        ne(y(xd), {
          text: k.minReason,
          disabled: !k.minReason || !x.value || !a.value
        }, {
          default: N(() => [
            ne(rn, {
              class: "p-date-range-select__button pointer-events-auto",
              icon: "ArrowSmallLeftIcon",
              disabled: x.value,
              size: k.size,
              onClick: A
            }, null, 8, ["disabled", "size"])
          ]),
          _: 1
        }, 8, ["text", "disabled"]),
        ne(rn, {
          class: Oe(["p-date-range-select__button p-date-range-select__input", y(n)({ size: k.size })]),
          disabled: k.disabled,
          size: k.size,
          onClick: Z
        }, {
          default: N(() => [
            d("div", rz, [
              ne(Dn, {
                icon: "CalendarIcon",
                class: "shrink-0",
                size: k.size
              }, null, 8, ["size"]),
              d("span", {
                class: Oe(["p-date-range-select__label", h.value.label])
              }, ye(E.value), 3),
              ne(Dn, {
                icon: "ChevronDownIcon",
                class: "ml-auto shrink-0",
                size: k.size
              }, null, 8, ["size"])
            ])
          ]),
          _: 1
        }, 8, ["class", "disabled", "size", "onClick"]),
        a.value && k.clearable && !k.disabled ? (c(), G(rn, {
          key: 0,
          class: "p-date-range-select__button p-date-range-select__button--clear",
          icon: "XCircleIcon",
          size: k.size,
          onClick: P
        }, null, 8, ["size"])) : le("", !0),
        ne(y(xd), {
          text: k.maxReason,
          disabled: !k.maxReason || !D.value || !a.value
        }, {
          default: N(() => [
            ne(rn, {
              class: "p-date-range-select__button pointer-events-auto",
              icon: "ArrowSmallRightIcon",
              disabled: D.value,
              size: k.size,
              onClick: L
            }, null, 8, ["disabled", "size"])
          ]),
          _: 1
        }, 8, ["text", "disabled"])
      ]),
      default: N(() => [
        d("div", {
          class: "p-date-range-select__picker",
          onClick: U[1] || (U[1] = xa(() => {
          }, ["stop"]))
        }, [
          g.value === null ? (c(), G(QY, {
            key: 0,
            mode: g.value,
            "onUpdate:mode": U[0] || (U[0] = (Z) => g.value = Z),
            style: Gr(f.value.options),
            onApply: b
          }, null, 8, ["mode", "style"])) : le("", !0),
          g.value === "span" ? (c(), G(nz, oe({
            key: 1,
            style: f.value.options
          }, { maxSpanInSeconds: k.maxSpanInSeconds, min: k.min, max: k.max }, {
            onClose: q,
            onApply: b
          }), null, 16, ["style"])) : le("", !0),
          g.value === "around" ? (c(), G(GY, oe({ key: 2 }, { maxSpanInSeconds: k.maxSpanInSeconds, min: k.min, minReason: k.minReason, max: k.max, maxReason: k.maxReason }, {
            onClose: q,
            onApply: b
          }), null, 16)) : le("", !0),
          g.value === "range" ? (c(), G(XY, oe({ key: 3 }, { maxSpanInSeconds: k.maxSpanInSeconds, min: k.min, minReason: k.minReason, max: k.max, maxReason: k.maxReason }, {
            onClose: q,
            onApply: b
          }), null, 16)) : le("", !0)
        ])
      ]),
      _: 1
    }, 512));
  }
}), oz = (t) => {
  t.component("PDateRangeSelect", az);
}, iz = /* @__PURE__ */ W({
  __name: "PDialogBase",
  props: {
    open: { type: Boolean },
    defaultOpen: { type: Boolean },
    modal: { type: Boolean }
  },
  emits: ["update:open"],
  setup(t, { emit: n }) {
    const s = Wn(t, n);
    return (u, p) => (c(), G(y(ES), ve(we(y(s))), {
      default: N(() => [
        I(u.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), sz = /* @__PURE__ */ W({
  inheritAttrs: !1,
  __name: "PDialogContent",
  props: {
    forceMount: { type: Boolean },
    trapFocus: { type: Boolean },
    disableOutsidePointerEvents: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
  setup(t, { emit: n }) {
    const s = Wn(t, n);
    return (u, p) => {
      const g = ht("p-icon");
      return c(), G(y(bS), null, {
        default: N(() => [
          ne(y(zS), { class: "p-dialog-overlay" }),
          ne(y(GS), oe({ ...y(s), ...u.$attrs }, { class: "p-dialog-content" }), {
            default: N(() => [
              I(u.$slots, "default"),
              ne(y(ZS), { class: "p-dialog-close" }, {
                default: N(() => [
                  ne(g, {
                    icon: "Close",
                    class: "w-4 h-4"
                  }),
                  p[0] || (p[0] = d("span", { class: "sr-only" }, "Close", -1))
                ]),
                _: 1
              })
            ]),
            _: 3
          }, 16)
        ]),
        _: 3
      });
    };
  }
}), lz = /* @__PURE__ */ W({
  __name: "PDialogDescription",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(t) {
    const n = t;
    return (a, i) => (c(), G(y(WS), oe(n, { class: "p-dialog-description" }), {
      default: N(() => [
        I(a.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), cz = {}, uz = { class: "p-dialog-footer" };
function dz(t, n) {
  return c(), _("div", uz, [
    I(t.$slots, "default")
  ]);
}
const _z = /* @__PURE__ */ Wt(cz, [["render", dz]]), pz = {}, mz = { class: "p-dialog-header" };
function gz(t, n) {
  return c(), _("div", mz, [
    I(t.$slots, "default")
  ]);
}
const fz = /* @__PURE__ */ Wt(pz, [["render", gz]]), hz = /* @__PURE__ */ W({
  __name: "PDialogTitle",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(t) {
    const n = t;
    return (a, i) => (c(), G(y(qS), oe(n, { class: "p-dialog-title" }), {
      default: N(() => [
        I(a.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), vz = /* @__PURE__ */ W({
  inheritAttrs: !1,
  __name: "PDialog",
  props: {
    open: { type: Boolean },
    defaultOpen: { type: Boolean },
    modal: { type: Boolean }
  },
  emits: ["update:open"],
  setup(t, { emit: n }) {
    const s = Wn(t, n);
    return (u, p) => (c(), G(iz, ve(we(y(s))), {
      default: N(() => [
        ne(sz, oe({
          class: "sm:max-w-[425px]",
          "as-child": !!u.$slots.default
        }, u.$attrs), {
          default: N(() => [
            I(u.$slots, "default", {}, () => [
              !u.$slots.header || u.$slots.title || u.$slots.description ? (c(), G(fz, { key: 0 }, {
                default: N(() => [
                  I(u.$slots, "header", {}, () => [
                    u.$slots.title ? (c(), G(hz, { key: 0 }, {
                      default: N(() => [
                        I(u.$slots, "title")
                      ]),
                      _: 3
                    })) : le("", !0),
                    u.$slots.description ? (c(), G(lz, { key: 1 }, {
                      default: N(() => [
                        I(u.$slots, "description")
                      ]),
                      _: 3
                    })) : le("", !0)
                  ])
                ]),
                _: 3
              })) : le("", !0),
              u.$slots.footer ? (c(), G(_z, { key: 1 }, {
                default: N(() => [
                  I(u.$slots, "footer")
                ]),
                _: 3
              })) : le("", !0)
            ])
          ]),
          _: 3
        }, 16, ["as-child"])
      ]),
      _: 3
    }, 16));
  }
}), Ez = (t) => {
  t.component("PDialog", vz);
}, bz = {}, Sz = { class: "p-divider" }, wz = { class: "p-divider__text" };
function yz(t, n) {
  return c(), _("div", Sz, [
    n[1] || (n[1] = d("hr", { class: "p-divider__line" }, null, -1)),
    t.$slots.default ? (c(), _(Qe, { key: 0 }, [
      d("div", wz, [
        I(t.$slots, "default")
      ]),
      n[0] || (n[0] = d("hr", { class: "p-divider__line" }, null, -1))
    ], 64)) : le("", !0)
  ]);
}
const of = /* @__PURE__ */ Wt(bz, [["render", yz]]), Tz = (t) => {
  t.component("PDivider", of);
}, Cz = ["draggable", "onDragover", "onDragleave"], xz = ["onMousedown", "onTouchstart"], Az = { class: "p-draggable-list__item-content" }, Rz = /* @__PURE__ */ W({
  __name: "PDraggableList",
  props: {
    modelValue: {},
    generator: { type: Function },
    allowCreate: { type: Boolean }
  },
  emits: ["update:modelValue", "create"],
  setup(t, { emit: n }) {
    const a = t, i = n, s = z([]), u = z(null), p = z(null), g = M(() => W2(p.value)), E = M(() => ({
      root: {
        "p-draggable-list--dragging": g.value
      },
      item: (X) => ({
        "p-draggable-list__item--over": g.value && u.value === X,
        "p-draggable-list__item--dragging": g.value && p.value === X
      })
    })), h = (X) => p.value === X ? "true" : "false", f = (X, re) => {
      const Q = [...a.modelValue];
      Q.splice(re, 0, Q.splice(X, 1)[0]), i("update:modelValue", Q);
    }, b = (X) => () => {
      const re = X - 1;
      re < 0 || (f(X, re), L(re));
    }, w = (X) => () => {
      const re = X + 1;
      re >= a.modelValue.length || f(X, re);
    }, x = (X) => () => {
      f(X, 0);
    }, A = (X) => () => {
      f(X, a.modelValue.length - 1);
    }, D = (X) => {
      const re = [...a.modelValue];
      re.splice(X, 1), i("update:modelValue", re);
    }, L = (X) => s.value[X]?.focus(), $ = (X) => {
      if (!a.generator) {
        i("create", void 0);
        return;
      }
      const re = [...a.modelValue], Q = a.generator(), ce = re.length;
      re.splice(ce, 0, a.generator()), i("update:modelValue", re), i("create", Q);
    }, q = (X) => {
      p.value = X;
    }, P = () => {
      p.value = null;
    }, k = () => {
      p.value = null, u.value = null;
    }, U = (X, re) => {
      X.preventDefault(), !(p.value === null || u.value === re) && (u.value = re);
    }, Z = (X) => {
      p.value === null || u.value !== X || (u.value = null);
    }, ee = (X) => {
      if (p.value === null)
        return;
      X.preventDefault();
      const re = u.value ?? 0;
      f(p.value, re);
    };
    return (X, re) => {
      const Q = ht("PButton");
      return c(), _("div", {
        class: Oe(["p-draggable-list", E.value.root])
      }, [
        (c(!0), _(Qe, null, Ye(X.modelValue, (ce, me) => (c(), _("div", {
          key: me,
          ref_for: !0,
          ref_key: "items",
          ref: s,
          class: Oe(["p-draggable-list__item", E.value.item(me)]),
          draggable: h(me),
          tabindex: "0",
          onDragover: (Se) => U(Se, me),
          onDragleave: (Se) => Z(me),
          onDragend: k,
          onDrop: ee
        }, [
          I(X.$slots, "item", oe({ ref_for: !0 }, {
            item: ce,
            index: me,
            handleDown: () => q(me),
            handleUp: P,
            moveUp: b(me),
            moveToTop: x(me),
            moveDown: w(me),
            moveToBottom: A(me),
            deleteItem: () => D(me)
          }), () => [
            d("div", {
              class: "p-draggable-list__item-handle",
              onMousedown: (Se) => q(me),
              onTouchstart: (Se) => q(me),
              onTouchend: P,
              onMouseup: P
            }, [
              I(X.$slots, "handle", oe({ ref_for: !0 }, { item: ce, index: me }), () => [
                ne(Dn, { icon: "DragHandle" })
              ])
            ], 40, xz),
            d("div", Az, [
              I(X.$slots, "default", oe({ ref_for: !0 }, {
                item: ce,
                index: me,
                moveUp: b(me),
                moveToTop: x(me),
                moveDown: w(me),
                moveToBottom: A(me),
                deleteItem: () => D(me)
              }))
            ])
          ])
        ], 42, Cz))), 128)),
        X.allowCreate ? I(X.$slots, "create", { key: 0 }, () => [
          ne(Q, {
            small: "",
            icon: "PlusIcon",
            class: "p-draggable-list__create-button",
            onClick: re[0] || (re[0] = (ce) => $())
          }, {
            default: N(() => [...re[1] || (re[1] = [
              Ne(" Add item ", -1)
            ])]),
            _: 1
          })
        ]) : le("", !0)
      ], 2);
    };
  }
}), Oz = (t) => {
  t.component("PDraggableList", Rz);
}, Iz = {}, Nz = { class: "p-layout-default" }, Mz = {
  key: 0,
  class: "p-layout-default__header"
}, Dz = { class: "p-layout-default__content" };
function kz(t, n) {
  return c(), _("div", Nz, [
    t.$slots.header ? (c(), _("div", Mz, [
      I(t.$slots, "header")
    ])) : le("", !0),
    d("div", Dz, [
      I(t.$slots, "default")
    ])
  ]);
}
const Lz = /* @__PURE__ */ Wt(Iz, [["render", kz]]), Pz = (t) => {
  t.component("PLayoutDefault", Lz);
}, Bz = {}, Fz = { class: "p-layout-full" }, Uz = { class: "p-layout-full__header" };
function $z(t, n) {
  return c(), _("div", Fz, [
    d("div", Uz, [
      I(t.$slots, "header", { class: "p-layout-full__header" })
    ]),
    I(t.$slots, "default")
  ]);
}
const Vz = /* @__PURE__ */ Wt(Bz, [["render", $z]]), Hz = (t) => {
  t.component("PLayoutFull", Vz);
}, N3 = /* @__PURE__ */ W({
  __name: "PLayoutResizable",
  props: /* @__PURE__ */ E0({
    collapsePoint: {},
    disabled: { type: Boolean },
    placement: {}
  }, {
    size: { required: !1 },
    sizeModifiers: {}
  }),
  emits: ["update:size"],
  setup(t) {
    const n = Ni(t, "size"), a = t, i = Yr(), s = z(), u = z(), p = z(!1), g = z(!1), E = z(void 0), h = M({
      get() {
        return n.value ?? E.value;
      },
      set(Z) {
        n.value = E.value = Z;
      }
    });
    xt(() => {
      D();
    });
    const f = M(() => a.placement ?? "left"), b = M(() => I2(f.value)), w = M(() => {
      const Z = !a.disabled;
      return {
        root: {
          [`p-layout-resizable--${f.value}`]: !!f.value
        },
        aside: {
          "p-layout-resizable--events-none": p.value,
          "p-layout-resizable__aside--collapsed": g.value,
          [`p-layout-resizable__aside-${f.value}`]: !!f.value
        },
        handle: {
          "p-layout-resizable__handle--resizable": Z,
          "p-layout-resizable__handle--collapsed": g.value,
          "p-layout-resizable__handle--e-resizable": Z && f.value === "left",
          "p-layout-resizable__handle--w-resizable": Z && f.value === "right",
          "p-layout-resizable__handle--s-resizable": Z && f.value === "top",
          "p-layout-resizable__handle--n-resizable": Z && f.value === "bottom",
          [`p-layout-resizable__handle--${f.value}`]: !!f.value
        },
        main: {
          "p-layout-resizable--events-none": p.value,
          [`p-layout-resizable__main--${f.value}`]: !!f.value
        }
      };
    }), x = (Z = 0) => {
      if (a.disabled || !s.value || !u.value)
        return;
      const ee = s.value.getBoundingClientRect(), X = a.collapsePoint ?? 0;
      let re = !1, Q = 0;
      switch (f.value) {
        case "left":
          Q = Z - ee.x, re = Z - ee.x < X;
          break;
        case "right":
          Q = ee.x + ee.width - Z, re = Z > ee.x + ee.width - X;
          break;
        case "top":
          Q = Z - ee.y, re = Z < ee.y + X;
          break;
        case "bottom":
          Q = ee.y + ee.height - Z, re = Z > ee.y + ee.height - X;
          break;
      }
      return g.value = !!a.collapsePoint && re, Q = Math.max(Q, 0), Q = Math.min(Q, b.value ? ee.width : ee.height), Q;
    }, A = (Z) => {
      if (a.disabled || !s.value || !u.value)
        return;
      const ee = b.value ? Z.clientX : Z.clientY;
      h.value = x(ee), D();
    };
    function D() {
      !u.value || !Nd(h.value) || (b.value ? u.value.style.width = `${h.value}px` : u.value.style.height = `${h.value}px`);
    }
    tt(f, (Z, ee) => {
      if (a.disabled || !s.value || !u.value)
        return;
      const X = I2(Z), re = I2(ee);
      X && !re && (u.value.style.height = "100%", u.value.style.width = "auto"), !X && re && (u.value.style.height = "auto", u.value.style.width = "100%");
    });
    const L = () => {
      a.disabled || !s.value || !u.value || (p.value = !0, document.body.classList.add(`p-layout-resizable--resizing-${f.value}`), window.addEventListener("mouseup", $), window.addEventListener("mousemove", A));
    }, $ = () => {
      window.removeEventListener("mousemove", A), window.removeEventListener("mouseup", $), p.value = !1, document.body.classList.remove(`p-layout-resizable--resizing-${f.value}`);
    }, q = () => {
      !a.disabled && g.value && P();
    }, P = () => {
      g.value = !1;
    }, k = () => {
      g.value = !0;
    }, U = () => {
      g.value = !g.value;
    };
    return (Z, ee) => (c(), _("section", {
      ref_key: "container",
      ref: s,
      class: Oe(["p-layout-resizable", w.value.root])
    }, [
      y(i).aside ? (c(), _("aside", {
        key: 0,
        ref_key: "aside",
        ref: u,
        class: Oe(["p-layout-resizable__aside", w.value.aside])
      }, [
        I(Z.$slots, "aside", ve(we({ collapsed: g.value, expand: P, collapse: k, toggle: U, size: h.value })))
      ], 2)) : le("", !0),
      y(i).default && y(i).aside ? (c(), _("div", {
        key: 1,
        class: Oe(["p-layout-resizable__handle", w.value.handle]),
        onMousedown: L,
        onMouseup: q
      }, [
        I(Z.$slots, "handle")
      ], 34)) : le("", !0),
      y(i).default ? (c(), _("main", {
        key: 2,
        class: Oe(["p-layout-resizable__main", w.value.main])
      }, [
        I(Z.$slots, "default", ve(we({ collapsed: g.value, expand: P, collapse: k, toggle: U, asideSize: h.value })))
      ], 2)) : le("", !0)
    ], 2));
  }
}), Gz = (t) => {
  t.component("PLayoutResizable", N3);
}, Yz = {}, zz = { class: "p-layout-grid" }, Zz = {
  key: 0,
  class: "p-layout-grid__header"
}, qz = { class: "p-layout-grid__header-leading" }, Wz = { class: "p-layout-grid__header-trailing" }, jz = {
  key: 1,
  class: "p-layout-grid__toolbar"
}, Kz = { class: "p-layout-grid__toolbar-leading" }, Qz = { class: "p-layout-grid__toolbar-trailing" }, Xz = { class: "p-layout-grid__main" }, Jz = {
  key: 0,
  class: "p-layout-grid__main-leading"
}, eZ = { class: "p-layout-grid__content" }, tZ = {
  key: 1,
  class: "p-layout-grid__main-trailing"
};
function nZ(t, n) {
  return c(), _("div", zz, [
    t.$slots.header || t.$slots["header-leading"] || t.$slots["header-trailing"] ? (c(), _("div", Zz, [
      I(t.$slots, "header", {}, () => [
        d("div", qz, [
          I(t.$slots, "header-leading")
        ]),
        d("div", Wz, [
          I(t.$slots, "header-trailing")
        ])
      ])
    ])) : le("", !0),
    t.$slots.toolbar || t.$slots["toolbar-leading"] || t.$slots["toolbar-trailing"] ? (c(), _("div", jz, [
      I(t.$slots, "toolbar", {}, () => [
        d("div", Kz, [
          I(t.$slots, "toolbar-leading")
        ]),
        d("div", Qz, [
          I(t.$slots, "toolbar-trailing")
        ])
      ])
    ])) : le("", !0),
    d("main", Xz, [
      t.$slots["main-leading"] ? (c(), _("div", Jz, [
        I(t.$slots, "main-leading")
      ])) : le("", !0),
      d("div", eZ, [
        I(t.$slots, "default")
      ]),
      t.$slots["main-trailing"] ? (c(), _("div", tZ, [
        I(t.$slots, "main-trailing")
      ])) : le("", !0)
    ])
  ]);
}
const rZ = /* @__PURE__ */ Wt(Yz, [["render", nZ]]), aZ = (t) => {
  t.component("PLayoutToolbarGrid", rZ);
}, oZ = {}, iZ = { class: "p-layout-well" }, sZ = { class: "p-layout-well__header" }, lZ = { class: "p-layout-well__content" }, cZ = { class: "p-layout-well__well" };
function uZ(t, n) {
  return c(), _("div", iZ, [
    d("div", sZ, [
      I(t.$slots, "header")
    ]),
    d("div", lZ, [
      I(t.$slots, "default")
    ]),
    d("div", cZ, [
      I(t.$slots, "well")
    ])
  ]);
}
const dZ = /* @__PURE__ */ Wt(oZ, [["render", uZ]]), _Z = (t) => {
  t.component("PLayoutWell", dZ);
}, pZ = [
  Pz,
  Hz,
  Gz,
  _Z,
  aZ
], mZ = /* @__PURE__ */ W({
  inheritAttrs: !1,
  __name: "PDrawer",
  props: /* @__PURE__ */ E0({
    resizable: { type: Boolean },
    placement: { default: "left" },
    to: { default: "body" },
    disableTeleport: { type: Boolean }
  }, {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  }),
  emits: ["update:open"],
  setup(t) {
    const n = t, a = Ni(t, "open"), i = h0(), s = a6(a);
    function u(g) {
      N7(Ie.escape, g) && s.close();
    }
    z7("keyup", u);
    const p = M(() => ({
      root: {
        [`p-drawer--${n.placement}`]: !0,
        "p-drawer--teleport": !n.disableTeleport
      }
    }));
    return (g, E) => (c(), G(Rd, {
      to: g.to,
      disabled: g.disableTeleport
    }, [
      ne(v0, {
        name: "p-drawer__slide",
        duration: 350
      }, {
        default: N(() => [
          (c(), G(mE, null, [
            a.value ? (c(), G(y(N3), {
              key: 0,
              disabled: !g.resizable,
              class: Oe(["p-drawer", p.value.root]),
              placement: g.placement
            }, {
              aside: N(() => [
                d("div", oe({ class: "p-drawer__aside" }, y(i)), [
                  I(g.$slots, "default", ve(we(y(s))))
                ], 16)
              ]),
              default: N(() => [
                I(g.$slots, "overlay", ve(we(y(s))), () => [
                  d("div", {
                    class: "p-drawer__overlay",
                    onClick: E[0] || (E[0] = //@ts-ignore
                    (...h) => y(s).close && y(s).close(...h))
                  })
                ])
              ]),
              _: 3
            }, 8, ["disabled", "class", "placement"])) : le("", !0)
          ], 1024))
        ]),
        _: 3
      })
    ], 8, ["to", "disabled"]));
  }
}), gZ = (t) => {
  t.component("PDrawer", mZ);
}, fZ = /* @__PURE__ */ W({
  __name: "PDropdownMenuContent",
  props: {
    forceMount: { type: Boolean },
    loop: { type: Boolean },
    side: {},
    sideOffset: { default: 4 },
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "closeAutoFocus"],
  setup(t, { emit: n }) {
    const s = Wn(t, n);
    return (u, p) => (c(), G(y(Vw), null, {
      default: N(() => [
        ne(y(Hw), oe(y(s), { class: "p-dropdown-menu-content" }), {
          default: N(() => [
            I(u.$slots, "default")
          ]),
          _: 3
        }, 16)
      ]),
      _: 3
    }));
  }
}), hZ = /* @__PURE__ */ W({
  __name: "PDropdownMenuRoot",
  props: {
    defaultOpen: { type: Boolean },
    open: { type: Boolean },
    dir: {},
    modal: { type: Boolean }
  },
  emits: ["update:open"],
  setup(t, { emit: n }) {
    const s = Wn(t, n);
    return (u, p) => (c(), G(y(Uw), ve(we(y(s))), {
      default: N(() => [
        I(u.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), vZ = /* @__PURE__ */ W({
  __name: "PDropdownMenuTrigger",
  props: {
    disabled: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  setup(t) {
    const a = vl(t);
    return (i, s) => (c(), G(y($w), oe({ class: "outline-none" }, y(a)), {
      default: N(() => [
        I(i.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), EZ = /* @__PURE__ */ W({
  __name: "PDropdownMenu",
  setup(t) {
    return (n, a) => (c(), G(hZ, null, {
      default: N(() => [
        ne(vZ, null, {
          default: N(() => [
            I(n.$slots, "trigger")
          ]),
          _: 3
        }),
        ne(fZ, null, {
          default: N(() => [
            I(n.$slots, "default")
          ]),
          _: 3
        })
      ]),
      _: 3
    }));
  }
}), bZ = /* @__PURE__ */ W({
  __name: "PDropdownMenuItem",
  props: {
    disabled: { type: Boolean },
    textValue: {},
    asChild: { type: Boolean },
    as: {}
  },
  setup(t) {
    const a = vl(t);
    return (i, s) => (c(), G(y(Gw), oe(y(a), { class: "p-dropdown-menu-item" }), {
      default: N(() => [
        I(i.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), SZ = (t) => {
  t.component("PDropdownMenuItem", bZ);
}, wZ = (t) => {
  t.component("PDropdownMenu", EZ);
}, yZ = {}, TZ = { class: "p-empty-results" }, CZ = { class: "p-empty-results__message" };
function xZ(t, n) {
  return c(), _("div", TZ, [
    d("div", CZ, [
      I(t.$slots, "message", {}, () => [
        n[0] || (n[0] = Ne(" No results ", -1))
      ])
    ]),
    I(t.$slots, "actions")
  ]);
}
const AZ = /* @__PURE__ */ Wt(yZ, [["render", xZ]]), RZ = (t) => {
  t.component("PEmptyResults", AZ);
}, OZ = {}, IZ = {
  key: 0,
  class: "p-empty-state__corner-label"
}, NZ = { class: "p-empty-state__text" }, MZ = {
  key: 0,
  class: "p-empty-state__icon"
}, DZ = {
  key: 1,
  class: "p-empty-state__heading"
}, kZ = {
  key: 2,
  class: "p-empty-state__description"
}, LZ = {
  key: 3,
  class: "p-empty-state__actions"
};
function PZ(t, n) {
  const a = ht("p-card");
  return c(), G(a, { class: "p-empty-state" }, {
    default: N(() => [
      t.$slots.cornerLabel ? (c(), _("div", IZ, [
        I(t.$slots, "corner-label")
      ])) : le("", !0),
      d("div", NZ, [
        t.$slots.icon ? (c(), _("div", MZ, [
          I(t.$slots, "icon")
        ])) : le("", !0),
        t.$slots.heading ? (c(), _("h3", DZ, [
          I(t.$slots, "heading")
        ])) : le("", !0),
        t.$slots.description ? (c(), _("p", kZ, [
          I(t.$slots, "description")
        ])) : le("", !0),
        I(t.$slots, "default"),
        t.$slots.actions ? (c(), _("div", LZ, [
          I(t.$slots, "actions")
        ])) : le("", !0)
      ])
    ]),
    _: 3
  });
}
const BZ = /* @__PURE__ */ Wt(OZ, [["render", PZ]]), FZ = (t) => {
  t.component("PEmptyState", BZ);
}, UZ = /* @__PURE__ */ W({
  __name: "PErrorBoundary",
  emits: ["error"],
  setup(t, { emit: n }) {
    const a = n, i = z(null), s = () => {
      i.value = null;
    };
    return gE((u) => (i.value = u, a("error", i.value), !1)), (u, p) => i.value ? I(u.$slots, "fallback", ve(oe({ key: 1 }, { error: i.value, reset: s }))) : I(u.$slots, "default", { key: 0 });
  }
}), $Z = (t) => {
  t.component("PErrorBoundary", UZ);
}, VZ = {
  key: 0,
  class: "p-form__header"
}, HZ = {
  key: 1,
  class: "p-form__footer"
}, GZ = /* @__PURE__ */ W({
  __name: "PForm",
  props: {
    heading: {}
  },
  emits: ["submit"],
  setup(t, { emit: n }) {
    const a = n, i = Yr();
    return (s, u) => (c(), _("form", {
      class: "p-form",
      onSubmit: u[0] || (u[0] = xa((p) => a("submit", p), ["prevent"]))
    }, [
      y(i).heading || s.heading ? (c(), _("div", VZ, [
        I(s.$slots, "heading", {}, () => [
          d("span", null, ye(s.heading), 1)
        ])
      ])) : le("", !0),
      I(s.$slots, "default"),
      y(i).footer ? (c(), _("div", HZ, [
        I(s.$slots, "footer")
      ])) : le("", !0)
    ], 32));
  }
}), YZ = (t) => {
  t.component("PForm", GZ);
}, zZ = ["height"], ZZ = /* @__PURE__ */ W({
  inheritAttrs: !1,
  __name: "PFrame",
  props: {
    bodyClass: {}
  },
  setup(t) {
    const n = t, a = z(), i = z(document.createElement("div")), s = z(!1), { height: u } = tc(i);
    function p(f) {
      const b = Array.from(document.getElementsByTagName("style")), w = Array.from(document.getElementsByTagName("link"));
      for (const x of b.concat(w)) {
        const A = x.cloneNode(!0);
        f.appendChild(A);
      }
    }
    const g = M(() => ({
      iframe: {
        "p-frame--loaded": s.value
      }
    }));
    function E() {
      if (!a.value?.contentDocument)
        return;
      const [f] = a.value.contentDocument.getElementsByTagName("head");
      p(f), h();
      const [b] = a.value.contentDocument.getElementsByTagName("body");
      b.appendChild(i.value), s.value = !0;
    }
    function h() {
      if (!a.value?.contentDocument)
        return;
      const [f] = a.value.contentDocument.getElementsByTagName("body");
      if (f.classList.forEach((b) => f.classList.remove(b)), typeof n.bodyClass == "string")
        f.classList.add(n.bodyClass);
      else if (Array.isArray(n.bodyClass))
        f.classList.add(...n.bodyClass);
      else
        for (const [b, w] of Object.entries(n.bodyClass))
          w ? f.classList.add(b) : f.classList.remove(b);
    }
    return tt(() => n.bodyClass, () => {
      h();
    }), (f, b) => (c(), _(Qe, null, [
      d("iframe", oe({
        ref_key: "frame",
        ref: a,
        class: ["p-frame", g.value.iframe],
        srcdoc: "<body></body>",
        height: y(u)
      }, f.$attrs, { onLoad: E }), null, 16, zZ),
      i.value ? (c(), G(Rd, {
        key: 0,
        to: i.value
      }, [
        I(f.$slots, "default")
      ], 8, ["to"])) : le("", !0)
    ], 64));
  }
}), qZ = (t) => {
  t.component("PFrame", ZZ);
}, WZ = /* @__PURE__ */ W({
  __name: "PGlobalNavItem",
  props: {
    to: {},
    title: {},
    icon: {}
  },
  setup(t) {
    return (n, a) => {
      const i = ht("router-link");
      return c(), G(i, { to: n.to }, {
        default: N(() => [
          n.icon ? (c(), G(Dn, {
            key: 0,
            icon: n.icon,
            class: "p-global-nav-item__icon"
          }, null, 8, ["icon"])) : le("", !0),
          d("span", null, ye(n.title), 1)
        ]),
        _: 1
      }, 8, ["to"]);
    };
  }
}), jZ = (t) => {
  t.component("PGlobalNavItem", WZ);
}, KZ = {}, QZ = { class: "p-global-sidebar p-background" }, XZ = { class: "p-global-sidebar__nav-links" }, JZ = { class: "p-global-sidebar__nav-links" };
function eq(t, n) {
  return c(), _("div", QZ, [
    d("div", XZ, [
      I(t.$slots, "upper-links")
    ]),
    d("div", JZ, [
      I(t.$slots, "bottom-links")
    ])
  ]);
}
const tq = /* @__PURE__ */ Wt(KZ, [["render", eq]]), nq = (t) => {
  t.component("PGlobalSidebar", tq);
}, M3 = /* @__PURE__ */ W({
  __name: "PHashLink",
  props: {
    depth: {},
    hash: {}
  },
  setup(t) {
    const n = t, a = fv(), i = M(() => Qn(n.hash ?? ""));
    function s() {
      const p = n.hash ? `#${i.value}` : void 0;
      a.push({ hash: p });
    }
    const u = M(() => n.depth ? `h${n.depth}` : "span");
    return (p, g) => (c(), G(Hr(u.value), {
      id: i.value,
      class: "p-hash-link",
      onClick: s
    }, {
      default: N(() => [
        I(p.$slots, "default")
      ]),
      _: 3
    }, 8, ["id"]));
  }
}), rq = (t) => {
  t.component("PHashLink", M3);
}, D3 = /* @__PURE__ */ W({
  __name: "PHeading",
  props: {
    heading: {},
    element: {}
  },
  setup(t) {
    const n = t, a = M(() => n.heading ?? 1), i = M(() => n.element ?? `h${a.value}`), s = M(() => `p-heading--${a.value}`);
    return (u, p) => (c(), G(Hr(i.value), {
      class: Oe(["p-heading", s.value])
    }, {
      default: N(() => [
        I(u.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), aq = (t) => {
  t.component("PHeading", D3);
}, oq = (t) => {
  t.component("PIcon", Dn);
}, iq = /* @__PURE__ */ W({
  inheritAttrs: !1,
  __name: "PIconButtonMenu",
  props: {
    icon: { default: "EllipsisVerticalIcon" }
  },
  setup(t) {
    const { classes: n, styles: a, attrs: i } = Xa(), s = z(), u = z();
    function p() {
      s.value && s.value.close();
    }
    function g() {
      s.value && s.value.close(), u.value && u.value.el.focus();
    }
    return (E, h) => (c(), G(Sl, {
      ref_key: "popOver",
      ref: s,
      class: Oe(["p-icon-button-menu", y(n)]),
      style: Gr(y(a)),
      placement: [y(Pi), y(Li), y(Fi), y(Bi)],
      "auto-close": ""
    }, {
      target: N(({ toggle: f }) => [
        ne(rn, oe({
          ref_key: "button",
          ref: u,
          icon: E.icon
        }, y(i), { onClick: f }), null, 16, ["icon", "onClick"])
      ]),
      default: N(() => [
        d("div", {
          class: "p-icon-button-menu__content",
          onKeydown: ui(g, ["esc"]),
          onClick: p
        }, [
          ne(th, null, {
            default: N(() => [
              I(E.$slots, "default", ve(we({ close: p })))
            ]),
            _: 3
          })
        ], 32)
      ]),
      _: 3
    }, 8, ["class", "style", "placement"]));
  }
}), sq = (t) => {
  t.component("PIconButtonMenu", iq);
}, lq = { class: "p-icon-text" }, cq = { class: "p-icon-text__label" }, uq = /* @__PURE__ */ W({
  __name: "PIconText",
  props: {
    icon: {},
    text: {}
  },
  setup(t) {
    return (n, a) => (c(), _("div", lq, [
      ne(Dn, {
        icon: n.icon,
        class: "p-icon-text__icon"
      }, null, 8, ["icon"]),
      d("div", cq, [
        I(n.$slots, "default", {}, () => [
          Ne(ye(n.text), 1)
        ])
      ])
    ]));
  }
}), dq = (t) => {
  t.component("PIconText", uq);
}, _q = /* @__PURE__ */ W({
  __name: "PKeyValue",
  props: {
    alternate: { type: Boolean },
    label: {},
    value: {}
  },
  setup(t) {
    const n = Yr(), a = t, i = (u) => typeof u == "object" && u !== null ? Vl(u) ? p7(u) : Array.isArray(u) ? u.length > 0 : Object.keys(u).length > 0 : typeof u < "u" && u !== null && u !== "", s = M(() => ({
      container: {
        "p-key-value--alt": a.alternate
      },
      label: {
        "p-key-value__label--alt": a.alternate
      },
      value: {
        "p-key-value__value--alt": a.alternate
      },
      empty: {
        "p-key-value__empty--alt": a.alternate
      }
    }));
    return (u, p) => (c(), _("div", {
      class: Oe(["p-key-value", s.value.container])
    }, [
      d("div", {
        class: Oe(["p-key-value__label", s.value.label])
      }, [
        I(u.$slots, "label", {}, () => [
          Ne(ye(u.label), 1)
        ])
      ], 2),
      i(u.value) || y(n).value ? (c(), _("div", {
        key: 0,
        class: Oe(["p-key-value__value", s.value.value])
      }, [
        I(u.$slots, "value", {}, () => [
          Ne(ye(u.value), 1)
        ])
      ], 2)) : (c(), _("div", {
        key: 1,
        class: Oe(["p-key-value__empty", s.value.empty])
      }, [
        I(u.$slots, "empty", {}, () => [
          p[0] || (p[0] = Ne(" None ", -1))
        ])
      ], 2))
    ], 2));
  }
}), pq = (t) => {
  t.component("PKeyValue", _q);
}, mq = (t) => {
  t.component("PLabel", nh);
}, gq = { class: "p-line-numbers" }, ih = /* @__PURE__ */ W({
  __name: "PLineNumbers",
  props: {
    lines: {}
  },
  setup(t) {
    return (n, a) => (c(), _("div", gq, [
      (c(!0), _(Qe, null, Ye(n.lines, (i) => (c(), _("div", {
        key: i,
        class: "p-line-numbers__line-number"
      }))), 128))
    ]));
  }
}), fq = (t) => {
  t.component("PLineNumbers", ih);
}, hq = /* @__PURE__ */ W({
  __name: "PLink",
  props: {
    to: {}
  },
  setup(t) {
    const n = t, a = M(() => !!n.to && Wf(n.to)), i = M(() => !!n.to && F4(n.to)), s = M(() => !n.to || a.value || i.value ? "a" : "router-link"), u = M(() => n.to ? a.value || i.value ? {
      href: n.to,
      target: a.value ? "_blank" : void 0
    } : {
      to: n.to
    } : {
      target: "_blank"
    });
    return (p, g) => (c(), G(Hr(s.value), oe(u.value, { class: "p-link" }), {
      default: N(() => [
        I(p.$slots, "default"),
        a.value ? (c(), G(Dn, {
          key: 0,
          class: "p-link__external-icon",
          icon: "ArrowTopRightOnSquareIcon"
        })) : le("", !0)
      ]),
      _: 3
    }, 16));
  }
}), vq = (t) => {
  t.component("PLink", hq);
}, Eq = { class: "list-header__left" }, bq = {
  key: 0,
  class: "list-header__controls"
}, Sq = {
  key: 1,
  class: "list-header__sort"
}, wq = /* @__PURE__ */ W({
  __name: "PListHeader",
  props: {
    sticky: { type: Boolean },
    boundingElement: {}
  },
  setup(t) {
    const n = t, a = Yr(), i = z(), { margin: s } = l6(), u = () => n.boundingElement ? { boundingElement: n.boundingElement } : { rootMargin: s.value }, { stuck: p } = v4(i, u), g = M(() => ({
      header: {
        "list-header--sticky": n.sticky,
        "list-header--stuck": n.sticky && p.value
      }
    }));
    return (E, h) => (c(), _("div", {
      ref_key: "stickyContainer",
      ref: i,
      class: Oe(["list-header", g.value.header])
    }, [
      d("div", Eq, [
        I(E.$slots, "default")
      ]),
      y(a).controls ? (c(), _("div", bq, [
        I(E.$slots, "controls")
      ])) : le("", !0),
      y(a).sort ? (c(), _("div", Sq, [
        I(E.$slots, "sort")
      ])) : le("", !0)
    ], 2));
  }
}), yq = (t) => {
  t.component("PListHeader", wq);
}, Tq = {}, Cq = { class: "p-list-item p-background" };
function xq(t, n) {
  return c(), _("div", Cq, [
    I(t.$slots, "default")
  ]);
}
const k3 = /* @__PURE__ */ Wt(Tq, [["render", xq]]), Aq = (t) => {
  t.component("PListItem", k3);
}, Rq = { class: "p-list-item-input__control" }, Oq = { class: "p-list-item-input__checkbox" }, Iq = { class: "p-list-item-input__content" }, Nq = /* @__PURE__ */ W({
  __name: "PListItemInput",
  props: {
    selected: { type: [Boolean, Array, null] },
    value: {},
    disabled: { type: Boolean }
  },
  emits: ["update:selected"],
  setup(t, { emit: n }) {
    const a = t, i = n, s = M({
      get() {
        return a.selected ?? void 0;
      },
      set(u) {
        i("update:selected", u);
      }
    });
    return (u, p) => (c(), G(k3, { class: "p-list-item-input p-background" }, {
      default: N(() => [
        d("div", Rq, [
          d("label", Oq, [
            ne(Ld, oe({
              modelValue: s.value,
              "onUpdate:modelValue": p[0] || (p[0] = (g) => s.value = g)
            }, { value: u.value, disabled: u.disabled }), null, 16, ["modelValue"])
          ])
        ]),
        d("div", Iq, [
          I(u.$slots, "default")
        ])
      ]),
      _: 3
    }));
  }
}), Mq = (t) => {
  t.component("PListItemInput", Nq);
}, qd = 5, Dq = /* @__PURE__ */ W({
  __name: "PListTruncate",
  props: {
    items: {},
    shown: {},
    increment: {},
    decrement: {},
    buttonLabel: {}
  },
  setup(t) {
    const n = t, a = z(n.shown ?? qd), i = M(() => n.items.length > a.value), s = M(() => a.value > qd), u = M(() => n.items.slice(0, a.value)), p = () => {
      a.value += n.increment ?? qd;
    }, g = () => {
      if (n.decrement) {
        a.value -= n.decrement;
        return;
      }
      a.value = qd;
    };
    return (E, h) => {
      const f = ht("p-button"), b = ht("p-virtual-scroller");
      return c(), G(b, {
        items: u.value,
        class: "p-list-truncate"
      }, {
        default: N(({ item: w, index: x }) => [
          I(E.$slots, "default", ve(we({ item: w, index: x, shown: a.value, showMore: p, showLess: g, canShowMore: i.value, canShowLess: s.value })))
        ]),
        bottom: N(() => [
          I(E.$slots, "bottom", ve(we({ shown: a.value, showMore: p, showLess: g, canShowMore: i.value, canShowLess: s.value })), () => [
            i.value ? (c(), G(f, {
              key: 0,
              class: "p-list-truncate__button",
              onClick: p
            }, {
              default: N(() => [
                Ne(ye(E.buttonLabel ?? "Show more"), 1)
              ]),
              _: 1
            })) : le("", !0)
          ])
        ]),
        _: 3
      }, 8, ["items"]);
    };
  }
}), kq = (t) => {
  t.component("PListTruncate", Dq);
};
function Lq(t) {
  return typeof t == "number" && [1, 2, 3, 4, 5, 6].includes(t) || typeof t == "string" && ["1", "2", "3", "4", "5", "6"].includes(t);
}
const Pq = ["css"], Bq = ["gh-markdown"], Fq = ["html", "xml"], Uq = ["javascript", "js"], $q = ["jinja"], Vq = ["json"], Hq = ["markdown", "md"], Gq = ["python", "py"], Yq = ["vue"], zq = ["yaml", "yml"], Zq = ["sql"], qq = [
  ...Pq,
  ...Bq,
  ...Fq,
  ...Uq,
  ...$q,
  ...Vq,
  ...Hq,
  ...Gq,
  ...Yq,
  ...zq,
  ...Zq
];
function Wq(t) {
  return qq.includes(t);
}
function Ln(t) {
  return !!t && typeof t == "object" && "type" in t;
}
function jq(t) {
  return Ln(t) && "tokens" in t;
}
function Kq(t) {
  return Ln(t) && t.type === "code";
}
function Qq(t) {
  return Ln(t) && t.type === "codespan";
}
function Xq(t) {
  return Ln(t) && t.type === "table";
}
function Jq(t) {
  return Ln(t) && t.type === "list";
}
function eW(t) {
  return Ln(t) && t.type === "list_item";
}
function tW(t) {
  return Ln(t) && t.type === "heading";
}
function nW(t) {
  return Ln(t) && t.type === "link";
}
function rW(t) {
  return Ln(t) && t.type === "image";
}
function aW(t) {
  return Ln(t) && t.type === "html";
}
function oW(t) {
  return Ln(t) && t.type === "blockquote";
}
function iW(t) {
  return Ln(t) && t.type === "hr";
}
function sW(t) {
  return Ln(t) && t.type === "space";
}
function lW(t) {
  return Ln(t) && t.type === "br";
}
function cW(t) {
  return Ln(t) && t.type === "text";
}
function uW(t) {
  return Ln(t) && t.type === "paragraph";
}
function dW(t) {
  return Ln(t) && t.type === "strong";
}
function _W(t) {
  return Ln(t) && t.type === "em";
}
function pW(t) {
  return Ln(t) && t.type === "del";
}
function mW(t) {
  return cW(t) || uW(t) || dW(t) || _W(t) || pW(t);
}
function gW(t) {
  return Ln(t) && t.type === "escape";
}
const Ml = "div", nn = "markdown-renderer", fW = ["text-4xl", "text-3xl", "text-2xl", "text-lg", "text-base", "text-sm"], Ad = (t, n) => t.flatMap((a) => hW(a, n)), hW = (t, n) => {
  const { headingClasses: a = fW } = n;
  let i = [];
  jq(t) && (i = Ad(t.tokens, n));
  const s = { class: [`${nn}__token`] }, { type: u } = t;
  if (gW(t))
    return Ne(Xd(t.text));
  if (mW(t)) {
    if (i.length) {
      const p = [`${nn}__text`, `${nn}__text--${u}`];
      return Vt(Ml, { class: p }, i);
    }
    return Ne(Xd(t.text));
  }
  if (sW(t) || lW(t)) {
    const p = [`${nn}__space`];
    return Vt(Ml, { class: p }, i);
  }
  if (iW(t)) {
    const p = [`${nn}__divider`];
    return Vt(of, { class: p });
  }
  if (rW(t)) {
    const { href: p, text: g, title: E } = t, h = [`${nn}__image`];
    return Vt("img", { src: p, alt: g, class: h, title: E });
  }
  if (aW(t)) {
    const { text: p } = t;
    return Vt(H3, { html: p, class: [`${nn}__html`] });
  }
  if (Kq(t))
    return SW(t);
  if (Qq(t)) {
    const p = [`${nn}__codespan`];
    return Vt(Pd, { inline: !0, class: p }, { default: () => Xd(t.text) });
  }
  if (Xq(t))
    return vW(t, n);
  if (Jq(t))
    return bW(t, n, i);
  if (eW(t)) {
    const { task: p, checked: g } = t;
    if (p || typeof g == "boolean")
      return EW(t);
    const E = [`${nn}__list-item`];
    return Vt("li", { class: E }, i);
  }
  if (oW(t)) {
    const p = [`${nn}__blockquote`];
    return Vt("blockquote", { class: p }, i);
  }
  if (tW(t)) {
    const { depth: p, text: g } = t, E = [a[p], `${nn}__heading`, `${nn}__heading--h${p}`, `${nn}__heading-wrapper`];
    let h;
    return n.headerAnchors ? h = Vt(M3, { hash: g, depth: p, class: E }, { default: () => i }) : Lq(p) ? h = Vt(D3, { class: E, heading: p }, { default: () => i }) : h = Vt(Ml, { class: E }, i), p < 2 ? [h, Vt(of)] : h;
  }
  if (nW(t)) {
    const { href: p, title: g } = t, E = [`${nn}__link`];
    return Vt("a", { href: p, title: g, class: E, rel: "noopener", target: p.startsWith("#") ? "_self" : "_blank" }, { default: () => t.text });
  }
  return Vt(Ml, s, i);
}, vW = (t, n) => {
  const { header: a, align: i, rows: s } = t, u = [`${nn}__table`], p = [], g = [], E = {};
  return a.forEach(({ tokens: f }, b) => {
    const w = ml();
    g.push(w);
    const x = Ad(f, n), A = [`${nn}__table-heading`], D = i[b];
    D && A.push(`${nn}__table-column--${D}`), E[`${w}-heading`] = () => Vt(Ml, { class: A }, x);
  }), s.forEach((f) => {
    const b = {};
    f.forEach(({ text: w, tokens: x }, A) => {
      const D = ml();
      b[g[A]] = { [D]: w, _markdownMetadata: { text: w, tokens: x } };
    }), p.push(b);
  }), g.forEach((f) => {
    E[f] = ({ value: b }) => {
      const { _markdownMetadata: { tokens: w } } = b, x = Ad(w, n);
      return x.length ? x : Vt(Ml, { class: [`${nn}__table-cell`] }, { default: () => b[f] });
    };
  }), Vt(W3, { class: u, data: p, columnClasses: (f, b, w) => {
    const x = i[w], A = [`${nn}__table-column`];
    return x && A.push(`${nn}__table-column--${x}`), A;
  } }, E);
}, EW = (t) => {
  const { text: n, checked: a } = t, i = [`${nn}__checkbox`];
  return Vt(Ld, { modelValue: a, disabled: !0, label: n, checked: a, class: i });
}, bW = (t, n, a = []) => {
  const { ordered: i, items: s } = t, u = i ? "ol" : "ul", p = [`${nn}__list`, `${nn}__list--${i ? "ordered" : "unordered"}`], g = Ad(s, n);
  return Vt(u, { class: p }, [...a, ...g]);
}, SW = (t) => {
  const n = [`${nn}__code`], { text: a, lang: i } = t;
  return Wq(i) ? Vt(eh, { text: a, lang: i, class: n }) : Vt(Pd, { class: n }, { default: () => Xd(a) });
}, wW = (t, n = {}) => {
  const a = Ad(t, n);
  return Vt("article", { class: [nn] }, a);
}, L3 = /* @__PURE__ */ W({
  __name: "PMarkdownRenderer",
  props: {
    text: {},
    parserOptions: {}
  },
  setup(t) {
    const { tokens: n } = i6(() => t.text), a = M(() => wW(n.value, t.parserOptions));
    return (i, s) => (c(), G(Hr(a.value)));
  }
}), yW = (t) => {
  t.component("PMarkdownRenderer", L3);
}, TW = { class: "p-message__body" }, CW = { class: "p-message__action" }, xW = /* @__PURE__ */ W({
  __name: "PMessage",
  props: {
    info: { type: Boolean },
    warning: { type: Boolean },
    error: { type: Boolean },
    success: { type: Boolean },
    dismissible: { type: Boolean }
  },
  emits: ["dismiss"],
  setup(t, { emit: n }) {
    const a = t, i = n, s = M(() => {
      if (a.info)
        return "InformationCircleIcon";
      if (a.warning || a.error)
        return "ExclamationCircleIcon";
      if (a.success)
        return "CheckCircleIcon";
    }), u = M(() => ({
      message: {
        "p-message--info": a.info,
        "p-message--warning": a.warning,
        "p-message--error": a.error,
        "p-message--success": a.success
      },
      icon: {
        "p-message__icon--info": a.info,
        "p-message__icon--warning": a.warning,
        "p-message__icon--error": a.error,
        "p-message__icon--success": a.success
      }
    }));
    return (p, g) => {
      const E = ht("p-icon"), h = ht("p-button");
      return c(), _("div", {
        class: Oe(["p-message", u.value.message])
      }, [
        I(p.$slots, "icon", {}, () => [
          s.value ? (c(), G(E, {
            key: 0,
            class: Oe(["p-message__icon", u.value.icon]),
            icon: s.value
          }, null, 8, ["class", "icon"])) : le("", !0)
        ]),
        d("div", TW, [
          I(p.$slots, "default")
        ]),
        I(p.$slots, "action", {}, () => [
          d("div", CW, [
            p.dismissible ? (c(), G(h, {
              key: 0,
              class: "p-message__dismiss",
              icon: "XMarkIcon",
              small: "",
              flat: "",
              onClick: g[0] || (g[0] = (f) => i("dismiss"))
            })) : le("", !0)
          ])
        ])
      ], 2);
    };
  }
}), AW = (t) => {
  t.component("PMessage", xW);
};
function RW(t) {
  const n = 'button:not([disabled]), [href]:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]):not([disabled])';
  return M(() => t.value === void 0 ? [] : Array.from(t.value.querySelectorAll(n)));
}
const sf = "#p-modal-teleport-target";
function OW() {
  if (document.body.querySelector(sf))
    return;
  const t = document.createElement("div");
  t.id = sf.slice(1), document.body.appendChild(t);
}
const IW = {
  install: () => {
    OW();
  }
}, NW = { class: "p-modal__container" }, MW = { class: "p-modal__card" }, DW = { class: "p-modal__tile-icon-group" }, kW = { class: "p-modal__title" }, LW = {
  key: 0,
  class: "p-modal__footer"
}, PW = /* @__PURE__ */ W({
  inheritAttrs: !1,
  __name: "PModal",
  props: {
    showModal: { type: Boolean },
    title: {},
    icon: {},
    hideCloseButton: { type: Boolean },
    autoClose: { type: Boolean }
  },
  emits: ["update:showModal"],
  setup(t, { emit: n }) {
    const a = t, i = n, s = z(!1), u = M({
      get() {
        return a.showModal || s.value;
      },
      set(L) {
        s.value = L, i("update:showModal", L);
      }
    }), p = s6(u), g = z(), E = z(), h = Yr(), f = M(() => ({
      header: {
        "p-modal__header--no-title": a.title === void 0 && h.title === void 0
      }
    }));
    function b() {
      const L = RW(E);
      return L.value.length ? L.value[0] : g.value;
    }
    function w() {
      b()?.focus();
    }
    function x() {
      a.autoClose && p.close();
    }
    function A(L) {
      u.value && a.autoClose && N7(Ie.escape, L) && p.close();
    }
    z7("keyup", A);
    function D() {
      document.body.classList.remove("p-modal__stop-bg-scroll");
    }
    return pv(D), tt(() => a.showModal, (L) => {
      L && Ct(w), document.body.classList.toggle("p-modal__stop-bg-scroll", L);
    }, { immediate: !0 }), (L, $) => (c(), G(Rd, { to: y(sf) }, [
      ne(v0, { name: "modal" }, {
        default: N(() => [
          L.showModal ? (c(), _("div", oe({
            key: 0,
            ref_key: "modalRoot",
            ref: g,
            class: "p-modal",
            "aria-labelledby": "modal-title",
            role: "dialog",
            "aria-modal": "true",
            tabindex: "0"
          }, L.$attrs), [
            d("div", NW, [
              d("div", {
                class: "p-modal__background",
                "aria-hidden": "true",
                onClick: x
              }),
              d("div", MW, [
                d("div", {
                  class: Oe(["p-modal__header", f.value.header])
                }, [
                  d("div", DW, [
                    I(L.$slots, "icon", ve(we(y(p))), () => [
                      L.icon ? (c(), G(Dn, {
                        key: 0,
                        icon: L.icon,
                        class: "p-modal__icon"
                      }, null, 8, ["icon"])) : le("", !0)
                    ]),
                    I(L.$slots, "title", ve(we(y(p))), () => [
                      d("span", kW, ye(L.title), 1)
                    ])
                  ]),
                  L.hideCloseButton ? le("", !0) : (c(), G(rn, {
                    key: 0,
                    class: "p-modal__x-button",
                    icon: "XMarkIcon",
                    small: "",
                    flat: "",
                    onClick: y(p).close
                  }, null, 8, ["onClick"]))
                ], 2),
                d("div", {
                  ref_key: "modalBody",
                  ref: E,
                  class: "p-modal__body"
                }, [
                  I(L.$slots, "default", ve(we(y(p))))
                ], 512),
                L.$slots.actions ? (c(), _("div", LW, [
                  I(L.$slots, "actions", ve(we(y(p)))),
                  L.hideCloseButton ? le("", !0) : I(L.$slots, "cancel", ve(oe({ key: 0 }, y(p))), () => [
                    ne(rn, {
                      class: "p-modal__close-button",
                      onClick: y(p).close
                    }, {
                      default: N(() => [...$[0] || ($[0] = [
                        Ne(" Close ", -1)
                      ])]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ])) : le("", !0)
              ])
            ])
          ], 16)) : le("", !0)
        ]),
        _: 3
      })
    ], 8, ["to"]));
  }
}), BW = (t) => {
  t.component("PModal", PW);
}, FW = (t) => {
  t.component("PNativeDateInput", rh);
}, UW = (t) => {
  t.component("PNativeSelect", y3);
}, $W = (t) => {
  t.component("PNativeTimeInput", b3);
}, VW = /* @__PURE__ */ W({
  __name: "PNavigationBar",
  props: {
    layout: {}
  },
  setup(t) {
    const n = t, a = Yr(), i = M(() => n.layout ?? "vertical"), s = M(() => ({
      root: {
        [`p-navigation-bar--${i.value}`]: !0
      },
      prepend: {
        [`p-navigation-bar__prepend--${i.value}`]: !0
      },
      append: {
        [`p-navigation-bar__append--${i.value}`]: !0
      },
      content: {
        [`p-navigation-bar__content--${i.value}`]: !0
      }
    }));
    return (u, p) => (c(), _("div", {
      class: Oe(["p-navigation-bar", s.value.root])
    }, [
      y(a).prepend ? (c(), _("div", {
        key: 0,
        class: Oe(["p-navigation-bar__prepend", s.value.prepend])
      }, [
        I(u.$slots, "prepend")
      ], 2)) : le("", !0),
      d("div", {
        class: Oe(["p-navigation-bar__content", s.value.content])
      }, [
        I(u.$slots, "default")
      ], 2),
      y(a).append ? (c(), _("div", {
        key: 1,
        class: Oe(["p-navigation-bar__append", s.value.append])
      }, [
        I(u.$slots, "append")
      ], 2)) : le("", !0)
    ], 2));
  }
}), HW = (t) => {
  t.component("PNavigationBar", VW);
}, GW = (t) => {
  t.component("PNumberInput", w3);
}, YW = (t) => {
  t.component("POverflowMenu", th);
}, zW = {
  key: 1,
  class: "p-overflow-menu-item__after"
}, ZW = /* @__PURE__ */ W({
  __name: "POverflowMenuItem",
  props: {
    label: {},
    icon: {},
    to: {}
  },
  setup(t) {
    const n = t, a = M(() => n.to ? Wf(n.to) ? "a" : "router-link" : "button"), i = M(() => a.value === "a" ? {
      role: "button",
      href: n.to
    } : a.value === "button" ? {
      type: "button"
    } : {
      role: "button",
      to: n.to
    });
    return (s, u) => (c(), G(Hr(a.value), oe({
      class: "p-overflow-menu-item",
      "exact-active-class": "p-overflow-menu-item--active"
    }, i.value), {
      default: N(() => [
        s.icon ? (c(), G(Dn, {
          key: 0,
          icon: s.icon,
          class: "p-overflow-menu-item__icon"
        }, null, 8, ["icon"])) : le("", !0),
        I(s.$slots, "default", {}, () => [
          d("span", null, ye(s.label), 1)
        ]),
        s.$slots.after ? (c(), _("div", zW, [
          I(s.$slots, "after")
        ])) : le("", !0)
      ]),
      _: 3
    }, 16));
  }
}), qW = (t) => {
  t.component("POverflowMenuItem", ZW);
}, WW = { class: "p-pager" }, jW = {
  key: 0,
  class: "p-pager__limit"
}, KW = { class: "p-pager__slot" }, QW = { class: "p-pager__buttons" }, XW = { class: "p-pager__context" }, JW = { class: "p-pager__page" }, ej = { class: "p-pager__page" }, tj = {
  key: 1,
  class: "p-pager__page"
}, nj = /* @__PURE__ */ W({
  __name: "PPager",
  props: {
    page: { required: !0 },
    pageModifiers: {},
    pages: {},
    pagesModifiers: {},
    limit: {},
    limitModifiers: {},
    limits: { default: () => [5, 10, 25, 50, 100] },
    limitsModifiers: {}
  },
  emits: ["update:page", "update:pages", "update:limit", "update:limits"],
  setup(t) {
    const n = Ni(t, "page"), a = Ni(t, "pages"), i = Ni(t, "limit"), s = Ni(t, "limits"), u = M(() => "Items per page"), p = M(() => n.value === 1), g = M(() => n.value === (a.value ?? 1 / 0)), E = M(() => n.value >= (a.value ?? 1 / 0)), h = M(() => n.value <= 1);
    function f() {
      --n.value;
    }
    function b() {
      ++n.value;
    }
    function w() {
      n.value = 1;
    }
    function x() {
      n.value = a.value ?? 1;
    }
    return (A, D) => {
      const L = ht("p-select"), $ = ht("p-button");
      return c(), _("div", WW, [
        I(A.$slots, "limit", {}, () => [
          i.value ? (c(), _("div", jW, [
            Ne(ye(u.value) + " ", 1),
            ne(L, {
              modelValue: i.value,
              "onUpdate:modelValue": D[0] || (D[0] = (q) => i.value = q),
              small: "",
              class: "p-pager__limit-select",
              options: s.value
            }, null, 8, ["modelValue", "options"])
          ])) : le("", !0)
        ]),
        d("div", KW, [
          I(A.$slots, "default")
        ]),
        d("div", QW, [
          a.value ? (c(), G($, {
            key: 0,
            icon: "ChevronDoubleLeftIcon",
            disabled: p.value,
            size: "sm",
            variant: "ghost",
            onClick: w
          }, null, 8, ["disabled"])) : le("", !0),
          ne($, {
            icon: "ChevronLeftIcon",
            disabled: h.value,
            size: "sm",
            variant: "ghost",
            onClick: f
          }, null, 8, ["disabled"]),
          d("p", XW, [
            D[2] || (D[2] = Ne(" Page ", -1)),
            a.value ? (c(), _(Qe, { key: 0 }, [
              d("span", JW, ye(n.value), 1),
              D[1] || (D[1] = Ne(" of ", -1)),
              d("span", ej, ye(a.value), 1)
            ], 64)) : (c(), _("span", tj, ye(n.value), 1))
          ]),
          ne($, {
            icon: "ChevronRightIcon",
            disabled: E.value,
            size: "sm",
            variant: "ghost",
            onClick: b
          }, null, 8, ["disabled"]),
          a.value ? (c(), G($, {
            key: 1,
            icon: "ChevronDoubleRightIcon",
            disabled: g.value,
            size: "sm",
            variant: "ghost",
            onClick: x
          }, null, 8, ["disabled"])) : le("", !0)
        ])
      ]);
    };
  }
}), rj = (t) => {
  t.component("PPager", nj);
}, aj = (t) => {
  t.component("PPopOver", Sl);
}, oj = { class: "p-radio__label" }, ij = ["id", "disabled", "value"], P3 = /* @__PURE__ */ W({
  inheritAttrs: !1,
  __name: "PRadio",
  props: {
    modelValue: { type: [String, Number, Boolean, null] },
    label: {},
    value: { type: [String, Number, Boolean, null] },
    state: {},
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: n }) {
    const a = t, i = n, s = Yr(), { classes: u, styles: p, attrs: g } = Xa(), E = M({
      get() {
        return a.modelValue ?? null;
      },
      set(b) {
        i("update:modelValue", b);
      }
    }), h = M(() => a.state?.valid === !1 && a.state.validated && !a.state.pending), f = M(() => [
      u.value,
      {
        "p-radio--disabled": a.disabled,
        "p-radio--failed": h.value,
        "p-radio--pending": a.state?.pending
      }
    ]);
    return (b, w) => {
      const x = ht("PLabel");
      return c(), G(x, {
        class: Oe(["p-radio", f.value]),
        style: Gr(y(p))
      }, mn({
        default: N(({ id: A }) => [
          ur(d("input", oe({ id: A }, y(g), {
            "onUpdate:modelValue": w[0] || (w[0] = (D) => E.value = D),
            type: "radio",
            disabled: b.disabled,
            value: b.value,
            class: "p-radio__input"
          }), null, 16, ij), [
            [fE, E.value]
          ])
        ]),
        _: 2
      }, [
        y(s).label || y(Nd)(b.label) ? {
          name: "label",
          fn: N(() => [
            I(b.$slots, "label", {}, () => [
              d("span", oj, ye(b.label), 1)
            ])
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["class", "style"]);
    };
  }
}), sj = (t) => {
  t.component("PRadio", P3);
}, lj = /* @__PURE__ */ W({
  inheritAttrs: !1,
  __name: "PRadioGroup",
  props: {
    modelValue: { type: [String, Number, Boolean, null] },
    options: {},
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: n }) {
    const a = t, i = n, s = M({
      get() {
        return a.modelValue ?? null;
      },
      set(h) {
        i("update:modelValue", h);
      }
    }), u = M(() => a.options.map((h) => Ei(h))), { classes: p, styles: g, attrs: E } = Xa();
    return (h, f) => (c(), _("div", {
      class: Oe(["p-radio-group", y(p)]),
      style: Gr(y(g))
    }, [
      (c(!0), _(Qe, null, Ye(u.value, (b, w) => (c(), G(y(P3), oe({
        key: w,
        modelValue: s.value,
        "onUpdate:modelValue": f[0] || (f[0] = (x) => s.value = x)
      }, { ref_for: !0 }, y(E), {
        label: b.label,
        value: b.value,
        disabled: b.disabled || h.disabled
      }), {
        label: N(() => [
          I(h.$slots, "label", { option: b })
        ]),
        _: 2
      }, 1040, ["modelValue", "label", "value", "disabled"]))), 128))
    ], 6));
  }
}), cj = (t) => {
  t.component("PRadioGroup", lj);
};
/*! @license DOMPurify 3.2.6 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.2.6/LICENSE */
const {
  entries: B3,
  setPrototypeOf: Xh,
  isFrozen: uj,
  getPrototypeOf: dj,
  getOwnPropertyDescriptor: _j
} = Object;
let {
  freeze: Or,
  seal: Aa,
  create: F3
} = Object, {
  apply: lf,
  construct: cf
} = typeof Reflect < "u" && Reflect;
Or || (Or = function(n) {
  return n;
});
Aa || (Aa = function(n) {
  return n;
});
lf || (lf = function(n, a, i) {
  return n.apply(a, i);
});
cf || (cf = function(n, a) {
  return new n(...a);
});
const Wd = Ir(Array.prototype.forEach), pj = Ir(Array.prototype.lastIndexOf), Jh = Ir(Array.prototype.pop), md = Ir(Array.prototype.push), mj = Ir(Array.prototype.splice), e0 = Ir(String.prototype.toLowerCase), M2 = Ir(String.prototype.toString), ev = Ir(String.prototype.match), gd = Ir(String.prototype.replace), gj = Ir(String.prototype.indexOf), fj = Ir(String.prototype.trim), ja = Ir(Object.prototype.hasOwnProperty), Rr = Ir(RegExp.prototype.test), fd = hj(TypeError);
function Ir(t) {
  return function(n) {
    n instanceof RegExp && (n.lastIndex = 0);
    for (var a = arguments.length, i = new Array(a > 1 ? a - 1 : 0), s = 1; s < a; s++)
      i[s - 1] = arguments[s];
    return lf(t, n, i);
  };
}
function hj(t) {
  return function() {
    for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
      a[i] = arguments[i];
    return cf(t, a);
  };
}
function ct(t, n) {
  let a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : e0;
  Xh && Xh(t, null);
  let i = n.length;
  for (; i--; ) {
    let s = n[i];
    if (typeof s == "string") {
      const u = a(s);
      u !== s && (uj(n) || (n[i] = u), s = u);
    }
    t[s] = !0;
  }
  return t;
}
function vj(t) {
  for (let n = 0; n < t.length; n++)
    ja(t, n) || (t[n] = null);
  return t;
}
function ci(t) {
  const n = F3(null);
  for (const [a, i] of B3(t))
    ja(t, a) && (Array.isArray(i) ? n[a] = vj(i) : i && typeof i == "object" && i.constructor === Object ? n[a] = ci(i) : n[a] = i);
  return n;
}
function hd(t, n) {
  for (; t !== null; ) {
    const i = _j(t, n);
    if (i) {
      if (i.get)
        return Ir(i.get);
      if (typeof i.value == "function")
        return Ir(i.value);
    }
    t = dj(t);
  }
  function a() {
    return null;
  }
  return a;
}
const tv = Or(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), D2 = Or(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), k2 = Or(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), Ej = Or(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), L2 = Or(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), bj = Or(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), nv = Or(["#text"]), rv = Or(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]), P2 = Or(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), av = Or(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), jd = Or(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), Sj = Aa(/\{\{[\w\W]*|[\w\W]*\}\}/gm), wj = Aa(/<%[\w\W]*|[\w\W]*%>/gm), yj = Aa(/\$\{[\w\W]*/gm), Tj = Aa(/^data-[\-\w.\u00B7-\uFFFF]+$/), Cj = Aa(/^aria-[\-\w]+$/), U3 = Aa(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), xj = Aa(/^(?:\w+script|data):/i), Aj = Aa(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), $3 = Aa(/^html$/i), Rj = Aa(/^[a-z][.\w]*(-[.\w]+)+$/i);
var ov = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ARIA_ATTR: Cj,
  ATTR_WHITESPACE: Aj,
  CUSTOM_ELEMENT: Rj,
  DATA_ATTR: Tj,
  DOCTYPE_NAME: $3,
  ERB_EXPR: wj,
  IS_ALLOWED_URI: U3,
  IS_SCRIPT_OR_DATA: xj,
  MUSTACHE_EXPR: Sj,
  TMPLIT_EXPR: yj
});
const vd = {
  element: 1,
  text: 3,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9
}, Oj = function() {
  return typeof window > "u" ? null : window;
}, Ij = function(n, a) {
  if (typeof n != "object" || typeof n.createPolicy != "function")
    return null;
  let i = null;
  const s = "data-tt-policy-suffix";
  a && a.hasAttribute(s) && (i = a.getAttribute(s));
  const u = "dompurify" + (i ? "#" + i : "");
  try {
    return n.createPolicy(u, {
      createHTML(p) {
        return p;
      },
      createScriptURL(p) {
        return p;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + u + " could not be created."), null;
  }
}, iv = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function V3() {
  let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Oj();
  const n = (Pe) => V3(Pe);
  if (n.version = "3.2.6", n.removed = [], !t || !t.document || t.document.nodeType !== vd.document || !t.Element)
    return n.isSupported = !1, n;
  let {
    document: a
  } = t;
  const i = a, s = i.currentScript, {
    DocumentFragment: u,
    HTMLTemplateElement: p,
    Node: g,
    Element: E,
    NodeFilter: h,
    NamedNodeMap: f = t.NamedNodeMap || t.MozNamedAttrMap,
    HTMLFormElement: b,
    DOMParser: w,
    trustedTypes: x
  } = t, A = E.prototype, D = hd(A, "cloneNode"), L = hd(A, "remove"), $ = hd(A, "nextSibling"), q = hd(A, "childNodes"), P = hd(A, "parentNode");
  if (typeof p == "function") {
    const Pe = a.createElement("template");
    Pe.content && Pe.content.ownerDocument && (a = Pe.content.ownerDocument);
  }
  let k, U = "";
  const {
    implementation: Z,
    createNodeIterator: ee,
    createDocumentFragment: X,
    getElementsByTagName: re
  } = a, {
    importNode: Q
  } = i;
  let ce = iv();
  n.isSupported = typeof B3 == "function" && typeof P == "function" && Z && Z.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: me,
    ERB_EXPR: Se,
    TMPLIT_EXPR: Le,
    DATA_ATTR: qe,
    ARIA_ATTR: _t,
    IS_SCRIPT_OR_DATA: ot,
    ATTR_WHITESPACE: st,
    CUSTOM_ELEMENT: Me
  } = ov;
  let {
    IS_ALLOWED_URI: je
  } = ov, Fe = null;
  const Pn = ct({}, [...tv, ...D2, ...k2, ...L2, ...nv]);
  let Rt = null;
  const Zr = ct({}, [...rv, ...P2, ...av, ...jd]);
  let De = Object.seal(F3(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), gn = null, Ot = null, mt = !0, an = !0, ha = !1, pr = !0, Cn = !1, qr = !0, pt = !1, Xn = !1, go = !1, Ft = !1, va = !1, Ja = !1, dr = !0, Ut = !1;
  const mr = "user-content-";
  let gr = !0, Ra = !1, xn = {}, Ea = null;
  const Bn = ct({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let An = null;
  const Wr = ct({}, ["audio", "video", "img", "source", "image", "track"]);
  let fn = null;
  const jr = ct({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), fr = "http://www.w3.org/1998/Math/MathML", Dr = "http://www.w3.org/2000/svg", Rn = "http://www.w3.org/1999/xhtml";
  let Fn = Rn, kr = !1, Lr = null;
  const $i = ct({}, [fr, Dr, Rn], M2);
  let _r = ct({}, ["mi", "mo", "mn", "ms", "mtext"]), Oa = ct({}, ["annotation-xml"]);
  const fo = ct({}, ["title", "style", "font", "a", "script"]);
  let Kr = null;
  const ho = ["application/xhtml+xml", "text/html"], Ia = "text/html";
  let qt = null, Pr = null;
  const Na = a.createElement("form"), ba = function(K) {
    return K instanceof RegExp || K instanceof Function;
  }, vo = function() {
    let K = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!(Pr && Pr === K)) {
      if ((!K || typeof K != "object") && (K = {}), K = ci(K), Kr = // eslint-disable-next-line unicorn/prefer-includes
      ho.indexOf(K.PARSER_MEDIA_TYPE) === -1 ? Ia : K.PARSER_MEDIA_TYPE, qt = Kr === "application/xhtml+xml" ? M2 : e0, Fe = ja(K, "ALLOWED_TAGS") ? ct({}, K.ALLOWED_TAGS, qt) : Pn, Rt = ja(K, "ALLOWED_ATTR") ? ct({}, K.ALLOWED_ATTR, qt) : Zr, Lr = ja(K, "ALLOWED_NAMESPACES") ? ct({}, K.ALLOWED_NAMESPACES, M2) : $i, fn = ja(K, "ADD_URI_SAFE_ATTR") ? ct(ci(jr), K.ADD_URI_SAFE_ATTR, qt) : jr, An = ja(K, "ADD_DATA_URI_TAGS") ? ct(ci(Wr), K.ADD_DATA_URI_TAGS, qt) : Wr, Ea = ja(K, "FORBID_CONTENTS") ? ct({}, K.FORBID_CONTENTS, qt) : Bn, gn = ja(K, "FORBID_TAGS") ? ct({}, K.FORBID_TAGS, qt) : ci({}), Ot = ja(K, "FORBID_ATTR") ? ct({}, K.FORBID_ATTR, qt) : ci({}), xn = ja(K, "USE_PROFILES") ? K.USE_PROFILES : !1, mt = K.ALLOW_ARIA_ATTR !== !1, an = K.ALLOW_DATA_ATTR !== !1, ha = K.ALLOW_UNKNOWN_PROTOCOLS || !1, pr = K.ALLOW_SELF_CLOSE_IN_ATTR !== !1, Cn = K.SAFE_FOR_TEMPLATES || !1, qr = K.SAFE_FOR_XML !== !1, pt = K.WHOLE_DOCUMENT || !1, Ft = K.RETURN_DOM || !1, va = K.RETURN_DOM_FRAGMENT || !1, Ja = K.RETURN_TRUSTED_TYPE || !1, go = K.FORCE_BODY || !1, dr = K.SANITIZE_DOM !== !1, Ut = K.SANITIZE_NAMED_PROPS || !1, gr = K.KEEP_CONTENT !== !1, Ra = K.IN_PLACE || !1, je = K.ALLOWED_URI_REGEXP || U3, Fn = K.NAMESPACE || Rn, _r = K.MATHML_TEXT_INTEGRATION_POINTS || _r, Oa = K.HTML_INTEGRATION_POINTS || Oa, De = K.CUSTOM_ELEMENT_HANDLING || {}, K.CUSTOM_ELEMENT_HANDLING && ba(K.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (De.tagNameCheck = K.CUSTOM_ELEMENT_HANDLING.tagNameCheck), K.CUSTOM_ELEMENT_HANDLING && ba(K.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (De.attributeNameCheck = K.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), K.CUSTOM_ELEMENT_HANDLING && typeof K.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (De.allowCustomizedBuiltInElements = K.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), Cn && (an = !1), va && (Ft = !0), xn && (Fe = ct({}, nv), Rt = [], xn.html === !0 && (ct(Fe, tv), ct(Rt, rv)), xn.svg === !0 && (ct(Fe, D2), ct(Rt, P2), ct(Rt, jd)), xn.svgFilters === !0 && (ct(Fe, k2), ct(Rt, P2), ct(Rt, jd)), xn.mathMl === !0 && (ct(Fe, L2), ct(Rt, av), ct(Rt, jd))), K.ADD_TAGS && (Fe === Pn && (Fe = ci(Fe)), ct(Fe, K.ADD_TAGS, qt)), K.ADD_ATTR && (Rt === Zr && (Rt = ci(Rt)), ct(Rt, K.ADD_ATTR, qt)), K.ADD_URI_SAFE_ATTR && ct(fn, K.ADD_URI_SAFE_ATTR, qt), K.FORBID_CONTENTS && (Ea === Bn && (Ea = ci(Ea)), ct(Ea, K.FORBID_CONTENTS, qt)), gr && (Fe["#text"] = !0), pt && ct(Fe, ["html", "head", "body"]), Fe.table && (ct(Fe, ["tbody"]), delete gn.tbody), K.TRUSTED_TYPES_POLICY) {
        if (typeof K.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw fd('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof K.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw fd('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        k = K.TRUSTED_TYPES_POLICY, U = k.createHTML("");
      } else
        k === void 0 && (k = Ij(x, s)), k !== null && typeof U == "string" && (U = k.createHTML(""));
      Or && Or(K), Pr = K;
    }
  }, bi = ct({}, [...D2, ...k2, ...Ej]), Sa = ct({}, [...L2, ...bj]), Vi = function(K) {
    let pe = P(K);
    (!pe || !pe.tagName) && (pe = {
      namespaceURI: Fn,
      tagName: "template"
    });
    const xe = e0(K.tagName), ut = e0(pe.tagName);
    return Lr[K.namespaceURI] ? K.namespaceURI === Dr ? pe.namespaceURI === Rn ? xe === "svg" : pe.namespaceURI === fr ? xe === "svg" && (ut === "annotation-xml" || _r[ut]) : !!bi[xe] : K.namespaceURI === fr ? pe.namespaceURI === Rn ? xe === "math" : pe.namespaceURI === Dr ? xe === "math" && Oa[ut] : !!Sa[xe] : K.namespaceURI === Rn ? pe.namespaceURI === Dr && !Oa[ut] || pe.namespaceURI === fr && !_r[ut] ? !1 : !Sa[xe] && (fo[xe] || !bi[xe]) : !!(Kr === "application/xhtml+xml" && Lr[K.namespaceURI]) : !1;
  }, On = function(K) {
    md(n.removed, {
      element: K
    });
    try {
      P(K).removeChild(K);
    } catch {
      L(K);
    }
  }, Qr = function(K, pe) {
    try {
      md(n.removed, {
        attribute: pe.getAttributeNode(K),
        from: pe
      });
    } catch {
      md(n.removed, {
        attribute: null,
        from: pe
      });
    }
    if (pe.removeAttribute(K), K === "is")
      if (Ft || va)
        try {
          On(pe);
        } catch {
        }
      else
        try {
          pe.setAttribute(K, "");
        } catch {
        }
  }, eo = function(K) {
    let pe = null, xe = null;
    if (go)
      K = "<remove></remove>" + K;
    else {
      const bt = ev(K, /^[\r\n\t ]+/);
      xe = bt && bt[0];
    }
    Kr === "application/xhtml+xml" && Fn === Rn && (K = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + K + "</body></html>");
    const ut = k ? k.createHTML(K) : K;
    if (Fn === Rn)
      try {
        pe = new w().parseFromString(ut, Kr);
      } catch {
      }
    if (!pe || !pe.documentElement) {
      pe = Z.createDocument(Fn, "template", null);
      try {
        pe.documentElement.innerHTML = kr ? U : ut;
      } catch {
      }
    }
    const hn = pe.body || pe.documentElement;
    return K && xe && hn.insertBefore(a.createTextNode(xe), hn.childNodes[0] || null), Fn === Rn ? re.call(pe, pt ? "html" : "body")[0] : pt ? pe.documentElement : hn;
  }, Br = function(K) {
    return ee.call(
      K.ownerDocument || K,
      K,
      // eslint-disable-next-line no-bitwise
      h.SHOW_ELEMENT | h.SHOW_COMMENT | h.SHOW_TEXT | h.SHOW_PROCESSING_INSTRUCTION | h.SHOW_CDATA_SECTION,
      null
    );
  }, Eo = function(K) {
    return K instanceof b && (typeof K.nodeName != "string" || typeof K.textContent != "string" || typeof K.removeChild != "function" || !(K.attributes instanceof f) || typeof K.removeAttribute != "function" || typeof K.setAttribute != "function" || typeof K.namespaceURI != "string" || typeof K.insertBefore != "function" || typeof K.hasChildNodes != "function");
  }, Si = function(K) {
    return typeof g == "function" && K instanceof g;
  };
  function hr(Pe, K, pe) {
    Wd(Pe, (xe) => {
      xe.call(n, K, pe, Pr);
    });
  }
  const wi = function(K) {
    let pe = null;
    if (hr(ce.beforeSanitizeElements, K, null), Eo(K))
      return On(K), !0;
    const xe = qt(K.nodeName);
    if (hr(ce.uponSanitizeElement, K, {
      tagName: xe,
      allowedTags: Fe
    }), qr && K.hasChildNodes() && !Si(K.firstElementChild) && Rr(/<[/\w!]/g, K.innerHTML) && Rr(/<[/\w!]/g, K.textContent) || K.nodeType === vd.progressingInstruction || qr && K.nodeType === vd.comment && Rr(/<[/\w]/g, K.data))
      return On(K), !0;
    if (!Fe[xe] || gn[xe]) {
      if (!gn[xe] && jn(xe) && (De.tagNameCheck instanceof RegExp && Rr(De.tagNameCheck, xe) || De.tagNameCheck instanceof Function && De.tagNameCheck(xe)))
        return !1;
      if (gr && !Ea[xe]) {
        const ut = P(K) || K.parentNode, hn = q(K) || K.childNodes;
        if (hn && ut) {
          const bt = hn.length;
          for (let In = bt - 1; In >= 0; --In) {
            const vr = D(hn[In], !0);
            vr.__removalCount = (K.__removalCount || 0) + 1, ut.insertBefore(vr, $(K));
          }
        }
      }
      return On(K), !0;
    }
    return K instanceof E && !Vi(K) || (xe === "noscript" || xe === "noembed" || xe === "noframes") && Rr(/<\/no(script|embed|frames)/i, K.innerHTML) ? (On(K), !0) : (Cn && K.nodeType === vd.text && (pe = K.textContent, Wd([me, Se, Le], (ut) => {
      pe = gd(pe, ut, " ");
    }), K.textContent !== pe && (md(n.removed, {
      element: K.cloneNode()
    }), K.textContent = pe)), hr(ce.afterSanitizeElements, K, null), !1);
  }, yi = function(K, pe, xe) {
    if (dr && (pe === "id" || pe === "name") && (xe in a || xe in Na))
      return !1;
    if (!(an && !Ot[pe] && Rr(qe, pe))) {
      if (!(mt && Rr(_t, pe))) {
        if (!Rt[pe] || Ot[pe]) {
          if (
            // First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            !(jn(K) && (De.tagNameCheck instanceof RegExp && Rr(De.tagNameCheck, K) || De.tagNameCheck instanceof Function && De.tagNameCheck(K)) && (De.attributeNameCheck instanceof RegExp && Rr(De.attributeNameCheck, pe) || De.attributeNameCheck instanceof Function && De.attributeNameCheck(pe)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            pe === "is" && De.allowCustomizedBuiltInElements && (De.tagNameCheck instanceof RegExp && Rr(De.tagNameCheck, xe) || De.tagNameCheck instanceof Function && De.tagNameCheck(xe)))
          ) return !1;
        } else if (!fn[pe]) {
          if (!Rr(je, gd(xe, st, ""))) {
            if (!((pe === "src" || pe === "xlink:href" || pe === "href") && K !== "script" && gj(xe, "data:") === 0 && An[K])) {
              if (!(ha && !Rr(ot, gd(xe, st, "")))) {
                if (xe)
                  return !1;
              }
            }
          }
        }
      }
    }
    return !0;
  }, jn = function(K) {
    return K !== "annotation-xml" && ev(K, Me);
  }, Ti = function(K) {
    hr(ce.beforeSanitizeAttributes, K, null);
    const {
      attributes: pe
    } = K;
    if (!pe || Eo(K))
      return;
    const xe = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: Rt,
      forceKeepAttr: void 0
    };
    let ut = pe.length;
    for (; ut--; ) {
      const hn = pe[ut], {
        name: bt,
        namespaceURI: In,
        value: vr
      } = hn, Fr = qt(bt), Ma = vr;
      let on = bt === "value" ? Ma : fj(Ma);
      if (xe.attrName = Fr, xe.attrValue = on, xe.keepAttr = !0, xe.forceKeepAttr = void 0, hr(ce.uponSanitizeAttribute, K, xe), on = xe.attrValue, Ut && (Fr === "id" || Fr === "name") && (Qr(bt, K), on = mr + on), qr && Rr(/((--!?|])>)|<\/(style|title)/i, on)) {
        Qr(bt, K);
        continue;
      }
      if (xe.forceKeepAttr)
        continue;
      if (!xe.keepAttr) {
        Qr(bt, K);
        continue;
      }
      if (!pr && Rr(/\/>/i, on)) {
        Qr(bt, K);
        continue;
      }
      Cn && Wd([me, Se, Le], (Ci) => {
        on = gd(on, Ci, " ");
      });
      const Jn = qt(K.nodeName);
      if (!yi(Jn, Fr, on)) {
        Qr(bt, K);
        continue;
      }
      if (k && typeof x == "object" && typeof x.getAttributeType == "function" && !In)
        switch (x.getAttributeType(Jn, Fr)) {
          case "TrustedHTML": {
            on = k.createHTML(on);
            break;
          }
          case "TrustedScriptURL": {
            on = k.createScriptURL(on);
            break;
          }
        }
      if (on !== Ma)
        try {
          In ? K.setAttributeNS(In, bt, on) : K.setAttribute(bt, on), Eo(K) ? On(K) : Jh(n.removed);
        } catch {
          Qr(bt, K);
        }
    }
    hr(ce.afterSanitizeAttributes, K, null);
  }, Hi = function Pe(K) {
    let pe = null;
    const xe = Br(K);
    for (hr(ce.beforeSanitizeShadowDOM, K, null); pe = xe.nextNode(); )
      hr(ce.uponSanitizeShadowNode, pe, null), wi(pe), Ti(pe), pe.content instanceof u && Pe(pe.content);
    hr(ce.afterSanitizeShadowDOM, K, null);
  };
  return n.sanitize = function(Pe) {
    let K = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, pe = null, xe = null, ut = null, hn = null;
    if (kr = !Pe, kr && (Pe = "<!-->"), typeof Pe != "string" && !Si(Pe))
      if (typeof Pe.toString == "function") {
        if (Pe = Pe.toString(), typeof Pe != "string")
          throw fd("dirty is not a string, aborting");
      } else
        throw fd("toString is not a function");
    if (!n.isSupported)
      return Pe;
    if (Xn || vo(K), n.removed = [], typeof Pe == "string" && (Ra = !1), Ra) {
      if (Pe.nodeName) {
        const vr = qt(Pe.nodeName);
        if (!Fe[vr] || gn[vr])
          throw fd("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (Pe instanceof g)
      pe = eo("<!---->"), xe = pe.ownerDocument.importNode(Pe, !0), xe.nodeType === vd.element && xe.nodeName === "BODY" || xe.nodeName === "HTML" ? pe = xe : pe.appendChild(xe);
    else {
      if (!Ft && !Cn && !pt && // eslint-disable-next-line unicorn/prefer-includes
      Pe.indexOf("<") === -1)
        return k && Ja ? k.createHTML(Pe) : Pe;
      if (pe = eo(Pe), !pe)
        return Ft ? null : Ja ? U : "";
    }
    pe && go && On(pe.firstChild);
    const bt = Br(Ra ? Pe : pe);
    for (; ut = bt.nextNode(); )
      wi(ut), Ti(ut), ut.content instanceof u && Hi(ut.content);
    if (Ra)
      return Pe;
    if (Ft) {
      if (va)
        for (hn = X.call(pe.ownerDocument); pe.firstChild; )
          hn.appendChild(pe.firstChild);
      else
        hn = pe;
      return (Rt.shadowroot || Rt.shadowrootmode) && (hn = Q.call(i, hn, !0)), hn;
    }
    let In = pt ? pe.outerHTML : pe.innerHTML;
    return pt && Fe["!doctype"] && pe.ownerDocument && pe.ownerDocument.doctype && pe.ownerDocument.doctype.name && Rr($3, pe.ownerDocument.doctype.name) && (In = "<!DOCTYPE " + pe.ownerDocument.doctype.name + `>
` + In), Cn && Wd([me, Se, Le], (vr) => {
      In = gd(In, vr, " ");
    }), k && Ja ? k.createHTML(In) : In;
  }, n.setConfig = function() {
    let Pe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    vo(Pe), Xn = !0;
  }, n.clearConfig = function() {
    Pr = null, Xn = !1;
  }, n.isValidAttribute = function(Pe, K, pe) {
    Pr || vo({});
    const xe = qt(Pe), ut = qt(K);
    return yi(xe, ut, pe);
  }, n.addHook = function(Pe, K) {
    typeof K == "function" && md(ce[Pe], K);
  }, n.removeHook = function(Pe, K) {
    if (K !== void 0) {
      const pe = pj(ce[Pe], K);
      return pe === -1 ? void 0 : mj(ce[Pe], pe, 1)[0];
    }
    return Jh(ce[Pe]);
  }, n.removeHooks = function(Pe) {
    ce[Pe] = [];
  }, n.removeAllHooks = function() {
    ce = iv();
  }, n;
}
var Nj = V3();
const sh = /* @__PURE__ */ W({
  __name: "PUnwrap",
  props: {
    html: {}
  },
  setup(t) {
    const n = z(), a = {
      mounted(i, s) {
        const u = document.createRange().createContextualFragment(s.value);
        n.value = i.parentElement, n.value.replaceChildren(u);
      },
      updated(i, s) {
        const u = document.createRange().createContextualFragment(s.value);
        n.value.replaceChildren(u);
      }
    };
    return (i, s) => ur((c(), _("html", null, null, 512)), [
      [a, i.html]
    ]);
  }
}), Mj = (t) => {
  t.component("PUnwrap", sh);
}, Dj = { class: "p-sanitize-html" }, H3 = /* @__PURE__ */ W({
  __name: "PSanitizeHtml",
  props: {
    html: {},
    config: {}
  },
  setup(t) {
    const n = t, a = {
      FORBID_TAGS: ["script", "style", "iframe", "form"],
      FORBID_ATTR: ["style", "action", "method", "onclick", "onmouseover", "onload", "data", "onmousedown", "onmouseup"],
      USE_PROFILES: { svg: !0, html: !0 }
    }, i = (u) => Nj.sanitize(
      u,
      n.config ?? a
    ), s = M(() => i(n.html));
    return (u, p) => (c(), _("span", Dj, [
      ne(y(sh), { html: s.value }, null, 8, ["html"])
    ]));
  }
}), kj = (t) => {
  t.component("PSanitizeHtml", H3);
}, Lj = (t) => {
  t.component("PSelect", L0);
}, G3 = /* @__PURE__ */ W({
  __name: "PSelectAllCheckbox",
  props: /* @__PURE__ */ E0({
    selectable: {},
    itemName: { default: "item" }
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const n = Ni(t, "modelValue"), a = t, i = h0(), s = M({
      get: () => n.value.length > 0,
      set: (p) => {
        p ? n.value = a.selectable : n.value = [];
      }
    }), u = M(() => s.value ? `Deselect all ${n.value.length} ${_a(a.itemName, n.value.length)}` : `Select all ${a.selectable.length} ${_a(a.itemName, a.selectable.length)}`);
    return (p, g) => {
      const E = ht("p-checkbox"), h = ht("p-tooltip");
      return c(), G(h, {
        text: s.value ? "Deselect all" : "Select all"
      }, {
        default: N(() => [
          ne(E, oe({
            modelValue: s.value,
            "onUpdate:modelValue": g[0] || (g[0] = (f) => s.value = f),
            indeterminate: n.value.length && n.value.length < p.selectable.length,
            "aria-label": u.value
          }, y(i)), mn({ _: 2 }, [
            p.$slots.label ? {
              name: "label",
              fn: N(() => [
                I(p.$slots, "label", { label: u.value })
              ]),
              key: "0"
            } : void 0
          ]), 1040, ["modelValue", "indeterminate", "aria-label"])
        ]),
        _: 3
      }, 8, ["text"]);
    };
  }
}), Pj = (t) => {
  t.component("PSelectAllCheckbox", G3);
}, Bj = (t) => {
  t.component("PSelectOption", T3);
}, Fj = (t) => {
  t.component("PSelectOptionGroup", C3);
}, Uj = /* @__PURE__ */ W({
  __name: "PStepper",
  props: {
    modelValue: {},
    disabled: { type: Boolean },
    min: { default: null },
    max: { default: null },
    step: { default: 1 }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: n }) {
    const a = t, i = n, s = M({
      get() {
        return a.modelValue ?? a.min ?? 0;
      },
      set(h) {
        i("update:modelValue", h);
      }
    }), u = M(() => g(s.value - a.step)), p = M(() => E(s.value + a.step));
    function g(h) {
      return typeof a.min != "number" || h >= a.min;
    }
    function E(h) {
      return typeof a.max != "number" || h <= a.max;
    }
    return (h, f) => {
      const b = ht("p-number-input");
      return c(), G(b, {
        modelValue: s.value,
        "onUpdate:modelValue": f[2] || (f[2] = (w) => s.value = w),
        class: "p-stepper",
        disabled: h.disabled
      }, {
        prepend: N(() => [
          ne(rn, {
            class: "p-stepper__step p-stepper__step--down",
            flat: "",
            small: "",
            icon: "MinusIcon",
            disabled: h.disabled || !u.value,
            onClick: f[0] || (f[0] = (w) => s.value -= h.step)
          }, null, 8, ["disabled"])
        ]),
        append: N(() => [
          ne(rn, {
            class: "p-stepper__step p-stepper__step--up",
            flat: "",
            small: "",
            icon: "PlusIcon",
            disabled: h.disabled || !p.value,
            onClick: f[1] || (f[1] = (w) => s.value += h.step)
          }, null, 8, ["disabled"])
        ]),
        _: 1
      }, 8, ["modelValue", "disabled"]);
    };
  }
}), $j = (t) => {
  t.component("PStepper", Uj);
}, Y3 = /* @__PURE__ */ W({
  __name: "PTab",
  props: {
    active: { type: Boolean },
    disabled: { type: Boolean }
  },
  setup(t) {
    const n = t, a = M(() => ({
      "p-tab__active": n.active,
      "p-tab__disabled": n.disabled
    }));
    return (i, s) => (c(), _("li", {
      class: Oe(["p-tab", a.value]),
      tabindex: "0"
    }, [
      I(i.$slots, "default")
    ], 2));
  }
}), Vj = (t) => {
  t.component("PTab", Y3);
}, Hj = {}, Gj = { class: "p-table-data" };
function Yj(t, n) {
  return c(), _("td", Gj, [
    I(t.$slots, "default")
  ]);
}
const g0 = /* @__PURE__ */ Wt(Hj, [["render", Yj]]), zj = {}, Zj = { class: "p-table-row" };
function qj(t, n) {
  return c(), _("tr", Zj, [
    I(t.$slots, "default")
  ]);
}
const kl = /* @__PURE__ */ Wt(zj, [["render", qj]]), Wj = { class: "p-table-body p-background" }, z3 = /* @__PURE__ */ W({
  __name: "PTableBody",
  props: {
    data: { default: () => [] },
    columns: { default: () => [] }
  },
  setup(t) {
    function n(a, i) {
      return i.property ? a[i.property] : "";
    }
    return (a, i) => (c(), _("tbody", Wj, [
      I(a.$slots, "default", {}, () => [
        (c(!0), _(Qe, null, Ye(a.data, (s, u) => (c(), _(Qe, { key: u }, [
          ne(kl, null, {
            default: N(() => [
              I(a.$slots, "row", oe({ ref_for: !0 }, { row: s, index: u }), () => [
                (c(!0), _(Qe, null, Ye(a.columns, (p) => I(a.$slots, y(Qn)(p.label), oe({
                  key: p,
                  value: n(s, p)
                }, { ref_for: !0 }, { column: p, row: s }), () => [
                  ne(g0, null, {
                    default: N(() => [
                      Ne(ye(n(s, p)), 1)
                    ]),
                    _: 2
                  }, 1024)
                ])), 128))
              ])
            ]),
            _: 2
          }, 1024),
          a.$slots["row-after"] ? I(a.$slots, "row-after", oe({
            key: 0,
            ref_for: !0
          }, { row: s, index: u })) : le("", !0)
        ], 64))), 128))
      ])
    ]));
  }
}), jj = {}, Kj = { class: "p-table-foot p-background" };
function Qj(t, n) {
  return c(), _("tfoot", Kj, [
    I(t.$slots, "default")
  ]);
}
const Z3 = /* @__PURE__ */ Wt(jj, [["render", Qj]]), Xj = { class: "p-table-head" }, q3 = /* @__PURE__ */ W({
  __name: "PTableHead",
  setup(t) {
    return (n, a) => (c(), _("thead", Xj, [
      I(n.$slots, "default", {}, () => [
        ne(kl, null, {
          default: N(() => [
            I(n.$slots, "row")
          ]),
          _: 3
        })
      ])
    ]));
  }
}), Jj = {}, eK = { class: "p-table-header" };
function tK(t, n) {
  return c(), _("th", eK, [
    I(t.$slots, "default")
  ]);
}
const uf = /* @__PURE__ */ Wt(Jj, [["render", tK]]), nK = { class: "p-table" }, rK = { class: "p-table__table" }, aK = ["colspan"], W3 = /* @__PURE__ */ W({
  __name: "PTable",
  props: {
    data: {},
    selected: {},
    columns: {},
    rowClasses: { type: Function },
    headerClasses: { type: Function },
    columnClasses: { type: Function },
    rowKey: { type: Function },
    columnKey: { type: Function },
    headerColumnKey: { type: Function }
  },
  emits: ["update:selected", "row:click"],
  setup(t, { emit: n }) {
    const a = t, i = Yr(), s = n, u = M({
      get() {
        return a.selected ?? [];
      },
      set(P) {
        s("update:selected", P);
      }
    }), p = M(() => a.data.filter((P) => !P.disabled)), g = M(() => a.selected !== void 0 && p.value.length > 0), E = M(() => {
      if (a.columns)
        return a.columns;
      if (a.data.length) {
        const P = Object.keys(a.data[0]);
        return b(P);
      }
      return [];
    }), h = M(() => E.value.filter((P) => P.visible ?? !0));
    function f(P) {
      return {
        width: P.width,
        minWidth: P.minWidth ?? P.width ?? 0,
        maxWidth: P.maxWidth ?? P.width
      };
    }
    function b(P) {
      return P.map((k) => ({ label: k, property: k }));
    }
    function w(P, k) {
      if (k)
        return P[k];
    }
    function x(P, k) {
      return [
        ...cl(a.rowClasses?.(P, k)),
        {
          "p-table-row--first": k === 0,
          "p-table-row--even": A2(k),
          "p-table-row--odd": R2(k),
          "p-table-row--last": k === a.data.length - 1
        }
      ];
    }
    function A(P, k) {
      return [
        ...cl(a.headerClasses?.(P, k)),
        {
          "p-table-column-header--first": k === 0,
          "p-table-column-header--even": A2(k),
          "p-table-column-header--odd": R2(k),
          "p-table-column-header--last": k === E.value.length - 1
        }
      ];
    }
    function D(P, k, U, Z, ee) {
      return [
        ...cl(a.columnClasses?.(P, k, U, Z, ee)),
        {
          "p-table-column--first": U === 0,
          "p-table-column--even": A2(U),
          "p-table-column--odd": R2(U),
          "p-table-column--last": U === E.value.length - 1
        }
      ];
    }
    function L(P, k) {
      return a.rowKey ? a.rowKey(P, k) : k;
    }
    function $(P, k) {
      return a.headerColumnKey ? a.headerColumnKey(P, k) : k;
    }
    function q(P, k) {
      return a.columnKey ? a.columnKey(P, k) : k;
    }
    return (P, k) => {
      const U = ht("p-checkbox");
      return c(), _("div", nK, [
        d("table", rK, [
          I(P.$slots, "default", {}, () => [
            ne(q3, null, {
              default: N(() => [
                I(P.$slots, "header", {}, () => [
                  ne(kl, null, {
                    default: N(() => [
                      g.value ? (c(), G(uf, {
                        key: 0,
                        class: "p-table__checkbox-cell"
                      }, {
                        default: N(() => [
                          ne(G3, {
                            modelValue: u.value,
                            "onUpdate:modelValue": k[0] || (k[0] = (Z) => u.value = Z),
                            selectable: p.value
                          }, null, 8, ["modelValue", "selectable"])
                        ]),
                        _: 1
                      })) : le("", !0),
                      (c(!0), _(Qe, null, Ye(h.value, (Z, ee) => (c(), G(uf, {
                        key: $(Z, ee),
                        style: Gr(f(Z)),
                        class: Oe(A(Z, ee)),
                        title: Z.label
                      }, {
                        default: N(() => [
                          I(P.$slots, `${y(Qn)(Z.label)}-heading`, oe({ ref_for: !0 }, { column: Z }), () => [
                            Ne(ye(Z.label), 1)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["style", "class", "title"]))), 128))
                    ]),
                    _: 3
                  })
                ])
              ]),
              _: 3
            }),
            ne(z3, null, {
              default: N(() => [
                (c(!0), _(Qe, null, Ye(P.data, (Z, ee) => (c(), _(Qe, {
                  key: L(Z, ee)
                }, [
                  ne(kl, {
                    class: Oe(x(Z, ee)),
                    onClick: (X) => s("row:click", { row: Z, rowIndex: ee })
                  }, {
                    default: N(() => [
                      g.value ? (c(), G(g0, {
                        key: 0,
                        class: "p-table__checkbox-cell"
                      }, {
                        default: N(() => [
                          ne(U, {
                            modelValue: u.value,
                            "onUpdate:modelValue": k[1] || (k[1] = (X) => u.value = X),
                            value: Z,
                            disabled: Z.disabled
                          }, null, 8, ["modelValue", "value", "disabled"])
                        ]),
                        _: 2
                      }, 1024)) : le("", !0),
                      (c(!0), _(Qe, null, Ye(h.value, (X, re) => (c(), G(g0, {
                        key: q(X, re),
                        class: Oe(D(X, w(Z, X.property), re, Z, ee))
                      }, {
                        default: N(() => [
                          I(P.$slots, y(Qn)(X.label), oe({
                            value: w(Z, X.property)
                          }, { ref_for: !0 }, { column: X, row: Z }), () => [
                            Ne(ye(w(Z, X.property)), 1)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["class"]))), 128))
                    ]),
                    _: 2
                  }, 1032, ["class", "onClick"]),
                  P.$slots["row-after"] ? I(P.$slots, "row-after", oe({
                    key: 0,
                    ref_for: !0
                  }, { row: Z, rowIndex: ee })) : le("", !0)
                ], 64))), 128)),
                y(i)["empty-state"] && P.data.length === 0 ? (c(), G(kl, { key: 0 }, {
                  default: N(() => [
                    d("td", {
                      colspan: h.value.length
                    }, [
                      I(P.$slots, "empty-state")
                    ], 8, aK)
                  ]),
                  _: 3
                })) : le("", !0)
              ]),
              _: 3
            }),
            y(i).footer ? (c(), G(Z3, { key: 0 }, {
              default: N(() => [
                I(P.$slots, "footer")
              ]),
              _: 3
            })) : le("", !0)
          ])
        ])
      ]);
    };
  }
}), oK = (t) => {
  t.component("PTable", W3), t.component("PTableHead", q3), t.component("PTableBody", z3), t.component("PTableHeader", uf), t.component("PTableRow", kl), t.component("PTableData", g0), t.component("PTableFoot", Z3);
}, iK = {
  class: "p-tab-navigation",
  role: "tablist",
  "aria-label": "Tab"
}, j3 = /* @__PURE__ */ W({
  __name: "PTabNavigation",
  props: {
    tabs: {},
    selected: {}
  },
  emits: ["update:selected"],
  setup(t, { emit: n }) {
    const a = t, i = n, s = M(() => a.tabs.map(Xf)), u = M({
      get() {
        if (a.selected)
          return a.selected;
        const [g] = s.value;
        return g.label;
      },
      set(g) {
        i("update:selected", g);
      }
    });
    function p(g) {
      g.disabled || (u.value = g.label);
    }
    return (g, E) => (c(), _("ul", iK, [
      (c(!0), _(Qe, null, Ye(s.value, (h, f) => (c(), G(Y3, {
        key: h.label,
        id: y(Qn)(h.label),
        active: u.value === h.label,
        disabled: h.disabled,
        "area-controls": `${y(Qn)(h.label)}-content`,
        onClick: (b) => u.value = h.label,
        onKeydown: ui(xa((b) => p(h), ["prevent"]), ["enter", "space"])
      }, {
        default: N(() => [
          I(g.$slots, `${y(Qn)(h.label)}-heading`, {
            tab: h,
            index: f
          }, () => [
            I(g.$slots, "heading", {
              tab: h,
              index: f
            }, () => [
              Ne(ye(h.label), 1)
            ])
          ])
        ]),
        _: 2
      }, 1032, ["id", "active", "disabled", "area-controls", "onClick", "onKeydown"]))), 128))
    ]));
  }
}), K3 = /* @__PURE__ */ W({
  __name: "PTabSelect",
  props: {
    tabs: {},
    selected: {}
  },
  emits: ["update:selected"],
  setup(t, { emit: n }) {
    const a = t, i = n, s = ml(), u = M(() => a.tabs.map((h) => Xf(h))), p = M(() => u.value.map((h) => ({
      ...h,
      value: h.label
    }))), g = M({
      get() {
        if (a.selected)
          return a.selected;
        const [h] = p.value;
        return h.label;
      },
      set(h) {
        i("update:selected", h);
      }
    });
    function E(h) {
      const f = u.value.findIndex((w) => w.label === h);
      return {
        tab: u.value[f],
        index: f
      };
    }
    return (h, f) => {
      const b = ht("p-label");
      return c(), _(Qe, null, [
        ne(b, {
          label: "Select a tab",
          for: y(s),
          class: "p-tab-select__label"
        }, null, 8, ["for"]),
        ne(L0, {
          id: y(s),
          modelValue: g.value,
          "onUpdate:modelValue": f[0] || (f[0] = (w) => g.value = w),
          class: "p-tab-select",
          options: p.value,
          name: "tabs"
        }, {
          option: N(({ option: w, index: x }) => [
            I(h.$slots, `${y(Qn)(w.label)}-heading`, {
              tab: w,
              index: x
            }, () => [
              I(h.$slots, "heading", {
                tab: w,
                index: x
              }, () => [
                Ne(ye(w.label), 1)
              ])
            ])
          ]),
          default: N(({ label: w }) => [
            I(h.$slots, `${y(Qn)(w)}-heading`, ve(we(E(w))), () => [
              I(h.$slots, "heading", ve(we(E(w))))
            ])
          ]),
          _: 3
        }, 8, ["id", "modelValue", "options"])
      ], 64);
    };
  }
}), sK = { class: "p-tabs" }, lK = ["id", "aria-labelledby"], cK = /* @__PURE__ */ W({
  __name: "PTabs",
  props: {
    tabs: {},
    selected: {}
  },
  emits: ["update:selected"],
  setup(t, { emit: n }) {
    const a = t, i = n, s = M(() => a.tabs.map(Xf)), u = z(), p = M({
      get() {
        if (a.selected)
          return a.selected;
        if (u.value)
          return u.value;
        const [E] = s.value;
        return E.label;
      },
      set(E) {
        u.value = E, i("update:selected", E);
      }
    });
    function g(E) {
      return `${Qn(E.label)}-heading`;
    }
    return (E, h) => (c(), _("section", sK, [
      y(Dd).sm ? (c(), G(j3, {
        key: 0,
        selected: p.value,
        "onUpdate:selected": h[0] || (h[0] = (f) => p.value = f),
        class: "p-tabs--not-mobile",
        tabs: s.value
      }, mn({
        heading: N((f) => [
          I(E.$slots, "heading", ve(we(f)))
        ]),
        _: 2
      }, [
        Ye(s.value, (f) => ({
          name: g(f),
          fn: N((b) => [
            I(E.$slots, `${y(Qn)(f.label)}-heading`, ve(we(b)))
          ])
        }))
      ]), 1032, ["selected", "tabs"])) : (c(), G(K3, {
        key: 1,
        selected: p.value,
        "onUpdate:selected": h[1] || (h[1] = (f) => p.value = f),
        tabs: s.value
      }, mn({
        heading: N((f) => [
          I(E.$slots, "heading", ve(we(f)))
        ]),
        _: 2
      }, [
        Ye(s.value, (f) => ({
          name: g(f),
          fn: N((b) => [
            I(E.$slots, `${y(Qn)(f.label)}-heading`, ve(we(b)))
          ])
        }))
      ]), 1032, ["selected", "tabs"])),
      (c(!0), _(Qe, null, Ye(s.value, (f, b) => (c(), _(Qe, {
        key: f.label
      }, [
        p.value === f.label ? (c(), _("section", {
          key: 0,
          id: `${y(Qn)(f.label)}-content`,
          class: "p-tabs__content",
          role: "tabpanel",
          "aria-labelledby": `${y(Qn)(f.label)}`
        }, [
          I(E.$slots, `${y(Qn)(f.label)}`, oe({ ref_for: !0 }, { tab: f, index: b }), () => [
            I(E.$slots, "content", oe({ ref_for: !0 }, { tab: f, index: b }))
          ])
        ], 8, lK)) : le("", !0)
      ], 64))), 128))
    ]));
  }
}), uK = /* @__PURE__ */ W({
  __name: "PTabsContent",
  props: {
    value: {},
    forceMount: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  setup(t) {
    const n = t;
    return (a, i) => (c(), G(y(Ww), oe({ class: "p-tabs-content" }, n), {
      default: N(() => [
        I(a.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), dK = /* @__PURE__ */ W({
  __name: "PTabsList",
  props: {
    loop: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  setup(t) {
    const n = t;
    return (a, i) => (c(), G(y(qw), oe(n, { class: "p-tabs-list" }), {
      default: N(() => [
        I(a.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), _K = /* @__PURE__ */ W({
  __name: "PTabsRoot",
  props: {
    defaultValue: {},
    orientation: {},
    dir: {},
    activationMode: {},
    modelValue: {},
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["update:modelValue"],
  setup(t, { emit: n }) {
    const s = Wn(t, n);
    return (u, p) => (c(), G(y(Zw), ve(we(y(s))), {
      default: N(() => [
        I(u.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), pK = /* @__PURE__ */ W({
  __name: "PTabsTrigger",
  props: {
    value: {},
    disabled: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  setup(t) {
    const a = vl(t);
    return (i, s) => (c(), G(y(jw), oe(y(a), { class: "p-tabs-trigger" }), {
      default: N(() => [
        I(i.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), mK = (t) => {
  t.component("PTabs", cK), t.component("PTabNavigation", j3), t.component("PTabSelect", K3), t.component("PTabsRoot", _K), t.component("PTabsContent", uK), t.component("PTabsList", dK), t.component("PTabsTrigger", pK);
}, gK = (t) => {
  t.component("PTag", Yl);
}, fK = { class: "p-tags" }, hK = /* @__PURE__ */ W({
  __name: "PTags",
  props: {
    tags: {},
    dismissible: { type: Boolean },
    small: { type: Boolean }
  },
  setup(t) {
    const n = t, a = M(() => n.tags.map(Jf));
    return (i, s) => (c(), _("div", fK, [
      (c(!0), _(Qe, null, Ye(a.value, (u) => (c(), G(Yl, {
        key: u.label,
        dismissible: i.dismissible,
        small: i.small
      }, {
        default: N(() => [
          I(i.$slots, "default", { tag: u }, () => [
            Ne(ye(u.label), 1)
          ])
        ]),
        _: 2
      }, 1032, ["dismissible", "small"]))), 128))
    ]));
  }
}), vK = (t) => {
  t.component("PTags", hK);
}, EK = { class: "p-tags-area" }, bK = { class: "p-tags-area__tags" }, SK = ["disabled", "onClick"], wK = /* @__PURE__ */ W({
  inheritAttrs: !1,
  __name: "PTagsArea",
  props: {
    modelValue: {},
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: n }) {
    const a = t, i = n, s = M({
      get() {
        return a.modelValue ?? [];
      },
      set(w) {
        i("update:modelValue", w);
      }
    }), u = z(null);
    function p(w) {
      const x = s.value.filter((A) => A !== w);
      s.value = x;
    }
    function g(w) {
      u.value = w, p(w);
    }
    function E(w) {
      w.key === Ie.enter && b() && w.preventDefault();
    }
    function h() {
      b();
    }
    function f(w) {
      return !!u.value?.length && !s.value.includes(u.value);
    }
    function b() {
      return f(u.value) ? (s.value = [...s.value, u.value], u.value = null, !0) : !1;
    }
    return (w, x) => (c(), _("div", EK, [
      I(w.$slots, "default", {
        tags: s.value,
        removeTag: p
      }, () => [
        d("div", bK, [
          (c(!0), _(Qe, null, Ye(s.value, (A) => (c(), _("button", {
            key: A,
            type: "button",
            class: "p-tags-area__tag",
            disabled: w.disabled,
            onClick: (D) => g(A)
          }, [
            I(w.$slots, "tag", {
              tag: A,
              removeTag: p
            }, () => [
              ne(Yl, {
                dismissible: !w.disabled,
                onDismiss: (D) => p(A)
              }, {
                default: N(() => [
                  Ne(ye(A), 1)
                ]),
                _: 2
              }, 1032, ["dismissible", "onDismiss"])
            ])
          ], 8, SK))), 128))
        ])
      ]),
      ne(mo, ve(we(w.$attrs)), mn({
        control: N(({ attrs: A }) => [
          ur(d("input", oe({
            "onUpdate:modelValue": x[0] || (x[0] = (D) => u.value = D),
            type: "text",
            class: "p-tags-area__input"
          }, { ...A, disabled: w.disabled }, {
            onKeydown: E,
            onBlur: h
          }), null, 16), [
            [fl, u.value]
          ])
        ]),
        _: 2
      }, [
        Ye(w.$slots, (A, D) => ({
          name: D,
          fn: N((L) => [
            I(w.$slots, D, ve(we(L)))
          ])
        }))
      ]), 1040)
    ]));
  }
}), yK = (t) => {
  t.component("PTagsArea", wK);
}, TK = { class: "p-tags-input__tag" }, CK = /* @__PURE__ */ W({
  __name: "PTagsInput",
  props: {
    modelValue: {},
    placeholder: { default: "Add tag" },
    optionsClass: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: n }) {
    const a = t, i = n, s = M({
      get() {
        return a.modelValue ?? [];
      },
      set(u) {
        i("update:modelValue", u);
      }
    });
    return (u, p) => (c(), G(p3, {
      modelValue: s.value,
      "onUpdate:modelValue": p[0] || (p[0] = (g) => s.value = g),
      class: "p-tags-input",
      "allow-unknown-value": "",
      options: [],
      placeholder: u.placeholder,
      "options-class": u.optionsClass
    }, mn({
      default: N(({ value: g }) => [
        Ne(ye(g), 1)
      ]),
      option: N(({ option: g }) => [
        I(u.$slots, "tag", {
          tag: g.value
        }, () => [
          d("span", TK, ye(g.label), 1)
        ])
      ]),
      "options-empty": N(() => [
        p[1] || (p[1] = d("span", null, null, -1))
      ]),
      _: 2
    }, [
      Ye(u.$slots, (g, E) => ({
        name: E,
        fn: N((h) => [
          I(u.$slots, E, ve(we(h)))
        ])
      }))
    ]), 1032, ["modelValue", "placeholder", "options-class"]));
  }
}), xK = (t) => {
  t.component("PTagsInput", CK);
}, AK = (t) => {
  t.component("PTagWrapper", x3);
}, RK = { class: "p-window p-background" }, OK = { class: "p-window__top-bar" }, IK = { class: "p-window__title" }, NK = { class: "p-window__actions" }, MK = { class: "p-window__body" }, Q3 = /* @__PURE__ */ W({
  __name: "PWindow",
  props: {
    title: {}
  },
  setup(t) {
    return (n, a) => (c(), _("div", RK, [
      d("div", OK, [
        a[0] || (a[0] = d("div", { class: "p-window__buttons" }, [
          d("div", { class: "p-window__button" }),
          d("div", { class: "p-window__button" }),
          d("div", { class: "p-window__button" })
        ], -1)),
        d("div", IK, [
          I(n.$slots, "title", {}, () => [
            Ne(ye(n.title), 1)
          ])
        ]),
        d("div", NK, [
          I(n.$slots, "actions")
        ])
      ]),
      d("div", MK, [
        I(n.$slots, "default")
      ])
    ]));
  }
}), DK = { class: "p-toast__card-container" }, kK = { class: "p-toast__info" }, LK = { class: "p-toast__message" }, PK = {
  key: 0,
  class: "p-toast__close"
}, BK = {
  key: 0,
  class: "p-toast__svg",
  viewBox: "0 0 100 100"
}, X3 = /* @__PURE__ */ W({
  __name: "PToast",
  props: {
    message: {},
    dismissible: { type: Boolean },
    timeout: { type: [Number, Boolean] },
    type: {},
    icon: {}
  },
  emits: ["close"],
  setup(t, { emit: n }) {
    hE((A) => ({
      "39877c2c": i.value,
      dfeff552: s.value,
      "61216a5a": u.value
    }));
    const a = z(), i = z(t.timeout === !1 ? "0" : "8px"), s = z(t.timeout ? `${t.timeout / 1e3}s` : "5s"), u = z("running"), p = {
      default: "Info",
      success: "CheckCircleIcon",
      error: "ExclamationTriangleIcon"
    }, g = M(() => t.icon ?? p[t.type]), E = [
      { className: "p-toast__icon--success", name: "success" },
      { className: "p-toast__icon--error", name: "error" }
    ], h = M(() => E.find((A) => A.name == t.type)?.className), f = n, b = () => {
      f("close");
    }, w = () => {
      u.value = "paused", clearTimeout(a.value);
    }, x = () => {
      t.timeout && (u.value = "running", a.value = setTimeout(b, t.timeout));
    };
    return xt(() => {
      x();
    }), (A, D) => (c(), _("div", {
      class: "p-toast__card",
      onMouseenter: w,
      onMouseleave: x,
      onFocusinCapture: w,
      onFocusoutCapture: x
    }, [
      d("div", DK, [
        d("div", kK, [
          ne(Dn, {
            icon: g.value,
            "aria-hidden": "true",
            class: Oe(["p-toast__icon", h.value]),
            solid: ""
          }, null, 8, ["icon", "class"]),
          d("p", LK, [
            I(A.$slots, "default", {}, () => [
              Ne(ye(A.message), 1)
            ])
          ])
        ]),
        A.dismissible || A.timeout === !1 ? (c(), _("div", PK, [
          ne(rn, {
            class: "p-toast__close-btn",
            icon: "Close",
            variant: "ghost",
            size: "sm",
            onClick: b
          }, {
            default: N(() => [
              D[1] || (D[1] = d("span", { class: "sr-only" }, "Close", -1)),
              A.dismissible ? (c(), _("svg", BK, [...D[0] || (D[0] = [
                d("circle", {
                  cx: "50",
                  cy: "50",
                  r: "45",
                  class: "p-toast__svg-circle"
                }, null, -1)
              ])])) : le("", !0)
            ]),
            _: 1
          })
        ])) : le("", !0)
      ])
    ], 32));
  }
}), FK = {
  "aria-live": "assertive",
  class: "p-toast-container"
}, UK = /* @__PURE__ */ W({
  __name: "ToastContainer",
  setup(t) {
    function n(a) {
      return typeof a == "string";
    }
    return (a, i) => (c(), _("div", FK, [
      ne(mv, { name: "toast" }, {
        default: N(() => [
          (c(!0), _(Qe, null, Ye(y(f0), ({ id: s, message: u, dismissible: p, timeout: g, type: E, dismiss: h }) => (c(), _("div", {
            key: s,
            class: "p-toast-container__toast"
          }, [
            ne(X3, oe({ ref_for: !0 }, { dismissible: p, timeout: g, type: E }, { onClose: h }), {
              default: N(() => [
                n(u) ? (c(), G(y(L3), {
                  key: 0,
                  text: u
                }, null, 8, ["text"])) : (c(), G(Hr(u), { key: 1 }))
              ]),
              _: 2
            }, 1040, ["onClose"])
          ]))), 128))
        ]),
        _: 1
      })
    ]));
  }
});
let $K = 0;
const f0 = Mr([]);
function VK() {
  return $K++;
}
function HK(t) {
  const n = f0.findIndex((a) => a.id === t);
  n > -1 && f0.splice(n, 1);
}
function GK() {
  const t = document.createElement("div");
  return t.id = "prefect-design-toast-app", document.body.appendChild(t), t;
}
function YK(t) {
  const n = document.querySelector(t);
  if (!n)
    throw new Error(
      "Toast plugin wasn't provided a valid mount point. Make sure the mount point exists in the DOM or pass nothing to create one automatically."
    );
  return n;
}
function zK(t) {
  return t ? typeof t == "string" ? YK(t) : t : GK();
}
function J3(t, n = "default", a) {
  const i = VK(), s = {
    dismissible: !0,
    timeout: 5e3,
    icon: "Info"
  }, u = typeof t == "string" ? t : cv(t), p = {
    ...s,
    id: i,
    message: u,
    type: n,
    dismiss: () => HK(i),
    ...a
  };
  return f0.unshift(p), p;
}
const ZK = {
  install: (t, n = {}) => {
    const a = zK(n.mountPoint);
    vE(UK).mount(a), t.config.globalProperties.$toast = J3;
  }
}, qK = [ZK.install, IW.install], WK = { class: "p-terminal__code" }, jK = /* @__PURE__ */ W({
  __name: "PTerminal",
  props: {
    command: {}
  },
  setup(t) {
    const n = t, a = M(() => cl(n.command));
    async function i() {
      const s = a.value.join(" && ");
      await navigator.clipboard.writeText(s), J3("Copied!", "success");
    }
    return (s, u) => (c(), G(Q3, { class: "p-terminal" }, {
      actions: N(() => [
        ne(rn, {
          small: "",
          flat: "",
          class: "p-terminal__copy-button",
          icon: "ClipboardDocumentIcon",
          onClick: i
        })
      ]),
      default: N(() => [
        d("div", WK, [
          (c(!0), _(Qe, null, Ye(a.value, (p, g) => (c(), _("p", {
            key: g,
            class: "p-terminal__code-line"
          }, [
            Ne(ye(p) + " ", 1),
            u[0] || (u[0] = d("span", { class: "p-terminal__cursor" }, null, -1))
          ]))), 128))
        ])
      ]),
      _: 1
    }));
  }
}), KK = (t) => {
  t.component("PTerminal", jK);
}, QK = /* @__PURE__ */ W({
  __name: "PTextarea",
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(t, { expose: n, emit: a }) {
    const i = t, s = a, u = z();
    n({ el: u });
    const p = M({
      get() {
        return i.modelValue ?? "";
      },
      set(g) {
        s("update:modelValue", g);
      }
    });
    return (g, E) => (c(), G(mo, { class: "p-textarea" }, mn({
      control: N(({ attrs: h }) => [
        ur(d("textarea", oe({
          ref_key: "el",
          ref: u,
          "onUpdate:modelValue": E[0] || (E[0] = (f) => p.value = f),
          class: "p-textarea__control"
        }, h), null, 16), [
          [fl, p.value]
        ])
      ]),
      _: 2
    }, [
      Ye(g.$slots, (h, f) => ({
        name: f,
        fn: N((b) => [
          I(g.$slots, f, ve(we(b)))
        ])
      }))
    ]), 1024));
  }
}), XK = (t) => {
  t.component("PTextarea", QK);
}, JK = (t) => {
  t.component("PTextInput", P0);
}, eQ = { class: "p-text-truncate" }, tQ = /* @__PURE__ */ W({
  __name: "PTextTruncate",
  props: {
    text: { default: "" },
    characterCount: { default: 70 },
    actionText: { default: "See More" },
    collapseText: { default: "See Less" }
  },
  setup(t) {
    const n = t, a = z(!1), i = M(() => a.value || s.value ? n.text : `${n.text.substring(0, n.characterCount).trim()}...`), s = M(() => n.text.length <= n.characterCount);
    return (u, p) => (c(), _("span", eQ, [
      Ne(ye(i.value) + " ", 1),
      s.value ? le("", !0) : (c(), _("span", {
        key: 0,
        class: "p-text-truncate--action-text",
        onClick: p[0] || (p[0] = (g) => a.value = !a.value)
      }, ye(a.value ? u.collapseText : u.actionText), 1))
    ]));
  }
}), nQ = (t) => {
  t.component("PTextTruncate", tQ);
}, rQ = /* @__PURE__ */ W({
  __name: "PThemeToggle",
  setup(t) {
    const { value: n, setTheme: a } = Y7(), i = M({
      get() {
        return n.value === "dark";
      },
      set(s) {
        a(s ? "dark" : "light");
      }
    });
    return (s, u) => {
      const p = ht("p-icon"), g = ht("p-toggle");
      return c(), G(g, {
        modelValue: i.value,
        "onUpdate:modelValue": u[0] || (u[0] = (E) => i.value = E),
        class: "p-theme-toggle",
        "neutral-states": ""
      }, {
        prepend: N(() => [
          ne(p, { icon: "SunIcon" })
        ]),
        append: N(() => [
          ne(p, { icon: "MoonIcon" })
        ]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
}), aQ = (t) => {
  t.component("PThemeToggle", rQ);
}, eE = /* @__PURE__ */ W({
  __name: "PTimelineItem",
  props: {
    layout: {}
  },
  setup(t) {
    const n = Yr(), a = t, { layout: i } = Nr(a), s = M(() => ({
      root: `p-timeline-item--${i.value}`,
      point: `p-timeline-item__point--${i.value}`,
      date: `p-timeline-item__date--${i.value}`,
      content: `p-timeline-item__content--${i.value}`
    }));
    return (u, p) => {
      const g = ht("PTimelinePoint");
      return c(), _("li", {
        class: Oe(["p-timeline-item", s.value.root])
      }, [
        y(n).date ? (c(), _("div", {
          key: 0,
          class: Oe(["p-timeline-item__date", s.value.date])
        }, [
          I(u.$slots, "date")
        ], 2)) : le("", !0),
        d("div", {
          class: Oe(["p-timeline-item__point", s.value.point])
        }, [
          I(u.$slots, "point", {}, () => [
            ne(g)
          ])
        ], 2),
        y(n).content ? (c(), _("div", {
          key: 1,
          class: Oe(["p-timeline-item__content", s.value.content])
        }, [
          I(u.$slots, "content")
        ], 2)) : le("", !0)
      ], 2);
    };
  }
}), oQ = {}, iQ = { class: "p-timeline-point p-background" };
function sQ(t, n) {
  return c(), _("div", iQ, [
    I(t.$slots, "default")
  ]);
}
const tE = /* @__PURE__ */ Wt(oQ, [["render", sQ]]), lQ = /* @__PURE__ */ W({
  __name: "PTimeline",
  props: {
    items: {},
    itemKey: {},
    layout: { type: Function }
  },
  setup(t) {
    const n = t, a = M(() => n.layout ?? "date-left");
    function i(f, b) {
      return n.itemKey ? Qn(`${f[n.itemKey]}`) : b;
    }
    function s(f, b) {
      return `item-${i(f, b)}`;
    }
    function u(f, b) {
      return `${s(f, b)}-point`;
    }
    function p(f, b) {
      return `${s(f, b)}-point-content`;
    }
    function g(f, b) {
      return `${s(f, b)}-date`;
    }
    function E(f, b) {
      return `${s(f, b)}-content`;
    }
    function h(f, b) {
      return typeof a.value == "function" ? a.value(f, b) : a.value;
    }
    return (f, b) => {
      const w = ht("p-icon");
      return c(), G(ah, {
        items: f.items,
        "item-key": f.itemKey,
        class: "p-timeline",
        element: "ol"
      }, {
        default: N(({ item: x, index: A }) => [
          I(f.$slots, "default", ve(we({ item: x, index: A })), () => [
            I(f.$slots, s(x, A), ve(we({ item: x, index: A })), () => [
              ne(eE, {
                layout: h(x, A)
              }, {
                date: N(() => [
                  I(f.$slots, "date", ve(we({ item: x, index: A })), () => [
                    I(f.$slots, g(x, A), ve(we({ item: x, index: A })))
                  ])
                ]),
                point: N(() => [
                  I(f.$slots, "point", ve(we({ item: x, index: A })), () => [
                    I(f.$slots, u(x, A), ve(we({ item: x, index: A })), () => [
                      ne(tE, null, {
                        default: N(() => [
                          I(f.$slots, p(x, A), ve(we({ item: x, index: A })), () => [
                            I(f.$slots, "point-content", ve(we({ item: x, index: A })), () => [
                              x.icon ? (c(), G(w, {
                                key: 0,
                                icon: x.icon,
                                solid: ""
                              }, null, 8, ["icon"])) : le("", !0)
                            ])
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ])
                ]),
                content: N(() => [
                  I(f.$slots, "content", ve(we({ item: x, index: A })), () => [
                    I(f.$slots, E(x, A), ve(we({ item: x, index: A })))
                  ])
                ]),
                _: 2
              }, 1032, ["layout"])
            ])
          ])
        ]),
        _: 3
      }, 8, ["items", "item-key"]);
    };
  }
}), cQ = (t) => {
  t.component("PTimeline", lQ), t.component("PTimelineItem", eE), t.component("PTimelinePoint", tE);
}, uQ = (t) => {
  t.component("PToast", X3);
}, dQ = ["disabled"], _Q = ["aria-checked"], pQ = {
  class: "p-toggle__slider",
  "aria-hidden": "true"
}, mQ = ["disabled"], gQ = /* @__PURE__ */ W({
  __name: "PToggle",
  props: {
    modelValue: { type: [Boolean, null] },
    neutralStates: { type: Boolean },
    disabled: { type: Boolean },
    state: {},
    prepend: {},
    append: {}
  },
  emits: ["update:modelValue"],
  setup(t, { emit: n }) {
    const a = t, i = n, s = Yr(), u = M({
      get() {
        return a.modelValue ?? !1;
      },
      set(b) {
        a.disabled || i("update:modelValue", b);
      }
    }), p = M(() => a.state?.valid === !1 && a.state.validated && !a.state.pending), g = M(() => ({
      control: {
        "p-toggle__control--checked": u.value,
        "p-toggle__control--disabled": a.disabled,
        "p-toggle__control--failed": p.value,
        "p-toggle__control--pending": a.state?.pending,
        "p-toggle__control--neutral-states": a.neutralStates
      }
    }));
    function E() {
      u.value = !u.value;
    }
    function h() {
      a.append || s.append ? u.value = !1 : E();
    }
    function f() {
      a.prepend || s.prepend ? u.value = !0 : E();
    }
    return (b, w) => (c(), _("fieldset", {
      class: "p-toggle",
      disabled: b.disabled
    }, [
      b.prepend || y(s).prepend ? (c(), _("button", {
        key: 0,
        type: "button",
        class: "p-toggle__prepend",
        onClick: h
      }, [
        I(b.$slots, "prepend", {}, () => [
          Ne(ye(b.prepend), 1)
        ])
      ])) : le("", !0),
      d("label", {
        class: Oe(["p-toggle__control", g.value.control]),
        tabindex: "0",
        role: "switch",
        "aria-checked": u.value,
        onKeypress: ui(E, ["space"])
      }, [
        ur(d("input", {
          "onUpdate:modelValue": w[0] || (w[0] = (x) => u.value = x),
          type: "checkbox"
        }, null, 512), [
          [Ll, !1],
          [gv, u.value]
        ]),
        d("div", pQ, [
          b.state?.pending ? (c(), G(y(kd), { key: 0 })) : le("", !0)
        ])
      ], 42, _Q),
      b.append || y(s).append ? (c(), _("button", {
        key: 1,
        type: "button",
        class: "p-toggle__append",
        disabled: b.disabled,
        onClick: f
      }, [
        I(b.$slots, "append", {}, () => [
          Ne(ye(b.append), 1)
        ])
      ], 8, mQ)) : le("", !0)
    ], 8, dQ));
  }
}), fQ = (t) => {
  t.component("PToggle", gQ);
}, hQ = /* @__PURE__ */ W({
  inheritAttrs: !1,
  __name: "PTypeAhead",
  props: {
    modelValue: {},
    disabled: { type: Boolean },
    openOnFocus: { type: Boolean },
    options: {}
  },
  emits: ["update:modelValue", "selected", "open", "close"],
  setup(t, { emit: n }) {
    const a = t, i = n, s = z(), u = M(() => s.value?.wrapper), { width: p } = tc(u), { classes: g, styles: E, attrs: h } = Xa(), f = z(), b = M({
      get() {
        return a.modelValue ?? null;
      },
      set(Z) {
        i("update:modelValue", Z);
      }
    }), w = M(() => f.value?.visible ?? !1), x = M(() => a.options.map((Z) => Ei(Z))), A = M(() => x.value.filter((Z) => a3(Z, b.value))), D = M(() => ({
      option: {
        minWidth: `${p.value}px`
      }
    }));
    function L() {
      !w.value && !a.disabled && f.value.open();
    }
    function $() {
      w.value && f.value.close();
    }
    function q() {
      a.openOnFocus && L();
    }
    function P(Z) {
      Array.isArray(Z) || (i("selected", Z?.toString() ?? null), $());
    }
    function k(Z) {
      Z ? i("open") : (i("close"), s.value?.el.focus());
    }
    function U(Z) {
      if (Qf(Z.key)) {
        L();
        return;
      }
      switch (Z.key) {
        case Ie.escape:
        case Ie.tab:
          $();
          break;
        case Ie.upArrow:
        case Ie.downArrow:
        case Ie.space:
          w.value || (L(), Z.preventDefault());
          break;
      }
    }
    return (Z, ee) => (c(), G(Sl, {
      ref_key: "popOver",
      ref: f,
      placement: [y(Fi), y(Bi), y(Pi), y(Li)],
      class: Oe(["p-type-ahead", y(g)]),
      styles: y(E),
      "auto-close": "",
      onOpen: k,
      onKeydown: U
    }, {
      target: N(() => [
        ne(P0, oe({
          ref_key: "inputElement",
          ref: s,
          modelValue: b.value,
          "onUpdate:modelValue": ee[0] || (ee[0] = (X) => b.value = X),
          disabled: Z.disabled
        }, y(h), { onClick: q }), mn({ _: 2 }, [
          Ye(Z.$slots, (X, re) => ({
            name: re,
            fn: N((Q) => [
              I(Z.$slots, re, ve(we({ ...Q, isOpen: w.value, open: L, close: $ })))
            ])
          }))
        ]), 1040, ["modelValue", "disabled"])
      ]),
      default: N(() => [
        ne(k0, {
          modelValue: b.value,
          "onUpdate:modelValue": [
            ee[1] || (ee[1] = (X) => b.value = X),
            P
          ],
          class: "p-type-ahead__options",
          options: A.value,
          style: Gr(D.value.option),
          onKeydown: U
        }, mn({ _: 2 }, [
          Ye(Z.$slots, (X, re) => ({
            name: re,
            fn: N((Q) => [
              I(Z.$slots, re, ve(we({ ...Q, close: $ })))
            ])
          }))
        ]), 1032, ["modelValue", "options", "style"])
      ]),
      _: 3
    }, 8, ["placement", "class", "styles"]));
  }
}), vQ = (t) => {
  t.component("PTypeAhead", hQ);
}, EQ = (t) => {
  t.component("PVirtualScroller", ah);
}, bQ = (t) => {
  t.component("PWindow", Q3);
}, SQ = { class: "p-wizard-step-header__index" }, wQ = { class: "p-wizard-step-header__title" }, nE = /* @__PURE__ */ W({
  __name: "PWizardStepHeader",
  props: {
    step: {},
    index: {},
    current: { type: Boolean },
    loading: { type: Boolean },
    complete: { type: Boolean }
  },
  setup(t) {
    const n = t, a = M(() => ({
      "p-wizard-step-header--current": n.current,
      "p-wizard-step-header--loading": n.loading,
      "p-wizard-step-header--complete": n.complete
    })), i = M(() => String(n.index + 1).padStart(2, "0"));
    return (s, u) => (c(), _("button", {
      class: Oe(["p-wizard-step-header", a.value]),
      type: "button"
    }, [
      d("div", SQ, [
        s.complete ? (c(), G(Dn, {
          key: 0,
          icon: "CheckIcon"
        })) : s.loading ? (c(), G(kd, { key: 1 })) : (c(), _(Qe, { key: 2 }, [
          Ne(ye(i.value), 1)
        ], 64))
      ]),
      d("div", wQ, [
        I(s.$slots, "default", {
          title: s.step.title
        }, () => [
          Ne(ye(s.step.title), 1)
        ])
      ])
    ], 2));
  }
}), rE = /* @__PURE__ */ W({
  __name: "PWizardHeaders",
  props: {
    steps: {},
    currentStepIndex: {},
    loading: { type: Boolean },
    nonlinear: { type: Boolean }
  },
  setup(t) {
    const n = t, a = z(), i = z([]), s = XC(i, a), u = j7(), p = (h) => !n.nonlinear && h > u.furthestStepIndex.value;
    function g(h) {
      n.loading || p(h) || u.goto(h + 1);
    }
    const E = M(() => ({
      container: {
        "p-wizard-headers--wrapped": s.value
      },
      stepHeader: (h) => ({
        "p-wizard-headers__step-header--loading": n.loading,
        "p-wizard-headers__step-header--interactive": !n.loading && !p(h) && h !== n.currentStepIndex
      })
    }));
    return (h, f) => (c(), _("div", {
      ref_key: "container",
      ref: a,
      class: Oe(["p-wizard-headers", E.value.container])
    }, [
      (c(!0), _(Qe, null, Ye(h.steps, (b, w) => (c(), _("span", {
        key: w,
        ref_for: !0,
        ref_key: "children",
        ref: i,
        class: "p-wizard-headers__heading"
      }, [
        ne(nE, {
          step: b,
          index: w,
          current: w === h.currentStepIndex,
          loading: h.loading && w === h.currentStepIndex,
          complete: w < y(u).furthestStepIndex.value,
          class: Oe(["p-wizard-headers__step-header", E.value.stepHeader(w)]),
          disabled: p(w),
          onClick: (x) => g(w)
        }, {
          default: N((x) => [
            I(h.$slots, `${y(I0)(b)}-heading`, oe({ ref_for: !0 }, x))
          ]),
          _: 2
        }, 1032, ["step", "index", "current", "loading", "complete", "disabled", "class", "onClick"])
      ], 512))), 128))
    ], 2));
  }
}), aE = /* @__PURE__ */ W({
  __name: "PWizardStep",
  props: {
    step: {}
  },
  setup(t) {
    const n = t, a = M(() => I0(n.step)), i = f6(a);
    return pn(() => {
      Zl(K7, i);
    }), (s, u) => I(s.$slots, "default");
  }
}), yQ = { class: "p-wizard" }, TQ = { class: "p-wizard__actions" }, CQ = /* @__PURE__ */ W({
  __name: "PWizard",
  props: {
    steps: {},
    showCancel: { type: Boolean },
    lastStepText: { default: "Submit" },
    nonlinear: { type: Boolean },
    showSaveAndExit: { type: Boolean }
  },
  emits: ["cancel", "next", "previous", "submit", "step"],
  setup(t, { expose: n, emit: a }) {
    const i = t, s = a, {
      steps: u,
      currentStepIndex: p,
      currentStep: g,
      loading: E,
      next: h,
      previous: f,
      goto: b,
      getStepIndex: w,
      getStep: x,
      setStep: A,
      isValid: D
    } = g6(i.steps);
    n({
      steps: u,
      currentStepIndex: p,
      currentStep: g,
      loading: E,
      next: h,
      previous: f,
      goto: b,
      getStepIndex: w,
      getStep: x,
      setStep: A,
      isValid: D,
      setLoading: ee
    });
    const L = M(() => p.value === 0), $ = M(() => p.value === u.value.length - 1), q = M(() => $.value ? i.lastStepText : "Next"), P = M(() => i.showSaveAndExit && !$.value);
    async function k() {
      const { success: X } = await f();
      X && (s("step", g.value), s("previous"));
    }
    async function U() {
      const X = $.value, { success: re } = await h();
      re && (s("step", g.value), s("next"), X && (s("step", g.value), s("submit")));
    }
    async function Z() {
      const { success: X } = await h();
      X && (s("next"), s("submit"));
    }
    function ee(X) {
      E.value = X;
    }
    return (X, re) => (c(), _("div", yQ, [
      ne(tf, { class: "p-wizard__header" }, {
        default: N(() => [
          ne(rE, {
            steps: y(u),
            loading: y(E),
            "current-step-index": y(p),
            nonlinear: X.nonlinear
          }, null, 8, ["steps", "loading", "current-step-index", "nonlinear"])
        ]),
        _: 1
      }),
      ne(tf, null, {
        default: N(() => [
          I(X.$slots, "before-steps"),
          (c(!0), _(Qe, null, Ye(y(u), (Q, ce) => ur((c(), _("div", {
            key: ce,
            class: "p-wizard__step"
          }, [
            ne(aE, { step: Q }, {
              default: N(() => [
                I(X.$slots, y(I0)(Q))
              ]),
              _: 2
            }, 1032, ["step"])
          ], 512)), [
            [Ll, ce === y(p)]
          ])), 128)),
          I(X.$slots, "after-steps"),
          d("div", TQ, [
            I(X.$slots, "actions", {
              nextButtonText: q.value,
              handleNextButtonClick: U
            }, () => [
              X.showCancel ? (c(), G(rn, {
                key: 0,
                onClick: re[0] || (re[0] = (Q) => s("cancel"))
              }, {
                default: N(() => [...re[1] || (re[1] = [
                  Ne(" Cancel ", -1)
                ])]),
                _: 1
              })) : le("", !0),
              ne(rn, {
                disabled: L.value,
                onClick: k
              }, {
                default: N(() => [...re[2] || (re[2] = [
                  Ne(" Previous ", -1)
                ])]),
                _: 1
              }, 8, ["disabled"]),
              ne(rn, {
                primary: !P.value,
                loading: y(E),
                onClick: U
              }, {
                default: N(() => [
                  Ne(ye(q.value), 1)
                ]),
                _: 1
              }, 8, ["primary", "loading"]),
              P.value ? (c(), _(Qe, { key: 1 }, [
                re[4] || (re[4] = d("span", { class: "border-l border-divider mx-2" }, null, -1)),
                ne(rn, {
                  primary: "",
                  onClick: Z
                }, {
                  default: N(() => [...re[3] || (re[3] = [
                    Ne(" Save & Exit ", -1)
                  ])]),
                  _: 1
                })
              ], 64)) : le("", !0)
            ])
          ]),
          I(X.$slots, "footer")
        ]),
        _: 3
      })
    ]));
  }
}), xQ = (t) => {
  t.component("PWizard", CQ), t.component("PWizardHeaders", rE), t.component("PWizardStep", aE), t.component("PWizardStepHeader", nE);
}, AQ = [
  S6,
  y6,
  kV,
  BV,
  $V,
  aH,
  yH,
  zH,
  jH,
  XH,
  tG,
  aG,
  lG,
  dG,
  mG,
  CG,
  xG,
  AG,
  RG,
  OG,
  IG,
  NG,
  MG,
  DG,
  kG,
  UG,
  YG,
  jG,
  QG,
  oY,
  hY,
  vY,
  SY,
  wY,
  oz,
  Ez,
  Tz,
  Oz,
  gZ,
  wZ,
  SZ,
  RZ,
  FZ,
  $Z,
  YZ,
  qZ,
  jZ,
  nq,
  rq,
  aq,
  oq,
  sq,
  dq,
  pq,
  mq,
  fq,
  vq,
  yq,
  Aq,
  Mq,
  kq,
  OV,
  yW,
  AW,
  BW,
  FW,
  UW,
  $W,
  HW,
  GW,
  YW,
  qW,
  rj,
  aj,
  sj,
  cj,
  kj,
  Lj,
  Pj,
  Bj,
  Fj,
  $j,
  Vj,
  oK,
  mK,
  gK,
  vK,
  yK,
  xK,
  AK,
  KK,
  XK,
  JK,
  nQ,
  aQ,
  cQ,
  uQ,
  fQ,
  oH,
  vQ,
  Mj,
  EQ,
  bQ,
  xQ
], JQ = {
  install(t) {
    AQ.forEach((n) => n(t)), pZ.forEach((n) => n(t)), qK.forEach((n) => n(t));
  }
};
export {
  QV as LayoutResizablePlacements,
  b6 as PAccordion,
  Q7 as PAutoHeightTransition,
  mo as PBaseInput,
  PV as PBreadCrumbs,
  rn as PButton,
  rH as PButtonGroup,
  c3 as PCalendar,
  tf as PCard,
  u3 as PCascadePanel,
  WH as PCascadePanels,
  Ld as PCheckbox,
  eG as PCheckboxGroup,
  Pd as PCode,
  eh as PCodeHighlight,
  uG as PCodeInput,
  p3 as PCombobox,
  hG as PCommand,
  m3 as PCommandBase,
  g3 as PCommandEmpty,
  vG as PCommandGroup,
  f3 as PCommandInput,
  EG as PCommandItem,
  h3 as PCommandList,
  bG as PCommandSeparator,
  TG as PCommandShortcut,
  p0 as PContent,
  FG as PContextAccordionItem,
  GG as PContextDivider,
  WG as PContextMenu,
  KG as PContextNavItem,
  aY as PContextSidebar,
  fY as PDateInput,
  D0 as PDatePicker,
  bY as PDateRangeInput,
  S3 as PDateRangePicker,
  az as PDateRangeSelect,
  vz as PDialog,
  of as PDivider,
  Rz as PDraggableList,
  mZ as PDrawer,
  EZ as PDropdownMenu,
  bZ as PDropdownMenuItem,
  AZ as PEmptyResults,
  BZ as PEmptyState,
  UZ as PErrorBoundary,
  GZ as PForm,
  ZZ as PFrame,
  WZ as PGlobalNavItem,
  tq as PGlobalSidebar,
  M3 as PHashLink,
  D3 as PHeading,
  Dn as PIcon,
  iq as PIconButtonMenu,
  uq as PIconText,
  _q as PKeyValue,
  nh as PLabel,
  Lz as PLayoutDefault,
  Vz as PLayoutFull,
  N3 as PLayoutResizable,
  rZ as PLayoutToolbarGrid,
  dZ as PLayoutWell,
  ih as PLineNumbers,
  hq as PLink,
  wq as PListHeader,
  k3 as PListItem,
  Nq as PListItemInput,
  Dq as PListTruncate,
  kd as PLoadingIcon,
  L3 as PMarkdownRenderer,
  xW as PMessage,
  PW as PModal,
  rh as PNativeDateInput,
  y3 as PNativeSelect,
  b3 as PNativeTimeInput,
  VW as PNavigationBar,
  w3 as PNumberInput,
  th as POverflowMenu,
  ZW as POverflowMenuItem,
  nj as PPager,
  Sl as PPopOver,
  P3 as PRadio,
  lj as PRadioGroup,
  H3 as PSanitizeHtml,
  L0 as PSelect,
  G3 as PSelectAllCheckbox,
  T3 as PSelectOption,
  C3 as PSelectOptionGroup,
  Uj as PStepper,
  Y3 as PTab,
  j3 as PTabNavigation,
  K3 as PTabSelect,
  W3 as PTable,
  z3 as PTableBody,
  g0 as PTableData,
  Z3 as PTableFoot,
  q3 as PTableHead,
  uf as PTableHeader,
  kl as PTableRow,
  cK as PTabs,
  uK as PTabsContent,
  dK as PTabsList,
  _K as PTabsRoot,
  pK as PTabsTrigger,
  Yl as PTag,
  x3 as PTagWrapper,
  hK as PTags,
  wK as PTagsArea,
  CK as PTagsInput,
  jK as PTerminal,
  P0 as PTextInput,
  tQ as PTextTruncate,
  QK as PTextarea,
  rQ as PThemeToggle,
  lQ as PTimeline,
  eE as PTimelineItem,
  tE as PTimelinePoint,
  X3 as PToast,
  gQ as PToggle,
  xd as PTooltip,
  o3 as PTooltipContent,
  i3 as PTooltipProvider,
  s3 as PTooltipRoot,
  l3 as PTooltipTrigger,
  hQ as PTypeAhead,
  sh as PUnwrap,
  ah as PVirtualScroller,
  Q3 as PWindow,
  CQ as PWizard,
  ZK as ToastPlugin,
  m6 as WizardNotFound,
  Gh as WizardStepNotFound,
  e3 as alphaKeys,
  KV as alphaNumericKeys,
  cl as asArray,
  B7 as cascadePanelKey,
  N0 as cascadePanelsKey,
  DQ as convertToStylesArray,
  g6 as createWizard,
  HQ as escapeHtml,
  JV as filterOptionGroup,
  r3 as filterOptionsOrOptionGroups,
  Gl as flattenSelectOptions,
  YY as getDateRangeSelectValueLabel,
  L4 as getRouteName,
  I0 as getStepKey,
  XQ as getVirtualScroller,
  u0 as globalExists,
  HK as hideToast,
  AQ as installs,
  WQ as isAlphaKey,
  Qf as isAlphaNumeric,
  Y2 as isArray,
  VV as isButtonGroupOption,
  Zf as isDateAfter,
  qC as isDateAfterOrEqual,
  R0 as isDateBefore,
  ZC as isDateBeforeOrEqual,
  I7 as isDateInRange,
  WV as isDateRangeSelectAroundUnit,
  jV as isDateRangeSelectAroundValue,
  J7 as isDateRangeSelectPeriod,
  ZV as isDateRangeSelectPeriodValue,
  YV as isDateRangeSelectRangeValue,
  GV as isDateRangeSelectSpanValue,
  ZQ as isDateRangeSelectType,
  qQ as isDateRangeSelectValue,
  Nd as isDefined,
  A2 as isEven,
  I2 as isHorizontalPlacement,
  y2 as isHtmlElement,
  N7 as isKeyEvent,
  oy as isListener,
  O7 as isMatchingPrecision,
  W2 as isNotNullish,
  P7 as isNumber,
  jQ as isNumberKey,
  R2 as isOdd,
  KQ as isResizablePlacement,
  F4 as isRouteAbsolute,
  Wf as isRouteExternal,
  P4 as isRouteLocationNamedRaw,
  B4 as isRouteRelative,
  gl as isSelectOptionGroup,
  XV as isSelectOptionGroupNormalized,
  n3 as isSelectOptionNormalized,
  LQ as isStrings,
  eH as isTab,
  tH as isTagValue,
  Qn as kebabCase,
  A0 as keepDateInRange,
  Ie as keys,
  pZ as layouts,
  Dh as mapDateRangeSelectValueToDateRange,
  Dd as media,
  Jf as normalize,
  Ei as normalizeSelectOption,
  Xf as normalizeTab,
  t3 as numberKeys,
  a3 as optionIncludes,
  Hh as overrideMargins,
  JQ as plugin,
  qK as plugins,
  Yd as positionAroundPoint,
  kQ as positions,
  f0 as queue,
  ml as randomId,
  BQ as reduceToMap,
  PQ as reduceToRecord,
  $Q as refValueIsDefined,
  UQ as refValueIsUndefined,
  Uh as scrollIntoView,
  GQ as scrollToValidationError,
  J3 as showToast,
  FQ as sortStringArray,
  VQ as stripBaseUrl,
  QQ as timelineLayouts,
  X2 as toPixels,
  _a as toPluralString,
  py as toggleArrayValue,
  Xd as unescapeHtml,
  Xa as useAttrsStylesAndClasses,
  iy as useAttrsStylesClassesAndListeners,
  Y4 as useCascadePanel,
  V4 as useCascadePanels,
  Y7 as useColorTheme,
  a6 as useDrawer,
  z7 as useGlobalEventListener,
  i6 as useMarkdownRenderer,
  s6 as useModal,
  z4 as useMostVisiblePosition,
  Z4 as useMostVisiblePositionStyles,
  l6 as useOffsetStickyRootMargin,
  u6 as usePopOverGroup,
  F7 as usePosition,
  YQ as usePositionStyles,
  d6 as useScrollLinking,
  zQ as useThemeTokens,
  j7 as useWizard,
  W7 as useWizardKey,
  f6 as useWizardStep,
  K7 as useWizardStepKey
};
